
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kku53", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $054Kg = parcelRequire("054Kg");


var $fwDOR = parcelRequire("fwDOR");


var $hnvzE = parcelRequire("hnvzE");


var $l998X = parcelRequire("l998X");











var $dpPtd = parcelRequire("dpPtd");


var $7bZ3i = parcelRequire("7bZ3i");


var $dh538 = parcelRequire("dh538");





var $4xBBd = parcelRequire("4xBBd");


var $gWF6I = parcelRequire("gWF6I");


var $iA4lt = parcelRequire("iA4lt");

var $d264f14dd361aa2b$exports = {};
$d264f14dd361aa2b$exports = new URL("error-dark.43e0a164.svg", import.meta.url).toString();


var $6df538e2e254fd26$exports = {};
$6df538e2e254fd26$exports = new URL("error-light.02ef2e6f.svg", import.meta.url).toString();



var $9rRKJ = parcelRequire("9rRKJ");


var $7WbA8 = parcelRequire("7WbA8");


var $5G9KX = parcelRequire("5G9KX");

const $c7e627886411fcb9$export$add61e2630a21f9 = 'cachedImageErrorLight';
const $c7e627886411fcb9$export$4be43fd067fd9d7f = 'cachedImageErrorDark';
const $c7e627886411fcb9$export$7f23364af4709df5 = async (url, key)=>{
    const response = await fetch(url);
    const blob = await response.blob();
    const reader = new FileReader();
    const base64data = await new Promise((resolve, reject)=>{
        reader.onloadend = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
    (0, $5G9KX.setLocalStorageItem)(key, base64data);
};
const $c7e627886411fcb9$export$5e3e5ca9e3ba891b = async (isOnline, imageLight, lightImageKey, imageDark, darkImageKey)=>{
    if (isOnline) {
        await $c7e627886411fcb9$export$7f23364af4709df5(imageLight, lightImageKey);
        await $c7e627886411fcb9$export$7f23364af4709df5(imageDark, darkImageKey);
    }
};
const $c7e627886411fcb9$export$ce969d199fe2c04e = (key)=>{
    return (0, $5G9KX.getLocalStorageItemAsString)(key);
};



var $2lmJQ = parcelRequire("2lmJQ");


var $86ob4 = parcelRequire("86ob4");








var $4OGlb = parcelRequire("4OGlb");




// referenced from confluence/next/packages/error-boundary/src/ErrorComponent.tsx







var $aXWIB = parcelRequire("aXWIB");







var $aoVih = parcelRequire("aoVih");

var $iHPbg = parcelRequire("iHPbg");

// Code referenced from confluence/next/packages/monitoring/src/error-attributes.ts
// referenced from confluence/next/packages/network/src/getTraceIdFromResponse.ts
const $ad189a387c307ba4$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-b3-traceid') || response?.headers?.get('atl-traceid') || null;


// code referenced from confluence/next/packages/network/src/BadStatusError.ts

class $1e41a9366b8ff075$export$12c8b3d0a1a46f87 extends Error {
    get traceId() {
        return (0, $ad189a387c307ba4$export$9f229e40eb65abfc)(this.response);
    }
    static isBadStatusError(value) {
        return value instanceof $1e41a9366b8ff075$export$12c8b3d0a1a46f87;
    }
    constructor(message, response){
        super(message);
        this.response = void 0;
        this.name = 'BadStatusError';
        this.response = response;
    }
}


const $d29e73b15d9cce60$var$REACT_ERROR_CONTEXT_SYMBOL = Symbol('React error context');
const $d29e73b15d9cce60$export$8b5fa6128aa81e5e = (error)=>{
    if (typeof error === 'object' && error !== null) return error[$d29e73b15d9cce60$var$REACT_ERROR_CONTEXT_SYMBOL];
    return undefined;
};
const $d29e73b15d9cce60$var$GRAPHQL_ERROR_CONTEXT_SYMBOL = Symbol('Graphql error context');
const $d29e73b15d9cce60$var$getGraphqlErrorAttributes = (error)=>{
    if (typeof error !== 'object' || error === null) return undefined;
    if (error[$d29e73b15d9cce60$var$GRAPHQL_ERROR_CONTEXT_SYMBOL]) return error[$d29e73b15d9cce60$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
};
const $d29e73b15d9cce60$var$SLA_ERROR_CONTEXT_SYMBOL = Symbol('SLA error context');
const $d29e73b15d9cce60$var$getSlaErrorAttributes = (error)=>{
    if (typeof error === 'object' && error !== null) return error[$d29e73b15d9cce60$var$SLA_ERROR_CONTEXT_SYMBOL];
    return undefined;
};
const $d29e73b15d9cce60$var$getBadStatusErrorAttributes = (error)=>{
    if (!(error instanceof (0, $1e41a9366b8ff075$export$12c8b3d0a1a46f87))) return undefined;
    return {
        statusCode: error.response.status,
        traceId: (0, $ad189a387c307ba4$export$9f229e40eb65abfc)(error.response)
    };
};
const $d29e73b15d9cce60$var$CONTENT_ERROR_CONTEXT_SYMBOL = Symbol('Content error context');
function $d29e73b15d9cce60$export$bc010311f017b17c(error) {
    if (typeof error === 'object' && error !== null) return error[$d29e73b15d9cce60$var$CONTENT_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $d29e73b15d9cce60$var$LOADABLE_ERROR_CONTEXT_SYMBOL = Symbol('Loadable error context');
const $d29e73b15d9cce60$var$getLoadableErrorAttributes = (error)=>{
    if (typeof error === 'object' && error !== null) return error[$d29e73b15d9cce60$var$LOADABLE_ERROR_CONTEXT_SYMBOL];
    return undefined;
};
const $d29e73b15d9cce60$export$d08bac32cb78075f = (error)=>{
    if (!error || typeof error !== 'object') return {};
    return {
        ...$d29e73b15d9cce60$export$8b5fa6128aa81e5e(error),
        ...$d29e73b15d9cce60$var$getGraphqlErrorAttributes(error),
        ...$d29e73b15d9cce60$var$getSlaErrorAttributes(error),
        ...$d29e73b15d9cce60$export$bc010311f017b17c(error),
        ...$d29e73b15d9cce60$var$getLoadableErrorAttributes(error),
        ...$d29e73b15d9cce60$var$getBadStatusErrorAttributes(error)
    };
};












var $2Nwuj = parcelRequire("2Nwuj");




const $48ae26af81a9c654$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    atlassianSupportLink: {
        id: "error-boundary.description.support-link",
        defaultMessage: "Atlassian Support"
    }
});


const $b89a004dfc5e6c32$export$98c2bfe563916273 = 'https://support.atlassian.com/contact/#/';
const $b89a004dfc5e6c32$var$getLinkText = (showHostname)=>showHostname ? new URL($b89a004dfc5e6c32$export$98c2bfe563916273).hostname : /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        ...(0, $48ae26af81a9c654$export$a7357cdd1f0b0168).atlassianSupportLink
    });
const $b89a004dfc5e6c32$export$f1bb9e069c7d2c = ({ showHostname: showHostname, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        href: $b89a004dfc5e6c32$export$98c2bfe563916273,
        target: "_blank",
        children: (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) ? children : $b89a004dfc5e6c32$var$getLinkText(showHostname)
    });


// referenced from confluence/next/packages/error-boundary/src/DevErrorDetail.tsx










var $iXCQx = parcelRequire("iXCQx");


var $4JDbp = parcelRequire("4JDbp");


// If any changes are made here, they should also be made in that file.
const $2d2c706c5260f6d5$var$getUrlForQuery = (query)=>`https://splunk.paas-inf.net/en-US/app/search/search?q=search%20${encodeURIComponent(query)}&display.page.search.mode=smart`;
function $2d2c706c5260f6d5$export$902f232e663144b5({ error: error, errorInfo: errorInfo }) {
    const reactErrorAttributes = (0, $d29e73b15d9cce60$export$8b5fa6128aa81e5e)(error);
    const errorHashCode = reactErrorAttributes ? reactErrorAttributes.errorHashCode : undefined;
    const traceId = (0, $d29e73b15d9cce60$export$d08bac32cb78075f)(error).traceId;
    let splunkQueryText;
    let splunkQueryHref;
    if (errorHashCode) {
        splunkQueryText = `ext.event.attributes.errorHashCode="${errorHashCode}"`;
        splunkQueryHref = $2d2c706c5260f6d5$var$getUrlForQuery([
            'eventtype="micros_analytics-service"',
            'ext.event.product=confluence',
            splunkQueryText
        ].join('\n'));
    }
    const [width, setWidth] = (0, $42omo.useState)(0);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.default), {
                setWidth: setWidth
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                children: [
                    "You can also discuss this in the",
                    ' ',
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                        target: "_blank",
                        href: "https://atlassian.slack.com/messages/CFG8QANL9",
                        children: "#help-search-plex"
                    }),
                    ' ',
                    "Slack channel."
                ]
            }),
            splunkQueryText && splunkQueryHref ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                children: [
                    "You can search",
                    ' ',
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                        href: splunkQueryHref,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: "Splunk"
                        })
                    }),
                    ' ',
                    "for ",
                    /*#__PURE__*/ (0, $l998X.jsx)("b", {
                        children: splunkQueryText
                    }),
                    ". g",
                    ' '
                ]
            }) : null,
            traceId ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                children: [
                    "Trace ID: ",
                    /*#__PURE__*/ (0, $l998X.jsx)("b", {
                        children: traceId
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                children: [
                    "Error:",
                    width ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            overflow: 'scroll',
                            width: width
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsxs)("pre", {
                            children: [
                                `${error.message || String(error)}`,
                                errorInfo && `${errorInfo.componentStack}`
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
}


// referenced from confluence/next/packages/error-boundary/src/ErrorComponent.tsx



const $f09899ff43583193$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    actionReloadPage: {
        id: "error-boundary.reload-page",
        defaultMessage: "Refresh page"
    },
    description: {
        id: "error-boundary.description",
        defaultMessage: "The issue should resolve on its own, but if it keeps happening, ask your admin to contact {atlassianSupportLink} and give them:"
    },
    title: {
        id: "error-boundary.title",
        defaultMessage: "We've hit a snag"
    },
    code: {
        id: "error-boundary.code",
        defaultMessage: "The code associated with this error: {code}"
    },
    url: {
        id: "error-boundary.url",
        defaultMessage: "The URL of this page"
    },
    supportLinkText: {
        id: "error-boundary.support-link-text",
        defaultMessage: "our support team"
    }
});


const $b30d5c5335be09a9$var$ContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center'
});
const $b30d5c5335be09a9$var$SectionMessageContainerStyles = (0, $ecnYn.xcss)({
    maxWidth: '600px'
});
const $b30d5c5335be09a9$export$65db35c377fab04b = ({ error: error, errorInfo: errorInfo })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [showDevErrorDetail, setShowDevErrorDetail] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        focusError();
    }, []);
    const focusError = ()=>{
        const error = document.querySelector(`#error-container`);
        return error?.focus();
    };
    const title = intl.formatMessage((0, $f09899ff43583193$export$a7357cdd1f0b0168).title);
    let errorDetail = /*#__PURE__*/ (0, $l998X.jsx)($b30d5c5335be09a9$var$ErrorDetail, {
        error: error,
        errorInfo: errorInfo
    });
    const actions = [
        {
            key: 'error-boundary.reload-page',
            text: intl.formatMessage((0, $f09899ff43583193$export$a7357cdd1f0b0168).actionReloadPage),
            appearance: 'danger',
            autoFocus: true,
            onClick () {
                window.location.reload();
            }
        }
    ];
    if (showDevErrorDetail) errorDetail = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            errorDetail,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2d2c706c5260f6d5$export$902f232e663144b5), {
                error: error,
                errorInfo: errorInfo
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $b30d5c5335be09a9$var$ContainerStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $b30d5c5335be09a9$var$SectionMessageContainerStyles,
            testId: "error-container-with-error-details",
            id: "error-container",
            tabIndex: 0,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                appearance: "error",
                actions: actions.map(({ onClick: onClick, key: key, text: text })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iHPbg.default), {
                        onClick: onClick,
                        children: text
                    }, key)),
                title: title,
                children: errorDetail
            })
        })
    });
};
function $b30d5c5335be09a9$var$ErrorDetail(props) {
    const reactErrorAttributes = (0, $d29e73b15d9cce60$export$8b5fa6128aa81e5e)(props.error);
    const errorHashCode = reactErrorAttributes ? reactErrorAttributes.errorHashCode : undefined;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $f09899ff43583193$export$a7357cdd1f0b0168).description,
                tagName: "p",
                values: {
                    atlassianSupportLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $b89a004dfc5e6c32$export$f1bb9e069c7d2c), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $f09899ff43583193$export$a7357cdd1f0b0168).supportLinkText
                        })
                    })
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("li", {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $f09899ff43583193$export$a7357cdd1f0b0168).url
                        })
                    }),
                    errorHashCode ? /*#__PURE__*/ (0, $l998X.jsx)("li", {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $f09899ff43583193$export$a7357cdd1f0b0168).code,
                            values: {
                                code: /*#__PURE__*/ (0, $l998X.jsx)("b", {
                                    children: errorHashCode || ''
                                })
                            }
                        })
                    }) : null
                ]
            })
        ]
    });
}





const $f516b8d1f224d864$export$30fd472c870047da = (searchSessionId, referrer)=>({
        name: 'advancedSearchScreen',
        attributes: {
            additionalAttributes: {
                searchSessionId: // we're not passing the application mode since this event is triggered before the application mode is set
                searchSessionId,
                referrer: referrer
            }
        }
    });



var $j4ply = parcelRequire("j4ply");


var $3CshZ = parcelRequire("3CshZ");

const $d6c71ab59cbce7e1$export$cb48c45f3598fb8 = ()=>{
    const { fireAnalyticsScreenEvent: fireAnalyticsScreenEvent } = (0, $3CshZ.useAnalytics)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [referrer] = (0, $j4ply.useReferrer)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsScreenEvent((0, $f516b8d1f224d864$export$30fd472c870047da)(searchSessionId, referrer));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};



var $1nJM3 = parcelRequire("1nJM3");








var $f8oYd = parcelRequire("f8oYd");


var $gY9AU = parcelRequire("gY9AU");





var $djVCD = parcelRequire("djVCD");

const $10ae4d7be0130777$export$2025f1e19c7d8520 = ()=>{
    const [cloudId] = (0, $j4ply.useCloudId)();
    const intl = (0, $aXWIB.useIntl)();
    const isTypeFilteredToIncident = (0, $j4ply.useIsTypeFilteredToIncident)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const jiraIssueTypeFilters = (0, $djVCD.useJsmIncidentFilterIds)();
    const isFetching = (0, $42omo.useRef)(false);
    const { setJsmIncidentFilterIds: setJsmIncidentFilterIds } = (0, $djVCD.useSearchActions)();
    const logException = (0, $f8oYd.useLogException)();
    const hasJiraIssueTypeFilters = jiraIssueTypeFilters.length > 0;
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    (0, $42omo.useEffect)(()=>{
        async function fetchJiraIssueTypesFilter() {
            // Only fetch when filtered to incident
            if (!isTypeFilteredToIncident) return;
            // Only fetch if not yet available (don't over-fetch!)
            if (isFetching.current || hasJiraIssueTypeFilters) return;
            isFetching.current = true;
            try {
                const jsmIncidentId = await (0, $gY9AU.getJiraIssueTypesFilter)(cloudId, intl, 'incident', analyticsAttributes?.activationId, primaryProduct);
                setJsmIncidentFilterIds([
                    jsmIncidentId
                ]);
            } catch (e) {
                logException(e);
            } finally{
                isFetching.current = false;
            }
        }
        fetchJiraIssueTypesFilter();
    }, [
        cloudId,
        intl,
        isTypeFilteredToIncident,
        hasJiraIssueTypeFilters,
        logException,
        setJsmIncidentFilterIds,
        analyticsAttributes?.activationId,
        primaryProduct
    ]);
    return null;
};









var $1662I = parcelRequire("1662I");


var $8lMgE = parcelRequire("8lMgE");


var $7sS82 = parcelRequire("7sS82");





var $2urbH = parcelRequire("2urbH");


var $lwP5K = parcelRequire("lwP5K");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $e407d87f2e9f371a$export$7eaa56945d1970dc = 'kkvkd7ql';



var $b4tvS = parcelRequire("b4tvS");







const $814d53f457d71a8a$var$generateSearchPageVisitedString = ()=>{
    const currentDate = new Date();
    const year = (0, $8lMgE.default)(currentDate);
    const week = (0, $1662I.default)(currentDate);
    return `search_page_visited_${year}_week_${week}`;
};
const $814d53f457d71a8a$export$2a1369f17c026393 = ({ children: children })=>{
    const { boot: boot, shutdown: shutdown, trackEvent: trackEvent } = (0, $7sS82.useIntercom)();
    const [intercomHmac] = (0, $j4ply.useIntercomHmac)();
    const [userWithStatus] = (0, $j4ply.useUser)();
    const [features] = (0, $j4ply.useFeatures)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const isUserUnauthenticated = userWithStatus.status === (0, $lwP5K.UserStatus).Unauthenticated;
    (0, $42omo.useEffect)(()=>{
        // Do not boot if sideBySide feature is enabled
        if (features?.sideBySide?.enabled) return;
        // Do not boot if user details are not available
        if (isUserUnauthenticated || !userWithStatus.name || !userWithStatus.email || !intercomHmac) return;
        // Do not boot if there are no products available
        if (availableProducts.length === 0) return;
        const thirdPartyProducts = availableProducts.filter((product)=>(0, $b4tvS.is3pProductKey)(product));
        boot({
            userId: userWithStatus.id ?? undefined,
            name: userWithStatus.name,
            email: userWithStatus.email,
            userHash: intercomHmac,
            customAttributes: {
                // Some intercom users were registered without an email and succeeding
                // bootstrap calls did not update their email.
                // This change is temporary to ensure all users have an attribute that
                // actually stores the email for them :fried_angry_lol_cry:
                atlassian_account_email: userWithStatus.email,
                connected_third_parties: thirdPartyProducts.join(',')
            }
        });
        // A new intercom event will be created each week of the year.
        // Example: search_page_visited_2024_week_29
        // Events: https://app.intercom.com/a/apps/kkvkd7ql/settings/data/people?tab=events
        const eventString = $814d53f457d71a8a$var$generateSearchPageVisitedString();
        trackEvent(eventString);
        trackEvent('search_page_visited');
        return ()=>{
            shutdown();
        };
    }, [
        availableProducts,
        boot,
        features?.sideBySide?.enabled,
        intercomHmac,
        shutdown,
        isUserUnauthenticated,
        userWithStatus.id,
        userWithStatus.name,
        userWithStatus.email,
        trackEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: children
    });
};
const $814d53f457d71a8a$var$Intercom = ({ children: children })=>{
    const [intercomAllowed, setIntercomAllowed] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        (0, $2urbH.checkThirdParty)('intercom', async ()=>setIntercomAllowed(true), async ()=>setIntercomAllowed(false));
    }, []);
    if (!intercomAllowed) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7sS82.IntercomProvider), {
        appId: (0, $e407d87f2e9f371a$export$7eaa56945d1970dc),
        children: /*#__PURE__*/ (0, $l998X.jsx)($814d53f457d71a8a$export$2a1369f17c026393, {
            children: children
        })
    });
};
const $814d53f457d71a8a$var$IntercomWithErrorBoundary = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        fallback: children,
        section: "SearchPageIntercom",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-intercom",
            children: /*#__PURE__*/ (0, $l998X.jsx)($814d53f457d71a8a$var$Intercom, {
                children: children
            })
        })
    });
};
var $814d53f457d71a8a$export$2e2bcd8739ae039 = $814d53f457d71a8a$var$IntercomWithErrorBoundary;








const $aec377272259e0f9$var$REFERRER_PARAM = 'referrer';
const $aec377272259e0f9$export$93ca63a045ddcea8 = ()=>new URLSearchParams(window.location.search).get($aec377272259e0f9$var$REFERRER_PARAM) ?? undefined;
const $aec377272259e0f9$export$a4a337593fcc41db = (logException)=>{
    try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has($aec377272259e0f9$var$REFERRER_PARAM)) return;
        url.searchParams.delete($aec377272259e0f9$var$REFERRER_PARAM);
        window.history.replaceState(null, '', url.href);
    } catch (error) {
        logException(error);
    }
};
const $aec377272259e0f9$export$6a93826c3e88a7f6 = ()=>{
    const logException = (0, $f8oYd.useLogException)();
    (0, $42omo.useEffect)(()=>{
        $aec377272259e0f9$export$a4a337593fcc41db(logException);
    }, [
        logException
    ]);
    return null;
};






var $aXjWU = parcelRequire("aXjWU");

const $f6a925dc3308ab80$export$1b49510872e7246c = 'platform.search-platform.rovo-changeboarding-app-selectors';
const $f6a925dc3308ab80$export$d2ea4f931a71a509 = 'plex-filters-changeboarding-rovo-free';



var $9zUhf = parcelRequire("9zUhf");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");

const $b3bd4a67e85b92b5$var$initialState = {
    spotlight: {
        state: 'hidden'
    }
};
const $b3bd4a67e85b92b5$var$actions = {
    start: ()=>({ getState: getState, setState: setState })=>{
            const { spotlight: spotlight } = getState();
            if (spotlight.state !== 'hidden') return;
            setState({
                spotlight: {
                    state: 'visible',
                    activeSpotlight: 0
                }
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                spotlight: {
                    state: 'seen'
                }
            });
        },
    dismiss: ()=>({ setState: setState })=>{
            setState({
                spotlight: {
                    state: 'dismiss'
                }
            });
        }
};
const $b3bd4a67e85b92b5$var$SpotlightStore = (0, $1P1Tu.createStore)({
    initialState: $b3bd4a67e85b92b5$var$initialState,
    actions: $b3bd4a67e85b92b5$var$actions,
    name: 'SpotlightStore'
});
const $b3bd4a67e85b92b5$export$d52beefead77af4c = (0, $9zUhf.createActionsHook)($b3bd4a67e85b92b5$var$SpotlightStore);
const $b3bd4a67e85b92b5$export$42b1420c4bc8ee20 = (0, $9zUhf.createHook)($b3bd4a67e85b92b5$var$SpotlightStore);
const $b3bd4a67e85b92b5$export$a771c137b2620ff2 = (0, $9zUhf.createHook)($b3bd4a67e85b92b5$var$SpotlightStore, {
    selector: (0, $cclHy.createSelector)((state)=>state.spotlight, (spotlightState)=>spotlightState)
});


const $14f459c4dfcc6b1a$export$f86c748bd13d5f7a = ()=>{
    const [spotlight, { start: start }] = (0, $b3bd4a67e85b92b5$export$a771c137b2620ff2)();
    const hasRequestedMessageRef = (0, $42omo.useRef)(false);
    const { requestMessageStart: requestMessageStart, dismissMessage: dismissMessage, hasMessageStarted: hasMessageStarted } = (0, $aXjWU.usePostOfficeExernalMessageProxy)((0, $f6a925dc3308ab80$export$d2ea4f931a71a509));
    (0, $42omo.useEffect)(()=>{
        if (!hasRequestedMessageRef.current) {
            requestMessageStart();
            hasRequestedMessageRef.current = true;
            return;
        }
        // If spotlight should be shown within Post Office logic
        if (hasMessageStarted) start();
    }, [
        hasMessageStarted,
        requestMessageStart,
        start
    ]);
    (0, $42omo.useEffect)(()=>{
        if (spotlight.state === 'dismiss') dismissMessage();
    }, [
        dismissMessage,
        spotlight.state
    ]);
};
const $14f459c4dfcc6b1a$export$d076c6f78afb0ebc = ()=>{
    $14f459c4dfcc6b1a$export$f86c748bd13d5f7a();
    return null;
};



var $8aC7e = parcelRequire("8aC7e");


var $bHLTK = parcelRequire("bHLTK");

const $2bb9aeea11dbc94b$export$f6a06b563a614935 = ({ children: children, ...props })=>{
    const renderWithErrorInfo = (0, $42omo.useCallback)((props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $b30d5c5335be09a9$export$65db35c377fab04b), {
            ...props
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        renderWithErrorInfo: renderWithErrorInfo,
        section: "SearchPageRelayBootstrap",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8aC7e.default), {
            ...props,
            statsigLayer: (0, $4OGlb.STATSIG_FULL_PAGE_SEARCH_LAYER),
            experience: (0, $9rRKJ.SearchExperience).SEARCH_PAGE,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bHLTK.SearchStoreProvider), {
                experience: (0, $9rRKJ.SearchExperience).SEARCH_PAGE,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $d6c71ab59cbce7e1$export$cb48c45f3598fb8), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $aec377272259e0f9$export$6a93826c3e88a7f6), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $14f459c4dfcc6b1a$export$d076c6f78afb0ebc), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $10ae4d7be0130777$export$2025f1e19c7d8520), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $814d53f457d71a8a$export$2e2bcd8739ae039), {
                        children: children
                    })
                ]
            })
        })
    });
};


/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 






var $irOoi = parcelRequire("irOoi");





var $gdv5Z = parcelRequire("gdv5Z");








var $aaNIP = parcelRequire("aaNIP");


var $6Gsan = parcelRequire("6Gsan");


var $fZ3l2 = parcelRequire("fZ3l2");








const $f43a1e29196bf274$export$3c6a6c4c70845302 = ({ setProductsWithTimeout: setProductsWithTimeout })=>{
    (0, $42omo.useEffect)(()=>{
        setProductsWithTimeout(undefined);
    }, [
        setProductsWithTimeout
    ]);
    return null;
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");













parcelRequire("42omo");


var $9vOy1 = parcelRequire("9vOy1");

const $919e914043a539a1$var$ApplicationModeSpecificComponent = ({ rovoComponent: rovoComponent, unifiedComponent: unifiedComponent, applicationMode: applicationMode })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            applicationMode === (0, $9vOy1.ApplicationModes).Rovo && rovoComponent,
            applicationMode === (0, $9vOy1.ApplicationModes).Unified && unifiedComponent
        ]
    });
};
var $919e914043a539a1$export$2e2bcd8739ae039 = $919e914043a539a1$var$ApplicationModeSpecificComponent;





parcelRequire("42omo");


var $gj7hi = parcelRequire("gj7hi");




var $5dK2X = parcelRequire("5dK2X");



const $330959ad09458c13$var$resultStateContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 'space.1000',
    textAlign: 'center'
});
const $330959ad09458c13$var$ImageContainerStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.150',
    width: '124px',
    height: '124px'
});
const $330959ad09458c13$var$primaryTextContainerStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.150',
    font: 'font.heading.medium',
    fontWeight: 'font.weight.medium'
});
const $330959ad09458c13$var$secondaryTextContainerStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.200'
});
const $330959ad09458c13$export$d9172702747fb4bc = ({ imageSrcLight: imageSrcLight, imageSrcDark: imageSrcDark, primaryText: primaryText, secondaryText: secondaryText, callToAction: callToAction, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $330959ad09458c13$var$resultStateContainerStyles,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $330959ad09458c13$var$ImageContainerStyles,
                children: imageSrcLight && imageSrcDark && // eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                    src: imageSrcLight,
                    srcDark: imageSrcDark,
                    role: "presentation"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $330959ad09458c13$var$primaryTextContainerStyles,
                children: primaryText
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $330959ad09458c13$var$secondaryTextContainerStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    children: secondaryText
                })
            }),
            callToAction && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: callToAction
            })
        ]
    });
};


var $5e5cd8421dca6bae$exports = {};
$5e5cd8421dca6bae$exports = new URL("landing-dark.4ee27e71.svg", import.meta.url).toString();


var $bbbf2953c1e88da3$exports = {};
$bbbf2953c1e88da3$exports = new URL("landing-light.0988f0a2.svg", import.meta.url).toString();





const $30ab1532ab66340a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    landingPrimary: {
        id: "landing_primary",
        defaultMessage: "Seek and you shall find"
    },
    landingSecondaryRovo: {
        id: "landing_secondary_rovo",
        defaultMessage: "Search or ask Rovo what you're looking for in your Atlassian and connected apps"
    },
    landingSecondaryUnifiedWithSAIN: {
        id: "landing_secondary_unified_with_sain",
        defaultMessage: "Search or ask anything across your Atlassian apps"
    },
    landingSecondaryUnifiedWithoutSAIN: {
        id: "landing_secondary_unified_without_sain",
        defaultMessage: "Search for anything across your Atlassian apps"
    },
    landingSecondary: {
        id: "landing_secondary",
        defaultMessage: "Search for what you're looking for in your Atlassian and connected apps"
    },
    landingSecondaryWithAI: {
        id: "landing_secondary_with_atlassian_intelligence",
        defaultMessage: "Search or ask what you're looking for in your Atlassian and connected apps"
    }
});


const $448d3451574c04df$var$styles = {
    headingWrapper: "_11c81af2 _k48p1wq8"
};
const $448d3451574c04df$var$getMessage = (isAIEnabled)=>isAIEnabled ? (0, $30ab1532ab66340a$export$defe85febe8b728c).landingSecondaryWithAI : (0, $30ab1532ab66340a$export$defe85febe8b728c).landingSecondary;
const $448d3451574c04df$var$SecondaryText = ({ applicationMode: applicationMode, isAdminHubAIEnabled: isAdminHubAIEnabled = false, isRovoLLMEnabled: isRovoLLMEnabled = false })=>{
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $919e914043a539a1$export$2e2bcd8739ae039), {
        rovoComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...$448d3451574c04df$var$getMessage(isRovoLLMEnabled)
        }),
        unifiedComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...$448d3451574c04df$var$getMessage(isAdminHubAIEnabled)
        }),
        applicationMode: applicationMode
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $919e914043a539a1$export$2e2bcd8739ae039), {
        rovoComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $30ab1532ab66340a$export$defe85febe8b728c).landingSecondaryRovo
        }),
        unifiedComponent: isAdminHubAIEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $30ab1532ab66340a$export$defe85febe8b728c).landingSecondaryUnifiedWithSAIN
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $30ab1532ab66340a$export$defe85febe8b728c).landingSecondaryUnifiedWithoutSAIN
        }),
        applicationMode: applicationMode
    });
};
const $448d3451574c04df$export$12449a31c6671d53 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $330959ad09458c13$export$d9172702747fb4bc), {
        testId: "search-page-landing",
        imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($bbbf2953c1e88da3$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5e5cd8421dca6bae$exports))),
        primaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $448d3451574c04df$var$styles.headingWrapper,
            as: "h2",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $30ab1532ab66340a$export$defe85febe8b728c).landingPrimary
            })
        }),
        secondaryText: /*#__PURE__*/ (0, $l998X.jsx)($448d3451574c04df$var$SecondaryText, {
            ...props
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");













const $849ee461ff61ea47$var$styles = {
    layout: "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4"
};
const $849ee461ff61ea47$var$NAV3_HEIGHT = 56;
const $849ee461ff61ea47$var$NAV4_HEIGHT = 48;
const $849ee461ff61ea47$export$c84671f46d6a1ca = ({ children: children, headerOffset: headerOffset = 0, primaryProduct: _primaryProduct })=>{
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const headerHeight = (isNav4Enabled ? $849ee461ff61ea47$var$NAV4_HEIGHT : $849ee461ff61ea47$var$NAV3_HEIGHT) + headerOffset;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-layout",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.WidthObserverElement), {
            id: "layout",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                testId: "search-page-layout",
                xcss: $849ee461ff61ea47$var$styles.layout,
                style: {
                    height: `calc(100vh - ${headerHeight}px)`
                },
                children: children
            })
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");







var $u9agA = parcelRequire("u9agA");


var $2OtFZ = parcelRequire("2OtFZ");


var $26jni = parcelRequire("26jni");




const $f8be7d82aac68e80$var$isRevampTreatment = (0, $2OtFZ.serveFullpageSearchSummarizeButtonRevamp)({
    fireExperimentExposure: false
}) !== 'control';
const $f8be7d82aac68e80$var$styles = {
    container: "_18m915zi",
    containerRevamp: "_1reo15vq",
    contentContainer: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _19bvu2gc _u5f3u2gc _4cvr1yb4 _b8yq1a8x",
    contentContainerWithTabs: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _19bv1ejb _u5f31ejb _4cvr1yb4 _b8yq1a8x",
    mainContentBase: "_1e0c1txw _2lx21bp4 _1bah1fhb _16jlkb7n _1ul9idpf _1pbyidpf",
    mainContent: "_zulppxbi _1rjcv47k _p12fbxu3",
    mainContentLite: "_zulpidpf _1p571ejb _ca0qidpf _4t3i1osq _p12f1osq _18u01wug _2hwx1wug",
    rightPanelWrapper: "_1e0cglyw _181n1ule",
    rightPanel: "_kqsw1if8 _154iidpf _1bsbde1w",
    fullWidthSainPortal: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _ca0qv47k _19bvu2gc _u5f3u2gc _fiawglyw _b8yq1a8x"
};
const $f8be7d82aac68e80$export$4b2c32e08f77ff18 = ({ selectedProduct: selectedProduct, rightPanel: rightPanel, children: children, bodyRef: bodyRef, mainContentRef: mainContentRef, setMainContentWidth: setMainContentWidth, primaryProduct: primaryProduct, sideBySide: sideBySide, fullWidthSainPortalRef: fullWidthSainPortalRef, isLiteMode: isLiteMode })=>{
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const fpsNinNavigation = (0, $26jni.serveJiraNinFpsNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: locale
    });
    (0, $42omo.useEffect)(()=>{
        bodyRef?.current?.scrollTo?.(0, 0);
    }, [
        selectedProduct,
        bodyRef,
        isNav4Enabled
    ]);
    (0, $42omo.useEffect)(()=>{
        const callback = ()=>{
            if (mainContentRef.current) setMainContentWidth(mainContentRef.current.offsetWidth);
        };
        const resizeObserver = new ResizeObserver(callback);
        if (mainContentRef.current) {
            resizeObserver.observe(mainContentRef.current); // Set initial width
            callback();
        }
        return ()=>{
            resizeObserver.disconnect();
        }; // These dependencies should never change
    }, [
        mainContentRef,
        setMainContentWidth
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        ref: bodyRef,
        "data-testid": "search-page-body",
        className: (0, $gMc0m.default)([
            $f8be7d82aac68e80$var$styles.container,
            $f8be7d82aac68e80$var$isRevampTreatment && $f8be7d82aac68e80$var$styles.containerRevamp
        ]),
        children: [
            fullWidthSainPortalRef && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: fullWidthSainPortalRef,
                "data-testid": "search-page-full-width-sain-portal",
                className: (0, $gMc0m.default)([
                    $f8be7d82aac68e80$var$styles.fullWidthSainPortal
                ])
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.800",
                xcss: fpsNinNavigation?.cohort === 'tabs' ? $f8be7d82aac68e80$var$styles.contentContainerWithTabs : $f8be7d82aac68e80$var$styles.contentContainer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        ref: mainContentRef,
                        "data-testid": "search-page-body-main-content",
                        className: (0, $gMc0m.default)([
                            $f8be7d82aac68e80$var$styles.mainContentBase,
                            isLiteMode ? $f8be7d82aac68e80$var$styles.mainContentLite : $f8be7d82aac68e80$var$styles.mainContent
                        ]),
                        children: children
                    }),
                    !sideBySide && rightPanel && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $f8be7d82aac68e80$var$styles.rightPanelWrapper,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            className: (0, $gMc0m.default)([
                                $f8be7d82aac68e80$var$styles.rightPanel
                            ]),
                            children: rightPanel
                        })
                    })
                ]
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $1Whri = parcelRequire("1Whri");




var $d8SNb = parcelRequire("d8SNb");


var $6F6hl = parcelRequire("6F6hl");







const $3867e15ac7e3b5d9$var$styles = {
    base: "_kqsw1if8 _154iidpf _bfhkvuon _1bsb1osq _1y1m1u8q _1pby1kze",
    contentContainer: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _19bvu2gc _u5f3u2gc _4cvr1yb4 _b8yq1a8x",
    contentContainerWithTabs: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _19bv1ejb _u5f31ejb _4cvr1yb4 _b8yq1a8x",
    keyline: "_n7zlia51",
    grid: "_1lmc19pt _yv0e1k1g _n3tdv47k",
    paddingTop: "_ca0q1ejb",
    inputGridArea: "_nd5l1hq5 _1e0c1txw _4cvr1h6o",
    filtersGridArea: "_nd5l12xr"
};
const $3867e15ac7e3b5d9$export$8b251419efc915eb = ({ input: input, filters: filters, primaryProduct: primaryProduct })=>{
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const cohort = (0, $26jni.serveJiraNinFpsNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: locale
    })?.cohort;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($3867e15ac7e3b5d9$var$styles.base, $3867e15ac7e3b5d9$var$styles.keyline),
                testId: "search-page-header",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: cohort === 'tabs' ? $3867e15ac7e3b5d9$var$styles.contentContainerWithTabs : $3867e15ac7e3b5d9$var$styles.contentContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                        xcss: (0, $1Whri.cx)($3867e15ac7e3b5d9$var$styles.grid, !isNav4Enabled && $3867e15ac7e3b5d9$var$styles.paddingTop),
                        columnGap: "space.200",
                        rowGap: "space.200",
                        children: [
                            !isNav4Enabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $3867e15ac7e3b5d9$var$styles.inputGridArea,
                                children: input
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $3867e15ac7e3b5d9$var$styles.filtersGridArea,
                                children: filters
                            })
                        ]
                    })
                })
            }),
            isNav4Enabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: input
            })
        ]
    });
};





parcelRequire("42omo");







var $1hlFx = parcelRequire("1hlFx");

const $e0d9e2bc48f29be1$var$resultsListGridAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'results-list',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200'
});
const $e0d9e2bc48f29be1$export$18a2402e95ebb069 = ({ rowCount: rowCount = 7 })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        role: "list",
        xcss: $e0d9e2bc48f29be1$var$resultsListGridAreaStyles,
        testId: "search-page-results-loading",
        children: Array.from({
            length: rowCount
        }).map((_, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1hlFx.SearchResultSkeleton), {}, index))
    });
};



var $bVltF = parcelRequire("bVltF");

const $821ff4954924b9b5$export$11556de7beafcaf8 = ()=>({
        eventType: 'operational',
        action: 'shown',
        actionSubject: 'debugPanel',
        attributes: {}
    });


const $0e1691e3261af771$export$abd5de3aada5ec8b = ({ availableProducts: availableProducts, searchSessionId: searchSessionId })=>({
        eventType: 'track',
        action: 'availableProducts',
        actionSubject: 'searchPage',
        attributes: {
            additionalAttributes: {
                experienceName: 'search-page',
                availableProducts: availableProducts,
                availableProductsCount: availableProducts.length,
                searchSessionId: searchSessionId
            }
        }
    });






var $c2HNo = parcelRequire("c2HNo");


var $2x777 = parcelRequire("2x777");


var $22zVp = parcelRequire("22zVp");

const $bae6f8ff1d9250a0$export$cfd0a4eecdb5b49d = (b)=>{
    return {
        cloudId: b.cloudId,
        primaryProduct: b.primaryProduct,
        searchSessionId: b.searchSessionId,
        isRovoEnabled: b.isRovoEnabled,
        allFilterExcludedProducts: b.allFilterExcludedProducts,
        thirdPartyConfigs: b.thirdPartyConfigs,
        experimentConfig: b.experimentConfig,
        experimentLayers: b.experimentLayers,
        products: b.products,
        isJiraIssueIndexed: b.isJiraIssueIndexed,
        user: b.user,
        nouns: b.nouns,
        isNounsAvailable: b.isNounsAvailable,
        referrer: b.referrer,
        productDataRegions: b.productDataRegions,
        productEdition: b.productEdition,
        overrides: b.overrides
    };
};


const $29e931a0b3bfc4fe$export$3761754c69bcbfc2 = (s)=>{
    return {
        searchQuery: s.searchQuery,
        originalQuery: s.originalQuery,
        resultsSort: s.resultsSort,
        filters: s.filters,
        selectedProducts: s.selectedProducts,
        selectedDatasource: s.selectedDatasource,
        jsmIncidentFilterIds: s.jsmIncidentFilterIds,
        paginationTokens: s.paginationTokens,
        availableProducts: s.availableProducts,
        requestId: s.requestId,
        traceId: s.traceId,
        cql: s.cql
    };
};



var $20r3r = parcelRequire("20r3r");











var $8uOED = parcelRequire("8uOED");

















var $bUlM5 = parcelRequire("bUlM5");

var $cwkWT = parcelRequire("cwkWT");

var $dcJ7R = parcelRequire("dcJ7R");










var $1yEFx = parcelRequire("1yEFx");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $4ymSL = parcelRequire("4ymSL");





var $auNCB = parcelRequire("auNCB");


var $c0hNi = parcelRequire("c0hNi");

const $6957b588b0d16361$export$f47dcf3d531e732f = ({ source: source, experiment: experiment, commonAttributes: commonAttributes, queryHash: queryHash, queryLength: queryLength, searchSessionId: searchSessionId, isHello: isHello, referrer: referrer })=>({
        source: source,
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'rovoNavigation',
        name: 'rovoNavigation',
        attributes: {
            commonAttributes: commonAttributes,
            queryHash: queryHash,
            queryLength: queryLength,
            searchSessionId: searchSessionId,
            isHello: isHello,
            referrer: referrer,
            additionalAttributes: {
                experiment: experiment
            }
        }
    });














const $03c37cb592b068e5$export$92bb7bcca1963f8b = (intent)=>intent.__typename === 'KnowledgeDiscoveryNavContentIntent';

const $21e23cac0593e029$export$a9b89ab41c676da3 = (intent)=>intent.__typename === 'KnowledgeDiscoveryNavigationalIntent';


const $ed340a232d40a52e$var$NAV_BOOST_SCORE_THRESHOLD = 0.5;
const $ed340a232d40a52e$var$initialState = {
    workspaceId: null,
    intentClassificationData: null,
    sainJql: null
};
// Singleton state shared across all components
const $ed340a232d40a52e$var$sharedState = {
    current: {
        ...$ed340a232d40a52e$var$initialState
    }
};
const $ed340a232d40a52e$var$sainJqlListeners = new Set();
function $ed340a232d40a52e$var$notifySainJqlListeners() {
    $ed340a232d40a52e$var$sainJqlListeners.forEach((l)=>l());
}
function $ed340a232d40a52e$var$subscribeSainJql(listener) {
    $ed340a232d40a52e$var$sainJqlListeners.add(listener);
    return ()=>{
        $ed340a232d40a52e$var$sainJqlListeners.delete(listener);
    };
}
function $ed340a232d40a52e$var$getSainJqlSnapshot() {
    return $ed340a232d40a52e$var$sharedState.current.sainJql;
}
function $ed340a232d40a52e$export$79876d69540370f5() {
    return (0, $42omo.useSyncExternalStore)($ed340a232d40a52e$var$subscribeSainJql, $ed340a232d40a52e$var$getSainJqlSnapshot, $ed340a232d40a52e$var$getSainJqlSnapshot);
}
const $ed340a232d40a52e$export$ff55966aa7474110 = ()=>{
    const state = $ed340a232d40a52e$var$sharedState;
    const setWorkspaceId = (0, $42omo.useCallback)((workspaceId)=>{
        state.current.workspaceId = workspaceId;
    }, [
        state
    ]);
    const getWorkspaceId = (0, $42omo.useCallback)(()=>{
        return state.current.workspaceId;
    }, [
        state
    ]);
    const setQueryIntentClassificationData = (0, $42omo.useCallback)((intentClassificationData)=>{
        state.current.intentClassificationData = intentClassificationData;
    }, [
        state
    ]);
    const clearStore = (0, $42omo.useCallback)(()=>{
        state.current = {
            ...$ed340a232d40a52e$var$initialState
        };
        $ed340a232d40a52e$var$notifySainJqlListeners();
    }, [
        state
    ]);
    const setSainJql = (0, $42omo.useCallback)((jql)=>{
        state.current.sainJql = jql;
        $ed340a232d40a52e$var$notifySainJqlListeners();
    }, [
        state
    ]);
    const getSainJql = (0, $42omo.useCallback)(()=>{
        return state.current.sainJql;
    }, [
        state
    ]);
    const isSAINNavigationalExperienceEligible = (0, $42omo.useCallback)(({ position: position, url: url, navBoostScore: navBoostScore })=>{
        if (position === 0 && (0, $dh538.fg)('kd_enable_sain_hero_nav')) {
            const queryIntentClassificationData = state.current.intentClassificationData;
            // use the URL check for nav content intent
            if (queryIntentClassificationData && (0, $03c37cb592b068e5$export$92bb7bcca1963f8b)(queryIntentClassificationData)) {
                const navContentUrl = queryIntentClassificationData.url;
                if (navContentUrl === url) return true;
            }
            // use the nav boost score check for navigational intent or nav content intent if we missed the document
            // because the URL returned is not for the first result
            if (queryIntentClassificationData && ((0, $21e23cac0593e029$export$a9b89ab41c676da3)(queryIntentClassificationData) || (0, $03c37cb592b068e5$export$92bb7bcca1963f8b)(queryIntentClassificationData))) {
                if (navBoostScore && navBoostScore > $ed340a232d40a52e$var$NAV_BOOST_SCORE_THRESHOLD) return true;
            }
        }
        return false;
    }, [
        state
    ]);
    return {
        setWorkspaceId: setWorkspaceId,
        getWorkspaceId: getWorkspaceId,
        setQueryIntentClassificationData: setQueryIntentClassificationData,
        isSAINNavigationalExperienceEligible: isSAINNavigationalExperienceEligible,
        clearStore: clearStore,
        setSainJql: setSainJql,
        getSainJql: getSainJql
    };
};









var $731W9 = parcelRequire("731W9");


var $3fzmz = parcelRequire("3fzmz");




const $dad12d2a3779d6f3$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    buttonLabel: {
        id: "search-page.navigation.search.work-items",
        defaultMessage: "Search work items"
    }
});


const $e9ecd89ba2d8712f$var$REFERRER_PARAM = 'referrer=search-page'; // This is the default url when you use "Enter" on QF in Jira
const $e9ecd89ba2d8712f$var$NEW_ISSUE_NAVIGATOR_DEFAULT_URL = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}&${$e9ecd89ba2d8712f$var$REFERRER_PARAM}`;
const $e9ecd89ba2d8712f$var$styles = {
    buttonLinkStyles: "_zulp12x7 _2rko12b0 _19itia51 _11c8fhey _4bfu1r31 _1hmsglyw _ajmmnqa1 _18zrutpp _1rjc1b66 _1e0c1txw _4cvr1h6o _syazazsu _c71lzwfg _1tkezwfg _bfhksm61 _o5721q9c _k48p1wq8 _p12f1178 _1053azsu _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa _30l3azsu"
};
const $e9ecd89ba2d8712f$export$7905e7d9062c8ee6 = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const sainJql = (0, $ed340a232d40a52e$export$79876d69540370f5)();
    const isPartOfJiraNinFpsExperiment = (0, $42omo.useMemo)(()=>(0, $26jni.serveJiraNinFpsNavigation)({
            primaryProduct: primaryProduct,
            locale: locale
        })?.cohort === 'control', [
        primaryProduct,
        locale
    ]);
    const referrer = (0, $42omo.useMemo)(()=>{
        const params = new URLSearchParams(window.location.search);
        return params.get('referrer') || '';
    }, []);
    const href = (0, $42omo.useMemo)(()=>{
        const trimmedQuery = searchQuery.trim();
        try {
            if (sainJql && (0, $dh538.fg)('fps_nin_cta_use_sain_jql')) return `/issues/?jql=${encodeURIComponent(sainJql)}&${$e9ecd89ba2d8712f$var$REFERRER_PARAM}`;
            if (trimmedQuery !== '') {
                let jql;
                const typedJqlRoutingEnabled = (0, $dh538.fg)('rovo_fps_route_typed_jql_as_jql');
                if (typedJqlRoutingEnabled && (0, $c0hNi.isTypedJql)(trimmedQuery)) jql = encodeURIComponent(trimmedQuery);
                else jql = (0, $3fzmz.buildJql)({
                    query: searchQuery,
                    projectARIs: [],
                    accountARIs: []
                });
                return `/issues/?jql=${jql}&${$e9ecd89ba2d8712f$var$REFERRER_PARAM}`;
            }
            return $e9ecd89ba2d8712f$var$NEW_ISSUE_NAVIGATOR_DEFAULT_URL;
        } catch  {
            return $e9ecd89ba2d8712f$var$NEW_ISSUE_NAVIGATOR_DEFAULT_URL;
        }
    }, [
        searchQuery,
        sainJql
    ]);
    const onClick = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $6957b588b0d16361$export$f47dcf3d531e732f)({
            source: 'advancedSearchScreen',
            experiment: isPartOfJiraNinFpsExperiment ? 'control' : undefined,
            commonAttributes: commonAttributes,
            queryHash: (0, $731W9.sha256Hash)(searchQuery),
            queryLength: searchQuery.length,
            isHello: isHello,
            searchSessionId: searchSessionId,
            referrer: referrer
        }));
    }, [
        fireAnalyticsEvent,
        isPartOfJiraNinFpsExperiment,
        commonAttributes,
        searchQuery,
        isHello,
        searchSessionId,
        referrer
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default), {
        onClick: onClick,
        xcss: $e9ecd89ba2d8712f$var$styles.buttonLinkStyles,
        href: href,
        testId: "issue-navigator-cta",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))), {
                label: ""
            }),
            formatMessage((0, $dad12d2a3779d6f3$export$a7357cdd1f0b0168).buttonLabel)
        ]
    });
};














/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 









var $5iakG = parcelRequire("5iakG");














var $ccHMk = parcelRequire("ccHMk");


var $ghftu = parcelRequire("ghftu");


var $lGgRw = parcelRequire("lGgRw");










var $2W0qg = parcelRequire("2W0qg");

var $1GzhS = parcelRequire("1GzhS");




var $4A7Gn = parcelRequire("4A7Gn");

var $0DTaW = parcelRequire("0DTaW");

var $bDrnk = parcelRequire("bDrnk");


var $4EMbH = parcelRequire("4EMbH");







var $def8z = parcelRequire("def8z");


var $ckkm9 = parcelRequire("ckkm9");


var $YqPsE = parcelRequire("YqPsE");


var $eoZmS = parcelRequire("eoZmS");


var $aRSt4 = parcelRequire("aRSt4");







const $e921223821c79c8f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    allOptionVisualLabel: {
        id: "search-page.tab-filter.all-filter-visual-label",
        defaultMessage: "All"
    },
    allOptionAccessibleLabel: {
        id: "search-page.tab-filter.all-filter-accessible-label",
        defaultMessage: "Filter by all apps"
    },
    more: {
        id: "search-page.tab-filter.more-dropdown-label",
        defaultMessage: "More"
    },
    accessibleMoreMenuLabel: {
        id: "search-page.tab-filter.accessible-more-dropdown-label",
        defaultMessage: "Filter by more apps"
    }
});


/** The maximum number of visible tabs.
 * Higher number of app options will be rendered in a menu.
 */ const $782950564c4e1cfd$var$APP_OPTION_OVERFLOW = 4;
/**
 * The app filter.
 * Shows available products in tabs.
 */ const $782950564c4e1cfd$var$AppFilterTabsInline = ({ onSelectProduct: onSelectProduct, availableProducts: availableProducts, availableNouns: availableNouns, selectedProduct: selectedProduct, isNounsAvailable: isNounsAvailable, filterData: filterData, setAtlasNoun: setAtlasNoun, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, thirdPartyConfigs: thirdPartyConfigs })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const products = (0, $1yEFx.useProductConfigs)();
    let shouldShowNouns;
    const isWebCrawlerAvailable = availableProducts.includes((0, $1yEFx.ProductKeys).AtlassianWebCrawler);
    if (!isNounsAvailable) // Convoluting atlassian-web-crawler with nouns is a tech-debt, ideally it should be decoupled from nouns.
    shouldShowNouns = availableNouns.length > 0 || isWebCrawlerAvailable;
    else shouldShowNouns = isWebCrawlerAvailable || isNounsAvailable;
    const availableProductsWithoutAtlasAndCustomWebsitesIfNounsAvailable = shouldShowNouns ? availableProducts.filter((key)=>key !== (0, $1yEFx.ProductKeys).Atlas && key !== (0, $1yEFx.ProductKeys).AtlassianWebCrawler) : availableProducts;
    const { inlineOptions: inlineOptions, nestedOptions: nestedOptions } = (0, $42omo.useMemo)(()=>{
        let availableOptions = [
            ...availableProductsWithoutAtlasAndCustomWebsitesIfNounsAvailable
        ].filter((productKey)=>products[productKey]).sort((a, b)=>{
            const indexA = (0, $b4tvS.PRODUCTS_ORDER).indexOf(a);
            const indexB = (0, $b4tvS.PRODUCTS_ORDER).indexOf(b);
            if (indexA === -1 || indexB === -1) return 0;
            else return indexA - indexB;
        }).map((productKey)=>{
            const workspaceName = (0, $YqPsE.getWorkspaceNameFromProduct)(productKey, thirdPartyConfigs);
            const label = workspaceName || products[productKey].displayName;
            const isSelected = productKey === selectedProduct;
            return {
                label: label,
                inlineLabel: label,
                value: productKey,
                isSelected: isSelected,
                inlineIsSelected: isSelected
            };
        });
        if (shouldShowNouns) {
            const nounsToDisplay = [
                ...availableNouns.filter((noun)=>noun !== (0, $4EMbH.NounKeys).AtlassianWebCrawler),
                ...isWebCrawlerAvailable ? [
                    (0, $1yEFx.ProductKeys).AtlassianWebCrawler
                ] : []
            ].sort((a, b)=>(0, $4EMbH.NOUNS_ORDER).indexOf(a) - (0, $4EMbH.NOUNS_ORDER).indexOf(b));
            const availableNounOptions = nounsToDisplay.map((noun)=>{
                const isAtlasSelected = selectedProduct === (0, $1yEFx.ProductKeys).Atlas;
                const isWebCrawlerSelected = selectedProduct === (0, $1yEFx.ProductKeys).AtlassianWebCrawler;
                const isSelected = (isWebCrawlerSelected && noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler || isAtlasSelected && filterData?.options.find((option)=>option.queryParamValue === noun)?.isSelected) ?? false;
                const label = formatMessage((0, $4EMbH.nouns)[noun].displayNamePlural);
                return {
                    label: label,
                    inlineLabel: label,
                    value: noun,
                    isSelected: isSelected,
                    inlineIsSelected: isSelected
                };
            });
            availableOptions.push(...availableNounOptions);
        }
        return $782950564c4e1cfd$var$splitAppOptions(availableOptions, availableOptions.findIndex((option)=>option.isSelected));
    }, [
        availableNouns,
        availableProductsWithoutAtlasAndCustomWebsitesIfNounsAvailable,
        filterData?.options,
        formatMessage,
        isWebCrawlerAvailable,
        products,
        selectedProduct,
        shouldShowNouns,
        thirdPartyConfigs
    ]);
    const inlineSelectedIndex = (0, $42omo.useMemo)(()=>{
        return inlineOptions.findIndex((option)=>option.isSelected);
    }, [
        inlineOptions
    ]);
    const onSelectTab = (productOrNounKey)=>{
        if (!productOrNounKey || productOrNounKey in products) onSelectProduct(productOrNounKey);
        else if (productOrNounKey in (0, $4EMbH.nouns)) setAtlasNoun(productOrNounKey);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center",
        grow: "fill",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4A7Gn.default), {
            id: "app-filters-tabs",
            selected: inlineSelectedIndex + 1,
            onChange: (tabIndex)=>{
                if (tabIndex === 0) {
                    onSelectTab(undefined); // user selected "All"
                    return;
                }
                const changedOption = inlineOptions[tabIndex - 1]; // index 0 is "All"
                if (!changedOption) return;
                onSelectTab(changedOption.value);
            },
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $0DTaW.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($782950564c4e1cfd$var$FilterTab, {
                        productOrNounKey: undefined,
                        "aria-label": formatMessage((0, $e921223821c79c8f$export$defe85febe8b728c).allOptionAccessibleLabel),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $e921223821c79c8f$export$defe85febe8b728c).allOptionVisualLabel
                        })
                    }),
                    inlineOptions.map((option)=>{
                        const isSmartlink = (0, $def8z.isProductSmartlink)({
                            productKey: option.value,
                            thirdPartyConfigs: thirdPartyConfigs
                        });
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
                            datasourceId: option.datasourceId,
                            isInline: true,
                            product: option.value,
                            trigger: ({ oAuthWarning: oAuthWarning, isDisabled: isDisabled, triggerProps: triggerProps })=>/*#__PURE__*/ (0, $l998X.jsxs)($782950564c4e1cfd$var$FilterTab, {
                                    triggerProps: triggerProps,
                                    isDisabled: isDisabled,
                                    productOrNounKey: option.value,
                                    children: [
                                        option.inlineLabel,
                                        oAuthWarning
                                    ]
                                }, option.value),
                            useOAuthHandlers: useOAuthHandlers,
                            useIsUserOAuthed: useIsUserOAuthed,
                            isSmartlink: isSmartlink,
                            oAuthSource: (0, $ckkm9.OAuthSource).searchPageFilter,
                            thirdPartyConfigs: thirdPartyConfigs
                        }, option.value);
                    }),
                    nestedOptions.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)($782950564c4e1cfd$var$MoreAppsButton, {
                        nestedOptions: nestedOptions,
                        onSelectTab: onSelectTab,
                        useOAuthHandlers: useOAuthHandlers,
                        useIsUserOAuthed: useIsUserOAuthed,
                        thirdPartyConfigs: thirdPartyConfigs
                    })
                ]
            })
        })
    });
};
const $782950564c4e1cfd$var$tabsTypography = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $782950564c4e1cfd$var$filterTabStyles = (0, $ecnYn.xcss)({
    background: 'none',
    ':hover': {
        background: 'none'
    }
});
const $782950564c4e1cfd$var$filterTextStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    paddingRight: 'space.025'
});
const $782950564c4e1cfd$var$filterNounTestStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.025'
});
const $782950564c4e1cfd$var$moreAppsMenuStyles = (0, $ecnYn.xcss)({
    width: '330px'
});
const $782950564c4e1cfd$var$moreAppsMenuButtonStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $782950564c4e1cfd$var$FilterTab = ({ productOrNounKey: productOrNounKey, children: children, isDisabled: isOnClickDisabled, triggerProps: triggerProps, ...pressableProps })=>{
    const tabAttrs = (0, $bDrnk.default)();
    const onClick = isOnClickDisabled ? ()=>{} : tabAttrs.onClick;
    const isNounFilter = !!productOrNounKey && !!(0, $4EMbH.nouns)[productOrNounKey];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        xcss: [
            $782950564c4e1cfd$var$filterTabStyles,
            $782950564c4e1cfd$var$tabsTypography
        ],
        ...pressableProps,
        ...tabAttrs,
        onClick: onClick,
        ...triggerProps,
        "aria-controls": undefined,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
            alignItems: "center",
            gap: "space.050",
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    productOrNounKey && /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductOrNounIcon), {
                        label: "",
                        size: "small",
                        productOrNounKey: productOrNounKey
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            isNounFilter && $782950564c4e1cfd$var$filterNounTestStyles,
                            $782950564c4e1cfd$var$filterTextStyles
                        ],
                        children: children
                    })
                ]
            })
        })
    });
};
const $782950564c4e1cfd$var$MoreAppsMenu = ({ options: options, onSelectTab: onSelectTab, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, thirdPartyConfigs: thirdPartyConfigs })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $782950564c4e1cfd$var$moreAppsMenuStyles,
        padding: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
            space: "space.050",
            children: options.map((option)=>{
                const isSmartlink = (0, $def8z.isProductSmartlink)({
                    productKey: option.value,
                    thirdPartyConfigs: thirdPartyConfigs
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
                    datasourceId: option.datasourceId,
                    product: option.value,
                    trigger: ({ isDisabled: isDisabled, oAuthWarning: oAuthWarning, triggerProps: triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $782950564c4e1cfd$var$moreAppsMenuButtonStyles,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                shouldFitContainer: true,
                                appearance: "subtle",
                                onClick: ()=>{
                                    !isDisabled && onSelectTab(option.value);
                                },
                                iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductOrNounIcon), {
                                        label: "",
                                        size: "small",
                                        productOrNounKey: option.value
                                    }),
                                ...triggerProps,
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                                    templateColumns: "1fr auto",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                                            alignInline: "start",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                                paddingInlineStart: "space.050",
                                                children: option.label
                                            })
                                        }),
                                        oAuthWarning
                                    ]
                                })
                            }, option.value)
                        }),
                    useOAuthHandlers: useOAuthHandlers,
                    useIsUserOAuthed: useIsUserOAuthed,
                    isSmartlink: isSmartlink,
                    oAuthSource: (0, $ckkm9.OAuthSource).searchPageFilter,
                    thirdPartyConfigs: thirdPartyConfigs
                });
            })
        })
    });
};
const $782950564c4e1cfd$var$MoreAppsButton = ({ nestedOptions: nestedOptions, onSelectTab: onSelectTab, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, thirdPartyConfigs: thirdPartyConfigs })=>{
    const tabAttrs = (0, $bDrnk.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const renderContent = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.Hide), {
            target: "layout",
            above: "sm",
            children: /*#__PURE__*/ (0, $l998X.jsx)($782950564c4e1cfd$var$MoreAppsMenu, {
                options: nestedOptions,
                onSelectTab: (value)=>{
                    onSelectTab(value);
                    setIsOpen(false);
                },
                useOAuthHandlers: useOAuthHandlers,
                useIsUserOAuthed: useIsUserOAuthed,
                thirdPartyConfigs: thirdPartyConfigs
            })
        });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: renderContent,
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                xcss: [
                    $782950564c4e1cfd$var$filterTabStyles,
                    $782950564c4e1cfd$var$tabsTypography
                ],
                "aria-label": formatMessage((0, $e921223821c79c8f$export$defe85febe8b728c).accessibleMoreMenuLabel),
                ...tabAttrs,
                ...triggerProps,
                onClick: ()=>setIsOpen(!isOpen),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                    alignItems: "center",
                    gap: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $e921223821c79c8f$export$defe85febe8b728c).more
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            color: "currentColor",
                            label: "",
                            size: "small"
                        })
                    ]
                })
            })
    });
};
const $782950564c4e1cfd$var$splitAppOptions = (appOptions, selectedIndex)=>{
    let inlineOptions = appOptions.slice(0, $782950564c4e1cfd$var$APP_OPTION_OVERFLOW);
    // if the selected item isn't in the inline options, replace the last item
    if (selectedIndex >= 0 && !inlineOptions.find((inline)=>inline.value === appOptions[selectedIndex].value)) {
        inlineOptions = appOptions.slice(0, $782950564c4e1cfd$var$APP_OPTION_OVERFLOW - 1);
        inlineOptions.push(appOptions[selectedIndex]);
    }
    // The nestedOptions is then simply the filter of the whole list by what is shown inline
    let inlineValues = inlineOptions.map((i)=>i.value);
    const nestedOptions = appOptions.filter((a)=>!inlineValues.includes(a.value));
    return {
        inlineOptions: inlineOptions,
        nestedOptions: nestedOptions
    };
};
var $782950564c4e1cfd$export$2e2bcd8739ae039 = $782950564c4e1cfd$var$AppFilterTabsInline;





const $9afb3d504f643405$export$f0fed4b0765d7314 = ()=>{
    try {
        return (0, $7sS82.useIntercom)();
    } catch (err) {
        return;
    }
};






var $5cssW = parcelRequire("5cssW");


var $gGFxq = parcelRequire("gGFxq");







/**
 * Render search page product filters as tabs.
 */ const $5c159be2d08d05f8$var$AppFilterInline = ()=>{
    const [{ products: availableProducts, nouns: availableNouns, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [isNounsAvailable] = (0, $j4ply.useIsNounsAvailable)();
    const [universalTypeFilterData] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5iakG.universalTypeFilterId)
    });
    const { selectProductFilter: selectProductFilter, unselectProductFilter: unselectProductFilter, unsafe_setAtlasNouns: unsafe_setAtlasNouns } = (0, $djVCD.useSearchActions)();
    const intercom = (0, $9afb3d504f643405$export$f0fed4b0765d7314)();
    const [features] = (0, $j4ply.useFeatures)();
    const appFilterProps = (0, $42omo.useMemo)(()=>({
            sideBySide: features?.sideBySide?.enabled,
            availableProducts: availableProducts,
            availableNouns: availableNouns,
            selectedProduct: selectedProduct,
            isNounsAvailable: isNounsAvailable,
            filterData: universalTypeFilterData,
            setAtlasNoun: unsafe_setAtlasNouns,
            onSelectProduct: (newProduct)=>{
                if (newProduct === selectedProduct) // do nothing when the same product is selected
                return;
                if (!newProduct && selectedProduct) {
                    unselectProductFilter();
                    return;
                }
                selectProductFilter(newProduct);
                if (newProduct && (0, $b4tvS.is3pProductKey)(newProduct)) intercom?.trackEvent('product_filter_clicked_3p', {
                    product_filter: newProduct
                });
                else intercom?.trackEvent('product_filter_clicked', {
                    product_filter: newProduct
                });
            },
            useOAuthHandlers: $gGFxq.useOAuthHandlers,
            useIsUserOAuthed: $gGFxq.useIsUserOAuthed,
            thirdPartyConfigs: thirdPartyConfigs
        }), [
        features,
        availableProducts,
        availableNouns,
        selectedProduct,
        isNounsAvailable,
        universalTypeFilterData,
        unsafe_setAtlasNouns,
        selectProductFilter,
        unselectProductFilter,
        intercom,
        thirdPartyConfigs
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        space: "space.100",
        shouldWrap: true,
        grow: "fill",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
            section: "SearchPageAppFilterInline",
            children: features?.sideBySide?.enabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $782950564c4e1cfd$export$2e2bcd8739ae039), {
                ...appFilterProps
            })
        })
    });
};
var $5c159be2d08d05f8$export$2e2bcd8739ae039 = $5c159be2d08d05f8$var$AppFilterInline;





parcelRequire("42omo");






const $10519cde419c271e$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100',
    paddingTop: 'space.100'
});
const $10519cde419c271e$var$filterStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'radius.small',
    height: 'size.300',
    width: 'size.600'
});
const $10519cde419c271e$export$d5722e1c0b3e12f1 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $10519cde419c271e$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $10519cde419c271e$var$filterStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $10519cde419c271e$var$filterStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $10519cde419c271e$var$filterStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $10519cde419c271e$var$filterStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $10519cde419c271e$var$filterStyles
            })
        ]
    });
};



var $kRxMN = parcelRequire("kRxMN");

const $96ac82e899780ca0$var$filterRowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative',
    paddingBlock: 'space.050',
    paddingInline: 'space.050'
});
// In lite mode, the filters row needs to align flush with the All apps pill
// (no horizontal padding), so the More filters button starts at the same x.
const $96ac82e899780ca0$var$filterRowStylesLite = (0, $ecnYn.xcss)({
    paddingInline: 'space.0'
});
const $96ac82e899780ca0$var$Filters = ()=>{
    const [bootstrapLoading] = (0, $j4ply.useBootstrapLoading)();
    const [features] = (0, $j4ply.useFeatures)();
    const filterContainerRef = (0, $42omo.useRef)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { locale: locale } = (0, $aXWIB.useIntl)();
    if (bootstrapLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: "search-page-filters-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $10519cde419c271e$export$d5722e1c0b3e12f1), {})
    });
    const productFiltersWithClear = /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        space: "space.100",
        ref: filterContainerRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-product-filters",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kRxMN.default), {
                containerRef: filterContainerRef
            })
        })
    });
    // In Lite mode, AppFilterInline is shown in the header row above filters — don't duplicate it here
    const isLiteMode = features?.lite?.enabled ?? false;
    // Side by side always gets the "responsive below sm" version
    if (features?.sideBySide?.enabled) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        direction: "column",
        gap: "space.200",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
                name: "search-page-sbs-app-filter-inline",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5c159be2d08d05f8$export$2e2bcd8739ae039), {})
            }),
            productFiltersWithClear
        ]
    });
    const jiraNinFpsNavigation = (0, $26jni.serveJiraNinFpsNavigation)({
        primaryProduct: primaryProduct,
        locale: locale
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
        templateColumns: "1fr auto",
        alignItems: "center",
        gap: "space.150",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                direction: "column",
                gap: "space.200",
                xcss: isLiteMode ? [
                    $96ac82e899780ca0$var$filterRowStyles,
                    $96ac82e899780ca0$var$filterRowStylesLite
                ] : $96ac82e899780ca0$var$filterRowStyles,
                children: [
                    !isLiteMode && /*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.Hide), {
                        target: "layout",
                        above: "sm",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
                            name: "search-page-app-filter-inline",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5c159be2d08d05f8$export$2e2bcd8739ae039), {})
                        })
                    }),
                    productFiltersWithClear
                ]
            }),
            (!jiraNinFpsNavigation || jiraNinFpsNavigation.cohort === 'control') && primaryProduct === (0, $1yEFx.ProductKeys).Jira && /*#__PURE__*/ (0, $l998X.jsx)((0, $e9ecd89ba2d8712f$export$7905e7d9062c8ee6), {})
        ]
    });
};
const $96ac82e899780ca0$var$FiltersWithErrorBoundary = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "SearchPageFilters",
        children: /*#__PURE__*/ (0, $l998X.jsx)($96ac82e899780ca0$var$Filters, {})
    });
};
var $96ac82e899780ca0$export$2e2bcd8739ae039 = $96ac82e899780ca0$var$FiltersWithErrorBoundary;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $fFa3V = parcelRequire("fFa3V");













var $icqFF = parcelRequire("icqFF");


var $6yNqK = parcelRequire("6yNqK");

const $c8c12c8e63822f48$export$900d08b010253a5e = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}Dropdown`,
        action: 'closed',
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





const $94068ad8452530ec$export$c8d721b69c7e30be = ({ commonAttributes: commonAttributes })=>({
        name: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}Dropdown`,
        attributes: {
            commonAttributes: commonAttributes
        }
    });













const $25a8b9613a265659$export$d4c72bab9d6cc13a = {
    showDropdown: false,
    dropdownLoading: true,
    activeQueryFilterId: '',
    prefetchedRecentViewsResults: undefined,
    prefetchedRecentSearchResults: [],
    peopleAndTeamsResults: {
        results: [],
        duration: -1
    },
    recentViewsResults: [],
    autoSuggestionResults: {
        results: [],
        duration: -1
    },
    recentSearchResults: [],
    resultCount: {
        peopleAndTeams: 0,
        autoSuggestion: 0,
        recentSearch: 0,
        recentViews: 0
    },
    selectedInputFilters: []
};
const $25a8b9613a265659$var$actions = {
    setShowDropdown: (showDropdown)=>({ setState: setState })=>{
            setState({
                showDropdown: showDropdown
            });
        },
    setDropdownLoading: (dropdownLoading)=>({ setState: setState })=>{
            setState({
                dropdownLoading: dropdownLoading
            });
        },
    setActiveQueryFilterId: (activeQueryFilterId)=>({ setState: setState })=>{
            setState({
                activeQueryFilterId: activeQueryFilterId
            });
        },
    setPeopleAndTeamsResults: (peopleAndTeamsResults)=>({ setState: setState })=>{
            setState({
                peopleAndTeamsResults: peopleAndTeamsResults
            });
        },
    setRecentViewsResults: (recentViewsResults)=>({ setState: setState })=>{
            setState({
                recentViewsResults: recentViewsResults
            });
        },
    setAutoSuggestionResults: (autoSuggestionResults)=>({ setState: setState })=>{
            setState({
                autoSuggestionResults: autoSuggestionResults
            });
        },
    setRecentSearchResults: (recentSearchResults)=>({ setState: setState })=>{
            setState({
                recentSearchResults: recentSearchResults
            });
        },
    setResultCount: (resultCount)=>({ setState: setState })=>{
            setState({
                resultCount: resultCount
            });
        },
    setPrefetchedRecentViewsResults: (prefetchedRecentViewsResults)=>({ setState: setState })=>{
            setState({
                prefetchedRecentViewsResults: prefetchedRecentViewsResults
            });
        },
    setPrefetchedRecentSearchResults: (prefetchedRecentSearchResults)=>({ setState: setState })=>{
            setState({
                prefetchedRecentSearchResults: prefetchedRecentSearchResults
            });
        },
    setSelectedInputFilters: (selectedInputFilters)=>({ setState: setState })=>{
            setState({
                selectedInputFilters: selectedInputFilters
            });
        }
};
// Keep store private and use hooks to access state and actions
const $25a8b9613a265659$var$Store = (0, $1P1Tu.createStore)({
    initialState: $25a8b9613a265659$export$d4c72bab9d6cc13a,
    actions: $25a8b9613a265659$var$actions,
    name: 'dropdown'
});
const $25a8b9613a265659$export$4e8b5ffe8cfc8886 = (0, $9zUhf.createActionsHook)($25a8b9613a265659$var$Store);
const $25a8b9613a265659$export$8c32fdb3462273b4 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.showDropdown
});
const $25a8b9613a265659$export$41ba39ed718e7414 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.dropdownLoading
});
const $25a8b9613a265659$export$988aa64982b6032c = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.activeQueryFilterId
});
const $25a8b9613a265659$export$c30c238644aa02ee = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.peopleAndTeamsResults
});
const $25a8b9613a265659$export$f53e0f96bec5ea4d = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.recentViewsResults
});
const $25a8b9613a265659$export$30ecbc19a2297251 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.autoSuggestionResults
});
const $25a8b9613a265659$export$970bfa0ee111b06 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.recentSearchResults
});
const $25a8b9613a265659$export$22da568447791223 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.resultCount
});
const $25a8b9613a265659$export$a7f7068aa342db89 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.prefetchedRecentViewsResults
});
const $25a8b9613a265659$export$8fdf7942b5f23117 = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.prefetchedRecentSearchResults
});
const $25a8b9613a265659$export$5a795cafef59146c = (0, $9zUhf.createHook)($25a8b9613a265659$var$Store, {
    selector: (state)=>state.selectedInputFilters
});











parcelRequire("42omo");


var $1SV4e = parcelRequire("1SV4e");


var $jjjIy = parcelRequire("jjjIy");

const $62cf4e492e3f8cd7$export$7a283d45f414521b = (primaryProduct, userId)=>{
    if (userId && primaryProduct) return (0, $1SV4e.getRecentSearches)({
        userId: userId,
        productId: primaryProduct,
        key: (0, $1SV4e.RECENT_SEARCH_KEY)
    }).map((recentSearch)=>{
        const { query: query } = (0, $1SV4e.getRecentQueryObject)(recentSearch);
        return {
            title: query,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
            onClick: ()=>null
        };
    });
    return [];
};
const $62cf4e492e3f8cd7$export$9770ca05e8d4f1fe = (recentSearches, inputQuery)=>{
    if (inputQuery.length === 0) return recentSearches;
    return (0, $jjjIy.filterSearchResultsWithHighlighting)(recentSearches, inputQuery, inputQuery.length < 3 ? 3 : 2, true);
};



var $jwO5V = parcelRequire("jwO5V");


var $ja8yA = parcelRequire("ja8yA");











var $1R3zJ = parcelRequire("1R3zJ");


var $kMqyt = parcelRequire("kMqyt");


var $hWR4v = parcelRequire("hWR4v");


var $3E8x9 = parcelRequire("3E8x9");





var $4Chrd = parcelRequire("4Chrd");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ // Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/ConfluenceResultMeta.tsx













var $3ro6F = parcelRequire("3ro6F");

var $kGnTD = parcelRequire("kGnTD");





var $gzcCN = parcelRequire("gzcCN");




const $e404dc00fe6cf4ff$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    }
});


const $3f5fa33f99028861$var$ConfluenceResultMetaWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $3f5fa33f99028861$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qv77o _1yijwadc _1xbjidpf _1gmmidpf _fggvidpf _86yhidpf _95px1osq _fu36glyw _1bir1h6o _n1rrwadc _gyc2idpf _uzb6idpf _jnu2idpf _2gatidpf _1jn1glyw _1t771h6o _19301osq _1700idpf _10kk1b66 _ceouidpf _rq3g1b66 _1iev1y44 _1hjc1q9c _1bf67vkz",
            __cmplp.className
        ])
    });
});
const $3f5fa33f99028861$var$ConfluenceTypeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazazsu _1p1d1dk0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f5fa33f99028861$var$ConfluenceMetaSpacerWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazazsu _19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
});
const $3f5fa33f99028861$export$9138e703d4b4585b = ({ resultContentType: resultContentType, resultContentSubtype: resultContentSubtype, resultAncestors: resultAncestors, resultSpace: resultSpace })=>{
    const breadcrumbs = $3f5fa33f99028861$export$ed9f69ac7e699c53(resultAncestors, resultSpace);
    const isLiveDoc = resultContentSubtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in');
    return /*#__PURE__*/ (0, $l998X.jsxs)($3f5fa33f99028861$var$ConfluenceResultMetaWrapper, {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($3f5fa33f99028861$var$ConfluenceTypeWrapper, {
                children: "Confluence"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($3f5fa33f99028861$var$ConfluenceMetaSpacerWrapper, {
                children: "\u2022"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($3f5fa33f99028861$var$ConfluenceTypeWrapper, {
                children: isLiveDoc ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $e404dc00fe6cf4ff$export$defe85febe8b728c).liveDoc
                }) : resultContentType
            }),
            breadcrumbs?.length && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($3f5fa33f99028861$var$ConfluenceMetaSpacerWrapper, {
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($3f5fa33f99028861$var$BreadcrumbsWrapper, {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kGnTD.default), {
                            maxItems: 2,
                            isExpanded: false,
                            onExpand: (e)=>e.preventDefault(),
                            children: breadcrumbs.map(({ id: id, title: title }, itemIndex)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3ro6F.default), {
                                    text: title || '',
                                    truncationWidth: itemIndex === breadcrumbs.length - 1 || itemIndex === 0 ? 130 : 50
                                }, id))
                        })
                    })
                ]
            })
        ]
    });
};
const $3f5fa33f99028861$export$ed9f69ac7e699c53 = (ancestors, space)=>{
    let breadcrumbs = [];
    if (space) {
        const spaceBreadcrumb = {
            id: space?.id,
            title: space?.name
        };
        if (!ancestors || ancestors.length === 0) breadcrumbs = [
            spaceBreadcrumb
        ];
        else if (ancestors.length >= 1) breadcrumbs = [
            spaceBreadcrumb,
            ...ancestors.slice(1)
        ];
    }
    return breadcrumbs;
};


const $f99740509791cca4$var$CONTEXT_PATH = '/wiki/spaces';
const $f99740509791cca4$export$7192bcb9a5864aaa = (edge, thirdPartyConfigs)=>{
    const item = edge.node;
    const iconLabel = `${item.object.product} ${item.object.type}`;
    if ((0, $hWR4v.is1PActivity)(item.object)) switch(item.object.product){
        case 'jira':
            return {
                title: `${item.object.data?.key}: ${(item.object.data?.fieldsById?.edges || [
                    {}
                ])[0].node?.text}` || '',
                description: `Jira ${item.object.type}`,
                subheading: /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType,
                    isMyActivityData: true
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $kMqyt.default), {
                    size: "small",
                    label: iconLabel
                }),
                onClick: ()=>{},
                navigationUrl: item.object.data?.webUrl || ''
            };
        case 'confluence':
            return {
                title: item.object.data?.title || '',
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $3f5fa33f99028861$export$9138e703d4b4585b), {
                    resultContentType: item.object.type,
                    resultContentSubtype: item.object.data?.subtype,
                    resultAncestors: item.object.data?.ancestors,
                    resultSpace: item.object.data?.space
                }),
                subheading: /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType,
                    isMyActivityData: true
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $1R3zJ.default), {
                    size: "small",
                    label: iconLabel
                }),
                onClick: ()=>{},
                navigationUrl: `${item.object.data?.links?.base || $f99740509791cca4$var$CONTEXT_PATH}${item.object.data?.links?.webUi || ''}`
            };
        case 'townsquare':
            return {
                title: `${item.object.data?.key}: ${item.object.data?.name}` || '',
                description: `Atlas ${item.object.type}`,
                subheading: /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType,
                    isMyActivityData: true
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                    width: 24,
                    height: 24,
                    src: item.object.data?.iconData || '',
                    alt: `${item.object.product} ${item.object.type}`
                }),
                onClick: ()=>{},
                navigationUrl: item.object.data?.url || '',
                meta: `Atlas ${item.object.type}`
            };
        default:
            return {
                title: '',
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                onClick: ()=>{
                    return;
                }
            };
    }
    else if ((0, $hWR4v.isGraphActivity)(item.object)) {
        if ((0, $hWR4v.isDocumentActivity)(item.object)) {
            const providerId = item.object.data?.provider?.providerId;
            const product = (0, $4Chrd.getProductFromProviderId)(thirdPartyConfigs, providerId);
            return {
                title: `${item.object.data?.displayName}` || '',
                description: `${product} ${item.object.data?.type?.category}`,
                subheading: /*#__PURE__*/ (0, $l998X.jsx)((0, $3E8x9.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType,
                    isMyActivityData: true
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
                    size: "small",
                    product: product
                }),
                onClick: ()=>{},
                navigationUrl: item.object.data?.url || ''
            };
        } else return {
            title: '',
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
            onClick: ()=>{
                return;
            }
        };
    } else return {
        title: '',
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        onClick: ()=>{
            return;
        }
    };
};


const $f4f28935e73c0254$export$ba7d28c6aa777ec8 = async (cloudId, onError, thirdPartyConfigs, primaryProduct, activationId)=>{
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        product: primaryProduct,
        cloudId: cloudId,
        activationId: activationId
    });
    const fetchData = async (filteredProducts, filteredObjectTypes, filteredRootContainerIds, filteredEventTypes, itemsLimit)=>{
        const response = await (0, $ja8yA.recentActivitiesQuery)({
            variables: {
                filteredProducts: filteredProducts,
                filteredObjectTypes: filteredObjectTypes,
                filteredEventTypes: filteredEventTypes,
                filteredRootContainerIds: filteredRootContainerIds,
                itemsLimit: itemsLimit
            },
            headers: headers
        }).catch((error)=>{
            onError(error);
        });
        const data = response && response.data;
        const edges = data?.activity?.myActivity?.all?.edges || [];
        return edges?.filter((edge)=>edge.node?.object?.data).map((edge)=>(0, $f99740509791cca4$export$7192bcb9a5864aaa)(edge, thirdPartyConfigs));
    };
    return await fetchData([
        'confluence',
        'jira',
        'townsquare'
    ], [
        'page',
        'issue',
        'project'
    ], [
        `ari:cloud:platform::site/${cloudId}`,
        `ari:cloud:townsquare::site/${cloudId}`
    ], [], 200);
};
const $f4f28935e73c0254$export$c8394dd336252c18 = (recentViews, inputQuery)=>{
    if (inputQuery.length === 0) return recentViews;
    return recentViews && (0, $jjjIy.filterSearchResultsWithHighlighting)(recentViews, inputQuery);
};


const $4219044a34e95c55$export$11133d09694420f7 = ()=>{
    const [{ user: user, primaryProduct: primaryProduct, cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs, analyticsAttributes: analyticsAttributes }] = (0, $j4ply.useBootstrap)();
    const { setPrefetchedRecentSearchResults: setPrefetchedRecentSearchResults, setPrefetchedRecentViewsResults: setPrefetchedRecentViewsResults } = (0, $25a8b9613a265659$export$4e8b5ffe8cfc8886)();
    const viewsResultsFetched = (0, $42omo.useRef)(false);
    const searchResultsFetched = (0, $42omo.useRef)(false);
    const logException = (0, $f8oYd.useLogException)();
    const activationId = analyticsAttributes?.activationId;
    (0, $42omo.useEffect)(()=>{
        async function fetchRecentViewsResults() {
            // Only fetch once
            if (!cloudId || viewsResultsFetched.current) return;
            viewsResultsFetched.current = true;
            const recentViewsResults = await (0, $f4f28935e73c0254$export$ba7d28c6aa777ec8)(cloudId, logException, thirdPartyConfigs, primaryProduct, activationId);
            setPrefetchedRecentViewsResults(recentViewsResults);
        }
        fetchRecentViewsResults();
    }, [
        setPrefetchedRecentViewsResults,
        cloudId,
        logException,
        thirdPartyConfigs,
        primaryProduct,
        activationId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (searchResultsFetched.current) return;
        searchResultsFetched.current = true;
        const recentSearchResults = (0, $62cf4e492e3f8cd7$export$7a283d45f414521b)(primaryProduct, user?.id);
        if (recentSearchResults.length > 0) setPrefetchedRecentSearchResults(recentSearchResults);
    }, [
        primaryProduct,
        user,
        setPrefetchedRecentSearchResults
    ]);
};


























parcelRequire("42omo");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss



parcelRequire("42omo");






const $901e25dc7e018c2c$var$searchLinkWithDescriptionStyles = (0, $ecnYn.xcss)({
    width: 'fill',
    padding: 'space.100',
    display: 'grid',
    columnGap: 'space.100',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateAreas: `
    "icon title"
    "icon description"
  `,
    alignItems: 'center',
    height: '50px',
    borderRadius: 'radius.large'
});
const $901e25dc7e018c2c$var$iconSkeleton = (0, $ecnYn.xcss)({
    gridArea: 'icon',
    backgroundColor: 'color.background.neutral',
    width: '24px',
    height: '24px',
    borderRadius: 'radius.xsmall'
});
const $901e25dc7e018c2c$var$titleSkeleton = (0, $ecnYn.xcss)({
    gridArea: 'title',
    backgroundColor: 'color.background.neutral',
    width: '260px',
    height: '14px',
    borderRadius: 'radius.xsmall'
});
const $901e25dc7e018c2c$var$descriptionSkeleton = (0, $ecnYn.xcss)({
    gridArea: 'description',
    backgroundColor: 'color.background.neutral',
    width: '150px',
    height: '10px',
    borderRadius: 'radius.xsmall'
});
const $901e25dc7e018c2c$export$f2db87eaff19de11 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $901e25dc7e018c2c$var$searchLinkWithDescriptionStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $901e25dc7e018c2c$var$iconSkeleton
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $901e25dc7e018c2c$var$titleSkeleton
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $901e25dc7e018c2c$var$descriptionSkeleton
            })
        ]
    });
};


const $ced8ec59864e4e14$export$772547de01833b56 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $901e25dc7e018c2c$export$f2db87eaff19de11), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $901e25dc7e018c2c$export$f2db87eaff19de11), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $901e25dc7e018c2c$export$f2db87eaff19de11), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $901e25dc7e018c2c$export$f2db87eaff19de11), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $901e25dc7e018c2c$export$f2db87eaff19de11), {})
        ]
    });
};





const $98ef75abab6f287f$export$88efc7c63a8a4724 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, dwellTime: dwellTime })=>({
        eventType: 'track',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}Dropdown`,
        action: 'dwelled',
        attributes: {
            additionalAttributes: {
                dwellTime: dwellTime
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });









var $czt8s = parcelRequire("czt8s");




const $86a123e1e6e984a8$export$afebbafde0a7a4ec = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, count: count, duration: duration })=>({
        eventType: 'track',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}DropdownResults`,
        action: 'shown',
        attributes: {
            additionalAttributes: {
                count: count,
                duration: duration
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });















const $6dd92f60995cb7a0$export$e292df53a75b4e9b = (inputQuery, count)=>{
    let { peopleAndTeams: peopleAndTeams, autoSuggestion: autoSuggestion, recentSearch: recentSearch, recentViews: recentViews } = count;
    // case 1: pre-query
    let maxDisplayed = {
        peopleAndTeams: 0,
        autoSuggestion: 0,
        recentSearch: 3,
        recentViews: 5
    };
    // case 2: 1-2 characters in query
    if (inputQuery.length === 1 || inputQuery.length === 2) {
        // with recent search match (same as pre-query)
        if (recentSearch > 0) ;
        else if (autoSuggestion > 0) maxDisplayed = {
            peopleAndTeams: 0,
            autoSuggestion: 8 - Math.min(5, recentViews),
            recentSearch: 0,
            recentViews: 5
        };
        else maxDisplayed = {
            peopleAndTeams: 0,
            autoSuggestion: 0,
            recentSearch: 0,
            recentViews: 7
        };
    }
    // case 3: 3+ characters in query
    if (inputQuery.length >= 3) {
        // with no person match
        if (peopleAndTeams === 0) {
            // with no person match, with recent search
            if (recentSearch) maxDisplayed = {
                peopleAndTeams: 0,
                autoSuggestion: 3,
                recentSearch: 2,
                recentViews: 3
            };
            else maxDisplayed = {
                peopleAndTeams: 0,
                autoSuggestion: 4,
                recentSearch: 0,
                recentViews: 4
            };
        } else maxDisplayed = {
            peopleAndTeams: 2,
            autoSuggestion: recentSearch > 0 ? 1 : 3,
            // surface more auto suggestion if no recent search
            recentSearch: 3,
            recentViews: 3
        };
    }
    return {
        peopleAndTeams: Math.min(maxDisplayed.peopleAndTeams, peopleAndTeams),
        autoSuggestion: Math.min(maxDisplayed.autoSuggestion, autoSuggestion),
        recentSearch: Math.min(maxDisplayed.recentSearch, recentSearch),
        recentViews: Math.min(maxDisplayed.recentViews, recentViews)
    };
};



var $c6GJD = parcelRequire("c6GJD");





var $4qT1X = parcelRequire("4qT1X");

const $c535aa85cd05bb48$var$operationName = 'AutoSuggestionQuery';
const $c535aa85cd05bb48$var$AutoSuggestionQuery = `
query ${$c535aa85cd05bb48$var$operationName}($query: String, $limit: Int!, $filters: QuerySuggestionFilterInput!) {
  suggest {
    suggest(query: $query, limit: $limit, filters: $filters) {
      nodes {
        title
        type
      }
      totalCount
    }
  }
}
`;
const $c535aa85cd05bb48$export$aa1032c480f72e0d = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>(0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $c535aa85cd05bb48$var$AutoSuggestionQuery,
        operationName: $c535aa85cd05bb48$var$operationName,
        headers: headers
    });


const $6315d0ad4d04ad6a$export$2d543e88c46c0c38 = (query, params, onError)=>{
    const autoSuggestionFilters = {
        entities: [
            'query-suggestion.query-suggestion-item'
        ],
        locations: [
            `ari:cloud:confluence::site/${params.cloudId}`
        ]
    };
    const primaryProduct = params.primaryProduct;
    const fetchData = async (query)=>{
        // Disable auto-suggestion for Confluence
        if (primaryProduct === 'confluence') return {
            results: [],
            duration: 0
        };
        // Atlas killswitch
        if (primaryProduct === 'townsquare' && !(0, $c6GJD.default).checkGate('atlas_enable_query_suggestion_dropdown')) return {
            results: [],
            duration: 0
        };
        const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
            cloudId: params.cloudId,
            activationId: params.activationId,
            product: params.primaryProduct
        });
        performance.mark('fetchAutoSuggestionResultsStart');
        const response = await (0, $c535aa85cd05bb48$export$aa1032c480f72e0d)({
            variables: {
                limit: 10,
                filters: autoSuggestionFilters,
                query: query
            },
            headers: headers
        }).catch((error)=>{
            onError(error);
        });
        performance.mark('fetchAutoSuggestionResultsEnd');
        const { duration: duration } = performance.measure('fetchAutoSuggestionResultsDuration', 'fetchAutoSuggestionResultsStart', 'fetchAutoSuggestionResultsEnd');
        return {
            results: response?.data?.suggest?.suggest?.nodes || [],
            duration: duration
        };
    };
    return fetchData(query);
};



var $1L3gY = parcelRequire("1L3gY");

var $c5JjN = parcelRequire("c5JjN");

const $6701285ebb022f4c$export$290039782fc4e47 = (query, params, onError)=>{
    const fetchData = async (query)=>{
        performance.mark('fetchPeopleAndTeamsResultsStart');
        // Map townsquare scope as URS does not support townsquare as a primary product
        const productKey = params.primaryProduct === 'townsquare' ? 'people' : params.primaryProduct;
        const recommendations = await (0, $1L3gY.default)({
            query: query,
            context: {
                contextType: 'full_page_search',
                siteId: params.cloudId || '',
                productKey: productKey || '',
                principalId: params.userId || '',
                organizationId: params.orgId || ''
            },
            includeUsers: true,
            includeTeams: true,
            includeGroups: false,
            maxNumberOfResults: 3,
            performSearchQueryOnly: false,
            searchQuery: {
                filter: 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)',
                teamSearchFields: [
                    (0, $c5JjN.TeamSearchField).NAME
                ]
            }
        }).catch((error)=>{
            onError(error);
            return [];
        });
        performance.mark('fetchPeopleAndTeamsResultsEnd');
        const { duration: duration } = performance.measure('fetchPeopleAndTeamsResultsDuration', 'fetchPeopleAndTeamsResultsStart', 'fetchPeopleAndTeamsResultsEnd');
        return {
            results: recommendations,
            duration: duration
        };
    };
    return fetchData(query);
};




const $295a673e2b594ca9$var$fetchAll = async (query, peopleParams, autoSuggestionParams, onError)=>{
    return Promise.all([
        (0, $6701285ebb022f4c$export$290039782fc4e47)(query, peopleParams, onError),
        (0, $6315d0ad4d04ad6a$export$2d543e88c46c0c38)(query, autoSuggestionParams, onError)
    ]);
};
const $295a673e2b594ca9$export$4e2bef15a5b74b17 = ()=>{
    const [inputQuery] = (0, $djVCD.useInputQuery)();
    const [{ cloudId: cloudId, user: user, primaryProduct: primaryProduct, orgId: orgId, analyticsAttributes: analyticsAttributes }] = (0, $j4ply.useBootstrap)();
    const peopleParams = (0, $42omo.useMemo)(()=>({
            primaryProduct: primaryProduct,
            cloudId: cloudId,
            userId: user?.id ?? undefined,
            orgId: orgId
        }), [
        primaryProduct,
        cloudId,
        user?.id,
        orgId
    ]);
    const autoSuggestionParams = (0, $42omo.useMemo)(()=>({
            primaryProduct: primaryProduct,
            cloudId: cloudId,
            activationId: analyticsAttributes?.activationId
        }), [
        primaryProduct,
        cloudId,
        analyticsAttributes?.activationId
    ]);
    const [dropdownLoading] = (0, $25a8b9613a265659$export$41ba39ed718e7414)();
    const requestRef = (0, $42omo.useRef)();
    const [currentInputQuery, setCurrentInputQuery] = (0, $42omo.useState)(inputQuery);
    const [recentSearchResults] = (0, $25a8b9613a265659$export$8fdf7942b5f23117)();
    const [recentViewsResults] = (0, $25a8b9613a265659$export$a7f7068aa342db89)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const logException = (0, $f8oYd.useLogException)();
    const { setPeopleAndTeamsResults: setPeopleAndTeamsResults, setRecentViewsResults: setRecentViewsResults, setAutoSuggestionResults: setAutoSuggestionResults, setRecentSearchResults: setRecentSearchResults, setDropdownLoading: setDropdownLoading, setResultCount: setResultCount } = (0, $25a8b9613a265659$export$4e8b5ffe8cfc8886)();
    const debounceTimeout = (0, $42omo.useRef)(null);
    const fetchData = (0, $42omo.useCallback)(async (query)=>{
        setCurrentInputQuery(inputQuery);
        if (requestRef.current) // If there is an existing fetchAll promise, cancel it
        requestRef.current.cancel();
        setDropdownLoading(true);
        // Set the fetchAll promise
        requestRef.current = new (0, $czt8s.CancellablePromise)($295a673e2b594ca9$var$fetchAll(query, peopleParams, autoSuggestionParams, logException));
        try {
            const [peopleAndTeamsResults, autoSuggestionResults] = await requestRef.current.promise();
            // update store
            setPeopleAndTeamsResults(peopleAndTeamsResults);
            setAutoSuggestionResults(autoSuggestionResults);
            const filteredRecentSearchResults = (0, $62cf4e492e3f8cd7$export$9770ca05e8d4f1fe)(recentSearchResults, query);
            setRecentSearchResults(filteredRecentSearchResults);
            const filteredRecentViewsResults = (0, $f4f28935e73c0254$export$c8394dd336252c18)(recentViewsResults ?? [], query);
            setRecentViewsResults(filteredRecentViewsResults);
            const resultCounts = (0, $6dd92f60995cb7a0$export$e292df53a75b4e9b)(query, {
                peopleAndTeams: peopleAndTeamsResults.results.length,
                autoSuggestion: autoSuggestionResults.results.length,
                recentSearch: filteredRecentSearchResults.length,
                recentViews: filteredRecentViewsResults.length
            });
            setResultCount(resultCounts);
            const queryDurations = {
                peopleAndTeams: peopleAndTeamsResults.duration,
                autoSuggestion: autoSuggestionResults.duration
            };
            fireAnalyticsEvent(// TODO: Move this to where the results are actually rendered
            (0, $86a123e1e6e984a8$export$afebbafde0a7a4ec)({
                commonAttributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                count: resultCounts,
                duration: queryDurations
            }));
            // stop loading
            setDropdownLoading(false);
        } catch (error) {
            if (!(error instanceof (0, $czt8s.CancelError))) {
                // stop loading
                setDropdownLoading(false);
                // log error
                logException(error);
            }
        }
    }, [
        autoSuggestionParams,
        commonAttributes,
        fireAnalyticsEvent,
        inputQuery,
        logException,
        nonPrivacySafeAttributes,
        peopleParams,
        recentSearchResults,
        recentViewsResults,
        setAutoSuggestionResults,
        setDropdownLoading,
        setPeopleAndTeamsResults,
        setRecentSearchResults,
        setRecentViewsResults,
        setResultCount
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((inputQuery !== currentInputQuery || dropdownLoading && !requestRef.current) && recentViewsResults !== undefined) {
            if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
            debounceTimeout.current = setTimeout(()=>{
                fetchData(inputQuery);
            }, 300);
        }
    }, [
        inputQuery,
        currentInputQuery,
        dropdownLoading,
        recentViewsResults,
        fetchData
    ]);
};













var $jluld = parcelRequire("jluld");







var $bloXB = parcelRequire("bloXB");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $inPa6 = parcelRequire("inPa6");







var $9lW6K = parcelRequire("9lW6K");







const $ab3cb6efe7e048b3$export$efeec3c53a35b71b = (index, applicationMode)=>{
    return {
        type: 'sendUIEvent',
        data: {
            actionSubject: 'keyboard',
            action: 'highlighted',
            source: 'fullPageSearch',
            attributes: {
                index: index,
                mode: applicationMode
            }
        }
    };
};


const $3342c6eb4ab6ed12$export$6766232a164d1444 = (pressType, title, applicationMode)=>{
    return {
        type: 'sendUIEvent',
        data: {
            actionSubject: 'keyboard',
            action: 'pressed',
            source: 'fullPageSearch',
            attributes: {
                pressType: pressType,
                title: title,
                mode: applicationMode
            }
        }
    };
};



var $jAenQ = parcelRequire("jAenQ");




const $7354f8668f751838$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    searchLinkLabel: {
        id: "search-page.search-link.label",
        defaultMessage: "Search Link"
    }
});


const $6d18f2976733d256$var$searchLinkStyles = (0, $ecnYn.xcss)({
    width: 'fill',
    padding: 'space.100',
    display: 'grid',
    columnGap: 'space.100',
    gridTemplateColumns: 'auto 1fr auto',
    gridTemplateAreas: `
    "icon title subheading"
  `,
    alignItems: 'center',
    height: '40px',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    borderRadius: 'radius.large',
    cursor: 'pointer'
});
const $6d18f2976733d256$var$searchLinkWithDescriptionStyles = (0, $ecnYn.xcss)({
    width: 'fill',
    padding: 'space.100',
    display: 'grid',
    columnGap: 'space.100',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateAreas: `
    "icon title subheading"
    "icon description subheading"
  `,
    alignItems: 'center',
    height: '50px',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    borderRadius: 'radius.large',
    cursor: 'pointer'
});
const $6d18f2976733d256$var$iconStyles = (0, $ecnYn.xcss)({
    gridArea: 'icon'
});
const $6d18f2976733d256$var$titleStyles = (0, $ecnYn.xcss)({
    gridArea: 'title',
    color: 'color.text',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $6d18f2976733d256$var$descriptionStyles = (0, $ecnYn.xcss)({
    gridArea: 'description',
    display: 'flex',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'inherit',
    color: 'color.text.subtle',
    paddingTop: 'space.075'
});
const $6d18f2976733d256$var$subheadingStyles = (0, $ecnYn.xcss)({
    gridArea: 'subheading',
    display: 'flex',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    alignItems: 'center',
    gap: 'space.050'
});
const $6d18f2976733d256$var$DropdownResultContent = ({ title: title, description: description, subheading: subheading, icon: icon, onClick: onClick, highlightedTitle: highlightedTitle, rightPanel: rightPanel, linkRef: linkRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const onSubmit = (e, target)=>{
        if (e.key === 'Enter') {
            createAnalyticsEvent((0, $3342c6eb4ab6ed12$export$6766232a164d1444)(e.key, title, applicationMode)).fire();
            onClick({
                target: target
            });
            if (linkRef?.current) linkRef.current.click();
        }
    };
    const onHighlighted = (index)=>{
        createAnalyticsEvent((0, $ab3cb6efe7e048b3$export$efeec3c53a35b71b)(index, applicationMode)).fire();
    };
    const [isKeyboardHighlighted, setRef] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: onSubmit,
        onHighlightedCallback: onHighlighted
    });
    const [isMouseHighlighted, setIsMouseHighlighted] = (0, $42omo.useState)(false);
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        ref: setRef,
        xcss: description ? $6d18f2976733d256$var$searchLinkWithDescriptionStyles : $6d18f2976733d256$var$searchLinkStyles,
        backgroundColor: isKeyboardHighlighted ? 'color.background.neutral.subtle.hovered' : 'color.background.neutral.subtle',
        onClick: onClick,
        onMouseDown: (e)=>e.preventDefault(),
        "aria-label": formatMessage((0, $7354f8668f751838$export$defe85febe8b728c).searchLinkLabel),
        onMouseOver: ()=>setIsMouseHighlighted(true),
        onMouseLeave: ()=>setIsMouseHighlighted(false),
        testId: "search-page-dropdown-result",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $6d18f2976733d256$var$iconStyles,
                children: icon
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $6d18f2976733d256$var$titleStyles,
                children: highlightedTitle ? (0, $9lW6K.enrichResultTitle)(highlightedTitle) : title
            }),
            subheading && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $6d18f2976733d256$var$subheadingStyles,
                children: subheading
            }),
            description && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $6d18f2976733d256$var$descriptionStyles,
                children: description
            }),
            rightPanel && (isKeyboardHighlighted || isMouseHighlighted) && rightPanel
        ]
    }));
};
const $6d18f2976733d256$export$5b6118e2ff142a50 = (props)=>{
    const linkRef = (0, $42omo.useRef)(null);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ), {
        style: {
            textDecoration: 'none',
            color: 'inherit'
        },
        ref: linkRef,
        href: props.navigationUrl || '',
        testId: "search-page-dropdown-result-link",
        children: /*#__PURE__*/ (0, $l998X.jsx)($6d18f2976733d256$var$DropdownResultContent, {
            ...props,
            linkRef: linkRef
        })
    });
};
const $6d18f2976733d256$export$f12258e0b62ed378 = (props)=>{
    const [features] = (0, $j4ply.useFeatures)();
    const onClick = (0, $42omo.useCallback)(()=>{
        if (!features?.chromeExtension?.enabled) return;
        const { onInputDropdownResultSelect: onInputDropdownResultSelect } = features.chromeExtension;
        onInputDropdownResultSelect({
            title: props.title,
            url: props.navigationUrl
        });
    }, [
        features?.chromeExtension,
        props.title,
        props.navigationUrl
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($6d18f2976733d256$var$DropdownResultContent, {
        ...props,
        onClick: onClick
    });
};
const $6d18f2976733d256$export$bbedf2c4ad87789c = (props)=>{
    const [features] = (0, $j4ply.useFeatures)();
    if (features?.chromeExtension?.enabled) return /*#__PURE__*/ (0, $l998X.jsx)($6d18f2976733d256$export$f12258e0b62ed378, {
        ...props
    });
    else if (props.navigationUrl) return /*#__PURE__*/ (0, $l998X.jsx)($6d18f2976733d256$export$5b6118e2ff142a50, {
        ...props
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)($6d18f2976733d256$var$DropdownResultContent, {
        ...props
    });
};


var $c54c3c289a186d1e$export$29f60e5970ae74d2 = /*#__PURE__*/ function(SearchLinkTypes) {
    SearchLinkTypes["RecentViews"] = "RECENT_VIEWS";
    SearchLinkTypes["RecentSearches"] = "RECENT_SEARCHES";
    SearchLinkTypes["PeopleAndTeams"] = "PEOPLE_AND_TEAMS";
    SearchLinkTypes["MimicQuery"] = "MIMIC_QUERY";
    SearchLinkTypes["GenerateAnswer"] = "GENERATE_ANSWER";
    SearchLinkTypes["AutoSuggestion"] = "AUTO_SUGGESTION";
    return SearchLinkTypes;
}({});





const $71cd44a664d39200$export$dd7618150e1396d8 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, resultType: resultType, duration: duration, index: index })=>({
        eventType: 'ui',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}DropdownResult`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                resultType: resultType,
                index: index,
                duration: duration
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });












const $a9a99e809a5bb9aa$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    searchIconLabel: {
        id: "dropdown_search_icon_label",
        defaultMessage: "Search"
    }
});


const $6cf1b3e958519a2d$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $6cf1b3e958519a2d$export$14bd3dc13236b3f1 = ({ getElementIndex: getElementIndex })=>{
    const [inputQuery, { setSearchQuery: setSearchQuery }] = (0, $djVCD.useInputQuery)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $25a8b9613a265659$export$8c32fdb3462273b4)();
    const intl = (0, $aXWIB.useIntl)();
    const [recentSearchResults] = (0, $25a8b9613a265659$export$970bfa0ee111b06)();
    const [autoSuggestionResults] = (0, $25a8b9613a265659$export$30ecbc19a2297251)();
    const [resultCount] = (0, $25a8b9613a265659$export$22da568447791223)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const recentSearchTitles = recentSearchResults.slice(0, resultCount.recentSearch).map((search)=>search.title.toLowerCase());
    const filteredAutoSuggestions = autoSuggestionResults.results.filter((suggestion)=>{
        return !recentSearchTitles.includes(suggestion.title.toLowerCase()) && suggestion.title !== inputQuery.toLowerCase();
    }).slice(0, resultCount.autoSuggestion);
    const fireAnalytics = (0, $42omo.useCallback)((event)=>{
        const index = event.target && getElementIndex ? getElementIndex(event.target) : undefined;
        fireAnalyticsEvent((0, $71cd44a664d39200$export$dd7618150e1396d8)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            resultType: (0, $c54c3c289a186d1e$export$29f60e5970ae74d2).AutoSuggestion,
            duration: autoSuggestionResults.duration,
            ...index !== undefined ? {
                index: index
            } : {}
        }));
    }, [
        getElementIndex,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        autoSuggestionResults.duration
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: filteredAutoSuggestions.map((suggestion, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6d18f2976733d256$export$bbedf2c4ad87789c), {
                title: suggestion.title || '',
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $6cf1b3e958519a2d$var$iconStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                        color: "currentColor",
                        label: intl.formatMessage((0, $a9a99e809a5bb9aa$export$defe85febe8b728c).searchIconLabel)
                    })
                }),
                onClick: (event)=>{
                    setSearchQuery(suggestion.title || '');
                    setShowDropdown(false);
                    fireAnalytics(event);
                },
                highlightedTitle: (0, $bloXB.highlightMatchedText)(suggestion.title, inputQuery.split(' ')).negatedHighlightedTitle
            }, `${index}-${suggestion.title}`))
    });
};





const $4a762473300bc750$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    searchSuggestionsDropdown: {
        id: "search-page.dropdown.search-suggestions",
        defaultMessage: "Search Suggestions Dropdown"
    }
});



















// Copied from packages/search/search-dialog/src/icons/square-return-icon.tsx



parcelRequire("42omo");

const $b06cfc8e8811599c$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: "var(--ds-background-neutral, #0515240F)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: "var(--ds-icon-subtle, #505258)"
            })
        ]
    });















const $95f09aab874ce9e0$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    search: {
        id: "dropdown_search",
        defaultMessage: "Search"
    },
    searchIconLabel: {
        id: "dropdown_search_icon_label",
        defaultMessage: "Search"
    }
});


const $ca2ec3db2bdd58ea$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $ca2ec3db2bdd58ea$var$subheadingTextWrapper = (0, $ecnYn.xcss)({
    marginRight: 'space.100'
});
const $ca2ec3db2bdd58ea$export$4a7d659f3bdb9018 = ({ getElementIndex: getElementIndex })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [inputQuery] = (0, $djVCD.useInputQuery)();
    const { triggerSearch: triggerSearch } = (0, $djVCD.useSearchActions)();
    const { setShowDropdown: setShowDropdown } = (0, $25a8b9613a265659$export$4e8b5ffe8cfc8886)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const fireAnalytics = (0, $42omo.useCallback)((event)=>{
        const index = event.target && getElementIndex ? getElementIndex(event.target) : undefined;
        fireAnalyticsEvent((0, $71cd44a664d39200$export$dd7618150e1396d8)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            resultType: (0, $c54c3c289a186d1e$export$29f60e5970ae74d2).MimicQuery,
            ...index !== undefined ? {
                index: index
            } : {}
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        getElementIndex
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: inputQuery.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $6d18f2976733d256$export$bbedf2c4ad87789c), {
            title: inputQuery,
            subheading: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $ca2ec3db2bdd58ea$var$subheadingTextWrapper,
                        children: intl.formatMessage((0, $95f09aab874ce9e0$export$defe85febe8b728c).search)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $b06cfc8e8811599c$export$4501fc029b186da8), {})
                ]
            }),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $ca2ec3db2bdd58ea$var$iconStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                    color: "currentColor",
                    label: intl.formatMessage((0, $95f09aab874ce9e0$export$defe85febe8b728c).searchIconLabel)
                })
            }),
            onClick: (event)=>{
                fireAnalytics(event);
                setShowDropdown(false);
                triggerSearch();
            }
        })
    });
};












var $esRft = parcelRequire("esRft");













var $5e5BE = parcelRequire("5e5BE");

var $ipWWT = parcelRequire("ipWWT");

















const $98f084424a43f90a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    teamLabel: {
        id: "team",
        defaultMessage: "Team"
    },
    avatarLabel: {
        id: "avatar",
        defaultMessage: "Avatar"
    }
});


const $6c53656bfd846eca$export$9d052a57a86e166 = ({ getElementIndex: getElementIndex })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [orgId] = (0, $j4ply.useOrgId)();
    const [inputQuery] = (0, $djVCD.useInputQuery)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $25a8b9613a265659$export$8c32fdb3462273b4)();
    const [resultCount] = (0, $25a8b9613a265659$export$22da568447791223)();
    const [peopleAndTeamsResults] = (0, $25a8b9613a265659$export$c30c238644aa02ee)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const fireAnalytics = (0, $42omo.useCallback)((event)=>{
        const index = event.target && getElementIndex ? getElementIndex(event.target) : undefined;
        fireAnalyticsEvent((0, $71cd44a664d39200$export$dd7618150e1396d8)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            resultType: (0, $c54c3c289a186d1e$export$29f60e5970ae74d2).PeopleAndTeams,
            duration: peopleAndTeamsResults.duration,
            ...index !== undefined ? {
                index: index
            } : {}
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        getElementIndex,
        nonPrivacySafeAttributes,
        peopleAndTeamsResults.duration
    ]);
    const onClick = (event)=>{
        setShowDropdown(false);
        fireAnalytics(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: peopleAndTeamsResults.results.slice(0, resultCount.peopleAndTeams).map((result, index)=>{
            if (result.entityType === (0, $c5JjN.EntityType).USER && result.name) {
                const navigationUrl = primaryProduct && cloudId && orgId && (0, $ipWWT.getUserPath)(result.id, primaryProduct, orgId, cloudId);
                return /*#__PURE__*/ (0, $l998X.jsx)($6c53656bfd846eca$var$PeopleAndTeamsLink, {
                    title: result.name,
                    description: result.title,
                    avatarUrl: result.avatarUrl,
                    onClick: onClick,
                    inputQuery: inputQuery,
                    navigationUrl: navigationUrl || ''
                }, `${index}-${result.name}`);
            } else if (result.entityType === (0, $c5JjN.EntityType).TEAM && result.displayName) {
                const navigationUrl = primaryProduct && cloudId && orgId && (0, $5e5BE.getTeamPath)(result.id, primaryProduct, orgId, cloudId);
                return /*#__PURE__*/ (0, $l998X.jsx)($6c53656bfd846eca$var$PeopleAndTeamsLink, {
                    title: result.displayName,
                    description: intl.formatMessage((0, $98f084424a43f90a$export$defe85febe8b728c).teamLabel),
                    avatarUrl: result?.smallAvatarImageUrl,
                    onClick: onClick,
                    inputQuery: inputQuery,
                    navigationUrl: navigationUrl || ''
                }, `${index}-${result.name}`);
            }
        })
    });
};
const $6c53656bfd846eca$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.full',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $6c53656bfd846eca$var$PeopleAndTeamsLink = ({ title: title, description: description = '', avatarUrl: avatarUrl = '', inputQuery: inputQuery, onClick: onClick, navigationUrl: navigationUrl })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6d18f2976733d256$export$bbedf2c4ad87789c), {
        title: title,
        description: description,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $6c53656bfd846eca$var$iconStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                src: avatarUrl,
                size: "small"
            })
        }),
        onClick: onClick,
        highlightedTitle: (0, $bloXB.highlightMatchedText)(title, inputQuery.split(' ')).highlightedTitle,
        navigationUrl: navigationUrl
    });












var $1qfLF = parcelRequire("1qfLF");


var $kevJM = parcelRequire("kevJM");


var $hmuev = parcelRequire("hmuev");

























const $1e0f992ea0a7c583$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    recentSearchIconLabel: {
        id: "dropdown_recent_icon_label",
        defaultMessage: "Recent"
    },
    removeRecentSearchIcon: {
        id: "search-result.remove-recent-search",
        defaultMessage: "Remove recent search icon"
    },
    removeRecentSearchSubheading: {
        id: "search-result.remove-recent-search-result-subheading",
        defaultMessage: "Recent search"
    }
});


const $6d00a4911a1ec23f$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $6d00a4911a1ec23f$export$e4bc6828df5bf4e8 = ({ getElementIndex: getElementIndex })=>{
    const { setSearchQuery: setSearchQuery } = (0, $djVCD.useSearchActions)();
    const [resultCount] = (0, $25a8b9613a265659$export$22da568447791223)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $25a8b9613a265659$export$8c32fdb3462273b4)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const fireAnalytics = (0, $42omo.useCallback)((event)=>{
        const index = event.target && getElementIndex ? getElementIndex(event.target) : undefined;
        fireAnalyticsEvent((0, $71cd44a664d39200$export$dd7618150e1396d8)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            resultType: (0, $c54c3c289a186d1e$export$29f60e5970ae74d2).RecentSearches,
            ...index !== undefined ? {
                index: index
            } : {}
        }));
    }, [
        getElementIndex,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
    const onClick = (query, event)=>{
        setShowDropdown(false);
        fireAnalytics(event);
        setSearchQuery(query);
    };
    const [recentSearches] = (0, $25a8b9613a265659$export$970bfa0ee111b06)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: recentSearches.slice(0, resultCount.recentSearch).map((result, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6d18f2976733d256$export$bbedf2c4ad87789c), {
                title: result.title,
                icon: /*#__PURE__*/ (0, $l998X.jsx)($6d00a4911a1ec23f$export$aa64f88f83123fb7, {}),
                onClick: (event)=>onClick(result.title, event),
                rightPanel: /*#__PURE__*/ (0, $l998X.jsx)($6d00a4911a1ec23f$export$ea04c1e9e2b7cc14, {
                    title: result.title
                })
            }, `${index}-${result.title}`))
    });
};
const $6d00a4911a1ec23f$export$aa64f88f83123fb7 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $6d00a4911a1ec23f$var$iconStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            color: "currentColor",
            label: intl.formatMessage((0, $1e0f992ea0a7c583$export$defe85febe8b728c).recentSearchIconLabel),
            spacing: "spacious"
        })
    });
};
const $6d00a4911a1ec23f$var$recentSearchRightPanelStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $6d00a4911a1ec23f$var$subheadingStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.150'
});
const $6d00a4911a1ec23f$export$ea04c1e9e2b7cc14 = ({ title: title })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { setRecentSearchResults: setRecentSearchResults } = (0, $25a8b9613a265659$export$4e8b5ffe8cfc8886)();
    const onClick = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        if (user?.id && primaryProduct) {
            const newRecentSearches = (0, $1SV4e.removeRecentSearch)({
                value: title,
                userId: user.id,
                productId: primaryProduct,
                key: (0, $1SV4e.RECENT_SEARCH_KEY)
            }).map((recentSearchItem)=>({
                    // Todo: cleanup this so that we only need to pass the search title.
                    title: (0, $1SV4e.getRecentQueryObject)(recentSearchItem).query,
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                    onClick: ()=>null
                }));
            setRecentSearchResults(newRecentSearches);
        }
    }, [
        primaryProduct,
        title,
        setRecentSearchResults,
        user?.id
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $6d00a4911a1ec23f$var$recentSearchRightPanelStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                as: "span",
                xcss: $6d00a4911a1ec23f$var$subheadingStyles,
                children: intl.formatMessage((0, $1e0f992ea0a7c583$export$defe85febe8b728c).removeRecentSearchSubheading)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                        ...iconProps,
                        label: intl.formatMessage((0, $1e0f992ea0a7c583$export$defe85febe8b728c).removeRecentSearchIcon),
                        color: "currentColor"
                    }),
                spacing: 'compact',
                onClick: onClick,
                label: intl.formatMessage((0, $1e0f992ea0a7c583$export$defe85febe8b728c).removeRecentSearchIcon),
                appearance: 'subtle'
            })
        ]
    });
};




















const $b9c63843351470aa$var$iconStyles = (0, $ecnYn.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $b9c63843351470aa$export$c68af787f8f88afe = ({ getElementIndex: getElementIndex })=>{
    const [recentViewsResults] = (0, $25a8b9613a265659$export$f53e0f96bec5ea4d)();
    const { setShowDropdown: setShowDropdown } = (0, $25a8b9613a265659$export$4e8b5ffe8cfc8886)();
    const [resultCount] = (0, $25a8b9613a265659$export$22da568447791223)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const fireAnalytics = (0, $42omo.useCallback)((event)=>{
        const index = event.target && getElementIndex ? getElementIndex(event.target) : undefined;
        fireAnalyticsEvent((0, $71cd44a664d39200$export$dd7618150e1396d8)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            resultType: (0, $c54c3c289a186d1e$export$29f60e5970ae74d2).RecentViews,
            ...index !== undefined ? {
                index: index
            } : {}
        }));
    }, [
        getElementIndex,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
    const onClick = (event)=>{
        setShowDropdown(false);
        fireAnalytics(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: recentViewsResults?.slice(0, resultCount.recentViews).map((result, index)=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6d18f2976733d256$export$bbedf2c4ad87789c), {
                title: result.title,
                description: result.description,
                subheading: result.subheading,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $b9c63843351470aa$var$iconStyles,
                    children: result.icon
                }),
                onClick: onClick,
                highlightedTitle: result.highlightedTitle,
                navigationUrl: result.navigationUrl
            }, `${index}-${result.title}`);
        })
    });
};


const $de28d63f0a3d693c$var$searchDropdownStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    gap: 'space.025',
    boxShadow: 'elevation.shadow.overlay',
    borderWidth: '0',
    boxSizing: 'border-box'
});
const $de28d63f0a3d693c$export$e33d60b8f4099ae = ({ inputWidth: inputWidth })=>{
    (0, $295a673e2b594ca9$export$4e2bef15a5b74b17)();
    const [dropdownLoading] = (0, $25a8b9613a265659$export$41ba39ed718e7414)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const containerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const start = Date.now();
        return ()=>{
            const end = Date.now();
            const msElapsed = end - start;
            fireAnalyticsEvent((0, $98ef75abab6f287f$export$88efc7c63a8a4724)({
                commonAttributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                dwellTime: msElapsed
            }));
        };
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes
    ]);
    const getElementIndex = (0, $42omo.useCallback)((eventTarget)=>{
        if (!eventTarget || !containerRef.current) return;
        const currentChildNodes = containerRef.current.childNodes;
        const childNodeList = [];
        for(let i = 0; i < currentChildNodes.length; i++)childNodeList.push(currentChildNodes.item(i));
        // Find which index the selected target is from the childNodes of this component
        const childIndex = childNodeList.findIndex((child)=>{
            return child.isSameNode(eventTarget) || child.contains(eventTarget);
        });
        return childIndex === -1 ? undefined : childIndex;
    }, [
        containerRef
    ]);
    // The direct childNodes of this component are used to get the analytics element index of each
    // SearchLink. Nesting two SearchLinks together into a single direct childNode will result in
    // an incorrect element index. See `getElementIndex` for logic.
    const content = dropdownLoading ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ca2ec3db2bdd58ea$export$4a7d659f3bdb9018), {
                getElementIndex: getElementIndex
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ced8ec59864e4e14$export$772547de01833b56), {})
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ca2ec3db2bdd58ea$export$4a7d659f3bdb9018), {
                getElementIndex: getElementIndex
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6cf1b3e958519a2d$export$14bd3dc13236b3f1), {
                getElementIndex: getElementIndex
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6d00a4911a1ec23f$export$e4bc6828df5bf4e8), {
                getElementIndex: getElementIndex
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6c53656bfd846eca$export$9d052a57a86e166), {
                getElementIndex: getElementIndex
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $b9c63843351470aa$export$c68af787f8f88afe), {
                getElementIndex: getElementIndex
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $de28d63f0a3d693c$var$searchDropdownStyles,
        style: {
            width: `${inputWidth}px`
        },
        "aria-label": formatMessage((0, $4a762473300bc750$export$defe85febe8b728c).searchSuggestionsDropdown),
        testId: 'search-suggestions-dropdown',
        ref: containerRef,
        children: content
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 




























var $9hlns = parcelRequire("9hlns");


var $4noo5 = parcelRequire("4noo5");














var $fm8DG = parcelRequire("fm8DG");





var $kIdP4 = parcelRequire("kIdP4");







const $afacec520190eeee$export$a622d365e8995608 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, location: location })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}CopyLinkButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                location: location
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });



var $1ymk3 = parcelRequire("1ymk3");




const $e31123e898a81d94$export$9f6a79d85aed5338 = (location)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    return (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $afacec520190eeee$export$a622d365e8995608)({
            commonAttributes: {
                ...commonAttributes,
                ...(0, $1ymk3.getExtensionData)(commonAttributes.isCQL)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            location: location
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        location
    ]);
};











const $53c6e852a90698b9$export$613310893a9f5d54 = (0, $aXWIB.defineMessages)({
    inputPlaceholderDefault: {
        id: "input_placeholder_default",
        defaultMessage: "Search for anything"
    },
    inputPlaceholderNav3: {
        id: "input_placeholder_nav3",
        defaultMessage: "Search"
    },
    inputPlaceholder: {
        id: "input_placeholder",
        defaultMessage: "Search"
    }
});











const $0b1aaacc4dfed6a4$export$6593fbebf10a44f4 = (0, $aXWIB.defineMessages)({
    inputPlaceholderWithAtlassianIntelligence: {
        id: "input_placeholder_with_atlassian_intelligence",
        defaultMessage: "Search or ask anything"
    },
    inputPlaceholderWithRovo: {
        id: "input_placeholder_with_rovo",
        defaultMessage: "Search or ask Rovo"
    },
    searchAcrossProducts: {
        id: "input_placeholder_ghost_text_search_across",
        defaultMessage: "Search across {products}, and more"
    },
    submitExpenseQuestion: {
        id: "input_placeholder_ghost_text_submit_expense",
        defaultMessage: "Ask a question like \"How do I submit an expense?\""
    },
    kpiAcronymSearch: {
        id: "input_placeholder_ghost_text_kpi_acronym",
        defaultMessage: "Search any acronym, like \"KPI\""
    },
    mentionTeammatesSearch: {
        id: "input_placeholder_ghost_text_mention_teammates",
        defaultMessage: "@mention a teammate to see their work"
    },
    searchTeammateName: {
        id: "input_placeholder_ghost_text_search_teammate",
        defaultMessage: "Search the name of a teammate"
    }
});


const { searchAcrossProducts: $29bbc9a782c07566$var$searchAcrossProducts, submitExpenseQuestion: $29bbc9a782c07566$var$submitExpenseQuestion, kpiAcronymSearch: $29bbc9a782c07566$var$kpiAcronymSearch, mentionTeammatesSearch: $29bbc9a782c07566$var$mentionTeammatesSearch, searchTeammateName: $29bbc9a782c07566$var$searchTeammateName } = (0, $0b1aaacc4dfed6a4$export$6593fbebf10a44f4);
const $29bbc9a782c07566$export$80bfcd0b41a91527 = [
    // First session
    [
        $29bbc9a782c07566$var$searchAcrossProducts,
        // Ghost text 1
        $29bbc9a782c07566$var$submitExpenseQuestion,
        // Ghost text 2
        $29bbc9a782c07566$var$kpiAcronymSearch // Ghost text 3
    ],
    // Second session
    [
        $29bbc9a782c07566$var$submitExpenseQuestion,
        // Ghost text 1
        $29bbc9a782c07566$var$mentionTeammatesSearch,
        // Ghost text 2
        $29bbc9a782c07566$var$searchAcrossProducts // Ghost text 3
    ],
    // etc...
    [
        $29bbc9a782c07566$var$kpiAcronymSearch,
        $29bbc9a782c07566$var$searchAcrossProducts,
        $29bbc9a782c07566$var$submitExpenseQuestion
    ],
    [
        $29bbc9a782c07566$var$searchTeammateName,
        $29bbc9a782c07566$var$submitExpenseQuestion,
        $29bbc9a782c07566$var$searchAcrossProducts
    ],
    [
        $29bbc9a782c07566$var$mentionTeammatesSearch,
        $29bbc9a782c07566$var$searchAcrossProducts,
        $29bbc9a782c07566$var$submitExpenseQuestion
    ]
];
const $29bbc9a782c07566$export$c8250431df989e51 = (session, index)=>{
    // Reset index to 0 to guarantee that something will be displayed in the placeholder
    const sessionIndex = session % $29bbc9a782c07566$export$80bfcd0b41a91527.length;
    const ghostTextIndex = index % $29bbc9a782c07566$export$80bfcd0b41a91527[sessionIndex].length;
    return $29bbc9a782c07566$export$80bfcd0b41a91527[sessionIndex][ghostTextIndex];
};
const $29bbc9a782c07566$var$QUICK_FIND_GHOST_TEXT_KEY = 'quick-find-ghost-text';
const $29bbc9a782c07566$var$DEFAULT_GHOST_TEXT_STATE = {
    ghostTextSessionCount: undefined
};
const $29bbc9a782c07566$export$d6c611f7f67115e6 = (params)=>{
    const [{ ghostTextSessionCount: ghostTextSessionCount }, setState] = (0, $42omo.useState)((0, $5G9KX.getLocalStorageItem)($29bbc9a782c07566$var$QUICK_FIND_GHOST_TEXT_KEY) || $29bbc9a782c07566$var$DEFAULT_GHOST_TEXT_STATE);
    const sessionCount = ghostTextSessionCount === undefined ? params.initialValue : ghostTextSessionCount;
    const incrementSession = (0, $42omo.useCallback)(()=>{
        const newState = {
            ghostTextSessionCount: (sessionCount + 1) % params.maxCount
        };
        setState(newState);
        (0, $5G9KX.setLocalStorageItem)($29bbc9a782c07566$var$QUICK_FIND_GHOST_TEXT_KEY, JSON.stringify(newState));
    }, [
        sessionCount,
        params.maxCount,
        setState
    ]);
    return [
        sessionCount,
        {
            incrementSession: incrementSession
        }
    ];
};


const $6891f76f64ebebfd$export$3bfd2296a37df616 = ({})=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [ghostTextSession, { incrementSession: incrementSession }] = (0, $29bbc9a782c07566$export$d6c611f7f67115e6)({
        initialValue: 0,
        maxCount: (0, $29bbc9a782c07566$export$80bfcd0b41a91527).length
    });
    const placeholder = (0, $42omo.useMemo)(()=>{
        return formatMessage((0, $53c6e852a90698b9$export$613310893a9f5d54).inputPlaceholder);
    }, [
        formatMessage
    ]);
    return {
        placeholder: placeholder,
        incrementSession: incrementSession,
        ghostTextSession: ghostTextSession
    };
};












const $271a704d78bd6a18$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    searchIconLabel: {
        id: "input_search_icon_label",
        defaultMessage: "Search"
    },
    clearIconLabel: {
        id: "input_clear_icon_label",
        defaultMessage: "Clear search"
    },
    copyLinkIconLabel: {
        id: "input_copy_link_icon_label",
        defaultMessage: "Copy link"
    },
    inputPlaceholderDefault: {
        id: "input_placeholder_default",
        defaultMessage: "Search for anything"
    },
    inputPlaceholderWithAtlassianIntelligence: {
        id: "input_placeholder_with_atlassian_intelligence",
        defaultMessage: "Search or ask anything"
    },
    inputPlaceholderWithRovo: {
        id: "input_placeholder_with_rovo",
        defaultMessage: "Search or ask Rovo"
    }
});


const $79f1d977d329e116$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    height: 'space.500',
    flexGrow: 1
});
const $79f1d977d329e116$var$cssOverrideWrapperStyles = null;
const $79f1d977d329e116$var$searchIconWrapperStyles = (0, $ecnYn.xcss)({
    minWidth: 'size.200',
    minHeight: 'size.200',
    marginLeft: 'space.150',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $79f1d977d329e116$var$rightIconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.100'
});
const $79f1d977d329e116$export$fb8d8fbc0c4c1705 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { localQuery: localQuery, setLocalQuery: setLocalQuery, onSubmit: onSubmit } = props;
    const intl = (0, $aXWIB.useIntl)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams, isAdminHubAIEnabled: isAdminHubAIEnabled, isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)(); // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [isLoading] = (0, $djVCD.useIsLoading)();
    const [searchQuery, { setInputQuery: setInputQuery, triggerSearch: triggerSearch }] = (0, $djVCD.useSearchQuery)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [userWithStatus] = (0, $j4ply.useUser)();
    const [showDropdown, { setShowDropdown: setShowDropdown }] = (0, $25a8b9613a265659$export$8c32fdb3462273b4)();
    const [features] = (0, $j4ply.useFeatures)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const fireCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchInput');
    const isUserAuthenticated = userWithStatus.status === (0, $lwP5K.UserStatus).Authenticated;
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const { placeholder: placeholder } = (0, $6891f76f64ebebfd$export$3bfd2296a37df616)({
        applicationMode: applicationMode,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        availableProducts: availableProducts,
        isNav4Enabled: isNav4Enabled,
        quickFindOpen: true // We only consider the open state for FPS
    });
    let hasReceivedFocus = (0, $42omo.useMemo)(()=>props.hasReceivedFocus ? props.hasReceivedFocus : ()=>{}, [
        props.hasReceivedFocus
    ]); // Sync local query with input query
    (0, $42omo.useEffect)(()=>{
        setInputQuery(localQuery);
    }, [
        setInputQuery,
        localQuery
    ]); // Sync search query with local query
    // on search query change, determine intent / get smart answer route
    (0, $42omo.useEffect)(()=>{
        setLocalQuery(searchQuery);
    }, [
        searchQuery,
        setLocalQuery
    ]);
    const handleOnSubmit = ()=>{
        // Store search in recent searches
        if (localQuery.trim() !== '' && userWithStatus && userWithStatus.id && primaryProduct) (0, $1SV4e.addRecentSearch)({
            value: localQuery,
            userId: userWithStatus.id,
            productId: primaryProduct,
            key: (0, $1SV4e.RECENT_SEARCH_KEY)
        });
        if (onSubmit) onSubmit();
        if (features?.chromeExtension?.enabled) features.chromeExtension.onInputSubmit({
            query: localQuery
        });
        else triggerSearch();
    };
    const onChange = (0, $42omo.useCallback)((e)=>{
        setLocalQuery(e.currentTarget.value);
        hasReceivedFocus();
        if (e.currentTarget.value === '' && !isUserAuthenticated) setShowDropdown(false);
        else if (e.currentTarget.value !== '') setShowDropdown(true);
    }, [
        hasReceivedFocus,
        isUserAuthenticated,
        setLocalQuery,
        setShowDropdown
    ]);
    const onClick = ()=>{
        hasReceivedFocus();
        if (localQuery === '' && !isUserAuthenticated) setShowDropdown(false);
    };
    const onKeyPress = (event)=>{
        if (event.key === 'Enter') {
            handleOnSubmit();
            event.currentTarget.blur();
        }
    };
    const onKeyDown = (event)=>{
        if (event.key === 'ArrowDown') hasReceivedFocus();
        if (showDropdown && event.key === 'Tab') {
            if (onSubmit) onSubmit();
        }
    };
    const searchBoxRef = (0, $42omo.useRef)(null);
    (0, $86ob4.useWidthObserverRegistration)('search-box', searchBoxRef);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $79f1d977d329e116$var$textFieldBoxStyles,
        ref: (0, $kIdP4.mergeRefs)(ref, searchBoxRef),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                "_zbay1qi0 _1r6fe4h9 _k8em1ylp"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                ref: props.keyboardRef,
                id: "text-query-input",
                testId: "text-query-input",
                value: localQuery,
                onKeyPress: (event)=>onKeyPress(event),
                onKeyDown: (event)=>onKeyDown(event),
                onChange: onChange,
                onClick: onClick,
                autoComplete: "off",
                placeholder: placeholder,
                elemBeforeInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $79f1d977d329e116$var$searchIconWrapperStyles,
                    children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                        testId: "search-page-input-spinner",
                        size: "small"
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                        color: "currentColor",
                        label: intl.formatMessage((0, $271a704d78bd6a18$export$defe85febe8b728c).searchIconLabel)
                    })
                }),
                elemAfterInput: localQuery && /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                    space: "space.050",
                    xcss: $79f1d977d329e116$var$rightIconStyles,
                    children: [
                        applicationMode === (0, $9vOy1.ApplicationModes).Rovo && /*#__PURE__*/ (0, $l998X.jsx)((0, $fm8DG.CopyLinkButton), {
                            fullResultUrl: ()=>generateSearchUrl({
                                    ...queryParams,
                                    text: localQuery
                                }),
                            showSuccess: true,
                            isButton: true,
                            onClick: fireCopyLinkButtonClicked,
                            testId: "search-input-copy-link-button"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                    ...iconProps,
                                    color: "currentColor",
                                    size: "small"
                                }),
                            spacing: "compact",
                            onClick: ()=>setLocalQuery(''),
                            label: intl.formatMessage((0, $271a704d78bd6a18$export$defe85febe8b728c).clearIconLabel),
                            appearance: "subtle"
                        })
                    ]
                }),
                autoFocus: true
            })
        })
    });
});


const $1a733a128842bf36$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    height: 'space.500',
    flexGrow: 1
});
const $1a733a128842bf36$export$f5b8910cec6cf069 = ()=>{
    const [showDropdown, { setShowDropdown: setShowDropdown }] = (0, $25a8b9613a265659$export$8c32fdb3462273b4)();
    const inputBoxRef = (0, $42omo.useRef)(null);
    const inputRef = (0, $42omo.useRef)(null);
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    (0, $4219044a34e95c55$export$11133d09694420f7)();
    const [_, setInputWidth] = (0, $42omo.useState)(inputBoxRef.current?.offsetWidth);
    const [localQuery, setLocalQuery] = (0, $42omo.useState)(searchQuery);
    const { fireAnalyticsEvent: fireAnalyticsEvent, fireAnalyticsScreenEvent: fireAnalyticsScreenEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    (0, $42omo.useEffect)(()=>{
        const listener = ()=>setInputWidth(inputBoxRef.current?.offsetWidth);
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: listener
        });
        return unbind;
    }, []);
    const closeDropdown = (0, $42omo.useCallback)(()=>{
        if (showDropdown) {
            setShowDropdown(false);
            fireAnalyticsEvent((0, $c8c12c8e63822f48$export$900d08b010253a5e)({
                commonAttributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        }
    }, [
        showDropdown,
        setShowDropdown,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
    const trigger = (0, $42omo.useCallback)((triggerProps)=>{
        // When the SearchTextField receives a submit/enter
        const hasSubmitted = ()=>{
            closeDropdown();
        }; // When the SearchTextField receives focus - simple API for multiple events that cause this
        const inputHasReceivedFocus = ()=>{
            if (!showDropdown) {
                fireAnalyticsScreenEvent((0, $94068ad8452530ec$export$c8d721b69c7e30be)({
                    commonAttributes: commonAttributes
                }));
                setShowDropdown(true);
            }
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $1a733a128842bf36$var$textFieldBoxStyles,
            ref: inputBoxRef,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $79f1d977d329e116$export$fb8d8fbc0c4c1705), {
                keyboardRef: inputRef,
                ...triggerProps,
                ref: triggerProps.ref,
                onSubmit: hasSubmitted,
                hasReceivedFocus: inputHasReceivedFocus,
                localQuery: localQuery,
                setLocalQuery: setLocalQuery
            })
        });
    }, [
        localQuery,
        closeDropdown,
        showDropdown,
        fireAnalyticsScreenEvent,
        commonAttributes,
        setShowDropdown
    ]);
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $icqFF.KeyboardHighlightProvider), {
        listenerNode: inputRef?.current,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $de28d63f0a3d693c$export$e33d60b8f4099ae), {
            inputWidth: inputBoxRef.current?.offsetWidth || 0,
            setLocalQuery: setLocalQuery
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        shouldReturnFocus: false,
        content: ()=>content,
        isOpen: showDropdown,
        autoFocus: false,
        placement: "bottom-start",
        trigger: trigger,
        onClose: closeDropdown
    });
};
const $1a733a128842bf36$var$FallbackInput = ()=>{
    const [localQuery, setLocalQuery] = (0, $42omo.useState)('');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $79f1d977d329e116$export$fb8d8fbc0c4c1705), {
        localQuery: localQuery,
        setLocalQuery: setLocalQuery
    });
};
const $1a733a128842bf36$var$InputWithErrorBoundary = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)($1a733a128842bf36$var$FallbackInput, {}),
        section: "SearchPageInput",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-input",
            children: /*#__PURE__*/ (0, $l998X.jsx)($1a733a128842bf36$export$f5b8910cec6cf069, {})
        })
    });
};
var $1a733a128842bf36$export$2e2bcd8739ae039 = $1a733a128842bf36$var$InputWithErrorBoundary;


/* lite-header.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 


















var $2AytZ = parcelRequire("2AytZ");


















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 




















var $laHi9 = parcelRequire("laHi9");


var $6R5uz = parcelRequire("6R5uz");


var $8tdj3 = parcelRequire("8tdj3");







var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");


var $hdfeV = parcelRequire("hdfeV");


var $7iBhV = parcelRequire("7iBhV");







/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


























const $4dd72e8bb888f87e$export$1d0e30033014b87d = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isConnected: isConnected, section: section })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelAppFilterShowMore`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                isConnected: isConnected,
                section: section
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





const $fd71ee172a38aaa6$export$62cf98e2e77b39a2 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isConnected: isConnected })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelAppFilterShowMore`,
        action: 'hovered',
        attributes: {
            additionalAttributes: {
                isConnected: isConnected
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





const $ac33c27f1ebfdd91$export$a519e015cc174c44 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        actionSubject: 'textField',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelAppFilterShowMore`,
        action: 'focused',
        attributes: {
            additionalAttributes: {},
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });








const $e2036452b566463b$export$189a50cb1d778d89 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isConnected: isConnected, productKey: productKey, datasourceId: datasourceId, index: index, isInShowMore: isInShowMore })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelAppFilter`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                productKey: productKey ?? 'all',
                ...datasourceId && {
                    datasourceId: datasourceId
                },
                is3pProduct: productKey ? (0, $b4tvS.is3pProductKey)(productKey) : false,
                isConnected: isConnected,
                ...index !== undefined && {
                    index: index
                },
                ...isInShowMore !== undefined && {
                    isInShowMore: isInShowMore
                }
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });
















const $e7b92363a3904b47$export$f9c22828284a3288 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, productKey: productKey, isConnected: isConnected, index: index, isInShowMore: isInShowMore })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelAppFilter`,
        action: 'hovered',
        attributes: {
            additionalAttributes: {
                productKey: productKey ?? 'all',
                is3pProduct: productKey ? (0, $b4tvS.is3pProductKey)(productKey) : false,
                isConnected: isConnected,
                ...index !== undefined && {
                    index: index
                },
                ...isInShowMore !== undefined && {
                    isInShowMore: isInShowMore
                }
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });
const $e7b92363a3904b47$export$27036168f995da84 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, productKey: productKey, isConnected: isConnected })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelAppFilterMenuButton`,
        action: 'hovered',
        attributes: {
            additionalAttributes: {
                productKey: productKey ?? 'all',
                is3pProduct: productKey ? (0, $b4tvS.is3pProductKey)(productKey) : false,
                isConnected: isConnected
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });
const $e7b92363a3904b47$export$df645a1f296cb5d3 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, productKey: productKey, isConnected: isConnected })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelAppFilterHideButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                productKey: productKey ?? 'all',
                is3pProduct: productKey ? (0, $b4tvS.is3pProductKey)(productKey) : false,
                isConnected: isConnected
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });
const $e7b92363a3904b47$export$8f7e93015eb658b5 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, productKey: productKey, isConnected: isConnected })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelAppFilterHideButton`,
        action: 'hovered',
        attributes: {
            additionalAttributes: {
                productKey: productKey ?? 'all',
                is3pProduct: productKey ? (0, $b4tvS.is3pProductKey)(productKey) : false,
                isConnected: isConnected
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });






var $JQd0k = parcelRequire("JQd0k");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 




























var $3gadb = parcelRequire("3gadb");













parcelRequire("42omo");








var $aRCWA = parcelRequire("aRCWA");


var $9VJDA = parcelRequire("9VJDA");


var $56M4r = parcelRequire("56M4r");

var $7rvPL = parcelRequire("7rvPL");














const $681c93d9b8abe194$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    menuTriggerLabel: {
        id: "search-page.app-filter-sidebar.filter-menu.trigger",
        defaultMessage: "Show more options"
    },
    hideMenuItemLabel: {
        id: "search-page.app-filter-sidebar.filter-menu.menu-item.hide",
        defaultMessage: "Hide app"
    }
});


const $16ecf1ad5ce5b545$var$overflowMenu = (0, $ecnYn.xcss)({
    opacity: 0,
    width: '0px',
    // hide it by making it very small. We need it in the DOM so that it's focusable
    ':focus-within': {
        opacity: 1,
        width: 'auto'
    }
});
const $16ecf1ad5ce5b545$var$overflowMenuVisible = (0, $ecnYn.xcss)({
    opacity: 1,
    width: 'auto',
    marginLeft: 'space.100'
});
const $16ecf1ad5ce5b545$var$FilterMenu = ({ isVisible: isVisible, isMenuOpen: isMenuOpen = false, onClick: onClick, onClickMenuItem: onClickMenuItem, onClose: onClose, onHoverMenuButton: onHoverMenuButton, onHoverMenuItem: onHoverMenuItem })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: [
            isVisible ? $16ecf1ad5ce5b545$var$overflowMenuVisible : $16ecf1ad5ce5b545$var$overflowMenu
        ],
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            isOpen: isMenuOpen,
            onClose: onClose,
            placement: "bottom-end",
            content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            role: "presentation",
                            onMouseEnter: onHoverMenuItem,
                            onFocus: onHoverMenuItem,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aRCWA))), {
                                    label: ""
                                }),
                                onClick: (ev)=>{
                                    ev.stopPropagation();
                                    onClickMenuItem?.(ev, 'hide');
                                    onClose?.(ev);
                                },
                                children: formatMessage((0, $681c93d9b8abe194$export$defe85febe8b728c).hideMenuItemLabel)
                            })
                        })
                    })
                }),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ...triggerProps,
                    onClick: onClick,
                    onMouseEnter: onHoverMenuButton,
                    label: formatMessage((0, $681c93d9b8abe194$export$defe85febe8b728c).menuTriggerLabel),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                    appearance: "subtle",
                    spacing: "compact"
                })
        })
    });
};
var $16ecf1ad5ce5b545$export$2e2bcd8739ae039 = $16ecf1ad5ce5b545$var$FilterMenu;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















var $i6xGB = parcelRequire("i6xGB");










var $afneb = parcelRequire("afneb");




const $7dab2c2c5855389e$export$4088a37018960a0f = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, product: product })=>({
        eventType: 'track',
        action: 'clicked',
        actionSubject: 'filterOptionTimeoutButton',
        attributes: {
            additionalAttributes: {
                product: product
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





const $23e66b0e1267ac0f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    timeoutTooltip: {
        id: "search-page.app-filter-sidebar.product-timeout-tooltip",
        defaultMessage: "{product} results were too slow to show"
    },
    timeoutPrimaryText: {
        id: "search-page.app-filter-sidebar.product-timeout-primary-text",
        defaultMessage: "{product} results took too long to show"
    },
    timeoutSecondaryText: {
        id: "search-page.app-filter-sidebar.product-timeout-secondary-text",
        defaultMessage: "Try again by filtering just for {product}."
    },
    timeoutButtonText: {
        id: "search-page.app-filter-sidebar.product-timeout-button-text",
        defaultMessage: "See only {product} results"
    }
});


const $bca72fe813e6693a$var$styles = {
    trigggerContainer: "_2hwxr5cr",
    tooltip: "_2rkofajl _11c8wadc _vchhusvi _p12f1ns9 _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i51b66 _1q511b66 _y4ti12x7 _bozg12x7 _slp31hna",
    popupContainer: "_2rko12b0 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1e0c1txw _2lx21bp4",
    popupPrimaryText: "_11c8fhey _k48p1wq8 _1wpz1y6m",
    popupSecondaryText: "_11c8fhey _k48pi7a9 _1wpz1y6m _19pkv77o _otyrv77o",
    buttonContainer: "_1wpzesu3 _19pkpxbi"
};
const $bca72fe813e6693a$var$TimeoutTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)(function CustomTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $afneb.default), {
        ...rest,
        // https://atlassian.design/components/tooltip/examples
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gMc0m.default)([
            $bca72fe813e6693a$var$styles.tooltip,
            className
        ]),
        ref: ref,
        children: children
    });
});
const $bca72fe813e6693a$export$433d5c9b4b3a90fa = ({ option: option, setIsMouseOver: setIsMouseOver })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const trigger = (triggerProps)=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($bca72fe813e6693a$var$styles.trigggerContainer),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                component: $bca72fe813e6693a$var$TimeoutTooltip,
                content: formatMessage((0, $23e66b0e1267ac0f$export$defe85febe8b728c).timeoutTooltip, {
                    product: option.label
                }),
                position: "bottom",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    testId: `search-page-filter-option-timeout-${option.value}`,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($i6xGB))),
                    appearance: "subtle",
                    spacing: "compact",
                    label: formatMessage((0, $23e66b0e1267ac0f$export$defe85febe8b728c).timeoutTooltip, {
                        product: option.label
                    }),
                    isSelected: isOpen,
                    onClick: (event)=>{
                        event.stopPropagation();
                        setIsOpen(!isOpen);
                    },
                    ...triggerProps
                })
            })
        });
    };
    const content = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($bca72fe813e6693a$var$styles.popupContainer),
            onPointerDown: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($bca72fe813e6693a$var$styles.popupPrimaryText),
                    children: formatMessage((0, $23e66b0e1267ac0f$export$defe85febe8b728c).timeoutPrimaryText, {
                        product: option.label
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($bca72fe813e6693a$var$styles.popupSecondaryText),
                    children: formatMessage((0, $23e66b0e1267ac0f$export$defe85febe8b728c).timeoutSecondaryText, {
                        product: option.label
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($bca72fe813e6693a$var$styles.buttonContainer),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        testId: `search-page-filter-option-timeout-button-${option.value}`,
                        appearance: "primary",
                        onClick: (event)=>{
                            event.stopPropagation();
                            setIsOpen(false);
                            option.onSelect?.();
                            setIsMouseOver(false);
                            fireAnalyticsEvent((0, $7dab2c2c5855389e$export$4088a37018960a0f)({
                                commonAttributes: commonAttributes,
                                nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                                product: option.value
                            }));
                        },
                        children: formatMessage((0, $23e66b0e1267ac0f$export$defe85febe8b728c).timeoutButtonText, {
                            product: option.label
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        content: content,
        trigger: trigger,
        placement: "bottom-end",
        onClose: ()=>setIsOpen(false)
    });
};





const $f50a0b647d44470a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    groupLabel: {
        id: "search-page.app-filter-sidebar.group",
        defaultMessage: "Filter search by app"
    },
    allFilterLabel: {
        id: "search-page.app-filter-sidebar.all",
        defaultMessage: "All"
    },
    noMatchingResultsTooltip: {
        id: "search-page.app-filter-sidebar.no-matching-results-tooltip",
        defaultMessage: "No matching results in {product}"
    },
    connectedAppsHeader: {
        id: "search-page.app-filter-sidebar.connected-apps-header",
        defaultMessage: "Filter results"
    },
    connectAppsHeader: {
        id: "search-page.app-filter-sidebar.connect-apps-header",
        defaultMessage: "Connect apps"
    },
    connectAppsDescription: {
        id: "search-page.app-filter-sidebar.connect-apps-description",
        defaultMessage: "Get better answers and more results across Search and Chat."
    }
});





parcelRequire("42omo");











const $d8565f7ad7385d82$var$styles = (0, $ecnYn.xcss)({
    marginLeft: 'auto'
});
const $d8565f7ad7385d82$export$bb17ebbbeb7ce35d = (option)=>{
    const { count: count, isSelected: isSelected, resultCountLimit: resultCountLimit } = option;
    if (count === undefined) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    const countExceedsLimit = !!(resultCountLimit && count >= resultCountLimit);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $d8565f7ad7385d82$var$styles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
            color: isSelected ? 'color.text.accent.blue' : 'color.text.subtlest',
            size: "small",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedNumber), {
                    value: countExceedsLimit ? resultCountLimit : count,
                    notation: 'compact'
                }),
                countExceedsLimit && /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: "+"
                })
            ]
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







const $7b53561762001049$var$styles = {
    countLoading: "_2rko12b0 _bfhkysee _4t3i7vkz _1bsbzwfg"
};
const $7b53561762001049$export$d279ab0e61c6c87b = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($7b53561762001049$var$styles.countLoading),
        testId: "result-count-loading"
    });
};


const $73f6cd01fde76615$var$baseStyles = (0, $ecnYn.xcss)({
    height: '36px',
    paddingInline: 'space.150',
    width: '100%',
    color: 'color.text',
    background: 'none'
}); // Single-select variant base styles
const $73f6cd01fde76615$var$baseStylesSingleSelect = (0, $ecnYn.xcss)({
    height: 'space.400',
    // 32px
    paddingBlock: 'space.075',
    paddingInline: 'space.100',
    width: '100%',
    color: 'color.text',
    background: 'none',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 'radius.small',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    }
});
const $73f6cd01fde76615$var$selectedStyles = (0, $ecnYn.xcss)({
    color: 'color.text.accent.blue',
    background: "var(--ds-background-selected, #E9F2FE)",
    ':hover': {
        color: 'color.text.accent.blue',
        background: "var(--ds-background-selected, #E9F2FE)"
    }
}); // Single-select variant selected styles — left side is square so the inset left border doesn't curve,
// right side keeps the border radius to match the hover state.
const $73f6cd01fde76615$var$selectedStylesSingleSelect = (0, $ecnYn.xcss)({
    color: 'color.text.accent.blue',
    background: "var(--ds-background-selected, #E9F2FE)",
    borderStartStartRadius: 0,
    borderEndStartRadius: 0,
    borderStartEndRadius: 'radius.small',
    borderEndEndRadius: 'radius.small',
    ':hover': {
        color: 'color.text.accent.blue',
        background: "var(--ds-background-selected, #E9F2FE)"
    }
});
// NOTE: When cleaning up rovo_filters_discoverability FG, add borderLeft attribute to selectedStyles above
const $73f6cd01fde76615$var$selectedStyleBorder = (0, $ecnYn.xcss)({
    // @ts-ignore
    // - Don't want to use borderLeft because it takes up space
    // - Can't use outline because we can't only target the left side to have the outline
    // - We'd rather ignore the TS error than add a new div with margin or position hacks
    boxShadow: `inset ${"var(--ds-space-025, 2px)"} 0px ${"var(--ds-border-selected, #1868DB)"}`
});
const $73f6cd01fde76615$var$containerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    paddingBottom: 'space.025',
    width: '100%',
    ':hover': {
        color: 'color.text',
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    }
}); // Single-select variant container styles
const $73f6cd01fde76615$var$containerStylesSingleSelect = (0, $ecnYn.xcss)({
    position: 'relative',
    paddingBottom: 'space.025',
    width: '100%',
    background: 'none',
    ':hover': {
        color: 'color.text',
        background: 'none'
    }
});
const $73f6cd01fde76615$var$containerStylesZeroCount = (0, $ecnYn.xcss)({
    opacity: 0.5
});
const $73f6cd01fde76615$var$inlineStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.075'
}); // Single-select variant inline styles with 6px (space.050) gap
const $73f6cd01fde76615$var$inlineStylesSingleSelect = (0, $ecnYn.xcss)({
    marginLeft: 'space.050'
}); // Spacer to reserve space for the FilterMenu when it's visible in the overlay.
// This maintains the same label truncation as when FilterMenu was inside the grid.
// Matches the visible FilterMenu: 32px (compact IconButton) + 8px marginLeft.
const $73f6cd01fde76615$var$filterMenuSpacerStyles = (0, $ecnYn.xcss)({
    width: '32px',
    marginLeft: 'space.100',
    height: '0px'
});
const $73f6cd01fde76615$var$interactiveOverlayStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    right: 'space.150',
    // Adjust for paddingBottom on container to align with Pressable content center
    top: 'calc(50% - 1px)',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center'
}); // Single-select variant — flush to the right edge so the IconButton's internal padding
// naturally aligns the icon to match the left paddingInline (space.100 = 8px)
const $73f6cd01fde76615$var$interactiveOverlayStylesSingleSelect = (0, $ecnYn.xcss)({
    position: 'absolute',
    right: 'space.100',
    // Adjust for paddingBottom on container to align with Pressable content center
    top: 'calc(50% - 1px)',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center'
});
const $73f6cd01fde76615$var$FilterOptionResultCount = ({ option: option })=>{
    if (option.value === (0, $b4tvS.ProductKeys3P).Gmail && option.resultCountLimit !== undefined && (0, $dh538.fg)('formula_3p_gmail_result_count')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d8565f7ad7385d82$export$bb17ebbbeb7ce35d), {
        count: option.count,
        isSelected: option.isSelected,
        resultCountLimit: option.resultCountLimit
    });
    if (option.value === (0, $b4tvS.ProductKeys3P).OutlookMail && option.resultCountLimit !== undefined && (0, $dh538.fg)('formula_3p_outlook_result_count')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d8565f7ad7385d82$export$bb17ebbbeb7ce35d), {
        count: option.count,
        isSelected: option.isSelected,
        resultCountLimit: option.resultCountLimit
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d8565f7ad7385d82$export$bb17ebbbeb7ce35d), {
        count: option.count,
        isSelected: option.isSelected
    });
};
const $73f6cd01fde76615$var$labelStyles = {
    truncated: "_1reo15vq _18m915vq _3fcw1q9c _11c8fhey _1bto1l2s _y3gn1e5h _1o9zkb7n"
};
const $73f6cd01fde76615$var$gridStyles = (0, $ecnYn.xcss)({
    width: '100%'
}); // Single-select variant grid styles with 6px gap
const $73f6cd01fde76615$var$gridStylesSingleSelect = (0, $ecnYn.xcss)({
    width: '100%',
    gap: 'space.075' // 6px gap between icon, label, and count
});
const $73f6cd01fde76615$var$testIdGenerator = (value, isShowMore)=>{
    if (isShowMore) return 'search-page-app-filter-sidebar-show-more';
    if (value) return `filter-${value}`;
    return 'filter-all';
};
const $73f6cd01fde76615$var$FilterOption = ({ option: option, isDisabled: isDisabled, oAuthWarning: oAuthWarning = null, triggerProps: triggerProps, onClickMenuItem: onClickMenuItem, onClick: onClick, ariaRole: ariaRole, isHidden: isHidden, isShowMore: isShowMore = false, onHover: onHover, onHoverMenuButton: onHoverMenuButton, onHoverMenuItem: onHoverMenuItem })=>{
    const [isMouseOver, setIsMouseOver] = (0, $42omo.useState)(false);
    const [isMenuOpen, setIsMenuOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isConnector = Boolean(option.value) && option.value !== 'goal' && option.value !== 'project' && option.value !== 'atlassian-web-crawler';
    const isMenuTriggerVisible = !isHidden && isConnector && (isMouseOver || isMenuOpen) && !(option.isPrimaryProduct || false);
    const noMatchingResults = option?.count === 0;
    const shouldBeGreyedOut = !option.isSelected && noMatchingResults && !isDisabled;
    const labelRef = (0, $42omo.useRef)(null);
    const canTooltipAppear = (0, $42omo.useCallback)(()=>noMatchingResults || !isMenuOpen && (labelRef.current?.offsetWidth ?? 0) < (labelRef.current?.scrollWidth ?? 0), [
        noMatchingResults,
        isMenuOpen
    ]);
    const tooltipContent = noMatchingResults ? formatMessage((0, $f50a0b647d44470a$export$defe85febe8b728c).noMatchingResultsTooltip, {
        product: option.label
    }) : option.label; // Determine which interactive element to show in the overlay (outside the button)
    const showTimeoutOverlay = !oAuthWarning && !option.countLoading && option.timeout && !option.isSelected;
    const showFilterMenuOverlay = !isHidden && !isShowMore && !(option.timeout && !option.isSelected) && !option.countLoading; // Show non-interactive content inside the button only when no interactive overlay is visible
    const showResultCount = !oAuthWarning && !option.countLoading && !(option.timeout && !option.isSelected) && !isMenuTriggerVisible;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $73f6cd01fde76615$var$containerStylesSingleSelect : $73f6cd01fde76615$var$containerStyles,
            shouldBeGreyedOut && $73f6cd01fde76615$var$containerStylesZeroCount
        ],
        onMouseEnter: ()=>{
            setIsMouseOver(true);
            onHover?.();
        },
        onMouseLeave: ()=>{
            setIsMouseOver(false);
        },
        onFocus: ()=>setIsMouseOver(true),
        onBlur: ()=>setIsMouseOver(false),
        role: ariaRole,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: tooltipContent,
                delay: 300,
                canAppear: canTooltipAppear,
                hideTooltipOnClick: true,
                children: /*#__PURE__*/ (0, $42omo.createElement)((0, $2W0qg.default), {
                    ...triggerProps,
                    key: option.value,
                    onClick: isDisabled ? ()=>{} : onClick,
                    xcss: [
                        (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $73f6cd01fde76615$var$baseStylesSingleSelect : $73f6cd01fde76615$var$baseStyles,
                        option.isSelected && ((0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $73f6cd01fde76615$var$selectedStylesSingleSelect : $73f6cd01fde76615$var$selectedStyles),
                        option.isSelected && $73f6cd01fde76615$var$selectedStyleBorder
                    ],
                    padding: "space.0",
                    testId: $73f6cd01fde76615$var$testIdGenerator(option.value, isShowMore),
                    "aria-current": option.isSelected
                }, /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                    templateColumns: "auto 1fr auto",
                    gap: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'space.075' : 'space.100',
                    alignItems: "center",
                    justifyContent: "start",
                    xcss: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $73f6cd01fde76615$var$gridStylesSingleSelect : $73f6cd01fde76615$var$gridStyles,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.IconDecider), {
                            productOrNounKey: option.value,
                            isShowMore: isShowMore,
                            label: "",
                            size: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'xxsmall' : 'small',
                            isSelected: option.isSelected
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            as: "div",
                            ref: labelRef,
                            xcss: (0, $1Whri.cx)($73f6cd01fde76615$var$labelStyles.truncated),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                color: option.isSelected ? 'color.text.accent.blue' : 'color.text',
                                align: "start",
                                children: option.label
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                            alignBlock: "center",
                            xcss: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $73f6cd01fde76615$var$inlineStylesSingleSelect : $73f6cd01fde76615$var$inlineStyles,
                            children: [
                                oAuthWarning ? oAuthWarning : option.countLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7b53561762001049$export$d279ab0e61c6c87b), {}) : showResultCount ? /*#__PURE__*/ (0, $l998X.jsx)($73f6cd01fde76615$var$FilterOptionResultCount, {
                                    option: option
                                }) : null,
                                isMenuTriggerVisible && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                    xcss: $73f6cd01fde76615$var$filterMenuSpacerStyles,
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    ]
                }))
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $73f6cd01fde76615$var$interactiveOverlayStylesSingleSelect : $73f6cd01fde76615$var$interactiveOverlayStyles,
                children: [
                    showTimeoutOverlay && /*#__PURE__*/ (0, $l998X.jsx)((0, $bca72fe813e6693a$export$433d5c9b4b3a90fa), {
                        option: option,
                        setIsMouseOver: setIsMouseOver
                    }),
                    showFilterMenuOverlay && /*#__PURE__*/ (0, $l998X.jsx)((0, $16ecf1ad5ce5b545$export$2e2bcd8739ae039), {
                        isVisible: isMenuTriggerVisible,
                        onClickMenuItem: onClickMenuItem,
                        isMenuOpen: isMenuOpen,
                        onClick: (event)=>{
                            event.stopPropagation();
                            setIsMenuOpen(!isMenuOpen);
                        },
                        onClose: ()=>setIsMenuOpen(false),
                        onHoverMenuButton: onHoverMenuButton,
                        onHoverMenuItem: onHoverMenuItem
                    })
                ]
            })
        ]
    });
};
var $73f6cd01fde76615$export$2e2bcd8739ae039 = $73f6cd01fde76615$var$FilterOption;





const $c395f352fa4770d3$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    showMoreLabel: {
        id: "search-page.app-filter-sidebar.show-more.button.label",
        defaultMessage: "Show more"
    },
    showAllAppsLabel: {
        id: "search-page.app-filter-sidebar.show-all-apps.button.label",
        defaultMessage: "Show all apps"
    },
    filterPlaceholder: {
        id: "search-page.app-filter-sidebar.show-more.filter.placeholder",
        defaultMessage: "Find apps"
    }
});


const $862f29a1de109ab0$var$styles = {
    showMoreApps: "_c71l1dty _18m91wug"
};
const $862f29a1de109ab0$var$ShowMorePopupItem = ({ option: option, index: index, thirdPartyConfigs: thirdPartyConfigs, useIsUserOAuthed: useIsUserOAuthed, useOAuthHandlers: useOAuthHandlers, oAuthSource: oAuthSource, setIsOpen: setIsOpen, fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>{
    const isSmartlink = (0, $def8z.isProductSmartlink)({
        productKey: option.value,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const reactKey = option.compositeKey || option.value;
    const itemIsConnected = (0, $def8z.isProductConnected)(option.value, thirdPartyConfigs);
    const debouncedOnHover = (0, $JQd0k.useDebouncedCallback)((0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $e7b92363a3904b47$export$f9c22828284a3288)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            productKey: option.value,
            isConnected: itemIsConnected,
            index: index,
            isInShowMore: true
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        option.value,
        itemIsConnected,
        index
    ]), 500);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
        datasourceId: option.datasourceId,
        product: option.value,
        trigger: ({ oAuthWarning: oAuthWarning, triggerProps: triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $73f6cd01fde76615$export$2e2bcd8739ae039), {
                oAuthWarning: oAuthWarning,
                triggerProps: triggerProps,
                isHidden: true,
                option: option,
                onClick: ()=>{
                    if (!oAuthWarning) {
                        fireAnalyticsEvent((0, $e2036452b566463b$export$189a50cb1d778d89)({
                            commonAttributes: commonAttributes,
                            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                            productKey: option.value,
                            isConnected: itemIsConnected,
                            index: index,
                            isInShowMore: true
                        }));
                        option.showFilter();
                        option.onSelect();
                        setIsOpen(false);
                    }
                },
                onHover: debouncedOnHover,
                ariaRole: "listitem"
            }, reactKey),
        useOAuthHandlers: useOAuthHandlers,
        useIsUserOAuthed: useIsUserOAuthed,
        option: option,
        isSmartlink: isSmartlink,
        oAuthSource: oAuthSource,
        thirdPartyConfigs: thirdPartyConfigs,
        postAuthAction: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? ()=>{
            setIsOpen(false);
        } : undefined,
        skipFlagsProvider: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select'
    }, reactKey);
};
const $862f29a1de109ab0$var$ShowMoreAppsDialog = ({ options: options = [], useIsUserOAuthed: useIsUserOAuthed, useOAuthHandlers: useOAuthHandlers, thirdPartyConfigs: thirdPartyConfigs, oAuthSource: oAuthSource, trigger: trigger, shouldFitContainer: shouldFitContainer, offset: offset, isConnected: isConnected = true, onTriggerClick: onTriggerClick })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [filter, setFilter] = (0, $42omo.useState)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const debouncedOnShowMoreHover = (0, $JQd0k.useDebouncedCallback)((0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $fd71ee172a38aaa6$export$62cf98e2e77b39a2)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isConnected: isConnected
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        isConnected
    ]), 500);
    if (!options.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        content: ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                paddingBlock: "space.100",
                xcss: $862f29a1de109ab0$var$styles.showMoreApps,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        paddingInline: "space.100",
                        paddingBlockEnd: "space.150",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                            placeholder: formatMessage((0, $c395f352fa4770d3$export$defe85febe8b728c).filterPlaceholder),
                            onChange: (ev)=>setFilter(new RegExp(ev.currentTarget.value, 'i')),
                            onFocus: ()=>{
                                fireAnalyticsEvent((0, $ac33c27f1ebfdd91$export$a519e015cc174c44)({
                                    commonAttributes: commonAttributes,
                                    nonPrivacySafeAttributes: nonPrivacySafeAttributes
                                }));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        role: "list",
                        children: options.filter((option)=>!filter || typeof option.label === 'string' && filter.test(option.label)).map((option, index)=>/*#__PURE__*/ (0, $l998X.jsx)($862f29a1de109ab0$var$ShowMorePopupItem, {
                                option: option,
                                index: index,
                                thirdPartyConfigs: thirdPartyConfigs,
                                useIsUserOAuthed: useIsUserOAuthed,
                                useOAuthHandlers: useOAuthHandlers,
                                oAuthSource: oAuthSource,
                                setIsOpen: setIsOpen,
                                fireAnalyticsEvent: fireAnalyticsEvent,
                                commonAttributes: commonAttributes,
                                nonPrivacySafeAttributes: nonPrivacySafeAttributes
                            }, option.compositeKey || option.value))
                    })
                ]
            }),
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
            setFilter(undefined);
        },
        placement: "bottom-start",
        shouldFitContainer: shouldFitContainer,
        offset: offset,
        trigger: (triggerProps)=>trigger ? trigger({
                ...triggerProps,
                onClick: ()=>{
                    onTriggerClick?.();
                    setIsOpen((prev)=>!prev);
                    setFilter(undefined);
                }
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $73f6cd01fde76615$export$2e2bcd8739ae039), {
                oAuthWarning: null,
                triggerProps: triggerProps,
                isDisabled: false,
                isShowMore: true,
                option: {
                    label: formatMessage((0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? (0, $c395f352fa4770d3$export$defe85febe8b728c).showAllAppsLabel : (0, $c395f352fa4770d3$export$defe85febe8b728c).showMoreLabel),
                    isSelected: false,
                    value: undefined
                },
                onClick: ()=>{
                    onTriggerClick?.();
                    setIsOpen(true);
                    setFilter(undefined);
                    fireAnalyticsEvent((0, $4dd72e8bb888f87e$export$1d0e30033014b87d)({
                        commonAttributes: commonAttributes,
                        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                        isConnected: isConnected,
                        section: isConnected ? 'filterResults' : 'connectApps'
                    }));
                },
                onHover: debouncedOnShowMoreHover
            }),
        modifiers: [
            {
                name: 'computeStyles',
                options: {
                    // Prevent use of 3D transforms to avoid creating a new stacking context for fixed position children
                    // This allows the connection prompt popup to appear to the left of this dialog
                    gpuAcceleration: false
                }
            }
        ]
    });
};
var $862f29a1de109ab0$export$2e2bcd8739ae039 = $862f29a1de109ab0$var$ShowMoreAppsDialog;















var $228oz = parcelRequire("228oz");


var $9ZAVx = parcelRequire("9ZAVx");


var $hrMXM = parcelRequire("hrMXM");






function $cc0a0dee27693859$export$4b6aa0918037c08e({ filteredProducts: filteredProducts, products: products, selectedProduct: selectedProduct, thirdPartyConfigs: thirdPartyConfigs, primaryProduct: primaryProduct }) {
    const productsOrder = (0, $hrMXM.getProductsOrderByPrimaryProduct)(primaryProduct);
    return filteredProducts.filter((key)=>!!products[key]).sort((a, b)=>(0, $9ZAVx.getProductOrder)(a, b, productsOrder)).map((key)=>{
        const workspaceName = (0, $YqPsE.getWorkspaceNameFromProduct)(key, thirdPartyConfigs);
        return {
            value: key,
            label: workspaceName || String(products[key].displayName),
            isSelected: key === selectedProduct
        };
    });
}
function $cc0a0dee27693859$export$b27646c00c14c9a2({ availableNouns: availableNouns, availableProducts: availableProducts, selectedProduct: selectedProduct, selectedNounType: selectedNounType, formatMessage: formatMessage }) {
    const isWebCrawlerAvailable = availableProducts.includes((0, $1yEFx.ProductKeys).AtlassianWebCrawler);
    const nounsToDisplay = [
        ...availableNouns.filter((noun)=>noun !== (0, $4EMbH.NounKeys).AtlassianWebCrawler),
        ...isWebCrawlerAvailable ? [
            (0, $1yEFx.ProductKeys).AtlassianWebCrawler
        ] : []
    ].sort((a, b)=>(0, $4EMbH.NOUNS_ORDER).indexOf(a) - (0, $4EMbH.NOUNS_ORDER).indexOf(b));
    const isAtlasSelected = selectedProduct === (0, $1yEFx.ProductKeys).Atlas;
    return nounsToDisplay.filter((noun)=>!!(0, $4EMbH.nouns)[noun]).map((noun)=>({
            value: noun,
            label: formatMessage((0, $4EMbH.nouns)[noun].displayNamePlural),
            isSelected: noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler ? selectedProduct === (0, $1yEFx.ProductKeys).AtlassianWebCrawler : isAtlasSelected && noun === selectedNounType
        }));
}
function $cc0a0dee27693859$export$280307f0fd19d2fc(options, thirdPartyConfigs) {
    const minimalOptions = options.map((opt)=>({
            label: opt.label,
            value: opt.value,
            isSelected: opt.isSelected,
            onSelect: ()=>{},
            hideFilter: ()=>{},
            showFilter: ()=>{}
        }));
    const { connectedApps: connectedApps } = (0, $228oz.categorizeAppsByAuthStatus)({
        visibleApps: minimalOptions,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const connectedKeys = new Set(connectedApps.map((a)=>a.value));
    const authenticatedOptions = options.filter((opt)=>connectedKeys.has(opt.value));
    const unauthenticatedOptions = options.filter((opt)=>!connectedKeys.has(opt.value)).map((opt)=>({
            ...opt,
            isUnauthenticated: true
        }));
    return {
        authenticatedOptions: authenticatedOptions,
        unauthenticatedOptions: unauthenticatedOptions
    };
}











function $a30c047264eb4c93$export$3a04ac81be9f14ea(availableProducts, shouldShowNouns) {
    if (!shouldShowNouns) return availableProducts;
    return availableProducts.filter((key)=>key !== (0, $1yEFx.ProductKeys).Atlas && key !== (0, $1yEFx.ProductKeys).AtlassianWebCrawler);
}





function $3bef5f61e3423cb7$export$b63798d81f22734d(isNounsAvailable, availableNouns, availableProducts) {
    return isNounsAvailable || availableNouns.length > 0 || availableProducts.includes((0, $1yEFx.ProductKeys).AtlassianWebCrawler);
}









var $i1nCm = parcelRequire("i1nCm");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");





var $hjK5g = parcelRequire("hjK5g");


const { refreshOnAccessDecorator: $fd4dd27e5286221f$var$refreshOnAccessDecoratorPersonalization, get: $fd4dd27e5286221f$var$getPersonalizationCache, clear: $fd4dd27e5286221f$var$clearPersonalizationCache } = (0, $jnPv4.promiseCache)({
    name: (0, $i1nCm.SEARCH_PERSONALIZATION_BY_SITE_USER_CACHE_KEY),
    expiration: (0, $i1nCm.SEVEN_DAY_MS_TTL)
});
const $fd4dd27e5286221f$export$3207741464bed15e = async (userId)=>{
    const requestUrl = (0, $hjK5g.getPersonalizationSiteUserTraitsUrl)(userId);
    const requestOptions = {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.ok) return response.json();
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};
const $fd4dd27e5286221f$export$d2be385a647191c0 = async ({ userId: userId, analyticsCallback: analyticsCallback, cacheKeySuffix: cacheKeySuffix, traitName: traitName, degradationCallback: degradationCallback = ()=>{} })=>{
    const key = (0, $2qzBQ.generateHash)(`${(0, $i1nCm.SEARCH_PERSONALIZATION_BY_SITE_USER_CACHE_KEY)}|${userId}|${cacheKeySuffix}`);
    const supplier = async ()=>{
        const fetchPromise = $fd4dd27e5286221f$export$3207741464bed15e(userId).then((data)=>{
            const { attributes: attributes } = data;
            return attributes?.find((t)=>t.name === traitName);
        }).catch(()=>undefined); // treat non-200 as empty and avoid caching a rejected promise
        const degrader = new (0, $3Tbc2.DegradablePromise)(fetchPromise, degradationCallback, 1000); // 1s degrade threshold
        return degrader.promise().catch(async (e)=>{
            // On degrade/timeout, re-set cache entry to resolved undefined with ONE_HOUR_TTL
            // so callers won't hammer the service for the next hour, but will retry after.
            // Since we're in supplier, we can't directly set here without re-entrant complexity.
            // Instead, throw and let refreshOnAccessDecorator store this rejecting promise; after this call,
            // callers should rely on our external code path to clear or retry as needed.
            throw e;
        });
    };
    const existing = $fd4dd27e5286221f$var$getPersonalizationCache(key.toString());
    // Choose TTL based on outcome:
    // - success (non-empty trait): default SEVEN_DAY_TTL
    // - empty (undefined): ONE_DAY_TTL
    // - degraded (timeout/reject): ONE_HOUR_TTL
    // We cannot know the outcome until supplier resolves/rejects; so we approximate:
    //   if no existing value, we assume empty path (ONE_HOUR_MS_TTL) to avoid hammering
    //   then, within supplier, we adjust by re-setting the cache on rejection with ONE_HOUR_TTL
    const effectiveExpiration = !existing?.storedValue ? (0, $i1nCm.ONE_HOUR_MS_TTL) : undefined;
    const effectiveOnlyRefreshIfExpired = true;
    // Helper to re-write the cached value with a specific TTL without re-fetching
    const writeBackWithTTL = (value, ttl)=>{
        $fd4dd27e5286221f$var$refreshOnAccessDecoratorPersonalization({
            key: key.toString(),
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            expiration: ttl
        });
    };
    return $fd4dd27e5286221f$var$refreshOnAccessDecoratorPersonalization({
        key: key.toString(),
        supplier: async ()=>{
            try {
                const result = await supplier(); // Trait | undefined (no degrade)
                if (result) writeBackWithTTL(result, (0, $i1nCm.SEVEN_DAY_MS_TTL));
                else writeBackWithTTL(undefined, (0, $i1nCm.ONE_DAY_MS_TTL));
                return result;
            } catch (e) {
                // On degrade/timeout, return undefined so promiseCache stores an "empty" value
                // and then write back a short TTL to avoid hammering
                writeBackWithTTL(undefined, (0, $i1nCm.ONE_HOUR_MS_TTL));
                return undefined;
            }
        },
        onlyRefreshIfExpired: effectiveOnlyRefreshIfExpired,
        expiration: effectiveExpiration,
        analyticsCallback: analyticsCallback
    });
};
const $fd4dd27e5286221f$export$5f7b484a4ccacc79 = (key)=>$fd4dd27e5286221f$var$clearPersonalizationCache(key);


const $0b0bdfc4d6e4bfa6$export$5fd6e6f864665c35 = (traitName, trait)=>{
    if (trait && trait.name === traitName && trait.value && typeof trait.value === 'string') return trait.value.split(',').filter((s)=>s.length > 0);
    return [];
};


const $d15b8950e6ad335c$export$2fda7622441f06c6 = async ({ userId: userId, analyticsCallback: analyticsCallback, degradationCallback: degradationCallback })=>{
    if (!userId) return [];
    const trait = await (0, $fd4dd27e5286221f$export$d2be385a647191c0)({
        userId: userId,
        analyticsCallback: analyticsCallback,
        degradationCallback: degradationCallback,
        cacheKeySuffix: 'right-panel',
        traitName: (0, $i1nCm.RIGHT_PANEL_TRAIT)
    });
    return (0, $0b0bdfc4d6e4bfa6$export$5fd6e6f864665c35)((0, $i1nCm.RIGHT_PANEL_TRAIT), trait);
};


const $03a6710eb43ac8d4$export$67cdecee1ba002c3 = ({ searchSessionId: searchSessionId })=>({
        eventType: 'track',
        actionSubject: 'searchPage',
        action: '3pRecommendationStatus',
        attributes: {
            additionalAttributes: {
                status: 'NO_IDENTIFIER',
                searchSessionId: searchSessionId
            }
        }
    });


const $ee85427c6a0e1cd6$export$bf964e46bf8194b2 = ({ searchSessionId: searchSessionId, hit: hit })=>({
        eventType: 'track',
        actionSubject: 'searchPage',
        action: '3pRecommendationStatus',
        attributes: {
            additionalAttributes: {
                status: hit ? 'CACHE_HIT' : 'CACHE_MISS',
                searchSessionId: searchSessionId
            }
        }
    });


const $d420456113bb31a9$export$9154573ddadf513c = ({ searchSessionId: searchSessionId, reason: reason })=>({
        eventType: 'track',
        actionSubject: 'searchPage',
        action: '3pRecommendationStatus',
        attributes: {
            additionalAttributes: {
                status: 'DEGRADED',
                searchSessionId: searchSessionId,
                reason: reason
            }
        }
    });








function $2a8d6d6445842483$export$a718b8eb2c469b45({ userId: userId, showRecommendations: showRecommendations }) {
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [recommended3pApps, setRecommended3pApps] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const analyticsCallback = (0, $42omo.useCallback)(async (state)=>{
        try {
            fireAnalyticsEvent((0, $ee85427c6a0e1cd6$export$bf964e46bf8194b2)({
                searchSessionId: searchSessionId,
                hit: state.hit
            }));
        } catch  {}
    }, [
        fireAnalyticsEvent,
        searchSessionId
    ]);
    const degradationCallback = (0, $42omo.useCallback)((reason)=>{
        try {
            fireAnalyticsEvent((0, $d420456113bb31a9$export$9154573ddadf513c)({
                searchSessionId: searchSessionId,
                reason: reason
            }));
        } catch  {}
    }, [
        fireAnalyticsEvent,
        searchSessionId
    ]);
    const fetchRecs = (0, $42omo.useCallback)(async ()=>{
        if (!showRecommendations) {
            setRecommended3pApps([]);
            setLoading(false);
            return;
        } else if (!userId) {
            setRecommended3pApps([]);
            setLoading(false);
            fireAnalyticsEvent((0, $03a6710eb43ac8d4$export$67cdecee1ba002c3)({
                searchSessionId: searchSessionId
            }));
            return;
        } else {
            setLoading(true);
            try {
                const recs = await (0, $d15b8950e6ad335c$export$2fda7622441f06c6)({
                    userId: userId,
                    analyticsCallback: analyticsCallback,
                    degradationCallback: degradationCallback
                });
                setRecommended3pApps(Array.isArray(recs) ? recs : []);
            } finally{
                setLoading(false);
            }
        }
    }, [
        fireAnalyticsEvent,
        userId,
        searchSessionId,
        showRecommendations,
        analyticsCallback,
        degradationCallback
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchRecs();
    }, [
        fetchRecs
    ]);
    return (0, $42omo.useMemo)(()=>({
            recommended3pApps: recommended3pApps,
            loading: loading
        }), [
        recommended3pApps,
        loading
    ]);
}








/**
 * Represents the layout measurements of a child element within a scroll container.
 */ function $b8707a417e6afa79$export$ed9bf273412d47b9(direction, container, children) {
    if (children.length === 0) return 0;
    if (direction === 'right') {
        const containerRight = container.scrollLeft + container.clientWidth;
        // Find pills that are fully or partially hidden to the right
        const hiddenRight = children.filter((child)=>{
            const childRight = child.offsetLeft + child.offsetWidth;
            return childRight > containerRight + 1;
        });
        if (hiddenRight.length === 0) return 0;
        // Scroll so the first hidden pill aligns to the left edge of the container,
        // revealing as many of the next hidden pills as fit within the container width.
        const firstHiddenPill = hiddenRight[0];
        return firstHiddenPill.offsetLeft - container.scrollLeft;
    } else {
        const containerLeft = container.scrollLeft;
        // Find pills that are fully or partially hidden to the left
        const hiddenLeft = children.filter((child)=>{
            return child.offsetLeft < containerLeft - 1;
        });
        if (hiddenLeft.length === 0) return 0;
        // Scroll so the last hidden pill aligns to the right edge of the container,
        // revealing as many of the previous hidden pills as fit within the container width.
        const lastHiddenPill = hiddenLeft[hiddenLeft.length - 1];
        const lastHiddenPillRight = lastHiddenPill.offsetLeft + lastHiddenPill.offsetWidth;
        return container.scrollLeft + container.clientWidth - lastHiddenPillRight;
    }
}


const $b80c19d5cb4b6cce$var$DEFAULT_APP_PILL_LAYOUT = {
    firstConnectedBatchSize: 4,
    unauthenticated3pSlots: 2,
    secondConnectedBatchSize: 3
}; /**
    * Team 26 Demo layout: 6 connected (1P + 3P) → 3 unauthenticated 3P (no second connected batch).
    * Total visible pills = 9. Gated behind `rovo_fps_lite_app_filter_team26_demo_layout` and intended
    * to be targeted at Team 26 Demo sites via Statsig cohorting.
    */ 
const $b80c19d5cb4b6cce$var$TEAM26_DEMO_APP_PILL_LAYOUT = {
    firstConnectedBatchSize: 6,
    unauthenticated3pSlots: 3,
    secondConnectedBatchSize: 0
}; /**
    * Selects the active {@link AppPillLayout}. This is the single place the layout-related
    * feature gate(s) are consulted; downstream callers only deal with the resulting layout.
    */ 
const $b80c19d5cb4b6cce$export$19677ad52af0f5ac = ()=>{
    if ((0, $dh538.fg)('rovo_fps_lite_app_filter_team26_demo_layout')) return $b80c19d5cb4b6cce$var$TEAM26_DEMO_APP_PILL_LAYOUT;
    return $b80c19d5cb4b6cce$var$DEFAULT_APP_PILL_LAYOUT;
}; /**
    * Applies a {@link AppPillLayout} to the given authenticated/unauthenticated app option lists,
    * producing the visible pill order and the overflow remainder.
    *
    * Pure function (no React/feature-gate access) so it can be tested and reused independently.
    */ 
const $b80c19d5cb4b6cce$export$ce2d498e8592d9c5 = [
    (0, $1yEFx.ProductKeys).Jira,
    (0, $hdfeV.ProductKeys3P).GoogleDrive,
    (0, $hdfeV.ProductKeys3P).Github,
    (0, $hdfeV.ProductKeys3P).Salesforce,
    (0, $hdfeV.ProductKeys3P).Teams,
    (0, $hdfeV.ProductKeys3P).Figma,
    (0, $1yEFx.ProductKeys).Confluence
]; /**
                                                                                                                                                                                                                            * Reorders `authenticatedOptions` so that any entries whose `value` matches `pinnedOrder`
                                                                                                                                                                                                                            * appear first in the declared pinned order, followed by the remaining authenticated entries
                                                                                                                                                                                                                            * in their original order. Pinned keys with no matching entry are skipped silently.
                                                                                                                                                                                                                            *
                                                                                                                                                                                                                            * Pure function (no React/feature-gate access) so it can be tested and reused independently.
                                                                                                                                                                                                                            */ 
const $b80c19d5cb4b6cce$export$f40f823283e1d9b0 = (authenticatedOptions, pinnedOrder)=>{
    const byValue = new Map(authenticatedOptions.map((o)=>[
            o.value,
            o
        ]));
    const pinnedKeys = new Set(pinnedOrder);
    const pinned = pinnedOrder.map((key)=>byValue.get(key)).filter((o)=>o !== undefined);
    const rest = authenticatedOptions.filter((o)=>!pinnedKeys.has(o.value));
    return [
        ...pinned,
        ...rest
    ];
};
const $b80c19d5cb4b6cce$export$56e395abfaa2bd7d = ({ layout: layout, authenticatedOptions: authenticatedOptions, rankedUnauthenticated3p: rankedUnauthenticated3p })=>{
    const { firstConnectedBatchSize: firstConnectedBatchSize, unauthenticated3pSlots: unauthenticated3pSlots, secondConnectedBatchSize: secondConnectedBatchSize } = layout;
    const firstConnectedBatch = authenticatedOptions.slice(0, firstConnectedBatchSize);
    const visibleUnauthenticated3p = rankedUnauthenticated3p.slice(0, unauthenticated3pSlots);
    const secondConnectedBatch = authenticatedOptions.slice(firstConnectedBatchSize, firstConnectedBatchSize + secondConnectedBatchSize);
    const visibleOptions = [
        ...firstConnectedBatch,
        ...visibleUnauthenticated3p,
        ...secondConnectedBatch
    ];
    const overflowAuthenticated = authenticatedOptions.slice(firstConnectedBatchSize + secondConnectedBatchSize);
    const overflowUnauthenticated3p = rankedUnauthenticated3p.slice(unauthenticated3pSlots);
    const overflowOptions = [
        ...overflowAuthenticated,
        ...overflowUnauthenticated3p
    ];
    return {
        visibleOptions: visibleOptions,
        overflowOptions: overflowOptions
    };
}; /**
    * Context that tracks the set of app keys that have been "promoted" from the
    * "Show more apps" dialog into the visible app filter pill bar. Promoted apps
    * are rendered as the first pills in the bar (before the regular visible
    * options) and are removed from the overflow dropdown. State is in-memory only
    * and intentionally does not persist across page reloads.
    */ 
const $b80c19d5cb4b6cce$var$PromotedAppsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    promotedAppKeys: [],
    promoteApp: ()=>{}
}); /**
     * Provider for the promoted apps state. Place this around `LiteAppFilterBar`
     * and `LiteShowAllAppsButton` so they share the same in-memory list of
     * apps that have been selected from the "Show more apps" dialog.
     */ 
const $b80c19d5cb4b6cce$export$3e468973358aadd3 = ({ children: children })=>{
    const [promotedAppKeys, setPromotedAppKeys] = (0, $42omo.useState)([]);
    const promoteApp = (0, $42omo.useCallback)((key)=>{
        setPromotedAppKeys((prev)=>prev.includes(key) ? prev : [
                ...prev,
                key
            ]);
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            promotedAppKeys: promotedAppKeys,
            promoteApp: promoteApp
        }), [
        promotedAppKeys,
        promoteApp
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($b80c19d5cb4b6cce$var$PromotedAppsContext.Provider, {
        value: value,
        children: children
    });
};
const $b80c19d5cb4b6cce$var$usePromotedApps = ()=>(0, $42omo.useContext)($b80c19d5cb4b6cce$var$PromotedAppsContext);
const $b80c19d5cb4b6cce$var$styles = {
    pill: "_zulpu2gc _2rko1rr0 _11c8fhey _1rjc12x7 _18zrutpp _189ee4h9 _1dqonqa1 _1h6d1j28 _1e0c1txw _4cvr1h6o _80omtlke _k48p1wq8 _syazi7uo _bfhki8nm _o5721q9c _1o9zidpf _irr3plhp _30l3i7uo",
    pillSelected: "_1h6dq98m _bfhk15s3 _syaz6x5g _irr3ufnl _30l36x5g",
    scrollContainer: "_zulputpp _1e0c1txw _4cvr1h6o _1reo1wug _1fjgglyw _1dm8q5uf",
    outerContainer: "_1e0c1txw _4cvr1h6o _kqswh2mm",
    chevronButton: "_2rko1rr0 _1reo15vq _18m915vq _1e0c1txw _bfhk1bhr _16qs130s",
    chevronContainer: "_18zrv77o _kqswstnw _154iidpf _94n5idpf _1e0c1txw _4cvr1h6o _1bah1h6o _1pbykb7n",
    chevronLeft: "_1ltvidpf",
    chevronRight: "_1xi2idpf",
    iconContainer: "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz _1o9zidpf"
}; /**
    * Builds the ordered list of visible and overflow app options for the Lite mode pill bar.
    * - Total of up to 9 visible pills, split per the active {@link AppPillLayout}
    *   (see {@link getAppPillLayout} for the selection logic).
    * - Unauthenticated 3P apps are ranked by recommended3pApps order.
    * - Remaining apps beyond the visible budget go to the "Show all apps" overflow dropdown.
    *
    * Uses shared util functions from app-filter-options for product/noun building and auth splitting,
    * and delegates final visible/overflow slicing to {@link applyAppPillLayout}.
    */ 
function $b80c19d5cb4b6cce$var$useLiteAppOptions() {
    const [{ products: availableProducts, nouns: availableNouns, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [isNounsAvailable] = (0, $j4ply.useIsNounsAvailable)();
    const userId = (0, $j4ply.useCurrentUserId)();
    const { recommended3pApps: recommended3pApps } = (0, $2a8d6d6445842483$export$a718b8eb2c469b45)({
        userId: userId,
        showRecommendations: true
    });
    const filters = (0, $djVCD.useFilters)();
    const { promotedAppKeys: promotedAppKeys, promoteApp: promoteApp } = $b80c19d5cb4b6cce$var$usePromotedApps();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const products = (0, $1yEFx.useProductConfigs)(); // Derive the currently selected noun type from the universal type filter.
    // When a noun like "project" or "goal" is selected, the store sets product=townsquare
    // and sets the type filter to that noun value.
    const selectedNounType = (0, $42omo.useMemo)(()=>{
        const typeFilter = filters[0, $7iBhV.universalTypeFilterId];
        if (typeFilter && 'selectedOptions' in typeFilter) {
            const selected = typeFilter.selectedOptions.find((opt)=>opt.isSelected);
            return selected?.value;
        }
        return undefined;
    }, [
        filters
    ]);
    const result = (0, $42omo.useMemo)(()=>{
        // Always exclude Townsquare/Atlas (rendered as "Home") from the Lite app pill bar.
        // In the right rail, Atlas is hidden because it's classified as a "nested product" of
        // the `atlas` product category and the category's primary product key (`'atlas'`) is
        // not a real ProductKeys value, so the parent never renders. The Lite filter bar does
        // not implement that nested-categories logic, so we drop Atlas explicitly here to keep
        // behaviour consistent with the right rail.
        const productsWithoutAtlas = availableProducts.filter((key)=>key !== (0, $1yEFx.ProductKeys).Atlas);
        const shouldShowNouns = (0, $3bef5f61e3423cb7$export$b63798d81f22734d)(isNounsAvailable, availableNouns, productsWithoutAtlas);
        const filteredProducts = (0, $a30c047264eb4c93$export$3a04ac81be9f14ea)(productsWithoutAtlas, shouldShowNouns);
        const productOptions = (0, $cc0a0dee27693859$export$4b6aa0918037c08e)({
            filteredProducts: filteredProducts,
            products: products,
            selectedProduct: selectedProduct,
            thirdPartyConfigs: thirdPartyConfigs
        });
        const nounOptions = shouldShowNouns ? (0, $cc0a0dee27693859$export$b27646c00c14c9a2)({
            availableNouns: availableNouns,
            availableProducts: productsWithoutAtlas,
            selectedProduct: selectedProduct,
            selectedNounType: selectedNounType,
            formatMessage: formatMessage
        }) : [];
        const allOptions = [
            ...productOptions,
            ...nounOptions
        ];
        const { authenticatedOptions: authenticatedOptions, unauthenticatedOptions: unauthenticatedOptions } = (0, $cc0a0dee27693859$export$280307f0fd19d2fc)(allOptions, thirdPartyConfigs); // Rank unauthenticated 3P by recommendations order: walk the recommended list first
        // (preserving rank), then append any unauthenticated apps not in the recommendations list.
        const unauthenticatedByValue = new Map(unauthenticatedOptions.map((o)=>[
                o.value,
                o
            ]));
        const rankedFromRecommendations = recommended3pApps.map((key)=>unauthenticatedByValue.get(key)).filter((o)=>o !== undefined);
        const recommendedKeys = new Set(recommended3pApps);
        const unranked = unauthenticatedOptions.filter((o)=>!recommendedKeys.has(o.value));
        const rankedUnauthenticated3p = [
            ...rankedFromRecommendations,
            ...unranked
        ]; // When the Team 26 Demo gate is on, pin a fixed front-of-bar order
        // (Jira → named 3Ps that are authenticated → Confluence) before slicing into the
        // visible/overflow buckets. Unauthenticated handling is unchanged: the named 3Ps that
        // are not connected fall back to the existing `rankedUnauthenticated3p` Connect-pill flow.
        const orderedAuthenticatedOptions = (0, $dh538.fg)('rovo_fps_lite_app_filter_team26_demo_layout') ? $b80c19d5cb4b6cce$export$f40f823283e1d9b0(authenticatedOptions, $b80c19d5cb4b6cce$export$ce2d498e8592d9c5) : authenticatedOptions; // Pick the active layout (default vs Team 26 Demo) and split the options into visible vs
        // overflow. The layout choice is encapsulated in `getAppPillLayout()` and the slicing in
        // `applyAppPillLayout()` so this hook only owns option construction.
        const { visibleOptions: visibleOptions, overflowOptions: overflowOptions } = $b80c19d5cb4b6cce$export$56e395abfaa2bd7d({
            layout: $b80c19d5cb4b6cce$export$19677ad52af0f5ac(),
            authenticatedOptions: orderedAuthenticatedOptions,
            rankedUnauthenticated3p: rankedUnauthenticated3p
        }); // Apply "promoted" apps: any app that the user selected from the
        // "Show more apps" dialog is moved out of the overflow list and
        // rendered as a pill at the start of the visible options. Promoted
        // apps stay in the visible bar for the rest of the session, even if
        // this means rendering more than the regular max of 9 pills.
        //
        // Promoted apps are rendered in *reverse* selection order: the most
        // recently promoted app appears first. For example, if the user clicks
        // Google and then Confluence, the visible bar shows
        // [Confluence, Google, ...].
        if (promotedAppKeys.length === 0) return {
            visibleOptions: visibleOptions,
            overflowOptions: overflowOptions
        };
        const promotedSet = new Set(promotedAppKeys); // Build the promoted pills in *reverse* promotion order so the most
        // recently selected app appears first. Look up the option from either
        // the visible or overflow lists so that promotion is idempotent and
        // works regardless of where the option currently sits.
        const allOptionsByKey = new Map();
        for (const opt of [
            ...visibleOptions,
            ...overflowOptions
        ])allOptionsByKey.set(String(opt.value), opt);
        const promotedOptions = [
            ...promotedAppKeys
        ].reverse().map((key)=>allOptionsByKey.get(key)).filter((o)=>o !== undefined);
        const filteredVisibleOptions = visibleOptions.filter((o)=>!promotedSet.has(String(o.value)));
        const filteredOverflowOptions = overflowOptions.filter((o)=>!promotedSet.has(String(o.value)));
        return {
            visibleOptions: [
                ...promotedOptions,
                ...filteredVisibleOptions
            ],
            overflowOptions: filteredOverflowOptions
        };
    }, [
        availableProducts,
        availableNouns,
        isNounsAvailable,
        selectedProduct,
        selectedNounType,
        thirdPartyConfigs,
        products,
        formatMessage,
        recommended3pApps,
        promotedAppKeys
    ]); // Auto-promote any overflow option that is currently selected. This handles
    // the case where the page is loaded with a URL whose `selectedProduct` lives
    // inside the "Show more apps" overflow dialog: instead of leaving the app
    // hidden inside the dialog (with only the "Show all apps" trigger reflecting
    // the selection), we surface the selected app as the first visible pill.
    // Once promoted, the app stays in the visible bar for the rest of the
    // session even if the user later clicks a different pill — this matches the
    // existing in-memory promotion behaviour for apps clicked from the dialog.
    (0, $42omo.useEffect)(()=>{
        for (const option of result.overflowOptions)if (option.isSelected && option.value !== undefined) promoteApp(String(option.value));
    }, [
        result.overflowOptions,
        promoteApp
    ]);
    return result;
}
const $b80c19d5cb4b6cce$var$AppPill = ({ option: option, onSelect: onSelect, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const label = option.isUnauthenticated ? formatMessage({
        id: "search_page.lite_app_filter_bar.connect_app",
        defaultMessage: "Connect {app}"
    }, {
        app: option.label
    }) : option.label;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($b80c19d5cb4b6cce$var$styles.pill, option.isSelected && $b80c19d5cb4b6cce$var$styles.pillSelected),
        onClick: ()=>{
            if (!isDisabled) onSelect(option.value);
        },
        "aria-pressed": option.isSelected,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            alignItems: "center",
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $b80c19d5cb4b6cce$var$styles.iconContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductOrNounIcon), {
                        label: "",
                        size: "xxsmall",
                        productOrNounKey: option.value,
                        isSelected: option.isSelected
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: label
                }),
                option.isUnauthenticated && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                    label: "",
                    size: "small",
                    color: "var(--ds-icon-subtle, #505258)"
                })
            ]
        })
    });
};
const $b80c19d5cb4b6cce$var$AllPill = ({ isSelected: isSelected, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($b80c19d5cb4b6cce$var$styles.pill, isSelected && $b80c19d5cb4b6cce$var$styles.pillSelected),
        onClick: onSelect,
        "aria-pressed": isSelected,
        children: formatMessage({
            id: "search_page.lite_app_filter_bar.all",
            defaultMessage: "All"
        })
    });
}; /**
    * Shared hook that returns a stable callback for selecting a product or noun filter.
    * Used by both LiteAppFilterBar (visible pills) and LiteShowAllAppsButton (overflow menu).
    */ 
function $b80c19d5cb4b6cce$var$useLiteFilterSelect() {
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const { selectProductFilter: selectProductFilter, unselectProductFilter: unselectProductFilter, unsafe_setAtlasNouns: unsafe_setAtlasNouns, unsafe_setWebPageType: unsafe_setWebPageType } = (0, $djVCD.useSearchActions)();
    return (0, $42omo.useCallback)((value)=>{
        if (!value || value === selectedProduct) {
            unselectProductFilter();
            return;
        }
        if (value === (0, $4EMbH.NounKeys).AtlassianWebCrawler) {
            unsafe_setWebPageType();
            return;
        }
        if ((0, $4EMbH.isNounKey)(value)) {
            unsafe_setAtlasNouns(value);
            return;
        }
        selectProductFilter(value);
    }, [
        selectedProduct,
        selectProductFilter,
        unselectProductFilter,
        unsafe_setAtlasNouns,
        unsafe_setWebPageType
    ]);
} /**
   * Horizontal app filter bar for Lite mode. Shows "All" pill + up to 9 product pills
   * in a single horizontally-scrollable row. Chevron buttons appear on hover to scroll
   * left/right. A "Show all apps" dropdown provides access to overflow apps.
   */ 
const $b80c19d5cb4b6cce$export$d6e71f9cd5617f42 = ()=>{
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const isAllSelected = !selectedProduct;
    const { visibleOptions: visibleOptions } = $b80c19d5cb4b6cce$var$useLiteAppOptions();
    const handleSelect = $b80c19d5cb4b6cce$var$useLiteFilterSelect();
    const scrollRef = (0, $42omo.useRef)(null);
    const [canScrollLeft, setCanScrollLeft] = (0, $42omo.useState)(false);
    const [canScrollRight, setCanScrollRight] = (0, $42omo.useState)(false);
    const [isHovering, setIsHovering] = (0, $42omo.useState)(false);
    const updateScrollState = (0, $42omo.useCallback)(()=>{
        const el = scrollRef.current;
        if (!el) return;
        setCanScrollLeft(el.scrollLeft > 0);
        setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    }, []);
    (0, $42omo.useEffect)(()=>{
        const el = scrollRef.current;
        if (!el) return;
        updateScrollState();
        const unbindScroll = (0, $fFa3V.bind)(el, {
            type: 'scroll',
            listener: updateScrollState
        });
        const resizeObserver = new ResizeObserver(updateScrollState);
        resizeObserver.observe(el);
        return ()=>{
            unbindScroll();
            resizeObserver.disconnect();
        };
    }, [
        updateScrollState
    ]);
    const computeScrollAmount = (0, $42omo.useCallback)((direction)=>{
        const el = scrollRef.current;
        if (!el) return 0;
        const children = Array.from(el.children);
        return (0, $b8707a417e6afa79$export$ed9bf273412d47b9)(direction, {
            scrollLeft: el.scrollLeft,
            clientWidth: el.clientWidth
        }, children.map((child)=>({
                offsetLeft: child.offsetLeft,
                offsetWidth: child.offsetWidth
            })));
    }, []);
    const scrollLeft = (0, $42omo.useCallback)(()=>{
        const amount = computeScrollAmount('left');
        scrollRef.current?.scrollBy({
            left: -amount,
            behavior: 'smooth'
        });
    }, [
        computeScrollAmount
    ]);
    const scrollRight = (0, $42omo.useCallback)(()=>{
        const amount = computeScrollAmount('right');
        scrollRef.current?.scrollBy({
            left: amount,
            behavior: 'smooth'
        });
    }, [
        computeScrollAmount
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $b80c19d5cb4b6cce$var$styles.outerContainer,
        onMouseEnter: ()=>setIsHovering(true),
        onMouseLeave: ()=>setIsHovering(false),
        children: [
            isHovering && canScrollLeft && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($b80c19d5cb4b6cce$var$styles.chevronContainer, $b80c19d5cb4b6cce$var$styles.chevronLeft),
                style: {
                    background: `linear-gradient(to right, ${"var(--ds-surface, #FFFFFF)"} 50%, transparent)`,
                    paddingInline: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-200, 16px)"}`
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $b80c19d5cb4b6cce$var$styles.chevronButton,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        appearance: "subtle",
                        spacing: "compact",
                        shape: "circle",
                        label: "Scroll left",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($laHi9))),
                        onClick: scrollLeft
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                ref: scrollRef,
                xcss: $b80c19d5cb4b6cce$var$styles.scrollContainer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($b80c19d5cb4b6cce$var$AllPill, {
                        isSelected: isAllSelected,
                        onSelect: ()=>handleSelect(undefined)
                    }),
                    visibleOptions.map((option)=>option.isUnauthenticated ? /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
                            product: option.value,
                            isSmartlink: (0, $def8z.isProductSmartlink)({
                                productKey: option.value,
                                thirdPartyConfigs: thirdPartyConfigs
                            }),
                            useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
                            useIsUserOAuthed: (0, $gGFxq.useIsUserOAuthed),
                            oAuthSource: (0, $ckkm9.OAuthSource).searchPageFilter,
                            thirdPartyConfigs: thirdPartyConfigs,
                            skipFlagsProvider: false,
                            trigger: ({ isDisabled: isDisabled })=>/*#__PURE__*/ (0, $l998X.jsx)($b80c19d5cb4b6cce$var$AppPill, {
                                    option: option,
                                    onSelect: handleSelect,
                                    isDisabled: isDisabled
                                })
                        }, option.value) : /*#__PURE__*/ (0, $l998X.jsx)($b80c19d5cb4b6cce$var$AppPill, {
                            option: option,
                            onSelect: handleSelect
                        }, option.value))
                ]
            }),
            isHovering && canScrollRight && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($b80c19d5cb4b6cce$var$styles.chevronContainer, $b80c19d5cb4b6cce$var$styles.chevronRight),
                style: {
                    background: `linear-gradient(to left, ${"var(--ds-surface, #FFFFFF)"} 50%, transparent)`,
                    paddingInline: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-025, 2px)"}`
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $b80c19d5cb4b6cce$var$styles.chevronButton,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        appearance: "subtle",
                        spacing: "compact",
                        shape: "circle",
                        label: "Scroll right",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))),
                        onClick: scrollRight
                    })
                })
            })
        ]
    });
}; /**
    * "Show all apps" button that renders overflow app options beyond the 9 visible pills.
    * Designed to be placed alongside the "More filters" button in the header toggle area.
    */ 
const $b80c19d5cb4b6cce$export$6939095785c277c7 = ()=>{
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { visibleOptions: visibleOptions, overflowOptions: overflowOptions } = $b80c19d5cb4b6cce$var$useLiteAppOptions();
    const handleSelect = $b80c19d5cb4b6cce$var$useLiteFilterSelect();
    const { promoteApp: promoteApp } = $b80c19d5cb4b6cce$var$usePromotedApps();
    const dialogOptions = (0, $42omo.useMemo)(()=>[
            ...visibleOptions,
            ...overflowOptions
        ], [
        visibleOptions,
        overflowOptions
    ]);
    const showMoreOptions = (0, $42omo.useMemo)(()=>dialogOptions.map((option)=>({
                label: option.label,
                value: option.value,
                isSelected: option.isSelected,
                onSelect: ()=>{
                    // Promote the app so it renders as a pill at the start of the
                    // visible app filter bar (instead of remaining in the dialog
                    // list). The selection is then applied in the usual way.
                    if (option.value !== undefined) promoteApp(String(option.value));
                    handleSelect(option.value);
                },
                hideFilter: ()=>{},
                showFilter: ()=>{}
            })), [
        dialogOptions,
        handleSelect,
        promoteApp
    ]);
    const hasSelectedOverflow = overflowOptions.some((opt)=>opt.isSelected); // Only render the "Show all apps" entry point when the user actually
    // cannot see every app as a pill in the visible bar. If everything
    // already fits as a pill (no overflow), the dialog would be redundant
    // and would just add visual noise to the header.
    if (overflowOptions.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $862f29a1de109ab0$export$2e2bcd8739ae039), {
        options: showMoreOptions,
        useIsUserOAuthed: (0, $gGFxq.useIsUserOAuthed),
        useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
        thirdPartyConfigs: thirdPartyConfigs,
        oAuthSource: (0, $ckkm9.OAuthSource).searchPageFilter,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                ref: triggerProps.ref,
                appearance: "default",
                isSelected: hasSelectedOverflow || triggerProps['aria-expanded'] === true,
                onClick: triggerProps.onClick,
                "aria-expanded": triggerProps['aria-expanded'],
                "aria-haspopup": triggerProps['aria-haspopup'],
                children: formatMessage({
                    id: "search_page.lite_app_filter_bar.show_all_apps",
                    defaultMessage: "Show all apps"
                })
            })
    });
};








const $690d125b2472b865$export$1217913212f99c7 = ()=>{
    const [width, setWidth] = (0, $42omo.useState)(0);
    const nodeRef = (0, $42omo.useRef)(null);
    const lastWidthRef = (0, $42omo.useRef)(0);
    const commitWidth = (0, $42omo.useCallback)((nextWidth)=>{
        if (nextWidth <= 0 || nextWidth === lastWidthRef.current) return;
        lastWidthRef.current = nextWidth;
        setWidth(nextWidth);
    }, []);
    const setNode = (0, $42omo.useCallback)((node)=>{
        nodeRef.current = node;
        if (node) commitWidth(node.getBoundingClientRect().width);
    }, [
        commitWidth
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = nodeRef.current;
        if (!el) return;
        const observer = new ResizeObserver((entries)=>{
            for (const entry of entries)commitWidth(entry.contentRect.width);
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, [
        commitWidth
    ]);
    return {
        width: width,
        setNode: setNode,
        nodeRef: nodeRef
    };
};
const $690d125b2472b865$var$isScrollableElement = (el)=>{
    const style = window.getComputedStyle(el);
    const overflowY = style.overflowY;
    return (overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight;
};
/**
 * Walks up from `start` looking for a scrollable ancestor; if none found,
 * checks siblings (covers the lite layout where the header and body are
 * siblings under a non-scrolling wrapper). Falls back to `window`.
 * Re-resolved on every scroll event so it picks up layout changes (e.g.
 * results loading after an initial empty-state render).
 */ const $690d125b2472b865$var$findScrollSource = (start)=>{
    let node = start?.parentElement ?? null;
    while(node && node !== document.body && node !== document.documentElement){
        if ($690d125b2472b865$var$isScrollableElement(node)) return node;
        const siblings = Array.from(node.children);
        for (const sibling of siblings){
            if (sibling !== start && $690d125b2472b865$var$isScrollableElement(sibling)) return sibling;
        }
        node = node.parentElement;
    }
    return window;
};
const $690d125b2472b865$var$computeIsScrolled = (source)=>{
    if (source === window) return window.scrollY > 0;
    return source.scrollTop > 0;
};
const $690d125b2472b865$var$getScrollOverflow = (source)=>{
    if (source === window) return Math.max(0, document.documentElement.scrollHeight - document.documentElement.clientHeight);
    const el = source;
    return Math.max(0, el.scrollHeight - el.clientHeight);
};
// Safety margin for the insufficient-scroll-overflow guard.
// Overflow must exceed (filterRowHeight + buffer) to allow auto-collapse.
const $690d125b2472b865$var$SAFETY_MARGIN_FLOOR = 80;
const $690d125b2472b865$var$SAFETY_MARGIN_BUFFER = 24;
const $690d125b2472b865$export$98084ad349e2edae = ({ containerRef: containerRef, filtersRowRef: filtersRowRef })=>{
    const [isScrolled, setIsScrolled] = (0, $42omo.useState)(false);
    const [hasInsufficientScrollOverflow, setHasInsufficientScrollOverflow] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const handleScroll = ()=>{
            // Re-resolve the scroll source on every scroll so layout changes
            // (e.g. a body container becoming scrollable after results load)
            // are always reflected without stale-cache issues.
            const source = $690d125b2472b865$var$findScrollSource(containerRef.current);
            setIsScrolled($690d125b2472b865$var$computeIsScrolled(source));
            const filterRowHeight = filtersRowRef.current?.offsetHeight ?? 0;
            const safetyMargin = Math.max(filterRowHeight, $690d125b2472b865$var$SAFETY_MARGIN_FLOOR) + $690d125b2472b865$var$SAFETY_MARGIN_BUFFER;
            setHasInsufficientScrollOverflow($690d125b2472b865$var$getScrollOverflow(source) < safetyMargin);
        };
        // Initialise synchronously so deep-linked pages render the correct state on first paint.
        handleScroll();
        // `scroll` doesn't bubble — use capture on document to catch all sources.
        // Also bind window directly for document-level scrolling layouts.
        const unbindDocument = (0, $fFa3V.bind)(document, {
            type: 'scroll',
            listener: handleScroll,
            options: {
                capture: true,
                passive: true
            }
        });
        const unbindWindow = (0, $fFa3V.bind)(window, {
            type: 'scroll',
            listener: handleScroll,
            options: {
                passive: true
            }
        });
        return ()=>{
            unbindDocument();
            unbindWindow();
        };
    }, [
        containerRef,
        filtersRowRef
    ]);
    return {
        isScrolled: isScrolled,
        hasInsufficientScrollOverflow: hasInsufficientScrollOverflow
    };
};
const $690d125b2472b865$export$367e70606473630e = ({ isScrolled: isScrolled, hasInsufficientScrollOverflow: hasInsufficientScrollOverflow, hasSelectedFilters: hasSelectedFilters, setIsFiltersExpanded: setIsFiltersExpanded })=>{
    (0, $42omo.useEffect)(()=>{
        if (hasSelectedFilters) {
            setIsFiltersExpanded(true);
            return;
        }
        if (hasInsufficientScrollOverflow) return;
        setIsFiltersExpanded(!isScrolled);
    }, [
        isScrolled,
        hasSelectedFilters,
        hasInsufficientScrollOverflow,
        setIsFiltersExpanded
    ]);
};
// Aligns the cluster center with filter pill centers (pills have outer padding
// that shifts their visual center slightly below a plain button's center).
const $690d125b2472b865$var$PILL_INNER_PADDING_OFFSET = 3;
// Vertical gap between the appFilterBar row and the filters row.
const $690d125b2472b865$var$ROW_GAP = 12;
const $690d125b2472b865$export$c25a9b8edd9dd4fb = ({ appFilterBarRowEl: appFilterBarRowEl, filtersRowEl: filtersRowEl, isFiltersExpanded: isFiltersExpanded, containerWidth: containerWidth })=>{
    const [toggleClusterTop, setToggleClusterTop] = (0, $42omo.useState)(0);
    const { width: toggleClusterWidth, setNode: setToggleClusterEl } = $690d125b2472b865$export$1217913212f99c7();
    const [hasMeasuredInitialPosition, setHasMeasuredInitialPosition] = (0, $42omo.useState)(false);
    const [areTransitionsEnabled, setAreTransitionsEnabled] = (0, $42omo.useState)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!appFilterBarRowEl || !filtersRowEl) return;
        const computeTop = ()=>{
            const appFilterBarCenter = appFilterBarRowEl.offsetTop + appFilterBarRowEl.offsetHeight / 2;
            if (isFiltersExpanded) return appFilterBarCenter + appFilterBarRowEl.offsetHeight + $690d125b2472b865$var$ROW_GAP + $690d125b2472b865$var$PILL_INNER_PADDING_OFFSET;
            return appFilterBarCenter;
        };
        // Bail out if the computed value hasn't changed (avoids renders on height-only resizes).
        let lastTop = -1;
        const commitTop = ()=>{
            const next = computeTop();
            if (next !== lastTop) {
                lastTop = next;
                setToggleClusterTop(next);
            }
        };
        commitTop();
        const observer = new ResizeObserver(commitTop);
        observer.observe(appFilterBarRowEl);
        observer.observe(filtersRowEl);
        return ()=>observer.disconnect();
    }, [
        isFiltersExpanded,
        containerWidth,
        appFilterBarRowEl,
        filtersRowEl
    ]);
    // Reveal the cluster once both top and width are measured.
    // useLayoutEffect ensures the reveal is flushed in the same paint as the
    // first measurement so the cluster is never visible at y=0.
    (0, $42omo.useLayoutEffect)(()=>{
        if (hasMeasuredInitialPosition || toggleClusterTop === 0 || toggleClusterWidth === 0) return;
        setHasMeasuredInitialPosition(true);
    }, [
        hasMeasuredInitialPosition,
        toggleClusterTop,
        toggleClusterWidth
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!hasMeasuredInitialPosition || areTransitionsEnabled) return;
        let rafId2 = 0;
        const rafId1 = requestAnimationFrame(()=>{
            rafId2 = requestAnimationFrame(()=>{
                setAreTransitionsEnabled(true);
            });
        });
        return ()=>{
            cancelAnimationFrame(rafId1);
            if (rafId2) cancelAnimationFrame(rafId2);
        };
    }, [
        hasMeasuredInitialPosition,
        areTransitionsEnabled
    ]);
    return {
        toggleClusterTop: toggleClusterTop,
        toggleClusterWidth: toggleClusterWidth,
        hasMeasuredInitialPosition: hasMeasuredInitialPosition,
        areTransitionsEnabled: areTransitionsEnabled,
        setToggleClusterEl: setToggleClusterEl
    };
};


const $be490c0458782317$var$MIN_FILTERS_SECTION_WIDTH = 300; /**
                                        * Estimated width (in px) per app pill in the app filter bar. Each pill is a
                                        * button containing an icon + label, typically 80–120px. We use a conservative
                                        * estimate to ensure we don't show the combined row when there isn't enough
                                        * space.
                                        */ 
const $be490c0458782317$var$ESTIMATED_APP_PILL_WIDTH = 110; /**
                                       * Fixed overhead in the app filter bar (in px): the "All" pill (~50px), the
                                       * "Show all apps" button (~120px when visible), gaps between pills (~12px each),
                                       * and the grid column gap between the app bar and filters section (16px).
                                       */ 
const $be490c0458782317$var$APP_FILTER_BAR_FIXED_OVERHEAD = 200;
const $be490c0458782317$var$styles = {
    base: "_kqsw1if8 _154iidpf _bfhkvuon _1bsb1osq _1y1m1u8q _1pby1kze",
    keyline: "_n7zlia51",
    contentContainer: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _19bvu2gc _u5f3u2gc _4cvr1yb4 _b8yq1a8x",
    gridTwoRow: "_1lmc1g5p _yv0ehkll _ca0q1ejb _n3td1ejb _kqswh2mm",
    filtersAnimatedWrapper: "_v5641d1u _1e0c11p5 _2z0563bf _tzy4idpf _t9ec1kyj _ca0qze3t",
    filtersAnimatedWrapperExpanded: "_2z05hkll _tzy4kb7n _t9ec1kli _ca0qutpp",
    filtersAnimatedInner: "_1reo15vq _18m915vq _1tkeidpf",
    filtersRowContent: "_zulputpp _1e0c1txw _4cvr1h6o",
    filtersRowFiltersArea: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
    filtersRowToggleArea: "_zulputpp _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _1bahesu3",
    filtersRowToggleClusterSpacer: "_1reo15vq _18m915vq _v564122b _1o9zidpf _16jlidpf",
    filtersRowToggleClusterSpacerNoTransition: "_v564glyw",
    inputGridArea: "_nd5l1hq5 _1e0c1txw _4cvr1h6o _otyrpxbi",
    appFilterBarGridArea: "_nd5lsg9t _zulputpp _1ul9idpf _1e0c1txw _4cvr1h6o",
    appFilterBarScroll: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul9idpf",
    toggleCluster: "_zulputpp _v5641fzk _kqswstnw _1xi2idpf _1e0c1txw _4cvr1h6o _t9ec1i34 _1pbykb7n",
    toggleClusterNoTransition: "_v564glyw",
    toggleClusterHidden: "_3um015vq",
    toggleClusterSpacer: "_1reo15vq _18m915vq _v56419g2 _1o9zidpf _16jlidpf",
    toggleClusterSpacerNoTransition: "_v564glyw",
    filtersGridArea: "_nd5l12xr",
    gridSingleApp: "_1lmch78g _yv0e1j7d _ca0q1ejb _n3td1ejb",
    gridCombinedRow: "_1lmc1cbl _yv0e16ab _gy1putpp _ca0q1ejb _n3td1ejb",
    feedbackGridArea: "_nd5l1v4b _1e0c1txw _4cvr1h6o _1bahesu3",
    paddingTop: "_ca0q1ejb",
    filtersDivider: "_nd5l1k2t _189ee4h9 _1h6d1l7x _1mouu2gc _1apgnqa1 _1wpz1fhb"
};
const $be490c0458782317$export$694105dda8ac2ac1 = ({ input: input, filters: filters, feedback: feedback })=>{
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)(); // `isFiltersExpanded` reflects the user-controlled / scroll-derived expansion
    // state of the "More filters" section. It starts expanded so the user lands
    // on a fully-revealed filter row, then auto-collapses when the page is
    // scrolled down and re-expands when the page is scrolled back to the top
    // (unless the user has any filter selected, in which case it stays expanded
    // regardless of scroll position).
    const [isFiltersExpanded, setIsFiltersExpanded] = (0, $42omo.useState)(true);
    const [{ products: products }] = (0, $j4ply.useBootstrap)();
    const [{ selectedFilterCount: selectedFilterCount }] = (0, $djVCD.useSelectedFilterCount)();
    const hasSelectedFilters = selectedFilterCount > 0;
    const isSingleApp = products.length <= 1; // Track the content container width. The container is always in the DOM
    // regardless of layout mode, so we get reliable width updates even when
    // the filters element is unmounted (2-row collapsed). Drives the
    // combined-row vs 2-row layout decision below.
    const { width: containerWidth, setNode: containerRefCallback, nodeRef: containerRef } = (0, $690d125b2472b865$export$1217913212f99c7)(); // Refs to the two rows whose `offsetTop` anchors the toggle cluster's
    // vertical position. State (not refs) so the `useToggleClusterPosition`
    // layout effect can re-run when they mount/unmount. The filters row's
    // element is also mirrored into a ref so the always-mounted scroll
    // handler in `useScrollState` can read its current `offsetHeight`
    // without re-binding every time the row's identity changes.
    const [appFilterBarRowEl, setAppFilterBarRowEl] = (0, $42omo.useState)(null);
    const [filtersRowEl, _setFiltersRowEl] = (0, $42omo.useState)(null);
    const filtersRowRef = (0, $42omo.useRef)(null);
    const setFiltersRowEl = (0, $42omo.useCallback)((node)=>{
        filtersRowRef.current = node;
        _setFiltersRowEl(node);
    }, []); // Resolve the page's actual scroll source and track:
    //  - isScrolled                    → drives the bottom-border keyline.
    //  - hasInsufficientScrollOverflow → guards against the auto-collapse
    //                                    feedback loop on landing /
    //                                    no-results / very short pages.
    const { isScrolled: isScrolled, hasInsufficientScrollOverflow: hasInsufficientScrollOverflow } = (0, $690d125b2472b865$export$98084ad349e2edae)({
        containerRef: containerRef,
        filtersRowRef: filtersRowRef
    }); // Drive `isFiltersExpanded` from the scroll signals (with the "filters
    // selected → always expanded" override). Manual button toggles bypass
    // this and call `setIsFiltersExpanded` directly.
    (0, $690d125b2472b865$export$367e70606473630e)({
        isScrolled: isScrolled,
        hasInsufficientScrollOverflow: hasInsufficientScrollOverflow,
        hasSelectedFilters: hasSelectedFilters,
        setIsFiltersExpanded: setIsFiltersExpanded
    }); // Compute the absolutely-positioned toggle cluster's `top` between its
    // top-row (collapsed) and bottom-row (expanded) anchors, plus measure
    // its width (drives the row spacers) and report when both are first
    // committed (drives the initial-paint visibility/transition guards).
    const { toggleClusterTop: toggleClusterTop, toggleClusterWidth: toggleClusterWidth, hasMeasuredInitialPosition: hasMeasuredInitialPosition, areTransitionsEnabled: areTransitionsEnabled, setToggleClusterEl: setToggleClusterEl } = (0, $690d125b2472b865$export$c25a9b8edd9dd4fb)({
        appFilterBarRowEl: appFilterBarRowEl,
        filtersRowEl: filtersRowEl,
        isFiltersExpanded: isFiltersExpanded,
        containerWidth: containerWidth
    }); // Estimate the app filter bar's natural width based on the number of
    // connected products. We can't reliably measure the bar's intrinsic width
    // because in the 2-row grid layout it stretches to fill 1fr, and
    // scrollWidth reports the stretched size. Using a per-pill estimate avoids
    // this measurement problem while adapting to the number of connected apps.
    const estimatedAppBarWidth = products.length * $be490c0458782317$var$ESTIMATED_APP_PILL_WIDTH + $be490c0458782317$var$APP_FILTER_BAR_FIXED_OVERHEAD; // Determine whether there's enough remaining space in the container for
    // the filters section alongside the app filter bar.
    // When containerWidth is 0 (not yet measured), default to combined row
    // so the layout is immediately correct on wide viewports.
    const remainingWidth = containerWidth - estimatedAppBarWidth;
    const hasSufficientWidth = containerWidth === 0 || remainingWidth >= $be490c0458782317$var$MIN_FILTERS_SECTION_WIDTH;
    const isCombinedRow = !isSingleApp && hasSufficientWidth;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($be490c0458782317$var$styles.base, isScrolled && !hasInsufficientScrollOverflow && $be490c0458782317$var$styles.keyline),
                testId: "search-page-header",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $be490c0458782317$var$styles.contentContainer,
                    ref: containerRefCallback,
                    children: isSingleApp ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                        xcss: $be490c0458782317$var$styles.gridSingleApp,
                        columnGap: "space.200",
                        rowGap: isNav4Enabled ? 'space.0' : 'space.200',
                        children: [
                            !isNav4Enabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $be490c0458782317$var$styles.inputGridArea,
                                children: input
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $be490c0458782317$var$styles.filtersGridArea,
                                children: filters
                            }),
                            feedback && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $be490c0458782317$var$styles.feedbackGridArea,
                                children: feedback
                            })
                        ]
                    }) : isCombinedRow ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                        xcss: $be490c0458782317$var$styles.gridCombinedRow,
                        rowGap: isNav4Enabled ? 'space.0' : 'space.200',
                        testId: "lite-header-combined-row",
                        children: [
                            !isNav4Enabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $be490c0458782317$var$styles.inputGridArea,
                                children: input
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $b80c19d5cb4b6cce$export$3e468973358aadd3), {
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                    xcss: $be490c0458782317$var$styles.appFilterBarGridArea,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $be490c0458782317$var$styles.appFilterBarScroll,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b80c19d5cb4b6cce$export$d6e71f9cd5617f42), {})
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $b80c19d5cb4b6cce$export$6939095785c277c7), {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $be490c0458782317$var$styles.filtersDivider
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $be490c0458782317$var$styles.filtersGridArea,
                                children: filters
                            }),
                            feedback && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $be490c0458782317$var$styles.feedbackGridArea,
                                children: feedback
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                        xcss: $be490c0458782317$var$styles.gridTwoRow,
                        rowGap: "space.0",
                        columnGap: "space.0",
                        children: [
                            !isNav4Enabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $be490c0458782317$var$styles.inputGridArea,
                                children: input
                            }),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $b80c19d5cb4b6cce$export$3e468973358aadd3), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                        xcss: $be490c0458782317$var$styles.appFilterBarGridArea,
                                        ref: setAppFilterBarRowEl,
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $be490c0458782317$var$styles.appFilterBarScroll,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b80c19d5cb4b6cce$export$d6e71f9cd5617f42), {})
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $b80c19d5cb4b6cce$export$6939095785c277c7), {}),
                                            !isFiltersExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: (0, $1Whri.cx)($be490c0458782317$var$styles.toggleClusterSpacer, !areTransitionsEnabled && $be490c0458782317$var$styles.toggleClusterSpacerNoTransition),
                                                style: {
                                                    width: `${toggleClusterWidth}px`
                                                },
                                                "aria-hidden": true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: (0, $1Whri.cx)($be490c0458782317$var$styles.filtersGridArea, $be490c0458782317$var$styles.filtersAnimatedWrapper, isFiltersExpanded && $be490c0458782317$var$styles.filtersAnimatedWrapperExpanded),
                                        ref: setFiltersRowEl,
                                        ...!isFiltersExpanded && {
                                            inert: '',
                                            'aria-hidden': true
                                        },
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $be490c0458782317$var$styles.filtersAnimatedInner,
                                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                                xcss: $be490c0458782317$var$styles.filtersRowContent,
                                                children: [
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                        xcss: $be490c0458782317$var$styles.filtersRowFiltersArea,
                                                        children: filters
                                                    }),
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                        xcss: (0, $1Whri.cx)($be490c0458782317$var$styles.filtersRowToggleClusterSpacer, !areTransitionsEnabled && $be490c0458782317$var$styles.filtersRowToggleClusterSpacerNoTransition),
                                                        style: {
                                                            width: isFiltersExpanded ? `${toggleClusterWidth}px` : '0px'
                                                        },
                                                        "aria-hidden": true
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                        xcss: (0, $1Whri.cx)($be490c0458782317$var$styles.toggleCluster, !areTransitionsEnabled && $be490c0458782317$var$styles.toggleClusterNoTransition, !hasMeasuredInitialPosition && $be490c0458782317$var$styles.toggleClusterHidden),
                                        ref: setToggleClusterEl,
                                        style: {
                                            top: `${toggleClusterTop}px`
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                                appearance: "default",
                                                iconBefore: isFiltersExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))),
                                                onClick: ()=>setIsFiltersExpanded(!isFiltersExpanded),
                                                children: isFiltersExpanded ? formatMessage({
                                                    id: "search_page.header.less_filters",
                                                    defaultMessage: "Less filters"
                                                }) : formatMessage({
                                                    id: "search_page.header.more_filters",
                                                    defaultMessage: "More filters"
                                                })
                                            }),
                                            feedback
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            isNav4Enabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: input
            })
        ]
    });
};





parcelRequire("42omo");




















var $7yOcR = parcelRequire("7yOcR");


var $8UOsA = parcelRequire("8UOsA");





var $7Yuqm = parcelRequire("7Yuqm");

const $cc710e5633c22833$var$messages = (0, $aXWIB.defineMessages)({
    giveFeedbackText: {
        id: "give_feedback_text",
        defaultMessage: "Give feedback"
    }
});
/**
 * Renders a give feedback button and controls whether to display the feedback form.
 */ const $cc710e5633c22833$var$Feedback = ({ cloudId: cloudId, primaryProduct: primaryProduct, experimentConfig: experimentConfig, selectedProducts: selectedProducts, user: user, applicationMode: applicationMode, source: source, appearance: appearance, buttonRef: buttonRef, requestId: requestId, traceId: traceId, isCQL: isCQL, buttonLabel: buttonLabel, onFeedbackClick: onFeedbackClick, onFeedbackSubmit: onFeedbackSubmit, onFeedbackCancel: onFeedbackCancel })=>{
    const intl = (0, $aXWIB.useIntl)();
    const resolvedButtonLabel = buttonLabel ?? intl.formatMessage($cc710e5633c22833$var$messages.giveFeedbackText);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [traceIdForFeedbackCollector, setTraceIdForFeedbackCollector] = (0, $42omo.useState)('');
    const [requestIdForFeedbackCollector, setRequestIdForFeedbackCollector] = (0, $42omo.useState)('');
    (0, $42omo.useEffect)(()=>{
        if (traceId) setTraceIdForFeedbackCollector(traceId);
    }, [
        traceId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (requestId) setRequestIdForFeedbackCollector(requestId);
    }, [
        requestId
    ]);
    const updateTraceAndRequestIdFromRelay = (0, $42omo.useCallback)(()=>{
        const { traceId: traceIdForRelay } = (0, $1ymk3.getExtensionData)(isCQL || false);
        if (traceIdForRelay && traceIdForRelay !== traceIdForFeedbackCollector) {
            setTraceIdForFeedbackCollector(traceIdForRelay);
            // using traceId for now, for backwards compatibility, this will be updated with integration test later
            setRequestIdForFeedbackCollector(traceIdForRelay);
        }
    }, [
        traceIdForFeedbackCollector,
        isCQL
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            appearance === 'subtle' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                appearance: "subtle",
                onClick: (e)=>{
                    updateTraceAndRequestIdFromRelay();
                    e.preventDefault();
                    setIsOpen(true);
                    onFeedbackClick?.();
                },
                iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))), {
                        color: "currentColor",
                        label: resolvedButtonLabel
                    }),
                ref: buttonRef,
                children: resolvedButtonLabel
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $8UOsA.FeedbackButton), {
                onClick: (e)=>{
                    updateTraceAndRequestIdFromRelay();
                    e.preventDefault();
                    setIsOpen(true);
                    onFeedbackClick?.();
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7Yuqm.default), {
                cloudId: cloudId || '',
                experimentConfig: experimentConfig,
                isOpen: isOpen,
                primaryProduct: primaryProduct || '',
                product: selectedProducts.length ? selectedProducts.join(', ') : 'no product filter',
                source: source,
                setIsOpen: setIsOpen,
                onSubmit: ()=>{
                    onFeedbackSubmit?.();
                    setIsOpen(false);
                },
                onCancel: ()=>{
                    onFeedbackCancel?.();
                    setIsOpen(false);
                },
                userId: user.id || '',
                userName: user.name || '',
                mode: applicationMode,
                requestId: requestIdForFeedbackCollector,
                traceId: traceIdForFeedbackCollector
            })
        ]
    });
};
var $cc710e5633c22833$export$2e2bcd8739ae039 = $cc710e5633c22833$var$Feedback;






var $74x1m = parcelRequire("74x1m");

const $581d88978d17bd2f$var$messages = (0, $aXWIB.defineMessages)({
    feedbackButtonLabel: {
        id: "search_page.lite_header.feedback_button_label",
        defaultMessage: "Feedback"
    }
});
const $581d88978d17bd2f$export$e6b7dda6e06d753e = ()=>{
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const [user] = (0, $j4ply.useUser)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const intl = (0, $aXWIB.useIntl)();
    const { selectedProducts: selectedProducts } = (0, $74x1m.getSearchConfig)({
        cloudId: cloudId || '',
        queryParams: queryParams,
        thirdPartyConfigs: thirdPartyConfigs
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cc710e5633c22833$export$2e2bcd8739ae039), {
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        experimentConfig: experimentConfig,
        selectedProducts: selectedProducts,
        user: user,
        applicationMode: applicationMode,
        source: "search-page-lite-header",
        appearance: "subtle",
        buttonLabel: intl.formatMessage($581d88978d17bd2f$var$messages.feedbackButtonLabel)
    });
};





parcelRequire("42omo");





var $eXmBZ = parcelRequire("eXmBZ");









/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $338fbb43846ae3b0$var$styles = {
    grid: "_2rko12b0 _1lmc1b06 _yv0e5lfm _1nmz1hna _bfhk19ip _19bvutpp _u5f3utpp _ca0qutpp _n3tdutpp"
};
const $338fbb43846ae3b0$export$c9c949013c9343de = ({ testId: testId, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
        alignItems: "center",
        columnGap: "space.150",
        testId: testId,
        xcss: $338fbb43846ae3b0$var$styles.grid,
        children: children
    });
};





const $3f34d0c7590b02ef$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    dismissMessage: {
        id: "assets-app-message-banner-dismiss-message",
        defaultMessage: "Dismiss"
    },
    assetsAsAnAppBannerText: {
        id: "assets-app-message-banner-available-soon",
        defaultMessage: "<bold>Assets will be available here soon</bold>. For now, try <assetsSearchLink>Assets search</assetsSearchLink>."
    }
});


const $d7417ff36c8b22bc$export$8d42f71dae8efa55 = ({ testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $338fbb43846ae3b0$export$c9c949013c9343de), {
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                label: "information",
                color: "var(--ds-icon-brand)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                space: "space.050",
                alignBlock: "center",
                shouldWrap: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "medium",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $3f34d0c7590b02ef$export$defe85febe8b728c).assetsAsAnAppBannerText,
                        values: {
                            assetsSearchLink: (children)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                    href: "/jira/assets?showSearch=true",
                                    children: children
                                }),
                            bold: (children)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "bold",
                                    children: children
                                })
                        }
                    })
                })
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
































const $e6f52813e1dbd344$export$975b2b7393cd0143 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: (0, $6yNqK.EVENT_SOURCE),
        eventType: 'ui',
        action: 'dismissed',
        actionSubject: 'inlineMessageBanner',
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });











const $dd6b7d3483332917$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    bannerText: {
        id: "new-product-message-banner-text",
        defaultMessage: "{product} was only recently added and we're still tweaking the results."
    },
    dismissMessage: {
        id: "new-product-message-banner-dismiss-message-button",
        defaultMessage: "Dismiss"
    }
});


const $c00f6725a09cf8c9$var$styles = {
    actions: "_i0dl1ns9",
    action: "_19bvutpp _u5f3utpp"
};
const $c00f6725a09cf8c9$var$newProducts = {
    [(0, $1yEFx.ProductKeys).Bitbucket]: 'Bitbucket',
    [(0, $1yEFx.ProductKeys).JiraProductDiscovery]: 'Jira Product Discovery',
    [(0, $1yEFx.ProductKeys).JiraServiceManagement]: 'Jira Service Management'
};
const $c00f6725a09cf8c9$export$37ce7744bd1ee394 = ({ searchQuery: searchQuery, selectedProduct: selectedProduct, selectedProducts: selectedProducts, primaryProduct: primaryProduct, cloudId: cloudId, experimentConfig: experimentConfig, user: user, applicationMode: applicationMode, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [trackSearchQuery, setTrackSearchQuery] = (0, $42omo.useState)(searchQuery);
    const [showProductBanner, setShowProductBanner] = (0, $42omo.useState)({
        [(0, $1yEFx.ProductKeys).Bitbucket]: true,
        [(0, $1yEFx.ProductKeys).JiraProductDiscovery]: true,
        [(0, $1yEFx.ProductKeys).JiraServiceManagement]: true
    });
    (0, $42omo.useEffect)(()=>{
        // reset to default state
        if (searchQuery !== trackSearchQuery) {
            setShowProductBanner({
                [(0, $1yEFx.ProductKeys).Bitbucket]: true,
                [(0, $1yEFx.ProductKeys).JiraProductDiscovery]: true,
                [(0, $1yEFx.ProductKeys).JiraServiceManagement]: true
            });
            setTrackSearchQuery(searchQuery);
        }
    }, [
        searchQuery,
        trackSearchQuery
    ]);
    const onDismiss = ()=>{
        fireAnalyticsEvent((0, $e6f52813e1dbd344$export$975b2b7393cd0143)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        setShowProductBanner((prev)=>({
                ...prev,
                [selectedProduct]: false
            }));
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: selectedProduct in showProductBanner && showProductBanner[selectedProduct] && /*#__PURE__*/ (0, $l998X.jsxs)((0, $338fbb43846ae3b0$export$c9c949013c9343de), {
            testId: testId,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                    label: "information",
                    color: "var(--ds-icon-brand)"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    space: "space.050",
                    alignBlock: "center",
                    shouldWrap: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "medium",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $dd6b7d3483332917$export$defe85febe8b728c).bannerText,
                            values: {
                                product: /*#__PURE__*/ (0, $l998X.jsx)("b", {
                                    children: $c00f6725a09cf8c9$var$newProducts[selectedProduct]
                                })
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    testId: testId && `${testId}--actions`,
                    space: "space.150",
                    rowSpace: "space.0",
                    alignBlock: "center",
                    xcss: $c00f6725a09cf8c9$var$styles.actions,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $c00f6725a09cf8c9$var$styles.action,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                                section: "SearchPageNewProductMessageBanner",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cc710e5633c22833$export$2e2bcd8739ae039), {
                                    source: "search-page-new-product-banner",
                                    cloudId: cloudId || '',
                                    experimentConfig: experimentConfig,
                                    primaryProduct: primaryProduct,
                                    user: user,
                                    applicationMode: applicationMode,
                                    selectedProducts: selectedProducts,
                                    isCQL: commonAttributes.isCQL
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                            onClick: onDismiss,
                            label: formatMessage((0, $dd6b7d3483332917$export$defe85febe8b728c).dismissMessage),
                            appearance: 'subtle',
                            spacing: 'compact'
                        })
                    ]
                })
            ]
        })
    });
};


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ // Note: The above eslint-disable is needed because this module imports from parent directories.
// This is acceptable here as query-plan is tightly coupled to search-page-relay.




var $hL7bb = parcelRequire("hL7bb");





var $4cq9O = parcelRequire("4cq9O");








var $PVo4u = parcelRequire("PVo4u");





var $8RFAN = parcelRequire("8RFAN");








var $2XqLN = parcelRequire("2XqLN");





var $hw4j5 = parcelRequire("hw4j5");

const $3c85391cc375b41f$var$cache = (0, $hw4j5.inMemoryCache)();
const $3c85391cc375b41f$export$3a4b7d0cd0a11cfc = ({ query: query, product: product })=>{
    const relativeLeapQueryUrl = `/gateway/api/assist/api/ai/v2/ai-feature/leapquery`;
    const body = {
        ai_feature_input: {
            query: query
        }
    };
    return $3c85391cc375b41f$var$cache.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)({
        query: query
    }), ()=>fetch(relativeLeapQueryUrl, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                'X-Product': product,
                'X-Experience-Id': 'query-suggestion'
            }
        }).then((response)=>{
            if (response.ok) return response.json();
        }).then((data)=>{
            // return empty skeleton response if response is not ok
            // UI will treat this response as no results
            return data?.ai_feature_output || {
                title: 0,
                candidates: []
            };
        }).catch(()=>{
            // return empty skeleton response if response is not ok
            // UI will treat this response as no results
            return {
                title: 0,
                candidates: []
            };
        }));
};


function $63bf09322ac8b111$export$ccfe5b970c8b72a3(promise) {
    let isResolved = false;
    let isRejected = false;
    let cachedValue;
    // Create a new promise that tracks the resolution or rejection
    const trackedPromise = promise.then((value)=>{
        isResolved = true;
        cachedValue = value;
        return value;
    }, (reason)=>{
        isRejected = true;
        throw reason;
    });
    // Add methods to check the state
    trackedPromise.isResolved = ()=>isResolved;
    trackedPromise.isRejected = ()=>isRejected;
    trackedPromise.isSettled = ()=>isResolved || isRejected;
    // Add a method to get the cached value
    trackedPromise.getValue = ()=>cachedValue;
    return trackedPromise;
}
function $63bf09322ac8b111$export$aa6b1e6f46173ae2(fn) {
    return (...args)=>{
        const originalPromise = fn(...args);
        return $63bf09322ac8b111$export$ccfe5b970c8b72a3(originalPromise);
    };
}


const $2b038019829bbd3e$export$1aafcd2cfb41dc92 = (0, $2XqLN.default)((0, $63bf09322ac8b111$export$aa6b1e6f46173ae2)((0, $3c85391cc375b41f$export$3a4b7d0cd0a11cfc)), (0, (/*@__PURE__*/$parcel$interopDefault($hL7bb))));











const $eb4a02b80e2ab764$export$3afecd2a83596299 = (appMode, isAdminHubAIEnabled, isRovoLLMEnabled)=>{
    // TODO: QS-6660 clean up the Unified Mode condition once it's decommissioned
    if (appMode === (0, $9vOy1.ApplicationModes).Unified) return isAdminHubAIEnabled;
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) return isRovoLLMEnabled;
    return true;
};


const $f97ce1f1c5afcd2b$export$383dd888028aa640 = (appMode, isAdminHubAIEnabled, isRovoLLMEnabled)=>appMode === (0, $9vOy1.ApplicationModes).Rovo && (0, $eb4a02b80e2ab764$export$3afecd2a83596299)(appMode, isAdminHubAIEnabled, isRovoLLMEnabled);














var $7yVTH = parcelRequire("7yVTH");

const $40b6880ea7365c64$export$efc22d0a8971b841 = 60;
const $40b6880ea7365c64$export$96e202f323d22c8c = 24;
const $40b6880ea7365c64$export$2db639ca606fdc06 = (containerHeight)=>{
    // This formula comes from solving for x, where x is the number of results to show
    // containerHeight = x * MINIMUM_RESULT_HEIGHT_PX + (x - 1) * RESULT_GAP_PX
    // containerHeight = x * MINIMUM_RESULT_HEIGHT_PX + x * RESULT_GAP_PX - RESULT_GAP_PX
    // containerHeight + RESULT_GAP_PX = x * MINIMUM_RESULT_HEIGHT_PX + x * RESULT_GAP_PX
    // containerHeight + RESULT_GAP_PX = x * (MINIMUM_RESULT_HEIGHT_PX + RESULT_GAP_PX)
    // x = (containerHeight + RESULT_GAP_PX) / (MINIMUM_RESULT_HEIGHT_PX + RESULT_GAP_PX)
    return Math.ceil((containerHeight + $40b6880ea7365c64$export$96e202f323d22c8c) / ($40b6880ea7365c64$export$efc22d0a8971b841 + $40b6880ea7365c64$export$96e202f323d22c8c));
};






var $chwej = parcelRequire("chwej");

function $d0b07f1b6ca90690$export$1bb1cb0a9da0a635({ primaryProduct: primaryProduct, productDataRegions: productDataRegions, cloudId: cloudId }) {
    const edgeRegionHint = primaryProduct && productDataRegions ? (0, $chwej.getEdgeRegionHint)(primaryProduct, productDataRegions) : undefined;
    return {
        networkCacheConfig: {
            metadata: {
                headers: {
                    [(0, $chwej.EDGE_REGION_HINT_HEADER)]: edgeRegionHint,
                    ...cloudId && (0, $dh538.fg)('rovo_fps_ms_teams_1p_picture_mapping') ? {
                        'X-Query-Context': `ari:cloud:platform::site/${cloudId}`
                    } : {}
                }
            }
        }
    };
}





const $8a16a41870dcc4f0$export$68339b3094913cd4 = (availableProducts, selectedProduct, searchQuery = '')=>{
    const isSearchReady = availableProducts && availableProducts.length > 0;
    const isEmptyQuerySearchable = selectedProduct ? (0, $b4tvS.productsSupportingEmptyQuery).includes(selectedProduct) : false;
    const isEmptyQuery = !searchQuery || searchQuery.trim() === '';
    const isSearchable = isEmptyQuery && isEmptyQuerySearchable || !isEmptyQuery;
    return isSearchReady && isSearchable;
};


function $411ad342376b971d$export$87ba7e4f15231598(args) {
    // If bootstrap is not ready, we can only show config-loading skeletons.
    if (!args.bootstrapReady) return 'BOOTSTRAP_LOADING';
    // CQL is only used when there's no non-CQL query (searchQuery or selected filters takes precedence if either are present).
    const hasSearchQuery = args.searchQuery.trim() !== '';
    if (args.cql && !hasSearchQuery && !args.hasAnyFilterSelected) return 'CQL_RESULTS';
    // If the current search is valid, use results
    if ((0, $8a16a41870dcc4f0$export$68339b3094913cd4)(args.availableProducts, args.selectedProduct, args.searchQuery)) return 'RESULTS';
    // Fallback for invalid searches.
    return 'LANDING';
}





const $f2570c53ec82c965$export$578b3958c99ef1eb = ({ match: match, mismatchCount: mismatchCount, search: search, rightPanel: rightPanel, experimentLayers: experimentLayers })=>({
        eventType: 'track',
        action: 'preloadQueryVarsDiff',
        actionSubject: 'searchPage',
        attributes: {
            additionalAttributes: {
                experienceName: 'search-page',
                match: match,
                mismatchCount: mismatchCount,
                search: search,
                rightPanel: rightPanel,
                experimentLayers: // Temporary diagnostics field. Clean this up with FG `search_async_ssr`; for now keep
                // full SSR and SPA `experimentLayers` dumps here regardless of mismatch for diagnostics.
                experimentLayers
            }
        }
    });






var $9yHRR = parcelRequire("9yHRR");

const $be44947282c9e056$var$ROOT_PATH = '';
const $be44947282c9e056$var$MISSING_VALUE = '__missing__';
const $be44947282c9e056$var$UNDEFINED_VALUE = '__undefined__';
const $be44947282c9e056$var$ALLOWED_DIFF_KEYS = new Set([
    'sessionId',
    'expectResult'
]);
const $be44947282c9e056$var$ALLOWED_VALUE_FIELD_PREFIXES = [
    'experimentLayers',
    'fanoutExperimentCohort'
];
function $be44947282c9e056$var$isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function $be44947282c9e056$var$getObjectKeys(value) {
    return Object.keys(value).sort();
}
function $be44947282c9e056$var$buildPath(basePath, key) {
    return basePath ? `${basePath}.${key}` : key;
}
function $be44947282c9e056$var$buildArrayPath(basePath, index) {
    return `${basePath}[${index}]`;
}
function $be44947282c9e056$var$hasOwnKey(value, key) {
    return Object.prototype.hasOwnProperty.call(value, key);
}
function $be44947282c9e056$var$isMissingOrUndefinedMismatchEqual(left, right, key) {
    const leftHasKey = $be44947282c9e056$var$hasOwnKey(left, key);
    const rightHasKey = $be44947282c9e056$var$hasOwnKey(right, key);
    if (leftHasKey === rightHasKey) return false;
    return leftHasKey ? left[key] === undefined : right[key] === undefined;
}
function $be44947282c9e056$var$shouldIncludeValues(fieldName) {
    return $be44947282c9e056$var$ALLOWED_VALUE_FIELD_PREFIXES.some((prefix)=>fieldName.startsWith(prefix));
}
function $be44947282c9e056$var$getSideValue(value, hasValue) {
    if (!hasValue) return $be44947282c9e056$var$MISSING_VALUE;
    return value === undefined ? $be44947282c9e056$var$UNDEFINED_VALUE : value;
}
function $be44947282c9e056$var$getValueType(value) {
    if (value === null) return 'null';
    if (Array.isArray(value)) return 'array';
    if (value === undefined) return 'undefined';
    if (typeof value === 'boolean') return 'boolean';
    if (typeof value === 'number') return 'number';
    if (typeof value === 'string') return 'string';
    return 'object';
}
function $be44947282c9e056$var$getSideMetadata(value, hasValue) {
    if (!hasValue) return {
        state: 'missing'
    };
    if (value === undefined) return {
        state: 'undefined',
        type: 'undefined'
    };
    if (value === null) return {
        state: 'null',
        type: 'null'
    };
    if (Array.isArray(value)) return {
        state: 'present',
        type: 'array',
        arrayLength: value.length
    };
    if ($be44947282c9e056$var$isRecord(value)) return {
        state: 'present',
        type: 'object',
        objectKeyCount: Object.keys(value).length
    };
    return {
        state: 'present',
        type: $be44947282c9e056$var$getValueType(value)
    };
}
function $be44947282c9e056$var$createMismatchField(fieldName, ssr, spa, ssrHasValue = true, spaHasValue = true) {
    if (!$be44947282c9e056$var$shouldIncludeValues(fieldName)) return {
        fieldName: fieldName,
        ssr: $be44947282c9e056$var$getSideMetadata(ssr, ssrHasValue),
        spa: $be44947282c9e056$var$getSideMetadata(spa, spaHasValue)
    };
    return {
        fieldName: fieldName,
        ssr: $be44947282c9e056$var$getSideValue(ssr, ssrHasValue),
        spa: $be44947282c9e056$var$getSideValue(spa, spaHasValue)
    };
}
function $be44947282c9e056$export$c1629f1c34507dc1(left, right, path = $be44947282c9e056$var$ROOT_PATH) {
    if (Object.is(left, right)) return [];
    if (Array.isArray(left) || Array.isArray(right)) {
        if (!Array.isArray(left) || !Array.isArray(right)) return [
            $be44947282c9e056$var$createMismatchField(path, left, right)
        ];
        const mismatchFields = [];
        const maxLength = Math.max(left.length, right.length);
        if (left.length !== right.length) mismatchFields.push($be44947282c9e056$var$createMismatchField(`${path}.length`, left.length, right.length));
        for(let index = 0; index < maxLength; index++){
            const arrayPath = $be44947282c9e056$var$buildArrayPath(path, index);
            const leftHasIndex = index in left;
            const rightHasIndex = index in right;
            if (!leftHasIndex || !rightHasIndex) {
                mismatchFields.push($be44947282c9e056$var$createMismatchField(arrayPath, left[index], right[index], leftHasIndex, rightHasIndex));
                continue;
            }
            mismatchFields.push(...$be44947282c9e056$export$c1629f1c34507dc1(left[index], right[index], arrayPath));
        }
        return mismatchFields;
    }
    if ($be44947282c9e056$var$isRecord(left) || $be44947282c9e056$var$isRecord(right)) {
        if (!$be44947282c9e056$var$isRecord(left) || !$be44947282c9e056$var$isRecord(right)) return [
            $be44947282c9e056$var$createMismatchField(path, left, right)
        ];
        const mismatchFields = [];
        const allKeys = $be44947282c9e056$var$getObjectKeys({
            ...left,
            ...right
        }).filter((key)=>!$be44947282c9e056$var$ALLOWED_DIFF_KEYS.has(key));
        for (const key of allKeys){
            const fieldPath = $be44947282c9e056$var$buildPath(path, key);
            const leftHasKey = $be44947282c9e056$var$hasOwnKey(left, key);
            const rightHasKey = $be44947282c9e056$var$hasOwnKey(right, key);
            if (!leftHasKey || !rightHasKey) {
                if (!$be44947282c9e056$var$isMissingOrUndefinedMismatchEqual(left, right, key)) mismatchFields.push($be44947282c9e056$var$createMismatchField(fieldPath, left[key], right[key], leftHasKey, rightHasKey));
                continue;
            }
            mismatchFields.push(...$be44947282c9e056$export$c1629f1c34507dc1(left[key], right[key], fieldPath));
        }
        return mismatchFields;
    }
    return [
        $be44947282c9e056$var$createMismatchField(path, left, right)
    ];
}
function $be44947282c9e056$export$fa12697f7de01c6b(ssrSearchQueryVariables, spaSearchQueryVariables) {
    const mismatchFields = $be44947282c9e056$export$c1629f1c34507dc1(ssrSearchQueryVariables, spaSearchQueryVariables);
    return {
        match: mismatchFields.length === 0,
        mismatchCount: mismatchFields.length,
        mismatchFields: mismatchFields
    };
}
function $be44947282c9e056$export$74006b1820c996bf(source, ssrSearchResultsQueryVariables, spaSearchResultsQueryVariables, ssrRightPanelQueryVariables, spaRightPanelQueryVariables) {
    const search = $be44947282c9e056$export$fa12697f7de01c6b(ssrSearchResultsQueryVariables, spaSearchResultsQueryVariables);
    const rightPanel = $be44947282c9e056$export$fa12697f7de01c6b(ssrRightPanelQueryVariables, spaRightPanelQueryVariables);
    const mismatchCount = search.mismatchCount + rightPanel.mismatchCount;
    return {
        source: source ?? '',
        match: mismatchCount === 0,
        mismatchCount: mismatchCount,
        search: search,
        rightPanel: rightPanel,
        experimentLayers: {
            ssr: {
                searchResultsQueryVariables: $be44947282c9e056$var$isRecord(ssrSearchResultsQueryVariables) ? ssrSearchResultsQueryVariables.experimentLayers : undefined,
                rightPanelQueryVariables: $be44947282c9e056$var$isRecord(ssrRightPanelQueryVariables) ? ssrRightPanelQueryVariables.experimentLayers : undefined
            },
            spa: {
                searchResultsQueryVariables: $be44947282c9e056$var$isRecord(spaSearchResultsQueryVariables) ? spaSearchResultsQueryVariables.experimentLayers : undefined,
                rightPanelQueryVariables: $be44947282c9e056$var$isRecord(spaRightPanelQueryVariables) ? spaRightPanelQueryVariables.experimentLayers : undefined
            }
        }
    };
}
function $be44947282c9e056$export$d18fc794cd63a6c4(preloadDataProvider) {
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const hasReportedRef = (0, $42omo.useRef)(false);
    const firePreloadQueryVarsDiffAnalytics = (0, $42omo.useCallback)((diff)=>{
        const event = (0, $f2570c53ec82c965$export$578b3958c99ef1eb)(diff);
        fireAnalyticsEvent({
            ...event,
            attributes: {
                commonAttributes: commonAttributes,
                additionalAttributes: event.attributes.additionalAttributes
            }
        });
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]);
    return (0, $42omo.useCallback)(({ cloudId: cloudId, searchResultsQueryVariables: searchResultsQueryVariables, rightPanelQueryVariables: rightPanelQueryVariables })=>{
        if (hasReportedRef.current) return;
        const preloadedQueryVars = (0, $9yHRR.getPreloadedQueryVars)({
            cloudId: cloudId,
            preloadDataProvider: preloadDataProvider
        });
        if (!preloadedQueryVars) return;
        hasReportedRef.current = true;
        const diff = $be44947282c9e056$export$74006b1820c996bf(preloadedQueryVars.source, preloadedQueryVars.searchResultsQueryVariables, searchResultsQueryVariables, preloadedQueryVars.rightPanelQueryVariables, rightPanelQueryVariables);
        firePreloadQueryVarsDiffAnalytics(diff);
    }, [
        firePreloadQueryVarsDiffAnalytics,
        preloadDataProvider
    ]);
}



var $lRrav = parcelRequire("lRrav");














var $6jKOp = parcelRequire("6jKOp");


var $31eSD = parcelRequire("31eSD");


var $bQSQw = parcelRequire("bQSQw");

function $6b38ac5f99e2f44f$export$e56e03f775f4eedc({ searchSessionId: searchSessionId, fireAnalyticsEvent: fireAnalyticsEvent, fullPageSearchNetworkRefs: fullPageSearchNetworkRefs }) {
    const isEnabled = ()=>Boolean(searchSessionId) && (0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-network');
    const getTimeTaken = ()=>{
        const startAt = fullPageSearchNetworkRefs.current.startAt;
        return startAt ? Math.max(0, performance.now() - startAt) : undefined;
    };
    return {
        onNetworkSuccess: (resultCount, traceInfo)=>{
            if (!isEnabled()) return;
            const state = fullPageSearchNetworkRefs.current.state;
            if (state.state !== 'started' || !state.taskId) return;
            // Update state BEFORE firing event (prevents duplicates under re-entrancy)
            fullPageSearchNetworkRefs.current.state = {
                ...state,
                state: 'completed'
            };
            const tracingHeaders = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.normaliseTraceInfo)(traceInfo) : {};
            fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
                searchSessionId: searchSessionId ?? '',
                taskId: state.taskId,
                task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK,
                moreContext: {
                    uxTaskId: state.uxTaskId,
                    resultCount: resultCount,
                    timeTaken: getTimeTaken(),
                    cacheAvailable: state.cacheAvailable,
                    cacheExpected: state.cacheExpected,
                    ...tracingHeaders
                }
            }));
        },
        onNetworkFail: (errorName, errorMessage, traceInfo)=>{
            if (!isEnabled()) return;
            const state = fullPageSearchNetworkRefs.current.state;
            if (state.state !== 'started' || !state.taskId) return;
            // Update state BEFORE firing event (prevents duplicates under re-entrancy)
            fullPageSearchNetworkRefs.current.state = {
                ...state,
                state: 'failed'
            };
            const tracingHeaders = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.normaliseTraceInfo)(traceInfo) : {};
            fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
                searchSessionId: searchSessionId ?? '',
                taskId: state.taskId,
                task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK,
                moreContext: {
                    uxTaskId: state.uxTaskId,
                    errorName: errorName,
                    errorMessage: errorMessage,
                    timeTaken: getTimeTaken(),
                    cacheAvailable: state.cacheAvailable,
                    cacheExpected: state.cacheExpected,
                    ...tracingHeaders
                }
            }));
        },
        onNetworkAbort: (reason)=>{
            if (!isEnabled()) return;
            const state = fullPageSearchNetworkRefs.current.state;
            if (state.state !== 'started' || !state.taskId) return;
            fullPageSearchNetworkRefs.current.state = {
                ...state,
                state: 'aborted'
            };
            fireAnalyticsEvent((0, $bQSQw.onTaskAbort)({
                searchSessionId: searchSessionId ?? '',
                taskId: state.taskId,
                task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK,
                moreContext: {
                    uxTaskId: state.uxTaskId,
                    reason: reason,
                    cacheAvailable: state.cacheAvailable,
                    cacheExpected: state.cacheExpected
                }
            }));
        }
    };
}
function $6b38ac5f99e2f44f$export$d3070defdd0e7637({ searchSessionId: searchSessionId, fireAnalyticsEvent: fireAnalyticsEvent, fullPageSearchAsyncSearchRefs: fullPageSearchAsyncSearchRefs }) {
    const isEnabled = ()=>Boolean(searchSessionId) && (0, $dh538.fg)('search_async_ssr');
    const getTimeTaken = ()=>{
        const startAt = fullPageSearchAsyncSearchRefs.current.startAt;
        return startAt ? Math.max(0, performance.now() - startAt) : undefined;
    };
    return {
        onAsyncSearchSuccess: ()=>{
            if (!isEnabled()) return;
            const state = fullPageSearchAsyncSearchRefs.current.state;
            if (state.state !== 'started' || !state.taskId) return;
            fullPageSearchAsyncSearchRefs.current.state = {
                ...state,
                state: 'completed'
            };
            fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
                searchSessionId: searchSessionId ?? '',
                taskId: state.taskId,
                task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_ASYNC_SEARCH_RESULTS,
                moreContext: {
                    uxTaskId: state.uxTaskId,
                    isCachedResult: true,
                    timeTaken: getTimeTaken()
                }
            }));
        },
        onAsyncSearchFail: ()=>{
            if (!isEnabled()) return;
            const state = fullPageSearchAsyncSearchRefs.current.state;
            if (state.state !== 'started' || !state.taskId) return;
            fullPageSearchAsyncSearchRefs.current.state = {
                ...state,
                state: 'failed'
            };
            fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
                searchSessionId: searchSessionId ?? '',
                taskId: state.taskId,
                task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_ASYNC_SEARCH_RESULTS,
                moreContext: {
                    uxTaskId: state.uxTaskId,
                    isCachedResult: false,
                    timeTaken: getTimeTaken()
                }
            }));
        },
        onAsyncSearchAbort: (reason)=>{
            if (!isEnabled()) return;
            const state = fullPageSearchAsyncSearchRefs.current.state;
            if (state.state !== 'started' || !state.taskId) return;
            fullPageSearchAsyncSearchRefs.current.state = {
                ...state,
                state: 'aborted'
            };
            fireAnalyticsEvent((0, $bQSQw.onTaskAbort)({
                searchSessionId: searchSessionId ?? '',
                taskId: state.taskId,
                task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_ASYNC_SEARCH_RESULTS,
                moreContext: {
                    uxTaskId: state.uxTaskId,
                    reason: reason
                }
            }));
        }
    };
}
function $6b38ac5f99e2f44f$export$1ef754039accea4b({ searchSessionId: searchSessionId, fireAnalyticsEvent: fireAnalyticsEvent, fullPageSearchTaskIdRef: fullPageSearchTaskIdRef, fullPageSearchNetworkRefs: fullPageSearchNetworkRefs, fullPageSearchAsyncSearchRefs: fullPageSearchAsyncSearchRefs, cacheAvailable: cacheAvailable, cacheExpected: cacheExpected, isNetworkMode: isNetworkMode }) {
    const startUxTask = (uxTaskId)=>{
        fullPageSearchTaskIdRef.current = uxTaskId;
        if (searchSessionId) fireAnalyticsEvent((0, $bQSQw.onTaskStart)({
            searchSessionId: searchSessionId,
            taskId: uxTaskId,
            task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_UX,
            moreContext: {
                cacheExpected: cacheExpected
            }
        }));
    };
    const abortSupersededNetworkTaskIfNeeded = ()=>{
        if (!searchSessionId || !isNetworkMode) return;
        $6b38ac5f99e2f44f$export$e56e03f775f4eedc({
            searchSessionId: searchSessionId,
            fireAnalyticsEvent: fireAnalyticsEvent,
            fullPageSearchNetworkRefs: fullPageSearchNetworkRefs
        }).onNetworkAbort('superseded');
    };
    const abortSupersededAsyncSearchTaskIfNeeded = ()=>{
        if (!searchSessionId || !isNetworkMode) return;
        $6b38ac5f99e2f44f$export$d3070defdd0e7637({
            searchSessionId: searchSessionId,
            fireAnalyticsEvent: fireAnalyticsEvent,
            fullPageSearchAsyncSearchRefs: fullPageSearchAsyncSearchRefs
        }).onAsyncSearchAbort('superseded');
    };
    const startNetworkTask = (uxTaskId)=>{
        if (!searchSessionId || !isNetworkMode || !(0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-network')) return;
        const networkTaskId = crypto.randomUUID();
        fullPageSearchNetworkRefs.current.taskId = networkTaskId;
        fullPageSearchNetworkRefs.current.startAt = performance.now();
        // Update state BEFORE firing event
        fullPageSearchNetworkRefs.current.state = {
            taskId: networkTaskId,
            uxTaskId: uxTaskId,
            cacheAvailable: cacheAvailable,
            cacheExpected: cacheExpected,
            state: 'started'
        };
        fireAnalyticsEvent((0, $bQSQw.onTaskStart)({
            searchSessionId: searchSessionId,
            taskId: networkTaskId,
            task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK,
            moreContext: {
                uxTaskId: uxTaskId,
                cacheAvailable: cacheAvailable,
                cacheExpected: cacheExpected
            }
        }));
    };
    const startAsyncSearchTask = (uxTaskId)=>{
        if (!searchSessionId || !isNetworkMode || !cacheExpected || !(0, $dh538.fg)('search_async_ssr')) return;
        const asyncSearchTaskId = crypto.randomUUID();
        fullPageSearchAsyncSearchRefs.current.taskId = asyncSearchTaskId;
        fullPageSearchAsyncSearchRefs.current.startAt = performance.now();
        // Update state BEFORE firing event
        fullPageSearchAsyncSearchRefs.current.state = {
            taskId: asyncSearchTaskId,
            uxTaskId: uxTaskId,
            cacheExpected: cacheExpected,
            state: 'started'
        };
        fireAnalyticsEvent((0, $bQSQw.onTaskStart)({
            searchSessionId: searchSessionId,
            taskId: asyncSearchTaskId,
            task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_ASYNC_SEARCH_RESULTS,
            moreContext: {
                uxTaskId: uxTaskId,
                cacheExpected: cacheExpected
            }
        }));
    };
    return {
        /**
		 * Called when a new search is initiated.
		 * Handles:
		 * - UX taskStart
		 * - Network taskAbort (superseded)
		 * - Network taskStart
		 * - Async search taskAbort (superseded)
		 * - Async search taskStart (only when cacheExpected=true)
		 */ onSearchStart: ()=>{
            const uxTaskId = crypto.randomUUID();
            startUxTask(uxTaskId);
            abortSupersededNetworkTaskIfNeeded();
            startNetworkTask(uxTaskId);
            abortSupersededAsyncSearchTaskIfNeeded();
            startAsyncSearchTask(uxTaskId);
            return uxTaskId;
        }
    };
}








const $3f9016d1e452d4e9$export$d8aa641030aec4f4 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $3f9016d1e452d4e9$export$119dcb5621de506f = ({ children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { searchSessionId: searchSessionId } = (0, $j4ply.useBootstrapState)((state)=>state);
    // UX VitalStats task id ref (full page search)
    const uxTaskIdRef = (0, $42omo.useRef)(null);
    // Consolidated ref for Network VitalStats (taskId, startAt, state share same lifecycle)
    const fullPageSearchNetworkRefs = (0, $42omo.useRef)({
        taskId: null,
        startAt: 0,
        state: {
            taskId: null,
            uxTaskId: null,
            cacheAvailable: false,
            cacheExpected: false,
            state: 'idle'
        }
    });
    // Consolidated ref for Async Search VitalStats (tracks aggregator backend cache hit/miss after async search)
    const fullPageSearchAsyncSearchRefs = (0, $42omo.useRef)({
        taskId: null,
        startAt: 0,
        state: {
            taskId: null,
            uxTaskId: null,
            cacheExpected: false,
            state: 'idle'
        }
    });
    // Refs to avoid stale closures in unmount cleanup
    const searchSessionIdRef = (0, $42omo.useRef)((0, $dh538.fg)('search_async_ssr') ? searchSessionId : undefined);
    const fireAnalyticsEventRef = (0, $42omo.useRef)(fireAnalyticsEvent);
    if ((0, $dh538.fg)('search_async_ssr')) searchSessionIdRef.current = searchSessionId;
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('search_async_ssr')) searchSessionIdRef.current = searchSessionId;
    }, [
        searchSessionId
    ]);
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEventRef.current = fireAnalyticsEvent;
    }, [
        fireAnalyticsEvent
    ]);
    // Helper to create network vitalstats instance with current refs
    const getNetworkVitalStats = ()=>(0, $6b38ac5f99e2f44f$export$e56e03f775f4eedc)({
            searchSessionId: searchSessionIdRef.current ?? '',
            fireAnalyticsEvent: fireAnalyticsEventRef.current,
            fullPageSearchNetworkRefs: fullPageSearchNetworkRefs
        });
    // Helper to create async search vitalstats instance with current refs
    const getAsyncSearchVitalStats = ()=>(0, $6b38ac5f99e2f44f$export$d3070defdd0e7637)({
            searchSessionId: searchSessionIdRef.current ?? '',
            fireAnalyticsEvent: fireAnalyticsEventRef.current,
            fullPageSearchAsyncSearchRefs: fullPageSearchAsyncSearchRefs
        });
    // Network VitalStats unmount cleanup - fire taskAbort if task is in progress
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if ((0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-network')) getNetworkVitalStats().onNetworkAbort('unmounted');
            if ((0, $dh538.fg)('search_async_ssr')) getAsyncSearchVitalStats().onAsyncSearchAbort('unmounted');
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Memoized API that doesn't change identity (prevents re-renders)
    const api = (0, $42omo.useMemo)(()=>{
        // Use a ref-based approach so the API object identity is stable
        // but always uses the latest values from refs
        return {
            onSearchStart: ({ cacheAvailable: cacheAvailable, cacheExpected: cacheExpected, isNetworkMode: isNetworkMode })=>{
                const vitalStats = (0, $6b38ac5f99e2f44f$export$1ef754039accea4b)({
                    searchSessionId: searchSessionIdRef.current,
                    fireAnalyticsEvent: fireAnalyticsEventRef.current,
                    fullPageSearchTaskIdRef: uxTaskIdRef,
                    fullPageSearchNetworkRefs: fullPageSearchNetworkRefs,
                    fullPageSearchAsyncSearchRefs: fullPageSearchAsyncSearchRefs,
                    cacheAvailable: cacheAvailable,
                    cacheExpected: cacheExpected,
                    isNetworkMode: isNetworkMode
                });
                return vitalStats.onSearchStart();
            },
            onNetworkSuccess: (resultCount, traceInfo)=>{
                getNetworkVitalStats().onNetworkSuccess(resultCount, traceInfo);
            },
            onNetworkFail: (errorName, errorMessage, traceInfo)=>{
                getNetworkVitalStats().onNetworkFail(errorName, errorMessage, traceInfo);
            },
            onNetworkAbort: (reason)=>{
                getNetworkVitalStats().onNetworkAbort(reason);
            },
            getUxTaskId: ()=>uxTaskIdRef.current,
            getNetworkRefs: ()=>fullPageSearchNetworkRefs,
            onAsyncSearchSuccess: ()=>{
                getAsyncSearchVitalStats().onAsyncSearchSuccess();
            },
            onAsyncSearchFail: ()=>{
                getAsyncSearchVitalStats().onAsyncSearchFail();
            },
            onAsyncSearchAbort: (reason)=>{
                getAsyncSearchVitalStats().onAsyncSearchAbort(reason);
            },
            getAsyncSearchRefs: ()=>fullPageSearchAsyncSearchRefs,
            getUxTaskIdRef: ()=>uxTaskIdRef
        };
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($3f9016d1e452d4e9$export$d8aa641030aec4f4.Provider, {
        value: api,
        children: children
    });
};
const $3f9016d1e452d4e9$export$586800522161402 = ()=>{
    const context = (0, $42omo.useContext)($3f9016d1e452d4e9$export$d8aa641030aec4f4);
    if (!context) throw new Error('useFullPageSearchVitalStats must be used within a FullPageSearchVitalStatsProvider');
    return context;
};


/**
 * Common setup for search modes (RESULTS and CQL_RESULTS).
 * Handles task ID generation, analytics, error boundary reset, and scroll behavior.
 */ function $522e970424cd3461$var$setupSearchExecution({ onSearchStart: onSearchStart, resetErrorBoundary: resetErrorBoundary, setQueryUpdatedTime: setQueryUpdatedTime, bodyRef: bodyRef, setMaxResultsToShow: setMaxResultsToShow, cacheAvailable: cacheAvailable, cacheExpected: cacheExpected, isNetworkMode: isNetworkMode }) {
    // VitalStats: fires UX taskStart + Network taskStart (and superseded abort)
    // This also sets the UX task ID ref internally via context
    onSearchStart({
        cacheAvailable: cacheAvailable,
        cacheExpected: cacheExpected,
        isNetworkMode: isNetworkMode
    });
    // Reset error boundary and query timestamp
    resetErrorBoundary?.();
    setQueryUpdatedTime();
    // Scroll to top and update max results
    bodyRef.current?.scrollTo?.(0, 0);
    setMaxResultsToShow((0, $40b6880ea7365c64$export$2db639ca606fdc06)(window.innerHeight));
}
/**
 * Load LeapQuery as a non-CQL enhancement (errors are non-fatal and should not block results).
 */ function $522e970424cd3461$var$loadLeapQuery({ bootstrap: bootstrap, searchQuery: searchQuery, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled, logError: logError }) {
    const { primaryProduct: primaryProduct, isRovoEnabled: isRovoEnabled } = bootstrap;
    if (primaryProduct && searchQuery && (0, $f97ce1f1c5afcd2b$export$383dd888028aa640)((0, $c2HNo.getApplicationMode)({
        isRovoEnabled: isRovoEnabled
    }), isAdminHubAIEnabled, isRovoLLMEnabled)) // Loading state handled in the LeapQuery component.
    (0, $2b038019829bbd3e$export$1aafcd2cfb41dc92)({
        query: searchQuery,
        product: primaryProduct
    }).catch((e)=>{
        logError(e);
    });
}
/**
 * Executes the query plan: loads/disposes queries, fires analytics, and updates state.
 * This is the single point where we orchestrate all query loading based on the derived mode.
 */ function $522e970424cd3461$var$executeQueryPlan({ plan: plan, loadSearchResultsQuery: loadSearchResultsQuery, loadSearchResultsAsyncQuery: loadSearchResultsAsyncQuery, loadRightPanelQuery: loadRightPanelQuery, loadRightPanelAsyncQuery: loadRightPanelAsyncQuery, loadSearchResultsCQLQuery: loadSearchResultsCQLQuery, disposeSearchResultsQuery: disposeSearchResultsQuery, disposeSearchResultsAsyncQuery: disposeSearchResultsAsyncQuery, disposeSearchResultsCQLQuery: disposeSearchResultsCQLQuery, disposeRightPanelQuery: disposeRightPanelQuery, disposeRightPanelAsyncQuery: disposeRightPanelAsyncQuery, setBootstrap: setBootstrap, setSearch: setSearch, setResultsState: setResultsState, resetErrorBoundary: resetErrorBoundary, setMaxResultsToShow: setMaxResultsToShow, bodyRef: bodyRef, backendExperimentRef: backendExperimentRef, reportPreloadQueryVarsDiff: reportPreloadQueryVarsDiff, vitalStats: vitalStats, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled, isLiteMode: isLiteMode, logError: logError, preloadDataProvider: preloadDataProvider }) {
    const { mode: mode, bootstrap: bootstrap, search: search, cql: cql, selectedProducts: selectedProducts, queryParams: queryParams } = plan;
    const relayFetchOptions = (0, $d0b07f1b6ca90690$export$1bb1cb0a9da0a635)(bootstrap);
    // RESULTS: load results + counts + leapQuery; ensure CQL ref is disposed.
    if (mode === 'RESULTS') {
        disposeSearchResultsCQLQuery();
        // Dispose the query path we're NOT using
        if ((0, $dh538.fg)('search_async_ssr')) disposeSearchResultsQuery();
        else disposeSearchResultsAsyncQuery();
        const { searchResultsQueryVariables: searchResultsQueryVariables, rightPanelQueryVariables: rightPanelQueryVariables, backendExperiment: backendExperiment } = (0, $7yVTH.generateSearchInputs)({
            backendExperimentOverrides: bootstrap.overrides?.backendExperiments || [],
            cloudId: bootstrap.cloudId || '',
            user: bootstrap.user,
            primaryProduct: bootstrap.primaryProduct,
            experimentLayers: bootstrap.experimentLayers,
            experience: (0, $4cq9O.SEARCH_PAGE),
            thirdPartyConfigs: bootstrap.thirdPartyConfigs,
            products: bootstrap.products,
            productEdition: bootstrap.productEdition || {},
            productDataRegions: bootstrap.productDataRegions || {},
            isJiraIssueIndexed: bootstrap.isJiraIssueIndexed,
            sessionId: (0, $PVo4u.getSessionIdFromLocalStorage)(),
            searchSessionId: bootstrap.searchSessionId,
            queryParams: queryParams,
            jsmIncidentFilterIds: search.jsmIncidentFilterIds,
            onError: logError,
            isLiteMode: isLiteMode
        });
        (0, $8RFAN.serveFederatedSlackExperiment)(undefined, selectedProducts, {
            fireExperimentExposure: true
        }, bootstrap.thirdPartyConfigs);
        if (backendExperiment) backendExperimentRef.current = backendExperiment;
        (0, $bVltF.searchResultsLoadUFOExperienceStart)();
        // Used for smart answers to track results state.
        setResultsState((0, $fZ3l2.ResultsStates).IS_LOADING);
        // Note: cacheAvailable is always false because Relay's store-or-network policy
        // always makes network requests. The label is kept for future use if we change fetch policy.
        const cacheAvailable = false;
        // A cache hit is expected when the preload data provider has search query variables
        // from a successful preload (e.g. SSR or quick-find)
        const cacheExpected = Boolean(preloadDataProvider?.getPreloadedSearch({
            cloudId: bootstrap.cloudId || ''
        })?.search?.queryVariables);
        $522e970424cd3461$var$setupSearchExecution({
            onSearchStart: vitalStats.onSearchStart,
            resetErrorBoundary: resetErrorBoundary,
            setQueryUpdatedTime: $20r3r.setQueryUpdatedTime,
            bodyRef: bodyRef,
            setMaxResultsToShow: setMaxResultsToShow,
            cacheAvailable: cacheAvailable,
            cacheExpected: cacheExpected,
            isNetworkMode: true
        });
        if ((0, $dh538.fg)('search_async_ssr')) {
            loadSearchResultsAsyncQuery(searchResultsQueryVariables, relayFetchOptions);
            disposeRightPanelQuery?.();
            loadRightPanelAsyncQuery?.(rightPanelQueryVariables, relayFetchOptions);
        } else {
            loadSearchResultsQuery(searchResultsQueryVariables, relayFetchOptions);
            disposeRightPanelAsyncQuery?.();
            loadRightPanelQuery?.(rightPanelQueryVariables, relayFetchOptions);
        }
        // Load LeapQuery after kicking off the core queries.
        $522e970424cd3461$var$loadLeapQuery({
            bootstrap: bootstrap,
            searchQuery: search.searchQuery,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled,
            logError: logError
        });
        const quickFindAsyncPreloadEnabled = (0, $2OtFZ.isQuickFindAsyncPreloadEnabled)();
        if ((0, $dh538.fg)('search_async_ssr') || quickFindAsyncPreloadEnabled) {
            reportPreloadQueryVarsDiff({
                cloudId: bootstrap.cloudId,
                searchResultsQueryVariables: searchResultsQueryVariables,
                rightPanelQueryVariables: rightPanelQueryVariables
            });
            // Once we have reported the diff for the Quick Find async preload, we can
            // clear the preload data provider so it can be re-warmed on the next
            // Quick Find→search-page transition. We also clear the SEARCH_SESSION_ID
            // so that it isn't reused the next time the search page is visited.
            if (quickFindAsyncPreloadEnabled && bootstrap.cloudId && preloadDataProvider) {
                preloadDataProvider.clearPreloadedSearch({
                    cloudId: bootstrap.cloudId
                });
                (0, $lRrav.SEARCH_SESSION_ID).dispose();
            }
        }
    }
    // CQL_RESULTS: load CQL results; ensure non-CQL refs are disposed.
    if (mode === 'CQL_RESULTS') {
        disposeRightPanelQuery?.();
        disposeRightPanelAsyncQuery?.();
        disposeSearchResultsQuery();
        disposeSearchResultsAsyncQuery();
        $522e970424cd3461$var$setupSearchExecution({
            onSearchStart: vitalStats.onSearchStart,
            resetErrorBoundary: resetErrorBoundary,
            setQueryUpdatedTime: $20r3r.setQueryUpdatedTime,
            bodyRef: bodyRef,
            setMaxResultsToShow: setMaxResultsToShow,
            cacheAvailable: false,
            cacheExpected: false,
            isNetworkMode: false
        });
        // `mode` guarantees cql exists here.
        loadSearchResultsCQLQuery({
            cql: cql,
            first: 30,
            after: null
        }, relayFetchOptions);
    }
    // LANDING: invalidate all query refs so stale results can't render/suspend.
    if (mode === 'LANDING') {
        disposeSearchResultsQuery();
        disposeSearchResultsAsyncQuery();
        disposeRightPanelQuery?.();
        disposeRightPanelAsyncQuery?.();
        disposeSearchResultsCQLQuery();
    }
    // Keep local mirrors in sync for rendering.
    setSearch(search);
    setBootstrap(bootstrap);
}
function $522e970424cd3461$export$68c6db5b1ec6ba65({ loadSearchResultsQuery: loadSearchResultsQuery, disposeSearchResultsQuery: disposeSearchResultsQuery, loadSearchResultsAsyncQuery: loadSearchResultsAsyncQuery, disposeSearchResultsAsyncQuery: disposeSearchResultsAsyncQuery, loadRightPanelQuery: loadRightPanelQuery, disposeRightPanelQuery: disposeRightPanelQuery, loadRightPanelAsyncQuery: loadRightPanelAsyncQuery, disposeRightPanelAsyncQuery: disposeRightPanelAsyncQuery, loadSearchResultsCQLQuery: loadSearchResultsCQLQuery, disposeSearchResultsCQLQuery: disposeSearchResultsCQLQuery, setBootstrap: setBootstrap, setSearch: setSearch, setResultsState: setResultsState, resetErrorBoundary: resetErrorBoundary, bodyRef: bodyRef, setMaxResultsToShow: setMaxResultsToShow, backendExperimentRef: backendExperimentRef, preloadDataProvider: preloadDataProvider, isAdminHubAIEnabled: isAdminHubAIEnabled = false, isRovoLLMEnabled: isRovoLLMEnabled = false, logError: logError, cql: cql, searchQuery: searchQuery, filters: filters, selectedProducts: selectedProducts, queryParams: queryParams, isLiteMode: isLiteMode }) {
    const vitalStats = (0, $3f9016d1e452d4e9$export$586800522161402)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const search = (0, $djVCD.useSearchState)((0, $29e931a0b3bfc4fe$export$3761754c69bcbfc2));
    const bootstrap = (0, $j4ply.useBootstrapState)((0, $bae6f8ff1d9250a0$export$cfd0a4eecdb5b49d));
    const reportPreloadQueryVarsDiff = (0, $be44947282c9e056$export$d18fc794cd63a6c4)(preloadDataProvider);
    // Available products are sourced from bootstrap store/context, not local search mirror
    const availableProducts = bootstrap.products;
    // Bootstrap is ready when there are available products
    const bootstrapReady = availableProducts.length > 0;
    // Filters are considered selected when there is a selected product or any filter has a selection
    const hasAnyFilterSelected = Boolean(selectedProducts[0]) || Object.values(filters).some((filter)=>filter?.hasSelection);
    // There should only ever be one selected product
    const selectedProduct = selectedProducts[0];
    const mode = (0, $411ad342376b971d$export$87ba7e4f15231598)({
        bootstrapReady: bootstrapReady,
        availableProducts: availableProducts,
        selectedProduct: selectedProduct,
        searchQuery: searchQuery,
        hasAnyFilterSelected: hasAnyFilterSelected,
        cql: cql
    });
    const previousPlanRef = (0, $42omo.useRef)();
    // Refs for non-reactive dependencies: always created to satisfy React's
    // rules of hooks (hooks must be called in the same order every render).
    // When the feature flag is ON, the useEffect reads from these refs instead
    // of using the values directly, so changes to store objects and callbacks
    // don't trigger unnecessary re-executions.
    const bootstrapRef = (0, $42omo.useRef)(bootstrap);
    bootstrapRef.current = bootstrap;
    const searchRef = (0, $42omo.useRef)(search);
    searchRef.current = search;
    const loadSearchResultsQueryRef = (0, $42omo.useRef)(loadSearchResultsQuery);
    loadSearchResultsQueryRef.current = loadSearchResultsQuery;
    const loadSearchResultsAsyncQueryRef = (0, $42omo.useRef)(loadSearchResultsAsyncQuery);
    loadSearchResultsAsyncQueryRef.current = loadSearchResultsAsyncQuery;
    const loadRightPanelQueryRef = (0, $42omo.useRef)(loadRightPanelQuery);
    loadRightPanelQueryRef.current = loadRightPanelQuery ?? undefined;
    const loadRightPanelAsyncQueryRef = (0, $42omo.useRef)(loadRightPanelAsyncQuery);
    loadRightPanelAsyncQueryRef.current = loadRightPanelAsyncQuery ?? undefined;
    const loadSearchResultsCQLQueryRef = (0, $42omo.useRef)(loadSearchResultsCQLQuery);
    loadSearchResultsCQLQueryRef.current = loadSearchResultsCQLQuery;
    const disposeSearchResultsQueryRef = (0, $42omo.useRef)(disposeSearchResultsQuery);
    disposeSearchResultsQueryRef.current = disposeSearchResultsQuery;
    const disposeSearchResultsAsyncQueryRef = (0, $42omo.useRef)(disposeSearchResultsAsyncQuery);
    disposeSearchResultsAsyncQueryRef.current = disposeSearchResultsAsyncQuery;
    const disposeSearchResultsCQLQueryRef = (0, $42omo.useRef)(disposeSearchResultsCQLQuery);
    disposeSearchResultsCQLQueryRef.current = disposeSearchResultsCQLQuery;
    const disposeRightPanelQueryRef = (0, $42omo.useRef)(disposeRightPanelQuery);
    disposeRightPanelQueryRef.current = disposeRightPanelQuery ?? undefined;
    const disposeRightPanelAsyncQueryRef = (0, $42omo.useRef)(disposeRightPanelAsyncQuery);
    disposeRightPanelAsyncQueryRef.current = disposeRightPanelAsyncQuery ?? undefined;
    const resetErrorBoundaryRef = (0, $42omo.useRef)(resetErrorBoundary);
    resetErrorBoundaryRef.current = resetErrorBoundary;
    const vitalStatsRef = (0, $42omo.useRef)(vitalStats);
    vitalStatsRef.current = vitalStats;
    const logErrorRef = (0, $42omo.useRef)(logError);
    logErrorRef.current = logError;
    const reportPreloadQueryVarsDiffRef = (0, $42omo.useRef)(reportPreloadQueryVarsDiff);
    reportPreloadQueryVarsDiffRef.current = reportPreloadQueryVarsDiff;
    (0, $42omo.useEffect)(()=>{
        if (!bootstrapReady) return;
        const useStableDeps = (0, $dh538.fg)('rovo-search-vitalstats-stable-query-plan-deps');
        // The deepEqual comparison only checks the search identity fields. bootstrap
        // and search are excluded because they contain non-search-relevant fields
        // (filter options, third-party configs, etc.) that change independently.
        // The search-relevant fields from bootstrap/search are already extracted as
        // individual variables (searchQuery, filters, selectedProducts, etc.) and
        // compared directly.
        const nextPlan = {
            mode: mode,
            bootstrap: useStableDeps ? {} : bootstrap,
            search: useStableDeps ? {} : search,
            cql: cql,
            selectedProducts: selectedProducts,
            queryParams: queryParams
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hL7bb)))(previousPlanRef.current, nextPlan)) return;
        // Skip clearing here when the Quick Find preload is on — clearing happens
        // as soon as the diff is reported (see executeQueryPlan), not when we go
        // to make a new query.
        if (!(0, $2OtFZ.isQuickFindAsyncPreloadEnabled)() && previousPlanRef.current && preloadDataProvider && bootstrapRef.current.cloudId && (0, $dh538.fg)('search_async_ssr')) // Once the hydrated plan transitions to the first client-driven plan, retire the SSR preload
        // context so subsequent searches do not report as initial async-SSR loads.
        preloadDataProvider.clearPreloadedSearch({
            cloudId: bootstrapRef.current.cloudId
        });
        previousPlanRef.current = nextPlan;
        $522e970424cd3461$var$executeQueryPlan({
            plan: {
                ...nextPlan,
                bootstrap: bootstrapRef.current,
                search: searchRef.current
            },
            loadSearchResultsQuery: loadSearchResultsQueryRef.current,
            loadSearchResultsAsyncQuery: loadSearchResultsAsyncQueryRef.current,
            loadRightPanelQuery: loadRightPanelQueryRef.current,
            loadRightPanelAsyncQuery: loadRightPanelAsyncQueryRef.current,
            loadSearchResultsCQLQuery: loadSearchResultsCQLQueryRef.current,
            disposeSearchResultsQuery: disposeSearchResultsQueryRef.current,
            disposeSearchResultsAsyncQuery: disposeSearchResultsAsyncQueryRef.current,
            disposeSearchResultsCQLQuery: disposeSearchResultsCQLQueryRef.current,
            disposeRightPanelQuery: disposeRightPanelQueryRef.current,
            disposeRightPanelAsyncQuery: disposeRightPanelAsyncQueryRef.current,
            setBootstrap: setBootstrap,
            setSearch: setSearch,
            setResultsState: setResultsState,
            resetErrorBoundary: resetErrorBoundaryRef.current,
            setMaxResultsToShow: setMaxResultsToShow,
            bodyRef: bodyRef,
            backendExperimentRef: backendExperimentRef,
            reportPreloadQueryVarsDiff: reportPreloadQueryVarsDiffRef.current,
            vitalStats: vitalStatsRef.current,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled,
            isLiteMode: isLiteMode,
            logError: logErrorRef.current,
            preloadDataProvider: preloadDataProvider
        });
    }, [
        bootstrap,
        search,
        bootstrapReady,
        mode,
        loadSearchResultsQuery,
        loadSearchResultsAsyncQuery,
        loadRightPanelQuery,
        loadRightPanelAsyncQuery,
        loadSearchResultsCQLQuery,
        disposeSearchResultsQuery,
        disposeSearchResultsAsyncQuery,
        disposeSearchResultsCQLQuery,
        disposeRightPanelQuery,
        disposeRightPanelAsyncQuery,
        setBootstrap,
        setSearch,
        setResultsState,
        resetErrorBoundary,
        setMaxResultsToShow,
        bodyRef,
        backendExperimentRef,
        vitalStats,
        isAdminHubAIEnabled,
        isRovoLLMEnabled,
        isLiteMode,
        logError,
        cql,
        searchQuery,
        filters,
        selectedProducts,
        queryParams,
        preloadDataProvider
    ]);
    return {
        mode: mode,
        bootstrap: bootstrap,
        search: search
    };
}
function $522e970424cd3461$export$d152b66e844f2488(args) {
    $522e970424cd3461$export$68c6db5b1ec6ba65(args);
    return null;
}


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 









var $eEA8O = parcelRequire("eEA8O");





var $4u5NT = parcelRequire("4u5NT");








const $8c82ce48fc53c798$export$bbc0f837b34857b7 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>{
    return {
        name: (0, $6yNqK.ERROR_SCREEN_NAME),
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};


const $00671a63acd7458c$export$8b03bfde0d56431b = ({ success: success, commonAttributes: commonAttributes })=>({
        eventType: 'operational',
        action: success ? 'taskSuccess' : 'taskFail',
        actionSubject: 'ui',
        attributes: {
            commonAttributes: commonAttributes,
            additionalAttributes: {
                task: 'unifiedSearch',
                capability: 'fullPageSearchResult',
                // This edition is not exact matching the need for the AutoHots
                // A follow up is to find the current primary product edition and log that.
                // Currently we only have confluence edition in the productEdition object, so logging the entire object for now.
                edition: commonAttributes.productEdition,
                // Confirmed with AutoHots team this is mandatory
                // and base on "Can I log this" doc, we can log this.
                // https://hello.atlassian.net/wiki/spaces/Monitoring/pages/5816497997/Vitalstats+Onboarding+contract?focusedCommentId=5864073069
                // https://hello.atlassian.net/wiki/spaces/SECURITY/pages/236070634/Can+I+Log+This
                hostname: window.location.hostname
            }
        }
    });


















const $85b9020f088869ac$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    errorPrimary: {
        id: "error_primary",
        defaultMessage: "We're having trouble searching"
    },
    errorSecondary: {
        id: "error_secondary",
        defaultMessage: "It might just be a hiccup. The best thing to do is to <btn>try again</btn>."
    }
});


// Global set to track which task IDs have already fired taskFail
// This prevents duplicate taskFail events when multiple Error components mount simultaneously
// The Set is cleared when a new search starts (keeping only the current task ID)
const $6b25d1ac83f43781$var$firedTaskFailIds = new Set();
const $6b25d1ac83f43781$export$ca07aa59d198dca6 = ()=>{
    $6b25d1ac83f43781$var$firedTaskFailIds.clear();
};
const $6b25d1ac83f43781$export$edf27be85e5f6da0 = ({ fetchResults: fetchResults, error: error })=>{
    const vitalStats = (0, $3f9016d1e452d4e9$export$586800522161402)();
    $6b25d1ac83f43781$var$useFireAnalytics(error, vitalStats.getUxTaskId(), vitalStats.onNetworkFail);
    (0, $42omo.useMemo)(()=>(0, $4u5NT.addErrorToAll)('search-page-results-error', null, // this is used internally, can be null
        'interaction error', error?.message || 'generic error'), [
        error
    ]);
    const ImageErrorLight = (0, $c7e627886411fcb9$export$ce969d199fe2c04e)('cachedImageErrorLight') || (0, (/*@__PURE__*/$parcel$interopDefault($6df538e2e254fd26$exports)));
    const ImageErrorDark = (0, $c7e627886411fcb9$export$ce969d199fe2c04e)('cachedImageErrorDark') || (0, (/*@__PURE__*/$parcel$interopDefault($d264f14dd361aa2b$exports)));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $330959ad09458c13$export$d9172702747fb4bc), {
        imageSrcLight: ImageErrorLight,
        imageSrcDark: ImageErrorDark,
        primaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $85b9020f088869ac$export$defe85febe8b728c).errorPrimary
        }),
        secondaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $85b9020f088869ac$export$defe85febe8b728c).errorSecondary,
            values: {
                btn: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                        appearance: "link",
                        spacing: "none",
                        onClick: fetchResults,
                        children: chunks
                    })
            }
        }),
        testId: "search-page-error"
    });
};
const $6b25d1ac83f43781$var$useFireAnalytics = (error, fullPageSearchTaskId, onNetworkFail)=>{
    const { fireAnalyticsScreenEvent: fireAnalyticsScreenEvent, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttrs, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    (0, $42omo.useEffect)(()=>{
        // Prevent duplicate taskFail events for the same task ID (multiple Error components may render)
        if (fullPageSearchTaskId && $6b25d1ac83f43781$var$firedTaskFailIds.has(fullPageSearchTaskId)) return;
        // Mark this task ID as having fired taskFail and clean up old task IDs
        if (fullPageSearchTaskId) {
            // Clear old task IDs to prevent unbounded memory growth
            // Keep only the current task ID (in case multiple Error components mount)
            $6b25d1ac83f43781$var$firedTaskFailIds.clear();
            $6b25d1ac83f43781$var$firedTaskFailIds.add(fullPageSearchTaskId);
        }
        const commonAttributes = {
            ...commonAttrs,
            ...(0, $1ymk3.getExtensionData)(commonAttrs.isCQL)
        };
        fireAnalyticsScreenEvent((0, $8c82ce48fc53c798$export$bbc0f837b34857b7)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        fireAnalyticsEvent((0, $00671a63acd7458c$export$8b03bfde0d56431b)({
            success: false,
            commonAttributes: commonAttributes
        }));
        // Fire vital stats taskFail event when error screen is shown
        if (fullPageSearchTaskId && commonAttrs.searchSessionId) fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
            searchSessionId: commonAttrs.searchSessionId,
            taskId: fullPageSearchTaskId,
            task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_UX,
            moreContext: {
                errorName: error?.name || 'Error',
                errorMessage: error?.message || 'generic error'
            }
        }));
        // Fire Network VitalStats taskFail event - gated by feature flag
        if (onNetworkFail && (0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-network')) {
            const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $1ymk3.getRelayNetworkTraceInfo)(commonAttrs.isCQL) : undefined;
            onNetworkFail(error?.name || 'Error', error?.message || 'generic error', traceInfo);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};





/**
 * @generated SignedSource<<857274c49dd22db8dab2dceea866003e>>
 * @relayHash fe074351f7d60c7371e8425904d5e88a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 544db1c2c21fb97d410a3ea7a4f85a8695606636eb356dba2c43c66119e3b686
const $2589229aad43bae5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "assetsFilters"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARI"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "compassFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "expectResult"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentId"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentLayers"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraFilters"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "mercuryFilters"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryVersion"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchSessionId"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shadowExperimentId"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceProduct"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "talentFilters"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "thirdPartyFilters"
    }, v23 = [
        {
            "concreteType": "SearchQueryAPI",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
                {
                    "alias": "results",
                    "args": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "queryVersion",
                                    "variableName": "queryVersion"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "searchSessionId",
                                    "variableName": "searchSessionId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "sessionId",
                                    "variableName": "sessionId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "sourceProduct",
                                    "variableName": "sourceProduct"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "analytics"
                        },
                        {
                            "kind": "Variable",
                            "name": "disableQueryReplacement",
                            "variableName": "disableQueryReplacement"
                        },
                        {
                            "kind": "Variable",
                            "name": "expectResult",
                            "variableName": "expectResult"
                        },
                        {
                            "kind": "Variable",
                            "name": "experience",
                            "variableName": "experience"
                        },
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "experimentId",
                                    "variableName": "experimentId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "experimentLayers",
                                    "variableName": "experimentLayers"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "shadowExperimentId",
                                    "variableName": "shadowExperimentId"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "experimentContext"
                        },
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "assetsFilters",
                                    "variableName": "assetsFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "commonFilters",
                                    "variableName": "commonFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "compassFilters",
                                    "variableName": "compassFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "confluenceFilters",
                                    "variableName": "confluenceFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "entities",
                                    "variableName": "entities"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "jiraFilters",
                                    "variableName": "jiraFilters"
                                },
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "locations.0",
                                            "variableName": "cloudIdARI"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "locations"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "mercuryFilters",
                                    "variableName": "mercuryFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "talentFilters",
                                    "variableName": "talentFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "thirdPartyFilters",
                                    "variableName": "thirdPartyFilters"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "filters"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "limit"
                        },
                        {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "query"
                        },
                        {
                            "kind": "Variable",
                            "name": "sort",
                            "variableName": "sort"
                        }
                    ],
                    "concreteType": "SearchItemConnection",
                    "kind": "LinkedField",
                    "name": "asyncSearch",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isCachedResult"
                        },
                        {
                            "concreteType": "SearchProductCount",
                            "kind": "LinkedField",
                            "name": "totalCounts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "product"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "rightPanelAsyncQuery",
            "selections": v23 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v14 /*: any*/ ,
                v1 /*: any*/ ,
                v12 /*: any*/ ,
                v6 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v11 /*: any*/ ,
                v0 /*: any*/ ,
                v13 /*: any*/ ,
                v21 /*: any*/ ,
                v3 /*: any*/ ,
                v22 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v9 /*: any*/ ,
                v18 /*: any*/ ,
                v10 /*: any*/ ,
                v5 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "rightPanelAsyncQuery",
            "selections": v23 /*: any*/ 
        },
        "params": {
            "id": "544db1c2c21fb97d410a3ea7a4f85a8695606636eb356dba2c43c66119e3b686",
            "metadata": {},
            "name": "rightPanelAsyncQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2589229aad43bae5$var$node.hash = "86d4d580ed2a10f77b2725edc1c5a526";
var $2589229aad43bae5$export$2e2bcd8739ae039 = $2589229aad43bae5$var$node;


/**
 * @generated SignedSource<<518c0f8283ebe66c947968df58a31c9f>>
 * @relayHash 75ec887ee22b87fff1e6a8cbc04f765f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f711da52c9d546b458e4081e59e2519ac2fbf265affee91689828bfddb8494fc
const $71b133da64a47244$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "assetsFilters"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARI"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "compassFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentId"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentLayers"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraFilters"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "mercuryFilters"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryVersion"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchSessionId"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shadowExperimentId"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceProduct"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "talentFilters"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "thirdPartyFilters"
    }, v22 = [
        {
            "concreteType": "SearchQueryAPI",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
                {
                    "alias": "results",
                    "args": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "queryVersion",
                                    "variableName": "queryVersion"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "searchSessionId",
                                    "variableName": "searchSessionId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "sessionId",
                                    "variableName": "sessionId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "sourceProduct",
                                    "variableName": "sourceProduct"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "analytics"
                        },
                        {
                            "kind": "Variable",
                            "name": "disableQueryReplacement",
                            "variableName": "disableQueryReplacement"
                        },
                        {
                            "kind": "Variable",
                            "name": "experience",
                            "variableName": "experience"
                        },
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "experimentId",
                                    "variableName": "experimentId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "experimentLayers",
                                    "variableName": "experimentLayers"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "shadowExperimentId",
                                    "variableName": "shadowExperimentId"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "experimentContext"
                        },
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "assetsFilters",
                                    "variableName": "assetsFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "commonFilters",
                                    "variableName": "commonFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "compassFilters",
                                    "variableName": "compassFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "confluenceFilters",
                                    "variableName": "confluenceFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "entities",
                                    "variableName": "entities"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "jiraFilters",
                                    "variableName": "jiraFilters"
                                },
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "locations.0",
                                            "variableName": "cloudIdARI"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "locations"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "mercuryFilters",
                                    "variableName": "mercuryFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "talentFilters",
                                    "variableName": "talentFilters"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "thirdPartyFilters",
                                    "variableName": "thirdPartyFilters"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "filters"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "limit"
                        },
                        {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "query"
                        },
                        {
                            "kind": "Variable",
                            "name": "sort",
                            "variableName": "sort"
                        }
                    ],
                    "concreteType": "SearchItemConnection",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SearchProductCount",
                            "kind": "LinkedField",
                            "name": "totalCounts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "product"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "rightPanelQuery",
            "selections": v22 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v11 /*: any*/ ,
                v6 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v10 /*: any*/ ,
                v0 /*: any*/ ,
                v12 /*: any*/ ,
                v20 /*: any*/ ,
                v3 /*: any*/ ,
                v21 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v8 /*: any*/ ,
                v17 /*: any*/ ,
                v9 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "rightPanelQuery",
            "selections": v22 /*: any*/ 
        },
        "params": {
            "id": "f711da52c9d546b458e4081e59e2519ac2fbf265affee91689828bfddb8494fc",
            "metadata": {},
            "name": "rightPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$71b133da64a47244$var$node.hash = "3e753a7ad74216369453ac3610b91186";
var $71b133da64a47244$export$2e2bcd8739ae039 = $71b133da64a47244$var$node;




















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





















var $lAFHW = parcelRequire("lAFHW");











var $i2RLU = parcelRequire("i2RLU");


var $2zyFZ = parcelRequire("2zyFZ");

// @ts-ignore - this is not a valid package entry point and cannot be resolved when using a modern Typescript 'moduleResolution' setting



const $d9ccd4ce0db98dc8$export$296e0cc1e82f1480 = ()=>({
        source: (0, $6yNqK.EVENT_SOURCE),
        eventType: 'ui',
        actionSubject: 'link',
        action: 'clicked',
        actionSubjectId: 'browserExtensionCTA',
        attributes: {
            additionalAttributes: {
                componentName: 'BrowserExtensionBanner'
            }
        }
    });








const $b2ac47778ad6ae54$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    title: {
        id: "search-page.browser-extension-banner.title",
        defaultMessage: "Use Rovo wherever you are"
    },
    linkText: {
        id: "search-page.browser-extension-banner.link-text",
        defaultMessage: "Get the browser extension"
    },
    closeButtonLabel: {
        id: "search-page.browser-extension-banner.close-button-label",
        defaultMessage: "Close browser extension banner"
    }
});


const $b0ebf52c770dccf7$var$styles = {
    banner: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1mouu2gc _kqswh2mm _1tke1et3 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1itk3whj",
    content: "_kqswh2mm _4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    header: "_zulputpp _1e0c1txw _2lx21bp4 _4cvr1y6m _otyru2gc _1o9zidpf",
    title: "_11c81qyo _k48p1pd9 _syazi7uo _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _slp31hna _1i4q1hna _ct361wug",
    closeButtonContainer: "_kqswstnw _154ize3t _1xi2ze3t _1pbykb7n",
    linkContainer: "_zulp1b66 _1e0c1txw _4cvr1h6o _1o9zidpf _19pk1wug"
};
const $b0ebf52c770dccf7$var$isGoogleChromeBrowser = ()=>{
    if (typeof navigator === 'undefined') return false;
    const uaData = navigator.userAgentData;
    const brands = uaData?.brands?.map((b)=>b.brand) ?? [];
    if (brands.length) {
        const result = brands.includes('Google Chrome') && !brands.some((b)=>/(Microsoft Edge|Opera)/i.test(b));
        return result;
    }
    const ua = navigator.userAgent || '';
    const isDesktopChrome = /Chrome\/\d+/.test(ua) && !/(Edg|OPR|Chromium)\//.test(ua);
    const isIOS = /\b(iPad|iPhone|iPod)\b/.test(ua) || /CriOS\/\d+/.test(ua);
    return isDesktopChrome && !isIOS;
};
const $b0ebf52c770dccf7$var$isRovoExtensionInstalled = ()=>{
    try {
        // Check for the rovoExtension object that the extension injects
        return typeof window?.rovoExtension?.openChat === 'function';
    } catch  {
        return false;
    }
};
const $b0ebf52c770dccf7$var$STORAGE_KEY = 'search-page-rovo-browser-extension-banner-state';
const $b0ebf52c770dccf7$var$getBannerState = ()=>{
    const state = (0, $5G9KX.getLocalStorageItem)($b0ebf52c770dccf7$var$STORAGE_KEY);
    return state || {
        isCTAClicked: false,
        isDismissed: false
    };
};
const $b0ebf52c770dccf7$var$setBannerState = (updates)=>{
    const currentState = $b0ebf52c770dccf7$var$getBannerState();
    const newState = {
        ...currentState,
        ...updates
    };
    (0, $5G9KX.setLocalStorageItem)($b0ebf52c770dccf7$var$STORAGE_KEY, JSON.stringify(newState));
};
const $b0ebf52c770dccf7$var$hasUserDismissedBanner = ()=>{
    return $b0ebf52c770dccf7$var$getBannerState().isDismissed;
};
const $b0ebf52c770dccf7$var$hasUserClickedCTA = ()=>{
    return $b0ebf52c770dccf7$var$getBannerState().isCTAClicked;
};
const $b0ebf52c770dccf7$export$246e5924b4316cdf = ()=>{
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    (0, $42omo.useEffect)(()=>{
        // Check if AI/LLM features are enabled based on entitlements
        const areLLMPoweredFeaturesEnabled = (0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25') ? isRovoLLMEnabled : isAdminHubAIEnabled;
        const extensionInstalled = $b0ebf52c770dccf7$var$isRovoExtensionInstalled();
        const userDismissed = $b0ebf52c770dccf7$var$hasUserDismissedBanner();
        const userClickedCTA = $b0ebf52c770dccf7$var$hasUserClickedCTA();
        const isChrome = $b0ebf52c770dccf7$var$isGoogleChromeBrowser();
        const shouldShow = areLLMPoweredFeaturesEnabled && isChrome && !extensionInstalled && !userDismissed && !userClickedCTA && (0, $c6GJD.default).getExperimentValue('rovo-expansion-fps-extension-install-exp', 'isEnabled', false);
        setIsVisible(shouldShow);
    }, [
        isAdminHubAIEnabled,
        isRovoLLMEnabled
    ]);
    const markAsDismissed = ()=>{
        $b0ebf52c770dccf7$var$setBannerState({
            isDismissed: true
        });
        setIsVisible(false);
    };
    const markCTAClicked = ()=>{
        $b0ebf52c770dccf7$var$setBannerState({
            isCTAClicked: true
        });
        setIsVisible(false);
    };
    return {
        isVisible: isVisible,
        markAsDismissed: markAsDismissed,
        markCTAClicked: markCTAClicked
    };
};
const $b0ebf52c770dccf7$export$8316e1225e2e8973 = ({ testId: testId = 'browser-extension-banner', fireAnalyticsEvent: fireAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isVisible: isVisible, markAsDismissed: markAsDismissed, markCTAClicked: markCTAClicked } = $b0ebf52c770dccf7$export$246e5924b4316cdf();
    const handleDismiss = ()=>{
        markAsDismissed(); // Fire analytics event for banner dismissal
        if (fireAnalyticsEvent) fireAnalyticsEvent((0, $i2RLU.onBannerDismissed)({
            componentName: 'BrowserExtensionBanner'
        }));
    };
    const handleCTAClick = ()=>{
        markCTAClicked(); // Fire analytics event for CTA click
        if (fireAnalyticsEvent) fireAnalyticsEvent((0, $d9ccd4ce0db98dc8$export$296e0cc1e82f1480)());
    };
    (0, $42omo.useEffect)(()=>{
        if (isVisible && fireAnalyticsEvent) fireAnalyticsEvent((0, $2zyFZ.onBannerShown)({
            componentName: 'BrowserExtensionBanner'
        }));
    }, [
        fireAnalyticsEvent,
        isVisible
    ]);
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b0ebf52c770dccf7$var$styles.banner,
        testId: testId,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            xcss: $b0ebf52c770dccf7$var$styles.content,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $b0ebf52c770dccf7$var$styles.closeButtonContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        spacing: "compact",
                        appearance: "subtle",
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                size: "small",
                                label: ""
                            }),
                        label: formatMessage((0, $b2ac47778ad6ae54$export$defe85febe8b728c).closeButtonLabel),
                        onClick: handleDismiss,
                        testId: `${testId}-close`
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $b0ebf52c770dccf7$var$styles.header,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                            appearance: "brand",
                            shouldUseNewLogoDesign: true,
                            size: "small"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $b0ebf52c770dccf7$var$styles.title,
                            children: formatMessage((0, $b2ac47778ad6ae54$export$defe85febe8b728c).title)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $b0ebf52c770dccf7$var$styles.linkContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                        href: "https://chromewebstore.google.com/detail/npbjhobkibekbklkghlhfhieggcggpdb?utm_source=confluence-full-page-search&utm_medium=persistent-banner&utm_campaign=rovo_extension_confluence_fps_install_cta",
                        target: "_blank",
                        appearance: "default",
                        testId: `${testId}-link`,
                        onClick: handleCTAClick,
                        children: formatMessage((0, $b2ac47778ad6ae54$export$defe85febe8b728c).linkText)
                    })
                })
            ]
        })
    });
};




























var $7DldS = parcelRequire("7DldS");


var $bRblh = parcelRequire("bRblh");








var $kjNhq = parcelRequire("kjNhq");







var $9d9t8 = parcelRequire("9d9t8");











const $771c2bf7e29ea10c$export$f7577bb728ad6048 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, numOfFilters: numOfFilters, numOfUnconnectedApps: numOfUnconnectedApps, viewportHeight: viewportHeight, viewportWidth: viewportWidth })=>({
        eventType: 'ui',
        actionSubject: 'filter',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelAppFilter`,
        action: 'rendered',
        attributes: {
            additionalAttributes: {
                numOfFilters: numOfFilters,
                numOfUnconnectedApps: numOfUnconnectedApps,
                ...viewportHeight !== undefined && {
                    viewportHeight: viewportHeight
                },
                ...viewportWidth !== undefined && {
                    viewportWidth: viewportWidth
                }
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });



































const $2d40e93801a0fc92$var$getComponentId = (groupId)=>`filter-group-${groupId.toLowerCase()}`;
const $2d40e93801a0fc92$var$AccordionContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    defaultIsExpanded: false,
    isOpen: false,
    setIsOpen: ()=>{},
    displayChevron: false,
    hasSelection: false
});
const $2d40e93801a0fc92$var$accordionPressableStyles = (0, $ecnYn.xcss)({
    background: 'none',
    // Remove Pressable default background
    display: 'flex',
    width: '100%',
    padding: '0' // Remove Pressable default padding
});
const $2d40e93801a0fc92$var$accordionItemsStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.150'
});
const $2d40e93801a0fc92$export$d99097c13d4dac9f = ({ children: children, triggerComponent: triggerComponent, onClick: onClick, groupId: groupId, defaultIsExpanded: defaultIsExpanded = false, hasSelection: hasSelection = false, isInitiallyExpanded: isInitiallyExpanded = false })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(defaultIsExpanded || isInitiallyExpanded);
    const [displayChevron, setDisplayChevron] = (0, $42omo.useState)(false);
    const hasUserInteractedRef = (0, $42omo.useRef)(false);
    const prevDefaultIsExpandedRef = (0, $42omo.useRef)(defaultIsExpanded);
    const prevIsInitiallyExpandedRef = (0, $42omo.useRef)(isInitiallyExpanded);
    (0, $42omo.useEffect)(()=>{
        // isInitiallyExpanded is true only in single-select cohort — used as the gate here
        // to avoid recording experiment exposures on every accordion mount.
        if (isInitiallyExpanded) {
            // Handle late experiment resolution: if isInitiallyExpanded transitions false → true,
            // force-open the accordion. This happens in slow environments (e.g. pollinator headless
            // browsers) where the experiment value resolves after the first render.
            if (!hasUserInteractedRef.current && !prevIsInitiallyExpandedRef.current) setIsOpen(true);
            // Auto-collapse when viewport shrinks (defaultIsExpanded: true→false),
            // unless the user has manually interacted — in which case their preference is preserved.
            if (!hasUserInteractedRef.current && prevDefaultIsExpandedRef.current === true && defaultIsExpanded === false) setIsOpen(false);
            // Auto-expand when defaultIsExpanded changes from false to true (viewport expands)
            // Only expand if user hasn't interacted (to preserve their choice of closing it)
            if (!hasUserInteractedRef.current && prevDefaultIsExpandedRef.current === false && defaultIsExpanded === true) setIsOpen(true);
        } else setIsOpen(defaultIsExpanded);
        prevDefaultIsExpandedRef.current = defaultIsExpanded;
        prevIsInitiallyExpandedRef.current = isInitiallyExpanded;
    }, [
        defaultIsExpanded,
        isInitiallyExpanded
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)($2d40e93801a0fc92$var$AccordionProvider, {
        defaultIsExpanded: defaultIsExpanded,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        displayChevron: displayChevron,
        hasSelection: hasSelection,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                "aria-expanded": isOpen,
                "aria-current": !isOpen && hasSelection,
                id: $2d40e93801a0fc92$var$getComponentId(groupId),
                testId: $2d40e93801a0fc92$var$getComponentId(groupId),
                xcss: $2d40e93801a0fc92$var$accordionPressableStyles,
                onBlur: ()=>setDisplayChevron(false),
                onFocus: ()=>setDisplayChevron(true),
                onMouseOver: ()=>setDisplayChevron(true),
                onMouseLeave: ()=>setDisplayChevron(false),
                onClick: ()=>{
                    const newIsOpen = !isOpen;
                    hasUserInteractedRef.current = true; // Mark that user has interacted
                    setIsOpen(()=>newIsOpen);
                    if (onClick && newIsOpen) onClick(newIsOpen);
                },
                children: triggerComponent
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                role: "list",
                xcss: $2d40e93801a0fc92$var$accordionItemsStyles,
                children: isOpen && children
            })
        ]
    });
};
function $2d40e93801a0fc92$var$AccordionProvider(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)($2d40e93801a0fc92$var$AccordionContext.Provider, {
        value: props,
        children: props.children
    });
}
function $2d40e93801a0fc92$export$35e88b08325f7140() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($2d40e93801a0fc92$var$AccordionContext);
    if (context === undefined) throw new Error('useAccordion must be used within a AccordionContext');
    return context;
}



















var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");














var $bqAtB = parcelRequire("bqAtB");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $416969f577a1507a$exports = {};
$416969f577a1507a$exports = new URL("fps-changeboarding-spotlight.11d55c6d.svg", import.meta.url).toString();












const $e42de015ac3b74e7$var$_default_1 = (0, $aXWIB.defineMessages)({
    gotIt: {
        id: "rovo-onboarding-got-it",
        defaultMessage: "Got it"
    },
    onboardingStep1Heading: {
        id: "rovo-onboarding-step-1-heading",
        defaultMessage: "Search across company apps"
    },
    onboardingStep1Description: {
        id: "rovo-onboarding-step-1-description",
        defaultMessage: "Choose an app to get more relevant results and filters. For example, filter by Space in Confluence."
    }
});
var $e42de015ac3b74e7$export$2e2bcd8739ae039 = $e42de015ac3b74e7$var$_default_1;


const $3c6c42416140d712$var$spotlightAnalyticsPayload = (action, attributes)=>({
        actionSubject: 'rovoChangeboardingSpotlight',
        attributes: {
            additionalAttributes: attributes
        },
        eventType: 'ui',
        action: action
    });
const $3c6c42416140d712$export$8ed1d7c0f0e55b10 = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [spotlight, { dismiss: dismiss }] = (0, $b3bd4a67e85b92b5$export$a771c137b2620ff2)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const renderSpotlight = spotlight.state === 'visible' && availableProducts.length > 0;
    (0, $42omo.useEffect)(()=>{
        if (renderSpotlight) fireAnalyticsEvent($3c6c42416140d712$var$spotlightAnalyticsPayload('view spotlight', {
            step: spotlight.activeSpotlight + 1
        }));
    }, [
        fireAnalyticsEvent,
        renderSpotlight,
        spotlight
    ]);
    if (!renderSpotlight) return null;
    const handleDismiss = ()=>{
        dismiss();
        fireAnalyticsEvent($3c6c42416140d712$var$spotlightAnalyticsPayload('click ok', {
            step: spotlight.activeSpotlight + 1
        }));
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bqAtB.PopoverContent), {
        isVisible: renderSpotlight,
        placement: "left-end",
        shouldDismissOnClickOutside: false,
        dismiss: handleDismiss,
        offset: [
            0,
            4
        ],
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $71521.SpotlightCard), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $aZQ5F.SpotlightHeader), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $bUJpY.SpotlightHeadline), {
                            children: formatMessage((0, $e42de015ac3b74e7$export$2e2bcd8739ae039).onboardingStep1Heading)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $aVS0S.SpotlightControls), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2owmo.SpotlightDismissControl), {
                                onClick: handleDismiss
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fdtRy.SpotlightMedia), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($416969f577a1507a$exports))),
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $f1UQW.SpotlightBody), {
                    children: formatMessage((0, $e42de015ac3b74e7$export$2e2bcd8739ae039).onboardingStep1Description)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $eopLP.SpotlightFooter), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3chlW.SpotlightActions), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fNcP1.SpotlightPrimaryAction), {
                            onClick: handleDismiss,
                            children: formatMessage((0, $e42de015ac3b74e7$export$2e2bcd8739ae039).gotIt)
                        })
                    })
                })
            ]
        })
    });
};


const $8dc422bc1cdea1f9$var$gridOverlapStyles = (0, $ecnYn.xcss)({
    gridRow: 1,
    gridColumn: 1
});
const $8dc422bc1cdea1f9$var$spotlightFillStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.300'
});
const $8dc422bc1cdea1f9$var$isAboveSmBreakpoint = ()=>window.innerWidth > 768;
const $8dc422bc1cdea1f9$export$95d78afe1ba1dce1 = ({ children: children, name: name })=>{
    const [displaySpotlight] = (0, $42omo.useState)($8dc422bc1cdea1f9$var$isAboveSmBreakpoint());
    if (!displaySpotlight) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $k7Tf7.PopoverProvider), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $8dc422bc1cdea1f9$var$gridOverlapStyles,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a90ar.PopoverTarget), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                    xcss: $8dc422bc1cdea1f9$var$spotlightFillStyles
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $8dc422bc1cdea1f9$var$gridOverlapStyles,
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
                    name: "search-page-onboarding-spotlight",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3c6c42416140d712$export$8ed1d7c0f0e55b10), {})
                })
            ]
        })
    });
};





/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
































const $42c79e2f0c046f7e$var$accordionFilterTriggerStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    color: 'color.text',
    gap: 'space.100',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    }
});
// Single-select variant styles
const $42c79e2f0c046f7e$var$accordionFilterTriggerStylesSingleSelect = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    color: 'color.text',
    gap: 'space.075',
    borderRadius: 'radius.small',
    ':hover': {
        background: 'background.neutral.subtle.hovered'
    }
});
const $42c79e2f0c046f7e$var$accordionFilterTriggerSelectedStyles = (0, $ecnYn.xcss)({
    color: 'color.text.accent.blue',
    background: "var(--ds-background-selected, #E9F2FE)",
    ':hover': {
        color: 'color.text.accent.blue',
        background: "var(--ds-background-selected, #E9F2FE)"
    }
}); // Single-select variant selected styles — adds border radius to match the hover state
const $42c79e2f0c046f7e$var$accordionFilterTriggerSelectedStylesSingleSelect = (0, $ecnYn.xcss)({
    color: 'color.text.accent.blue',
    background: "var(--ds-background-selected, #E9F2FE)",
    borderRadius: 'radius.small',
    ':hover': {
        color: 'color.text.accent.blue',
        background: "var(--ds-background-selected, #E9F2FE)"
    }
});
const $42c79e2f0c046f7e$var$iconStyles = (0, $ecnYn.xcss)({
    minWidth: '24px',
    minHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}); // Single-select variant icon styles
const $42c79e2f0c046f7e$var$iconStylesSingleSelect = (0, $ecnYn.xcss)({
    width: 'size.200',
    // 16px
    height: 'size.200',
    // 16px
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}); // Single-select variant chevron wrapper — constrains the chevron SVG to 16px to match app icon size
const $42c79e2f0c046f7e$var$chevronWrapperStylesSingleSelect = (0, $ecnYn.xcss)({
    width: 'size.200',
    // 16px
    height: 'size.200',
    // 16px
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $42c79e2f0c046f7e$var$contentStyles = (0, $ecnYn.xcss)({
    width: '100%',
    flex: 1
});
const $42c79e2f0c046f7e$var$labelStyles = {
    truncated: "_3fcw1q9c _1reo15vq _18m915vq _1bto1l2s _y3gnv2br"
};
const $42c79e2f0c046f7e$export$fd50ae2bcf5da2e1 = ({ icon: icon, label: label, count: count, countLoading: countLoading })=>{
    const { displayChevron: displayChevron, isOpen: isOpen, hasSelection: hasSelection } = (0, $2d40e93801a0fc92$export$35e88b08325f7140)();
    const labelRef = (0, $42omo.useRef)(null);
    const shouldTooltipAppear = ()=>(labelRef.current?.offsetWidth ?? 0) < (labelRef.current?.scrollWidth ?? 0);
    const renderChevron = ()=>{
        // We are reversing the behavior (down arrow if accordian is open, right arrow if accordian is closed) for the Chevron icon in this experiment
        // to match other Atlassian components that use accordion triggers.
        // Note: ChevronIcon size prop does not accept "xsmall", so we wrap in a Box to constrain to 16px to match app icon sizing
        if ((0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select') return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                displayChevron && isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $42c79e2f0c046f7e$var$chevronWrapperStylesSingleSelect,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: "",
                        size: "small"
                    })
                }),
                displayChevron && !isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $42c79e2f0c046f7e$var$chevronWrapperStylesSingleSelect,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        label: "",
                        size: "small"
                    })
                }),
                !displayChevron && icon
            ]
        });
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                displayChevron && isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                    label: "",
                    size: "small"
                }),
                displayChevron && !isOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "",
                    size: "small"
                }),
                !displayChevron && icon
            ]
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $42c79e2f0c046f7e$var$accordionFilterTriggerStylesSingleSelect : $42c79e2f0c046f7e$var$accordionFilterTriggerStyles,
            hasSelection && !isOpen && ((0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $42c79e2f0c046f7e$var$accordionFilterTriggerSelectedStylesSingleSelect : $42c79e2f0c046f7e$var$accordionFilterTriggerSelectedStyles)
        ],
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $42c79e2f0c046f7e$var$iconStylesSingleSelect : $42c79e2f0c046f7e$var$iconStyles,
                "aria-hidden": true,
                children: renderChevron()
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $42c79e2f0c046f7e$var$contentStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: label,
                    delay: 300,
                    canAppear: shouldTooltipAppear,
                    hideTooltipOnClick: true,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                        templateColumns: "1fr max-content",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'space.075' : 'space.100',
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: (0, $1Whri.cx)($42c79e2f0c046f7e$var$labelStyles.truncated),
                                ref: labelRef,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                    color: "inherit",
                                    children: label
                                })
                            }),
                            countLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7b53561762001049$export$d279ab0e61c6c87b), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $d8565f7ad7385d82$export$bb17ebbbeb7ce35d), {
                                count: count,
                                isSelected: hasSelection
                            })
                        ]
                    })
                })
            })
        ]
    });
};













var $4rdL9 = parcelRequire("4rdL9");

var $78e9ef1c2d2db925$export$285cbcdb788689a9 = /*#__PURE__*/ function(Sections) {
    Sections["VISIBLE_PRIMARY_PRODUCTS"] = "visible-primary-products";
    Sections["VISIBLE_PRODUCTS_WITH_RESULTS"] = "visible-products-with-results";
    Sections["VISIBLE_PRODUCTS_TO_AUTH"] = "visible-products-to-auth";
    Sections["HIDDEN_PRODUCTS"] = "hidden-products";
    Sections["NESTED_PRODUCTS"] = "nested-products";
    return Sections;
}({});
const $78e9ef1c2d2db925$var$PRODUCTS_WITH_RESULTS_DISPLAY_LIMIT = 10;
const $78e9ef1c2d2db925$var$PRODUCTS_TO_AUTH_DISPLAY_LIMIT = 3;
const $78e9ef1c2d2db925$var$sortByResultCount = (productResultCountMap)=>(a, b)=>{
        const aCount = productResultCountMap[a];
        const bCount = productResultCountMap[b];
        if (aCount === undefined) return 1;
        if (bCount === undefined) return -1;
        return bCount - aCount;
    };
const $78e9ef1c2d2db925$var$isPrimaryProduct = (productKey, primaryProduct)=>{
    const isAtlas = primaryProduct === (0, $1yEFx.ProductKeys).Atlas;
    if (isAtlas) return productKey === (0, $1yEFx.ProductKeys).Confluence || productKey === (0, $1yEFx.ProductKeys).Jira;
    return productKey === primaryProduct;
};
// Type guard to check if a string is a ProductKeys
function $78e9ef1c2d2db925$var$isProductKey(availableProducts, key) {
    return availableProducts.includes(key);
}
/**
 * Creates an aggregated count map where counts are summed up for individual products and their
 * nested products (e.g. Confluence = Confluence + Confluence DC).
 */ const $78e9ef1c2d2db925$var$createAggregatedCountMap = (productResultCountMap, availableProducts)=>{
    const aggregatedCountMap = {
        ...productResultCountMap
    };
    // For each product category, aggregate counts to the primary product
    Object.values((0, $kjNhq.productCategories)).forEach((categoryConfig)=>{
        const primaryProductKey = categoryConfig.productCategory;
        let aggregatedCount = 0;
        categoryConfig.products.forEach((productKey)=>{
            const count = productResultCountMap[productKey] || 0;
            aggregatedCount += count;
        });
        // Only set aggregated count if the primary product is available
        if (availableProducts.includes(primaryProductKey) && aggregatedCount > 0) aggregatedCountMap[primaryProductKey] = aggregatedCount;
    });
    return aggregatedCountMap;
};
const $78e9ef1c2d2db925$export$53f40d04a46cef05 = ({ primaryProduct: primaryProduct, availableProducts: availableProducts, productResultCountMap: productResultCountMap, thirdPartyConfigs: thirdPartyConfigs, isProductHiddenByUser: isProductHiddenByUser, ignoreCounts: ignoreCounts = false, recommended3pApps: recommended3pApps })=>{
    const sections = new Map([
        [
            "visible-primary-products",
            []
        ],
        [
            "visible-products-with-results",
            []
        ],
        [
            "visible-products-to-auth",
            []
        ],
        [
            "hidden-products",
            []
        ],
        [
            "nested-products",
            []
        ]
    ]);
    const nestedProducts = (0, $4rdL9.getNestedProducts)();
    // Create aggregated count map which reflects both the individual product and nested DC products
    const aggregatedCountMap = $78e9ef1c2d2db925$var$createAggregatedCountMap(productResultCountMap, availableProducts);
    // Separate variable since we need to slice these later up to the limit
    const productsWithResults = [];
    const productsToAuth = [];
    // Iterate over all products and do an initial categorisation into sections.
    // For VISIBLE_PRODUCTS_WITH_RESULTS and VISIBLE_PRODUCTS_TO_AUTH we will do a second pass to enforce limits.
    for (const productKey of availableProducts){
        if ($78e9ef1c2d2db925$var$isPrimaryProduct(productKey, primaryProduct)) sections.get("visible-primary-products").push(productKey);
        else if (isProductHiddenByUser(productKey)) // Check hidden products after primary product check so that primary product is never hidden.
        sections.get("hidden-products").push(productKey);
        else if (nestedProducts.has(productKey)) sections.get("nested-products").push(productKey);
        else if (thirdPartyConfigs[productKey]?.userNeedsOAuth) productsToAuth.push(productKey);
        else if (ignoreCounts || (aggregatedCountMap[productKey] ?? 0) > 0) productsWithResults.push(productKey);
        else sections.get("hidden-products").push(productKey);
    }
    // A util to sort by counts (using aggregated counts)
    const sortByCountIfNeeded = ignoreCounts ? ()=>0 : $78e9ef1c2d2db925$var$sortByResultCount(aggregatedCountMap);
    // Products with results- sort, extract the TOP N and push the overflow to HIDDEN_PRODUCTS
    productsWithResults.sort(sortByCountIfNeeded);
    // TODO: we should include NESTED_PRODUCTS count when calculating how many items to show here
    sections.set("visible-products-with-results", productsWithResults.slice(0, $78e9ef1c2d2db925$var$PRODUCTS_WITH_RESULTS_DISPLAY_LIMIT));
    sections.get("hidden-products").push(...productsWithResults.slice($78e9ef1c2d2db925$var$PRODUCTS_WITH_RESULTS_DISPLAY_LIMIT));
    if (recommended3pApps.length > 0) {
        const recommendedAppsToAuth = recommended3pApps.filter((app)=>$78e9ef1c2d2db925$var$isProductKey(availableProducts, app)).filter((app)=>productsToAuth.includes(app));
        const otherAppsToAuth = productsToAuth.filter((app)=>!recommended3pApps.includes(app));
        const recommendationsAndDefault3pOrder = [
            ...recommendedAppsToAuth,
            ...otherAppsToAuth
        ];
        sections.set("visible-products-to-auth", recommendationsAndDefault3pOrder.slice(0, $78e9ef1c2d2db925$var$PRODUCTS_TO_AUTH_DISPLAY_LIMIT));
        sections.get("hidden-products").push(...recommendationsAndDefault3pOrder.slice($78e9ef1c2d2db925$var$PRODUCTS_TO_AUTH_DISPLAY_LIMIT));
    } else {
        // Products to auth - extract the TOP N and push the overflow to HIDDEN_PRODUCTS
        sections.set("visible-products-to-auth", productsToAuth.slice(0, $78e9ef1c2d2db925$var$PRODUCTS_TO_AUTH_DISPLAY_LIMIT));
        sections.get("hidden-products").push(...productsToAuth.slice($78e9ef1c2d2db925$var$PRODUCTS_TO_AUTH_DISPLAY_LIMIT));
    }
    // Finally sort HIDDEN_PRODUCTS section by count
    sections.get("hidden-products").sort(sortByCountIfNeeded);
    return sections;
};








const $8843d4ad25ded6c5$var$isFederatedEmailProduct = (productKey)=>productKey === (0, $b4tvS.ProductKeys3P).Gmail || productKey === (0, $b4tvS.ProductKeys3P).OutlookMail;
const $8843d4ad25ded6c5$export$40eb42b948e3f793 = ({ productKey: productKey, count: count, hasMoreGmailResults: hasMoreGmailResults, hasMoreOutlookMailResults: hasMoreOutlookMailResults })=>{
    if (!$8843d4ad25ded6c5$var$isFederatedEmailProduct(productKey)) return undefined;
    const isFederatedEmailCountEnabled = productKey === (0, $b4tvS.ProductKeys3P).Gmail ? (0, $dh538.fg)('formula_3p_gmail_result_count') : (0, $dh538.fg)('formula_3p_outlook_result_count');
    if (!isFederatedEmailCountEnabled) return undefined;
    const hasMoreResults = productKey === (0, $b4tvS.ProductKeys3P).Gmail ? hasMoreGmailResults : hasMoreOutlookMailResults;
    if (!hasMoreResults || count === undefined) return undefined;
    return count;
};






var $3IoAL = parcelRequire("3IoAL");




const $ecaec232d474cc0a$var$TRIGGER_HEIGHT_OFFSET = 24;
const $ecaec232d474cc0a$var$dividerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    borderBlockEnd: 'none',
    borderBlockStart: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderInline: 'none',
    marginTop: 'space.075',
    marginBottom: 'space.100'
});
const $ecaec232d474cc0a$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $ecaec232d474cc0a$var$dividerStyles
    });
const $ecaec232d474cc0a$var$sectionHeaderStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.025',
    paddingBottom: 'space.100',
    paddingInline: 'space.050',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
const $ecaec232d474cc0a$var$unconnectedAppsHeaderStyleOverrides = (0, $ecnYn.xcss)({
    paddingTop: 'space.025',
    paddingInline: 'space.050',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 653)"
});
const $ecaec232d474cc0a$var$SectionHeader = ({ children: children, styleOverrides: styleOverrides })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: styleOverrides ?? $ecaec232d474cc0a$var$sectionHeaderStyles,
        children: children
    });
/**
 * Renders a FilterOption wrapped in OAuthWarningWrapper with consistent props.
 * Encapsulates the common pattern used throughout the app filters.
 */ const $ecaec232d474cc0a$var$FilterOptionWithOAuth = ({ option: option, index: index, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, thirdPartyConfigs: thirdPartyConfigs, selectedDatasource: selectedDatasource, isInShowMore: isInShowMore = false })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const isSmartlink = (0, $def8z.isProductSmartlink)({
        productKey: option.value,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const isConnected = (0, $def8z.isProductConnected)(option.value, thirdPartyConfigs);
    const debouncedOnHover = (0, $JQd0k.useDebouncedCallback)((0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $e7b92363a3904b47$export$f9c22828284a3288)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            productKey: option.value,
            isConnected: isConnected,
            index: index,
            isInShowMore: isInShowMore
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        option.value,
        isConnected,
        index,
        isInShowMore
    ]), 500);
    const debouncedOnHoverMenuButton = (0, $JQd0k.useDebouncedCallback)((0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $e7b92363a3904b47$export$27036168f995da84)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            productKey: option.value,
            isConnected: isConnected
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        option.value,
        isConnected
    ]), 500);
    const debouncedOnHoverMenuItem = (0, $JQd0k.useDebouncedCallback)((0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $e7b92363a3904b47$export$8f7e93015eb658b5)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            productKey: option.value,
            isConnected: isConnected
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        option.value,
        isConnected
    ]), 500);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eoZmS.OAuthWarningWrapper), {
        datasourceId: option.datasourceId ?? selectedDatasource?.datasourceId,
        product: option.value,
        trigger: ({ isDisabled: isDisabled, oAuthWarning: oAuthWarning, triggerProps: triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $73f6cd01fde76615$export$2e2bcd8739ae039), {
                oAuthWarning: oAuthWarning,
                triggerProps: triggerProps,
                isDisabled: isDisabled,
                option: option,
                onClick: ()=>{
                    fireAnalyticsEvent((0, $e2036452b566463b$export$189a50cb1d778d89)({
                        commonAttributes: commonAttributes,
                        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                        productKey: option.value,
                        isConnected: isConnected,
                        index: index,
                        isInShowMore: isInShowMore
                    }));
                    option.onSelect();
                },
                onHover: debouncedOnHover,
                onHoverMenuButton: debouncedOnHoverMenuButton,
                onHoverMenuItem: debouncedOnHoverMenuItem,
                onClickMenuItem: (_, action)=>{
                    if (action === 'hide') // onFilterHide in right-panel fires onAppFilterShowHideClicked — no need to fire here too
                    option.hideFilter();
                },
                ariaRole: "listitem"
            }, option.compositeKey ?? option.value),
        index: index,
        useOAuthHandlers: useOAuthHandlers,
        useIsUserOAuthed: useIsUserOAuthed,
        isSmartlink: isSmartlink,
        oAuthSource: (0, $ckkm9.OAuthSource).searchPageFilter,
        thirdPartyConfigs: thirdPartyConfigs,
        option: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? option : undefined,
        skipFlagsProvider: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select'
    });
};
/**
 * Renders an accordion item for nested apps (e.g., Jira, Confluence, JSM with cloud/DC variants).
 */ const $ecaec232d474cc0a$var$AccordionFilterItem = ({ option: option, primaryProduct: primaryProduct, anyConnectedConfluenceDC: anyConnectedConfluenceDC, anyConnectedJiraDC: anyConnectedJiraDC, anyConnectedJsmDC: anyConnectedJsmDC, resultCountsLoading: resultCountsLoading, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, thirdPartyConfigs: thirdPartyConfigs, selectedDatasource: selectedDatasource })=>{
    if (!option.nestedApps || option.nestedApps.length <= 1 || !option.productCategory) return null;
    // Check if accordion children are in the visible slice (for single-select accordion collapse behavior)
    // For single-select: use __hasVisibleChildren metadata set by buildSingleSelectVisibleAndHidden
    // For control/multi-select: fallback to checking if nestedApps exists
    const hasVisibleChildren = (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? option.__hasVisibleChildren ?? false : option.nestedApps && option.nestedApps.length > 1;
    const FilterTriggerIcon = option.productCategory.Icon;
    const hasSelection = option.nestedApps?.find((nestedApp)=>nestedApp?.isSelected)?.isSelected;
    const totalCount = option.nestedApps?.reduce((prev, curr)=>curr.count === undefined ? prev : (prev ?? 0) + curr.count, undefined);
    const accordionCategory = option.productCategory.productCategory;
    let defaultIsExpanded = false;
    let isInitiallyExpanded = false;
    if ((0, $dh538.fg)('rovo-search-right-rail-personalisation')) {
        const isPrimaryProductToExpand = primaryProduct === option.value;
        if ((0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select') {
            // In single-select: defaultIsExpanded is driven by hasVisibleChildren so viewport resize
            // correctly triggers collapse/expand in AccordionItem (prev→now transition).
            // isInitiallyExpanded force-opens the accordion on mount for the primary product,
            // even when hasVisibleChildren=false at a small initial viewport.
            defaultIsExpanded = (!!hasSelection || isPrimaryProductToExpand) && hasVisibleChildren;
            isInitiallyExpanded = isPrimaryProductToExpand || !!hasSelection && hasVisibleChildren;
        } else // Control: preserve original behavior — isPrimaryProductToExpand keeps accordion open
        // regardless of hasVisibleChildren (viewport-agnostic).
        defaultIsExpanded = (hasSelection || isPrimaryProductToExpand) && (hasVisibleChildren || isPrimaryProductToExpand);
    } else {
        const expandConfluenceApps = accordionCategory === (0, $1yEFx.ProductKeys).Confluence && anyConnectedConfluenceDC;
        const expandJiraApps = accordionCategory === (0, $1yEFx.ProductKeys).Jira && anyConnectedJiraDC;
        const expandJSMApps = accordionCategory === (0, $1yEFx.ProductKeys).JiraServiceManagement && anyConnectedJsmDC;
        // Only expand if children are visible to show
        defaultIsExpanded = (hasSelection || expandConfluenceApps || expandJiraApps || expandJSMApps) && hasVisibleChildren;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        role: "listitem",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2d40e93801a0fc92$export$d99097c13d4dac9f), {
            triggerComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $42c79e2f0c046f7e$export$fd50ae2bcf5da2e1), {
                // icons should be xxsmall (16px) in single-select variant
                icon: /*#__PURE__*/ (0, $l998X.jsx)(FilterTriggerIcon, {
                    size: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'xxsmall' : 'small'
                }),
                label: option.productCategory.displayName,
                count: totalCount,
                countLoading: resultCountsLoading
            }),
            groupId: option.value || 'unknown',
            defaultIsExpanded: defaultIsExpanded,
            isInitiallyExpanded: isInitiallyExpanded,
            hasSelection: hasSelection,
            onClick: // For single-select: don't auto-select on expand to avoid re-render/remount
            // For control/multi-select: keep original auto-select behavior
            (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? undefined : (openState)=>{
                if (!openState) return;
                if (option.nestedApps && option.nestedApps.find((nested)=>nested.isSelected)) return;
                option.nestedApps?.[0]?.onSelect();
            },
            children: option.nestedApps && option.nestedApps.length > 1 ? option.nestedApps.map((nestedOption)=>/*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$var$FilterOptionWithOAuth, {
                    option: nestedOption,
                    useOAuthHandlers: useOAuthHandlers,
                    useIsUserOAuthed: useIsUserOAuthed,
                    thirdPartyConfigs: thirdPartyConfigs,
                    selectedDatasource: selectedDatasource
                }, nestedOption.compositeKey ?? nestedOption.value)) : null
        })
    });
};
/**
 * Renders a product option with fanout support.
 * Handles both fanout products (multiple datasources) and regular products.
 */ const $ecaec232d474cc0a$var$ProductOption = ({ option: option, index: index, thirdPartyConfigs: thirdPartyConfigs, selectedProduct: selectedProduct, selectedDatasource: selectedDatasource, onSelectProduct: onSelectProduct, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, allApps: allApps })=>{
    const hasFanout = thirdPartyConfigs[option.value]?.fanOutConnectorSources;
    if (hasFanout) {
        let optionsToRender = (0, $228oz.createFanoutOptions)(option, thirdPartyConfigs, selectedProduct, selectedDatasource, onSelectProduct);
        if (option.value === (0, $1yEFx.ProductKeys).AtlassianWebCrawler && option.value === selectedProduct && selectedDatasource && allApps?.hiddenApps && allApps.hiddenApps.length > 0) optionsToRender = optionsToRender.filter((renderOption)=>renderOption.isSelected);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: optionsToRender.map((renderOption)=>/*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$var$FilterOptionWithOAuth, {
                    option: renderOption,
                    index: index,
                    useOAuthHandlers: useOAuthHandlers,
                    useIsUserOAuthed: useIsUserOAuthed,
                    thirdPartyConfigs: thirdPartyConfigs,
                    selectedDatasource: selectedDatasource
                }, renderOption.compositeKey ?? renderOption.value))
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$var$FilterOptionWithOAuth, {
        option: option,
        index: index,
        useOAuthHandlers: useOAuthHandlers,
        useIsUserOAuthed: useIsUserOAuthed,
        thirdPartyConfigs: thirdPartyConfigs,
        selectedDatasource: selectedDatasource
    });
};
/**
 * Renders a list of product options, handling both accordion items and regular products.
 */ const $ecaec232d474cc0a$var$ProductOptions = ({ options: options, thirdPartyConfigs: thirdPartyConfigs, selectedProduct: selectedProduct, selectedDatasource: selectedDatasource, onSelectProduct: onSelectProduct, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, allApps: allApps, primaryProduct: primaryProduct, anyConnectedConfluenceDC: anyConnectedConfluenceDC, anyConnectedJiraDC: anyConnectedJiraDC, anyConnectedJsmDC: anyConnectedJsmDC, resultCountsLoading: resultCountsLoading })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: options.map((option, index)=>{
            if (option.nestedApps && option.nestedApps.length > 1 && option.productCategory) return /*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$var$AccordionFilterItem, {
                option: option,
                primaryProduct: primaryProduct,
                anyConnectedConfluenceDC: anyConnectedConfluenceDC ?? false,
                anyConnectedJiraDC: anyConnectedJiraDC ?? false,
                anyConnectedJsmDC: anyConnectedJsmDC ?? false,
                resultCountsLoading: resultCountsLoading ?? false,
                useOAuthHandlers: useOAuthHandlers,
                useIsUserOAuthed: useIsUserOAuthed,
                thirdPartyConfigs: thirdPartyConfigs,
                selectedDatasource: selectedDatasource
            }, option.productCategory.productCategory);
            return /*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$var$ProductOption, {
                option: option,
                index: index,
                thirdPartyConfigs: thirdPartyConfigs,
                selectedProduct: selectedProduct,
                selectedDatasource: selectedDatasource,
                onSelectProduct: onSelectProduct,
                useOAuthHandlers: useOAuthHandlers,
                useIsUserOAuthed: useIsUserOAuthed,
                allApps: allApps
            }, option.compositeKey ?? option.value);
        })
    });
/**
 * Trigger component for RovoSettingsModal that renders a FilterOption
 * styled as the "Show all apps" button.
 */ const $ecaec232d474cc0a$var$RovoSettingsModalTrigger = ({ open: open })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $73f6cd01fde76615$export$2e2bcd8739ae039), {
        oAuthWarning: null,
        isDisabled: false,
        isShowMore: true,
        option: {
            label: formatMessage((0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? (0, $c395f352fa4770d3$export$defe85febe8b728c).showAllAppsLabel : (0, $c395f352fa4770d3$export$defe85febe8b728c).showMoreLabel),
            isSelected: false,
            value: undefined
        },
        onClick: ()=>{
            (0, $2OtFZ.triggerExposureForSearchSettingsModalExperiment)();
            open({
                defaultTab: 'discovery'
            });
            fireAnalyticsEvent((0, $4dd72e8bb888f87e$export$1d0e30033014b87d)({
                commonAttributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                isConnected: true,
                section: 'connectApps'
            }));
        }
    });
};
const $ecaec232d474cc0a$export$9b075a47a6ed3f23 = ({ options: options, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, thirdPartyConfigs: thirdPartyConfigs, isConnected: isConnected = true, cloudId: cloudId, primaryProduct: primaryProduct })=>{
    if (!isConnected && cloudId && primaryProduct && (0, $2OtFZ.serveSearchSettingsModalExperiment)({
        fireExperimentExposure: false
    })) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bRblh.RovoSettingsModal), {
        product: primaryProduct,
        cloudId: cloudId,
        surface: (0, $7DldS.RovoSettingsModalSurface).SEARCH_SIDEBAR,
        children: (props)=>/*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$var$RovoSettingsModalTrigger, {
                ...props
            })
    });
    // Fire search experiment exposure for the control cohort at click-time, only
    // when this caller could have rendered the treatment branch above.
    const isEligibleForSearchSettingsModalExperiment = !isConnected && !!cloudId && !!primaryProduct;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $862f29a1de109ab0$export$2e2bcd8739ae039), {
        options: options,
        useIsUserOAuthed: useIsUserOAuthed,
        useOAuthHandlers: useOAuthHandlers,
        thirdPartyConfigs: thirdPartyConfigs,
        oAuthSource: (0, $ckkm9.OAuthSource).searchPageFilter,
        shouldFitContainer: true,
        offset: [
            0,
            -$ecaec232d474cc0a$var$TRIGGER_HEIGHT_OFFSET
        ],
        isConnected: isConnected,
        onTriggerClick: isEligibleForSearchSettingsModalExperiment ? (0, $2OtFZ.triggerExposureForSearchSettingsModalExperiment) : undefined
    });
};
// Single-select variant: keep gray section container background
const $ecaec232d474cc0a$var$connectedAppsContainerStylesSingleSelect = (0, $ecnYn.xcss)({
    background: "var(--ds-surface-sunken, #F8F8F8)",
    borderRadius: "var(--ds-radius-medium, 6px)",
    padding: 'space.150',
    gap: 'space.025',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 'space.150'
});
// Single-select variant: keep gray section container background
const $ecaec232d474cc0a$var$unconnectedAppsContainerStylesSingleSelect = (0, $ecnYn.xcss)({
    background: "var(--ds-surface-sunken, #F8F8F8)",
    borderRadius: "var(--ds-radius-medium, 6px)",
    padding: 'space.150',
    gap: 'space.025',
    display: 'flex',
    flexDirection: 'column'
});
const $ecaec232d474cc0a$var$unconnectedAppsDescriptionStyles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.050'
});
const $ecaec232d474cc0a$export$4fc9b866c5c60225 = (productResultCountMap, searchQuery, selectedProduct)=>{
    // Only some products allow empty queries so we should only return the count for that product
    if (searchQuery === '' && selectedProduct && (0, $b4tvS.productsSupportingEmptyQuery).includes(selectedProduct)) return undefined;
    return Object.keys(productResultCountMap).reduce((count, key)=>count += productResultCountMap[key], 0) || undefined;
};
// Module-level constant to avoid repeated Set creation in render loops
const $ecaec232d474cc0a$var$NOUN_KEYS_SET = new Set(Object.values((0, $4EMbH.NounKeys)));
const $ecaec232d474cc0a$var$MAX_VISIBLE_APP_FILTERS = 15;
// Ceiling for showFilter - allows user to reveal more apps from Show More popup when viewport allows.
// Visibility limits are computed dynamically via getSectionVisibilityLimits for single-select.
const $ecaec232d474cc0a$var$MAX_VISIBLE_APP_FILTERS_SINGLE_SELECT_CEILING = 20;
const $ecaec232d474cc0a$var$getMaxVisibleAppFilters = ()=>{
    // For single-select, visibility uses getSectionVisibilityLimits (viewport-based).
    // This is only used for showFilter ceiling when user reveals an app from Show More.
    if ((0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select') return $ecaec232d474cc0a$var$MAX_VISIBLE_APP_FILTERS_SINGLE_SELECT_CEILING;
    return $ecaec232d474cc0a$var$MAX_VISIBLE_APP_FILTERS;
};
/**
 * Checks if any datasource for a product is connected (doesn't need OAuth)
 * This is a utility function that avoids using hooks in loops
 *
 * NOTE: First-party Atlassian products (like confluence-cloud, jira-cloud) are NOT in thirdPartyConfigs
 * and are considered automatically connected since they don't require OAuth.
 *
 * For third-party products, userNeedsOAuth indicates whether user needs to authenticate:
 * - userNeedsOAuth: true → NOT connected (needs OAuth)
 * - userNeedsOAuth: false → IS connected (OAuth completed)
 */ const $ecaec232d474cc0a$var$hasAnyAuthedDatasource = (productKey, thirdPartyConfigs)=>{
    const productConfig = thirdPartyConfigs[productKey];
    return productConfig?.datasources?.some((ds)=>!ds?.userNeedsOAuth) ?? false;
};
const $ecaec232d474cc0a$export$ca41603276fc834c = ({ onSelectProduct: onSelectProduct, recommended3pApps: recommended3pApps, availableProducts: availableProducts, availableNouns: availableNouns, selectedProduct: selectedProduct, selectedDatasource: selectedDatasource, isNounsAvailable: isNounsAvailable, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, productResultCountMap: productResultCountMap = {}, sidebarStoredState: sidebarStoredState, onFilterHide: onFilterHide, onFilterShow: onFilterShow, thirdPartyConfigs: thirdPartyConfigs, searchQuery: searchQuery, primaryProduct: primaryProduct, cloudId: cloudId, isInitialState: isInitialState, onVisibleProductsToAuthShown: onVisibleProductsToAuthShown, personalisedProductSections: personalisedProductSections, setPersonalisedProductSections: setPersonalisedProductSections, productsWithTimeout: productsWithTimeout, resultCountsLoading: resultCountsLoading, hasMoreGmailResults: hasMoreGmailResults, hasMoreOutlookMailResults: hasMoreOutlookMailResults, setAtlasNoun: setAtlasNoun, setWebPageType: setWebPageType, filterData: filterData })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const products = (0, $1yEFx.useProductConfigs)();
    const [viewportHeight, setViewportHeight] = (0, $42omo.useState)(()=>typeof window !== 'undefined' ? window.innerHeight : 600);
    // Only track viewport for single-select variant (used by getSectionVisibilityLimits)
    (0, $42omo.useEffect)(()=>{
        if (typeof window !== 'undefined' && (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select') return (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: ()=>setViewportHeight(window.innerHeight)
        });
    }, []);
    const visibleFiltersCount = (0, $42omo.useMemo)(()=>{
        return Object.values(sidebarStoredState?.filters ?? {}).filter((filter)=>{
            return filter && typeof filter === 'object' && 'hidden' in filter && !filter.hidden;
        }).length;
    }, [
        sidebarStoredState?.filters
    ]);
    const isProductHiddenByUser = (0, $42omo.useMemo)(()=>(productKey)=>{
            return !!sidebarStoredState?.filters?.[productKey]?.hidden;
        }, [
        sidebarStoredState?.filters
    ]);
    const shouldShowNouns = (0, $42omo.useMemo)(()=>(0, $3bef5f61e3423cb7$export$b63798d81f22734d)(isNounsAvailable, availableNouns, availableProducts), [
        isNounsAvailable,
        availableNouns,
        availableProducts
    ]);
    const productFilters = (0, $42omo.useMemo)(()=>{
        const availableProductsWithoutAtlasAndCustomWebsitesIfNounsAvailable = shouldShowNouns ? availableProducts.filter((key)=>{
            // For single-select: always filter out both Atlas and AtlassianWebCrawler when shouldShowNouns.
            // Nouns (including web pages) are created as separate noun options below, so the product
            // entry must be removed to avoid duplicates (even when fanOutConnectorSources is truthy).
            if ((0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select') return key !== (0, $1yEFx.ProductKeys).Atlas && key !== (0, $1yEFx.ProductKeys).AtlassianWebCrawler;
            // For other cohorts: keep AtlassianWebCrawler if it has fanout (original behavior)
            return thirdPartyConfigs[(0, $1yEFx.ProductKeys).AtlassianWebCrawler]?.fanOutConnectorSources ? key !== (0, $1yEFx.ProductKeys).Atlas : key !== (0, $1yEFx.ProductKeys).Atlas && key !== (0, $1yEFx.ProductKeys).AtlassianWebCrawler;
        }) : availableProducts;
        const createProductOption = (productKey, section)=>{
            const workspaceName = (0, $YqPsE.getWorkspaceNameFromProduct)(productKey, thirdPartyConfigs);
            const isSelected = productKey === selectedProduct && !selectedDatasource;
            // workspaceName is available for Forge connectors and products with displayWorkspaceNameAsProductName
            // Otherwise fall back to displayName from products map
            const label = workspaceName || products[productKey]?.displayName || productKey;
            const count = productResultCountMap[productKey];
            const isPrimaryProduct = productKey === primaryProduct;
            return {
                label: label,
                count: count,
                value: productKey,
                isSelected: isSelected,
                isPrimaryProduct: isPrimaryProduct,
                productCategory: (0, $kjNhq.getCategoryForProduct)(productKey),
                onSelect: ()=>onSelectProduct(productKey),
                hideFilter: ()=>{
                    onFilterHide(productKey);
                    onSelectProduct(undefined);
                },
                showFilter: ()=>{
                    if (visibleFiltersCount >= $ecaec232d474cc0a$var$getMaxVisibleAppFilters()) return;
                    return onFilterShow(productKey);
                },
                resultCountLimit: (0, $8843d4ad25ded6c5$export$40eb42b948e3f793)({
                    productKey: productKey,
                    count: count,
                    hasMoreGmailResults: hasMoreGmailResults,
                    hasMoreOutlookMailResults: hasMoreOutlookMailResults
                }) ?? (productKey === (0, $1yEFx.ProductKeys).Trello ? 30 : undefined),
                section: section,
                countLoading: resultCountsLoading,
                timeout: productsWithTimeout?.includes(productKey)
            };
        };
        const productsOrder = (0, $hrMXM.getProductsOrderByPrimaryProduct)(primaryProduct);
        const availableProductsInDefaultOrder = availableProductsWithoutAtlasAndCustomWebsitesIfNounsAvailable.filter((productKey)=>{
            // Forge connectors are dynamically added and won't be in the static products map
            if ((0, $9d9t8.isForgeConnectorProductKey)(productKey) && (0, $dh538.fg)('rovo-search-dynamic-forge-config')) return true;
            // For hardcoded products, check if they exist in the products map
            return !!products[productKey];
        }).sort((a, b)=>(0, $9ZAVx.getProductOrder)(a, b, productsOrder));
        let productOptions;
        if ((0, $dh538.fg)('rovo-search-right-rail-personalisation')) {
            // Ignore counts if:
            //  - we're in the initial state (to show the default order)
            //  - when counts are missing- we want to fall back to the default order and show all apps
            const ignoreCounts = isInitialState || Object.keys(productResultCountMap).length === 0;
            let productOrderWithDynamicSections = new Map();
            if (!personalisedProductSections) {
                productOrderWithDynamicSections = (0, $78e9ef1c2d2db925$export$53f40d04a46cef05)({
                    primaryProduct: primaryProduct,
                    availableProducts: availableProductsInDefaultOrder,
                    productResultCountMap: productResultCountMap,
                    thirdPartyConfigs: thirdPartyConfigs,
                    isProductHiddenByUser: isProductHiddenByUser,
                    ignoreCounts: ignoreCounts,
                    recommended3pApps: recommended3pApps
                });
                // Store the order of the personalised sections for future use
                // but only after a successful search has been made
                if (!isInitialState) setPersonalisedProductSections?.(productOrderWithDynamicSections);
            } else productOrderWithDynamicSections = personalisedProductSections;
            // Convert to options
            productOptions = Array.from(productOrderWithDynamicSections.entries()).flatMap(([section, products])=>products.map((productKey)=>createProductOption(productKey, section)));
        } else productOptions = availableProductsInDefaultOrder.map((productKey)=>createProductOption(productKey));
        // For single-select cohort: build noun filter options inline so they appear in the
        // connected apps section and respect viewport-based visibility limits like any other app.
        let nounOptions = [];
        if (shouldShowNouns && (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select') {
            const isWebCrawlerAvailable = availableProducts.includes((0, $1yEFx.ProductKeys).AtlassianWebCrawler);
            const NOUNS_ORDER_WITH_WEBCRAWLER = isWebCrawlerAvailable ? (0, $4EMbH.NOUNS_ORDER) : (0, $4EMbH.NOUNS_ORDER).filter((noun)=>noun !== (0, $4EMbH.NounKeys).AtlassianWebCrawler);
            let nounsToDisplay;
            if (!isNounsAvailable) nounsToDisplay = NOUNS_ORDER_WITH_WEBCRAWLER.filter((noun)=>availableNouns.includes(noun) || isWebCrawlerAvailable && noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler);
            else nounsToDisplay = NOUNS_ORDER_WITH_WEBCRAWLER;
            const isAtlasSelected = selectedProduct === (0, $1yEFx.ProductKeys).Atlas;
            nounOptions = nounsToDisplay.map((noun)=>({
                    label: formatMessage((0, $4EMbH.nouns)[noun].displayNamePlural),
                    value: noun,
                    isSelected: noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler ? selectedProduct === (0, $1yEFx.ProductKeys).AtlassianWebCrawler : isAtlasSelected && (filterData?.options.find((option)=>option.queryParamValue === noun)?.isSelected ?? false),
                    count: productResultCountMap[noun],
                    //web crawler is rendered as a noun, but queried as a product
                    onSelect: noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler ? ()=>setWebPageType?.() : ()=>setAtlasNoun?.(noun),
                    hideFilter: ()=>{},
                    showFilter: ()=>{},
                    countLoading: resultCountsLoading
                }));
        }
        return [
            // All filter
            {
                count: $ecaec232d474cc0a$export$4fc9b866c5c60225(productResultCountMap, searchQuery, selectedProduct),
                label: formatMessage((0, $f50a0b647d44470a$export$defe85febe8b728c).allFilterLabel),
                value: undefined,
                isSelected: !selectedProduct,
                productCategory: undefined,
                onSelect: ()=>onSelectProduct(undefined, undefined),
                hideFilter: ()=>{},
                showFilter: ()=>{},
                countLoading: resultCountsLoading
            },
            ...productOptions,
            ...nounOptions
        ];
    }, [
        availableProducts,
        formatMessage,
        onSelectProduct,
        selectedProduct,
        selectedDatasource,
        productResultCountMap,
        onFilterHide,
        onFilterShow,
        thirdPartyConfigs,
        products,
        visibleFiltersCount,
        searchQuery,
        primaryProduct,
        isInitialState,
        isProductHiddenByUser,
        recommended3pApps,
        personalisedProductSections,
        setPersonalisedProductSections,
        productsWithTimeout,
        resultCountsLoading,
        hasMoreGmailResults,
        hasMoreOutlookMailResults,
        shouldShowNouns,
        availableNouns,
        isNounsAvailable,
        filterData,
        setAtlasNoun,
        setWebPageType
    ]);
    const allApps = (0, $42omo.useMemo)(()=>{
        let visibleApps;
        let hiddenApps;
        if ((0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select') {
            const { visibleApps: visibleAppsFull, hiddenApps: hiddenAppsOther } = productFilters.reduce((acc, option)=>{
                const visibility = $ecaec232d474cc0a$export$87241c4456b8fd64(option, sidebarStoredState, acc.visibleApps, onFilterHide, selectedProduct, selectedDatasource, thirdPartyConfigs);
                if (visibility === 'visible') acc.visibleApps.push(option);
                else acc.hiddenApps.push(option);
                return acc;
            }, {
                visibleApps: [],
                hiddenApps: []
            });
            // When shouldShowNouns is true, keep nouns in the visible apps list so they appear
            // inline in the connected apps section and respect viewport-based visibility limits.
            // When shouldShowNouns is false, exclude nouns as before.
            const appsForCategorization = shouldShowNouns ? visibleAppsFull : visibleAppsFull.filter((app)=>app.value === undefined || !$ecaec232d474cc0a$var$NOUN_KEYS_SET.has(app.value));
            const { connectedApps: connectedAppsUnsorted, unconnectedApps: unconnectedApps } = (0, $228oz.categorizeAppsByAuthStatus)({
                visibleApps: appsForCategorization,
                thirdPartyConfigs: thirdPartyConfigs,
                hiddenApps: []
            });
            // Re-sort connectedApps by result count (descending) to ensure proper ranking
            // This is necessary because categorizeAppsByAuthStatus preserves the original order,
            // which may have apps from different sections (e.g., VISIBLE_PRODUCTS_TO_AUTH) mixed in
            const connectedApps = (0, $3IoAL.sortByResultCount)([
                ...connectedAppsUnsorted
            ]);
            const { connectedMax: connectedMax, unconnectedMax: unconnectedMax } = (0, $228oz.getSectionVisibilityLimits)(viewportHeight, {
                connectedCount: connectedApps.length,
                unconnectedCount: unconnectedApps.length
            });
            ({ visibleApps: visibleApps, hiddenApps: hiddenApps } = (0, $228oz.buildSingleSelectVisibleAndHidden)({
                visibleAppsFull: visibleAppsFull,
                connectedApps: connectedApps,
                unconnectedApps: unconnectedApps,
                connectedMax: connectedMax,
                unconnectedMax: unconnectedMax,
                hiddenAppsOther: hiddenAppsOther,
                thirdPartyConfigs: thirdPartyConfigs,
                sidebarStoredState: sidebarStoredState,
                selectedProduct: selectedProduct,
                primaryProduct: primaryProduct
            }));
        } else {
            const reduced = productFilters.reduce((acc, option)=>{
                const visibility = $ecaec232d474cc0a$export$87241c4456b8fd64(option, sidebarStoredState, acc.visibleApps, onFilterHide, selectedProduct, selectedDatasource, thirdPartyConfigs);
                if (visibility === 'visible') acc.visibleApps.push(option);
                else acc.hiddenApps.push(option);
                return acc;
            }, {
                visibleApps: [],
                hiddenApps: []
            });
            visibleApps = reduced.visibleApps;
            hiddenApps = reduced.hiddenApps;
        }
        // Sort hidden apps by result count (descending) so they appear in the correct order in ShowMoreApps popup
        // On page refresh, getProductOrderWithDynamicSections sorts everything upfront, including hidden items.
        // But when a user immediately hides a product, it transitions from visible→hidden with its original ordering,
        // so we must re-sort here to match the refresh behavior.
        (0, $3IoAL.sortByResultCount)(hiddenApps);
        // Note: Special handling for selected datasource is now done in the fanout rendering logic
        // to preserve the original ordering position of the product
        const nestedProducts = (0, $4rdL9.getNestedProducts)();
        const appsToDisplaySet = new Set();
        // For single-select: combine visibleApps and hiddenApps for searching nested children
        // This ensures accordion children are found even when viewport constraints push them to hidden
        // For control/multi-select: only search in visibleApps (original behavior)
        const allAppsForNesting = (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? [
            ...visibleApps,
            ...hiddenApps
        ] : visibleApps;
        const visibleAppsWithCategories = visibleApps.filter((visibleApp)=>visibleApp != null).filter((visibleApp)=>{
            if ((0, $dh538.fg)('rovo-search-right-rail-personalisation')) {
                // Exclude nested products from the main list since they'll be shown within their category.
                // This also means the nested products (eg. DC) will not be shown in the dropdown- only their parent.
                // For single-select: noun options (e.g. 'atlassian-web-crawler') must NOT be excluded even
                // though they appear in productCategories as nested products — they are standalone inline
                // filter options, not accordion children.
                if ($ecaec232d474cc0a$var$NOUN_KEYS_SET.has(visibleApp.value) && (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select') return true;
                return !nestedProducts.has(visibleApp.value);
            }
            return true;
        }).map((visibleApp)=>{
            return {
                ...visibleApp,
                nestedApps: // Populate products within its respective category
                // Single-select: Search in BOTH visible and hidden apps so accordion children are available
                // Control/multi-select: Only search in visible apps (original behavior)
                visibleApp.productCategory?.products.flatMap((productWithinCategory)=>{
                    // For single-select: skip noun values when building accordion children.
                    // Nouns are standalone inline options, not accordion children.
                    if ((0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' && $ecaec232d474cc0a$var$NOUN_KEYS_SET.has(productWithinCategory)) return [];
                    const nestedApp = allAppsForNesting.find((app)=>app && app.value === productWithinCategory);
                    if (!nestedApp) return [];
                    // Apply fanout logic to nested apps to get correct selection state
                    const hasFanout = thirdPartyConfigs[nestedApp.value]?.fanOutConnectorSources;
                    if (hasFanout) {
                        // For fanout products, use the fanout options to get correct selection state
                        const fanoutOptions = (0, $228oz.createFanoutOptions)(nestedApp, thirdPartyConfigs, selectedProduct, selectedDatasource, onSelectProduct);
                        // Otherwise return the first fanout option (which will have the correct base state)
                        return fanoutOptions;
                    }
                    return [
                        nestedApp
                    ];
                }) ?? []
            };
        }).filter((visibleApp)=>{
            // The 'All' case should always be displayed
            if (!visibleApp.value) return true;
            // Don't display apps that are already in a nested category
            if (appsToDisplaySet.has(visibleApp.value)) return false;
            visibleApp.nestedApps.forEach((nestedApp)=>nestedApp?.value && appsToDisplaySet.add(nestedApp.value));
            return true;
        });
        // Apply fanout logic to hidden apps for show more popup
        const hiddenAppsWithFanout = (0, $228oz.applyFanoutToHiddenApps)(hiddenApps, thirdPartyConfigs, selectedProduct, selectedDatasource, onSelectProduct);
        // For single-select: filter nouns from visible apps and return pre-categorized results
        // to avoid re-running categorizeAppsByAuthStatus in groupedAppsBySection.
        // For non-single-select: visibleApps are returned as-is (nouns handled by NounFilters component).
        const filteredVisibleApps = !shouldShowNouns && (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? visibleAppsWithCategories.filter((app)=>app.value === undefined || !$ecaec232d474cc0a$var$NOUN_KEYS_SET.has(app.value)) : visibleAppsWithCategories;
        // Pre-categorize for single-select to avoid double categorization in groupedAppsBySection
        const categorized = (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? (0, $228oz.categorizeAppsByAuthStatus)({
            visibleApps: filteredVisibleApps,
            thirdPartyConfigs: thirdPartyConfigs,
            hiddenApps: hiddenAppsWithFanout
        }) : undefined;
        return {
            visibleApps: filteredVisibleApps,
            hiddenApps: hiddenAppsWithFanout,
            categorized: categorized
        };
    }, [
        productFilters,
        sidebarStoredState,
        onFilterHide,
        thirdPartyConfigs,
        selectedProduct,
        primaryProduct,
        selectedDatasource,
        onSelectProduct,
        viewportHeight,
        shouldShowNouns
    ]);
    onVisibleProductsToAuthShown(allApps.visibleApps.filter((o)=>o !== undefined && o.value !== undefined && o.section === (0, $78e9ef1c2d2db925$export$285cbcdb788689a9).VISIBLE_PRODUCTS_TO_AUTH).map((o)=>o.value).filter((o)=>o !== undefined), recommended3pApps);
    // Memoize the OAuth connection states to avoid recalculating on every render
    const oAuthConnectionStates = (0, $42omo.useMemo)(()=>({
            anyConnectedConfluenceDC: $ecaec232d474cc0a$var$hasAnyAuthedDatasource((0, $1yEFx.ProductKeys).ConfluenceDC, thirdPartyConfigs),
            anyConnectedJiraDC: $ecaec232d474cc0a$var$hasAnyAuthedDatasource((0, $1yEFx.ProductKeys).JiraDC, thirdPartyConfigs),
            anyConnectedJsmDC: $ecaec232d474cc0a$var$hasAnyAuthedDatasource((0, $1yEFx.ProductKeys).JsmDC, thirdPartyConfigs)
        }), [
        thirdPartyConfigs
    ]);
    const { anyConnectedConfluenceDC: anyConnectedConfluenceDC, anyConnectedJiraDC: anyConnectedJiraDC, anyConnectedJsmDC: anyConnectedJsmDC } = oAuthConnectionStates;
    const groupedAppsBySection = (0, $42omo.useMemo)(()=>{
        // For single-select: reuse pre-categorized results from allApps to avoid redundant work
        if (allApps.categorized) return {
            apps: allApps.visibleApps,
            connectedApps: allApps.categorized.connectedApps,
            unconnectedApps: allApps.categorized.unconnectedApps,
            connectedHiddenApps: allApps.categorized.connectedHiddenApps,
            unconnectedHiddenApps: allApps.categorized.unconnectedHiddenApps
        };
        // For non-single-select: categorize here (original behavior)
        const { connectedApps: connectedApps, unconnectedApps: unconnectedApps, unconnectedHiddenApps: unconnectedHiddenApps, connectedHiddenApps: connectedHiddenApps } = (0, $228oz.categorizeAppsByAuthStatus)({
            visibleApps: allApps.visibleApps,
            thirdPartyConfigs: thirdPartyConfigs,
            hiddenApps: allApps.hiddenApps
        });
        return {
            apps: allApps.visibleApps,
            connectedApps: connectedApps,
            unconnectedApps: unconnectedApps,
            connectedHiddenApps: connectedHiddenApps,
            unconnectedHiddenApps: unconnectedHiddenApps
        };
    }, [
        allApps,
        thirdPartyConfigs
    ]);
    // Fires exactly once when results first appear (isInitialState flips false).
    // hasRenderedRef prevents re-firing if deps change after the initial render.
    const hasRenderedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!isInitialState && !hasRenderedRef.current) {
            hasRenderedRef.current = true;
            const numOfFilters = allApps.visibleApps.length;
            const numOfUnconnectedApps = allApps.visibleApps.filter((opt)=>{
                if (!opt?.value) return false;
                const productConfig = thirdPartyConfigs[opt.value];
                return productConfig?.datasources?.some((ds)=>ds?.userNeedsOAuth) ?? false;
            }).length;
            fireAnalyticsEvent((0, $771c2bf7e29ea10c$export$f7577bb728ad6048)({
                commonAttributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                numOfFilters: numOfFilters,
                numOfUnconnectedApps: numOfUnconnectedApps,
                viewportHeight: window.innerHeight,
                viewportWidth: window.innerWidth
            }));
        }
    }, [
        isInitialState,
        allApps,
        thirdPartyConfigs,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-app-filters",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8dc422bc1cdea1f9$export$95d78afe1ba1dce1), {
            name: (0, $f6a925dc3308ab80$export$1b49510872e7246c),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                role: "list",
                children: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' && groupedAppsBySection && groupedAppsBySection.apps.length > 0 ? // New experiment UI with section headers
                [
                    // Render connected apps section with "All" option at the top
                    ...(groupedAppsBySection.connectedApps.length ?? 0) > 0 || allApps.visibleApps.some((app)=>app.value === undefined) ? [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                            xcss: $ecaec232d474cc0a$var$connectedAppsContainerStylesSingleSelect,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$var$SectionHeader, {
                                    children: formatMessage((0, $f50a0b647d44470a$export$defe85febe8b728c).connectedAppsHeader)
                                }, "connected-header"),
                                allApps.visibleApps.filter((app)=>app.value === undefined).map((option, index)=>/*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$var$FilterOptionWithOAuth, {
                                        option: option,
                                        index: index,
                                        useOAuthHandlers: useOAuthHandlers,
                                        useIsUserOAuthed: useIsUserOAuthed,
                                        thirdPartyConfigs: thirdPartyConfigs,
                                        selectedDatasource: selectedDatasource
                                    }, option.value ?? 'all')),
                                /*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$var$ProductOptions, {
                                    options: groupedAppsBySection.connectedApps ?? [],
                                    thirdPartyConfigs: thirdPartyConfigs,
                                    selectedProduct: selectedProduct,
                                    selectedDatasource: selectedDatasource,
                                    onSelectProduct: onSelectProduct,
                                    useOAuthHandlers: useOAuthHandlers,
                                    useIsUserOAuthed: useIsUserOAuthed,
                                    allApps: allApps,
                                    primaryProduct: primaryProduct,
                                    anyConnectedConfluenceDC: anyConnectedConfluenceDC,
                                    anyConnectedJiraDC: anyConnectedJiraDC,
                                    anyConnectedJsmDC: anyConnectedJsmDC,
                                    resultCountsLoading: resultCountsLoading
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$export$9b075a47a6ed3f23, {
                                    options: groupedAppsBySection.connectedHiddenApps,
                                    useIsUserOAuthed: useIsUserOAuthed,
                                    useOAuthHandlers: useOAuthHandlers,
                                    thirdPartyConfigs: thirdPartyConfigs,
                                    isConnected: true,
                                    cloudId: cloudId,
                                    primaryProduct: primaryProduct
                                })
                            ]
                        }, "connected-section")
                    ] : [],
                    // Then render unconnected apps section
                    ...(groupedAppsBySection.unconnectedApps.length ?? 0) > 0 ? [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                            xcss: $ecaec232d474cc0a$var$unconnectedAppsContainerStylesSingleSelect,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$var$SectionHeader, {
                                    styleOverrides: $ecaec232d474cc0a$var$unconnectedAppsHeaderStyleOverrides,
                                    children: formatMessage((0, $f50a0b647d44470a$export$defe85febe8b728c).connectAppsHeader)
                                }, "unconnected-header"),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                    xcss: $ecaec232d474cc0a$var$unconnectedAppsDescriptionStyles,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                        color: "color.text.subtlest",
                                        size: "medium",
                                        weight: "regular",
                                        children: formatMessage((0, $f50a0b647d44470a$export$defe85febe8b728c).connectAppsDescription)
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$var$ProductOptions, {
                                    options: groupedAppsBySection.unconnectedApps ?? [],
                                    thirdPartyConfigs: thirdPartyConfigs,
                                    selectedProduct: selectedProduct,
                                    selectedDatasource: selectedDatasource,
                                    onSelectProduct: onSelectProduct,
                                    useOAuthHandlers: useOAuthHandlers,
                                    useIsUserOAuthed: useIsUserOAuthed,
                                    allApps: allApps,
                                    primaryProduct: primaryProduct,
                                    anyConnectedConfluenceDC: anyConnectedConfluenceDC,
                                    anyConnectedJiraDC: anyConnectedJiraDC,
                                    anyConnectedJsmDC: anyConnectedJsmDC,
                                    resultCountsLoading: resultCountsLoading
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$export$9b075a47a6ed3f23, {
                                    options: groupedAppsBySection.unconnectedHiddenApps,
                                    useIsUserOAuthed: useIsUserOAuthed,
                                    useOAuthHandlers: useOAuthHandlers,
                                    thirdPartyConfigs: thirdPartyConfigs,
                                    isConnected: false,
                                    cloudId: cloudId,
                                    primaryProduct: primaryProduct
                                })
                            ]
                        }, "unconnected-section")
                    ] : []
                ] : // Original UI without section headers
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$var$ProductOptions, {
                            options: allApps.visibleApps,
                            thirdPartyConfigs: thirdPartyConfigs,
                            selectedProduct: selectedProduct,
                            selectedDatasource: selectedDatasource,
                            onSelectProduct: onSelectProduct,
                            useOAuthHandlers: useOAuthHandlers,
                            useIsUserOAuthed: useIsUserOAuthed,
                            allApps: allApps,
                            primaryProduct: primaryProduct,
                            anyConnectedConfluenceDC: anyConnectedConfluenceDC,
                            anyConnectedJiraDC: anyConnectedJiraDC,
                            anyConnectedJsmDC: anyConnectedJsmDC,
                            resultCountsLoading: resultCountsLoading
                        }),
                        (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() !== 'single-select' && /*#__PURE__*/ (0, $l998X.jsx)($ecaec232d474cc0a$export$9b075a47a6ed3f23, {
                            options: allApps.hiddenApps,
                            useIsUserOAuthed: useIsUserOAuthed,
                            useOAuthHandlers: useOAuthHandlers,
                            thirdPartyConfigs: thirdPartyConfigs,
                            cloudId: cloudId,
                            primaryProduct: primaryProduct
                        })
                    ]
                })
            })
        })
    });
};
const $ecaec232d474cc0a$export$87241c4456b8fd64 = (option, sidebarStoredState, visibleApps, onFilterHide, selectedProduct, selectedDatasource, thirdPartyConfigs)=>{
    // Always show "All" option or already selected options
    if (option.label === 'All' || option.isSelected) return 'visible';
    // Check if this product matches the selected product
    if (option.value === selectedProduct) {
        const hasFanout = thirdPartyConfigs?.[option.value]?.fanOutConnectorSources;
        if (hasFanout) // For fanout products, keep the base product visible to maintain ordering
        // The fanout rendering logic will handle showing the selected datasource
        return 'visible';
        else // For regular products, only show if no datasource is selected
        return !selectedDatasource ? 'visible' : 'hidden';
    }
    // Always show primary product in the non-dynamic version of right-rail
    if (option.isPrimaryProduct) return 'visible';
    // Always show products from VISIBLE_PRIMARY_PRODUCTS section
    if (option.section === (0, $78e9ef1c2d2db925$export$285cbcdb788689a9).VISIBLE_PRIMARY_PRODUCTS) return 'visible';
    // Check if the user has manually hidden this option (must be checked before other section visibility)
    if (option.value && sidebarStoredState?.filters?.[option.value]?.hidden) return 'hidden';
    // Logic for the new dynamic sections
    if (option.section === (0, $78e9ef1c2d2db925$export$285cbcdb788689a9).VISIBLE_PRODUCTS_WITH_RESULTS || option.section === (0, $78e9ef1c2d2db925$export$285cbcdb788689a9).VISIBLE_PRODUCTS_TO_AUTH) return 'visible';
    if (option.section === (0, $78e9ef1c2d2db925$export$285cbcdb788689a9).NESTED_PRODUCTS) // Make it visible since it will be rendered within its category.
    return 'visible';
    if (option.section === (0, $78e9ef1c2d2db925$export$285cbcdb788689a9).HIDDEN_PRODUCTS) return 'hidden';
    if (option.value && visibleApps.length > $ecaec232d474cc0a$var$getMaxVisibleAppFilters()) return 'hidden';
    else return 'visible';
};






















var $9zZIW = parcelRequire("9zZIW");













const $5c2e577797240fed$var$dividerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    borderBlockEnd: 'none',
    borderBlockStart: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderInline: 'none',
    marginTop: 'space.075',
    marginBottom: 'space.100'
});
const $5c2e577797240fed$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $5c2e577797240fed$var$dividerStyles
    });
const $5c2e577797240fed$export$ea8986aeb9fc460a = ({ availableProducts: availableProducts, availableNouns: availableNouns, selectedProduct: selectedProduct, setAtlasNoun: setAtlasNoun, setWebPageType: setWebPageType, isNounsAvailable: isNounsAvailable, filterData: filterData, productResultCountMap: productResultCountMap = {}, resultCountsLoading: resultCountsLoading = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const shouldShowNouns = (0, $42omo.useMemo)(()=>{
        if (!isNounsAvailable) return availableNouns.length > 0;
        else return isNounsAvailable;
    }, [
        isNounsAvailable,
        availableNouns
    ]);
    const nounFilters = (0, $42omo.useMemo)(()=>{
        if ((0, $9zZIW.atlassianWebCrawlerConfig).fanOutConnectorSources) {
            const isAtlasSelected = selectedProduct === (0, $1yEFx.ProductKeys).Atlas;
            const isNounSelected = (noun)=>{
                return (isAtlasSelected && filterData?.options.find((option)=>option.queryParamValue === noun)?.isSelected) ?? false;
            };
            let nounsToDisplay;
            if (!isNounsAvailable) nounsToDisplay = (0, $4EMbH.NOUNS_ORDER).filter((noun)=>availableNouns.includes(noun));
            else nounsToDisplay = [
                (0, $4EMbH.NounKeys).goal,
                (0, $4EMbH.NounKeys).project
            ];
            return nounsToDisplay.map((noun)=>({
                    label: formatMessage((0, $4EMbH.nouns)[noun].displayNamePlural),
                    value: noun,
                    isSelected: isNounSelected(noun),
                    onSelect: ()=>setAtlasNoun(noun)
                }));
        } else {
            const isWebCrawlerAvailable = availableProducts.includes((0, $1yEFx.ProductKeys).AtlassianWebCrawler);
            const isAtlasSelected = selectedProduct === (0, $1yEFx.ProductKeys).Atlas;
            const isWebCrawlerSelected = selectedProduct === (0, $1yEFx.ProductKeys).AtlassianWebCrawler;
            const isNounSelected = (noun)=>{
                const result = (isWebCrawlerSelected && noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler || isAtlasSelected && filterData?.options.find((option)=>option.queryParamValue === noun)?.isSelected) ?? false;
                return result;
            };
            const NOUNS_ORDER_WITH_WEBCRAWLER = isWebCrawlerAvailable ? (0, $4EMbH.NOUNS_ORDER) : (0, $4EMbH.NOUNS_ORDER).filter((noun)=>noun !== (0, $4EMbH.NounKeys).AtlassianWebCrawler);
            let atlasNouns;
            let nounsToDisplay;
            if (!isNounsAvailable) {
                atlasNouns = availableNouns;
                nounsToDisplay = NOUNS_ORDER_WITH_WEBCRAWLER.filter((noun)=>atlasNouns.includes(noun) || isWebCrawlerAvailable && noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler);
            } else {
                atlasNouns = [
                    (0, $4EMbH.NounKeys).goal,
                    (0, $4EMbH.NounKeys).project
                ];
                nounsToDisplay = isNounsAvailable ? NOUNS_ORDER_WITH_WEBCRAWLER : isWebCrawlerAvailable ? [
                    (0, $4EMbH.NounKeys).AtlassianWebCrawler
                ] : [];
            }
            const shouldServeNounResultCounts = (0, $2OtFZ.serveNounResultCounts)();
            return nounsToDisplay.map((noun)=>{
                const isSelected = isNounSelected(noun);
                return {
                    label: formatMessage((0, $4EMbH.nouns)[noun].displayNamePlural),
                    value: noun,
                    isSelected: isSelected,
                    count: shouldServeNounResultCounts ? productResultCountMap[noun] : undefined,
                    countLoading: shouldServeNounResultCounts ? resultCountsLoading : false,
                    //web crawler is rendered as a noun, but queried as a product
                    onSelect: noun === (0, $4EMbH.NounKeys).AtlassianWebCrawler ? ()=>setWebPageType() : ()=>setAtlasNoun(noun)
                };
            });
        }
    }, [
        setAtlasNoun,
        setWebPageType,
        isNounsAvailable,
        selectedProduct,
        filterData,
        availableProducts,
        availableNouns,
        formatMessage,
        resultCountsLoading,
        productResultCountMap
    ]);
    if (!shouldShowNouns || !nounFilters.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($5c2e577797240fed$export$2e0a83ec2e27ecbb, {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                role: "list",
                children: nounFilters.map((option, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $73f6cd01fde76615$export$2e2bcd8739ae039), {
                        option: option,
                        onClick: ()=>{
                            fireAnalyticsEvent((0, $e2036452b566463b$export$189a50cb1d778d89)({
                                commonAttributes: commonAttributes,
                                nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                                productKey: option.value,
                                isConnected: true,
                                index: // nouns are always 1p/connected
                                index
                            }));
                            option.onSelect();
                        },
                        onHover: ()=>{
                            if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
                            hoverTimeoutRef.current = setTimeout(()=>{
                                fireAnalyticsEvent((0, $e7b92363a3904b47$export$f9c22828284a3288)({
                                    commonAttributes: commonAttributes,
                                    nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                                    productKey: option.value,
                                    isConnected: true,
                                    index: // nouns are always 1p/connected
                                    index
                                }));
                            }, 500);
                        },
                        ariaRole: "listitem"
                    }, option.value))
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







const $5e9cfc142ef96d2f$var$styles = null;
const $5e9cfc142ef96d2f$var$NAV3_HEIGHT = 56;
const $5e9cfc142ef96d2f$var$NAV4_HEIGHT = 48;
const $5e9cfc142ef96d2f$var$HEADER_FILTER_HEIGHT_WITH_NAV3 = 140;
const $5e9cfc142ef96d2f$var$HEADER_FILTER_HEIGHT_WITH_NAV4 = 76;
const $5e9cfc142ef96d2f$export$f39f3f768bc98e3d = ({ ariaLabel: ariaLabel, testId: testId, children: children })=>{
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const navHeight = isNav4Enabled ? $5e9cfc142ef96d2f$var$NAV4_HEIGHT : $5e9cfc142ef96d2f$var$NAV3_HEIGHT;
    const headerFilterHeight = isNav4Enabled ? $5e9cfc142ef96d2f$var$HEADER_FILTER_HEIGHT_WITH_NAV4 : $5e9cfc142ef96d2f$var$HEADER_FILTER_HEIGHT_WITH_NAV3;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "group",
        "aria-label": ariaLabel,
        "data-testid": testId,
        style: {
            height: `calc(100vh - ${navHeight}px - ${headerFilterHeight}px)`
        },
        className: (0, $gMc0m.default)([
            "_1rjcv47k _18zr1b66 _1e0c1txw _vchhusvi _2lx21bp4 _18m91wug _1reo15vq _1bahv2br"
        ]),
        children: children
    });
};





parcelRequire("42omo");






const $1ee81a6dccb3a778$var$filterOptionListGridAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200',
    width: '100%'
});
const $1ee81a6dccb3a778$var$filterOptionStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    paddingInline: 'space.150'
});
const $1ee81a6dccb3a778$var$baseStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'radius.small'
});
const $1ee81a6dccb3a778$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200'
});
const $1ee81a6dccb3a778$var$contentStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-200, 16px)"
});
const $1ee81a6dccb3a778$var$textStyles = (0, $ecnYn.xcss)({
    flex: 'auto'
});
const $1ee81a6dccb3a778$var$countStyles = (0, $ecnYn.xcss)({
    width: 'size.300'
});
const $1ee81a6dccb3a778$var$FilterOptionSkeleton = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $1ee81a6dccb3a778$var$filterOptionStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $1ee81a6dccb3a778$var$baseStyles,
                    $1ee81a6dccb3a778$var$iconStyles
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $1ee81a6dccb3a778$var$baseStyles,
                    $1ee81a6dccb3a778$var$contentStyles,
                    $1ee81a6dccb3a778$var$textStyles
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $1ee81a6dccb3a778$var$baseStyles,
                    $1ee81a6dccb3a778$var$contentStyles,
                    $1ee81a6dccb3a778$var$countStyles
                ]
            })
        ]
    });
};
const $1ee81a6dccb3a778$export$c597ff09df837ae9 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $1ee81a6dccb3a778$var$filterOptionListGridAreaStyles,
        testId: "app-filter-sidebar-loading",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($1ee81a6dccb3a778$var$FilterOptionSkeleton, {})
        ]
    });
};





parcelRequire("42omo");























const $adfdc67a12688883$export$aa7232f5c0426902 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelFeedbackCancelButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {},
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





const $343ffff5c244722f$export$df7364b615a922fd = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelFeedback`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {},
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });





const $27fcfe3a03486ff0$export$da775e8ea6893f7a = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelFeedbackSubmitButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {},
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });












const $21806c766532a692$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    improveSearch: {
        id: "search-page.app-filter-sidebar.improve-search",
        defaultMessage: "Improve search"
    }
});


const $6f007caa1e941263$var$dividerStyles = (0, $ecnYn.xcss)({
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    height: '1px',
    marginBlock: 'space.075',
    marginInline: 'space.150'
});
const $6f007caa1e941263$var$wrapperStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    gap: 'space.075',
    marginTop: 'space.100',
    paddingBlock: 'space.050',
    paddingLeft: 'space.150'
});
const $6f007caa1e941263$var$feedbackIconContainer = (0, $ecnYn.xcss)({
    padding: 'space.050',
    justifyContent: 'center'
});
const $6f007caa1e941263$export$ae377d31562bc30 = ({ cloudId: cloudId, primaryProduct: primaryProduct, experimentConfig: experimentConfig, selectedProducts: selectedProducts, user: user, appMode: appMode, requestId: requestId, traceId: traceId, isCQL: isCQL })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
        name: "search-page-feedback",
        children: [
            (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() !== 'single-select' && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $6f007caa1e941263$var$dividerStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: [
                    $6f007caa1e941263$var$wrapperStyles
                ],
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $6f007caa1e941263$var$feedbackIconContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))), {
                            color: "currentColor",
                            label: "Give feedback"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        children: formatMessage((0, $21806c766532a692$export$defe85febe8b728c).improveSearch)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cc710e5633c22833$export$2e2bcd8739ae039), {
                        cloudId: cloudId,
                        primaryProduct: primaryProduct,
                        experimentConfig: experimentConfig,
                        selectedProducts: selectedProducts,
                        user: (0, $2x777.getUser)(user),
                        applicationMode: appMode,
                        source: "search-page",
                        appearance: "link",
                        requestId: requestId || '',
                        traceId: traceId || '',
                        isCQL: isCQL,
                        onFeedbackClick: ()=>{
                            fireAnalyticsEvent((0, $343ffff5c244722f$export$df7364b615a922fd)({
                                commonAttributes: commonAttributes,
                                nonPrivacySafeAttributes: nonPrivacySafeAttributes
                            }));
                        },
                        onFeedbackSubmit: ()=>{
                            fireAnalyticsEvent((0, $27fcfe3a03486ff0$export$da775e8ea6893f7a)({
                                commonAttributes: commonAttributes,
                                nonPrivacySafeAttributes: nonPrivacySafeAttributes
                            }));
                        },
                        onFeedbackCancel: ()=>{
                            fireAnalyticsEvent((0, $adfdc67a12688883$export$aa7232f5c0426902)({
                                commonAttributes: commonAttributes,
                                nonPrivacySafeAttributes: nonPrivacySafeAttributes
                            }));
                        }
                    })
                ]
            })
        ]
    });
};











const $ab2e247364ac3575$export$bfc9fede3294c124 = ()=>{
    const [storedState, setStoredState] = (0, $42omo.useState)((0, $5G9KX.getLocalStorageItem)((0, $5iakG.getSearchPageFilterConfigKey)()) || {});
    const setFilterHidden = (0, $42omo.useCallback)((productKey, value)=>{
        const newValue = {
            ...storedState,
            filters: {
                ...storedState?.filters,
                [productKey]: {
                    hidden: value
                }
            }
        };
        setStoredState(newValue);
        (0, $5G9KX.setLocalStorageItem)((0, $5iakG.getSearchPageFilterConfigKey)(), JSON.stringify(newValue));
    }, [
        storedState,
        setStoredState
    ]);
    return [
        storedState,
        {
            setFilterHidden: setFilterHidden
        }
    ];
};








const $871ab8347ae20fda$export$99516ac3f2ff068f = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, productKey: productKey, hidden: hidden, isConnected: isConnected })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}RightPanelAppFilterMenuButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                productKey: productKey,
                hidden: hidden,
                isConnected: isConnected
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });
















const $2315743e23d0a9b4$export$78d8344b0db57ca9 = ({ searchSessionId: searchSessionId, visibleProductsToAuth: visibleProductsToAuth, recommended3pApps: recommended3pApps })=>({
        eventType: 'track',
        actionSubject: 'searchPage',
        action: '3pRecommendationServed',
        attributes: {
            additionalAttributes: {
                searchSessionId: searchSessionId,
                visibleProductsToAuth: visibleProductsToAuth,
                recommended3pApps: recommended3pApps
            }
        }
    });





// Module-level flag so the event fires at most once per page session,
// even if the host component unmounts and remounts (e.g. Relay suspense).
let $4b4d6fff8ba3907a$var$hasFiredThisSession = false;
function $4b4d6fff8ba3907a$export$10276bdacc472670() {
    $4b4d6fff8ba3907a$var$hasFiredThisSession = false;
}
function $4b4d6fff8ba3907a$export$eabd66cde5dba12f(visibleProductsToAuth, recommended3pApps) {
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    // Keep refs to the latest values so the effect fires with current data
    // without re-triggering on every render.
    const fireAnalyticsEventRef = (0, $42omo.useRef)(fireAnalyticsEvent);
    fireAnalyticsEventRef.current = fireAnalyticsEvent;
    const visibleProductsRef = (0, $42omo.useRef)(visibleProductsToAuth);
    visibleProductsRef.current = visibleProductsToAuth;
    const recommended3pAppsRef = (0, $42omo.useRef)(recommended3pApps);
    recommended3pAppsRef.current = recommended3pApps;
    // Fire exactly once per page session, and only after recommended3pApps
    // has been populated (the data loads asynchronously).
    (0, $42omo.useEffect)(()=>{
        if ($4b4d6fff8ba3907a$var$hasFiredThisSession || recommended3pApps.length === 0) return;
        $4b4d6fff8ba3907a$var$hasFiredThisSession = true;
        fireAnalyticsEventRef.current((0, $2315743e23d0a9b4$export$78d8344b0db57ca9)({
            visibleProductsToAuth: visibleProductsRef.current,
            recommended3pApps: recommended3pAppsRef.current
        }));
    }, [
        recommended3pApps
    ]);
}


















const $73bb113f5f79cbc2$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    groupLabel: {
        id: "search-page.app-filter-sidebar.group",
        defaultMessage: "Filter search by app"
    }
});


const $7cc050d1a4a09085$export$98c4d2ac9cd9730 = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5e9cfc142ef96d2f$export$f39f3f768bc98e3d), {
        ariaLabel: formatMessage((0, $73bb113f5f79cbc2$export$defe85febe8b728c).groupLabel),
        "data-testid": "app-filter-sidebar-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1ee81a6dccb3a778$export$c597ff09df837ae9), {})
    });
};
const $7cc050d1a4a09085$export$364a989a35814102 = ({ data: data, cloudId: cloudId, searchQuery: searchQuery, primaryProduct: primaryProduct, experimentConfig: experimentConfig, selectedProducts: selectedProducts, user: user, appMode: appMode, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, availableNouns: availableNouns, selectedProduct: selectedProduct, selectedDatasource: selectedDatasource, isNounsAvailable: isNounsAvailable = false, federatedSlackCount: federatedSlackCount, federatedOutlookMailCount: federatedOutlookMailCount, federatedGmailCount: federatedGmailCount, hasMoreGmailResults: hasMoreGmailResults, hasMoreOutlookMailResults: hasMoreOutlookMailResults, personalisedProductSections: personalisedProductSections, setPersonalisedProductSections: setPersonalisedProductSections, productsWithTimeout: productsWithTimeout, resultCountsLoading: resultCountsLoading })=>{
    (0, $42omo.useEffect)(()=>{
        (0, $2OtFZ.serveNounResultCounts)(true);
        (0, $2OtFZ.serveWebPagesInTypeFilter)(true);
    }, []);
    const totalCounts = data?.search?.results?.totalCounts;
    const productResultCountMap = (0, $42omo.useMemo)(()=>{
        if (!totalCounts) return {};
        const countMap = totalCounts.reduce((prev, { product: product, count: count })=>({
                ...prev,
                [product]: count
            }), {});
        // the backend returns townsquare-goals and townsquare-projects but the
        // frontend expects goal and project, so we need to map them here.
        if ((0, $2OtFZ.serveNounResultCounts)()) {
            if ('townsquare-goal' in countMap) {
                countMap['goal'] = countMap['townsquare-goal'];
                delete countMap['townsquare-goal'];
            }
            if ('townsquare-project' in countMap) {
                countMap['project'] = countMap['townsquare-project'];
                delete countMap['townsquare-project'];
            }
        }
        // Combine passionfruit counts with mercury (Focus product)
        if ('passionfruit' in countMap && (0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled')) {
            countMap['mercury'] = countMap['mercury'] + countMap['passionfruit'];
            delete countMap['passionfruit'];
        }
        // Special handling for Slack: use federatedSlackCount when available
        const isSlackFederatedSearchEnabled = (0, $8RFAN.serveFederatedSlackExperiment)(selectedProduct, undefined, {
            fireExperimentExposure: false
        }, thirdPartyConfigs);
        if (federatedSlackCount !== null && federatedSlackCount !== undefined && 'slack' in countMap && isSlackFederatedSearchEnabled) countMap['slack'] = federatedSlackCount;
        // Special handling for Outlook Mail: use federatedOutlookMailCount when available.
        // Outlook Mail uses the same selected-product federated count behavior as Gmail.
        if (federatedOutlookMailCount !== null && federatedOutlookMailCount !== undefined) countMap['outlook-mail'] = federatedOutlookMailCount;
        // Special handling for Gmail: use federatedGmailCount when available.
        // Gmail is a federated connector (isFederated: true) so it is excluded from thirdPartyFilters
        // in the right panel count query — meaning the aggregator never returns a totalCounts entry
        // for Gmail. We therefore set the count directly without checking 'gmail' in countMap.
        if (federatedGmailCount !== null && federatedGmailCount !== undefined) countMap['gmail'] = federatedGmailCount;
        return countMap;
    }, [
        totalCounts,
        federatedSlackCount,
        federatedOutlookMailCount,
        federatedGmailCount,
        selectedProduct,
        thirdPartyConfigs
    ]);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { selectProductFilter: selectProductFilter, unselectProductFilter: unselectProductFilter, unsafe_setAtlasNouns: unsafe_setAtlasNouns, unsafe_setWebPageType: unsafe_setWebPageType } = (0, $djVCD.useSearchActions)();
    const intercom = (0, $9afb3d504f643405$export$f0fed4b0765d7314)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [universalTypeFilterData] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5iakG.universalTypeFilterId)
    });
    const [filters, { setFilterHidden: setFilterHidden }] = (0, $ab2e247364ac3575$export$bfc9fede3294c124)();
    const { recommended3pApps: recommended3pApps } = (0, $2a8d6d6445842483$export$a718b8eb2c469b45)({
        userId: user?.id,
        showRecommendations: (0, $2OtFZ.serveRightRailRecommendationsImprovementsWithExposure)()
    });
    // In the prequery state (aka initial state), there is no data from the query
    const isInitialState = !data;
    const getIsConnected = (0, $42omo.useCallback)((productKey)=>(0, $def8z.isProductConnected)(productKey, thirdPartyConfigs), [
        thirdPartyConfigs
    ]);
    const onSelectProductWithAnalytics = (0, $42omo.useCallback)((newProduct, datasource)=>{
        if (!newProduct && selectedProduct) {
            unselectProductFilter();
            fireAnalyticsEvent((0, $e2036452b566463b$export$189a50cb1d778d89)({
                commonAttributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                productKey: undefined,
                isConnected: true
            }));
            return;
        }
        selectProductFilter(newProduct, datasource);
        const datasourceId = typeof datasource === 'string' ? datasource : datasource?.datasourceId;
        fireAnalyticsEvent((0, $e2036452b566463b$export$189a50cb1d778d89)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            productKey: newProduct,
            isConnected: getIsConnected(newProduct),
            ...datasourceId && {
                datasourceId: datasourceId
            }
        }));
        if (newProduct && (0, $b4tvS.is3pProductKey)(newProduct)) intercom?.trackEvent('product_filter_clicked_3p', {
            product_filter: newProduct
        });
        else intercom?.trackEvent('product_filter_clicked', {
            product_filter: newProduct
        });
    }, [
        selectedProduct,
        unselectProductFilter,
        selectProductFilter,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        intercom,
        getIsConnected
    ]);
    const appFilterProps = (0, $42omo.useMemo)(()=>({
            searchQuery: searchQuery,
            thirdPartyConfigs: thirdPartyConfigs,
            availableProducts: availableProducts,
            availableNouns: availableNouns,
            selectedProduct: selectedProduct,
            selectedDatasource: selectedDatasource,
            isNounsAvailable: isNounsAvailable,
            primaryProduct: primaryProduct,
            cloudId: cloudId,
            filterData: universalTypeFilterData,
            setAtlasNoun: unsafe_setAtlasNouns,
            setWebPageType: unsafe_setWebPageType,
            onSelectProduct: onSelectProductWithAnalytics,
            productResultCountMap: productResultCountMap ?? {},
            sidebarStoredState: filters,
            onFilterHide: (productKey)=>{
                setFilterHidden(productKey, true);
                fireAnalyticsEvent((0, $871ab8347ae20fda$export$99516ac3f2ff068f)({
                    commonAttributes: commonAttributes,
                    nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                    productKey: productKey,
                    hidden: true,
                    isConnected: getIsConnected(productKey)
                }));
            },
            onFilterShow: (productKey)=>{
                setFilterHidden(productKey, false);
                fireAnalyticsEvent((0, $871ab8347ae20fda$export$99516ac3f2ff068f)({
                    commonAttributes: commonAttributes,
                    nonPrivacySafeAttributes: nonPrivacySafeAttributes,
                    productKey: productKey,
                    hidden: false,
                    isConnected: getIsConnected(productKey)
                }));
            },
            useOAuthHandlers: $gGFxq.useOAuthHandlers,
            useIsUserOAuthed: $gGFxq.useIsUserOAuthed,
            ErrorBoundary: $1nJM3.ErrorBoundary,
            isInitialState: isInitialState,
            recommended3pApps: recommended3pApps,
            onVisibleProductsToAuthShown: (0, $4b4d6fff8ba3907a$export$eabd66cde5dba12f),
            personalisedProductSections: personalisedProductSections,
            setPersonalisedProductSections: setPersonalisedProductSections,
            productsWithTimeout: productsWithTimeout,
            resultCountsLoading: resultCountsLoading,
            hasMoreGmailResults: hasMoreGmailResults,
            hasMoreOutlookMailResults: hasMoreOutlookMailResults
        }), [
        availableProducts,
        availableNouns,
        selectedProduct,
        selectedDatasource,
        onSelectProductWithAnalytics,
        unsafe_setWebPageType,
        isNounsAvailable,
        universalTypeFilterData,
        unsafe_setAtlasNouns,
        productResultCountMap,
        filters,
        setFilterHidden,
        thirdPartyConfigs,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        searchQuery,
        primaryProduct,
        cloudId,
        isInitialState,
        recommended3pApps,
        personalisedProductSections,
        setPersonalisedProductSections,
        productsWithTimeout,
        resultCountsLoading,
        hasMoreGmailResults,
        hasMoreOutlookMailResults,
        getIsConnected
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $5e9cfc142ef96d2f$export$f39f3f768bc98e3d), {
        ariaLabel: formatMessage((0, $73bb113f5f79cbc2$export$defe85febe8b728c).groupLabel),
        "data-testid": "app-filter-sidebar",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $b0ebf52c770dccf7$export$8316e1225e2e8973), {
                fireAnalyticsEvent: fireAnalyticsEvent
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                section: "SearchPageAppFilter",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ecaec232d474cc0a$export$ca41603276fc834c), {
                    ...appFilterProps
                })
            }),
            (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() !== 'single-select' && /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2e577797240fed$export$ea8986aeb9fc460a), {
                ...appFilterProps,
                onSelectProduct: onSelectProductWithAnalytics
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f007caa1e941263$export$ae377d31562bc30), {
                cloudId: cloudId,
                primaryProduct: primaryProduct,
                experimentConfig: experimentConfig,
                selectedProducts: selectedProducts,
                user: user,
                appMode: appMode,
                isCQL: commonAttributes.isCQL
            })
        ]
    });
};
const $7cc050d1a4a09085$export$e37cfb5282d612c2 = ({ rightPanelQuery: rightPanelQuery, ...props })=>{
    const queryData = (0, $irOoi.usePreloadedQuery)((0, $71b133da64a47244$export$2e2bcd8739ae039), rightPanelQuery);
    return /*#__PURE__*/ (0, $l998X.jsx)($7cc050d1a4a09085$export$364a989a35814102, {
        ...props,
        data: queryData
    });
};
const $7cc050d1a4a09085$export$727db389fe32d639 = ({ rightPanelQuery: rightPanelAsyncQueryRef, ...props })=>{
    const queryData = (0, $irOoi.usePreloadedQuery)((0, $2589229aad43bae5$export$2e2bcd8739ae039), rightPanelAsyncQueryRef);
    queryData.search?.results?.isCachedResult;
    return /*#__PURE__*/ (0, $l998X.jsx)($7cc050d1a4a09085$export$364a989a35814102, {
        ...props,
        data: queryData
    });
};
const $7cc050d1a4a09085$export$dbcc7c3a8377a3be = ({ rightPanelQueryRef: rightPanelQueryRef, ...props })=>{
    if ((0, $dh538.fg)('search_async_ssr')) return /*#__PURE__*/ (0, $l998X.jsx)($7cc050d1a4a09085$export$727db389fe32d639, {
        rightPanelQuery: rightPanelQueryRef,
        ...props
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($7cc050d1a4a09085$export$e37cfb5282d612c2, {
        rightPanelQuery: rightPanelQueryRef,
        ...props
    });
};




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 














/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $2o57A = parcelRequire("2o57A");






















var $6mXku = parcelRequire("6mXku");


var $fLkRZ = parcelRequire("fLkRZ");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $342cd0b33ed28a5a$export$ed78826c06dd24e3 = 'fabric-elements';




var $7azCD = parcelRequire("7azCD");

const $e69fce08e3e07faf$export$ee2c4908f4ae34b5 = (urlQueryParams, text)=>{
    return {
        queryHash: (0, $7azCD.sha256)(text || ''),
        queryLength: text?.length || 0,
        referrer: urlQueryParams.referrer
    };
};









var $dHZuf = parcelRequire("dHZuf");


var $aAFSf = parcelRequire("aAFSf");

const $bb92dab26e256d76$var$TEXT_FIELD_JQL_TERM = [
    'textfields',
    'text'
];
const $bb92dab26e256d76$var$trimWildcard = (value)=>{
    if (!value?.length) return;
    const lastChar = value.charAt(value.length - 1);
    if (lastChar === '*') return value.slice(0, -1);
    return value;
};
const $bb92dab26e256d76$export$e4ec0af15895ea7c = (jql)=>{
    try {
        const jast = new (0, $aAFSf.JastBuilder)().build(jql);
        if (!jast.query || !jast.query.where) return undefined;
        const clause = jast.query.where;
        const value = $bb92dab26e256d76$var$findTextFieldValue(clause);
        return $bb92dab26e256d76$var$trimWildcard(value);
    } catch  {
        return undefined;
    }
};
/**
 * Recursively searches a clause for textfields terminal clause
 */ const $bb92dab26e256d76$var$findTextFieldValue = (clause)=>{
    // Handle terminal clause
    if ('clauseType' in clause && clause.clauseType === 'terminal') {
        const terminalClause = clause;
        const fieldName = terminalClause.field?.value?.toLowerCase();
        if ($bb92dab26e256d76$var$TEXT_FIELD_JQL_TERM.includes(fieldName)) {
            // Extract the value from operand
            const operand = terminalClause.operand;
            if (operand && 'value' in operand) return operand.value;
        }
        return undefined;
    }
    // Handle compound clause (AND/OR)
    if ('clauseType' in clause && clause.clauseType === 'compound') {
        const compoundClause = clause;
        const clauses = compoundClause.clauses || [];
        // For AND clauses, look for textfields in any sub-clause
        // For OR clauses, prefer the first textfields value
        for (const subClause of clauses){
            const value = $bb92dab26e256d76$var$findTextFieldValue(subClause);
            if (value !== undefined) return value;
        }
    }
    // Handle NOT clause
    if ('clauseType' in clause && clause.clauseType === 'not') {
        const notClause = clause;
        return $bb92dab26e256d76$var$findTextFieldValue(notClause.clause);
    }
    return undefined;
};


const $eb3fa631425a2020$var$ISSUE_NAVIGATOR = 'issue-navigator';
const $eb3fa631425a2020$var$FULL_PAGE_SEARCH = 'full-page-search';
const $eb3fa631425a2020$var$ROVO_LOCAL_STORAGE_PREFIX_KEY = 'rovo-navigation-filters';
const $eb3fa631425a2020$var$getLocalStorage = ()=>{
    if (typeof window !== 'undefined') return window.localStorage;
};
const $eb3fa631425a2020$var$getFiltersFromLocalStorage = (experience)=>{
    const filters = $eb3fa631425a2020$var$getLocalStorage()?.getItem(`${$eb3fa631425a2020$var$ROVO_LOCAL_STORAGE_PREFIX_KEY}-${experience}`);
    return filters ? JSON.parse(filters) : null;
};
const $eb3fa631425a2020$var$saveFiltersToLocalStorage = (experience, filters)=>{
    $eb3fa631425a2020$var$getLocalStorage()?.setItem(`${$eb3fa631425a2020$var$ROVO_LOCAL_STORAGE_PREFIX_KEY}-${experience}`, JSON.stringify(filters));
};
const $eb3fa631425a2020$var$clearFilters = ()=>{
    $eb3fa631425a2020$var$getLocalStorage()?.removeItem(`${$eb3fa631425a2020$var$ROVO_LOCAL_STORAGE_PREFIX_KEY}-${$eb3fa631425a2020$var$ISSUE_NAVIGATOR}`);
    $eb3fa631425a2020$var$getLocalStorage()?.removeItem(`${$eb3fa631425a2020$var$ROVO_LOCAL_STORAGE_PREFIX_KEY}-${$eb3fa631425a2020$var$FULL_PAGE_SEARCH}`);
};
const $eb3fa631425a2020$var$extractTextFromQueryParams = (experience, queryString)=>experience === $eb3fa631425a2020$var$FULL_PAGE_SEARCH ? queryString.text?.toString() : (0, $bb92dab26e256d76$export$e4ec0af15895ea7c)(queryString.jql?.toString());
const $eb3fa631425a2020$var$syncJqlWithText = (filters, query)=>filters.text ? {
        ...filters,
        text: query || ''
    } : filters;
function $eb3fa631425a2020$export$ceed4c0b7a1f8043({ experience: experience, queryString: queryString, sainJql: sainJql }) {
    // we read the saved filters for the experience that we need to create the link for.
    const filterQueryParams = (0, $42omo.useRef)($eb3fa631425a2020$var$getFiltersFromLocalStorage(experience === $eb3fa631425a2020$var$FULL_PAGE_SEARCH ? $eb3fa631425a2020$var$ISSUE_NAVIGATOR : $eb3fa631425a2020$var$FULL_PAGE_SEARCH));
    const text = (0, $42omo.useMemo)(()=>$eb3fa631425a2020$var$extractTextFromQueryParams(experience, queryString), [
        experience,
        queryString
    ]);
    const initialText = (0, $42omo.useRef)(text);
    const hasTextChanged = text !== initialText.current;
    const issueNavigatorUrl = (0, $42omo.useMemo)(()=>{
        if (experience === $eb3fa631425a2020$var$ISSUE_NAVIGATOR) return '';
        if (sainJql && (0, $dh538.fg)('fps_nin_cta_use_sain_jql')) return `/issues/?jql=${encodeURIComponent(sainJql)}&referrer=search-page`;
        return (0, $dHZuf.generateJiraSearchUrl)(queryString, true, {
            ...hasTextChanged ? {} : filterQueryParams.current,
            referrer: 'search-page'
        }, !(0, $dh538.fg)('rovo_search_update_work_items_link'));
    }, [
        hasTextChanged,
        queryString,
        experience,
        sainJql
    ]);
    const fullPageSearchUrl = (0, $42omo.useMemo)(()=>{
        if (experience === $eb3fa631425a2020$var$FULL_PAGE_SEARCH) return '';
        return (0, $dHZuf.generateJiraSearchUrl)(queryString, false, {
            ...hasTextChanged ? {} : filterQueryParams.current,
            text: text || ''
        });
    }, [
        hasTextChanged,
        queryString,
        text,
        experience
    ]);
    // clear the filters on mount to prevent stale state
    (0, $42omo.useEffect)($eb3fa631425a2020$var$clearFilters, []);
    // Callback to save filters on link click to use it in the other view
    const onRovoNavigate = (0, $42omo.useCallback)(()=>{
        let filters = queryString;
        if (experience === $eb3fa631425a2020$var$ISSUE_NAVIGATOR) filters = $eb3fa631425a2020$var$syncJqlWithText(queryString, text);
        $eb3fa631425a2020$var$saveFiltersToLocalStorage(experience, filters);
    }, [
        experience,
        queryString,
        text
    ]);
    return {
        issueNavigatorUrl: issueNavigatorUrl,
        fullPageSearchUrl: fullPageSearchUrl,
        onRovoNavigate: onRovoNavigate,
        text: text
    };
}





const $7454b174dfb5c37a$var$_default_1 = (0, $aXWIB.defineMessages)({
    searchApps: {
        id: "rovo.search.navigation.buttons.searchApps",
        defaultMessage: "Search all apps"
    },
    viewWorkItems: {
        id: "rovo.search.navigation.buttons.viewWorkItems",
        defaultMessage: "View all work items"
    }
});
var $7454b174dfb5c37a$export$2e2bcd8739ae039 = $7454b174dfb5c37a$var$_default_1;


const $9bf0691eb49d9aac$var$ROVO_NAVIGATION_BUTTON_GNIN_TARGET = 'rovo-navigation-button-gnin';
const $9bf0691eb49d9aac$var$ROVO_NAVIGATION_BUTTON_FPS_TARGET = 'rovo-navigation-button-fps';
const $9bf0691eb49d9aac$var$styles = {
    ninWrapper: "_18u01b66 _2hwx1b66"
};
const $9bf0691eb49d9aac$var$ISSUE_NAVIGATOR = 'issue-navigator';
const $9bf0691eb49d9aac$var$FULL_PAGE_SEARCH = 'full-page-search';
const $9bf0691eb49d9aac$export$268af8ca93822c63 = ({ experience: experience, sainJql: sainJql })=>{
    const [{ query: query }] = (0, $2o57A.useRouter)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fullPageSearchUrl: fullPageSearchUrl, issueNavigatorUrl: issueNavigatorUrl, onRovoNavigate: onRovoNavigate, text: text } = (0, $eb3fa631425a2020$export$ceed4c0b7a1f8043)({
        experience: experience,
        queryString: query,
        sainJql: sainJql
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const ninQueryAnalytics = (0, $42omo.useMemo)(()=>(0, $e69fce08e3e07faf$export$ee2c4908f4ae34b5)(query, text), []); // we only want to use the initial query value in NIN because queryHash needs to remain the same value across the whole experience while a user is on NIN
    const queryAnalytics = (0, $42omo.useMemo)(()=>experience === $9bf0691eb49d9aac$var$FULL_PAGE_SEARCH ? (0, $e69fce08e3e07faf$export$ee2c4908f4ae34b5)(query, text) : ninQueryAnalytics, [
        experience,
        query,
        ninQueryAnalytics,
        text
    ]);
    const handleClick = (0, $42omo.useCallback)(()=>{
        onRovoNavigate();
        createAnalyticsEvent((0, $6957b588b0d16361$export$f47dcf3d531e732f)({
            source: experience === $9bf0691eb49d9aac$var$FULL_PAGE_SEARCH ? 'advancedSearchScreen' : 'globalIssueNavigatorScreen',
            experiment: 'button',
            ...queryAnalytics
        })).fire((0, $342cd0b33ed28a5a$export$ed78826c06dd24e3));
    }, [
        createAnalyticsEvent,
        experience,
        queryAnalytics,
        onRovoNavigate
    ]);
    const showGitHubIcon = (0, $42omo.useMemo)(()=>experience === $9bf0691eb49d9aac$var$ISSUE_NAVIGATOR && (0, $c6GJD.default).getExperimentValue('github_icon_in_jira_all_apps_experiment', 'isEnabled', 'false') === 'true', [
        experience
    ]);
    const { nextViewUrl: nextViewUrl, label: label, iconBefore: iconBefore, iconAfter: iconAfter } = (0, $42omo.useMemo)(()=>{
        if (experience === $9bf0691eb49d9aac$var$ISSUE_NAVIGATOR) return {
            nextViewUrl: fullPageSearchUrl,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jluld))),
            iconAfter: showGitHubIcon ? (0, $fLkRZ.JiraAppSelectorIconWithGithub) : (0, $6mXku.JiraAppSelectorIcon),
            label: (0, $7454b174dfb5c37a$export$2e2bcd8739ae039).searchApps
        };
        return {
            nextViewUrl: issueNavigatorUrl,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))),
            iconAfter: undefined,
            label: (0, $7454b174dfb5c37a$export$2e2bcd8739ae039).viewWorkItems
        };
    }, [
        experience,
        fullPageSearchUrl,
        issueNavigatorUrl,
        showGitHubIcon
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: experience === $9bf0691eb49d9aac$var$FULL_PAGE_SEARCH ? $9bf0691eb49d9aac$var$ROVO_NAVIGATION_BUTTON_FPS_TARGET : $9bf0691eb49d9aac$var$ROVO_NAVIGATION_BUTTON_GNIN_TARGET,
        xcss: experience === $9bf0691eb49d9aac$var$FULL_PAGE_SEARCH ? undefined : $9bf0691eb49d9aac$var$styles.ninWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
            href: nextViewUrl,
            tabIndex: -1,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                iconBefore: iconBefore,
                onClick: handleClick,
                iconAfter: iconAfter,
                children: formatMessage(label)
            })
        })
    });
};









const $41aa6e01ff7ad3e7$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    searchResults: {
        id: "search-page.search-page-header.search-results",
        defaultMessage: "Search results"
    }
});


const $f170baa2e5c0a53b$var$styles = {
    headerStyles: "_zulp1b66 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq _p12f1osq _o5721q9c _ca0qpxbi _u5f3utpp _n3tdu2gc _19bvutpp _b8yq1a8x",
    headerText: "_zulpu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug _19pkze3t _k48pi7a9 _4cvr1h6o _1e0c1txw _1ul9idpf",
    headerTitle: "_k48pwu06 _1o9zidpf",
    headerQuery: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul9idpf _1bto1l2s _o5721q9c"
};
const $f170baa2e5c0a53b$export$89dff4039d0e5c2d = ({ primaryProduct: primaryProduct, query: query })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const sainJql = (0, $ed340a232d40a52e$export$79876d69540370f5)();
    const fpsNinNavigation = (0, $42omo.useMemo)(()=>(0, $26jni.serveJiraNinFpsNavigation)({
            primaryProduct: primaryProduct,
            fireLayerExposure: false,
            locale: locale
        }), [
        primaryProduct,
        locale
    ]);
    if (!(0, $dh538.fg)('fps_nin_cta_use_sain_jql') || fpsNinNavigation?.cohort !== 'button') return null;
    const showQueryInHeader = Boolean(query) && Boolean(fpsNinNavigation.showQueryInHeader);
    const headerLabel = `${formatMessage((0, $41aa6e01ff7ad3e7$export$defe85febe8b728c).searchResults)}${showQueryInHeader ? ':' : ''}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $f170baa2e5c0a53b$var$styles.headerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "h2",
                xcss: $f170baa2e5c0a53b$var$styles.headerText,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $f170baa2e5c0a53b$var$styles.headerTitle,
                        children: headerLabel
                    }),
                    showQueryInHeader && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        xcss: $f170baa2e5c0a53b$var$styles.headerQuery,
                        children: [
                            "'",
                            query,
                            "'"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9bf0691eb49d9aac$export$268af8ca93822c63), {
                experience: "full-page-search",
                sainJql: sainJql
            })
        ]
    });
};


/**
 * @generated SignedSource<<b0b049e1fe6d23bcbf7295a50a6ec5dd>>
 * @relayHash 911ea8af59436c61c5146884cef37a11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1776e4b113d708090cbaac36ccb3643ee9dec1ec98126563d794cebf94db944e

var $5SuoG = parcelRequire("5SuoG");


var $aqtD4 = parcelRequire("aqtD4");


var $4PNBt = parcelRequire("4PNBt");

const $b96117069722906e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "assetsFilters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARI"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "compassFilters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "enableHighlighting"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "expectResult"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentId"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentLayers"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fanoutExperimentCohort"
    }, v14 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAssigneeField"
    }, v15 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeIconUrl"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeJiraLiteModeFields"
    }, v17 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeNavBoostScore"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePassionfruitAsk"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePositions"
    }, v20 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeThirdPartyId"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraFilters"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "mercuryFilters"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryVersion"
    }, v26 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchSessionId"
    }, v27 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v28 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shadowExperimentId"
    }, v29 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v30 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceProduct"
    }, v31 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "talentFilters"
    }, v32 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v33 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "thirdPartyFilters"
    }, v34 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "queryVersion",
                    "variableName": "queryVersion"
                },
                {
                    "kind": "Variable",
                    "name": "searchSessionId",
                    "variableName": "searchSessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sessionId",
                    "variableName": "sessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sourceProduct",
                    "variableName": "sourceProduct"
                }
            ],
            "kind": "ObjectValue",
            "name": "analytics"
        },
        {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
        },
        {
            "kind": "Variable",
            "name": "enableHighlighting",
            "variableName": "enableHighlighting"
        },
        {
            "kind": "Variable",
            "name": "expectResult",
            "variableName": "expectResult"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "experimentId",
                    "variableName": "experimentId"
                },
                {
                    "kind": "Variable",
                    "name": "experimentLayers",
                    "variableName": "experimentLayers"
                },
                {
                    "kind": "Variable",
                    "name": "shadowExperimentId",
                    "variableName": "shadowExperimentId"
                }
            ],
            "kind": "ObjectValue",
            "name": "experimentContext"
        },
        {
            "kind": "Variable",
            "name": "fanoutExperimentCohort",
            "variableName": "fanoutExperimentCohort"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "assetsFilters",
                    "variableName": "assetsFilters"
                },
                {
                    "kind": "Variable",
                    "name": "commonFilters",
                    "variableName": "commonFilters"
                },
                {
                    "kind": "Variable",
                    "name": "compassFilters",
                    "variableName": "compassFilters"
                },
                {
                    "kind": "Variable",
                    "name": "confluenceFilters",
                    "variableName": "confluenceFilters"
                },
                {
                    "kind": "Variable",
                    "name": "entities",
                    "variableName": "entities"
                },
                {
                    "kind": "Variable",
                    "name": "jiraFilters",
                    "variableName": "jiraFilters"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "locations.0",
                            "variableName": "cloudIdARI"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "mercuryFilters",
                    "variableName": "mercuryFilters"
                },
                {
                    "kind": "Variable",
                    "name": "talentFilters",
                    "variableName": "talentFilters"
                },
                {
                    "kind": "Variable",
                    "name": "thirdPartyFilters",
                    "variableName": "thirdPartyFilters"
                }
            ],
            "kind": "ObjectValue",
            "name": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        },
        {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
        }
    ], v35 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v36 = {
        "kind": "ScalarField",
        "name": "id"
    }, v37 = {
        "kind": "ScalarField",
        "name": "description"
    }, v38 = {
        "kind": "ScalarField",
        "name": "connectorType"
    }, v39 = {
        "kind": "ScalarField",
        "name": "title"
    }, v40 = {
        "kind": "ScalarField",
        "name": "url"
    }, v41 = {
        "kind": "ScalarField",
        "name": "type"
    }, v42 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v43 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v44 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v45 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v46 = {
        "kind": "ScalarField",
        "name": "value"
    }, v47 = {
        "kind": "ScalarField",
        "name": "label"
    }, v48 = [
        v47 /*: any*/ 
    ], v49 = {
        "kind": "ScalarField",
        "name": "key"
    }, v50 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v51 = [
        v50 /*: any*/ 
    ], v52 = {
        "condition": "includeIconUrl",
        "kind": "Condition",
        "passingValue": true,
        "selections": v51 /*: any*/ 
    }, v53 = {
        "kind": "ScalarField",
        "name": "name"
    }, v54 = [
        v53 /*: any*/ 
    ], v55 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v56 = {
        "kind": "ScalarField",
        "name": "total"
    }, v57 = [
        v36 /*: any*/ 
    ], v58 = {
        "kind": "InlineFragment",
        "selections": v57 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v59 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v60 = {
        "kind": "ScalarField",
        "name": "email"
    }, v61 = [
        {
            "kind": "ScalarField",
            "name": "jobTitle"
        }
    ], v62 = {
        "args": [
            {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "tenantId"
            }
        ],
        "concreteType": "SocialSignalSearch",
        "kind": "LinkedField",
        "name": "socialSignal",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "signal"
            },
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v35 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v53 /*: any*/ ,
                    v59 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v60 /*: any*/ ,
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": v61 /*: any*/ 
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    },
                    v36 /*: any*/ 
                ]
            }
        ]
    }, v63 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v54 /*: any*/ ,
                "type": "ExternalRepository"
            },
            v58 /*: any*/ 
        ]
    }, v64 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v65 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v64 /*: any*/ ,
                    v40 /*: any*/ ,
                    v43 /*: any*/ 
                ],
                "type": "ExternalSpace"
            },
            v58 /*: any*/ 
        ]
    }, v66 = {
        "kind": "ScalarField",
        "name": "externalId"
    }, v67 = {
        "concreteType": "ThirdPartyUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": v61 /*: any*/ 
    }, v68 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": [
                    v53 /*: any*/ ,
                    v60 /*: any*/ ,
                    v59 /*: any*/ ,
                    v66 /*: any*/ ,
                    v67 /*: any*/ ,
                    v36 /*: any*/ 
                ]
            }
        ]
    }, v69 = [
        v35 /*: any*/ ,
        v53 /*: any*/ ,
        v59 /*: any*/ ,
        v36 /*: any*/ 
    ], v70 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v69 /*: any*/ 
    }, v71 = {
        "kind": "ScalarField",
        "name": "nickname"
    }, v72 = [
        v66 /*: any*/ ,
        v53 /*: any*/ ,
        v71 /*: any*/ ,
        v60 /*: any*/ ,
        v59 /*: any*/ ,
        v67 /*: any*/ ,
        v36 /*: any*/ 
    ], v73 = {
        "concreteType": "ExternalAssociationConnection",
        "kind": "LinkedField",
        "name": "associatedWith",
        "plural": false,
        "selections": [
            {
                "concreteType": "ExternalAssociationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "ExternalAssociation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v72 /*: any*/ ,
                                        "type": "ThirdPartyUser"
                                    },
                                    v58 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": "channelId",
                                                "kind": "ScalarField",
                                                "name": "externalId"
                                            },
                                            v64 /*: any*/ 
                                        ],
                                        "type": "ExternalConversation"
                                    }
                                ]
                            },
                            v36 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v74 = {
        "kind": "ScalarField",
        "name": "thumbnailUrl"
    }, v75 = [
        v36 /*: any*/ ,
        v53 /*: any*/ ,
        v60 /*: any*/ ,
        v59 /*: any*/ ,
        v66 /*: any*/ ,
        v67 /*: any*/ 
    ], v76 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": v75 /*: any*/ 
            },
            {
                "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
                "kind": "LinkedField",
                "name": "linkedUsers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v53 /*: any*/ ,
                                            v59 /*: any*/ ,
                                            v36 /*: any*/ 
                                        ],
                                        "type": "AtlassianAccountUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v57 /*: any*/ ,
                                        "type": "AppUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v57 /*: any*/ ,
                                        "type": "CustomerUser"
                                    }
                                ]
                            },
                            v36 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v77 = [
        v36 /*: any*/ ,
        v53 /*: any*/ 
    ], v78 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v77 /*: any*/ 
    }, v79 = [
        v78 /*: any*/ 
    ], v80 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": v79 /*: any*/ 
    }, v81 = {
        "kind": "ScalarField",
        "name": "memberCount"
    }, v82 = {
        "kind": "ScalarField",
        "name": "status"
    }, v83 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v84 = [
        v53 /*: any*/ ,
        v36 /*: any*/ 
    ], v85 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v84 /*: any*/ 
    }, v86 = [
        v85 /*: any*/ 
    ], v87 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "owners",
        "plural": true,
        "selections": v86 /*: any*/ 
    }, v88 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v86 /*: any*/ 
    }, v89 = [
        v35 /*: any*/ ,
        v53 /*: any*/ ,
        v36 /*: any*/ 
    ], v90 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v89 /*: any*/ 
    }, v91 = [
        v35 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v36 /*: any*/ ,
                v64 /*: any*/ 
            ],
            "type": "ExternalCustomerOrg"
        },
        v58 /*: any*/ 
    ], v92 = [
        v87 /*: any*/ 
    ], v93 = {
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": v91 /*: any*/ 
    }, v94 = [
        {
            "kind": "ScalarField",
            "name": "lastActivityAt"
        },
        {
            "kind": "ScalarField",
            "name": "event"
        }
    ], v95 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "assignee",
        "plural": false,
        "selections": v79 /*: any*/ 
    }, v96 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v79 /*: any*/ 
    }, v97 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v98 = {
        "kind": "ScalarField",
        "name": "workspaceName"
    }, v99 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v100 = {
        "kind": "ScalarField",
        "name": "eventEndTime"
    }, v101 = {
        "kind": "ScalarField",
        "name": "eventStartTime"
    }, v102 = {
        "kind": "ScalarField",
        "name": "videoMeetingUrl"
    }, v103 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "allContributors",
        "plural": true,
        "selections": v72 /*: any*/ 
    }, v104 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "allContributors",
        "plural": true,
        "selections": [
            v53 /*: any*/ ,
            v71 /*: any*/ ,
            v60 /*: any*/ ,
            v59 /*: any*/ ,
            v66 /*: any*/ ,
            v67 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v105 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v106 = [
        v42 /*: any*/ ,
        v50 /*: any*/ 
    ], v107 = [
        {
            "kind": "ScalarField",
            "name": "targetDate"
        },
        {
            "kind": "ScalarField",
            "name": "targetDateType"
        }
    ], v108 = [
        v42 /*: any*/ 
    ], v109 = {
        "concreteType": "AssetsLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "web"
            }
        ]
    }, v110 = {
        "concreteType": "AssetsSchema",
        "kind": "LinkedField",
        "name": "objectSchemaEntity",
        "plural": false,
        "selections": v84 /*: any*/ 
    }, v111 = [
        {
            "kind": "ScalarField",
            "name": "url48"
        }
    ], v112 = [
        v49 /*: any*/ ,
        v36 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                v33 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultsAsyncQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "includeAssigneeField",
                            "variableName": "includeAssigneeField"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeIconUrl",
                            "variableName": "includeIconUrl"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeJiraLiteModeFields",
                            "variableName": "includeJiraLiteModeFields"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeNavBoostScore",
                            "variableName": "includeNavBoostScore"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePassionfruitAsk",
                            "variableName": "includePassionfruitAsk"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePositions",
                            "variableName": "includePositions"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeThirdPartyId",
                            "variableName": "includeThirdPartyId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v24 /*: any*/ ,
                v2 /*: any*/ ,
                v32 /*: any*/ ,
                v22 /*: any*/ ,
                v8 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v21 /*: any*/ ,
                v1 /*: any*/ ,
                v23 /*: any*/ ,
                v31 /*: any*/ ,
                v4 /*: any*/ ,
                v33 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v11 /*: any*/ ,
                v28 /*: any*/ ,
                v12 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v10 /*: any*/ ,
                v7 /*: any*/ ,
                v13 /*: any*/ ,
                v9 /*: any*/ ,
                v15 /*: any*/ ,
                v19 /*: any*/ ,
                v14 /*: any*/ ,
                v20 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v16 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isassetsenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "searchResultsAsyncQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "search",
                            "args": v34 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "asyncSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCachedResult"
                                },
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v35 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                {
                                                    "concreteType": "SearchLinkedResult",
                                                    "kind": "LinkedField",
                                                    "name": "linkedResults",
                                                    "plural": true,
                                                    "selections": [
                                                        v36 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        },
                                                        v38 /*: any*/ ,
                                                        v39 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        v41 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        v45 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isSearchResult"
                                                },
                                                v39 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoal",
                                                            "kind": "LinkedField",
                                                            "name": "goal",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareLocalizationField",
                                                                            "kind": "LinkedField",
                                                                            "name": "localizedLabel",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "messageId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "score"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v48 /*: any*/ 
                                                                },
                                                                v36 /*: any*/ ,
                                                                v49 /*: any*/ ,
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        v52 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasGoal"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isPrivate"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "dueDate",
                                                                    "plural": false,
                                                                    "selections": v48 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareProjectState",
                                                                    "kind": "LinkedField",
                                                                    "name": "state",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v47 /*: any*/ ,
                                                                        v46 /*: any*/ 
                                                                    ]
                                                                },
                                                                v36 /*: any*/ ,
                                                                v49 /*: any*/ 
                                                            ]
                                                        },
                                                        v52 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "SearchFederatedEmailUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "sender",
                                                                            "plural": false,
                                                                            "selections": v54 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "SearchFederatedEmailEntity"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultFederated"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "tier"
                                                        },
                                                        {
                                                            "concreteType": "CompassComponent",
                                                            "kind": "LinkedField",
                                                            "name": "component",
                                                            "plural": false,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                v36 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "ownerId"
                                                        }
                                                    ],
                                                    "type": "SearchResultCompassComponent"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v55 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isVerified"
                                                        },
                                                        {
                                                            "concreteType": "SearchConfluenceResultSpace",
                                                            "kind": "LinkedField",
                                                            "name": "space",
                                                            "plural": false,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v53 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webUiLink"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ConfluenceCommentCountSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "commentCountSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v56 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ConfluenceLikesSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "likesSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "count"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                v58 /*: any*/ 
                                                            ]
                                                        },
                                                        v62 /*: any*/ ,
                                                        v52 /*: any*/ ,
                                                        {
                                                            "condition": "includeNavBoostScore",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "navBoostScore"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v55 /*: any*/ ,
                                                        v52 /*: any*/ 
                                                    ],
                                                    "type": "SearchConfluenceSpace"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "permissionLevel"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v53 /*: any*/ ,
                                                                        v63 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalBranch"
                                                                },
                                                                v58 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v65 /*: any*/ ,
                                                                        v68 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "author",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v70 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v63 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCommit"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v64 /*: any*/ ,
                                                                                        v40 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalSpace"
                                                                                },
                                                                                v58 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalReaction",
                                                                            "kind": "LinkedField",
                                                                            "name": "reactions",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "reactionType"
                                                                                },
                                                                                v56 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "includeThirdPartyId",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "thirdPartyId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDocumentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "type",
                                                                            "plural": false,
                                                                            "selections": v51 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalLargeContent",
                                                                            "kind": "LinkedField",
                                                                            "name": "nonIndexableContent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mediaThumbnailUrl"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "parent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v64 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalDocument"
                                                                                },
                                                                                v58 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v66 /*: any*/ ,
                                                                        v73 /*: any*/ ,
                                                                        v37 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalAttachment",
                                                                            "kind": "LinkedField",
                                                                            "name": "attachments",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v39 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mimeType"
                                                                                },
                                                                                v40 /*: any*/ ,
                                                                                v74 /*: any*/ ,
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v76 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v64 /*: any*/ ,
                                                                                        v80 /*: any*/ ,
                                                                                        v41 /*: any*/ ,
                                                                                        v36 /*: any*/ ,
                                                                                        v81 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "membershipType"
                                                                                        }
                                                                                    ],
                                                                                    "type": "ExternalConversation"
                                                                                },
                                                                                v58 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastActive"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "reactionCount"
                                                                        }
                                                                    ],
                                                                    "type": "ExternalMessage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v37 /*: any*/ ,
                                                                        v64 /*: any*/ ,
                                                                        v81 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "members",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalConversation"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v82 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "endDate"
                                                                        },
                                                                        v83 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v88 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCampaign"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayNumber"
                                                                        },
                                                                        v82 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "closedAt"
                                                                        },
                                                                        v83 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "owners",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v85 /*: any*/ ,
                                                                                v90 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v88 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": v91 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v64 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ExternalUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "contributors",
                                                                                    "plural": true,
                                                                                    "selections": v79 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v92 /*: any*/ 
                                                                        },
                                                                        v93 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalCustomerOrgLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "customerOrgLastActivity",
                                                                            "plural": false,
                                                                            "selections": v94 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerOrg"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "stage"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "dealClosedAt"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDealLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "lastActivity",
                                                                            "plural": false,
                                                                            "selections": v94 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v92 /*: any*/ 
                                                                        },
                                                                        v93 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDeal"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v65 /*: any*/ ,
                                                                        v95 /*: any*/ ,
                                                                        v96 /*: any*/ ,
                                                                        v97 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v82 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalProject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v65 /*: any*/ ,
                                                                        v95 /*: any*/ ,
                                                                        v96 /*: any*/ ,
                                                                        v97 /*: any*/ ,
                                                                        v82 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "team"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalWorkItemProject",
                                                                            "kind": "LinkedField",
                                                                            "name": "workItemProject",
                                                                            "plural": false,
                                                                            "selections": v77 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalProvider",
                                                                            "kind": "LinkedField",
                                                                            "name": "provider",
                                                                            "plural": false,
                                                                            "selections": v54 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalWorkItem"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v39 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastUpdate"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "pullRequestId"
                                                                        },
                                                                        {
                                                                            "alias": "pullRequestStatus",
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        },
                                                                        v63 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "durationInSeconds"
                                                                        },
                                                                        v74 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalChapter",
                                                                            "kind": "LinkedField",
                                                                            "name": "chapters",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v39 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "startTimeInSeconds"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "createdBy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v78 /*: any*/ ,
                                                                                v90 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalVideo"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v36 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        v98 /*: any*/ ,
                                                                        v87 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDashboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v36 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataTableType",
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v98 /*: any*/ ,
                                                                        v87 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDataTable"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountName"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "contactUser",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ThirdPartyUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "thirdPartyUser",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v53 /*: any*/ ,
                                                                                        v67 /*: any*/ ,
                                                                                        v36 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerContact"
                                                                }
                                                            ]
                                                        },
                                                        v99 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v96 /*: any*/ ,
                                                                        v100 /*: any*/ ,
                                                                        v101 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "recurringEventId"
                                                                        },
                                                                        v102 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCalendarEvent"
                                                                },
                                                                v58 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalThumbnail",
                                                                            "kind": "LinkedField",
                                                                            "name": "thumbnail",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDesign"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "SearchResultGraphDocument",
                                                            "kind": "LinkedField",
                                                            "name": "linkedEntities",
                                                            "plural": true,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v39 /*: any*/ ,
                                                                v40 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "entity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v101 /*: any*/ ,
                                                                                v100 /*: any*/ ,
                                                                                v102 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalCalendarEvent"
                                                                        },
                                                                        v58 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v64 /*: any*/ ,
                                                                                v68 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v76 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "container",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v80 /*: any*/ ,
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "ExternalConversation"
                                                                                        },
                                                                                        v58 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v66 /*: any*/ ,
                                                                                v73 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalMessage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalConversation"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "parentId"
                                                                },
                                                                v99 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ThirdPartyUser",
                                                                    "kind": "LinkedField",
                                                                    "name": "initialContributors",
                                                                    "plural": true,
                                                                    "selections": v75 /*: any*/ 
                                                                },
                                                                v103 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v104 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "ThirdPartyUser",
                                                            "kind": "LinkedField",
                                                            "name": "initialContributors",
                                                            "plural": true,
                                                            "selections": [
                                                                v53 /*: any*/ ,
                                                                v59 /*: any*/ ,
                                                                v36 /*: any*/ ,
                                                                v60 /*: any*/ ,
                                                                v66 /*: any*/ ,
                                                                v67 /*: any*/ 
                                                            ]
                                                        },
                                                        v103 /*: any*/ ,
                                                        {
                                                            "concreteType": "SearchResultGraphTab",
                                                            "kind": "LinkedField",
                                                            "name": "tabs",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tabId"
                                                                },
                                                                v39 /*: any*/ ,
                                                                v40 /*: any*/ ,
                                                                v35 /*: any*/ 
                                                            ]
                                                        },
                                                        v98 /*: any*/ ,
                                                        {
                                                            "concreteType": "SearchResultGraphAttachment",
                                                            "kind": "LinkedField",
                                                            "name": "attachments",
                                                            "plural": true,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fileType"
                                                                },
                                                                v40 /*: any*/ ,
                                                                v35 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "containerName"
                                                        },
                                                        v104 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "links"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "linkedEntitiesType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "connectorId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "connectorProduct"
                                                        }
                                                    ],
                                                    "type": "SearchResultGraphDocument"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeAvatarUrl"
                                                                },
                                                                v105 /*: any*/ ,
                                                                v49 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": v84 /*: any*/ 
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "project"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        v53 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": v77 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        v36 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"project\"])"
                                                                },
                                                                {
                                                                    "condition": "includeAssigneeField",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                                            "kind": "LinkedField",
                                                                            "name": "assigneeField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v70 /*: any*/ ,
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "includeJiraLiteModeFields",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraPriorityField",
                                                                            "kind": "LinkedField",
                                                                            "name": "priorityField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraPriority",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priority",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v50 /*: any*/ ,
                                                                                        v53 /*: any*/ ,
                                                                                        v36 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraLabelsField",
                                                                            "kind": "LinkedField",
                                                                            "name": "labelsField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "first",
                                                                                            "value": 5
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "JiraLabelConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedLabelsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraLabelEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraLabel",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": v54 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedLabelsConnection(first:5)"
                                                                                },
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v36 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectKey"
                                                        },
                                                        v42 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v105 /*: any*/ ,
                                                                {
                                                                    "condition": "includeJiraLiteModeFields",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "lead",
                                                                            "plural": false,
                                                                            "selections": v69 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectStyle"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectType"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraProjectCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "category",
                                                                            "plural": false,
                                                                            "selections": v84 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v36 /*: any*/ 
                                                            ]
                                                        },
                                                        v62 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultJiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v106 /*: any*/ ,
                                                    "type": "SearchResultJiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraBoard",
                                                            "kind": "LinkedField",
                                                            "name": "board",
                                                            "plural": false,
                                                            "selections": [
                                                                v50 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardFrontendUrl"
                                                                },
                                                                v36 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v106 /*: any*/ ,
                                                    "type": "SearchResultJiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v106 /*: any*/ ,
                                                    "type": "SearchResultJiraFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v49 /*: any*/ ,
                                                                        v64 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                    "kind": "LinkedField",
                                                                    "name": "health",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v49 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "color"
                                                                        },
                                                                        v64 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MercuryTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v107 /*: any*/ 
                                                                },
                                                                v36 /*: any*/ ,
                                                                v53 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MercuryFocusAreaType",
                                                                    "kind": "LinkedField",
                                                                    "name": "focusAreaType",
                                                                    "plural": false,
                                                                    "selections": v77 /*: any*/ 
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "owner",
                                                                    "plural": false,
                                                                    "selections": v89 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v42 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultMercuryFocusArea"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": v84 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "SearchResultMercuryFocusAreaStatusUpdate"
                                                },
                                                {
                                                    "condition": "includePassionfruitAsk",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SpfAsk",
                                                                    "kind": "LinkedField",
                                                                    "name": "ask",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v82 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "SpfAskTargetDate",
                                                                            "kind": "LinkedField",
                                                                            "name": "targetDate",
                                                                            "plural": false,
                                                                            "selections": v107 /*: any*/ 
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "SearchResultSpfAsk"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v108 /*: any*/ ,
                                                    "type": "SearchResultTrelloBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v108 /*: any*/ ,
                                                    "type": "SearchResultTrelloCard"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsSchema",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectSchemaEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v109 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectSchema"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                v110 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObjectType",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectTypeEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsIcon",
                                                                            "kind": "LinkedField",
                                                                            "name": "icon",
                                                                            "plural": false,
                                                                            "selections": v111 /*: any*/ 
                                                                        },
                                                                        v109 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectType"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                v110 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObject",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": v111 /*: any*/ 
                                                                        },
                                                                        v109 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObject"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "includePositions",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "RadarPosition",
                                                                    "kind": "LinkedField",
                                                                    "name": "position",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "RadarWorker",
                                                                            "kind": "LinkedField",
                                                                            "name": "worker",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "preferredName"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        v59 /*: any*/ ,
                                                                                        v36 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "fieldIdIsIn",
                                                                                    "value": [
                                                                                        "positionId",
                                                                                        "positionStatus",
                                                                                        "positionJobTitle",
                                                                                        "positionPositionTitle",
                                                                                        "positionKey",
                                                                                        "positionExternalPositionKey",
                                                                                        "positionWorker",
                                                                                        "focusArea"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "RadarFieldValueIdPair",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldValues",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldValue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": "stringValue",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "value"
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarStringFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "value",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v53 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "status",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v112 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "health",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v112 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "MercuryFocusArea"
                                                                                                        },
                                                                                                        v58 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarAriFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultTalentPosition"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "SearchQueryInfo",
                                    "kind": "LinkedField",
                                    "name": "queryInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "replacementQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "suggestedQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQueryType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "confidenceScore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldTriggerAutocorrectionExperience"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "traceId"
                                },
                                {
                                    "concreteType": "SearchError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "product"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "integration"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "search",
                            "args": v34 /*: any*/ ,
                            "filters": [
                                "experience",
                                "enableHighlighting",
                                "query",
                                "sort",
                                "disableQueryReplacement",
                                "fanoutExperimentCohort",
                                "expectResult",
                                "filters",
                                "analytics",
                                "experimentContext"
                            ],
                            "handle": "connection",
                            "key": "SearchResultsAsyncPagination__search",
                            "kind": "LinkedHandle",
                            "name": "asyncSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1776e4b113d708090cbaac36ccb3643ee9dec1ec98126563d794cebf94db944e",
            "metadata": {},
            "name": "searchResultsAsyncQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__isassetsenabledrelayprovider": (0, $5SuoG.default),
                "__relay_internal__pv__iscustomerorgownersenabledrelayprovider": (0, $aqtD4.default),
                "__relay_internal__pv__isdealownersenabledrelayprovider": (0, $4PNBt.default)
            }
        }
    };
}();
$b96117069722906e$var$node.hash = "96b39a80beaf0464ae87909b1d40ecc4";
var $b96117069722906e$export$2e2bcd8739ae039 = $b96117069722906e$var$node;



var $atY36 = parcelRequire("atY36");


var $7Ngf7 = parcelRequire("7Ngf7");

/* search-results-lite-table-skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $kpYGL = parcelRequire("kpYGL");

const $2c669b87d30f9508$var$styles = {
    tableWrapper: "_vchhusvi _1bsb1osq _1o9zidpf _c71l1vmz",
    table: "_189eidpf _1e0c5mfb _1kqm1n9t _1bsb1osq _yq5hus1c _btyzidpf",
    thead: "_1e0czh62",
    headerRow: "_1e0c2e77 _4t3i1ylp",
    thFixed: "_1e0cdav6 _s7n4nkob _1bsby1l4 _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi _1doce4h9 _1il9nqa1 _1o3iizff _uwhkidpf _t6vdidpf _hr4jidpf",
    thBase: "_1e0cdav6 _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi _1doce4h9 _1il9nqa1 _1o3iizff _uwhkidpf _t6vdidpf _hr4jidpf",
    tbody: "_1e0c8xuz",
    bodyRow: "_1e0c2e77 _4t3i1ylp",
    tdBase: "_189eidpf _1e0cdav6 _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi",
    cellContent: "_zulpu2gc _1e0c1txw _4cvr1h6o"
};
// Varying text widths so rows look natural, not uniform
const $2c669b87d30f9508$var$WORK_TEXT_WIDTHS = [
    '240px',
    '320px',
    '280px',
    '360px',
    '200px',
    '300px',
    '260px',
    '340px',
    '220px',
    '290px'
];
const $2c669b87d30f9508$var$SkeletonHeaderRow = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("tr", {
        className: (0, $gMc0m.default)([
            $2c669b87d30f9508$var$styles.headerRow
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("th", {
                className: (0, $gMc0m.default)([
                    $2c669b87d30f9508$var$styles.thBase,
                    $2c669b87d30f9508$var$styles.thFixed
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    width: "60px",
                    height: "12px",
                    borderRadius: "var(--ds-radius-full, 9999px)",
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("th", {
                className: (0, $gMc0m.default)([
                    $2c669b87d30f9508$var$styles.thBase
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    width: "48px",
                    height: "12px",
                    borderRadius: "var(--ds-radius-full, 9999px)",
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("th", {
                className: (0, $gMc0m.default)([
                    $2c669b87d30f9508$var$styles.thBase
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    width: "56px",
                    height: "12px",
                    borderRadius: "var(--ds-radius-full, 9999px)",
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("th", {
                className: (0, $gMc0m.default)([
                    $2c669b87d30f9508$var$styles.thBase
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    width: "44px",
                    height: "12px",
                    borderRadius: "var(--ds-radius-full, 9999px)",
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("th", {
                className: (0, $gMc0m.default)([
                    $2c669b87d30f9508$var$styles.thBase
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    width: "48px",
                    height: "12px",
                    borderRadius: "var(--ds-radius-full, 9999px)",
                    isShimmering: true
                })
            })
        ]
    });
const $2c669b87d30f9508$var$SkeletonBodyRow = ({ textWidth: textWidth })=>/*#__PURE__*/ (0, $l998X.jsxs)("tr", {
        className: (0, $gMc0m.default)([
            $2c669b87d30f9508$var$styles.bodyRow
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    $2c669b87d30f9508$var$styles.tdBase
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    className: (0, $gMc0m.default)([
                        $2c669b87d30f9508$var$styles.cellContent
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                            width: "16px",
                            height: "16px",
                            borderRadius: "var(--ds-radius-small, 4px)",
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                            width: textWidth,
                            height: "12px",
                            borderRadius: "var(--ds-radius-full, 9999px)",
                            isShimmering: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    $2c669b87d30f9508$var$styles.tdBase
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    width: "60px",
                    height: "20px",
                    borderRadius: "var(--ds-radius-full, 9999px)",
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    $2c669b87d30f9508$var$styles.tdBase
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    className: (0, $gMc0m.default)([
                        $2c669b87d30f9508$var$styles.cellContent
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                            width: "16px",
                            height: "16px",
                            borderRadius: "var(--ds-radius-full, 9999px)",
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                            width: "64px",
                            height: "12px",
                            borderRadius: "var(--ds-radius-full, 9999px)",
                            isShimmering: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    $2c669b87d30f9508$var$styles.tdBase
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    className: (0, $gMc0m.default)([
                        $2c669b87d30f9508$var$styles.cellContent
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                            width: "16px",
                            height: "16px",
                            borderRadius: "var(--ds-radius-full, 9999px)",
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                            width: "72px",
                            height: "12px",
                            borderRadius: "var(--ds-radius-full, 9999px)",
                            isShimmering: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    $2c669b87d30f9508$var$styles.tdBase
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    width: "16px",
                    height: "16px",
                    borderRadius: "var(--ds-radius-small, 4px)",
                    isShimmering: true
                })
            })
        ]
    });
const $2c669b87d30f9508$export$c34f5bff0276748 = ({ rowCount: rowCount = 10 })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $2c669b87d30f9508$var$styles.tableWrapper
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("table", {
            "data-testid": "search-results-lite-table-skeleton",
            className: (0, $gMc0m.default)([
                $2c669b87d30f9508$var$styles.table
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("thead", {
                    className: (0, $gMc0m.default)([
                        $2c669b87d30f9508$var$styles.thead
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)($2c669b87d30f9508$var$SkeletonHeaderRow, {})
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("tbody", {
                    className: (0, $gMc0m.default)([
                        $2c669b87d30f9508$var$styles.tbody
                    ]),
                    children: Array.from({
                        length: rowCount
                    }).map((_, index)=>/*#__PURE__*/ (0, $l998X.jsx)($2c669b87d30f9508$var$SkeletonBodyRow, {
                            textWidth: $2c669b87d30f9508$var$WORK_TEXT_WIDTHS[index % $2c669b87d30f9508$var$WORK_TEXT_WIDTHS.length]
                        }, index))
                })
            ]
        })
    });





/**
 * @generated SignedSource<<8cb1f525161b8ede6ff08f22e9c0acf2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c64625978af12f02$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "connectorType"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__isassetsenabledrelayprovider"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeAssigneeField"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeIconUrl"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeJiraLiteModeFields"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeNavBoostScore"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includePassionfruitAsk"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includePositions"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeThirdPartyId"
            },
            {
                "kind": "RootArgument",
                "name": "tenantId"
            }
        ],
        "kind": "Fragment",
        "name": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData",
        "selections": [
            {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__typename"
                            },
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "description"
                            },
                            {
                                "concreteType": "SearchLinkedResult",
                                "kind": "LinkedField",
                                "name": "linkedResults",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "category"
                                    },
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "includeAssets",
                                        "variableName": "__relay_internal__pv__isassetsenabledrelayprovider"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeAssigneeField",
                                        "variableName": "includeAssigneeField"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeIconUrl",
                                        "variableName": "includeIconUrl"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeJiraLiteModeFields",
                                        "variableName": "includeJiraLiteModeFields"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeNavBoostScore",
                                        "variableName": "includeNavBoostScore"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includePassionfruitAsk",
                                        "variableName": "includePassionfruitAsk"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includePositions",
                                        "variableName": "includePositions"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeThirdPartyId",
                                        "variableName": "includeThirdPartyId"
                                    }
                                ],
                                "kind": "FragmentSpread",
                                "name": "searchResult_AtlassianSearchPage"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "providerId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "integrationId"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "connectorId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "connectorProduct"
                                    }
                                ],
                                "type": "SearchResultGraphDocument"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "ownerId"
                                    }
                                ],
                                "type": "SearchResultCompassComponent"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "url"
                                    },
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "webUrl"
                                            }
                                        ]
                                    }
                                ],
                                "type": "SearchResultJiraIssue"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "tenantId",
                                                "variableName": "tenantId"
                                            }
                                        ],
                                        "concreteType": "SocialSignalSearch",
                                        "kind": "LinkedField",
                                        "name": "socialSignal",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "signal"
                                            }
                                        ]
                                    }
                                ],
                                "type": "SearchConfluencePageBlogAttachment"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "SearchQueryInfo",
                "kind": "LinkedField",
                "name": "queryInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "originalQuery"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "autoCorrection_AtlassianSearchPage"
                    }
                ]
            },
            {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "traceId"
            },
            {
                "concreteType": "SearchError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "product"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integration"
                    }
                ]
            }
        ],
        "type": "SearchItemConnection"
    };
}();
$c64625978af12f02$var$node.hash = "88d4bfb8a5136fc639a7290cf93798f3";
var $c64625978af12f02$export$2e2bcd8739ae039 = $c64625978af12f02$var$node;


/**
 * @generated SignedSource<<16c9f70a279a09c381dc6022793f8ad7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * @generated SignedSource<<dd8547c70e4da7685c195e859ba0b5c8>>
 * @relayHash b97aa0e27f6b5e7e19ad22feb98e817e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID beef13cc5e249aa240a074cb93e92c0ee04fa89281839765247ac4e3dcaf0c85









const $42955532a44a41ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "assetsFilters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARI"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "compassFilters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "enableHighlighting"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "expectResult"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentId"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentLayers"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fanoutExperimentCohort"
    }, v14 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAssigneeField"
    }, v15 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeIconUrl"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeJiraLiteModeFields"
    }, v17 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeNavBoostScore"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePassionfruitAsk"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePositions"
    }, v20 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeThirdPartyId"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraFilters"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "mercuryFilters"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryVersion"
    }, v26 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchSessionId"
    }, v27 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v28 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shadowExperimentId"
    }, v29 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v30 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceProduct"
    }, v31 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "talentFilters"
    }, v32 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v33 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "thirdPartyFilters"
    }, v34 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "queryVersion",
                    "variableName": "queryVersion"
                },
                {
                    "kind": "Variable",
                    "name": "searchSessionId",
                    "variableName": "searchSessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sessionId",
                    "variableName": "sessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sourceProduct",
                    "variableName": "sourceProduct"
                }
            ],
            "kind": "ObjectValue",
            "name": "analytics"
        },
        {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
        },
        {
            "kind": "Variable",
            "name": "enableHighlighting",
            "variableName": "enableHighlighting"
        },
        {
            "kind": "Variable",
            "name": "expectResult",
            "variableName": "expectResult"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "experimentId",
                    "variableName": "experimentId"
                },
                {
                    "kind": "Variable",
                    "name": "experimentLayers",
                    "variableName": "experimentLayers"
                },
                {
                    "kind": "Variable",
                    "name": "shadowExperimentId",
                    "variableName": "shadowExperimentId"
                }
            ],
            "kind": "ObjectValue",
            "name": "experimentContext"
        },
        {
            "kind": "Variable",
            "name": "fanoutExperimentCohort",
            "variableName": "fanoutExperimentCohort"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "assetsFilters",
                    "variableName": "assetsFilters"
                },
                {
                    "kind": "Variable",
                    "name": "commonFilters",
                    "variableName": "commonFilters"
                },
                {
                    "kind": "Variable",
                    "name": "compassFilters",
                    "variableName": "compassFilters"
                },
                {
                    "kind": "Variable",
                    "name": "confluenceFilters",
                    "variableName": "confluenceFilters"
                },
                {
                    "kind": "Variable",
                    "name": "entities",
                    "variableName": "entities"
                },
                {
                    "kind": "Variable",
                    "name": "jiraFilters",
                    "variableName": "jiraFilters"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "locations.0",
                            "variableName": "cloudIdARI"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "mercuryFilters",
                    "variableName": "mercuryFilters"
                },
                {
                    "kind": "Variable",
                    "name": "talentFilters",
                    "variableName": "talentFilters"
                },
                {
                    "kind": "Variable",
                    "name": "thirdPartyFilters",
                    "variableName": "thirdPartyFilters"
                }
            ],
            "kind": "ObjectValue",
            "name": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        },
        {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
        }
    ], v35 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v36 = {
        "kind": "ScalarField",
        "name": "id"
    }, v37 = {
        "kind": "ScalarField",
        "name": "description"
    }, v38 = {
        "kind": "ScalarField",
        "name": "connectorType"
    }, v39 = {
        "kind": "ScalarField",
        "name": "title"
    }, v40 = {
        "kind": "ScalarField",
        "name": "url"
    }, v41 = {
        "kind": "ScalarField",
        "name": "type"
    }, v42 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v43 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v44 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v45 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v46 = {
        "kind": "ScalarField",
        "name": "value"
    }, v47 = {
        "kind": "ScalarField",
        "name": "label"
    }, v48 = [
        v47 /*: any*/ 
    ], v49 = {
        "kind": "ScalarField",
        "name": "key"
    }, v50 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v51 = [
        v50 /*: any*/ 
    ], v52 = {
        "condition": "includeIconUrl",
        "kind": "Condition",
        "passingValue": true,
        "selections": v51 /*: any*/ 
    }, v53 = {
        "kind": "ScalarField",
        "name": "name"
    }, v54 = [
        v53 /*: any*/ 
    ], v55 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v56 = {
        "kind": "ScalarField",
        "name": "total"
    }, v57 = [
        v36 /*: any*/ 
    ], v58 = {
        "kind": "InlineFragment",
        "selections": v57 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v59 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v60 = {
        "kind": "ScalarField",
        "name": "email"
    }, v61 = [
        {
            "kind": "ScalarField",
            "name": "jobTitle"
        }
    ], v62 = {
        "args": [
            {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "tenantId"
            }
        ],
        "concreteType": "SocialSignalSearch",
        "kind": "LinkedField",
        "name": "socialSignal",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "signal"
            },
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v35 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v53 /*: any*/ ,
                    v59 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v60 /*: any*/ ,
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": v61 /*: any*/ 
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    },
                    v36 /*: any*/ 
                ]
            }
        ]
    }, v63 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v54 /*: any*/ ,
                "type": "ExternalRepository"
            },
            v58 /*: any*/ 
        ]
    }, v64 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v65 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v64 /*: any*/ ,
                    v40 /*: any*/ ,
                    v43 /*: any*/ 
                ],
                "type": "ExternalSpace"
            },
            v58 /*: any*/ 
        ]
    }, v66 = {
        "kind": "ScalarField",
        "name": "externalId"
    }, v67 = {
        "concreteType": "ThirdPartyUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": v61 /*: any*/ 
    }, v68 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": [
                    v53 /*: any*/ ,
                    v60 /*: any*/ ,
                    v59 /*: any*/ ,
                    v66 /*: any*/ ,
                    v67 /*: any*/ ,
                    v36 /*: any*/ 
                ]
            }
        ]
    }, v69 = [
        v35 /*: any*/ ,
        v53 /*: any*/ ,
        v59 /*: any*/ ,
        v36 /*: any*/ 
    ], v70 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v69 /*: any*/ 
    }, v71 = {
        "kind": "ScalarField",
        "name": "nickname"
    }, v72 = [
        v66 /*: any*/ ,
        v53 /*: any*/ ,
        v71 /*: any*/ ,
        v60 /*: any*/ ,
        v59 /*: any*/ ,
        v67 /*: any*/ ,
        v36 /*: any*/ 
    ], v73 = {
        "concreteType": "ExternalAssociationConnection",
        "kind": "LinkedField",
        "name": "associatedWith",
        "plural": false,
        "selections": [
            {
                "concreteType": "ExternalAssociationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "ExternalAssociation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v72 /*: any*/ ,
                                        "type": "ThirdPartyUser"
                                    },
                                    v58 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": "channelId",
                                                "kind": "ScalarField",
                                                "name": "externalId"
                                            },
                                            v64 /*: any*/ 
                                        ],
                                        "type": "ExternalConversation"
                                    }
                                ]
                            },
                            v36 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v74 = {
        "kind": "ScalarField",
        "name": "thumbnailUrl"
    }, v75 = [
        v36 /*: any*/ ,
        v53 /*: any*/ ,
        v60 /*: any*/ ,
        v59 /*: any*/ ,
        v66 /*: any*/ ,
        v67 /*: any*/ 
    ], v76 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": v75 /*: any*/ 
            },
            {
                "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
                "kind": "LinkedField",
                "name": "linkedUsers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v35 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v53 /*: any*/ ,
                                            v59 /*: any*/ ,
                                            v36 /*: any*/ 
                                        ],
                                        "type": "AtlassianAccountUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v57 /*: any*/ ,
                                        "type": "AppUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v57 /*: any*/ ,
                                        "type": "CustomerUser"
                                    }
                                ]
                            },
                            v36 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v77 = [
        v36 /*: any*/ ,
        v53 /*: any*/ 
    ], v78 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v77 /*: any*/ 
    }, v79 = [
        v78 /*: any*/ 
    ], v80 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": v79 /*: any*/ 
    }, v81 = {
        "kind": "ScalarField",
        "name": "memberCount"
    }, v82 = {
        "kind": "ScalarField",
        "name": "status"
    }, v83 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v84 = [
        v53 /*: any*/ ,
        v36 /*: any*/ 
    ], v85 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v84 /*: any*/ 
    }, v86 = [
        v85 /*: any*/ 
    ], v87 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "owners",
        "plural": true,
        "selections": v86 /*: any*/ 
    }, v88 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v86 /*: any*/ 
    }, v89 = [
        v35 /*: any*/ ,
        v53 /*: any*/ ,
        v36 /*: any*/ 
    ], v90 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v89 /*: any*/ 
    }, v91 = [
        v35 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v36 /*: any*/ ,
                v64 /*: any*/ 
            ],
            "type": "ExternalCustomerOrg"
        },
        v58 /*: any*/ 
    ], v92 = [
        v87 /*: any*/ 
    ], v93 = {
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": v91 /*: any*/ 
    }, v94 = [
        {
            "kind": "ScalarField",
            "name": "lastActivityAt"
        },
        {
            "kind": "ScalarField",
            "name": "event"
        }
    ], v95 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "assignee",
        "plural": false,
        "selections": v79 /*: any*/ 
    }, v96 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v79 /*: any*/ 
    }, v97 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v98 = {
        "kind": "ScalarField",
        "name": "workspaceName"
    }, v99 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v100 = {
        "kind": "ScalarField",
        "name": "eventEndTime"
    }, v101 = {
        "kind": "ScalarField",
        "name": "eventStartTime"
    }, v102 = {
        "kind": "ScalarField",
        "name": "videoMeetingUrl"
    }, v103 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "allContributors",
        "plural": true,
        "selections": v72 /*: any*/ 
    }, v104 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "allContributors",
        "plural": true,
        "selections": [
            v53 /*: any*/ ,
            v71 /*: any*/ ,
            v60 /*: any*/ ,
            v59 /*: any*/ ,
            v66 /*: any*/ ,
            v67 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v105 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v106 = [
        v42 /*: any*/ ,
        v50 /*: any*/ 
    ], v107 = [
        {
            "kind": "ScalarField",
            "name": "targetDate"
        },
        {
            "kind": "ScalarField",
            "name": "targetDateType"
        }
    ], v108 = [
        v42 /*: any*/ 
    ], v109 = {
        "concreteType": "AssetsLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "web"
            }
        ]
    }, v110 = {
        "concreteType": "AssetsSchema",
        "kind": "LinkedField",
        "name": "objectSchemaEntity",
        "plural": false,
        "selections": v84 /*: any*/ 
    }, v111 = [
        {
            "kind": "ScalarField",
            "name": "url48"
        }
    ], v112 = [
        v49 /*: any*/ ,
        v36 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                v33 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SearchResultsAsyncPaginationQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "includeAssigneeField",
                            "variableName": "includeAssigneeField"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeIconUrl",
                            "variableName": "includeIconUrl"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeJiraLiteModeFields",
                            "variableName": "includeJiraLiteModeFields"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeNavBoostScore",
                            "variableName": "includeNavBoostScore"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePassionfruitAsk",
                            "variableName": "includePassionfruitAsk"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePositions",
                            "variableName": "includePositions"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeThirdPartyId",
                            "variableName": "includeThirdPartyId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                v33 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isassetsenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "SearchResultsAsyncPaginationQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "search",
                            "args": v34 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "asyncSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCachedResult"
                                },
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v35 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                {
                                                    "concreteType": "SearchLinkedResult",
                                                    "kind": "LinkedField",
                                                    "name": "linkedResults",
                                                    "plural": true,
                                                    "selections": [
                                                        v36 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        },
                                                        v38 /*: any*/ ,
                                                        v39 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        v41 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        v45 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isSearchResult"
                                                },
                                                v39 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoal",
                                                            "kind": "LinkedField",
                                                            "name": "goal",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareLocalizationField",
                                                                            "kind": "LinkedField",
                                                                            "name": "localizedLabel",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "messageId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "score"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v48 /*: any*/ 
                                                                },
                                                                v36 /*: any*/ ,
                                                                v49 /*: any*/ ,
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        v52 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasGoal"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isPrivate"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "dueDate",
                                                                    "plural": false,
                                                                    "selections": v48 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareProjectState",
                                                                    "kind": "LinkedField",
                                                                    "name": "state",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v47 /*: any*/ ,
                                                                        v46 /*: any*/ 
                                                                    ]
                                                                },
                                                                v36 /*: any*/ ,
                                                                v49 /*: any*/ 
                                                            ]
                                                        },
                                                        v52 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "SearchFederatedEmailUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "sender",
                                                                            "plural": false,
                                                                            "selections": v54 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "SearchFederatedEmailEntity"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultFederated"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "tier"
                                                        },
                                                        {
                                                            "concreteType": "CompassComponent",
                                                            "kind": "LinkedField",
                                                            "name": "component",
                                                            "plural": false,
                                                            "selections": [
                                                                v37 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                v36 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "ownerId"
                                                        }
                                                    ],
                                                    "type": "SearchResultCompassComponent"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v55 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isVerified"
                                                        },
                                                        {
                                                            "concreteType": "SearchConfluenceResultSpace",
                                                            "kind": "LinkedField",
                                                            "name": "space",
                                                            "plural": false,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v53 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webUiLink"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ConfluenceCommentCountSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "commentCountSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v56 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ConfluenceLikesSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "likesSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "count"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                v58 /*: any*/ 
                                                            ]
                                                        },
                                                        v62 /*: any*/ ,
                                                        v52 /*: any*/ ,
                                                        {
                                                            "condition": "includeNavBoostScore",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "navBoostScore"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v55 /*: any*/ ,
                                                        v52 /*: any*/ 
                                                    ],
                                                    "type": "SearchConfluenceSpace"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "permissionLevel"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v53 /*: any*/ ,
                                                                        v63 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalBranch"
                                                                },
                                                                v58 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v65 /*: any*/ ,
                                                                        v68 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "author",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v70 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v63 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCommit"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v64 /*: any*/ ,
                                                                                        v40 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalSpace"
                                                                                },
                                                                                v58 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalReaction",
                                                                            "kind": "LinkedField",
                                                                            "name": "reactions",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "reactionType"
                                                                                },
                                                                                v56 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "includeThirdPartyId",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "thirdPartyId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDocumentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "type",
                                                                            "plural": false,
                                                                            "selections": v51 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalLargeContent",
                                                                            "kind": "LinkedField",
                                                                            "name": "nonIndexableContent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mediaThumbnailUrl"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "parent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v64 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalDocument"
                                                                                },
                                                                                v58 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v66 /*: any*/ ,
                                                                        v73 /*: any*/ ,
                                                                        v37 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalAttachment",
                                                                            "kind": "LinkedField",
                                                                            "name": "attachments",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v39 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mimeType"
                                                                                },
                                                                                v40 /*: any*/ ,
                                                                                v74 /*: any*/ ,
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v76 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v64 /*: any*/ ,
                                                                                        v80 /*: any*/ ,
                                                                                        v41 /*: any*/ ,
                                                                                        v36 /*: any*/ ,
                                                                                        v81 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "membershipType"
                                                                                        }
                                                                                    ],
                                                                                    "type": "ExternalConversation"
                                                                                },
                                                                                v58 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastActive"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "reactionCount"
                                                                        }
                                                                    ],
                                                                    "type": "ExternalMessage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v37 /*: any*/ ,
                                                                        v64 /*: any*/ ,
                                                                        v81 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "members",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalConversation"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v82 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "endDate"
                                                                        },
                                                                        v83 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v88 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCampaign"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayNumber"
                                                                        },
                                                                        v82 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "closedAt"
                                                                        },
                                                                        v83 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "owners",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v85 /*: any*/ ,
                                                                                v90 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v88 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": v91 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v64 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ExternalUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "contributors",
                                                                                    "plural": true,
                                                                                    "selections": v79 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v92 /*: any*/ 
                                                                        },
                                                                        v93 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalCustomerOrgLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "customerOrgLastActivity",
                                                                            "plural": false,
                                                                            "selections": v94 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerOrg"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "stage"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "dealClosedAt"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDealLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "lastActivity",
                                                                            "plural": false,
                                                                            "selections": v94 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v92 /*: any*/ 
                                                                        },
                                                                        v93 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDeal"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v65 /*: any*/ ,
                                                                        v95 /*: any*/ ,
                                                                        v96 /*: any*/ ,
                                                                        v97 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v82 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalProject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v65 /*: any*/ ,
                                                                        v95 /*: any*/ ,
                                                                        v96 /*: any*/ ,
                                                                        v97 /*: any*/ ,
                                                                        v82 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "team"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalWorkItemProject",
                                                                            "kind": "LinkedField",
                                                                            "name": "workItemProject",
                                                                            "plural": false,
                                                                            "selections": v77 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalProvider",
                                                                            "kind": "LinkedField",
                                                                            "name": "provider",
                                                                            "plural": false,
                                                                            "selections": v54 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalWorkItem"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v39 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastUpdate"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "pullRequestId"
                                                                        },
                                                                        {
                                                                            "alias": "pullRequestStatus",
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        },
                                                                        v63 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "durationInSeconds"
                                                                        },
                                                                        v74 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalChapter",
                                                                            "kind": "LinkedField",
                                                                            "name": "chapters",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v39 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "startTimeInSeconds"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "createdBy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v78 /*: any*/ ,
                                                                                v90 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalVideo"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v36 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        v98 /*: any*/ ,
                                                                        v87 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDashboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v36 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataTableType",
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v98 /*: any*/ ,
                                                                        v87 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDataTable"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountName"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "contactUser",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ThirdPartyUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "thirdPartyUser",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v53 /*: any*/ ,
                                                                                        v67 /*: any*/ ,
                                                                                        v36 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerContact"
                                                                }
                                                            ]
                                                        },
                                                        v99 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v96 /*: any*/ ,
                                                                        v100 /*: any*/ ,
                                                                        v101 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "recurringEventId"
                                                                        },
                                                                        v102 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCalendarEvent"
                                                                },
                                                                v58 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalThumbnail",
                                                                            "kind": "LinkedField",
                                                                            "name": "thumbnail",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDesign"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "SearchResultGraphDocument",
                                                            "kind": "LinkedField",
                                                            "name": "linkedEntities",
                                                            "plural": true,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v39 /*: any*/ ,
                                                                v40 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "entity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v101 /*: any*/ ,
                                                                                v100 /*: any*/ ,
                                                                                v102 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalCalendarEvent"
                                                                        },
                                                                        v58 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v64 /*: any*/ ,
                                                                                v68 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v76 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "container",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v80 /*: any*/ ,
                                                                                                v41 /*: any*/ 
                                                                                            ],
                                                                                            "type": "ExternalConversation"
                                                                                        },
                                                                                        v58 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v66 /*: any*/ ,
                                                                                v73 /*: any*/ ,
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalMessage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalConversation"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "parentId"
                                                                },
                                                                v99 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ThirdPartyUser",
                                                                    "kind": "LinkedField",
                                                                    "name": "initialContributors",
                                                                    "plural": true,
                                                                    "selections": v75 /*: any*/ 
                                                                },
                                                                v103 /*: any*/ ,
                                                                v44 /*: any*/ ,
                                                                v104 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "ThirdPartyUser",
                                                            "kind": "LinkedField",
                                                            "name": "initialContributors",
                                                            "plural": true,
                                                            "selections": [
                                                                v53 /*: any*/ ,
                                                                v59 /*: any*/ ,
                                                                v36 /*: any*/ ,
                                                                v60 /*: any*/ ,
                                                                v66 /*: any*/ ,
                                                                v67 /*: any*/ 
                                                            ]
                                                        },
                                                        v103 /*: any*/ ,
                                                        {
                                                            "concreteType": "SearchResultGraphTab",
                                                            "kind": "LinkedField",
                                                            "name": "tabs",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tabId"
                                                                },
                                                                v39 /*: any*/ ,
                                                                v40 /*: any*/ ,
                                                                v35 /*: any*/ 
                                                            ]
                                                        },
                                                        v98 /*: any*/ ,
                                                        {
                                                            "concreteType": "SearchResultGraphAttachment",
                                                            "kind": "LinkedField",
                                                            "name": "attachments",
                                                            "plural": true,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fileType"
                                                                },
                                                                v40 /*: any*/ ,
                                                                v35 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "containerName"
                                                        },
                                                        v104 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "links"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "linkedEntitiesType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "connectorId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "connectorProduct"
                                                        }
                                                    ],
                                                    "type": "SearchResultGraphDocument"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeAvatarUrl"
                                                                },
                                                                v105 /*: any*/ ,
                                                                v49 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": v84 /*: any*/ 
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "project"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        v53 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": v77 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        v36 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"project\"])"
                                                                },
                                                                {
                                                                    "condition": "includeAssigneeField",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                                            "kind": "LinkedField",
                                                                            "name": "assigneeField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v70 /*: any*/ ,
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "includeJiraLiteModeFields",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraPriorityField",
                                                                            "kind": "LinkedField",
                                                                            "name": "priorityField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraPriority",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priority",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v50 /*: any*/ ,
                                                                                        v53 /*: any*/ ,
                                                                                        v36 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraLabelsField",
                                                                            "kind": "LinkedField",
                                                                            "name": "labelsField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "first",
                                                                                            "value": 5
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "JiraLabelConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedLabelsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraLabelEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraLabel",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": v54 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedLabelsConnection(first:5)"
                                                                                },
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v36 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectKey"
                                                        },
                                                        v42 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v105 /*: any*/ ,
                                                                {
                                                                    "condition": "includeJiraLiteModeFields",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "lead",
                                                                            "plural": false,
                                                                            "selections": v69 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectStyle"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectType"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraProjectCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "category",
                                                                            "plural": false,
                                                                            "selections": v84 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v36 /*: any*/ 
                                                            ]
                                                        },
                                                        v62 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultJiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v106 /*: any*/ ,
                                                    "type": "SearchResultJiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraBoard",
                                                            "kind": "LinkedField",
                                                            "name": "board",
                                                            "plural": false,
                                                            "selections": [
                                                                v50 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardFrontendUrl"
                                                                },
                                                                v36 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v106 /*: any*/ ,
                                                    "type": "SearchResultJiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v106 /*: any*/ ,
                                                    "type": "SearchResultJiraFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v49 /*: any*/ ,
                                                                        v64 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                    "kind": "LinkedField",
                                                                    "name": "health",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v49 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "color"
                                                                        },
                                                                        v64 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MercuryTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v107 /*: any*/ 
                                                                },
                                                                v36 /*: any*/ ,
                                                                v53 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MercuryFocusAreaType",
                                                                    "kind": "LinkedField",
                                                                    "name": "focusAreaType",
                                                                    "plural": false,
                                                                    "selections": v77 /*: any*/ 
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "owner",
                                                                    "plural": false,
                                                                    "selections": v89 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v42 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultMercuryFocusArea"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": v84 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "SearchResultMercuryFocusAreaStatusUpdate"
                                                },
                                                {
                                                    "condition": "includePassionfruitAsk",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SpfAsk",
                                                                    "kind": "LinkedField",
                                                                    "name": "ask",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v82 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "SpfAskTargetDate",
                                                                            "kind": "LinkedField",
                                                                            "name": "targetDate",
                                                                            "plural": false,
                                                                            "selections": v107 /*: any*/ 
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                v42 /*: any*/ 
                                                            ],
                                                            "type": "SearchResultSpfAsk"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v108 /*: any*/ ,
                                                    "type": "SearchResultTrelloBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v108 /*: any*/ ,
                                                    "type": "SearchResultTrelloCard"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsSchema",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectSchemaEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v109 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectSchema"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                v110 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObjectType",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectTypeEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsIcon",
                                                                            "kind": "LinkedField",
                                                                            "name": "icon",
                                                                            "plural": false,
                                                                            "selections": v111 /*: any*/ 
                                                                        },
                                                                        v109 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectType"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                v110 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObject",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": v111 /*: any*/ 
                                                                        },
                                                                        v109 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObject"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "includePositions",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "RadarPosition",
                                                                    "kind": "LinkedField",
                                                                    "name": "position",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "RadarWorker",
                                                                            "kind": "LinkedField",
                                                                            "name": "worker",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "preferredName"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        v59 /*: any*/ ,
                                                                                        v36 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "fieldIdIsIn",
                                                                                    "value": [
                                                                                        "positionId",
                                                                                        "positionStatus",
                                                                                        "positionJobTitle",
                                                                                        "positionPositionTitle",
                                                                                        "positionKey",
                                                                                        "positionExternalPositionKey",
                                                                                        "positionWorker",
                                                                                        "focusArea"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "RadarFieldValueIdPair",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldValues",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldValue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v35 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": "stringValue",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "value"
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarStringFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "value",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v53 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "status",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v112 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "health",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v112 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "MercuryFocusArea"
                                                                                                        },
                                                                                                        v58 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarAriFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                                                                        },
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultTalentPosition"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "SearchQueryInfo",
                                    "kind": "LinkedField",
                                    "name": "queryInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "replacementQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "suggestedQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQueryType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "confidenceScore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldTriggerAutocorrectionExperience"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "traceId"
                                },
                                {
                                    "concreteType": "SearchError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "product"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "integration"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "search",
                            "args": v34 /*: any*/ ,
                            "filters": [
                                "experience",
                                "enableHighlighting",
                                "query",
                                "sort",
                                "disableQueryReplacement",
                                "fanoutExperimentCohort",
                                "expectResult",
                                "filters",
                                "analytics",
                                "experimentContext"
                            ],
                            "handle": "connection",
                            "key": "SearchResultsAsyncPagination__search",
                            "kind": "LinkedHandle",
                            "name": "asyncSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "beef13cc5e249aa240a074cb93e92c0ee04fa89281839765247ac4e3dcaf0c85",
            "metadata": {},
            "name": "SearchResultsAsyncPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__isassetsenabledrelayprovider": (0, $5SuoG.default),
                "__relay_internal__pv__iscustomerorgownersenabledrelayprovider": (0, $aqtD4.default),
                "__relay_internal__pv__isdealownersenabledrelayprovider": (0, $4PNBt.default)
            }
        }
    };
}();
$42955532a44a41ee$var$node.hash = "af5b3ce885b8e5a125848886070f1f49";
var $42955532a44a41ee$export$2e2bcd8739ae039 = $42955532a44a41ee$var$node;


const $b9704ba2490974ad$var$node = function() {
    var v0 = [
        "search",
        "search"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "assetsFilters"
            },
            {
                "kind": "RootArgument",
                "name": "cloudIdARI"
            },
            {
                "kind": "RootArgument",
                "name": "commonFilters"
            },
            {
                "kind": "RootArgument",
                "name": "compassFilters"
            },
            {
                "kind": "RootArgument",
                "name": "confluenceFilters"
            },
            {
                "kind": "RootArgument",
                "name": "disableQueryReplacement"
            },
            {
                "kind": "RootArgument",
                "name": "enableHighlighting"
            },
            {
                "kind": "RootArgument",
                "name": "entities"
            },
            {
                "kind": "RootArgument",
                "name": "expectResult"
            },
            {
                "kind": "RootArgument",
                "name": "experience"
            },
            {
                "kind": "RootArgument",
                "name": "experimentId"
            },
            {
                "kind": "RootArgument",
                "name": "experimentLayers"
            },
            {
                "kind": "RootArgument",
                "name": "fanoutExperimentCohort"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeAssigneeField"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeIconUrl"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeJiraLiteModeFields"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeNavBoostScore"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includePassionfruitAsk"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includePositions"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeThirdPartyId"
            },
            {
                "kind": "RootArgument",
                "name": "jiraFilters"
            },
            {
                "kind": "RootArgument",
                "name": "limit"
            },
            {
                "kind": "RootArgument",
                "name": "mercuryFilters"
            },
            {
                "kind": "RootArgument",
                "name": "query"
            },
            {
                "kind": "RootArgument",
                "name": "queryVersion"
            },
            {
                "kind": "RootArgument",
                "name": "searchSessionId"
            },
            {
                "kind": "RootArgument",
                "name": "sessionId"
            },
            {
                "kind": "RootArgument",
                "name": "shadowExperimentId"
            },
            {
                "kind": "RootArgument",
                "name": "sort"
            },
            {
                "kind": "RootArgument",
                "name": "sourceProduct"
            },
            {
                "kind": "RootArgument",
                "name": "talentFilters"
            },
            {
                "kind": "RootArgument",
                "name": "tenantId"
            },
            {
                "kind": "RootArgument",
                "name": "thirdPartyFilters"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "limit",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "limit",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $42955532a44a41ee$export$2e2bcd8739ae039)
            }
        },
        "name": "searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData",
        "selections": [
            {
                "concreteType": "SearchQueryAPI",
                "kind": "LinkedField",
                "name": "search",
                "plural": false,
                "selections": [
                    {
                        "alias": "search",
                        "args": [
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "queryVersion",
                                        "variableName": "queryVersion"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "searchSessionId",
                                        "variableName": "searchSessionId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "sessionId",
                                        "variableName": "sessionId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "sourceProduct",
                                        "variableName": "sourceProduct"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "analytics"
                            },
                            {
                                "kind": "Variable",
                                "name": "disableQueryReplacement",
                                "variableName": "disableQueryReplacement"
                            },
                            {
                                "kind": "Variable",
                                "name": "enableHighlighting",
                                "variableName": "enableHighlighting"
                            },
                            {
                                "kind": "Variable",
                                "name": "expectResult",
                                "variableName": "expectResult"
                            },
                            {
                                "kind": "Variable",
                                "name": "experience",
                                "variableName": "experience"
                            },
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "experimentId",
                                        "variableName": "experimentId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "experimentLayers",
                                        "variableName": "experimentLayers"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "shadowExperimentId",
                                        "variableName": "shadowExperimentId"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "experimentContext"
                            },
                            {
                                "kind": "Variable",
                                "name": "fanoutExperimentCohort",
                                "variableName": "fanoutExperimentCohort"
                            },
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "assetsFilters",
                                        "variableName": "assetsFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "commonFilters",
                                        "variableName": "commonFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "compassFilters",
                                        "variableName": "compassFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "confluenceFilters",
                                        "variableName": "confluenceFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "entities",
                                        "variableName": "entities"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "jiraFilters",
                                        "variableName": "jiraFilters"
                                    },
                                    {
                                        "items": [
                                            {
                                                "kind": "Variable",
                                                "name": "locations.0",
                                                "variableName": "cloudIdARI"
                                            }
                                        ],
                                        "kind": "ListValue",
                                        "name": "locations"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "mercuryFilters",
                                        "variableName": "mercuryFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "talentFilters",
                                        "variableName": "talentFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "thirdPartyFilters",
                                        "variableName": "thirdPartyFilters"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "filters"
                            },
                            {
                                "kind": "Variable",
                                "name": "query",
                                "variableName": "query"
                            },
                            {
                                "kind": "Variable",
                                "name": "sort",
                                "variableName": "sort"
                            }
                        ],
                        "concreteType": "SearchItemConnection",
                        "kind": "LinkedField",
                        "name": "__SearchResultsAsyncPagination__search_connection",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isCachedResult"
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "includeAssigneeField",
                                        "variableName": "includeAssigneeField"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeIconUrl",
                                        "variableName": "includeIconUrl"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeJiraLiteModeFields",
                                        "variableName": "includeJiraLiteModeFields"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeNavBoostScore",
                                        "variableName": "includeNavBoostScore"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includePassionfruitAsk",
                                        "variableName": "includePassionfruitAsk"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includePositions",
                                        "variableName": "includePositions"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeThirdPartyId",
                                        "variableName": "includeThirdPartyId"
                                    }
                                ],
                                "kind": "FragmentSpread",
                                "name": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData"
                            },
                            {
                                "concreteType": "SearchResultItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    }
                                ]
                            },
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "endCursor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$b9704ba2490974ad$var$node.hash = "af5b3ce885b8e5a125848886070f1f49";
var $b9704ba2490974ad$export$2e2bcd8739ae039 = $b9704ba2490974ad$var$node;



/**
 * @generated SignedSource<<1ef507906a828113e80beb77477c9692>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * @generated SignedSource<<ff665b2eaeb82750b108c29d03815c9e>>
 * @relayHash b4901f1fa1aa8806172b18b21656ce91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5641ab53d33fc7ee92a504bb5fe41351e43cf63fae7a24d9d4cf2c3165e8b9f8









const $05232064a3df46d5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "assetsFilters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARI"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "compassFilters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "enableHighlighting"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentId"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentLayers"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fanoutExperimentCohort"
    }, v13 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAssigneeField"
    }, v14 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeIconUrl"
    }, v15 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeJiraLiteModeFields"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeNavBoostScore"
    }, v17 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePassionfruitAsk"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePositions"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeThirdPartyId"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraFilters"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "mercuryFilters"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryVersion"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchSessionId"
    }, v26 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v27 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shadowExperimentId"
    }, v28 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v29 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceProduct"
    }, v30 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "talentFilters"
    }, v31 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v32 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "thirdPartyFilters"
    }, v33 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "queryVersion",
                    "variableName": "queryVersion"
                },
                {
                    "kind": "Variable",
                    "name": "searchSessionId",
                    "variableName": "searchSessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sessionId",
                    "variableName": "sessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sourceProduct",
                    "variableName": "sourceProduct"
                }
            ],
            "kind": "ObjectValue",
            "name": "analytics"
        },
        {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
        },
        {
            "kind": "Variable",
            "name": "enableHighlighting",
            "variableName": "enableHighlighting"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "experimentId",
                    "variableName": "experimentId"
                },
                {
                    "kind": "Variable",
                    "name": "experimentLayers",
                    "variableName": "experimentLayers"
                },
                {
                    "kind": "Variable",
                    "name": "shadowExperimentId",
                    "variableName": "shadowExperimentId"
                }
            ],
            "kind": "ObjectValue",
            "name": "experimentContext"
        },
        {
            "kind": "Variable",
            "name": "fanoutExperimentCohort",
            "variableName": "fanoutExperimentCohort"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "assetsFilters",
                    "variableName": "assetsFilters"
                },
                {
                    "kind": "Variable",
                    "name": "commonFilters",
                    "variableName": "commonFilters"
                },
                {
                    "kind": "Variable",
                    "name": "compassFilters",
                    "variableName": "compassFilters"
                },
                {
                    "kind": "Variable",
                    "name": "confluenceFilters",
                    "variableName": "confluenceFilters"
                },
                {
                    "kind": "Variable",
                    "name": "entities",
                    "variableName": "entities"
                },
                {
                    "kind": "Variable",
                    "name": "jiraFilters",
                    "variableName": "jiraFilters"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "locations.0",
                            "variableName": "cloudIdARI"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "mercuryFilters",
                    "variableName": "mercuryFilters"
                },
                {
                    "kind": "Variable",
                    "name": "talentFilters",
                    "variableName": "talentFilters"
                },
                {
                    "kind": "Variable",
                    "name": "thirdPartyFilters",
                    "variableName": "thirdPartyFilters"
                }
            ],
            "kind": "ObjectValue",
            "name": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        },
        {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
        }
    ], v34 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v35 = {
        "kind": "ScalarField",
        "name": "id"
    }, v36 = {
        "kind": "ScalarField",
        "name": "description"
    }, v37 = {
        "kind": "ScalarField",
        "name": "connectorType"
    }, v38 = {
        "kind": "ScalarField",
        "name": "title"
    }, v39 = {
        "kind": "ScalarField",
        "name": "url"
    }, v40 = {
        "kind": "ScalarField",
        "name": "type"
    }, v41 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v42 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v43 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v44 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v45 = {
        "kind": "ScalarField",
        "name": "value"
    }, v46 = {
        "kind": "ScalarField",
        "name": "label"
    }, v47 = [
        v46 /*: any*/ 
    ], v48 = {
        "kind": "ScalarField",
        "name": "key"
    }, v49 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v50 = [
        v49 /*: any*/ 
    ], v51 = {
        "condition": "includeIconUrl",
        "kind": "Condition",
        "passingValue": true,
        "selections": v50 /*: any*/ 
    }, v52 = {
        "kind": "ScalarField",
        "name": "name"
    }, v53 = [
        v52 /*: any*/ 
    ], v54 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v55 = {
        "kind": "ScalarField",
        "name": "total"
    }, v56 = [
        v35 /*: any*/ 
    ], v57 = {
        "kind": "InlineFragment",
        "selections": v56 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v58 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v59 = {
        "kind": "ScalarField",
        "name": "email"
    }, v60 = [
        {
            "kind": "ScalarField",
            "name": "jobTitle"
        }
    ], v61 = {
        "args": [
            {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "tenantId"
            }
        ],
        "concreteType": "SocialSignalSearch",
        "kind": "LinkedField",
        "name": "socialSignal",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "signal"
            },
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v34 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v52 /*: any*/ ,
                    v58 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v59 /*: any*/ ,
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": v60 /*: any*/ 
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    },
                    v35 /*: any*/ 
                ]
            }
        ]
    }, v62 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v34 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v53 /*: any*/ ,
                "type": "ExternalRepository"
            },
            v57 /*: any*/ 
        ]
    }, v63 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v64 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v34 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v63 /*: any*/ ,
                    v39 /*: any*/ ,
                    v42 /*: any*/ 
                ],
                "type": "ExternalSpace"
            },
            v57 /*: any*/ 
        ]
    }, v65 = {
        "kind": "ScalarField",
        "name": "externalId"
    }, v66 = {
        "concreteType": "ThirdPartyUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": v60 /*: any*/ 
    }, v67 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": [
                    v52 /*: any*/ ,
                    v59 /*: any*/ ,
                    v58 /*: any*/ ,
                    v65 /*: any*/ ,
                    v66 /*: any*/ ,
                    v35 /*: any*/ 
                ]
            }
        ]
    }, v68 = [
        v34 /*: any*/ ,
        v52 /*: any*/ ,
        v58 /*: any*/ ,
        v35 /*: any*/ 
    ], v69 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v68 /*: any*/ 
    }, v70 = {
        "kind": "ScalarField",
        "name": "nickname"
    }, v71 = [
        v65 /*: any*/ ,
        v52 /*: any*/ ,
        v70 /*: any*/ ,
        v59 /*: any*/ ,
        v58 /*: any*/ ,
        v66 /*: any*/ ,
        v35 /*: any*/ 
    ], v72 = {
        "concreteType": "ExternalAssociationConnection",
        "kind": "LinkedField",
        "name": "associatedWith",
        "plural": false,
        "selections": [
            {
                "concreteType": "ExternalAssociationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "ExternalAssociation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                    v34 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v71 /*: any*/ ,
                                        "type": "ThirdPartyUser"
                                    },
                                    v57 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": "channelId",
                                                "kind": "ScalarField",
                                                "name": "externalId"
                                            },
                                            v63 /*: any*/ 
                                        ],
                                        "type": "ExternalConversation"
                                    }
                                ]
                            },
                            v35 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v73 = {
        "kind": "ScalarField",
        "name": "thumbnailUrl"
    }, v74 = [
        v35 /*: any*/ ,
        v52 /*: any*/ ,
        v59 /*: any*/ ,
        v58 /*: any*/ ,
        v65 /*: any*/ ,
        v66 /*: any*/ 
    ], v75 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": v74 /*: any*/ 
            },
            {
                "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
                "kind": "LinkedField",
                "name": "linkedUsers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v34 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v52 /*: any*/ ,
                                            v58 /*: any*/ ,
                                            v35 /*: any*/ 
                                        ],
                                        "type": "AtlassianAccountUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v56 /*: any*/ ,
                                        "type": "AppUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v56 /*: any*/ ,
                                        "type": "CustomerUser"
                                    }
                                ]
                            },
                            v35 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v76 = [
        v35 /*: any*/ ,
        v52 /*: any*/ 
    ], v77 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v76 /*: any*/ 
    }, v78 = [
        v77 /*: any*/ 
    ], v79 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": v78 /*: any*/ 
    }, v80 = {
        "kind": "ScalarField",
        "name": "memberCount"
    }, v81 = {
        "kind": "ScalarField",
        "name": "status"
    }, v82 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v83 = [
        v52 /*: any*/ ,
        v35 /*: any*/ 
    ], v84 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v83 /*: any*/ 
    }, v85 = [
        v84 /*: any*/ 
    ], v86 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "owners",
        "plural": true,
        "selections": v85 /*: any*/ 
    }, v87 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v85 /*: any*/ 
    }, v88 = [
        v34 /*: any*/ ,
        v52 /*: any*/ ,
        v35 /*: any*/ 
    ], v89 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v88 /*: any*/ 
    }, v90 = [
        v34 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v35 /*: any*/ ,
                v63 /*: any*/ 
            ],
            "type": "ExternalCustomerOrg"
        },
        v57 /*: any*/ 
    ], v91 = [
        v86 /*: any*/ 
    ], v92 = {
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": v90 /*: any*/ 
    }, v93 = [
        {
            "kind": "ScalarField",
            "name": "lastActivityAt"
        },
        {
            "kind": "ScalarField",
            "name": "event"
        }
    ], v94 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "assignee",
        "plural": false,
        "selections": v78 /*: any*/ 
    }, v95 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v78 /*: any*/ 
    }, v96 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v97 = {
        "kind": "ScalarField",
        "name": "workspaceName"
    }, v98 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v99 = {
        "kind": "ScalarField",
        "name": "eventEndTime"
    }, v100 = {
        "kind": "ScalarField",
        "name": "eventStartTime"
    }, v101 = {
        "kind": "ScalarField",
        "name": "videoMeetingUrl"
    }, v102 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "allContributors",
        "plural": true,
        "selections": v71 /*: any*/ 
    }, v103 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "allContributors",
        "plural": true,
        "selections": [
            v52 /*: any*/ ,
            v70 /*: any*/ ,
            v59 /*: any*/ ,
            v58 /*: any*/ ,
            v65 /*: any*/ ,
            v66 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v104 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v105 = [
        v41 /*: any*/ ,
        v49 /*: any*/ 
    ], v106 = [
        {
            "kind": "ScalarField",
            "name": "targetDate"
        },
        {
            "kind": "ScalarField",
            "name": "targetDateType"
        }
    ], v107 = [
        v41 /*: any*/ 
    ], v108 = {
        "concreteType": "AssetsLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "web"
            }
        ]
    }, v109 = {
        "concreteType": "AssetsSchema",
        "kind": "LinkedField",
        "name": "objectSchemaEntity",
        "plural": false,
        "selections": v83 /*: any*/ 
    }, v110 = [
        {
            "kind": "ScalarField",
            "name": "url48"
        }
    ], v111 = [
        v48 /*: any*/ ,
        v35 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v32 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SearchResultsPaginationQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "includeAssigneeField",
                            "variableName": "includeAssigneeField"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeIconUrl",
                            "variableName": "includeIconUrl"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeJiraLiteModeFields",
                            "variableName": "includeJiraLiteModeFields"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeNavBoostScore",
                            "variableName": "includeNavBoostScore"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePassionfruitAsk",
                            "variableName": "includePassionfruitAsk"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePositions",
                            "variableName": "includePositions"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeThirdPartyId",
                            "variableName": "includeThirdPartyId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResults_AtlassianSearchPage_SearchResultsSyncInner_queryData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isassetsenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "SearchResultsPaginationQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v33 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v34 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                {
                                                    "concreteType": "SearchLinkedResult",
                                                    "kind": "LinkedField",
                                                    "name": "linkedResults",
                                                    "plural": true,
                                                    "selections": [
                                                        v35 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        },
                                                        v37 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        v39 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        v36 /*: any*/ ,
                                                        v41 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v44 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isSearchResult"
                                                },
                                                v38 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoal",
                                                            "kind": "LinkedField",
                                                            "name": "goal",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareLocalizationField",
                                                                            "kind": "LinkedField",
                                                                            "name": "localizedLabel",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "messageId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "score"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v47 /*: any*/ 
                                                                },
                                                                v35 /*: any*/ ,
                                                                v48 /*: any*/ ,
                                                                v36 /*: any*/ 
                                                            ]
                                                        },
                                                        v51 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasGoal"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isPrivate"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "dueDate",
                                                                    "plural": false,
                                                                    "selections": v47 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareProjectState",
                                                                    "kind": "LinkedField",
                                                                    "name": "state",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        v45 /*: any*/ 
                                                                    ]
                                                                },
                                                                v35 /*: any*/ ,
                                                                v48 /*: any*/ 
                                                            ]
                                                        },
                                                        v51 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v34 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "SearchFederatedEmailUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "sender",
                                                                            "plural": false,
                                                                            "selections": v53 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "SearchFederatedEmailEntity"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultFederated"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "tier"
                                                        },
                                                        {
                                                            "concreteType": "CompassComponent",
                                                            "kind": "LinkedField",
                                                            "name": "component",
                                                            "plural": false,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                v35 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "ownerId"
                                                        }
                                                    ],
                                                    "type": "SearchResultCompassComponent"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v54 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isVerified"
                                                        },
                                                        {
                                                            "concreteType": "SearchConfluenceResultSpace",
                                                            "kind": "LinkedField",
                                                            "name": "space",
                                                            "plural": false,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                v52 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webUiLink"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v34 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v42 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ConfluenceCommentCountSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "commentCountSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v55 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ConfluenceLikesSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "likesSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "count"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                v57 /*: any*/ 
                                                            ]
                                                        },
                                                        v61 /*: any*/ ,
                                                        v51 /*: any*/ ,
                                                        {
                                                            "condition": "includeNavBoostScore",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "navBoostScore"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v54 /*: any*/ ,
                                                        v51 /*: any*/ 
                                                    ],
                                                    "type": "SearchConfluenceSpace"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v44 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v41 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "permissionLevel"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v34 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v52 /*: any*/ ,
                                                                        v62 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalBranch"
                                                                },
                                                                v57 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v64 /*: any*/ ,
                                                                        v67 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "author",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v69 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v62 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCommit"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v63 /*: any*/ ,
                                                                                        v39 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalSpace"
                                                                                },
                                                                                v57 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalReaction",
                                                                            "kind": "LinkedField",
                                                                            "name": "reactions",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "reactionType"
                                                                                },
                                                                                v55 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "includeThirdPartyId",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "thirdPartyId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDocumentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "type",
                                                                            "plural": false,
                                                                            "selections": v50 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalLargeContent",
                                                                            "kind": "LinkedField",
                                                                            "name": "nonIndexableContent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mediaThumbnailUrl"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "parent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v63 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalDocument"
                                                                                },
                                                                                v57 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v65 /*: any*/ ,
                                                                        v72 /*: any*/ ,
                                                                        v36 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalAttachment",
                                                                            "kind": "LinkedField",
                                                                            "name": "attachments",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mimeType"
                                                                                },
                                                                                v39 /*: any*/ ,
                                                                                v73 /*: any*/ ,
                                                                                v34 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v75 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v63 /*: any*/ ,
                                                                                        v79 /*: any*/ ,
                                                                                        v40 /*: any*/ ,
                                                                                        v35 /*: any*/ ,
                                                                                        v80 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "membershipType"
                                                                                        }
                                                                                    ],
                                                                                    "type": "ExternalConversation"
                                                                                },
                                                                                v57 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastActive"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "reactionCount"
                                                                        }
                                                                    ],
                                                                    "type": "ExternalMessage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v36 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v80 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "members",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v34 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalConversation"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v81 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "endDate"
                                                                        },
                                                                        v82 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCampaign"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayNumber"
                                                                        },
                                                                        v81 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "closedAt"
                                                                        },
                                                                        v82 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "owners",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v84 /*: any*/ ,
                                                                                v89 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v87 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": v90 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v63 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ExternalUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "contributors",
                                                                                    "plural": true,
                                                                                    "selections": v78 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v91 /*: any*/ 
                                                                        },
                                                                        v92 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalCustomerOrgLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "customerOrgLastActivity",
                                                                            "plural": false,
                                                                            "selections": v93 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerOrg"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "stage"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "dealClosedAt"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDealLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "lastActivity",
                                                                            "plural": false,
                                                                            "selections": v93 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v91 /*: any*/ 
                                                                        },
                                                                        v92 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDeal"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v64 /*: any*/ ,
                                                                        v94 /*: any*/ ,
                                                                        v95 /*: any*/ ,
                                                                        v96 /*: any*/ ,
                                                                        v48 /*: any*/ ,
                                                                        v81 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalProject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v64 /*: any*/ ,
                                                                        v94 /*: any*/ ,
                                                                        v95 /*: any*/ ,
                                                                        v96 /*: any*/ ,
                                                                        v81 /*: any*/ ,
                                                                        v42 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "team"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalWorkItemProject",
                                                                            "kind": "LinkedField",
                                                                            "name": "workItemProject",
                                                                            "plural": false,
                                                                            "selections": v76 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalProvider",
                                                                            "kind": "LinkedField",
                                                                            "name": "provider",
                                                                            "plural": false,
                                                                            "selections": v53 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalWorkItem"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v38 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastUpdate"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "pullRequestId"
                                                                        },
                                                                        {
                                                                            "alias": "pullRequestStatus",
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        },
                                                                        v62 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "durationInSeconds"
                                                                        },
                                                                        v73 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalChapter",
                                                                            "kind": "LinkedField",
                                                                            "name": "chapters",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "startTimeInSeconds"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "createdBy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v77 /*: any*/ ,
                                                                                v89 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalVideo"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        v39 /*: any*/ ,
                                                                        v97 /*: any*/ ,
                                                                        v86 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDashboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        v39 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataTableType",
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v97 /*: any*/ ,
                                                                        v86 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDataTable"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountName"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "contactUser",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ThirdPartyUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "thirdPartyUser",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v52 /*: any*/ ,
                                                                                        v66 /*: any*/ ,
                                                                                        v35 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerContact"
                                                                }
                                                            ]
                                                        },
                                                        v98 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v34 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v95 /*: any*/ ,
                                                                        v99 /*: any*/ ,
                                                                        v100 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "recurringEventId"
                                                                        },
                                                                        v101 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCalendarEvent"
                                                                },
                                                                v57 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalThumbnail",
                                                                            "kind": "LinkedField",
                                                                            "name": "thumbnail",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDesign"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "SearchResultGraphDocument",
                                                            "kind": "LinkedField",
                                                            "name": "linkedEntities",
                                                            "plural": true,
                                                            "selections": [
                                                                v35 /*: any*/ ,
                                                                v38 /*: any*/ ,
                                                                v39 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "entity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v34 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v100 /*: any*/ ,
                                                                                v99 /*: any*/ ,
                                                                                v101 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalCalendarEvent"
                                                                        },
                                                                        v57 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v63 /*: any*/ ,
                                                                                v67 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v75 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "container",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v79 /*: any*/ ,
                                                                                                v40 /*: any*/ 
                                                                                            ],
                                                                                            "type": "ExternalConversation"
                                                                                        },
                                                                                        v57 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v65 /*: any*/ ,
                                                                                v72 /*: any*/ ,
                                                                                v36 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalMessage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v36 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalConversation"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "parentId"
                                                                },
                                                                v98 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ThirdPartyUser",
                                                                    "kind": "LinkedField",
                                                                    "name": "initialContributors",
                                                                    "plural": true,
                                                                    "selections": v74 /*: any*/ 
                                                                },
                                                                v102 /*: any*/ ,
                                                                v43 /*: any*/ ,
                                                                v103 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "ThirdPartyUser",
                                                            "kind": "LinkedField",
                                                            "name": "initialContributors",
                                                            "plural": true,
                                                            "selections": [
                                                                v52 /*: any*/ ,
                                                                v58 /*: any*/ ,
                                                                v35 /*: any*/ ,
                                                                v59 /*: any*/ ,
                                                                v65 /*: any*/ ,
                                                                v66 /*: any*/ 
                                                            ]
                                                        },
                                                        v102 /*: any*/ ,
                                                        {
                                                            "concreteType": "SearchResultGraphTab",
                                                            "kind": "LinkedField",
                                                            "name": "tabs",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tabId"
                                                                },
                                                                v38 /*: any*/ ,
                                                                v39 /*: any*/ ,
                                                                v34 /*: any*/ 
                                                            ]
                                                        },
                                                        v97 /*: any*/ ,
                                                        {
                                                            "concreteType": "SearchResultGraphAttachment",
                                                            "kind": "LinkedField",
                                                            "name": "attachments",
                                                            "plural": true,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fileType"
                                                                },
                                                                v39 /*: any*/ ,
                                                                v34 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "containerName"
                                                        },
                                                        v103 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "links"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "linkedEntitiesType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "connectorId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "connectorProduct"
                                                        }
                                                    ],
                                                    "type": "SearchResultGraphDocument"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        v49 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeAvatarUrl"
                                                                },
                                                                v104 /*: any*/ ,
                                                                v48 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": v83 /*: any*/ 
                                                                        },
                                                                        v35 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "project"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v52 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": v76 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        v35 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"project\"])"
                                                                },
                                                                {
                                                                    "condition": "includeAssigneeField",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                                            "kind": "LinkedField",
                                                                            "name": "assigneeField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v69 /*: any*/ ,
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "includeJiraLiteModeFields",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraPriorityField",
                                                                            "kind": "LinkedField",
                                                                            "name": "priorityField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraPriority",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priority",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v49 /*: any*/ ,
                                                                                        v52 /*: any*/ ,
                                                                                        v35 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraLabelsField",
                                                                            "kind": "LinkedField",
                                                                            "name": "labelsField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "first",
                                                                                            "value": 5
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "JiraLabelConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedLabelsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraLabelEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraLabel",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": v53 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedLabelsConnection(first:5)"
                                                                                },
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v35 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectKey"
                                                        },
                                                        v41 /*: any*/ ,
                                                        v49 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v104 /*: any*/ ,
                                                                {
                                                                    "condition": "includeJiraLiteModeFields",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "lead",
                                                                            "plural": false,
                                                                            "selections": v68 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectStyle"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectType"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraProjectCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "category",
                                                                            "plural": false,
                                                                            "selections": v83 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v35 /*: any*/ 
                                                            ]
                                                        },
                                                        v61 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultJiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v105 /*: any*/ ,
                                                    "type": "SearchResultJiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        v49 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraBoard",
                                                            "kind": "LinkedField",
                                                            "name": "board",
                                                            "plural": false,
                                                            "selections": [
                                                                v49 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardFrontendUrl"
                                                                },
                                                                v35 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v105 /*: any*/ ,
                                                    "type": "SearchResultJiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v105 /*: any*/ ,
                                                    "type": "SearchResultJiraFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v48 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v35 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                    "kind": "LinkedField",
                                                                    "name": "health",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v48 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "color"
                                                                        },
                                                                        v63 /*: any*/ ,
                                                                        v35 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MercuryTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v106 /*: any*/ 
                                                                },
                                                                v35 /*: any*/ ,
                                                                v52 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MercuryFocusAreaType",
                                                                    "kind": "LinkedField",
                                                                    "name": "focusAreaType",
                                                                    "plural": false,
                                                                    "selections": v76 /*: any*/ 
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "owner",
                                                                    "plural": false,
                                                                    "selections": v88 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v41 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultMercuryFocusArea"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v41 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": v83 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "SearchResultMercuryFocusAreaStatusUpdate"
                                                },
                                                {
                                                    "condition": "includePassionfruitAsk",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SpfAsk",
                                                                    "kind": "LinkedField",
                                                                    "name": "ask",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v81 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "SpfAskTargetDate",
                                                                            "kind": "LinkedField",
                                                                            "name": "targetDate",
                                                                            "plural": false,
                                                                            "selections": v106 /*: any*/ 
                                                                        },
                                                                        v35 /*: any*/ 
                                                                    ]
                                                                },
                                                                v41 /*: any*/ 
                                                            ],
                                                            "type": "SearchResultSpfAsk"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v107 /*: any*/ ,
                                                    "type": "SearchResultTrelloBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v107 /*: any*/ ,
                                                    "type": "SearchResultTrelloCard"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v41 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsSchema",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectSchemaEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v108 /*: any*/ ,
                                                                        v35 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectSchema"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v41 /*: any*/ ,
                                                                v109 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObjectType",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectTypeEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsIcon",
                                                                            "kind": "LinkedField",
                                                                            "name": "icon",
                                                                            "plural": false,
                                                                            "selections": v110 /*: any*/ 
                                                                        },
                                                                        v108 /*: any*/ ,
                                                                        v35 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectType"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v41 /*: any*/ ,
                                                                v109 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObject",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": v110 /*: any*/ 
                                                                        },
                                                                        v108 /*: any*/ ,
                                                                        v35 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObject"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "includePositions",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "RadarPosition",
                                                                    "kind": "LinkedField",
                                                                    "name": "position",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v34 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "RadarWorker",
                                                                            "kind": "LinkedField",
                                                                            "name": "worker",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "preferredName"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        v58 /*: any*/ ,
                                                                                        v35 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "fieldIdIsIn",
                                                                                    "value": [
                                                                                        "positionId",
                                                                                        "positionStatus",
                                                                                        "positionJobTitle",
                                                                                        "positionPositionTitle",
                                                                                        "positionKey",
                                                                                        "positionExternalPositionKey",
                                                                                        "positionWorker",
                                                                                        "focusArea"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "RadarFieldValueIdPair",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldValues",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldValue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": "stringValue",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "value"
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarStringFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "value",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v34 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v52 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "status",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v111 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "health",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v111 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "MercuryFocusArea"
                                                                                                        },
                                                                                                        v57 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarAriFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                                                                        },
                                                                        v35 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultTalentPosition"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "SearchQueryInfo",
                                    "kind": "LinkedField",
                                    "name": "queryInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "replacementQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "suggestedQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQueryType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "confidenceScore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldTriggerAutocorrectionExperience"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "traceId"
                                },
                                {
                                    "concreteType": "SearchError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "product"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "integration"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v33 /*: any*/ ,
                            "filters": [
                                "experience",
                                "enableHighlighting",
                                "query",
                                "sort",
                                "disableQueryReplacement",
                                "fanoutExperimentCohort",
                                "filters",
                                "analytics",
                                "experimentContext"
                            ],
                            "handle": "connection",
                            "key": "SearchResultsPagination__search",
                            "kind": "LinkedHandle",
                            "name": "search"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5641ab53d33fc7ee92a504bb5fe41351e43cf63fae7a24d9d4cf2c3165e8b9f8",
            "metadata": {},
            "name": "SearchResultsPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__isassetsenabledrelayprovider": (0, $5SuoG.default),
                "__relay_internal__pv__iscustomerorgownersenabledrelayprovider": (0, $aqtD4.default),
                "__relay_internal__pv__isdealownersenabledrelayprovider": (0, $4PNBt.default)
            }
        }
    };
}();
$05232064a3df46d5$var$node.hash = "88f564f4bb7d5f6b91ca1c498278457b";
var $05232064a3df46d5$export$2e2bcd8739ae039 = $05232064a3df46d5$var$node;


const $9777a9dc8fd7d279$var$node = function() {
    var v0 = [
        "search",
        "search"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "assetsFilters"
            },
            {
                "kind": "RootArgument",
                "name": "cloudIdARI"
            },
            {
                "kind": "RootArgument",
                "name": "commonFilters"
            },
            {
                "kind": "RootArgument",
                "name": "compassFilters"
            },
            {
                "kind": "RootArgument",
                "name": "confluenceFilters"
            },
            {
                "kind": "RootArgument",
                "name": "disableQueryReplacement"
            },
            {
                "kind": "RootArgument",
                "name": "enableHighlighting"
            },
            {
                "kind": "RootArgument",
                "name": "entities"
            },
            {
                "kind": "RootArgument",
                "name": "experience"
            },
            {
                "kind": "RootArgument",
                "name": "experimentId"
            },
            {
                "kind": "RootArgument",
                "name": "experimentLayers"
            },
            {
                "kind": "RootArgument",
                "name": "fanoutExperimentCohort"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeAssigneeField"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeIconUrl"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeJiraLiteModeFields"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeNavBoostScore"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includePassionfruitAsk"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includePositions"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeThirdPartyId"
            },
            {
                "kind": "RootArgument",
                "name": "jiraFilters"
            },
            {
                "kind": "RootArgument",
                "name": "limit"
            },
            {
                "kind": "RootArgument",
                "name": "mercuryFilters"
            },
            {
                "kind": "RootArgument",
                "name": "query"
            },
            {
                "kind": "RootArgument",
                "name": "queryVersion"
            },
            {
                "kind": "RootArgument",
                "name": "searchSessionId"
            },
            {
                "kind": "RootArgument",
                "name": "sessionId"
            },
            {
                "kind": "RootArgument",
                "name": "shadowExperimentId"
            },
            {
                "kind": "RootArgument",
                "name": "sort"
            },
            {
                "kind": "RootArgument",
                "name": "sourceProduct"
            },
            {
                "kind": "RootArgument",
                "name": "talentFilters"
            },
            {
                "kind": "RootArgument",
                "name": "tenantId"
            },
            {
                "kind": "RootArgument",
                "name": "thirdPartyFilters"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "limit",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "limit",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $05232064a3df46d5$export$2e2bcd8739ae039)
            }
        },
        "name": "searchResults_AtlassianSearchPage_SearchResultsSyncInner_queryData",
        "selections": [
            {
                "concreteType": "SearchQueryAPI",
                "kind": "LinkedField",
                "name": "search",
                "plural": false,
                "selections": [
                    {
                        "alias": "search",
                        "args": [
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "queryVersion",
                                        "variableName": "queryVersion"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "searchSessionId",
                                        "variableName": "searchSessionId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "sessionId",
                                        "variableName": "sessionId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "sourceProduct",
                                        "variableName": "sourceProduct"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "analytics"
                            },
                            {
                                "kind": "Variable",
                                "name": "disableQueryReplacement",
                                "variableName": "disableQueryReplacement"
                            },
                            {
                                "kind": "Variable",
                                "name": "enableHighlighting",
                                "variableName": "enableHighlighting"
                            },
                            {
                                "kind": "Variable",
                                "name": "experience",
                                "variableName": "experience"
                            },
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "experimentId",
                                        "variableName": "experimentId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "experimentLayers",
                                        "variableName": "experimentLayers"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "shadowExperimentId",
                                        "variableName": "shadowExperimentId"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "experimentContext"
                            },
                            {
                                "kind": "Variable",
                                "name": "fanoutExperimentCohort",
                                "variableName": "fanoutExperimentCohort"
                            },
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "assetsFilters",
                                        "variableName": "assetsFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "commonFilters",
                                        "variableName": "commonFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "compassFilters",
                                        "variableName": "compassFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "confluenceFilters",
                                        "variableName": "confluenceFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "entities",
                                        "variableName": "entities"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "jiraFilters",
                                        "variableName": "jiraFilters"
                                    },
                                    {
                                        "items": [
                                            {
                                                "kind": "Variable",
                                                "name": "locations.0",
                                                "variableName": "cloudIdARI"
                                            }
                                        ],
                                        "kind": "ListValue",
                                        "name": "locations"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "mercuryFilters",
                                        "variableName": "mercuryFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "talentFilters",
                                        "variableName": "talentFilters"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "thirdPartyFilters",
                                        "variableName": "thirdPartyFilters"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "filters"
                            },
                            {
                                "kind": "Variable",
                                "name": "query",
                                "variableName": "query"
                            },
                            {
                                "kind": "Variable",
                                "name": "sort",
                                "variableName": "sort"
                            }
                        ],
                        "concreteType": "SearchItemConnection",
                        "kind": "LinkedField",
                        "name": "__SearchResultsPagination__search_connection",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "includeAssigneeField",
                                        "variableName": "includeAssigneeField"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeIconUrl",
                                        "variableName": "includeIconUrl"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeJiraLiteModeFields",
                                        "variableName": "includeJiraLiteModeFields"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeNavBoostScore",
                                        "variableName": "includeNavBoostScore"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includePassionfruitAsk",
                                        "variableName": "includePassionfruitAsk"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includePositions",
                                        "variableName": "includePositions"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "includeThirdPartyId",
                                        "variableName": "includeThirdPartyId"
                                    }
                                ],
                                "kind": "FragmentSpread",
                                "name": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData"
                            },
                            {
                                "concreteType": "SearchResultItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    }
                                ]
                            },
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "endCursor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$9777a9dc8fd7d279$var$node.hash = "88f564f4bb7d5f6b91ca1c498278457b";
var $9777a9dc8fd7d279$export$2e2bcd8739ae039 = $9777a9dc8fd7d279$var$node;









var $jTxSS = parcelRequire("jTxSS");











var $2cEww = parcelRequire("2cEww");





var $k4HRJ = parcelRequire("k4HRJ");


var $6h3V2 = parcelRequire("6h3V2");


var $fuGkE = parcelRequire("fuGkE");
















const $f9bf54cec5ccb807$var$DebugOverridesPanelLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("a9bjQ")).then(({ DebugOverridesPanel: DebugOverridesPanel })=>({
            default: DebugOverridesPanel
        })));
const $f9bf54cec5ccb807$export$bf4ee085e09787c5 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f9bf54cec5ccb807$var$DebugOverridesPanelLazy, {
            ...props
        })
    });


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $1bY7o = parcelRequire("1bY7o");











var $hpUsb = parcelRequire("hpUsb");

var $5TXU5 = parcelRequire("5TXU5");

var $5znEc = parcelRequire("5znEc");













var $1VHLw = parcelRequire("1VHLw");

const $514d99dea8b7ae4b$var$fallbackComponentStyles = null;
const $514d99dea8b7ae4b$var$styles = null;
const $514d99dea8b7ae4b$var$cardList = {
    base: "_zulpv47k _1e0c1txw _2lx21bp4",
    hidden: "_tzy4idpf _kqswstnw _154iidpf",
    appended: "_ca0q1b66",
    notAppended: "_ca0qpxbi"
}; /**
    * Smart cards lazy load when they are in the viewport. This is a behavior that is
    * not desired in this experience. To circumvent this, we set the position of the
    * card to absolute and hide it until the link is resolved. This allows the card to
    * be rendered in the DOM without lazy loading, while still being hidden from view
    * until the link is resolved.
    */ 
const $514d99dea8b7ae4b$var$card = {
    hidden: "_tzy4idpf _kqswstnw _154iidpf"
};
const $514d99dea8b7ae4b$var$skeleton = {
    grid: "_zulpu2gc _1e0c11p5 _1lmcyw1n _yv0e1p7m _2z051d08",
    iconArea: "_nd5l2ec4",
    titleArea: "_nd5l1cy2",
    metaArea: "_nd5l8bpj"
};
const $514d99dea8b7ae4b$export$dffce0f8d8968f9c = ({ links: links = [], isLinkedResults: isLinkedResults, indexOffset: indexOffset, parentPosition: parentPosition, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [linksLoading, setLinksLoading] = (0, $42omo.useState)(links);
    const [linkProductKeys, setLinkProductKeys] = (0, $42omo.useState)(new Map());
    const cards = links.map((link, index)=>{
        const resolveLink = (productKey)=>{
            if (productKey) setLinkProductKeys((prev)=>{
                // Only update if the value has changed to prevent infinite re-renders
                if (prev.get(link) !== productKey) {
                    const newMap = new Map(prev);
                    newMap.set(link, productKey);
                    return newMap;
                }
                return prev;
            });
            if (linksLoading.includes(link)) setLinksLoading((prev)=>prev.filter((l)=>l !== link));
        };
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            role: "button",
            tabIndex: 0,
            onContextMenu: (e)=>{
                if (isLinkedResults) {
                    e.preventDefault();
                    const productKey = linkProductKeys.get(link);
                    const fanoutProduct = $514d99dea8b7ae4b$var$getProductKey(productKey);
                    onResultContextMenu?.({
                        sublistPosition: index + (indexOffset ?? 0),
                        linkDocContentType: (0, $lwP5K.LinkDocContentType).extractedLink,
                        fanoutProduct: fanoutProduct
                    });
                }
            },
            onAuxClick: (e)=>{
                if ((0, $1VHLw.isAuxClick)(e) && isLinkedResults && (0, $dh538.fg)('add-middle-click-event-fanout-results')) {
                    const productKey = linkProductKeys.get(link);
                    const fanoutProduct = $514d99dea8b7ae4b$var$getProductKey(productKey);
                    onResultClicked?.({
                        sublistPosition: index + (indexOffset ?? 0),
                        linkDocContentType: (0, $lwP5K.LinkDocContentType).extractedLink,
                        fanoutProduct: fanoutProduct,
                        isAuxClick: true
                    });
                }
            },
            className: (0, $gMc0m.default)([
                linksLoading.length && $514d99dea8b7ae4b$var$card.hidden
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
                url: link,
                appearance: "inline",
                ui: {
                    hideElevation: true,
                    hideBackground: true,
                    hidePadding: true,
                    size: (0, $5TXU5.SmartLinkSize).Medium
                },
                onResolve: ({ extensionKey: extensionKey })=>{
                    resolveLink(extensionKey);
                },
                onError: ({ status: status })=>{
                    resolveLink();
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'error',
                            actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}SearchResultSmartCard`,
                            source: (0, $6yNqK.EVENT_SOURCE),
                            attributes: {
                                status: status
                            }
                        }
                    }).fire();
                },
                onClick: ()=>{
                    window.open(link, '_blank', 'noopener,noreferrer');
                    const productKey = linkProductKeys.get(link);
                    const fanoutProduct = $514d99dea8b7ae4b$var$getProductKey(productKey);
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}SearchResultSmartCard`,
                            source: (0, $6yNqK.EVENT_SOURCE),
                            attributes: {
                                position: parentPosition,
                                sublistPosition: indexOffset !== undefined ? index + indexOffset : undefined
                            }
                        }
                    }).fire();
                    if (isLinkedResults) onResultClicked?.({
                        sublistPosition: index + (indexOffset ?? 0),
                        linkDocContentType: (0, $lwP5K.LinkDocContentType).extractedLink,
                        fanoutProduct: fanoutProduct
                    });
                },
                placeholder: " ",
                fallbackComponent: ()=>/*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            "_zulp1b66 _1e0c1txw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                                label: "",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                                href: link,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: link
                            })
                        ]
                    }),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                    hideRetry: true,
                    hideIconLoadingSkeleton: true,
                    maxLines: 1,
                    metadata: [
                        {
                            name: (0, $5TXU5.ElementName).State
                        }
                    ],
                    subtitle: [
                        {
                            name: (0, $5TXU5.ElementName).CreatedBy
                        },
                        {
                            name: (0, $5TXU5.ElementName).ModifiedOn
                        }
                    ],
                    metadataPosition: (0, $5TXU5.SmartLinkPosition).Top,
                    position: (0, $5TXU5.SmartLinkPosition).Top
                })
            })
        }, link);
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_kqswh2mm _19bvutpp"
        ]),
        children: [
            linksLoading.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $514d99dea8b7ae4b$var$cardList.base
                ]),
                children: links.map((link)=>/*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            $514d99dea8b7ae4b$var$skeleton.grid
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    $514d99dea8b7ae4b$var$skeleton.iconArea
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                    height: "16px",
                                    width: "16px",
                                    borderRadius: "var(--ds-radius-small, 4px)",
                                    isShimmering: true
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    $514d99dea8b7ae4b$var$skeleton.titleArea
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                    height: "16px",
                                    width: "50%",
                                    isShimmering: true
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    $514d99dea8b7ae4b$var$skeleton.metaArea
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                    height: "16px",
                                    width: "85%",
                                    isShimmering: true
                                })
                            })
                        ]
                    }, link))
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $514d99dea8b7ae4b$var$cardList.base,
                    linksLoading.length && $514d99dea8b7ae4b$var$cardList.hidden,
                    isLinkedResults ? $514d99dea8b7ae4b$var$cardList.appended : $514d99dea8b7ae4b$var$cardList.notAppended
                ]),
                children: cards
            })
        ]
    });
};
const $514d99dea8b7ae4b$export$a414b3d5a172e15b = (text)=>{
    // URL terminator class (see {@link URL_PATTERN}) excludes whitespace,
    // markdown/HTML closers, and HTML attribute quotes (`"` / `'`) so a URL
    // inside `<img src="https://…/foo.png">` doesn't consume the closing `"`.
    const cleanedText = text.replace($514d99dea8b7ae4b$var$HIGHLIGHT_OPEN_PATTERN, '').replace($514d99dea8b7ae4b$var$HIGHLIGHT_CLOSE_PATTERN, '');
    let matches = cleanedText.match($514d99dea8b7ae4b$var$URL_PATTERN)?.map(String) || []; // Check if the text ends with a URL - if so, exclude it as it might be truncated
    if (matches.length > 0) {
        const lastMatch = matches[matches.length - 1];
        const lastMatchIndex = cleanedText.lastIndexOf(lastMatch);
        const textEndsWithLastMatch = lastMatchIndex + lastMatch.length === cleanedText.length; // If the text ends with a URL, exclude the last url match
        if (textEndsWithLastMatch) matches = matches.slice(0, -1);
    } // Filter out URLs that end with invalid patterns like "...", ".", ",", etc.
    const validMatches = matches.filter((url)=>!$514d99dea8b7ae4b$var$URL_INVALID_ENDING_PATTERN.test(url)); // Deduplicate (helpful for markdown like [https://example.com](https://example.com) )
    return [
        ...new Set(validMatches)
    ];
}; /**
    * Returns a normalized form of a URL suitable for *deduplication only*. The
    * original URL string should still be passed to UI components — this output is
    * not safe to render or navigate to.
    *
    * Normalization handles common ways the same resource ends up represented
    * differently across data sources (e.g. UGS-hydrated Jira issue links vs URLs
    * parsed straight out of an excerpt body):
    *
    * - Lower-cases the protocol and host (`HTTPS://Example.COM` → `https://example.com`)
    * - Strips a single trailing `/` from the path so `/foo` and `/foo/` match
    * - Falls back to the raw input if the URL cannot be parsed
    *
    * URL fragments (`#section-1`) are intentionally preserved — different
    * fragments often point at meaningfully different anchors on the same page
    * and should not be collapsed.
    */ 
const $514d99dea8b7ae4b$export$7b20225cbdd539d1 = (url)=>{
    if (!url) return url;
    try {
        const parsed = new URL(url);
        parsed.protocol = parsed.protocol.toLowerCase();
        parsed.hostname = parsed.hostname.toLowerCase();
        if (parsed.pathname.length > 1 && parsed.pathname.endsWith('/')) parsed.pathname = parsed.pathname.slice(0, -1);
        return parsed.toString();
    } catch  {
        return url;
    }
}; /**
    * Merges two or more lists of URLs, preserving the order of the first occurrence
    * and deduplicating using {@link canonicalizeUrlForDedupe} so that variants of
    * the same resource (trailing slash, fragment, casing of host, etc.) collapse
    * into a single entry. The first occurrence wins for the displayed URL.
    */ 
const $514d99dea8b7ae4b$export$d5a8f8e0d92d5f5e = (...lists)=>{
    const seen = new Set();
    const result = [];
    for (const list of lists)for (const link of list){
        if (!link) continue;
        const key = $514d99dea8b7ae4b$export$7b20225cbdd539d1(link);
        if (seen.has(key)) continue;
        seen.add(key);
        result.push(link);
    }
    return result;
}; /**
    * Tags whose entire element (open, children, close) should be dropped when
    * cleaning up an excerpt for plain-text rendering. These are "replaced" /
    * media elements whose meaningful content is the asset they reference, not
    * any inner text — leaving the surrounding text in place would just produce
    * empty shells like `<picture></picture>`.
    *
    * Kept lower-case; the regex below uses the `i` flag.
    */ 
const $514d99dea8b7ae4b$var$REPLACED_HTML_ELEMENTS = [
    'img',
    'picture',
    'source',
    'video',
    'audio',
    'iframe',
    'object'
]; // Pre-compiled regex constants — see `removeHtmlTags` for why each exists.
// Hoisted to module scope so we don't pay V8's regex-compile cost on every
// call. All patterns are linear-time (no nested quantifiers, concrete
// terminators) and safe to share because we never read `.lastIndex` ourselves.
const $514d99dea8b7ae4b$var$HTML_COMMENT_PATTERN = /<!--[\s\S]*?-->/g; // Paired form (uses a backreference so the open/close tag names must match):
// `<tag …>…</tag>`. Combined into a single alternation across all replaced
// elements so we do one regex pass instead of N.
const $514d99dea8b7ae4b$var$REPLACED_PAIRED_PATTERN = new RegExp(`<\\s*(${$514d99dea8b7ae4b$var$REPLACED_HTML_ELEMENTS.join('|')})\\b[^>]*>[\\s\\S]*?<\\s*/\\s*\\1\\s*>`, 'gi'); // Self-closing / void form: `<tag …/>` or `<tag …>`. Single alternation pass.
const $514d99dea8b7ae4b$var$REPLACED_VOID_PATTERN = new RegExp(`<\\s*(?:${$514d99dea8b7ae4b$var$REPLACED_HTML_ELEMENTS.join('|')})\\b[^>]*?/?>`, 'gi'); // Truncated opening of a replaced element at the tail of the excerpt (no `>`).
const $514d99dea8b7ae4b$var$REPLACED_TRUNCATED_TAIL_PATTERN = new RegExp(`<\\s*(?:${$514d99dea8b7ae4b$var$REPLACED_HTML_ELEMENTS.join('|')})\\b[^>]*$`, 'i');
const $514d99dea8b7ae4b$var$GENERIC_TAG_PATTERN = /<\/?[a-zA-Z][^>]*>/g;
const $514d99dea8b7ae4b$var$COLLAPSED_SPACES_PATTERN = /[ \t]{2,}/g;
const $514d99dea8b7ae4b$var$SPACE_BEFORE_PUNCTUATION_PATTERN = /\s+([.,;!?])/g; // Pre-compiled patterns shared by `getLinksFromText` and `removeUrlsFromText`.
const $514d99dea8b7ae4b$var$URL_PATTERN = /(https?:\/\/[^\s|>)\]"']+)/g;
const $514d99dea8b7ae4b$var$URL_INVALID_ENDING_PATTERN = /\.{2,}|[.,;!?]+$/;
const $514d99dea8b7ae4b$var$HIGHLIGHT_OPEN_PATTERN = /@@@hl@@@/g;
const $514d99dea8b7ae4b$var$HIGHLIGHT_CLOSE_PATTERN = /@@@endhl@@@/g;
const $514d99dea8b7ae4b$var$URL_WITH_OPTIONAL_HIGHLIGHTS_PATTERN = /(?:@@@hl@@@\s*)?https?:\/\/[^\s|>)\]"']+(?:\s*@@@endhl@@@)?/g; // Pre-compiled patterns shared by `extractMarkdownAndAnchorLinkHrefs`.
const $514d99dea8b7ae4b$var$MARKDOWN_LINK_PATTERN = RegExp("(?<!!)\\[[^\\]]*\\]\\((https?:\\/\\/[^\\s)]+)\\)", "g");
const $514d99dea8b7ae4b$var$ANCHOR_HREF_PATTERN = /<\s*a\b[^>]*?\bhref\s*=\s*("([^"]+)"|'([^']+)')/gi;
const $514d99dea8b7ae4b$var$HTTP_PROTOCOL_PATTERN = /^https?:\/\//i; /**
                                                * Pulls http(s) URLs out of "rich" link carriers in a body of text *before*
                                                * any cleanup passes (`removeMarkdown`, `removeHtmlTags`) consume them. Used
                                                * to seed the Links expand with URLs that would otherwise be silently dropped
                                                * when their wrappers are stripped.
                                                *
                                                * Currently extracts:
                                                * - Markdown link `(href)` parts, e.g. `[label](https://example.com)` →
                                                *   `https://example.com`. Reference-style links (`[label][1]`) and bare
                                                *   autolinks (`<https://…>`) are intentionally not handled here — bare
                                                *   autolinks are picked up by {@link getLinksFromText} after cleanup.
                                                * - `<a href="…">` and `<a href='…'>` attribute values.
                                                *
                                                * Image URLs (`<img src>`, `<picture>`, `![alt](url)`) are deliberately *not*
                                                * extracted: they reference assets, not navigable links, and surfacing them
                                                * in a "Links" expand creates noise (e.g. screenshot URLs in PR descriptions).
                                                *
                                                * Only `http(s)` URLs are returned; relative paths, `mailto:`, etc. are
                                                * skipped because the Links expand only supports navigable web URLs.
                                                */ 
const $514d99dea8b7ae4b$export$de7a19833a380984 = (text)=>{
    if (!text) return [];
    const results = []; // Markdown link `[label](url)`. Negative lookbehind in MARKDOWN_LINK_PATTERN
    // excludes the image form `![alt](url)`.
    for (const match of text.matchAll($514d99dea8b7ae4b$var$MARKDOWN_LINK_PATTERN))results.push(match[1]);
     // `<a href="…">` and `<a href='…'>` (any attribute order).
    for (const match of text.matchAll($514d99dea8b7ae4b$var$ANCHOR_HREF_PATTERN)){
        const href = match[2] ?? match[3];
        if (href && $514d99dea8b7ae4b$var$HTTP_PROTOCOL_PATTERN.test(href)) results.push(href);
    }
    return results;
}; /**
    * Removes HTML tags from a body of text so that excerpts (e.g. GitHub PR
    * descriptions, which support a restricted subset of HTML inside Markdown)
    * render cleanly as plain text instead of showing raw markup.
    *
    * Behaviour:
    * - For "replaced" / media elements ({@link REPLACED_HTML_ELEMENTS}, e.g.
    *   `<img>`, `<picture>`, `<video>`), the entire element (open tag, children,
    *   close tag) is removed. This handles both self-closing forms
    *   (`<img … />`, `<img …>`) and full forms (`<picture><source …/><img …/></picture>`).
    * - HTML comments (`<!-- … -->`) are removed.
    * - All other tags have their open/close markers stripped while the inner
    *   text content is preserved, so `<a href="…">label</a>` becomes `label`
    *   and `<details><summary>title</summary>body</details>` becomes
    *   `titlebody`.
    * - HTML entities are *not* decoded — that's intentional, the existing
    *   excerpt pipeline does not introduce raw entities.
    *
    * This helper is intentionally not a parser — excerpts are short and may
    * contain malformed HTML, so we use a small set of regexes that fail safe
    * (worst case: a stray `<` survives in the rendered output).
    */ 
const $514d99dea8b7ae4b$export$b7bece7666af5428 = (text)=>{
    if (!text) return '';
    let result = text; // 1. Drop HTML comments.
    result = result.replace($514d99dea8b7ae4b$var$HTML_COMMENT_PATTERN, ''); // Note: we intentionally do NOT try to repair *truncated* HTML comments
    // (e.g. an excerpt that starts mid-comment with `…content…-->`). A heuristic
    // like "delete up to the first `-->`" would have unacceptable false-positive
    // risk: arrow operators (`-->`), shell pipes, and other prose constructs
    // would be silently mangled. The cosmetic artifact is preferred.
    // 2. Drop entire replaced/media elements (open tag, children, close tag).
    //    Handles `<img …/>`, `<img …>`, and `<picture>…</picture>`. Paired form
    //    is removed first using a backreference (`\1`) to require matching
    //    open/close tag names so we don't leave a stray closing tag behind
    //    after the void pass.
    result = result.replace($514d99dea8b7ae4b$var$REPLACED_PAIRED_PATTERN, '');
    result = result.replace($514d99dea8b7ae4b$var$REPLACED_VOID_PATTERN, ''); // 2b. Truncated opening of a replaced/media element at the *tail* of the
    //     excerpt — e.g. `…<img width="307" alt="screenshot" src="https://…`
    //     with no closing `>`. The excerpt windowing on the backend can clip in
    //     the middle of a tag; `removeMarkdown` would otherwise eat just the
    //     leading `<` (its "broken autolink" rule), leaving the attribute soup
    //     visible inline. Restricting this to media element names keeps the
    //     false-positive risk low: regular prose tags like `<details>` or `<a>`
    //     are intentionally NOT included because the text *after* them is
    //     meaningful and dropping the tail would lose content. Only triggers
    //     when there is no `>` anywhere after the `<tag` — i.e. the tag is
    //     unambiguously unterminated within the excerpt.
    result = result.replace($514d99dea8b7ae4b$var$REPLACED_TRUNCATED_TAIL_PATTERN, ''); // 3. Strip remaining tags but keep their inner text content.
    result = result.replace($514d99dea8b7ae4b$var$GENERIC_TAG_PATTERN, ''); // 4. Tidy up whitespace introduced by tag removal, but preserve newlines.
    result = result.replace($514d99dea8b7ae4b$var$COLLAPSED_SPACES_PATTERN, ' ');
    result = result.replace($514d99dea8b7ae4b$var$SPACE_BEFORE_PUNCTUATION_PATTERN, '$1');
    return result.trim();
}; /**
    * Removes bare http(s) URLs from a body of text so they can be surfaced separately
    * (e.g. in a Links expand) without appearing twice in a result excerpt.
    *
    * Mirrors the URL pattern used by {@link getLinksFromText} so that the same set of
    * tokens that gets pulled into the Links expand is the set of tokens removed from
    * the body. Highlight markers (`@@@hl@@@…@@@endhl@@@`) wrapping a URL are also
    * stripped along with the URL so we don't leave dangling markers behind.
    *
    * - Preserves surrounding text
    * - Collapses whitespace introduced by URL removal so the body reads cleanly
    * - Does not attempt to undo markdown link syntax — pair with `removeMarkdown`
    *   first if the input may contain `[label](url)` style links
    */ 
const $514d99dea8b7ae4b$export$2f84a359bd634be4 = (text)=>{
    if (!text) return '';
     // URL token (URL_WITH_OPTIONAL_HIGHLIGHTS_PATTERN) is kept in sync with
    // `getLinksFromText` so the same characters terminate the URL — including
    // HTML attribute quotes (`"` / `'`).
    return text.replace($514d99dea8b7ae4b$var$URL_WITH_OPTIONAL_HIGHLIGHTS_PATTERN, '') // Collapse runs of whitespace left behind by URL removal, but preserve newlines
    .replace($514d99dea8b7ae4b$var$COLLAPSED_SPACES_PATTERN, ' ') // Trim spaces that now sit immediately before punctuation
    .replace($514d99dea8b7ae4b$var$SPACE_BEFORE_PUNCTUATION_PATTERN, '$1').trim();
};
const $514d99dea8b7ae4b$var$getProductKey = (key)=>{
    if (!key) return 'unknown';
    const foundKey1P = (0, $b4tvS.all1pProductKeys).find((productKey)=>key.includes(productKey));
    if (foundKey1P) return foundKey1P;
    const foundKey3P = (0, $1yEFx.all3pProductKeys).find((productKey)=>key.includes(productKey));
    if (foundKey3P) return foundKey3P;
    return 'unknown';
};
const $514d99dea8b7ae4b$export$47614749115bca3d = (0, $aXWIB.defineMessage)({
    id: "link-attachments.button.label",
    defaultMessage: "{count, plural, one {# link} other {# links}}"
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $69PnT = parcelRequire("69PnT");





var $b4wUN = parcelRequire("b4wUN");







/**
 * Domain patterns for different products
 * Maps domain patterns to ProductKeys (both 1P and 3P)
 */ const $21d2cd4cc2a842d3$var$DOMAIN_TO_PRODUCT_MAP = [
    // First-party Atlassian products
    {
        pattern: /^(.*\.)?atlassian\.net$/i,
        product: 'confluence'
    },
    {
        pattern: /^(.*\.)?atlassian\.com$/i,
        product: 'confluence'
    },
    {
        pattern: /^(.*\.)?trello\.com$/i,
        product: 'trello'
    },
    {
        pattern: /^(.*\.)?bitbucket\.org$/i,
        product: 'bitbucket'
    },
    // Google products (3P)
    {
        pattern: /^(.*\.)?drive\.google\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).GoogleDrive
    },
    {
        pattern: /^(.*\.)?docs\.google\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).GoogleDrive
    },
    {
        pattern: /^(.*\.)?sheets\.google\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).GoogleDrive
    },
    {
        pattern: /^(.*\.)?slides\.google\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).GoogleDrive
    },
    {
        pattern: /^(.*\.)?calendar\.google\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).GoogleCalendar
    },
    {
        pattern: /^(.*\.)?mail\.google\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Gmail
    },
    {
        pattern: /^(.*\.)?gmail\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Gmail
    },
    // Microsoft products (3P)
    {
        pattern: /^(.*\.)?sharepoint\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Sharepoint
    },
    {
        pattern: /^(.*\.)?onedrive\.live\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).OneDrive
    },
    {
        pattern: /^(.*\.)?1drv\.ms$/i,
        product: (0, $b4tvS.ProductKeys3P).OneDrive
    },
    {
        pattern: /^(.*\.)?teams\.microsoft\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Teams
    },
    {
        pattern: /^(.*\.)?outlook\.live\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).OutlookMail
    },
    {
        pattern: /^(.*\.)?outlook\.office\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).OutlookCalendar
    },
    // Other popular products (3P)
    {
        pattern: /^(.*\.)?slack\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Slack
    },
    {
        pattern: /^(.*\.)?dropbox\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Dropbox
    },
    {
        pattern: /^(.*\.)?github\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Github
    },
    {
        pattern: /^(.*\.)?figma\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Figma
    },
    {
        pattern: /^(.*\.)?loom\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Loom
    },
    {
        pattern: /^(.*\.)?notion\.so$/i,
        product: (0, $b4tvS.ProductKeys3P).Notion
    },
    {
        pattern: /^(.*\.)?asana\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Asana
    },
    {
        pattern: /^(.*\.)?airtable\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Airtable
    },
    {
        pattern: /^(.*\.)?smartsheet\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Smartsheet
    },
    {
        pattern: /^(.*\.)?zendesk\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Zendesk
    },
    {
        pattern: /^(.*\.)?miro\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Miro
    },
    {
        pattern: /^(.*\.)?docusign\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Docusign
    },
    {
        pattern: /^(.*\.)?lucidchart\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Lucid
    },
    {
        pattern: /^(.*\.)?lucidspark\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Lucid
    },
    {
        pattern: /^(.*\.)?monday\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Monday
    },
    {
        pattern: /^(.*\.)?dev\.azure\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).AzureDevops
    },
    {
        pattern: /^(.*\.)?visualstudio\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).AzureDevops
    },
    {
        pattern: /^(.*\.)?gitlab\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Gitlab
    },
    {
        pattern: /^(.*\.)?canva\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Canva
    },
    {
        pattern: /^(.*\.)?box\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Box
    },
    {
        pattern: /^(.*\.)?zeplin\.io$/i,
        product: (0, $b4tvS.ProductKeys3P).Zeplin
    },
    {
        pattern: /^(.*\.)?servicenow\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).ServiceNow
    },
    {
        pattern: /^(.*\.)?freshservice\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Freshservice
    },
    {
        pattern: /^(.*\.)?powerbi\.microsoft\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).PowerBI
    },
    {
        pattern: /^(.*\.)?clickup\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).ClickUp
    },
    {
        pattern: /^(.*\.)?amplitude\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Amplitude
    },
    {
        pattern: /^(.*\.)?stripe\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Stripe
    },
    {
        pattern: /^(.*\.)?adobe\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).AdobeXD
    },
    // Could be AdobeSign too
    {
        pattern: /^(.*\.)?aha\.io$/i,
        product: (0, $b4tvS.ProductKeys3P).Aha
    },
    {
        pattern: /^(.*\.)?mural\.co$/i,
        product: (0, $b4tvS.ProductKeys3P).Mural
    },
    {
        pattern: /^(.*\.)?webex\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Webex
    },
    {
        pattern: /^(.*\.)?todoist\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Todoist
    },
    {
        pattern: /^(.*\.)?pagerduty\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).PagerDuty
    },
    {
        pattern: /^(.*\.)?pipedrive\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Pipedrive
    },
    {
        pattern: /^(.*\.)?hubspot\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Hubspot
    },
    {
        pattern: /^(.*\.)?dovetailapp\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Dovetail
    },
    {
        pattern: /^(.*\.)?launchdarkly\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).LaunchDarkly
    },
    {
        pattern: /^(.*\.)?salesforce\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Salesforce
    },
    {
        pattern: /^(.*\.)?sentry\.io$/i,
        product: (0, $b4tvS.ProductKeys3P).Sentry
    },
    {
        pattern: /^(.*\.)?gitbook\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).Gitbook
    },
    {
        pattern: /^(.*\.)?amazonaws\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).AWSS3
    },
    {
        pattern: /^(.*\.)?s3\..*\.amazonaws\.com$/i,
        product: (0, $b4tvS.ProductKeys3P).AWSS3
    }
];
/**
 * Extracts the domain from a URL
 */ function $21d2cd4cc2a842d3$var$extractDomain(url) {
    try {
        const urlObj = new URL(url);
        return urlObj.hostname;
    } catch  {
        return null;
    }
}
/**
 * Predicts the product type based on the URL domain
 */ function $21d2cd4cc2a842d3$var$predictProductFromDomain(url) {
    const domain = $21d2cd4cc2a842d3$var$extractDomain(url);
    if (!domain) return null;
    for (const { pattern: pattern, product: product } of $21d2cd4cc2a842d3$var$DOMAIN_TO_PRODUCT_MAP){
        if (pattern.test(domain)) return product;
    }
    return null;
}
/**
 * Classifies a URL into its type and product category
 */ function $21d2cd4cc2a842d3$var$classifyLink(url) {
    const product = $21d2cd4cc2a842d3$var$predictProductFromDomain(url);
    let linkType;
    if (product && (0, $b4tvS.is3pProductKey)(product)) linkType = '3p';
    else if (product && (0, $b4tvS.is1pProductKey)(product)) linkType = '1p';
    else linkType = 'unknown';
    return {
        url: url,
        product: product,
        linkType: linkType
    };
}
/**
 * Gets the tier priority for a link classification
 * Special case: Loom is treated as 1P even though it's in ProductsOrder3P
 */ function $21d2cd4cc2a842d3$var$getTierPriority(item) {
    // Special case: Loom should be treated as 1P
    if (item.product === (0, $b4tvS.ProductKeys3P).Loom) return 1; // Treat Loom as 1P priority
    if (item.linkType === '3p') return 0;
     // 3P links first
    if (item.linkType === '1p') return 1;
     // 1P links second
    return 2; // Unknown links last
}
function $21d2cd4cc2a842d3$export$396d67700f1fa04e(urls) {
    // Create order maps for faster lookup
    const fullProductOrderMap = new Map();
    (0, $b4tvS.PRODUCTS_ORDER).forEach((product, index)=>{
        fullProductOrderMap.set(product, index);
    });
    // Classify URLs by their type and product
    const classifiedUrls = urls.map((url)=>$21d2cd4cc2a842d3$var$classifyLink(url));
    // Sort URLs based on two-tier priority system
    classifiedUrls.sort((a, b)=>{
        // First tier: 3P vs 1P vs Unknown
        const tierA = $21d2cd4cc2a842d3$var$getTierPriority(a);
        const tierB = $21d2cd4cc2a842d3$var$getTierPriority(b);
        if (tierA !== tierB) return tierA - tierB;
        // Second tier: Within same tier, sort by product order
        if (a.linkType === '3p' && b.linkType === '3p' && a.product && b.product) {
            // For 3P products, use ProductsOrder3P ordering
            const order3pA = (0, $hdfeV.ProductsOrder3P).indexOf(a.product);
            const order3pB = (0, $hdfeV.ProductsOrder3P).indexOf(b.product);
            const priorityA = order3pA !== -1 ? order3pA : Number.MAX_SAFE_INTEGER;
            const priorityB = order3pB !== -1 ? order3pB : Number.MAX_SAFE_INTEGER;
            if (priorityA !== priorityB) return priorityA - priorityB;
        } else if (a.linkType === '1p' && b.linkType === '1p' && a.product && b.product || a.product === (0, $b4tvS.ProductKeys3P).Loom || b.product === (0, $b4tvS.ProductKeys3P).Loom) {
            // For 1P products or Loom (treated as 1P), use PRODUCTS_ORDER ordering
            // Special handling for Loom: position it right after Confluence
            let orderA;
            let orderB;
            if (a.product === (0, $b4tvS.ProductKeys3P).Loom) // Position Loom right after Confluence (index 0), so give it index 0.5
            orderA = 0.5;
            else orderA = fullProductOrderMap.get(a.product) ?? Number.MAX_SAFE_INTEGER;
            if (b.product === (0, $b4tvS.ProductKeys3P).Loom) orderB = 0.5;
            else orderB = fullProductOrderMap.get(b.product) ?? Number.MAX_SAFE_INTEGER;
            if (orderA !== orderB) return orderA - orderB;
        }
        // Third tier: If same type and product (or both unknown), maintain original order
        return 0;
    });
    return classifiedUrls.map((item)=>item.url);
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



















const $664c8ed2681bd434$var$styles = {
    base: "_ca0qu2gc",
    buttonText: "_19bvv77o",
    contentExpanded: "_1rjcu2gc",
    contentCollapsed: "_1rjcidpf"
};
function $664c8ed2681bd434$export$49bd1dfb0ad29c40({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        children: children
    });
}
const $664c8ed2681bd434$export$6b89e3fa6be10ffa = ({ children: children, defaultExpandedIndex: defaultExpandedIndex = -1, parentPosition: parentPosition, buttonType: buttonType, additionalFooterButton: additionalFooterButton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [activeId, setActiveId] = (0, $42omo.useState)(defaultExpandedIndex); // Sync activeId when defaultExpandedIndex changes (e.g., when position changes due to filtering)
    (0, $42omo.useEffect)(()=>{
        setActiveId(defaultExpandedIndex);
    }, [
        defaultExpandedIndex
    ]);
    const handleExpand = (expandId)=>setActiveId((prev)=>prev === expandId ? -1 : expandId);
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)).filter((child)=>child.props.attachmentCount > 0);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                children: [
                    childrenArray.map((child, index)=>{
                        const isExpanded = activeId === index;
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $664c8ed2681bd434$var$styles.base,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                iconBefore: child.props.icon,
                                onClick: ()=>{
                                    handleExpand(index);
                                    createAnalyticsEvent({
                                        action: 'clicked',
                                        actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}ExpandAttachmentButton`,
                                        eventType: 'ui',
                                        source: (0, $6yNqK.EVENT_SOURCE),
                                        attributes: {
                                            attachmentType: child.props.attachmentType,
                                            attachmentCount: child.props.attachmentCount,
                                            position: parentPosition,
                                            buttonType: buttonType
                                        }
                                    }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
                                },
                                isSelected: isExpanded,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $664c8ed2681bd434$var$styles.buttonText,
                                    children: child.props.label
                                })
                            }, child.props.label)
                        });
                    }),
                    additionalFooterButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $664c8ed2681bd434$var$styles.base,
                        children: additionalFooterButton
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $664c8ed2681bd434$var$styles[activeId >= 0 ? 'contentExpanded' : 'contentCollapsed'],
                children: childrenArray[activeId]
            })
        ]
    });
};



/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 























var $67gKI = parcelRequire("67gKI");





var $Y34Hw = parcelRequire("Y34Hw");




parcelRequire("42omo");













const $235a70ab221836e5$export$6582c9566971e750 = ({ product: product, resourceType: resourceType, size: size, thirdPartyConfigs: thirdPartyConfigs })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    if (!product) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
    let productKey = product === 'google' ? (0, $1yEFx.ProductKeys).GoogleDrive : product;
    /**
   * Temporary fix for Microsoft integrationKey
   */ if (product === (0, $Y34Hw.MICROSOFT_INTEGRATION_KEY)) productKey = (0, $Y34Hw.getProductFromMicrosoftResourceType)(product, resourceType) ?? productKey;
    let IconComponent;
    // For Forge connectors, prioritize dynamic API icons over static hardcoded ones
    if ((0, $9d9t8.isForgeConnectorProductKey)(productKey)) {
        const dynamicConfig = thirdPartyConfigs[productKey];
        if (dynamicConfig) IconComponent = dynamicConfig.searchResultIcon || dynamicConfig.icon;
    }
    // Fallback to static products (for non-Forge or if dynamic config not found)
    if (!IconComponent) IconComponent = products[productKey]?.SearchResultIcon || products[productKey]?.Icon;
    return IconComponent ? /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
        label: "",
        size: size
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
};





parcelRequire("42omo");
















const $0c09b7eff2986caa$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    lastModified: {
        id: "search-result.last-modified",
        defaultMessage: "Updated {formattedDate}"
    }
});


const $2ba9d06a8e432719$export$e6747eee8f26f8c0 = ({ lastModified: lastModified, message: message = (0, $0c09b7eff2986caa$export$defe85febe8b728c).lastModified })=>{
    if (!lastModified) return null;
    const lastModifiedDate = new Date(lastModified);
    const { value: value, unit: unit } = (0, $Y34Hw.getRelativeTimeSince)(lastModifiedDate);
    const absoluteDate = /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedDate), {
        value: lastModified,
        month: "short",
        day: "numeric",
        year: "numeric"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: absoluteDate,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ...tooltipProps,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...message,
                    values: {
                        formattedDate: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedRelativeTime), {
                            value: -value,
                            unit: unit
                        })
                    }
                })
            })
    });
};



var $cORSX = parcelRequire("cORSX");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $gpC9w = parcelRequire("gpC9w");


var $h7sRY = parcelRequire("h7sRY");


var $mdlgz = parcelRequire("mdlgz");


var $gCEkV = parcelRequire("gCEkV");

const $5f3358d8816326cd$var$styles = {
    subheading: "_11c8wadc _nd5l1wdz _1reo15vq _18m915vq _syazazsu _1e0c1txw _4cvr1h6o _o5721q9c _1bto1l2s _19bv1b66",
    inline: "_16jlkb7n _1o9zidpf _i0dl1wug _kqswstnw _1pbyb4wl _4cvr1h6o",
    hiddenReferenceInline: "_16jlkb7n _1o9zidpf _i0dl1wug _3um015vq _kqswh2mm _1pbykb7n _4cvr1h6o",
    metadataItem: "_1e0c116y _4cvr1h6o"
};
const $5f3358d8816326cd$var$renderParts = (part, spacer)=>{
    const [key, value] = Array.isArray(part) ? part : [
        part,
        part
    ];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            value,
            spacer && /*#__PURE__*/ (0, $l998X.jsx)((0, $mdlgz.Spacer), {})
        ]
    }, key);
};
const $5f3358d8816326cd$var$filterPart = (part)=>{
    if (Array.isArray(part)) return !!part[1];
    return !!part;
};
const $5f3358d8816326cd$export$112d13beb34a0b82 = (parts, allowedKeys)=>{
    return parts.filter((part)=>{
        if (Array.isArray(part)) {
            const [key] = part;
            return allowedKeys.includes(key);
        } // For string parts, we keep them as they don't have keys
        return typeof part === 'string';
    });
};
const $5f3358d8816326cd$var$SearchMetadataWithOverflowObserver = ({ metadataItems: metadataItems, searchResultId: searchResultId, containerRef: containerRef })=>{
    const headerMetadataWithIds = metadataItems.map((item, index)=>{
        const prefix = searchResultId || 'default';
        return {
            id: `metadata-${prefix}-${index}`,
            content: item
        };
    });
    const headerMetadataRefs = (0, $42omo.useRef)([]);
    headerMetadataRefs.current = headerMetadataWithIds.map((_, i)=>headerMetadataRefs.current[i] ?? /*#__PURE__*/ (0, $42omo.createRef)());
    const visibleItems = (0, $gCEkV.useOverflowObserver)({
        containerRef: containerRef,
        itemRefs: headerMetadataRefs,
        itemIds: headerMetadataWithIds.map((item)=>item.id)
    });
    const hasHiddenItems = headerMetadataWithIds.length > visibleItems.length;
    const processVisibleItems = ()=>{
        const visibleMetadata = headerMetadataWithIds.filter((item)=>visibleItems.includes(item.id)); // If we have hidden items, remove spacer from last visible item
        if (hasHiddenItems && visibleMetadata.length > 0) {
            const lastIndex = visibleMetadata.length - 1;
            visibleMetadata[lastIndex] = {
                ...visibleMetadata[lastIndex],
                content: (0, $gpC9w.filterSpacer)(visibleMetadata[lastIndex].content)
            };
        }
        return visibleMetadata;
    };
    const processedVisibleItems = processVisibleItems();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $5f3358d8816326cd$var$styles.subheading,
        testId: "search-page-linked-result-metadata",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: $5f3358d8816326cd$var$styles.hiddenReferenceInline,
                testId: "search-page-linked-result-metadata-hidden",
                children: headerMetadataWithIds.map((item, index)=>{
                    const elementId = `reference:${item.id}`;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        id: elementId,
                        ref: headerMetadataRefs.current[index],
                        xcss: $5f3358d8816326cd$var$styles.metadataItem,
                        children: item.content
                    }, elementId);
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                xcss: $5f3358d8816326cd$var$styles.inline,
                testId: "search-page-linked-result-metadata-visible",
                children: [
                    processedVisibleItems.map((item)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $5f3358d8816326cd$var$styles.metadataItem,
                            children: item.content
                        }, `visible-${item.id}`)),
                    hasHiddenItems && /*#__PURE__*/ (0, $l998X.jsx)((0, $h7sRY.MetadataPopupButton), {
                        metadata: headerMetadataWithIds.filter((item)=>!visibleItems.includes(item.id)).map((item)=>item.content),
                        isFirstElement: processedVisibleItems.length === 0
                    })
                ]
            })
        ]
    });
};
const $5f3358d8816326cd$export$fe43dae6529505e9 = ({ searchResultId: searchResultId, parts: defaultParts = [], displaySpacer: displaySpacer = true, containerRef: containerRef })=>{
    // Filter to only keep parts with keys 'type' and 'last-modified'
    const filteredParts = $5f3358d8816326cd$export$112d13beb34a0b82(defaultParts, [
        'type',
        'last-modified'
    ]);
    const parts = filteredParts.filter($5f3358d8816326cd$var$filterPart);
    const metadataItems = parts.map((m, i)=>$5f3358d8816326cd$var$renderParts(m, displaySpacer && i < parts.length - 1)); // If we don't have a containerRef, we don't want to use the overflow observer
    return containerRef ? /*#__PURE__*/ (0, $l998X.jsx)($5f3358d8816326cd$var$SearchMetadataWithOverflowObserver, {
        metadataItems: metadataItems,
        searchResultId: searchResultId,
        containerRef: containerRef
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: metadataItems
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");



























var $kqMUN = parcelRequire("kqMUN");


var $976IZ = parcelRequire("976IZ");

const $5a3f247da11d2140$var$isRevampTreatment = (0, $2OtFZ.serveFullpageSearchSummarizeButtonRevamp)({
    fireExperimentExposure: false
}) !== 'control';
const $5a3f247da11d2140$var$styles = {
    headingArea: "_nd5laoqn _11c8fhey _1ul91x4w",
    headingAreaRevamp: "_nd5laoqn _11c8fhey _1ul9idpf",
    title: "_1reo15vq _18m915vq _1e0c116y _19bv1b66",
    titleText: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
    visitedLink: "_5bd61r31 _13jxglyw _xatrnqa1 _1xteglyw _10531ra0 _9oik1r31 _1bnx8stv _jf4cnqa1 _1vhv17z1",
    visitedLinkPatch: "_syaz1ra0 _9h8h17z1",
    grid: "_zulpxy5q _yv0ed3ry"
};
const $5a3f247da11d2140$export$b98262479e3660fe = (props)=>{
    const { id: id, title: title, url: url, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, sublistPosition: sublistPosition, provider: provider, category: category } = props; /**
              * A dynamic search_id query param and queryHash is appended to the document URL for 1P search results.
              * As result we are unable to use the browser's visited links history to determine if a link has been visited.
              * This is workaround until we have a better solution.
              */ 
    const visitedLinks = (0, $976IZ.getVisitedLinks)();
    const isVisitedLink = id ? (0, $kqMUN.isVisited)(visitedLinks, id) : false;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $5a3f247da11d2140$var$isRevampTreatment ? $5a3f247da11d2140$var$styles.headingAreaRevamp : $5a3f247da11d2140$var$styles.headingArea,
        onClick: ()=>{
            if (id) {
                onResultClicked?.({
                    fromLinksSeeAll: false,
                    sublistPosition: sublistPosition,
                    provider: provider,
                    fanoutProduct: provider,
                    linkDocId: id,
                    linkDocContentType: (0, $lwP5K.LinkDocContentType).boostedLink,
                    fanoutLinkCategory: category
                });
                (0, $976IZ.addVisitedLink)(id);
            }
        },
        onContextMenu: ()=>{
            if (id) onResultContextMenu?.({
                sublistPosition: sublistPosition,
                fanoutProduct: provider,
                linkDocId: id,
                linkDocContentType: (0, $lwP5K.LinkDocContentType).boostedLink,
                fanoutLinkCategory: category
            });
        },
        onAuxClick: (e)=>{
            if ((0, $1VHLw.isAuxClick)(e) && id && (0, $dh538.fg)('add-middle-click-event-fanout-results')) onResultClicked?.({
                fromLinksSeeAll: false,
                sublistPosition: sublistPosition,
                provider: provider,
                fanoutProduct: provider,
                linkDocId: id,
                linkDocContentType: (0, $lwP5K.LinkDocContentType).boostedLink,
                fanoutLinkCategory: category,
                isAuxClick: true
            });
        },
        children: id && url ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
            xcss: $5a3f247da11d2140$var$styles.grid,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                alignItems: "center",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                    xcss: (0, $1Whri.cx)($5a3f247da11d2140$var$styles.visitedLink, isVisitedLink && $5a3f247da11d2140$var$styles.visitedLinkPatch, $5a3f247da11d2140$var$styles.title),
                    href: url,
                    testId: "search-page-linked-result-link",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $5a3f247da11d2140$var$styles.titleText,
                        children: title
                    })
                })
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $5a3f247da11d2140$var$styles.title,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $5a3f247da11d2140$var$styles.titleText,
                children: title
            })
        })
    });
};


const $55195f091cb52b39$var$getLinkedResultIcon = (category, productKey3P, resultAri, thirdPartyConfigs)=>{
    // When 1P mentions 3P: category is 'MENTIONS'
    // Return the correct 3P icon for the linked result
    if (category?.toLocaleUpperCase() === 'MENTIONS' && thirdPartyConfigs) return /*#__PURE__*/ (0, $l998X.jsx)((0, $235a70ab221836e5$export$6582c9566971e750), {
        product: productKey3P,
        resourceType: resultAri.resourceType,
        size: 'xxsmall',
        thirdPartyConfigs: thirdPartyConfigs
    });
    else if (category?.toLocaleUpperCase() === 'MENTIONEDBY') {
        const icon1P = resultAri.resourceOwner in (0, $1yEFx.products1P) ? (0, $1yEFx.products1P)[resultAri.resourceOwner].Icon : undefined;
        return icon1P ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(icon1P, {
                size: 'xxsmall'
            })
        }) : null;
    } else if (category?.toLocaleUpperCase() === 'SIMILAR') {
        if (productKey3P && thirdPartyConfigs) return /*#__PURE__*/ (0, $l998X.jsx)((0, $235a70ab221836e5$export$6582c9566971e750), {
            product: productKey3P,
            resourceType: resultAri.resourceType,
            size: 'xxsmall',
            thirdPartyConfigs: thirdPartyConfigs
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
            size: "xxsmall",
            shouldUseNewLogoDesign: true
        });
    } else if (category?.toLocaleUpperCase() === 'CHILD') {
        if (productKey3P && thirdPartyConfigs) return /*#__PURE__*/ (0, $l998X.jsx)((0, $235a70ab221836e5$export$6582c9566971e750), {
            product: productKey3P,
            resourceType: resultAri.resourceType,
            size: 'xxsmall',
            thirdPartyConfigs: thirdPartyConfigs
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
            size: "xxsmall",
            shouldUseNewLogoDesign: true
        });
    }
    return null;
};
const $55195f091cb52b39$export$daafd2babca66cfb = (category, subtype, type, fallbackType)=>{
    const normCategory = category?.toLocaleUpperCase(); // MENTIONS: use subtype, then fallbackType, then unrecognised
    if (normCategory === 'MENTIONS') {
        if (subtype != null && subtype in (0, $cORSX.messages)) return (0, $cORSX.messages)[subtype];
        if (fallbackType && fallbackType in (0, $cORSX.messages)) return (0, $cORSX.messages)[fallbackType];
        return (0, $cORSX.messages).unrecognised;
    } // SIMILAR: use type, then subtype, then fallbackType, then unrecognised
    if (normCategory === 'SIMILAR') {
        if (type != null && type in (0, $cORSX.messages)) return (0, $cORSX.messages)[type];
        if (subtype != null && subtype in (0, $cORSX.messages)) return (0, $cORSX.messages)[subtype];
        if (fallbackType && fallbackType in (0, $cORSX.messages)) return (0, $cORSX.messages)[fallbackType];
        return (0, $cORSX.messages).unrecognised;
    } // MENTIONEDBY, CHILD, undefined: use type, then fallbackType, then unrecognised
    if (type != null && type in (0, $cORSX.messages)) return (0, $cORSX.messages)[type];
    if (fallbackType && fallbackType in (0, $cORSX.messages)) return (0, $cORSX.messages)[fallbackType];
    return (0, $cORSX.messages).unrecognised;
};
const $55195f091cb52b39$var$styles = {
    iconArea: "_nd5l2ec4 _1e0c1txw _4cvr1y6m _1bah1h6o _1bsb7vkz",
    newIcon: "_ca0qv77o",
    grid: "_yv0e5bpd _1lmc1pyr _gy1p1b66 _1p571b66 _19bvutpp"
};
const $55195f091cb52b39$export$cd7ef6aecb1db96c = ({ sublistPosition: sublistPosition, linkedResult: linkedResult, category: category, thirdPartyConfigs: thirdPartyConfigs, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, fallbackType: fallbackType })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const containerRef = (0, $42omo.useRef)(null);
    const { id: id, title: title, url: url, providerId: providerId, integrationId: integrationId, lastModifiedDate: lastModifiedDate, subtype: subtype, type: type } = linkedResult;
    const resultAri = (0, $k4HRJ.AnyAri).parse(id);
    const product = (0, $4Chrd.getProductFromProviderId)(thirdPartyConfigs, providerId);
    const integrationKey = (0, $67gKI.getIntegrationKey)(integrationId);
    const thirdPartyProduct = product || integrationKey;
    const firstPartyProduct = resultAri.resourceOwner;
    const productKey = thirdPartyProduct || firstPartyProduct;
    const icon = $55195f091cb52b39$var$getLinkedResultIcon(category, thirdPartyProduct, resultAri, thirdPartyConfigs);
    const typeLabel = formatMessage($55195f091cb52b39$export$daafd2babca66cfb(category, subtype, type, fallbackType));
    const metadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: typeLabel
            })
        ],
        [
            'last-modified',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                lastModified: lastModifiedDate
            })
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: containerRef,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
            xcss: $55195f091cb52b39$var$styles.grid,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $55195f091cb52b39$var$styles.iconArea,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $55195f091cb52b39$var$styles.newIcon,
                        children: icon
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5a3f247da11d2140$export$b98262479e3660fe), {
                    sublistPosition: sublistPosition,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultContextMenu,
                    category: category,
                    provider: productKey,
                    id: id,
                    title: (0, $Y34Hw.enrichExcerpt)(title),
                    url: url
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5f3358d8816326cd$export$fe43dae6529505e9), {
                    searchResultId: id,
                    parts: metadataParts,
                    containerRef: containerRef
                })
            ]
        })
    });
};





const $bdba1b2023ea1225$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    foundIn: {
        id: "search-page.linked-results.found-in",
        defaultMessage: "Found in"
    },
    similar: {
        id: "search-page.linked-results.similar",
        defaultMessage: "{count} similar"
    },
    related: {
        id: "search-page.linked-results.related",
        defaultMessage: "Related links"
    },
    mentionedIn: {
        id: "search-page.linked-results.mentioned-in",
        defaultMessage: "Mentioned in"
    },
    comments: {
        id: "search-page.linked-results.comments",
        defaultMessage: "Comments"
    },
    relatedPages: {
        id: "search-page.linked-results.related-pages",
        defaultMessage: "Related pages"
    },
    showMore: {
        id: "search-page.linked-results.show-more",
        defaultMessage: "Show {count} more"
    },
    seeAll: {
        id: "search-page.linked-results.see-all",
        defaultMessage: "See all"
    },
    externalLink: {
        id: "search-page.linked-results.external-link",
        defaultMessage: "External link"
    }
});


var $b7a5d3c4b4eaddeb$var$Category = /*#__PURE__*/ function(Category) {
    Category["MENTIONS"] = "MENTIONS";
    Category["MENTIONEDBY"] = "MENTIONEDBY";
    Category["SIMILAR"] = "SIMILAR";
    Category["CHILD"] = "CHILD";
    return Category;
}($b7a5d3c4b4eaddeb$var$Category || {})/**
   * Deduplicates URLs by removing any links that already exist in linkedResults
   * @param links - Array of URL strings
   * @param linkedResults - Array of linked result objects that have a url property
   * @returns Array of deduplicated URL strings
   */ ;
const $b7a5d3c4b4eaddeb$var$deduplicateLinksAgainstLinkedResults = (links, linkedResults)=>{
    if (!linkedResults || linkedResults.length === 0) return links;
    const linkedResultUrls = new Set(linkedResults.map((result)=>result.url)); // Filter out links that exist in linkedResults
    return links.filter((link)=>!linkedResultUrls.has(link));
};
const $b7a5d3c4b4eaddeb$var$linkedResultsStyles = {
    base: "_zulputpp _kqswh2mm _ca0q1b66 _1e0c1txw _2lx21bp4",
    showMoreButton: "_1wpz1y6m"
};
const $b7a5d3c4b4eaddeb$export$d6b2e1eb75e7aa51 = (props)=>{
    const { links: links, linkedResults: linkedResults, url: parentUrl, thirdPartyConfigs: thirdPartyConfigs, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, position: position, showSeeAllButton: showSeeAllButton, product: product, fallbackType: fallbackType } = props;
    const [showAll, setShowAll] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)(); // Deduplicate links against linkedResults first, then reorder
    const deduplicatedLinks = $b7a5d3c4b4eaddeb$var$deduplicateLinksAgainstLinkedResults(links ?? [], linkedResults);
    const orderedLinks = (0, $21d2cd4cc2a842d3$export$396d67700f1fa04e)(deduplicatedLinks);
    const linkedResultsCount = linkedResults?.length || 0;
    const linksCount = orderedLinks?.length || 0;
    const totalItemsCount = linkedResultsCount + linksCount;
    if (totalItemsCount === 0) return null;
    const initialResults = 2;
    const maxExpandedResults = 5;
    const hasMoreInitialResults = totalItemsCount > initialResults;
    const hasMoreExpandedResults = totalItemsCount > maxExpandedResults;
    const maxItemsToShow = showAll ? maxExpandedResults : initialResults; // Show linkedResults first, then links, respecting the total limit
    const linkedResultsToShow = linkedResults?.slice(0, Math.min(linkedResultsCount, maxItemsToShow)) || [];
    const remainingSlots = maxItemsToShow - linkedResultsToShow.length;
    const linksToShow = remainingSlots > 0 ? orderedLinks?.slice(0, remainingSlots) || [] : [];
    const components = [
        ...linkedResultsToShow.map((linkedResult, index)=>{
            return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $55195f091cb52b39$export$cd7ef6aecb1db96c), {
                    linkedResult: linkedResult,
                    thirdPartyConfigs: thirdPartyConfigs,
                    category: linkedResult.category,
                    sublistPosition: index,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultContextMenu,
                    product: product,
                    fallbackType: fallbackType
                })
            }, `${linkedResult.id}-${index}`);
        }),
        // Render LinkAttachments component if there are links to show
        ...linksToShow.length > 0 ? [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $514d99dea8b7ae4b$export$dffce0f8d8968f9c), {
                    links: linksToShow,
                    isLinkedResults: true,
                    indexOffset: linkedResultsToShow.length,
                    parentPosition: position,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultContextMenu
                })
            }, "link-attachments")
        ] : []
    ];
    const remainingCount = showAll ? totalItemsCount - maxExpandedResults : totalItemsCount - initialResults;
    const showMoreX = Math.min(maxExpandedResults - initialResults, remainingCount);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            $b7a5d3c4b4eaddeb$var$linkedResultsStyles.base
        ]),
        children: [
            components,
            hasMoreInitialResults && !showAll && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $b7a5d3c4b4eaddeb$var$linkedResultsStyles.showMoreButton
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    onClick: ()=>{
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: `searchPageLinkedResultShowMoreButton`,
                                source: (0, $6yNqK.EVENT_SOURCE),
                                attributes: {
                                    moreShownCount: showMoreX
                                }
                            }
                        }).fire();
                        return setShowAll(true);
                    },
                    spacing: "compact",
                    children: formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).showMore, {
                        count: showMoreX
                    })
                })
            }),
            showSeeAllButton && showAll && hasMoreExpandedResults && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $b7a5d3c4b4eaddeb$var$linkedResultsStyles.showMoreButton
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ccHMk.default), {
                    onClick: ()=>{
                        onResultClicked?.({
                            fromLinksSeeAll: true
                        });
                        return window.open(parentUrl, '_blank');
                    },
                    spacing: "compact",
                    children: [
                        formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).seeAll),
                        ' ',
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($69PnT))), {
                            label: formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).externalLink)
                        })
                    ]
                })
            })
        ]
    });
};
const $b7a5d3c4b4eaddeb$export$641545414024a53b = ({ linkedResults: linkedResults, thirdPartyConfigs: thirdPartyConfigs, partial: partial, url: url, position: position, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, isAllProductSelected: isAllProductSelected })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const shouldShowLinkedResults = partial.linkedResults && partial.linkedResults.length > 0 && isAllProductSelected; // expanded linked results for the first 5 results by default
    const shouldExpandLinkedResults = position !== undefined && position <= $b7a5d3c4b4eaddeb$export$f0079efc6806b623 ? 0 : undefined;
    const mentionedByLinkedResults = linkedResults.filter((linkedResult)=>linkedResult.category.toLocaleUpperCase() === "MENTIONEDBY");
    return shouldShowLinkedResults && /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
        defaultExpandedIndex: shouldExpandLinkedResults,
        parentPosition: position,
        buttonType: "MENTIONEDBY",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))),
            attachmentCount: mentionedByLinkedResults?.length ?? 0,
            attachmentType: "url",
            label: formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).mentionedIn),
            children: /*#__PURE__*/ (0, $l998X.jsx)($b7a5d3c4b4eaddeb$export$d6b2e1eb75e7aa51, {
                ...partial,
                url: url,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                thirdPartyConfigs: thirdPartyConfigs,
                linkedResults: mentionedByLinkedResults,
                onSeeAllClicked: onResultClicked,
                onResultClicked: onResultClicked,
                onResultContextMenu: onResultContextMenu,
                position: position
            })
        })
    });
};
const $b7a5d3c4b4eaddeb$export$f0079efc6806b623 = 4;
const $b7a5d3c4b4eaddeb$export$82bce033e6b355fc = 2;
const $b7a5d3c4b4eaddeb$export$695e5a3ae2478b3 = ({ linkedResults: linkedResults, thirdPartyConfigs: thirdPartyConfigs, partial: partial, url: url, position: position, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, isAllProductSelected: isAllProductSelected, additionalExpands: additionalExpands, additionalFooterButton: additionalFooterButton })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const extractedLinksFromText = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(partial.description);
    const hasLinkedResults = partial.linkedResults && partial.linkedResults.length > 0;
    const hasExtractedLinks = extractedLinksFromText && extractedLinksFromText.length > 0;
    const mentionsLinkedResults = linkedResults.filter((linkedResult)=>linkedResult.category.toLocaleUpperCase() === "MENTIONS"); // expanded linked results for the first 5 results by default
    const shouldExpandLinkedResults = position !== undefined && position <= $b7a5d3c4b4eaddeb$export$f0079efc6806b623 ? 0 : undefined;
    const shouldShowLinkedResults = (hasExtractedLinks || hasLinkedResults) && isAllProductSelected;
    const totalLinksLength = (mentionsLinkedResults?.length ?? 0) + extractedLinksFromText.length;
    const hasAdditionalExpands = !!additionalExpands;
    const hasAdditionalFooterButton = !!additionalFooterButton; // Only auto-expand when linked results are shown; additionalExpands (e.g. PRs) should start collapsed
    const defaultExpandedIndex = shouldShowLinkedResults ? shouldExpandLinkedResults : undefined;
    return (shouldShowLinkedResults || hasAdditionalExpands || hasAdditionalFooterButton) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
        defaultExpandedIndex: defaultExpandedIndex,
        parentPosition: position,
        buttonType: "MENTIONS",
        additionalFooterButton: additionalFooterButton,
        children: [
            shouldShowLinkedResults && /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
                attachmentCount: totalLinksLength,
                attachmentType: "url",
                label: formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).related),
                children: /*#__PURE__*/ (0, $l998X.jsx)($b7a5d3c4b4eaddeb$export$d6b2e1eb75e7aa51, {
                    ...partial,
                    links: extractedLinksFromText,
                    linkedResults: mentionsLinkedResults,
                    url: url,
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                    thirdPartyConfigs: thirdPartyConfigs,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultContextMenu,
                    position: position,
                    showSeeAllButton: true
                })
            }),
            additionalExpands
        ]
    });
};
const $b7a5d3c4b4eaddeb$export$df3a99a0361e78cf = ({ partial: partial, is3pGroupingEnabled: is3pGroupingEnabled, isAllProductSelected: isAllProductSelected = false })=>{
    const isFallbackCase = (is3pGroupingEnabled === undefined || is3pGroupingEnabled === false) && isAllProductSelected;
    return Boolean(partial.linkedResults?.length > 0 && (is3pGroupingEnabled || isFallbackCase));
};
const $b7a5d3c4b4eaddeb$export$59c57a80401f0a6 = ({ linkedResults: linkedResults, thirdPartyConfigs: thirdPartyConfigs, partial: partial, url: url, position: position, onResultClicked: onResultClicked, isAllProductSelected: isAllProductSelected = false, onResultContextMenu: onResultContextMenu, is3pGroupingEnabled: is3pGroupingEnabled, product: product, fallbackType: fallbackType, additionalFooterButton: additionalFooterButton })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const shouldShowLinkedResults = $b7a5d3c4b4eaddeb$export$df3a99a0361e78cf({
        partial: partial,
        is3pGroupingEnabled: is3pGroupingEnabled,
        isAllProductSelected: isAllProductSelected
    }); // expanded linked results for the first 5 results by default
    const shouldExpandLinkedResults = position !== undefined && position <= $b7a5d3c4b4eaddeb$export$f0079efc6806b623 ? 0 : undefined;
    const similarLinkedResults = linkedResults.filter((linkedResult)=>linkedResult.category.toLocaleUpperCase() === "SIMILAR");
    const hasAdditionalFooterButton = !!additionalFooterButton;
    return (shouldShowLinkedResults || hasAdditionalFooterButton) && /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
        defaultExpandedIndex: shouldExpandLinkedResults,
        parentPosition: position,
        buttonType: "SIMILAR",
        additionalFooterButton: additionalFooterButton,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            attachmentCount: similarLinkedResults?.length ?? 0,
            attachmentType: "url",
            label: formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).related),
            children: /*#__PURE__*/ (0, $l998X.jsx)($b7a5d3c4b4eaddeb$export$d6b2e1eb75e7aa51, {
                ...partial,
                url: url,
                thirdPartyConfigs: thirdPartyConfigs,
                linkedResults: similarLinkedResults,
                onResultClicked: onResultClicked,
                onResultContextMenu: onResultContextMenu,
                position: position,
                product: product,
                fallbackType: fallbackType
            })
        })
    });
}; /**
    * Row-only sibling of {@link SimilarLinkedResults}: returns just the `<Expand>` row so that it
    * can live as a peer inside an external `ExpandList` (alongside Comments and Mentioned in).
    *
    * Preserves the same rollout gate (`is3pGroupingEnabled || isAllProductSelected` fallback) and
    * the same SIMILAR-category filter applied by `SimilarLinkedResults`. Returns `null` when the
    * gate is off so callers can treat absence as "no row to render".
    */ 
const $b7a5d3c4b4eaddeb$export$1fe86ff8d80e6df8 = ({ linkedResults: linkedResults, thirdPartyConfigs: thirdPartyConfigs, partial: partial, url: url, position: position, onResultClicked: onResultClicked, isAllProductSelected: isAllProductSelected = false, onResultContextMenu: onResultContextMenu, is3pGroupingEnabled: is3pGroupingEnabled, product: product, fallbackType: fallbackType })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const shouldShowLinkedResults = $b7a5d3c4b4eaddeb$export$df3a99a0361e78cf({
        partial: partial,
        is3pGroupingEnabled: is3pGroupingEnabled,
        isAllProductSelected: isAllProductSelected
    });
    if (!shouldShowLinkedResults) return null;
    const similarLinkedResults = linkedResults.filter((linkedResult)=>linkedResult.category.toLocaleUpperCase() === "SIMILAR");
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
        attachmentCount: similarLinkedResults?.length ?? 0,
        attachmentType: "url",
        label: formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).related),
        children: /*#__PURE__*/ (0, $l998X.jsx)($b7a5d3c4b4eaddeb$export$d6b2e1eb75e7aa51, {
            ...partial,
            url: url,
            thirdPartyConfigs: thirdPartyConfigs,
            linkedResults: similarLinkedResults,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultContextMenu,
            position: position,
            product: product,
            fallbackType: fallbackType
        })
    });
};
const $b7a5d3c4b4eaddeb$export$5c57e85aa93a90d0 = ({ linkedResults: linkedResults, thirdPartyConfigs: thirdPartyConfigs, partial: partial, url: url, position: position, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, additionalFooterButton: additionalFooterButton })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const shouldShowLinkedResults = partial.linkedResults && partial.linkedResults.length > 0;
    const shouldExpandLinkedResults = position !== undefined && position <= $b7a5d3c4b4eaddeb$export$f0079efc6806b623 ? 0 : undefined;
    const childLinkedResults = linkedResults.filter((linkedResult)=>linkedResult.category.toLocaleUpperCase() === "CHILD");
    const hasAdditionalFooterButton = !!additionalFooterButton;
    const hasChildLinkedResults = !!shouldShowLinkedResults && childLinkedResults.length > 0;
    return (hasChildLinkedResults || hasAdditionalFooterButton) && /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
        defaultExpandedIndex: shouldExpandLinkedResults,
        parentPosition: position,
        buttonType: "CHILD",
        additionalFooterButton: additionalFooterButton,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            attachmentCount: childLinkedResults.length,
            attachmentType: "url",
            label: formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).relatedPages),
            children: /*#__PURE__*/ (0, $l998X.jsx)($b7a5d3c4b4eaddeb$export$d6b2e1eb75e7aa51, {
                ...partial,
                url: url,
                thirdPartyConfigs: thirdPartyConfigs,
                linkedResults: childLinkedResults,
                onResultClicked: onResultClicked,
                onResultContextMenu: onResultContextMenu,
                position: position
            })
        })
    });
};




















const $074353e7cefdba17$export$1fc5115025b27b98 = (thirdPartyConfigs, availableProducts)=>{
    // Prerequisite: user must have Jira enabled
    if (!availableProducts.includes((0, $b4tvS.ProductKeys).Jira)) return false;
    // Prerequisite: user must have GitHub connector authenticated
    if (thirdPartyConfigs[(0, $b4tvS.ProductKeys3P).Github]?.userNeedsOAuth !== false) return false;
    return true;
};



var $fUcm0 = parcelRequire("fUcm0");


var $kQT7c = parcelRequire("kQT7c");








var $PGaF8 = parcelRequire("PGaF8");







const $fe78820344aa1a37$export$97e18a3547cfead = ({ dwellData: dwellData, searchSessionId: searchSessionId, searchQuery: searchQuery, applicationMode: applicationMode })=>{
    const queryHash = (0, $731W9.sha256Hash)(searchQuery);
    return {
        ...dwellData,
        source: (0, $6yNqK.EVENT_SOURCE),
        actionSubject: 'searchPage',
        attributes: {
            additionalAttributes: {
                ...dwellData.attributes,
                searchSessionId: searchSessionId,
                queryHash: queryHash,
                mode: applicationMode
            }
        },
        eventType: 'track'
    };
};











const $320af85988d7ec69$var$useDwellTime = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    (0, $42omo.useEffect)(()=>{
        const dwellTimer = new (0, $PGaF8.default)((dwellData)=>{
            fireAnalyticsEvent((0, $fe78820344aa1a37$export$97e18a3547cfead)({
                dwellData: dwellData,
                searchQuery: searchQuery,
                searchSessionId: searchSessionId,
                applicationMode: applicationMode
            }));
        }, // These actually get overridden in onAdvancedSearchDwelled, but the DwellTimeHelper code path requires them to be set anyway, so we do.
        {
            source: 'source',
            actionSubject: 'actionSubject'
        }, searchSessionId);
        dwellTimer.start();
        return ()=>{
            dwellTimer.stop();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
var $320af85988d7ec69$export$2e2bcd8739ae039 = $320af85988d7ec69$var$useDwellTime;









var $a97k3 = parcelRequire("a97k3");




/**
 * @generated SignedSource<<370e9adea12cd328170f5a0a7e2f6e29>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $285a05f8e46adb50$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "autoCorrection_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "originalQuery"
        },
        {
            "kind": "ScalarField",
            "name": "replacementQuery"
        },
        {
            "kind": "ScalarField",
            "name": "suggestedQuery"
        },
        {
            "kind": "ScalarField",
            "name": "originalQueryType"
        },
        {
            "kind": "ScalarField",
            "name": "confidenceScore"
        },
        {
            "kind": "ScalarField",
            "name": "shouldTriggerAutocorrectionExperience"
        }
    ],
    "type": "SearchQueryInfo"
};
$285a05f8e46adb50$var$node.hash = "c10236f368a121324971f6864af67d34";
var $285a05f8e46adb50$export$2e2bcd8739ae039 = $285a05f8e46adb50$var$node;






































var $5XpfZ = parcelRequire("5XpfZ");







const $5d5a27ecf17ccfe8$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    showingResultsFor: {
        id: "search-page.auto-correction.showing-results-for",
        defaultMessage: "Showing results for {replacementQuery}"
    },
    searchInsteadFor: {
        id: "search-page.auto-correction.search-instead-for",
        defaultMessage: "Search instead for {originalQuery}"
    },
    didYouMean: {
        id: "search-page.auto-correction.did-you-mean",
        defaultMessage: "Did you mean {suggestedQuery}"
    }
});


const $7d957fe130cc1584$var$anchorStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $7d957fe130cc1584$var$useFireClickEvent = (cloudId)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    return (additionalAttributes)=>{
        // Check if this is a hello tenant - only hello tenants can pass sensitive fields
        const isHelloTenant = (0, $5XpfZ.isHello)(cloudId);
        let filteredAttributes = {
            ...additionalAttributes
        };
        if (!isHelloTenant) // For non-hello tenants, replace fields with values to [REDACTED], keep null as null
        filteredAttributes = {
            ...filteredAttributes,
            originalQuery: additionalAttributes?.originalQuery ? '[REDACTED]' : null,
            replacementQuery: additionalAttributes?.replacementQuery ? '[REDACTED]' : null,
            suggestedQuery: additionalAttributes?.suggestedQuery ? '[REDACTED]' : null
        };
        fireAnalyticsEvent({
            eventType: 'ui',
            actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}AutoCorrection`,
            action: 'clicked',
            attributes: {
                commonAttributes: commonAttributes,
                additionalAttributes: filteredAttributes
            }
        });
    };
};
const $7d957fe130cc1584$var$useFireShownEvent = (cloudId)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    return (additionalAttributes)=>{
        // Check if this is a hello tenant - only hello tenants can pass sensitive fields
        const isHelloTenant = (0, $5XpfZ.isHello)(cloudId);
        let filteredAttributes = {
            ...additionalAttributes
        };
        if (!isHelloTenant) // For non-hello tenants, replace fields with values to [REDACTED], keep null as null
        filteredAttributes = {
            ...filteredAttributes,
            originalQuery: additionalAttributes?.originalQuery ? '[REDACTED]' : null,
            replacementQuery: additionalAttributes?.replacementQuery ? '[REDACTED]' : null,
            suggestedQuery: additionalAttributes?.suggestedQuery ? '[REDACTED]' : null
        };
        fireAnalyticsEvent({
            eventType: 'ui',
            actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}AutoCorrection`,
            action: 'shown',
            attributes: {
                commonAttributes: commonAttributes,
                additionalAttributes: filteredAttributes
            }
        });
    };
};
const $7d957fe130cc1584$var$isEnglishLocale = (locale)=>{
    const lowerCaseLocale = locale.toLowerCase();
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return lowerCaseLocale === 'en' || lowerCaseLocale.startsWith('en-');
};
const $7d957fe130cc1584$var$AutoCorrection = ({ node: node, cloudId: cloudId })=>{
    const queryInfo = (0, $irOoi.useFragment)((0, $285a05f8e46adb50$export$2e2bcd8739ae039), node);
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const fireClickEvent = $7d957fe130cc1584$var$useFireClickEvent(cloudId);
    const fireShownEvent = $7d957fe130cc1584$var$useFireShownEvent(cloudId);
    const hasTrackedShown = (0, $42omo.useRef)(false);
    const originalQueryUrlParam = queryParams.originalQuery;
    const { originalQuery: originalQuery, replacementQuery: replacementQuery, suggestedQuery: suggestedQuery, originalQueryType: originalQueryType, confidenceScore: confidenceScore, shouldTriggerAutocorrectionExperience: shouldTriggerAutocorrectionExperience } = queryInfo || {};
    /**
   * Show auto correction if:
   * - replacementQuery is available
   * - shouldTriggerAutocorrectionExperience is true (currently not available)
   */ const showAutoCorrection = (replacementQuery || suggestedQuery) && shouldTriggerAutocorrectionExperience;
    // Fire shown events when auto-correction is displayed
    (0, $42omo.useEffect)(()=>{
        const { originalQuery: originalQuery, replacementQuery: replacementQuery, suggestedQuery: suggestedQuery, originalQueryType: originalQueryType, confidenceScore: confidenceScore, shouldTriggerAutocorrectionExperience: shouldTriggerAutocorrectionExperience } = queryInfo || {};
        const showAutoCorrection = (replacementQuery || suggestedQuery) && shouldTriggerAutocorrectionExperience;
        if (showAutoCorrection) {
            // Generate a unique key for the current auto-correction state
            // Only depend on the actual auto-correction data, not URL parameters
            const autoCorrectionKey = `${replacementQuery || ''}-${suggestedQuery || ''}`;
            if (hasTrackedShown.current !== autoCorrectionKey) {
                hasTrackedShown.current = autoCorrectionKey;
                // Fire shown events based on what's actually displayed
                if (!originalQueryUrlParam && replacementQuery) {
                    // Fire shown events for replacement and original
                    fireShownEvent({
                        autoCorrectionType: 'replacement',
                        originalQueryType: originalQueryType,
                        confidenceScore: confidenceScore,
                        originalQuery: originalQuery,
                        replacementQuery: replacementQuery,
                        suggestedQuery: null,
                        originalQueryHash: originalQuery ? (0, $731W9.sha256Hash)(originalQuery) : null,
                        replacementQueryHash: replacementQuery ? (0, $731W9.sha256Hash)(replacementQuery) : null,
                        suggestedQueryHash: null
                    });
                    fireShownEvent({
                        autoCorrectionType: 'original',
                        originalQueryType: originalQueryType,
                        confidenceScore: confidenceScore,
                        originalQuery: originalQuery,
                        replacementQuery: replacementQuery,
                        suggestedQuery: null,
                        originalQueryHash: originalQuery ? (0, $731W9.sha256Hash)(originalQuery) : null,
                        replacementQueryHash: replacementQuery ? (0, $731W9.sha256Hash)(replacementQuery) : null,
                        suggestedQueryHash: null
                    });
                }
                if (!replacementQuery && suggestedQuery) // Fire shown event for suggested
                fireShownEvent({
                    autoCorrectionType: 'suggested',
                    originalQueryType: originalQueryType,
                    confidenceScore: confidenceScore,
                    originalQuery: originalQuery,
                    replacementQuery: null,
                    suggestedQuery: suggestedQuery,
                    originalQueryHash: originalQuery ? (0, $731W9.sha256Hash)(originalQuery) : null,
                    replacementQueryHash: null,
                    suggestedQueryHash: suggestedQuery ? (0, $731W9.sha256Hash)(suggestedQuery) : null
                });
            }
        }
    }, [
        queryInfo,
        fireShownEvent,
        originalQueryUrlParam
    ]);
    if (showAutoCorrection) {
        if (!originalQueryUrlParam && replacementQuery) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        size: "large",
                        weight: "medium",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $5d5a27ecf17ccfe8$export$defe85febe8b728c).showingResultsFor,
                            values: {
                                replacementQuery: /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                                    href: generateSearchUrl({
                                        ...queryParams,
                                        text: replacementQuery,
                                        originalQuery: originalQuery
                                    }),
                                    xcss: $7d957fe130cc1584$var$anchorStyles,
                                    onClick: ()=>fireClickEvent({
                                            autoCorrectionType: 'replacement',
                                            originalQueryType: originalQueryType,
                                            confidenceScore: confidenceScore,
                                            originalQuery: originalQuery,
                                            replacementQuery: replacementQuery,
                                            suggestedQuery: null,
                                            originalQueryHash: originalQuery ? (0, $731W9.sha256Hash)(originalQuery) : null,
                                            replacementQueryHash: replacementQuery ? (0, $731W9.sha256Hash)(replacementQuery) : null,
                                            suggestedQueryHash: null
                                        }),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                        as: "em",
                                        size: "large",
                                        weight: "medium",
                                        color: "color.link",
                                        children: replacementQuery
                                    })
                                })
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $5d5a27ecf17ccfe8$export$defe85febe8b728c).searchInsteadFor,
                            values: {
                                originalQuery: /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                                    href: generateSearchUrl({
                                        ...queryParams,
                                        text: originalQuery,
                                        originalQuery: replacementQuery
                                    }),
                                    xcss: $7d957fe130cc1584$var$anchorStyles,
                                    onClick: ()=>fireClickEvent({
                                            autoCorrectionType: 'original',
                                            originalQueryType: originalQueryType,
                                            confidenceScore: confidenceScore,
                                            originalQuery: originalQuery,
                                            replacementQuery: replacementQuery,
                                            suggestedQuery: null,
                                            originalQueryHash: originalQuery ? (0, $731W9.sha256Hash)(originalQuery) : null,
                                            replacementQueryHash: replacementQuery ? (0, $731W9.sha256Hash)(replacementQuery) : null,
                                            suggestedQueryHash: null
                                        }),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                        as: "em",
                                        color: "color.link",
                                        children: originalQuery
                                    })
                                })
                            }
                        })
                    })
                })
            ]
        });
        if (!replacementQuery && suggestedQuery) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "large",
                weight: "medium",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $5d5a27ecf17ccfe8$export$defe85febe8b728c).didYouMean,
                    values: {
                        suggestedQuery: /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
                            // TODO: Why changing the query using query params and not Store actions?
                            href: generateSearchUrl({
                                ...queryParams,
                                text: suggestedQuery,
                                originalQuery: originalQuery
                            }),
                            xcss: $7d957fe130cc1584$var$anchorStyles,
                            onClick: ()=>fireClickEvent({
                                    autoCorrectionType: 'suggested',
                                    originalQueryType: originalQueryType,
                                    confidenceScore: confidenceScore,
                                    originalQuery: originalQuery,
                                    replacementQuery: null,
                                    suggestedQuery: suggestedQuery,
                                    originalQueryHash: originalQuery ? (0, $731W9.sha256Hash)(originalQuery) : null,
                                    replacementQueryHash: null,
                                    suggestedQueryHash: suggestedQuery ? (0, $731W9.sha256Hash)(suggestedQuery) : null
                                }),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                as: "em",
                                size: "large",
                                weight: "medium",
                                color: "color.link",
                                children: suggestedQuery
                            })
                        })
                    }
                })
            })
        });
    }
    return null;
};
const $7d957fe130cc1584$var$AutoCorrectionIfEligible = ({ appMode: appMode, node: node, cloudId: cloudId })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    if (!$7d957fe130cc1584$var$isEnglishLocale(locale) || !(0, $eb4a02b80e2ab764$export$3afecd2a83596299)(appMode, isAdminHubAIEnabled, isRovoLLMEnabled) || appMode !== (0, $9vOy1.ApplicationModes).Rovo) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-auto-correction",
        children: /*#__PURE__*/ (0, $l998X.jsx)($7d957fe130cc1584$var$AutoCorrection, {
            node: node,
            cloudId: cloudId
        })
    });
};
var $7d957fe130cc1584$export$2e2bcd8739ae039 = $7d957fe130cc1584$var$AutoCorrectionIfEligible;









var $6gi58 = parcelRequire("6gi58");

const $26168fcfdca601ab$export$fb62e1866e8071b1 = async (cloudId, issueKeys, aggAbsoluteUrl, setJiraStatuses, logError, activationId, product)=>{
    if (cloudId && issueKeys.length > 0) try {
        const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
            cloudId: cloudId,
            activationId: activationId,
            product: product
        });
        const response = await (0, $6gi58.fetchJiraFieldsQuery)({
            variables: {
                issueKeys: issueKeys,
                cloudId: cloudId,
                includeStatusCategoryId: (0, $dh538.fg)('use_jira_fe_status_color_mapping_fps')
            },
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const issuesByKey = response.data?.jira?.issuesByKey;
        setJiraStatuses((prevIssueStatuses)=>{
            if (issuesByKey) {
                const issueStatuses = {
                    ...prevIssueStatuses
                };
                // Have seen the issuesByKey have [null] responses
                for (const issue of issuesByKey.filter((issue)=>issue)){
                    const statusName = issue.statusField?.status?.name;
                    const colorName = issue.statusField?.status?.statusCategory?.colorName;
                    const statusCategoryId = issue.statusField?.status?.statusCategory?.statusCategoryId;
                    if (issue.id && statusName && colorName) issueStatuses[issue.id] = {
                        statusName: statusName,
                        colorName: colorName,
                        statusCategoryId: statusCategoryId
                    };
                }
                return issueStatuses;
            }
            return prevIssueStatuses;
        });
        return;
    } catch (e) {
        logError(e);
    }
    // If fetching Jira fields fails, we still want to update the issue statuses to null
    setJiraStatuses((prevIssueStatuses)=>{
        const issueStatuses = {
            ...prevIssueStatuses
        };
        for (const key of issueKeys)issueStatuses[key] = null;
        return issueStatuses;
    });
};


/**
 * Fetch function for Jira issue → PR hydration.
 *
 * Mirrors the pattern of fetchJiraFieldsQuery in ./index.tsx:
 * - Uses fetchAgg to call AGG
 * - Wraps with inMemoryCache for deduplication
 * - Parses response into IssueLinkedPRs mapping
 */ 









var $bZUnP = parcelRequire("bZUnP");


var $gX70r = parcelRequire("gX70r");

const $00b4ceba340ae8be$var$cache = (0, $hw4j5.inMemoryCache)();
const $00b4ceba340ae8be$var$generateCacheKeyForJiraPRs = (issueAris)=>{
    // Sort for stable cache keys regardless of order
    const keyObj = {
        issueAris: [
            ...issueAris
        ].sort()
    };
    return (0, $2qzBQ.generateHashFromVariables)(keyObj);
};
// Expire cache on errors or empty response
const $00b4ceba340ae8be$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    // Check if graphStore has any data at all
    return Object.keys(data.graphStore ?? {}).length === 0;
};
/**
 * Splits an array into chunks of the specified size.
 */ const $00b4ceba340ae8be$var$chunk = (arr, size)=>{
    const chunks = [];
    for(let i = 0; i < arr.length; i += size)chunks.push(arr.slice(i, i + size));
    return chunks;
};
/**
 * Fetches linked PR data for a single chunk of Jira issue ARIs via AGG.
 * This is the underlying fetch that handles a batch within MAX_ISSUES_PER_QUERY.
 */ const $00b4ceba340ae8be$var$fetchJiraPRsChunk = ({ issueAris: issueAris, aggAbsoluteUrl: aggAbsoluteUrl, cloudId: cloudId })=>{
    const graphQuery = (0, $bZUnP.jiraPRQueryGenerator)(issueAris);
    const variables = (0, $bZUnP.buildPRQueryVariables)(issueAris);
    return $00b4ceba340ae8be$var$cache.inMemoryDecorator($00b4ceba340ae8be$var$generateCacheKeyForJiraPRs(issueAris), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: 'SearchPageJiraPRHydration',
            headers: {
                'X-Query-Context': `ari:cloud:platform::site/${cloudId}`
            }
        }), $00b4ceba340ae8be$var$expireWhen);
};
/**
 * Merges multiple chunked AGG responses into a single response.
 * Combines all graphStore aliases and aggregates errors.
 */ const $00b4ceba340ae8be$var$mergeChunkedResponses = (responses)=>{
    const mergedGraphStore = {};
    const allErrors = [];
    responses.forEach((response, chunkIndex)=>{
        if (response.data?.graphStore) {
            // Re-key aliases from each chunk to use global indices
            // Chunk responses use local aliases (issue0, issue1, ...) which we
            // remap to the global position so parseJiraPRResponse works correctly.
            const chunkOffset = chunkIndex * (0, $bZUnP.MAX_ISSUES_PER_QUERY);
            for (const [localKey, value] of Object.entries(response.data.graphStore)){
                const localIndex = parseInt(localKey.replace('issue', ''), 10);
                const globalKey = `issue${chunkOffset + localIndex}`;
                mergedGraphStore[globalKey] = value;
            }
        }
        if (response.errors) allErrors.push(...response.errors);
    });
    return {
        data: {
            graphStore: mergedGraphStore
        },
        ...allErrors.length > 0 ? {
            errors: allErrors
        } : {}
    };
};
const $00b4ceba340ae8be$export$d0610c25cdff96a = async ({ issueAris: issueAris, aggAbsoluteUrl: aggAbsoluteUrl, cloudId: cloudId })=>{
    if (issueAris.length <= (0, $bZUnP.MAX_ISSUES_PER_QUERY)) return $00b4ceba340ae8be$var$fetchJiraPRsChunk({
        issueAris: issueAris,
        aggAbsoluteUrl: aggAbsoluteUrl,
        cloudId: cloudId
    });
    const chunks = $00b4ceba340ae8be$var$chunk(issueAris, (0, $bZUnP.MAX_ISSUES_PER_QUERY));
    const responses = await Promise.all(chunks.map((chunkAris)=>$00b4ceba340ae8be$var$fetchJiraPRsChunk({
            issueAris: chunkAris,
            aggAbsoluteUrl: aggAbsoluteUrl,
            cloudId: cloudId
        })));
    return $00b4ceba340ae8be$var$mergeChunkedResponses(responses);
};







const $f38e98fa021acfed$export$43421873caba4846 = ({ issueCount: issueCount, prCount: prCount, issuesWithPRsCount: issuesWithPRsCount, latencyMs: latencyMs })=>{
    return {
        action: 'taskSuccess',
        actionSubject: 'linkedPRsFetch',
        eventType: 'operational',
        source: (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                issueCount: issueCount,
                prCount: prCount,
                issuesWithPRsCount: issuesWithPRsCount,
                latencyMs: latencyMs
            }
        }
    };
};
const $f38e98fa021acfed$export$88bcb3939177310b = ({ reason: reason, latencyMs: latencyMs })=>{
    return {
        action: 'taskFail',
        actionSubject: 'linkedPRsFetch',
        eventType: 'operational',
        source: (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                reason: reason,
                latencyMs: latencyMs
            }
        }
    };
};


const $58ec885ea6cc3454$export$abdd37837b6fbc28 = async (issueAris, cloudId, aggAbsoluteUrl, setLinkedPRs, logError, fireAnalyticsEvent)=>{
    if (!cloudId || issueAris.length === 0) return;
    const startTime = performance.now();
    try {
        const response = await (0, $00b4ceba340ae8be$export$d0610c25cdff96a)({
            issueAris: issueAris,
            aggAbsoluteUrl: aggAbsoluteUrl,
            cloudId: cloudId
        });
        const parsed = (0, $gX70r.parseJiraPRResponse)(response, issueAris);
        const latencyMs = Math.round(performance.now() - startTime);
        const prCount = Object.values(parsed).reduce((total, entry)=>{
            if (entry.status === 'loaded') return total + entry.prs.length;
            return total;
        }, 0);
        const issuesWithPRsCount = Object.values(parsed).filter((entry)=>entry.status === 'loaded' && entry.prs.length > 0).length;
        fireAnalyticsEvent?.((0, $f38e98fa021acfed$export$43421873caba4846)({
            issueCount: issueAris.length,
            prCount: prCount,
            issuesWithPRsCount: issuesWithPRsCount,
            latencyMs: latencyMs
        }));
        setLinkedPRs((prev)=>({
                ...prev,
                ...parsed
            }));
    } catch (e) {
        const latencyMs = Math.round(performance.now() - startTime);
        fireAnalyticsEvent?.((0, $f38e98fa021acfed$export$88bcb3939177310b)({
            reason: e instanceof Error ? e.message : 'unknown',
            latencyMs: latencyMs
        }));
        logError(e);
        // On failure, set error entries so UI knows hydration attempted but failed
        setLinkedPRs((prev)=>{
            const updated = {
                ...prev
            };
            for (const ari of issueAris)updated[ari] = {
                status: 'error'
            };
            return updated;
        });
    }
};














/**
 * Generates the GraphQL query that uses TWG cypherQueryV2 to find
 * past occurrences of a recurring MS Teams meeting given a video ARI.
 *
 * The Cypher traversal walks:
 *   video → child CalendarEvent → parent CalendarEvent
 *   → sibling CalendarEvents (past only) → sibling Videos
 *
 * Returns ExternalVideo fields needed to render related links: url, displayName, createdAt,
 * thirdPartyId and provider.providerId.
 *
 * @see https://hello.atlassian.net/wiki/spaces/TEAMGRAPH/pages/6618235865/Expanding+Meeting+Video+relationships+in+TWG
 */ const $c4e86131095dcef4$export$3dd46835702a2ec = ()=>`
	query SearchPagePastMeetingOccurrencesHydration(
		$cypherQuery: String!
		$params: JSON!
		$queryContext: String!
	) {
		graphStore @optIn(to: "GraphStore") {
			cypherQueryV2(
				query: $cypherQuery
				params: $params
				queryContext: $queryContext
			) @optIn(to: "GraphStoreCypherQueryV2") {
				edges {
					node {
						columns {
							key
							value {
								... on GraphStoreCypherQueryV2AriNode {
									data {
										... on ExternalVideo {
											url
											displayName
											createdAt
											thirdPartyId
											provider {
												providerId
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;


/**
 * Cypher query: given a video ARI, walk up to its parent recurring CalendarEvent,
 * then return up to 5 sibling past-occurrence videos ordered by meeting date DESC.
 *
 * Variables: $videoAri — the ARI of the current meeting video.
 */ const $c043afc45c845e1f$var$PAST_MEETING_OCCURRENCES_CYPHER_QUERY = `
MATCH (video:GraphVideo {ari: $videoAri})
    <-[:external_calendar_event_links_external_video]-(child:GraphCalendarEvent)
    <-[:external_calendar_event_has_child_external_calendar_event]-(parent:GraphCalendarEvent)
MATCH (parent)-[:external_calendar_event_has_child_external_calendar_event]->(sibling:GraphCalendarEvent)
    -[:external_calendar_event_links_external_video]->(siblingVideo:GraphVideo)
WHERE sibling.createdAt < child.createdAt
RETURN siblingVideo
ORDER BY sibling.createdAt DESC
LIMIT 5
`;
const $c043afc45c845e1f$var$cache = (0, $hw4j5.inMemoryCache)();
const $c043afc45c845e1f$var$expireOnErrorOrEmpty = (result)=>{
    const { data: data, errors: errors } = result;
    return !data || !!errors && errors.length > 0;
};
/**
 * Extracts past meeting occurrences from a cypherQueryV2 response.
 * Each edge's column value contains an ExternalVideo node with url, displayName, createdAt.
 */ function $c043afc45c845e1f$var$parsePastMeetingOccurrences(response) {
    const edges = response.data?.graphStore?.cypherQueryV2?.edges;
    if (!edges || edges.length === 0) return [];
    const occurrences = [];
    for (const edge of edges)for (const column of edge.node.columns){
        const data = column.value?.data;
        if (data?.url) occurrences.push({
            url: data.url,
            title: data.displayName ?? null,
            lastModifiedDate: data.createdAt ?? null,
            thirdPartyId: data.thirdPartyId ?? null,
            providerId: data.provider?.providerId ?? null
        });
    }
    return occurrences;
}
async function $c043afc45c845e1f$export$694ccfc2d90e340b(videoAri, queryContext, { aggAbsoluteUrl: aggAbsoluteUrl, headers: headers }) {
    const graphQuery = (0, $c4e86131095dcef4$export$3dd46835702a2ec)();
    const variables = {
        cypherQuery: $c043afc45c845e1f$var$PAST_MEETING_OCCURRENCES_CYPHER_QUERY,
        params: {
            videoAri: videoAri
        },
        queryContext: queryContext
    };
    const response = await $c043afc45c845e1f$var$cache.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)({
        videoAri: videoAri,
        queryContext: queryContext
    }), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: 'SearchPagePastMeetingOccurrencesHydration',
            headers: headers
        }), $c043afc45c845e1f$var$expireOnErrorOrEmpty);
    return $c043afc45c845e1f$var$parsePastMeetingOccurrences(response);
}
async function $c043afc45c845e1f$export$6f7d236b52aa52d6(videoAris, queryContext, fetchProps) {
    const results = {};
    const promises = videoAris.map(async (videoAri)=>{
        try {
            const occurrences = await $c043afc45c845e1f$export$694ccfc2d90e340b(videoAri, queryContext, fetchProps);
            results[videoAri] = occurrences;
        } catch  {
            results[videoAri] = null;
        }
    });
    await Promise.all(promises);
    return results;
}


const $7c43e2355d28c6dc$export$6c5cbc95f27dc639 = async (videoAris, cloudId, aggAbsoluteUrl, setPastOccurrences, logError)=>{
    if (!cloudId || videoAris.length === 0) return;
    // TWG workspace routing requires a site ARI as the queryContext
    const queryContext = `ari:cloud:platform::site/${cloudId}`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: cloudId
    });
    try {
        const result = await (0, $c043afc45c845e1f$export$6f7d236b52aa52d6)(videoAris, queryContext, {
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        setPastOccurrences((prev)=>({
                ...prev,
                ...result
            }));
    } catch (e) {
        logError(e);
        // On failure, mark each ARI as null so the UI knows hydration was attempted but failed
        setPastOccurrences((prev)=>{
            const updated = {
                ...prev
            };
            for (const ari of videoAris)updated[ari] = null;
            return updated;
        });
    }
};



var $7YExv = parcelRequire("7YExv");

async function $b0ed28a083ef01d9$export$2716d470ab5d7e10(cloudId, teamIds, nodeIdMap, setTeamNames, logError) {
    if (cloudId && teamIds.length > 0) try {
        const { teams: teams } = await (0, $7YExv.fetchTeamsBulk)({
            siteId: cloudId,
            teamIds: teamIds
        });
        const newTeamNames = {};
        for(let i = 0; i < teams.length; i++){
            const team = teams[i];
            newTeamNames[team.id] = team.displayName;
        }
        setTeamNames((prevTeamNames)=>{
            const updatedTeamNames = {
                ...prevTeamNames
            };
            for (const [nodeId, teamId] of Object.entries(nodeIdMap))updatedTeamNames[nodeId] = teamId ? newTeamNames[teamId] : null;
            return updatedTeamNames;
        });
        return;
    } catch (e) {
        logError(e);
    }
    // If fetching teams fails, we still want to update the team names to null
    setTeamNames((prevTeamNames)=>{
        const updatedTeamNames = {
            ...prevTeamNames
        };
        for (const [nodeId] of Object.entries(nodeIdMap))updatedTeamNames[nodeId] = null;
        return updatedTeamNames;
    });
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 























/**
 * @generated SignedSource<<b7cecd268821a8068fd44fc3382fca63>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1cc2f6a902ce7bda$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeAssets"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeAssigneeField"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeIconUrl"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeJiraLiteModeFields"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeNavBoostScore"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includePassionfruitAsk"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includePositions"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeThirdPartyId"
        }
    ],
    "kind": "Fragment",
    "name": "searchResult_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "includeAssets",
                    "variableName": "includeAssets"
                },
                {
                    "kind": "Variable",
                    "name": "includeAssigneeField",
                    "variableName": "includeAssigneeField"
                },
                {
                    "kind": "Variable",
                    "name": "includeIconUrl",
                    "variableName": "includeIconUrl"
                },
                {
                    "kind": "Variable",
                    "name": "includeJiraLiteModeFields",
                    "variableName": "includeJiraLiteModeFields"
                },
                {
                    "kind": "Variable",
                    "name": "includeNavBoostScore",
                    "variableName": "includeNavBoostScore"
                },
                {
                    "kind": "Variable",
                    "name": "includePassionfruitAsk",
                    "variableName": "includePassionfruitAsk"
                },
                {
                    "kind": "Variable",
                    "name": "includePositions",
                    "variableName": "includePositions"
                },
                {
                    "kind": "Variable",
                    "name": "includeThirdPartyId",
                    "variableName": "includeThirdPartyId"
                }
            ],
            "kind": "FragmentSpread",
            "name": "searchResultRenderer_AtlassianSearchPage"
        }
    ],
    "type": "SearchResult",
    "abstractKey": "__isSearchResult"
};
$1cc2f6a902ce7bda$var$node.hash = "be924295141390fa74cee40ea7cf60f4";
var $1cc2f6a902ce7bda$export$2e2bcd8739ae039 = $1cc2f6a902ce7bda$var$node;
























/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
























var $eyWa4 = parcelRequire("eyWa4");










const $66757835dcd8b2bc$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    title: {
        id: "third-party-query-suggestion.title",
        defaultMessage: "Do smarter searches with {product}"
    },
    dismiss: {
        id: "third-party-query-suggestion.dismiss",
        defaultMessage: "Dismiss"
    }
});


const $c993d6901d2f55e4$var$styles = {
    iconArea: "_nd5l2ec4 _1e0c1txw _4cvr1y6m _1bah1h6o _1bsbckbl",
    icon: "_1pfh12x7",
    pressable: "_zulp12x7 _2rko1tm3 _1rjc12x7 _18zrutpp _1e0c116y _4cvr1h6o _bfhk1s93 _o5721q9c _irr3daj9 _1di6xm0g"
};
const $c993d6901d2f55e4$var$QuerySuggestion = ({ suggestion: suggestion, onSuggestionClicked: onSuggestionClicked })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
        onClick: ()=>{
            onSuggestionClicked(suggestion);
        },
        xcss: $c993d6901d2f55e4$var$styles.pressable,
        testId: "query-suggestion",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                label: "",
                color: "currentColor"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                children: suggestion.text
            })
        ]
    });
};
const $c993d6901d2f55e4$export$85527808033fc689 = ({ suggestions: suggestions, productKey: productKey, thirdPartyConfigs: thirdPartyConfigs, onSuggestionClicked: onSuggestionClicked, onSuggestionsShown: onSuggestionsShown, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const products = (0, $1yEFx.useProductConfigs)();
    const productName = products[productKey]?.displayName || '';
    (0, $42omo.useEffect)(()=>{
        onSuggestionsShown?.(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.150",
        testId: "third-party-query-suggestions",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $c993d6901d2f55e4$var$styles.iconArea,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $c993d6901d2f55e4$var$styles.icon,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $235a70ab221836e5$export$6582c9566971e750), {
                        product: productKey,
                        resourceType: "document",
                        size: "medium",
                        thirdPartyConfigs: thirdPartyConfigs
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                grow: "fill",
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.050",
                        alignBlock: "center",
                        spread: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "large",
                                weight: "medium",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...(0, $66757835dcd8b2bc$export$defe85febe8b728c).title,
                                    values: {
                                        product: productName
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                        ...iconProps,
                                        label: "",
                                        color: "currentColor"
                                    }),
                                onClick: onDismiss,
                                label: formatMessage((0, $66757835dcd8b2bc$export$defe85febe8b728c).dismiss),
                                appearance: 'subtle',
                                spacing: 'compact',
                                testId: "third-party-query-suggestions-dismiss"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                shouldWrap: true,
                                space: "space.100",
                                children: suggestions.slice(0, 2).map((suggestion, index)=>/*#__PURE__*/ (0, $l998X.jsx)($c993d6901d2f55e4$var$QuerySuggestion, {
                                        suggestion: suggestion,
                                        onSuggestionClicked: onSuggestionClicked
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                shouldWrap: true,
                                space: "space.100",
                                children: suggestions.slice(2, 4).map((suggestion, index)=>/*#__PURE__*/ (0, $l998X.jsx)($c993d6901d2f55e4$var$QuerySuggestion, {
                                        suggestion: suggestion,
                                        onSuggestionClicked: onSuggestionClicked
                                    }, index + 2))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};





const $001b368c709a105b$var$THIRD_PARTY_QUERY_SUGGESTIONS_DISMISS_KEY = 'atlassian.unified-search.third-party-query-suggestions-dismissed';
const $001b368c709a105b$export$c8027f1a7616f570 = ()=>{
    const dismissed = (0, $5G9KX.getLocalStorageItemAsString)($001b368c709a105b$var$THIRD_PARTY_QUERY_SUGGESTIONS_DISMISS_KEY);
    return dismissed === 'true';
};
const $001b368c709a105b$export$1933374763d7e99f = ()=>{
    (0, $5G9KX.setLocalStorageItem)($001b368c709a105b$var$THIRD_PARTY_QUERY_SUGGESTIONS_DISMISS_KEY, 'true');
};





const $23a66b055d1610fc$export$62c679d3d22156b = ({ suggestionType: suggestionType, suggestion: suggestion, productKey: productKey })=>({
        source: (0, $6yNqK.EVENT_SOURCE),
        eventType: 'ui',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}ThirdPartyQuerySuggestion`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                productKey: productKey,
                suggestionType: suggestionType,
                suggestion: suggestion
            }
        }
    });





const $db94c542ab3ef651$export$596fd8dcf2541349 = ({ productKey: productKey })=>({
        source: (0, $6yNqK.EVENT_SOURCE),
        eventType: 'ui',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}ThirdPartyQuerySuggestions`,
        action: 'dismissed',
        attributes: {
            additionalAttributes: {
                productKey: productKey
            }
        }
    });





const $716a0146762e0cb2$export$f74b372e2322bcb = ({ productKey: productKey })=>({
        source: (0, $6yNqK.EVENT_SOURCE),
        eventType: 'track',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}ThirdPartyQuerySuggestions`,
        action: 'shown',
        attributes: {
            additionalAttributes: {
                productKey: productKey
            }
        }
    });






var $dS0qJ = parcelRequire("dS0qJ");

const $7b6c4f15f7b4e061$export$63a6ae67de6e43d9 = [
    (query)=>`Show files about "${query}"`,
    (query)=>`Recent files related to "${query}"`,
    (query)=>`Show "${query}" files`,
    (query)=>`"${query}" files`,
    (query)=>`My "${query}" files from this week`,
    (query)=>`My recent "${query}" files`,
    (query)=>`List my "${query}" files`,
    (query)=>`"${query}" files from this year`,
    (query)=>`Show Google docs about "${query}"`,
    (query)=>`Google docs related to "${query}"`,
    (query)=>`"${query}" Google docs`,
    (query)=>`My "${query}" Google docs`
];


// Google Drive
const $1fcd2a222e1eb7dc$export$a15e368fe4e6b7b9 = [
    'Show me my recent files',
    'List files I worked on recently',
    'Find files I edited this week',
    'Files I updated in the last 7 days',
    'My files from the last 14 days',
    'My files older than 2 months',
    'Show my files from this year',
    'Show me my recent Google docs',
    'My newest Google docs',
    'My Google docs from this week',
    'Google docs I worked on',
    'Google docs I updated yesterday'
];








const $c5fba3ce35f1a58a$var$shuffleArray = (arr)=>[
        ...arr
    ].sort(()=>Math.random() - 0.5);
const $c5fba3ce35f1a58a$export$1710af163879a8fa = (staticSuggestionsPool, dynamicSuggestionsPool, currentQuery)=>{
    // Get treatment without firing exposure to use dynamic queries if needed
    const treatment = (0, $2OtFZ.serveInline3PQuerySuggestionsPhase1)({
        fireExperimentExposure: false
    });
    return (0, $42omo.useMemo)(()=>{
        const staticSuggestions = $c5fba3ce35f1a58a$var$shuffleArray(staticSuggestionsPool).slice(0, 4).map((text)=>({
                text: text,
                suggestionType: 'static'
            }));
        const currentQueryWordCount = currentQuery ? currentQuery.trim().split(/\s+/).length : 0;
        if (treatment !== 'dynamic' || !currentQuery || currentQueryWordCount > 2) return staticSuggestions;
        const dynamicSuggestions = $c5fba3ce35f1a58a$var$shuffleArray(dynamicSuggestionsPool).slice(0, 2).map((dynamicSuggestion)=>({
                text: dynamicSuggestion(currentQuery),
                suggestionType: 'dynamic'
            }));
        return $c5fba3ce35f1a58a$var$shuffleArray([
            ...staticSuggestions.slice(0, 2),
            ...dynamicSuggestions
        ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};


// Redacts the current query within a dynamic suggestion to prevent logging UGC
const $2e58397ebab3e6f0$var$sanitizeSuggestion = (suggestion, currentQuery)=>{
    return currentQuery ? suggestion.replace(`"${currentQuery}"`, '"[query]"') : suggestion;
};
const $2e58397ebab3e6f0$var$shouldShowContainer = ({ isDismissed: isDismissed, displayedConfig: displayedConfig, userNeedsOAuth: userNeedsOAuth, locale: locale, thirdPartyConfigs: thirdPartyConfigs })=>{
    // Don't show if user has dismissed, config is missing, or user isn't authenticated
    if (isDismissed || !displayedConfig || userNeedsOAuth !== false) return false;
    // Don't show if locale isn't English
    if (!(0, $dS0qJ.isEnglishLocale)(locale)) return false;
    // Don't show if connector creation date is missing
    const connectorCreatedAt = thirdPartyConfigs[displayedConfig.productKey]?.connectorCreatedAt;
    if (!connectorCreatedAt) return false;
    // Don't show if the connector was created less than 2 weeks ago
    const twoWeeksAgo = new Date();
    twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);
    return new Date(connectorCreatedAt) <= twoWeeksAgo;
};
const $2e58397ebab3e6f0$export$da834437f2e70a90 = ({ thirdPartyConfigs: thirdPartyConfigs, useIsUserOAuthed: useIsUserOAuthed, useSearchActions: useSearchActions, useAnalytics: useAnalytics, currentQuery: currentQuery, onVisible: onVisible })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)((0, $001b368c709a105b$export$c8027f1a7616f570)());
    const { setInputQuery: setInputQuery, selectProductFilter: selectProductFilter } = useSearchActions();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = useAnalytics();
    // For now, only Google Drive is supported
    const displayedProductKey = (0, $b4tvS.ProductKeys3P).GoogleDrive;
    const { userNeedsOAuth: userNeedsOAuth } = useIsUserOAuthed(displayedProductKey);
    const suggestions = (0, $c5fba3ce35f1a58a$export$1710af163879a8fa)((0, $1fcd2a222e1eb7dc$export$a15e368fe4e6b7b9), (0, $7b6c4f15f7b4e061$export$63a6ae67de6e43d9), currentQuery);
    const displayedConfig = {
        productKey: displayedProductKey,
        suggestions: suggestions
    };
    if (!$2e58397ebab3e6f0$var$shouldShowContainer({
        isDismissed: isDismissed,
        displayedConfig: displayedConfig,
        userNeedsOAuth: userNeedsOAuth,
        locale: locale,
        thirdPartyConfigs: thirdPartyConfigs
    })) return null;
    const inline3PQuerySuggestionsPhase1ExperimentTreatment = (0, $2OtFZ.serveInline3PQuerySuggestionsPhase1)();
    if (inline3PQuerySuggestionsPhase1ExperimentTreatment === 'control') return null;
    const handleSuggestionsShown = ()=>{
        onVisible?.();
        fireAnalyticsEvent((0, $716a0146762e0cb2$export$f74b372e2322bcb)({
            productKey: displayedConfig.productKey
        }));
    };
    const handleSuggestionClick = (clickedSuggestion)=>{
        fireAnalyticsEvent((0, $23a66b055d1610fc$export$62c679d3d22156b)({
            productKey: displayedConfig.productKey,
            suggestionType: clickedSuggestion.suggestionType,
            suggestion: $2e58397ebab3e6f0$var$sanitizeSuggestion(clickedSuggestion.text, currentQuery)
        }));
        setInputQuery(clickedSuggestion.text);
        selectProductFilter(displayedConfig.productKey);
    };
    const handleDismiss = ()=>{
        fireAnalyticsEvent((0, $db94c542ab3ef651$export$596fd8dcf2541349)({
            productKey: displayedConfig.productKey
        }));
        (0, $001b368c709a105b$export$1933374763d7e99f)();
        setIsDismissed(true);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c993d6901d2f55e4$export$85527808033fc689), {
        suggestions: displayedConfig.suggestions,
        productKey: displayedConfig.productKey,
        thirdPartyConfigs: thirdPartyConfigs,
        onSuggestionsShown: handleSuggestionsShown,
        onSuggestionClicked: handleSuggestionClick,
        onDismiss: handleDismiss
    });
};














/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $a5OFf = parcelRequire("a5OFf");


var $eO6NY = parcelRequire("eO6NY");










// Hide the listitem wrapper when the banner renders nothing to avoid whitespace gaps.
const $14f5a0c0b568e7eb$var$styles = {
    hideWhenEmpty: "_fiawglyw"
};
const $14f5a0c0b568e7eb$export$df17046610238203 = ({ thirdPartyConfigs: thirdPartyConfigs, selectedProduct: selectedProduct, availableProducts: availableProducts })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const bannerEligibleProductsOrder = (0, $eO6NY.useBannerEligibleProductsOrder)({
        isOnSearchDialog: false,
        thirdPartyConfigs: thirdPartyConfigs,
        availableProducts: availableProducts
    });
    if (!selectedProduct) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "SearchPageRelayResultsOAuthContainer",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            role: "listitem",
            xcss: $14f5a0c0b568e7eb$var$styles.hideWhenEmpty,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a5OFf.OAuthContainer), {
                thirdPartyConfigs: thirdPartyConfigs,
                eligibleProducts: bannerEligibleProductsOrder,
                useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
                fireAnalyticsEvent: fireAnalyticsEvent
            })
        })
    });
    return null;
};

















parcelRequire("42omo");





var $cO1el = parcelRequire("cO1el");


























const $875248bc25579340$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    relatedSearch: {
        id: "leap-query.title.related-search",
        defaultMessage: "Related searches"
    },
    teammatesAlsoAsk: {
        id: "leap-query.title.teammates-also-ask",
        defaultMessage: "Your teammates also ask"
    }
});


const $39e2a93ffdbf67f4$var$candidateStyles = (0, $ecnYn.xcss)({
    height: '100%',
    borderRadius: 'radius.full',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $39e2a93ffdbf67f4$var$candidateContentStyles = (0, $ecnYn.xcss)({
    height: '100%'
});
const $39e2a93ffdbf67f4$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':visited': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':focus': {
        textDecoration: 'none',
        color: 'color.text'
    }
});
const $39e2a93ffdbf67f4$var$candidatesGridStyle = (0, $ecnYn.xcss)({
    gridAutoRows: '1fr'
});
const $39e2a93ffdbf67f4$var$Candidate = ({ candidate: candidate, candidateIndex: candidateIndex, handleCandidateClicked: handleCandidateClicked })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jAenQ.Link), {
        href: candidate.href,
        xcss: $39e2a93ffdbf67f4$var$linkStyles,
        onClick: ()=>{
            if (handleCandidateClicked) handleCandidateClicked(candidateIndex);
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            paddingBlock: "space.150",
            paddingInline: "space.300",
            backgroundColor: "color.background.neutral",
            xcss: $39e2a93ffdbf67f4$var$candidateStyles,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                space: "space.150",
                alignBlock: "center",
                alignInline: "start",
                xcss: $39e2a93ffdbf67f4$var$candidateContentStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                        label: `search ${candidate}`
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        children: candidate.label
                    })
                ]
            })
        })
    });
};
const $39e2a93ffdbf67f4$var$Candidates = ({ candidates: candidates, titleIndex: titleIndex, handleCandidateClicked: handleCandidateClicked })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "small",
                children: intl.formatMessage($39e2a93ffdbf67f4$var$titleMessagesArray[titleIndex])
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cwkWT.default), {
                rowGap: "space.200",
                columnGap: "space.400",
                templateColumns: "1fr 1fr",
                xcss: $39e2a93ffdbf67f4$var$candidatesGridStyle,
                children: candidates.map((candidate, index)=>/*#__PURE__*/ (0, $l998X.jsx)($39e2a93ffdbf67f4$var$Candidate, {
                        candidate: candidate,
                        candidateIndex: index,
                        handleCandidateClicked: handleCandidateClicked
                    }, index))
            })
        ]
    });
};
const $39e2a93ffdbf67f4$var$CandidatesSkeleton = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                width: 100,
                height: 20
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                rowGap: "space.200",
                columnGap: "space.400",
                templateColumns: "1fr 1fr",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: '100%',
                        height: 44,
                        borderRadius: "var(--ds-radius-full, 9999px)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: '100%',
                        height: 44,
                        borderRadius: "var(--ds-radius-full, 9999px)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: '100%',
                        height: 44,
                        borderRadius: "var(--ds-radius-full, 9999px)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: '100%',
                        height: 44,
                        borderRadius: "var(--ds-radius-full, 9999px)"
                    })
                ]
            })
        ]
    });
};
const $39e2a93ffdbf67f4$var$titleMessagesArray = [
    (0, $875248bc25579340$export$defe85febe8b728c).relatedSearch,
    (0, $875248bc25579340$export$defe85febe8b728c).teammatesAlsoAsk
];
const $39e2a93ffdbf67f4$var$LeapQuery = ({ candidates: candidates, loading: loading, titleIndex: titleIndex = 0, handleCandidateClicked: handleCandidateClicked })=>{
    // The `titleIndex` prop is used to specify which title to display.
    // `titleMessagesArray` is in the order that we aligned with backend engineers who maintains the leap query API.
    return loading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        padding: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsx)($39e2a93ffdbf67f4$var$CandidatesSkeleton, {})
    }) : candidates.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        padding: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsx)($39e2a93ffdbf67f4$var$Candidates, {
            candidates: candidates,
            titleIndex: titleIndex,
            handleCandidateClicked: handleCandidateClicked
        })
    }) : null;
};
var $39e2a93ffdbf67f4$export$2e2bcd8739ae039 = $39e2a93ffdbf67f4$var$LeapQuery;





const $5402f5bed179af85$export$cdb486deb3bf42a6 = ({ candidateIndex: candidateIndex, titleIndex: titleIndex, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        actionSubject: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}LeapQueryCandidate`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                leapQueryCandidateIndex: candidateIndex,
                lastQueryTitleIndex: titleIndex
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });


const $e40b2724d9f27471$export$4f8c03bff03c2688 = ({ candidatesCount: candidatesCount, titleIndex: titleIndex, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'shown',
        actionSubject: 'leapQuery',
        attributes: {
            additionalAttributes: {
                leapQueryCandidatesCount: candidatesCount,
                lastQueryTitleIndex: titleIndex
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });









const $c87f95dd2abf5b51$var$LeapQuery = ({ searchQuery: searchQuery, originalQuery: originalQuery, primaryProduct: primaryProduct, logError: logError })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [{ candidates: candidates, titleIndex: titleIndex, loading: loading }, setLeapQuery] = (0, $42omo.useState)(()=>{
        const response = searchQuery && primaryProduct ? (0, $2b038019829bbd3e$export$1aafcd2cfb41dc92)({
            query: searchQuery,
            product: primaryProduct
        }).getValue() : undefined;
        return {
            candidates: response?.candidates || [],
            titleIndex: response?.title || 0,
            loading: searchQuery && primaryProduct ? !response : false
        };
    });
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const hasCandidates = candidates.length > 0;
    const analyticsDataRef = (0, $42omo.useRef)({
        fireAnalyticsEvent: fireAnalyticsEvent,
        commonAttributes: commonAttributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        titleIndex: titleIndex
    });
    // Hack to ensure that the analytics data is not stale
    analyticsDataRef.current = {
        fireAnalyticsEvent: fireAnalyticsEvent,
        commonAttributes: commonAttributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        titleIndex: titleIndex
    };
    (0, $42omo.useEffect)(()=>{
        if (!searchQuery || !primaryProduct || hasCandidates) return;
        setLeapQuery((prevState)=>({
                ...prevState,
                loading: true
            }));
        (0, $2b038019829bbd3e$export$1aafcd2cfb41dc92)({
            query: searchQuery,
            product: primaryProduct
        }).then((response)=>{
            setLeapQuery({
                candidates: response.candidates,
                titleIndex: response.title,
                loading: false
            });
        }).catch((e)=>{
            setLeapQuery({
                candidates: [],
                titleIndex: 0,
                loading: false
            });
            logError(e);
        });
    }, [
        hasCandidates,
        searchQuery,
        primaryProduct,
        setLeapQuery,
        logError
    ]);
    const mappedCandidates = (0, $42omo.useMemo)(()=>candidates.slice(0, 4).map((candidate)=>({
                label: candidate,
                href: generateSearchUrl({
                    ...queryParams,
                    text: candidate,
                    originalQuery: originalQuery
                })
            })), [
        candidates,
        generateSearchUrl,
        originalQuery,
        queryParams
    ]);
    const handleCandidateClicked = (candidateIndex)=>{
        fireAnalyticsEvent((0, $5402f5bed179af85$export$cdb486deb3bf42a6)({
            candidateIndex: candidateIndex,
            titleIndex: titleIndex,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    };
    (0, $42omo.useEffect)(()=>{
        if (loading || mappedCandidates.length === 0) return;
        const { fireAnalyticsEvent: fireAnalyticsEvent, titleIndex: titleIndex, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = analyticsDataRef.current;
        fireAnalyticsEvent((0, $e40b2724d9f27471$export$4f8c03bff03c2688)({
            candidatesCount: mappedCandidates.length,
            titleIndex: titleIndex,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        mappedCandidates.length,
        loading,
        analyticsDataRef
    ]);
    if (!loading && mappedCandidates.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        role: "listitem",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $39e2a93ffdbf67f4$export$2e2bcd8739ae039), {
            candidates: mappedCandidates,
            loading: loading,
            titleIndex: titleIndex,
            handleCandidateClicked: handleCandidateClicked
        })
    });
};
const $c87f95dd2abf5b51$export$9b91afdfe0a13e1a = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "SearchPageLeapQuery",
        children: /*#__PURE__*/ (0, $l998X.jsx)($c87f95dd2abf5b51$var$LeapQuery, {
            ...props
        })
    });





/**
 * @generated SignedSource<<7044fa3c91a44fb3e558b9e2b6e86f00>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f2155b61e0619eb7$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "includeIconUrl",
        "variableName": "includeIconUrl"
    }, v1 = [
        v0 /*: any*/ 
    ], v2 = {
        "kind": "Variable",
        "name": "includeJiraLiteModeFields",
        "variableName": "includeJiraLiteModeFields"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeAssets"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeAssigneeField"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeIconUrl"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeJiraLiteModeFields"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeNavBoostScore"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includePassionfruitAsk"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includePositions"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeThirdPartyId"
            }
        ],
        "kind": "Fragment",
        "name": "searchResultRenderer_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "args": v1 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "searchAtlasGoal_AtlassianSearchPage"
            },
            {
                "args": v1 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "searchAtlasProject_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchFederatedResult_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchCompassComponent_AtlassianSearchPage"
            },
            {
                "args": [
                    v0 /*: any*/ ,
                    {
                        "kind": "Variable",
                        "name": "includeNavBoostScore",
                        "variableName": "includeNavBoostScore"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "searchConfluencePageBlogAttachment_AtlassianSearchPage"
            },
            {
                "args": v1 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "searchConfluenceSpace_AtlassianSearchPage"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "includeThirdPartyId",
                        "variableName": "includeThirdPartyId"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "searchGraphResult_AtlassianSearchPage"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "includeAssigneeField",
                        "variableName": "includeAssigneeField"
                    },
                    v2 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "searchJiraIssue_AtlassianSearchPage"
            },
            {
                "args": [
                    v2 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "searchJiraProject_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchJiraPlan_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchJiraBoard_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchJiraDashboard_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchJiraFilter_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchMercuryFocusArea_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchMercuryFocusAreaUpdate_AtlassianSearchPage"
            },
            {
                "condition": "includePassionfruitAsk",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "searchPassionfruitAsk_AtlassianSearchPage"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "searchTrello_AtlassianSearchPage"
            },
            {
                "condition": "includeAssets",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "searchAssetsObjectSchema_AtlassianSearchPage"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "searchAssetsObjectType_AtlassianSearchPage"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "searchAssetsObject_AtlassianSearchPage"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "searchDefaultRenderer_AtlassianSearchPage"
            },
            {
                "condition": "includePositions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "searchTalentPosition_AtlassianSearchPage"
                    }
                ]
            }
        ],
        "type": "SearchResult",
        "abstractKey": "__isSearchResult"
    };
}();
$f2155b61e0619eb7$var$node.hash = "1ce7f8772af10b9ab3054561e63ad975";
var $f2155b61e0619eb7$export$2e2bcd8739ae039 = $f2155b61e0619eb7$var$node;


parcelRequire("42omo");













/**
 * @generated SignedSource<<6f5549fe3caf20280288ad2d100826b4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fe1d7af275809cbe$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchAssetsObject_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "concreteType": "AssetsSchema",
            "kind": "LinkedField",
            "name": "objectSchemaEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        },
        {
            "concreteType": "AssetsObject",
            "kind": "LinkedField",
            "name": "objectEntity",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AssetsAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url48"
                        }
                    ]
                },
                {
                    "concreteType": "AssetsLinks",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "web"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SearchResultAssetsObject"
};
$fe1d7af275809cbe$var$node.hash = "0eea183c12ea41b63de705e78bddf666";
var $fe1d7af275809cbe$export$2e2bcd8739ae039 = $fe1d7af275809cbe$var$node;









var $226KS = parcelRequire("226KS");













var $icWhS = parcelRequire("icWhS");







parcelRequire("42omo");






const $0d63697edde98d0a$var$descriptionBodyStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    lineClamp: 2,
    WebkitBoxOrient: 'vertical'
});
const $0d63697edde98d0a$export$780f34b9b2f156ca = ({ description: description })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $0d63697edde98d0a$var$descriptionBodyStyles,
        children: description
    });
};




var $2waBy = parcelRequire("2waBy");


var $9WEcF = parcelRequire("9WEcF");


var $kXlQy = parcelRequire("kXlQy");










const $93586e46c0b180da$export$c7c0ac9713d05b8e = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}ContextMenuButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                location: 'searchResultTitle'
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });








const $3808426f0faae55b$export$ede80662f98c6d00 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    return (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $93586e46c0b180da$export$c7c0ac9713d05b8e)({
            commonAttributes: {
                ...commonAttributes,
                ...(0, $1ymk3.getExtensionData)(commonAttributes.isCQL)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
};








const $e7c87e3ee203b05c$export$822017e4f08ebe1e = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}ContextMenuCopyButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                location: 'searchResultTitle'
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });








const $2719c743fbe13cbd$export$875f4c2863f9261e = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    return (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $e7c87e3ee203b05c$export$822017e4f08ebe1e)({
            commonAttributes: {
                ...commonAttributes,
                ...(0, $1ymk3.getExtensionData)(commonAttributes.isCQL)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
};












const $7854452482d3991b$export$640da93e7e078b14 = ({ metadata: metadata, position: position, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, socialSignal: socialSignal, fromLinksSeeAll: fromLinksSeeAll, sublistPosition: sublistPosition, provider: provider, linkDocId: linkDocId, linkDocContentType: linkDocContentType, fanoutProduct: fanoutProduct, fanoutLinkCategory: fanoutLinkCategory, isImpersonated: isImpersonated = false, hasRelatedLinks: hasRelatedLinks, is3PClickIngestionEnabled: is3PClickIngestionEnabled, thirdPartyId: thirdPartyId, isAuxClick: isAuxClick = false, isSummarizeClick: isSummarizeClick = false, intentDetectionTriggered: intentDetectionTriggered })=>{
    const { product: metadataProduct, ...restMetadata } = metadata;
    const product = fanoutProduct || metadataProduct;
    return {
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'advancedSearchResultLink',
        attributes: {
            additionalAttributes: {
                position: position,
                metadata: {
                    ...restMetadata,
                    product: product,
                    ...fanoutProduct && {
                        parentProduct: metadataProduct
                    },
                    ...fanoutLinkCategory && {
                        fanoutLinkCategory: fanoutLinkCategory
                    },
                    is3PLink: (0, $fuGkE.is3pProductKeyForAnalytics)(product),
                    fromLinksSeeAll: fromLinksSeeAll,
                    sublistPosition: sublistPosition,
                    provider: provider,
                    linkDocId: linkDocId,
                    linkDocContentType: linkDocContentType,
                    hasRelatedLinks: hasRelatedLinks,
                    thirdPartyId: thirdPartyId
                },
                isImpersonated: isImpersonated,
                socialSignal: socialSignal,
                is3PClickIngestionEnabled: is3PClickIngestionEnabled,
                isAuxClick: isAuxClick,
                isSummarizeClick: isSummarizeClick,
                ...intentDetectionTriggered !== undefined ? {
                    intentDetectionTriggered: intentDetectionTriggered
                } : {}
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $7854452482d3991b$export$a72fc3c2887a9000 = ({ metadata: metadata, position: position, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, socialSignal: socialSignal, sublistPosition: sublistPosition, linkDocId: linkDocId, linkDocContentType: linkDocContentType, fanoutProduct: fanoutProduct, fanoutLinkCategory: fanoutLinkCategory, isImpersonated: isImpersonated = false, is3PClickIngestionEnabled: is3PClickIngestionEnabled, intentDetectionTriggered: intentDetectionTriggered, thirdPartyId: thirdPartyId })=>{
    const { product: metadataProduct, ...restMetadata } = metadata;
    const product = fanoutProduct || metadataProduct;
    return {
        eventType: 'ui',
        action: 'contextMenuClicked',
        actionSubject: 'advancedSearchResultLink',
        attributes: {
            additionalAttributes: {
                position: position,
                metadata: {
                    ...restMetadata,
                    product: product,
                    ...fanoutProduct && {
                        parentProduct: metadataProduct
                    },
                    ...fanoutLinkCategory && {
                        fanoutLinkCategory: fanoutLinkCategory
                    },
                    is3PLink: (0, $fuGkE.is3pProductKeyForAnalytics)(product),
                    sublistPosition: sublistPosition,
                    linkDocId: linkDocId,
                    linkDocContentType: linkDocContentType,
                    thirdPartyId: thirdPartyId
                },
                isImpersonated: isImpersonated,
                socialSignal: socialSignal,
                is3PClickIngestionEnabled: is3PClickIngestionEnabled,
                ...intentDetectionTriggered !== undefined ? {
                    intentDetectionTriggered: intentDetectionTriggered
                } : {}
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};














const $29cf2c8a5cfa1059$export$b9038cd1b8a570da = ({ metadata: metadata, position: position, socialSignal: socialSignal, isImpersonated: isImpersonated = false, is3PClickIngestionEnabled: is3PClickIngestionEnabled })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const intentDetectionTriggered = (0, $26jni.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale);
    return (0, $42omo.useCallback)((params = {})=>{
        const { fromLinksSeeAll: fromLinksSeeAll, sublistPosition: sublistPosition, provider: provider, linkDocId: linkDocId, linkDocContentType: linkDocContentType, fanoutProduct: fanoutProduct, fanoutLinkCategory: fanoutLinkCategory, hasRelatedLinks: hasRelatedLinks, thirdPartyId: thirdPartyId, isAuxClick: // This is different from ID. It's needed to track clicks on results in Act. Platform.
        isAuxClick, isSummarizeClick: isSummarizeClick } = params;
        const analyticsPayload = (0, $7854452482d3991b$export$640da93e7e078b14)({
            metadata: metadata,
            position: position,
            socialSignal: socialSignal,
            commonAttributes: {
                ...commonAttributes,
                ...(0, $1ymk3.getExtensionData)(commonAttributes.isCQL)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            fromLinksSeeAll: fromLinksSeeAll,
            sublistPosition: sublistPosition,
            provider: provider,
            fanoutProduct: fanoutProduct,
            linkDocId: linkDocId,
            linkDocContentType: linkDocContentType,
            fanoutLinkCategory: fanoutLinkCategory,
            isImpersonated: isImpersonated,
            hasRelatedLinks: hasRelatedLinks,
            is3PClickIngestionEnabled: is3PClickIngestionEnabled,
            thirdPartyId: thirdPartyId,
            isAuxClick: isAuxClick,
            isSummarizeClick: isSummarizeClick,
            intentDetectionTriggered: intentDetectionTriggered
        });
        fireAnalyticsEvent(analyticsPayload);
    }, [
        fireAnalyticsEvent,
        metadata,
        position,
        socialSignal,
        commonAttributes,
        nonPrivacySafeAttributes,
        isImpersonated,
        is3PClickIngestionEnabled,
        intentDetectionTriggered
    ]);
};





















const $add774a162708af3$export$8839bf4972090a38 = ({ metadata: metadata, position: position, socialSignal: socialSignal, isImpersonated: isImpersonated = false, is3PClickIngestionEnabled: is3PClickIngestionEnabled })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const intentDetectionTriggered = (0, $26jni.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale);
    return (0, $42omo.useCallback)((params = {})=>{
        const { sublistPosition: sublistPosition, linkDocId: linkDocId, provider: provider, linkDocContentType: linkDocContentType, fanoutProduct: fanoutProduct, fanoutLinkCategory: fanoutLinkCategory, thirdPartyId: thirdPartyId } = params;
        const analyticsPayload = (0, $7854452482d3991b$export$a72fc3c2887a9000)({
            metadata: metadata,
            position: position,
            fanoutProduct: fanoutProduct,
            fanoutLinkCategory: fanoutLinkCategory,
            socialSignal: socialSignal,
            commonAttributes: {
                ...commonAttributes,
                ...(0, $1ymk3.getExtensionData)(commonAttributes.isCQL)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            sublistPosition: sublistPosition,
            provider: provider,
            linkDocId: linkDocId,
            linkDocContentType: linkDocContentType,
            isImpersonated: isImpersonated ?? false,
            is3PClickIngestionEnabled: is3PClickIngestionEnabled,
            intentDetectionTriggered: intentDetectionTriggered,
            thirdPartyId: thirdPartyId
        });
        fireAnalyticsEvent(analyticsPayload);
    }, [
        fireAnalyticsEvent,
        metadata,
        position,
        socialSignal,
        commonAttributes,
        nonPrivacySafeAttributes,
        isImpersonated,
        is3PClickIngestionEnabled,
        intentDetectionTriggered
    ]);
};








const $43a335bf303e6216$export$1c710fc72952b57e = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, location: location, metadata: metadata, position: position })=>({
        eventType: 'ui',
        actionSubject: 'button',
        actionSubjectId: `${0, $6yNqK.ACTION_SUBJECT_PREFIX}SummarizeInChatButton`,
        action: 'clicked',
        attributes: {
            additionalAttributes: {
                location: location,
                metadata: metadata,
                position: position
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });








const $bbb097a890bbf9c9$export$5ce6946676179c6b = ({ location: location, metadata: metadata, position: position })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    return (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $43a335bf303e6216$export$1c710fc72952b57e)({
            commonAttributes: {
                ...commonAttributes,
                ...(0, $1ymk3.getExtensionData)(commonAttributes.isCQL)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            location: location,
            metadata: metadata,
            position: position
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        location,
        metadata,
        position
    ]);
};


const $def5c503597c8977$var$SchemaMetadata = ({ schemaName: schemaName })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                size: "small",
                label: ""
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "inherit",
                children: schemaName
            })
        ]
    });
};
const $def5c503597c8977$export$7afb78c1a6844ab6 = ({ node: node, position: position, searchSessionId: searchSessionId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $fe1d7af275809cbe$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            // Normalise to the canonical 1P key ('cmdb') so analytics pipelines
            // see a single identifier. The ARI resource-owner may be 'assets'
            // (assets-site deployments) or 'cmdb' (regular cloud).
            product: (0, $dh538.fg)('search-page-assets-analytics-consolidation') ? (0, $1yEFx.ProductKeys).Assets : product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        const webUrl = data.objectEntity?.links?.web;
        if (!webUrl) return null;
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: webUrl,
            searchSessionId: searchSessionId
        });
    }, [
        data.objectEntity?.links?.web,
        searchSessionId
    ]);
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!data.lastModifiedDate) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: data.lastModifiedDate
        });
    }, [
        data.lastModifiedDate
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: data.type
            })
        ],
        ...data.objectSchemaEntity?.name ? [
            [
                'schema',
                /*#__PURE__*/ (0, $l998X.jsx)($def5c503597c8977$var$SchemaMetadata, {
                    schemaName: data.objectSchemaEntity.name
                })
            ]
        ] : [],
        [
            'lastModified',
            getLastModified
        ]
    ];
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(data.title);
    }, [
        data.title
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(data.description);
    }, [
        data.description
    ]);
    const icon = (0, $42omo.useMemo)(()=>{
        return (0, $2waBy.getAssetsEntityIcon)({
            iconUrl: data.objectEntity?.avatar?.url48,
            type: data.type,
            size: 'medium'
        });
    }, [
        data.objectEntity?.avatar?.url48,
        data.type
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Assets,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $def5c503597c8977$export$4cdaf9794367deaa = (node)=>{
    return node?.__typename === 'SearchResultAssetsObject';
};





/**
 * @generated SignedSource<<b821295bd507fb4ca3c5e44d75529568>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $89b45b1aab34744d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchAssetsObjectSchema_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "concreteType": "AssetsSchema",
            "kind": "LinkedField",
            "name": "objectSchemaEntity",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AssetsLinks",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "web"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SearchResultAssetsObjectSchema"
};
$89b45b1aab34744d$var$node.hash = "34ba06a2a15f2dcbbea5dad1112fecb2";
var $89b45b1aab34744d$export$2e2bcd8739ae039 = $89b45b1aab34744d$var$node;








































const $b28fdd1f3658a84e$export$33645cba5cb4e74d = ({ node: node, position: position, searchSessionId: searchSessionId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $89b45b1aab34744d$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            // Normalise to the canonical 1P key ('cmdb') so analytics pipelines
            // see a single identifier. The ARI resource-owner may be 'assets'
            // (assets-site deployments) or 'cmdb' (regular cloud).
            product: (0, $dh538.fg)('search-page-assets-analytics-consolidation') ? (0, $1yEFx.ProductKeys).Assets : product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        const webUrl = data.objectSchemaEntity?.links?.web;
        if (!webUrl) return null;
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: webUrl,
            searchSessionId: searchSessionId
        });
    }, [
        data.objectSchemaEntity?.links?.web,
        searchSessionId
    ]);
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!data.lastModifiedDate) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: data.lastModifiedDate
        });
    }, [
        data.lastModifiedDate
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: data.type
            })
        ],
        [
            'lastModified',
            getLastModified
        ]
    ];
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(data.title);
    }, [
        data.title
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(data.description);
    }, [
        data.description
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Assets,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: (0, $2waBy.getAssetsEntityIcon)({
            iconUrl: null,
            type: data.type,
            size: 'medium'
        }),
        headerMetadataParts: headerMetadataParts,
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $b28fdd1f3658a84e$export$7b84b51bda14a6a0 = (node)=>{
    return node?.__typename === 'SearchResultAssetsObjectSchema';
};





/**
 * @generated SignedSource<<bf5fe60138764399d667c8128386aaaa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0f388f25e3fcca4e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchAssetsObjectType_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "concreteType": "AssetsSchema",
            "kind": "LinkedField",
            "name": "objectSchemaEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        },
        {
            "concreteType": "AssetsObjectType",
            "kind": "LinkedField",
            "name": "objectTypeEntity",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AssetsIcon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url48"
                        }
                    ]
                },
                {
                    "concreteType": "AssetsLinks",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "web"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SearchResultAssetsObjectType"
};
$0f388f25e3fcca4e$var$node.hash = "413e6bbad4a1a59e111fea1b1a76dab9";
var $0f388f25e3fcca4e$export$2e2bcd8739ae039 = $0f388f25e3fcca4e$var$node;
















































const $3910a17689cc33ca$var$SchemaMetadata = ({ schemaName: schemaName })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                size: "small",
                label: ""
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "inherit",
                children: schemaName
            })
        ]
    });
};
const $3910a17689cc33ca$export$9f67e5fd0627a72b = ({ node: node, position: position, searchSessionId: searchSessionId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $0f388f25e3fcca4e$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            // Normalise to the canonical 1P key ('cmdb') so analytics pipelines
            // see a single identifier. The ARI resource-owner may be 'assets'
            // (assets-site deployments) or 'cmdb' (regular cloud).
            product: (0, $dh538.fg)('search-page-assets-analytics-consolidation') ? (0, $1yEFx.ProductKeys).Assets : product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        const webUrl = data.objectTypeEntity?.links?.web;
        if (!webUrl) return null;
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: webUrl,
            searchSessionId: searchSessionId
        });
    }, [
        data.objectTypeEntity?.links?.web,
        searchSessionId
    ]);
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!data.lastModifiedDate) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: data.lastModifiedDate
        });
    }, [
        data.lastModifiedDate
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: data.type
            })
        ],
        ...data.objectSchemaEntity?.name ? [
            [
                'schema',
                /*#__PURE__*/ (0, $l998X.jsx)($3910a17689cc33ca$var$SchemaMetadata, {
                    schemaName: data.objectSchemaEntity.name
                })
            ]
        ] : [],
        [
            'lastModified',
            getLastModified
        ]
    ];
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(data.title);
    }, [
        data.title
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(data.description);
    }, [
        data.description
    ]);
    const icon = (0, $42omo.useMemo)(()=>{
        return (0, $2waBy.getAssetsEntityIcon)({
            iconUrl: data.objectTypeEntity?.icon?.url48,
            type: data.type,
            size: 'medium'
        });
    }, [
        data.objectTypeEntity?.icon?.url48,
        data.type
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Assets,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $3910a17689cc33ca$export$510b7ec52c081a20 = (node)=>{
    return node?.__typename === 'SearchResultAssetsObjectType';
};





/**
 * @generated SignedSource<<7843fd3ca6511c7e429078faa3645191>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $43dfb553b2241053$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "description"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeIconUrl"
            }
        ],
        "kind": "Fragment",
        "name": "searchAtlasGoal_AtlassianSearchPage",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "goalTitleMetadata_AtlassianSearchPage"
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "condition": "includeIconUrl",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            },
            {
                "concreteType": "TownsquareGoal",
                "kind": "LinkedField",
                "name": "goal",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v0 /*: any*/ 
                ]
            }
        ],
        "type": "SearchResultAtlasGoal"
    };
}();
$43dfb553b2241053$var$node.hash = "5d37968657dd4ac5331c73def0a72966";
var $43dfb553b2241053$export$2e2bcd8739ae039 = $43dfb553b2241053$var$node;





















































/**
 * @generated SignedSource<<f1be512eefa5f4344ff7af795f9db259>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $21524b73e3a6a6c6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "goalTitleMetadata_AtlassianSearchPage",
    "selections": [
        {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "goal",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TownsquareStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TownsquareLocalizationField",
                            "kind": "LinkedField",
                            "name": "localizedLabel",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "messageId"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "score"
                        }
                    ]
                },
                {
                    "concreteType": "TownsquareTargetDate",
                    "kind": "LinkedField",
                    "name": "targetDate",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "label"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SearchResultAtlasGoal"
};
$21524b73e3a6a6c6$var$node.hash = "c30318c731fc2ff06bbb542cb5aa234a";
var $21524b73e3a6a6c6$export$2e2bcd8739ae039 = $21524b73e3a6a6c6$var$node;


parcelRequire("42omo");










parcelRequire("42omo");





var $5nBzc = parcelRequire("5nBzc");









const $b9d6f88287920668$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    for: {
        id: "search-page.atlas.for",
        defaultMessage: "for"
    }
});


const $f2f03c9fb6d1a105$var$lozengeStyleMapping = {
    onTrack: {
        default: {
            backgroundColor: `${"var(--ds-background-accent-green-subtle, #4BCE97)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        },
        withScore: {
            backgroundColor: `${"var(--ds-background-accent-lime-subtler, #D3F1A7)"}`,
            secondaryBackgroundColor: `${"var(--ds-background-accent-lime-subtle, #94C748)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        }
    },
    atRisk: {
        default: {
            backgroundColor: `${"var(--ds-background-accent-yellow-subtle, #EED12B)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        },
        withScore: {
            backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #F5E989)"}`,
            secondaryBackgroundColor: `${"var(--ds-background-accent-yellow-subtle, #EED12B)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        }
    },
    offTrack: {
        default: {
            backgroundColor: `${"var(--ds-background-accent-red-subtle, #F87168)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        },
        withScore: {
            backgroundColor: `${"var(--ds-background-accent-red-subtle, #F87168)"}`,
            secondaryBackgroundColor: `${"var(--ds-border-accent-red, #E2483D)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        }
    },
    date: {
        default: {
            backgroundColor: `${"var(--ds-background-neutral-subtle, #00000000)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        }
    },
    default: {
        default: {
            backgroundColor: `${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        },
        withScore: {
            backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}`,
            secondaryBackgroundColor: `${"var(--ds-background-inverse-subtle, #00000029)"}`,
            color: `${"var(--ds-text, #292A2E)"}`
        }
    }
};
const $f2f03c9fb6d1a105$export$e9a2c2b0ecc25ba5 = (statusType, hasScore)=>{
    switch(statusType){
        case 'on_track':
            return hasScore ? $f2f03c9fb6d1a105$var$lozengeStyleMapping.onTrack.withScore : $f2f03c9fb6d1a105$var$lozengeStyleMapping.onTrack.default;
        case 'at_risk':
            return hasScore ? $f2f03c9fb6d1a105$var$lozengeStyleMapping.atRisk.withScore : $f2f03c9fb6d1a105$var$lozengeStyleMapping.atRisk.default;
        case 'off_track':
            return hasScore ? $f2f03c9fb6d1a105$var$lozengeStyleMapping.offTrack.withScore : $f2f03c9fb6d1a105$var$lozengeStyleMapping.offTrack.default;
        case 'date':
            return $f2f03c9fb6d1a105$var$lozengeStyleMapping.date.default;
        default:
            return hasScore ? $f2f03c9fb6d1a105$var$lozengeStyleMapping.default.withScore : $f2f03c9fb6d1a105$var$lozengeStyleMapping.default.default;
    }
};
const $f2f03c9fb6d1a105$var$statusAndScoreStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex'
});
const $f2f03c9fb6d1a105$var$statusStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    top: 'space.negative.025',
    left: 'space.050',
    clipPath: 'inset(0 6px 0 0)'
});
const $f2f03c9fb6d1a105$var$scoreStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    top: 'space.negative.025',
    right: 'space.050',
    clipPath: 'inset(0 0 0 2px)'
});
const $f2f03c9fb6d1a105$var$statusAndDateContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $f2f03c9fb6d1a105$var$vrStatusDateStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $f2f03c9fb6d1a105$export$689bde3f7e9a94ec = ({ statusValue: statusValue, statusLabel: statusLabel, statusScore: statusScore, date: date })=>{
    const hasScore = statusScore !== null;
    const { backgroundColor: backgroundColor, secondaryBackgroundColor: secondaryBackgroundColor, color: color } = $f2f03c9fb6d1a105$export$e9a2c2b0ecc25ba5(statusValue, hasScore);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $f2f03c9fb6d1a105$var$statusAndDateContainerStyles,
        children: [
            hasScore ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $f2f03c9fb6d1a105$var$statusAndScoreStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $f2f03c9fb6d1a105$var$statusStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                            style: {
                                backgroundColor: backgroundColor,
                                color: color
                            },
                            isBold: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                paddingInlineEnd: "space.075",
                                children: statusLabel
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $f2f03c9fb6d1a105$var$scoreStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                            style: {
                                backgroundColor: secondaryBackgroundColor,
                                color: color
                            },
                            isBold: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                paddingInlineStart: "space.025",
                                children: statusScore
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                    style: {
                        backgroundColor: backgroundColor,
                        color: color
                    },
                    isBold: true,
                    children: statusLabel
                })
            }),
            date && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $f2f03c9fb6d1a105$var$vrStatusDateStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $b9d6f88287920668$export$defe85febe8b728c).for
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        style: $f2f03c9fb6d1a105$export$e9a2c2b0ecc25ba5('date', false),
                        children: date
                    })
                ]
            })
        ]
    });
};



var $a7nUd = parcelRequire("a7nUd");




const $70dc1f0f601efdf3$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    for: {
        id: "search-page.atlas.goal.for",
        defaultMessage: "for"
    },
    'townsquare.api.goal-state.archived': {
        id: "seaech-page.townsquare.api.goal-state.archived",
        defaultMessage: "Archived"
    },
    'townsquare.api.goal-state.off-track': {
        id: "seaech-page.townsquare.api.goal-state.off-track",
        defaultMessage: "Off track"
    },
    'townsquare.api.goal-state.at-risk': {
        id: "seaech-page.townsquare.api.goal-state.at-risk",
        defaultMessage: "At risk"
    },
    'townsquare.api.goal-state.on-track': {
        id: "seaech-page.townsquare.api.goal-state.on-track",
        defaultMessage: "On track"
    },
    'townsquare.api.goal-state.pending': {
        id: "seaech-page.townsquare.api.goal-state.pending",
        defaultMessage: "Pending"
    },
    'townsquare.api.goal-state.paused': {
        id: "seaech-page.townsquare.api.goal-state.paused",
        defaultMessage: "Paused"
    },
    'townsquare.api.goal-state.completed': {
        id: "seaech-page.townsquare.api.goal-state.completed",
        defaultMessage: "Completed"
    },
    'townsquare.api.goal-state.cancelled': {
        id: "seaech-page.townsquare.api.goal-state.cancelled",
        defaultMessage: "Cancelled"
    }
});


const $a32c5e145f28a188$export$4c3ec08c664f4c95 = ({ metadata: metadata })=>{
    const data = (0, $irOoi.useFragment)((0, $21524b73e3a6a6c6$export$2e2bcd8739ae039), metadata);
    let statusLozenge = null;
    const messageKey = data.goal?.status?.localizedLabel?.messageId;
    const statusLabel = (0, $70dc1f0f601efdf3$export$defe85febe8b728c)[messageKey] ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        ...(0, $70dc1f0f601efdf3$export$defe85febe8b728c)[messageKey]
    }) : null;
    const statusValue = data.goal?.status?.value;
    const statusScore = data.goal?.status?.score ?? null;
    const date = data.goal?.targetDate?.label;
    if (statusLabel && statusValue) statusLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $f2f03c9fb6d1a105$export$689bde3f7e9a94ec), {
        statusValue: statusValue,
        statusLabel: statusLabel,
        statusScore: statusScore,
        date: date
    });
    const titleMetadataParts = [
        [
            'status',
            statusLozenge
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
        parts: titleMetadataParts,
        displaySpacer: false
    });
};


const $5b3efb581ea6b58d$export$bd12cc2939091aab = ({ node: node, position: position, searchQuery: searchQuery, searchSessionId: searchSessionId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $43dfb553b2241053$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: data.url,
            searchSessionId: searchSessionId
        });
    }, [
        data.url,
        searchSessionId
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: data.type
            })
        ]
    ];
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const prefix = data.goal?.key;
        if (prefix) return (0, $Y34Hw.enrichExcerpt)(prefix.concat('\u2002', data.title));
        return (0, $Y34Hw.enrichExcerpt)(data.title);
    }, [
        data.title,
        data.goal?.key
    ]);
    const description = $5b3efb581ea6b58d$var$getDescription(data);
    const excerptDescription = data.description;
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        if (excerptDescription) return (0, $Y34Hw.enrichExcerpt)(excerptDescription);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(description, searchQuery.split(' '));
        if (!highlightedTitle) return description;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        description,
        excerptDescription,
        searchQuery
    ]);
    let icon;
    if ((0, $dh538.fg)('rovo_search_confluence_icons_fps')) icon = (0, $2waBy.getAtlasEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        size: 'medium'
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        product: (0, $1yEFx.ProductKeys).Atlas,
        label: "Atlas"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Atlas,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a32c5e145f28a188$export$4c3ec08c664f4c95), {
            metadata: data
        }),
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $5b3efb581ea6b58d$var$descriptionContainerStyles,
            testId: "search-page-atlas-result-description",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
                description: enrichedDescription
            })
        }),
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $5b3efb581ea6b58d$export$e232933b3399051b = (node)=>{
    return node?.id?.includes('townsquare') && node?.__typename === 'SearchResultAtlasGoal';
};
const $5b3efb581ea6b58d$var$descriptionContainerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    maxHeight: '60px'
});
const $5b3efb581ea6b58d$var$getDescription = (data)=>{
    let description = '';
    if (!data.goal?.description) return '';
    const parsedDescrption = JSON.parse(data.goal.description);
    // Recursive function to build the description. Traversal occurs in DFS
    // order. The base case is when the node is a text node, in which case
    // the text is appended to the description.
    const buildDescription = (goalDescription)=>{
        if (goalDescription.content) goalDescription.content.forEach(buildDescription);
        else if (goalDescription.type === 'text') description += goalDescription.text;
    };
    if (parsedDescrption.content) buildDescription(parsedDescrption);
    return description;
};





/**
 * @generated SignedSource<<1e49db42fa99c632401cad09374f823e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a8823c5e0fe3b2bf$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeIconUrl"
        }
    ],
    "kind": "Fragment",
    "name": "searchAtlasProject_AtlassianSearchPage",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "projectTitleMetadata_AtlassianSearchPage"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "condition": "includeIconUrl",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        },
        {
            "concreteType": "TownsquareProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                }
            ]
        }
    ],
    "type": "SearchResultAtlasProject"
};
$a8823c5e0fe3b2bf$var$node.hash = "5648bed532cee859541b1023161a3504";
var $a8823c5e0fe3b2bf$export$2e2bcd8739ae039 = $a8823c5e0fe3b2bf$var$node;












































/**
 * @generated SignedSource<<7fdf6ebb0f4b0c103ea0627e588086fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0ae82f3cd79894a4$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "label"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "projectTitleMetadata_AtlassianSearchPage",
        "selections": [
            {
                "concreteType": "TownsquareProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isPrivate"
                    },
                    {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "SearchResultAtlasProject"
    };
}();
$0ae82f3cd79894a4$var$node.hash = "e1cfd426806d5804439f761565129f8f";
var $0ae82f3cd79894a4$export$2e2bcd8739ae039 = $0ae82f3cd79894a4$var$node;


parcelRequire("42omo");








parcelRequire("42omo");





var $9Q2dU = parcelRequire("9Q2dU");










const $a5f8781bd2cf4516$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    restrictedTooltip: {
        id: "search-page.results.restricted-result-tooltip",
        defaultMessage: "Only visible to specific people"
    },
    privateTooltip: {
        id: "search-page.results.private-result-tooltip",
        defaultMessage: "Only visible to you"
    }
});


const $df2d84bd02793768$var$defaultIconColor = "var(--ds-icon, #292A2E)";
const $df2d84bd02793768$export$3aad690c5eb10b93 = 'restricted-lozenge';
const $df2d84bd02793768$export$fb0d481c8f77ba99 = ({ permissionLevel: permissionLevel, iconColour: iconColour })=>{
    if (!permissionLevel || permissionLevel === 'public') return null;
    const tooltipText = permissionLevel === 'private' ? (0, $a5f8781bd2cf4516$export$defe85febe8b728c).privateTooltip : (0, $a5f8781bd2cf4516$export$defe85febe8b728c).restrictedTooltip;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...tooltipText
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            testId: $df2d84bd02793768$export$3aad690c5eb10b93,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                label: "",
                color: iconColour ?? $df2d84bd02793768$var$defaultIconColor,
                size: "small"
            })
        })
    });
};





const $bba4b470addb2f7e$export$f20eb787e62d666a = ({ metadata: metadata })=>{
    const data = (0, $irOoi.useFragment)((0, $0ae82f3cd79894a4$export$2e2bcd8739ae039), metadata);
    let statusLozenge = null;
    if (data.project?.state?.label && data.project?.state?.value) statusLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $f2f03c9fb6d1a105$export$689bde3f7e9a94ec), {
        statusValue: data.project.state.value,
        statusLabel: data.project.state.label,
        statusScore: null,
        date: data.project.dueDate?.label
    });
    const titleMetadataParts = [
        [
            'is-private-project',
            data.project?.isPrivate && /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
                permissionLevel: "restricted",
                iconColour: "var(--ds-icon-accent-red, #C9372C)"
            })
        ],
        [
            'status',
            statusLozenge
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
        parts: titleMetadataParts,
        displaySpacer: false
    });
};


const $e69dcf232ee4a7ce$export$a77407ffacf1d445 = ({ node: node, position: position, searchSessionId: searchSessionId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $a8823c5e0fe3b2bf$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const prefix = data.project?.key;
        if (prefix) return (0, $Y34Hw.enrichExcerpt)(prefix.concat('\u2002', data.title));
        return (0, $Y34Hw.enrichExcerpt)(data.title);
    }, [
        data.title,
        data.project?.key
    ]);
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: data.url,
            searchSessionId: searchSessionId
        });
    }, [
        data.url,
        searchSessionId
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: data.type
            })
        ]
    ];
    let icon;
    if ((0, $dh538.fg)('rovo_search_confluence_icons_fps')) icon = (0, $2waBy.getAtlasEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        size: 'medium'
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $aRSt4.ProductIcon), {
        product: (0, $1yEFx.ProductKeys).Atlas,
        label: "Atlas"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Atlas,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $bba4b470addb2f7e$export$f20eb787e62d666a), {
            metadata: data
        }),
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $e69dcf232ee4a7ce$export$eb74eda5abb6ce2f = (node)=>{
    return node?.id?.includes('townsquare') && node?.__typename === 'SearchResultAtlasProject';
};





/**
 * @generated SignedSource<<e490e89f96ff282cde54b4eb507051dc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5e8fd04d68dc4ae1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "description"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchCompassComponent_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "tier"
            },
            {
                "concreteType": "CompassComponent",
                "kind": "LinkedField",
                "name": "component",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "state"
                    }
                ]
            }
        ],
        "type": "SearchResultCompassComponent"
    };
}();
$5e8fd04d68dc4ae1$var$node.hash = "c2a052c4a3d75d6d671dbff5b4efcf18";
var $5e8fd04d68dc4ae1$export$2e2bcd8739ae039 = $5e8fd04d68dc4ae1$var$node;















var $3WVxj = parcelRequire("3WVxj");
























parcelRequire("42omo");




const $fcee77680d43964f$var$stateLozengePropsMap = {
    ACTIVE: {
        appearance: 'success'
    },
    ARCHIVED: {
        appearance: 'neutral'
    },
    PENDING: {
        appearance: 'neutral'
    }
};
const $fcee77680d43964f$export$e21059a573e71ec0 = ({ state: state })=>{
    if (!state) return null;
    const lozengeProps = {
        appearance: 'neutral',
        isBold: true,
        ...state ? $fcee77680d43964f$var$stateLozengePropsMap?.[state] : {}
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        ...lozengeProps,
        children: state
    });
};









var $bOpS4 = parcelRequire("bOpS4");








parcelRequire("42omo");















const $b0cdd31dcea0fac6$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    ownerName: {
        id: "search-page.relay.compass.owner-name",
        defaultMessage: "Owned by {ownerName}"
    }
});


const $7b7252988bd42ac9$export$2e647dc980bb160 = ({ displayName: displayName, isLoading: isLoading = false })=>{
    if (displayName) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $7b7252988bd42ac9$var$owningTeamStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $b0cdd31dcea0fac6$export$defe85febe8b728c).ownerName,
            values: {
                ownerName: displayName
            }
        })
    });
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1hlFx.MetaDataItemSkeletonWide), {});
};
const $7b7252988bd42ac9$var$owningTeamStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px'
});





const $dc82fcf7bf8dd4c4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    tier: {
        id: "search-page.relay.compass.tier",
        defaultMessage: "Tier {tier}"
    }
});


const $e4107ff9b0892e16$export$e206de30029925c0 = ({ node: node, position: position, searchQuery: searchQuery, searchSessionId: searchSessionId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, cloudId: cloudId, compassTeamName: compassTeamName, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $5e8fd04d68dc4ae1$export$2e2bcd8739ae039), node);
    const { id: id, title: title, tier: tier, component: component, lastModifiedDate: lastModifiedDate, type: type, description: description } = data;
    const { state: state, description: componentDescription } = component || {};
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(id);
        return {
            id: id,
            containerId: null,
            spaceId: null,
            contentType: type,
            entityType: type,
            contentId: contentId,
            product: product
        };
    }, [
        id,
        type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
            url: data.url,
            searchSessionId: searchSessionId
        });
    }, [
        data.url,
        searchSessionId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.enrichExcerpt)(title);
    }, [
        title
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        if (description) return (0, $Y34Hw.processExcerpt)(description);
        const reducedDescription = (0, $bOpS4.truncateTextWithQuery)(componentDescription, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        componentDescription,
        description,
        searchQuery
    ]);
    const titleMetadataParts = (0, $42omo.useMemo)(()=>[
            [
                'componentState',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fcee77680d43964f$export$e21059a573e71ec0), {
                    state: state
                })
            ],
            [
                'tier',
                tier ? /*#__PURE__*/ (0, $l998X.jsx)($e4107ff9b0892e16$var$Tier, {
                    tier: tier
                }) : null
            ]
        ], [
        state,
        tier
    ]);
    const headerMetadataParts = (0, $42omo.useMemo)(()=>[
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: type
                })
            ],
            [
                'ownerName',
                compassTeamName || compassTeamName === undefined ? // we need to pass data.ownerName here rather than unconditionally rendering this component
                // as sometimes there is no owner to render, which results in `• •` showing up in the metadata
                /*#__PURE__*/ (0, $l998X.jsx)((0, $7b7252988bd42ac9$export$2e647dc980bb160), {
                    displayName: compassTeamName,
                    isLoading: compassTeamName === undefined
                }) : null
            ],
            [
                'lastModified',
                lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: lastModifiedDate
                }) : null
            ]
        ], [
        type,
        compassTeamName,
        lastModifiedDate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Compass,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        url: url,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.CompassIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        title: enrichedTitle,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts,
            displaySpacer: false
        }),
        headerMetadataParts: headerMetadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $e4107ff9b0892e16$export$3ea06079dfb7d39c = (node)=>{
    return node?.__typename === 'SearchResultCompassComponent';
};
const $e4107ff9b0892e16$var$Tier = ({ tier: tier })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3WVxj.default), {
        text: formatMessage((0, $dc82fcf7bf8dd4c4$export$defe85febe8b728c).tier, {
            tier: tier
        }),
        isRemovable: false,
        migration_fallback: "lozenge"
    });
};





/**
 * @generated SignedSource<<6ea826cda81513dcd504c64abcd426f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e0ddc7b382b65af0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "description"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "subtype"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeIconUrl"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeNavBoostScore"
            },
            {
                "kind": "RootArgument",
                "name": "tenantId"
            }
        ],
        "kind": "Fragment",
        "name": "searchConfluencePageBlogAttachment_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "lastModified"
            },
            {
                "kind": "ScalarField",
                "name": "isVerified"
            },
            {
                "condition": "includeIconUrl",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            },
            {
                "condition": "includeNavBoostScore",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "navBoostScore"
                    }
                ]
            },
            {
                "concreteType": "SearchConfluenceResultSpace",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "webUiLink"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "confluenceEntity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v6 /*: any*/ ,
                            {
                                "concreteType": "ConfluenceCommentCountSummary",
                                "kind": "LinkedField",
                                "name": "commentCountSummary",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "total"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ConfluenceLikesSummary",
                                "kind": "LinkedField",
                                "name": "likesSummary",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "count"
                                    }
                                ]
                            }
                        ],
                        "type": "ConfluencePage"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "tenantId",
                        "variableName": "tenantId"
                    }
                ],
                "concreteType": "SocialSignalSearch",
                "kind": "LinkedField",
                "name": "socialSignal",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "signal"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "timestamp"
                    },
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            },
                            v5 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "picture"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "email"
                                    },
                                    {
                                        "concreteType": "AtlassianAccountUserExtendedProfile",
                                        "kind": "LinkedField",
                                        "name": "extendedProfile",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "jobTitle"
                                            }
                                        ]
                                    }
                                ],
                                "type": "AtlassianAccountUser"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v2 /*: any*/ ,
                    v4 /*: any*/ ,
                    v3 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "lastModifiedDate"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchConfluencePageBlogAttachment"
    };
}();
$e0ddc7b382b65af0$var$node.hash = "8a2e47b7232da07cc9c5817ff662b1e1";
var $e0ddc7b382b65af0$export$2e2bcd8739ae039 = $e0ddc7b382b65af0$var$node;

































var $cVtio = parcelRequire("cVtio");






















var $cOQz3 = parcelRequire("cOQz3");







var $i25hX = parcelRequire("i25hX");

const $719cb442948fe6b0$var$messages = {
    summarize: {
        id: 'search-ai.conversation-starters.summarize',
        defaultMessage: 'Summarize',
        description: 'Button text for AI summarize action'
    },
    showLess: {
        id: 'search-ai.conversation-starters.show-less',
        defaultMessage: 'Show less',
        description: 'Button text for showing less conversation starters'
    },
    showMore: {
        id: 'search-ai.conversation-starters.show-more',
        defaultMessage: 'Show more',
        description: 'Button text for showing more conversation starters'
    }
};
const $719cb442948fe6b0$export$ea338c37011da44c = ({ conversationStarters: conversationStarters, onConversationStarterClick: onConversationStarterClick, url: url })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const [showMore, setShowMore] = (0, $42omo.useState)(false);
    const handleConversationStarterClick = (0, $42omo.useCallback)((starter, index)=>{
        publish({
            type: 'browser-context-payload',
            source: 'search-result',
            data: {
                context: {
                    browserUrl: url
                }
            }
        });
        publish({
            type: 'chat-new',
            source: 'search-result',
            data: {
                name: starter.starter,
                prompt: `${starter.starter} ${url}`,
                dialogues: []
            }
        });
        onConversationStarterClick(starter, index);
    }, [
        publish,
        onConversationStarterClick,
        url
    ]);
    const handleShowMoreClick = (0, $42omo.useCallback)(()=>{
        setShowMore((s)=>!s);
        const analyticsPayload = {
            starter: '',
            // Empty since this isn't a real conversation starter
            [showMore ? 'isShowLess' : 'isShowMore']: true
        };
        onConversationStarterClick(analyticsPayload, -1);
    }, [
        showMore,
        onConversationStarterClick
    ]);
    const summarizeText = formatMessage($719cb442948fe6b0$var$messages.summarize);
    // Create array with summarize button first, then conversation starters
    const allItems = [
        {
            starter: summarizeText,
            isSummarize: true,
            originalIndex: 0
        },
        ...conversationStarters.map((starter, index)=>({
                ...starter,
                isSummarize: false,
                originalIndex: index + 1
            }))
    ];
    const visibleItems = allItems.slice(0, 2);
    const shouldShowExpandButton = allItems.length > 2;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "start",
        shouldWrap: true,
        children: [
            (showMore ? allItems : visibleItems).map((item)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))),
                        onClick: ()=>{
                            const analyticsPayload = {
                                starter: item.starter,
                                isSummarize: item.isSummarize || false
                            };
                            handleConversationStarterClick(analyticsPayload, item.originalIndex);
                        },
                        children: item.starter
                    })
                }, item.starter)),
            shouldShowExpandButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    onClick: handleShowMoreClick,
                    icon: showMore ? (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))),
                    label: showMore ? formatMessage($719cb442948fe6b0$var$messages.showLess) : formatMessage($719cb442948fe6b0$var$messages.showMore)
                })
            })
        ]
    });
};



var $bjsau = parcelRequire("bjsau");


var $4Zqgi = parcelRequire("4Zqgi");

const $5f52e7407c2fd9d2$export$7a0403e8f12fc1bc = (props)=>{
    const { starter: starterText, isSummarize: isSummarize, isShowMore: isShowMore, isShowLess: isShowLess } = props.starter;
    try {
        return {
            action: 'clicked',
            actionSubject: 'aiConvoStarter',
            eventType: 'ui',
            attributes: {
                ...props.analyticsAttributes,
                starterIndex: props.starterIndex,
                isSummarize: isSummarize,
                isShowMore: isShowMore,
                isShowLess: isShowLess
            },
            nonPrivacySafeAttributes: {
                starter: starterText
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onConversationStarterClick'
        });
        return {};
    }
};





const $51849b5bbb5e2f8a$export$b93b2183babcd11e = (props)=>{
    try {
        return {
            action: 'failed',
            actionSubject: 'aiConvoStarters',
            eventType: 'track',
            attributes: {
                ...props.analyticsAttributes,
                error: props.error
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onConvoStartersFailed'
        });
        return {};
    }
};





const $2d57a8e9dd400375$export$d163ffe93667d9e7 = (props)=>{
    try {
        return {
            action: 'shown',
            actionSubject: 'aiConvoStarters',
            eventType: 'track',
            attributes: {
                ...props.analyticsAttributes,
                startersCount: props.starters.length
            },
            nonPrivacySafeAttributes: {
                starters: props.starters
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onConvoStarterShown'
        });
        return {};
    }
};


const $383edc9b6c74463d$var$getConversationStarters = async ({ ari: ari, product: product, cloudId: cloudId })=>{
    const requestBody = {
        ai_feature_input: {
            documents: [
                {
                    ari: ari
                }
            ]
        }
    };
    const response = await fetch('/gateway/api/assist/api/ai/v2/ai-feature/convo-starters', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Experience-Id': 'convo-starter-for-search',
            'X-Product': product,
            'X-Cloudid': cloudId
        },
        body: JSON.stringify(requestBody)
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    return await response.json();
};
const $383edc9b6c74463d$export$89b2b22a9acd6d75 = ({ primaryProduct: primaryProduct, cloudId: cloudId, searchResult: searchResult, analyticsAttributes: analyticsAttributes })=>{
    const [{ conversationStarters: conversationStarters, loading: loading }, setConversationStarters] = (0, $42omo.useState)(()=>{
        return {
            conversationStarters: [],
            loading: false
        };
    });
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const memoizedAnalyticsAttributes = (0, $42omo.useMemo)(()=>analyticsAttributes, [
        analyticsAttributes
    ]);
    const handleConversationStarterClick = (0, $42omo.useCallback)((starter, index)=>{
        fireAnalyticsEvent((0, $5f52e7407c2fd9d2$export$7a0403e8f12fc1bc)({
            starter: starter,
            analyticsAttributes: memoizedAnalyticsAttributes,
            starterIndex: index
        }));
    }, [
        fireAnalyticsEvent,
        memoizedAnalyticsAttributes
    ]);
    const handleConversationStartersShown = (0, $42omo.useCallback)((starters)=>{
        const startersWithSummarize = [
            'Summarize',
            ...starters
        ];
        fireAnalyticsEvent((0, $2d57a8e9dd400375$export$d163ffe93667d9e7)({
            starters: startersWithSummarize,
            analyticsAttributes: memoizedAnalyticsAttributes
        }));
    }, [
        fireAnalyticsEvent,
        memoizedAnalyticsAttributes
    ]);
    const handleConversationStartersFailed = (0, $42omo.useCallback)((error)=>{
        fireAnalyticsEvent((0, $51849b5bbb5e2f8a$export$b93b2183babcd11e)({
            analyticsAttributes: memoizedAnalyticsAttributes,
            error: error.message
        }));
    }, [
        fireAnalyticsEvent,
        memoizedAnalyticsAttributes
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!searchResult?.ari || conversationStarters.length > 0 || loading) return;
        setConversationStarters((prevState)=>({
                ...prevState,
                loading: true
            }));
        $383edc9b6c74463d$var$getConversationStarters({
            ari: searchResult.ari,
            product: primaryProduct ?? '',
            cloudId: cloudId ?? ''
        }).then((response)=>{
            setConversationStarters({
                conversationStarters: response.ai_feature_output?.results[0]?.convo_starters || [],
                loading: false
            });
            handleConversationStartersShown(response.ai_feature_output?.results[0]?.convo_starters.map((starter)=>starter.starter) || []);
        }).catch((error)=>{
            setConversationStarters({
                conversationStarters: [],
                loading: false
            });
            handleConversationStartersFailed(error);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $719cb442948fe6b0$export$ea338c37011da44c), {
            conversationStarters: conversationStarters || [],
            onConversationStarterClick: handleConversationStarterClick,
            url: searchResult.url
        })
    });
};
const $383edc9b6c74463d$export$10e76ebde8d3ea11 = ({ primaryProduct: primaryProduct, cloudId: cloudId, searchResult: searchResult, analyticsAttributes: analyticsAttributes })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    if (!(0, $bjsau.isEnglishLocale)(locale)) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($383edc9b6c74463d$export$89b2b22a9acd6d75, {
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        searchResult: searchResult,
        analyticsAttributes: analyticsAttributes
    });
};



var $eUEtI = parcelRequire("eUEtI");




parcelRequire("42omo");


var $2Rith = parcelRequire("2Rith");


var $f7lNm = parcelRequire("f7lNm");

/* ConfluenceResultCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















var $fYQcF = parcelRequire("fYQcF");


var $eMz0l = parcelRequire("eMz0l");


var $4xTru = parcelRequire("4xTru");


var $elfKF = parcelRequire("elfKF");


var $eaSIT = parcelRequire("eaSIT");


var $4jIuc = parcelRequire("4jIuc");








var $kkJIR = parcelRequire("kkJIR");


var $ka0Y0 = parcelRequire("ka0Y0");



var $9lp28 = parcelRequire("9lp28");


var $kF5LJ = parcelRequire("kF5LJ");








var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");




const $761cfb03749ba18a$export$e67cfd67e64df0f4 = 'KnowledgeDiscoveryConfluencePageContributorsQuery';
const $761cfb03749ba18a$export$2603e533e340cb6b = `
query KnowledgeDiscoveryConfluencePageContributorsQuery($id: ID!) {
  contributorsLinkedToConfluencePageV2(pageId: $id) {
    queryResult {
      rows {
        __typename
        rowItems {
          key
          value {
            id
            data {
              __typename
              ... on AtlassianAccountUser {
                __typename
                name
                picture
                accountId
                canonicalAccountId
              }
            }
          }
        }
      }
    }
  }
}
`;


const $faf08354a609221e$export$200e3b64ac0020f0 = async ({ id: id, workspaceId: workspaceId, cloudId: cloudId, product: product })=>{
    try {
        const contributors = [];
        const { data: data, errors: errors } = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $761cfb03749ba18a$export$2603e533e340cb6b),
            variables: {
                id: id
            },
            operationName: (0, $761cfb03749ba18a$export$e67cfd67e64df0f4),
            headers: {
                ...(0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                }),
                'X-Query-Context': workspaceId
            }
        });
        if (errors) {
            (0, $4Zqgi.logger).error({
                error: errors[0],
                functionName: 'getConfluenceContributors'
            });
            return null;
        }
        data?.contributorsLinkedToConfluencePageV2.queryResult.rows.forEach((row)=>{
            row.rowItems.forEach((item, index)=>{
                const type = row.rowItems[index].key;
                if (item.value && item.value.length > 0 && (type === 'creator' || type === 'owner' || type === 'editor' || type === 'commentor' || type === 'tagged')) item.value.forEach((contributor)=>{
                    contributors.push({
                        ...contributor,
                        type: type
                    });
                });
            });
        });
        return contributors;
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'getConfluenceContributors'
        });
        return null;
    }
};











const $ea64f11ff5214fe6$export$84a5087b650d8963 = 'KnowledgeDiscoveryConfluencePageOutgoingLinksQuery';
const $ea64f11ff5214fe6$export$f0f6c9d061558c7c = `
query KnowledgeDiscoveryConfluencePageOutgoingLinksQuery($id: ID!) {
  linksOutgoingFromConfluencePage(pageId: $id) {
    queryResult {
      rows {
        __typename
        rowItems {
          key
          value {
            id
            data {
              __typename
              ... on ConfluencePage {
                __typename
                id
                title
                latestVersion {
                  createdAt
                }
                links {
                  base
                  webUi
                }
                author {
                  user {
                    name
                    picture
                    canonicalAccountId
                  }
                }
              }
              ... on JiraIssue {
                __typename
                id
                summary
                issueTypeAvatarUrl
                updatedField {
                  dateTime
                }
                reporter {
                  name
                  picture
                  canonicalAccountId
                }
                webUrl
              }
            }
          }
        }
      }
    }
  }
}
`;


const $6edc5dd1f640e937$export$a65921bf7e72ea90 = (item)=>{
    const itemData = item.value[0].data;
    if (!itemData) return undefined;
    else if (itemData.__typename === 'ConfluencePage') return Boolean(itemData.links?.base) && Boolean(itemData.links?.webUi) ? `${itemData.links.base}${itemData.links.webUi}` : undefined;
    else if (itemData.__typename === 'JiraIssue') return itemData.webUrl;
};


const $57cda4ad3af70dd3$export$9375c293fc837eed = async ({ id: id, workspaceId: workspaceId, cloudId: cloudId, product: product })=>{
    try {
        const urls = [];
        const { data: data, errors: errors } = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $ea64f11ff5214fe6$export$f0f6c9d061558c7c),
            variables: {
                id: id
            },
            operationName: (0, $ea64f11ff5214fe6$export$84a5087b650d8963),
            headers: {
                ...(0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                }),
                'X-Query-Context': workspaceId
            }
        });
        if (errors) {
            (0, $4Zqgi.logger).error({
                error: errors[0],
                functionName: 'getConfluenceOutgoingLinks'
            });
            return null;
        }
        data?.linksOutgoingFromConfluencePage.queryResult.rows.forEach((row)=>{
            row.rowItems.forEach((item)=>{
                const link = (0, $6edc5dd1f640e937$export$a65921bf7e72ea90)(item);
                if (link) urls.push(link);
            });
        });
        return urls;
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'getConfluenceOutgoingLinks'
        });
        return null;
    }
};


const $7af60c4a5978bce8$export$6ed38de17ee0fdc9 = ({ workspaceId: workspaceId, cloudId: cloudId, product: product, contentId: contentId })=>{
    const [loading, setIsLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(false);
    const [contributors, setContributors] = (0, $42omo.useState)([]);
    const [outgoingLinks, setOutgoingLinks] = (0, $42omo.useState)([]);
    (0, $42omo.useEffect)(()=>{
        const getLinkedResults = async ()=>{
            await Promise.allSettled([
                (0, $faf08354a609221e$export$200e3b64ac0020f0)({
                    id: contentId,
                    workspaceId: workspaceId,
                    cloudId: cloudId,
                    product: product
                }),
                (0, $57cda4ad3af70dd3$export$9375c293fc837eed)({
                    id: contentId,
                    workspaceId: workspaceId,
                    cloudId: cloudId,
                    product: product
                })
            ]).then(([contributorsResult, outgoingLinksResult])=>{
                setContributors(contributorsResult.status === 'fulfilled' ? contributorsResult.value || [] : []);
                setOutgoingLinks(outgoingLinksResult.status === 'fulfilled' ? outgoingLinksResult.value || [] : []);
                if (contributorsResult.status === 'rejected' && outgoingLinksResult.status === 'rejected') {
                    (0, $4Zqgi.logger).error({
                        error: contributorsResult.reason || outgoingLinksResult.reason || new Error('Failed to fetch contributors and outgoing links'),
                        functionName: 'useTwgSources'
                    });
                    setError(true);
                }
            }).catch((error)=>{
                (0, $4Zqgi.logger).error({
                    error: error,
                    functionName: 'useTwgSources'
                });
                setError(true);
            }).finally(()=>{
                setIsLoading(false);
            });
        };
        if (Boolean(contentId)) {
            setIsLoading(true);
            getLinkedResults();
        }
    }, [
        cloudId,
        contentId,
        workspaceId,
        product
    ]);
    return {
        loading: loading,
        error: error,
        contributors: contributors,
        outgoingLinks: outgoingLinks
    };
};


/* AdditionInfoSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 



















const $872baa6c44f00b3c$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    sources_icon_stack_text: {
        id: "search_ai.sources_icon_stack_text",
        defaultMessage: "+{count} more"
    },
    contributors_avatar_stack_text: {
        id: "search_ai.contributors_avatar_stack_text",
        defaultMessage: "+{count} more"
    },
    related_links_title: {
        id: "search_ai.related_links_title",
        defaultMessage: "Related Links"
    },
    contributors_title: {
        id: "search_ai.contributors_title",
        defaultMessage: "Collaborators"
    },
    contributors_card_subtitle: {
        id: "search_ai.contributors_card_subtitle",
        defaultMessage: "{type, select, tagged {tagged on this page} other {{type} of this page}}"
    },
    show_less_button_label: {
        id: "search_ai.show_less_button_label",
        defaultMessage: "Show less"
    },
    page_icon_label: {
        id: "search_ai.page_icon_label",
        defaultMessage: "Page Icon"
    },
    globe_icon_label: {
        id: "search_ai.globe_icon_label",
        defaultMessage: "Globe Icon"
    },
    confluence_product_name: {
        id: "search_ai.confluence_product_name",
        defaultMessage: "Confluence"
    },
    webpage_label: {
        id: "search_ai.webpage_label",
        defaultMessage: "Web page"
    },
    contributors_card_hover_profile_link: {
        id: "search_ai.contributors_card_hover_profile_link",
        defaultMessage: "View profile"
    },
    fallback_description: {
        id: "search_ai.confluence_flex_card_fallback_description",
        defaultMessage: "...{fallbackDescription}..."
    }
});


/* Contributors.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");















/* ContributorAvatarStack.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $2Pg7f = parcelRequire("2Pg7f");














const $dbb5a6cff0b3b351$var$DEFAULT_MAX_CONTRIBUTORS_IN_STACK = 3;
const $dbb5a6cff0b3b351$var$styles = {
    pressable: "_bfhk1j28",
    avatarGroup: "_t9ec18p1"
};
const $dbb5a6cff0b3b351$export$68ba394a09a9d437 = ({ contributors: contributors, onClick: onClick, isLoading: isLoading, singleColumnLayout: singleColumnLayout = false })=>{
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
        height: "20px",
        width: "100px",
        isShimmering: true,
        testId: "contributors-avatar-stack-skeleton"
    });
    const maxContributors = $dbb5a6cff0b3b351$var$DEFAULT_MAX_CONTRIBUTORS_IN_STACK; // Transform to avatar group data format
    const avatarData = contributors.map((contributor, index)=>({
            key: contributor.data.accountId,
            name: contributor.data.name,
            src: contributor.data.picture,
            appearance: 'circle',
            testId: `contributor-avatar-${index}`
        }));
    const remainingContributorsInStack = singleColumnLayout ? avatarData.slice(1, 3) : avatarData.slice(3, 6);
    const remainingContributorsCount = singleColumnLayout ? avatarData.slice(1).length : avatarData.slice(3).length;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: onClick,
        xcss: $dbb5a6cff0b3b351$var$styles.pressable,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.0",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $dbb5a6cff0b3b351$var$styles.avatarGroup,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Pg7f.default), {
                        appearance: "stack",
                        data: remainingContributorsInStack,
                        size: "small",
                        maxCount: maxContributors,
                        isTooltipDisabled: true,
                        testId: "contributors-avatargroup"
                    })
                }),
                remainingContributorsInStack.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtle",
                    testId: "contributors-avatar-stack-remaining-count",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $872baa6c44f00b3c$export$defe85febe8b728c).contributors_avatar_stack_text,
                        values: {
                            count: remainingContributorsCount
                        }
                    })
                })
            ]
        })
    });
};


/* ContributorCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 























var $8j9VY = parcelRequire("8j9VY");


var $d6uGK = parcelRequire("d6uGK");


var $2j8w0 = parcelRequire("2j8w0");


var $ckCUa = parcelRequire("ckCUa");


var $6aPlH = parcelRequire("6aPlH");


const $a568b3c1722569fb$var$styles = {
    pressable: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _bfhksm61",
    contributorCard: "_4t3i1ylp",
    contributorCardContent: "_y3gn1e5h",
    contributorsCardSubtitle: "_299m1dk0"
};
const $a568b3c1722569fb$export$3f45fa6d1e6fb5fe = ({ contributor: contributor, cloudId: cloudId, onContributorClick: onContributorClick })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { toUser: toUser } = (0, $6aPlH.useTeamsAppLinks)({
        type: (0, $ckCUa.KnowledgeCardsIntentType).PERSON,
        currentUserId: contributor.data.accountId || '',
        cloudId: cloudId
    });
    const profileClient = (0, $42omo.useMemo)(()=>(0, $d6uGK.createProfileClient)(cloudId), [
        cloudId
    ]);
    const onContributorClickHandler = (e)=>{
        onContributorClick('collaborator-link');
        toUser(contributor.data.accountId || '').onNavigate(e);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8j9VY.default), {
        userId: (0, $2j8w0.trimARI)(contributor.data.accountId || ''),
        resourceClient: profileClient,
        actions: [
            {
                label: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).contributors_card_hover_profile_link),
                link: toUser(contributor.data.accountId || '').href,
                callback: onContributorClickHandler
            }
        ],
        ariaLabel: contributor.data.name,
        position: "bottom-end",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            onClick: onContributorClickHandler,
            xcss: $a568b3c1722569fb$var$styles.pressable,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.100",
                xcss: $a568b3c1722569fb$var$styles.contributorCard,
                testId: "contributor-card",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                        size: "small",
                        name: contributor.data.name,
                        src: contributor.data.picture
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        xcss: $a568b3c1722569fb$var$styles.contributorCardContent,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text",
                                maxLines: 1,
                                children: contributor.data.name
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $a568b3c1722569fb$var$styles.contributorsCardSubtitle,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...(0, $872baa6c44f00b3c$export$defe85febe8b728c).contributors_card_subtitle,
                                        values: {
                                            type: contributor.type
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};


const $191637e8e278d6c0$var$DEFAULT_CONTRIBUTORS_TO_DISPLAY_WHEN_COLLAPSED = 3;
const $191637e8e278d6c0$var$MAX_CONTRIBUTORS_TO_DISPLAY = 15;
const $191637e8e278d6c0$var$styles = {
    contributorsTitleContainer: "_otyr1b66",
    singleColumnLayout: "_yv0ehkll",
    multiColumnLayout: "_yv0e16hb"
};
const $191637e8e278d6c0$export$5360f064464e9211 = ({ contributors: contributors, cloudId: cloudId, isExpanded: isExpanded, onExpandToggle: onExpandToggle, onContributorClick: onContributorClick, singleColumnLayout: singleColumnLayout = false })=>{
    const truncatedContributors = contributors.slice(0, $191637e8e278d6c0$var$MAX_CONTRIBUTORS_TO_DISPLAY);
    const contributorsToDisplayWhenCollapsed = singleColumnLayout ? 1 : $191637e8e278d6c0$var$DEFAULT_CONTRIBUTORS_TO_DISPLAY_WHEN_COLLAPSED;
    const contributorsToDisplay = isExpanded ? truncatedContributors : truncatedContributors.slice(0, contributorsToDisplayWhenCollapsed);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                spread: "space-between",
                alignBlock: "center",
                xcss: $191637e8e278d6c0$var$styles.contributorsTitleContainer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtle",
                        weight: "medium",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $872baa6c44f00b3c$export$defe85febe8b728c).contributors_title
                        })
                    }),
                    truncatedContributors.length > contributorsToDisplayWhenCollapsed && /*#__PURE__*/ (0, $l998X.jsx)((0, $dbb5a6cff0b3b351$export$68ba394a09a9d437), {
                        contributors: truncatedContributors,
                        onClick: onExpandToggle,
                        singleColumnLayout: singleColumnLayout
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
                rowGap: "space.200",
                columnGap: "space.400",
                xcss: (0, $1Whri.cx)(singleColumnLayout ? $191637e8e278d6c0$var$styles.singleColumnLayout : $191637e8e278d6c0$var$styles.multiColumnLayout),
                children: contributorsToDisplay?.map((contributor)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $a568b3c1722569fb$export$3f45fa6d1e6fb5fe), {
                        contributor: contributor,
                        cloudId: cloudId,
                        onContributorClick: onContributorClick
                    }, contributor.data.accountId))
            })
        ]
    });
};


/* RelatedLinks.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");















/* LinkCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $buthI = parcelRequire("buthI");























const $93ce23c5e9bc03a8$var$styles = {
    link: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz13af _105313af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnx8stv _jf4cnqa1 _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h12zz",
    iconContainer: "_ca0qv77o"
};
const $93ce23c5e9bc03a8$var$FallbackComponent = ({ url: url, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: url,
        target: "_blank",
        xcss: $93ce23c5e9bc03a8$var$styles.link,
        onClick: (e)=>onClick({
                event: e,
                resourceUrl: url,
                location: 'related-link'
            }),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "start",
            space: "space.100",
            alignInline: "start",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $93ce23c5e9bc03a8$var$styles.iconContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
                        label: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).globe_icon_label),
                        size: "medium"
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "medium",
                            maxLines: 1,
                            color: "color.link",
                            children: url
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            maxLines: 1,
                            color: "color.text.subtle",
                            children: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).webpage_label)
                        })
                    ]
                })
            ]
        })
    });
};
const $93ce23c5e9bc03a8$export$2c381a86421d5abf = ({ url: url, onClick: onClick })=>{
    const [isReady, setIsReady] = (0, $42omo.useState)(false);
    const [forceFallback, setForceFallback] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    transition: 'visibility 0.3s ease-in-out, opacity 0.3s ease-in-out',
                    visibility: isReady ? 'hidden' : 'visible',
                    opacity: isReady ? 0 : 1,
                    pointerEvents: isReady ? 'none' : 'auto',
                    height: isReady ? 0 : 'auto',
                    width: isReady ? 0 : '100%'
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    height: 32,
                    width: 200,
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    transition: 'visibility 0.3s ease-in-out, opacity 0.3s ease-in-out',
                    visibility: isReady ? 'visible' : 'hidden',
                    opacity: isReady ? 1 : 0,
                    pointerEvents: isReady ? 'auto' : 'none',
                    height: isReady ? 'auto' : 0,
                    width: isReady ? '100%' : 0
                },
                children: forceFallback ? /*#__PURE__*/ (0, $l998X.jsx)($93ce23c5e9bc03a8$var$FallbackComponent, {
                    url: url,
                    onClick: onClick
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $hpUsb.Card), {
                    url: url,
                    ui: {
                        removeBlockRestriction: true,
                        hidePadding: true,
                        hideElevation: true,
                        hideBackground: true
                    },
                    appearance: "block",
                    onClick: (e)=>{
                        onClick({
                            event: e,
                            resourceUrl: url,
                            location: 'related-link'
                        });
                    },
                    onResolve: ()=>setIsReady(true),
                    onError: ()=>{
                        setForceFallback(true);
                        setIsReady(true);
                    },
                    fallbackComponent: ()=>/*#__PURE__*/ (0, $l998X.jsx)($93ce23c5e9bc03a8$var$FallbackComponent, {
                            url: url,
                            onClick: onClick
                        }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                        size: (0, $5TXU5.SmartLinkSize).Medium,
                        subtitle: [
                            {
                                name: (0, $5TXU5.ElementName).ModifiedOn
                            }
                        ],
                        maxLines: 1
                    })
                })
            })
        ]
    });
};


/* LinkIconStack.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


















var $JBlXx = parcelRequire("JBlXx");


var $ehPkL = parcelRequire("ehPkL");


var $dN2lk = parcelRequire("dN2lk");


const $3d12974a4e287534$var$DEFAULT_MAX_SOURCES_IN_STACK = 3;
const $3d12974a4e287534$var$styles = {
    pressable: "_bfhk1j28"
};
const $3d12974a4e287534$export$c1e33b78dff82c3c = ({ sources: sources, onClick: onClick, maxSourcesInStack: maxSourcesInStack, singleColumnLayout: singleColumnLayout = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { objectResolverData: resolvedLinks, isLoading: objectResolverLoading } = (0, $JBlXx.useFetchSmartLinkData)({
        urls: sources
    });
    const sourcesForIconStack = [];
    const sourceNamesMap = {};
    maxSourcesInStack = maxSourcesInStack ?? $3d12974a4e287534$var$DEFAULT_MAX_SOURCES_IN_STACK;
    for(let i = 0; i < resolvedLinks.length; i++){
        const source = resolvedLinks[i];
        if (source.generator?.name && !sourceNamesMap[source.generator?.name]) {
            sourcesForIconStack.push(source.generator.name);
            sourceNamesMap[source.generator.name] = true;
        }
        if (sourcesForIconStack.length === maxSourcesInStack) break;
    }
    const remainingSourcesCount = singleColumnLayout ? sources.slice(1).length : sources.slice(2).length;
    if (objectResolverLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
        height: "20px",
        width: "100px",
        isShimmering: true,
        testId: "contributors-avatar-stack-skeleton"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: onClick,
        xcss: $3d12974a4e287534$var$styles.pressable,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dN2lk.IconStack), {
                    children: sourcesForIconStack.map((source, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ehPkL.AppIcon), {
                            app: source,
                            size: "xxsmall",
                            fallbackIcon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
                                label: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).globe_icon_label),
                                size: "medium"
                            })
                        }, index))
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtle",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $872baa6c44f00b3c$export$defe85febe8b728c).sources_icon_stack_text,
                        values: {
                            count: remainingSourcesCount
                        }
                    })
                })
            ]
        })
    });
};


const $96012d3f013bc30d$var$DEFAULT_LINKS_TO_DISPLAY_WHEN_COLLAPSED = 2;
const $96012d3f013bc30d$var$MAX_LINKS_TO_DISPLAY = 10;
const $96012d3f013bc30d$var$styles = {
    relatedLinksGrid: "_19pk1b66",
    singleColumnLayout: "_yv0ehkll",
    dualColumnLayout: "_yv0ewxkt",
    relatedLinksTitle: "_4t3i1ul9"
};
const $96012d3f013bc30d$export$a7ff6651352b415b = ({ links: links, isExpanded: isExpanded, onExpandToggle: onExpandToggle, onResourceClick: onResourceClick, singleColumnLayout: singleColumnLayout = false })=>{
    const linksToDisplayWhenCollapsed = singleColumnLayout ? 1 : $96012d3f013bc30d$var$DEFAULT_LINKS_TO_DISPLAY_WHEN_COLLAPSED;
    const truncatedLinks = links.slice(0, $96012d3f013bc30d$var$MAX_LINKS_TO_DISPLAY);
    const linksToDisplay = isExpanded ? truncatedLinks : truncatedLinks.slice(0, linksToDisplayWhenCollapsed);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                spread: "space-between",
                alignBlock: "center",
                xcss: $96012d3f013bc30d$var$styles.relatedLinksTitle,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtle",
                        weight: "medium",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $872baa6c44f00b3c$export$defe85febe8b728c).related_links_title
                        })
                    }),
                    links.length > linksToDisplayWhenCollapsed && /*#__PURE__*/ (0, $l998X.jsx)((0, $3d12974a4e287534$export$c1e33b78dff82c3c), {
                        sources: truncatedLinks,
                        onClick: onExpandToggle,
                        singleColumnLayout: singleColumnLayout
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
                rowGap: "space.200",
                columnGap: "space.400",
                xcss: (0, $1Whri.cx)($96012d3f013bc30d$var$styles.relatedLinksGrid, singleColumnLayout ? $96012d3f013bc30d$var$styles.singleColumnLayout : $96012d3f013bc30d$var$styles.dualColumnLayout),
                children: linksToDisplay.map((link, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $93ce23c5e9bc03a8$export$2c381a86421d5abf), {
                        url: link,
                        onClick: onResourceClick
                    }, index))
            })
        ]
    });
};


const $c2ee2b5f73ff8eda$var$styles = {
    showLessButtonContainer: "_1e0c1txw _4cvr1h6o _1bah1h6o",
    dualColumnLayout: "_yv0ewxkt"
};
const $c2ee2b5f73ff8eda$export$62500b33cee05471 = ({ links: links, contributors: contributors, cloudId: cloudId, onResourceClick: onResourceClick, onContributorClick: onContributorClick, onExpandClicked: onExpandClicked })=>{
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    let layout = 'single-column';
    const handleExpandToggle = ()=>{
        if (!isExpanded) onExpandClicked(layout);
        setIsExpanded(!isExpanded);
    };
    if (links.length === 0 && contributors.length === 0) return null;
     // we need to decide the layout based on the number of items
    // if we have lesser that 5 links and contributors each, we need to show them in a dual column
    // if we have only one of them, we need to show them in a single column
    // if we have more than 5 links or contributors, we need to show them in a single column
    // of the above: we show links first and then contributors if there are no links
    if (links.length > 0 && links.length <= 5 && contributors.length > 0 && contributors.length <= 5) layout = 'dual-column';
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            layout === 'dual-column' ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                columnGap: "space.400",
                xcss: $c2ee2b5f73ff8eda$var$styles.dualColumnLayout,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $96012d3f013bc30d$export$a7ff6651352b415b), {
                            links: links,
                            singleColumnLayout: true,
                            isExpanded: isExpanded,
                            onExpandToggle: handleExpandToggle,
                            onResourceClick: onResourceClick
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $191637e8e278d6c0$export$5360f064464e9211), {
                            singleColumnLayout: true,
                            contributors: contributors,
                            cloudId: cloudId,
                            isExpanded: isExpanded,
                            onExpandToggle: handleExpandToggle,
                            onContributorClick: onContributorClick
                        })
                    })
                ]
            }) : links.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $96012d3f013bc30d$export$a7ff6651352b415b), {
                links: links,
                isExpanded: isExpanded,
                onExpandToggle: handleExpandToggle,
                onResourceClick: onResourceClick
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $191637e8e278d6c0$export$5360f064464e9211), {
                contributors: contributors,
                isExpanded: isExpanded,
                onContributorClick: onContributorClick,
                onExpandToggle: handleExpandToggle,
                cloudId: cloudId
            }),
            isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $c2ee2b5f73ff8eda$var$styles.showLessButtonContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    appearance: "subtle",
                    onClick: ()=>setIsExpanded(false),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $872baa6c44f00b3c$export$defe85febe8b728c).show_less_button_label
                    })
                })
            })
        ]
    });
};


const $b4536d1ff2577c9e$export$16bf99dc0596865c = (contributors)=>{
    if (contributors.length === 0) return [];
    const seen = new Set();
    const uniqueContributors = [];
    for (const contributor of contributors)if (!seen.has(contributor.id)) {
        uniqueContributors.push(contributor);
        seen.add(contributor.id);
    }
    return uniqueContributors;
};


/* ConfluenceFlexibleSmartCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $7642E = parcelRequire("7642E");


var $8jHAi = parcelRequire("8jHAi");


var $9RVmI = parcelRequire("9RVmI");


















var $1lLfV = parcelRequire("1lLfV");




var $1HJbl = parcelRequire("1HJbl");













const $34a8fe3a8e97a3b4$export$e6e3b13f99e77224 = 'KnowledgeDiscoveryAiSnippetQuery';
const $34a8fe3a8e97a3b4$export$1c9bc8dcd3da6ba1 = `
query KnowledgeDiscoveryAiSnippetQuery($cloudId: ID!, $id: ID!) {
  singleContent(cloudId: $cloudId, id: $id) {
    aiProperty(objectType: snippet_v2) {
      objectData
    }
  }
}
`;


const $4754ffae30f7064c$var$fetchConfluenceAiSnippet = async ({ variables: variables, workspaceId: workspaceId, product: product })=>{
    return (0, $9EFEY.fetchAggResponse)({
        variables: variables,
        graphQuery: (0, $34a8fe3a8e97a3b4$export$1c9bc8dcd3da6ba1),
        operationName: (0, $34a8fe3a8e97a3b4$export$e6e3b13f99e77224),
        headers: (0, $6yuru.createAtlAttributionHeader)({
            atlWorkspaceId: workspaceId,
            tenantId: variables.cloudId,
            product: product
        })
    }).then((response)=>response.data).catch((error)=>{
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'useConfluenceAiSnippet'
        });
        // rethrow error to be handled by the caller
        throw error;
    });
};
const $4754ffae30f7064c$export$c1ef9bcd7a0f276c = ({ cloudId: cloudId, id: id, workspaceId: workspaceId, product: product })=>{
    const [loading, setIsLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(false);
    const [aiSnippet, setAiSnippet] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                setIsLoading(true);
                const data = await $4754ffae30f7064c$var$fetchConfluenceAiSnippet({
                    variables: {
                        cloudId: cloudId,
                        id: id
                    },
                    workspaceId: workspaceId,
                    product: product
                });
                setAiSnippet(data?.singleContent?.aiProperty?.objectData || '');
            } catch (e) {
                (0, $4Zqgi.logger).error({
                    error: e,
                    functionName: 'useConfluenceAiSnippet'
                });
                setError(true);
            } finally{
                setIsLoading(false);
            }
        };
        if (id && cloudId && workspaceId && product) fetchData();
    }, [
        cloudId,
        id,
        workspaceId,
        product
    ]);
    return {
        aiSnippet: aiSnippet,
        loading: loading,
        error: error
    };
};



const $7f560cb8e964d6f3$var$unboundedStyles = {
    titleBlock: "_1r031e3o",
    metadataContainer: "_1v57z0dk _17bh1b66 _13ehz0dk _1fx71b66"
};
const $7f560cb8e964d6f3$var$styles = {
    titleBlock: "_1bsb1osq",
    titleIconContainer: "_1e0c1txw _1wpz1y6m _ca0qu2gc",
    metadataContainer: "_19pkr5cr",
    productNameContainer: "_1e0c1txw _4cvr1q9y",
    snippetContainer: "_19pk1b66"
}; // using vanilla css because primitives don't allow assinging 'color.border' to color which linking platform uses as a separator for metadata
const $7f560cb8e964d6f3$var$separatorStyle = {
    display: 'inline',
    color: "var(--ds-border, #0B120E24)",
    paddingLeft: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-050, 4px)",
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $7f560cb8e964d6f3$var$ConfluenceFlexibleSmartCardUnmemoized = ({ url: url, cloudId: cloudId, contentId: contentId, contentType: contentType, description: description, areLLMPoweredFeaturesEnabled: areLLMPoweredFeaturesEnabled, onLoad: onLoad, onClick: onClick, onActionButtonClicked: onActionButtonClicked, searchPageAnalyticsCallbacks: searchPageAnalyticsCallbacks, workspaceId: workspaceId, product: product })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isReady, setIsReady] = (0, $42omo.useState)(false);
    const { aiSnippet: aiSnippet, loading: aiSnippetLoading, error: aiSnippetError } = (0, $4754ffae30f7064c$export$c1ef9bcd7a0f276c)({
        cloudId: cloudId,
        id: contentId,
        workspaceId: workspaceId,
        product: product
    });
    const fallbackContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        maxLines: 2,
        testId: "fallback-description",
        children: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).fallback_description, {
            fallbackDescription: (0, $1HJbl.cleanExcerpt)(description).trim()
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    transition: 'visibility 0.3s ease-in-out, opacity 0.3s ease-in-out',
                    visibility: isReady ? 'hidden' : 'visible',
                    opacity: isReady ? 0 : 1,
                    pointerEvents: isReady ? 'none' : 'auto',
                    height: isReady ? 0 : 'auto',
                    width: isReady ? 0 : '100%'
                },
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            space: "space.150",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $7f560cb8e964d6f3$var$styles.titleIconContainer,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                        height: 32,
                                        width: 32,
                                        isShimmering: true,
                                        testId: "skeleton"
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                    xcss: $7f560cb8e964d6f3$var$styles.titleBlock,
                                    space: "space.100",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                            height: 32,
                                            width: 200,
                                            isShimmering: true,
                                            testId: "skeleton"
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                            height: 20,
                                            width: 200,
                                            isShimmering: true,
                                            testId: "skeleton"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                height: 20,
                                width: "100%",
                                isShimmering: true,
                                testId: "skeleton"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    transition: 'visibility 0.3s ease-in-out, opacity 0.3s ease-in-out',
                    visibility: isReady ? 'visible' : 'hidden',
                    opacity: isReady ? 1 : 0,
                    pointerEvents: isReady ? 'auto' : 'none',
                    height: isReady ? 'auto' : 0,
                    width: isReady ? '100%' : 0
                },
                onContextMenu: searchPageAnalyticsCallbacks.onResultContextMenu,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $hpUsb.Card), {
                    url: url,
                    ui: {
                        removeBlockRestriction: true,
                        hidePadding: true,
                        hideElevation: true,
                        hideBackground: true,
                        clickableContainer: true
                    },
                    appearance: "block",
                    onClick: (e)=>{
                        onClick({
                            event: e,
                            resourceUrl: url,
                            location: 'page-link'
                        });
                        searchPageAnalyticsCallbacks.onResultClicked();
                    },
                    onResolve: ()=>{
                        setIsReady(true);
                        onLoad();
                    },
                    onError: ()=>setIsReady(true),
                    testId: "smart-card",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            space: "space.150",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $7f560cb8e964d6f3$var$styles.titleIconContainer,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7642E.IconTile), {
                                        icon: contentType === 'blogpost' ? (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))) : (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
                                        label: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).page_icon_label),
                                        appearance: "blue",
                                        size: "medium"
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                    xcss: (0, $1Whri.cx)($7f560cb8e964d6f3$var$styles.titleBlock, $7f560cb8e964d6f3$var$unboundedStyles.titleBlock),
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                                            hideIcon: true,
                                            actions: [
                                                {
                                                    name: (0, $5TXU5.ActionName).CopyLinkAction,
                                                    onClick: ()=>{
                                                        onActionButtonClicked((0, $5TXU5.ActionName).CopyLinkAction);
                                                        searchPageAnalyticsCallbacks.onCopyLinkButtonClicked();
                                                    },
                                                    hideContent: true
                                                },
                                                {
                                                    name: (0, $5TXU5.ActionName).PreviewAction,
                                                    onClick: ()=>onActionButtonClicked((0, $5TXU5.ActionName).PreviewAction),
                                                    hideContent: true
                                                }
                                            ],
                                            maxLines: 1
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            alignBlock: "baseline",
                                            xcss: (0, $1Whri.cx)($7f560cb8e964d6f3$var$styles.metadataContainer, $7f560cb8e964d6f3$var$unboundedStyles.metadataContainer),
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                                    xcss: (0, $1Whri.cx)($7f560cb8e964d6f3$var$styles.productNameContainer),
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                            size: "small",
                                                            color: "color.text.subtle",
                                                            children: formatMessage((0, $872baa6c44f00b3c$export$defe85febe8b728c).confluence_product_name)
                                                        }),
                                                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                                            style: $7f560cb8e964d6f3$var$separatorStyle,
                                                            children: "\u2022"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $1lLfV.default), {
                                                    primary: [
                                                        {
                                                            name: (0, $5TXU5.ElementName).CreatedBy
                                                        },
                                                        {
                                                            name: (0, $5TXU5.ElementName).ModifiedOn
                                                        },
                                                        {
                                                            name: (0, $5TXU5.ElementName).ViewCount
                                                        },
                                                        {
                                                            name: (0, $5TXU5.ElementName).CommentCount
                                                        },
                                                        {
                                                            name: (0, $5TXU5.ElementName).ReactCount
                                                        },
                                                        {
                                                            name: (0, $5TXU5.ElementName).VoteCount
                                                        }
                                                    ],
                                                    size: (0, $5TXU5.SmartLinkSize).Small,
                                                    maxLines: 1
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $7f560cb8e964d6f3$var$styles.snippetContainer,
                            children: areLLMPoweredFeaturesEnabled ? aiSnippetLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                                height: 20,
                                width: "90%",
                                isShimmering: true,
                                testId: "skeleton"
                            }) : aiSnippetError ? fallbackContent : aiSnippet ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                maxLines: 2,
                                children: aiSnippet
                            }) : fallbackContent : fallbackContent
                        })
                    ]
                })
            })
        ]
    });
};
const $7f560cb8e964d6f3$export$446a917ae3eb13bc = /*#__PURE__*/ (0, $42omo.memo)($7f560cb8e964d6f3$var$ConfluenceFlexibleSmartCardUnmemoized);


/*
 * This file contains the utilities for navigating to a link from a confluence result card.
 * We mainly want to support SPA navigation if search-page provides its own onNavigate function
 * inspired by
 *  - /platform/packages/search/search-page/src/common/ui/link-component/index.tsx
 *  - /platform/packages/search/search-page/src/common/utils/url.ts
 */ 


const $ad22036b26d138b6$var$defaultOnNavigate = {
    callback: (url)=>{
        window.location.href = url;
    },
    options: {
        alwaysUseOnLinkClick: false
    }
};
const $ad22036b26d138b6$export$c22fd8ed236ca380 = ({ event: event, url: url, onNavigate: onNavigate = $ad22036b26d138b6$var$defaultOnNavigate })=>{
    try {
        const metaPressed = event.ctrlKey || event.metaKey || event.shiftKey;
        const sameOrigin = window.location.origin === new URL(url).origin;
        const useOnNavigate = sameOrigin && !metaPressed;
        if (useOnNavigate) {
            event.preventDefault();
            // Handles SPA navigation if search-page provides own onNavigate
            const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
            onNavigateCallback(url, 'push');
        } else $ad22036b26d138b6$var$defaultOnNavigate.callback(url);
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'navigateToLink'
        });
        $ad22036b26d138b6$var$defaultOnNavigate.callback(url);
    }
};


const $22c94c8e6129496b$var$styles = {
    disclaimerSpacer: "_4t3i14no",
    root: "_2rko12b0 _1h6d1l7x _1dqonqa1 _189ee4h9 _1bsb1osq",
    smartCardContainer: "_1tkes0l4 _ca0qutpp _n3tdpxbi",
    additionalInfoSectionContainer: "_1tke168d _ca0qutpp _n3tdpxbi",
    conversationStartersContainer: "_ca0qutpp _n3tdutpp",
    borderBottomSeparator: "_1il9nqa1 _1doce4h9 _1o3i1l7x",
    sidePadding: "_19bvpxbi _u5f3pxbi",
    feedbackContainer: "_ca0q1b66 _n3tdu2gc"
};
const $22c94c8e6129496b$export$94b7dbb53a4cb787 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eMz0l.AnimatedWrapper), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kF5LJ.SmartAnswerCardBodyGenerating), {
                    heightOverride: "navigationalCard"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $22c94c8e6129496b$var$styles.disclaimerSpacer
            })
        ]
    });
const $22c94c8e6129496b$var$ConfluenceCardComponent = ({ searchResultData: searchResultData, workspaceId: workspaceId, source: source, searchPageAnalyticsCallbacks: searchPageAnalyticsCallbacks, onNavigate: onNavigate })=>{
    const renderStartTime = (0, $42omo.useRef)(performance.now());
    const hasFiredNavCardLoaded = (0, $42omo.useRef)(false);
    const { query: query, url: url, cloudId: cloudId, searchSessionId: searchSessionId, id: contentId, type: contentType, description: description, areLLMPoweredFeaturesEnabled: areLLMPoweredFeaturesEnabled, primaryProduct: primaryProduct, linkedResults: linkedResults, extractedLinks: extractedLinks } = searchResultData;
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const { loading: twgSourcesLoading, contributors: contributors, outgoingLinks: outgoingLinks } = (0, $7af60c4a5978bce8$export$6ed38de17ee0fdc9)({
        contentId: contentId,
        workspaceId: workspaceId || '',
        cloudId: cloudId || '',
        product: primaryProduct || ''
    });
    const deduplicatedContributors = (0, $42omo.useMemo)(()=>(0, $b4536d1ff2577c9e$export$16bf99dc0596865c)(contributors), [
        contributors
    ]); /**
                                                                                                          * The priority for how we show the related links in the UI:
                                                                                                          * P1: BE(these are part of the search results) related links coming from search-page
                                                                                                          * P2: FE(these are extracted from the description) related links coming from search-page
                                                                                                          * P3: Outgoing links from the TWG API (pages mentioned in the confluence page)
                                                                                                          */ 
    const links = (0, $42omo.useMemo)(()=>{
        return [
            ...linkedResults?.map((result)=>result.url) || [],
            ...extractedLinks || [],
            ...outgoingLinks || []
        ].slice(0, 50); // Limit the number of links to 50 to avoid errors from Object Resolver
    }, [
        linkedResults,
        extractedLinks,
        outgoingLinks
    ]);
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $ka0Y0.sha256Hash)(query),
            brand: (0, $f7lNm.AiBrand).ROVO,
            source: source,
            query: query,
            answerString: url || '',
            answerCardType: (0, $f7lNm.AnswerCardType).NAV_CONTENT
        }), [
        searchSessionId,
        query,
        url,
        source
    ]); // removing UGC attributes
    const analyticsAttributesWithoutUGC = (0, $42omo.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $ka0Y0.sha256Hash)(query),
            brand: (0, $f7lNm.AiBrand).ROVO,
            source: source,
            answerCardType: (0, $f7lNm.AnswerCardType).NAV_CONTENT
        }), [
        query,
        searchSessionId,
        source
    ]);
    const fireNavCardLoaded = (0, $42omo.useCallback)(()=>{
        if (hasFiredNavCardLoaded.current) return;
        hasFiredNavCardLoaded.current = true;
        const apiLoadedTime = performance.now();
        const totalDuration = apiLoadedTime - renderStartTime.current;
        fireAnalyticsEvent((0, $elfKF.onNonGenerativeAIAnswerResultShown)({
            ...analyticsAttributes,
            fmpLoadTime: totalDuration,
            resourceType: 'confluence'
        }));
    }, [
        fireAnalyticsEvent,
        analyticsAttributes
    ]);
    (0, $42omo.useEffect)(()=>{
        trackAIInteractionInit();
        fireSAINUsageEvent({});
    }, [
        fireSAINUsageEvent,
        trackAIInteractionInit
    ]);
    const handleLinkClick = (0, $42omo.useCallback)(({ event: event, resourceUrl: resourceUrl, location: location })=>{
        event.preventDefault();
        fireAnalyticsEvent((0, $kkJIR.onNonGenerativeKnowledgeCardLinkClick)({
            ...analyticsAttributes,
            location: location
        }));
        fireSAINUsageEvent({});
        (0, $ad22036b26d138b6$export$c22fd8ed236ca380)({
            event: event,
            url: resourceUrl,
            onNavigate: onNavigate
        });
    }, [
        fireAnalyticsEvent,
        analyticsAttributes,
        fireSAINUsageEvent,
        onNavigate
    ]);
    const fireAnalyticsEventAndUsage = (0, $42omo.useCallback)((action)=>{
        fireAnalyticsEvent((0, $kkJIR.onNonGenerativeKnowledgeCardLinkClick)({
            ...analyticsAttributes,
            location: action
        }));
        fireSAINUsageEvent({});
    }, [
        fireAnalyticsEvent,
        analyticsAttributes,
        fireSAINUsageEvent
    ]);
    const fireAnalyticsEventAndUsageForExpand = (0, $42omo.useCallback)((layout)=>{
        fireAnalyticsEvent((0, $kkJIR.onNonGenerativeKnowledgeCardLinkClick)({
            ...analyticsAttributes,
            location: `expand-${layout}`
        }));
        fireSAINUsageEvent({});
    }, [
        fireAnalyticsEvent,
        analyticsAttributes,
        fireSAINUsageEvent
    ]);
    if (twgSourcesLoading) return /*#__PURE__*/ (0, $l998X.jsx)($22c94c8e6129496b$export$94b7dbb53a4cb787, {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eaSIT.SearchAIAnalyticsContext), {
        data: {
            attributes: {
                ...analyticsAttributesWithoutUGC,
                location: (0, $4xTru.SearchAIAnalyticsContextLocation).SEARCH_RESULT_CONFLUENCE_CARD
            },
            location: (0, $4xTru.SearchAIAnalyticsContextLocation).SEARCH_RESULT_CONFLUENCE_CARD
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7bZ3i.SmartCardProvider), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    xcss: $22c94c8e6129496b$var$styles.root,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($22c94c8e6129496b$var$styles.smartCardContainer, $22c94c8e6129496b$var$styles.borderBottomSeparator, $22c94c8e6129496b$var$styles.sidePadding),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7f560cb8e964d6f3$export$446a917ae3eb13bc), {
                                url: url,
                                cloudId: cloudId,
                                contentId: contentId,
                                contentType: contentType,
                                description: description,
                                areLLMPoweredFeaturesEnabled: areLLMPoweredFeaturesEnabled,
                                workspaceId: workspaceId || '',
                                product: primaryProduct || '',
                                onLoad: fireNavCardLoaded,
                                onClick: handleLinkClick,
                                onActionButtonClicked: fireAnalyticsEventAndUsage,
                                searchPageAnalyticsCallbacks: searchPageAnalyticsCallbacks
                            })
                        }),
                        (links.length > 0 || deduplicatedContributors.length > 0) && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($22c94c8e6129496b$var$styles.additionalInfoSectionContainer, $22c94c8e6129496b$var$styles.borderBottomSeparator, $22c94c8e6129496b$var$styles.sidePadding),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c2ee2b5f73ff8eda$export$62500b33cee05471), {
                                links: links,
                                contributors: deduplicatedContributors,
                                cloudId: cloudId,
                                onResourceClick: handleLinkClick,
                                onContributorClick: fireAnalyticsEventAndUsage,
                                onExpandClicked: fireAnalyticsEventAndUsageForExpand
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($22c94c8e6129496b$var$styles.conversationStartersContainer, $22c94c8e6129496b$var$styles.sidePadding),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $383edc9b6c74463d$export$10e76ebde8d3ea11), {
                                primaryProduct: primaryProduct,
                                cloudId: cloudId,
                                searchResult: {
                                    ari: contentId,
                                    url: url
                                },
                                analyticsAttributes: analyticsAttributesWithoutUGC
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $22c94c8e6129496b$var$styles.feedbackContainer,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                        showFeedbackButtons: true,
                        showAIUsageDisclaimer: areLLMPoweredFeaturesEnabled
                    })
                })
            ]
        })
    });
};
const $22c94c8e6129496b$var$ConfluenceCardComponentMemoized = /*#__PURE__*/ (0, $42omo.memo)($22c94c8e6129496b$var$ConfluenceCardComponent);
const $22c94c8e6129496b$export$b769a864d98cccb0 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)($22c94c8e6129496b$var$ConfluenceCardComponentMemoized, {
        ...props
    });


const $6406541fb8ffe635$export$b8e08e4af5c98a73 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            product: props.searchResultData?.product || '',
            subproduct: props.subproduct ?? 'unknown',
            aiFeatureName: 'smartAnswers',
            aiExperienceName: (0, $f7lNm.AiExperienceName).NAVIGATIONAL_SEARCH_RESULT_CARD,
            // TODO: update this section once we have agreement on how we track this card towards SAIN
            proactiveGeneratedAI: 0,
            userGeneratedAI: 0,
            isAIFeature: 0,
            source: props.source,
            channel: (0, $f7lNm.DEFAULT_GAS_CHANNEL)
        },
        children: props.searchResultData?.__typename === 'SearchConfluencePageBlogAttachment' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $22c94c8e6129496b$export$b769a864d98cccb0), {
            ...props
        }) : null
    });


























parcelRequire("42omo");





var $1yB28 = parcelRequire("1yB28");









const $f71581c8beb50ce0$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    commentIconLabel: {
        id: "search-page.comment-icon-label",
        defaultMessage: "Comment"
    }
});


const $8ca12d73b6c4215d$export$f4c1466e6fdd07b = ({ numberOfComments: numberOfComments })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                label: formatMessage((0, $f71581c8beb50ce0$export$a7357cdd1f0b0168).commentIconLabel)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest",
                children: numberOfComments
            })
        ]
    });
};
const $8ca12d73b6c4215d$export$e03b3a8fca9c958d = (numberOfComments)=>{
    if (!numberOfComments || numberOfComments === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($8ca12d73b6c4215d$export$f4c1466e6fdd07b, {
        numberOfComments: numberOfComments
    });
};





parcelRequire("42omo");






/**
 * Extracts the base URL from a given URL if it exists. Otherwise, it returns the current origin.
 * @param url string or undefined
 * @returns base URL or current origin
 */ function $8272198a7df0b358$export$f654b28f82155665(url) {
    return url ? new URL(url).origin : window.location.origin;
}





parcelRequire("42omo");






const $5dbea7e9699c6e46$var$styles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
const $5dbea7e9699c6e46$var$SearchMetadataGeneric = ({ label: label })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $5dbea7e9699c6e46$var$styles,
        children: label
    });
};
var $5dbea7e9699c6e46$export$2e2bcd8739ae039 = $5dbea7e9699c6e46$var$SearchMetadataGeneric;





parcelRequire("42omo");


var $fpGTa = parcelRequire("fpGTa");



const $655681e89d0ffd52$var$anchorStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    overflow: 'hidden',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest',
    textDecoration: 'none',
    ':hover': {
        color: 'color.text.subtlest'
    },
    ':visited': {
        color: 'color.text.subtlest'
    },
    ':focus': {
        color: 'color.text.subtlest'
    },
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $655681e89d0ffd52$var$SearchMetadataLink = ({ label: label, href: href })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
        href: href,
        xcss: $655681e89d0ffd52$var$anchorStyles,
        testId: "search-page-result-metadata-link",
        children: label
    });
};
var $655681e89d0ffd52$export$2e2bcd8739ae039 = $655681e89d0ffd52$var$SearchMetadataLink;


const $e6acefe6e798f052$var$breadcrumbsContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.100',
    maxWidth: '246px' // Specified in the design
});
const $e6acefe6e798f052$export$9138e703d4b4585b = ({ url: url, name: name, webUiLink: webUiLink })=>{
    const baseUrl = url && (0, $8272198a7df0b358$export$f654b28f82155665)(url);
    const href = `${baseUrl}/wiki${webUiLink}`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        xcss: $e6acefe6e798f052$var$breadcrumbsContainerStyles,
        children: href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
            label: name,
            href: `${baseUrl}/wiki${webUiLink}`
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $5dbea7e9699c6e46$export$2e2bcd8739ae039), {
            label: name
        })
    });
};







parcelRequire("42omo");









parcelRequire("42omo");

const $b79e8443c320d4b1$export$db3737f3b54fe9a0 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.536 7.96266C15.536 7.7391 15.4827 7.52932 15.3933 7.33866C14.7973 5.41599 12.0071 5.55643 8.03823 5.46266C7.37468 5.4471 7.75423 4.66355 7.98712 2.94355C8.13868 1.82488 7.41734 0.107101 6.2049 0.107101C4.20579 0.107101 6.1289 1.68399 4.36134 5.58355C3.4169 7.6671 1.30579 6.49999 1.30579 8.59288V13.3569C1.30579 14.1715 1.38579 14.9547 2.53156 15.0835C3.64223 15.2084 3.39245 16 4.99468 16H13.0142C13.8311 16 14.4956 15.3351 14.4956 14.5182C14.4956 14.1795 14.3769 13.8711 14.1853 13.6213C14.6387 13.3675 14.9498 12.8884 14.9498 12.3329C14.9498 11.9951 14.8316 11.6867 14.6405 11.4373C15.0951 11.184 15.4071 10.7044 15.4071 10.148C15.4071 9.74399 15.2436 9.37777 14.98 9.10977C15.3165 8.83821 15.536 8.42755 15.536 7.96266Z",
                fill: "#FFDB5E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.2311 9.44401H14.0551C14.5751 9.44401 15.0631 9.16578 15.3289 8.71823C15.4382 8.53378 15.3773 8.29512 15.1925 8.18534C15.008 8.07556 14.7693 8.13734 14.6596 8.32178C14.5338 8.53467 14.3013 8.66623 14.0547 8.66623H10.1391C9.75113 8.66623 9.43557 8.35067 9.43557 7.96267C9.43557 7.57467 9.75113 7.25912 10.1391 7.25912H12.7556C12.9702 7.25912 13.1445 7.08489 13.1445 6.87023C13.1445 6.65556 12.9702 6.48134 12.7556 6.48134H10.1387C9.32179 6.48134 8.65735 7.14578 8.65735 7.96267C8.65735 8.41823 8.86846 8.82134 9.1929 9.09334C8.91957 9.36223 8.74935 9.73556 8.74935 10.148C8.74935 10.6049 8.96179 11.0093 9.28802 11.2809C9.01646 11.5493 8.84802 11.9213 8.84802 12.3329C8.84802 12.8307 9.09646 13.2698 9.47424 13.5387C9.24135 13.8004 9.09557 14.1413 9.09557 14.5182C9.09557 15.3351 9.76002 15.9996 10.5769 15.9996H13.0142C13.5342 15.9996 14.0227 15.7218 14.2885 15.2742C14.3982 15.0898 14.3373 14.8511 14.1529 14.7413C13.968 14.6325 13.7293 14.6924 13.62 14.8769C13.4933 15.0898 13.2609 15.2218 13.0142 15.2218H10.5769C10.1889 15.2218 9.87335 14.9062 9.87335 14.5182C9.87335 14.1302 10.1889 13.8147 10.5769 13.8147H13.4685C13.9885 13.8147 14.4773 13.5365 14.7427 13.0889C14.8525 12.904 14.7916 12.6653 14.6071 12.556C14.4209 12.4444 14.1831 12.5071 14.0742 12.6916C13.9458 12.908 13.7191 13.0369 13.4685 13.0369H10.3293C9.94135 13.0369 9.62579 12.7209 9.62579 12.3329C9.62579 11.9449 9.94135 11.6293 10.3293 11.6293H13.9253C14.4453 11.6293 14.9338 11.3516 15.1996 10.904C15.3093 10.7196 15.2485 10.4809 15.064 10.3711C14.8787 10.2618 14.6405 10.3222 14.5311 10.5067C14.4027 10.7227 14.176 10.8516 13.9253 10.8516H10.2311C9.84313 10.8516 9.52757 10.536 9.52757 10.148C9.52757 9.76001 9.84268 9.44401 10.2311 9.44401Z",
                fill: "#EE9547"
            })
        ]
    });


const $f70284887e2e1865$export$1bd444ba34dbd512 = ({ numberOfLikes: numberOfLikes })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $b79e8443c320d4b1$export$db3737f3b54fe9a0), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest",
                children: numberOfLikes
            })
        ]
    });
const $f70284887e2e1865$export$b52fa2ff0823604f = (numberOfLikes)=>{
    if (!numberOfLikes || numberOfLikes === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($f70284887e2e1865$export$1bd444ba34dbd512, {
        numberOfLikes: numberOfLikes
    });
};




























const $6a8b466b77e29197$export$b2199c37e85de4a7 = (text)=>{
    const callback = (0, $42omo.useCallback)(()=>{
        if (text) navigator.clipboard.writeText(text);
    }, [
        text
    ]);
    if (text) return callback;
};














var $7p4As = parcelRequire("7p4As");





var $1Zr9M = parcelRequire("1Zr9M");


var $ldfch = parcelRequire("ldfch");


var $9M4aB = parcelRequire("9M4aB");








/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 













/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $034f80c7bef66068$var$textColor = "var(--ds-text, #292A2E)";
const $034f80c7bef66068$var$initialsAvatarColor = "var(--ds-background-neutral, #0515240F)"; /** Shown when name is empty or whitespace-only (External Person) */ 
const $034f80c7bef66068$var$DEFAULT_INITIALS = 'EP';
const $034f80c7bef66068$var$initialsCss = null;
const $034f80c7bef66068$export$8f045b5892495218 = ({ name: name })=>{
    const initials = (0, $42omo.useMemo)(()=>$034f80c7bef66068$var$getInitials(name), [
        name
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "10",
                fill: $034f80c7bef66068$var$initialsAvatarColor
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("text", {
                x: "50%",
                y: "55%",
                fontFamily: "SF Pro Text, sans-serif",
                dominantBaseline: "middle",
                textAnchor: "middle",
                fontSize: "11",
                fontWeight: "400",
                fill: $034f80c7bef66068$var$textColor,
                children: initials
            })
        ]
    });
};
function $034f80c7bef66068$var$getInitials(name) {
    const trimmed = name.trim();
    if (!trimmed) return $034f80c7bef66068$var$DEFAULT_INITIALS;
    const names = trimmed.split(/\s+/).filter(Boolean);
    const lastName = names.length > 1 ? names[names.length - 1] : '';
    const firstInitial = names[0][0].toUpperCase();
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return firstInitial + lastInitial;
}


const $e0a3a41d6257d9b3$var$initialsAvatarCSS = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex'
});
const $e0a3a41d6257d9b3$var$profilePicAvatarCSS = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex',
    borderRadius: 'radius.full',
    overflow: 'hidden'
});
const $e0a3a41d6257d9b3$var$profilePicXcss = null; /** Adapted from @atlaskit/avatar */ 
const $e0a3a41d6257d9b3$var$AVATAR_SIZES = {
    xsmall: (0, $ecnYn.xcss)({
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    }),
    // custom smaller size of 20px
    smaller: (0, $ecnYn.xcss)({
        width: "var(--ds-space-250, 20px)",
        height: "var(--ds-space-250, 20px)"
    }),
    small: (0, $ecnYn.xcss)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
    }),
    medium: (0, $ecnYn.xcss)({
        width: "var(--ds-space-400, 32px)",
        height: "var(--ds-space-400, 32px)"
    }),
    large: (0, $ecnYn.xcss)({
        width: "var(--ds-space-500, 40px)",
        height: "var(--ds-space-500, 40px)"
    }),
    xlarge: (0, $ecnYn.xcss)({
        width: `calc(${"var(--ds-space-600, 48px)"} * 2)`,
        height: `calc(${"var(--ds-space-600, 48px)"} * 2)`
    }),
    xxlarge: (0, $ecnYn.xcss)({
        width: `calc(${"var(--ds-space-800, 64px)"} * 2)`,
        height: `calc(${"var(--ds-space-800, 64px)"} * 2)`
    })
};
const $e0a3a41d6257d9b3$export$e2255cf6045e8d47 = ({ variant: variant, size: size = 'medium' })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $42omo.useState)(false);
    if (variant.type === 'profile-pic' && !hasImageErrored) {
        const { src: src } = variant;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            "aria-hidden": true,
            testId: "search-ui-avatar",
            xcss: [
                $e0a3a41d6257d9b3$var$profilePicAvatarCSS,
                $e0a3a41d6257d9b3$var$AVATAR_SIZES[size]
            ],
            children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                src: src,
                onError: ()=>setHasImageErrored(true),
                className: (0, $gMc0m.default)([
                    "_1bsb1osq _4t3i1osq"
                ])
            })
        });
    }
    const { name: name } = variant;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        "aria-hidden": true,
        testId: "search-ui-avatar",
        xcss: [
            $e0a3a41d6257d9b3$var$initialsAvatarCSS,
            $e0a3a41d6257d9b3$var$AVATAR_SIZES[size]
        ],
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $034f80c7bef66068$export$8f045b5892495218), {
            name: name
        })
    });
};





parcelRequire("42omo");





var $dE1p6 = parcelRequire("dE1p6");




parcelRequire("42omo");

const $d5bc004e7a8c7c68$export$8f6c6f317abe37f6 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_259_44146)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M13.7812 10H18.2369C18.6578 10 18.9991 10.3403 18.9991 10.76V14.8068C18.9991 16.3494 17.7449 17.6 16.1978 17.6H16.1845C14.6374 17.6002 13.383 16.3498 13.3828 14.8072C13.3828 14.8071 13.3828 14.8069 13.3828 14.8068V10.3972C13.3828 10.1778 13.5612 10 13.7812 10Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M16.7935 9.19961C17.7905 9.19961 18.5987 8.39372 18.5987 7.39961C18.5987 6.4055 17.7905 5.59961 16.7935 5.59961C15.7965 5.59961 14.9883 6.4055 14.9883 7.39961C14.9883 8.39372 15.7965 9.19961 16.7935 9.19961Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M11.1779 9.20001C12.618 9.20001 13.7854 8.03594 13.7854 6.6C13.7854 5.16406 12.618 4 11.1779 4C9.73776 4 8.57031 5.16406 8.57031 6.6C8.57031 8.03594 9.73776 9.20001 11.1779 9.20001Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.654 10H7.29908C6.88313 10.0103 6.5541 10.3545 6.56375 10.7692V15.3848C6.50566 17.8737 8.48048 19.9391 10.9765 20C13.4726 19.9391 15.4474 17.8737 15.3893 15.3848V10.7692C15.399 10.3545 15.0699 10.0103 14.654 10Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M11.3767 10V16.468C11.3747 16.7646 11.1944 17.0311 10.9193 17.144C10.8318 17.1809 10.7376 17.2 10.6425 17.2H6.91574C6.86359 17.068 6.81545 16.936 6.77533 16.8C6.6349 16.341 6.56325 15.8639 6.56271 15.384V10.768C6.55306 10.3539 6.88156 10.0103 7.29683 10H11.3767Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M10.9755 10V16.868C10.9755 16.9628 10.9564 17.0567 10.9193 17.144C10.8061 17.4183 10.5388 17.598 10.2414 17.6H7.10428C7.03608 17.468 6.9719 17.336 6.91574 17.2C6.85957 17.064 6.81545 16.936 6.77533 16.8C6.6349 16.341 6.56325 15.8639 6.56271 15.384V10.768C6.55306 10.3539 6.88156 10.0103 7.29683 10H10.9755Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M10.9755 10V16.068C10.9724 16.471 10.6456 16.797 10.2414 16.8H6.77533C6.6349 16.341 6.56325 15.8639 6.56271 15.384V10.768C6.55306 10.3539 6.88156 10.0103 7.29683 10H10.9755Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M10.5743 10V16.068C10.5713 16.471 10.2444 16.797 9.8402 16.8H6.77533C6.6349 16.341 6.56325 15.8639 6.56271 15.384V10.768C6.55306 10.3539 6.88156 10.0103 7.29683 10H10.5743Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M11.3766 7.93219V9.19219C11.3084 9.19619 11.2442 9.20019 11.176 9.20019C11.1078 9.20019 11.0436 9.19619 10.9754 9.19219C10.84 9.18323 10.7057 9.16181 10.5742 9.12819C9.76187 8.93637 9.09074 8.3683 8.769 7.60019C8.71364 7.4712 8.67066 7.33727 8.64062 7.2002H10.6424C11.0472 7.20172 11.375 7.52855 11.3766 7.93219Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M10.9759 8.3316V9.1916C10.8405 9.18264 10.7062 9.16122 10.5748 9.12761C9.76241 8.93578 9.09127 8.36772 8.76953 7.59961H10.2418C10.6466 7.60114 10.9744 7.92797 10.9759 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M10.9759 8.3316V9.1916C10.8405 9.18264 10.7062 9.16122 10.5748 9.12761C9.76241 8.93578 9.09127 8.36772 8.76953 7.59961H10.2418C10.6466 7.60114 10.9744 7.92797 10.9759 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M10.5748 8.33161V9.12761C9.76241 8.93578 9.09127 8.36772 8.76953 7.59961H9.84064C10.2454 7.60115 10.5732 7.92798 10.5748 8.33161Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M2.48533 7.59961H9.84024C10.2464 7.59961 10.5756 7.92788 10.5756 8.33281V15.6664C10.5756 16.0713 10.2464 16.3996 9.84024 16.3996H2.48533C2.07921 16.3996 1.75 16.0713 1.75 15.6664V8.33281C1.75 7.92788 2.07922 7.59961 2.48533 7.59961Z",
                        fill: "url(#paint0_linear_259_44146)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M8.09698 10.3916H6.62671V14.3836H5.69V10.3916H4.22656V9.61719H8.09698V10.3916Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint0_linear_259_44146",
                        x1: "3.28318",
                        y1: "7.0267",
                        x2: "9.01736",
                        y2: "16.9869",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "#5A62C3"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5",
                                stopColor: "#4D55BD"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#3940AB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_259_44146",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "17.25",
                            height: "16",
                            fill: "white",
                            transform: "translate(1.75 4)"
                        })
                    })
                ]
            })
        ]
    });





parcelRequire("42omo");

const $d15e8e694a23f0d0$export$b33fb54b08bb6422 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.86632 4C8.98186 4.00065 8.26606 4.71698 8.26671 5.59967C8.26606 6.48236 8.98251 7.19869 9.86697 7.19935H11.4672V5.60033C11.4679 4.71763 10.7514 4.0013 9.86632 4C9.86697 4 9.86697 4 9.86632 4V4ZM9.86632 8.26667H5.60026C4.7158 8.26732 3.99935 8.98365 4 9.86634C3.99869 10.749 4.71515 11.4654 5.59961 11.4667H9.86632C10.7508 11.466 11.4672 10.7497 11.4666 9.86699C11.4672 8.98365 10.7508 8.26732 9.86632 8.26667Z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.9999 9.86634C20.0005 8.98365 19.2841 8.26732 18.3996 8.26667C17.5151 8.26732 16.7987 8.98365 16.7993 9.86634V11.4667H18.3996C19.2841 11.466 20.0005 10.7497 19.9999 9.86634ZM15.7331 9.86634V5.59967C15.7338 4.71763 15.018 4.0013 14.1335 4C13.2491 4.00065 12.5326 4.71698 12.5333 5.59967V9.86634C12.532 10.749 13.2484 11.4654 14.1329 11.4667C15.0173 11.466 15.7338 10.7497 15.7331 9.86634Z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.133 19.9998C15.0174 19.9992 15.7339 19.2828 15.7333 18.4001C15.7339 17.5174 15.0174 16.8011 14.133 16.8005H12.5327V18.4001C12.5321 19.2822 13.2485 19.9985 14.133 19.9998ZM14.133 15.7325H18.3997C19.2842 15.7318 20.0006 15.0155 20 14.1328C20.0013 13.2501 19.2848 12.5338 18.4004 12.5325H14.1336C13.2492 12.5331 12.5327 13.2495 12.5334 14.1322C12.5327 15.0155 13.2485 15.7318 14.133 15.7325Z",
                fill: "#ECB22E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.00012 14.1335C3.99947 15.0162 4.71593 15.7325 5.60039 15.7332C6.48485 15.7325 7.2013 15.0162 7.20065 14.1335V12.5338H5.60039C4.71593 12.5345 3.99947 13.2508 4.00012 14.1335ZM8.26684 14.1335V18.4002C8.26553 19.2829 8.98199 19.9992 9.86645 20.0005C10.7509 19.9999 11.4674 19.2835 11.4667 18.4008V14.1348C11.468 13.2521 10.7516 12.5358 9.86711 12.5345C8.98199 12.5345 8.26619 13.2508 8.26684 14.1335C8.26684 14.1341 8.26684 14.1335 8.26684 14.1335Z",
                fill: "#E01E5A"
            })
        ]
    });





const $ccffef27afc66230$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    openDmButtonLabel: {
        id: "search-page.social-signals.user-card.open-dm-button-label",
        defaultMessage: "Direct message"
    }
});


const $8ba86ca7710e8cf5$export$628b037ae7bb4a39 = ({ integrationInfo: integrationInfo })=>{
    const { integration: integration, openDmUrl: openDmUrl } = integrationInfo;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
        target: "_blank",
        rel: "noopener noreferrer",
        href: openDmUrl,
        icon: integration === 'ms-teams' ? (0, $d5bc004e7a8c7c68$export$8f6c6f317abe37f6) : (0, $d15e8e694a23f0d0$export$b33fb54b08bb6422),
        label: formatMessage((0, $ccffef27afc66230$export$defe85febe8b728c).openDmButtonLabel),
        isTooltipDisabled: false
    });
};






const $0a5741db56043cfe$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    viewProfile: {
        id: "search-page.social-signals.user-card.view-profile",
        defaultMessage: "View profile"
    },
    emailButtonLabel: {
        id: "search-page.social-signals.user-card.email-button-label",
        defaultMessage: "Copy email address"
    }
});





const $c59b288e67b742a2$export$6bab030fe17f656d = (0, $aXWIB.defineMessages)({
    share: {
        id: "search-page.social-signals.user-card.shared-time-unit-ago-by",
        defaultMessage: "Shared {relativeDate} by"
    },
    comment: {
        id: "search-page.social-signals.user-card.commented-time-unit-ago-by",
        defaultMessage: "Commented {relativeDate} by"
    },
    edit: {
        id: "search-page.social-signals.user-card.edited-time-unit-ago-by",
        defaultMessage: "Edited {relativeDate} by"
    }
});


const $168e8abba0f0ce48$var$cardXcss = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.raised',
    borderRadius: "var(--ds-radius-large, 8px)",
    padding: 'space.200',
    minWidth: '214px',
    width: 'fit-content'
});
const $168e8abba0f0ce48$var$headerXcss = (0, $ecnYn.xcss)({
    font: 'font.body.small',
    fontWeight: 'font.weight.semibold'
});
const $168e8abba0f0ce48$var$userNameXcss = (0, $ecnYn.xcss)({
    font: 'font.body.large',
    fontWeight: 'font.weight.semibold',
    textAlign: 'center',
    maxWidth: '214px',
    overflowWrap: 'break-word'
});
const $168e8abba0f0ce48$var$userSubheadingXcss = (0, $ecnYn.xcss)({
    font: 'font.body',
    textAlign: 'center',
    maxWidth: '214px',
    overflowWrap: 'break-word'
});
const $168e8abba0f0ce48$export$4c094c8f61edecb4 = ({ signalDate: signalDate, signalType: signalType, user: user, onCopyEmail: onCopyEmail, externalMessageIntegration: externalMessageIntegration })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        xcss: $168e8abba0f0ce48$var$cardXcss,
        testId: "search-person-card",
        children: [
            signalDate && signalType && /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                xcss: $168e8abba0f0ce48$var$headerXcss,
                alignItems: "center",
                gap: "space.075",
                children: /*#__PURE__*/ (0, $l998X.jsx)($168e8abba0f0ce48$export$4a6f3cfec60dc525, {
                    signalDate: signalDate,
                    signalType: signalType
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0a3a41d6257d9b3$export$e2255cf6045e8d47), {
                    variant: user.profilePicUrl ? {
                        type: 'profile-pic',
                        src: user.profilePicUrl,
                        name: user.name
                    } : {
                        type: 'initials',
                        name: user.name
                    },
                    size: "xlarge"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                direction: "column",
                alignItems: "center",
                gap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $168e8abba0f0ce48$var$userNameXcss,
                        children: user.name
                    }),
                    user.jobTitle && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $168e8abba0f0ce48$var$userSubheadingXcss,
                        children: user.jobTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                gap: "space.050",
                children: [
                    externalMessageIntegration && /*#__PURE__*/ (0, $l998X.jsx)((0, $8ba86ca7710e8cf5$export$628b037ae7bb4a39), {
                        integrationInfo: externalMessageIntegration
                    }),
                    onCopyEmail && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldfch))),
                        label: formatMessage((0, $0a5741db56043cfe$export$defe85febe8b728c).emailButtonLabel),
                        isTooltipDisabled: false,
                        onClick: onCopyEmail
                    }),
                    user.profileUrl && /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                        href: user.profileUrl,
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $0a5741db56043cfe$export$defe85febe8b728c).viewProfile
                        })
                    })
                ]
            })
        ]
    });
};
const $168e8abba0f0ce48$var$SECONDS_IN_A_DAY = 86400;
const $168e8abba0f0ce48$var$SECONDS_IN_AN_HOUR = 3600;
function $168e8abba0f0ce48$export$e603bc8e48e0cfbb(signalDate) {
    const secondsSinceUpdate = (Date.now() - signalDate.getTime()) / 1000;
    const daysSinceUpdate = Math.floor(secondsSinceUpdate / $168e8abba0f0ce48$var$SECONDS_IN_A_DAY);
    /** Seconds that don't fit into a whole day */ const remainingSecondsInAnHour = secondsSinceUpdate % $168e8abba0f0ce48$var$SECONDS_IN_A_DAY;
    const leftoverHoursSinceUpdate = Math.floor(remainingSecondsInAnHour / $168e8abba0f0ce48$var$SECONDS_IN_AN_HOUR);
    const minutesSinceUpdate = Math.floor(secondsSinceUpdate / 60);
    return {
        daysSinceUpdate: daysSinceUpdate,
        leftoverHoursSinceUpdate: leftoverHoursSinceUpdate,
        minutesSinceUpdate: minutesSinceUpdate
    };
}
const $168e8abba0f0ce48$var$SOCIAL_SIGNAL_ICONS = {
    comment: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
        label: "",
        color: "currentColor"
    }),
    edit: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        label: "",
        color: "currentColor"
    }),
    share: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9M4aB))), {
        label: "",
        color: "currentColor"
    })
};
const $168e8abba0f0ce48$export$4a6f3cfec60dc525 = ({ signalDate: signalDate, signalType: signalType })=>{
    const icon = $168e8abba0f0ce48$var$SOCIAL_SIGNAL_ICONS[signalType];
    const timeUnitAgoMessage = (0, $c59b288e67b742a2$export$6bab030fe17f656d)[signalType];
    const { unit: unit, value: value } = (0, $42omo.useMemo)(()=>{
        const { daysSinceUpdate: daysSinceUpdate, leftoverHoursSinceUpdate: leftoverHoursSinceUpdate, minutesSinceUpdate: minutesSinceUpdate } = $168e8abba0f0ce48$export$e603bc8e48e0cfbb(signalDate);
        return $168e8abba0f0ce48$var$getTimeValues(daysSinceUpdate, leftoverHoursSinceUpdate, minutesSinceUpdate);
    }, [
        signalDate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedRelativeTime), {
                value: -value,
                style: "long",
                unit: unit,
                numeric: "auto",
                children: (formattedTime)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...timeUnitAgoMessage,
                        values: {
                            relativeDate: formattedTime
                        }
                    })
            })
        ]
    });
};
const $168e8abba0f0ce48$var$getTimeValues = (daysSinceUpdate, leftoverHoursSinceUpdate, minutesSinceUpdate)=>{
    if (daysSinceUpdate === 0) {
        if (leftoverHoursSinceUpdate < 1) return {
            unit: 'minute',
            value: minutesSinceUpdate
        };
        return {
            unit: 'hour',
            value: leftoverHoursSinceUpdate
        };
    }
    return {
        unit: 'day',
        value: daysSinceUpdate
    };
};
























const $7e40d1495048d124$export$1ebf25a5760ae3d6 = (0, $aXWIB.defineMessages)({
    share: {
        id: "search-ui.social-signals.user-card-trigger.shared",
        defaultMessage: "{name} shared"
    },
    edit: {
        id: "search-ui.social-signals.user-card-trigger.edited",
        defaultMessage: "{name} edited"
    },
    comment: {
        id: "search-ui.social-signals.user-card-trigger.commented",
        defaultMessage: "{name} commented"
    }
});


const $8f4f6b5c57107ce5$var$signalTextXcss = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    ':hover': {
        textDecoration: 'underline'
    },
    ':focus-visible': {
        textDecoration: 'underline'
    },
    background: 'none',
    padding: '0'
});
const $8f4f6b5c57107ce5$export$b3c2c65aed2f6e98 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ avatarUrl: avatarUrl, userName: userName, onClick: onClick, socialSignalType: socialSignalType, testId: testId, componentName: componentName, analyticsContext: analyticsContext }, ref)=>{
    const firstName = (0, $42omo.useMemo)(()=>userName.split(' ')[0], [
        userName
    ]);
    const message = (0, $7e40d1495048d124$export$1ebf25a5760ae3d6)[socialSignalType];
    if (!message) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        ref: ref,
        onClick: onClick,
        xcss: $8f4f6b5c57107ce5$var$signalTextXcss,
        testId: testId,
        componentName: componentName,
        analyticsContext: analyticsContext,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
            gap: "space.075",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $e0a3a41d6257d9b3$export$e2255cf6045e8d47), {
                    variant: {
                        type: 'profile-pic',
                        src: avatarUrl,
                        name: userName
                    },
                    size: "xsmall"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...message,
                        values: {
                            name: firstName
                        }
                    })
                })
            ]
        })
    });
});








const $cdccb8e2c3df7374$export$f9c37c834f90de21 = ({ commonAttributes: commonAttributes, socialSignal: socialSignal })=>({
        eventType: 'ui',
        source: (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            ...commonAttributes,
            isFullPageSearch: true,
            socialSignal: socialSignal
        }
    });








const $e46c71a22c4ed891$export$2530a1964f2c1c12 = ({ partial: partial, commonAttributes: commonAttributes })=>{
    const copyEmailToClipboard = (0, $6a8b466b77e29197$export$b2199c37e85de4a7)(partial.socialSignal?.user?.email ?? '');
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { mapUserIdToProfileUrl: mapUserIdToProfileUrl } = (0, $7WbA8.useAppContext)();
    const { socialSignal: socialSignal } = partial;
    if (!socialSignal || !socialSignal.user || !socialSignal.signal || !$e46c71a22c4ed891$var$isSupportedSocialSignal(socialSignal.signal)) return null;
    const { signal: signal, timestamp: timestamp, user: user } = socialSignal;
    const userProfileUrl = mapUserIdToProfileUrl(user.accountId);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        trigger: (triggerProps)=>{
            const extensionData = (0, $1ymk3.getExtensionData)(commonAttributes.isCQL);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8f4f6b5c57107ce5$export$b3c2c65aed2f6e98), {
                ...triggerProps,
                userName: user.name,
                socialSignalType: signal,
                avatarUrl: user.picture,
                onClick: ()=>{
                    setIsOpen((open)=>!open);
                },
                testId: "search-page-social-signal",
                componentName: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}SocialSignal`,
                analyticsContext: (0, $cdccb8e2c3df7374$export$f9c37c834f90de21)({
                    commonAttributes: {
                        ...commonAttributes,
                        // traceId is only available on extensionData when using Relay
                        ...extensionData.traceId ? extensionData : {}
                    },
                    socialSignal: signal
                })
            });
        },
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $168e8abba0f0ce48$export$4c094c8f61edecb4), {
                user: {
                    name: user.name,
                    profilePicUrl: user.picture,
                    jobTitle: user.extendedProfile?.jobTitle,
                    profileUrl: userProfileUrl
                },
                onCopyEmail: copyEmailToClipboard,
                signalDate: timestamp ? new Date(timestamp) : undefined,
                signalType: signal
            })
    });
};
const $e46c71a22c4ed891$var$supportedSignals = [
    'edit',
    'share',
    'comment'
];
function $e46c71a22c4ed891$var$isSupportedSocialSignal(signalFromApi) {
    return $e46c71a22c4ed891$var$supportedSignals.includes(signalFromApi);
}
const $e46c71a22c4ed891$export$229f0558b2da716c = ({ userAccountId: userAccountId, userName: userName, userEmail: userEmail, userPicture: userPicture, userJobTitle: userJobTitle, signal: signal, timestamp: timestamp, commonAttributes: commonAttributes })=>{
    const copyEmailToClipboard = (0, $6a8b466b77e29197$export$b2199c37e85de4a7)(userEmail);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { mapUserIdToProfileUrl: mapUserIdToProfileUrl } = (0, $7WbA8.useAppContext)();
    if (!userAccountId || !userName || !userPicture || !signal || !$e46c71a22c4ed891$var$isSupportedSocialSignal(signal)) return null;
    const userProfileUrl = mapUserIdToProfileUrl(userAccountId);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        trigger: (triggerProps)=>{
            const extensionData = (0, $1ymk3.getExtensionData)(commonAttributes.isCQL);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8f4f6b5c57107ce5$export$b3c2c65aed2f6e98), {
                ...triggerProps,
                userName: userName,
                socialSignalType: signal,
                avatarUrl: userPicture,
                onClick: ()=>{
                    setIsOpen((open)=>!open);
                },
                testId: "search-page-social-signal",
                componentName: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}SocialSignal`,
                analyticsContext: (0, $cdccb8e2c3df7374$export$f9c37c834f90de21)({
                    commonAttributes: {
                        ...commonAttributes,
                        // traceId is only available on extensionData when using Relay
                        ...extensionData.traceId ? extensionData : {}
                    },
                    socialSignal: signal
                })
            });
        },
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $168e8abba0f0ce48$export$4c094c8f61edecb4), {
                user: {
                    name: userName,
                    profilePicUrl: userPicture,
                    jobTitle: userJobTitle,
                    profileUrl: userProfileUrl
                },
                onCopyEmail: copyEmailToClipboard,
                signalDate: timestamp ? new Date(timestamp) : undefined,
                signalType: signal
            })
    });
};



var $i1wpt = parcelRequire("i1wpt");











var $bh5s2 = parcelRequire("bh5s2");












const $62efe42719bc0caf$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    verifiedIconLabel: {
        id: "search-page.verified-icon-label",
        defaultMessage: "Verified"
    },
    verifiedIconTooltipMessage: {
        id: "search-page.verified-icon-tooltip-message",
        defaultMessage: "This page has been verified by an owner or admin."
    }
});


const $436f4269638928bb$var$TooltipTagStyles = (0, $ecnYn.xcss)({
    display: 'flex'
});
const $436f4269638928bb$export$48d215ae75c54231 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        as: "div",
        xcss: $436f4269638928bb$var$TooltipTagStyles,
        ref: ref,
        ...props
    }));
const $436f4269638928bb$export$eb413699769dd9b1 = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage((0, $62efe42719bc0caf$export$a7357cdd1f0b0168).verifiedIconTooltipMessage),
        tag: $436f4269638928bb$export$48d215ae75c54231,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
            label: formatMessage((0, $62efe42719bc0caf$export$a7357cdd1f0b0168).verifiedIconLabel),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        })
    });
};













var $7Evbj = parcelRequire("7Evbj");











const $328ff6efa3a7a420$export$c89c057fd480d10c = (node)=>{
    return node?.__typename === 'SearchConfluencePageBlogAttachment';
};
const $328ff6efa3a7a420$export$1e8aa22a53a15ada = ({ node: node, position: position, cloudId: cloudId, searchQuery: query, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, thirdPartyConfigs: thirdPartyConfigs, is3pGroupingEnabled: is3pGroupingEnabled, smartAnswersPortalRef: smartAnswersPortalRef, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $e0ddc7b382b65af0$export$2e2bcd8739ae039), node);
    const [features] = (0, $j4ply.useFeatures)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const { getFeatureGate: getFeatureGate, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled, onNavigate: onNavigate } = (0, $7WbA8.useAppContext)();
    const { isSAINNavigationalExperienceEligible: isSAINNavigationalExperienceEligible, getWorkspaceId: getWorkspaceId } = (0, $ed340a232d40a52e$export$ff55966aa7474110)();
    const isSideBySideEnabled = features?.sideBySide?.enabled;
    const isLiteMode = features?.lite?.enabled ?? false;
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        let containerId = null;
        if (data.space?.id) {
            const [, , , spaceId] = (0, $6h3V2.getProductAndIDFromARI)(data.space.id);
            containerId = spaceId;
        }
        return {
            id: data.id,
            containerId: containerId,
            spaceId: containerId,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product,
            isSideBySideEnabled: isSideBySideEnabled
        };
    }, [
        data,
        isSideBySideEnabled
    ]);
    const isSAINNavigationalExperienceEnabled = isSAINNavigationalExperienceEligible({
        position: position,
        url: data.url,
        navBoostScore: data.navBoostScore
    });
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position,
        socialSignal: data.socialSignal?.signal || undefined
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position,
        socialSignal: data.socialSignal?.signal || undefined
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const subtype = data.confluenceEntity?.subtype;
    const metadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: data.type,
                subtype: subtype
            })
        ],
        [
            'breadcrumbs',
            data.space?.name && /*#__PURE__*/ (0, $l998X.jsx)((0, $e6acefe6e798f052$export$9138e703d4b4585b), {
                name: data.space.name,
                url: data.url,
                webUiLink: data.space?.webUiLink
            })
        ],
        [
            'last-modified',
            data.lastModified && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                lastModified: data.lastModified
            })
        ]
    ];
    const socialMetadataParts = [
        [
            'comment-count',
            (0, $8ca12d73b6c4215d$export$e03b3a8fca9c958d)(data.confluenceEntity?.commentCountSummary?.total)
        ],
        [
            'like-count',
            (0, $f70284887e2e1865$export$b52fa2ff0823604f)(data.confluenceEntity?.likesSummary?.count)
        ]
    ];
    const titleMetadataParts = [
        [
            'verified',
            data.isVerified && /*#__PURE__*/ (0, $l998X.jsx)((0, $436f4269638928bb$export$eb413699769dd9b1), {})
        ]
    ];
    if (data.socialSignal && appMode === (0, $9vOy1.ApplicationModes).Rovo) {
        const { user: user, signal: signal, timestamp: timestamp } = data.socialSignal;
        socialMetadataParts.push([
            'social-signal',
            user?.email && /*#__PURE__*/ (0, $l998X.jsx)((0, $e46c71a22c4ed891$export$229f0558b2da716c), {
                userAccountId: user.accountId,
                userName: user.name,
                userEmail: user.email,
                userPicture: user.picture,
                userJobTitle: user.extendedProfile?.jobTitle,
                signal: signal,
                timestamp: timestamp,
                commonAttributes: commonAttributes
            })
        ]);
    }
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const hasSimilarResults = linkedResults?.some((linkedResult)=>linkedResult.category?.toUpperCase() === 'SIMILAR');
    const hasChildResults = linkedResults?.some((linkedResult)=>linkedResult.category?.toUpperCase() === 'CHILD');
    const extractedLinksFromText = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(data.description);
    const hasExtractedLinks = extractedLinksFromText && extractedLinksFromText.length > 0;
    const hasRelatedLinks = linkedResults && linkedResults.length > 0 || hasExtractedLinks;
    const { serveExperiment: serveConversationStartersExperiment } = (0, $eUEtI.getSAINLayerFrontendExperiment)({
        abTestId: 'kd_convo_starters_in_search'
    });
    const isConversationStartersEnabled = getFeatureGate('kd_convo_starters_dogfooding');
    const conversationStartersIfEnabled = position === 0 && appMode === (0, $9vOy1.ApplicationModes).Rovo && (0, $eb4a02b80e2ab764$export$3afecd2a83596299)(appMode, isAdminHubAIEnabled, isRovoLLMEnabled) && [
        'page',
        'blogpost'
    ].includes(data.type) && !!(serveConversationStartersExperiment || isConversationStartersEnabled) ? {
        ari: data.id,
        url: data.url
    } : null;
    // In lite mode, instead of rendering the AI "Summarize" pill banner above
    // the related links footer, reuse the existing SummarizeInChatButton with
    // default Atlaskit Button spacing (32px tall) and place it on the same line
    // as the Related links toggle. The button reuses the established analytics
    // callback + Rovo Chat publish flow used by the per-row hover Summarize.
    const shouldRenderLiteSummarizeButton = isLiteMode && !!conversationStartersIfEnabled;
    const liteSummarizeButton = shouldRenderLiteSummarizeButton ? /*#__PURE__*/ (0, $l998X.jsx)((0, $i1wpt.SummarizeInChatButton), {
        url: data.url,
        testId: "search-result-lite-summarize-in-chat-button",
        onClick: onSummarizeInChatButtonClicked,
        spacing: "default"
    }) : null;
    let icon;
    if ((0, $dh538.fg)('rovo_search_confluence_icons_fps')) icon = (0, $2waBy.getConfluenceEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        size: 'medium',
        isLiveDoc: data.confluenceEntity?.subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    const searchResultComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Confluence,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
            url: data.url,
            query: query,
            searchSessionId: searchSessionId
        }),
        title: (0, $Y34Hw.enrichExcerpt)(data.title),
        icon: icon,
        headerMetadataParts: metadataParts,
        headerMetadataSocialParts: socialMetadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts,
            displaySpacer: false
        }),
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(data.description)
        }),
        hideSummarizeInChat: !!conversationStartersIfEnabled,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        hasRelatedLinks: hasRelatedLinks,
        footer: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            children: [
                cloudId && conversationStartersIfEnabled && !isLiteMode && /*#__PURE__*/ (0, $l998X.jsx)((0, $383edc9b6c74463d$export$10e76ebde8d3ea11), {
                    primaryProduct: primaryProduct,
                    cloudId: cloudId,
                    searchResult: conversationStartersIfEnabled,
                    analyticsAttributes: {
                        resultMetadata: metadata,
                        ...commonAttributes
                    }
                }),
                hasSimilarResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$59c57a80401f0a6), {
                    linkedResults: linkedResults || [],
                    thirdPartyConfigs: thirdPartyConfigs,
                    partial: data,
                    url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
                        url: data.url,
                        query: query,
                        searchSessionId: searchSessionId
                    }),
                    position: position,
                    onResultClicked: onResultClicked,
                    isAllProductSelected: !selectedProduct,
                    onResultContextMenu: onResultCtxMenuClicked,
                    is3pGroupingEnabled: is3pGroupingEnabled,
                    product: (0, $1yEFx.ProductKeys).Confluence,
                    additionalFooterButton: isLiteMode ? liteSummarizeButton : undefined
                }) : hasChildResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$5c57e85aa93a90d0), {
                    linkedResults: linkedResults || [],
                    thirdPartyConfigs: thirdPartyConfigs,
                    partial: data,
                    url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
                        url: data.url,
                        query: query,
                        searchSessionId: searchSessionId
                    }),
                    position: position,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultCtxMenuClicked,
                    additionalFooterButton: isLiteMode ? liteSummarizeButton : undefined
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$695e5a3ae2478b3), {
                    linkedResults: linkedResults || [],
                    thirdPartyConfigs: thirdPartyConfigs,
                    partial: data,
                    url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
                        url: data.url,
                        query: query,
                        searchSessionId: searchSessionId
                    }),
                    position: position,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultCtxMenuClicked,
                    isAllProductSelected: !selectedProduct,
                    additionalFooterButton: isLiteMode ? liteSummarizeButton : undefined
                })
            ]
        }),
        mainContentWidth: mainContentWidth
    });
    // the SAIN Hero Nav card is rendered at the top of the search results via a portal replacing the first blue link
    if (isSAINNavigationalExperienceEnabled && smartAnswersPortalRef?.current) {
        const workspaceId = getWorkspaceId();
        return /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
            section: "search-page-smart-answers-nav-card",
            fallback: searchResultComponent,
            onException: (error)=>{
                (0, $7Evbj.logException)(error);
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                id: "search-page-smart-answers",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6406541fb8ffe635$export$b8e08e4af5c98a73), {
                    searchResultData: {
                        ...data,
                        url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
                            url: data.url,
                            query: query,
                            searchSessionId: searchSessionId
                        }),
                        query: query,
                        searchSessionId: searchSessionId,
                        cloudId: cloudId || '',
                        areLLMPoweredFeaturesEnabled: (0, $eb4a02b80e2ab764$export$3afecd2a83596299)(appMode, isAdminHubAIEnabled, isRovoLLMEnabled),
                        primaryProduct: primaryProduct ?? 'unknown',
                        extractedLinks: (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(data.description),
                        linkedResults: linkedResults
                    },
                    onNavigate: onNavigate,
                    source: (0, $6yNqK.EVENT_SOURCE),
                    workspaceId: workspaceId ?? '',
                    navBoostScore: (0, $dh538.fg)('kd_enable_nav_boost_score') ? data.navBoostScore : undefined,
                    searchPageAnalyticsCallbacks: {
                        onResultClicked: onResultClicked,
                        onResultContextMenu: onResultCtxMenuClicked,
                        onCopyLinkButtonClicked: onCopyLinkButtonClicked
                    }
                })
            })
        }), smartAnswersPortalRef.current, 'search-page-smart-answers-nav-card');
    }
    return searchResultComponent;
};





/**
 * @generated SignedSource<<b98fc05db8b5993a75eaa6c5b7c46fbd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2ae640618ea5e94a$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeIconUrl"
        }
    ],
    "kind": "Fragment",
    "name": "searchConfluenceSpace_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "condition": "includeIconUrl",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "lastModified"
        }
    ],
    "type": "SearchConfluenceSpace"
};
$2ae640618ea5e94a$var$node.hash = "0c267c1ef1d1bacf6c1b9971a73d0911";
var $2ae640618ea5e94a$export$2e2bcd8739ae039 = $2ae640618ea5e94a$var$node;














































const $38a1e03191a959a6$export$4619f000f23ee8d1 = (node)=>{
    return node?.__typename === 'SearchConfluenceSpace';
};
const $38a1e03191a959a6$export$f3b885cf8bfefc5f = ({ node: node, position: position, cloudId: cloudId, searchQuery: query, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $2ae640618ea5e94a$export$2e2bcd8739ae039), node);
    const [features] = (0, $j4ply.useFeatures)();
    const isSideBySideEnabled = features?.sideBySide?.enabled;
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        let containerId = null;
        return {
            id: data.id,
            containerId: containerId,
            spaceId: containerId,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product,
            isSideBySideEnabled: isSideBySideEnabled
        };
    }, [
        data,
        isSideBySideEnabled
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const metadataParts = [
        [
            'type',
            (0, $kXlQy.getSearchResultType)(data.type)
        ],
        [
            'last-modified',
            data.lastModified && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                lastModified: data.lastModified
            })
        ]
    ];
    let icon;
    if ((0, $dh538.fg)('rovo_search_confluence_icons_fps')) icon = (0, $2waBy.getConfluenceEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        size: 'medium'
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Confluence,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
            url: data.url,
            query: query,
            searchSessionId: searchSessionId
        }),
        title: (0, $Y34Hw.enrichExcerpt)(data.title),
        icon: icon,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(data.description)
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<c38ba491f56703337a59063ddfa7084b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $187ddf73ef2601a7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchDefaultRenderer_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ],
    "type": "SearchResult",
    "abstractKey": "__isSearchResult"
};
$187ddf73ef2601a7$var$node.hash = "d7dbec072d57a60ae7acb966e96f70e5";
var $187ddf73ef2601a7$export$2e2bcd8739ae039 = $187ddf73ef2601a7$var$node;



























const $d75f7c12f192fdc3$export$7397c326dc16df01 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $187ddf73ef2601a7$export$2e2bcd8739ae039), node);
    const { id: id, url: url, type: type, title: title, description: description } = data;
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(id);
        return {
            id: id,
            containerId: null,
            spaceId: null,
            contentType: type,
            entityType: type,
            contentId: contentId,
            product: product
        };
    }, [
        id,
        type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const enrichedTitle = (0, $Y34Hw.enrichExcerpt)(title);
    const encrichedBody = description && /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(description)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        title: enrichedTitle,
        icon: /*#__PURE__*/ (0, $l998X.jsx)($d75f7c12f192fdc3$export$cd8dc052ba8808af, {}),
        headerMetadataParts: [],
        description: encrichedBody,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $d75f7c12f192fdc3$export$cd8dc052ba8808af = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });





/**
 * @generated SignedSource<<6b63e831b956ec0f2187ea294197b4eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $733a2991b57ecebd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchFederatedResult_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchFederatedEmail_AtlassianSearchPage"
        }
    ],
    "type": "SearchResultFederated"
};
$733a2991b57ecebd$var$node.hash = "54b396c04e9434e8bfcf5a97cc47d5fa";
var $733a2991b57ecebd$export$2e2bcd8739ae039 = $733a2991b57ecebd$var$node;















var $eakyO = parcelRequire("eakyO");





parcelRequire("42omo");







const $5d3d637dc8569dd3$export$7819ed9db7396ac5 = ({ product: product, resourceType: resourceType })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    let productKey;
    if (product === 'google' && resourceType === 'email') productKey = (0, $1yEFx.ProductKeys).Gmail;
    else if (product === 'microsoft' && resourceType === 'email') productKey = (0, $1yEFx.ProductKeys).OutlookMail;
    if (!productKey) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
    let IconComponent = products[productKey]?.SearchResultIcon;
    return IconComponent ? /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
        label: ""
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
};





















/**
 * @generated SignedSource<<f68afa9f9a0d13be6d63b78f28942c15>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0d3940576703a81$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchFederatedEmail_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "LinkedField",
            "name": "entity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "SearchFederatedEmailUser",
                            "kind": "LinkedField",
                            "name": "sender",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ],
                    "type": "SearchFederatedEmailEntity"
                }
            ]
        }
    ],
    "type": "SearchResultFederated"
};
$b0d3940576703a81$var$node.hash = "fe6e2341012e955a1fe71d28c0a79382";
var $b0d3940576703a81$export$2e2bcd8739ae039 = $b0d3940576703a81$var$node;


parcelRequire("42omo");

















parcelRequire("42omo");





var $4wwVl = parcelRequire("4wwVl");










const $821eab66233151f6$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    personAvatarLabel: {
        id: "search-page.profile-avatar.label",
        defaultMessage: "Person Avatar"
    }
});


const $678a8075b20296fe$var$personAvatarColor = "var(--ds-icon, #292A2E)";
const $678a8075b20296fe$var$defaultAvatarCSS = (0, $ecnYn.xcss)({
    padding: 'space.025',
    alignItems: 'center',
    display: 'flex'
});
const $678a8075b20296fe$var$avatarCSS = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex',
    marginInlineEnd: 'space.025'
});
const $678a8075b20296fe$export$3778be82376b06d7 = ({ name: name, picture: picture })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (name) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        testId: "3p-message-avatar",
        xcss: $678a8075b20296fe$var$avatarCSS,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0a3a41d6257d9b3$export$e2255cf6045e8d47), {
            variant: picture ? {
                type: 'profile-pic',
                src: picture,
                name: name
            } : {
                type: 'initials',
                name: name
            },
            size: "smaller"
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $678a8075b20296fe$var$defaultAvatarCSS,
        testId: "3p-message-avatar",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4wwVl))), {
            label: formatMessage((0, $821eab66233151f6$export$defe85febe8b728c).personAvatarLabel),
            color: $678a8075b20296fe$var$personAvatarColor
        })
    });
};











const $d3beec6ca8114fa5$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    emailLabel: {
        id: "search-federated-result.email.label",
        defaultMessage: "Email"
    },
    inboxLabel: {
        id: "search-federated-result.inbox.label",
        defaultMessage: "Inbox"
    },
    sentLabel: {
        id: "search-federated-result.sent.label",
        defaultMessage: "{person} sent"
    },
    forwardedLabel: {
        id: "search-federated-result.forwarded.label",
        defaultMessage: "{person} forwarded"
    },
    externalPersonLabel: {
        id: "search-federated-result.external-person.label",
        defaultMessage: "External person"
    },
    timestampLabel: {
        id: "search-federated-result.timestamp.label",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{formattedDate}"
    }
});


const $e3908224cc055321$var$styles = {
    nameContainer: "_o5721q9c"
};
const $e3908224cc055321$export$5376c8ad9cf3a7c7 = ({ node: node, position: position, product: product, icon: icon, cloudId: cloudId, appMode: appMode, selectedProduct: selectedProduct, primaryProduct: primaryProduct, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $b0d3940576703a81$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { id: id, lastModifiedDate: lastModifiedDate, url: url, title: title, description: description, entity: entity } = data;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate,
        message: (0, $d3beec6ca8114fa5$export$defe85febe8b728c).timestampLabel
    }) : null;
    const label = /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        ...(0, $d3beec6ca8114fa5$export$defe85febe8b728c).emailLabel
    });
    const inboxLabel = /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        ...(0, $d3beec6ca8114fa5$export$defe85febe8b728c).inboxLabel
    });
    const fullName = entity?.sender?.name || '';
    const firstName = fullName?.split(' ')?.[0] || formatMessage((0, $d3beec6ca8114fa5$export$defe85febe8b728c).externalPersonLabel);
    const actionLabel = formatMessage((0, $d3beec6ca8114fa5$export$defe85febe8b728c).sentLabel, {
        person: firstName
    });
    const metadataParts = [
        [
            'label',
            label
        ],
        [
            'inbox',
            inboxLabel
        ],
        [
            'lastModified',
            lastModifiedComponent
        ],
        [
            'sender',
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                        name: fullName
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $e3908224cc055321$var$styles.nameContainer,
                        children: actionLabel
                    })
                ]
            })
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        headerMetadataParts: metadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(description)
        }),
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        isThirdParty: true,
        mainContentWidth: mainContentWidth
    });
};


const $64821cc7b4fbd082$var$styles = {
    typeLabelContainer: "_299m1dk0"
};
const $64821cc7b4fbd082$var$getLabel = (entityNoun)=>entityNoun.replace(/-/g, ' ');
var $64821cc7b4fbd082$var$ResourceType = /*#__PURE__*/ function(ResourceType) {
    ResourceType["EMAIL"] = "email";
    return ResourceType;
}($64821cc7b4fbd082$var$ResourceType || {});
const $64821cc7b4fbd082$export$b3f67b85a605a606 = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, appMode: appMode, selectedProduct: selectedProduct, searchQuery: searchQuery, searchSessionId: searchSessionId, mainContentWidth: mainContentWidth, thirdPartyConfigs: thirdPartyConfigs })=>{
    const data = (0, $irOoi.useFragment)((0, $733a2991b57ecebd$export$2e2bcd8739ae039), node);
    const { resourceId: resourceId, resourceOwner: product, resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(data.id);
    const metadata = (0, $42omo.useMemo)(()=>{
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: resourceType,
            entityType: resourceType,
            contentId: resourceId,
            product: product,
            // it's federated so always false in this component
            is3PSmartLink: false,
            connectorType: (0, $eakyO.ConnectorSources).Federated
        };
    }, [
        resourceId,
        product,
        resourceType,
        data.id
    ]);
    const is3PClickIngestionEnabled = (0, $2OtFZ.serve3PClickIngestionExperiment)(thirdPartyConfigs || {}, {
        fireExperimentExposure: false
    });
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position,
        is3PClickIngestionEnabled: is3PClickIngestionEnabled
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position,
        is3PClickIngestionEnabled: is3PClickIngestionEnabled
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $5d3d637dc8569dd3$export$7819ed9db7396ac5), {
        product: product,
        resourceType: resourceType
    });
    if (resourceType === "email") return /*#__PURE__*/ (0, $l998X.jsx)((0, $e3908224cc055321$export$5376c8ad9cf3a7c7), {
        node: data,
        position: position,
        product: product,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        selectedProduct: selectedProduct,
        searchQuery: searchQuery,
        searchSessionId: searchSessionId,
        appMode: appMode,
        icon: icon,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        mainContentWidth: mainContentWidth
    });
    const { id: id, lastModifiedDate: lastModifiedDate, url: url, title: title, description: description } = data;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const label = $64821cc7b4fbd082$var$getLabel(metadata.entityType);
    const headerMetadataParts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $64821cc7b4fbd082$var$styles.typeLabelContainer,
                children: label
            })
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(description)
        }),
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $64821cc7b4fbd082$export$59a100e12914442b = (node)=>{
    return node?.__typename === 'SearchResultFederated';
};





/**
 * @generated SignedSource<<f387b6e5d18c74f361e0d98fa5144685>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bc37e735c0a85c0e$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": true,
            "kind": "LocalArgument",
            "name": "includeThirdPartyId"
        }
    ],
    "kind": "Fragment",
    "name": "searchGraphResult_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "providerId"
        },
        {
            "kind": "ScalarField",
            "name": "connectorType"
        },
        {
            "kind": "ScalarField",
            "name": "integrationId"
        },
        {
            "kind": "ScalarField",
            "name": "subtype"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphBranch_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphCalendar_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphComment_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphCommit_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphConfluenceDc_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphConversation_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphCampaign_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphCase_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphCustomerOrg_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphDeal_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphDefault_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphDesign_AtlassianSearchPage"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "includeThirdPartyId",
                    "variableName": "includeThirdPartyId"
                }
            ],
            "kind": "FragmentSpread",
            "name": "searchGraphDocument_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphMessage_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphJiraDc_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphPullRequest_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphRepository_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphVideo_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphWorkItem_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphDashboard_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphDataTable_AtlassianSearchPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "searchGraphCustomerContact_AtlassianSearchPage"
        }
    ],
    "type": "SearchResultGraphDocument"
};
$bc37e735c0a85c0e$var$node.hash = "443f2736e49b4756f797d46d84eeb155";
var $bc37e735c0a85c0e$export$2e2bcd8739ae039 = $bc37e735c0a85c0e$var$node;












var $7ZetK = parcelRequire("7ZetK");









var $gRvZB = parcelRequire("gRvZB");



















/**
 * @generated SignedSource<<45b4474fd832bc1b9164bc25a9fbd931>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $54951185c35bf8b1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphBranch_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v3 /*: any*/ 
                                        ],
                                        "type": "ExternalRepository"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalBranch"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$54951185c35bf8b1$var$node.hash = "18a24dc86d2787d5d678dbcfc92fb480";
var $54951185c35bf8b1$export$2e2bcd8739ae039 = $54951185c35bf8b1$var$node;


parcelRequire("42omo");

















var $9NPDv = parcelRequire("9NPDv");




const $9cd64de2d6b50ca9$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    resultLabel: {
        id: "search-branch-result.label",
        defaultMessage: "Branch"
    }
});


const $c04256cd812d51cc$export$e7f66f0a0905935e = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $54951185c35bf8b1$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity } = data;
    const { name: branchName, container: container } = entity || {};
    const label = formatMessage((0, $9cd64de2d6b50ca9$export$defe85febe8b728c).resultLabel);
    // TODO: Wire up real build status data when GraphQL schema is available
    // const buildStatusComponent = isCiCdEnabled ? (
    // const isCiCdEnabled = fg('rovo_fps_enable_git_ui_ci_cd');
    // 	<GitBuildStatus build={placeholderBuildStatus} testId="branch-build-status" />
    // ) : null;
    const buildStatusComponent = null;
    const titleMetadataParts = buildStatusComponent ? [
        [
            'build-status',
            buildStatusComponent
        ]
    ] : [];
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $9NPDv.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const headerMetadataParts = [
        label,
        [
            'repository-name',
            container?.name ?? null
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: '',
        headerMetadataParts: headerMetadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts,
            displaySpacer: false
        }),
        title: branchName,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth,
        footer: footerComponent
    });
};





/**
 * @generated SignedSource<<1e0aee726686afe605e5447f136e9e23>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $abce0ea31e67f251$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "description"
    }, v4 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "eventEndTime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "eventStartTime"
    }, v7 = {
        "kind": "ScalarField",
        "name": "videoMeetingUrl"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphCalendar_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            v4 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            }
                                        ]
                                    }
                                ]
                            },
                            v5 /*: any*/ ,
                            v6 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "recurringEventId"
                            },
                            v7 /*: any*/ 
                        ],
                        "type": "ExternalCalendarEvent"
                    }
                ]
            },
            {
                "concreteType": "SearchResultGraphDocument",
                "kind": "LinkedField",
                "name": "linkedEntities",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v6 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v7 /*: any*/ 
                                ],
                                "type": "ExternalCalendarEvent"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "lastModifiedDate"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$abce0ea31e67f251$var$node.hash = "fe83f0e60cf642e25009d9ac9051f446";
var $abce0ea31e67f251$export$2e2bcd8739ae039 = $abce0ea31e67f251$var$node;

















var $8DN9t = parcelRequire("8DN9t");








var $2Yaht = parcelRequire("2Yaht");




















parcelRequire("42omo");




const $e050b981814f4361$export$10f53ee736dae147 = ({ date: date })=>{
    if (!date) return null;
    const event = new Date(date);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedDate), {
        value: event,
        month: "short",
        day: "numeric",
        year: "numeric"
    });
};











/**
 * Returns a date and time range based on two date strings
 * @example 10-11 AM
 */ const $428ad5ad3a150038$export$abc17c795ac8b09b = ({ from: from, to: to })=>{
    const fromDate = new Date(from);
    const toDate = new Date(to);
    const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric'
    });
    const fromDateParts = dateTimeFormat.format(fromDate);
    const toDateParts = dateTimeFormat.format(toDate);
    return `${fromDateParts} - ${toDateParts}`;
};











const $a6e233594fbb8ba2$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    eventLabel: {
        id: "search-graph-calendar.calendar-label",
        defaultMessage: "Calendar"
    },
    meetingLink: {
        id: "search-graph-calendar.meeting-link",
        defaultMessage: "Meeting link"
    },
    joinMeetingLink: {
        id: "search-graph-calendar.join-meeting-link",
        defaultMessage: "Join meeting"
    },
    meetingLinkIcon: {
        id: "search-graph-calendar.meeting-link-icon",
        defaultMessage: "Join meeting"
    },
    recurringEventIcon: {
        id: "search-graph-calendar.recurring-event-icon",
        defaultMessage: "Recurring event"
    },
    recurringMetadataLabel: {
        id: "search-graph-calendar.recurring-event-label",
        defaultMessage: "Recurring"
    },
    upcomingEventsButton: {
        id: "search-graph-calendar.upcoming-events-button",
        defaultMessage: "Upcoming events"
    },
    pastEventsButton: {
        id: "search-graph-calendar.past-events-button",
        defaultMessage: "Past events"
    },
    created: {
        id: "search-graph-calendar.created.placeholder",
        defaultMessage: "{person} created"
    },
    externalPerson: {
        id: "search-graph-calendar.external-person",
        defaultMessage: "External person"
    }
});


const $c25124bad4c60a80$var$RELATED_EVENTS_STATE = {
    UPCOMING: 'upcoming',
    PAST: 'past',
    CLOSED: 'closed'
};
const $c25124bad4c60a80$export$137e3167f558cbc3 = ({ fromDate: fromDate, toDate: toDate, meetingLink: meetingLink })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (!fromDate || !meetingLink || !toDate) return null;
    const currentDate = new Date();
    const startDate = new Date(fromDate);
    startDate.setHours(startDate.getHours() - 2); // Checks if the event is within 2 hours
    const endDate = new Date(toDate);
    const eventIsWithin2hoursOrIsOngoing = startDate < currentDate && currentDate < endDate;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
        iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
                color: "var(--ds-icon-subtle)",
                label: ''
            }),
        href: meetingLink,
        children: eventIsWithin2hoursOrIsOngoing ? formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).joinMeetingLink) : formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).meetingLink)
    });
};
const $c25124bad4c60a80$var$calendarEventLinkStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        color: 'color.link',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    },
    display: 'flex'
});
const $c25124bad4c60a80$var$relatedCalendarEventMetadataStyles = (0, $ecnYn.xcss)({
    gridColumn: 2,
    alignItems: 'center'
});
const $c25124bad4c60a80$var$nameContainer = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
const $c25124bad4c60a80$var$RelatedCalendarEvents = ({ calendarEvents: calendarEvents })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cwkWT.default), {
        gap: "space.200",
        children: calendarEvents.map((calendarEvent)=>{
            const { id: id, entity: entity, title: title, url: url } = calendarEvent;
            if (!entity) return null;
            const labelMessageComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).eventLabel)
            });
            const eventDateComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e050b981814f4361$export$10f53ee736dae147), {
                    date: entity.eventStartTime
                })
            });
            const eventTimeComponent = entity.eventStartTime && entity.eventEndTime ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: (0, $428ad5ad3a150038$export$abc17c795ac8b09b)({
                    from: entity.eventStartTime,
                    to: entity.eventEndTime
                })
            }) : null;
            const meetingLink = entity.videoMeetingUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                    xcss: $c25124bad4c60a80$var$calendarEventLinkStyles,
                    href: entity.videoMeetingUrl,
                    children: formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).meetingLink)
                })
            }) : null;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                templateColumns: "min-content 1fr",
                alignItems: "center",
                columnGap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                        label: formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).recurringEventIcon),
                        size: "medium",
                        color: "var(--ds-icon-accent-blue, #357DE8)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        size: "small",
                        weight: "semibold",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                            xcss: $c25124bad4c60a80$var$calendarEventLinkStyles,
                            href: url,
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                        xcss: $c25124bad4c60a80$var$relatedCalendarEventMetadataStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
                            parts: [
                                [
                                    'calendar-label',
                                    labelMessageComponent
                                ],
                                [
                                    'event-date',
                                    eventDateComponent
                                ],
                                [
                                    'event-time',
                                    eventTimeComponent
                                ],
                                [
                                    'meeting-link',
                                    meetingLink
                                ]
                            ]
                        })
                    })
                ]
            }, id);
        })
    });
};
const $c25124bad4c60a80$var$calendarEventActionStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100'
});
const $c25124bad4c60a80$var$CalendarEventActions = ({ fromDate: fromDate, toDate: toDate, meetingLink: meetingLink, linkedEntities: linkedEntities })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [relatedEventsState, setEventsToDisplay] = (0, $42omo.useState)($c25124bad4c60a80$var$RELATED_EVENTS_STATE.CLOSED);
    const isUpcomingEventsSelected = relatedEventsState === $c25124bad4c60a80$var$RELATED_EVENTS_STATE.UPCOMING;
    const isPastEventsSelected = relatedEventsState === $c25124bad4c60a80$var$RELATED_EVENTS_STATE.PAST;
    const data = (0, $42omo.useMemo)(()=>{
        const currentDate = new Date();
        const linkedCalendarEvents = linkedEntities.flatMap((linkedEntity)=>linkedEntity.entity ? [
                {
                    id: linkedEntity.id,
                    title: linkedEntity.title,
                    url: linkedEntity.url,
                    entity: linkedEntity.entity
                }
            ] : []);
        const [pastEvents, upcomingEvents] = linkedCalendarEvents.reduce((events, currentEvent)=>{
            const isPastEvent = currentEvent.entity.eventStartTime && new Date(currentEvent.entity.eventStartTime) < currentDate;
            if (isPastEvent) return [
                events[0].concat(currentEvent),
                events[1]
            ];
            return [
                events[0],
                events[1].concat(currentEvent)
            ];
        }, [
            [],
            []
        ]);
        return {
            pastEvents: pastEvents,
            upcomingEvents: upcomingEvents
        };
    }, [
        linkedEntities
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
        gap: "space.200",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $c25124bad4c60a80$var$calendarEventActionStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($c25124bad4c60a80$export$137e3167f558cbc3, {
                        fromDate: fromDate,
                        toDate: toDate,
                        meetingLink: meetingLink
                    }),
                    !!data.upcomingEvents.length && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        iconAfter: (iconProps)=>isUpcomingEventsSelected ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                ...iconProps,
                                size: "small"
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                ...iconProps,
                                size: "small"
                            }),
                        onClick: ()=>setEventsToDisplay(isUpcomingEventsSelected ? $c25124bad4c60a80$var$RELATED_EVENTS_STATE.CLOSED : $c25124bad4c60a80$var$RELATED_EVENTS_STATE.UPCOMING),
                        isSelected: isUpcomingEventsSelected,
                        children: formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).upcomingEventsButton)
                    }),
                    !!data.pastEvents.length && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        iconAfter: (iconProps)=>isPastEventsSelected ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                ...iconProps,
                                size: "small"
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                ...iconProps,
                                size: "small"
                            }),
                        onClick: ()=>setEventsToDisplay(isPastEventsSelected ? $c25124bad4c60a80$var$RELATED_EVENTS_STATE.CLOSED : $c25124bad4c60a80$var$RELATED_EVENTS_STATE.PAST),
                        isSelected: isPastEventsSelected,
                        children: formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).pastEventsButton)
                    })
                ]
            }),
            relatedEventsState === $c25124bad4c60a80$var$RELATED_EVENTS_STATE.UPCOMING && /*#__PURE__*/ (0, $l998X.jsx)($c25124bad4c60a80$var$RelatedCalendarEvents, {
                calendarEvents: data.upcomingEvents
            }),
            relatedEventsState === $c25124bad4c60a80$var$RELATED_EVENTS_STATE.PAST && /*#__PURE__*/ (0, $l998X.jsx)($c25124bad4c60a80$var$RelatedCalendarEvents, {
                calendarEvents: data.pastEvents
            })
        ]
    });
};
const $c25124bad4c60a80$export$aafb10d415667378 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, is3pGroupingEnabled: is3pGroupingEnabled, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $abce0ea31e67f251$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { url: url, description: description, permissionLevel: permissionLevel, entity: entity, title: title, linkedEntities: linkedEntities, excerpt: excerpt, integrationId: integrationId } = data;
    const calendarEvent = (0, $42omo.useMemo)(()=>{
        const eventTime = entity?.eventStartTime && entity?.eventEndTime ? (0, $428ad5ad3a150038$export$abc17c795ac8b09b)({
            from: entity?.eventStartTime,
            to: entity?.eventEndTime
        }) : null;
        const recurringEvent = entity?.recurringEventId ? formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).recurringMetadataLabel) : null;
        const getCreator = ()=>{
            const fullName = entity?.createdBy?.thirdPartyUser?.name || '';
            const firstName = fullName?.split(' ')?.[0] || formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).externalPerson);
            const actionLabel = formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).created, {
                person: firstName
            });
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                        name: fullName
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $c25124bad4c60a80$var$nameContainer,
                        children: actionLabel
                    })
                ]
            });
        };
        return {
            labelMessage: formatMessage((0, $a6e233594fbb8ba2$export$defe85febe8b728c).eventLabel),
            eventTime: eventTime,
            recurringEvent: recurringEvent,
            createdBy: getCreator()
        };
    }, [
        entity,
        formatMessage
    ]);
    const eventDateComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $e050b981814f4361$export$10f53ee736dae147), {
        date: entity?.eventStartTime
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        paddingBlockEnd: "space.100",
        children: description
    });
    const padlockIcon = (0, $9NPDv.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const headerMetadataParts = [
        calendarEvent.labelMessage,
        [
            'event-date',
            eventDateComponent
        ],
        [
            'event-time',
            calendarEvent.eventTime
        ],
        calendarEvent.recurringEvent,
        [
            'padlock',
            padlockIcon
        ],
        [
            'createdBy',
            calendarEvent.createdBy
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const isGoogleCalendar = integrationId === 'ari:cloud:platform::integration/google';
    const shouldRenderSimilarResults = isGoogleCalendar && linkedResults?.some((linkedResult)=>linkedResult.category?.toUpperCase() === 'SIMILAR');
    const shouldShowRelatedLinks = linkedResults && linkedResults.length > 0;
    const footerComponent = shouldShowRelatedLinks ? shouldRenderSimilarResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$59c57a80401f0a6), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        isAllProductSelected: !selectedProduct,
        onResultContextMenu: onResultContextMenu,
        is3pGroupingEnabled: is3pGroupingEnabled,
        fallbackType: "calendar"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    }) : /*#__PURE__*/ (0, $l998X.jsx)($c25124bad4c60a80$var$CalendarEventActions, {
        meetingLink: entity?.videoMeetingUrl,
        fromDate: entity?.eventStartTime,
        toDate: entity?.eventEndTime,
        linkedEntities: linkedEntities ?? []
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: excerpt ? (0, $Y34Hw.processExcerpt)(excerpt, true) : body
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<9948beefc42ad4591db686515a3d62e6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3b6f3e9e44b2e542$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v4 = [
        {
            "concreteType": "ThirdPartyUser",
            "kind": "LinkedField",
            "name": "thirdPartyUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphCampaign_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "endDate"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "lastUpdated"
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "owners",
                                "plural": true,
                                "selections": v4 /*: any*/ 
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": v4 /*: any*/ 
                            }
                        ],
                        "type": "ExternalCampaign"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v2 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$3b6f3e9e44b2e542$var$node.hash = "d9dc4823e19ba6981e09da96d704b382";
var $3b6f3e9e44b2e542$export$2e2bcd8739ae039 = $3b6f3e9e44b2e542$var$node;


parcelRequire("42omo");


















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















const $2bd4a834f1261b6f$var$styles = {
    content: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $2bd4a834f1261b6f$var$MAX_STATUS_LENGTH = 20;
const $2bd4a834f1261b6f$export$99514a272b734f96 = ({ statusText: statusText, popupContent: popupContent, defaultOpen: defaultOpen = false })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(defaultOpen);
    const truncatedStatusText = statusText.length > $2bd4a834f1261b6f$var$MAX_STATUS_LENGTH ? `${statusText.slice(0, $2bd4a834f1261b6f$var$MAX_STATUS_LENGTH)}...` : statusText;
    const defaultPopupContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $2bd4a834f1261b6f$var$styles.content,
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            children: statusText
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "right-start",
        content: ()=>popupContent ?? defaultPopupContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: statusText,
                position: "auto",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...triggerProps,
                    isSelected: isOpen,
                    appearance: "subtle",
                    spacing: "compact",
                    onClick: ()=>setIsOpen(!isOpen),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        children: truncatedStatusText
                    })
                })
            })
    });
};








const $e402fe4c012b1f99$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    campaignLabel: {
        id: "search-graph-campaign.campaign-label",
        defaultMessage: "Campaign"
    },
    endedOn: {
        id: "search-graph-campaign.ended-on",
        defaultMessage: "Ended on {date}"
    },
    endsOn: {
        id: "search-graph-campaign.ends-on",
        defaultMessage: "Ends on {date}"
    }
});


const $0b30e0258a8db6c5$var$styles = {
    campaignContainer: "_1bsb1osq",
    resultWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
    content: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $0b30e0258a8db6c5$export$3596f4e18e688c6e = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $aXWIB.useIntl)();
    const data = (0, $irOoi.useFragment)((0, $3b6f3e9e44b2e542$export$2e2bcd8739ae039), node);
    const { id: id, url: url, title: title, lastModifiedDate: lastModifiedDate, excerpt: excerpt, entity: entity } = data;
    const ownerName = entity?.owners?.[0]?.thirdPartyUser?.name ?? entity?.createdBy?.thirdPartyUser?.name;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: entity?.lastUpdated ?? lastModifiedDate
    });
    const description = /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.enrichExcerpt)(excerpt)
    });
    const statusText = entity?.status ?? '';
    const endDateValue = entity?.endDate ? new Date(entity.endDate) : null;
    const formattedEndDate = endDateValue ? formatDate(endDateValue, {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    }) : '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endDateMessage = endDateValue && endDateValue >= today ? (0, $e402fe4c012b1f99$export$defe85febe8b728c).endsOn : (0, $e402fe4c012b1f99$export$defe85febe8b728c).endedOn;
    const endDatePopupContent = endDateValue ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $0b30e0258a8db6c5$var$styles.content,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...endDateMessage,
            values: {
                date: formattedEndDate
            }
        })
    }) : undefined;
    const headerMetadataParts = [
        formatMessage((0, $e402fe4c012b1f99$export$defe85febe8b728c).campaignLabel),
        // Note: parent/location omitted — ExternalCampaign has containerId only (no hydration)
        [
            'owner',
            ownerName
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        gap: "space.100",
        alignItems: "start",
        role: "listitem",
        xcss: $0b30e0258a8db6c5$var$styles.campaignContainer,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $0b30e0258a8db6c5$var$styles.resultWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
                    id: id,
                    product: product,
                    productSelected: !!selectedProduct,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultContextMenu,
                    onCopyLinkButtonClicked: onCopyLinkButtonClicked,
                    onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
                    onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
                    onContextMenuButtonClicked: onContextMenuButtonClicked,
                    icon: icon,
                    description: description,
                    headerMetadataParts: headerMetadataParts,
                    title: (0, $Y34Hw.enrichExcerpt)(title),
                    role: "none",
                    url: url,
                    isThirdParty: true,
                    cloudId: cloudId,
                    primaryProduct: primaryProduct,
                    position: position,
                    partial: data,
                    appMode: appMode,
                    footer: footerComponent,
                    hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
                    mainContentWidth: mainContentWidth
                })
            }),
            statusText && /*#__PURE__*/ (0, $l998X.jsx)((0, $2bd4a834f1261b6f$export$99514a272b734f96), {
                statusText: statusText,
                popupContent: endDatePopupContent
            })
        ]
    });
};





/**
 * @generated SignedSource<<3d5f172d7da836295264e600a892de2f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3293f5c9676261c9$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ], v5 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v4 /*: any*/ 
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphCase_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "displayNumber"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "closedAt"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "lastUpdated"
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "owners",
                                "plural": true,
                                "selections": [
                                    v5 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": v4 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                    v5 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            }
                                        ],
                                        "type": "ExternalCustomerOrg"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalCase"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v2 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$3293f5c9676261c9$var$node.hash = "0568058d7927569b5e9009ace5205ae5";
var $3293f5c9676261c9$export$2e2bcd8739ae039 = $3293f5c9676261c9$var$node;


parcelRequire("42omo");

























const $d4450a9781dfdef1$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    caseLabel: {
        id: "search-graph-case.case-label",
        defaultMessage: "Case"
    },
    closedOn: {
        id: "search-graph-case.closed-on",
        defaultMessage: "Closed on {date}"
    },
    closesOn: {
        id: "search-graph-case.closes-on",
        defaultMessage: "Closes on {date}"
    }
});


const $c1f708c33175b5a1$var$styles = {
    caseContainer: "_1bsb1osq",
    resultWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
    content: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $c1f708c33175b5a1$export$6880787011d90d36 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $aXWIB.useIntl)();
    const data = (0, $irOoi.useFragment)((0, $3293f5c9676261c9$export$2e2bcd8739ae039), node);
    const { id: id, url: url, title: title, lastModifiedDate: lastModifiedDate, excerpt: excerpt, entity: entity } = data;
    const ownerName = entity?.owners?.[0]?.thirdPartyUser?.name ?? entity?.owners?.[0]?.user?.name ?? entity?.createdBy?.thirdPartyUser?.name;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: entity?.lastUpdated ?? lastModifiedDate
    });
    const description = /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.enrichExcerpt)(excerpt)
    });
    const statusText = entity?.status ?? '';
    const closedAtValue = entity?.closedAt ? new Date(entity.closedAt) : null;
    const formattedClosedAt = closedAtValue ? formatDate(closedAtValue, {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    }) : '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const closedAtMessage = closedAtValue && closedAtValue >= today ? (0, $d4450a9781dfdef1$export$defe85febe8b728c).closesOn : (0, $d4450a9781dfdef1$export$defe85febe8b728c).closedOn;
    const closedAtPopupContent = closedAtValue ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $c1f708c33175b5a1$var$styles.content,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...closedAtMessage,
            values: {
                date: formattedClosedAt
            }
        })
    }) : undefined;
    const containerName = entity?.container?.displayName;
    const headerMetadataParts = [
        formatMessage((0, $d4450a9781dfdef1$export$defe85febe8b728c).caseLabel),
        containerName,
        [
            'owner',
            ownerName
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        gap: "space.100",
        alignItems: "start",
        role: "listitem",
        xcss: $c1f708c33175b5a1$var$styles.caseContainer,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $c1f708c33175b5a1$var$styles.resultWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
                    id: id,
                    product: product,
                    productSelected: !!selectedProduct,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultContextMenu,
                    onCopyLinkButtonClicked: onCopyLinkButtonClicked,
                    onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
                    onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
                    onContextMenuButtonClicked: onContextMenuButtonClicked,
                    icon: icon,
                    description: description,
                    headerMetadataParts: headerMetadataParts,
                    title: entity?.displayNumber ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                as: "span",
                                color: "color.link",
                                children: entity.displayNumber
                            }),
                            ' ',
                            (0, $Y34Hw.enrichExcerpt)(title)
                        ]
                    }) : (0, $Y34Hw.enrichExcerpt)(title),
                    role: "none",
                    url: url,
                    isThirdParty: true,
                    cloudId: cloudId,
                    primaryProduct: primaryProduct,
                    position: position,
                    partial: data,
                    appMode: appMode,
                    footer: footerComponent,
                    hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
                    mainContentWidth: mainContentWidth
                })
            }),
            statusText && /*#__PURE__*/ (0, $l998X.jsx)((0, $2bd4a834f1261b6f$export$99514a272b734f96), {
                statusText: statusText,
                popupContent: closedAtPopupContent
            })
        ]
    });
};





/**
 * @generated SignedSource<<8572acdccf2a51db6cd2bf8fb8e5903c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $13c3fde251b8ec2f$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphComment_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            v3 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            },
                                            v2 /*: any*/ 
                                        ],
                                        "type": "ExternalSpace"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalComment"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$13c3fde251b8ec2f$var$node.hash = "b17f6d38cfefaa62af51c3cdcd08a442";
var $13c3fde251b8ec2f$export$2e2bcd8739ae039 = $13c3fde251b8ec2f$var$node;


parcelRequire("42omo");








var $hB77E = parcelRequire("hB77E");














const $463097be5d0afaf7$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    resultLabel: {
        id: "comment-result.label",
        defaultMessage: "Comment"
    }
});


const $318bc8ae651e831c$export$9c9dc84757cc5710 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const data = (0, $irOoi.useFragment)((0, $13c3fde251b8ec2f$export$2e2bcd8739ae039), node);
    const { id: id, url: url, title: title, excerpt: excerpt, entity: entity, lastModifiedDate: lastModifiedDate } = data;
    const lastModifiedComponent = lastModifiedDate && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const label = formatMessage((0, $463097be5d0afaf7$export$defe85febe8b728c).resultLabel);
    const containerName = entity?.container?.displayName;
    const containerUrl = entity?.container?.url;
    const container = containerUrl && containerName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
        label: containerName,
        href: containerUrl
    }) : containerName;
    // only include site if DC product
    // NOTE: jira-dc results now go through JiraDcSearchResult component
    // this component can be removed once a custom ConfluenceDcSearchResult component is made
    const site = product === (0, $hB77E.ProductKeys3P).ConfluenceDC ? thirdPartyConfigs?.[product]?.workspaceName || null : null;
    const headerMetadataParts = [
        [
            'label',
            label
        ],
        [
            'site',
            site
        ],
        [
            'container',
            container
        ],
        [
            'lastModified',
            lastModifiedComponent
        ]
    ];
    const enrichedTitle = (0, $Y34Hw.enrichExcerpt)(title);
    const description = excerpt && /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(excerpt)
    });
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        title: enrichedTitle,
        description: description,
        headerMetadataParts: headerMetadataParts,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        isThirdParty: true,
        icon: icon,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<0c1122be3df45d696ae8fbf1caddd5f8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2202b2805c605b9$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphCommit_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "initialContributors",
                "plural": true,
                "selections": v5 /*: any*/ 
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": v5 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v4 /*: any*/ 
                                        ],
                                        "type": "ExternalRepository"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalCommit"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$a2202b2805c605b9$var$node.hash = "ecef5849b2755517f0014ee14d90d2fb";
var $a2202b2805c605b9$export$2e2bcd8739ae039 = $a2202b2805c605b9$var$node;


parcelRequire("42omo");























const $d3495236ecda9c4b$var$normalizeDisplayName = (name)=>{
    if (typeof name !== 'string') return '';
    return name.trim();
};
// Prioritized a customized photo over one with initals
const $d3495236ecda9c4b$var$prioritizeAvatarWithoutInitials = (avatar1, avatar2)=>{
    if (!avatar1) return avatar2;
    if (avatar1.includes('/initials/') && avatar2) return avatar2;
    return avatar1;
};
const $d3495236ecda9c4b$export$a7867b5ee1911e6d = (initialContributors, authorUser)=>{
    let authorName = null;
    let initialContributor = initialContributors && initialContributors.length > 0 ? initialContributors[0] : null;
    let authorPicture1 = initialContributor?.picture?.trim() ?? null;
    let authorPicture2 = authorUser?.picture?.trim() ?? null;
    if (initialContributor?.name && initialContributor.name.trim() !== '') authorName = initialContributor.name.trim();
    else if (authorUser?.name && authorUser.name.trim() !== '') authorName = authorUser.name.trim();
    if (authorName) return [
        $d3495236ecda9c4b$var$normalizeDisplayName(authorName),
        $d3495236ecda9c4b$var$prioritizeAvatarWithoutInitials(authorPicture1, authorPicture2)
    ];
    return null;
};








const $9ad330cd2bdd6e39$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    resultLabel: {
        id: "search-commit-result.label",
        defaultMessage: "Commit"
    },
    committed: {
        id: "search-commit-result.committed",
        defaultMessage: "Committed {formattedDate}"
    }
});


/**
 * Extracts a short commit hash from a commit URL.
 * Supports GitHub and Bitbucket URL formats where the full hash is the last path segment.
 * Returns the first 6 characters of the hash, or null if not found.
 */ const $fc7ae146ec7d2606$var$extractCommitHash = (url)=>{
    try {
        const { pathname: pathname } = new URL(url);
        const segments = pathname.split('/').filter(Boolean);
        const lastSegment = segments[segments.length - 1];
        if (lastSegment && /^[0-9a-f]{6,40}$/i.test(lastSegment)) return lastSegment.slice(0, 6);
        return null;
    } catch  {
        return null;
    }
};
const $fc7ae146ec7d2606$export$f8ac23605711b215 = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    /* eslint-disable @atlassian/relay/unused-fields -- picture fields are consumed indirectly via resolveGitNounAuthors */ const data = (0, $irOoi.useFragment)((0, $a2202b2805c605b9$export$2e2bcd8739ae039), node);
    /* eslint-enable @atlassian/relay/unused-fields */ const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt, entity: entity } = data;
    const { author: author, container: container } = entity || {};
    const resolvedAuthor = (0, $d3495236ecda9c4b$export$a7867b5ee1911e6d)(data.initialContributors, author?.user);
    const label = formatMessage((0, $9ad330cd2bdd6e39$export$defe85febe8b728c).resultLabel);
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate,
        message: (0, $9ad330cd2bdd6e39$export$defe85febe8b728c).committed
    }) : null;
    const padlockIcon = (0, $9NPDv.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const messageDescription = /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(excerpt, true)
    });
    const commitHash = $fc7ae146ec7d2606$var$extractCommitHash(url);
    const headerMetadataParts = [
        label,
        [
            'repository-name',
            container?.name ?? null
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'commit-hash',
            commitHash
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    if (resolvedAuthor) {
        const [authorName, authorPicture] = resolvedAuthor;
        const authorContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.025",
            alignBlock: "start",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                    name: authorName,
                    picture: authorPicture
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: authorName
                })
            ]
        });
        headerMetadataParts.push([
            'author',
            authorContent
        ]);
    }
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: messageDescription,
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<5b456c572a232fb7476e3f57eb839144>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4ccbeb1508288f91$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphConfluenceDc_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "subtype"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            },
                                            v0 /*: any*/ 
                                        ],
                                        "type": "ExternalSpace"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ExternalReaction",
                                "kind": "LinkedField",
                                "name": "reactions",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "reactionType"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "total"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDocument"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$4ccbeb1508288f91$var$node.hash = "84328c11caa37465be9e406ec32593d9";
var $4ccbeb1508288f91$export$2e2bcd8739ae039 = $4ccbeb1508288f91$var$node;






























const $abcafd932f47a17f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    pageLabel: {
        id: "search-graph-confluence-dc.document.pageLabel",
        defaultMessage: "Page"
    },
    spaceLabel: {
        id: "search-graph-confluence-dc.document.spaceLabel",
        defaultMessage: "Space"
    },
    blogpostLabel: {
        id: "search-graph-confluence-dc.document.blogpostLabel",
        defaultMessage: "Blog Post"
    },
    commentLabel: {
        id: "search-graph-confluence-dc.document.commentLabel",
        defaultMessage: "Comment"
    },
    attachmentLabel: {
        id: "search-graph-confluence-dc.document.attachmentLabel",
        defaultMessage: "Attachment"
    }
});


const $61cfa2381edf5d9d$var$SUBTYPE_PAGE = 'page';
const $61cfa2381edf5d9d$var$SUBTYPE_BLOGPOST = 'blogpost';
const $61cfa2381edf5d9d$var$LIKE_REACTION_TYPE = 'like';
const $61cfa2381edf5d9d$var$CONFLUENCE_DC_LABELS = {
    [$61cfa2381edf5d9d$var$SUBTYPE_PAGE]: (0, $abcafd932f47a17f$export$defe85febe8b728c).pageLabel,
    [$61cfa2381edf5d9d$var$SUBTYPE_BLOGPOST]: (0, $abcafd932f47a17f$export$defe85febe8b728c).blogpostLabel
};
const $61cfa2381edf5d9d$var$ATTACHMENT_SUBTYPES = new Set([
    'archive',
    'audio',
    'code',
    'document',
    'image',
    'pdf',
    'presentation',
    'spreadsheet',
    'video',
    'web-page',
    'other'
]);
const $61cfa2381edf5d9d$var$getLabel = (subtype)=>{
    if ($61cfa2381edf5d9d$var$ATTACHMENT_SUBTYPES.has(subtype)) return (0, $abcafd932f47a17f$export$defe85febe8b728c).attachmentLabel;
    return $61cfa2381edf5d9d$var$CONFLUENCE_DC_LABELS[subtype];
};
const $61cfa2381edf5d9d$export$b773c9cc5f495a3 = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, appMode: appMode, product: product, selectedProduct: selectedProduct, thirdPartyConfigs: thirdPartyConfigs, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $4ccbeb1508288f91$export$2e2bcd8739ae039), node);
    const { id: id, lastModifiedDate: lastModifiedDate, url: url, title: title, excerpt: excerpt, subtype: subtype, entity: entity } = data;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const label = subtype ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        ...$61cfa2381edf5d9d$var$getLabel(subtype)
    }) : null;
    const site = thirdPartyConfigs?.[(0, $hB77E.ProductKeys3P).ConfluenceDC]?.workspaceName;
    const spaceName = entity?.container?.displayName;
    const spaceUrl = entity?.container?.url;
    const space = spaceUrl && spaceName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
        label: spaceName,
        href: spaceUrl
    }) : spaceName;
    const metadataParts = [
        [
            'label',
            label
        ],
        [
            'site',
            site
        ],
        [
            'space',
            space
        ],
        [
            'lastModified',
            lastModifiedComponent
        ]
    ];
    const numberOfLikes = data.entity?.reactions?.find((reaction)=>reaction?.reactionType?.toLowerCase() === $61cfa2381edf5d9d$var$LIKE_REACTION_TYPE)?.total ?? 0;
    const likeCount = (0, $42omo.useMemo)(()=>(0, $f70284887e2e1865$export$b52fa2ff0823604f)(numberOfLikes), [
        numberOfLikes
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        headerMetadataParts: metadataParts,
        headerMetadataSocialParts: [
            [
                'like-count',
                likeCount
            ]
        ],
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt)
        }),
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<8c735b6e872015e2d2d240790d774fef>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4759be98858eb7d9$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v3 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphConversation_AtlassianSearchPage",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "messageBody_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "tabs_AtlassianSearchPage"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workspaceName"
            },
            {
                "concreteType": "SearchResultGraphTab",
                "kind": "LinkedField",
                "name": "tabs",
                "plural": true,
                "selections": v5 /*: any*/ 
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "displayName"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "memberCount"
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "members",
                                "plural": true,
                                "selections": v5 /*: any*/ 
                            }
                        ],
                        "type": "ExternalConversation"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v4 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "lastModifiedDate"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$4759be98858eb7d9$var$node.hash = "0431480ef125ed314d51c01fc9cf0f80";
var $4759be98858eb7d9$export$2e2bcd8739ae039 = $4759be98858eb7d9$var$node;


parcelRequire("42omo");
















/**
 * @generated SignedSource<<62e09952c60e2e85eabb7118805a6b3e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6b573a545d440457$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "description"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "messageBody_AtlassianSearchPage",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "mention_AtlassianSearchPage_UserMention"
            },
            {
                "kind": "FragmentSpread",
                "name": "channel_AtlassianSearchPage"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": v0 /*: any*/ ,
                        "type": "ExternalMessage"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": v0 /*: any*/ ,
                        "type": "ExternalConversation"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$6b573a545d440457$var$node.hash = "24e4e9e72573cfcbb15c7aca65aa13b6";
var $6b573a545d440457$export$2e2bcd8739ae039 = $6b573a545d440457$var$node;


parcelRequire("42omo");


var $e6pbP = parcelRequire("e6pbP");












function $4dd635508e197aad$export$7e4bcd4afb389edb(markdown) {
    if (!markdown) return ''; // Handle the case where markdown is null or undefined
    // Convert headers to plain text
    markdown = markdown.replace(/^#+\s*(.+?)\s*$/gm, '$1');
    // Convert bold and italic text to plain text
    markdown = markdown.replace(/\*\*(.+?)\*\*/g, '$1');
    markdown = markdown.replace(/__(.+?)__/g, '$1');
    markdown = markdown.replace(/\*(.+?)\*/g, '$1');
    markdown = markdown.replace(/_(.+?)_/g, '$1');
    // Convert strikethrough text to plain text
    markdown = markdown.replace(/~~(.+?)~~/g, '$1');
    // Remove code blocks first (before inline code, since ``` contains `)
    // Remove complete code blocks with closing ```
    markdown = markdown.replace(/```[\s\S]*?```/g, '');
    // Remove any remaining unclosed code block markers
    markdown = markdown.replace(/```/g, '');
    // Convert inline code to plain text (after code blocks are removed)
    markdown = markdown.replace(/`(.+?)`/g, '$1');
    // Break up == with zero-width space to prevent markdown-to-jsx from parsing it as <mark>
    // This preserves the visual appearance of == (common in code like ===, !==, ==)
    // while preventing the parser from hanging on malformed mark syntax
    const ZERO_WIDTH_SPACE = '\u200B';
    markdown = markdown.replace(/==/g, `=${ZERO_WIDTH_SPACE}=`);
    // Convert links to plain text by keeping only the link text
    markdown = markdown.replace(/\[(.+?)\]\((.+?)\)/g, '$1');
    // Convert autolinks to plain text
    markdown = markdown.replace(/<(?![@#]|!.*>)([^>|\s]+)>/g, '$1');
    // Handle autolinks with display text, like <http://example.com|example.com>
    markdown = markdown.replace(/<([^|>]+)\|([^>]+)>/g, '$2');
    // Fix broken autolinks
    markdown = markdown.replace(/<(?![@#]|!.*>)([^>|\s]+)>?/g, '$1');
    // Remove images, keeping only the alt text
    markdown = markdown.replace(/!\[(.+?)\]\((.+?)\)/g, '$1');
    // Remove blockquotes, preserving the quoted text
    markdown = markdown.replace(/^\s*>\s+(.+?)\s*$/gm, '$1');
    // Preserve list items as plain text, removing the list markers
    markdown = markdown.replace(/^\s*[\*\+-]\s+(.+?)\s*$/gm, '$1');
    markdown = markdown.replace(/^\s*\d+\.\s+(.+?)\s*$/gm, '$1');
    // Remove horizontal lines
    markdown = markdown.replace(/^\s*[-*_]{3,}\s*$/gm, '');
    // Replace multiple newlines with a single newline
    markdown = markdown.replace(/\n\s*\n/g, '\n');
    return markdown.trim();
}





/**
 * @generated SignedSource<<202550ae007c94c96cea9933a201d805>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b27b38637b9b254f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "channel_AtlassianSearchPage",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "entity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "ExternalAssociationConnection",
                            "kind": "LinkedField",
                            "name": "associatedWith",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ExternalAssociationEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "ExternalAssociation",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "entity",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "alias": "channelId",
                                                                    "kind": "ScalarField",
                                                                    "name": "externalId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                }
                                                            ],
                                                            "type": "ExternalConversation"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "ExternalMessage"
                }
            ]
        }
    ],
    "type": "SearchResultGraphDocument"
};
$b27b38637b9b254f$var$node.hash = "65025c6fc5eb039a81cc5f05b1245093";
var $b27b38637b9b254f$export$2e2bcd8739ae039 = $b27b38637b9b254f$var$node;


parcelRequire("42omo");







const $dca8c86965c6f71e$var$SPACE = ' ';
const $dca8c86965c6f71e$var$channelStyle = null;
const $dca8c86965c6f71e$export$cfdacaa37f9b4dd7 = ({ children: children, node: node, noSpace: noSpace })=>{
    const channelId = children?.[0];
    const data = (0, $irOoi.useFragment)((0, $b27b38637b9b254f$export$2e2bcd8739ae039), node);
    const channelAssociation = data.entity?.associatedWith?.edges?.find((edge)=>edge?.node?.entity?.__typename === 'ExternalConversation' && Boolean(channelId) && channelId === edge?.node?.entity?.channelId);
    if (!channelAssociation || channelAssociation?.node?.entity?.__typename !== 'ExternalConversation') return null;
    const entity = channelAssociation?.node?.entity;
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        className: (0, $gMc0m.default)([
            "_o5721q9c"
        ]),
        children: [
            noSpace ? '' : $dca8c86965c6f71e$var$SPACE,
            "#",
            entity?.displayName
        ]
    });
};





/**
 * @generated SignedSource<<7cb59dc267a6353727b1e1f87cb85a17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $98ec54643c336b70$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "externalId"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "nickname"
        },
        {
            "kind": "ScalarField",
            "name": "email"
        },
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        {
            "concreteType": "ThirdPartyUserExtendedProfile",
            "kind": "LinkedField",
            "name": "extendedProfile",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jobTitle"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "mention_AtlassianSearchPage_UserMention",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "concreteType": "ExternalAssociationConnection",
                                "kind": "LinkedField",
                                "name": "associatedWith",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ExternalAssociationEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "ExternalAssociation",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "entity",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v1 /*: any*/ ,
                                                                "type": "ThirdPartyUser"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalMessage"
                    }
                ]
            },
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "allContributors",
                "plural": true,
                "selections": v1 /*: any*/ 
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$98ec54643c336b70$var$node.hash = "0f985bc027ec0834f1a24c86f3852a30";
var $98ec54643c336b70$export$2e2bcd8739ae039 = $98ec54643c336b70$var$node;


parcelRequire("42omo");





















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 








const $136ad0dff93ca4d5$var$styles = {
    root: "_2rko1rr0 _ca0qidpf _u5f3zjw7 _n3tdyh40 _19bv1poh _vchhusvi _syazazsu _bfhki8nm _uiztglyw _o5721jtm _80omtlke _irr3plhp",
    focusRing: "_ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg4v77o _1ah3v77o _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _qa7m1r31 _1cvmnqa1 _4davt94y"
};
const $136ad0dff93ca4d5$export$e891316fea657d90 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ name: name, prefix: prefix = '@', testId: testId, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        ...htmlAttributes,
        "data-testid": testId,
        ref: ref,
        className: (0, $gMc0m.default)([
            $136ad0dff93ca4d5$var$styles.root,
            $136ad0dff93ca4d5$var$styles.focusRing
        ]),
        children: [
            prefix,
            name
        ]
    });
});


const $f3accdd0219154ae$export$4d833b6a2de3de88 = ({ isOpen: open = false, content: content, ...mentionProps })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(open);
    (0, $42omo.useEffect)(()=>setIsOpen(open), [
        open
    ]);
    function handleKeyPress(event) {
        if (event.code === 'Space' || event.code === 'Enter' || event.code === 'NumpadEnter') {
            event.preventDefault();
            setIsOpen((isOpenState)=>!isOpenState);
        }
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $136ad0dff93ca4d5$export$e891316fea657d90), {
                role: "button",
                tabIndex: 0,
                onClick: ()=>setIsOpen((open)=>!open),
                onKeyUp: (event)=>handleKeyPress(event),
                ...mentionProps,
                ...triggerProps
            }),
        content: (contentProps)=>content({
                ...mentionProps,
                ...contentProps
            })
    });
};








const $376ef8b88d296257$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    externalPersonLabel: {
        id: "search-result.user-mention.external-person",
        defaultMessage: "External person"
    }
});


/**
 * The whitespace in between aliases <!here> <!channel> is removed
 * This constant prevent the alias from being pushed together ex: "@here@channel"
 * We are using this constant rather than adding a space through CSS because it adds
 * a real space character that does not break up the text when selecting.
 * */ const $c831c43df09baf69$var$SPACE = ' ';
const $c831c43df09baf69$export$6ae462bff574866a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        children: [
            $c831c43df09baf69$var$SPACE,
            "@",
            children
        ]
    });
};
const $c831c43df09baf69$export$85d6e42a90e882cb = ({ children: children, integrationId: integrationId, node: node })=>{
    const userId = children?.[0];
    let name;
    let entity;
    const data = (0, $irOoi.useFragment)((0, $98ec54643c336b70$export$2e2bcd8739ae039), node);
    if ((0, $dh538.fg)('exclude_3p_entity_in_search_results')) entity = data.allContributors?.find((contributor)=>Boolean(userId) && userId === contributor?.externalId);
    else {
        const userAssociation = data.entity?.associatedWith?.edges?.find((edge)=>Boolean(userId) && userId === edge?.node?.entity?.externalId);
        entity = userAssociation?.node?.entity;
    }
    name = entity?.nickname || entity?.name;
    const email = entity?.email;
    const copyToClipboard = (0, $6a8b466b77e29197$export$b2199c37e85de4a7)(email);
    if (entity && name) {
        // We are waiting for this commit ticket to complete for jobTitle & profileUrl
        // https://hello.jira.atlassian.cloud/browse/COMMIT-14774
        const user = {
            name: name,
            profilePicUrl: entity.picture,
            jobTitle: entity.extendedProfile?.jobTitle,
            profileUrl: null // not available as of late Oct 2024
        };
        if (user) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                $c831c43df09baf69$var$SPACE,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $f3accdd0219154ae$export$4d833b6a2de3de88), {
                    name: name,
                    content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $168e8abba0f0ce48$export$4c094c8f61edecb4), {
                            onCopyEmail: copyToClipboard,
                            user: user,
                            externalMessageIntegration: (0, $Y34Hw.getExternalMessageDmIntegrationInfo)(integrationId, entity)
                        })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)($c831c43df09baf69$export$6ae462bff574866a, {
        children: name || /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $376ef8b88d296257$export$defe85febe8b728c).externalPersonLabel
        })
    });
};


const $f63e4118bbf61370$var$styles = {
    title: "_1reo15vq _18m915vq _1e0c1o8l _p12fuuw1 _1bto1l2s _o5721q9c _s7n4yfq0 _syazazsu",
    separator: "_19bvu2gc _u5f3u2gc"
}; /**
    * The whitespace in between aliases <!here> <!channel> is removed
    * This constant prevent the alias from being pushed together ex: "@here@channel"
    * We are using this constant rather than adding a space through CSS because it adds
    * a real space character that does not break up the text when selecting.
    * */ 
const $f63e4118bbf61370$var$SPACE = ' ';
const $f63e4118bbf61370$export$95e34c5d2bf14b09 = (inputString)=>{
    if (!inputString) return '';
    const processed = (0, $4dd635508e197aad$export$7e4bcd4afb389edb)(inputString) // removing * or _, which can cause massive slowdown when processed by markdown-to-jsx's Markdown component
    .replace(/[*_]/g, '') //Slack User
    .replace(/<@(\w+)>/g, '<Mention>$1</Mention>') //Teams User
    .replace(/<@([a-zA-Z0-9-]+)>/g, '<Mention>$1</Mention>') //Slack Channel
    .replace(/<#(\w+)\|?>/g, '<Channel>$1</Channel>') //Teams Channel variation 1
    .replace(/<#teamId\/[a-f0-9-]+\/channelId\/teamId\/([a-f0-9-]+)\/channelId\/([0-9a-zA-Z:@._-]+)>/g, '<Channel>teamId/$1/channelId/$2</Channel>') // Teams Channel variation 2
    .replace(/<[@#]teamId\/([a-f0-9-]+)\/channelId\/([0-9a-zA-Z:@._-]+)>/g, '<Channel>teamId/$1/channelId/$2</Channel>').replace(/<\!subteam\^(\w+)>/g, '<Subteam>$1</Subteam>').replace(/<\!(\w+)>/g, '<Alias>$1</Alias>') // emojis, works for those that have repeating pattern as well. eg: :word-word-word:
    .replace(/:((@@@hl@@@.+?@@@endhl@@@)(-@@@hl@@@.+?@@@endhl@@@)*):/g, (match)=>{
        const words = match.match(/@@@hl@@@(.+?)@@@endhl@@@/g)?.map((m)=>m.replace(/@@@hl@@@|@@@endhl@@@/g, '')) || [];
        return `<Highlight>:${words.join('-')}:</Highlight>`;
    }).replace(/@@@hl@@@(.+?)@@@endhl@@@/g, '<Highlight>$1</Highlight>').replace(/<@<Highlight>(.+?)<\/Highlight>>/g, '<Highlight><Mention>$1</Mention></Highlight>').replace(/<#<Highlight>(.+?)<\/Highlight>\|>/g, '<Highlight><Channel>$1</Channel></Highlight>'); // .replace(/\:(\w+)\:/g, '<Emoji>$1</Emoji>') Support for emojis coming soon
    // Check if the processed string starts with a channel tag and replace the first occurrence with ChannelWithoutSpace
    if (processed.startsWith('<Highlight><Channel>')) return processed.replace('<Highlight><Channel>', '<HighlightWithoutSpace><ChannelWithoutSpace>').replace('</Channel></Highlight>', '</ChannelWithoutSpace></HighlightWithoutSpace>');
     // Check if the processed string starts with a highlight tag and replace the first occurrence with HighlightWithoutSpace
    if (processed.startsWith('<Highlight>')) return processed.replace('<Highlight>', '<HighlightWithoutSpace>').replace('</Highlight>', '</HighlightWithoutSpace>');
    return processed;
};
const $f63e4118bbf61370$var$PlainText = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
const $f63e4118bbf61370$var$Highlight = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
        as: "strong",
        children: [
            $f63e4118bbf61370$var$SPACE,
            children
        ]
    });
const $f63e4118bbf61370$var$HighlightWithoutSpace = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        as: "strong",
        children: children
    });
const $f63e4118bbf61370$var$ChannelWithoutSpace = ({ children: children, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dca8c86965c6f71e$export$cfdacaa37f9b4dd7), {
        ...props,
        noSpace: true,
        children: children
    }); // It is assumed that description is the full message and excerpt is a potentially truncated version
const $f63e4118bbf61370$export$bf780c85e04b8810 = (excerpt, description)=>{
    if (excerpt.length === 0 || description.length === 0 || excerpt === description) return excerpt;
    var modifiedExcerpt = excerpt; // regex which has the starting tag of a mention, but not the end
    const startTagRegex = /<[@#][^> ]*$/g;
    const startTagMatch = modifiedExcerpt.match(startTagRegex);
    if (startTagMatch) {
        // theoretically, there should only be one match at max
        const partialMention = startTagMatch[startTagMatch.length - 1]; // the partialMention can appear several times in the string. We need to find the correct one
        const partialMentionInExcerptCount = excerpt.split(partialMention).length - 1;
        const splitDescription = description.split(partialMention); // check if partial mention is found in description
        if (splitDescription.length >= 2) {
            const splitByClosingTag = splitDescription[partialMentionInExcerptCount].split('>'); // check if closing tag is found
            if (splitByClosingTag.length >= 2) {
                const restOfString = splitByClosingTag[0];
                modifiedExcerpt = modifiedExcerpt + restOfString + '>';
            }
        }
    } // const endTagRegex = /^[^< ]*\.tacv2>/g; This works on channel mentions that I have observed
    // weaker regex which tries to capture the ending tag of a mention (assuming it always ends with >), but not the start
    const weakEndTagRegex = /^[^< ]*>/g;
    const weakEndTagMatch = modifiedExcerpt.match(weakEndTagRegex);
    if (weakEndTagMatch) {
        // theoretically, there should only be one match at max
        const partialMention = weakEndTagMatch[0];
        const splitDescription = description.split(partialMention); // partialMention not found in description
        if (splitDescription.length >= 2) {
            const splitByOpeningTag = splitDescription[0].split('<'); // opening tag found
            if (splitByOpeningTag.length >= 2) {
                const restOfString = splitByOpeningTag[splitByOpeningTag.length - 1];
                modifiedExcerpt = '<' + restOfString + modifiedExcerpt;
            }
        }
    }
    return modifiedExcerpt;
};
const $f63e4118bbf61370$export$41910d2944957acd = (body)=>{
    const hlStartTag = '@@@hl@@@'; // if cannot find hl tag, return the original body
    if (!body.includes('@@@hl@@@')) return body;
    const highlightStringAndRemainder = body.substring(body.indexOf(hlStartTag));
    let cursorPosition = body.indexOf(hlStartTag) - 1;
    let numChars = 0;
    let prefix = '';
    let currentWord = '';
    let numWords = 0; // get all words before cursorPosition, less than 15 characters
    while(numChars < 15 && cursorPosition > 0){
        currentWord = body[cursorPosition] + currentWord;
        cursorPosition--;
        numChars++;
        if (body[cursorPosition] === ' ') {
            prefix = currentWord + prefix;
            currentWord = '';
            numWords++;
        }
    }
    if (cursorPosition <= 0) return body;
    else if (numWords === 0) return '...' + currentWord + highlightStringAndRemainder;
    else return '...' + prefix + highlightStringAndRemainder;
};
const $f63e4118bbf61370$export$36e783c4ff07cd7c = ({ node: node, integrationId: integrationId })=>{
    const data = (0, $irOoi.useFragment)((0, $6b573a545d440457$export$2e2bcd8739ae039), node); // in ConversationSearchResult, data.excerpt is used as the body
    let excerpt = data.excerpt;
    if (data.excerpt) excerpt = $f63e4118bbf61370$export$bf780c85e04b8810(data.excerpt, data?.entity?.description ?? '');
    let title = data.title || '';
    let body = excerpt || data?.entity?.description || '';
    const isMicrosoftTeams = integrationId === 'ari:cloud:platform::integration/microsoft';
    const shouldShowTitle = title && isMicrosoftTeams && (0, $dh538.fg)('search_page_enable_teams_title_message');
    title = $f63e4118bbf61370$export$41910d2944957acd(title);
    body = $f63e4118bbf61370$export$41910d2944957acd(body);
    const markdownOptions = {
        forceInline: true,
        overrides: {
            a: $f63e4118bbf61370$var$PlainText,
            Highlight: $f63e4118bbf61370$var$Highlight,
            HighlightWithoutSpace: $f63e4118bbf61370$var$HighlightWithoutSpace,
            Alias: (0, $c831c43df09baf69$export$6ae462bff574866a),
            mark: $f63e4118bbf61370$var$PlainText,
            Mention: {
                component: (0, $c831c43df09baf69$export$85d6e42a90e882cb),
                props: {
                    integrationId: integrationId,
                    node: data
                }
            },
            Channel: {
                component: (0, $dca8c86965c6f71e$export$cfdacaa37f9b4dd7),
                props: {
                    node: data
                }
            },
            ChannelWithoutSpace: {
                component: $f63e4118bbf61370$var$ChannelWithoutSpace,
                props: {
                    node: data
                }
            }
        }
    }; /**
      * Even though we remove markdown from the body, we still use this component
      * to render mentions and highlighted text */ 
    if (shouldShowTitle) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: $f63e4118bbf61370$var$styles.title,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
                    options: markdownOptions,
                    children: $f63e4118bbf61370$export$95e34c5d2bf14b09(title)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: $f63e4118bbf61370$var$styles.separator,
                children: "\xb7"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
                options: markdownOptions,
                children: $f63e4118bbf61370$export$95e34c5d2bf14b09(body)
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
        options: markdownOptions,
        children: $f63e4118bbf61370$export$95e34c5d2bf14b09(body)
    });
};






/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







const $748199d195cd32c0$export$551a816c078ac825 = 50;
const $748199d195cd32c0$var$containerStyles = {
    root: "_1reo15vq _18m915vq _1e0c1o8l _p12foiq5 _1bto1l2s _o5721q9c _s7n4yfq0"
};
const $748199d195cd32c0$export$863b644c95635d3b = ({ workspaceName: workspaceName })=>{
    const isTruncated = workspaceName.length > $748199d195cd32c0$export$551a816c078ac825;
    const displayName = isTruncated ? `${workspaceName.slice(0, $748199d195cd32c0$export$551a816c078ac825)}...` : workspaceName;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: isTruncated ? workspaceName : null,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $748199d195cd32c0$var$containerStyles.root,
                testId: "workspace-name-metadata",
                ...tooltipProps,
                children: displayName
            })
    });
};





const $49fb29a3608bc9fe$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    label: {
        id: "search-page-relay.results.product-results.third-party.conversation-search-result.label",
        defaultMessage: "Channel"
    },
    memberCount: {
        id: "search-page-relay.results.product-results.third-party.conversation-search-result.member-count",
        defaultMessage: "{count, plural, one {# member} other {# members}}"
    },
    lastActive: {
        id: "search-page-relay.results.product-results.third-party.conversation-search-result.time-since-label",
        defaultMessage: "Last active {formattedDate}"
    },
    unknownChannel: {
        id: "search-page-relay.results.product-results.third-party.conversation-search-result.unknown-channel",
        defaultMessage: "unknown-channel"
    },
    privateChannel: {
        id: "search-page-relay.results.product-results.third-party.conversation-search-result.private-channel",
        defaultMessage: "Private channel"
    }
});





/**
 * @generated SignedSource<<5b9d732e97e64c54db219b58ddaa4bab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2bb05c6df1abfa7b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "tabs_AtlassianSearchPage",
    "selections": [
        {
            "concreteType": "SearchResultGraphTab",
            "kind": "LinkedField",
            "name": "tabs",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "tabId"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "url"
                }
            ]
        }
    ],
    "type": "SearchResultGraphDocument"
};
$2bb05c6df1abfa7b$var$node.hash = "c02ba04c211b1a64b9312215c94994e6";
var $2bb05c6df1abfa7b$export$2e2bcd8739ae039 = $2bb05c6df1abfa7b$var$node;


parcelRequire("42omo");


























const $34835dfebfe64d52$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    tabsExpandButtonLabel: {
        id: "relay.search-page.results.product-results.third-party.conversation-search-result.tabs-label",
        defaultMessage: "Tabs"
    }
});


const $cbae70011183c1f1$var$styles = {
    tabItem: "_1rjc1b66 _bozgu2gc",
    tabLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $cbae70011183c1f1$export$b2539bed5023c21c = ({ node: node, defaultExpandedIndex: defaultExpandedIndex })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const data = (0, $irOoi.useFragment)((0, $2bb05c6df1abfa7b$export$2e2bcd8739ae039), node);
    const tabs = (data.tabs ?? []).filter((tab)=>tab != null);
    if (!tabs.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
        defaultExpandedIndex: defaultExpandedIndex,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            attachmentCount: tabs.length,
            attachmentType: "url",
            label: formatMessage((0, $34835dfebfe64d52$export$a7357cdd1f0b0168).tabsExpandButtonLabel),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: tabs.map((tab, index)=>{
                    const key = tab.tabId ?? tab.url ?? String(index);
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $cbae70011183c1f1$var$styles.tabItem,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                                    label: "",
                                    size: "medium",
                                    color: "currentColor"
                                }),
                                tab.url ? /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                                    xcss: $cbae70011183c1f1$var$styles.tabLink,
                                    href: tab.url,
                                    rel: "noreferrer",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: "medium",
                                        color: "color.link",
                                        weight: "medium",
                                        children: (0, $Y34Hw.enrichExcerpt)(tab.title ?? tab.url)
                                    })
                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "medium",
                                    weight: "medium",
                                    children: (0, $Y34Hw.enrichExcerpt)(tab.title)
                                })
                            ]
                        })
                    }, key);
                })
            })
        })
    });
};


const $3656b7fd5d879deb$export$73ee84431f6e335a = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const data = (0, $irOoi.useFragment)((0, $4759be98858eb7d9$export$2e2bcd8739ae039), node);
    const memberCount = data.entity?.memberCount ?? data.entity?.members?.length;
    const workspaceName = data.workspaceName;
    const parts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $49fb29a3608bc9fe$export$a7357cdd1f0b0168).label
            })
        ],
        [
            'workspaceName',
            workspaceName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $748199d195cd32c0$export$863b644c95635d3b), {
                workspaceName: workspaceName
            }) : null
        ],
        [
            'memberCount',
            memberCount && /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $49fb29a3608bc9fe$export$a7357cdd1f0b0168).memberCount,
                values: {
                    count: memberCount
                }
            })
        ]
    ];
    const getChannelName = ()=>{
        if (data.entity?.displayName) return `#${data.entity.displayName}`;
        if (data.title) return data.title.startsWith('#') ? data.title : `#${data.title}`;
        return `#${formatMessage((0, $49fb29a3608bc9fe$export$a7357cdd1f0b0168).unknownChannel)}`;
    };
    let privateChannelName;
    if (data.subtype === 'private-channel') privateChannelName = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                label: formatMessage((0, $49fb29a3608bc9fe$export$a7357cdd1f0b0168).privateChannel),
                size: "small"
            }),
            getChannelName()
        ]
    });
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const tabItems = data.tabs ?? [];
    const tabs = (0, $dh538.fg)('rovo_fps_enable_ms_teams_channel_tab_type_filter') ? tabItems : [];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $f63e4118bbf61370$export$36e783c4ff07cd7c), {
            integrationId: data.integrationId,
            node: data
        }),
        icon: icon,
        headerMetadataParts: parts,
        title: privateChannelName || getChannelName(),
        url: data.url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        appMode: appMode,
        footer: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                tabs.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $cbae70011183c1f1$export$b2539bed5023c21c), {
                    node: data
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
                    linkedResults: linkedResults || [],
                    thirdPartyConfigs: thirdPartyConfigs,
                    partial: data,
                    position: position,
                    onResultClicked: onResultClicked,
                    url: data.url,
                    onResultContextMenu: onResultContextMenu,
                    isAllProductSelected: !selectedProduct
                })
            ]
        }),
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<4d7241f2c42047cc56dede618c447f79>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3958b5e8ee8a488c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchGraphCustomerContact_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "LinkedField",
            "name": "entity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountName"
                        },
                        {
                            "concreteType": "ExternalUser",
                            "kind": "LinkedField",
                            "name": "contactUser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ThirdPartyUser",
                                    "kind": "LinkedField",
                                    "name": "thirdPartyUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "concreteType": "ThirdPartyUserExtendedProfile",
                                            "kind": "LinkedField",
                                            "name": "extendedProfile",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jobTitle"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "ExternalCustomerContact"
                }
            ]
        }
    ],
    "type": "SearchResultGraphDocument"
};
$3958b5e8ee8a488c$var$node.hash = "12a9377b2d2c510be0042ad9759961af";
var $3958b5e8ee8a488c$export$2e2bcd8739ae039 = $3958b5e8ee8a488c$var$node;


parcelRequire("42omo");

















const $b46856d2bd584e9e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    eventLabel: {
        id: "search-graph-customer-contact.customer-contact-label",
        defaultMessage: "Customer Contact"
    }
});


const $19060b73dca5ceaf$export$a3fd078d13d8ac2 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const data = (0, $irOoi.useFragment)((0, $3958b5e8ee8a488c$export$2e2bcd8739ae039), node);
    const { id: id, url: url, lastModifiedDate: lastModifiedDate, entity: entity } = data;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const accountName = entity?.accountName;
    const thirdPartyUser = entity?.contactUser?.thirdPartyUser;
    const title = thirdPartyUser?.name;
    const headerMetadataParts = [
        formatMessage((0, $b46856d2bd584e9e$export$defe85febe8b728c).eventLabel),
        [
            'account-name',
            accountName
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: thirdPartyUser?.extendedProfile?.jobTitle,
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<2f7e1a29caf756efbda4fbdf99271721>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d76a1f4103738a2d$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "searchGraphCustomerOrg_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v4 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "concreteType": "ExternalUser",
                                        "kind": "LinkedField",
                                        "name": "contributors",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "ThirdPartyUser",
                                                "kind": "LinkedField",
                                                "name": "thirdPartyUser",
                                                "plural": false,
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    v5 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "ExternalUser",
                                        "kind": "LinkedField",
                                        "name": "owners",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "ThirdPartyUser",
                                                "kind": "LinkedField",
                                                "name": "thirdPartyUser",
                                                "plural": false,
                                                "selections": [
                                                    v5 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "parent",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v4 /*: any*/ 
                                        ],
                                        "type": "ExternalCustomerOrg"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ExternalCustomerOrgLastActivity",
                                "kind": "LinkedField",
                                "name": "customerOrgLastActivity",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "lastActivityAt"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "event"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalCustomerOrg"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$d76a1f4103738a2d$var$node.hash = "f865c9e7b61b842c45c871a53ff1a606";
var $d76a1f4103738a2d$export$2e2bcd8739ae039 = $d76a1f4103738a2d$var$node;


parcelRequire("42omo");
























const $2285d5346b37029f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    eventLabel: {
        id: "search-graph-customer-org.customer-org-label",
        defaultMessage: "Customer Organization"
    }
});


const $77eea3dd744c20d3$var$styles = {
    subheading: "_11c8fhey _syaz1rpy"
};
const $77eea3dd744c20d3$export$f49280cd3d93cb86 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const data = (0, $irOoi.useFragment)((0, $d76a1f4103738a2d$export$2e2bcd8739ae039), node);
    const { id: id, url: url, title: title, lastModifiedDate: lastModifiedDate, entity: entity } = data;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        children: entity?.customerOrgLastActivity?.event
    });
    const description = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
                description: body
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $77eea3dd744c20d3$var$styles.subheading,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: entity?.customerOrgLastActivity?.lastActivityAt
                })
            })
        ]
    });
    const parent = entity?.parent?.displayName;
    const ownerFromContributors = entity?.contributors?.[0]?.thirdPartyUser?.name;
    const ownerFromOwners = ()=>{
        if (!entity?.owners || !Array.isArray(entity.owners) || entity.owners.length === 0) return undefined;
        return entity.owners[0]?.thirdPartyUser?.name;
    };
    const ownerName = ownerFromOwners() ?? ownerFromContributors;
    const headerMetadataParts = [
        formatMessage((0, $2285d5346b37029f$export$defe85febe8b728c).eventLabel),
        [
            'parent',
            parent
        ],
        [
            'owner',
            ownerName
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: description,
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<6fec455b0c76b28e4f023833e6df6b5d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8b389320d1d2d649$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphDashboard_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "workspaceName"
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "owners",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDashboard"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$8b389320d1d2d649$var$node.hash = "a344ff8b7dc86aea8605c36b488e8de2";
var $8b389320d1d2d649$export$2e2bcd8739ae039 = $8b389320d1d2d649$var$node;


parcelRequire("42omo");

















const $6fee8e7e690f660e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    eventLabel: {
        id: "search-graph-dashboard.dashboard-label",
        defaultMessage: "Dashboard"
    }
});


const $6bb44605052e87f7$export$5039b6acf48ea77b = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const partial = (0, $irOoi.useFragment)((0, $8b389320d1d2d649$export$2e2bcd8739ae039), node);
    const { url: url, entity: entity, title: title, lastModifiedDate: lastModifiedDate, excerpt: excerpt } = partial;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const getOwnerName = ()=>{
        if (!entity?.owners || !Array.isArray(entity.owners) || entity.owners.length === 0) return undefined;
        return entity.owners[0]?.thirdPartyUser?.name;
    };
    const workspaceName = entity?.workspaceName;
    const ownerName = getOwnerName();
    const headerMetadataParts = [
        formatMessage((0, $6fee8e7e690f660e$export$defe85febe8b728c).eventLabel),
        [
            'workspaceName',
            workspaceName
        ],
        ...workspaceName && ownerName && workspaceName === ownerName ? [] : ownerName ? [
            [
                'owner',
                ownerName
            ]
        ] : [],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        icon: icon,
        description: (0, $Y34Hw.processExcerpt)(excerpt),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<caa0ca0040e932976c86580039d4366c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ac31cc5ea3f0a44$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphDataTable_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            {
                                "alias": "dataTableType",
                                "kind": "ScalarField",
                                "name": "type"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "workspaceName"
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "owners",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDataTable"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$6ac31cc5ea3f0a44$var$node.hash = "6ff93efabe2d5f906a794ed3377fc473";
var $6ac31cc5ea3f0a44$export$2e2bcd8739ae039 = $6ac31cc5ea3f0a44$var$node;


parcelRequire("42omo");

















const $8d627c4379faf988$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    eventLabel: {
        id: "search-graph-data-table.data-table-label",
        defaultMessage: "Data table"
    }
});


const $d3b5e6118cd795f4$export$a2ac0f4098dc2a39 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const partial = (0, $irOoi.useFragment)((0, $6ac31cc5ea3f0a44$export$2e2bcd8739ae039), node);
    const { url: url, entity: entity, title: title, lastModifiedDate: lastModifiedDate, excerpt: excerpt } = partial;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const getOwnerName = ()=>{
        if (!entity?.owners || !Array.isArray(entity.owners) || entity.owners.length === 0) return undefined;
        return entity.owners[0]?.thirdPartyUser?.name;
    };
    const workspaceName = entity?.workspaceName;
    const ownerName = getOwnerName();
    const headerMetadataParts = [
        formatMessage((0, $8d627c4379faf988$export$defe85febe8b728c).eventLabel),
        [
            'type',
            entity?.dataTableType
        ],
        [
            'workspaceName',
            workspaceName
        ],
        ...workspaceName && ownerName && workspaceName === ownerName ? [] : ownerName ? [
            [
                'owner',
                ownerName
            ]
        ] : [],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: partial.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        icon: icon,
        description: (0, $Y34Hw.processExcerpt)(excerpt),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<f2886be5685e239d3c2a48b576bb2208>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $050cd53b79465001$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "searchGraphDeal_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "stage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "dealClosedAt"
                            },
                            {
                                "concreteType": "ExternalDealLastActivity",
                                "kind": "LinkedField",
                                "name": "lastActivity",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "lastActivityAt"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "event"
                                    }
                                ]
                            },
                            {
                                "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "ExternalUser",
                                        "kind": "LinkedField",
                                        "name": "owners",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "ThirdPartyUser",
                                                "kind": "LinkedField",
                                                "name": "thirdPartyUser",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "parent",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            }
                                        ],
                                        "type": "ExternalCustomerOrg"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDeal"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v2 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$050cd53b79465001$var$node.hash = "a67dcd516788ae186b2f421b3cb9f8c0";
var $050cd53b79465001$export$2e2bcd8739ae039 = $050cd53b79465001$var$node;


parcelRequire("42omo");



























const $eb4dfd021d4d6278$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    eventLabel: {
        id: "search-graph-deal.deal-label",
        defaultMessage: "Deal"
    },
    closedOn: {
        id: "search-graph-deal.closed-on",
        defaultMessage: "Closed on {date}"
    },
    closesOn: {
        id: "search-graph-deal.closes-on",
        defaultMessage: "Closes on {date}"
    }
});


const $c295bb43a0a69b45$var$styles = {
    content: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    subheading: "_11c8fhey _syaz1rpy",
    dealContainer: "_1bsb1osq",
    resultWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf"
};
const $c295bb43a0a69b45$export$97947ae87dd2d3c0 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $050cd53b79465001$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $aXWIB.useIntl)();
    const { id: id, url: url, entity: entity, title: title, lastModifiedDate: lastModifiedDate } = data;
    const lastModifiedComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const dealClosedAtDate = entity?.dealClosedAt ? new Date(entity.dealClosedAt) : null;
    const formattedDate = dealClosedAtDate ? formatDate(dealClosedAtDate, {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    }) : '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const closeDateMessage = dealClosedAtDate && dealClosedAtDate >= today ? (0, $eb4dfd021d4d6278$export$defe85febe8b728c).closesOn : (0, $eb4dfd021d4d6278$export$defe85febe8b728c).closedOn;
    const closeOnDateComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $c295bb43a0a69b45$var$styles.content,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...closeDateMessage,
            values: {
                date: formattedDate
            }
        })
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        children: entity?.lastActivity?.event
    });
    const description = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
                description: body
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $c295bb43a0a69b45$var$styles.subheading,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: entity?.lastActivity?.lastActivityAt
                })
            })
        ]
    });
    const ownerName = entity?.owners?.[0]?.thirdPartyUser?.name;
    const stageText = entity?.stage || '';
    const parent = entity?.parent?.displayName;
    const headerMetadataParts = [
        formatMessage((0, $eb4dfd021d4d6278$export$defe85febe8b728c).eventLabel),
        [
            'parent',
            parent
        ],
        [
            'owner',
            ownerName
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        gap: "space.100",
        alignItems: "start",
        role: "listitem",
        xcss: $c295bb43a0a69b45$var$styles.dealContainer,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $c295bb43a0a69b45$var$styles.resultWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
                    id: id,
                    product: product,
                    productSelected: !!selectedProduct,
                    onResultClicked: onResultClicked,
                    onResultContextMenu: onResultContextMenu,
                    onCopyLinkButtonClicked: onCopyLinkButtonClicked,
                    onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
                    onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
                    onContextMenuButtonClicked: onContextMenuButtonClicked,
                    icon: icon,
                    description: description,
                    headerMetadataParts: headerMetadataParts,
                    title: (0, $Y34Hw.enrichExcerpt)(title),
                    role: "none",
                    url: url,
                    isThirdParty: true,
                    cloudId: cloudId,
                    primaryProduct: primaryProduct,
                    position: position,
                    partial: data,
                    appMode: appMode,
                    footer: footerComponent,
                    hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
                    mainContentWidth: mainContentWidth
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2bd4a834f1261b6f$export$99514a272b734f96), {
                statusText: stageText,
                popupContent: closeOnDateComponent
            })
        ]
    });
};





/**
 * @generated SignedSource<<6a9240f3c1ee9d331b747fa3cbf7118d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9cf7c181e0845eab$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v4 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphDefault_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$9cf7c181e0845eab$var$node.hash = "f94f2a94cf3a3a359423eadcef3a5758";
var $9cf7c181e0845eab$export$2e2bcd8739ae039 = $9cf7c181e0845eab$var$node;


parcelRequire("42omo");


















parcelRequire("42omo");




















const $b41425164bb8bebe$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    restrictedLabel: {
        id: "search-page.results.restricted-result-label",
        defaultMessage: "Restricted"
    },
    restrictedTooltip: {
        id: "search-page.results.restricted-result-tooltip",
        defaultMessage: "Only visible to specific people"
    },
    privateLabel: {
        id: "search-page.results.private-result-label",
        defaultMessage: "Private"
    },
    privateTooltip: {
        id: "search-page.results.private-result-tooltip",
        defaultMessage: "Only visible to you"
    }
});


const $5c2df34c79a6120f$var$container = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'space.050',
    backgroundColor: 'color.background.neutral',
    paddingLeft: 'space.100',
    paddingRight: 'space.150',
    // different to paddingLeft for visual balance
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    borderRadius: 'radius.small',
    cursor: 'default' // so that it doesn't change to the text-selecting looking one
});
const $5c2df34c79a6120f$var$iconColor = "var(--ds-icon, #292A2E)";
const $5c2df34c79a6120f$export$3aad690c5eb10b93 = 'restricted-lozenge';
const $5c2df34c79a6120f$export$3eac322cb0b365da = ({ restriction: restriction })=>{
    if (!restriction || restriction === 'public') return null;
    const label = restriction === 'private' ? (0, $b41425164bb8bebe$export$defe85febe8b728c).privateLabel : (0, $b41425164bb8bebe$export$defe85febe8b728c).restrictedLabel;
    const tooltipText = restriction === 'private' ? (0, $b41425164bb8bebe$export$defe85febe8b728c).privateTooltip : (0, $b41425164bb8bebe$export$defe85febe8b728c).restrictedTooltip;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...tooltipText
        }),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $5c2df34c79a6120f$var$container,
            testId: $5c2df34c79a6120f$export$3aad690c5eb10b93,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                    label: "",
                    color: $5c2df34c79a6120f$var$iconColor,
                    size: "small"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    color: "color.text",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...label
                    })
                })
            ]
        })
    });
};














const $4fc3ecceff404a0a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    task: {
        id: "search-graph-default.task.label",
        defaultMessage: "Task"
    },
    dashboard: {
        id: "search-graph-default.dashboard.label",
        defaultMessage: "Dashboard"
    },
    invoice: {
        id: "search-graph-default.invoice.label",
        defaultMessage: "Invoice"
    },
    design: {
        id: "search-graph-default.design.label",
        defaultMessage: "Design"
    },
    deal: {
        id: "search-graph-default.deal.label",
        defaultMessage: "Deal"
    }
});


const $9a45c40b46beaab7$var$footerContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $9a45c40b46beaab7$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $9a45c40b46beaab7$var$getLabel = (entityNoun)=>entityNoun.replace(/-/g, ' ');
const $9a45c40b46beaab7$export$2b64796aabcbabd2 = ({ node: node, position: position, cloudId: cloudId, product: product, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, icon: icon, entityType: entityType, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $9cf7c181e0845eab$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { id: id, url: url, title: title, subtype: subtype, excerpt: excerpt, lastModifiedDate: lastModifiedDate, permissionLevel: permissionLevel } = data;
    const isNotPublic = (0, $9NPDv.isNonPublic)(permissionLevel);
    const lastModifiedComponent = lastModifiedDate && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const resultType = subtype || entityType;
    const labelMessage = (0, $4fc3ecceff404a0a$export$defe85febe8b728c)[resultType];
    const label = resultType && labelMessage ? formatMessage(labelMessage) : $9a45c40b46beaab7$var$getLabel(resultType);
    const headerMetadataParts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $9a45c40b46beaab7$var$typeLabelContainer,
                children: label
            })
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const enrichedTitle = (0, $Y34Hw.enrichExcerpt)(title);
    const description = excerpt && /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(excerpt)
    });
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const shouldShowRelatedLinks = linkedResults && linkedResults.length > 0;
    const footerComponent = shouldShowRelatedLinks ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultContextMenu: onResultContextMenu,
        onResultClicked: onResultClicked,
        isAllProductSelected: !selectedProduct
    }) : isNotPublic && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $9a45c40b46beaab7$var$footerContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2df34c79a6120f$export$3eac322cb0b365da), {
            restriction: permissionLevel
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        title: enrichedTitle,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        description: description,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        isThirdParty: true,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<a1bafda6ca044b43c3901dd3e6202124>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9b486ea511c4975$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    }, v4 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphDesign_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "concreteType": "ExternalThumbnail",
                                "kind": "LinkedField",
                                "name": "thumbnail",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "externalUrl"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDesign"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$f9b486ea511c4975$var$node.hash = "33e7c4704ea491a336bc35c0ecdefe69";
var $f9b486ea511c4975$export$2e2bcd8739ae039 = $f9b486ea511c4975$var$node;


parcelRequire("42omo");













/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








/* thumbnail-image.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $e7dcc4a9e5ae8e24$var$THUMBNAIL_WIDTH = 204;
const $e7dcc4a9e5ae8e24$var$THUMBNAIL_HEIGHT = 132;
const $e7dcc4a9e5ae8e24$var$thumbnailImageStyles = null;
const $e7dcc4a9e5ae8e24$export$775c760e42beccb7 = ({ src: src, alt: alt, onError: onError })=>/*#__PURE__*/ (0, $l998X.jsx)("img", {
        src: src,
        alt: alt,
        onError: onError,
        width: $e7dcc4a9e5ae8e24$var$THUMBNAIL_WIDTH,
        height: $e7dcc4a9e5ae8e24$var$THUMBNAIL_HEIGHT,
        className: (0, $gMc0m.default)([
            "_2rko1qi0 _189e1dm9 _1dqonqa1 _1h6d1gmx _5ral1dfr _rsuf1h6o _1bsb9rak _4t3in0hr"
        ])
    });


const $2853273f3c22f618$var$thumbnailContainerStyles = (0, $ecnYn.xcss)({
    gridArea: 'body'
});
const $2853273f3c22f618$var$descriptionLinkStyles = (0, $ecnYn.xcss)({
    display: 'inline-block'
});
const $2853273f3c22f618$export$9acaedfb553281a4 = ({ resultUrl: resultUrl, thumbnailUrl: thumbnailUrl, onError: onError })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
        xcss: [
            $2853273f3c22f618$var$descriptionLinkStyles
        ],
        rel: 'noreferrer',
        target: '_blank',
        href: resultUrl,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            testId: "thumbnail-container",
            xcss: $2853273f3c22f618$var$thumbnailContainerStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e7dcc4a9e5ae8e24$export$775c760e42beccb7), {
                src: thumbnailUrl,
                onError: onError
            })
        })
    });



var $3euKc = parcelRequire("3euKc");










const $30bd85a956e8089e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    designLabel: {
        id: "design-search-result.label",
        defaultMessage: "Design"
    }
});


const $116289f16507c09c$export$81afb8005ea84971 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const data = (0, $irOoi.useFragment)((0, $f9b486ea511c4975$export$2e2bcd8739ae039), node);
    const { id: id, url: url, title: title, entity: entity, permissionLevel: permissionLevel, lastModifiedDate: lastModifiedDate } = data;
    const lastModifiedComponent = lastModifiedDate && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    });
    const label = formatMessage((0, $30bd85a956e8089e$export$defe85febe8b728c).designLabel);
    const padlockIcon = (0, $9NPDv.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const headerMetadataParts = [
        [
            'label',
            label
        ],
        [
            'lastModified',
            lastModifiedComponent
        ],
        [
            'padlock',
            padlockIcon
        ]
    ];
    const enrichedTitle = (0, $Y34Hw.enrichExcerpt)(title);
    const thumbnailUrl = entity?.__typename === 'ExternalDesign' && entity?.thumbnail?.externalUrl;
    const hasThumbnail = thumbnailUrl && !(0, $3euKc.isAWSThumbnailUrlExpired)(thumbnailUrl);
    const body = hasThumbnail ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2853273f3c22f618$export$9acaedfb553281a4), {
        resultUrl: url,
        thumbnailUrl: thumbnailUrl
    }) : null;
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        title: enrichedTitle,
        description: body,
        headerMetadataParts: headerMetadataParts,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        isThirdParty: true,
        icon: icon,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<d857d353c4dd353d36cb9dd2405eb62d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $29278d67853c092d$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v4 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = [
        v5 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": true,
                "kind": "LocalArgument",
                "name": "includeThirdPartyId"
            }
        ],
        "kind": "Fragment",
        "name": "searchGraphDocument_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "condition": "includeThirdPartyId",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "thirdPartyId"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ExternalDocumentType",
                                "kind": "LinkedField",
                                "name": "type",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ExternalLargeContent",
                                "kind": "LinkedField",
                                "name": "nonIndexableContent",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "mediaThumbnailUrl"
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "parent",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v6 /*: any*/ ,
                                        "type": "ExternalDocument"
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v5 /*: any*/ ,
                                            v2 /*: any*/ 
                                        ],
                                        "type": "ExternalSpace"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalDocument"
                    }
                ]
            },
            {
                "concreteType": "SearchResultGraphDocument",
                "kind": "LinkedField",
                "name": "linkedEntities",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "parentId"
                    },
                    v3 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": v6 /*: any*/ ,
                                "type": "ExternalComment"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$29278d67853c092d$var$node.hash = "e136425f34dabec4dde19ffe92b24579";
var $29278d67853c092d$export$2e2bcd8739ae039 = $29278d67853c092d$var$node;























var $hP2yW = parcelRequire("hP2yW");


var $2Znam = parcelRequire("2Znam");





var $9kYXz = parcelRequire("9kYXz");






/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");













/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $eEJlK = parcelRequire("eEJlK");





















var $i7jPX = parcelRequire("i7jPX");










const $2ec2ce3f97e56c14$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    commentHeaderPrefix: {
        id: "search-page.embedded-comments.comment-header-prefix",
        defaultMessage: "Re: {label}"
    }
});


const $0f10bb3caea56648$var$styles = {
    container: "_ca0q1b66",
    commentWrapper: "_1ul9idpf",
    commentLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko12b0 _1e0c1ule _1ul9idpf _syazi7uo _u5f31b66 _bozgutpp _irr319i6",
    commentLinkAuthorGlyph: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko12b0 _1e0c1ule _1ul9idpf _syaz13af _u5f31b66 _bozgutpp _10531ra0 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    commentCardGrid: "_yv0e5bpd _1lmcjrvm _gy1p12x7 _1p57v77o",
    commentCardGridWithoutHeading: "_yv0e5bpd _1lmc17un _gy1p12x7",
    commentIconArea: "_nd5l2ec4 _1e0c1txw _4cvr1y6m _1bah1h6o _ca0qv77o",
    commentHeadingArea: "_nd5laoqn _1ul9idpf",
    commentBodyArea: "_nd5l18xf _1ul9idpf",
    replyCard: "_bozgpxbi _gx38e4h9 _ngwonqa1 _14vnv30g",
    commentBodyWrapper: "_1ul9idpf",
    excerptInlineRow: "_1reo15vq _18m915vq _1ul9idpf",
    excerptIcon: "_1o9zidpf _1e0c1txw",
    excerptText: "_1ul9idpf _16jlkb7n _i0dlf1ug"
};
/**
 * Validates that a URL is safe to use as an href (https only).
 * Rejects javascript:, data:, and other non-https schemes.
 */ const $0f10bb3caea56648$var$isValidHttpsUrl = (url)=>{
    if (!url || typeof url !== 'string') return false;
    try {
        const parsed = new URL(url);
        return parsed.protocol === 'https:';
    } catch  {
        return false;
    }
};
const $0f10bb3caea56648$export$824152dfe600f28c = ({ comments: comments, maxComments: maxComments = 3 })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (!comments.length) return null;
     // Order top-level comments before threaded replies using parentId.
    // A comment is a reply if its parentId matches another comment's id in the list.
    // This ensures the most contextual comments surface first within the flat list.
    const commentIds = new Set(comments.map((c)=>c.id).filter(Boolean));
    const sortedComments = [
        ...comments
    ].sort((a, b)=>{
        const aIsReply = a.parentId != null && commentIds.has(a.parentId);
        const bIsReply = b.parentId != null && commentIds.has(b.parentId);
        if (aIsReply === bIsReply) return 0;
        return aIsReply ? 1 : -1;
    });
    const visibleComments = sortedComments.slice(0, maxComments);
    const commentContent = (comment)=>{
        // noLeadingEllipsis=true prevents processExcerpt from prepending '...' to long excerpts.
        // Leading ellipsis is wrong in a card layout — truncation only happens visually at the end.
        const processedExcerpt = comment.excerpt ? (0, $Y34Hw.processExcerpt)(comment.excerpt, true) : null;
        const isReply = comment.parentId != null && commentIds.has(comment.parentId);
        const hasDisplayName = Boolean(comment.displayName);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: isReply ? $0f10bb3caea56648$var$styles.replyCard : $0f10bb3caea56648$var$styles.commentWrapper,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                xcss: hasDisplayName ? $0f10bb3caea56648$var$styles.commentCardGrid : $0f10bb3caea56648$var$styles.commentCardGridWithoutHeading,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $0f10bb3caea56648$var$styles.commentIconArea,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
                            label: "Reply",
                            size: "xxsmall",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eEJlK))), {
                                label: "",
                                color: "currentColor"
                            })
                        })
                    }),
                    hasDisplayName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $0f10bb3caea56648$var$styles.commentHeadingArea,
                        children: (0, $dh538.fg)('rovo_fps_embedded_comments_author_glyph') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "inherit",
                            maxLines: 1,
                            children: formatMessage((0, $2ec2ce3f97e56c14$export$defe85febe8b728c).commentHeaderPrefix, {
                                label: comment.displayName
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            color: "color.text.subtle",
                            children: formatMessage((0, $2ec2ce3f97e56c14$export$defe85febe8b728c).commentHeaderPrefix, {
                                label: comment.displayName
                            })
                        })
                    }) : null,
                    processedExcerpt ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $0f10bb3caea56648$var$styles.commentBodyArea,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                            content: processedExcerpt,
                            children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    ...tooltipProps,
                                    xcss: $0f10bb3caea56648$var$styles.commentBodyWrapper,
                                    children: (0, $dh538.fg)('rovo_fps_embedded_comments_author_glyph') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                        space: "space.075",
                                        alignBlock: "center",
                                        xcss: $0f10bb3caea56648$var$styles.excerptInlineRow,
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $0f10bb3caea56648$var$styles.excerptIcon,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4wwVl))), {
                                                    label: "",
                                                    color: "var(--ds-icon-subtle, #505258)"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $0f10bb3caea56648$var$styles.excerptText,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    maxLines: 1,
                                                    color: "color.text",
                                                    children: processedExcerpt
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        maxLines: 2,
                                        color: "color.text",
                                        children: processedExcerpt
                                    })
                                })
                        })
                    }) : null
                ]
            })
        });
    };
    const commentWrapper = (comment, index)=>{
        const key = comment.id || index;
        if ($0f10bb3caea56648$var$isValidHttpsUrl(comment.url)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
            href: comment.url,
            xcss: (0, $dh538.fg)('rovo_fps_embedded_comments_author_glyph') ? $0f10bb3caea56648$var$styles.commentLinkAuthorGlyph : $0f10bb3caea56648$var$styles.commentLink,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: (e)=>e.stopPropagation(),
            children: commentContent(comment)
        }, key);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $dh538.fg)('rovo_fps_embedded_comments_author_glyph') ? $0f10bb3caea56648$var$styles.commentLinkAuthorGlyph : $0f10bb3caea56648$var$styles.commentLink,
            children: commentContent(comment)
        }, key);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $0f10bb3caea56648$var$styles.container,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
            space: "space.150",
            children: visibleComments.map(commentWrapper)
        })
    });
};






const $0b34b6361e1f15bc$var$styles = {
    footerContainer: "_ca0qu2gc"
}; /**
    * Props passed by a search result renderer (e.g. SearchGraphDocument) to surface its three
    * "context" tabs in a single shared row of expand buttons:
    *   • Comments      — discussion contained inside the result
    *   • Mentioned in  — other documents that reference this result
    *   • Related links — semantically similar documents
    *
    * Each tab is gated independently. Rows are rendered only when their bucket is non-empty AND
    * their gate flag is satisfied. The first non-empty visible row is auto-expanded.
    */ 
const $0b34b6361e1f15bc$var$MENTIONED_BY = 'MENTIONEDBY'; /**
                                     * Renders the three peer "context" tabs (Comments, Mentioned in, Related links) for a search
                                     * result as a single shared row of expand buttons. Clicking a button reveals its content beneath
                                     * the row; only one row is open at a time (enforced by `ExpandList`).
                                     *
                                     * Bucketing is purely category-driven:
                                     *   • `category === 'SIMILAR'`     → Related links
                                     *   • `category === 'MENTIONEDBY'` → Mentioned in
                                     *   • Other categories             → ignored (consistent with the previous behaviour for 3P
                                     *                                    document renderers)
                                     *
                                     * Rows are emitted in a fixed visual order: Comments → Mentioned in → Related links. The first
                                     * non-empty visible row is auto-expanded; subsequent rows remain collapsed until clicked. When
                                     * no rows are eligible the component falls back to the restricted-lozenge (if `isNotPublic`),
                                     * matching the prior renderer behaviour.
                                     */ 
const $0b34b6361e1f15bc$export$72aa2b1900cff144 = ({ embeddedComments: embeddedComments, isEmbeddedCommentsEnabled: isEmbeddedCommentsEnabled, forceCommentsExpanded: forceCommentsExpanded = false, linkedResults: linkedResults, isMentionedInEnabled: isMentionedInEnabled, is3pGroupingEnabled: is3pGroupingEnabled, isAllProductSelected: isAllProductSelected, permissionLevel: permissionLevel, isNotPublic: isNotPublic, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, position: position, id: id, url: url, enrichedTitle: enrichedTitle, product: product, selectedProduct: selectedProduct, primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, partial: partial })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const hasEmbeddedComments = isEmbeddedCommentsEnabled && embeddedComments.length > 0; // `linkedResults` is the Relay-generated SearchPageNode supertype. Each element exposes a
    // `category` field of type `string | null | undefined`; we treat it as a simple
    // case-insensitive match against the category constants.
    const safeLinkedResults = linkedResults ?? [];
    const mentionedByLinkedResults = safeLinkedResults.filter((linkedResult)=>linkedResult.category?.toLocaleUpperCase() === $0b34b6361e1f15bc$var$MENTIONED_BY);
    const isSimilarEligible = (0, $b7a5d3c4b4eaddeb$export$df3a99a0361e78cf)({
        partial: partial,
        is3pGroupingEnabled: is3pGroupingEnabled,
        isAllProductSelected: isAllProductSelected
    });
    const hasSimilar = isSimilarEligible && safeLinkedResults.some((linkedResult)=>linkedResult.category?.toUpperCase() === 'SIMILAR'); // Mentioned-in is suppressed whenever Related links is shown: by product convention only one
    // of the two ever renders (Related links takes priority when SIMILAR items exist). This keeps
    // the footer focused on the most useful "linked" surface for the result.
    const hasMentionedIn = isMentionedInEnabled && mentionedByLinkedResults.length > 0 && !hasSimilar; // Build rows in fixed order. The Comments row uses `attachmentCount={embeddedComments.length}`
    // purely so ExpandList does not filter it out (ExpandList drops children whose
    // attachmentCount is 0); the rendered button surface still shows only the label, since
    // Drive/SharePoint do not expose total comment counts.
    const commentsExpand = hasEmbeddedComments ? /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        attachmentCount: embeddedComments.length,
        attachmentType: "comment",
        label: formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).comments),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $0f10bb3caea56648$export$824152dfe600f28c), {
            comments: embeddedComments
        })
    }) : null;
    const mentionedInExpand = hasMentionedIn ? /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))),
        attachmentCount: mentionedByLinkedResults.length,
        attachmentType: "url",
        label: formatMessage((0, $bdba1b2023ea1225$export$defe85febe8b728c).mentionedIn),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$d6b2e1eb75e7aa51), {
            id: id,
            product: product,
            productSelected: !!selectedProduct,
            primaryProduct: primaryProduct,
            title: enrichedTitle,
            url: url,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
            thirdPartyConfigs: thirdPartyConfigs,
            linkedResults: mentionedByLinkedResults,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultContextMenu,
            position: position
        })
    }) : null; // SimilarLinkedResultsExpand returns an <Expand> element directly. We invoke it as a regular
    // function (not as a JSX element) so the resulting <Expand> sits directly underneath the
    // shared ExpandList — ExpandList introspects its direct children's props (icon, label,
    // attachmentCount) to render the row of buttons, so wrapping the row in another component
    // would hide those props from it.
    const relatedLinksExpand = hasSimilar ? (0, $b7a5d3c4b4eaddeb$export$1fe86ff8d80e6df8)({
        linkedResults: safeLinkedResults,
        thirdPartyConfigs: thirdPartyConfigs,
        partial: partial,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        isAllProductSelected: isAllProductSelected,
        onResultContextMenu: onResultContextMenu,
        is3pGroupingEnabled: is3pGroupingEnabled,
        product: product
    }) : null; // Render rows in fixed visual order (Comments → Mentioned in → Related links). Null entries
    // are filtered out so ExpandList only sees the visible children directly (it introspects each
    // child's `icon` / `label` / `attachmentCount` props to render the row of buttons, so the
    // children must remain bare <Expand> elements rather than being wrapped in fragments).
    // `defaultExpandedIndex={0}` then auto-expands the first non-empty visible row.
    const visibleExpands = [
        commentsExpand,
        mentionedInExpand,
        relatedLinksExpand
    ].filter((row)=>row !== null);
    if (visibleExpands.length === 0) {
        // No tabs to render — fall back to the restricted lozenge for non-public results, matching
        // the renderer's previous footer behaviour.
        if (isNotPublic) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $0b34b6361e1f15bc$var$styles.footerContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2df34c79a6120f$export$3eac322cb0b365da), {
                restriction: permissionLevel
            })
        });
        return null;
    } // Comments auto-expand when present (matches the prior behaviour for embedded comments —
    // they are intrinsic content of the result and worth surfacing immediately). The two
    // "linked" surfaces (Mentioned in, Related links) start collapsed: only one of them is
    // ever rendered, by product convention, and the user opts in to inspect it. The
    // `forceCommentsExpanded` prop has no extra effect here — Comments is always the first
    // row in `visibleExpands` when present, and is therefore already at index 0 — but the
    // flag is honoured upstream by the document renderer (it bypasses the per-product
    // embedded-comments gate so the row renders at all when the Comments filter is active).
    const commentsIndex = visibleExpands.findIndex((expand)=>expand === commentsExpand);
    const defaultExpandedIndex = commentsIndex >= 0 && (forceCommentsExpanded || commentsIndex === 0) ? commentsIndex : undefined;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
        parentPosition: position,
        buttonType: "LINKED_COMMENT_FOOTER",
        defaultExpandedIndex: defaultExpandedIndex,
        children: visibleExpands
    });
};









function $b3bbf437cc7d9ed9$export$961e56f930032ef9(permissionLevel) {
    if (permissionLevel === 'public' || permissionLevel === 'private' || permissionLevel === 'restricted') return permissionLevel;
    return null;
}



var $4VkIo = parcelRequire("4VkIo");

const $61039992c4292c45$var$labelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $61039992c4292c45$var$contentIconStyles = null;
const $61039992c4292c45$var$IMAGE_THUMBNAIL_WIDTH = 204;
const $61039992c4292c45$var$IMAGE_THUMBNAIL_HEIGHT = 132;
const $61039992c4292c45$var$getSizedMediaThumbnailUrl = (mediaThumbnailUrl)=>{
    try {
        const thumbnailUrl = new URL(mediaThumbnailUrl);
        if (thumbnailUrl.protocol !== 'https:') return null;
        thumbnailUrl.searchParams.set('width', String($61039992c4292c45$var$IMAGE_THUMBNAIL_WIDTH));
        thumbnailUrl.searchParams.set('height', String($61039992c4292c45$var$IMAGE_THUMBNAIL_HEIGHT));
        return thumbnailUrl.toString();
    } catch  {
        return null;
    }
};
const $61039992c4292c45$export$d69ae1468ab7f1da = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, subtype: subtype, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth, is3pGroupingEnabled: is3pGroupingEnabled })=>{
    const data = (0, $irOoi.useFragment)((0, $29278d67853c092d$export$2e2bcd8739ae039), node);
    /**
   * A wrapper to include thirdPartyId in the onResultClicked callback.
   */ const onResultClickedWithThirdPartyId = (0, $42omo.useCallback)((params = {})=>{
        const thirdPartyId = data.entity?.thirdPartyId || undefined;
        return onResultClicked?.({
            ...params,
            thirdPartyId: thirdPartyId
        });
    }, [
        onResultClicked,
        data
    ]); /**
                                * A wrapper to include thirdPartyId in the onResultContextMenu callback.
                                */ 
    const onResultContextMenuWithThirdPartyId = (0, $42omo.useCallback)((params = {})=>{
        const thirdPartyId = data.entity?.thirdPartyId || undefined;
        return onResultContextMenu?.({
            ...params,
            thirdPartyId: thirdPartyId
        });
    }, [
        onResultContextMenu,
        data
    ]);
    const { id: id, url: url, title: title, excerpt: excerpt, entity: entity, lastModifiedDate: lastModifiedDate, permissionLevel: permissionLevel, linkedEntities: linkedEntities } = data;
    const isNotPublic = (0, $9NPDv.isNonPublic)(permissionLevel);
    const parentName = entity?.parent?.displayName || null;
    const containerName = entity?.container?.displayName || null; // Transform linkedEntities (comments) into EmbeddedComment format
    const embeddedComments = (0, $42omo.useMemo)(()=>{
        if (!linkedEntities?.length) return [];
        return linkedEntities.filter((linkedEntity)=>linkedEntity.excerpt).map((linkedEntity)=>({
                id: linkedEntity.id,
                parentId: linkedEntity.parentId ?? null,
                excerpt: linkedEntity.excerpt ?? null,
                url: linkedEntity.url,
                displayName: linkedEntity.entity?.displayName ?? null
            }));
    }, [
        linkedEntities
    ]); // Memoized URL validation function to avoid recreation on every render
    const isValidIconUrl = (0, $42omo.useCallback)((url)=>{
        try {
            const parsedUrl = new URL(url); // Only allow https URLs for security
            return parsedUrl.protocol === 'https:';
        } catch  {
            return false;
        }
    }, []); // Get icon URL and validate it
    const iconUrl = entity?.type?.iconUrl;
    const validatedIconUrl = (0, $42omo.useMemo)(()=>{
        return iconUrl && isValidIconUrl(iconUrl) ? iconUrl : null;
    }, [
        iconUrl,
        isValidIconUrl
    ]); // State to track if the icon image failed to load
    const [iconLoadError, setIconLoadError] = (0, $42omo.useState)(false); // Handle icon load error
    const handleIconError = (0, $42omo.useCallback)(()=>{
        setIconLoadError(true);
    }, []); // Reset error state when iconUrl changes
    (0, $42omo.useEffect)(()=>{
        setIconLoadError(false);
    }, [
        validatedIconUrl
    ]); // Memoize document icon creation to avoid recreation when props haven't changed
    const documentIcon = (0, $42omo.useMemo)(()=>{
        // GitBook support - use GitbookIcon when selectedProduct is 'gitbook'
        if (selectedProduct === 'gitbook') return /*#__PURE__*/ (0, $l998X.jsx)((0, $hP2yW.GitbookIcon), {});
        if (!validatedIconUrl || iconLoadError) return icon;
        return /*#__PURE__*/ (0, $l998X.jsx)("img", {
            src: validatedIconUrl,
            onError: handleIconError,
            alt: "",
            role: "presentation",
            className: (0, $gMc0m.default)([
                "_1bsbxy5q _4t3ixy5q _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _vchhusvi _5ral1f51"
            ])
        });
    }, [
        selectedProduct,
        validatedIconUrl,
        iconLoadError,
        handleIconError,
        icon
    ]);
    const shouldShowLastModified = lastModifiedDate && product !== (0, $1yEFx.ProductKeys).AtlassianWebCrawler;
    const lastModifiedComponent = shouldShowLastModified ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null; // We overwrite some subtype labels by product, eg for presentation->PowerPoint
    const label = (0, $9kYXz.getDocumentSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const subtypeComponent = subtype && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $61039992c4292c45$var$labelContainer,
        children: subtype?.replace(/-/g, ' ')
    });
    const labelComponent = label && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $61039992c4292c45$var$labelContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...label
        })
    });
    const headerMetadataParts = [
        [
            'label',
            labelComponent || subtypeComponent || null
        ],
        [
            'containerName',
            containerName
        ],
        [
            'parentName',
            parentName || null
        ],
        [
            'lastModified',
            lastModifiedComponent
        ]
    ];
    const enrichedTitle = (0, $Y34Hw.enrichExcerpt)(title);
    const mediaThumbnailUrl = entity?.nonIndexableContent?.mediaThumbnailUrl;
    const sizedMediaThumbnailUrl = mediaThumbnailUrl ? $61039992c4292c45$var$getSizedMediaThumbnailUrl(mediaThumbnailUrl) : null;
    const [thumbnailLoadError, setThumbnailLoadError] = (0, $42omo.useState)(false);
    const shouldAttemptThumbnail = subtype === 'image' && sizedMediaThumbnailUrl && (0, $dh538.fg)('rovo_fps_3p_document_image_thumbnail');
    const description = shouldAttemptThumbnail && !thumbnailLoadError ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2853273f3c22f618$export$9acaedfb553281a4), {
        resultUrl: url,
        thumbnailUrl: sizedMediaThumbnailUrl,
        onError: ()=>setThumbnailLoadError(true)
    }) : excerpt && /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(excerpt)
    });
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        })); // When the user explicitly selects the "Comments" type filter, treat that as an opt-in for
    // embedded comments — surface (and auto-expand) the Comments tab even if the per-product
    // rollout flag is off. This keeps the filtered view's intent consistent with what's shown.
    const { selectedEntities: selectedEntities } = (0, $4VkIo.useSelectedFilters)({});
    const isCommentsFilterActive = selectedEntities.includes((0, $2Znam.TypeFilterValueKey).Comment); // Embedded comments are gated per product so each product can be toggled independently:
    //   - Google Drive: enable_3p_embedded_comments_search
    //   - SharePoint:   rovo_fps_sharepoint_embedded_comments
    // Other products fall back to the shared 3p flag (current behaviour).
    // The Comments filter selection bypasses the per-product gate (the user has explicitly
    // asked for comments — honour that intent).
    const isEmbeddedCommentsEnabled = isCommentsFilterActive || (product === (0, $1yEFx.ProductKeys).Sharepoint ? (0, $dh538.fg)('rovo_fps_sharepoint_embedded_comments') : (0, $dh538.fg)('enable_3p_embedded_comments_search')); // Mentioned-in is currently scoped to Google Drive / SharePoint and gated by the existing
    // product feature flag.
    const isDriveOrSharepointResult = product === (0, $1yEFx.ProductKeys).GoogleDrive || product === (0, $1yEFx.ProductKeys).Sharepoint;
    const isMentionedInEnabled = isDriveOrSharepointResult && (0, $dh538.fg)('rovo_fps_enable_gdrive_sharepoint_mentioned'); // SearchResultContextFooter renders Comments / Mentioned in / Related links as peer expand
    // buttons in a single shared ExpandList. By product convention only one "linked" surface is
    // shown at a time: Related links takes priority over Mentioned in when SIMILAR items exist.
    // All rows start collapsed and the user expands one at a time.
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $0b34b6361e1f15bc$export$72aa2b1900cff144), {
        embeddedComments: embeddedComments,
        isEmbeddedCommentsEnabled: isEmbeddedCommentsEnabled,
        forceCommentsExpanded: isCommentsFilterActive,
        linkedResults: linkedResults,
        isMentionedInEnabled: isMentionedInEnabled,
        is3pGroupingEnabled: is3pGroupingEnabled,
        isAllProductSelected: !selectedProduct,
        permissionLevel: (0, $b3bbf437cc7d9ed9$export$961e56f930032ef9)(permissionLevel),
        isNotPublic: isNotPublic,
        onResultClicked: onResultClickedWithThirdPartyId,
        onResultContextMenu: onResultContextMenuWithThirdPartyId,
        position: position,
        id: id,
        url: url,
        enrichedTitle: enrichedTitle,
        product: product,
        selectedProduct: selectedProduct,
        primaryProduct: primaryProduct,
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        id: id,
        product: product,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClickedWithThirdPartyId,
        onResultContextMenu: onResultContextMenuWithThirdPartyId,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        title: enrichedTitle,
        icon: documentIcon,
        headerMetadataParts: headerMetadataParts,
        description: description,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        isThirdParty: true,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<416137cefc801f2d2aed8580e072bf1d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0b97e21f4d37cba6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = [
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        v1 /*: any*/ ,
                        v0 /*: any*/ 
                    ],
                    "type": "ExternalSpace"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphJiraDc_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "integrationId"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": v2 /*: any*/ ,
                        "type": "ExternalComment"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": v2 /*: any*/ ,
                        "type": "ExternalProject"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": v2 /*: any*/ ,
                        "type": "ExternalWorkItem"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "searchGraphJiraDcProject_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "searchGraphJiraDcWorkItem_AtlassianSearchPage"
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$0b97e21f4d37cba6$var$node.hash = "80e470e81e5ff9e507416cdfb6a7b7a6";
var $0b97e21f4d37cba6$export$2e2bcd8739ae039 = $0b97e21f4d37cba6$var$node;


parcelRequire("42omo");


































const $60df979cd5e73233$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    project: {
        id: "search-graph-jira-dc.project-result.label",
        defaultMessage: "Project"
    },
    space: {
        id: "search-graph-jira-dc.space-result.label",
        defaultMessage: "Space"
    },
    issue: {
        id: "search-graph-jira-dc.issue-result.label",
        defaultMessage: "Work item"
    },
    commment: {
        id: "search-graph-jira-dc.comment-result.label",
        defaultMessage: "Comment"
    }
});





/**
 * @generated SignedSource<<2d51b1184aab39a708e8cade6f9d30e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e3e0ecd21beca515$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = [
        {
            "concreteType": "ThirdPartyUser",
            "kind": "LinkedField",
            "name": "thirdPartyUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphJiraDcProject_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "integrationId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "subtype"
            },
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": v2 /*: any*/ 
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": v2 /*: any*/ 
                            },
                            {
                                "kind": "ScalarField",
                                "name": "dueDate"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            },
                                            v1 /*: any*/ 
                                        ],
                                        "type": "ExternalSpace"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalProject"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$e3e0ecd21beca515$var$node.hash = "efa0ed5362e28e5da85c6004de8eaa34";
var $e3e0ecd21beca515$export$2e2bcd8739ae039 = $e3e0ecd21beca515$var$node;























/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");



















const $c8b27af5d97101db$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    for: {
        id: "relay.jira-dc.work-item-status.for",
        defaultMessage: "{statusLozenge} for {dateLozenge}"
    },
    isAssigned: {
        id: "relay.jira-dc.work-item-assignee.assigned",
        defaultMessage: "{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}"
    },
    created: {
        id: "relay.jira-dc.work-item-creator.created",
        defaultMessage: "{created, select, internal {{firstName} created} other {External person created}}"
    }
});


const $82e2c7ad113e1592$export$e3945b9ca5ee7998 = [
    'ari:cloud:platform::integration/jira-dc',
    'ari:cloud:platform::integration/jira-dc-secondary',
    'ari:cloud:platform::integration/jira-dc-tertiary'
];
const $82e2c7ad113e1592$export$ba3533aa072a80cd = (props)=>{
    return props?.node?.__typename === 'SearchResultGraphDocument' && $82e2c7ad113e1592$export$e3945b9ca5ee7998.includes(props?.node?.integrationId ?? '');
};
const $82e2c7ad113e1592$export$9e2ad0c662b4c1bf = (key)=>key ? key + ' ' : '';
const $82e2c7ad113e1592$export$677945de1a5fba91 = (formatMessage, assigneeName, createdByName)=>{
    let actionLabel;
    const fullName = assigneeName || createdByName || '';
    if (!fullName) return null;
    const firstName = fullName?.split(' ')?.[0];
    if (assigneeName) actionLabel = formatMessage((0, $c8b27af5d97101db$export$defe85febe8b728c).isAssigned, {
        firstName: firstName,
        isAssigned: firstName ? 'internal' : 'external'
    });
    else actionLabel = formatMessage((0, $c8b27af5d97101db$export$defe85febe8b728c).created, {
        firstName: firstName,
        created: firstName ? 'internal' : 'external'
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.025",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                name: fullName
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($82e2c7ad113e1592$var$styles.nameContainer),
                children: actionLabel
            })
        ]
    });
};
const $82e2c7ad113e1592$export$9c8d0e44d1e8398 = (status, dueDate)=>{
    if (!status) return null;
    const statusLabel = status.replace(/[-_]+/g, ' ');
    const statusLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        appearance: $82e2c7ad113e1592$var$getStatusLozengeAppearance(statusLabel),
        children: statusLabel
    });
    const dateLozenge = /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedDate), {
            value: dueDate ?? undefined,
            month: "short",
            day: "numeric"
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($82e2c7ad113e1592$var$styles.statusAndDateContainerStyles),
        children: dueDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $c8b27af5d97101db$export$defe85febe8b728c).for,
            values: {
                statusLozenge: statusLozenge,
                dateLozenge: dateLozenge
            }
        }) : statusLozenge
    });
};
const $82e2c7ad113e1592$var$getStatusLozengeAppearance = (label)=>{
    label = label.replace(/[\s]+/g, '').toLowerCase();
    switch(true){
        case [
            'onhold'
        ].includes(label):
            return 'neutral';
        // gray
        case [
            'solved',
            'complete'
        ].includes(label):
            return 'success';
        // green
        case [
            'open',
            'offtrack'
        ].includes(label):
            return 'danger';
        // red
        case [
            'new',
            'atrisk'
        ].includes(label):
            return 'warning';
        // yellow
        case [
            'pending',
            'ontrack'
        ].includes(label):
            return 'information';
    }
    return 'information'; // blue for custom status labels
};
const $82e2c7ad113e1592$var$styles = {
    nameContainer: "_o5721q9c",
    statusAndDateContainerStyles: "_zulpu2gc _1e0c1txw _4cvr1h6o"
};







var $1BldJ = parcelRequire("1BldJ");










const $afd10684eae12f48$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    project: {
        id: "relay.jira-dc.project-result.label",
        defaultMessage: "Project"
    },
    space: {
        id: "relay.jira-dc.space-result.label",
        defaultMessage: "Space"
    },
    issue: {
        id: "relay.jira-dc.issue-result.label",
        defaultMessage: "Work item"
    },
    commment: {
        id: "relay.jira-dc.comment-result.label",
        defaultMessage: "Comment"
    }
});


const $eec12467ab9be34f$export$a438d1545a43fbaa = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, thirdPartyConfigs: thirdPartyConfigs, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $e3e0ecd21beca515$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, title: title } = data;
    const { assignee: assignee, createdBy: createdBy, dueDate: dueDate, status: status, key: key } = entity || {};
    const integrationId = data.integrationId;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $9NPDv.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const entityToLabelMap = {
        space: 'space',
        'work-item': 'issue',
        project: 'issue',
        comment: 'comment'
    };
    const { resourceType: resourceType } = (0, $42omo.useMemo)(()=>(0, $k4HRJ.AnyAri).parse(data.id), [
        data.id
    ]);
    const subtype = data.subtype ? (0, $1BldJ.getJiraSearchResultTypeMetadata)(data.subtype) : null;
    const resultType = subtype || (entityToLabelMap[resourceType] ?? resourceType);
    const labelMessage = (0, $afd10684eae12f48$export$defe85febe8b728c)[resultType];
    const label = resultType && labelMessage ? formatMessage(labelMessage) : $eec12467ab9be34f$var$getLabel(resultType);
    // Find the specific datasource for this result based on its integrationId
    const resultDatasource = thirdPartyConfigs?.[(0, $1yEFx.ProductKeys).JiraDC]?.datasources?.find((ds)=>ds.integrationId === integrationId) || null;
    const site = resultDatasource?.workspaceName || thirdPartyConfigs?.[(0, $1yEFx.ProductKeys).JiraDC]?.workspaceName || null;
    const containerName = entity?.container?.displayName;
    const containerUrl = entity?.container?.url;
    const container = containerUrl && containerName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
        label: containerName,
        href: containerUrl
    }) : containerName;
    const headerMetadataParts = [
        label,
        [
            'site',
            site
        ],
        [
            'container',
            container
        ],
        [
            'last-modified',
            lastModifiedComponent
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'status',
            (0, $82e2c7ad113e1592$export$9c8d0e44d1e8398)(status, dueDate)
        ],
        [
            'person',
            (0, $82e2c7ad113e1592$export$677945de1a5fba91)(formatMessage, assignee?.thirdPartyUser?.name, createdBy?.thirdPartyUser?.name)
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt ?? undefined, true)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title, (0, $82e2c7ad113e1592$export$9e2ad0c662b4c1bf)(key)),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $eec12467ab9be34f$var$getLabel = (entityNoun)=>entityNoun.replace(/-/g, ' ');
const $eec12467ab9be34f$export$a3305511c098cb21 = (node)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(node.id);
    return node?.__typename === 'SearchResultGraphDocument' && (resourceType === (0, $7ZetK.ResourceType).PROJECT || node?.subtype === (0, $7ZetK.ResourceType).PROJECT);
};





/**
 * @generated SignedSource<<a0e65cbf096163ce47edb1e851ca55d6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9c15493e6beb48b0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = [
        {
            "concreteType": "ThirdPartyUser",
            "kind": "LinkedField",
            "name": "thirdPartyUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphJiraDcWorkItem_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "integrationId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": v2 /*: any*/ 
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": v2 /*: any*/ 
                            },
                            {
                                "kind": "ScalarField",
                                "name": "dueDate"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "subtype"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "team"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            },
                                            v1 /*: any*/ 
                                        ],
                                        "type": "ExternalSpace"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalWorkItem"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$9c15493e6beb48b0$var$node.hash = "e5918a4fc563b65267f6c7d5107c7fb8";
var $9c15493e6beb48b0$export$2e2bcd8739ae039 = $9c15493e6beb48b0$var$node;


parcelRequire("42omo");





























const $1a4fe4da3026790a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    workItemLabel: {
        id: "relay.jira-dc-work-item.work-item.work-item-label",
        defaultMessage: "Work item"
    },
    issueLabel: {
        id: "relay.jira-dc-work-item.issue-label",
        defaultMessage: "Issue"
    }
});


const $9eaa0238cdd4a2a9$export$ff46249c8f6d43da = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, subtype: subtype, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $9c15493e6beb48b0$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { lastModifiedDate: lastModifiedDate, url: url, entity: entity, excerpt: excerpt, title: title } = data;
    const { dueDate: dueDate, status: status, team: team } = entity || {};
    const integrationId = data.integrationId;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const subtypeMap = {
        work_item: (0, $1a4fe4da3026790a$export$defe85febe8b728c).workItemLabel,
        issue: (0, $1a4fe4da3026790a$export$defe85febe8b728c).issueLabel,
        other: (0, $1a4fe4da3026790a$export$defe85febe8b728c).workItemLabel
    };
    const label = formatMessage(subtypeMap[subtype?.toLowerCase() ?? 'other'] || (0, $1a4fe4da3026790a$export$defe85febe8b728c).workItemLabel);
    // Find the specific datasource for this result based on its integrationId
    const resultDatasource = thirdPartyConfigs?.[(0, $1yEFx.ProductKeys).JiraDC]?.datasources?.find((ds)=>ds.integrationId === integrationId) || null;
    const site = resultDatasource?.workspaceName || thirdPartyConfigs?.[(0, $1yEFx.ProductKeys).JiraDC]?.workspaceName || null;
    const containerName = entity?.container?.displayName;
    const containerUrl = entity?.container?.url;
    const container = containerUrl && containerName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
        label: containerName,
        href: containerUrl
    }) : containerName;
    const headerMetadataParts = [
        label,
        [
            'site',
            site
        ],
        [
            'container',
            container
        ],
        [
            'last-modified',
            lastModifiedComponent
        ],
        [
            'status',
            (0, $82e2c7ad113e1592$export$9c8d0e44d1e8398)(status, dueDate)
        ],
        [
            'person',
            (0, $82e2c7ad113e1592$export$677945de1a5fba91)(formatMessage, data.entity?.assignee?.thirdPartyUser?.name, data.entity?.createdBy?.thirdPartyUser?.name)
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt ?? undefined, true)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title, (0, $82e2c7ad113e1592$export$9e2ad0c662b4c1bf)(team)),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $9eaa0238cdd4a2a9$export$1ac2dfe1fc47509f = (node)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(node.id);
    return node?.__typename === 'SearchResultGraphDocument' && resourceType === (0, $7ZetK.ResourceType).WORK_ITEM;
};


const $a81664d8b32e1a9b$var$SERVICE_DESK = 'service_desk';
const $a81664d8b32e1a9b$var$isJsmIcon = (containerType)=>{
    return containerType?.toLowerCase() === $a81664d8b32e1a9b$var$SERVICE_DESK;
};
const $a81664d8b32e1a9b$var$styles = {
    footerContainer: "_ca0qu2gc",
    typeLabelContainer: "_299m1dk0"
};
const $a81664d8b32e1a9b$var$PROJECT_SUBTYPES = new Set([
    'software',
    'service_desk',
    'business',
    'project' //to be removed once implementation is finalised
]);
const $a81664d8b32e1a9b$var$SUBTYPE_PROJECT = 'project';
const $a81664d8b32e1a9b$var$SUBTYPE_SPACE = 'space';
const $a81664d8b32e1a9b$var$SUBTYPE_COMMENT = 'comment';
const $a81664d8b32e1a9b$var$SUBTYPE_ISSUE = 'issue';
const $a81664d8b32e1a9b$var$JIRA_DC_LABELS = {
    [$a81664d8b32e1a9b$var$SUBTYPE_SPACE]: (0, $60df979cd5e73233$export$defe85febe8b728c).space,
    [$a81664d8b32e1a9b$var$SUBTYPE_PROJECT]: (0, $60df979cd5e73233$export$defe85febe8b728c).project,
    [$a81664d8b32e1a9b$var$SUBTYPE_COMMENT]: (0, $60df979cd5e73233$export$defe85febe8b728c).comment,
    [$a81664d8b32e1a9b$var$SUBTYPE_ISSUE]: (0, $60df979cd5e73233$export$defe85febe8b728c).issue
};
const $a81664d8b32e1a9b$var$getLabel = (subtype)=>{
    if ($a81664d8b32e1a9b$var$PROJECT_SUBTYPES.has(subtype)) return (0, $60df979cd5e73233$export$defe85febe8b728c).project;
    return $a81664d8b32e1a9b$var$JIRA_DC_LABELS[subtype];
};
const $a81664d8b32e1a9b$export$3464c3355ad3f97e = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, primaryProduct: primaryProduct, appMode: appMode, product: product, entityType: entityType, selectedProduct: selectedProduct, searchSessionId: searchSessionId, thirdPartyConfigs: thirdPartyConfigs, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $0b97e21f4d37cba6$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt } = data;
    const subtype = data?.subtype || null;
    const integrationId = data.integrationId;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const jiraIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    const jsmIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraServiceManagementIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    let icon = jiraIcon; // Find the specific datasource for this result based on its integrationId
    const resultDatasource = thirdPartyConfigs?.[product]?.datasources?.find((ds)=>ds.integrationId === integrationId) || null;
    const site = resultDatasource?.workspaceName || thirdPartyConfigs?.[product]?.workspaceName;
    const entityToLabelMap = {
        space: 'space',
        'work-item': 'issue',
        project: 'issue',
        comment: 'comment'
    };
    const resultType = subtype || (entityToLabelMap[entityType] ?? entityType);
    const labelMessage = $a81664d8b32e1a9b$var$getLabel(resultType);
    const label = labelMessage ? formatMessage(labelMessage) : resultType;
    const isNotPublic = (0, $9NPDv.isNonPublic)(permissionLevel);
    const SearchGraphJiraDcResult = (0, $eec12467ab9be34f$export$a3305511c098cb21)(data) ? (0, $eec12467ab9be34f$export$a438d1545a43fbaa) : (0, $9eaa0238cdd4a2a9$export$1ac2dfe1fc47509f)(data) ? (0, $9eaa0238cdd4a2a9$export$ff46249c8f6d43da) : null;
    if (SearchGraphJiraDcResult) {
        if ($a81664d8b32e1a9b$var$isJsmIcon(data.entity?.container?.subtype)) icon = jsmIcon;
        return /*#__PURE__*/ (0, $l998X.jsx)(SearchGraphJiraDcResult, {
            node: data,
            position: position,
            cloudId: cloudId,
            selectedProduct: selectedProduct,
            searchQuery: searchQuery,
            primaryProduct: primaryProduct,
            appMode: appMode,
            searchSessionId: searchSessionId,
            thirdPartyConfigs: thirdPartyConfigs,
            icon: icon,
            product: product,
            subtype: subtype,
            entityType: entityType,
            onCopyLinkButtonClicked: onCopyLinkButtonClicked,
            onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultContextMenu,
            onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
            onContextMenuButtonClicked: onContextMenuButtonClicked,
            mainContentWidth: mainContentWidth
        });
    }
    let container;
    if ($a81664d8b32e1a9b$var$isCommentEntity(data)) {
        const { entity: entity } = data;
        const containerName = entity?.container?.displayName;
        const containerUrl = entity?.container?.url;
        if ($a81664d8b32e1a9b$var$isJsmIcon(entity?.container?.subtype)) icon = jsmIcon;
        container = containerUrl && containerName ? /*#__PURE__*/ (0, $l998X.jsx)((0, $655681e89d0ffd52$export$2e2bcd8739ae039), {
            label: containerName,
            href: containerUrl
        }) : containerName;
    } else if ($a81664d8b32e1a9b$var$isJsmIcon(subtype)) icon = jsmIcon;
    const headerMetadataParts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $a81664d8b32e1a9b$var$styles.typeLabelContainer,
                children: label
            })
        ],
        [
            'site',
            site
        ],
        [
            'container',
            container
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ]; // space noun (project in the UI) and comment use default result component
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: (0, $Y34Hw.processExcerpt)(excerpt),
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        footer: isNotPublic && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $a81664d8b32e1a9b$var$styles.footerContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2df34c79a6120f$export$3eac322cb0b365da), {
                restriction: permissionLevel
            })
        }),
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $a81664d8b32e1a9b$var$isCommentEntity = (node)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(node?.id);
    return resourceType === (0, $7ZetK.ResourceType).COMMENT;
};





/**
 * @generated SignedSource<<7f46995dc1b101a8f98ab1001d568858>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $983e6d707353d744$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphMessage_AtlassianSearchPage",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "attachmentItems_AtlassianSearchPage_DropdownItems"
            },
            {
                "kind": "FragmentSpread",
                "name": "attachments_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "threadTitle_AtlassianSearchPage"
            },
            {
                "kind": "FragmentSpread",
                "name": "threadBody_AtlassianSearchPage"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "links"
            },
            {
                "concreteType": "SearchResultGraphAttachment",
                "kind": "LinkedField",
                "name": "attachments",
                "plural": true,
                "selections": v3 /*: any*/ 
            },
            {
                "concreteType": "SearchResultGraphDocument",
                "kind": "LinkedField",
                "name": "linkedEntities",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v4 /*: any*/ 
                                ],
                                "type": "ExternalMessage"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "linkedEntitiesType"
            },
            v5 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "lastActive"
                            },
                            v4 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "reactionCount"
                            },
                            {
                                "concreteType": "ExternalAttachment",
                                "kind": "LinkedField",
                                "name": "attachments",
                                "plural": true,
                                "selections": v3 /*: any*/ 
                            },
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "memberCount"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "membershipType"
                                            }
                                        ],
                                        "type": "ExternalConversation"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalMessage"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    v4 /*: any*/ ,
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$983e6d707353d744$var$node.hash = "df951b5e13a761dd66948ceaa86c4148";
var $983e6d707353d744$export$2e2bcd8739ae039 = $983e6d707353d744$var$node;


parcelRequire("42omo");








var $9lz2c = parcelRequire("9lz2c");


















/**
 * @generated SignedSource<<99c91b1ae1ac795845b971c4fac4ab8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $70e0eafbeacc75d4$var$node = function() {
    var v0 = {
        "kind": "FragmentSpread",
        "name": "threadMessage_AtlassianSearchPage"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "threadBody_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "integrationId"
            },
            {
                "concreteType": "SearchResultGraphDocument",
                "kind": "LinkedField",
                "name": "linkedEntities",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    v0 /*: any*/ 
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$70e0eafbeacc75d4$var$node.hash = "a11eded9a6a51942258f01f5565479d1";
var $70e0eafbeacc75d4$export$2e2bcd8739ae039 = $70e0eafbeacc75d4$var$node;


parcelRequire("42omo");







/**
 * @generated SignedSource<<74a392eb85e60f3c4ad26140a221d891>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e938a34be2b829c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    }, v1 = {
        "kind": "ScalarField",
        "name": "email"
    }, v2 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v3 = {
        "kind": "ScalarField",
        "name": "externalId"
    }, v4 = {
        "concreteType": "ThirdPartyUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "jobTitle"
            }
        ]
    }, v5 = [
        v0 /*: any*/ ,
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v4 /*: any*/ 
    ], v6 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v5 /*: any*/ 
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "threadMessage_AtlassianSearchPage",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "messageBody_AtlassianSearchPage"
            },
            {
                "kind": "ScalarField",
                "name": "integrationId"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                    v6 /*: any*/ ,
                                    {
                                        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedUsers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v0 /*: any*/ ,
                                                                    v2 /*: any*/ 
                                                                ],
                                                                "type": "AtlassianAccountUser"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalMessage"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                    v6 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "ExternalComment"
                    }
                ]
            },
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "initialContributors",
                "plural": true,
                "selections": v5 /*: any*/ 
            },
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "allContributors",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "nickname"
                    },
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v4 /*: any*/ 
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$7e938a34be2b829c$var$node.hash = "50c0ef91a6150a0448893e108b3bc9e1";
var $7e938a34be2b829c$export$2e2bcd8739ae039 = $7e938a34be2b829c$var$node;





































const $1e09a1fddf774e08$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    externalPersonLabel: {
        id: "externalPersonLabel",
        defaultMessage: "External person"
    }
});








/**
 * Builds the operational analytics event payload for the "External person" fallback case.
 */ const $f263ce87eb4ddae3$var$buildExternalPersonFallbackEvent = ({ traceId: traceId, searchSessionId: searchSessionId, integrationId: integrationId, hasThirdPartyUser: hasThirdPartyUser, hasInitialContributors: hasInitialContributors, hasAllContributors: hasAllContributors, thirdPartyUserHasName: thirdPartyUserHasName, initialContributorHasName: initialContributorHasName, allContributorHasName: allContributorHasName })=>({
        eventType: 'operational',
        action: 'taskFail',
        actionSubject: 'threadMessage',
        attributes: {
            commonAttributes: {
                traceId: traceId,
                searchSessionId: searchSessionId
            },
            additionalAttributes: {
                task: 'resolveMessageSender',
                capability: 'threadMessage_externalPersonFallback',
                integrationId: integrationId ?? null,
                hasThirdPartyUser: hasThirdPartyUser,
                hasInitialContributors: hasInitialContributors,
                hasAllContributors: hasAllContributors,
                thirdPartyUserHasName: thirdPartyUserHasName,
                initialContributorHasName: initialContributorHasName,
                allContributorHasName: allContributorHasName
            }
        }
    });
const $f263ce87eb4ddae3$export$761220c836611546 = ({ externalPersonFallback: externalPersonFallback, integrationId: integrationId, hasThirdPartyUser: hasThirdPartyUser, hasInitialContributors: hasInitialContributors, hasAllContributors: hasAllContributors, thirdPartyUserHasName: thirdPartyUserHasName, initialContributorHasName: initialContributorHasName, allContributorHasName: allContributorHasName })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const { traceId: traceId, searchSessionId: searchSessionId } = commonAttributes;
    (0, $42omo.useEffect)(()=>{
        if (!externalPersonFallback) return;
        fireAnalyticsEvent($f263ce87eb4ddae3$var$buildExternalPersonFallbackEvent({
            traceId: traceId,
            searchSessionId: searchSessionId,
            integrationId: integrationId,
            hasThirdPartyUser: hasThirdPartyUser,
            hasInitialContributors: hasInitialContributors,
            hasAllContributors: hasAllContributors,
            thirdPartyUserHasName: thirdPartyUserHasName,
            initialContributorHasName: initialContributorHasName,
            allContributorHasName: allContributorHasName
        }));
    }, [
        externalPersonFallback,
        integrationId,
        hasThirdPartyUser,
        hasInitialContributors,
        hasAllContributors,
        thirdPartyUserHasName,
        initialContributorHasName,
        allContributorHasName,
        traceId,
        searchSessionId,
        fireAnalyticsEvent
    ]);
};


const $9251487084b7a3c7$var$styles = {
    threadItem: "_n3td1b66 _ca0q1b66 _1e0c1ule _s7n4yfq0",
    nameContainer: "_o5721q9c",
    popupTrigger: "_zulpv77o _11c8fhey _1e0c116y _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _2hwx12x7 _bfhk1j28 _s7n4yfq0 _9oik1r31 _1bnx8stv _jf4cnqa1",
    regularUser: "_zulpv77o _1e0c116y _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _2hwx12x7 _bfhk1j28 _s7n4yfq0"
};
const { serveExperiment: $9251487084b7a3c7$var$serveDoubleLineRenderingModifications } = (0, $iA4lt.getFrontendExperiment)({
    abTestId: 'slack_result_rendering'
});
const $9251487084b7a3c7$export$1859ac2c716ee754 = ({ parent: parent, node: node })=>{
    const [isPersonPopupOpen, setIsPersonPopupOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const data = (0, $irOoi.useFragment)((0, $7e938a34be2b829c$export$2e2bcd8739ae039), node);
    const integrationId = parent?.integrationId || data?.integrationId; // Check for user with email priority:
    // createdBy?.thirdPartyUser -> initialContributors with email -> allContributors
    let user = data?.entity?.createdBy?.thirdPartyUser;
    if (!user?.name) {
        const initialContributor = data?.initialContributors?.[0];
        if (initialContributor?.email) user = initialContributor;
        else user = data?.allContributors?.[0];
    }
    (0, $f263ce87eb4ddae3$export$761220c836611546)({
        externalPersonFallback: !user?.name && !user?.nickname,
        integrationId: integrationId,
        hasThirdPartyUser: Boolean(data?.entity?.createdBy?.thirdPartyUser),
        hasInitialContributors: Boolean(data?.initialContributors?.length),
        hasAllContributors: Boolean(data?.allContributors?.length),
        thirdPartyUserHasName: Boolean(data?.entity?.createdBy?.thirdPartyUser?.name),
        initialContributorHasName: Boolean(data?.initialContributors?.[0]?.name),
        allContributorHasName: Boolean(data?.allContributors?.[0]?.name)
    });
    const currentMessageOwnerName = user?.name || user?.nickname || formatMessage((0, $1e09a1fddf774e08$export$a7357cdd1f0b0168).externalPersonLabel); // Use 3P picture if available, fall back to 1P AtlassianAccountUser picture from linkedUsers
    // (only when feature flag is enabled, to avoid using data fetched unnecessarily)
    const linkedUserPicture = (0, $dh538.fg)('rovo_fps_ms_teams_1p_picture_mapping') ? data?.entity?.createdBy?.linkedUsers?.edges?.find((edge)=>edge?.node?.name === currentMessageOwnerName)?.node?.picture ?? null : null;
    const picture = user?.picture ?? linkedUserPicture; // We are waiting for this commit ticket to complete for jobTitle & profileUrl
    const userData = user && user.name ? {
        name: user.name,
        profilePicUrl: picture ?? undefined,
        jobTitle: user.extendedProfile?.jobTitle,
        profileUrl: null // not available as of late Oct 2024
    } : null;
    const onCopyEmail = (0, $6a8b466b77e29197$export$b2199c37e85de4a7)(user?.email);
    const messageSender = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                name: currentMessageOwnerName,
                picture: picture
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $9251487084b7a3c7$var$styles.nameContainer,
                children: currentMessageOwnerName
            })
        ]
    });
    const externalMessageIntegration = (0, $42omo.useMemo)(()=>(0, $Y34Hw.getExternalMessageDmIntegrationInfo)(integrationId, {
            email: user?.email,
            externalId: user?.externalId
        }), [
        integrationId,
        user?.email,
        user?.externalId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $9251487084b7a3c7$var$styles.threadItem,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
            maxLines: $9251487084b7a3c7$var$serveDoubleLineRenderingModifications ? 2 : 1,
            children: [
                userData ? // if we don't have enough data to render the person card we shouldn't make the name
                //	a popup trigger
                /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                    isOpen: isPersonPopupOpen,
                    onClose: ()=>setIsPersonPopupOpen(false),
                    content: ()=>userData ? /*#__PURE__*/ (0, $l998X.jsx)((0, $168e8abba0f0ce48$export$4c094c8f61edecb4), {
                            user: userData,
                            externalMessageIntegration: externalMessageIntegration,
                            onCopyEmail: onCopyEmail
                        }) : null,
                    trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                            xcss: $9251487084b7a3c7$var$styles.popupTrigger,
                            onClick: ()=>setIsPersonPopupOpen(true),
                            ...triggerProps,
                            children: messageSender
                        })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $9251487084b7a3c7$var$styles.regularUser,
                    children: messageSender
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $f63e4118bbf61370$export$36e783c4ff07cd7c), {
                    integrationId: integrationId,
                    node: data
                })
            ]
        })
    });
};


const $6c8fe7e8d3a5eca9$export$39a3a4657e687b88 = ({ node: node, showParent: showParent = true, maxComments: maxComments = 2 })=>{
    const data = (0, $irOoi.useFragment)((0, $70e0eafbeacc75d4$export$2e2bcd8739ae039), node);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            showParent && /*#__PURE__*/ (0, $l998X.jsx)((0, $9251487084b7a3c7$export$1859ac2c716ee754), {
                parent: null,
                node: data
            }),
            data.linkedEntities?.slice(0, maxComments).map((linkedMessage)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9251487084b7a3c7$export$1859ac2c716ee754), {
                    node: linkedMessage,
                    parent: {
                        integrationId: data.integrationId
                    }
                }, linkedMessage.id))
        ]
    });
};





/**
 * @generated SignedSource<<766d807d3a93da5215c13d8d3031d3d5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9505a375d8687a8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "title"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "attachmentItems_AtlassianSearchPage_DropdownItems",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "SearchResultGraphAttachment",
                "kind": "LinkedField",
                "name": "attachments",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "fileType"
                    },
                    v1 /*: any*/ 
                ]
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalAttachment",
                                "kind": "LinkedField",
                                "name": "attachments",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "mimeType"
                                    },
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "thumbnailUrl"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalMessage"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$f9505a375d8687a8$var$node.hash = "b50007094eba88dbf814e17330590a16";
var $f9505a375d8687a8$export$2e2bcd8739ae039 = $f9505a375d8687a8$var$node;


parcelRequire("42omo");











var $e3TOY = parcelRequire("e3TOY");


var $fZtQj = parcelRequire("fZtQj");

































const $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    attachedDateLabel: {
        id: "relay.search-result.attachments.attached-date.label",
        defaultMessage: "Attached {formattedDate}"
    },
    attachmentLabel: {
        id: "relay.search-result.attachment-label",
        defaultMessage: "Attachment"
    },
    pdfLabel: {
        id: "relay.search-result.attachments.pdf-label",
        defaultMessage: "PDF"
    },
    videoLabel: {
        id: "relay.search-result.attachments.video-label",
        defaultMessage: "Video"
    },
    imageLabel: {
        id: "relay.search-result.attachments.image-label",
        defaultMessage: "Image"
    },
    audioLabel: {
        id: "relay.search-result.attachments.audio-label",
        defaultMessage: "Audio"
    }
});


const $9d89d5105e50bac9$var$dropdownItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    columnGap: 'space.100',
    paddingBlock: 'space.050',
    marginTop: 'space.100'
});
const $9d89d5105e50bac9$var$attachmentStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        color: 'color.link',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    // NOTE: this selector is preventing migration to @atlaskit/css as it's not officially supported.
    // Context: https://atlassian.slack.com/archives/CFJ9DU39U/p1754279429281269
    ':active:visited': {
        color: 'color.link.visited.pressed'
    }
});
const $9d89d5105e50bac9$var$graphQlFileTypeToConsolidatedFileType = (fileType)=>{
    if (!fileType) return 'attachment';
    switch(fileType){
        case 'image':
            return 'image';
        case 'audio':
            return 'audio';
        case 'video':
            return 'video';
        default:
            return 'attachment';
    }
};
const $9d89d5105e50bac9$var$fileTypeToIcon = (fileType, graphQlFileType)=>{
    if (!fileType) return 0, (/*@__PURE__*/$parcel$interopDefault($9lz2c));
    if (graphQlFileType && graphQlFileType === 'pdf') return 0, (/*@__PURE__*/$parcel$interopDefault($8jHAi));
    switch(fileType){
        case 'image':
            return 0, (/*@__PURE__*/$parcel$interopDefault($fZtQj));
        case 'audio':
            return 0, (/*@__PURE__*/$parcel$interopDefault($e3TOY));
        case 'video':
            return 0, (/*@__PURE__*/$parcel$interopDefault($2Yaht));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9lz2c));
    }
};
const $9d89d5105e50bac9$var$fileTypeToLabel = (fileType, graphQlFileType)=>{
    if (!fileType) return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).attachmentLabel;
    if (graphQlFileType && graphQlFileType === 'pdf') return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).pdfLabel;
    switch(fileType){
        case 'image':
            return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).imageLabel;
        case 'audio':
            return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).audioLabel;
        case 'video':
            return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).videoLabel;
        default:
            return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).attachmentLabel;
    }
};
const $9d89d5105e50bac9$var$mimeTypeToIcon = (mimeType)=>{
    if (!mimeType) return 0, (/*@__PURE__*/$parcel$interopDefault($9lz2c));
    const [type, specificType] = mimeType.split('/');
    if (specificType === 'pdf') return 0, (/*@__PURE__*/$parcel$interopDefault($8jHAi));
    switch(type){
        case 'video':
            return 0, (/*@__PURE__*/$parcel$interopDefault($2Yaht));
        case 'image':
            return 0, (/*@__PURE__*/$parcel$interopDefault($fZtQj));
        case 'audio':
            return 0, (/*@__PURE__*/$parcel$interopDefault($e3TOY));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9lz2c));
    }
};
const $9d89d5105e50bac9$var$mimeTypeToLabel = (mimeType)=>{
    if (!mimeType) return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).attachmentLabel;
    const [type, specificType] = mimeType.split('/');
    if (specificType === 'pdf') return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).pdfLabel;
    switch(type){
        case 'video':
            return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).videoLabel;
        case 'image':
            return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).imageLabel;
        case 'audio':
            return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).audioLabel;
        default:
            return (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).attachmentLabel;
    }
};
const $9d89d5105e50bac9$export$28f865e0208f513d = ({ node: node, product: product })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const forceUnclickableForTeams = (0, $dh538.fg)('search-page-unclickable-attachments-teams') && product === (0, $b4tvS.ProductKeys3P).Teams;
    const data = (0, $irOoi.useFragment)((0, $f9505a375d8687a8$export$2e2bcd8739ae039), node);
    // Prefer top-level GraphQL attachments when available,
    // otherwise fall back to entity attachments
    const useGraphqlAttachments = (data.attachments ?? []).length > 0;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        children: useGraphqlAttachments ? data.attachments?.map((attachment)=>{
            if (!attachment) return null;
            const { title: title, url: url, fileType: fileType } = attachment;
            const consolidatedFileType = $9d89d5105e50bac9$var$graphQlFileTypeToConsolidatedFileType(fileType);
            const FileTypeIcon = $9d89d5105e50bac9$var$fileTypeToIcon(consolidatedFileType, fileType);
            const truncatedUrl = url?.replace(/\/download\//g, '/');
            const viewUrl = forceUnclickableForTeams ? undefined : (0, $dh538.fg)('search-page-clickable-attachments') || fileType?.includes('image') ? truncatedUrl : undefined;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                xcss: $9d89d5105e50bac9$var$dropdownItemStyles,
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        space: "space.025",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)(FileTypeIcon, {
                                label: "icon",
                                size: "medium",
                                color: "var(--ds-icon-accent-blue, #357DE8)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "medium",
                                color: "color.link",
                                weight: "medium",
                                children: viewUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                                    xcss: $9d89d5105e50bac9$var$attachmentStyles,
                                    href: viewUrl,
                                    rel: 'noreferrer',
                                    target: "_blank",
                                    children: (0, $Y34Hw.enrichExcerpt)(title)
                                }) : (0, $Y34Hw.enrichExcerpt)(title)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        separator: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                            size: "small",
                            children: "\u2022"
                        }),
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "small",
                                children: formatMessage($9d89d5105e50bac9$var$fileTypeToLabel(consolidatedFileType, fileType))
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "small",
                                color: "color.text.subtle",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                                    lastModified: data.lastModifiedDate,
                                    message: (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).attachedDateLabel
                                })
                            })
                        ]
                    })
                ]
            }, url);
        }) : data.entity?.attachments?.map((attachment)=>{
            if (!attachment) return null;
            const { title: title, mimeType: mimeType, url: url, thumbnailUrl: thumbnailUrl } = attachment;
            const MimeTypeIcon = $9d89d5105e50bac9$var$mimeTypeToIcon(mimeType);
            const truncatedUrl = url?.replace(/\/download\//g, '/');
            const viewUrl = forceUnclickableForTeams ? undefined : (0, $dh538.fg)('search-page-clickable-attachments') ? truncatedUrl ?? thumbnailUrl : mimeType?.includes('image') ? truncatedUrl : thumbnailUrl;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                xcss: $9d89d5105e50bac9$var$dropdownItemStyles,
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        space: "space.025",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)(MimeTypeIcon, {
                                label: "icon",
                                size: "medium",
                                color: "var(--ds-icon-accent-blue, #357DE8)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "medium",
                                color: "color.link",
                                weight: "medium",
                                children: viewUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                                    xcss: $9d89d5105e50bac9$var$attachmentStyles,
                                    href: viewUrl,
                                    rel: 'noreferrer',
                                    target: "_blank",
                                    children: (0, $Y34Hw.enrichExcerpt)(title)
                                }) : (0, $Y34Hw.enrichExcerpt)(title)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        separator: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                            size: "small",
                            children: "\u2022"
                        }),
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "small",
                                children: formatMessage($9d89d5105e50bac9$var$mimeTypeToLabel(mimeType))
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "small",
                                color: "color.text.subtle",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                                    lastModified: data.lastModifiedDate,
                                    message: (0, $e3e44bbf05f0c8c3$export$a7357cdd1f0b0168).attachedDateLabel
                                })
                            })
                        ]
                    })
                ]
            }, url);
        })
    });
};





const $dde367fe129b91bd$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    threadTypeLabel: {
        id: "relay.search-result.thread-type-label",
        defaultMessage: "Thread"
    },
    messageTypeLabel: {
        id: "relay.search-result.message-type-label",
        defaultMessage: "Message"
    },
    lastActive: {
        id: "relay.search-result.message-last-active",
        defaultMessage: "Last active {formattedDate}"
    },
    attachedDateLabel: {
        id: "relay.search-result.attachments.attached-date.label",
        defaultMessage: "Attached {formattedDate}"
    },
    privateChannelLabel: {
        id: "relay.search-result.private-channel-label",
        defaultMessage: "Private Channel"
    },
    memberCount: {
        id: "relay.search-page.results.product-results.third-party.message-search-result.member-count",
        defaultMessage: "{count, plural, one {# member} other {# members}}"
    },
    smartlinkAttachmentsExpandButtonLabel: {
        id: "relay.search-page.results.product-results.third-party.message-search-result.smartlink-attachments-expand-button-label",
        defaultMessage: "{count, plural, one {# link} other {# links}}"
    },
    fileAttachmentsExpandButtonLabel: {
        id: "relay.search-page.results.product-results.third-party.message-search-result.file-attachments-expand-button-label",
        defaultMessage: "{count, plural, one {# attachment} other {# attachments}}"
    }
});





/**
 * @generated SignedSource<<2e91392088a11ffea6682cec2bce168b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f94f2ac6c5f705b7$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ], v1 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "initialContributors",
        "plural": true,
        "selections": v0 /*: any*/ 
    }, v2 = [
        {
            "concreteType": "ThirdPartyUser",
            "kind": "LinkedField",
            "name": "thirdPartyUser",
            "plural": false,
            "selections": v0 /*: any*/ 
        }
    ], v3 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": v2 /*: any*/ 
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "threadTitle_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "containerName"
            },
            {
                "kind": "ScalarField",
                "name": "workspaceName"
            },
            {
                "kind": "ScalarField",
                "name": "integrationId"
            },
            v1 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            },
                                            v4 /*: any*/ ,
                                            v5 /*: any*/ 
                                        ],
                                        "type": "ExternalConversation"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalMessage"
                    }
                ]
            },
            {
                "concreteType": "SearchResultGraphDocument",
                "kind": "LinkedField",
                "name": "linkedEntities",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "entity",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "container",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v4 /*: any*/ ,
                                                    v5 /*: any*/ 
                                                ],
                                                "type": "ExternalConversation"
                                            }
                                        ]
                                    }
                                ],
                                "type": "ExternalMessage"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$f94f2ac6c5f705b7$var$node.hash = "f1ac0a588153ce965e6a928cdf7b63fb";
var $f94f2ac6c5f705b7$export$2e2bcd8739ae039 = $f94f2ac6c5f705b7$var$node;


parcelRequire("42omo");

















const $c3354863f2722b97$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    threadTitleWithOthers: {
        id: "search-result.thread-title-with-others-and-channel-name",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {contributorCount, plural,\n\t\t\t\t=0 {}\n\t\t\t\t=1 {{name1} in }\n\t\t\t\t=2 {{name1} and {name2} in }\n\t\t\t\t=3 {{name1}, {name2}, and {name3} in }\n\t\t\t\t=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in }\n\t\t\t\tother {{name1}, {name2}, {name3}, and {overflowContributorCount} others in }\n\t\t\t}#{channelName} "
    },
    groupChatTitle: {
        id: "search-result.group-chat-title",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {contributorCount, plural,\n\t\t\t\t=0 {Group message with external users}\n\t\t\t\t=1 {{name1}}\n\t\t\t\t=2 {{name1} and {name2}}\n\t\t\t\t=3 {{name1}, {name2}, and {name3}}\n\t\t\t\t=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other}\n\t\t\t\tother {{name1}, {name2}, {name3}, and {overflowContributorCount} others}\n\t\t\t} "
    },
    groupMeetingTitle: {
        id: "search-result.group-meeting-title",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {contributorCount, plural,\n\t\t\t\t=0 {}\n\t\t\t\t=1 {{name1} in }\n\t\t\t\t=2 {{name1} and {name2} in }\n\t\t\t\t=3 {{name1}, {name2}, and {name3} in }\n\t\t\t\t=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in }\n\t\t\t\tother {{name1}, {name2}, {name3}, and {overflowContributorCount} others in }\n\t\t\t}{channelName} "
    },
    externalPeopleLabel: {
        id: "externalPeopleLabel",
        defaultMessage: "External people #{channelName}"
    },
    externalPersonLabel: {
        id: "externalPersonLabel",
        defaultMessage: "External person"
    },
    unknownChannel: {
        id: "search-result.unknown-channel-in-thread",
        defaultMessage: "unknown-channel"
    },
    directMessageSingleUser: {
        id: "search-result.direct-message-single-user",
        defaultMessage: "{name1} and 1 other"
    },
    directMessageTwoUsers: {
        id: "search-result.direct-message-two-users",
        defaultMessage: "{name1} and {name2}"
    },
    groupDirectMessageUnknownNames: {
        id: "search-result.group-direct-message-unknown-names",
        defaultMessage: "{totalPeopleCount} people"
    },
    federatedGroupDirectMessage: {
        id: "search-result.federated-group-direct-message",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {knownNamesCount, plural,\n\t\t\t\t=1 {{name1}}\n\t\t\t\t=2 {{name1} and {name2}}\n\t\t\t\t=3 {{name1}, {name2} and {name3}}\n\t\t\t\tother {{name1}, {name2} and {name3}}\n\t\t\t} "
    },
    federatedGroupDirectMessageWithOneOther: {
        id: "search-result.federated-group-direct-message-with-one-other",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {knownNamesCount, plural,\n\t\t\t\t=1 {{name1} and {totalOthersCount} other}\n\t\t\t\t=2 {{name1}, {name2} and {totalOthersCount} other}\n\t\t\t\t=3 {{name1}, {name2}, {name3} and {totalOthersCount} other}\n\t\t\t\tother {{name1}, {name2}, {name3} and {totalOthersCount} other}\n\t\t\t} "
    },
    federatedGroupDirectMessageWithMultipleOthers: {
        id: "search-result.federated-group-direct-message-with-multiple-others",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: " {knownNamesCount, plural,\n\t\t\t\t=1 {{name1} and {totalOthersCount} others}\n\t\t\t\t=2 {{name1}, {name2} and {totalOthersCount} others}\n\t\t\t\t=3 {{name1}, {name2}, {name3} and {totalOthersCount} others}\n\t\t\t\tother {{name1}, {name2}, {name3} and {totalOthersCount} others}\n\t\t\t} "
    }
});


const $71f86e8ae561d577$var$USER_DISPLAY_LIMIT = 3;
const $71f86e8ae561d577$var$dedupUsers = (userMap, user, index)=>{
    if (!userMap[user.id]) userMap[user.id] = {
        thirdPartyUser: user,
        index: index
    };
    return userMap;
};
const $71f86e8ae561d577$var$getTitleMessageValues = (intl, users = [])=>{
    const { formatMessage: formatMessage } = intl;
    const uniqueUsers = users.filter((thirdPartyUser)=>Boolean(thirdPartyUser?.name?.trim())).reduce($71f86e8ae561d577$var$dedupUsers, {});
    const validContributors = Object.values(uniqueUsers).sort((a, b)=>a.index - b.index).map((entry)=>entry?.thirdPartyUser?.name || formatMessage((0, $c3354863f2722b97$export$a7357cdd1f0b0168).externalPersonLabel)).map((name)=>name?.split(' ')[0]);
    const externalPersonLabel = formatMessage((0, $c3354863f2722b97$export$a7357cdd1f0b0168).externalPersonLabel);
    const externalPersonCount = validContributors.filter((name)=>name === externalPersonLabel).length;
    let adjustedContributors = validContributors;
    if (externalPersonCount > 1) {
        adjustedContributors = validContributors.filter((name)=>name !== externalPersonLabel);
        adjustedContributors.unshift(formatMessage((0, $c3354863f2722b97$export$a7357cdd1f0b0168).externalPeopleLabel));
    }
    const contributorCount = adjustedContributors.length;
    const namedContributors = adjustedContributors.slice(0, $71f86e8ae561d577$var$USER_DISPLAY_LIMIT);
    const overflowContributorCount = adjustedContributors.slice($71f86e8ae561d577$var$USER_DISPLAY_LIMIT).length;
    return {
        contributorCount: contributorCount,
        namedContributors: namedContributors,
        overflowContributorCount: overflowContributorCount
    };
};
const $71f86e8ae561d577$var$truncateWorkspaceName = (name)=>{
    if (name.length <= (0, $748199d195cd32c0$export$551a816c078ac825)) return name;
    return `${name.slice(0, (0, $748199d195cd32c0$export$551a816c078ac825))}...`;
};
const $71f86e8ae561d577$var$getRegularThreadTitleValues = (data, intl, formatMessage)=>{
    const linkedEntities = data.linkedEntities || [];
    const threadUsers = [
        data,
        ...linkedEntities
    ].map((linkedMessage)=>linkedMessage?.entity?.createdBy?.thirdPartyUser || linkedMessage?.initialContributors?.[0]);
    const { contributorCount: contributorCount, namedContributors: namedContributors, overflowContributorCount: overflowContributorCount } = $71f86e8ae561d577$var$getTitleMessageValues(intl, threadUsers);
    const [name1, name2, name3] = namedContributors;
    const rawWorkspaceName = data?.workspaceName;
    const channelName = data?.entity?.container?.displayName || (rawWorkspaceName ? $71f86e8ae561d577$var$truncateWorkspaceName(rawWorkspaceName) : null) || data?.containerName || formatMessage((0, $c3354863f2722b97$export$a7357cdd1f0b0168).unknownChannel);
    return {
        values: {
            contributorCount: contributorCount,
            name1: name1,
            name2: name2,
            name3: name3,
            overflowContributorCount: overflowContributorCount,
            channelName: channelName
        },
        titleMessage: (0, $c3354863f2722b97$export$a7357cdd1f0b0168).threadTitleWithOthers
    };
};
const $71f86e8ae561d577$export$18638a7ae5c7368a = ({ node: node, thirdPartyConfigs: thirdPartyConfigs })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { formatMessage: formatMessage } = intl;
    let values = {};
    let titleMessage = (0, $c3354863f2722b97$export$a7357cdd1f0b0168).groupChatTitle;
    const data = (0, $irOoi.useFragment)((0, $f94f2ac6c5f705b7$export$2e2bcd8739ae039), node);
    const isSlackFederatedSearchEnabled = (0, $8RFAN.serveFederatedSlackExperiment)(undefined, undefined, {
        fireExperimentExposure: false
    }, thirdPartyConfigs);
    const isSlackIntegration = data.integrationId === 'ari:cloud:platform::integration/slack';
    if (data.containerName != null && isSlackFederatedSearchEnabled && isSlackIntegration) {
        const groupChatParticipants = data?.initialContributors;
        // direct message
        if (data.containerName === '') {
            const nonNullParticipants = groupChatParticipants?.filter((participant)=>participant?.name) || [];
            const { namedContributors: namedContributors } = $71f86e8ae561d577$var$getTitleMessageValues(intl, nonNullParticipants);
            const [name1, name2] = namedContributors;
            if (nonNullParticipants.length === 1) {
                values = {
                    name1: name1
                };
                titleMessage = (0, $c3354863f2722b97$export$a7357cdd1f0b0168).directMessageSingleUser;
            } else {
                values = {
                    name1: name1,
                    name2: name2
                };
                titleMessage = (0, $c3354863f2722b97$export$a7357cdd1f0b0168).directMessageTwoUsers;
            }
        } else if (data.containerName && /^mpdm-.+--.*-\d+$/.test(data.containerName)) {
            // Extract number of people from containerName (format: mpdm-name1--name2--name3-1)
            const totalPeopleCount = (data.containerName.match(/--/g) || []).length + 1;
            const nonNullParticipants = groupChatParticipants?.filter((participant)=>participant?.name) || [];
            const otherCount = totalPeopleCount - nonNullParticipants.length;
            if (nonNullParticipants.length > 0) {
                const { namedContributors: namedContributors } = $71f86e8ae561d577$var$getTitleMessageValues(intl, nonNullParticipants);
                const displayedNames = namedContributors.slice(0, $71f86e8ae561d577$var$USER_DISPLAY_LIMIT);
                const [name1, name2, name3] = displayedNames;
                // Calculate total others (remaining known names + unknown people)
                const totalOthersCount = nonNullParticipants.length - displayedNames.length + otherCount;
                const hasOthers = totalOthersCount > 0;
                values = {
                    knownNamesCount: nonNullParticipants.length,
                    name1: name1,
                    name2: name2,
                    name3: name3,
                    totalOthersCount: totalOthersCount
                };
                titleMessage = hasOthers ? totalOthersCount === 1 ? (0, $c3354863f2722b97$export$a7357cdd1f0b0168).federatedGroupDirectMessageWithOneOther : (0, $c3354863f2722b97$export$a7357cdd1f0b0168).federatedGroupDirectMessageWithMultipleOthers : (0, $c3354863f2722b97$export$a7357cdd1f0b0168).federatedGroupDirectMessage;
            } else {
                // Fallback if no names available
                values = {
                    totalPeopleCount: totalPeopleCount
                };
                titleMessage = (0, $c3354863f2722b97$export$a7357cdd1f0b0168).groupDirectMessageUnknownNames;
            }
        } else {
            const result = $71f86e8ae561d577$var$getRegularThreadTitleValues(data, intl, formatMessage);
            values = result.values;
            titleMessage = result.titleMessage;
        }
    } else if (data?.entity?.container?.type === 'GROUP_MEETING' && (0, $dh538.fg)('rovo_fps_fix_unknown_channel_group_chat')) {
        const displayName = data?.entity?.container?.displayName?.trim();
        if (displayName) {
            // Named GROUP_MEETING — show "Bob in Create some random chat data" (no #)
            const result = $71f86e8ae561d577$var$getRegularThreadTitleValues(data, intl, formatMessage);
            values = {
                ...result.values,
                channelName: displayName
            };
            titleMessage = (0, $c3354863f2722b97$export$a7357cdd1f0b0168).groupMeetingTitle;
        } else {
            // Unnamed GROUP_MEETING — show names only, don't show "unknown-channel"
            const groupChatParticipants = data?.entity?.container?.members?.map((member)=>member?.thirdPartyUser) ?? [];
            const { contributorCount: contributorCount, namedContributors: namedContributors, overflowContributorCount: overflowContributorCount } = $71f86e8ae561d577$var$getTitleMessageValues(intl, groupChatParticipants);
            const [name1, name2, name3] = namedContributors;
            values = {
                contributorCount: contributorCount,
                name1: name1,
                name2: name2,
                name3: name3,
                overflowContributorCount: overflowContributorCount
            };
            titleMessage = (0, $c3354863f2722b97$export$a7357cdd1f0b0168).groupChatTitle;
        }
    } else if (data?.entity?.container?.type === 'DIRECT_MESSAGE' || data?.entity?.container?.type === 'GROUP_DIRECT_MESSAGE') {
        const groupChatParticipants = data?.entity?.container?.members?.map((member)=>member?.thirdPartyUser) ?? [];
        const { contributorCount: contributorCount, namedContributors: namedContributors, overflowContributorCount: overflowContributorCount } = $71f86e8ae561d577$var$getTitleMessageValues(intl, groupChatParticipants);
        const [name1, name2, name3] = namedContributors;
        values = {
            contributorCount: contributorCount,
            name1: name1,
            name2: name2,
            name3: name3,
            overflowContributorCount: overflowContributorCount
        };
        titleMessage = (0, $c3354863f2722b97$export$a7357cdd1f0b0168).groupChatTitle;
    } else {
        const result = $71f86e8ae561d577$var$getRegularThreadTitleValues(data, intl, formatMessage);
        values = result.values;
        titleMessage = result.titleMessage;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
        ...titleMessage,
        values: values
    });
};


const $1cb6de7b071beecb$export$8054dcb2b42da45c = (data, linkedEntities)=>{
    // If GraphQL provided links (even an empty array), use them directly
    if (Array.isArray(data.links)) return [
        ...data.links
    ];
    // Otherwise, fall back to parsing links from text (pre-existing approach)
    return [
        data,
        ...linkedEntities ?? []
    ]?.map((node)=>node.entity?.description || node.excerpt)?.filter((excerpt)=>!!excerpt)?.flatMap((0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)) ?? [];
};
const $1cb6de7b071beecb$export$eb10cea9a7aeba8c = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $983e6d707353d744$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { url: url, linkedEntities: linkedEntities = [] } = data;
    // Get attachments count - prefer GraphQL schema attachments when available,
    // otherwise fall back to entity attachments
    const graphqlAttachments = data.attachments ?? [];
    const entityAttachments = data.entity?.attachments || [];
    const attachments = graphqlAttachments.length > 0 ? graphqlAttachments : entityAttachments;
    // Use linkedEntitiesType if available, otherwise fallback to existing logic
    const labelMessage = data.linkedEntitiesType ? data.linkedEntitiesType === 'thread' ? (0, $dde367fe129b91bd$export$defe85febe8b728c).threadTypeLabel : (0, $dde367fe129b91bd$export$defe85febe8b728c).messageTypeLabel : linkedEntities?.length ? (0, $dde367fe129b91bd$export$defe85febe8b728c).threadTypeLabel : (0, $dde367fe129b91bd$export$defe85febe8b728c).messageTypeLabel;
    const title = /*#__PURE__*/ (0, $l998X.jsx)((0, $71f86e8ae561d577$export$18638a7ae5c7368a), {
        node: data,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $6c8fe7e8d3a5eca9$export$39a3a4657e687b88), {
        node: data
    });
    const parts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...labelMessage
            })
        ]
    ];
    const socialParts = [];
    const conversationMemberCount = data.entity?.container?.memberCount;
    if (conversationMemberCount) parts.push([
        'memberCount',
        /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $dde367fe129b91bd$export$defe85febe8b728c).memberCount,
            values: {
                count: conversationMemberCount
            }
        })
    ]);
    const lastActiveDate = data?.entity?.lastActive || data?.lastModifiedDate;
    if (lastActiveDate) parts.push([
        'lastActive',
        /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
            lastModified: lastActiveDate,
            message: (0, $dde367fe129b91bd$export$defe85febe8b728c).lastActive
        })
    ]);
    // Add reaction count UI if feature flag is enabled
    if ((0, $dh538.fg)('rovo_fps_enable_3p_messages_reaction_count_ui')) {
        const likeCountComponent = (0, $f70284887e2e1865$export$b52fa2ff0823604f)(data.entity?.reactionCount);
        if (likeCountComponent) socialParts.push([
            'like-count',
            likeCountComponent
        ]);
    }
    const links = $1cb6de7b071beecb$export$8054dcb2b42da45c(data, linkedEntities);
    const shouldShowAttachmentsOrLinks = attachments.length > 0 || links.length > 0;
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const shouldShowRelatedLinks = linkedResults && linkedResults.length > 0;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: body,
        headerMetadataParts: parts,
        headerMetadataSocialParts: socialParts,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: shouldShowRelatedLinks ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
                linkedResults: linkedResults || [],
                thirdPartyConfigs: thirdPartyConfigs,
                partial: data,
                url: url,
                onResultClicked: onResultClicked,
                position: position,
                onResultContextMenu: onResultContextMenu,
                isAllProductSelected: !selectedProduct
            }) : shouldShowAttachmentsOrLinks && /*#__PURE__*/ (0, $l998X.jsxs)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))),
                        attachmentCount: attachments.length,
                        attachmentType: "file",
                        label: formatMessage((0, $dde367fe129b91bd$export$defe85febe8b728c).fileAttachmentsExpandButtonLabel, {
                            count: attachments.length
                        }),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9d89d5105e50bac9$export$28f865e0208f513d), {
                            node: data,
                            product: product
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
                        attachmentCount: links.length,
                        attachmentType: "url",
                        label: formatMessage((0, $514d99dea8b7ae4b$export$47614749115bca3d), {
                            count: links.length
                        }),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $514d99dea8b7ae4b$export$dffce0f8d8968f9c), {
                            links: links,
                            onResultClicked: onResultClicked
                        })
                    })
                ]
            })
        }),
        title: title,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        appMode: appMode,
        isPrivate: data?.entity?.container?.membershipType === 'PRIVATE',
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<827a972150dfebd3ab7f0a7d54ce5c07>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $698bf5c47f2c99a5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "url"
    }, v2 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphPullRequest_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "ScalarField",
                "name": "containerName"
            },
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "lastUpdate"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "pullRequestId"
                            },
                            {
                                "alias": "pullRequestStatus",
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v4 /*: any*/ 
                                        ],
                                        "type": "ExternalRepository"
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalPullRequest"
                    }
                ]
            },
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "initialContributors",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "threadBody_AtlassianSearchPage"
            },
            {
                "concreteType": "SearchResultGraphDocument",
                "kind": "LinkedField",
                "name": "linkedEntities",
                "plural": true,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v3 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$698bf5c47f2c99a5$var$node.hash = "8a0af99579aaad577a3dc3ce55453372";
var $698bf5c47f2c99a5$export$2e2bcd8739ae039 = $698bf5c47f2c99a5$var$node;































// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 








/**
 * Generates a GraphQL query that uses UGS Cypher to find Jira issue URLs
 * linked to a given entity via a specified relationship type.
 *
 * The actual Cypher traversal query and entity ARI are passed as variables,
 * making this query reusable for any relationship that targets JiraIssue nodes
 * (e.g., `issue_associated_pr`, `issue_associated_commit`, etc.).
 *
 * Returns only the `webUrl` field, which is passed to Smart Card for rendering.
 *
 * @see https://developer.atlassian.com/cloud/ari-graph-store/cypher/api-usage
 */ const $c089aa53c9f31aa8$export$3ff7d5f891e140d8 = ()=>{
    return `
	query SearchPageLinkedJiraIssuesHydration(
		$cypherQuery: String!
		$params: JSON!
		$queryContext: String!
	) {
		graphStore @optIn(to: "GraphStore") {
			cypherQueryV2(
				query: $cypherQuery
				params: $params
				queryContext: $queryContext
			) @optIn(to: "GraphStoreCypherQueryV2") {
				edges {
					node {
						columns {
							key
							value {
								... on GraphStoreCypherQueryV2AriNode {
									data {
										... on JiraIssue {
											webUrl
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
};


/**
 * Default Cypher query for finding Jira issues linked to a pull request
 * via the `issue_associated_pr` relationship.
 */ const $b1db62a3747eff0f$var$PR_TO_JIRA_ISSUE_CYPHER_QUERY = 'MATCH (issue:JiraIssue)-[:issue_associated_pr]->(pr:GraphPullRequest {ari: $id}) RETURN issue';
const $b1db62a3747eff0f$var$cache = (0, $hw4j5.inMemoryCache)();
const $b1db62a3747eff0f$var$expireOnErrorOrEmpty = (result)=>{
    const { data: data, errors: errors } = result;
    return !data || !!errors && errors.length > 0;
};
/**
 * Extracts Jira issue URLs from a Cypher query response.
 */ function $b1db62a3747eff0f$var$parseJiraIssueUrls(response) {
    const edges = response.data?.graphStore?.cypherQueryV2?.edges;
    if (!edges || edges.length === 0) return [];
    const urls = [];
    for (const edge of edges)for (const column of edge.node.columns){
        const webUrl = column.value?.data?.webUrl;
        if (webUrl) urls.push(webUrl);
    }
    return urls;
}
async function $b1db62a3747eff0f$export$4391d4b38f03358f(entityAri, queryContext, { aggAbsoluteUrl: aggAbsoluteUrl, headers: headers }, cypherQuery = $b1db62a3747eff0f$var$PR_TO_JIRA_ISSUE_CYPHER_QUERY) {
    const graphQuery = (0, $c089aa53c9f31aa8$export$3ff7d5f891e140d8)();
    const variables = {
        cypherQuery: cypherQuery,
        params: {
            id: entityAri
        },
        queryContext: queryContext
    };
    const response = await $b1db62a3747eff0f$var$cache.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)({
        entityAri: entityAri,
        cypherQuery: cypherQuery
    }), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: 'SearchPageLinkedJiraIssuesHydration',
            headers: headers
        }), $b1db62a3747eff0f$var$expireOnErrorOrEmpty);
    return $b1db62a3747eff0f$var$parseJiraIssueUrls(response);
}
async function $b1db62a3747eff0f$export$ae41544460413386(entityAris, queryContext, fetchProps, cypherQuery) {
    const results = {};
    // Fetch in parallel for all entity ARIs
    const promises = entityAris.map(async (entityAri)=>{
        try {
            const urls = await $b1db62a3747eff0f$export$4391d4b38f03358f(entityAri, queryContext, fetchProps, cypherQuery);
            results[entityAri] = urls;
        } catch  {
            results[entityAri] = null;
        }
    });
    await Promise.all(promises);
    return results;
}


















const $81899a88e127576f$export$94a5d1171b2b3f1 = ({ issueCount: issueCount })=>{
    return {
        action: 'taskSuccess',
        actionSubject: 'linkedJiraIssuesFetch',
        eventType: 'operational',
        source: (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                issueCount: issueCount
            }
        }
    };
};
const $81899a88e127576f$export$50285b4aadb60bc9 = ({ reason: reason })=>{
    return {
        action: 'taskFail',
        actionSubject: 'linkedJiraIssuesFetch',
        eventType: 'operational',
        source: (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                reason: reason
            }
        }
    };
};






var $2vU0F = parcelRequire("2vU0F");


















const $60785cd45ae6de28$var$localMessages = (0, $aXWIB.defineMessages)({
    resultLabel: {
        id: "search-pull-request-result.label",
        defaultMessage: "Pull request"
    },
    commentsLabel: {
        id: "search-pull-request-result.comments-label",
        defaultMessage: "{count} {count, plural, one {comment} other {comments}}"
    }
});
const $60785cd45ae6de28$export$defe85febe8b728c = {
    ...$60785cd45ae6de28$var$localMessages,
    ...(0, $2vU0F.pullRequestStatusMessages)
};


const $5d482861d79b63c5$var$styles = {
    commentsContent: "_bozgutpp"
};
const $5d482861d79b63c5$export$ff9a66c66b5ab669 = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $698bf5c47f2c99a5$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, containerName: containerName, lastModifiedDate: lastModifiedDate, title: partialTitle, initialContributors: initialContributors } = data;
    const { title: entityTitle, lastUpdate: lastUpdate, container: container, pullRequestId: pullRequestId, pullRequestStatus: status } = entity || {};
    const label = formatMessage((0, $60785cd45ae6de28$export$defe85febe8b728c).resultLabel);
    const lastModifiedComponent = lastModifiedDate || lastUpdate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastUpdate ?? lastModifiedDate
    }) : null;
    const padlockIcon = (0, $9NPDv.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null; // Memoize the regex-heavy excerpt cleanup so we don't re-run the full
    // `removeHtmlTags` → `removeMarkdown` → `removeUrlsFromText` pipeline on
    // every parent re-render. The pipeline is bounded (excerpts are short and
    // regexes are linear-time) but unmemoized it would re-run every commit.
    //
    // PR descriptions can contain a restricted subset of HTML (e.g. `<img>`,
    // `<picture>`, `<details>`) and Markdown. For excerpt rendering we want
    // plain text. Order matters here:
    //   1. Strip HTML FIRST so media-asset URLs (`<img src="…">`) and tag
    //      markup don't appear inline. We must do this before `removeMarkdown`
    //      because that helper's "broken autolink" rule eats the leading `<`
    //      of any HTML tag, which would corrupt the tag and prevent us from
    //      removing it cleanly afterwards.
    //   2. Run `removeMarkdown` to flatten markdown link labels (`[label](url)`
    //      → `label`), inline code, headings, etc.
    //   3. Strip any remaining bare URLs — they're surfaced via the Links
    //      expand instead.
    // The Links expand reads from `cleanedExcerptForLinks` (after HTML +
    // markdown) so it stays in sync with what's visible in the body.
    const stripLinksFromExcerpt = (0, $dh538.fg)('rovo_fps_pr_strip_links_from_excerpt');
    const cleanedExcerptForLinks = (0, $42omo.useMemo)(()=>{
        if (!stripLinksFromExcerpt) return excerpt || '';
        return (0, $4dd635508e197aad$export$7e4bcd4afb389edb)((0, $514d99dea8b7ae4b$export$b7bece7666af5428)(excerpt || ''));
    }, [
        excerpt,
        stripLinksFromExcerpt
    ]);
    const descriptionText = (0, $42omo.useMemo)(()=>{
        if (stripLinksFromExcerpt) // `cleanedExcerptForLinks` is already `removeMarkdown(removeHtmlTags(...))`,
        // so we just need the final URL-stripping pass on top.
        return (0, $Y34Hw.processExcerpt)((0, $514d99dea8b7ae4b$export$2f84a359bd634be4)(cleanedExcerptForLinks), true);
        return (0, $Y34Hw.processExcerpt)((0, $4dd635508e197aad$export$7e4bcd4afb389edb)(excerpt), true);
    }, [
        excerpt,
        cleanedExcerptForLinks,
        stripLinksFromExcerpt
    ]);
    const isPrCommentsEnabled = (0, $dh538.fg)('rovo_fps_enable_pr_comments'); // TODO: Wire up real build status data when GraphQL schema is available
    // const isCiCdEnabled = fg('rovo_fps_enable_git_ui_ci_cd');
    // const buildStatusComponent = isCiCdEnabled ? (
    // 	<GitBuildStatus build={placeholderBuildStatus} testId="pull-request-build-status" />
    // ) : null;
    const buildStatusComponent = null;
    const maxComments = 5;
    const statusLabel = status ? formatMessage((0, $60785cd45ae6de28$export$defe85febe8b728c)[`status_${status.toLowerCase()}`] ?? (0, $60785cd45ae6de28$export$defe85febe8b728c).resultLabel) : null;
    const statusLozenge = status && statusLabel ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        appearance: (0, $2vU0F.getPullRequestStatusAppearance)(status),
        testId: "pull-request-status-lozenge",
        isBold: true,
        children: statusLabel
    }) : null;
    const titleMetadataParts = statusLozenge ? [
        [
            'status',
            statusLozenge
        ]
    ] : [];
    if (buildStatusComponent) titleMetadataParts.unshift([
        'build-status',
        buildStatusComponent
    ]);
    const headerMetadataParts = [
        label,
        [
            'pull-request-id',
            pullRequestId ? `#${pullRequestId}` : null
        ],
        [
            'repository-name',
            container?.name ?? containerName ?? null
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ]; // Add contributor if they exist
    const initialContributor = initialContributors?.[0] ?? null;
    const contributorName = initialContributor?.name?.trim() || null;
    if (contributorName) {
        const contributorContent = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.025",
            alignBlock: "start",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                    name: contributorName,
                    picture: initialContributor?.picture
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: contributorName
                })
            ]
        });
        headerMetadataParts.push([
            'author',
            contributorContent
        ]);
    } // Fetch linked Jira issue URLs from UGS
    const [aggAbsoluteUrl] = (0, $j4ply.useAggAbsoluteUrl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const [linkedJiraIssueUrls, setLinkedJiraIssueUrls] = (0, $42omo.useState)([]);
    (0, $42omo.useEffect)(()=>{
        if (!cloudId || !data.id || !data.id.includes(':pull-request/')) return;
        let cancelled = false;
        const queryContext = `ari:cloud:jira::site/${cloudId}`;
        const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
            cloudId: cloudId,
            product: primaryProduct
        });
        (0, $b1db62a3747eff0f$export$4391d4b38f03358f)(data.id, queryContext, {
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        }).then((urls)=>{
            if (!cancelled) {
                setLinkedJiraIssueUrls(urls);
                fireAnalyticsEvent((0, $81899a88e127576f$export$94a5d1171b2b3f1)({
                    issueCount: urls.length
                }));
            }
        }).catch((error)=>{
            fireAnalyticsEvent((0, $81899a88e127576f$export$50285b4aadb60bc9)({
                reason: error instanceof Error ? error.message : String(error)
            }));
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        cloudId,
        data.id,
        aggAbsoluteUrl,
        primaryProduct,
        fireAnalyticsEvent
    ]); // Pull URLs out of "rich" link carriers (`[label](url)` markdown links and
    // `<a href="…">` HTML anchors) BEFORE the cleanup passes consume them.
    // Otherwise removing markdown / HTML would silently drop these links.
    // Image URLs (`<img src>`, `![alt](url)`) are intentionally excluded — those
    // are assets, not navigable links.
    //
    // Also memoizes the bare-URL extraction over the cleaned excerpt and the
    // final merge so repeat renders don't re-walk the regexes.
    const richExcerptLinks = (0, $42omo.useMemo)(()=>stripLinksFromExcerpt ? (0, $514d99dea8b7ae4b$export$de7a19833a380984)(excerpt || '') : [], [
        excerpt,
        stripLinksFromExcerpt
    ]);
    const excerptLinks = (0, $42omo.useMemo)(()=>(0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(cleanedExcerptForLinks), [
        cleanedExcerptForLinks
    ]); // Merge UGS-hydrated Jira issue URLs with rich-link hrefs and bare excerpt
    // URLs. `mergeAndDedupeLinks` canonicalizes URLs for deduplication so
    // variants of the same resource (trailing slash, host casing, etc.) collapse
    // into a single entry — UGS-hydrated URLs win order so they appear first.
    const links = (0, $42omo.useMemo)(()=>(0, $514d99dea8b7ae4b$export$d5a8f8e0d92d5f5e)(linkedJiraIssueUrls, richExcerptLinks, excerptLinks), [
        linkedJiraIssueUrls,
        richExcerptLinks,
        excerptLinks
    ]);
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const shouldShowRelatedLinks = linkedResults && linkedResults.length > 0;
    const commentCount = isPrCommentsEnabled ? data.linkedEntities?.length ?? 0 : 0;
    const hasComments = commentCount > 0;
    const showExpandList = hasComments || links.length > 0;
    const footerComponent = shouldShowRelatedLinks ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
            linkedResults: linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: data,
            url: url,
            position: position,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultContextMenu,
            isAllProductSelected: !selectedProduct
        })
    }) : showExpandList ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
                attachmentCount: commentCount,
                attachmentType: "comment",
                label: formatMessage((0, $60785cd45ae6de28$export$defe85febe8b728c).commentsLabel, {
                    count: commentCount
                }),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $5d482861d79b63c5$var$styles.commentsContent,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6c8fe7e8d3a5eca9$export$39a3a4657e687b88), {
                        node: data,
                        showParent: false,
                        maxComments: maxComments
                    })
                })
            }),
            links.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
                attachmentCount: links.length,
                attachmentType: "url",
                label: formatMessage((0, $514d99dea8b7ae4b$export$47614749115bca3d), {
                    count: links.length
                }),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $514d99dea8b7ae4b$export$dffce0f8d8968f9c), {
                    links: links,
                    onResultClicked: onResultClicked
                })
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: descriptionText
        }),
        headerMetadataParts: headerMetadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts,
            displaySpacer: false
        }),
        title: (0, $Y34Hw.enrichExcerpt)(partialTitle ?? entityTitle),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<00c526c9c92c320e84561e75f69d36b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $000492c4a0656d4d$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphRepository_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v3 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$000492c4a0656d4d$var$node.hash = "ca41a20e0191caf0691caf5ec12937f3";
var $000492c4a0656d4d$export$2e2bcd8739ae039 = $000492c4a0656d4d$var$node;


parcelRequire("42omo");
























const $9b7c9a4872c9cd63$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    resultLabel: {
        id: "search-respository-result.label",
        defaultMessage: "Repository"
    }
});


const $c5ef8720fa5f1985$var$GITHUB_INTEGRATION_KEY = 'github';
const $c5ef8720fa5f1985$export$b873936a7a174976 = ({ node: node, position: position, cloudId: cloudId, primaryProduct: primaryProduct, selectedProduct: selectedProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $000492c4a0656d4d$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt } = data;
    const label = formatMessage((0, $9b7c9a4872c9cd63$export$defe85febe8b728c).resultLabel);
    const padlockIcon = (0, $9NPDv.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getDescription = (excerpt)=>{
        const markdownRemoved = (0, $4dd635508e197aad$export$7e4bcd4afb389edb)(excerpt);
        return (0, $Y34Hw.processExcerpt)(markdownRemoved, true);
    };
    const lastModifiedComponent = lastModifiedDate && product !== $c5ef8720fa5f1985$var$GITHUB_INTEGRATION_KEY ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const headerMetadataParts = [
        label,
        [
            'padlock',
            padlockIcon
        ],
        [
            'last-modified',
            lastModifiedComponent
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: getDescription(excerpt)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};





/**
 * @generated SignedSource<<aacedf86f119aec0399181dffce54ac9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1bb1420b6ba035f4$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v4 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphVideo_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            v4 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "durationInSeconds"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "thumbnailUrl"
                            },
                            {
                                "concreteType": "ExternalChapter",
                                "kind": "LinkedField",
                                "name": "chapters",
                                "plural": true,
                                "selections": [
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "startTimeInSeconds"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ThirdPartyUser",
                                        "kind": "LinkedField",
                                        "name": "thirdPartyUser",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v5 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            v5 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "ExternalVideo"
                    }
                ]
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$1bb1420b6ba035f4$var$node.hash = "5acd117695a3c880ca26ab9502e4446c";
var $1bb1420b6ba035f4$export$2e2bcd8739ae039 = $1bb1420b6ba035f4$var$node;


parcelRequire("42omo");










/* meeting-transcript-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");












var $bKOxc = parcelRequire("bKOxc");


var $dWCFT = parcelRequire("dWCFT");




const $2c4d0c6cf5bca3eb$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    videoThumbnailAltText: {
        id: "search-graph-video.video-thumbnail-alt-text",
        defaultMessage: "Video thumbnail"
    },
    videoIconLabel: {
        id: "search-graph-video.video-icon-label",
        defaultMessage: "video icon"
    },
    dropdownMessage: {
        id: "search-graph-video.dropdown-message",
        defaultMessage: "{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}"
    },
    videoType: {
        id: "search-graph-video.video-type",
        defaultMessage: "Video"
    },
    durationInSeconds: {
        id: "search-graph-video.duration.seconds",
        defaultMessage: "{seconds} sec"
    },
    durationInMinutes: {
        id: "search-graph-video.duration.minutes",
        defaultMessage: "{minutes} min"
    },
    durationInHours: {
        id: "search-graph-video.duration.hours",
        defaultMessage: "{hours} hour {minutes} min"
    },
    seeAll: {
        id: "search-graph-video.see-all",
        defaultMessage: "See all"
    },
    pastMeetings: {
        id: "search-graph-video.past-meetings",
        defaultMessage: "Past meetings"
    },
    pastMeetingsUpdated: {
        id: "search-graph-video.past-meetings-updated",
        defaultMessage: "Updated {relativeTime}"
    }
});


const $3d2b83995ccaa46d$export$b0d5f79a828d791e = (durationInSeconds, options)=>{
    if (durationInSeconds === undefined || durationInSeconds === null) return null;
    const date = (0, $bKOxc.default)(new Date(0), durationInSeconds);
    const ONE_HOUR = 3600;
    const ONE_MINUTE = 60;
    const hours = Math.floor(durationInSeconds / ONE_HOUR);
    const minutes = Math.floor(durationInSeconds % ONE_HOUR / ONE_MINUTE);
    const seconds = durationInSeconds % ONE_MINUTE;
    if (options?.readable && options.formatMessage) {
        if (durationInSeconds < ONE_MINUTE) return options.formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).durationInSeconds, {
            seconds: seconds
        });
        else if (durationInSeconds < 3600) return options.formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).durationInMinutes, {
            minutes: minutes
        });
        else return options.formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).durationInHours, {
            hours: hours,
            minutes: minutes
        });
    }
    if (options?.readable) {
        if (durationInSeconds < ONE_MINUTE) return `${seconds} sec`;
        else if (durationInSeconds < 3600) return `${minutes} min`;
        else return `${hours} hour ${minutes} min`;
    }
    if (durationInSeconds < ONE_HOUR) return (0, $dWCFT.default)(date, 'mm:ss');
    return (0, $dWCFT.default)(date, 'HH:mm:ss');
};





parcelRequire("42omo");





var $lJWuA = parcelRequire("lJWuA");




const $ef0bda3913e098e7$export$fa46d21387df90fd = ({ data: data, linkedResults: linkedResults, thirdPartyConfigs: thirdPartyConfigs, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, position: position, defaultExpandedIndex: defaultExpandedIndex })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (!linkedResults || linkedResults.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$6b89e3fa6be10ffa), {
        parentPosition: position,
        defaultExpandedIndex: defaultExpandedIndex,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lJWuA))),
            attachmentCount: linkedResults.length,
            attachmentType: "url",
            label: formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).pastMeetings),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$d6b2e1eb75e7aa51), {
                url: data.url,
                title: data.title,
                linkedResults: linkedResults,
                thirdPartyConfigs: thirdPartyConfigs,
                onResultClicked: onResultClicked,
                onResultContextMenu: onResultContextMenu,
                fallbackType: "video",
                description: "",
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {})
            })
        })
    });
};


/* base-video-search-result.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 


parcelRequire("42omo");
















const $3937a4926ef9c941$export$2af0427184fd7376 = ({ data: data, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, mainContentWidth: mainContentWidth, body: // Customization props
body, footer: footer, hasRelatedLinks: hasRelatedLinks = false, additionalMetadataParts: additionalMetadataParts = [], customTitle: customTitle })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, title: title } = data;
    const { createdBy: createdBy } = entity || {};
    const creatorName = createdBy?.user?.name || createdBy?.thirdPartyUser?.name || null;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $9NPDv.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const headerMetadataParts = [
        formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).videoType),
        [
            'creator-name',
            creatorName
        ],
        [
            'last-modified',
            lastModifiedComponent
        ],
        ...additionalMetadataParts,
        [
            'padlock',
            padlockIcon
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        description: body,
        icon: icon,
        headerMetadataParts: headerMetadataParts,
        footer: footer,
        title: (0, $Y34Hw.enrichExcerpt)(customTitle || title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        hasRelatedLinks: hasRelatedLinks,
        mainContentWidth: mainContentWidth
    });
};


const $fc11365f4879160a$var$formatTitleWithDate = (title, lastModifiedDate, formatDate)=>{
    if (!lastModifiedDate) return title;
    const formattedDate = formatDate(new Date(lastModifiedDate), {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
    return `${title} - ${formattedDate}`;
};
const $fc11365f4879160a$export$96a462af0b650fcd = (props)=>{
    const { data: data, formatMessage: formatMessage, linkedResults: linkedResults, thirdPartyConfigs: thirdPartyConfigs, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, position: position } = props;
    const { excerpt: excerpt, title: title, lastModifiedDate: lastModifiedDate, entity: entity } = data;
    const { durationInSeconds: durationInSeconds } = entity || {};
    const { formatDate: formatDate } = (0, $aXWIB.useIntl)();
    const videoDuration = (0, $3d2b83995ccaa46d$export$b0d5f79a828d791e)(durationInSeconds, {
        readable: true,
        formatMessage: formatMessage
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
        description: (0, $Y34Hw.processExcerpt)(excerpt, true)
    });
    const customTitle = $fc11365f4879160a$var$formatTitleWithDate(title, lastModifiedDate, formatDate);
    const pastMeetings = linkedResults && linkedResults.length > 0 && (0, $dh538.fg)('rovo_fps_enable_ms_teams_past_meetings') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ef0bda3913e098e7$export$fa46d21387df90fd), {
        data: data,
        linkedResults: linkedResults,
        thirdPartyConfigs: thirdPartyConfigs,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        position: position
    }) : undefined;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3937a4926ef9c941$export$2af0427184fd7376), {
        ...props,
        body: body,
        customTitle: customTitle,
        additionalMetadataParts: [
            [
                'video-duration',
                videoDuration
            ]
        ],
        footer: pastMeetings,
        hasRelatedLinks: !!pastMeetings
    });
};


/* video-result-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











var $iA9co = parcelRequire("iA9co");

var $a1c8710e7c423c85$require$Buffer = $iA9co.Buffer;
const $a1c8710e7c423c85$export$edf82fe058be01d = (url)=>{
    const urlParams = new URLSearchParams(new URL(url).search);
    const base64Policy = urlParams.get('Policy');
    if (!base64Policy) return true;
    const decodedPolicy = $a1c8710e7c423c85$require$Buffer.from(base64Policy, 'base64').toString('utf-8');
    const i = decodedPolicy.lastIndexOf('}');
    const sanitizedPolicy = decodedPolicy.substring(0, i + 1);
    let policy;
    try {
        policy = JSON.parse(sanitizedPolicy);
    } catch  {
        return true;
    }
    if (policy.Statement && policy.Statement.length > 0) {
        const statement = policy.Statement[0];
        if (statement.Condition && statement.Condition.DateLessThan) {
            const epochTime = statement.Condition.DateLessThan['AWS:EpochTime'];
            const currentTime = Math.floor(Date.now() / 1000);
            return currentTime > epochTime;
        }
    }
    //fallthrough treat as expired
    return true;
};



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $1d2c9a76d7360ed1$export$f4f9f118e88808a5 = (chapter)=>chapter !== null && chapter !== undefined;


/* video-chapters.tsx generated by @compiled/babel-plugin v0.36.1 */ 






























const $2244b6957a019758$export$121bfeb3f6fb7f94 = (baseUrl, durationInSeconds)=>{
    return `${baseUrl}?t=${durationInSeconds}`;
};




const $607ed374734760ce$var$videoChapterStyles = {
    footerContainer: "_ca0qutpp _kqswh2mm",
    chapterLinkStyles: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz13af _10531ra0 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _1vhv17z1",
    dropdownItemStyles: "_1rjc1b66 _1e0c1txw _gy1pv77o _19pku2gc",
    seeAllStyles: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _11c8wadc _19pkutpp"
};
const $607ed374734760ce$var$DropdownItems = ({ chapters: chapters, url: url })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            chapters.map(({ title: title, startTimeInSeconds: startTimeInSeconds })=>{
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $607ed374734760ce$var$videoChapterStyles.dropdownItemStyles,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
                            label: formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).videoIconLabel),
                            size: "medium",
                            color: "var(--ds-icon-accent-blue, #357DE8)"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: 'space.050',
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    weight: "medium",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                                        xcss: $607ed374734760ce$var$videoChapterStyles.chapterLinkStyles,
                                        href: (0, $2244b6957a019758$export$121bfeb3f6fb7f94)(url, startTimeInSeconds),
                                        rel: 'noreferrer',
                                        target: "_blank",
                                        children: (0, $3d2b83995ccaa46d$export$b0d5f79a828d791e)(startTimeInSeconds)
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    children: title
                                })
                            ]
                        })
                    ]
                }, `${title}-${startTimeInSeconds}`);
            }),
            chapters.length > 10 && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $607ed374734760ce$var$videoChapterStyles.seeAllStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                    href: url,
                    target: "_blank",
                    xcss: $607ed374734760ce$var$videoChapterStyles.seeAllStyles,
                    children: formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).seeAll)
                })
            })
        ]
    });
};
const $607ed374734760ce$var$DropdownMenu = ({ chapters: chapters, url: url })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const dropdownMessage = formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).dropdownMessage, {
        chapterCount: chapters.length
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                iconAfter: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        ...iconProps,
                        size: "small"
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: ()=>setIsExpanded(!isExpanded),
                isSelected: isExpanded,
                children: dropdownMessage
            }),
            isExpanded && /*#__PURE__*/ (0, $l998X.jsx)($607ed374734760ce$var$DropdownItems, {
                chapters: chapters,
                url: url
            })
        ]
    });
};
const $607ed374734760ce$export$d277574e14079165 = ({ chapters: chapters, url: url })=>{
    if (!chapters || chapters.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $607ed374734760ce$var$videoChapterStyles.footerContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)($607ed374734760ce$var$DropdownMenu, {
            chapters: chapters,
            url: url
        })
    });
};


/* video-thumbnail.tsx generated by @compiled/babel-plugin v0.36.1 */ 
















const $06af07ec2fcc9e7d$var$styles = {
    thumbnailContainer: "_nd5l18xf _kqswh2mm"
};
const $06af07ec2fcc9e7d$export$bd4b73f15688a160 = ({ thumbnailUrl: thumbnailUrl, url: url })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isErrored, setIsErrored] = (0, $42omo.useState)(false);
    if (!thumbnailUrl || (0, $a1c8710e7c423c85$export$edf82fe058be01d)(thumbnailUrl) || isErrored) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        testId: "thumbnail-container",
        xcss: $06af07ec2fcc9e7d$var$styles.thumbnailContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
            href: url,
            rel: 'noreferrer',
            target: '_blank',
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e7dcc4a9e5ae8e24$export$775c760e42beccb7), {
                src: thumbnailUrl,
                alt: formatMessage((0, $2c4d0c6cf5bca3eb$export$defe85febe8b728c).videoThumbnailAltText),
                onError: ()=>setIsErrored(true)
            })
        })
    });
};


const $57520cf3a6ba1155$var$videoresultsStyles = {
    bodyAreaStyles: "_1e0c1txw _gy1putpp"
}; /**
    * Renderer for regular video search results (e.g., Loom videos).
    * Shows thumbnail, video duration, and chapter navigation.
    */ 
const $57520cf3a6ba1155$export$a0005e6573cda3b = (props)=>{
    const { data: data, formatMessage: formatMessage, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, position: position, selectedProduct: selectedProduct, product: product, is3pGroupingEnabled: is3pGroupingEnabled, thirdPartyConfigs: thirdPartyConfigs, linkedResults: linkedResults } = props;
    const { url: url, entity: entity, integrationId: integrationId } = data;
    const { durationInSeconds: durationInSeconds, chapters: chapters, thumbnailUrl: thumbnailUrl } = entity || {};
    const { excerpt: excerpt } = data;
    const videoDuration = (0, $3d2b83995ccaa46d$export$b0d5f79a828d791e)(durationInSeconds, {
        readable: true,
        formatMessage: formatMessage
    });
    const body = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        testId: "thumbnail-container",
        xcss: $57520cf3a6ba1155$var$videoresultsStyles.bodyAreaStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $06af07ec2fcc9e7d$export$bd4b73f15688a160), {
                thumbnailUrl: thumbnailUrl,
                url: url
            }),
            thumbnailUrl && !(0, $a1c8710e7c423c85$export$edf82fe058be01d)(thumbnailUrl) ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                children: [
                    (0, $Y34Hw.processExcerpt)(excerpt, true),
                    " "
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
                description: (0, $Y34Hw.processExcerpt)(excerpt, true)
            })
        ]
    });
    const isLoom = integrationId === 'ari:cloud:platform::integration/loom';
    const shouldRenderSimilarResults = isLoom && linkedResults?.some((linkedResult)=>linkedResult.category?.toUpperCase() === 'SIMILAR');
    const shouldShowRelatedLinks = linkedResults && linkedResults.length > 0;
    const footerComponent = shouldShowRelatedLinks ? shouldRenderSimilarResults ? /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$59c57a80401f0a6), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        isAllProductSelected: !selectedProduct,
        onResultContextMenu: onResultContextMenu,
        is3pGroupingEnabled: is3pGroupingEnabled,
        product: product,
        fallbackType: "video"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $607ed374734760ce$export$d277574e14079165), {
            chapters: (chapters ?? []).filter((0, $1d2c9a76d7360ed1$export$f4f9f118e88808a5)),
            url: url
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3937a4926ef9c941$export$2af0427184fd7376), {
        ...props,
        body: body,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        additionalMetadataParts: [
            [
                'video-duration',
                videoDuration
            ]
        ]
    });
};


const $3cdba03374a66139$export$77e38f0db0b0632d = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, is3pGroupingEnabled: is3pGroupingEnabled, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth, pastMeetingOccurrences: pastMeetingOccurrences, entityType: entityType })=>{
    const data = (0, $irOoi.useFragment)((0, $1bb1420b6ba035f4$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { integrationId: integrationId } = data;
    // NOTE: The integration ID is the sole indicator currently to differentiate a video entity from Loom vs MS Teams Meeting Transcript.
    // This is because both entities share the same resourceType ('video') and do not necessarily pass a subType or other identifying information.
    // For Meeting Transcripts (Microsoft Teams), we don't show video duration, thumbnail, or chapters - just the transcript excerpt.
    const isMeetingTranscript = integrationId === 'ari:cloud:platform::integration/microsoft' && (0, $dh538.fg)('rovo_fps_enable_ms_teams_meeting_type_filter');
    // Past meeting occurrences are hydrated client-side via TWG Cypher query
    // For MS Teams recurring meetings, past occurrences are hydrated client-side via TWG Cypher
    // query (fetchPastMeetingOccurrencesBatch) and passed in as the pastMeetingOccurrences prop.
    // When pastMeetingOccurrences is provided (MS Teams + gate on), it overrides the GraphQL
    // linkedResults from SearchResultGraphDocument (used by Loom and other video types).
    // `category: 'SIMILAR'` is required for correct icon rendering via getLinkedResultIcon.
    // `providerId` is fetched from ExternalVideo.provider.providerId via the Cypher query.
    const linkedResults = pastMeetingOccurrences != null ? pastMeetingOccurrences.map((occurrence)=>({
            id: occurrence.thirdPartyId ?? occurrence.url,
            title: occurrence.title,
            url: occurrence.url,
            type: entityType,
            description: null,
            lastModifiedDate: occurrence.lastModifiedDate,
            category: 'SIMILAR',
            subtype: null,
            integrationId: data.integrationId,
            providerId: occurrence.providerId,
            connectorType: null
        })) : data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const rendererProps = {
        data: data,
        formatMessage: formatMessage,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        position: position,
        cloudId: cloudId,
        selectedProduct: selectedProduct,
        primaryProduct: primaryProduct,
        appMode: appMode,
        product: product,
        icon: icon,
        is3pGroupingEnabled: is3pGroupingEnabled,
        thirdPartyConfigs: thirdPartyConfigs,
        mainContentWidth: mainContentWidth,
        linkedResults: linkedResults
    };
    if (isMeetingTranscript) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fc11365f4879160a$export$96a462af0b650fcd), {
        ...rendererProps
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $57520cf3a6ba1155$export$a0005e6573cda3b), {
        ...rendererProps
    });
};





/**
 * @generated SignedSource<<657b86139fd7febbe78e822a664c9a1a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b1fef4787f14ce26$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = [
        v0 /*: any*/ ,
        v4 /*: any*/ 
    ], v6 = [
        {
            "concreteType": "ThirdPartyUser",
            "kind": "LinkedField",
            "name": "thirdPartyUser",
            "plural": false,
            "selections": v5 /*: any*/ 
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "subtype"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchGraphWorkItem_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionLevel"
            },
            {
                "kind": "LinkedField",
                "name": "entity",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": v6 /*: any*/ 
                            },
                            {
                                "concreteType": "ExternalUser",
                                "kind": "LinkedField",
                                "name": "createdBy",
                                "plural": false,
                                "selections": v6 /*: any*/ 
                            },
                            {
                                "concreteType": "ExternalWorkItemProject",
                                "kind": "LinkedField",
                                "name": "workItemProject",
                                "plural": false,
                                "selections": v5 /*: any*/ 
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            v7 /*: any*/ ,
                            {
                                "concreteType": "ExternalProvider",
                                "kind": "LinkedField",
                                "name": "provider",
                                "plural": false,
                                "selections": [
                                    v4 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "ExternalWorkItem"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "containerName"
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v3 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultGraphDocument"
    };
}();
$b1fef4787f14ce26$var$node.hash = "c48e1a7829873d321d8869c7f94f2a97";
var $b1fef4787f14ce26$export$2e2bcd8739ae039 = $b1fef4787f14ce26$var$node;




















var $aKt88 = parcelRequire("aKt88");




















const $a84a41c1040183af$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    workItemLabel: {
        id: "search-graph-work-item.label",
        defaultMessage: "Work item"
    },
    taskLabel: {
        id: "search-graph-work-item.task.label",
        defaultMessage: "Task"
    },
    epicLabel: {
        id: "search-graph-work-item.epic.label",
        defaultMessage: "Epic"
    },
    bugLabel: {
        id: "search-graph-work-item.bug.label",
        defaultMessage: "Bug"
    },
    storyLabel: {
        id: "search-graph-work-item.story.label",
        defaultMessage: "Story"
    },
    milestoneLabel: {
        id: "search-graph-work-item.milestone.label",
        defaultMessage: "Milestone"
    },
    sectionLabel: {
        id: "search-graph-work-item.section",
        defaultMessage: "Section"
    },
    approvalLabel: {
        id: "search-graph-work-item.approval",
        defaultMessage: "Approval"
    },
    problemLabel: {
        id: "search-graph-work-item.problem",
        defaultMessage: "Problem"
    },
    incidentLabel: {
        id: "search-graph-work-item.incident",
        defaultMessage: "Incident"
    },
    questionLabel: {
        id: "search-graph-work-item.question",
        defaultMessage: "Question"
    },
    issueLabel: {
        id: "search-graph-work-item.issue",
        defaultMessage: "Issue"
    },
    ticketLabel: {
        id: "search-graph-work-item.ticket",
        defaultMessage: "Ticket"
    },
    requestedItemLabel: {
        id: "search-graph-work-item.requested_item",
        defaultMessage: "Requested item"
    },
    catalogItemLabel: {
        id: "search-graph-work-item.catalog_item",
        defaultMessage: "Catalog item"
    },
    for: {
        id: "work-item-status.for",
        defaultMessage: "{statusLozenge} for {dateLozenge}"
    },
    isAssigned: {
        id: "work-item-assignee.assigned",
        defaultMessage: "{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}"
    },
    created: {
        id: "work-item-creator.created",
        defaultMessage: "{created, select, internal {{firstName} created} other {External person created}}"
    }
});


const $485beeea42bb88b1$var$nameContainer = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
const $485beeea42bb88b1$export$d1e5c8cc4a829640 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, product: product, icon: icon, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $b1fef4787f14ce26$export$2e2bcd8739ae039), node);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, title: title, containerName: containerName } = data;
    const { assignee: assignee, createdBy: createdBy, workItemProject: workItemProject, status: status, subtype: subtype, provider: provider } = entity || {};
    const projectName = workItemProject?.name ?? containerName;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $9NPDv.isNonPublic)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $df2d84bd02793768$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const titleMetadataParts = (0, $42omo.useMemo)(()=>{
        const statusLabel = status ? status.replace(/[-_]+/g, ' ').toLowerCase().replace(/^\w/, (c)=>c.toUpperCase()) : undefined;
        const statusNode = (0, $aKt88.getStatus)(statusLabel);
        return statusNode ? [
            [
                'status',
                statusNode
            ]
        ] : [];
    }, [
        status
    ]);
    const getAssigneeOrCreator = ()=>{
        let actionLabel;
        const fullName = assignee?.thirdPartyUser?.name || createdBy?.thirdPartyUser?.name || '';
        const firstName = fullName?.split(' ')?.[0];
        if (assignee?.thirdPartyUser?.name) actionLabel = formatMessage((0, $a84a41c1040183af$export$defe85febe8b728c).isAssigned, {
            firstName: firstName,
            isAssigned: firstName ? 'internal' : 'external'
        });
        else actionLabel = formatMessage((0, $a84a41c1040183af$export$defe85febe8b728c).created, {
            firstName: firstName,
            created: firstName ? 'internal' : 'external'
        });
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            space: "space.025",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $678a8075b20296fe$export$3778be82376b06d7), {
                    name: fullName
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $485beeea42bb88b1$var$nameContainer,
                    children: actionLabel
                })
            ]
        });
    };
    const subtypeMap = {
        task: (0, $a84a41c1040183af$export$defe85febe8b728c).taskLabel,
        default_task: (0, $a84a41c1040183af$export$defe85febe8b728c).taskLabel,
        epic: (0, $a84a41c1040183af$export$defe85febe8b728c).epicLabel,
        bug: (0, $a84a41c1040183af$export$defe85febe8b728c).bugLabel,
        story: (0, $a84a41c1040183af$export$defe85febe8b728c).storyLabel,
        milestone: (0, $a84a41c1040183af$export$defe85febe8b728c).milestoneLabel,
        section: (0, $a84a41c1040183af$export$defe85febe8b728c).sectionLabel,
        approval: (0, $a84a41c1040183af$export$defe85febe8b728c).approvalLabel,
        problem: (0, $a84a41c1040183af$export$defe85febe8b728c).problemLabel,
        incident: (0, $a84a41c1040183af$export$defe85febe8b728c).incidentLabel,
        question: (0, $a84a41c1040183af$export$defe85febe8b728c).questionLabel,
        work_item: null,
        // defer to providerDefaultLabelMap
        issue: (0, $a84a41c1040183af$export$defe85febe8b728c).issueLabel,
        ticket: (0, $a84a41c1040183af$export$defe85febe8b728c).ticketLabel,
        requested_item: (0, $a84a41c1040183af$export$defe85febe8b728c).requestedItemLabel,
        catalog_item: (0, $a84a41c1040183af$export$defe85febe8b728c).catalogItemLabel,
        other: null // defer to providerDefaultLabelMap
    };
    // Maps provider names to the default label to show when subtype doesn't resolve to a specific label.
    // Add new providers here as needed.
    const providerDefaultLabelMap = {
        github: (0, $a84a41c1040183af$export$defe85febe8b728c).issueLabel
    };
    const providerName = provider?.name?.toLowerCase();
    const defaultLabel = providerName && providerDefaultLabelMap[providerName] || (0, $a84a41c1040183af$export$defe85febe8b728c).workItemLabel;
    const label = formatMessage(subtypeMap[subtype?.toLowerCase() ?? 'other'] || defaultLabel);
    const headerMetadataParts = [
        label,
        [
            'project',
            projectName
        ],
        [
            'last-modified',
            lastModifiedComponent
        ],
        [
            'padlock',
            padlockIcon
        ],
        [
            'person',
            getAssigneeOrCreator()
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const footerComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$641545414024a53b), {
        linkedResults: linkedResults || [],
        thirdPartyConfigs: thirdPartyConfigs,
        partial: data,
        url: url,
        position: position,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        isAllProductSelected: !selectedProduct
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: data.id,
        product: product,
        productSelected: !!selectedProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        icon: icon,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(excerpt, true)
        }),
        headerMetadataParts: headerMetadataParts,
        title: (0, $Y34Hw.enrichExcerpt)(title),
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts
        }),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: data,
        appMode: appMode,
        footer: footerComponent,
        hasRelatedLinks: !!linkedResults && linkedResults.length > 0,
        mainContentWidth: mainContentWidth
    });
};


const $9b59a3205d194c41$export$e84f7c0bef931609 = (props)=>{
    const logException = (0, $f8oYd.useLogException)();
    const { node: node, position: position, thirdPartyConfigs: thirdPartyConfigs } = props;
    // note that `SearchResultGraphDocument` in this fragment isn't a document type from graph, it's the base type!
    // TODO: QS-6952 optIn may not be working, entity.parent is always null
    const data = (0, $irOoi.useFragment)((0, $bc37e735c0a85c0e$export$2e2bcd8739ae039), node);
    let { id: id, providerId: providerId, integrationId: integrationId, connectorType: connectorType } = data;
    const subtype = data?.subtype || null;
    const { resourceType: resourceType, resourceId: resourceId } = (0, $k4HRJ.AnyAri).parse(id);
    const product = (0, $Y34Hw.get3PProductFromProviderIdOrIntegrationId)({
        thirdPartyConfigs: thirdPartyConfigs,
        providerId: providerId,
        integrationId: integrationId,
        resourceType: resourceType
    });
    const metadata = (0, $42omo.useMemo)(()=>{
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: subtype,
            entityType: resourceType,
            contentId: resourceId,
            product: product,
            is3PSmartLink: (0, $kQT7c.isResultSmartLink)({
                connectorType: connectorType,
                resultAri: id,
                productKey: product,
                thirdPartyConfigs: thirdPartyConfigs
            }),
            connectorType: (0, $kQT7c.getResultConnectorSource)({
                connectorType: connectorType,
                resultNodeId: id,
                productKey: product,
                thirdPartyConfigs: thirdPartyConfigs
            })
        };
    }, [
        subtype,
        resourceType,
        resourceId,
        product,
        data.id,
        connectorType,
        id,
        thirdPartyConfigs
    ]);
    const is3PClickIngestionEnabled = (0, $2OtFZ.serve3PClickIngestionExperiment)(thirdPartyConfigs, {
        fireExperimentExposure: false
    });
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position,
        isImpersonated: (0, $gRvZB.isProductImpersonated)(product, thirdPartyConfigs),
        is3PClickIngestionEnabled: is3PClickIngestionEnabled
    });
    const onResultContextMenu = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position,
        isImpersonated: (0, $gRvZB.isProductImpersonated)(product, thirdPartyConfigs),
        is3PClickIngestionEnabled: is3PClickIngestionEnabled
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const baseProps = {
        ...props,
        node: data,
        product: product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        subtype: subtype,
        entityType: resourceType
    };
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $235a70ab221836e5$export$6582c9566971e750), {
        product: product,
        resourceType: resourceType,
        thirdPartyConfigs: thirdPartyConfigs
    });
    try {
        if (!product) throw new Error(`SearchGraphResult: missing product for integrationId=${integrationId} providerId=${providerId}`);
        const SearchGraphRenderer = $9b59a3205d194c41$var$getGraphRenderer(product, resourceType);
        if (!SearchGraphRenderer) throw new Error(`SearchGraphResult: missing renderer for resourceType=${resourceType} product=${product}`);
        return /*#__PURE__*/ (0, $l998X.jsx)(SearchGraphRenderer, {
            ...baseProps,
            product: product,
            icon: icon
        });
    } catch (e) {
        logException(e);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $9a45c40b46beaab7$export$2b64796aabcbabd2), {
            ...baseProps,
            product: product,
            icon: icon
        });
    }
};
const $9b59a3205d194c41$var$getGraphRenderer = (product, resourceType)=>{
    if (product === (0, $b4tvS.ProductKeys3P).JiraDC) return 0, $a81664d8b32e1a9b$export$3464c3355ad3f97e;
    switch(resourceType){
        case (0, $7ZetK.ResourceType).CAMPAIGN:
            return 0, $0b30e0258a8db6c5$export$3596f4e18e688c6e;
        case (0, $7ZetK.ResourceType).CASE:
            return 0, $c1f708c33175b5a1$export$6880787011d90d36;
        case (0, $7ZetK.ResourceType).BRANCH:
            return 0, $c04256cd812d51cc$export$e7f66f0a0905935e;
        case (0, $7ZetK.ResourceType).CALENDAR_EVENT:
            return 0, $c25124bad4c60a80$export$aafb10d415667378;
        case (0, $7ZetK.ResourceType).COMMENT:
            return 0, $318bc8ae651e831c$export$9c9dc84757cc5710;
        case (0, $7ZetK.ResourceType).COMMIT:
            return 0, $fc7ae146ec7d2606$export$f8ac23605711b215;
        case (0, $7ZetK.ResourceType).CONVERSATION:
            return 0, $3656b7fd5d879deb$export$73ee84431f6e335a;
        case (0, $7ZetK.ResourceType).CUSTOMER_CONTACT:
            return 0, $19060b73dca5ceaf$export$a3fd078d13d8ac2;
        case (0, $7ZetK.ResourceType).CUSTOMER_ORG:
            return 0, $77eea3dd744c20d3$export$f49280cd3d93cb86;
        case (0, $7ZetK.ResourceType).DEAL:
            return 0, $c295bb43a0a69b45$export$97947ae87dd2d3c0;
        case (0, $7ZetK.ResourceType).DOCUMENT:
            if (product === (0, $b4tvS.ProductKeys3P).ConfluenceDC) return 0, $61cfa2381edf5d9d$export$b773c9cc5f495a3;
            else return 0, $61039992c4292c45$export$d69ae1468ab7f1da;
        case (0, $7ZetK.ResourceType).DESIGN:
            return 0, $116289f16507c09c$export$81afb8005ea84971;
        case (0, $7ZetK.ResourceType).MESSAGE:
            return 0, $1cb6de7b071beecb$export$eb10cea9a7aeba8c;
        case (0, $7ZetK.ResourceType).PULL_REQUEST:
            return 0, $5d482861d79b63c5$export$ff9a66c66b5ab669;
        case (0, $7ZetK.ResourceType).REPOSITORY:
            return 0, $c5ef8720fa5f1985$export$b873936a7a174976;
        case (0, $7ZetK.ResourceType).VIDEO:
            return 0, $3cdba03374a66139$export$77e38f0db0b0632d;
        case (0, $7ZetK.ResourceType).WORK_ITEM:
            return 0, $485beeea42bb88b1$export$d1e5c8cc4a829640;
        case (0, $7ZetK.ResourceType).DASHBOARD:
            return 0, $6bb44605052e87f7$export$5039b6acf48ea77b;
        case (0, $7ZetK.ResourceType).DATA_TABLE:
            return 0, $d3b5e6118cd795f4$export$a2ac0f4098dc2a39;
        case (0, $7ZetK.ResourceType).REMOTE_LINK:
            return 0, $9a45c40b46beaab7$export$2b64796aabcbabd2;
        // Remote link intentionally uses the default renderer
        default:
            return null;
    }
};
const $9b59a3205d194c41$export$48471e9a17c64a92 = (node)=>{
    return node?.__typename === 'SearchResultGraphDocument';
};





/**
 * @generated SignedSource<<31df82b9c77b3658ee8f320978b916f8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7f16476ffb9e4f90$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchJiraBoard_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "description"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            v0 /*: any*/ ,
            {
                "concreteType": "JiraBoard",
                "kind": "LinkedField",
                "name": "board",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "boardFrontendUrl"
                    }
                ]
            }
        ],
        "type": "SearchResultJiraBoard"
    };
}();
$7f16476ffb9e4f90$var$node.hash = "4bd8e621e374695ab53532c4f4d11d01";
var $7f16476ffb9e4f90$export$2e2bcd8739ae039 = $7f16476ffb9e4f90$var$node;
































var $7loel = parcelRequire("7loel");





var $92zSJ = parcelRequire("92zSJ");










const $ef85b0f97f42606b$export$4d44dfc3b1a588bc = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $7f16476ffb9e4f90$export$2e2bcd8739ae039), node);
    const logException = (0, $f8oYd.useLogException)();
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        const notDummyBoardUrl = (0, $7loel.isDummyBoardUrl)(data.url) ? undefined : data.url;
        const boardUrl = data.board?.boardFrontendUrl || notDummyBoardUrl;
        return boardUrl ? (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
            url: boardUrl,
            searchSessionId: searchSessionId,
            resultId: data.id
        }) : '';
    }, [
        data.url,
        data.id,
        data.board,
        searchSessionId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(data.title, searchQuery.split(' '));
        return !highlightedTitle ? data.title : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        data.title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $92zSJ.getSummarizedAdfContent)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const metadataParts = (0, $42omo.useMemo)(()=>{
        const parts = [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            ],
            [
                'lastModified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                }) : null
            ]
        ];
        return parts.filter(Boolean);
    }, [
        data.type,
        data.lastModifiedDate
    ]);
    // Don't render anything if there's no URL
    if (!url) {
        logException(new Error(String(`Jira Board search result has no URL. Result ID: ${data.id}`)));
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    }
    const iconUrl = data.board?.iconUrl || data.iconUrl;
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: iconUrl,
        type: data.type,
        isIssue: false,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $ef85b0f97f42606b$export$1ac32d77bb207897 = (node)=>{
    return node?.__typename === 'SearchResultJiraBoard';
};





/**
 * @generated SignedSource<<2948c9dfd95ad5b837cfdbadecf3ac98>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $daf59631fbe551ff$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchJiraDashboard_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "ScalarField",
            "name": "iconUrl"
        }
    ],
    "type": "SearchResultJiraDashboard"
};
$daf59631fbe551ff$var$node.hash = "165d504f5f9abf8bec64d659ff7dcd0c";
var $daf59631fbe551ff$export$2e2bcd8739ae039 = $daf59631fbe551ff$var$node;











































const $87cf4eaba3a575c0$export$a5c532a12af1d7c8 = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $daf59631fbe551ff$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
            url: data.url,
            searchSessionId: searchSessionId,
            resultId: data.id
        });
    }, [
        data.url,
        data.id,
        searchSessionId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(data.title, searchQuery.split(' '));
        return !highlightedTitle ? data.title : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        data.title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $92zSJ.getSummarizedAdfContent)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const metadataParts = (0, $42omo.useMemo)(()=>{
        const parts = [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            ],
            [
                'lastModified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                }) : null
            ]
        ];
        return parts.filter(Boolean);
    }, [
        data.type,
        data.lastModifiedDate
    ]);
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        isIssue: false,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $87cf4eaba3a575c0$export$8fd9ffc22de770d9 = (node)=>{
    return node?.__typename === 'SearchResultJiraDashboard';
};





/**
 * @generated SignedSource<<dacc8d8329437c0dd5f2aac8767b5439>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7a7ba6d5984cc500$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchJiraFilter_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "ScalarField",
            "name": "iconUrl"
        }
    ],
    "type": "SearchResultJiraFilter"
};
$7a7ba6d5984cc500$var$node.hash = "16cb9379c0ec44d660de2e7ef7b7d063";
var $7a7ba6d5984cc500$export$2e2bcd8739ae039 = $7a7ba6d5984cc500$var$node;











































const $4fc71968c4272f25$export$7c35d70259168995 = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $7a7ba6d5984cc500$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
            url: data.url,
            searchSessionId: searchSessionId,
            resultId: data.id
        });
    }, [
        data.url,
        data.id,
        searchSessionId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(data.title, searchQuery.split(' '));
        return !highlightedTitle ? data.title : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        data.title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $92zSJ.getSummarizedAdfContent)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const metadataParts = (0, $42omo.useMemo)(()=>{
        const parts = [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            ],
            [
                'lastModified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                }) : null
            ]
        ];
        return parts.filter(Boolean);
    }, [
        data.type,
        data.lastModifiedDate
    ]);
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        isIssue: false,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $4fc71968c4272f25$export$f78f5f7633f09cb5 = (node)=>{
    return node?.__typename === 'SearchResultJiraFilter';
};





/**
 * @generated SignedSource<<ad5eb8597fd657e9c5d2cedb6eb568ff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f1a2103d173cf5d0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "title"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "kind": "ScalarField",
        "name": "description"
    }, v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v6 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeAssigneeField"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeJiraLiteModeFields"
            }
        ],
        "kind": "Fragment",
        "name": "searchJiraIssue_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "issueTypeAvatarUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": v8 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                    "project"
                                ]
                            }
                        ],
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fieldsById",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v7 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            v7 /*: any*/ 
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraProjectField"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "fieldsById(ids:[\"project\"])"
                    },
                    {
                        "condition": "includeAssigneeField",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraSingleSelectUserPickerField",
                                "kind": "LinkedField",
                                "name": "assigneeField",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            v7 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "picture"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "includeJiraLiteModeFields",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraPriorityField",
                                "kind": "LinkedField",
                                "name": "priorityField",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraPriority",
                                        "kind": "LinkedField",
                                        "name": "priority",
                                        "plural": false,
                                        "selections": [
                                            v6 /*: any*/ ,
                                            v7 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraLabelsField",
                                "kind": "LinkedField",
                                "name": "labelsField",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 5
                                            }
                                        ],
                                        "concreteType": "JiraLabelConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedLabelsConnection",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraLabelEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraLabel",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": v8 /*: any*/ 
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "selectedLabelsConnection(first:5)"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v9 /*: any*/ ,
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    v4 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResultJiraIssue"
    };
}();
$f1a2103d173cf5d0$var$node.hash = "dc78f8442736dab9df82abd402312bae";
var $f1a2103d173cf5d0$export$2e2bcd8739ae039 = $f1a2103d173cf5d0$var$node;












var $7OYaz = parcelRequire("7OYaz");


















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





parcelRequire("42omo");




















const $6c7cd866f40b6bfc$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    assignee: {
        id: "search-page.jira-assignee.assignee",
        defaultMessage: "Assignee: {assigneeName}"
    },
    unassigned: {
        id: "search-page.jira-assignee.unassigned",
        defaultMessage: "Unassigned"
    }
});


const $157d4b2b9c0ccedc$var$styles = {
    truncatedTextWrapper: "_o5724jg8 _1bto1l2s _1reo15vq"
};
const $157d4b2b9c0ccedc$export$361f73eba39649ac = ({ user: user })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const tooltipText = user ? formatMessage((0, $6c7cd866f40b6bfc$export$defe85febe8b728c).assignee, {
        assigneeName: user.name
    }) : formatMessage((0, $6c7cd866f40b6bfc$export$defe85febe8b728c).unassigned);
    const name = user ? user.name : formatMessage((0, $6c7cd866f40b6bfc$export$defe85febe8b728c).unassigned);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.025",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: tooltipText,
                children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        alignBlock: "center",
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                            src: user?.picture,
                            appearance: "circle",
                            size: "xsmall",
                            name: name
                        })
                    })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $157d4b2b9c0ccedc$var$styles.truncatedTextWrapper
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    maxLines: 1,
                    children: name
                })
            })
        ]
    });
};







/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


































/**
 * Types for Jira issue → Pull Request hydration.
 *
 * Used by the frontend hydration path to enrich Jira search results
 * with linked PR data from devOps.ariGraph.issueAssociatedPr (UGS via AGG).
 * Supports PRs from all providers (GitHub, GitLab, Bitbucket, etc.).
 */ const $1b8c818c22dd73dd$export$4dec602c1ab1d95e = {
    Open: 'OPEN',
    Merged: 'MERGED',
    Declined: 'DECLINED',
    Draft: 'DRAFT',
    Unknown: 'UNKNOWN'
};



var $iFvZ5 = parcelRequire("iFvZ5");


var $go3Ad = parcelRequire("go3Ad");


var $tNEXZ = parcelRequire("tNEXZ");










const $7bfed7214d4a524b$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    expandLabel: {
        id: "search-page.linked-pull-requests.expand-label",
        defaultMessage: "{count}{hasMore, select, true {+} other {}} {count, plural, one {Pull request} other {Pull requests}}"
    },
    metadataLabel: {
        id: "search-page.linked-pull-requests.metadata-label",
        defaultMessage: "Pull Request"
    },
    pullRequestId: {
        id: "search-page.linked-pull-requests.pull-request-id",
        defaultMessage: "ID# {prId}"
    },
    reviewerCount: {
        id: "search-page.linked-pull-requests.reviewer-count",
        defaultMessage: "{count, plural, =0 {No reviewers} one {# reviewer} other {# reviewers}}"
    },
    lastUpdated: {
        id: "search-page.linked-pull-requests.last-updated",
        defaultMessage: "Updated {relativeTime}"
    },
    statusOpen: {
        id: "search-page.linked-pull-requests.status-open",
        defaultMessage: "Open"
    },
    statusMerged: {
        id: "search-page.linked-pull-requests.status-merged",
        defaultMessage: "Merged"
    },
    statusDeclined: {
        id: "search-page.linked-pull-requests.status-declined",
        defaultMessage: "Declined"
    },
    statusDraft: {
        id: "search-page.linked-pull-requests.status-draft",
        defaultMessage: "Draft"
    },
    statusUnknown: {
        id: "search-page.linked-pull-requests.status-unknown",
        defaultMessage: "Unknown"
    }
});


const $a7e952e2df3d6f82$var$iconContainerStyles = null;
const $a7e952e2df3d6f82$var$getProviderFromUrl = (url)=>{
    if (!url) return 'unknown';
    try {
        const hostname = new URL(url).hostname.toLowerCase();
        if (hostname === 'github.com') return 'github';
        if (hostname === 'gitlab.com') return 'gitlab';
        if (hostname === 'bitbucket.org' || hostname.endsWith('stash.atlassian.com')) return 'bitbucket';
        if (hostname === 'dev.azure.com' || hostname.endsWith('.visualstudio.com')) return 'azure-devops';
        return 'unknown';
    } catch  {
        return 'unknown';
    }
};
const $a7e952e2df3d6f82$var$ProviderIcon = ({ url: url })=>{
    const provider = $a7e952e2df3d6f82$var$getProviderFromUrl(url);
    switch(provider){
        case 'github':
            return /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_1o9zidpf _1e0c116y _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $go3Ad.GithubIcon), {})
            });
        case 'gitlab':
            return /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_1o9zidpf _1e0c116y _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $tNEXZ.GitlabIcon), {})
            });
        case 'azure-devops':
            return /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_1o9zidpf _1e0c116y _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iFvZ5.AzureDevopsIcon), {})
            });
        case 'bitbucket':
            return /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_1o9zidpf _1e0c116y _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.BitbucketIcon), {
                    label: "Bitbucket",
                    size: "xsmall"
                })
            });
        case 'unknown':
        default:
            return /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_1o9zidpf _1e0c116y _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))), {
                    label: "",
                    size: "small",
                    color: "currentColor"
                })
            });
    }
};
const $a7e952e2df3d6f82$var$styles = {
    anchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1reo15vq _18m915vq _syaz13af _1bto1l2s _o5721q9c _10531ra0 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af",
    titleText: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    rowContainer: "_bozgutpp",
    metadata: "_bozg1ejb"
};
const $a7e952e2df3d6f82$var$lozengeContainerStyles = null; // Lozenge appearance mapping matches @atlaskit/smart-card's VALID_STATES
// See: linking-platform/smart-card/src/extractors/common/lozenge/utils.ts
const $a7e952e2df3d6f82$var$STATUS_APPEARANCE = {
    [(0, $1b8c818c22dd73dd$export$4dec602c1ab1d95e).Open]: 'information',
    [(0, $1b8c818c22dd73dd$export$4dec602c1ab1d95e).Merged]: 'success',
    [(0, $1b8c818c22dd73dd$export$4dec602c1ab1d95e).Declined]: 'danger',
    [(0, $1b8c818c22dd73dd$export$4dec602c1ab1d95e).Draft]: 'information'
};
const $a7e952e2df3d6f82$var$STATUS_MESSAGES = {
    [(0, $1b8c818c22dd73dd$export$4dec602c1ab1d95e).Open]: (0, $7bfed7214d4a524b$export$defe85febe8b728c).statusOpen,
    [(0, $1b8c818c22dd73dd$export$4dec602c1ab1d95e).Merged]: (0, $7bfed7214d4a524b$export$defe85febe8b728c).statusMerged,
    [(0, $1b8c818c22dd73dd$export$4dec602c1ab1d95e).Declined]: (0, $7bfed7214d4a524b$export$defe85febe8b728c).statusDeclined,
    [(0, $1b8c818c22dd73dd$export$4dec602c1ab1d95e).Draft]: (0, $7bfed7214d4a524b$export$defe85febe8b728c).statusDraft
};
const $a7e952e2df3d6f82$var$PullRequestRow = ({ pr: pr, position: position, onResultClicked: onResultClicked })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const title = pr.title || 'Untitled';
    const prId = pr.pullRequestInternalId;
    const reviewerCount = pr.reviewers?.length ?? 0;
    const lastUpdated = pr.lastUpdated;
    const statusMessage = $a7e952e2df3d6f82$var$STATUS_MESSAGES[pr.status ?? ''] ?? (0, $7bfed7214d4a524b$export$defe85febe8b728c).statusUnknown;
    const handlePRClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}LinkedPullRequest`,
            eventType: 'ui',
            source: (0, $6yNqK.EVENT_SOURCE),
            attributes: {
                position: position,
                pullRequestStatus: pr.status
            }
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
        onResultClicked?.();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $a7e952e2df3d6f82$var$styles.rowContainer,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.100",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)($a7e952e2df3d6f82$var$ProviderIcon, {
                            url: pr.url
                        }),
                        pr.url ? /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                            href: pr.url,
                            target: "_blank",
                            xcss: $a7e952e2df3d6f82$var$styles.anchor,
                            onClick: handlePRClick,
                            children: title
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $a7e952e2df3d6f82$var$styles.titleText,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                weight: "medium",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("span", {
                            className: (0, $gMc0m.default)([
                                "_1o9zidpf _4t3igktf"
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                appearance: $a7e952e2df3d6f82$var$STATUS_APPEARANCE[pr.status ?? ''] ?? 'neutral',
                                isBold: true,
                                children: formatMessage(statusMessage)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $a7e952e2df3d6f82$var$styles.metadata,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        separator: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtlest",
                            children: "\u2022"
                        }),
                        space: "space.100",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtlest",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...(0, $7bfed7214d4a524b$export$defe85febe8b728c).metadataLabel
                                })
                            }),
                            prId && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtlest",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...(0, $7bfed7214d4a524b$export$defe85febe8b728c).pullRequestId,
                                    values: {
                                        prId: prId
                                    }
                                })
                            }),
                            lastUpdated && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtlest",
                                children: (()=>{
                                    const { value: value, unit: unit } = (0, $Y34Hw.getRelativeTimeSince)(new Date(lastUpdated));
                                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                        ...(0, $7bfed7214d4a524b$export$defe85febe8b728c).lastUpdated,
                                        values: {
                                            relativeTime: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedRelativeTime), {
                                                value: -value,
                                                unit: unit
                                            })
                                        }
                                    });
                                })()
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtlest",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...(0, $7bfed7214d4a524b$export$defe85febe8b728c).reviewerCount,
                                    values: {
                                        count: reviewerCount
                                    }
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $a7e952e2df3d6f82$export$c9e111d3747f61cf = ({ pullRequests: pullRequests, onResultClicked: onResultClicked })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasFiredOpened = (0, $42omo.useRef)(false); // Fires each time the PR section is expanded (component mounts).
    // ExpandList unmounts children on collapse, so the ref resets on remount — intentionally fires per-open, not once per session.
    // Uses a ref guard so it also handles the case where PRs load asynchronously after mount.
    (0, $42omo.useEffect)(()=>{
        if (pullRequests.length > 0 && !hasFiredOpened.current) {
            hasFiredOpened.current = true;
            createAnalyticsEvent({
                action: 'opened',
                actionSubject: `${(0, $6yNqK.ACTION_SUBJECT_PREFIX)}LinkedPullRequestSection`,
                eventType: 'track',
                source: (0, $6yNqK.EVENT_SOURCE),
                attributes: {
                    prCount: pullRequests.length
                }
            }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
        }
    }, [
        pullRequests,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        space: "space.100",
        children: pullRequests.map((pr, index)=>/*#__PURE__*/ (0, $l998X.jsx)($a7e952e2df3d6f82$var$PullRequestRow, {
                pr: pr,
                position: index,
                onResultClicked: onResultClicked
            }, pr.id))
    });
};


































parcelRequire("42omo");









const $d21ac91210a9e9f3$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    maxWidth: '215px',
    // from Figma design
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $d21ac91210a9e9f3$export$47d2cbdccded0b18 = ({ projectName: projectName })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: projectName,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $d21ac91210a9e9f3$var$containerStyles,
                testId: "project-metadata",
                ...tooltipProps,
                children: projectName
            })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





parcelRequire("42omo");

















const $5e5e27e38c15bb2a$var$styles = {
    tr: null,
    tdBase: null,
    tdWork: null,
    // Reporter (116px) is not implemented; its width is divided equally among the 4 non-Work columns.
    // 600px: 116/4 = 29px extra per column
    // 768px: 116/4 = 29px extra per column
    // 1026px: 146/4 ≈ 37px extra per column (rounded)
    // 1440px+: 146/4 ≈ 37px extra per column (rounded)
    tdStatus: null,
    tdAssignee: null,
    // TODO: add column and data to table — tdReporter kept for future use
    tdReporter: null,
    tdLabels: null,
    tdPriority: null,
    tdWorkInner: null,
    tdPriorityInner: null,
    link: null,
    iconWrapper: null,
    summary: null
};
// logic copied from /packages/search/search-common/src/utils/highlight-matched-text.tsx
const $5e5e27e38c15bb2a$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $5e5e27e38c15bb2a$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $5e5e27e38c15bb2a$var$cleanStartRegex = new RegExp($5e5e27e38c15bb2a$var$HIGHLIGHT_START_TAG, 'g');
const $5e5e27e38c15bb2a$var$cleanEndRegex = new RegExp($5e5e27e38c15bb2a$var$HIGHLIGHT_END_TAG, 'g'); // used to remove the special highlighting characters from the Jira issue title that we get back from GQL
const $5e5e27e38c15bb2a$var$removeSearchHighlighting = (source)=>source.replace($5e5e27e38c15bb2a$var$cleanStartRegex, '').replace($5e5e27e38c15bb2a$var$cleanEndRegex, '');
const $5e5e27e38c15bb2a$export$19b3d66141ca17f0 = ({ iconUrl: iconUrl, type: type, issueKey: issueKey, url: url, title: title, jiraIssueStatus: jiraIssueStatus, assignee: assignee, priority: priority, labels: labels = [], onClick: onClick })=>{
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: iconUrl,
        type: type,
        isIssue: true,
        size: 'small'
    });
    const statusInfo = (0, $dh538.fg)('use_jira_fe_status_color_mapping_fps') ? {
        statusCategoryId: jiraIssueStatus?.statusCategoryId
    } : {
        color: jiraIssueStatus?.colorName
    };
    const status = jiraIssueStatus != null ? (0, $aKt88.getStatus)(jiraIssueStatus.statusName, statusInfo, false) : null;
    const cleanTitle = $5e5e27e38c15bb2a$var$removeSearchHighlighting(title ?? '');
    return /*#__PURE__*/ (0, $l998X.jsxs)("tr", {
        "data-testid": "search-jira-issue-table-row",
        onClick: onClick,
        className: (0, $gMc0m.default)([
            "_1e0c2e77 _4t3i1ylp _bfhkvuon _1doce4h9 _1il9nqa1 _1o3i1l7x _80omtlke _rz8tu2gc _1lvcidpf _80tlu2gc _he07idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    "_1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _o5721q9c _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
                    "_1dl7dlvw _1i0l1kdj _oosly1l4"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    className: (0, $gMc0m.default)([
                        "_zulp12x7 _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _4cvr1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("span", {
                            className: (0, $gMc0m.default)([
                                "_1o9zidpf _1e0c1txw _4cvr1h6o"
                            ]),
                            children: icon
                        }),
                        issueKey && /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                            href: url,
                            target: "_blank",
                            onClick: onClick,
                            children: issueKey
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("span", {
                            className: (0, $gMc0m.default)([
                                "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c"
                            ]),
                            children: cleanTitle
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    "_1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _o5721q9c _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
                    "_1dl71n5l _1i0l1ame"
                ]),
                children: status || null
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    "_1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _o5721q9c _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
                    "_1dl710bg _1i0l1rr2"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $157d4b2b9c0ccedc$export$361f73eba39649ac), {
                    user: assignee ?? null
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    "_1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _o5721q9c _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
                    "_1dl75r1t _1i0l1h05"
                ]),
                children: labels[0] && /*#__PURE__*/ (0, $l998X.jsx)((0, $3WVxj.default), {
                    text: labels[0],
                    isRemovable: false
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    "_1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _o5721q9c _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
                    "_1dl7mfg7 _1i0l1nb2 _oosledzb"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        "_zulp1b66 _1e0c1txw _4cvr1h6o"
                    ]),
                    children: priority?.iconUrl && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        className: (0, $gMc0m.default)([
                            "_1o9zidpf _1e0c1txw _4cvr1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                            src: priority.iconUrl,
                            alt: priority.name ?? '',
                            width: 16,
                            height: 16
                        })
                    })
                })
            })
        ]
    });
};


const $73404969990abf67$export$26ac3e97753acb0e = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, jiraIssueStatus: jiraIssueStatus, jiraLinkedPRs: jiraLinkedPRs, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth, shouldRenderTableResult: shouldRenderTableResult = false })=>{
    const data = (0, $irOoi.useFragment)((0, $f1a2103d173cf5d0$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const [features] = (0, $j4ply.useFeatures)();
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const projectField = (0, $42omo.useMemo)(()=>{
        if (!data.issue?.fieldsById?.edges) return;
        const fields = data?.issue?.fieldsById?.edges ?? [];
        for (const field of fields){
            if (field && field.node?.__typename === 'JiraProjectField' && field.node?.name === 'Project') return field.node;
        }
    }, [
        data.issue?.fieldsById?.edges
    ]);
    const projectName = projectField?.project?.name || '';
    const projectId = projectField?.project?.id;
    const url = (0, $42omo.useMemo)(()=>{
        const url = data.issue?.webUrl || data.url;
        return (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
            url: url,
            searchSessionId: searchSessionId,
            resultId: data.id,
            projectId: projectId
        });
    }, [
        data.issue?.webUrl,
        data.url,
        data.id,
        searchSessionId,
        projectId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        return $73404969990abf67$export$b44712184b11a06(searchQuery, data.title, data.issue?.key);
    }, [
        data.title,
        data.issue?.key,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        return (0, $Y34Hw.processExcerpt)(data.description);
    }, [
        data.description
    ]);
    const issueType = (0, $42omo.useMemo)(()=>{
        const resolvedType = data.issue?.issueTypeField?.issueType?.name?.toLowerCase();
        if (resolvedType && resolvedType in (0, $cORSX.messages)) return resolvedType;
        return data.type;
    }, [
        data.type,
        data.issue?.issueTypeField?.issueType?.name
    ]);
    const metadataParts = (0, $42omo.useMemo)(()=>{
        const parts = [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: issueType
                })
            ],
            projectName ? [
                'project',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $d21ac91210a9e9f3$export$47d2cbdccded0b18), {
                    projectName: projectName
                })
            ] : null,
            [
                'lastModified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                }) : null
            ],
            [
                'assignee',
                (0, $dh538.fg)('rovo_search_assignee_field_fps') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $157d4b2b9c0ccedc$export$361f73eba39649ac), {
                    user: data.issue?.assigneeField?.user ? {
                        name: data.issue.assigneeField.user.name,
                        picture: data.issue.assigneeField.user.picture
                    } : null
                }) : null
            ]
        ];
        return parts.filter(Boolean);
    }, [
        issueType,
        data.lastModifiedDate,
        projectName,
        data.issue?.assigneeField?.user
    ]);
    const titleMetadataParts = (0, $42omo.useMemo)(()=>{
        const statusInfo = (0, $dh538.fg)('use_jira_fe_status_color_mapping_fps') ? {
            statusCategoryId: jiraIssueStatus?.statusCategoryId
        } : {
            color: jiraIssueStatus?.colorName
        };
        const status = jiraIssueStatus !== null && (0, $aKt88.getStatus)(jiraIssueStatus?.statusName, statusInfo, !jiraIssueStatus);
        return status ? [
            [
                'status',
                status
            ]
        ] : [];
    }, [
        jiraIssueStatus
    ]);
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    // PRs are gated upstream via shouldHydrateJiraGitHubPRs in SearchResultsBody.
    // jiraLinkedPRs is only populated when the user has GitHub connected, so we
    // use it directly here. The PR section is hidden entirely when there are no
    // PRs (see hasLinkedPRs / hasRelatedLinks below) to avoid empty renders.
    const effectivePRs = jiraLinkedPRs?.status === 'loaded' ? jiraLinkedPRs.prs : [];
    const hasMorePRs = jiraLinkedPRs?.status === 'loaded' ? jiraLinkedPRs.hasMore : false;
    const extractedLinksFromText = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(data.description);
    const hasExtractedLinks = extractedLinksFromText && extractedLinksFromText.length > 0;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const hasLinkedPRs = effectivePRs.length > 0;
    const hasRelatedLinks = linkedResults && linkedResults.length > 0 || hasExtractedLinks || hasLinkedPRs;
    // when in lite mode, we want to try and use the icon from the issue.issueTypeAvatar first and then default to .iconUrl if it is null
    const iconUrlSource = features?.lite?.enabled ? data.issue?.issueTypeAvatarUrl || data.iconUrl : data.iconUrl || data.issue?.issueTypeAvatarUrl;
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: iconUrlSource,
        type: data.type,
        isIssue: true,
        size: 'medium'
    });
    if (shouldRenderTableResult) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5e5e27e38c15bb2a$export$19b3d66141ca17f0), {
        iconUrl: data.issue?.issueTypeAvatarUrl || data.iconUrl,
        type: data.type,
        issueKey: data.issue?.key,
        url: url,
        title: data.title,
        jiraIssueStatus: jiraIssueStatus,
        assignee: data.issue?.assigneeField?.user ?? null,
        priority: data.issue?.priorityField?.priority ?? null,
        labels: data.issue?.labelsField?.selectedLabelsConnection?.edges?.flatMap((e)=>e?.node?.name ? [
                e.node.name
            ] : []) ?? [],
        // TODO: properly wire up analytics
        onClick: ()=>onResultClicked({})
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        titleMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7nUd.SearchMetadata), {
            parts: titleMetadataParts
        }),
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        hasRelatedLinks: hasRelatedLinks,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$695e5a3ae2478b3), {
            linkedResults: linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: data,
            url: url,
            position: position,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultCtxMenuClicked,
            isAllProductSelected: !selectedProduct,
            additionalExpands: hasLinkedPRs ? /*#__PURE__*/ (0, $l998X.jsx)((0, $664c8ed2681bd434$export$49bd1dfb0ad29c40), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))),
                attachmentCount: effectivePRs.length,
                attachmentType: "pull-request",
                label: formatMessage((0, $7bfed7214d4a524b$export$defe85febe8b728c).expandLabel, {
                    count: effectivePRs.length,
                    hasMore: hasMorePRs
                }),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a7e952e2df3d6f82$export$c9e111d3747f61cf), {
                    pullRequests: effectivePRs,
                    onResultClicked: ()=>onResultClicked({})
                })
            }) : undefined
        }),
        mainContentWidth: mainContentWidth
    });
};
const $73404969990abf67$export$b9491ee18011db60 = (node)=>{
    return node?.__typename === 'SearchResultJiraIssue';
};
const $73404969990abf67$export$b44712184b11a06 = (searchQuery, title, issueKey)=>{
    const enrichedTitle = (0, $Y34Hw.enrichExcerpt)(title);
    // If there is no issueKey or the issue key is already prefixed, simply return the title
    if (!issueKey || title.startsWith(issueKey)) return enrichedTitle;
    // If the issueKey exists in its entirety in the searchQuery, highlight and prefix it
    if (searchQuery.split(' ').includes(issueKey)) {
        const { highlightedTitle: highlightedIssueKey } = (0, $bloXB.highlightMatchedText)(issueKey, searchQuery.split(' '));
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                (0, $Y34Hw.enrichExcerpt)(highlightedIssueKey),
                ": ",
                enrichedTitle
            ]
        });
    }
    // Otherwise, return the issue key unhighlighted and prefixed
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            issueKey,
            ": ",
            enrichedTitle
        ]
    });
};





/**
 * @generated SignedSource<<ae959cb91670d5404fe1479f37384b54>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $25c9bd63bbe470d0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchJiraPlan_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "lastModifiedDate"
        },
        {
            "kind": "ScalarField",
            "name": "iconUrl"
        }
    ],
    "type": "SearchResultJiraPlan"
};
$25c9bd63bbe470d0$var$node.hash = "f4e7bb97d2f9944eea527780c5518350";
var $25c9bd63bbe470d0$export$2e2bcd8739ae039 = $25c9bd63bbe470d0$var$node;











































const $480180c1ff14c088$export$24f204fc253b9cb5 = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $25c9bd63bbe470d0$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
            url: data.url,
            searchSessionId: searchSessionId,
            resultId: data.id
        });
    }, [
        data.url,
        data.id,
        searchSessionId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(data.title, searchQuery.split(' '));
        return !highlightedTitle ? data.title : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        data.title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $92zSJ.getSummarizedAdfContent)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const metadataParts = (0, $42omo.useMemo)(()=>{
        const parts = [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            ],
            [
                'lastModified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                }) : null
            ]
        ];
        return parts.filter(Boolean);
    }, [
        data.type,
        data.lastModifiedDate
    ]);
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        isIssue: false,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $480180c1ff14c088$export$6566c83063a7eefb = (node)=>{
    return node?.__typename === 'SearchResultJiraPlan';
};





/**
 * @generated SignedSource<<784d33749d0d0c04388595b67124bd39>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a232b7a197706ce7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    }, v1 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeJiraLiteModeFields"
            },
            {
                "kind": "RootArgument",
                "name": "tenantId"
            }
        ],
        "kind": "Fragment",
        "name": "searchJiraProject_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "description"
            },
            {
                "kind": "ScalarField",
                "name": "projectKey"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "webUrl"
                    },
                    {
                        "condition": "includeJiraLiteModeFields",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "lead",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "small"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectType"
                            },
                            {
                                "concreteType": "JiraProjectCategory",
                                "kind": "LinkedField",
                                "name": "category",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "tenantId",
                        "variableName": "tenantId"
                    }
                ],
                "concreteType": "SocialSignalSearch",
                "kind": "LinkedField",
                "name": "socialSignal",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "signal"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "timestamp"
                    },
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            },
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "email"
                                    },
                                    {
                                        "concreteType": "AtlassianAccountUserExtendedProfile",
                                        "kind": "LinkedField",
                                        "name": "extendedProfile",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "jobTitle"
                                            }
                                        ]
                                    }
                                ],
                                "type": "AtlassianAccountUser"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "SearchResultJiraProject"
    };
}();
$a232b7a197706ce7$var$node.hash = "16380ef5d22d59f2b0f43c47e296b88b";
var $a232b7a197706ce7$export$2e2bcd8739ae039 = $a232b7a197706ce7$var$node;
























































/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





parcelRequire("42omo");


var $iKCFj = parcelRequire("iKCFj");














const $a2fde27cb090bf63$var$truncatedAnchorStyle = {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0
};
const $a2fde27cb090bf63$var$styles = {
    tr: null,
    tdBase: null,
    tdSpace: null,
    tdKey: null,
    tdType: null,
    tdLead: null,
    tdCategory: null,
    tdSpaceUrl: null,
    tdSpaceUrlInner: null,
    tdSpaceInner: null,
    truncateText: null,
    link: null,
    iconWrapper: null
};
const $a2fde27cb090bf63$var$makeProjectStyleOrTypeReadable = (styleOrType)=>{
    return styleOrType.split('_').map((0, (/*@__PURE__*/$parcel$interopDefault($iKCFj)))).join(' ');
};
const $a2fde27cb090bf63$export$f73ce31503cf3a1e = ({ iconUrl: iconUrl, type: type, projectKey: projectKey, title: title, projectUrl: projectUrl, projectStyle: projectStyle, projectType: projectType, lead: lead, category: category, onClick: onClick })=>{
    const Icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: iconUrl,
        type: type,
        isIssue: false,
        size: 'small'
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("tr", {
        "data-testid": "search-jira-issue-table-row",
        onClick: onClick,
        className: (0, $gMc0m.default)([
            "_1e0c2e77 _4t3i1ylp _bfhkvuon _1doce4h9 _1il9nqa1 _1o3i1l7x _80omtlke _rz8tu2gc _1lvcidpf _80tlu2gc _he07idpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    "_1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _o5721q9c _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
                    "_1dl7dlvw _1i0l18rv _ooslg8x7"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    className: (0, $gMc0m.default)([
                        "_zulp12x7 _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _4cvr1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("span", {
                            className: (0, $gMc0m.default)([
                                "_1o9zidpf _1e0c1txw _4cvr1h6o"
                            ]),
                            children: Icon
                        }),
                        title && /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                            href: projectUrl,
                            target: "_blank",
                            onClick: onClick,
                            // so that we don't need additional wrapper elements to achieve the same effect
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            style: $a2fde27cb090bf63$var$truncatedAnchorStyle,
                            children: title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    "_1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _o5721q9c _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
                    "_1dl7ys9h"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c"
                    ]),
                    children: projectKey || null
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    "_1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _o5721q9c _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
                    "_1dl711ux _1i0lmgvx"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c"
                    ]),
                    children: $a2fde27cb090bf63$var$makeProjectStyleOrTypeReadable(projectStyle || projectType)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    "_1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _o5721q9c _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
                    "_1dl768cl _1o3j11ux _1i0l1tkr"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $157d4b2b9c0ccedc$export$361f73eba39649ac), {
                    user: lead ?? null
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    "_1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _o5721q9c _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
                    "_1dl7ys9h _1i0l7iqz"
                ]),
                children: category
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    "_1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _o5721q9c _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
                    "_1dl7ys9h _1i0l1obz"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        "_2lx2vrvc _1n261q9c _1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dE1p6.default), {
                        appearance: "subtle",
                        isTooltipDisabled: false,
                        href: projectUrl,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
                        label: projectUrl
                    })
                })
            })
        ]
    });
};


const $31e547389e3910c7$export$14e63e5586bfae9b = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth, shouldRenderTableResult: shouldRenderTableResult = false })=>{
    const data = (0, $irOoi.useFragment)((0, $a232b7a197706ce7$export$2e2bcd8739ae039), node);
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const url = (0, $42omo.useMemo)(()=>{
        const initialResultUrl = data.project?.webUrl || data.url;
        return (0, $icWhS.getJiraUrlWithAnalyticsQueryParams)({
            url: initialResultUrl,
            searchSessionId: searchSessionId,
            resultId: data.id
        });
    }, [
        data.project?.webUrl,
        data.url,
        data.id,
        searchSessionId
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const prefix = data.projectKey;
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(data.title, searchQuery.split(' '));
        if (prefix && !(highlightedTitle?.startsWith(prefix) || data.title.startsWith(prefix))) return !highlightedTitle ? prefix.concat(': ', data.title) : (0, $Y34Hw.enrichExcerpt)(prefix.concat(': ', highlightedTitle));
        return !highlightedTitle ? data.title : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        data.title,
        data.projectKey,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $92zSJ.getSummarizedAdfContent)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const metadataParts = (0, $42omo.useMemo)(()=>{
        const parts = [
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: (0, $1BldJ.getJiraSearchResultTypeMetadata)(data.type)
                })
            ],
            [
                'lastModified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                }) : null
            ]
        ];
        if (appMode === (0, $9vOy1.ApplicationModes).Rovo && data.socialSignal?.user?.email && (0, $dh538.fg)('search-plex-jira-social-signal')) {
            const { user: user, signal: signal, timestamp: timestamp } = data.socialSignal;
            parts.push([
                'social-signal',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $e46c71a22c4ed891$export$229f0558b2da716c), {
                    userAccountId: user.accountId,
                    userName: user.name,
                    userEmail: data.socialSignal?.user?.email,
                    userPicture: user.picture,
                    userJobTitle: user.extendedProfile?.jobTitle,
                    signal: signal,
                    timestamp: timestamp,
                    commonAttributes: commonAttributes
                })
            ]);
        }
        return parts.filter(Boolean);
    }, [
        data.socialSignal,
        data.type,
        data.lastModifiedDate,
        appMode,
        commonAttributes
    ]);
    const icon = (0, $2waBy.getJiraEntityIcon)({
        iconUrl: data.iconUrl,
        type: data.type,
        isIssue: false,
        size: 'medium'
    });
    if (shouldRenderTableResult) return /*#__PURE__*/ (0, $l998X.jsx)((0, $a2fde27cb090bf63$export$f73ce31503cf3a1e), {
        iconUrl: data.project?.avatar?.small ?? '',
        type: data.type,
        projectStyle: data.project?.projectStyle ?? '',
        projectType: data.project?.projectType ?? '',
        projectKey: data.projectKey,
        projectUrl: url,
        title: enrichedTitle,
        lead: data.project?.lead ? {
            name: data.project.lead.name,
            picture: data.project.lead.picture
        } : null,
        category: data.project?.category?.name ?? '',
        // TODO: properly wire up analytics
        onClick: ()=>onResultClicked({})
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Jira,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: url,
        icon: icon,
        title: enrichedTitle,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $31e547389e3910c7$export$79503cf2fe431c3a = (node)=>{
    return node?.__typename === 'SearchResultJiraProject';
};





/**
 * @generated SignedSource<<772d0484ac0b0a03380aeff3b8237008>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $87a98fce03786246$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchMercuryFocusArea_AtlassianSearchPage",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage"
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "lastModifiedDate"
                    },
                    {
                        "concreteType": "MercuryFocusArea",
                        "kind": "LinkedField",
                        "name": "focusArea",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            {
                                "concreteType": "MercuryFocusAreaType",
                                "kind": "LinkedField",
                                "name": "focusAreaType",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "type": "SearchResultMercuryFocusArea"
            }
        ],
        "type": "SearchResult",
        "abstractKey": "__isSearchResult"
    };
}();
$87a98fce03786246$var$node.hash = "c84e3881069f1be8f1f3244bc1c9630e";
var $87a98fce03786246$export$2e2bcd8739ae039 = $87a98fce03786246$var$node;







































/**
 * @generated SignedSource<<d7162a934a0ab7c8304e0b0b51bc6150>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9cc83d995e39230c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "key"
    }, v1 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage",
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "MercuryFocusArea",
                        "kind": "LinkedField",
                        "name": "focusArea",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "MercuryFocusAreaStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "MercuryFocusAreaHealth",
                                "kind": "LinkedField",
                                "name": "health",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "color"
                                    },
                                    v1 /*: any*/ 
                                ]
                            },
                            {
                                "concreteType": "MercuryTargetDate",
                                "kind": "LinkedField",
                                "name": "targetDate",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "targetDate"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "targetDateType"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "SearchResultMercuryFocusArea"
            }
        ],
        "type": "SearchResult",
        "abstractKey": "__isSearchResult"
    };
}();
$9cc83d995e39230c$var$node.hash = "1ba6f6deb1ce6324e34fc596e49e59a6";
var $9cc83d995e39230c$export$2e2bcd8739ae039 = $9cc83d995e39230c$var$node;


parcelRequire("42omo");


var $cFEpk = parcelRequire("cFEpk");







parcelRequire("42omo");

















parcelRequire("42omo");

const $01817a1a99cb392d$export$72cad736eff3158c = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            stroke: "currentcolor",
            strokeWidth: "1.5",
            d: "M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"
        })
    });





const $eb140b8103a49e5d$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    for: {
        id: "search-page.common.status-target-date-display.for",
        defaultMessage: "for"
    }
});


const $46e1b4b176e8f674$export$cbab9d9e4aeea74c = ({ displayedStatus: displayedStatus, displayedStatusAppearance: displayedStatusAppearance, displayedTargetDate: displayedTargetDate })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $46e1b4b176e8f674$var$statusAndTargetDateXcss,
        testId: "search-status-target-date-display",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                appearance: displayedStatusAppearance,
                children: displayedStatus
            }),
            displayedTargetDate && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    ' ',
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $46e1b4b176e8f674$var$targetDateForXcss,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $eb140b8103a49e5d$export$defe85febe8b728c).for
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                            alignBlock: "center",
                            space: "space.050",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $01817a1a99cb392d$export$72cad736eff3158c), {}),
                                " ",
                                displayedTargetDate
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $46e1b4b176e8f674$var$statusAndTargetDateXcss = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
    // Fix height to match text lineHeight so that inline
    // children with built-in margins (e.g. Tag) do not cause the row to grow taller.
    height: "var(--ds-space-200, 16px)"
});
const $46e1b4b176e8f674$var$targetDateForXcss = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest'
});






var $3Vbz9 = parcelRequire("3Vbz9");


var $5eayg = parcelRequire("5eayg");





var $9tcaE = parcelRequire("9tcaE");


var $cPLkE = parcelRequire("cPLkE");

const $3d48d62c690afe86$var$SAME_YEAR_FORMAT = 'd MMM';
const $3d48d62c690afe86$var$DIFF_YEAR_FORMAT = 'd MMM yyyy';
const $3d48d62c690afe86$var$MONTH_ONLY_FORMAT = 'MMMM';
const $3d48d62c690afe86$var$MONTH_ONLY_FORMAT_SHORT = 'MMM';
const $3d48d62c690afe86$var$MONTH_ONLY_FORMAT_DIFF_YEAR = 'MMM yyyy';
const $3d48d62c690afe86$var$format = (date, formatStr)=>(0, $dWCFT.default)(date, formatStr, {
        weekStartsOn: 1
    });
const $3d48d62c690afe86$var$NonMemoTargetDate = ({ targetDate: targetDate, targetDateType: targetDateType })=>{
    const date = (0, $3Vbz9.toDate)(targetDate);
    let displayedTargetDate = '';
    if (targetDateType === 'DAY') displayedTargetDate = $3d48d62c690afe86$var$format(date, (0, $9tcaE.default)(date) ? $3d48d62c690afe86$var$SAME_YEAR_FORMAT : $3d48d62c690afe86$var$DIFF_YEAR_FORMAT);
    else if (targetDateType === 'MONTH') displayedTargetDate = $3d48d62c690afe86$var$format(date, (0, $9tcaE.default)(date) ? $3d48d62c690afe86$var$MONTH_ONLY_FORMAT : $3d48d62c690afe86$var$MONTH_ONLY_FORMAT_DIFF_YEAR);
    else if (targetDateType === 'QUARTER') displayedTargetDate = `${$3d48d62c690afe86$var$format((0, $cPLkE.default)(date), $3d48d62c690afe86$var$MONTH_ONLY_FORMAT_SHORT)}-${$3d48d62c690afe86$var$format((0, $5eayg.default)(date), (0, $9tcaE.default)(date) ? $3d48d62c690afe86$var$MONTH_ONLY_FORMAT_SHORT : $3d48d62c690afe86$var$MONTH_ONLY_FORMAT_DIFF_YEAR)}`;
    return displayedTargetDate;
};
const $3d48d62c690afe86$export$36b79ad3c18e5aae = (0, $42omo.memo)($3d48d62c690afe86$var$NonMemoTargetDate);


const $96a738ca6fc4ac74$var$getStatusAppearanceFromKey = (key)=>{
    switch(key){
        case 'off_track':
        case 'red':
            return 'danger';
        case 'at_risk':
        case 'yellow':
            return 'warning';
        case 'on_track':
        case 'green':
            return 'success';
        case 'completed':
        case 'paused':
        case 'pending':
        default:
            return 'neutral';
    }
};
const $96a738ca6fc4ac74$export$1da174cfafc04271 = ({ healthColor: healthColor, healthDisplayName: healthDisplayName, healthKey: healthKey, statusDisplayName: statusDisplayName, statusKey: statusKey })=>{
    const displayedStatus = statusKey === 'in_progress' ? healthDisplayName : statusDisplayName;
    const displayedStatusAppearance = $96a738ca6fc4ac74$var$getStatusAppearanceFromKey(healthColor?.toLowerCase() || healthKey || statusKey);
    return {
        displayedStatus: displayedStatus,
        displayedStatusAppearance: displayedStatusAppearance
    };
};


const $66ef7a52ea37745e$export$bb82a6046bad0cd0 = ({ node: node })=>{
    const data = (0, $irOoi.useFragment)((0, $9cc83d995e39230c$export$2e2bcd8739ae039), node);
    const { displayedStatus: displayedStatus, displayedStatusAppearance: displayedStatusAppearance } = (0, $96a738ca6fc4ac74$export$1da174cfafc04271)({
        healthColor: data.focusArea?.health?.color,
        statusKey: data.focusArea?.status?.key,
        statusDisplayName: data.focusArea?.status?.displayName,
        healthDisplayName: data.focusArea?.health?.displayName,
        healthKey: data.focusArea?.health?.key
    });
    if (!displayedStatus) return null;
    const targetDate = data.focusArea?.targetDate?.targetDate;
    const targetDateType = data.focusArea?.targetDate?.targetDateType;
    const displayedTargetDate = targetDate && targetDateType && (0, $cFEpk.default)(new Date(targetDate)) && /*#__PURE__*/ (0, $l998X.jsx)((0, $3d48d62c690afe86$export$36b79ad3c18e5aae), {
        targetDate: targetDate,
        targetDateType: targetDateType
    }) || undefined;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $46e1b4b176e8f674$export$cbab9d9e4aeea74c), {
        displayedStatus: displayedStatus,
        displayedStatusAppearance: displayedStatusAppearance,
        displayedTargetDate: displayedTargetDate
    });
};


const $1f5c3a9997a89a12$export$462e5965a804bcf5 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $87a98fce03786246$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const title = (0, $42omo.useMemo)(()=>(0, $Y34Hw.enrichExcerpt)(data.title), [
        data.title
    ]);
    const headerMetadataParts = (0, $42omo.useMemo)(()=>[
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                        type: data.type
                    })
                })
            ],
            [
                'focusAreaType',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: data.focusArea?.focusAreaType?.name
                })
            ],
            data.focusArea?.owner?.name ? [
                'owner',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: data.focusArea?.owner?.name
                })
            ] : null,
            [
                'last-modified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                        lastModified: data.lastModifiedDate
                    })
                }) : null
            ]
        ], [
        data.type,
        data.focusArea?.focusAreaType?.name,
        data.focusArea?.owner?.name,
        data.lastModifiedDate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Focus,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: data.url,
        title: title,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.FocusIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        headerMetadataParts: headerMetadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $66ef7a52ea37745e$export$bb82a6046bad0cd0), {
            node: data
        }),
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $1f5c3a9997a89a12$export$9bcd0683f048ca39 = (node)=>{
    return node?.id?.includes('mercury') && node.__typename === 'SearchResultMercuryFocusArea';
};





/**
 * @generated SignedSource<<87f68f8628660ee6538d5dde764f3819>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d56ee89a36058074$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchMercuryFocusAreaUpdate_AtlassianSearchPage",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastModifiedDate"
                },
                {
                    "concreteType": "MercuryFocusArea",
                    "kind": "LinkedField",
                    "name": "focusArea",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ],
            "type": "SearchResultMercuryFocusAreaStatusUpdate"
        }
    ],
    "type": "SearchResult",
    "abstractKey": "__isSearchResult"
};
$d56ee89a36058074$var$node.hash = "4bedbd663322481df5ab3989c8b87c7c";
var $d56ee89a36058074$export$2e2bcd8739ae039 = $d56ee89a36058074$var$node;










































const $addc29d84a174886$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    statusUpdateTitle: {
        id: "search-page.mercury.focus-area-update.title",
        defaultMessage: "Update for {focusAreaName}"
    }
});


const $aa67e67612c8c517$export$e299cc210f856d0f = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $d56ee89a36058074$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const description = (0, $42omo.useMemo)(()=>(0, $92zSJ.getSummarizedAdfContent)(data.description, searchQuery), [
        data.description,
        searchQuery
    ]);
    const headerMetadataParts = (0, $42omo.useMemo)(()=>[
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                        type: data.type
                    })
                })
            ],
            [
                'last-modified',
                data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                        lastModified: data.lastModifiedDate
                    })
                }) : null
            ]
        ], [
        data.type,
        data.lastModifiedDate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Focus,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: data.url,
        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $addc29d84a174886$export$defe85febe8b728c).statusUpdateTitle,
            values: {
                focusAreaName: data.focusArea?.name
            }
        }),
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.FocusIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        headerMetadataParts: headerMetadataParts,
        description: description,
        cloudId: cloudId,
        position: position,
        partial: data,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $aa67e67612c8c517$export$25e56f07edb2e8ac = (node)=>{
    return node?.id?.includes('mercury') && node?.__typename === 'SearchResultMercuryFocusAreaStatusUpdate';
};





/**
 * @generated SignedSource<<41c9275a4bfe32c32cea305daf6f41b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c7009a8f44c0d712$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchPassionfruitAsk_AtlassianSearchPage",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "searchPassionfruitAskStatusTargetDate_AtlassianSearchPage"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastModifiedDate"
                }
            ],
            "type": "SearchResultSpfAsk"
        }
    ],
    "type": "SearchResult",
    "abstractKey": "__isSearchResult"
};
$c7009a8f44c0d712$var$node.hash = "3d4f5d6c4a2884dde22ba42bee1c8825";
var $c7009a8f44c0d712$export$2e2bcd8739ae039 = $c7009a8f44c0d712$var$node;







































/**
 * @generated SignedSource<<8360b5031eb52c5459725804cf2a5fd3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6eec0849b11acd40$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchPassionfruitAskStatusTargetDate_AtlassianSearchPage",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "SpfAsk",
                    "kind": "LinkedField",
                    "name": "ask",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "SpfAskTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "targetDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetDateType"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "SearchResultSpfAsk"
        }
    ],
    "type": "SearchResult",
    "abstractKey": "__isSearchResult"
};
$6eec0849b11acd40$var$node.hash = "4f254907d88785a6e346dfbdbf1488e2";
var $6eec0849b11acd40$export$2e2bcd8739ae039 = $6eec0849b11acd40$var$node;


parcelRequire("42omo");










var $1u6ec = parcelRequire("1u6ec");

const $867b4b799ffba887$export$80ce3fe68e6abf83 = (status)=>{
    return (0, $1u6ec.SPF_ASK_STATUS_CONFIG)[status ?? '']?.appearance ?? 'neutral';
};
const $867b4b799ffba887$export$bdf152cbb4da9f25 = (status)=>{
    return status ? (0, $1u6ec.SPF_ASK_STATUS_CONFIG)[status]?.display : undefined;
};


const $c5bdfcbc92cdd77c$export$da5dd7197137195d = ({ node: node })=>{
    const data = (0, $irOoi.useFragment)((0, $6eec0849b11acd40$export$2e2bcd8739ae039), node);
    const askStatus = (0, $867b4b799ffba887$export$bdf152cbb4da9f25)(data.ask?.status);
    if (!askStatus) return null;
    const displayedStatusAppearance = (0, $867b4b799ffba887$export$80ce3fe68e6abf83)(data.ask?.status);
    const targetDate = data.ask?.targetDate?.targetDate;
    const targetDateType = data.ask?.targetDate?.targetDateType;
    const displayedTargetDate = targetDate && targetDateType && (0, $cFEpk.default)(new Date(targetDate)) && /*#__PURE__*/ (0, $l998X.jsx)((0, $3d48d62c690afe86$export$36b79ad3c18e5aae), {
        targetDate: targetDate,
        targetDateType: targetDateType
    }) || undefined;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $46e1b4b176e8f674$export$cbab9d9e4aeea74c), {
        displayedStatus: askStatus,
        displayedStatusAppearance: displayedStatusAppearance,
        displayedTargetDate: displayedTargetDate
    });
};


const $e1e365f93a6cb640$export$c92f93b41e432091 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $c7009a8f44c0d712$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const title = (0, $42omo.useMemo)(()=>(0, $Y34Hw.enrichExcerpt)(data.title), [
        data.title
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            })
        ],
        [
            'last-modified',
            data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                    lastModified: data.lastModifiedDate
                })
            }) : null
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Focus,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: data.url,
        title: title,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.FocusIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        headerMetadataParts: headerMetadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $c5bdfcbc92cdd77c$export$da5dd7197137195d), {
            node: data
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $e1e365f93a6cb640$export$29b4f3dd85087f82 = (node)=>{
    return node.__typename === 'SearchResultSpfAsk';
};





/**
 * @generated SignedSource<<e39dbb360283cf7c2b0975e9076363ab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2cea3badc71cab2b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchTalentPosition_AtlassianSearchPage",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "RadarPosition",
                        "kind": "LinkedField",
                        "name": "position",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "concreteType": "RadarWorker",
                                "kind": "LinkedField",
                                "name": "worker",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "preferredName"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "picture"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "fieldIdIsIn",
                                        "value": [
                                            "positionId",
                                            "positionStatus",
                                            "positionJobTitle",
                                            "positionPositionTitle",
                                            "positionKey",
                                            "positionExternalPositionKey",
                                            "positionWorker",
                                            "focusArea"
                                        ]
                                    }
                                ],
                                "concreteType": "RadarFieldValueIdPair",
                                "kind": "LinkedField",
                                "name": "fieldValues",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "fieldId"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "fieldValue",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": "stringValue",
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "RadarStringFieldValue"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "value",
                                                        "plural": false,
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": "positionFocusArea_AtlassianSearchPage"
                                                                    }
                                                                ],
                                                                "type": "MercuryFocusArea"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "RadarAriFieldValue"
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                            }
                        ]
                    }
                ],
                "type": "SearchResultTalentPosition"
            }
        ],
        "type": "SearchResult",
        "abstractKey": "__isSearchResult"
    };
}();
$2cea3badc71cab2b$var$node.hash = "4b2c420e8a8fe59c29a7e5a6a9af5ed0";
var $2cea3badc71cab2b$export$2e2bcd8739ae039 = $2cea3badc71cab2b$var$node;



























var $cWRpe = parcelRequire("cWRpe");
















const $0de0787fb1ebae17$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    positionExternalKey: {
        id: "search_talent_position.external_position_key",
        defaultMessage: "External key {positionExternalKey}"
    },
    positionTitle: {
        id: "search_talent_position.position_title",
        defaultMessage: "{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}"
    }
});





/**
 * @generated SignedSource<<a196c50ae86a6c923bf8da291ac6a70a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e52f8f55460571a7$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "positionFocusArea_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "MercuryFocusAreaStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": v0 /*: any*/ 
            },
            {
                "concreteType": "MercuryFocusAreaHealth",
                "kind": "LinkedField",
                "name": "health",
                "plural": false,
                "selections": v0 /*: any*/ 
            }
        ],
        "type": "MercuryFocusArea"
    };
}();
$e52f8f55460571a7$var$node.hash = "e9b519ecce5fbf8e7515fc87b88d3908";
var $e52f8f55460571a7$export$2e2bcd8739ae039 = $e52f8f55460571a7$var$node;


parcelRequire("42omo");










var $2BDjU = parcelRequire("2BDjU");

const $bfa7c91f92160eaf$export$21327edf61992871 = ({ node: node })=>{
    const data = (0, $irOoi.useFragment)((0, $e52f8f55460571a7$export$2e2bcd8739ae039), node);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2BDjU.default), {
                status: data?.status?.key,
                health: data?.health?.key
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "medium",
                weight: "regular",
                color: "color.text.subtle",
                children: data?.name
            })
        ]
    });
};


const $7703ce592a2f6397$export$a4810646942f13a2 = ({ node: node, position: position, cloudId: cloudId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, searchQuery: searchQuery, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const logException = (0, $f8oYd.useLogException)();
    const data = (0, $irOoi.useFragment)((0, $2cea3badc71cab2b$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type,
            entityType: data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const preferredName = data.position?.worker?.preferredName || undefined;
    const [jobTitle, positionExternalKey, focusArea, positionKey] = (0, $42omo.useMemo)(()=>{
        let jobTitle = '';
        let positionExternalKey = '';
        let focusArea = null;
        let positionKey = '';
        data.position?.fieldValues?.forEach((fieldValue)=>{
            if (fieldValue.fieldId === 'positionKey' && fieldValue.fieldValue?.__typename === 'RadarStringFieldValue') positionKey = fieldValue.fieldValue?.stringValue || '';
            if (fieldValue.fieldId === 'positionPositionTitle' && fieldValue.fieldValue?.__typename === 'RadarStringFieldValue') jobTitle = fieldValue.fieldValue?.stringValue || '';
            if (fieldValue.fieldId === 'positionExternalPositionKey' && fieldValue.fieldValue?.__typename === 'RadarStringFieldValue') positionExternalKey = fieldValue.fieldValue?.stringValue || '';
            if (fieldValue.fieldId === 'focusArea' && fieldValue.fieldValue?.__typename === 'RadarAriFieldValue' && fieldValue.fieldValue?.value?.__typename === 'MercuryFocusArea') focusArea = fieldValue.fieldValue?.value;
        });
        return [
            jobTitle,
            positionExternalKey,
            focusArea,
            positionKey
        ];
    }, [
        data.position?.fieldValues
    ]);
    const title = (0, $42omo.useMemo)(()=>{
        const title = formatMessage((0, $0de0787fb1ebae17$export$defe85febe8b728c).positionTitle, {
            positionKey: positionKey,
            preferredName: preferredName
        });
        if (!searchQuery) return (0, $Y34Hw.enrichExcerpt)(title) || title;
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(title, searchQuery.split(' '));
        return !highlightedTitle ? (0, $Y34Hw.enrichExcerpt)(title) : (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        positionKey,
        preferredName,
        formatMessage,
        searchQuery
    ]);
    const headerMetadataParts = (0, $42omo.useMemo)(()=>[
            [
                'type',
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                    type: data.type
                })
            ],
            jobTitle ? [
                'positionTitle',
                jobTitle
            ] : null,
            positionExternalKey ? [
                'positionExternalKey',
                formatMessage((0, $0de0787fb1ebae17$export$defe85febe8b728c).positionExternalKey, {
                    positionExternalKey: positionExternalKey
                })
            ] : null
        ], [
        data.type,
        jobTitle,
        positionExternalKey,
        formatMessage
    ]);
    if (!data.position) {
        logException(`SearchResultRenderer: Invalid Talent Position - ${data.id}`);
        return null;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        hideSummarizeInChat: true,
        product: (0, $1yEFx.ProductKeys).Talent,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: data.url,
        title: title,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $cWRpe.TalentUserAvatar), {
            src: data.position?.worker?.user?.picture
        }),
        headerMetadataParts: headerMetadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $bfa7c91f92160eaf$export$21327edf61992871), {
            node: focusArea
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth
    });
};
const $7703ce592a2f6397$export$6961f06bc751194b = (node)=>{
    return node?.id?.includes('radar') && node.__typename === 'SearchResultTalentPosition';
};





/**
 * @generated SignedSource<<9c211aa088d9d7510742f9683aad83c2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $508a9faa0fdcb277$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "description"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v6 = [
        v5 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "searchTrello_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v6 /*: any*/ ,
                "type": "SearchResultTrelloBoard"
            },
            {
                "kind": "InlineFragment",
                "selections": v6 /*: any*/ ,
                "type": "SearchResultTrelloCard"
            },
            {
                "concreteType": "SearchLinkedResult",
                "kind": "LinkedField",
                "name": "linkedResults",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v4 /*: any*/ ,
                    v3 /*: any*/ ,
                    v0 /*: any*/ ,
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "subtype"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "integrationId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "providerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "connectorType"
                    }
                ]
            }
        ],
        "type": "SearchResult",
        "abstractKey": "__isSearchResult"
    };
}();
$508a9faa0fdcb277$var$node.hash = "0d47378928f4dc8252dbb20d4890cfa9";
var $508a9faa0fdcb277$export$2e2bcd8739ae039 = $508a9faa0fdcb277$var$node;










































const $b22a5a74dc96194e$export$6e8065b29de68b35 = ({ node: node, position: position, cloudId: cloudId, searchQuery: searchQuery, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, thirdPartyConfigs: thirdPartyConfigs, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $508a9faa0fdcb277$export$2e2bcd8739ae039), node);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(data.id);
        return {
            id: data.id,
            containerId: null,
            spaceId: null,
            contentType: data.type === 'issue' ? 'card' : data.type,
            entityType: data.type === 'issue' ? 'card' : data.type,
            contentId: contentId,
            product: product
        };
    }, [
        data.id,
        data.type
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(data.title, searchQuery.split(' '));
        if (!highlightedTitle) return data.title;
        return (0, $Y34Hw.enrichExcerpt)(highlightedTitle);
    }, [
        data.title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $bOpS4.truncateTextWithQuery)(data.description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $Y34Hw.processExcerpt)(highlightedTitle);
    }, [
        data.description,
        searchQuery
    ]);
    const headerMetadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kXlQy.SearchResultType), {
                type: metadata.entityType
            })
        ],
        [
            'lastModified',
            data.lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                lastModified: data.lastModifiedDate
            }) : null
        ]
    ];
    const linkedResults = data.linkedResults?.map((linkedResult)=>({
            id: linkedResult.id,
            title: linkedResult.title,
            url: linkedResult.url,
            type: linkedResult.type,
            description: linkedResult.description,
            lastModifiedDate: linkedResult.lastModifiedDate,
            category: linkedResult.category,
            subtype: linkedResult.subtype,
            integrationId: linkedResult.integrationId,
            providerId: linkedResult.providerId,
            connectorType: linkedResult.connectorType
        }));
    const extractedLinksFromText = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(data.description);
    const hasExtractedLinks = extractedLinksFromText && extractedLinksFromText.length > 0;
    const hasRelatedLinks = linkedResults && linkedResults.length > 0 || hasExtractedLinks;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        ...data,
        product: (0, $1yEFx.ProductKeys).Trello,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: data.url,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.TrelloIcon), {
            size: "medium",
            shouldUseNewLogoDesign: true
        }),
        title: enrichedTitle,
        headerMetadataParts: headerMetadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: enrichedDescription
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode,
        hasRelatedLinks: hasRelatedLinks,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $b7a5d3c4b4eaddeb$export$695e5a3ae2478b3), {
            linkedResults: linkedResults || [],
            thirdPartyConfigs: thirdPartyConfigs,
            partial: data,
            url: data.url,
            position: position,
            onResultClicked: onResultClicked,
            onResultContextMenu: onResultCtxMenuClicked,
            isAllProductSelected: !selectedProduct
        }),
        mainContentWidth: mainContentWidth
    });
};
const $b22a5a74dc96194e$export$4a9584fe41dfb37d = (node)=>{
    return node?.__typename === 'SearchResultTrelloBoard' || node?.__typename === 'SearchResultTrelloCard';
};


const $d5fc325798e6b51f$export$705600d20983658a = ({ node: fragmentRef, thirdPartyConfigs: thirdPartyConfigs, compassTeamName: compassTeamName, jiraIssueStatus: jiraIssueStatus, jiraLinkedPRs: jiraLinkedPRs, pastMeetingOccurrences: pastMeetingOccurrences, smartAnswersPortalRef: smartAnswersPortalRef, isLiteMode: isLiteMode, ...props })=>{
    // Casting to `any` to avoid type errors with type guards
    // TODO: Improve type guards to avoid casting
    const node = (0, $irOoi.useFragment)((0, $f2155b61e0619eb7$export$2e2bcd8739ae039), fragmentRef);
    const logException = (0, $f8oYd.useLogException)();
    // Try/catch because AnyAri.parse throws on malformed ARIs
    try {
        if (!node) throw new Error('ResultRecord: node is undefined');
        if ((0, $38a1e03191a959a6$export$4619f000f23ee8d1)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $38a1e03191a959a6$export$f3b885cf8bfefc5f), {
            ...props,
            node: node
        });
        if ((0, $328ff6efa3a7a420$export$c89c057fd480d10c)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $328ff6efa3a7a420$export$1e8aa22a53a15ada), {
            ...props,
            node: node,
            thirdPartyConfigs: thirdPartyConfigs,
            smartAnswersPortalRef: smartAnswersPortalRef
        });
        if ((0, $5b3efb581ea6b58d$export$e232933b3399051b)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5b3efb581ea6b58d$export$bd12cc2939091aab), {
            ...props,
            node: node
        });
        if ((0, $e69dcf232ee4a7ce$export$eb74eda5abb6ce2f)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $e69dcf232ee4a7ce$export$a77407ffacf1d445), {
            ...props,
            node: node
        });
        if ((0, $e4107ff9b0892e16$export$3ea06079dfb7d39c)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $e4107ff9b0892e16$export$e206de30029925c0), {
            ...props,
            node: node,
            compassTeamName: compassTeamName
        });
        if ((0, $31e547389e3910c7$export$79503cf2fe431c3a)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $31e547389e3910c7$export$14e63e5586bfae9b), {
            ...props,
            node: node,
            shouldRenderTableResult: isLiteMode
        });
        if ((0, $73404969990abf67$export$b9491ee18011db60)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $73404969990abf67$export$26ac3e97753acb0e), {
            ...props,
            node: node,
            jiraIssueStatus: jiraIssueStatus,
            jiraLinkedPRs: jiraLinkedPRs,
            shouldRenderTableResult: isLiteMode
        });
        if ((0, $480180c1ff14c088$export$6566c83063a7eefb)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $480180c1ff14c088$export$24f204fc253b9cb5), {
            ...props,
            node: node
        });
        if ((0, $ef85b0f97f42606b$export$1ac32d77bb207897)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $ef85b0f97f42606b$export$4d44dfc3b1a588bc), {
            ...props,
            node: node
        });
        if ((0, $4fc71968c4272f25$export$f78f5f7633f09cb5)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $4fc71968c4272f25$export$7c35d70259168995), {
            ...props,
            node: node
        });
        if ((0, $87cf4eaba3a575c0$export$8fd9ffc22de770d9)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $87cf4eaba3a575c0$export$a5c532a12af1d7c8), {
            ...props,
            node: node
        });
        if ((0, $b22a5a74dc96194e$export$4a9584fe41dfb37d)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $b22a5a74dc96194e$export$6e8065b29de68b35), {
            ...props,
            node: node
        });
        if ((0, $1f5c3a9997a89a12$export$9bcd0683f048ca39)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1f5c3a9997a89a12$export$462e5965a804bcf5), {
            ...props,
            node: node
        });
        if ((0, $aa67e67612c8c517$export$25e56f07edb2e8ac)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $aa67e67612c8c517$export$e299cc210f856d0f), {
            ...props,
            node: node
        });
        if ((0, $e1e365f93a6cb640$export$29b4f3dd85087f82)(node) && (0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $e1e365f93a6cb640$export$c92f93b41e432091), {
            ...props,
            node: node
        });
        if ((0, $64821cc7b4fbd082$export$59a100e12914442b)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $64821cc7b4fbd082$export$b3f67b85a605a606), {
            ...props,
            node: node,
            thirdPartyConfigs: thirdPartyConfigs
        });
        if ((0, $b28fdd1f3658a84e$export$7b84b51bda14a6a0)(node) && (0, $dh538.fg)('assets_rovo_search_all')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $b28fdd1f3658a84e$export$33645cba5cb4e74d), {
            ...props,
            node: node
        });
        if ((0, $3910a17689cc33ca$export$510b7ec52c081a20)(node) && (0, $dh538.fg)('assets_rovo_search_all')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3910a17689cc33ca$export$9f67e5fd0627a72b), {
            ...props,
            node: node
        });
        if ((0, $def5c503597c8977$export$4cdaf9794367deaa)(node) && (0, $dh538.fg)('assets_rovo_search_all')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $def5c503597c8977$export$7afb78c1a6844ab6), {
            ...props,
            node: node
        });
        if ((0, $7703ce592a2f6397$export$6961f06bc751194b)(node) && (0, $dh538.fg)('talent_global_search')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $7703ce592a2f6397$export$a4810646942f13a2), {
            ...props,
            node: node
        });
        if (node.id && (0, $9b59a3205d194c41$export$48471e9a17c64a92)(node)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $9b59a3205d194c41$export$e84f7c0bef931609), {
            ...props,
            node: node,
            thirdPartyConfigs: thirdPartyConfigs,
            pastMeetingOccurrences: pastMeetingOccurrences
        });
        throw new Error(`SearchResultRenderer: unsupported node typename=${node['__typename']}`);
    } catch (e) {
        logException(e);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $d75f7c12f192fdc3$export$7397c326dc16df01), {
            ...props,
            node: node
        });
    }
};


const $bdefbb7f72d12f38$export$b9f6f9f70138c961 = 4;
const $bdefbb7f72d12f38$var$LEAP_QUERY_BANNER_POSITION = 5;
const $bdefbb7f72d12f38$var$THIRD_PARTY_QUERY_SUGGESTION_POSITION = 5;
const $bdefbb7f72d12f38$export$a2def421b23768aa = ({ node: node, position: position, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, cloudId: cloudId, searchQuery: searchQuery, originalQuery: originalQuery, selectedProduct: selectedProduct, searchSessionId: searchSessionId, primaryProduct: primaryProduct, appMode: appMode, logError: logError, compassTeamName: compassTeamName, jiraIssueStatus: jiraIssueStatus, jiraLinkedPRs: jiraLinkedPRs, pastMeetingOccurrences: pastMeetingOccurrences, is3pGroupingEnabled: is3pGroupingEnabled, smartAnswersPortalRef: smartAnswersPortalRef, mainContentWidth: mainContentWidth, isLiteMode: isLiteMode })=>{
    const data = (0, $irOoi.useFragment)((0, $1cc2f6a902ce7bda$export$2e2bcd8739ae039), node);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const [areThirdPartyQuerySuggestionsVisible, setAreThirdPartyQuerySuggestionsVisible] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            position === $bdefbb7f72d12f38$export$b9f6f9f70138c961 && /*#__PURE__*/ (0, $l998X.jsx)((0, $14f5a0c0b568e7eb$export$df17046610238203), {
                thirdPartyConfigs: thirdPartyConfigs,
                selectedProduct: selectedProduct,
                availableProducts: availableProducts
            }),
            position === $bdefbb7f72d12f38$var$LEAP_QUERY_BANNER_POSITION && (0, $f97ce1f1c5afcd2b$export$383dd888028aa640)(appMode, isAdminHubAIEnabled, isRovoLLMEnabled) && !areThirdPartyQuerySuggestionsVisible && /*#__PURE__*/ (0, $l998X.jsx)((0, $c87f95dd2abf5b51$export$9b91afdfe0a13e1a), {
                searchQuery: searchQuery,
                originalQuery: originalQuery,
                primaryProduct: primaryProduct,
                logError: logError
            }),
            position === $bdefbb7f72d12f38$var$THIRD_PARTY_QUERY_SUGGESTION_POSITION && !selectedProduct && /*#__PURE__*/ (0, $l998X.jsx)((0, $2e58397ebab3e6f0$export$da834437f2e70a90), {
                thirdPartyConfigs: thirdPartyConfigs,
                useIsUserOAuthed: (0, $gGFxq.useIsUserOAuthed),
                useSearchActions: (0, $djVCD.useSearchActions),
                useAnalytics: (0, $3CshZ.useAnalytics),
                currentQuery: searchQuery,
                onVisible: ()=>setAreThirdPartyQuerySuggestionsVisible(true)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                section: "SearchPageResultRecord",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d5fc325798e6b51f$export$705600d20983658a), {
                    node: data,
                    position: position,
                    cloudId: cloudId,
                    searchQuery: searchQuery,
                    searchSessionId: searchSessionId,
                    appMode: appMode,
                    primaryProduct: primaryProduct,
                    selectedProduct: selectedProduct,
                    thirdPartyConfigs: thirdPartyConfigs,
                    compassTeamName: compassTeamName,
                    jiraIssueStatus: jiraIssueStatus,
                    jiraLinkedPRs: jiraLinkedPRs,
                    pastMeetingOccurrences: pastMeetingOccurrences,
                    is3pGroupingEnabled: is3pGroupingEnabled,
                    smartAnswersPortalRef: smartAnswersPortalRef,
                    mainContentWidth: mainContentWidth,
                    isLiteMode: isLiteMode
                }, data.id)
            })
        ]
    });
};





parcelRequire("42omo");










parcelRequire("42omo");








var $032e51db6ad284d6$exports = {};
$032e51db6ad284d6$exports = new URL("no-results-dark.a00ae47b.svg", import.meta.url).toString();


var $948ce8c27c9b9ce5$exports = {};
$948ce8c27c9b9ce5$exports = new URL("no-results-light.5ca83755.svg", import.meta.url).toString();





const $bdbc32362c41e292$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    noResultsPrimary: {
        id: "no_results_primary",
        defaultMessage: "We couldn't find anything matching your search"
    },
    noResultsSecondary: {
        id: "no_results_secondary_no_filters",
        defaultMessage: "Try again with a different term."
    },
    noResultsSecondaryFilters: {
        id: "no_results_secondary_some_filters_applied",
        defaultMessage: "Looks like you have some filters applied. You could try clearing them."
    },
    noResultsClearFilters: {
        id: "no_results_clear_filters",
        defaultMessage: "Clear filters"
    },
    noResultsContentCleared: {
        id: "no_results_content_cleared_by_space_change",
        defaultMessage: "No results - the selected folder may have been moved or deleted."
    },
    noResultsSearchAllDrives: {
        id: "no_results_search_all_drives",
        defaultMessage: "Search all Drives"
    },
    noResultsSearchAllSites: {
        id: "no_results_search_all_sites",
        defaultMessage: "Search all Sites"
    }
});


const $88900765e2dbc6d9$export$f8a5875a19110e65 = ({ filtersEnabled: filtersEnabled, clearFilters: clearFilters })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $330959ad09458c13$export$d9172702747fb4bc), {
        imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($948ce8c27c9b9ce5$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($032e51db6ad284d6$exports))),
        primaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsPrimary
        }),
        secondaryText: filtersEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsSecondaryFilters
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsSecondary
        }),
        callToAction: filtersEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            appearance: "primary",
            onClick: clearFilters,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsClearFilters
            })
        }) : undefined
    });
};
























const $02eb09c3dde81993$export$caaa66025df736a1 = ({ selectedProduct: selectedProduct, clearSpaceFilter: clearSpaceFilter, clearFilters: clearFilters })=>{
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    // Default to Google Drive message if product is undefined
    const searchAllSpacesMessage = selectedProduct === (0, $1yEFx.ProductKeys).Sharepoint ? (0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsSearchAllSites : (0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsSearchAllDrives;
    const handleClearSpaceFilter = async ()=>{
        setIsSubmitting(true);
        try {
            await clearSpaceFilter();
        } catch  {
        // no-op: allow callers to reject without crashing the UI
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleClearFilters = async ()=>{
        setIsSubmitting(true);
        try {
            await clearFilters();
        } catch  {
        // no-op: allow callers to reject without crashing the UI
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $330959ad09458c13$export$d9172702747fb4bc), {
        imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($948ce8c27c9b9ce5$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($032e51db6ad284d6$exports))),
        primaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsPrimary
        }),
        secondaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsContentCleared
        }),
        callToAction: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    appearance: "default",
                    onClick: handleClearSpaceFilter,
                    isDisabled: isSubmitting,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...searchAllSpacesMessage
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    appearance: "primary",
                    onClick: handleClearFilters,
                    isDisabled: isSubmitting,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $bdbc32362c41e292$export$defe85febe8b728c).noResultsClearFilters
                    })
                })
            ]
        })
    });
};



















const $26867d7ca0c8f2ad$export$edb9b52ab3f1abbb = (ref)=>{
    const observerRef = (0, $42omo.useRef)(null);
    const [isOnScreen, setIsOnScreen] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!observerRef.current) observerRef.current = new IntersectionObserver(([entry])=>{
            setIsOnScreen(entry.isIntersecting);
        });
        const element = ref.current;
        if (element && observerRef.current) observerRef.current.observe(element);
        return ()=>{
            if (observerRef.current && element) observerRef.current.unobserve(element);
        };
    }, [
        ref
    ]);
    // Cleanup observer on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (observerRef.current) observerRef.current.disconnect();
        };
    }, []);
    return isOnScreen;
};


/**
 * In relay we re-render this pagination footer too fast, such that we end up paginating twice if the viewport remains at the bottom of the scroll height during the n+1 fetch!
 * This is because this component re-renders with the new paginationCursor/isLoading=false props from the fetch query, but before it has been pushed off the screen by the other results rendering.
 * We use an `isPaginatingRef` flag to prevent duplicate pagination requests by tracking when a pagination is already in progress.
 * The flag is set when pagination starts and reset when loading completes, ensuring only one pagination request at a time.
 */ const $3d6c58437980e8c0$var$hiddenBoxStyles = (0, $ecnYn.xcss)({
    display: 'none'
});
const $3d6c58437980e8c0$var$ResultsPaginationFooter = ({ cursor: currentCursor, fetchNextPage: fetchNextPage, isLoading: isLoading })=>{
    const paginationRef = (0, $42omo.useRef)(null);
    const isOnScreen = (0, $26867d7ca0c8f2ad$export$edb9b52ab3f1abbb)(paginationRef);
    const [lastCursor, setLastCursor] = (0, $42omo.useState)(null);
    const isPaginatingRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        // Start pagination if conditions are met and not already paginating
        if (isOnScreen && currentCursor && currentCursor !== lastCursor && !isPaginatingRef.current) {
            isPaginatingRef.current = true;
            setLastCursor(currentCursor);
            fetchNextPage(currentCursor);
        }
    }, [
        isOnScreen,
        currentCursor,
        lastCursor,
        fetchNextPage
    ]);
    // Separate effect to reset pagination flag when loading completes
    (0, $42omo.useEffect)(()=>{
        if (!isLoading) isPaginatingRef.current = false;
    }, [
        isLoading
    ]);
    // Reset lastCursor when currentCursor becomes null to ensure proper state reset
    (0, $42omo.useEffect)(()=>{
        if (!currentCursor) {
            setLastCursor(null);
            isPaginatingRef.current = false;
        }
    }, [
        currentCursor
    ]);
    // If there is no cursor, we can't paginate - render invisible element to maintain hook state
    if (!currentCursor) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        ref: paginationRef,
        xcss: $3d6c58437980e8c0$var$hiddenBoxStyles,
        testId: "search-page-pagination-footer-hidden"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        ref: paginationRef,
        testId: "search-page-pagination-footer",
        children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1hlFx.SearchResultSkeleton), {}) : null
    });
};
var $3d6c58437980e8c0$export$2e2bcd8739ae039 = $3d6c58437980e8c0$var$ResultsPaginationFooter;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















const $280ef4355050ad69$var$styles = {
    resultsListGridArea: "_nd5l1b0a _zulp1ejb _1e0c1txw _2lx21bp4",
    noMoreResults: "_otyrxy5q"
};
const $280ef4355050ad69$export$92697b2a267ec7ef = ({ children: children, containsSearchResults: containsSearchResults })=>{
    (0, $42omo.useEffect)(()=>{
        if (containsSearchResults) {
            (0, $2OtFZ.triggerExposureForEngagementTrackingImprovementsExperiment)();
            (0, $dh538.fg)('add-middle-click-event-fanout-results');
        }
    }, [
        containsSearchResults
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($280ef4355050ad69$var$styles.resultsListGridArea, $280ef4355050ad69$var$styles.noMoreResults),
        testId: "search-page-results-list",
        ...containsSearchResults && {
            role: 'list'
        },
        children: children
    });
};



const $fe707538f71ff5eb$export$d0848c15dbb5ad38 = ({ containsSearchResults: containsSearchResults, edgesToDisplay: edgesToDisplay, cloudId: cloudId, appMode: appMode, searchQuery: searchQuery, thirdPartyConfigs: thirdPartyConfigs, selectedProduct: selectedProduct, primaryProduct: primaryProduct, searchSessionId: searchSessionId, originalQuery: originalQuery, availableProducts: availableProducts, logError: logError, teamNames: teamNames, issueStatuses: issueStatuses, linkedPRs: linkedPRs, pastMeetingOccurrences: pastMeetingOccurrences, is3pGroupingEnabled: is3pGroupingEnabled, smartAnswersPortalRef: smartAnswersPortalRef, mainContentWidth: mainContentWidth, wasContentClearedBySpaceChange: wasContentClearedBySpaceChange, clearSpaceFilter: clearSpaceFilter, clearFilters: clearFilters, getSelectedFilters: getSelectedFilters, cursor: cursor, isLoadingNext: isLoadingNext, fetchNextPage: fetchNextPage })=>{
    const list = /*#__PURE__*/ (0, $l998X.jsxs)((0, $280ef4355050ad69$export$92697b2a267ec7ef), {
        containsSearchResults: containsSearchResults,
        children: [
            containsSearchResults ? edgesToDisplay.map((edge, position)=>edge?.node && /*#__PURE__*/ (0, $l998X.jsx)((0, $bdefbb7f72d12f38$export$a2def421b23768aa), {
                    node: edge.node,
                    position: position,
                    cloudId: cloudId,
                    appMode: appMode,
                    searchQuery: searchQuery,
                    thirdPartyConfigs: thirdPartyConfigs,
                    selectedProduct: selectedProduct,
                    primaryProduct: primaryProduct,
                    searchSessionId: searchSessionId,
                    originalQuery: originalQuery,
                    availableProducts: availableProducts,
                    logError: logError,
                    compassTeamName: teamNames[edge.node.id],
                    jiraIssueStatus: issueStatuses[edge.node.id],
                    jiraLinkedPRs: linkedPRs[edge.node.id],
                    pastMeetingOccurrences: pastMeetingOccurrences?.[edge.node.id],
                    is3pGroupingEnabled: is3pGroupingEnabled,
                    smartAnswersPortalRef: smartAnswersPortalRef,
                    mainContentWidth: mainContentWidth
                }, edge.node.id)) : wasContentClearedBySpaceChange ? /*#__PURE__*/ (0, $l998X.jsx)((0, $02eb09c3dde81993$export$caaa66025df736a1), {
                selectedProduct: selectedProduct,
                clearSpaceFilter: clearSpaceFilter,
                clearFilters: clearFilters
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $88900765e2dbc6d9$export$f8a5875a19110e65), {
                filtersEnabled: !!selectedProduct || getSelectedFilters().hasFiltersSelected,
                clearFilters: clearFilters
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3d6c58437980e8c0$export$2e2bcd8739ae039), {
                cursor: cursor,
                isLoading: isLoadingNext,
                fetchNextPage: fetchNextPage
            })
        ]
    });
    if ((0, $dh538.fg)('rovo_search_results_granular_ufo_segments')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-results-list-default",
        children: list
    });
    return list;
};


/* search-results-lite-issue-table.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");










const $60ab5c20a2abb319$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    workColumnHeader: {
        id: "search_results_lite_issue_table_header_work",
        defaultMessage: "Work"
    },
    statusColumnHeader: {
        id: "search_results_lite_issue_table_header_status",
        defaultMessage: "Status"
    },
    assigneeColumnHeader: {
        id: "search_results_lite_issue_table_header_assignee",
        defaultMessage: "Assignee"
    },
    labelsColumnHeader: {
        id: "search_results_lite_issue_table_header_labels",
        defaultMessage: "Labels"
    },
    priorityColumnHeader: {
        id: "search_results_lite_issue_table_header_priority",
        defaultMessage: "Priority"
    },
    spacesColumnHeader: {
        id: "search_results_lite_project_table_header_spaces",
        defaultMessage: "Spaces"
    },
    keyColumnHeader: {
        id: "search_results_lite_project_table_header_key",
        defaultMessage: "Key"
    },
    typeColumnHeader: {
        id: "search_results_lite_project_table_header_type",
        defaultMessage: "Type"
    },
    leadColumnHeader: {
        id: "search_results_lite_project_table_header_lead",
        defaultMessage: "Lead"
    },
    categoryColumnHeader: {
        id: "search_results_lite_project_table_header_category",
        defaultMessage: "Category"
    },
    spaceUrlColumnHeader: {
        id: "search_results_lite_project_table_header_spaceUrl",
        defaultMessage: "Space URL"
    }
});


const $07e7e7c2bc9fd0bb$var$styles = {
    tableWrapper: "_2rko12b0 _1dqonqa1 _1h6d1l7x _189ee4h9 _vchhusvi _1bsb1osq _1o9zidpf _1e0c1txw _2lx21bp4",
    tableWrapperFullHeight: "_c71l1vmz",
    tableWrapperRestrictedHeight: "_c71l12it",
    tableScrollWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug _1tkeidpf _1fjgglyw _4pckglyw _da911j28 _1l08glyw _hq8gglyw _155a1rr0 _aayn1aqn _pomm1j28 _1cicglyw _bman1ule _6erti2wt _1o2li2wt _dzilurpi",
    table: "_189eidpf _1e0c5mfb _1kqm1n9t _1bsb1osq _4t3i1osq _yq5hus1c _btyzidpf",
    thead: "_1e0czh62 _kqsw1if8 _154iidpf _1pbykb7n _1doce4h9 _1il9nqa1 _1o3i1l7x",
    headerRow: "_1e0c2e77 _4t3i1ylp _bfhkhfxm _1furu2gc _cnreidpf _16do12b0 _vjvku2gc _bwpuidpf _1f2z12b0",
    thWork: "_1e0cdav6 _s7n4nkob _y3gn1e5h _o5721q9c _1dl7dlvw _1i0l1kdj _oosly1l4",
    thStatus: "_1dl71n5l _1i0l1ame",
    thAssignee: "_1dl710bg _1i0l1rr2",
    thReporter: "_1dl77iqz _1i0l17n1",
    thLabels: "_1dl75r1t _1i0l1h05",
    thPriority: "_1dl7mfg7 _1i0l1nb2 _oosledzb",
    thBase: "_11c8fhey _1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _1bto1l2s _o5721q9c _syaz1rpy _k48p1wq8 _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
    tbody: "_1e0c8xuz _1w0hidpf",
    footer: "_11c8fhey _1o9zidpf _vchhusvi _4t3i1ylp _1e0c1txw _4cvr1h6o _1bahesu3 _19bvutpp _u5f3utpp _syazazsu _bfhkvuon _uwhke4h9 _15a5nqa1 _1i531l7x _mrkb12b0 _1o0z12b0"
};
const $07e7e7c2bc9fd0bb$var$TableHeader = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)("thead", {
        className: (0, $gMc0m.default)([
            $07e7e7c2bc9fd0bb$var$styles.thead
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("tr", {
            className: (0, $gMc0m.default)([
                $07e7e7c2bc9fd0bb$var$styles.headerRow
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("th", {
                    className: (0, $gMc0m.default)([
                        $07e7e7c2bc9fd0bb$var$styles.thBase,
                        $07e7e7c2bc9fd0bb$var$styles.thWork
                    ]),
                    children: formatMessage((0, $60ab5c20a2abb319$export$defe85febe8b728c).workColumnHeader)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("th", {
                    className: (0, $gMc0m.default)([
                        $07e7e7c2bc9fd0bb$var$styles.thBase,
                        $07e7e7c2bc9fd0bb$var$styles.thStatus
                    ]),
                    children: formatMessage((0, $60ab5c20a2abb319$export$defe85febe8b728c).statusColumnHeader)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("th", {
                    className: (0, $gMc0m.default)([
                        $07e7e7c2bc9fd0bb$var$styles.thBase,
                        $07e7e7c2bc9fd0bb$var$styles.thAssignee
                    ]),
                    children: formatMessage((0, $60ab5c20a2abb319$export$defe85febe8b728c).assigneeColumnHeader)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("th", {
                    className: (0, $gMc0m.default)([
                        $07e7e7c2bc9fd0bb$var$styles.thBase,
                        $07e7e7c2bc9fd0bb$var$styles.thLabels
                    ]),
                    children: formatMessage((0, $60ab5c20a2abb319$export$defe85febe8b728c).labelsColumnHeader)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("th", {
                    className: (0, $gMc0m.default)([
                        $07e7e7c2bc9fd0bb$var$styles.thBase,
                        $07e7e7c2bc9fd0bb$var$styles.thPriority
                    ]),
                    children: formatMessage((0, $60ab5c20a2abb319$export$defe85febe8b728c).priorityColumnHeader)
                })
            ]
        })
    });
};
const $07e7e7c2bc9fd0bb$var$TableFooter = ({ shown: shown, total: total })=>{
    // "25 of 50", or "50 of 50+" in the case that we received more results than we can show the user
    const totalLabel = total > shown ? `${total.toLocaleString()}+` : total.toLocaleString();
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            $07e7e7c2bc9fd0bb$var$styles.footer
        ]),
        children: [
            shown,
            " of ",
            totalLabel
        ]
    });
};
const $07e7e7c2bc9fd0bb$export$3c6d00b8713f507e = ({ children: children, shownCount: shownCount, totalCount: totalCount, isOnlyTableShown: isOnlyTableShown })=>/*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            $07e7e7c2bc9fd0bb$var$styles.tableWrapper,
            isOnlyTableShown ? $07e7e7c2bc9fd0bb$var$styles.tableWrapperFullHeight : $07e7e7c2bc9fd0bb$var$styles.tableWrapperRestrictedHeight
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $07e7e7c2bc9fd0bb$var$styles.tableScrollWrapper
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)("table", {
                    "data-testid": "search-results-lite-issue-table",
                    className: (0, $gMc0m.default)([
                        $07e7e7c2bc9fd0bb$var$styles.table
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)($07e7e7c2bc9fd0bb$var$TableHeader, {}),
                        /*#__PURE__*/ (0, $l998X.jsx)("tbody", {
                            className: (0, $gMc0m.default)([
                                $07e7e7c2bc9fd0bb$var$styles.tbody
                            ]),
                            children: children
                        })
                    ]
                })
            }),
            shownCount > 1 && /*#__PURE__*/ (0, $l998X.jsx)($07e7e7c2bc9fd0bb$var$TableFooter, {
                shown: shownCount,
                total: totalCount
            })
        ]
    });


/* search-results-lite-project-table.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








const $e37d2a766b7ab4a4$var$styles = {
    tableWrapper: "_2rko12b0 _1dqonqa1 _1h6d1l7x _189ee4h9 _vchhusvi _1bsb1osq _1o9zidpf _1e0c1txw _2lx21bp4",
    tableWrapperFullHeight: "_c71l1vmz",
    tableWrapperRestrictedHeight: "_c71l12it",
    tableScrollWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug _1tkeidpf _1fjgglyw _4pckglyw _da911j28 _1l08glyw _hq8gglyw _155a1rr0 _aayn1aqn _pomm1j28 _1cicglyw _bman1ule _6erti2wt _1o2li2wt _dzilurpi",
    table: "_189eidpf _1e0c5mfb _1kqm1n9t _1bsb1osq _4t3i1osq _yq5hus1c _btyzidpf",
    thead: "_1e0czh62 _kqsw1if8 _154iidpf _1pbykb7n _1doce4h9 _1il9nqa1 _1o3i1l7x",
    headerRow: "_1e0c2e77 _4t3i1ylp _bfhkhfxm _1furu2gc _cnreidpf _16do12b0 _vjvku2gc _bwpuidpf _1f2z12b0",
    thSpace: "_1e0cdav6 _s7n4nkob _y3gn1e5h _o5721q9c _1dl7dlvw _1i0l18rv _ooslg8x7",
    thKey: "_1dl7ys9h",
    thType: "_1dl711ux _1i0lmgvx",
    thLead: "_1dl768cl _1o3j11ux _1i0l1tkr",
    thCategory: "_1dl7ys9h _1i0l7iqz",
    thSpaceUrl: "_1dl7ys9h _1i0l1obz",
    thBase: "_11c8fhey _1dqonqa1 _1h6d1l7x _1e0cdav6 _vchhusvi _s7n4nkob _ca0qu2gc _n3tdu2gc _19bvu2gc _u5f3u2gc _1reo15vq _1bto1l2s _o5721q9c _syaz1rpy _k48p1wq8 _hr4je4h9 _1doce4h9 _uwhkidpf _t6vdidpf",
    tbody: "_1e0c8xuz _1w0hidpf",
    footer: "_11c8fhey _1o9zidpf _vchhusvi _4t3i1ylp _1e0c1txw _4cvr1h6o _1bahesu3 _19bvutpp _u5f3utpp _syazazsu _bfhkvuon _uwhke4h9 _15a5nqa1 _1i531l7x _mrkb12b0 _1o0z12b0"
};
const $e37d2a766b7ab4a4$var$TableHeader = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)("thead", {
        className: (0, $gMc0m.default)([
            $e37d2a766b7ab4a4$var$styles.thead
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("tr", {
            className: (0, $gMc0m.default)([
                $e37d2a766b7ab4a4$var$styles.headerRow
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("th", {
                    className: (0, $gMc0m.default)([
                        $e37d2a766b7ab4a4$var$styles.thBase,
                        $e37d2a766b7ab4a4$var$styles.thSpace
                    ]),
                    children: formatMessage((0, $60ab5c20a2abb319$export$defe85febe8b728c).spacesColumnHeader)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("th", {
                    className: (0, $gMc0m.default)([
                        $e37d2a766b7ab4a4$var$styles.thBase,
                        $e37d2a766b7ab4a4$var$styles.thKey
                    ]),
                    children: formatMessage((0, $60ab5c20a2abb319$export$defe85febe8b728c).keyColumnHeader)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("th", {
                    className: (0, $gMc0m.default)([
                        $e37d2a766b7ab4a4$var$styles.thBase,
                        $e37d2a766b7ab4a4$var$styles.thType
                    ]),
                    children: formatMessage((0, $60ab5c20a2abb319$export$defe85febe8b728c).typeColumnHeader)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("th", {
                    className: (0, $gMc0m.default)([
                        $e37d2a766b7ab4a4$var$styles.thBase,
                        $e37d2a766b7ab4a4$var$styles.thLead
                    ]),
                    children: formatMessage((0, $60ab5c20a2abb319$export$defe85febe8b728c).leadColumnHeader)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("th", {
                    className: (0, $gMc0m.default)([
                        $e37d2a766b7ab4a4$var$styles.thBase,
                        $e37d2a766b7ab4a4$var$styles.thCategory
                    ]),
                    children: formatMessage((0, $60ab5c20a2abb319$export$defe85febe8b728c).categoryColumnHeader)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("th", {
                    className: (0, $gMc0m.default)([
                        $e37d2a766b7ab4a4$var$styles.thBase,
                        $e37d2a766b7ab4a4$var$styles.thSpaceUrl
                    ]),
                    children: formatMessage((0, $60ab5c20a2abb319$export$defe85febe8b728c).spaceUrlColumnHeader)
                })
            ]
        })
    });
};
const $e37d2a766b7ab4a4$var$TableFooter = ({ shown: shown, total: total })=>{
    // "25 of 50", or "50 of 50+" in the case that we received more results than we can show the user
    const totalLabel = total > shown ? `${total.toLocaleString()}+` : total.toLocaleString();
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            $e37d2a766b7ab4a4$var$styles.footer
        ]),
        children: [
            shown,
            " of ",
            totalLabel
        ]
    });
};
const $e37d2a766b7ab4a4$export$3b6669b151d0f0ad = ({ children: children, shownCount: shownCount, totalCount: totalCount, isOnlyTableShown: isOnlyTableShown })=>/*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            $e37d2a766b7ab4a4$var$styles.tableWrapper,
            isOnlyTableShown ? $e37d2a766b7ab4a4$var$styles.tableWrapperFullHeight : $e37d2a766b7ab4a4$var$styles.tableWrapperRestrictedHeight
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $e37d2a766b7ab4a4$var$styles.tableScrollWrapper
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)("table", {
                    "data-testid": "search-results-lite-project-table",
                    className: (0, $gMc0m.default)([
                        $e37d2a766b7ab4a4$var$styles.table
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)($e37d2a766b7ab4a4$var$TableHeader, {}),
                        /*#__PURE__*/ (0, $l998X.jsx)("tbody", {
                            className: (0, $gMc0m.default)([
                                $e37d2a766b7ab4a4$var$styles.tbody
                            ]),
                            children: children
                        })
                    ]
                })
            }),
            shownCount > 1 && /*#__PURE__*/ (0, $l998X.jsx)($e37d2a766b7ab4a4$var$TableFooter, {
                shown: shownCount,
                total: totalCount
            })
        ]
    });


const $7d9c1f9bccecc564$var$styles = {
    liteResultsWrapper: "_zulp1ejb _1e0c1txw _2lx21bp4 _4t3iwe6u _1bsb1osq",
    invisibleBottomPadding: "_1o9zidpf _1e0c1ule _4t3it94y _1bsbt94y"
};
const $7d9c1f9bccecc564$var$JIRA_ISSUE_TYPENAME = 'SearchResultJiraIssue';
const $7d9c1f9bccecc564$var$JIRA_PROJECT_TYPENAME = 'SearchResultJiraProject';
const $7d9c1f9bccecc564$var$MAX_ROWS = 50;
const $7d9c1f9bccecc564$export$ad54ced6ff7118e5 = ({ containsSearchResults: containsSearchResults, selectedProduct: selectedProduct, edgesToDisplay: edgesToDisplay, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, originalQuery: originalQuery, logError: logError, is3pGroupingEnabled: is3pGroupingEnabled, smartAnswersPortalRef: smartAnswersPortalRef, mainContentWidth: mainContentWidth, cloudId: cloudId, appMode: appMode, searchQuery: searchQuery, primaryProduct: primaryProduct, searchSessionId: searchSessionId, linkedPRs: linkedPRs, pastMeetingOccurrences: pastMeetingOccurrences, teamNames: teamNames, issueStatuses: issueStatuses, wasContentClearedBySpaceChange: wasContentClearedBySpaceChange, clearFilters: clearFilters, clearSpaceFilter: clearSpaceFilter, fetchNextPage: fetchNextPage, cursor: cursor, isLoadingNext: isLoadingNext, getSelectedFilters: getSelectedFilters })=>{
    const jiraIssues = (0, $42omo.useMemo)(()=>edgesToDisplay.filter((edge)=>edge?.node?.__typename === $7d9c1f9bccecc564$var$JIRA_ISSUE_TYPENAME), [
        edgesToDisplay
    ]);
    const jiraIssuesPruned = jiraIssues.slice(0, $7d9c1f9bccecc564$var$MAX_ROWS);
    const jiraProjectsOrSpaces = (0, $42omo.useMemo)(()=>edgesToDisplay.filter((edge)=>edge?.node?.__typename === $7d9c1f9bccecc564$var$JIRA_PROJECT_TYPENAME), [
        edgesToDisplay
    ]);
    const jiraProjectsOrSpacesPruned = jiraProjectsOrSpaces.slice(0, $7d9c1f9bccecc564$var$MAX_ROWS); // Edges that are neither Jira issues nor Jira projects/spaces (e.g. boards,
    // filters, dashboards, plans). The lite tables only render issues and
    // projects, so any other Jira nouns must fall back to the default renderer
    // underneath the tables. Order is preserved relative to the original
    // `edgesToDisplay` because the filter is a single pass over that array.
    const otherJiraEdges = (0, $42omo.useMemo)(()=>edgesToDisplay.filter((edge)=>edge?.node?.__typename !== $7d9c1f9bccecc564$var$JIRA_ISSUE_TYPENAME && edge?.node?.__typename !== $7d9c1f9bccecc564$var$JIRA_PROJECT_TYPENAME), [
        edgesToDisplay
    ]);
    const hasJiraIssues = !!jiraIssues.length;
    const hasJiraProjectsOrSpaces = !!jiraProjectsOrSpaces.length;
    const hasOtherJiraEdges = !!otherJiraEdges.length; // Determine if we should render the new "lite" search results experience based on the following:
    //   1. the experiment is enabled (already verified by the parent component /search-results/search-results.tsx)
    // 	 2. a Jira product should be selected in the app filter
    //   3. there are results to show
    //   4. the results contain either Jira issues, projects, or spaces
    //
    // If a Jira product is selected and the response contains ONLY non-issue/non-project
    // nouns (e.g. only boards), we fall back to the default renderer for the whole page
    // so the user still sees their results instead of an empty lite shell.
    const shouldRenderLiteList = (0, $42omo.useMemo)(()=>{
        const jiraProductIsSelected = selectedProduct && (0, $22zVp.isJiraProduct)(selectedProduct, true);
        return jiraProductIsSelected && containsSearchResults && (hasJiraIssues || hasJiraProjectsOrSpaces);
    }, [
        containsSearchResults,
        selectedProduct,
        hasJiraIssues,
        hasJiraProjectsOrSpaces
    ]);
    const list = shouldRenderLiteList ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $7d9c1f9bccecc564$var$styles.liteResultsWrapper,
        children: [
            hasJiraIssues && /*#__PURE__*/ (0, $l998X.jsx)((0, $07e7e7c2bc9fd0bb$export$3c6d00b8713f507e), {
                shownCount: jiraIssuesPruned.length,
                totalCount: jiraIssues.length,
                isOnlyTableShown: hasJiraIssues && !hasJiraProjectsOrSpaces,
                children: jiraIssuesPruned.map((edge, position)=>edge?.node && /*#__PURE__*/ (0, $l998X.jsx)((0, $bdefbb7f72d12f38$export$a2def421b23768aa), {
                        node: edge.node,
                        position: position,
                        cloudId: cloudId,
                        appMode: appMode,
                        searchQuery: searchQuery,
                        thirdPartyConfigs: thirdPartyConfigs,
                        selectedProduct: selectedProduct,
                        primaryProduct: primaryProduct,
                        searchSessionId: searchSessionId,
                        originalQuery: originalQuery,
                        availableProducts: availableProducts,
                        logError: logError,
                        compassTeamName: teamNames[edge.node.id],
                        jiraIssueStatus: issueStatuses[edge.node.id],
                        jiraLinkedPRs: linkedPRs[edge.node.id],
                        pastMeetingOccurrences: pastMeetingOccurrences?.[edge.node.id],
                        is3pGroupingEnabled: is3pGroupingEnabled,
                        smartAnswersPortalRef: smartAnswersPortalRef,
                        mainContentWidth: mainContentWidth,
                        // inside this lite-list code path (a Jira product is selected
                        // and there are results), so the lite table row cannot leak
                        // onto the "All" tab via the default list renderer.
                        isLiteMode: true
                    }, edge.node.id))
            }),
            hasJiraProjectsOrSpaces && /*#__PURE__*/ (0, $l998X.jsx)((0, $e37d2a766b7ab4a4$export$3b6669b151d0f0ad), {
                shownCount: jiraProjectsOrSpacesPruned.length,
                totalCount: jiraProjectsOrSpaces.length,
                isOnlyTableShown: hasJiraProjectsOrSpaces && !hasJiraIssues,
                children: jiraProjectsOrSpacesPruned.map((edge, position)=>edge?.node && /*#__PURE__*/ (0, $l998X.jsx)((0, $bdefbb7f72d12f38$export$a2def421b23768aa), {
                        node: edge.node,
                        position: position,
                        cloudId: cloudId,
                        appMode: appMode,
                        searchQuery: searchQuery,
                        thirdPartyConfigs: thirdPartyConfigs,
                        selectedProduct: selectedProduct,
                        primaryProduct: primaryProduct,
                        searchSessionId: searchSessionId,
                        originalQuery: originalQuery,
                        availableProducts: availableProducts,
                        logError: logError,
                        compassTeamName: teamNames[edge.node.id],
                        jiraIssueStatus: issueStatuses[edge.node.id],
                        jiraLinkedPRs: linkedPRs[edge.node.id],
                        pastMeetingOccurrences: pastMeetingOccurrences?.[edge.node.id],
                        is3pGroupingEnabled: is3pGroupingEnabled,
                        smartAnswersPortalRef: smartAnswersPortalRef,
                        mainContentWidth: mainContentWidth,
                        // single source of truth for lite-mode rendering.
                        isLiteMode: true
                    }, edge.node.id))
            }),
            hasOtherJiraEdges && /*#__PURE__*/ (0, $l998X.jsx)((0, $fe707538f71ff5eb$export$d0848c15dbb5ad38), {
                containsSearchResults: containsSearchResults,
                edgesToDisplay: otherJiraEdges,
                cloudId: cloudId,
                appMode: appMode,
                searchQuery: searchQuery,
                thirdPartyConfigs: thirdPartyConfigs,
                selectedProduct: selectedProduct,
                primaryProduct: primaryProduct,
                searchSessionId: searchSessionId,
                originalQuery: originalQuery,
                availableProducts: availableProducts,
                logError: logError,
                teamNames: teamNames,
                issueStatuses: issueStatuses,
                linkedPRs: linkedPRs,
                is3pGroupingEnabled: is3pGroupingEnabled,
                smartAnswersPortalRef: smartAnswersPortalRef,
                mainContentWidth: mainContentWidth,
                wasContentClearedBySpaceChange: wasContentClearedBySpaceChange,
                clearSpaceFilter: clearSpaceFilter,
                clearFilters: clearFilters,
                getSelectedFilters: getSelectedFilters,
                cursor: cursor,
                isLoadingNext: isLoadingNext,
                fetchNextPage: fetchNextPage
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                "aria-hidden": "true",
                className: (0, $gMc0m.default)([
                    $7d9c1f9bccecc564$var$styles.invisibleBottomPadding
                ])
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fe707538f71ff5eb$export$d0848c15dbb5ad38), {
        containsSearchResults: containsSearchResults,
        edgesToDisplay: edgesToDisplay,
        cloudId: cloudId,
        appMode: appMode,
        searchQuery: searchQuery,
        thirdPartyConfigs: thirdPartyConfigs,
        selectedProduct: selectedProduct,
        primaryProduct: primaryProduct,
        searchSessionId: searchSessionId,
        originalQuery: originalQuery,
        availableProducts: availableProducts,
        logError: logError,
        teamNames: teamNames,
        issueStatuses: issueStatuses,
        linkedPRs: linkedPRs,
        pastMeetingOccurrences: pastMeetingOccurrences,
        is3pGroupingEnabled: is3pGroupingEnabled,
        smartAnswersPortalRef: smartAnswersPortalRef,
        mainContentWidth: mainContentWidth,
        wasContentClearedBySpaceChange: wasContentClearedBySpaceChange,
        clearSpaceFilter: clearSpaceFilter,
        clearFilters: clearFilters,
        getSelectedFilters: getSelectedFilters,
        cursor: cursor,
        isLoadingNext: isLoadingNext,
        fetchNextPage: fetchNextPage
    });
    if ((0, $dh538.fg)('rovo_search_results_granular_ufo_segments')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-results-list-lite",
        children: list
    });
    return list;
};














const $ea450f46c9ce72a3$var$FEDERATED_EMAIL_RESULT_PAGE_SIZE = 30;
function $ea450f46c9ce72a3$var$getFederatedEmailResultCount({ rawCount: rawCount, exactCount: exactCount, hasNextPage: hasNextPage, pageSize: pageSize = $ea450f46c9ce72a3$var$FEDERATED_EMAIL_RESULT_PAGE_SIZE }) {
    if (rawCount === 0 && exactCount === 0) return {
        count: null,
        hasMore: false
    };
    if (!hasNextPage) return {
        count: exactCount,
        hasMore: false
    };
    return {
        count: Math.ceil(rawCount / pageSize) * pageSize,
        hasMore: true
    };
}
const $ea450f46c9ce72a3$var$isFederatedEmailProduct = (productKey)=>productKey === (0, $b4tvS.ProductKeys3P).Gmail || productKey === (0, $b4tvS.ProductKeys3P).OutlookMail;
function $ea450f46c9ce72a3$export$7afdd26a4d2af5af({ selectedProduct: selectedProduct, rawResultsLength: rawResultsLength, resultsLength: resultsLength, pageInfo: pageInfo, isLoadingNext: isLoadingNext, setFederatedGmailCount: setFederatedGmailCount, setHasMoreGmailResults: setHasMoreGmailResults, setFederatedOutlookMailCount: setFederatedOutlookMailCount, setHasMoreOutlookMailResults: setHasMoreOutlookMailResults }) {
    (0, $42omo.useEffect)(()=>{
        const hasNextPage = pageInfo?.hasNextPage === true;
        if (!$ea450f46c9ce72a3$var$isFederatedEmailProduct(selectedProduct)) {
            setFederatedGmailCount?.(null);
            setHasMoreGmailResults?.(false);
            setFederatedOutlookMailCount?.(null);
            setHasMoreOutlookMailResults?.(false);
            return;
        }
        const isFederatedEmailCountEnabled = selectedProduct === (0, $b4tvS.ProductKeys3P).Gmail ? (0, $dh538.fg)('formula_3p_gmail_result_count') : (0, $dh538.fg)('formula_3p_outlook_result_count');
        const setSelectedProductCount = selectedProduct === (0, $b4tvS.ProductKeys3P).Gmail ? setFederatedGmailCount : setFederatedOutlookMailCount;
        const setSelectedProductHasMore = selectedProduct === (0, $b4tvS.ProductKeys3P).Gmail ? setHasMoreGmailResults : setHasMoreOutlookMailResults;
        if (!setSelectedProductCount) return;
        if (!isFederatedEmailCountEnabled) {
            if (selectedProduct === (0, $b4tvS.ProductKeys3P).Gmail) {
                setSelectedProductCount(null);
                setSelectedProductHasMore?.(false);
            }
            return;
        }
        const { count: count, hasMore: hasMore } = $ea450f46c9ce72a3$var$getFederatedEmailResultCount({
            rawCount: rawResultsLength,
            exactCount: resultsLength,
            hasNextPage: hasNextPage
        });
        setSelectedProductCount(count);
        setSelectedProductHasMore?.(hasMore);
    }, [
        isLoadingNext,
        pageInfo,
        rawResultsLength,
        resultsLength,
        selectedProduct,
        setFederatedGmailCount,
        setHasMoreGmailResults,
        setFederatedOutlookMailCount,
        setHasMoreOutlookMailResults
    ]);
}








const $d36edf17876c264b$var$canOptimiseResultsRendering = ()=>Boolean(window && window.requestIdleCallback);
const $d36edf17876c264b$export$e8402efe3c056aa3 = ({ bodyRef: bodyRef, edges: edges, maxResultsToShow: maxResultsToShow, setMaxResultsToShow: setMaxResultsToShow, queryReference: queryReference })=>{
    const edgesToDisplay = (0, $42omo.useMemo)(()=>{
        return $d36edf17876c264b$var$canOptimiseResultsRendering() && maxResultsToShow && maxResultsToShow < edges.length ? edges.slice(0, maxResultsToShow) : edges;
    }, [
        edges,
        maxResultsToShow
    ]);
    // We use a layout effect here to ensure the scroll event listener is bound
    // before the first paint of search results.
    (0, $42omo.useLayoutEffect)(()=>{
        if (!$d36edf17876c264b$var$canOptimiseResultsRendering()) return;
        if (!bodyRef?.current) return;
        // If the user tries to scroll the search results list, render all
        // results immediately
        const unbind = (0, $fFa3V.bind)(bodyRef.current, {
            type: 'scroll',
            listener: ()=>{
                setMaxResultsToShow(undefined);
            },
            options: {
                once: true
            }
        });
        // When the main thread is idle, render the rest of the results
        // eslint-disable-next-line no-restricted-globals -- canOptimiseResultsRendering checks if requestIdleCallback is available
        requestIdleCallback(()=>{
            unbind();
            setMaxResultsToShow(undefined);
        });
        return unbind;
    }, [
        bodyRef,
        setMaxResultsToShow,
        queryReference
    ]);
    return edgesToDisplay;
};























const $0f1906aa6a6024a0$export$4b73689f2f9f3dd3 = ({ queryState: queryState, numResults: numResults, shownCount: shownCount, are3pResultsShown: are3pResultsShown, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, searchAndResult: searchAndResult, resultsShown: resultsShown, socialSignalsAttributes: socialSignalsAttributes, requestedBackendExperiments: requestedBackendExperiments, referrer: referrer, isPaginatedQuery: isPaginatedQuery, isBulkConnectBannerShown: isBulkConnectBannerShown, productsWithTimeout: productsWithTimeout, intentDetectionTriggered: intentDetectionTriggered, queryClassification: queryClassification, modelId: modelId, cohort: cohort, patternType: patternType })=>{
    // Build connectorInfo array for unified 3P instrumentation
    // Only include entries for 3P results that have connectorInfo populated
    const connectorInfo = resultsShown.map((result)=>result.connectorInfo).filter((info)=>info !== undefined);
    return {
        eventType: 'track',
        action: 'shown',
        actionSubject: 'advancedSearchResults',
        attributes: {
            additionalAttributes: {
                queryState: queryState,
                numResults: numResults,
                numberOfResultsShown: shownCount,
                noResultsFetched: numResults === 0,
                numberOfDocs: numResults,
                are3pResultsShown: are3pResultsShown,
                searchAndResult: searchAndResult,
                resultsShown: resultsShown,
                // Add connectorInfo array for unified 3P instrumentation
                connectorInfo: connectorInfo.length > 0 ? connectorInfo : undefined,
                is3PFilter: commonAttributes.productSelected !== (0, $6yNqK.ALL_PRODUCTS_STRING) && (0, $fuGkE.is3pProductKeyForAnalytics)(commonAttributes.productSelected),
                isPaginatedQuery: isPaginatedQuery,
                isBulkConnectBannerShown: isBulkConnectBannerShown,
                referrer: referrer,
                ...socialSignalsAttributes,
                backendExperiments: {
                    experimentLayers: requestedBackendExperiments.backendExperiments?.experimentLayers?.map(({ analyticsDefinitions: analyticsDefinitions, ...layer })=>{
                        return {
                            ...layer,
                            definitions: analyticsDefinitions
                        };
                    })
                },
                productsWithTimeout: productsWithTimeout,
                ...intentDetectionTriggered !== undefined ? {
                    intentDetectionTriggered: intentDetectionTriggered
                } : {},
                queryClassification: queryClassification,
                modelId: modelId,
                cohort: cohort,
                patternType: patternType
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};







var $4tgkZ = parcelRequire("4tgkZ");


var $9wmQG = parcelRequire("9wmQG");













var $6yCpa = parcelRequire("6yCpa");

var $1VCtc = parcelRequire("1VCtc");

var $4FsX0 = parcelRequire("4FsX0");





var $idpYy = parcelRequire("idpYy");



















/**
 * Retrieves a product from ATI, but also supports legacy ATIs that don't follow the standard format.
 */ const $dd52a0ba4dde52e0$var$parseProductFromAti = (ati)=>{
    const legacyAtiToProductMap = {
        [(0, $idpYy.CONFLUENCE_CALENDAR_ENTITY_ATI)]: (0, $1yEFx.ProductKeys).Confluence,
        [(0, $idpYy.CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI)]: (0, $1yEFx.ProductKeys).Confluence,
        [(0, $idpYy.CONFLUENCE_ANSWER_ENTITY_ATI)]: (0, $1yEFx.ProductKeys).Confluence,
        [(0, $idpYy.CONFLUENCE_QUESTION_ENTITY_ATI)]: (0, $1yEFx.ProductKeys).Confluence,
        [(0, $idpYy.CONFLUENCE_GLIFFY_ENTITY_ATI)]: (0, $1yEFx.ProductKeys).Confluence
    };
    try {
        return (0, $6yCpa.Ati).parse(ati).resourceOwner;
    } catch (e) {
        if (e instanceof (0, $4FsX0.ValidationError)) return legacyAtiToProductMap[ati] || null;
        throw e;
    }
};
const $dd52a0ba4dde52e0$export$771e1c85614a020d = (relayResults)=>{
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const { selectedFilters: selectedFilters, entities: entities } = (0, $4VkIo.useSelectedFilters)({});
    const productsFromEntitiesSearchedFor = entities.map((entity)=>$dd52a0ba4dde52e0$var$parseProductFromAti(entity)).filter((productName)=>!!productName);
    const thirdPartyProductsSearchedFor = selectedFilters.thirdPartyFilters.thirdPartyProducts?.map((filter)=>filter.product) || [];
    const productsSearchedFor = [
        ...new Set([
            ...productsFromEntitiesSearchedFor,
            ...thirdPartyProductsSearchedFor
        ])
    ].filter((product)=>product !== 'graph');
    const wasAny3PSearched = (selectedFilters.thirdPartyFilters.integrations?.length || 0) > 0 || productsFromEntitiesSearchedFor.includes('graph');
    let productKeys = [];
    let authorized3PProducts = [];
    let notAuthorized3PProducts = [];
    if (thirdPartyConfigs) {
        productKeys = Object.keys(thirdPartyConfigs);
        authorized3PProducts = productKeys.filter((product)=>!thirdPartyConfigs[product]?.userNeedsOAuth);
        notAuthorized3PProducts = productKeys.filter((product)=>thirdPartyConfigs[product]?.userNeedsOAuth);
    }
    const { productsFirstResultPositions: productsFirstResultPositions, smartLinkProductsFirstResultPositions: smartLinkProductsFirstResultPositions, is3PInTop10Results: is3PInTop10Results, is3PResultPresentInResultSet: is3PResultPresentInResultSet, is3PSmartLinkInTop10Results: is3PSmartLinkInTop10Results, is3PSmartLinkPresentInResultSet: is3PSmartLinkPresentInResultSet } = $dd52a0ba4dde52e0$export$53d00de621f3e600(relayResults, thirdPartyConfigs);
    const productsInResults = Object.keys(productsFirstResultPositions);
    return {
        searchAndResult: {
            productsFirstResultPositions: productsFirstResultPositions,
            productsInResults: productsInResults,
            is3PInTop10Results: is3PInTop10Results,
            is3PResultPresentInResultSet: is3PResultPresentInResultSet,
            is3PSmartLinkInTop10Results: is3PSmartLinkInTop10Results,
            is3PSmartLinkPresentInResultSet: is3PSmartLinkPresentInResultSet,
            smartLinkProductsFirstResultPositions: smartLinkProductsFirstResultPositions,
            authorized3PProducts: authorized3PProducts,
            notAuthorized3PProducts: notAuthorized3PProducts,
            productsSearchedFor: productsSearchedFor,
            wasAny3PSearched: wasAny3PSearched
        }
    };
};
function $dd52a0ba4dde52e0$export$53d00de621f3e600(results, thirdPartyConfigs) {
    return (0, $42omo.useMemo)(()=>{
        let is3PInTop10Results = false;
        let is3PSmartLinkInTop10Results = false;
        let is3PSmartLinkPresentInResultSet = false;
        let is3PResultPresentInResultSet = false;
        const { productsFirstResultPositions: productsFirstResultPositions, smartLinkProductsFirstResultPositions: smartLinkProductsFirstResultPositions } = results?.edges?.reduce((acc, result, index)=>{
            const product = (0, $k4HRJ.AnyAri).parse(result.node.id).resourceOwner;
            // this is always true for graph nodes
            if (acc.productsFirstResultPositions[product] === undefined) {
                if (product === 'graph' && (0, $7ZetK.isSearchResultGraphEntity)(result.node) && result.node.integrationId) {
                    const thirdPartyProductKey = (0, $4Chrd.getProductFromProviderId)(thirdPartyConfigs, result.node.providerId) || (0, $1VCtc.PlatformIntegrationAri).parse(result.node.integrationId).integrationKey;
                    if (acc.productsFirstResultPositions[thirdPartyProductKey] === undefined) acc.productsFirstResultPositions[thirdPartyProductKey] = index + 1;
                    // this assumes only graph nodes can be 3p
                    if ((0, $fuGkE.is3pProductKeyForAnalytics)(thirdPartyProductKey)) {
                        if (!is3PResultPresentInResultSet) {
                            is3PResultPresentInResultSet = true;
                            is3PInTop10Results = index < 10;
                        }
                        if ((0, $kQT7c.isResultSmartLink)({
                            resultAri: result.node.id,
                            thirdPartyConfigs: thirdPartyConfigs,
                            productKey: thirdPartyProductKey,
                            connectorType: result.node.connectorType
                        })) {
                            if (!is3PSmartLinkPresentInResultSet) {
                                is3PSmartLinkPresentInResultSet = true;
                                is3PSmartLinkInTop10Results = index < 10;
                            }
                            if (acc.smartLinkProductsFirstResultPositions[thirdPartyProductKey] === undefined) acc.smartLinkProductsFirstResultPositions[thirdPartyProductKey] = index + 1;
                        }
                    }
                } else acc.productsFirstResultPositions[product] = index + 1;
            }
            return acc;
        }, {
            productsFirstResultPositions: {},
            smartLinkProductsFirstResultPositions: {}
        }) || {
            productsFirstResultPositions: {},
            smartLinkProductsFirstResultPositions: {}
        };
        return {
            productsFirstResultPositions: productsFirstResultPositions,
            smartLinkProductsFirstResultPositions: smartLinkProductsFirstResultPositions,
            is3PInTop10Results: is3PInTop10Results,
            is3PResultPresentInResultSet: is3PResultPresentInResultSet,
            is3PSmartLinkInTop10Results: is3PSmartLinkInTop10Results,
            is3PSmartLinkPresentInResultSet: is3PSmartLinkPresentInResultSet
        };
    }, [
        results,
        thirdPartyConfigs
    ]);
}



var $4TTdD = parcelRequire("4TTdD");

const $9df153e29ffddcb7$export$7d33b74a4ce5a7db = (relayResults)=>{
    return {
        numberOfSocialSignalsShown: $9df153e29ffddcb7$var$countSocialSignalsShown(relayResults),
        numberOfSocialSignalsShownTop10: $9df153e29ffddcb7$var$countSocialSignalsShownTop10(relayResults),
        socialSignalSearchResultPositions: $9df153e29ffddcb7$var$getSocialSignalSearchResultPositions(relayResults)
    };
};
const $9df153e29ffddcb7$var$countSocialSignalsShown = (results)=>results?.edges.filter(({ node: node })=>(0, $4TTdD.isSearchConfluencePartial)(node) && node.socialSignal).length || 0;
const $9df153e29ffddcb7$var$countSocialSignalsShownTop10 = (results)=>results?.edges.slice(0, 10).filter(({ node: node })=>(0, $4TTdD.isSearchConfluencePartial)(node) && node.socialSignal).length || 0;
const $9df153e29ffddcb7$var$getSocialSignalSearchResultPositions = (results)=>results?.edges.reduce((acc, { node: node }, index)=>{
        if ((0, $4TTdD.isSearchConfluencePartial)(node) && node.socialSignal) acc.push(index + 1);
        return acc;
    }, []) || [];









const $ec36d7d4426f2eb3$export$8554996556b9ba1 = ({ are3pResultsShown: are3pResultsShown, backendExperimentRef: backendExperimentRef, clearReferrer: clearReferrer, cloudId: cloudId, commonAttributes: commonAttributes, edges: edges, experimentConfig: experimentConfig, getSelectedFilters: getSelectedFilters, intentDetectionTriggered: intentDetectionTriggered, isLoadingNext: isLoadingNext, isJiraIssueIndexed: isJiraIssueIndexed, isPaginatedQuery: isPaginatedQuery, nonPrivacySafeAttributes: nonPrivacySafeAttributes, productDataRegions: productDataRegions, productEdition: productEdition, productsWithTimeoutsFromErrors: productsWithTimeoutsFromErrors, referrer: referrer, resultsForAnalytics: resultsForAnalytics, resultsShown: resultsShown, searchQuery: searchQuery })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const logException = (0, $f8oYd.useLogException)();
    const intl = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const intentDetectionCohort = (0, $26jni.serveJiraNINFpsNLQNavigation)({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        // Exposure is fired when a user calls the intent detection API
        locale: intl.locale
    })?.cohort;
    // Properties related to social signals
    const socialSignalsAttributes = (0, $9df153e29ffddcb7$export$7d33b74a4ce5a7db)(resultsForAnalytics);
    // Properties related to the search results in the result set
    const { searchAndResult: searchAndResult } = (0, $dd52a0ba4dde52e0$export$771e1c85614a020d)(resultsForAnalytics);
    // We store these values in a ref as the references to the properties are not
    // stable we do not want to trigger the analytics events unnecessarily. This
    // allows to narrow down the dependency array of the useEffect hook that fires
    // the analytics events.
    const analyticsProperties = {
        are3pResultsShown: are3pResultsShown,
        clearReferrer: clearReferrer,
        cloudId: cloudId,
        commonAttributes: commonAttributes,
        experimentConfig: experimentConfig,
        fireAnalyticsEvent: fireAnalyticsEvent,
        getSelectedFilters: getSelectedFilters,
        intentDetectionTriggered: intentDetectionTriggered,
        intentDetectionCohort: intentDetectionCohort,
        isJiraIssueIndexed: isJiraIssueIndexed,
        isPaginatedQuery: isPaginatedQuery,
        logException: logException,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        productDataRegions: productDataRegions,
        productEdition: productEdition,
        productsWithTimeoutsFromErrors: productsWithTimeoutsFromErrors,
        referrer: referrer,
        resultsShown: resultsShown,
        searchAndResult: searchAndResult,
        searchQuery: searchQuery,
        socialSignalsAttributes: socialSignalsAttributes
    };
    const analyticsPropertiesRef = (0, $42omo.useRef)(analyticsProperties);
    analyticsPropertiesRef.current = analyticsProperties;
    (0, $42omo.useEffect)(()=>{
        const { are3pResultsShown: are3pResultsShown, clearReferrer: clearReferrer, commonAttributes: commonAttributesWithoutExtensionData, fireAnalyticsEvent: fireAnalyticsEvent, intentDetectionTriggered: intentDetectionTriggered, intentDetectionCohort: intentDetectionCohort, isPaginatedQuery: isPaginatedQuery, logException: logException, nonPrivacySafeAttributes: nonPrivacySafeAttributes, productsWithTimeoutsFromErrors: productsWithTimeoutsFromErrors, referrer: referrerFromStore, resultsShown: resultsShown, searchAndResult: searchAndResult, searchQuery: searchQuery, socialSignalsAttributes: socialSignalsAttributes } = analyticsPropertiesRef.current;
        // Prefer the store value (kept in sync by the host app via onUpdate) but fall back to
        // reading directly from the URL at event-fire time. The fallback handles the case where
        // the host app does not update queryParams after a SPA navigation that adds ?referrer=
        // to the URL (e.g. zero-query suggestions navigating to the search page) and therefore
        // the store value is undefined even though the URL has a referrer.
        const referrerFromUrl = (0, $dh538.fg)('qf_zero_query_referrer') ? (0, $aec377272259e0f9$export$93ca63a045ddcea8)() : undefined;
        const referrer = referrerFromStore ?? referrerFromUrl;
        if (isLoadingNext) return;
        const numResults = edges.length;
        const isBulkConnectBannerShown = (0, $9wmQG.getIsBulkConnectBannerShown)();
        const commonAttributes = {
            ...commonAttributesWithoutExtensionData,
            ...(0, $1ymk3.getExtensionData)(commonAttributesWithoutExtensionData.isCQL)
        };
        const requestedBackendExperiment = backendExperimentRef.current ?? undefined;
        fireAnalyticsEvent((0, $0f1906aa6a6024a0$export$4b73689f2f9f3dd3)({
            queryState: searchQuery ? (0, $6yNqK.QueryState).POSTQUERY : (0, $6yNqK.QueryState).PREQUERY,
            numResults: numResults,
            shownCount: numResults,
            are3pResultsShown: are3pResultsShown,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            socialSignalsAttributes: socialSignalsAttributes,
            resultsShown: resultsShown,
            searchAndResult: searchAndResult,
            requestedBackendExperiments: {
                backendExperiments: requestedBackendExperiment
            },
            referrer: referrer && searchQuery ? referrer : undefined,
            isPaginatedQuery: isPaginatedQuery,
            isBulkConnectBannerShown: isBulkConnectBannerShown,
            productsWithTimeout: productsWithTimeoutsFromErrors || [],
            ...intentDetectionTriggered !== undefined ? {
                intentDetectionTriggered: intentDetectionTriggered
            } : {},
            ...(0, $dh538.fg)('rovo_qf_intent_detection_pattern_type_analytics') ? {
                queryClassification: (0, $4tgkZ.INTENT_DETECTION).value()?.mode,
                modelId: (0, $4tgkZ.INTENT_DETECTION).value()?.modelId,
                cohort: intentDetectionCohort,
                patternType: (0, $4tgkZ.INTENT_DETECTION).value()?.patternType,
                wordCount: commonAttributes.wordCount
            } : {}
        }));
        fireAnalyticsEvent((0, $00671a63acd7458c$export$8b03bfde0d56431b)({
            success: true,
            commonAttributes: commonAttributes
        }));
        (0, $bVltF.searchResultsLoadUFOExperienceSuccess)({
            queryLength: commonAttributes.queryLength,
            wordCount: commonAttributes.wordCount
        });
        // Ensure that the referrer attribute is only used once
        clearReferrer();
        if ((0, $dh538.fg)('qf_zero_query_referrer')) (0, $aec377272259e0f9$export$a4a337593fcc41db)(logException);
    }, [
        analyticsPropertiesRef,
        backendExperimentRef,
        edges,
        isLoadingNext
    ]);
};


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 


















const $f393218d2c2b7af2$export$7148f5ed0307d6ed = ({ edges: edges, searchSessionId: searchSessionId, isCQL: isCQL, isCachedResult: isCachedResult })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const vitalStats = (0, $3f9016d1e452d4e9$export$586800522161402)();
    const fullPageSearchTaskId = vitalStats.getUxTaskId();
    const networkRefs = vitalStats.getNetworkRefs();
    const asyncSearchRefs = vitalStats.getAsyncSearchRefs();
    const onNetworkSuccess = vitalStats.onNetworkSuccess;
    const onAsyncSearchSuccess = vitalStats.onAsyncSearchSuccess;
    const onAsyncSearchFail = vitalStats.onAsyncSearchFail;
    const vitalStatsEventFiredRef = (0, $42omo.useRef)(false);
    const networkVitalStatsEventFiredRef = (0, $42omo.useRef)(false);
    const asyncSearchVitalStatsEventFiredRef = (0, $42omo.useRef)(false);
    const fullPageSearchTaskIdRefStable = (0, $42omo.useRef)(fullPageSearchTaskId);
    const searchSessionIdRefStable = (0, $42omo.useRef)(searchSessionId);
    // Keep refs up to date and reset vitalStatsEventFiredRef when task ID changes
    (0, $42omo.useEffect)(()=>{
        const taskIdChanged = fullPageSearchTaskId !== fullPageSearchTaskIdRefStable.current;
        if (taskIdChanged) {
            vitalStatsEventFiredRef.current = false;
            networkVitalStatsEventFiredRef.current = false;
            asyncSearchVitalStatsEventFiredRef.current = false;
        }
        fullPageSearchTaskIdRefStable.current = fullPageSearchTaskId;
        searchSessionIdRefStable.current = searchSessionId;
    }, [
        fullPageSearchTaskId,
        searchSessionId
    ]);
    // Fire vital stats taskSuccess event when results are successfully rendered (UX)
    (0, $42omo.useEffect)(()=>{
        if (fullPageSearchTaskIdRefStable.current && !vitalStatsEventFiredRef.current && edges.length > 0) {
            vitalStatsEventFiredRef.current = true;
            fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
                searchSessionId: searchSessionIdRefStable.current || '',
                taskId: fullPageSearchTaskIdRefStable.current,
                task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_UX
            }));
        }
    // Refs (fullPageSearchTaskIdRefStable, searchSessionIdRefStable, vitalStatsEventFiredRef)
    // are intentionally NOT in dependencies - we use refs to read latest values without
    // causing re-runs. fireAnalyticsEvent is stable and doesn't need to be included.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        edges.length,
        fullPageSearchTaskId
    ]);
    // Fire network VitalStats taskSuccess event when results are received
    // Note: Network success fires for zero results too (edges.length === 0 is valid)
    (0, $42omo.useEffect)(()=>{
        if (networkRefs && onNetworkSuccess && !networkVitalStatsEventFiredRef.current && (0, $dh538.fg)('rovo-search-vitalstats-fullpage-search-network')) {
            const state = networkRefs.current.state;
            // Only fire if task is in 'started' state (prevents duplicates)
            if (state.state === 'started' && state.taskId) {
                networkVitalStatsEventFiredRef.current = true;
                const traceInfo = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $1ymk3.getRelayNetworkTraceInfo)(isCQL) : undefined;
                onNetworkSuccess(edges.length, traceInfo);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        edges.length,
        fullPageSearchTaskId,
        networkRefs,
        onNetworkSuccess
    ]);
    // Fire async search VitalStats taskSuccess/taskFail when results are received
    // Only fires when an async search task has been started (cacheExpected=true)
    // Success = aggregator served from backend cache (isCachedResult=true)
    // Fail = aggregator did not serve from cache (isCachedResult=false/undefined)
    (0, $42omo.useEffect)(()=>{
        if (!asyncSearchRefs || !onAsyncSearchSuccess || !onAsyncSearchFail || asyncSearchVitalStatsEventFiredRef.current || !(0, $dh538.fg)('search_async_ssr')) return;
        const state = asyncSearchRefs.current.state;
        // Only fire if async search task is in 'started' state (prevents duplicates)
        if (state.state === 'started' && state.taskId) {
            asyncSearchVitalStatsEventFiredRef.current = true;
            if (isCachedResult) onAsyncSearchSuccess();
            else onAsyncSearchFail();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        edges.length,
        fullPageSearchTaskId,
        asyncSearchRefs,
        onAsyncSearchSuccess,
        onAsyncSearchFail,
        isCachedResult
    ]);
};


const $e283d0740cdc7b40$var$PAGINATION_UNUSED_PAGE_SIZE = 30;
const $e283d0740cdc7b40$export$8230160803576e3b = ({ searchResultsQueryRef: searchResultsQueryRef, ...sharedProps })=>{
    if ((0, $dh538.fg)('search_async_ssr')) return /*#__PURE__*/ (0, $l998X.jsx)($e283d0740cdc7b40$var$SearchResultsAsync, {
        searchResultsAsyncQuery: searchResultsQueryRef,
        ...sharedProps
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($e283d0740cdc7b40$export$aee53da69e9839be, {
        searchResultsQuery: searchResultsQueryRef,
        ...sharedProps
    });
};
const $e283d0740cdc7b40$export$aee53da69e9839be = ({ searchResultsQuery: searchResultsQueryRef, ...sharedProps })=>{
    const queryData = (0, $irOoi.usePreloadedQuery)((0, $7Ngf7.default), searchResultsQueryRef);
    const inner = /*#__PURE__*/ (0, $l998X.jsx)($e283d0740cdc7b40$var$SearchResultsSyncInner, {
        queryData: queryData,
        queryReference: searchResultsQueryRef,
        sharedProps: sharedProps
    });
    if ((0, $dh538.fg)('rovo_search_results_granular_ufo_segments')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-results-query",
        children: inner
    });
    return inner;
};
const $e283d0740cdc7b40$var$SearchResultsSyncInner = ({ queryData: queryData, queryReference: queryReference, sharedProps: sharedProps })=>{
    // Pagination hasPrevious state (hasPreviousPage from usePaginationFragment does not work with aggregator)
    // See https://hello.atlassian.net/wiki/x/lYYyQQE
    const hasPreviousRef = (0, $42omo.useRef)(false);
    // Note that aggregator doesn't quite match the expected specification here
    // - hasNext is an available prop but will always be false.
    // - loadNext takes (limit: number) to set page size, but aggregator ignores it
    // See https://hello.atlassian.net/wiki/x/lYYyQQE
    const { data: data, loadNext: loadNext, isLoadingNext: isLoadingNext } = (0, $irOoi.usePaginationFragment)((0, $9777a9dc8fd7d279$export$2e2bcd8739ae039), queryData);
    // Pagination
    const cursor = data.search?.search?.pageInfo?.endCursor;
    const fetchNextPage = (0, $42omo.useCallback)((nextCursor)=>{
        // Double check we're fetching with the cursor from our current results
        if (nextCursor === cursor) {
            loadNext($e283d0740cdc7b40$var$PAGINATION_UNUSED_PAGE_SIZE);
            hasPreviousRef.current = true;
        }
    }, [
        loadNext,
        cursor
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($e283d0740cdc7b40$var$SearchResultsBody, {
        connectionData: data.search?.search ?? null,
        isLoadingNext: isLoadingNext,
        hasPreviousRef: hasPreviousRef,
        cursor: cursor,
        fetchNextPage: fetchNextPage,
        queryReference: queryReference,
        sharedProps: sharedProps
    });
};
const $e283d0740cdc7b40$var$SearchResultsAsync = ({ searchResultsAsyncQuery: searchResultsAsyncQueryRef, ...sharedProps })=>{
    const queryData = (0, $irOoi.usePreloadedQuery)((0, $b96117069722906e$export$2e2bcd8739ae039), searchResultsAsyncQueryRef);
    const inner = /*#__PURE__*/ (0, $l998X.jsx)($e283d0740cdc7b40$var$SearchResultsAsyncInner, {
        queryData: queryData,
        queryReference: searchResultsAsyncQueryRef,
        sharedProps: sharedProps
    });
    if ((0, $dh538.fg)('rovo_search_results_granular_ufo_segments')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-results-query",
        children: inner
    });
    return inner;
};
const $e283d0740cdc7b40$var$SearchResultsAsyncInner = ({ queryData: queryData, queryReference: queryReference, sharedProps: sharedProps })=>{
    const hasPreviousRef = (0, $42omo.useRef)(false);
    const { data: data, loadNext: loadNext, isLoadingNext: isLoadingNext } = (0, $irOoi.usePaginationFragment)((0, $b9704ba2490974ad$export$2e2bcd8739ae039), queryData);
    const cursor = data.search?.search?.pageInfo?.endCursor;
    const fetchNextPage = (0, $42omo.useCallback)((nextCursor)=>{
        if (nextCursor === cursor) {
            loadNext($e283d0740cdc7b40$var$PAGINATION_UNUSED_PAGE_SIZE);
            hasPreviousRef.current = true;
        }
    }, [
        loadNext,
        cursor
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($e283d0740cdc7b40$var$SearchResultsBody, {
        connectionData: data.search?.search ?? null,
        isCachedResult: data.search?.search?.isCachedResult,
        isLoadingNext: isLoadingNext,
        hasPreviousRef: hasPreviousRef,
        cursor: cursor,
        fetchNextPage: fetchNextPage,
        queryReference: queryReference,
        sharedProps: sharedProps
    });
};
const $e283d0740cdc7b40$var$SearchResultsBody = ({ connectionData: connectionData, isCachedResult: isCachedResult, isLoadingNext: isLoadingNext, hasPreviousRef: hasPreviousRef, cursor: cursor, fetchNextPage: fetchNextPage, queryReference: queryReference, sharedProps: sharedProps })=>{
    const { aggAbsoluteUrl: aggAbsoluteUrl, cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, searchSessionId: searchSessionId, searchQuery: searchQuery, availableProducts: availableProducts, experimentConfig: experimentConfig, productEdition: productEdition, productDataRegions: productDataRegions, isJiraIssueIndexed: isJiraIssueIndexed, setResultsState: setResultsState, getSelectedFilters: getSelectedFilters, clearFilters: clearFilters, logError: logError, clearReferrer: clearReferrer, referrer: referrer, autoCorrectPortalRef: autoCorrectPortalRef, smartAnswersPortalRef: smartAnswersPortalRef, debugPortalRef: debugPortalRef, setFederatedSlackCount: setFederatedSlackCount, setFederatedOutlookMailCount: setFederatedOutlookMailCount, setFederatedGmailCount: setFederatedGmailCount, setHasMoreGmailResults: setHasMoreGmailResults, setHasMoreOutlookMailResults: setHasMoreOutlookMailResults, setProductsWithTimeout: setProductsWithTimeout, bodyRef: bodyRef, maxResultsToShow: maxResultsToShow, setMaxResultsToShow: setMaxResultsToShow, mainContentWidth: mainContentWidth, backendExperimentRef: backendExperimentRef } = sharedProps;
    // Fragment for the search result body content within the connection
    const bodyData = (0, $irOoi.useFragment)((0, $c64625978af12f02$export$2e2bcd8739ae039), connectionData);
    // It is possible that aggregator returns the same node twice, but then <SearchResult key={edge.node.id} /> breaks
    // So we need to dedup by id
    const edges = (0, $42omo.useMemo)(()=>{
        const seenIds = new Set();
        const edges = bodyData?.edges || [];
        return edges.filter((edge)=>{
            const id = edge?.node?.id;
            if (seenIds.has(id)) return false;
            else {
                seenIds.add(id);
                return true;
            }
        });
    }, [
        bodyData?.edges
    ]);
    const edgesToDisplay = (0, $d36edf17876c264b$export$e8402efe3c056aa3)({
        bodyRef: bodyRef,
        edges: edges,
        maxResultsToShow: maxResultsToShow,
        setMaxResultsToShow: setMaxResultsToShow,
        queryReference: queryReference
    });
    const [features] = (0, $j4ply.useFeatures)();
    const isLiteMode = features?.lite?.enabled ?? false;
    const productsWithTimeoutsFromErrors = (0, $42omo.useMemo)(()=>{
        const errors = bodyData?.errors || [];
        return errors.filter((e)=>e.statusCode === 408).map((e)=>e.integration ?? e.product).flatMap((s)=>s && (0, $b4tvS.isProductKey)(s) ? [
                s
            ] : []); // Flatmap for better type inference
    }, [
        bodyData?.errors
    ]);
    (0, $42omo.useEffect)(()=>{
        // We only want to set products with timeout in all product search
        if (selectedProduct !== undefined) return;
        setProductsWithTimeout?.(productsWithTimeoutsFromErrors);
    }, [
        productsWithTimeoutsFromErrors,
        selectedProduct,
        setProductsWithTimeout
    ]);
    const resultsForAnalytics = (0, $42omo.useMemo)(()=>$e283d0740cdc7b40$var$transformResultsForAnalytics(edges), [
        edges
    ]);
    const resultsLength = edges.length;
    const rawResultsLength = bodyData?.edges?.length ?? 0;
    // Set federated Slack count when selectedProduct is Slack
    (0, $42omo.useEffect)(()=>{
        const isSlackFederatedSearchEnabled = (0, $8RFAN.serveFederatedSlackExperiment)(selectedProduct, undefined, {
            fireExperimentExposure: false
        }, thirdPartyConfigs);
        if (selectedProduct === (0, $1yEFx.ProductKeys).Slack && setFederatedSlackCount && isSlackFederatedSearchEnabled) setFederatedSlackCount(resultsLength);
    }, [
        selectedProduct,
        resultsLength,
        setFederatedSlackCount,
        thirdPartyConfigs
    ]);
    // Preserve existing Outlook Mail exact-count behaviour while the incremental count feature is off.
    (0, $42omo.useEffect)(()=>{
        if (selectedProduct === (0, $b4tvS.ProductKeys3P).OutlookMail && setFederatedOutlookMailCount && !(0, $dh538.fg)('formula_3p_outlook_result_count')) {
            setFederatedOutlookMailCount(resultsLength);
            setHasMoreOutlookMailResults?.(false);
        }
    }, [
        selectedProduct,
        resultsLength,
        setFederatedOutlookMailCount,
        setHasMoreOutlookMailResults
    ]);
    (0, $ea450f46c9ce72a3$export$7afdd26a4d2af5af)({
        selectedProduct: selectedProduct,
        rawResultsLength: rawResultsLength,
        resultsLength: resultsLength,
        pageInfo: bodyData?.pageInfo,
        isLoadingNext: isLoadingNext,
        setFederatedGmailCount: setFederatedGmailCount,
        setHasMoreGmailResults: setHasMoreGmailResults,
        setFederatedOutlookMailCount: setFederatedOutlookMailCount,
        setHasMoreOutlookMailResults: setHasMoreOutlookMailResults
    });
    const is3pGroupingEnabled = (0, $dh538.fg)('fps_3p_grouping_rollout_gate');
    // Records dwell time for search results
    // TODO: refactor this to use props instead of RSS
    (0, $320af85988d7ec69$export$2e2bcd8739ae039)();
    // Compass team names
    const [teamNames, setTeamNames] = (0, $42omo.useState)({});
    const { teamIds: teamIds, nodeIdMap: nodeIdMap } = (0, $42omo.useMemo)(()=>$e283d0740cdc7b40$var$getCompassTeamIds(edges, selectedProduct), [
        edges,
        selectedProduct
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $b0ed28a083ef01d9$export$2716d470ab5d7e10)(cloudId, teamIds, nodeIdMap, setTeamNames, logError);
    }, [
        cloudId,
        teamIds,
        nodeIdMap,
        logError
    ]);
    // Jira issue statuses
    const [issueStatuses, setIssueStatuses] = (0, $42omo.useState)({});
    const issueKeys = (0, $42omo.useMemo)(()=>$e283d0740cdc7b40$var$getJiraIssueKeys(edges), [
        edges
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $26168fcfdca601ab$export$fb62e1866e8071b1)(cloudId, issueKeys, aggAbsoluteUrl, setIssueStatuses, logError, undefined, primaryProduct);
    }, [
        cloudId,
        issueKeys,
        aggAbsoluteUrl,
        setIssueStatuses,
        logError,
        primaryProduct
    ]);
    // MS Teams past meeting occurrences hydration
    // Fetches up to 5 past occurrences of a recurring meeting via TWG Cypher query.
    // Only runs for MS Teams integration results (identified by integrationId).
    const [pastMeetingOccurrences, setPastMeetingOccurrences] = (0, $42omo.useState)({});
    const msTeamsVideoAris = (0, $42omo.useMemo)(()=>(0, $dh538.fg)('rovo_fps_enable_ms_teams_past_meetings') ? $e283d0740cdc7b40$var$getMsTeamsVideoAris(edges) : [], [
        edges
    ]);
    const fetchedMsTeamsArisRef = (0, $42omo.useRef)(new Set());
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('rovo_fps_enable_ms_teams_past_meetings')) return;
        const newAris = msTeamsVideoAris.filter((ari)=>!fetchedMsTeamsArisRef.current.has(ari));
        if (newAris.length === 0) return;
        for (const ari of newAris)fetchedMsTeamsArisRef.current.add(ari);
        (0, $7c43e2355d28c6dc$export$6c5cbc95f27dc639)(newAris, cloudId, aggAbsoluteUrl, setPastMeetingOccurrences, logError);
    }, [
        msTeamsVideoAris,
        cloudId,
        aggAbsoluteUrl,
        logError
    ]);
    // Jira issue linked PRs (GitHub PR hydration).
    // Only enabled when the user has Jira available and the GitHub connector
    // authenticated. Hydration is lazy: getJiraIssueARIs returns [] when no
    // Jira issues are present in the result set, in which case the fetch
    // effect below short-circuits and no network request is made.
    const isJiraLinkedPRsEnabled = (0, $074353e7cefdba17$export$1fc5115025b27b98)(thirdPartyConfigs, availableProducts);
    const [linkedPRs, setLinkedPRs] = (0, $42omo.useState)({});
    const { fireAnalyticsEvent: fireLinkedPRsAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const allIssueAris = (0, $42omo.useMemo)(()=>isJiraLinkedPRsEnabled ? $e283d0740cdc7b40$var$getJiraIssueARIs(edges) : [], [
        edges,
        isJiraLinkedPRsEnabled
    ]);
    // Track which ARIs we've already requested to avoid duplicate fetches on pagination.
    // When edges grow (e.g., user loads more results), we only fetch PRs for newly added issues.
    // Uses a ref rather than state to avoid triggering re-renders or effect cycles.
    const fetchedArisRef = (0, $42omo.useRef)(new Set());
    (0, $42omo.useEffect)(()=>{
        if (!isJiraLinkedPRsEnabled) return;
        const newAris = allIssueAris.filter((ari)=>!fetchedArisRef.current.has(ari));
        if (newAris.length === 0) return;
        for (const ari of newAris)fetchedArisRef.current.add(ari);
        (0, $58ec885ea6cc3454$export$abdd37837b6fbc28)(newAris, cloudId, aggAbsoluteUrl, setLinkedPRs, logError, fireLinkedPRsAnalyticsEvent);
    }, [
        allIssueAris,
        cloudId,
        aggAbsoluteUrl,
        logError,
        isJiraLinkedPRsEnabled,
        fireLinkedPRsAnalyticsEvent
    ]);
    const are3pResultsShown = (0, $42omo.useMemo)(()=>$e283d0740cdc7b40$export$87d91dbe2c36460b(edges, thirdPartyConfigs), [
        edges,
        thirdPartyConfigs
    ]);
    const resultsShown = (0, $42omo.useMemo)(()=>$e283d0740cdc7b40$export$8841f6f549512fc2(edges, thirdPartyConfigs), [
        edges,
        thirdPartyConfigs
    ]);
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const wasContentClearedBySpaceChange = (0, $djVCD.useWasContentClearedBySpaceChange)();
    const searchActions = (0, $djVCD.useSearchActions)();
    const clearSpaceFilter = (0, $42omo.useCallback)(async ()=>{
        await searchActions.clearSelectFilterOptions({
            filterId: (0, $a97k3.filter).id
        });
    }, [
        searchActions
    ]);
    const intl = (0, $aXWIB.useIntl)();
    const intentDetectionTriggered = (0, $42omo.useMemo)(()=>(0, $26jni.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale), [
        primaryProduct,
        intl.locale
    ]);
    (0, $ec36d7d4426f2eb3$export$8554996556b9ba1)({
        are3pResultsShown: are3pResultsShown,
        backendExperimentRef: backendExperimentRef,
        clearReferrer: clearReferrer,
        cloudId: cloudId,
        commonAttributes: commonAttributes,
        edges: edges,
        experimentConfig: experimentConfig,
        getSelectedFilters: getSelectedFilters,
        intentDetectionTriggered: intentDetectionTriggered,
        isJiraIssueIndexed: isJiraIssueIndexed,
        isLoadingNext: isLoadingNext,
        isPaginatedQuery: hasPreviousRef.current,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        productDataRegions: productDataRegions,
        productEdition: productEdition,
        productsWithTimeoutsFromErrors: productsWithTimeoutsFromErrors,
        referrer: referrer,
        resultsForAnalytics: resultsForAnalytics,
        resultsShown: resultsShown,
        searchQuery: searchQuery
    });
    (0, $f393218d2c2b7af2$export$7148f5ed0307d6ed)({
        edges: edges,
        searchSessionId: searchSessionId,
        isCQL: false,
        isCachedResult: isCachedResult ?? undefined
    });
    (0, $42omo.useEffect)(()=>{
        if (isLoadingNext) return;
        if (thirdPartyConfigs?.[(0, $b4tvS.ProductKeys3P).GoogleDrive]?.impersonationEnabled && selectedProduct === undefined) (0, $2OtFZ.triggerExposureForWeakLinkExp)();
    }, [
        isLoadingNext,
        selectedProduct,
        thirdPartyConfigs
    ]);
    // Update if there are no results
    (0, $42omo.useEffect)(()=>{
        setResultsState(edges.length === 0 ? (0, $fZ3l2.ResultsStates).NO_RESULTS : (0, $fZ3l2.ResultsStates).RESULTS);
    }, [
        edges,
        setResultsState
    ]);
    const queryInfo = bodyData?.queryInfo;
    const containsSearchResults = edges.length > 0;
    const debugResults = debugPortalRef?.current ? edges.map((edge)=>edge?.node ?? {}) : [];
    const traceId = bodyData?.traceId ?? undefined;
    const body = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                dataKey: "wordCount",
                value: commonAttributes.wordCount
            }),
            (0, $dh538.fg)('search_async_ssr') && /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                dataKey: "asyncQueryCachedResult",
                value: !!isCachedResult
            }),
            queryInfo && autoCorrectPortalRef && autoCorrectPortalRef.current && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, $l998X.jsx)((0, $7d957fe130cc1584$export$2e2bcd8739ae039), {
                node: queryInfo,
                appMode: appMode,
                cloudId: cloudId
            }), autoCorrectPortalRef.current, 'search-results-auto-correction'),
            debugPortalRef?.current && /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, $l998X.jsx)((0, $f9bf54cec5ccb807$export$bf4ee085e09787c5), {
                traceId: traceId,
                backendExperiment: backendExperimentRef.current ?? undefined,
                results: debugResults
            }), debugPortalRef.current),
            // the new Rovo Home experience renders Jira issues and projects in a table view in FPS
            isLiteMode ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7d9c1f9bccecc564$export$ad54ced6ff7118e5), {
                containsSearchResults: containsSearchResults,
                edgesToDisplay: edgesToDisplay,
                cloudId: cloudId,
                appMode: appMode,
                searchQuery: searchQuery,
                thirdPartyConfigs: thirdPartyConfigs,
                selectedProduct: selectedProduct,
                primaryProduct: primaryProduct,
                searchSessionId: searchSessionId,
                originalQuery: queryInfo?.originalQuery,
                availableProducts: availableProducts,
                logError: logError,
                teamNames: teamNames,
                issueStatuses: issueStatuses,
                linkedPRs: linkedPRs,
                pastMeetingOccurrences: pastMeetingOccurrences,
                is3pGroupingEnabled: is3pGroupingEnabled,
                smartAnswersPortalRef: smartAnswersPortalRef,
                mainContentWidth: mainContentWidth,
                wasContentClearedBySpaceChange: wasContentClearedBySpaceChange,
                clearSpaceFilter: clearSpaceFilter,
                clearFilters: clearFilters,
                getSelectedFilters: getSelectedFilters,
                cursor: cursor,
                isLoadingNext: isLoadingNext,
                fetchNextPage: fetchNextPage
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fe707538f71ff5eb$export$d0848c15dbb5ad38), {
                containsSearchResults: containsSearchResults,
                edgesToDisplay: edgesToDisplay,
                cloudId: cloudId,
                appMode: appMode,
                searchQuery: searchQuery,
                thirdPartyConfigs: thirdPartyConfigs,
                selectedProduct: selectedProduct,
                primaryProduct: primaryProduct,
                searchSessionId: searchSessionId,
                originalQuery: queryInfo?.originalQuery,
                availableProducts: availableProducts,
                logError: logError,
                teamNames: teamNames,
                issueStatuses: issueStatuses,
                linkedPRs: linkedPRs,
                pastMeetingOccurrences: pastMeetingOccurrences,
                is3pGroupingEnabled: is3pGroupingEnabled,
                smartAnswersPortalRef: smartAnswersPortalRef,
                mainContentWidth: mainContentWidth,
                wasContentClearedBySpaceChange: wasContentClearedBySpaceChange,
                clearSpaceFilter: clearSpaceFilter,
                clearFilters: clearFilters,
                getSelectedFilters: getSelectedFilters,
                cursor: cursor,
                isLoadingNext: isLoadingNext,
                fetchNextPage: fetchNextPage
            })
        ]
    });
    if ((0, $dh538.fg)('rovo_search_results_granular_ufo_segments')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-results-body",
        children: body
    });
    return body;
};
const $e283d0740cdc7b40$export$87d91dbe2c36460b = (edges, thirdPartyConfigs)=>{
    return !!edges?.some(({ node: node })=>{
        const productKey = (0, $4Chrd.getProductFromProviderId)(thirdPartyConfigs, node?.providerId) || (0, $67gKI.getIntegrationKey)(node?.integrationId);
        if (!productKey) // if no integration id it's a 1p
        return false;
        return (0, $fuGkE.is3pProductKeyForAnalytics)(productKey);
    });
};
function $e283d0740cdc7b40$var$getCompassTeamIds(edges, selectedProduct) {
    if (selectedProduct !== (0, $1yEFx.ProductKeys).Compass && selectedProduct !== undefined) return {
        teamIds: [],
        nodeIdMap: {}
    };
    const nodeIdMap = {};
    const ids = new Set();
    for(let i = 0; i < edges.length; i++){
        const node = edges[i]?.node;
        let ownerId = node?.ownerId;
        if ((0, $e4107ff9b0892e16$export$3ea06079dfb7d39c)(node)) {
            const teamId = (0, $fUcm0.getTeamId)(ownerId);
            if (teamId) {
                nodeIdMap[node.id] = teamId;
                ids.add(teamId);
            } else nodeIdMap[node.id] = null;
        }
    }
    return {
        teamIds: Array.from(ids),
        nodeIdMap: nodeIdMap
    };
}
/**
 * Extracts ARIs for MS Teams meeting transcript results from the result edges.
 * These are SearchResultGraphDocument nodes with the Microsoft integration ID whose
 * entity ARI resource type is 'video' (e.g. ari:cloud:graph::video/teams/...).
 *
 * We narrow by ARI resource type rather than `subtype` because `subtype` is null
 * in production for MS Teams meeting transcripts.
 */ function $e283d0740cdc7b40$var$getMsTeamsVideoAris(edges) {
    const arisSet = new Set();
    for (const edge of edges){
        const node = edge?.node;
        if (node?.id && node.__typename === 'SearchResultGraphDocument' && node.integrationId === 'ari:cloud:platform::integration/microsoft' && node.id.includes('::video/')) arisSet.add(node.id);
    }
    return Array.from(arisSet);
}
function $e283d0740cdc7b40$var$getJiraIssueARIs(edges) {
    const issueArisSet = new Set();
    for(let i = 0; i < edges.length; i++){
        const node = edges[i]?.node;
        if (node?.id && (0, $73404969990abf67$export$b9491ee18011db60)(node)) issueArisSet.add(node.id);
    }
    return Array.from(issueArisSet);
}
function $e283d0740cdc7b40$var$getJiraIssueKeys(edges) {
    const issueKeysSet = new Set();
    for(let i = 0; i < edges.length; i++){
        const node = edges[i]?.node;
        if (node?.id && (0, $73404969990abf67$export$b9491ee18011db60)(node)) {
            const issueKey = node.issue?.webUrl?.split('/').slice(-1)[0] || node?.url?.split('/').slice(-1)[0];
            if (issueKey) issueKeysSet.add(issueKey);
        }
    }
    return Array.from(issueKeysSet);
}
const $e283d0740cdc7b40$export$8841f6f549512fc2 = (edges, thirdPartyConfigs)=>{
    return edges?.map(({ node: node }, index)=>{
        const productKey = (0, $4Chrd.getProductFromProviderId)(thirdPartyConfigs, node?.providerId) || (0, $67gKI.getIntegrationKey)(node?.integrationId);
        const [firstPartyProduct] = (0, $6h3V2.getProductAndIDFromARI)(node?.id || '');
        const resultAri = (0, $k4HRJ.AnyAri).parse(node?.id || '');
        let hasLinkInDescription = false;
        if (resultAri.resourceOwner in (0, $1yEFx.products1P)) {
            const links = (0, $514d99dea8b7ae4b$export$a414b3d5a172e15b)(node?.description ?? '');
            if (links && links.length > 0) hasLinkInDescription = true;
        }
        const shouldShowBoostedLinks = node?.linkedResults ? node?.linkedResults.length > 0 && index <= (0, $b7a5d3c4b4eaddeb$export$f0079efc6806b623) : undefined;
        const connectorSourceType = (0, $kQT7c.getResultConnectorSource)({
            connectorType: node?.connectorType,
            resultNodeId: node?.id || '',
            productKey: productKey,
            thirdPartyConfigs: thirdPartyConfigs
        });
        // Build connectorInfo for unified 3P instrumentation
        // Only include for 3P results (where productKey exists)
        const connectorInfo = productKey ? {
            provider_id: node?.providerId || undefined,
            connector_id: node?.connectorId || undefined,
            connector_position: index,
            connector_product: node?.connectorProduct || undefined,
            connector_type: node?.connectorType || undefined,
            ari: node?.id,
            metadata: {
                // Add connectorWorkspaceId when available from backend
                // For now, only include fanoutResultsShown if present
                ...node?.linkedResults && node?.linkedResults.length > 0 && index <= (0, $b7a5d3c4b4eaddeb$export$f0079efc6806b623) ? {
                    fanOutResultsShown: node.linkedResults.slice(0, (0, $b7a5d3c4b4eaddeb$export$82bce033e6b355fc)).map((link)=>{
                        let is3P = false;
                        try {
                            is3P = !((0, $k4HRJ.AnyAri).parse(link.id).resourceOwner in (0, $1yEFx.products1P));
                        } catch  {
                            is3P = false;
                        }
                        return {
                            id: link.id,
                            category: link.category,
                            is3P: is3P
                        };
                    })
                } : {}
            }
        } : undefined;
        return {
            id: node?.id,
            position: index,
            product: productKey || firstPartyProduct,
            metadata: {
                connectorType: connectorSourceType,
                boostedLinksShown: shouldShowBoostedLinks,
                fanoutResultsShown: node?.linkedResults && node?.linkedResults.length > 0 && index <= (0, $b7a5d3c4b4eaddeb$export$f0079efc6806b623) ? node.linkedResults.slice(0, (0, $b7a5d3c4b4eaddeb$export$82bce033e6b355fc)).map((link)=>{
                    let is3P = false;
                    try {
                        is3P = !((0, $k4HRJ.AnyAri).parse(link.id).resourceOwner in (0, $1yEFx.products1P));
                    } catch  {
                        is3P = false;
                    }
                    return {
                        id: link.id,
                        category: link.category,
                        is3P: is3P
                    };
                }) : undefined,
                hasLinkInDescription: hasLinkInDescription
            },
            connectorInfo: connectorInfo
        };
    }) || [];
};
/**
 * Relay and RSS results have different types
 * Shared code (like result analytics) has typing assuming RSS
 * We solve this by building interfaces that accept both, such as IAnalyticsSearchPageResults
 *
 * We likely need a better approach for coalescing RSS and Relay result node typing, for shared code as we migrate away from RSS
 */ const $e283d0740cdc7b40$var$transformResultsForAnalytics = (edges)=>{
    const nodes = edges?.filter((edge)=>!!edge?.node) // drop undefined nodes
    ?.map((edge)=>{
        const node = edge.node;
        return {
            id: node?.id || '',
            __typename: node?.__typename || '',
            integrationId: node?.integrationId || '',
            providerId: node?.providerId || '',
            socialSignal: node?.socialSignal?.signal ? node?.socialSignal : null,
            connectorType: node?.connectorType || null
        };
    }) || [];
    return {
        edges: nodes.map((node)=>{
            return {
                node: node
            };
        })
    };
};





/**
 * @generated SignedSource<<b6257996c446266f3fd8763262ac3dd9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * @generated SignedSource<<cdff6965039e15e5a04f18ef5213136a>>
 * @relayHash c0137dc6045fd8bc5ac579c0af494372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 62ce9e2fbf44cfb184a0ee9f8da89b3a89c675f3cb47fe5725e846344017217c
const $ee6baca67a7541ac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cql"
        },
        {
            "defaultValue": 30,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        v2 /*: any*/ 
    ], v4 = {
        "kind": "ScalarField",
        "name": "ari"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SearchResultsCQLPaginationQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResultsCql_AtlassianSearchPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SearchResultsCQLPaginationQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceSearchResponse",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                            "kind": "LinkedField",
                                                            "name": "links",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webui"
                                                                }
                                                            ]
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "excerpt"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastModified"
                                        },
                                        {
                                            "concreteType": "LinksContextBase",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "base"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "filters": [
                        "cql"
                    ],
                    "handle": "connection",
                    "key": "SearchResultsCQLPagination__confluence_search",
                    "kind": "LinkedHandle",
                    "name": "confluence_search"
                }
            ]
        },
        "params": {
            "id": "62ce9e2fbf44cfb184a0ee9f8da89b3a89c675f3cb47fe5725e846344017217c",
            "metadata": {},
            "name": "SearchResultsCQLPaginationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ee6baca67a7541ac$var$node.hash = "51b24e33621d3475cf8b3ace0b87f653";
var $ee6baca67a7541ac$export$2e2bcd8739ae039 = $ee6baca67a7541ac$var$node;


const $893fbbd3862eadef$var$node = function() {
    var v0 = [
        "confluence_search"
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "cql"
            },
            {
                "defaultValue": 30,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $ee6baca67a7541ac$export$2e2bcd8739ae039)
            }
        },
        "name": "searchResultsCql_AtlassianSearchPage",
        "selections": [
            {
                "alias": "confluence_search",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cql",
                        "variableName": "cql"
                    }
                ],
                "concreteType": "ConfluenceSearchConnection",
                "kind": "LinkedField",
                "name": "__SearchResultsCQLPagination__confluence_search_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceSearchResponseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "ConfluenceSearchResponse",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "url"
                                    },
                                    {
                                        "concreteType": "Content",
                                        "kind": "LinkedField",
                                        "name": "content",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "ari"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "searchResultCql_AtlassianSearchPage"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$893fbbd3862eadef$var$node.hash = "51b24e33621d3475cf8b3ace0b87f653";
var $893fbbd3862eadef$export$2e2bcd8739ae039 = $893fbbd3862eadef$var$node;

































/**
 * @generated SignedSource<<2b3237facd1b2e3c6b7f039dd0c1ae3d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $69230a8b786d4754$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchResultCql_AtlassianSearchPage",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "confluenceSearchResponse_AtlassianSearchPage"
        }
    ],
    "type": "ConfluenceSearchResponse"
};
$69230a8b786d4754$var$node.hash = "cd25c423f4524a66fa1d1282afb1b2aa";
var $69230a8b786d4754$export$2e2bcd8739ae039 = $69230a8b786d4754$var$node;


parcelRequire("42omo");












/**
 * @generated SignedSource<<68a4cc1ab74fb8197f830c68f55fb47c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $db143c259e453ad6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "ari"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "confluenceSearchResponse_AtlassianSearchPage",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "kind": "ScalarField",
                "name": "url"
            },
            {
                "kind": "ScalarField",
                "name": "lastModified"
            },
            {
                "concreteType": "LinksContextBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "base"
                    }
                ]
            },
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "webui"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "ConfluenceSearchResponse"
    };
}();
$db143c259e453ad6$var$node.hash = "56720713632e89616c1b52d367ff72b8";
var $db143c259e453ad6$export$2e2bcd8739ae039 = $db143c259e453ad6$var$node;































































const $9226716d140bc3a4$export$22448a5b1a6731f4 = ({ node: node, position: position, cloudId: cloudId, searchQuery: query, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $db143c259e453ad6$export$2e2bcd8739ae039), node);
    const [features] = (0, $j4ply.useFeatures)();
    const isSideBySideEnabled = features?.sideBySide?.enabled;
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const { getFeatureGate: getFeatureGate, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const model = (0, $42omo.useMemo)(()=>({
            id: data?.content?.ari || '',
            title: data?.title,
            description: data?.excerpt,
            type: data?.content?.type || '',
            url: `${data?.links?.base}${data?.url}`,
            lastModified: data?.lastModified,
            isVerified: null,
            space: data?.content?.space?.ari && data?.content?.space?.name ? {
                id: data.content.space.ari,
                name: data.content.space.name,
                webUiLink: data.content.space.links?.webui
            } : null,
            socialSignal: null
        }), [
        data
    ]);
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product, , , contentId] = (0, $6h3V2.getProductAndIDFromARI)(model.id);
        let containerId = null;
        if (model.space?.id) {
            const [, , , spaceId] = (0, $6h3V2.getProductAndIDFromARI)(model.space.id);
            containerId = spaceId;
        }
        return {
            id: model.id,
            containerId: containerId,
            spaceId: containerId,
            contentType: model.type,
            entityType: model.type,
            contentId: contentId,
            product: product,
            isSideBySideEnabled: isSideBySideEnabled
        };
    }, [
        model,
        isSideBySideEnabled
    ]);
    const searchResultForConversationStarters = (0, $42omo.useMemo)(()=>{
        const { serveExperiment: serveConversationStartersExperiment } = (0, $eUEtI.getSAINLayerFrontendExperiment)({
            abTestId: 'kd_convo_starters_in_search'
        });
        const isConversationStartersEnabled = serveConversationStartersExperiment || getFeatureGate('kd_convo_starters_dogfooding');
        const isPageOrBlogpost = [
            'page',
            'blogpost'
        ].includes(model.type);
        const searchResultForConversationStarters = isPageOrBlogpost && isConversationStartersEnabled && position === 0 && appMode === (0, $9vOy1.ApplicationModes).Rovo && (0, $eb4a02b80e2ab764$export$3afecd2a83596299)(appMode, isAdminHubAIEnabled, isRovoLLMEnabled) ? {
            ari: model.id,
            url: model.url
        } : null;
        return searchResultForConversationStarters;
    }, [
        appMode,
        getFeatureGate,
        isAdminHubAIEnabled,
        isRovoLLMEnabled,
        model.id,
        model.type,
        model.url,
        position
    ]);
    const onResultClicked = (0, $29cf2c8a5cfa1059$export$b9038cd1b8a570da)({
        metadata: metadata,
        position: position
    });
    const onResultCtxMenuClicked = (0, $add774a162708af3$export$8839bf4972090a38)({
        metadata: metadata,
        position: position
    });
    const onCopyLinkButtonClicked = (0, $e31123e898a81d94$export$9f6a79d85aed5338)('searchResultTitle');
    const onSummarizeInChatButtonClicked = (0, $bbb097a890bbf9c9$export$5ce6946676179c6b)({
        location: 'searchResult',
        metadata: metadata,
        position: position
    });
    const onContextMenuCopyButtonClicked = (0, $2719c743fbe13cbd$export$875f4c2863f9261e)();
    const onContextMenuButtonClicked = (0, $3808426f0faae55b$export$ede80662f98c6d00)();
    const metadataParts = [
        [
            'type',
            (0, $kXlQy.getSearchResultType)(model.type)
        ],
        [
            'last-modified',
            model.lastModified && /*#__PURE__*/ (0, $l998X.jsx)((0, $2ba9d06a8e432719$export$e6747eee8f26f8c0), {
                lastModified: model.lastModified
            })
        ]
    ];
    let icon;
    if (model.type && (0, $dh538.fg)('rovo_search_confluence_icons_fps')) icon = (0, $2waBy.getConfluenceEntityIcon)({
        iconUrl: undefined,
        type: model.type,
        size: 'medium'
    });
    else icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
        size: "medium",
        shouldUseNewLogoDesign: true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9WEcF.SearchResult), {
        id: model.id,
        product: (0, $1yEFx.ProductKeys).Confluence,
        productSelected: !!selectedProduct,
        primaryProduct: primaryProduct,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultCtxMenuClicked,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked,
        url: (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
            url: model.url,
            query: query,
            searchSessionId: searchSessionId
        }),
        title: (0, $Y34Hw.enrichExcerpt)(model.title),
        icon: icon,
        headerMetadataParts: metadataParts,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d63697edde98d0a$export$780f34b9b2f156ca), {
            description: (0, $Y34Hw.processExcerpt)(model.description)
        }),
        cloudId: cloudId,
        position: position,
        appMode: appMode,
        mainContentWidth: mainContentWidth,
        hideSummarizeInChat: !!searchResultForConversationStarters,
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            children: cloudId && searchResultForConversationStarters && /*#__PURE__*/ (0, $l998X.jsx)((0, $383edc9b6c74463d$export$10e76ebde8d3ea11), {
                primaryProduct: primaryProduct,
                cloudId: cloudId,
                searchResult: searchResultForConversationStarters,
                analyticsAttributes: {
                    resultMetadata: metadata,
                    ...commonAttributes
                }
            })
        })
    });
};


const $2d6479d83ab325a8$export$d26e7574d0f17b15 = ({ node: node, position: position, cloudId: cloudId, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, selectedProduct: selectedProduct, searchQuery: searchQuery, searchSessionId: searchSessionId, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth })=>{
    const data = (0, $irOoi.useFragment)((0, $69230a8b786d4754$export$2e2bcd8739ae039), node);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            position === (0, $bdefbb7f72d12f38$export$b9f6f9f70138c961) && /*#__PURE__*/ (0, $l998X.jsx)((0, $14f5a0c0b568e7eb$export$df17046610238203), {
                availableProducts: availableProducts,
                selectedProduct: selectedProduct,
                thirdPartyConfigs: thirdPartyConfigs
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                section: "SearchPageResultRecordCQL",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9226716d140bc3a4$export$22448a5b1a6731f4), {
                    appMode: appMode,
                    cloudId: cloudId,
                    mainContentWidth: mainContentWidth,
                    node: data,
                    position: position,
                    primaryProduct: primaryProduct,
                    searchQuery: searchQuery,
                    searchSessionId: searchSessionId,
                    selectedProduct: selectedProduct
                })
            })
        ]
    });
};





const $29779de3a21de1c2$var$noop = ()=>{};
/**
 * Separated out the results logic and rendering as the relay fragment and pagination
 * adds significant bulk to the component, making it hard to read and test.
 */ const $29779de3a21de1c2$var$SearchResultCQLWithData = ({ availableProducts: availableProducts, backendExperimentRef: backendExperimentRef, bodyRef: bodyRef, clearReferrer: clearReferrer, cloudId: cloudId, edges: edges, experimentConfig: experimentConfig, getSelectedFilters: getSelectedFilters, isLoadingNext: isLoadingNext, isJiraIssueIndexed: isJiraIssueIndexed, isPaginatedQuery: isPaginatedQuery, maxResultsToShow: maxResultsToShow, productDataRegions: productDataRegions, productEdition: productEdition, referrer: referrer, searchQuery: searchQuery, searchResultsCQLQueryReference: searchResultsCQLQueryReference, searchSessionId: searchSessionId, selectedProduct: selectedProduct, primaryProduct: primaryProduct, appMode: appMode, mainContentWidth: mainContentWidth, setMaxResultsToShow: setMaxResultsToShow, setResultsState: setResultsState, thirdPartyConfigs: thirdPartyConfigs })=>{
    (0, $320af85988d7ec69$export$2e2bcd8739ae039)();
    (0, $42omo.useEffect)(()=>{
        setResultsState(edges.length === 0 ? (0, $fZ3l2.ResultsStates).NO_RESULTS : (0, $fZ3l2.ResultsStates).RESULTS);
    }, [
        edges,
        setResultsState
    ]);
    const edgesToDisplay = (0, $d36edf17876c264b$export$e8402efe3c056aa3)({
        bodyRef: bodyRef,
        edges: edges,
        maxResultsToShow: maxResultsToShow,
        setMaxResultsToShow: setMaxResultsToShow,
        queryReference: searchResultsCQLQueryReference
    });
    (0, $f393218d2c2b7af2$export$7148f5ed0307d6ed)({
        edges: edges,
        searchSessionId: searchSessionId,
        isCQL: true
    });
    const intl = (0, $aXWIB.useIntl)();
    const intentDetectionTriggered = (0, $42omo.useMemo)(()=>(0, $26jni.isIntentDetectionTriggeredForExperiment)(primaryProduct, intl.locale), [
        primaryProduct,
        intl.locale
    ]);
    const resultsForAnalytics = (0, $42omo.useMemo)(()=>$29779de3a21de1c2$var$transformEdgesToResultsForAnalytics(edges), [
        edges
    ]);
    const resultsShown = (0, $42omo.useMemo)(()=>$29779de3a21de1c2$var$transformEdgesToResultsShown(edges), [
        edges
    ]);
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    (0, $ec36d7d4426f2eb3$export$8554996556b9ba1)({
        are3pResultsShown: false,
        backendExperimentRef: backendExperimentRef,
        clearReferrer: clearReferrer,
        cloudId: cloudId,
        commonAttributes: commonAttributes,
        edges: edges,
        experimentConfig: experimentConfig,
        getSelectedFilters: getSelectedFilters,
        intentDetectionTriggered: intentDetectionTriggered,
        isJiraIssueIndexed: isJiraIssueIndexed,
        isLoadingNext: isLoadingNext,
        isPaginatedQuery: isPaginatedQuery,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        productDataRegions: productDataRegions,
        productEdition: productEdition,
        productsWithTimeoutsFromErrors: undefined,
        referrer: referrer,
        resultsForAnalytics: resultsForAnalytics,
        resultsShown: resultsShown,
        searchQuery: searchQuery
    });
    return edges.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: edgesToDisplay.flatMap((edge)=>edge?.node ? [
                edge.node
            ] : []).map((node, position)=>{
            const key = node.content?.ari || node.url || String(position);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $2d6479d83ab325a8$export$d26e7574d0f17b15), {
                appMode: appMode,
                availableProducts: availableProducts,
                cloudId: cloudId,
                mainContentWidth: mainContentWidth,
                node: node,
                position: position,
                primaryProduct: primaryProduct,
                searchQuery: searchQuery,
                searchSessionId: searchSessionId,
                selectedProduct: selectedProduct,
                thirdPartyConfigs: thirdPartyConfigs
            }, key);
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $88900765e2dbc6d9$export$f8a5875a19110e65), {
        filtersEnabled: false,
        clearFilters: $29779de3a21de1c2$var$noop
    });
};
const $29779de3a21de1c2$export$41bc27d9d5d29437 = (props)=>{
    const { searchResultsCQLQueryReference: searchResultsCQLQueryReference } = props;
    const preloadedQueryData = (0, $irOoi.usePreloadedQuery)((0, $atY36.default), searchResultsCQLQueryReference);
    // Pagination hasPrevious state (hasPreviousPage from usePaginationFragment does not work with aggregator)
    // See https://hello.atlassian.net/wiki/x/lYYyQQE
    const hasPreviousRef = (0, $42omo.useRef)(false);
    const { data: data, loadNext: loadNext, isLoadingNext: isLoadingNext } = (0, $irOoi.usePaginationFragment)((0, $893fbbd3862eadef$export$2e2bcd8739ae039), preloadedQueryData);
    const cursor = data.confluence_search?.pageInfo?.endCursor;
    const fetchNextPage = (0, $42omo.useCallback)((nextCursor)=>{
        // Double check we're fetching with the cursor from our current results
        if (nextCursor === cursor) {
            loadNext(30);
            hasPreviousRef.current = true;
        }
    }, [
        loadNext,
        cursor
    ]);
    const edges = (0, $42omo.useMemo)(()=>{
        const rawEdges = data.confluence_search?.edges || [];
        return rawEdges.flatMap((edge)=>edge?.node ? [
                {
                    node: edge.node
                }
            ] : []);
    }, [
        data.confluence_search?.edges
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $280ef4355050ad69$export$92697b2a267ec7ef), {
        containsSearchResults: edges.length > 0,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($29779de3a21de1c2$var$SearchResultCQLWithData, {
                ...props,
                edges: edges,
                isLoadingNext: isLoadingNext,
                isPaginatedQuery: hasPreviousRef.current
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3d6c58437980e8c0$export$2e2bcd8739ae039), {
                cursor: cursor,
                isLoading: isLoadingNext,
                fetchNextPage: fetchNextPage
            })
        ]
    });
};
const $29779de3a21de1c2$var$transformEdgesToResultsForAnalytics = (edges)=>{
    return {
        edges: edges.map((edge)=>({
                node: {
                    id: edge.node.content?.ari || '',
                    __typename: edge.node.__typename,
                    integrationId: '',
                    providerId: ''
                }
            }))
    };
};
const $29779de3a21de1c2$var$transformEdgesToResultsShown = (edges)=>{
    return edges.map((edge, index)=>({
            id: edge.node.content?.ari || '',
            product: (0, $1yEFx.ProductKeys).Confluence,
            position: index,
            metadata: {}
        }));
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
























var $cbc8g = parcelRequire("cbc8g");








var $3Opgu = parcelRequire("3Opgu");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 


















var $14qs9 = parcelRequire("14qs9");


var $6CITI = parcelRequire("6CITI");




/* add-pin-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 





























/* add-pin-modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $ci7Ox = parcelRequire("ci7Ox");


var $a3fRD = parcelRequire("a3fRD");


var $3sFtD = parcelRequire("3sFtD");





var $8CZUH = parcelRequire("8CZUH");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");











var $99qsA = parcelRequire("99qsA");

var $6T8v4 = parcelRequire("6T8v4");



















const $e76663b399762183$export$6f8706b02e0c2b69 = 'KnowledgeDiscoveryAdminhubCreateBookmarkMutation';
const $e76663b399762183$export$e1178492acb07f49 = `
mutation ${$e76663b399762183$export$6f8706b02e0c2b69}($cloudId: ID!, $keyPhrases: [String!], $url: String!, $title: String!, $description: String, $orgId: String!) {
	knowledgeDiscovery {
	  createBookmark(
		input: {cloudId: $cloudId, keyPhrases: $keyPhrases, url: $url, title: $title, description: $description, orgId: $orgId}
	  ) @optIn(to: "KnowledgeDiscovery Create bookmarks in AdminHub") {
		... on KnowledgeDiscoveryCreateAdminhubBookmarkPayload {
		  success
		  errors {
			message
			extensions {
			  ... on KnowledgeDiscoveryBookmarkMutationErrorExtension {
				bookmarkFailureMetadata {
				  errorType
				  ... on KnowledgeDiscoveryBookmarkCollisionFailureMetadata {
					keyPhrase
				  }
				  ... on KnowledgeDiscoveryBookmarkValidationFailureMetadata {
					keyPhrase
				  }
				}
			  }
			}
		  }
		}
	  }
	}
}
`;


const $b742b3503a432451$export$903a58c223e37926 = ()=>{
    const createBookmark = (0, $42omo.useCallback)(async (variables, workspaceId, product)=>{
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $e76663b399762183$export$e1178492acb07f49),
            variables: variables,
            operationName: (0, $e76663b399762183$export$6f8706b02e0c2b69),
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: variables.cloudId,
                product: product
            })
        }).then((response)=>{
            if (response?.data?.knowledgeDiscovery.createBookmark) {
                const createBookmarkResponse = response?.data?.knowledgeDiscovery.createBookmark;
                return {
                    success: createBookmarkResponse.success,
                    errors: createBookmarkResponse.errors || []
                };
            } else throw new Error('createBookmark mutation unsuccessful');
        });
    }, []);
    return {
        createBookmark: createBookmark
    };
};








const $098cea0b1e42c41d$export$c45e6f9e899c207d = 'KnowledgeDiscoveryAdminhubUpdateBookmarkMutation';
const $098cea0b1e42c41d$export$a3374c2b287ba43a = `
	mutation ${$098cea0b1e42c41d$export$c45e6f9e899c207d}(
		$cloudId: ID!, $bookmarkAdminhubId: ID!, $keyPhrases: [String!], $url: String!, $title: String!, $description: String, $orgId: String!
	) {
		knowledgeDiscovery {
			updateBookmark(
				input: {cloudId: $cloudId, bookmarkAdminhubId: $bookmarkAdminhubId, keyPhrases: $keyPhrases, url: $url, title: $title, description: $description, orgId: $orgId}
			) @optIn(to: "KnowledgeDiscovery Update bookmarks in AdminHub") {
				... on KnowledgeDiscoveryUpdateAdminhubBookmarkPayload {
					success
					errors {
						message
						extensions {
								... on KnowledgeDiscoveryBookmarkMutationErrorExtension {
								bookmarkFailureMetadata {
									errorType
									... on KnowledgeDiscoveryBookmarkCollisionFailureMetadata {
									keyPhrase
									}
									... on KnowledgeDiscoveryBookmarkValidationFailureMetadata {
									keyPhrase
									}
								}
							}
						}
					}
					adminhubBookmark {
						id
						properties {
							title
							description
							keyPhrases
							url
						}
        	}
				}
			}
		}
	}
`;


const $a30de311e583bce0$export$b0239751d777b2c7 = ()=>{
    const updateBookmark = (0, $42omo.useCallback)(async (variables)=>{
        return (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $098cea0b1e42c41d$export$a3374c2b287ba43a),
            variables: variables,
            operationName: (0, $098cea0b1e42c41d$export$c45e6f9e899c207d)
        }).then((response)=>{
            const updateBookmarkResponse = response?.data?.knowledgeDiscovery.updateBookmark;
            if (updateBookmarkResponse) return {
                success: updateBookmarkResponse.success,
                errors: updateBookmarkResponse.errors || [],
                adminhubBookmark: updateBookmarkResponse.adminhubBookmark
            };
            else throw new Error('updateBookmark mutation unsuccessful');
        });
    }, []);
    return {
        updateBookmark: updateBookmark
    };
};


const $43a8111b3f86df0f$export$602118ec0b4836ea = (keyPhraseValues)=>keyPhraseValues.map((keyPhraseValue)=>({
            label: keyPhraseValue,
            value: keyPhraseValue
        }));



var $1JvBr = parcelRequire("1JvBr");

const $94ec37e0524e6db7$export$ac8106eaa11606a8 = ({ orgId: orgId })=>{
    const env = (0, $1JvBr.getEnvironment)();
    const route = `o/${orgId}/rovo`;
    switch(env){
        case 'development':
        case 'staging':
            return `https://admin.stg.atlassian.com/${route}`;
        default:
            return `https://admin.atlassian.com/${route}`;
    }
};





const $97841560b31a4348$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    pin_title: {
        id: "search_ai.bookmark.title",
        defaultMessage: "Bookmarked by your company"
    },
    pin_title_suggested: {
        id: "search_ai.bookmark.title_suggested",
        defaultMessage: "Bookmark suggested by Rovo"
    },
    pin_icon_label: {
        id: "search_ai.bookmark.icon_label",
        defaultMessage: "Search bookmark icon"
    },
    add_another_pin_button_label: {
        id: "search_ai.bookmark.add_another_pin_button",
        defaultMessage: "Add another bookmark"
    },
    add_pin_button_label: {
        id: "search_ai.bookmark.add_pin_button",
        defaultMessage: "Add bookmark"
    },
    learn_about_pins: {
        id: "search_ai.bookmark.info_link",
        defaultMessage: "Learn more about bookmarks"
    },
    add_pin_card_copy: {
        id: "search_ai.bookmark.add_pin_card_copy",
        defaultMessage: "Add a bookmark so your teammates find things faster"
    },
    dismiss: {
        id: "search_ai.bookmark.add_pin_dismiss",
        defaultMessage: "Dismiss"
    },
    pinModalAddPinHeader: {
        id: "search_ai.bookmark.modal-add-header",
        defaultMessage: "Add a new bookmark"
    },
    pinModalSubheaderLine1: {
        id: "search_ai.bookmark.modal-subheader-line-1",
        defaultMessage: "Bookmarks allow you to show a search result first, based on particular search terms."
    },
    pinModalSubheaderLine2: {
        id: "search_ai.bookmark.modal-subheader-line-2",
        defaultMessage: "You can also create and manage bookmarks from <a>Admin Hub.</a>"
    },
    pinModalPinDetailsHeader: {
        id: "search_ai.bookmark.modal-pin-details",
        defaultMessage: "Bookmark details"
    },
    pinModalPinDetailsSubHeader: {
        id: "search_ai.bookmark.modal-pin-details-subheader",
        defaultMessage: "Everyone in your organization will see this result when they search for the terms."
    },
    pinModalSearchResultTitleHeader: {
        id: "search_ai.bookmark.modal-search-result-title-header",
        defaultMessage: "Search result title"
    },
    pinModalSearchResultTitlePlaceholder: {
        id: "search_ai.bookmark.modal-search-result-title-placeholder",
        defaultMessage: "Enter a title for this bookmark"
    },
    pinModalUrlHeader: {
        id: "search_ai.bookmark.modal-url-header",
        defaultMessage: "URL"
    },
    pinModalUrlPlaceholder: {
        id: "search_ai.bookmark.modal-url-placeholder",
        defaultMessage: "Enter internal or external URL for this bookmark"
    },
    pinModalDescriptionHeader: {
        id: "search_ai.bookmark.modal-description-header",
        defaultMessage: "Description"
    },
    pinModalDescriptionPlaceholder: {
        id: "search_ai.bookmark.modal-description-placeholder",
        defaultMessage: "Enter a short description for this bookmark"
    },
    pinModalSearchForTermsHeader: {
        id: "search_ai.bookmark.modal-search-terms-header",
        defaultMessage: "Search terms"
    },
    pinModalSearchForTermsPlaceholder: {
        id: "search_ai.bookmark.modal-search-terms-placeholder",
        defaultMessage: "Enter up to 5 terms to display this bookmark"
    },
    pinModalSearchForTermsTooltip: {
        id: "search_ai.bookmark.modal-search-terms-tooltip",
        defaultMessage: "Enter up to 5 terms that people can search for to display this bookmark. Terms can have multiple words (\"leave policy\"). Press enter to add a new term."
    },
    pinModalCancelButton: {
        id: "search_ai.bookmark.modal-cancel-button",
        defaultMessage: "Cancel"
    },
    pinModalAddButton: {
        id: "search_ai.bookmark.modal-add-button",
        defaultMessage: "Add"
    },
    pinModalNoTitleMessage: {
        id: "search_ai.bookmark.modal-no-title-msg",
        defaultMessage: "You must add a bookmark title."
    },
    pinModalNoUrlMessage: {
        id: "search_ai.bookmark.modal-no-url-msg",
        defaultMessage: "You must add a bookmark URL."
    },
    pinModalInvalidUrlMessage: {
        id: "search_ai.bookmark.modal-invalid-url-msg",
        defaultMessage: "You must add a valid absolute URL, for example 'http://www.atlassian.com'."
    },
    pinPhraseCollisionErr: {
        id: "search_ai.bookmark.modal-collision-err",
        defaultMessage: "{keyPhrases} {numKeyPhrases, plural, =1 {keyword is already used for another bookmark.} other {keywords are already used for another bookmark.}}"
    },
    pinKeyPhraseTooLongErr: {
        id: "search_ai.bookmark.modal-too-long-err",
        defaultMessage: "A search term can't be more than 50 characters."
    },
    pinKeyPhraseHasSpecialCharErr: {
        id: "search_ai.bookmark.modal-has-special-char-err",
        defaultMessage: "A search term can only contain letters, numbers, or spaces."
    },
    pinKeyPhraseListTooLongErr: {
        id: "search_ai.bookmark.modal-list-too-long-err",
        defaultMessage: "Maximum of 5 search terms per bookmark."
    },
    pinKeyPhraseListTooShortErr: {
        id: "search_ai.bookmark.modal-list-too-short-err",
        defaultMessage: "You must add at least one term."
    },
    pinKeyPhraseListNonUniqueErr: {
        id: "search_ai.bookmark.modal-list-non-unique-err",
        defaultMessage: "Each term must be unique."
    },
    pinExists: {
        id: "search_ai.bookmark.modal-keyphrase-exists-err",
        defaultMessage: "This bookmark already exists."
    },
    pinGenericErrorMessage: {
        id: "search_ai.bookmark.generic-error-msg",
        defaultMessage: "Something went wrong and we couldn't add your bookmark. Wait a few moments and try again."
    },
    pinUpdateErrorMessage: {
        id: "search_ai.bookmark.update-error-msg",
        defaultMessage: "Something went wrong and we couldn't edit your bookmark. Wait a few moments and try again."
    },
    pinCreationSuccessFlagTitle: {
        id: "search_ai.bookmark.pin-creation-success-title",
        defaultMessage: "Search pin was added"
    },
    pinCreationSuccessFlagMessage: {
        id: "search_ai.bookmark.pin-creation-success-message",
        defaultMessage: "People will see it when they search for the terms you added."
    },
    pinSuggestionMainMessage: {
        id: "search_ai.bookmark.pin-suggestion-main-message",
        defaultMessage: "Your teammates are searching for \"{suggestedTerm}\" a lot"
    },
    pinSuggestionSubMessage: {
        id: "search_ai.bookmark.pin-suggestion-sub-message",
        defaultMessage: "Add a bookmarked link so your teammates find things faster."
    },
    pinCompanyAddedTooltip: {
        id: "search_ai.bookmark.pin-company-added-tooltip",
        defaultMessage: "This result was prioritized by your admin to help you quickly find it."
    },
    pinSuggestedTooltip: {
        id: "search_ai.bookmark.pin-suggested-tooltip",
        defaultMessage: "This result was suggested by AI based on your company's content."
    },
    pinCopyUrlTooltip: {
        id: "search_ai.bookmark.pin-copy-url-tooltip",
        defaultMessage: "Copy bookmark URL"
    },
    pinFeedbackSubmittedFlagMessage: {
        id: "search_ai.bookmark.feedback-submitted-flag-message",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    },
    bookmarkEditTooltip: {
        id: "search_ai.bookmark.edit-tooltip",
        defaultMessage: "Edit bookmark"
    },
    bookmarkModalUpdateHeader: {
        id: "search_ai.bookmark.modal-update-header",
        defaultMessage: "Edit bookmark"
    },
    bookmarkModalUpdateButton: {
        id: "search_ai.bookmark.modal-update-button",
        defaultMessage: "Save"
    },
    bookmarkUpdateSuccessFlagTitle: {
        id: "search_ai.bookmark.update-success-title",
        defaultMessage: "Bookmark was updated"
    },
    userCreatedBookmarksFeatureTitle: {
        id: "search_ai.bookmark.user-created-feature-title",
        defaultMessage: "user-created bookmarks"
    }
});





const $ce57dc7d18b5bf6b$export$4f6bc579055d1a30 = (nonPrivacySafeAttributes, source)=>{
    try {
        return {
            action: 'clicked',
            actionSubject: 'aiSearchBookmarkAddButton',
            eventType: 'ui',
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            source: source
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onAddPin'
        });
        return {};
    }
};





const $dd2e57b941d98056$export$5c4a25c0b9d2f87d = (isUpdateModal, source)=>{
    try {
        return {
            action: 'shown',
            actionSubject: isUpdateModal ? 'aiSearchBookmarkOpenUpdateModal' : 'aiSearchBookmarkOpenAddModal',
            eventType: 'track',
            source: source
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onAddPinModalOpen'
        });
        return {};
    }
};





const $354a05f9b00025b3$export$e0596a2b847403aa = (isUpdateModal)=>{
    try {
        return {
            action: 'failed',
            actionSubject: isUpdateModal ? 'aiSearchBookmarkUpdate' : 'aiSearchBookmarkAddDismiss',
            eventType: 'track'
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onBookmarkAddFailed'
        });
        return {};
    }
};





const $bd2b7f7162378493$export$6f152bea48442457 = (nonPrivacySafeAttributes, source)=>{
    try {
        return {
            action: 'clicked',
            actionSubject: 'aiSearchBookmarkUpdateButton',
            eventType: 'ui',
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            source: source
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onUpdatePin'
        });
        return {};
    }
};


const $6546ec63e3319fe1$export$fc99885b7e473d08 = (str)=>{
    let givenURL;
    try {
        givenURL = new URL(str);
    } catch (error) {
        return false;
    }
    return givenURL.protocol === 'http:' || givenURL.protocol === 'https:';
};





parcelRequire("42omo");






var $efd7cf01f00f37ea$export$86984fac8e6cbdf2 = /*#__PURE__*/ function(SearchPinKeyphraseErrorState) {
    SearchPinKeyphraseErrorState["KEY_PHRASE_COLLISION"] = "KEY_PHRASE_COLLISION";
    SearchPinKeyphraseErrorState["KEY_PHRASE_TOO_LONG"] = "KEY_PHRASE_TOO_LONG";
    SearchPinKeyphraseErrorState["KEY_PHRASE_HAS_SPECIAL_CHAR"] = "KEY_PHRASE_HAS_SPECIAL_CHAR";
    SearchPinKeyphraseErrorState["KEY_PHRASE_LIST_TOO_LONG"] = "KEY_PHRASE_LIST_TOO_LONG";
    SearchPinKeyphraseErrorState["KEY_PHRASE_LIST_TOO_SHORT"] = "KEY_PHRASE_LIST_TOO_SHORT";
    SearchPinKeyphraseErrorState["KEY_PHRASE_LIST_NON_UNIQUE"] = "KEY_PHRASE_LIST_NON_UNIQUE";
    return SearchPinKeyphraseErrorState;
}({});
const $efd7cf01f00f37ea$export$46c6f0a9bc3dc55e = (keyPhraseErrorState, collidedKeyPhrases, numCollidedKeyPhrases)=>{
    switch(keyPhraseErrorState){
        case "KEY_PHRASE_COLLISION":
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinPhraseCollisionErr,
                values: {
                    keyPhrases: collidedKeyPhrases,
                    numKeyPhrases: numCollidedKeyPhrases
                }
            });
        case "KEY_PHRASE_TOO_LONG":
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinKeyPhraseTooLongErr
            });
        case "KEY_PHRASE_HAS_SPECIAL_CHAR":
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinKeyPhraseHasSpecialCharErr
            });
        case "KEY_PHRASE_LIST_NON_UNIQUE":
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinKeyPhraseListNonUniqueErr
            });
        case "KEY_PHRASE_LIST_TOO_LONG":
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinKeyPhraseListTooLongErr
            });
        case "KEY_PHRASE_LIST_TOO_SHORT":
        default:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinKeyPhraseListTooShortErr
            });
    }
};
const $efd7cf01f00f37ea$export$a8015f8bc7d64b8c = (mutationErrors)=>{
    const collidedKeyPhrases = [];
    mutationErrors.forEach((err)=>{
        if (err.extensions?.bookmarkFailureMetadata && err.extensions.bookmarkFailureMetadata.errorType === "KEY_PHRASE_COLLISION") collidedKeyPhrases.push(err.extensions.bookmarkFailureMetadata.keyPhrase);
    });
    return collidedKeyPhrases;
};


const $7b98dae0b13f338b$var$styles = {
    modalBody: "_19bv1ejb _u5f31ejb",
    formFieldsContainer: "_19pk1ejb"
};
const $7b98dae0b13f338b$var$KEY_PHRASE_MAX_LENGTH = 50;
const $7b98dae0b13f338b$var$KEY_PHRASES_LIST_MAX_LENGTH = 5;
const $7b98dae0b13f338b$export$6b6672b81db1fb01 = ({ orgId: orgId, cloudId: cloudId, hasAdminhubAccess: hasAdminhubAccess, handleClose: handleClose, onSuccessCallback: onSuccessCallback, query: query, workspaceId: workspaceId, product: product, existingBookmark: existingBookmark, source: source })=>{
    const { formatList: formatList, formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const isUpdateModal = !!existingBookmark;
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $dd2e57b941d98056$export$5c4a25c0b9d2f87d)(isUpdateModal, source)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [hasGenericError, setHasGenericError] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [pinTitle, setPinTitle] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(isUpdateModal ? existingBookmark.properties.title : query || '');
    const [pinTitleErr, setPinTitleErr] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const onPinTitleChange = (input, actionMeta)=>{
        if (actionMeta.action === 'input-change') {
            setPinTitleErr(false);
            setPinTitle(input);
        }
    };
    const onPinTitleBlur = ()=>{
        if (!pinTitle) setPinTitleErr(true);
    };
    const [pinUrl, setPinUrl] = (0, $42omo.useState)(isUpdateModal ? existingBookmark.properties.url : '');
    const [pinUrlErr, setPinUrlErr] = (0, $42omo.useState)({
        isError: false
    });
    const onPinUrlChange = (input, actionMeta)=>{
        if (actionMeta.action === 'input-change') {
            setPinUrlErr({
                isError: false
            });
            setPinUrl(input);
        }
    };
    const onPinUrlBlur = ()=>{
        if (!pinUrl) setPinUrlErr({
            isError: true,
            type: 'empty'
        });
        else if (!(0, $6546ec63e3319fe1$export$fc99885b7e473d08)(pinUrl)) setPinUrlErr({
            isError: true,
            type: 'invalid'
        });
    };
    const renderUrlErroredMessage = ()=>{
        if (pinUrlErr.isError && pinUrlErr.type === 'empty') return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalNoUrlMessage
        });
        if (pinUrlErr.isError && pinUrlErr.type === 'invalid') return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
            ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalInvalidUrlMessage
        });
    };
    const [pinDescription, setPinDescription] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(isUpdateModal ? existingBookmark.properties.description : '');
    const onPinDescriptionChange = (input, actionMeta)=>{
        if (actionMeta.action === 'input-change') setPinDescription(input);
    };
    const [pinKeyPhrases, setPinKeyPhrases] = (0, $42omo.useState)(isUpdateModal ? [
        {
            label: existingBookmark.properties.keyPhrase,
            value: existingBookmark.properties.keyPhrase
        }
    ] : query ? [
        {
            label: query,
            value: query
        }
    ] : []);
    const [keyPhraseErr, setKeyPhraseErr] = (0, $42omo.useState)(undefined);
    const [collidedKeyPhrases, setCollidedKeyPhrases] = (0, $42omo.useState)([]); // key phrase that user has typed in input
    const [typedKeyPhrase, setTypedKeyPhrase] = (0, $42omo.useState)('');
    const onTypedKeyPhraseChange = (inputValue, event)=>{
        if (event?.action === 'input-blur' || event?.action === 'menu-close') return;
        setKeyPhraseErr(undefined);
        setTypedKeyPhrase(inputValue);
    };
    const onPinKeyPhrasesChange = (newPins, _actionMeta)=>{
        setKeyPhraseErr(undefined);
        setPinKeyPhrases(newPins);
    };
    const onPinKeyPhraseSubmit = ()=>{
        const normalizedKeyPhrase = typedKeyPhrase.trim().toLowerCase(); // if nothing has been typed and user clicks tab, tab to button
        if (!normalizedKeyPhrase.length) return false;
        if (normalizedKeyPhrase.length > $7b98dae0b13f338b$var$KEY_PHRASE_MAX_LENGTH) {
            setKeyPhraseErr((0, $efd7cf01f00f37ea$export$86984fac8e6cbdf2).KEY_PHRASE_TOO_LONG);
            return true;
        }
        const specialCharsRegex = new RegExp(/[^\w\s]+|_+/);
        if (specialCharsRegex.test(normalizedKeyPhrase)) {
            setKeyPhraseErr((0, $efd7cf01f00f37ea$export$86984fac8e6cbdf2).KEY_PHRASE_HAS_SPECIAL_CHAR);
            return true;
        }
        const updatedKeyPhrases = (0, $43a8111b3f86df0f$export$602118ec0b4836ea)([
            ...new Set([
                ...pinKeyPhrases.map((keyPhrase)=>keyPhrase.value),
                normalizedKeyPhrase
            ])
        ]);
        if (updatedKeyPhrases.length > $7b98dae0b13f338b$var$KEY_PHRASES_LIST_MAX_LENGTH) {
            setKeyPhraseErr((0, $efd7cf01f00f37ea$export$86984fac8e6cbdf2).KEY_PHRASE_LIST_TOO_LONG);
            setTypedKeyPhrase('');
            return true;
        }
        setPinKeyPhrases(updatedKeyPhrases);
        setTypedKeyPhrase('');
        return true;
    };
    const onPinKeyPhrasesKeyDown = (event)=>{
        if (![
            'Tab',
            'Enter'
        ].includes(event.key)) return;
        const successfulSubmitOrKeyPhraseErr = onPinKeyPhraseSubmit();
        if (successfulSubmitOrKeyPhraseErr) // do not want to tab to button if user still adding key phrases or needs to correct a keyphrase
        event.preventDefault();
    };
    const onPinKeyPhrasesBlur = ()=>{
        // want to show this error only if no key phrase has been added AND user hasn't typed anything yet
        if (!pinKeyPhrases.length && !typedKeyPhrase) {
            setKeyPhraseErr((0, $efd7cf01f00f37ea$export$86984fac8e6cbdf2).KEY_PHRASE_LIST_TOO_SHORT);
            return;
        }
        setKeyPhraseErr(undefined); // add what user has typed so far as a keyphrase; if invalid keyphrase show error message
        if (typedKeyPhrase) onPinKeyPhraseSubmit();
    };
    const onClose = ()=>{
        // reset
        setPinTitle('');
        setPinUrl('');
        setPinDescription('');
        setPinKeyPhrases([]);
        setPinTitleErr(false);
        setPinUrlErr({
            isError: false
        });
        setKeyPhraseErr(undefined);
        handleClose();
    };
    const createSearchPinDisabled = !pinTitle || !(0, $6546ec63e3319fe1$export$fc99885b7e473d08)(pinUrl) || !pinKeyPhrases.length;
    const [createSearchPinLoading, setCreateSearchPinLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const { createBookmark: createBookmark } = (0, $b742b3503a432451$export$903a58c223e37926)();
    const { updateBookmark: updateBookmark } = (0, $a30de311e583bce0$export$b0239751d777b2c7)();
    const onCreateSearchPin = async ()=>{
        try {
            setHasGenericError(false);
            setCreateSearchPinLoading(true);
            const newPin = isUpdateModal ? await updateBookmark({
                cloudId: cloudId,
                orgId: orgId,
                keyPhrases: pinKeyPhrases.map((keyPhrase)=>keyPhrase.value),
                url: pinUrl,
                title: pinTitle,
                description: pinDescription,
                bookmarkAdminhubId: existingBookmark.properties.parentAdminhubBookmarkId ?? ''
            }) : await createBookmark({
                cloudId: cloudId,
                orgId: orgId,
                keyPhrases: pinKeyPhrases.map((keyPhrase)=>keyPhrase.value),
                url: pinUrl,
                title: pinTitle,
                description: pinDescription
            }, workspaceId, product); // check for keyphrase errors from the backend
            if (newPin.errors && newPin.errors.length) {
                const collidedKeyPhrasesList = (0, $efd7cf01f00f37ea$export$a8015f8bc7d64b8c)(newPin.errors);
                if (collidedKeyPhrasesList.length) {
                    setKeyPhraseErr((0, $efd7cf01f00f37ea$export$86984fac8e6cbdf2).KEY_PHRASE_COLLISION);
                    setCollidedKeyPhrases(collidedKeyPhrasesList);
                    setCreateSearchPinLoading(false);
                    return;
                }
                throw new Error(newPin.errors[0]?.message ?? 'Generic Error');
            }
            if (isUpdateModal) fireAnalyticsEvent((0, $bd2b7f7162378493$export$6f152bea48442457)({
                title: pinTitle,
                url: pinUrl,
                keyPhrases: pinKeyPhrases.map((keyPhrase)=>keyPhrase.value),
                description: pinDescription
            }, source ?? 'unknown'));
            else fireAnalyticsEvent((0, $ce57dc7d18b5bf6b$export$4f6bc579055d1a30)({
                title: pinTitle,
                url: pinUrl,
                keyPhrases: pinKeyPhrases.map((keyPhrase)=>keyPhrase.value),
                description: pinDescription
            }, source ?? 'unknown'));
            showFlag({
                isAutoDismiss: true,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon-success, #6A9A23)"
                }),
                id: 'create-search-pin',
                title: isUpdateModal ? formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).bookmarkUpdateSuccessFlagTitle) : formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pinCreationSuccessFlagTitle),
                description: isUpdateModal ? undefined : formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pinCreationSuccessFlagMessage)
            });
            onClose();
            onSuccessCallback && onSuccessCallback();
        } catch (error) {
            setHasGenericError(true);
            fireAnalyticsEvent((0, $354a05f9b00025b3$export$e0596a2b847403aa)(isUpdateModal));
            (0, $4Zqgi.logger).error({
                error: error,
                functionName: 'onCreateSearchPin'
            });
        } finally{
            setCreateSearchPinLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        children: isUpdateModal ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $97841560b31a4348$export$defe85febe8b728c).bookmarkModalUpdateHeader
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                            ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalAddPinHeader
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $7b98dae0b13f338b$var$styles.modalBody,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                            gap: "space.100",
                            direction: "column",
                            children: hasGenericError ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.050",
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                                        label: "",
                                        color: "var(--ds-text-danger, #AE2E24)"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        color: "color.text.danger",
                                        children: isUpdateModal ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                            ...(0, $97841560b31a4348$export$defe85febe8b728c).pinUpdateErrorMessage
                                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                            ...(0, $97841560b31a4348$export$defe85febe8b728c).pinGenericErrorMessage
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                            ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalSubheaderLine1
                                        })
                                    }),
                                    hasAdminhubAccess && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                            ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalSubheaderLine2,
                                            values: {
                                                a: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                        href: (0, $94ec37e0524e6db7$export$ac8106eaa11606a8)({
                                                            orgId: orgId
                                                        }),
                                                        children: chunks
                                                    })
                                            }
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            gap: "space.200",
                            direction: "column",
                            xcss: $7b98dae0b13f338b$var$styles.formFieldsContainer,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    gap: "space.100",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            weight: "semibold",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalPinDetailsHeader
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalPinDetailsSubHeader
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    gap: "space.050",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "small",
                                            weight: "medium",
                                            color: "color.text.subtle",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalSearchResultTitleHeader
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                                            components: {
                                                DropdownIndicator: ()=>null,
                                                Menu: ()=>null
                                            },
                                            inputValue: pinTitle,
                                            onInputChange: onPinTitleChange,
                                            onBlur: onPinTitleBlur,
                                            placeholder: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pinModalSearchResultTitlePlaceholder)
                                        }),
                                        pinTitleErr && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            space: "space.050",
                                            alignBlock: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                                                    label: "",
                                                    color: "var(--ds-text-danger, #AE2E24)"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    size: "small",
                                                    color: "color.text.danger",
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                                        ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalNoTitleMessage
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    gap: "space.050",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "small",
                                            weight: "medium",
                                            color: "color.text.subtle",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalUrlHeader
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                                            components: {
                                                DropdownIndicator: ()=>null,
                                                Menu: ()=>null
                                            },
                                            inputValue: pinUrl,
                                            onInputChange: onPinUrlChange,
                                            onBlur: onPinUrlBlur,
                                            placeholder: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pinModalUrlPlaceholder),
                                            testId: "add-pin-modal-url-input"
                                        }),
                                        pinUrlErr.isError && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            space: "space.050",
                                            alignBlock: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                                                    label: "",
                                                    color: "var(--ds-text-danger, #AE2E24)"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    size: "small",
                                                    color: "color.text.danger",
                                                    children: renderUrlErroredMessage()
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    gap: "space.050",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "small",
                                            weight: "medium",
                                            color: "color.text.subtle",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalDescriptionHeader
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                                            components: {
                                                DropdownIndicator: ()=>null,
                                                Menu: ()=>null
                                            },
                                            inputValue: pinDescription,
                                            onInputChange: onPinDescriptionChange,
                                            placeholder: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pinModalDescriptionPlaceholder)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                    gap: "space.050",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            space: "space.050",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    size: "small",
                                                    weight: "medium",
                                                    color: "color.text.subtle",
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                                        ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalSearchForTermsHeader
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                                    content: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pinModalSearchForTermsTooltip),
                                                    position: "bottom-start",
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                                                        color: "currentColor",
                                                        label: ""
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $99qsA.default), {
                                            components: {
                                                DropdownIndicator: ()=>null,
                                                Menu: ()=>null
                                            },
                                            isMulti: true,
                                            inputValue: typedKeyPhrase,
                                            onInputChange: onTypedKeyPhraseChange,
                                            defaultValue: pinKeyPhrases,
                                            value: pinKeyPhrases,
                                            onKeyDown: onPinKeyPhrasesKeyDown,
                                            onChange: onPinKeyPhrasesChange,
                                            onBlur: onPinKeyPhrasesBlur,
                                            placeholder: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pinModalSearchForTermsPlaceholder),
                                            testId: "add-pin-modal-key-phrase-input"
                                        }),
                                        keyPhraseErr && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            space: "space.050",
                                            alignBlock: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                                                    label: "",
                                                    color: "var(--ds-text-danger, #AE2E24)"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    size: "small",
                                                    color: "color.text.danger",
                                                    children: (0, $efd7cf01f00f37ea$export$46c6f0a9bc3dc55e)(keyPhraseErr, formatList(collidedKeyPhrases, {
                                                        style: 'long',
                                                        type: 'conjunction'
                                                    }), collidedKeyPhrases.length)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            testId: "add-search-pin-cancel-button",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalCancelButton
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "primary",
                            isDisabled: createSearchPinDisabled,
                            onClick: onCreateSearchPin,
                            isLoading: createSearchPinLoading,
                            testId: "bookmark-submit-button",
                            children: isUpdateModal ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $97841560b31a4348$export$defe85febe8b728c).bookmarkModalUpdateButton
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                ...(0, $97841560b31a4348$export$defe85febe8b728c).pinModalAddButton
                            })
                        })
                    ]
                })
            ]
        })
    });
};






const $01ae3194c42ce060$export$7d18122d8e1ee01a = (props)=>{
    try {
        const { query: query } = props;
        return {
            action: 'shown',
            actionSubject: 'aiSearchAddBookmark',
            eventType: 'track',
            nonPrivacySafeAttributes: {
                query: query
            }
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onAddBookmarkShown'
        });
        return {};
    }
};





const $332f9741a3e433f9$export$77b64c33e6bdaf7c = ()=>{
    try {
        return {
            action: 'clicked',
            actionSubject: 'aiSearchBookmarkAddLearnMore',
            eventType: 'ui'
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onLearnMoreAboutPinsClick'
        });
        return {};
    }
};


const $f3c680f674639682$var$styles = {
    container: "_nd5l1b0a _2rko12b0 _zulputpp _1e0c1txw _2lx21bp4 _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi _bfhk1s93",
    grid: "_gy1pze3t _1lmclxlj _yv0e1ghl",
    cardCopy: "_nd5l16yo",
    addPin: "_nd5l1uoe _10fpesu3 _1wpz1h6o",
    linkContainer: "_nd5l16yl"
};
const $f3c680f674639682$var$LEARN_MORE_URL = 'https://support.atlassian.com/organization-administration/docs/add-or-edit-rovo-search-bookmarks/';
const $f3c680f674639682$export$5cc0b8a7a0e0e4df = /*#__PURE__*/ (0, $42omo.memo)(({ query: query, orgId: orgId, cloudId: cloudId, callbacks: callbacks, hasAdminhubAccess: hasAdminhubAccess, workspaceId: workspaceId, product: product })=>{
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [showModal, setShowModal] = (0, $42omo.useState)(false);
    const onDismissClicked = ()=>callbacks.onDismissCallback();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $01ae3194c42ce060$export$7d18122d8e1ee01a)({
            query: query
        }));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $f3c680f674639682$var$styles.container,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                    xcss: $f3c680f674639682$var$styles.grid,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $f3c680f674639682$var$styles.cardCopy,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                children: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).add_pin_card_copy)
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $f3c680f674639682$var$styles.addPin,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                spacing: "compact",
                                onClick: ()=>setShowModal(true),
                                children: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).add_pin_button_label)
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $f3c680f674639682$var$styles.linkContainer,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                space: "space.100",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                        href: $f3c680f674639682$var$LEARN_MORE_URL,
                                        onClick: ()=>fireAnalyticsEvent((0, $332f9741a3e433f9$export$77b64c33e6bdaf7c)()),
                                        children: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).learn_about_pins)
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                        href: "",
                                        onClick: onDismissClicked,
                                        children: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).dismiss)
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            showModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $7b98dae0b13f338b$export$6b6672b81db1fb01), {
                query: query,
                handleClose: ()=>setShowModal(false),
                orgId: orgId,
                cloudId: cloudId,
                hasAdminhubAccess: hasAdminhubAccess,
                onSuccessCallback: callbacks.onSuccessCallback,
                workspaceId: workspaceId,
                product: product,
                source: "adminOnboarding"
            })
        ]
    });
});








const $5c40ea1dddca0440$var$DEFAULT_TTL = 300000;
class $5c40ea1dddca0440$var$InMemCache {
    static setCacheData(key, data) {
        this.cache[key] = {
            ttl: Date.now() + $5c40ea1dddca0440$var$DEFAULT_TTL,
            data: data
        };
    }
    static getCacheData(key) {
        return key in this.cache && Date.now() < this.cache[key].ttl ? this.cache[key].data : undefined;
    }
}
$5c40ea1dddca0440$var$InMemCache.cache = {};
const $5c40ea1dddca0440$export$eda8930120443143 = ({ cloudId: cloudId, orgId: orgId })=>{
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [hasBookmarkCreationAccess, setBookmarkCreationAccess] = (0, $42omo.useState)(false);
    const [hasAdminhubAccess, setHasAdminhubAccess] = (0, $42omo.useState)(false);
    const key = `${orgId}:${cloudId}`;
    const resource = (0, $42omo.useMemo)(()=>{
        return {
            orgAdmin: `ari:cloud:platform::org/${orgId}`,
            confluenceAdmin: `ari:cloud:confluence::site/${cloudId}`,
            jiraAdmin: `ari:cloud:jira::site/${cloudId}`,
            siteAdmin: `ari:cloud:platform::site/${cloudId}`
        };
    }, [
        orgId,
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!cloudId || !orgId) return;
        const callApi = async ()=>{
            setLoading(true);
            try {
                let data = $5c40ea1dddca0440$var$InMemCache.getCacheData(key);
                if (!data) {
                    const response = await fetch('/gateway/api/permissions/bulk/permitted', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify([
                            {
                                permissionId: 'manage/org',
                                resourceId: resource.orgAdmin
                            },
                            {
                                permissionId: 'manage',
                                resourceId: resource.confluenceAdmin
                            },
                            {
                                permissionId: 'manage',
                                resourceId: resource.jiraAdmin
                            },
                            {
                                permissionId: 'manage',
                                resourceId: resource.siteAdmin
                            }
                        ])
                    });
                    data = await response.json();
                    if (!Array.isArray(data)) throw new Error(data?.errorDetail || '/permissions/bulk/permitted failure');
                    $5c40ea1dddca0440$var$InMemCache.setCacheData(key, data);
                }
                setLoading(false);
                return data;
            } catch (error) {
                (0, $4Zqgi.logger).error({
                    error: error,
                    functionName: 'useAdminPermissions'
                });
                setLoading(false);
                return [];
            }
        };
        const checkPermissions = async ()=>{
            const permissions = await callApi();
            let userIsSomeAdmin = false;
            let userIsOrgAdmin = false;
            if (!permissions?.length) return;
            for (const permission of permissions){
                // allow creation of bookmarks if the user is any type of admin
                if (permission.permitted) userIsSomeAdmin = true;
                if (permission.resourceId === resource.orgAdmin && permission.permitted) userIsOrgAdmin = true;
            }
            setBookmarkCreationAccess(userIsSomeAdmin);
            setHasAdminhubAccess(userIsOrgAdmin);
        };
        checkPermissions();
    }, [
        cloudId,
        orgId,
        key,
        resource
    ]);
    return {
        hasBookmarkCreationAccess: hasBookmarkCreationAccess,
        hasAdminhubAccess: hasAdminhubAccess,
        loading: loading
    };
};








const $f105b5d9df5babad$export$2a78b23d2a3ac84b = 'KnowledgeDiscoveryBookmark';
const $f105b5d9df5babad$export$2464d968d37100c9 = `
	query ${$f105b5d9df5babad$export$2a78b23d2a3ac84b}($cloudId: String!, $keyPhrase: String!) {
		knowledgeDiscovery {
			bookmark(cloudId: $cloudId, keyPhrase: $keyPhrase) {
				__typename
				... on KnowledgeDiscoveryBookmark {
					id
					properties {
						url
						title
						description
						bookmarkState
						lastModifierAccountId
						keyPhrase
						parentAdminhubBookmarkId
					}
				}
				... on QueryError {
					identifier
					message
					extensions {
						errorType
						statusCode
						... on GenericQueryErrorExtension {
							errorType
							statusCode
						}
					}
				}
			}
		}
	}
`;


var $907ac179b537c87a$export$e12e02cef8635961 = /*#__PURE__*/ function(BookmarkState) {
    BookmarkState["ACTIVE"] = "ACTIVE";
    BookmarkState["SUGGESTED"] = "SUGGESTED";
    return BookmarkState;
}({});
const $907ac179b537c87a$export$7a8af96e1dd8695b = async (variables, workspaceId, product)=>{
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $f105b5d9df5babad$export$2464d968d37100c9),
        variables: variables,
        operationName: (0, $f105b5d9df5babad$export$2a78b23d2a3ac84b),
        headers: (0, $6yuru.createAtlAttributionHeader)({
            atlWorkspaceId: workspaceId,
            tenantId: variables.cloudId,
            product: product
        })
    }).then((response)=>{
        return {
            data: response.data?.knowledgeDiscovery?.bookmark,
            requestId: response.extensions?.gateway?.request_id ?? null
        };
    });
};


/* bookmark-knowledge-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $6uGcC = parcelRequire("6uGcC");


var $x4n5k = parcelRequire("x4n5k");


























var $bpAj5 = parcelRequire("bpAj5");











var $59vy4 = parcelRequire("59vy4");







const $e9e876f82a3b31d5$export$5335101d48c968c3 = ({ elementRef: elementRef, onDwellEnd: onDwellEnd })=>{
    const [isInViewport, setIsInViewport] = (0, $42omo.useState)(false);
    const [tabHasFocus, setTabHasFocus] = (0, $42omo.useState)(true);
    const dwellStartTimeRef = (0, $42omo.useRef)();
    const isDwellingRef = (0, $42omo.useRef)(false);
    // Track viewport intersection
    (0, $42omo.useEffect)(()=>{
        if (!elementRef.current) return;
        const observer = new IntersectionObserver(([entry])=>{
            setIsInViewport(entry.isIntersecting);
        }, {
            threshold: 1.0
        });
        observer.observe(elementRef.current);
        return ()=>{
            observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        elementRef.current
    ]);
    // Set up focus and navigation event listeners
    (0, $42omo.useEffect)(()=>{
        const handleVisibilityChange = ()=>{
            setTabHasFocus(!document.hidden);
        };
        const handleFocus = ()=>setTabHasFocus(true);
        const handleBlur = ()=>setTabHasFocus(false);
        const handleNavigation = ()=>{
            if (isDwellingRef.current && dwellStartTimeRef.current) {
                const dwellTime = Date.now() - dwellStartTimeRef.current;
                onDwellEnd?.(dwellTime);
            }
        };
        // Set up all event listeners using bind-event-listener
        const unbindVisibilityChange = (0, $fFa3V.bind)(document, {
            type: 'visibilitychange',
            listener: handleVisibilityChange
        });
        const unbindFocus = (0, $fFa3V.bind)(window, {
            type: 'focus',
            listener: handleFocus
        });
        const unbindBlur = (0, $fFa3V.bind)(window, {
            type: 'blur',
            listener: handleBlur
        });
        const unbindNavigation = (0, $fFa3V.bind)(window, {
            type: 'beforeunload',
            listener: handleNavigation
        });
        return ()=>{
            unbindVisibilityChange();
            unbindFocus();
            unbindBlur();
            unbindNavigation();
            // Fire on unmount if still dwelling
            if (isDwellingRef.current && dwellStartTimeRef.current) {
                const dwellTime = Date.now() - dwellStartTimeRef.current;
                onDwellEnd?.(dwellTime);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Handle dwell start/end logic based on state changes
    (0, $42omo.useEffect)(()=>{
        const shouldDwell = isInViewport && tabHasFocus;
        // Start dwelling
        if (shouldDwell && !isDwellingRef.current) {
            dwellStartTimeRef.current = Date.now();
            isDwellingRef.current = true;
        }
        // End dwelling (viewport exit)
        if (!shouldDwell && isDwellingRef.current && dwellStartTimeRef.current) {
            const dwellTime = Date.now() - dwellStartTimeRef.current;
            onDwellEnd?.(dwellTime);
            isDwellingRef.current = false;
            dwellStartTimeRef.current = undefined;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isInViewport,
        tabHasFocus
    ]);
};






var $6M0KD = parcelRequire("6M0KD");


var $fJBWn = parcelRequire("fJBWn");








var $df7ed = parcelRequire("df7ed");



/* bookmark-invisible-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $fe4d5bca7ad2879a$var$styles = {
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1itkglyw _bfhk1j28 _r06hglyw"
};
const $fe4d5bca7ad2879a$export$d0f9d04b7863337a = ({ url: url, onClick: onClick, onMouseEnter: onMouseEnter = ()=>{}, onMouseLeave: onMouseLeave = ()=>{}, label: label, testId: testId = 'bookmark-card-link' })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: url,
        xcss: $fe4d5bca7ad2879a$var$styles.root,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "aria-label": label,
        tabIndex: -1,
        "data-testId": testId
    });












var $7gpC4 = parcelRequire("7gpC4");


const $3f7da56acd6df247$var$AkFeedbackCollector = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $3f7da56acd6df247$var$FEEDBACK_ENTRYPOINT_ID_BOOKMARKS = 'f32dde59-8eb1-4974-8839-20183d163480';
const $3f7da56acd6df247$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $3f7da56acd6df247$var$messages = (0, $aXWIB.defineMessages)({
    bookmark_feedback_consent_checkbox_label: {
        id: "search_ai.bookmark_feedback_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    }
});
const $3f7da56acd6df247$export$f8d5d13de6379210 = ({ setShowFeedbackModal: setShowFeedbackModal, setShowDisplayFlag: setShowDisplayFlag, query: query, url: url, userDetails: userDetails })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const [hasConsent, setConsent] = (0, $42omo.useState)(false);
    const feedbackContextObject = {
        searchTerm: query,
        bookmarkUrl: url
    };
    const feedbackContext = Object.entries(feedbackContextObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)($3f7da56acd6df247$var$AkFeedbackCollector, {
                locale: locale,
                onClose: ()=>setShowFeedbackModal(false),
                onSubmit: ()=>{
                    setShowDisplayFlag(true);
                },
                atlassianAccountId: userDetails?.id,
                name: userDetails?.name,
                customContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                    label: formatMessage($3f7da56acd6df247$var$messages.bookmark_feedback_consent_checkbox_label),
                    onChange: ()=>setConsent(!hasConsent),
                    isChecked: hasConsent
                }),
                entrypointId: $3f7da56acd6df247$var$FEEDBACK_ENTRYPOINT_ID_BOOKMARKS,
                showTypeField: false,
                additionalFields: [
                    {
                        id: $3f7da56acd6df247$var$FEEDBACK_CONTEXT_CF,
                        value: feedbackContext
                    }
                ]
            })
        })
    });
};




var $4lrdQ = parcelRequire("4lrdQ");






const $d86ae07a91ec9535$var$OBJECT_RESOLVER_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $d86ae07a91ec9535$export$dbf5cea6f2cf1974 = async (url)=>{
    try {
        const objectResolver = await (0, $4lrdQ.fetchRestResponse)({
            url: $d86ae07a91ec9535$var$OBJECT_RESOLVER_ENDPOINT,
            body: [
                {
                    resourceUrl: url
                }
            ]
        });
        if (!objectResolver || objectResolver[0].status !== 200) {
            (0, $4Zqgi.logger).error({
                error: 'REQUEST ERROR',
                functionName: 'convertToKeyPhraseInputFormat'
            });
            return null;
        }
        return objectResolver[0].body.data;
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'convertToKeyPhraseInputFormat'
        });
        return null;
    }
};



const $3ede785c84f921db$var$AkFeedbackFlag = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $3ede785c84f921db$var$styles = {
    container: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _ca0qpxbi _u5f3pxbi _19bvpxbi _n3tdpxbi _kqswh2mm",
    headingUnderline: "_4bfu1r31 _1hms8stv _ajmmnqa1 _4bfu6x5g _1keg1lya"
};
const $3ede785c84f921db$export$91f5ac95cb52dd60 = /*#__PURE__*/ (0, $42omo.memo)(({ query: query, bookmarkId: bookmarkId, url: url, title: title, description: description, orgId: orgId, cloudId: cloudId, bookmarkState: bookmarkState = (0, $907ac179b537c87a$export$e12e02cef8635961).ACTIVE, searchSessionId: searchSessionId, source: source, brand: brand, hasBookmarkCreationAccess: hasBookmarkCreationAccess, hasAdminhubAccess: hasAdminhubAccess, userDetails: userDetails, workspaceId: workspaceId, product: product, requestId: requestId })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const [bookmarkDescription, setBookmarkDescription] = (0, $42omo.useState)(description);
    const [hovered, setHovered] = (0, $42omo.useState)(false);
    const [showAddBookmarkModal, setShowAddBookmarkModal] = (0, $42omo.useState)(false);
    const [showFeedbackModal, setShowFeedbackModal] = (0, $42omo.useState)(false);
    const [showFeedbackFlag, setShowFeedbackFlag] = (0, $42omo.useState)(false);
    const cardRef = (0, $42omo.useRef)(null);
    const initialLoadTs = (0, $42omo.useRef)(Date.now()).current; // Dwell tracker for viewport exit detection
    (0, $e9e876f82a3b31d5$export$5335101d48c968c3)({
        elementRef: cardRef,
        onDwellEnd: (dwellTime)=>{
            fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).FMP_RESULT_EXITED,
                dwellTime: dwellTime,
                commonAttributes: bookmarkAttributes
            });
        }
    });
    const bookmarkAttributes = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            orgId: orgId,
            source: source,
            query: query,
            queryHash: (0, $ka0Y0.sha256Hash)(query),
            baseQueryHash: (0, $ka0Y0.sha256Hash)(query),
            searchSessionId: searchSessionId,
            answerString: '',
            answerLength: 0,
            answerWordCount: 0,
            answerFormat: null,
            answerCardType: (0, $f7lNm.AnswerCardType).BOOKMARK_KNOWLEDGE_CARD,
            sources: [],
            followUps: [],
            errorState: null,
            errorStateSuggestedQueries: [],
            bookmarkId: bookmarkId,
            bookmarkUrl: bookmarkId,
            extraAttributes: {
                bookmarkId: bookmarkId,
                bookmarkUrl: bookmarkId,
                isFullPageSearch: true,
                bookmarkState: bookmarkState,
                ...(0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? {
                    requestId: requestId
                } : {}
            },
            apiSource: 'xp-knowledge-discovery',
            workspaceId: '',
            sessionId: searchSessionId,
            brand: brand,
            isHello: (0, $6M0KD.isHello)(cloudId)
        }), [
        bookmarkId,
        brand,
        cloudId,
        orgId,
        query,
        searchSessionId,
        source,
        bookmarkState,
        requestId
    ]);
    (0, $42omo.useEffect)(()=>{
        const fmpLoadTime = Date.now() - initialLoadTs;
        trackAIInteractionInit();
        fireSAINUsageEvent({
            commonAttributes: bookmarkAttributes
        });
        fireAnalyticsEvent((0, $bpAj5.onAIAnswerResultShown)({
            ...bookmarkAttributes,
            isStreamed: false,
            fmpLoadTime: fmpLoadTime
        }));
        (0, $59vy4.SAINFeatureControl).triggerNonPrimaryClickTrackingExposure();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $42omo.useEffect)(()=>{
        const getSmartLinkDescription = async ()=>{
            try {
                if (!bookmarkDescription) {
                    const objectResolver = await (0, $d86ae07a91ec9535$export$dbf5cea6f2cf1974)(url);
                    setBookmarkDescription(objectResolver?.summary ?? '');
                }
            } catch (error) {
                (0, $4Zqgi.logger).error({
                    error: error,
                    functionName: 'getSmartLinkDescription'
                });
            }
        };
        getSmartLinkDescription();
    }, [
        bookmarkDescription,
        url
    ]);
    const sanitizeUrl = ()=>{
        let pattern = /^(http|https):\/\//;
        let result = url;
        if (!pattern.test(url)) result = `https://${url}`;
        return result;
    };
    const onSearchPinOpened = (isAuxClick = false, isContextMenu = false)=>{
        if ((isAuxClick || isContextMenu) && !(0, $59vy4.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $fJBWn.onKnowledgeCardLinkClick)({
            ...bookmarkAttributes,
            location: 'bookmarkKnowledgeCard',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $4jIuc.SainAction).BOOKMARK_CLICKED,
            commonAttributes: bookmarkAttributes
        });
    };
    const openAddPinModal = (e)=>{
        e.stopPropagation();
        setShowAddBookmarkModal(true);
    };
    const bookmarkTitle = title ?? query;
    const isSuggestedBookmark = bookmarkState === (0, $907ac179b537c87a$export$e12e02cef8635961).SUGGESTED;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ref: cardRef,
                onAuxClick: (e)=>{
                    if (e.button !== 1) return;
                    onSearchPinOpened(true);
                },
                onContextMenu: ()=>onSearchPinOpened(false, true),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $df7ed.KnowledgeCard), {
                    name: "smart-answers-bookmark-knowledge-card",
                    size: "full",
                    containerStyles: $3ede785c84f921db$var$styles.container,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fe4d5bca7ad2879a$export$d0f9d04b7863337a), {
                            url: sanitizeUrl(),
                            onClick: ()=>onSearchPinOpened(false),
                            label: bookmarkTitle,
                            onMouseEnter: ()=>setHovered(true),
                            onMouseLeave: ()=>setHovered(false)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            space: "space.150",
                            grow: "fill",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    alignBlock: "center",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            alignBlock: "center",
                                            space: "space.100",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($x4n5k))), {
                                                    label: "",
                                                    size: "small",
                                                    color: "var(--ds-icon-subtle, #505258)"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                    color: "color.text.subtle",
                                                    children: isSuggestedBookmark ? formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pin_title_suggested) : formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pin_title)
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                                    content: isSuggestedBookmark ? formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pinSuggestedTooltip) : formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pinCompanyAddedTooltip),
                                                    position: "bottom",
                                                    children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                            ...tooltipProps,
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                                                                label: "",
                                                                size: "small",
                                                                color: "var(--ds-icon-subtle, #505258)"
                                                            })
                                                        })
                                                })
                                            ]
                                        }),
                                        hasBookmarkCreationAccess && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                            spacing: "compact",
                                            onClick: openAddPinModal,
                                            testId: "admin-create-bookmark-button",
                                            children: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).add_another_pin_button_label)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                    href: sanitizeUrl(),
                                    appearance: "subtle",
                                    onClick: ()=>onSearchPinOpened(false),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: hovered ? $3ede785c84f921db$var$styles.headingUnderline : undefined,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "large",
                                            color: "color.link",
                                            weight: "semibold",
                                            children: bookmarkTitle
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    children: bookmarkDescription
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                                    showAIUsageDisclaimer: false,
                                    showFeedbackButtons: true
                                })
                            ]
                        })
                    ]
                })
            }),
            showAddBookmarkModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $7b98dae0b13f338b$export$6b6672b81db1fb01), {
                handleClose: ()=>setShowAddBookmarkModal(false),
                orgId: orgId,
                cloudId: cloudId,
                hasAdminhubAccess: hasAdminhubAccess,
                workspaceId: workspaceId,
                product: product
            }),
            showFeedbackModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $3f7da56acd6df247$export$f8d5d13de6379210), {
                setShowDisplayFlag: setShowFeedbackFlag,
                setShowFeedbackModal: setShowFeedbackModal,
                userDetails: userDetails,
                query: query,
                url: url
            }),
            showFeedbackFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setShowFeedbackFlag(false),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                    children: /*#__PURE__*/ (0, $l998X.jsx)($3ede785c84f921db$var$AkFeedbackFlag, {
                        locale: locale,
                        description: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pinFeedbackSubmittedFlagMessage)
                    })
                })
            })
        ]
    });
});





const $e67c33e567f4f311$export$a9cdec4c0adbe9c5 = ()=>{
    try {
        return {
            action: 'clicked',
            actionSubject: 'aiSearchBookmarkAddDismiss',
            eventType: 'ui'
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onAddPinDismissClick'
        });
        return {};
    }
};



const $f1f3e476fc2c8b82$var$DISMISS_STATUS_KEY = 'add-new-pin-card-dismissed';
const $f1f3e476fc2c8b82$export$301ef70c5c7bdf65 = /*#__PURE__*/ (0, $42omo.memo)(({ query: query, cloudId: cloudId, orgId: orgId, bookmarkId: bookmarkId, bookmarkState: bookmarkState, url: url, title: title, description: description, hasBookmarkCreationAccess: hasBookmarkCreationAccess = false, hasAdminhubAccess: hasAdminhubAccess = false, searchSessionId: searchSessionId = '', source: source = '', brand: brand = (0, $f7lNm.AiBrand).AI, userDetails: userDetails, product: product, workspaceId: workspaceId, lastModifierAccountId: lastModifierAccountId, keyPhrase: keyPhrase, parentAdminhubBookmarkId: parentAdminhubBookmarkId, requestId: requestId })=>{
    const [viewType, setViewType] = (0, $42omo.useState)('none');
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    (0, $5c40ea1dddca0440$export$eda8930120443143)({
        cloudId: cloudId,
        orgId: orgId
    });
    // hide the card when a new pin is created via AddPinCard
    const onNewPinCreated = ()=>setViewType('none');
    // handle dismiss CTA clicked on add new pin card
    const onDismissCallback = ()=>{
        fireAnalyticsEvent((0, $e67c33e567f4f311$export$a9cdec4c0adbe9c5)());
        (0, $6CITI.localStore).setString($f1f3e476fc2c8b82$var$DISMISS_STATUS_KEY, 'true');
        setViewType('none');
    };
    const hasBookmarkCreationAccessWithFg = hasBookmarkCreationAccess && (0, $dh538.fg)('adminhub_search_pins_settings');
    (0, $42omo.useEffect)(()=>{
        if (url) // show the bookmark card when a url exists
        setViewType('view');
        else if (!url && (0, $6CITI.localStore).getString($f1f3e476fc2c8b82$var$DISMISS_STATUS_KEY) !== 'true' && hasBookmarkCreationAccessWithFg) // show the add bookmark card if a user is some kind of admin & bookmark for this query doesn't exist
        setViewType('add');
    }, [
        hasBookmarkCreationAccessWithFg,
        url
    ]);
    const commonBookmarkProps = {
        query: query,
        bookmarkState: bookmarkState,
        url: url,
        bookmarkId: bookmarkId,
        orgId: orgId,
        cloudId: cloudId,
        description: description,
        searchSessionId: searchSessionId,
        source: source,
        title: title,
        hasBookmarkCreationAccess: hasBookmarkCreationAccessWithFg,
        hasAdminhubAccess: hasAdminhubAccess,
        brand: brand,
        userDetails: userDetails,
        workspaceId: workspaceId,
        product: product ?? '',
        lastModifierAccountId: lastModifierAccountId,
        keyPhrase: keyPhrase,
        parentAdminhubBookmarkId: parentAdminhubBookmarkId,
        requestId: requestId
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $14qs9.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
                config: {
                    product: product ?? 'unknown',
                    subproduct: 'search-page',
                    aiFeatureName: 'smartAnswers',
                    aiExperienceName: 'bookmarks',
                    proactiveGeneratedAI: bookmarkState === (0, $907ac179b537c87a$export$e12e02cef8635961).ACTIVE ? 0 : 1,
                    userGeneratedAI: bookmarkState === (0, $907ac179b537c87a$export$e12e02cef8635961).ACTIVE ? 1 : 0,
                    isAIFeature: 1,
                    source: source,
                    channel: (0, $f7lNm.DEFAULT_GAS_CHANNEL)
                },
                children: viewType === 'view' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3ede785c84f921db$export$91f5ac95cb52dd60), {
                    ...commonBookmarkProps
                }) : viewType === 'add' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $f3c680f674639682$export$5cc0b8a7a0e0e4df), {
                    query: query,
                    orgId: orgId,
                    cloudId: cloudId,
                    hasAdminhubAccess: hasAdminhubAccess,
                    callbacks: {
                        onSuccessCallback: onNewPinCreated,
                        onDismissCallback: onDismissCallback
                    },
                    workspaceId: workspaceId,
                    product: product ?? ''
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {})
            })
        })
    });
});


const $6008f0aefb78b1a7$export$64a10023dd10f44e = (props)=>{
    const { searchSessionId: searchSessionId, queryHash: queryHash, source: source, bookmarkAPIHasBookmark: bookmarkAPIHasBookmark, queryIntentHasBookmark: queryIntentHasBookmark, bookmarkAPIBookmarkId: bookmarkAPIBookmarkId, queryIntentBookmarkId: queryIntentBookmarkId, bookmarkAPIRequestId: bookmarkAPIRequestId, queryIntentRequestId: queryIntentRequestId, bookmarksAreEqual: bookmarksAreEqual } = props;
    return {
        action: 'completed',
        actionSubject: 'aiSearchBookmarkRequests',
        eventType: 'operational',
        source: source,
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            bookmarkAPIHasBookmark: bookmarkAPIHasBookmark,
            queryIntentHasBookmark: queryIntentHasBookmark,
            bookmarkAPIBookmarkId: bookmarkAPIBookmarkId,
            queryIntentBookmarkId: queryIntentBookmarkId,
            bookmarkAPIRequestId: bookmarkAPIRequestId,
            queryIntentRequestId: queryIntentRequestId,
            bookmarksAreEqual: bookmarksAreEqual
        }
    };
};


/* bookmark-suggestion-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 





























var $jLyYG = parcelRequire("jLyYG");





var $8s0lk = parcelRequire("8s0lk");











var $be6b1538bae8f2d8$exports = {};
$be6b1538bae8f2d8$exports = new URL("bookmark-suggestion-search-icon.8ee7ee2d.svg", import.meta.url).toString();






const $1f418688c3c38567$export$941550b6519465df = ()=>{
    try {
        return {
            action: 'clicked',
            actionSubject: 'popularSearchQueryButton',
            eventType: 'ui'
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onPopularSearchQueryButtonClicked'
        });
        return {};
    }
};





const $bf71ddd7b3dcf076$export$9883993cbc623aae = ()=>{
    try {
        return {
            action: 'shown',
            actionSubject: 'popularSearchQuerySuggestion',
            eventType: 'track'
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onPopularSearchQuerySuggestionShown'
        });
        return {};
    }
};


const $fbd80e6e5492e345$var$styles = {
    bookmarkSuggestionContainer: "_2rko12b0 _zulpu2gc _1rjcv47k _18zrv47k _bfhk1j9a _16qs1nax _1e0c1txw",
    bookmarkSuggestionIconContainer: "_18zrutpp _1e0c1txw _1bah1h6o _4cvr1h6o",
    bookmarkSuggestionContentContainer: "_1bsb1osq"
};
const $fbd80e6e5492e345$var$BookmarkSuggestionCardComponent = /*#__PURE__*/ (0, $42omo.memo)(({ suggestedTerm: suggestedTerm, cloudId: cloudId, orgId: orgId, hasAdminhubAccess: hasAdminhubAccess, workspaceId: workspaceId, product: product, searchSessionId: searchSessionId, userDetails: userDetails, source: source })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [showAddModal, setShowAddModal] = (0, $42omo.useState)(false);
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $bf71ddd7b3dcf076$export$9883993cbc623aae)());
    }, [
        fireAnalyticsEvent
    ]);
    const feedbackOptions = (0, $jLyYG.useSmartAnswerCardFeedbackOptions)();
    const feedbackAttributes = {
        searchSessionId: searchSessionId,
        source: source,
        queryHash: (0, $ka0Y0.sha256Hash)(suggestedTerm),
        cloudId: cloudId
    };
    const onBookmarkCreationSuccess = ()=>{
        setIsDismissed(true);
    };
    const onAddBookmarkClick = ()=>{
        setShowAddModal(true);
        fireAnalyticsEvent((0, $1f418688c3c38567$export$941550b6519465df)());
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $14qs9.ErrorBoundary), {
        children: [
            isDismissed ? null : /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $fbd80e6e5492e345$var$styles.bookmarkSuggestionContainer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $fbd80e6e5492e345$var$styles.bookmarkSuggestionIconContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($be6b1538bae8f2d8$exports))),
                            width: "88",
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $fbd80e6e5492e345$var$styles.bookmarkSuggestionContentContainer,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            direction: "column",
                            gap: "space.075",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "large",
                                    weight: "bold",
                                    testId: "bookmark-suggestion-main-message",
                                    children: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pinSuggestionMainMessage, {
                                        suggestedTerm: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            size: "large",
                                            weight: "bold",
                                            color: "color.text.brand",
                                            children: suggestedTerm
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                    space: "space.250",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            children: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).pinSuggestionSubMessage)
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                            alignBlock: "center",
                                            spread: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                                    appearance: "default",
                                                    onClick: onAddBookmarkClick,
                                                    children: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).add_pin_button_label)
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $8s0lk.AIFeedbackV2), {
                                                    entrypointId: feedbackOptions.entrypointId,
                                                    userDetails: userDetails,
                                                    attributes: feedbackAttributes,
                                                    onLikeButtonClickHandler: feedbackOptions.onLikeButtonClickHandler,
                                                    onDislikeButtonClickHandler: feedbackOptions.onDislikeButtonClickHandler,
                                                    featureTitle: formatMessage((0, $97841560b31a4348$export$defe85febe8b728c).userCreatedBookmarksFeatureTitle)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            showAddModal && /*#__PURE__*/ (0, $l998X.jsx)((0, $7b98dae0b13f338b$export$6b6672b81db1fb01), {
                query: suggestedTerm,
                handleClose: ()=>setShowAddModal(false),
                orgId: orgId,
                cloudId: cloudId,
                hasAdminhubAccess: hasAdminhubAccess,
                workspaceId: workspaceId,
                product: product,
                source: "popularSearchQuery",
                onSuccessCallback: onBookmarkCreationSuccess
            })
        ]
    });
});
const $fbd80e6e5492e345$export$a763bcfb4adf736a = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            product: props.product,
            subproduct: 'search-page',
            aiFeatureName: 'smartAnswers',
            aiExperienceName: (0, $f7lNm.AiExperienceName).POPULAR_SEARCH_QUERY_CARD,
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            isAIFeature: 0,
            source: props.source,
            channel: (0, $f7lNm.DEFAULT_GAS_CHANNEL)
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)($fbd80e6e5492e345$var$BookmarkSuggestionCardComponent, {
            ...props
        })
    });






/* JiraIssueSmartCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $9CM6e = parcelRequire("9CM6e");





















const $928538791edf5bb0$export$d08a3eab2fc93ae2 = (event)=>$928538791edf5bb0$var$isSpecialEvent(event) ? '_blank' : '_self';
/**
 * All code below this comment block is lifted from Linking Platform to match their smart card link click behavior:
 * https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/238b520ec4308da2c86b01cbdd145f141c75d51b/platform/packages/linking-platform/smart-card/src/utils/index.tsx#lines-11:34
 */ const $928538791edf5bb0$var$isSpecialEvent = (event)=>event.isDefaultPrevented() && ($928538791edf5bb0$var$isIframe() || $928538791edf5bb0$var$isSpecialKey(event) || $928538791edf5bb0$var$isSpecialClick(event));
// Slight change from Linking Platform code to add try/catch here
const $928538791edf5bb0$var$isIframe = ()=>{
    try {
        return window.parent !== window;
    } catch  {
        // cross-origin parent access throws
        return true;
    }
};
/**
 * Meta key = cmd on mac, windows key on windows
 * Ctrl key on mac by default triggers a right click instead of left click
 * Ctrl key on Windows has the same behaviour of cmd key of mac (open in new tab)
 * Shift key is also a "special" key because the default behavior of Chromium-based browsers is to open the
 * link in a new window; Arc browser has custom logic to show links in its "peek" window when shift is held.
 *
 * `isSpecialKey` on a mouse event on mac with default behaviour should be equivalent to opening in new tab
 * On Windows it will be equivalent to opening a new tab, unless its the Window key that is held
 * in which case typically only a standard clickthrough will occur, this is likely a small portion of events
 */ const $928538791edf5bb0$var$isSpecialKey = (event)=>event.metaKey || event.ctrlKey || event.shiftKey;
const $928538791edf5bb0$var$isSpecialClick = (event)=>event.button === 1;














/**
 * Attempts to resolve a Jira URL from the local store
 * @param issueKey - The Jira issue key to look up eg PROJ-123
 * @returns The URL if found in local store, null otherwise
 */ const $0d11052e4349eb7f$var$resolveFromLocalStore = (issueKey)=>{
    const storedUrl = (0, $6CITI.localStore).getString('jira-issue-url');
    if (!!storedUrl && new RegExp(issueKey, 'i').test(storedUrl)) return storedUrl;
    return null;
};
/**
 * Attempts to resolve a Jira URL from the quicksearch endpoint
 * @param issueKey - The Jira issue key to look up eg PROJ-123
 * @returns The URL if found in quicksearch results, null otherwise
 */ const $0d11052e4349eb7f$var$resolveFromQuickSearch = async ({ issueKey: issueKey, cloudId: cloudId, workspaceId: workspaceId, product: product })=>{
    try {
        const response = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: `
			query KnowledgeDiscoveryIssueSearch(
				$experience: String!
				$query: String!
				$filters: SearchFilterInput!
				$first: Int
			) {
				search {
					results: search(
						experience: $experience
						query: $query
						filters: $filters
						first: $first
					) {
						edges {
							node {
								type
								id
								title
								url
								iconUrl
								... on SearchResultJiraIssue {
									issue {
										key
									}
								}
							}
						}
					}
				}
			}
			`,
            variables: {
                experience: 'knowledge-discovery.issue-card',
                query: issueKey,
                filters: {
                    entities: [
                        'ati:cloud:jira:issue'
                    ],
                    locations: [
                        `ari:cloud:jira::site/${cloudId}`
                    ]
                },
                first: 1
            },
            operationName: 'KnowledgeDiscoveryIssueSearch',
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        });
        const results = response.data?.search?.results?.edges ?? [];
        const matchingResult = results.find((result)=>result.node.issue?.key?.toLowerCase() === issueKey.toLowerCase());
        return matchingResult?.node?.url || null;
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'resolveFromQuickSearch'
        });
    }
    return null;
};
const $0d11052e4349eb7f$export$d7c7b957a5608d16 = async ({ issueKey: issueKey, cloudId: cloudId, workspaceId: workspaceId, product: product })=>{
    // Try local store first
    const localStoreUrl = $0d11052e4349eb7f$var$resolveFromLocalStore(issueKey);
    if (!!localStoreUrl) return localStoreUrl;
    // Fall back to quicksearch
    const quickSearchUrl = await $0d11052e4349eb7f$var$resolveFromQuickSearch({
        issueKey: issueKey,
        cloudId: cloudId,
        workspaceId: workspaceId,
        product: product
    });
    return quickSearchUrl;
};





















const $4c589766ed9a1110$var$styles = {
    root: "_bfhksm61 _otyrv77o _19bvze3t _u5f3ze3t _1bsb1osq"
};
const $4c589766ed9a1110$export$503d0d685bf87c06 = ({ issueKeyQuery: issueKeyQuery, cloudId: cloudId, aiBrand: aiBrand, searchSessionId: searchSessionId, workspaceId: workspaceId, product: product, source: source })=>{
    const [issueUrl, setIssueUrl] = (0, $42omo.useState)(null);
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $fYQcF.useAIEventsInstrumentation)();
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $4jIuc.useSAINUsageCriteriaMet)();
    const cardRef = (0, $42omo.useRef)(null);
    const initialLoadTs = (0, $42omo.useRef)(performance.now()).current;
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $ka0Y0.sha256Hash)(issueKeyQuery),
            brand: aiBrand,
            source: source,
            query: issueKeyQuery,
            answerString: issueUrl || '',
            answerCardType: (0, $f7lNm.AnswerCardType).JIRA_ISSUE
        }), [
        searchSessionId,
        issueKeyQuery,
        aiBrand,
        issueUrl,
        source
    ]);
    const analyticsAttributesWithoutUGC = (0, $42omo.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $ka0Y0.sha256Hash)(issueKeyQuery),
            brand: aiBrand,
            source: source,
            answerCardType: (0, $f7lNm.AnswerCardType).JIRA_ISSUE
        }), [
        searchSessionId,
        issueKeyQuery,
        aiBrand,
        source
    ]);
    const commonAttributes = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            orgId: '',
            source: // Not available in this component
            source,
            query: issueKeyQuery,
            queryHash: (0, $ka0Y0.sha256Hash)(issueKeyQuery),
            baseQueryHash: (0, $ka0Y0.sha256Hash)(issueKeyQuery),
            searchSessionId: searchSessionId,
            answerString: issueUrl || '',
            answerLength: issueUrl?.length || 0,
            answerWordCount: 0,
            answerFormat: null,
            answerCardType: (0, $f7lNm.AnswerCardType).JIRA_ISSUE,
            sources: [],
            followUps: [],
            errorState: null,
            errorStateSuggestedQueries: [],
            extraAttributes: {
                issueKey: issueKeyQuery
            },
            apiSource: 'xp-knowledge-discovery',
            workspaceId: workspaceId,
            sessionId: searchSessionId,
            brand: aiBrand,
            isHello: (0, $6M0KD.isHello)(cloudId)
        }), [
        cloudId,
        issueKeyQuery,
        searchSessionId,
        issueUrl,
        workspaceId,
        aiBrand,
        source
    ]); // Dwell tracker for viewport exit detection
    (0, $e9e876f82a3b31d5$export$5335101d48c968c3)({
        elementRef: cardRef,
        onDwellEnd: (dwellTime)=>{
            fireSAINUsageEvent({
                metCriteria: (0, $4jIuc.SainAction).FMP_RESULT_EXITED,
                dwellTime: dwellTime,
                commonAttributes: commonAttributes
            });
        }
    });
    (0, $42omo.useEffect)(()=>{
        (0, $0d11052e4349eb7f$export$d7c7b957a5608d16)({
            issueKey: issueKeyQuery,
            cloudId: cloudId,
            workspaceId: workspaceId,
            product: product
        }).then(setIssueUrl);
    }, [
        issueKeyQuery,
        cloudId,
        workspaceId,
        product
    ]);
    (0, $42omo.useEffect)(()=>{
        if (issueUrl) {
            const fmpLoadTime = Math.round(performance.now() - initialLoadTs);
            trackAIInteractionInit();
            fireAnalyticsEvent((0, $elfKF.onNonGenerativeAIAnswerResultShown)({
                ...commonAttributes,
                fmpLoadTime: fmpLoadTime
            }));
            (0, $59vy4.SAINFeatureControl).triggerNonPrimaryClickTrackingExposure();
            fireSAINUsageEvent({});
        }
    }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        analyticsAttributes,
        commonAttributes,
        issueUrl,
        trackAIInteractionInit,
        initialLoadTs
    ]);
    if (!issueUrl) return null;
    const handleClick = (event)=>{
        const isAuxClick = 'button' in event && event.button === 1;
        const isContextMenu = 'button' in event && event.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $59vy4.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $kkJIR.onNonGenerativeKnowledgeCardLinkClick)({
            ...analyticsAttributes,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        })); // Passing a click handler to the `SmartCardSSR` component requires navigation handling here
        if (!isAuxClick && !isContextMenu) {
            const target = (0, $928538791edf5bb0$export$d08a3eab2fc93ae2)(event);
            window.open(issueUrl, target);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ref: cardRef,
                xcss: $4c589766ed9a1110$var$styles.root,
                onAuxClick: (e)=>{
                    if (e.button !== 1) return;
                    handleClick(e);
                },
                onContextMenu: handleClick,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eaSIT.SearchAIAnalyticsContext), {
                    data: {
                        attributes: {
                            ...analyticsAttributesWithoutUGC,
                            location: (0, $4xTru.SearchAIAnalyticsContextLocation).SAIN_JIRA_ISSUE_CARD
                        },
                        location: (0, $4xTru.SearchAIAnalyticsContextLocation).SAIN_JIRA_ISSUE_CARD
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9CM6e.CardSSR), {
                            url: issueUrl,
                            appearance: "block",
                            ui: {
                                size: (0, $5TXU5.SmartLinkSize).Medium
                            },
                            onClick: handleClick
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9lp28.AIDisclaimerAndFeedback), {
                showFeedbackButtons: true
            })
        ]
    });
};
const $4c589766ed9a1110$export$1a6b6e147aad985 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Rith.AIEventsInstrumentationProvider), {
        config: {
            product: props.product,
            subproduct: props.subproduct ?? 'unknown',
            aiFeatureName: 'smartAnswers',
            aiExperienceName: (0, $f7lNm.AiExperienceName).JIRA_ISSUE_CARD,
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            isAIFeature: 0,
            source: props.source,
            channel: (0, $f7lNm.DEFAULT_GAS_CHANNEL)
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)($4c589766ed9a1110$export$503d0d685bf87c06, {
            ...props
        })
    });






var $5Ymlp = parcelRequire("5Ymlp");


var $7Zbm6 = parcelRequire("7Zbm6");










const $c3679052fdea2dcd$export$96282d4f091b522d = 'KnowledgeDiscoveryPopularSearchQuery';
const $c3679052fdea2dcd$export$a0d468182ff3d4cd = `
	query ${$c3679052fdea2dcd$export$96282d4f091b522d}($cloudId: String!, $searchQuery: String!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Popular Search Query") {
			popularSearchQuery(cloudId: $cloudId, searchQuery: $searchQuery) {
				__typename
				... on KnowledgeDiscoveryPopularSearchQuery {
        	isPopular
				}
				... on QueryError {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;


const $730b365431664b49$var$fetchIsSearchQueryPopular = async (variables)=>{
    return (0, $9EFEY.fetchAggResponse)({
        graphQuery: (0, $c3679052fdea2dcd$export$a0d468182ff3d4cd),
        variables: variables,
        operationName: (0, $c3679052fdea2dcd$export$96282d4f091b522d)
    }).then((response)=>response.data?.knowledgeDiscovery?.popularSearchQuery.isPopular);
};
const $730b365431664b49$export$6c5130d45c1357c5 = ({ cloudId: cloudId, searchQuery: searchQuery, isEnabled: isEnabled })=>{
    const [isPopular, setIsPopular] = (0, $42omo.useState)(false);
    const [loading, setIsLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const fetchIsPopular = async ()=>{
            try {
                setIsLoading(true);
                const isPopular = await $730b365431664b49$var$fetchIsSearchQueryPopular({
                    cloudId: cloudId,
                    searchQuery: searchQuery
                });
                setIsPopular(isPopular ?? false);
            } catch (err) {
                (0, $4Zqgi.logger).error({
                    error: err,
                    functionName: 'fetchIsSearchQueryPopular'
                });
                setError(true);
            } finally{
                setIsLoading(false);
            }
        };
        if (!!searchQuery && cloudId && isEnabled) fetchIsPopular();
    }, [
        cloudId,
        searchQuery,
        isEnabled
    ]);
    return {
        isPopular: isPopular,
        loading: loading,
        error: error
    };
};


















const $a214a7b03ff9a3a7$export$aa99a9b4b886f8c8 = ()=>{
    try {
        return {
            action: 'failed',
            actionSubject: 'aiSearchBookmarkAddDismiss',
            eventType: 'track'
        };
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'onBookmarkFetchFailed'
        });
        return {};
    }
};



const $018c8be6a4352dfb$export$714730cd5e58741b = ({ cloudId: cloudId, query: query, workspaceId: workspaceId, product: product, isStandaloneBookmark: isStandaloneBookmark, applicationMode: applicationMode })=>{
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [isError, setIsError] = (0, $42omo.useState)(false);
    const [refetchCounter, setRefetchCounter] = (0, $42omo.useState)(1);
    const [id, setId] = (0, $42omo.useState)('');
    const [url, setUrl] = (0, $42omo.useState)('');
    const [title, setTitle] = (0, $42omo.useState)('');
    const [description, setDescription] = (0, $42omo.useState)();
    const [bookmarkState, setBookmarkState] = (0, $42omo.useState)((0, $907ac179b537c87a$export$e12e02cef8635961).ACTIVE);
    const [lastModifierAccountId, setLastModifierAccountId] = (0, $42omo.useState)('');
    const [keyPhrase, setKeyPhrase] = (0, $42omo.useState)('');
    const [parentAdminhubBookmarkId, setParentAdminhubBookmarkId] = (0, $42omo.useState)('');
    const [requestId, setRequestId] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        const callApi = async ()=>{
            try {
                const response = await (0, $907ac179b537c87a$export$7a8af96e1dd8695b)({
                    cloudId: cloudId,
                    keyPhrase: query
                }, workspaceId, product);
                const data = response.data;
                const requestId = response.requestId;
                if (!data || data.extensions && data.extensions.length > 0 && data.extensions[0].statusCode !== 404) {
                    fireAnalyticsEvent((0, $a214a7b03ff9a3a7$export$aa99a9b4b886f8c8)());
                    (0, $4Zqgi.logger).error({
                        error: data?.extensions || 'Bookmark Fetch Error',
                        functionName: isStandaloneBookmark ? 'useBookmarkQueryStandaloneBookmark' : 'useBookmarkQuery'
                    });
                    setIsError(true);
                    return;
                }
                setId(data?.id || '');
                setUrl(data?.properties?.url || '');
                setDescription(data?.properties?.description || '');
                setTitle(data?.properties?.title || '');
                setBookmarkState(data?.properties?.bookmarkState || (0, $907ac179b537c87a$export$e12e02cef8635961).ACTIVE);
                setLastModifierAccountId(data?.properties?.lastModifierAccountId ?? '');
                setKeyPhrase(data?.properties?.keyPhrase ?? '');
                setParentAdminhubBookmarkId(data?.properties?.parentAdminhubBookmarkId ?? '');
                setRequestId(requestId);
            } catch (error) {
                fireAnalyticsEvent((0, $a214a7b03ff9a3a7$export$aa99a9b4b886f8c8)());
                (0, $4Zqgi.logger).error({
                    error: error,
                    functionName: isStandaloneBookmark ? 'useBookmarkQueryStandaloneBookmark' : 'useBookmarkQuery'
                });
                setIsError(true);
            } finally{
                setLoading(false);
            }
        };
        if (!!query && applicationMode === 'rovo') {
            setLoading(true);
            callApi();
        }
    }, [
        cloudId,
        query,
        refetchCounter,
        fireAnalyticsEvent,
        workspaceId,
        product,
        isStandaloneBookmark,
        applicationMode
    ]);
    const refetch = ()=>setRefetchCounter((counter)=>counter + 1);
    return {
        loading: loading,
        isError: isError,
        id: id,
        bookmarkState: bookmarkState,
        url: url,
        title: title,
        description: description,
        refetch: refetch,
        lastModifierAccountId: lastModifierAccountId,
        keyPhrase: keyPhrase,
        parentAdminhubBookmarkId: parentAdminhubBookmarkId,
        requestId: requestId
    };
};


const $8f04cda2106f6543$export$cd102a4242b3d189 = (intent)=>intent.__typename === 'KnowledgeDiscoveryBookmarkIntent';



var $epS7s = parcelRequire("epS7s");


var $hm6w9 = parcelRequire("hm6w9");














var $3R0ts = parcelRequire("3R0ts");
















function $3d5e1f52b831d793$export$5cae361ad82dce8b(value, { count: count }) {
    const ref = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        if (ref.current[ref.current.length - 1] === value) return;
        // Keep the size of the array equal to the count
        ref.current = [
            ...ref.current.slice(ref.current.length > count - 1 ? 1 : 0),
            value
        ];
    }, [
        count,
        value
    ]);
    return ref.current;
}


















const $71988ef00edd4050$export$5c2913b6a4d1611c = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    // TODO: QS-6660 clean up the Unified Mode condition once it's decommissioned
    if (applicationMode === (0, $9vOy1.ApplicationModes).Unified) return isAdminHubAIEnabled;
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) return isRovoLLMEnabled;
    return true;
};


















var $2XcmP = parcelRequire("2XcmP");




























function $b48bc080623d26d3$export$7542d9981bb876f9(query) {
    const lowercaseQuery = query.toLowerCase();
    if (/^[a-z][a-z0-9_]+-\d+$/.test(lowercaseQuery) && (0, $dh538.fg)('kd_restrict_jira_issue_query_intent')) return {
        queryIntent: (0, $f7lNm.QueryIntent).JIRA_ISSUE,
        transformedQuery: query
    };
    if (/\w+-\d+/.test(lowercaseQuery) && !(0, $dh538.fg)('kd_restrict_jira_issue_query_intent')) return {
        queryIntent: (0, $f7lNm.QueryIntent).JIRA_ISSUE,
        transformedQuery: query
    };
    if (lowercaseQuery.endsWith(' agent') || lowercaseQuery.endsWith(' agents')) return {
        queryIntent: (0, $f7lNm.QueryIntent).AGENT,
        transformedQuery: query.replace(' agent', '').replace(' Agent', '')
    };
}





const $e8b8727e3edb8560$export$6c52de753cb858f8 = 'KnowledgeDiscoveryIntentDetectionQuery';
const $e8b8727e3edb8560$export$12788ba4bf4fbd92 = `
    ... on KnowledgeDiscoveryBookmarkIntent {
        __typename
        bookmark {
            id
            url
            title
            description
            keyPhrase
            bookmarkState
            lastModifierAccountId
            lastModifiedTimestamp
            parentAdminhubBookmarkId
        }
    }
`;
const $e8b8727e3edb8560$export$6f87cad788b6beba = `
	... on KnowledgeDiscoveryPersonIntent {
		__typename
		persons {
			accountId
			name
			email
			picture
			jobTitle
			department
			organization
			location
			zoneInfo
		}
	}
`;
const $e8b8727e3edb8560$export$5cc310960e46a388 = `
	... on KnowledgeDiscoveryNavContentIntent {
		__typename
		url
		title
		createdAt
	}
`;
const $e8b8727e3edb8560$export$8145deeb4e892b30 = ()=>`
	query KnowledgeDiscoveryIntentDetectionQuery(
		$siteId: String!
		$query: String!
		$locale: String!
		$orgId: String!
	) {
		knowledgeDiscovery {
			intentDetection(locale: $locale, orgId: $orgId, query: $query, siteId: $siteId) {
				... on KnowledgeDiscoveryIntentDetectionSuccess {
					__typename
					errors {
						errorType
						statusCode
					}
					detectionMetadata {
						cacheHit
						latencyMs
						method
						model
						timestamp
						entityMetadata {
							entityCount
							entityType
						}
					}
					intent {
						classification
						detectionType
						subTypes
						transformedQuery
						... on KnowledgeDiscoveryJiraIntent {
							__typename
						}
						... on KnowledgeDiscoveryKeywordOrAcronymIntent {
							__typename
						}
						... on KnowledgeDiscoveryNaturalLanguageIntent {
							__typename
						}
						... on KnowledgeDiscoveryNoneIntent {
							__typename
						}
						... on KnowledgeDiscoveryPersonIntent {
							__typename
						}
						... on KnowledgeDiscoveryTeamIntent {
							__typename
						}
						... on KnowledgeDiscoveryTopicIntent {
							__typename
						}
						... on KnowledgeDiscoveryNavigationalIntent {
							__typename
						}
						... on KnowledgeDiscoveryOrgChartIntent {
							__typename
						}
						${(0, $dh538.fg)('kd_enable_sain_hero_nav') ? $e8b8727e3edb8560$export$5cc310960e46a388 : ''}
						${(0, $dh538.fg)('kd_bookmark_query_intent') ? $e8b8727e3edb8560$export$12788ba4bf4fbd92 : ''}
						${(0, $dh538.fg)('kd_fe_persons_intent_detection_els') ? $e8b8727e3edb8560$export$6f87cad788b6beba : ''}
					}
				}
			}
		}
	}
`;


// Jira-family product keys that support NL→JQL (jira, jira-product-discovery, jira-servicedesk).
// Used to guard against over-triggering JIRA_NATURAL_LANGUAGE_QUERY on non-Jira surfaces.
const $8ad1f7056bd8c98a$var$JIRA_FAMILY_APP_IDS = new Set([
    'jira',
    'jira-product-discovery',
    'jira-servicedesk'
]);
const $8ad1f7056bd8c98a$export$c16051a8e758ff55 = async ({ query: query, siteId: siteId, locale: locale, metadata: metadata, cloudId: cloudId, orgId: orgId, workspaceId: workspaceId, product: product, selectedProduct: selectedProduct, setQueryIntent: setQueryIntent, setTransformedQuery: setTransformedQuery, setIntentData: setIntentData, setRequestId: setRequestId, setTraceId: setTraceId, onError: onError })=>{
    const handleError = (error)=>{
        setQueryIntent((0, $f7lNm.QueryIntent).NONE);
        setTransformedQuery('');
        onError?.(error);
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'getQueryIntent: handleError'
        });
    };
    try {
        const frontendQueryIntent = (0, $b48bc080623d26d3$export$7542d9981bb876f9)(query);
        // Intent from the frontend has a higher priority than the BE
        // Add any experiment and gate exclusion logic in `getFrontendQueryIntent` to prevent messy conditionals in this function
        if (!!frontendQueryIntent) {
            setQueryIntent(frontendQueryIntent.queryIntent);
            setTransformedQuery(frontendQueryIntent.transformedQuery);
            return;
        }
        const aggResponse = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $e8b8727e3edb8560$export$8145deeb4e892b30)(),
            variables: {
                query: query,
                siteId: siteId,
                locale: locale,
                orgId: orgId,
                ...metadata ? {
                    metadata: metadata
                } : {}
            },
            operationName: (0, $e8b8727e3edb8560$export$6c52de753cb858f8),
            // we're using the cache to make sure the number of calls remain the same
            // make sure the cache key format is different from the actual intent detection call
            cache: {
                ttl: 300000,
                key: `shadow-intent-detection-${query}`
            },
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        });
        // Trace / request IDs from the gateway HTTP response (for analytics and debugging).
        const gatewayTracingHeaders = aggResponse.gatewayTracingHeaders ?? {};
        const response = aggResponse?.data?.knowledgeDiscovery.intentDetection;
        if (!response || !aggResponse?.data || aggResponse?.errors && aggResponse?.errors.length > 0 || response?.errors && response?.errors.length > 0) {
            // errors show up at the top level or in the response
            let errorMessage = aggResponse?.errors?.[0]?.message;
            if (response?.errors && response?.errors.length > 0) errorMessage = response?.errors?.[0]?.message;
            const error = errorMessage ? new Error(errorMessage) : new Error('getQueryIntent error');
            handleError(error);
            return;
        }
        // Intent from the BE
        let queryIntent = response.intent?.classification;
        if (queryIntent === (0, $f7lNm.QueryIntent).VISUAL && !(0, $dh538.fg)('hybrid_orchestrator_enable_image_search')) queryIntent = (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY;
        if (queryIntent === (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY && selectedProduct && !$8ad1f7056bd8c98a$var$JIRA_FAMILY_APP_IDS.has(selectedProduct) && (0, $dh538.fg)('kd_fix_sain_jira_nql_query_intent_overtriggering')) queryIntent = (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY;
        setQueryIntent(queryIntent);
        setTransformedQuery(response.intent?.transformedQuery);
        setIntentData?.(response.intent);
        setRequestId(gatewayTracingHeaders['atl-request-id'] ?? '');
        setTraceId?.(gatewayTracingHeaders['x-trace-id'] ?? '');
    } catch (error) {
        handleError(error);
    }
};






var $c2fn3 = parcelRequire("c2fn3");

const $010d1da313d06b34$export$bf345c00a520ed89 = 'DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5';
const $010d1da313d06b34$export$91b38aefeb22cc42 = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $010d1da313d06b34$export$57570b1603cf6adb = (cloudId)=>{
    switch(cloudId){
        case '':
        case undefined:
            return 'none';
        case $010d1da313d06b34$export$bf345c00a520ed89:
            return 'pug';
        case $010d1da313d06b34$export$91b38aefeb22cc42:
            return 'hello';
        default:
            return 'production';
    }
};


const $e4ad42dfad2cbd14$export$8ee41d4b861fc655 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, cloudId: cloudId })=>({
        eventType: 'track',
        actionSubject: `smartAnswersQueryIntent`,
        action: 'failed',
        attributes: {
            commonAttributes: commonAttributes,
            environment: (0, $010d1da313d06b34$export$57570b1603cf6adb)(cloudId)
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });
const $e4ad42dfad2cbd14$export$743c1c20c92a931f = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        actionSubject: `smartAnswersQueryIntent`,
        action: 'fired',
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });











const $30704138a28a6cd1$export$bd1c6954a81c5a8a = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [queryIntent, setQueryIntent] = (0, $42omo.useState)((0, $f7lNm.QueryIntent).DEFAULT);
    const [transformedQuery, setTransformedQuery] = (0, $42omo.useState)('');
    const [queryIntentClassificationData, setQueryIntentClassificationData] = (0, $42omo.useState)();
    const [requestId, setRequestId] = (0, $42omo.useState)();
    const [traceId, setTraceId] = (0, $42omo.useState)();
    const [{ analyticsAttributes: analyticsAttributes, cloudId: cloudId, primaryProduct: primaryProduct, orgId: orgId }] = (0, $j4ply.useBootstrap)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const siteARI = `ari:cloud:${primaryProduct}::site/${cloudId}`;
    // plex code uses "jira" as the primary product key but we need to use "jira-software" instead for intent detection
    const jiraSiteARI = `ari:cloud:jira-software::site/${cloudId}`;
    const workspaceId = analyticsAttributes?.activationId ? `ari:cloud:${primaryProduct}:${cloudId}:workspace/${analyticsAttributes.activationId}` : '';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const numberOfRecentDocuments = (0, $42omo.useMemo)(()=>{
        if (!(0, $dh538.fg)('kd_recent_activity_intent') || !searchQuery) return undefined;
        return Number((0, $6CITI.localStore).getString('recent-activity-count'));
    }, [
        searchQuery
    ]);
    const metadata = !!numberOfRecentDocuments ? {
        numberOfRecentDocuments: numberOfRecentDocuments
    } : undefined;
    const isIntentDetectionV2OnHelloEnabled = (0, $dh538.fg)('kd_intent_v2_exp_gate');
    const isIntentDetectionV2CustomerTestCohort = (0, $eUEtI.hasSAINLayerParamValue)('intent_v2_cohort', 'test') && (0, $dh538.fg)('kd_intent_v2_customer_exp_gate');
    const onQueryIntentFailed = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $e4ad42dfad2cbd14$export$8ee41d4b861fc655)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            cloudId: cloudId
        }));
        if ((0, $2XcmP.isQuestion)({
            query: searchQuery,
            locale: intl.locale
        })) setQueryIntent((0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY);
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        intl.locale,
        searchQuery,
        cloudId
    ]);
    const onQueryIntentFire = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent((0, $e4ad42dfad2cbd14$export$743c1c20c92a931f)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!searchQuery) return;
        const callGetSmartAnswerRoute = async ()=>{
            // this key targets only jira_web so it should be false for other products
            const actualSiteId = primaryProduct === 'jira' ? jiraSiteARI : siteARI;
            setLoading(true);
            onQueryIntentFire();
            // getQueryIntent and getSmartAnswerRoute internally catches and
            // sets queryIntent,transformedQuery to defaults when errored
            // no need for a try catch here
            if (isIntentDetectionV2OnHelloEnabled || isIntentDetectionV2CustomerTestCohort) await (0, $8ad1f7056bd8c98a$export$c16051a8e758ff55)({
                query: searchQuery,
                locale: intl.locale,
                siteId: actualSiteId,
                orgId: orgId ?? '',
                workspaceId: workspaceId,
                cloudId: cloudId ?? '',
                product: primaryProduct || '',
                selectedProduct: selectedProduct,
                setQueryIntent: setQueryIntent,
                setTransformedQuery: setTransformedQuery,
                setIntentData: setQueryIntentClassificationData,
                onError: onQueryIntentFailed,
                setRequestId: setRequestId,
                setTraceId: setTraceId,
                metadata: metadata
            });
            else await (0, $c2fn3.getSmartAnswerRoute)({
                query: searchQuery,
                locale: intl.locale,
                siteId: actualSiteId,
                orgId: orgId ?? '',
                workspaceId: workspaceId,
                cloudId: cloudId ?? '',
                product: primaryProduct || '',
                selectedProduct: selectedProduct,
                setQueryIntent: setQueryIntent,
                setTransformedQuery: setTransformedQuery,
                onError: onQueryIntentFailed,
                metadata: metadata
            });
            setLoading(false);
        };
        callGetSmartAnswerRoute();
    // selectedProduct is intentionally excluded from deps: intent detection is keyed to the
    // query text only. Re-running on filter change (without a new query) would cause a
    // redundant API call. appId is read at call-time via closure so it is always fresh within
    // a given query's execution.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        siteARI,
        intl.locale,
        searchQuery
    ]);
    return {
        loading: loading,
        transformedQuery: transformedQuery,
        queryIntent: queryIntent,
        queryIntentClassificationData: queryIntentClassificationData,
        requestId: requestId,
        traceId: traceId
    };
};









/**
 * this reflects the entites convo-ai uses when making requests to search,
 * we us it to fetch backend search relevance experiment configs to be sent to SAIN's streaming endpoint
 */ const $cf6fd620dc10d51f$export$9681e147410b3859 = [
    'ati:cloud:compass:component',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:jira:issue',
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:trello:card',
    // 3p sources
    'ati:cloud:graph:document',
    'ati:cloud:graph:message',
    'ati:cloud:graph:remote-link',
    'ati:cloud:graph:video',
    'ari:cloud:graph:design'
];





const $07b671143818bcf9$var$STORE_MESSAGE_KEY = 'search-ai.sain.store_message';
function $07b671143818bcf9$var$shouldStoreMessage() {
    if (!(0, $dh538.fg)('kd_sain_enable_arize_hello_only')) return false;
    try {
        const stored = localStorage.getItem($07b671143818bcf9$var$STORE_MESSAGE_KEY);
        return stored === null || stored === 'true';
    } catch  {
        return true;
    }
}
const $07b671143818bcf9$export$b01094c5debc47b8 = ()=>{
    return $07b671143818bcf9$var$shouldStoreMessage() ? {
        store_message: 'true'
    } : {};
};
const $07b671143818bcf9$export$ae29f654d9653c17 = ()=>{
    return $07b671143818bcf9$var$shouldStoreMessage() ? {
        store_message: true
    } : {};
};


const $22ca3560ef24cce2$export$1625b883b0fea34d = (filters)=>{
    const selectedFilters = [];
    if (!filters) return selectedFilters;
    if (filters.spacesFilter.length > 0) selectedFilters.push({
        '@type': 'spaces',
        spaceKeys: filters.spacesFilter
    });
    if (filters.isVerified) selectedFilters.push({
        '@type': 'isVerified',
        isVerified: filters.isVerified
    });
    if (filters.contributorsFilter.length > 0) selectedFilters.push({
        '@type': 'contributors',
        accountIds: filters.contributorsFilter
    });
    if (filters.range.length > 0) selectedFilters.push({
        '@type': 'lastModified',
        from: filters.range[0].gt,
        to: filters.range[0].lt
    });
    if (filters.ancestorIdsFilter.length > 0) selectedFilters.push({
        '@type': 'ancestorIds',
        ancestorIds: filters.ancestorIdsFilter
    });
    if (filters.labelsFilter.length > 0) selectedFilters.push({
        '@type': 'labels',
        labelIds: filters.labelsFilter
    });
    return selectedFilters;
};
const $22ca3560ef24cce2$export$e9b2fbad5ce470cd = function mapSelectedFiltersToAggregator(selectedFilters) {
    const mappedFilters = {
        commonFilters: [],
        confluenceFilters: []
    };
    if (!selectedFilters) return mappedFilters;
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters } = selectedFilters;
    if (commonFilters && Object.keys(commonFilters).length > 0) {
        if (commonFilters.range?.lastModified) {
            if (commonFilters.range.lastModified.gt && commonFilters.range.lastModified.lt) mappedFilters.commonFilters.push({
                '@type': 'lastUpdated',
                from: commonFilters.range.lastModified.gt,
                to: commonFilters.range.lastModified.lt
            });
            else if (commonFilters.range.lastModified.gt) mappedFilters.commonFilters.push({
                '@type': 'lastUpdated',
                from: commonFilters.range.lastModified.gt
            });
            else if (commonFilters.range.lastModified.lt) mappedFilters.commonFilters.push({
                '@type': 'lastUpdated',
                to: commonFilters.range.lastModified.lt
            });
        }
        if (commonFilters.contributorsFilter && commonFilters.contributorsFilter.length > 0) mappedFilters.commonFilters.push({
            '@type': 'contributors',
            accountIds: commonFilters.contributorsFilter
        });
    }
    if (confluenceFilters && Object.keys(confluenceFilters).length > 0) mappedFilters.confluenceFilters = $22ca3560ef24cce2$export$1625b883b0fea34d(confluenceFilters);
    return mappedFilters;
};


const $ec4f905bffd8c643$var$wrapperStyles = {
    root: "_fiawglyw",
    rootLite: "_1e0c1bgi",
    wrapper: "_1bsb1osq _19pkv77o _fiawglyw"
};
const $ec4f905bffd8c643$var$smartAnswersPortalStyles = {
    root: "_fiawglyw",
    hidden: "_1e0cglyw"
};
const $ec4f905bffd8c643$var$handleNavigateDummyFunction = ()=>{};
const $ec4f905bffd8c643$var$SmartAnswerDialogWrapper = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $ec4f905bffd8c643$var$wrapperStyles.wrapper,
        children: children
    });
const $ec4f905bffd8c643$export$df149e1510f7d09e = ({ isRovoLLMEnabled: isRovoLLMEnabled, applicationMode: applicationMode })=>{
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) {
        if (applicationMode === (0, $9vOy1.ApplicationModes).Unified) return false;
        return isRovoLLMEnabled;
    }
    return applicationMode === (0, $9vOy1.ApplicationModes).Rovo;
};
const $ec4f905bffd8c643$export$ba5404e9c41a327c = (props)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const [{ cloudId: cloudId, user: user, orgId: orgId, SAINHostName: SAINHostName, analyticsAttributes: analyticsAttributes, experimentConfig: experimentConfig, productEdition: productEdition, productDataRegions: productDataRegions, isJiraIssueIndexed: isJiraIssueIndexed }] = (0, $j4ply.useBootstrap)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [query, { setSearchQuery: setSearchQuery }] = (0, $djVCD.useSearchQuery)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { hasFiltersSelected: hasFiltersSelected, selectedFilters: selectedFilters } = (0, $4VkIo.useSelectedFilters)({});
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const mappedProductFilter = (0, $1yEFx.MapProductToKnowledgeSources)[selectedProduct];
    const [previousMappedProductFilter] = (0, $3d5e1f52b831d793$export$5cae361ad82dce8b)(mappedProductFilter, {
        count: 1
    });
    const [fireAnalyticsEvent] = (0, $cVtio.useAnalytics)();
    const { commonAttributes: { has3pProducts: has3pProducts, is3pSearch: is3pSearch, mode: mode, availableProducts: availableProducts, queryHash: queryHash } } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const { clearStore: clearSearchResultStore, setQueryIntentClassificationData: setQueryIntentClassificationData, setWorkspaceId: setWorkspaceId, setSainJql: setSainJql } = (0, $ed340a232d40a52e$export$ff55966aa7474110)();
    const intercom = (0, $9afb3d504f643405$export$f0fed4b0765d7314)(); // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [results] = (0, $djVCD.useResults)(); // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [error] = (0, $djVCD.useResultsError)(); // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const resultsState = (0, $djVCD.useResultsState)();
    let resultsLoaded = resultsState === (0, $fZ3l2.ResultsStates).RESULTS;
    if (props.isRelayEnabled) resultsLoaded = props?.resultsState === (0, $fZ3l2.ResultsStates).RESULTS;
    const { loading: queryIntentLoading, transformedQuery: transformedQuery, queryIntent: queryIntent, queryIntentClassificationData: queryIntentClassificationData, requestId: queryIntentRequestId, traceId: queryIntentTraceId } = (0, $30704138a28a6cd1$export$bd1c6954a81c5a8a)();
    const cloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
    const workspaceId = analyticsAttributes?.activationId ? `ari:cloud:${primaryProduct}:${cloudId}:workspace/${analyticsAttributes.activationId}` : '';
    const xProduct = applicationMode === (0, $9vOy1.ApplicationModes).Rovo ? 'rovo' : undefined; // Get dialog referrer tracking from sessionStorage
    const dialogReferrer = (0, $epS7s.getSessionItem)((0, $3R0ts.SEARCH_DIALOG_AI_DIALOG_REFERER_KEY)); // Clear the dialog referrer tracking after analytics events are fired
    const handleAnalyticsFired = (0, $42omo.useCallback)(()=>{
        // Clear the dialog referrer from sessionStorage
        (0, $epS7s.deleteSessionItem)((0, $3R0ts.SEARCH_DIALOG_AI_DIALOG_REFERER_KEY));
    }, []);
    let showBookmark = false;
    let bookmarkResult = {
        bookmarkState: 'ACTIVE',
        url: '',
        loading: false,
        id: '',
        isError: false,
        title: '',
        description: undefined,
        lastModifierAccountId: '',
        keyPhrase: '',
        parentAdminhubBookmarkId: '',
        requestId: null
    };
    const bookmarkAPIBookmark = (0, $018c8be6a4352dfb$export$714730cd5e58741b)({
        cloudId: cloudId || '',
        query: query,
        workspaceId: workspaceId,
        product: primaryProduct || '',
        applicationMode: applicationMode
    });
    let queryIntentBookmark;
    if (queryIntentClassificationData && (0, $8f04cda2106f6543$export$cd102a4242b3d189)(queryIntentClassificationData) && (0, $dh538.fg)('kd_bookmark_query_intent')) queryIntentBookmark = queryIntentClassificationData.bookmark;
    const normalizeIntentBookmark = (bookmark)=>({
            id: bookmark.id || '',
            url: bookmark.url || '',
            title: bookmark.title || '',
            description: bookmark.description || '',
            keyPhrase: bookmark.keyPhrase ?? '',
            bookmarkState: Object.values((0, $907ac179b537c87a$export$e12e02cef8635961)).includes(bookmark.bookmarkState) ? bookmark.bookmarkState : (0, $907ac179b537c87a$export$e12e02cef8635961).ACTIVE,
            lastModifierAccountId: bookmark.lastModifierAccountId ?? '',
            parentAdminhubBookmarkId: bookmark.parentAdminhubBookmarkId ?? '',
            // Resolved defaults not present on intent type
            loading: false,
            isError: false,
            requestId: queryIntentRequestId ?? null
        });
    const normalizedIntentBookmark = queryIntentBookmark ? normalizeIntentBookmark(queryIntentBookmark) : undefined;
    const areBookmarksEqual = ()=>{
        if (!normalizedIntentBookmark?.id || !bookmarkAPIBookmark.id || bookmarkAPIBookmark.loading || bookmarkAPIBookmark.isError) return false;
        return normalizedIntentBookmark.id === bookmarkAPIBookmark.id && normalizedIntentBookmark.url === bookmarkAPIBookmark.url && normalizedIntentBookmark.title === bookmarkAPIBookmark.title && normalizedIntentBookmark.description === bookmarkAPIBookmark.description && normalizedIntentBookmark.keyPhrase === bookmarkAPIBookmark.keyPhrase && normalizedIntentBookmark.bookmarkState === bookmarkAPIBookmark.bookmarkState && normalizedIntentBookmark.lastModifierAccountId === bookmarkAPIBookmark.lastModifierAccountId && normalizedIntentBookmark.parentAdminhubBookmarkId === bookmarkAPIBookmark.parentAdminhubBookmarkId;
    };
    const bookmarksAreEqual = areBookmarksEqual();
    const shouldUseIntentBookmark = ()=>{
        if (!normalizedIntentBookmark?.id || bookmarkAPIBookmark.loading) return false;
        if (!bookmarkAPIBookmark.id || bookmarkAPIBookmark.isError) // API resolved without a bookmark — trust intent
        return true;
        return bookmarksAreEqual;
    };
    if (shouldUseIntentBookmark() && (0, $dh538.fg)('kd_bookmark_query_intent')) bookmarkResult = normalizedIntentBookmark;
    else bookmarkResult = bookmarkAPIBookmark;
    const queryIntentHasBookmark = !!queryIntentBookmark;
    const queryIntentBookmarkId = queryIntentBookmark?.id;
    const bookmarkAPIHasBookmark = !!bookmarkAPIBookmark.url && !bookmarkAPIBookmark.isError;
    const hasLoggedParityEventRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        hasLoggedParityEventRef.current = false;
    }, [
        query
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('kd_bookmark_query_intent')) return;
        if (bookmarkAPIBookmark.loading || queryIntentLoading) return;
        if (!hasLoggedParityEventRef.current && (queryIntentHasBookmark || bookmarkAPIHasBookmark)) {
            hasLoggedParityEventRef.current = true;
            const event = (0, $6008f0aefb78b1a7$export$64a10023dd10f44e)({
                searchSessionId: searchSessionId,
                queryHash: queryHash,
                source: (0, $6yNqK.EVENT_SOURCE),
                bookmarkAPIHasBookmark: bookmarkAPIHasBookmark,
                queryIntentHasBookmark: queryIntentHasBookmark,
                bookmarkAPIBookmarkId: bookmarkAPIBookmark.id || undefined,
                queryIntentBookmarkId: queryIntentBookmarkId || undefined,
                bookmarkAPIRequestId: bookmarkAPIBookmark.requestId,
                queryIntentRequestId: queryIntentRequestId ?? null,
                bookmarksAreEqual: bookmarksAreEqual
            });
            fireAnalyticsEvent(event);
        }
    }, [
        bookmarkAPIBookmark.loading,
        bookmarkAPIBookmark.id,
        bookmarkAPIBookmark.requestId,
        bookmarkAPIHasBookmark,
        bookmarksAreEqual,
        fireAnalyticsEvent,
        query,
        queryHash,
        queryIntentBookmarkId,
        queryIntentHasBookmark,
        queryIntentLoading,
        queryIntentRequestId,
        searchSessionId
    ]);
    const { hasBookmarkCreationAccess: hasBookmarkCreationAccess, hasAdminhubAccess: hasAdminhubAccess } = (0, $5c40ea1dddca0440$export$eda8930120443143)({
        cloudId: cloudId || '',
        orgId: orgId || ''
    });
    const { isPopular: isSearchQueryPopular, loading: isSearchQueryPopularLoading, error: isSearchQueryPopularError } = (0, $730b365431664b49$export$6c5130d45c1357c5)({
        cloudId: cloudId ?? '',
        searchQuery: query,
        isEnabled: (0, $dh538.fg)('kd_user_created_bookmarks')
    }); // if SAIN nav card is enabled, we show the nav card if the query intent is NAV_CONTENT or NAVIGATIONAL
    // for NAVIGATIONAL intents, we use the nav boost score from the FPS search results, which is checked inside the store
    const showNavCard = (queryIntent === (0, $f7lNm.QueryIntent).NAV_CONTENT || queryIntent === (0, $f7lNm.QueryIntent).NAVIGATIONAL) && (0, $dh538.fg)('kd_enable_sain_hero_nav');
    const parsedFilters = (0, $dh538.fg)('kd_add_common_filters_support_to_sain') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $42omo.useMemo)(()=>(0, $22ca3560ef24cce2$export$e9b2fbad5ce470cd)(selectedFilters), [
        selectedFilters
    ]) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $42omo.useMemo)(()=>(0, $22ca3560ef24cce2$export$1625b883b0fea34d)(selectedFilters.confluenceFilters), [
        selectedFilters.confluenceFilters
    ]);
    (0, $42omo.useEffect)(()=>{
        // clear the search result store when the query changes or component unmounts
        // this prevents stale nav card data from persisting when transitioning between intents
        (0, $dh538.fg)('kd_enable_sain_hero_nav') && clearSearchResultStore();
        return ()=>{
            (0, $dh538.fg)('kd_enable_sain_hero_nav') && clearSearchResultStore();
        };
    }, [
        query,
        clearSearchResultStore
    ]);
    if ((0, $dh538.fg)('kd_hide_sain_for_unsupported_product_filters')) // fg check is stable between renders and won't cause issues with hook calls
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $42omo.useEffect)(()=>{
        if (previousMappedProductFilter && previousMappedProductFilter !== mappedProductFilter) (0, $epS7s.deleteSessionItem)((0, $f7lNm.SEARCH_AI_ANSWER_CACHE_KEY));
    }, [
        previousMappedProductFilter,
        mappedProductFilter
    ]);
    const tracingHeaders = (0, $42omo.useMemo)(()=>{
        // Use trace headers from intent detection, use arbitraty span id since its needed to propagate trace id
        if (queryIntentTraceId) {
            const spanId = crypto.randomUUID().replace(/-/g, '').slice(0, 16);
            return {
                'X-B3-TraceId': queryIntentTraceId,
                'X-B3-SpanId': spanId
            };
        }
        return undefined;
    }, [
        queryIntentTraceId
    ]);
    const requestId = tracingHeaders?.['X-B3-TraceId']; // A callback needed to parse the streaming response, ideally it should be defined inside @atlassian/search-ai
    const aiSearchStreamingFunction = (0, $42omo.useCallback)(({ variables: variables })=>{
        return {
            type: (0, $7Zbm6.AIAnswerAPIType).STREAM,
            stream: (0, $5Ymlp.sainStreamFetchConvoAIService)({
                variables: {
                    ...variables,
                    cloudIdARI: cloudIdARI
                },
                fetchConfig: {
                    hostName: SAINHostName,
                    credentials: 'include',
                    headers: {
                        'X-Cloudid': cloudId || '',
                        ...xProduct ? {
                            'X-Product': xProduct
                        } : {},
                        ...tracingHeaders ?? {},
                        ...(0, $07b671143818bcf9$export$b01094c5debc47b8)()
                    }
                },
                storeMessage: (0, $07b671143818bcf9$export$ae29f654d9653c17)(),
                isReadingAids: false
            })
        };
    }, [
        SAINHostName,
        cloudIdARI,
        cloudId,
        xProduct,
        tracingHeaders
    ]);
    const backendExperiment = (0, $42omo.useMemo)(()=>(0, $hm6w9.getBackendExperiment)({
            experimentConfig: experimentConfig,
            entities: (0, $cf6fd620dc10d51f$export$9681e147410b3859),
            productEdition: productEdition,
            isHello: (0, $5XpfZ.isHello)(cloudId),
            productDataRegions: productDataRegions,
            experience: 'sain',
            tenantId: cloudId,
            isJiraIssueIndexed: isJiraIssueIndexed,
            thirdPartyFilters: selectedFilters.thirdPartyFilters
        }), [
        experimentConfig,
        productEdition,
        cloudId,
        productDataRegions,
        isJiraIssueIndexed,
        selectedFilters
    ]);
    const { experimentLayers: experimentLayers } = backendExperiment || {};
    const extraAnalyticsAttributes = (0, $42omo.useMemo)(()=>({
            isFullPageSearch: true,
            has3pProducts: has3pProducts,
            is3pSearch: is3pSearch,
            mode: mode,
            availableProducts: availableProducts,
            referrer: dialogReferrer,
            originalQuery: query,
            transformedQuery: transformedQuery,
            requestId: requestId
        }), [
        has3pProducts,
        is3pSearch,
        mode,
        availableProducts,
        dialogReferrer,
        query,
        transformedQuery,
        requestId
    ]);
    const intercomCallbacks = (0, $42omo.useMemo)(()=>({
            onAIAnswerSourceClick: ()=>intercom?.trackEvent('ai_answer_source_clicked'),
            onFollowUpSuggestionClick: ()=>intercom?.trackEvent('ai_follow_up_suggestion_clicked'),
            onAIAnswerAnalyticsFired: ()=>handleAnalyticsFired(),
            ...(0, $dh538.fg)('fps_nin_cta_use_sain_jql') && {
                onSainJqlResolved: setSainJql
            }
        }), [
        intercom,
        handleAnalyticsFired,
        setSainJql
    ]);
    const userDetail = (0, $42omo.useMemo)(()=>({
            id: user?.id || '',
            name: user?.name || ''
        }), [
        user
    ]);
    if (props.isRelayEnabled && (props.resultsState === (0, $fZ3l2.ResultsStates).NO_RESULTS || props.resultsState === (0, $fZ3l2.ResultsStates).ERROR)) return null;
    else if (error && !results) // Do not show smart answers when there are errors, or empty results
    return null;
     // Do not show smart answers when the required data is not available
    if (!cloudId || !query) return null;
     // Do not show smart answers or bookmarks if query intent isn't set or is loading
    if (queryIntent === (0, $f7lNm.QueryIntent).DEFAULT || queryIntentLoading) {
        // If loading, register a UFO hold
        if (queryIntentLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
            name: "query-intent"
        });
        return null;
    } // if the SAIN nav card is enabled,
    // we rely on the intent detection API to determine if we should show the bookmark component
    // this prevents both the nav card and bookmark from being shown at the same time,
    // since there's a high overlap for these two components
    if ((0, $dh538.fg)('kd_enable_sain_hero_nav')) showBookmark = Boolean(queryIntent === (0, $f7lNm.QueryIntent).BOOKMARK && queryIntentClassificationData && (0, $8f04cda2106f6543$export$cd102a4242b3d189)(queryIntentClassificationData) && !selectedProduct && resultsLoaded);
    else showBookmark = !bookmarkResult.loading && !bookmarkResult.isError && queryIntent !== (0, $f7lNm.QueryIntent).PERSON && !selectedProduct && resultsLoaded;
    if (showNavCard && queryIntentClassificationData) {
        setWorkspaceId(workspaceId ?? '');
        setQueryIntentClassificationData(queryIntentClassificationData);
    }
    const showPopularQuerySuggestion = isSearchQueryPopular && !isSearchQueryPopularLoading && !isSearchQueryPopularError && showBookmark && (queryIntent === (0, $f7lNm.QueryIntent).NAVIGATIONAL || queryIntent === (0, $f7lNm.QueryIntent).KEYWORD_OR_ACRONYM) && (0, $dh538.fg)('kd_user_created_bookmarks');
    const aiBrand = applicationMode === (0, $9vOy1.ApplicationModes).Rovo ? (0, $f7lNm.AiBrand).ROVO : (0, $f7lNm.AiBrand).AI;
    const hideTopicCard = queryIntent === (0, $f7lNm.QueryIntent).TOPIC && !!bookmarkResult.url; // No need to check for loaded results before showing SAIN (decision made by PM and team)
    const showSmartAnswer = queryIntent !== (0, $f7lNm.QueryIntent).NONE && queryIntent !== (0, $f7lNm.QueryIntent).NAV_CONTENT && (queryIntent !== (0, $f7lNm.QueryIntent).NAVIGATIONAL || queryIntent === (0, $f7lNm.QueryIntent).NAVIGATIONAL && (0, $59vy4.SAINFeatureControl).isNavigationalIntentEnabled()) && queryIntent !== (0, $f7lNm.QueryIntent).BOOKMARK && !bookmarkResult.loading && !hideTopicCard && ((0, $dh538.fg)('kd_hide_sain_for_unsupported_product_filters') ? // check either if no product filter is selected or a supported product filter is selected
    (!selectedProduct || mappedProductFilter !== undefined) && !hasFiltersSelected : true); // Show Jira Issue Card with priority for JIRA_ISSUE query intent
    if (queryIntent === (0, $f7lNm.QueryIntent).JIRA_ISSUE) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
        name: "search-ai-dialog",
        children: [
            (0, $dh538.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "hasSAINComponent",
                        value: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "sainExperienceName",
                        value: "Jira Issue Card"
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc8g.default), {
                data: {
                    hasSAINComponent: true,
                    sainExperienceName: 'Jira Issue Card'
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($ec4f905bffd8c643$var$SmartAnswerDialogWrapper, {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4c589766ed9a1110$export$1a6b6e147aad985), {
                    issueKeyQuery: query,
                    cloudId: cloudId,
                    aiBrand: aiBrand,
                    searchSessionId: searchSessionId,
                    workspaceId: workspaceId,
                    product: primaryProduct ?? '',
                    source: (0, $6yNqK.EVENT_SOURCE)
                })
            })
        ]
    });
     // If a bookmark exists & can be shown, prioritize showing bookmark only
    // If a bookmark doesn't exist & query isn't answerable by SAIN, show the bookmark component to admins
    if ((showBookmark && !!bookmarkResult.url || !showSmartAnswer && showBookmark && hasBookmarkCreationAccess) && !(0, $dh538.fg)('kd_team_26_sain_hide_bookmark')) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
        name: "search-ai-dialog",
        children: [
            (0, $dh538.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "hasSAINComponent",
                        value: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "sainExperienceName",
                        value: "Bookmark"
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc8g.default), {
                data: {
                    hasSAINComponent: true,
                    sainExperienceName: 'Bookmark'
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f1f3e476fc2c8b82$export$301ef70c5c7bdf65), {
                query: query,
                cloudId: cloudId,
                bookmarkId: bookmarkResult.id,
                bookmarkState: bookmarkResult.bookmarkState,
                url: bookmarkResult.url,
                orgId: orgId || '',
                searchSessionId: searchSessionId,
                source: (0, $6yNqK.EVENT_SOURCE),
                brand: aiBrand,
                title: bookmarkResult.title || '',
                description: bookmarkResult.description || '',
                hasAdminhubAccess: hasAdminhubAccess,
                hasBookmarkCreationAccess: hasBookmarkCreationAccess,
                userDetails: userDetail,
                product: primaryProduct,
                workspaceId: workspaceId,
                lastModifierAccountId: bookmarkResult.lastModifierAccountId,
                keyPhrase: bookmarkResult.keyPhrase,
                parentAdminhubBookmarkId: bookmarkResult.parentAdminhubBookmarkId,
                requestId: bookmarkResult.requestId
            })
        ]
    });
    if (showPopularQuerySuggestion && !(0, $dh538.fg)('kd_team_26_sain_hide_bookmark')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $fbd80e6e5492e345$export$a763bcfb4adf736a), {
        suggestedTerm: query,
        cloudId: cloudId,
        orgId: orgId ?? '',
        hasAdminhubAccess: hasAdminhubAccess,
        product: primaryProduct ?? 'unknown',
        workspaceId: workspaceId,
        userDetails: userDetail,
        searchSessionId: searchSessionId,
        source: (0, $6yNqK.EVENT_SOURCE)
    });
    else if (showSmartAnswer) {
        const sainContent = /*#__PURE__*/ (0, $l998X.jsxs)($ec4f905bffd8c643$var$SAINIntercomWrapper, {
            children: [
                showBookmark && hasBookmarkCreationAccess && !(0, $dh538.fg)('kd_team_26_sain_hide_bookmark') ? // If bookmark *could* be shown but doesn't exist, show the bookmark component to admins
                /*#__PURE__*/ (0, $l998X.jsx)((0, $f1f3e476fc2c8b82$export$301ef70c5c7bdf65), {
                    query: query,
                    cloudId: cloudId,
                    bookmarkId: bookmarkResult.id,
                    url: bookmarkResult.url,
                    orgId: orgId || '',
                    searchSessionId: searchSessionId,
                    source: (0, $6yNqK.EVENT_SOURCE),
                    brand: aiBrand,
                    title: bookmarkResult.title || '',
                    description: bookmarkResult.description || '',
                    hasAdminhubAccess: hasAdminhubAccess,
                    hasBookmarkCreationAccess: hasBookmarkCreationAccess,
                    product: primaryProduct,
                    workspaceId: workspaceId,
                    lastModifierAccountId: bookmarkResult.lastModifierAccountId,
                    keyPhrase: bookmarkResult.keyPhrase,
                    parentAdminhubBookmarkId: bookmarkResult.parentAdminhubBookmarkId,
                    requestId: bookmarkResult.requestId
                }) : null,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3Opgu.SearchAIDialog), {
                    query: transformedQuery || query,
                    cloudId: cloudId,
                    orgId: orgId,
                    getAIAnswer: aiSearchStreamingFunction,
                    onNavigate: $ec4f905bffd8c643$var$handleNavigateDummyFunction,
                    userDetails: userDetail,
                    source: (0, $6yNqK.EVENT_SOURCE),
                    extraAnalyticsAttributes: extraAnalyticsAttributes,
                    wrapper: $ec4f905bffd8c643$var$SmartAnswerDialogWrapper,
                    loadingWrapper: $ec4f905bffd8c643$var$SmartAnswerDialogWrapper,
                    setQuery: setSearchQuery,
                    followUpsEnabled: true,
                    searchSessionId: searchSessionId,
                    selectedFilters: selectedFilters,
                    parsedFilters: parsedFilters,
                    selectedProduct: selectedProduct,
                    mappedProductFilter: mappedProductFilter,
                    smartAnswersRoute: queryIntent,
                    cardTemplate: (0, $f7lNm.CardTemplate).SMART_ANSWER,
                    baseQuery: query,
                    brand: aiBrand,
                    callbacks: intercomCallbacks,
                    workspaceId: workspaceId,
                    isAdminHubAIEnabled: isAdminHubAIEnabled,
                    sourceProduct: primaryProduct,
                    showChatFollowUps: $ec4f905bffd8c643$export$df149e1510f7d09e({
                        isRovoLLMEnabled: isRovoLLMEnabled,
                        applicationMode: applicationMode
                    }),
                    queryIntentClassificationData: queryIntentClassificationData,
                    ...(0, $dh538.fg)('kd_sain_backend_exp_context') ? {
                        experimentContext: {
                            // The experiment layers are mapped to ensure permitted attributes are sent into search requests.
                            experimentLayers: (experimentLayers || []).map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                                    name: name,
                                    layerId: layerId,
                                    shadowId: shadowId,
                                    definitions: definitions
                                }))
                        }
                    } : {},
                    referrer: dialogReferrer,
                    traceHeaders: tracingHeaders
                })
            ]
        });
        if (queryIntent === (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY && (0, $59vy4.SAINFeatureControl).isJiraSAINCardSmartLinkEnabled({
            sourceProduct: primaryProduct
        }) && props.fullWidthSainPortalRef?.current) return /*#__PURE__*/ (0, $jTxSS.createPortal)(sainContent, props.fullWidthSainPortalRef.current, 'search-page-full-width-jira-nl-sain');
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: sainContent
        });
    }
    return null;
};
const $ec4f905bffd8c643$export$39017662cee16e4e = (props)=>{
    const [{ cloudId: cloudId, user: user, orgId: orgId, analyticsAttributes: analyticsAttributes }] = (0, $j4ply.useBootstrap)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [query] = (0, $djVCD.useSearchQuery)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const workspaceId = analyticsAttributes?.activationId ? `ari:cloud:${primaryProduct}:${cloudId}:workspace/${analyticsAttributes.activationId}` : '';
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)(); // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [results] = (0, $djVCD.useResults)(); // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [error] = (0, $djVCD.useResultsError)(); // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const resultsState = (0, $djVCD.useResultsState)();
    let resultsLoaded = resultsState === (0, $fZ3l2.ResultsStates).RESULTS;
    if (props.isRelayEnabled) resultsLoaded = props.resultsState === (0, $fZ3l2.ResultsStates).RESULTS;
    const { bookmarkState: bookmarkState, url: bookmarkUrl, loading: bookmarkLoading, id: bookmarkId, isError: isError, title: title, description: description, lastModifierAccountId: lastModifierAccountId, keyPhrase: keyPhrase, parentAdminhubBookmarkId: parentAdminhubBookmarkId, requestId: bookmarkRequestId } = (0, $018c8be6a4352dfb$export$714730cd5e58741b)({
        cloudId: cloudId || '',
        query: query,
        workspaceId: workspaceId,
        product: primaryProduct || '',
        isStandaloneBookmark: true,
        applicationMode: applicationMode
    });
    const { hasBookmarkCreationAccess: hasBookmarkCreationAccess, hasAdminhubAccess: hasAdminhubAccess } = (0, $5c40ea1dddca0440$export$eda8930120443143)({
        cloudId: cloudId || '',
        orgId: orgId || ''
    });
    const userDetail = (0, $42omo.useMemo)(()=>({
            id: user?.id || '',
            name: user?.name || ''
        }), [
        user
    ]);
    if (props.isRelayEnabled && (props.resultsState === (0, $fZ3l2.ResultsStates).NO_RESULTS || props.resultsState === (0, $fZ3l2.ResultsStates).ERROR)) return null;
    else if (error && !results) // Do not show smart answers when there are errors, or empty results
    return null;
     // Do not show smart answers when the required data is not available
    if (!cloudId || !query) return null;
    const showBookmark = !bookmarkLoading && !isError && !selectedProduct && resultsLoaded; // If a bookmark exists & can be shown, prioritize showing bookmark only
    // If a bookmark doesn't exist & query isn't answerable by SAIN, show the bookmark component to admins
    if ((showBookmark && !!bookmarkUrl || showBookmark && hasBookmarkCreationAccess) && !(0, $dh538.fg)('kd_team_26_sain_hide_bookmark')) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
        name: "search-ai-dialog",
        children: [
            (0, $dh538.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "hasSAINComponent",
                        value: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2cEww.default), {
                        dataKey: "sainExperienceName",
                        value: "Bookmark"
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cbc8g.default), {
                data: {
                    hasSAINComponent: true,
                    sainExperienceName: 'Bookmark'
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f1f3e476fc2c8b82$export$301ef70c5c7bdf65), {
                query: query,
                cloudId: cloudId,
                bookmarkId: bookmarkId,
                bookmarkState: bookmarkState,
                url: bookmarkUrl,
                orgId: orgId || '',
                searchSessionId: searchSessionId,
                source: (0, $6yNqK.EVENT_SOURCE),
                brand: applicationMode === (0, $9vOy1.ApplicationModes).Rovo ? (0, $f7lNm.AiBrand).ROVO : (0, $f7lNm.AiBrand).AI,
                title: title || '',
                description: description || '',
                hasAdminhubAccess: hasAdminhubAccess,
                hasBookmarkCreationAccess: hasBookmarkCreationAccess,
                userDetails: userDetail,
                product: primaryProduct,
                workspaceId: workspaceId,
                lastModifierAccountId: lastModifierAccountId,
                keyPhrase: keyPhrase,
                parentAdminhubBookmarkId: parentAdminhubBookmarkId,
                requestId: bookmarkRequestId
            })
        ]
    });
    return null;
};
const $ec4f905bffd8c643$var$SAINIntercomWrapper = ({ children: children })=>{
    const intercom = (0, $9afb3d504f643405$export$f0fed4b0765d7314)();
    const { queryIntent: queryIntent } = (0, $30704138a28a6cd1$export$bd1c6954a81c5a8a)();
    (0, $42omo.useEffect)(()=>{
        intercom?.trackEvent('smart_answers_shown', {
            query_intent: queryIntent
        });
    }, [
        intercom,
        queryIntent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
const $ec4f905bffd8c643$export$6d2f0eb8aa322ad7 = (props)=>{
    const [userWithStatus] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [query] = (0, $djVCD.useSearchQuery)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [features] = (0, $j4ply.useFeatures)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $7WbA8.useAppContext)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const areLLMFeaturesEnabled = (0, $71988ef00edd4050$export$5c2913b6a4d1611c)();
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    const isUserAuthenticated = userWithStatus.status === (0, $lwP5K.UserStatus).Authenticated;
    const isPrimaryProductEligible = primaryProduct === (0, $1yEFx.ProductKeys).Confluence || primaryProduct === (0, $1yEFx.ProductKeys).Atlas || primaryProduct === (0, $1yEFx.ProductKeys).Jira; // In SearchPageLite, only render smart answers when the "All" app pill is selected
    // (i.e. no specific product filter). Other (non-lite) variants are unaffected.
    const isLiteMode = features?.lite?.enabled ?? false;
    if (!isUserAuthenticated || !isPrimaryProductEligible || !query) return null;
    if (isLiteMode && selectedProduct) return null;
     // Experiment to disable SAIN based on: https://atlassian.slack.com/archives/C06K9T53N66/p1757961269661659?thread_ts=1754004619.291609&cid=C06K9T53N66
    // skip hello users for SAIN holdback exp
    if (!(0, $5XpfZ.isHello)(cloudId) && (0, $dh538.fg)('kd_disable_sain_experiment_fg')) {
        const layer = (0, $c6GJD.default).getLayer((0, $4OGlb.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN));
        const abTestId = layer.get('abTestId', 'no_ab_test_id');
        if (abTestId === 'kd_disable_sain_experiment') {
            const backendExperimentData = layer.get('backendChanges', {
                sain: true
            });
            if (!backendExperimentData?.sain) return null;
        }
    }
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) {
        if (areLLMFeaturesEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-smart-answers",
            children: /*#__PURE__*/ (0, $l998X.jsx)($ec4f905bffd8c643$export$ba5404e9c41a327c, {
                ...props
            })
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-smart-answers",
            children: /*#__PURE__*/ (0, $l998X.jsx)($ec4f905bffd8c643$export$39017662cee16e4e, {
                ...props
            })
        });
    } else {
        if (isAdminHubAIEnabled || applicationMode === (0, $9vOy1.ApplicationModes).Rovo) return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
            name: "search-page-smart-answers",
            children: /*#__PURE__*/ (0, $l998X.jsx)($ec4f905bffd8c643$export$ba5404e9c41a327c, {
                ...props
            })
        });
    }
    return null;
}; /**
    * A wrapper for the entire smart answers component in the search page,
    * which wraps the component in a div with a specific id. This is used
    * to calculate VC90 of the search page ignoring smart answers by filtering
    * out mutations that occur on descendants of this div during VC90 calculation.
    *
    * The specific metric this is used for is:
    * https://tools.atlassian.com/glance/experience/confluence.fe.page-load.ufo-search-page-ignoring-smart-answers
    */ 
const $ec4f905bffd8c643$var$SmartAnswersWrapper = ({ children: children, isLiteMode: isLiteMode })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        id: "search-page-smart-answers",
        testId: "search-page-smart-answers",
        xcss: isLiteMode ? $ec4f905bffd8c643$var$wrapperStyles.rootLite : $ec4f905bffd8c643$var$wrapperStyles.root,
        children: children
    });
const $ec4f905bffd8c643$var$SmartAnswersWithErrorBoundary = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "SearchPageSmartAnswers",
        children: /*#__PURE__*/ (0, $l998X.jsxs)($ec4f905bffd8c643$var$SmartAnswersWrapper, {
            isLiteMode: props.isLiteMode,
            children: [
                (0, $dh538.fg)('kd_enable_sain_hero_nav') && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($ec4f905bffd8c643$var$smartAnswersPortalStyles.root, // Hide the SAIN portal when the results state is not RESULTS
                    // This is to prevent the SAIN portal from showing the previous nav card
                    props.resultsState !== (0, $fZ3l2.ResultsStates).RESULTS && $ec4f905bffd8c643$var$smartAnswersPortalStyles.hidden),
                    ref: props.smartAnswersPortalRef,
                    testId: "sain-nav-card-portal"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)($ec4f905bffd8c643$export$6d2f0eb8aa322ad7, {
                    ...props
                })
            ]
        })
    });
var $ec4f905bffd8c643$export$2e2bcd8739ae039 = $ec4f905bffd8c643$var$SmartAnswersWithErrorBoundary;






const $4fce253db54ab402$var$autoCorrectStyles = {
    root: "_fiawglyw"
}; /**
    * Memoized to prevent re-renders when SearchPageLayout re-renders due to bootstrap
    * context/store changes. SearchPageBody receives all reactive data from internal hooks
    * (useAppContext, useSearchActions, etc.) and local useState mirrors (set by
    * SearchPageQueryOrchestrator), not from parent props. Props are stable: aggAbsoluteUrl
    * is a string, debugPortalRef is a useRef. This keeps SearchPageBody off the critical
    * path for query start.
    */ 
const $4fce253db54ab402$var$SearchPageBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ aggAbsoluteUrl: aggAbsoluteUrl, debugPortalRef: debugPortalRef, preloadDataProvider: preloadDataProvider })=>{
    const [relaySearchResults, loadSearchResultsQuery, disposeSearchResultsQuery] = (0, $irOoi.useQueryLoader)((0, $7Ngf7.default));
    const [relaySearchResultsAsync, loadSearchResultsAsyncQuery, disposeSearchResultsAsyncQuery] = (0, $irOoi.useQueryLoader)((0, $b96117069722906e$export$2e2bcd8739ae039));
    const [relayRightPanel, loadRightPanelQuery, disposeRightPanelQuery] = (0, $irOoi.useQueryLoader)((0, $71b133da64a47244$export$2e2bcd8739ae039));
    const [relayRightPanelAsync, loadRightPanelAsyncQuery, disposeRightPanelAsyncQuery] = (0, $irOoi.useQueryLoader)((0, $2589229aad43bae5$export$2e2bcd8739ae039));
    const [searchResultsCQLQueryReference, loadSearchResultsCQLQuery, disposeSearchResultsCQLQuery] = (0, $irOoi.useQueryLoader)((0, $atY36.default));
    const [resultsState, setResultsState] = (0, $42omo.useState)((0, $fZ3l2.ResultsStates).INITIAL);
    const { queryParams: queryParams, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const { clearAllFilters: clearAllFilters, resetSort: resetSort } = (0, $djVCD.useSearchActions)();
    const clearReferrer = (0, $j4ply.useClearReferrer)();
    const logError = (0, $f8oYd.useLogException)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const [features] = (0, $j4ply.useFeatures)();
    const isSideBySideEnabled = features?.sideBySide?.enabled ?? false;
    const isLiteMode = features?.lite?.enabled ?? false; // Local state for bootstrap, search, and selected input filters to update when Relay query resolves
    const [bootstrap, setBootstrap] = (0, $42omo.useState)(()=>(0, $bae6f8ff1d9250a0$export$cfd0a4eecdb5b49d)((0, $aaNIP.initialState)));
    const [search, setSearch] = (0, $42omo.useState)(()=>(0, $29e931a0b3bfc4fe$export$3761754c69bcbfc2)((0, $djVCD.initialState)));
    const [federatedSlackCount, setFederatedSlackCount] = (0, $42omo.useState)(null);
    const [federatedOutlookMailCount, setFederatedOutlookMailCount] = (0, $42omo.useState)(null);
    const [federatedGmailCount, setFederatedGmailCount] = (0, $42omo.useState)(null);
    const [hasMoreGmailResults, setHasMoreGmailResults] = (0, $42omo.useState)(false);
    const [hasMoreOutlookMailResults, setHasMoreOutlookMailResults] = (0, $42omo.useState)(false);
    const [hasRecordedAvailableProducts, setHasRecordedAvailableProducts] = (0, $42omo.useState)(false);
    const [productsWithTimeout, setProductsWithTimeout] = (0, $42omo.useState)();
    const [personalisedProductSections, setPersonalisedProductSections] = (0, $42omo.useState)(); // Sync thirdPartyConfigs from the bootstrap store into the local snapshot
    // so the right-panel sidebar reflects OAuth changes immediately.
    const [liveThirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    (0, $42omo.useEffect)(()=>{
        setBootstrap((prev)=>{
            if (prev.thirdPartyConfigs === liveThirdPartyConfigs) return prev;
            return {
                ...prev,
                thirdPartyConfigs: liveThirdPartyConfigs
            };
        });
    }, [
        liveThirdPartyConfigs
    ]); // Error boundary reset handling - creates a ref to store the reset callback
    // Calling resetErrorBoundary() will invoke the reset on the ErrorBoundary component without a remount
    const errorBoundaryResetCbRef = (0, $42omo.useRef)(undefined);
    const setErrorBoundaryResetCb = (0, $42omo.useCallback)((cb)=>{
        errorBoundaryResetCbRef.current = cb; // undefined acts as a cleanup
    }, []);
    const resetErrorBoundary = (0, $42omo.useCallback)(()=>{
        errorBoundaryResetCbRef.current?.();
    }, []);
    const bodyRef = (0, $42omo.useRef)(null);
    const mainContentRef = (0, $42omo.useRef)(null);
    const [maxResultsToShow, setMaxResultsToShow] = (0, $42omo.useState)(undefined);
    const [mainContentWidth, setMainContentWidth] = (0, $42omo.useState)(undefined);
    const { cloudId: cloudId, primaryProduct: primaryProduct, searchSessionId: searchSessionId, isRovoEnabled: isRovoEnabled, allFilterExcludedProducts: allFilterExcludedProducts, experimentConfig: experimentConfig, productEdition: productEdition, productDataRegions: productDataRegions, isJiraIssueIndexed: isJiraIssueIndexed, user: maybeUser, nouns: nouns, isNounsAvailable: isNounsAvailable, referrer: referrer } = bootstrap;
    const { jsmIncidentFilterIds: jsmIncidentFilterIds } = search; // Bootstrap params outside of local mirror state
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const availableProducts = (0, $j4ply.useAvailableProducts)(); // Search parameters independent of search store
    const { cql: cql, searchQuery: searchQuery, filters: filters_DO_NOT_USE_FOR_RENDERING, selectedProducts: selectedProducts, selectedDatasource: selectedDatasource } = (0, $42omo.useMemo)(()=>(0, $74x1m.getSearchConfig)({
            cloudId: cloudId || '',
            queryParams: queryParams,
            thirdPartyConfigs: thirdPartyConfigs
        }), [
        cloudId,
        queryParams,
        thirdPartyConfigs
    ]);
    const selectedProduct = selectedProducts[0]; // QS-9805: In the lite Jira-table experience, when the user clicks a different
    // product filter `selectedProduct` updates immediately but the new preloaded
    // query ref doesn't arrive until a subsequent render. During that window the
    // existing query ref still resolves to the previous filter's data - rendering
    // it would briefly flash stale rows from another product. We capture the
    // selectedProduct in scope at the moment the queryRef identity changes (i.e.
    // when fresh data has arrived for a freshly-loaded query) and fall back to
    // the existing loading skeleton when the captured selection no longer matches
    // the live one. Scoped to lite mode only because the reported regression is
    // specific to the lite Jira-table consumer (Atlassian Home / Townsquare);
    // other consumers (Confluence FPS, Jira FPS) keep their existing behaviour to
    // avoid an unrequested skeleton flash on filter clicks. Tracks the live ref
    // `(relaySearchResults ?? relaySearchResultsAsync)` because either loader can
    // drive the query depending on the `search_async_ssr` feature gate; watching
    // only one would cause the gate to never release in the other path.
    const activeSearchResultsQueryRef = relaySearchResults ?? relaySearchResultsAsync;
    const lastQueryRefForResultsRef = (0, $42omo.useRef)(activeSearchResultsQueryRef);
    const lastSelectionForResultsRef = (0, $42omo.useRef)(selectedProduct);
    if (lastQueryRefForResultsRef.current !== activeSearchResultsQueryRef) {
        lastQueryRefForResultsRef.current = activeSearchResultsQueryRef;
        lastSelectionForResultsRef.current = selectedProduct;
    }
    const resultsDataMatchesSelection = lastSelectionForResultsRef.current === selectedProduct;
    const appMode = (0, $c2HNo.getApplicationMode)({
        isRovoEnabled: isRovoEnabled
    });
    const user = (0, $42omo.useMemo)(()=>(0, $2x777.getUser)(maybeUser), [
        maybeUser
    ]); /**
                                                                * QS-7760
                                                                *
                                                                * Our search page DOM looks like this:
                                                                * - 1. Input
                                                                * - 2. Autocorrect
                                                                * - 3. SAIN
                                                                * - 4. Results list
                                                                *
                                                                * 2 and 4 comes from the search query, which suspends.
                                                                * 3 needs to be rendered immediately to begin the SAIN query (which can show before results return), but also needs to render between 2 and 4 in DOM
                                                                * So we use a portal to insert 2 above 3
                                                                * Otherwise 3 will be within the common suspense parent of 2 and 4, and not render until the query is resolved
                                                                * We also dont want to shw 3 in the suspense fallback, as when suspense finishes a remount is triggered (which flashes the SAIN UI)
                                                                *
                                                                * We considered splitting 2 and 4 but would need to implement `usePreloadedQuery` independently (with all pagination, query vars etc) but decided to take this approach to reduce the risk surface/complexity of the queries changing
                                                                */ 
    const autoCorrectPortalRef = (0, $42omo.useRef)(null);
    const autoCorrectPortal = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $4fce253db54ab402$var$autoCorrectStyles.root,
        ref: autoCorrectPortalRef
    }); // Ref to the SAIN portal which is used by the Navigational Card that's rendered in the smart answer component
    const smartAnswersPortalRef = (0, $42omo.useRef)(null); // Ref to a full-width portal target in Body, used to render the Jira NL SAIN card above the two-column layout
    const fullWidthSainPortalRef = (0, $42omo.useRef)(null); // Ref for backend experiment data used when fetching search results
    const backendExperimentRef = (0, $42omo.useRef)(); // Ideally we can refactor filters so that we run this function only when the filters change.
    // This would allow us to have the object in state.
    const getSelectedFilters = (0, $42omo.useMemo)(()=>()=>(0, $8uOED.getSelectedFilters)({
                filters: filters_DO_NOT_USE_FOR_RENDERING,
                selectedProducts: selectedProducts,
                availableProducts: availableProducts,
                allFilterExcludedProducts: allFilterExcludedProducts,
                thirdPartyConfigs: thirdPartyConfigs,
                jsmIncidentFilterIds: jsmIncidentFilterIds,
                currentUserId: user?.id
            }), [
        filters_DO_NOT_USE_FOR_RENDERING,
        selectedProducts,
        availableProducts,
        allFilterExcludedProducts,
        thirdPartyConfigs,
        jsmIncidentFilterIds,
        user?.id
    ]);
    const resultsLoading = isLiteMode && (0, $22zVp.isJiraProduct)(selectedProduct) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: "search-page-results-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2c669b87d30f9508$export$c34f5bff0276748), {})
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: "search-page-results-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0d9e2bc48f29be1$export$18a2402e95ebb069), {
            rowCount: 10
        })
    });
    const resultsConfigLoading = /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
        name: "search-page-results-config-loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e0d9e2bc48f29be1$export$18a2402e95ebb069), {
            rowCount: 10
        })
    }); /**
                    * Our use of:
                    * 1. Suspense -> RightpanelContainer
                    * 2. rightPanelLoading -> Suspense<fallback={rightPanelLoading}>
                    * 3. AppFilterSidebarLoading
                    *
                    * Is so that we get a loading state on counts:
                    * - 3 is the skeleton state (during bootstrap, no connectors) - HOLD(seach-page-right-panel-config-loading)
                    * - 2 is the suspense state (during search, no counts, has connectors) - HOLD(seach-page-right-panel-counts-loading)
                    * - 1 is the end state (counts!)
                    *
                    * Note that FG(rovo-search-right-rail-personalisation) modifies this to:
                    * - 3 is the skeleton state (during bootstrap, no connectors) - HOLD(seach-page-right-panel-config-loading)
                    * - 2 is the suspense state (during counts query, no RR rendered) - HOLD(seach-page-right-panel-loading)
                    * - 1 is the end state (connectors + counts!)
                    *
                    * Problem is when we render 1, we throw away 2 which isn't great for performance.
                    *
                    * https://product-fabric.atlassian.net/browse/QS-7802 for improvement
                    */ 
    const rightPanelWithoutResultCounts = /*#__PURE__*/ (0, $l998X.jsx)((0, $7cc050d1a4a09085$export$364a989a35814102), {
        cloudId: cloudId,
        searchQuery: searchQuery,
        primaryProduct: primaryProduct,
        experimentConfig: experimentConfig,
        selectedProducts: selectedProducts,
        user: user,
        appMode: appMode,
        selectedProduct: selectedProduct,
        selectedDatasource: selectedDatasource,
        availableNouns: nouns,
        availableProducts: availableProducts,
        isNounsAvailable: isNounsAvailable,
        thirdPartyConfigs: thirdPartyConfigs,
        personalisedProductSections: personalisedProductSections,
        productsWithTimeout: productsWithTimeout
    });
    const rightPanelWithLoadingResultCounts = /*#__PURE__*/ (0, $l998X.jsx)((0, $7cc050d1a4a09085$export$364a989a35814102), {
        cloudId: cloudId,
        searchQuery: searchQuery,
        primaryProduct: primaryProduct,
        experimentConfig: experimentConfig,
        selectedProducts: selectedProducts,
        user: user,
        appMode: appMode,
        selectedProduct: selectedProduct,
        selectedDatasource: selectedDatasource,
        availableNouns: nouns,
        availableProducts: availableProducts,
        isNounsAvailable: isNounsAvailable,
        thirdPartyConfigs: thirdPartyConfigs,
        personalisedProductSections: personalisedProductSections,
        productsWithTimeout: productsWithTimeout,
        resultCountsLoading: true
    }); // In this state the RR has connectors but no counts
    const rightPanelWithoutResultCountsLoading = /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwDOR.default), {
        name: "search-page-right-panel-counts-loading",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f43a1e29196bf274$export$3c6a6c4c70845302), {
                setProductsWithTimeout: setProductsWithTimeout
            }),
            rightPanelWithoutResultCounts
        ]
    }); // In this state, we're waiting for 1P+3P config to be available
    const rightPanelConfigLoadingSkeleton = /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwDOR.default), {
        name: "search-page-right-panel-config-loading",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f43a1e29196bf274$export$3c6a6c4c70845302), {
                setProductsWithTimeout: setProductsWithTimeout
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7cc050d1a4a09085$export$98c4d2ac9cd9730), {})
        ]
    }); // In this state, we're waiting for the RR to be ready
    const rightPanelLoadingSkeleton = /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwDOR.default), {
        name: "search-page-right-panel-loading",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f43a1e29196bf274$export$3c6a6c4c70845302), {
                setProductsWithTimeout: setProductsWithTimeout
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7cc050d1a4a09085$export$98c4d2ac9cd9730), {})
        ]
    }); // In this state, we're waiting for the RR to be ready, but apps are visible
    const rightPanelLoadingSkeletonWithAppsVisible = /*#__PURE__*/ (0, $l998X.jsxs)((0, $fwDOR.default), {
        name: "search-page-right-panel-counts-loading",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f43a1e29196bf274$export$3c6a6c4c70845302), {
                setProductsWithTimeout: setProductsWithTimeout
            }),
            rightPanelWithLoadingResultCounts
        ]
    }); // Log a health metric for accessible products
    (0, $42omo.useEffect)(()=>{
        // When null or empty bootstrap isn't ready. Even failed bootstrap will have primaryProduct in the set
        if (availableProducts && availableProducts.length > 0 && !hasRecordedAvailableProducts) {
            fireAnalyticsEvent((0, $0e1691e3261af771$export$abd5de3aada5ec8b)({
                availableProducts: availableProducts,
                searchSessionId: searchSessionId
            }));
            setHasRecordedAvailableProducts(true);
        }
    }, [
        availableProducts,
        hasRecordedAvailableProducts,
        fireAnalyticsEvent,
        searchSessionId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (searchQuery.length === 0) setProductsWithTimeout(undefined);
    }, [
        searchQuery
    ]); // Clean up on unmount
    (0, $42omo.useEffect)(()=>()=>{
            // Dispose query updated time
            (0, $20r3r.disposeQueryUpdatedTime)();
        }, []);
    const bootstrapReady = availableProducts.length > 0;
    const hasAnyFilterSelected = (0, $42omo.useMemo)(()=>{
        return Boolean(selectedProduct) || getSelectedFilters().hasFiltersSelected;
    }, [
        selectedProduct,
        getSelectedFilters
    ]); // Derive mode from the same local mirror state used for rendering.
    const mode = (0, $42omo.useMemo)(()=>(0, $411ad342376b971d$export$87ba7e4f15231598)({
            bootstrapReady: bootstrapReady,
            availableProducts: availableProducts,
            selectedProduct: selectedProduct,
            searchQuery: searchQuery,
            hasAnyFilterSelected: hasAnyFilterSelected,
            cql: cql
        }), [
        bootstrapReady,
        availableProducts,
        selectedProduct,
        searchQuery,
        hasAnyFilterSelected,
        cql
    ]);
    const newProductMessageBanner = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $c00f6725a09cf8c9$export$37ce7744bd1ee394), {
            searchQuery: searchQuery,
            selectedProduct: selectedProduct,
            selectedProducts: selectedProducts,
            primaryProduct: primaryProduct,
            cloudId: cloudId,
            experimentConfig: experimentConfig,
            user: user,
            applicationMode: appMode
        }), [
        searchQuery,
        selectedProduct,
        selectedProducts,
        primaryProduct,
        cloudId,
        experimentConfig,
        user,
        appMode
    ]);
    const content = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $522e970424cd3461$export$d152b66e844f2488), {
                preloadDataProvider: preloadDataProvider,
                loadSearchResultsQuery: loadSearchResultsQuery,
                disposeSearchResultsQuery: disposeSearchResultsQuery,
                loadSearchResultsAsyncQuery: loadSearchResultsAsyncQuery,
                disposeSearchResultsAsyncQuery: disposeSearchResultsAsyncQuery,
                loadRightPanelQuery: isLiteMode ? undefined : loadRightPanelQuery,
                disposeRightPanelQuery: isLiteMode ? undefined : disposeRightPanelQuery,
                loadRightPanelAsyncQuery: isLiteMode ? undefined : loadRightPanelAsyncQuery,
                disposeRightPanelAsyncQuery: isLiteMode ? undefined : disposeRightPanelAsyncQuery,
                loadSearchResultsCQLQuery: loadSearchResultsCQLQuery,
                disposeSearchResultsCQLQuery: disposeSearchResultsCQLQuery,
                setBootstrap: setBootstrap,
                setSearch: setSearch,
                setResultsState: setResultsState,
                resetErrorBoundary: resetErrorBoundary,
                bodyRef: bodyRef,
                setMaxResultsToShow: setMaxResultsToShow,
                backendExperimentRef: backendExperimentRef,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                isRovoLLMEnabled: isRovoLLMEnabled,
                logError: logError,
                cql: cql,
                searchQuery: searchQuery,
                filters: filters_DO_NOT_USE_FOR_RENDERING,
                selectedProducts: selectedProducts,
                queryParams: queryParams,
                isLiteMode: isLiteMode
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $f8be7d82aac68e80$export$4b2c32e08f77ff18), {
                bodyRef: bodyRef,
                mainContentRef: mainContentRef,
                setMainContentWidth: setMainContentWidth,
                selectedProduct: selectedProduct,
                primaryProduct: primaryProduct,
                sideBySide: isSideBySideEnabled,
                isLiteMode: isLiteMode,
                fullWidthSainPortalRef: fullWidthSainPortalRef,
                rightPanel: isLiteMode ? undefined : /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                    section: "SearchPageRelayRightPanel",
                    fallback: rightPanelWithoutResultCounts,
                    children: bootstrapReady ? // In RESULTS mode we suspend on the counts query, otherwise we render the prequery right rail.
                    mode === 'RESULTS' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                        fallback: (0, $dh538.fg)('rovo-search-right-rail-personalisation') ? (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() !== 'single-select' ? rightPanelLoadingSkeletonWithAppsVisible : rightPanelLoadingSkeleton : rightPanelWithoutResultCountsLoading,
                        children: relayRightPanel || relayRightPanelAsync ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
                            name: "search-page-right-panel",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7cc050d1a4a09085$export$dbcc7c3a8377a3be), {
                                cloudId: cloudId,
                                searchQuery: searchQuery,
                                primaryProduct: primaryProduct,
                                experimentConfig: experimentConfig,
                                selectedProducts: selectedProducts,
                                user: user,
                                appMode: appMode,
                                rightPanelQueryRef: relayRightPanel ?? relayRightPanelAsync,
                                selectedProduct: selectedProduct,
                                selectedDatasource: selectedDatasource,
                                availableNouns: nouns,
                                availableProducts: availableProducts,
                                isNounsAvailable: isNounsAvailable,
                                thirdPartyConfigs: thirdPartyConfigs,
                                federatedSlackCount: federatedSlackCount,
                                federatedOutlookMailCount: federatedOutlookMailCount,
                                federatedGmailCount: federatedGmailCount,
                                hasMoreGmailResults: hasMoreGmailResults,
                                hasMoreOutlookMailResults: hasMoreOutlookMailResults,
                                personalisedProductSections: personalisedProductSections,
                                setPersonalisedProductSections: setPersonalisedProductSections,
                                productsWithTimeout: productsWithTimeout
                            })
                        }) : (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() !== 'single-select' ? rightPanelWithoutResultCountsLoading : rightPanelLoadingSkeleton
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $f43a1e29196bf274$export$3c6a6c4c70845302), {
                                setProductsWithTimeout: setProductsWithTimeout
                            }),
                            rightPanelWithoutResultCounts
                        ]
                    }) : rightPanelConfigLoadingSkeleton
                }),
                children: [
                    autoCorrectPortal,
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
                        name: "search-page-sain",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ec4f905bffd8c643$export$2e2bcd8739ae039), {
                            resultsState: resultsState,
                            isLiteMode: isLiteMode,
                            isRelayEnabled: true,
                            smartAnswersPortalRef: smartAnswersPortalRef,
                            fullWidthSainPortalRef: fullWidthSainPortalRef
                        })
                    }),
                    primaryProduct === (0, $6Gsan.PrimaryProductKeys).Assets && !(0, $dh538.fg)('assets_rovo_search_all') && /*#__PURE__*/ (0, $l998X.jsx)((0, $d7417ff36c8b22bc$export$8d42f71dae8efa55), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1nJM3.ErrorBoundary), {
                        section: "SearchPageRelayResults",
                        setErrorBoundaryResetCb: setErrorBoundaryResetCb,
                        onException: ()=>{
                            (0, $bVltF.searchResultsLoadUFOExperienceError)();
                            setResultsState((0, $fZ3l2.ResultsStates).ERROR);
                        },
                        // always receives actual error details (not generic "Error" message).
                        // This enables:
                        // 1. Specific error messages in VitalStats taskFail events (e.g., "NetworkError: Failed to fetch")
                        // 2. Better error tracking and debugging
                        // 3. Single rendering path for consistency
                        renderWithErrorInfo: ({ error: error, errorInfo: errorInfo })=>{
                            // Evaluate feature gate unconditionally to ensure exposure tracking
                            // (required by @atlaskit/platform/no-preconditioning linter rule)
                            const showErrorDetails = (0, $dh538.fg)('result_error_info_in_non_prod');
                            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                children: [
                                    showErrorDetails && false,
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6b25d1ac83f43781$export$edf27be85e5f6da0), {
                                        fetchResults: ()=>window.location.reload(),
                                        error: error
                                    })
                                ]
                            });
                        },
                        children: mode === 'BOOTSTRAP_LOADING' ? resultsConfigLoading : mode === 'LANDING' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                            name: "search-page-results-landing",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $448d3451574c04df$export$12449a31c6671d53), {
                                applicationMode: appMode,
                                isAdminHubAIEnabled: isAdminHubAIEnabled,
                                isRovoLLMEnabled: isRovoLLMEnabled
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                            fallback: resultsLoading,
                            children: mode === 'RESULTS' && isLiteMode && !resultsDataMatchesSelection ? resultsLoading : mode === 'RESULTS' && (relaySearchResults || relaySearchResultsAsync) ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
                                name: "search-page-results",
                                children: [
                                    newProductMessageBanner,
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $e283d0740cdc7b40$export$8230160803576e3b), {
                                        searchResultsQueryRef: relaySearchResults ?? relaySearchResultsAsync,
                                        aggAbsoluteUrl: aggAbsoluteUrl,
                                        autoCorrectPortalRef: autoCorrectPortalRef,
                                        smartAnswersPortalRef: smartAnswersPortalRef,
                                        debugPortalRef: debugPortalRef,
                                        setResultsState: setResultsState,
                                        searchQuery: searchQuery,
                                        cloudId: cloudId,
                                        primaryProduct: primaryProduct,
                                        selectedProduct: selectedProduct,
                                        thirdPartyConfigs: thirdPartyConfigs,
                                        availableProducts: availableProducts,
                                        searchSessionId: searchSessionId,
                                        experimentConfig: experimentConfig,
                                        productEdition: productEdition,
                                        productDataRegions: productDataRegions,
                                        isJiraIssueIndexed: isJiraIssueIndexed,
                                        appMode: appMode,
                                        getSelectedFilters: getSelectedFilters,
                                        clearFilters: ()=>{
                                            clearAllFilters();
                                            resetSort();
                                        },
                                        clearReferrer: clearReferrer,
                                        referrer: referrer,
                                        logError: logError,
                                        setFederatedSlackCount: setFederatedSlackCount,
                                        setFederatedOutlookMailCount: setFederatedOutlookMailCount,
                                        setFederatedGmailCount: setFederatedGmailCount,
                                        setHasMoreGmailResults: setHasMoreGmailResults,
                                        setHasMoreOutlookMailResults: setHasMoreOutlookMailResults,
                                        setProductsWithTimeout: setProductsWithTimeout,
                                        bodyRef: bodyRef,
                                        maxResultsToShow: maxResultsToShow,
                                        setMaxResultsToShow: setMaxResultsToShow,
                                        mainContentWidth: mainContentWidth,
                                        backendExperimentRef: backendExperimentRef
                                    })
                                ]
                            }) : mode === 'CQL_RESULTS' && searchResultsCQLQueryReference ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $hnvzE.default), {
                                name: "search-page-results-cql",
                                children: [
                                    newProductMessageBanner,
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $29779de3a21de1c2$export$41bc27d9d5d29437), {
                                        availableProducts: availableProducts,
                                        backendExperimentRef: backendExperimentRef,
                                        bodyRef: bodyRef,
                                        clearReferrer: clearReferrer,
                                        cloudId: cloudId,
                                        experimentConfig: experimentConfig,
                                        getSelectedFilters: getSelectedFilters,
                                        isJiraIssueIndexed: isJiraIssueIndexed,
                                        maxResultsToShow: maxResultsToShow,
                                        productDataRegions: productDataRegions,
                                        productEdition: productEdition,
                                        referrer: referrer,
                                        searchQuery: searchQuery,
                                        searchResultsCQLQueryReference: searchResultsCQLQueryReference,
                                        searchSessionId: searchSessionId,
                                        selectedProduct: selectedProduct,
                                        primaryProduct: primaryProduct,
                                        appMode: appMode,
                                        mainContentWidth: mainContentWidth,
                                        setMaxResultsToShow: setMaxResultsToShow,
                                        setResultsState: setResultsState,
                                        thirdPartyConfigs: thirdPartyConfigs
                                    })
                                ]
                            }) : resultsLoading
                        })
                    })
                ]
            })
        ]
    });
    return content;
});
const $4fce253db54ab402$var$DebugPanelPortal = ({ debugPortalRef: debugPortalRef })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $821ff4954924b9b5$export$11556de7beafcaf8)());
    }, [
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: debugPortalRef
    });
};
const $4fce253db54ab402$export$c3f0fa3e50c0d1e9 = ({ aggAbsoluteUrl: aggAbsoluteUrl, headerOffset: headerOffset, preloadDataProvider: preloadDataProvider })=>{
    const { isNav4Enabled: isNav4Enabled } = (0, $7WbA8.useAppContext)();
    const [features] = (0, $j4ply.useFeatures)();
    const [searchQueryParams] = (0, $j4ply.useQueryParams)();
    const { primaryProduct: primaryProduct } = (0, $j4ply.useBootstrapState)((0, $bae6f8ff1d9250a0$export$cfd0a4eecdb5b49d));
    const debugPortalRef = (0, $42omo.useRef)(null);
    const isSideBySideEnabled = features?.sideBySide?.enabled ?? false;
    const isLiteMode = features?.lite?.enabled ?? false;
    const hasOverrides = Boolean(searchQueryParams?.overrides);
    const showDebugPanel = (isSideBySideEnabled || hasOverrides) && (0, $dh538.fg)('enable_rovo_search_overrides');
    const queryText = typeof searchQueryParams?.text === 'string' ? searchQueryParams.text : undefined;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f170baa2e5c0a53b$export$89dff4039d0e5c2d), {
                primaryProduct: primaryProduct,
                query: queryText
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $849ee461ff61ea47$export$c84671f46d6a1ca), {
                headerOffset: headerOffset,
                children: [
                    showDebugPanel && /*#__PURE__*/ (0, $l998X.jsx)($4fce253db54ab402$var$DebugPanelPortal, {
                        debugPortalRef: debugPortalRef
                    }),
                    isLiteMode ? /*#__PURE__*/ (0, $l998X.jsx)((0, $be490c0458782317$export$694105dda8ac2ac1), {
                        input: isNav4Enabled ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $1a733a128842bf36$export$2e2bcd8739ae039), {}),
                        filters: /*#__PURE__*/ (0, $l998X.jsx)((0, $96ac82e899780ca0$export$2e2bcd8739ae039), {}),
                        feedback: /*#__PURE__*/ (0, $l998X.jsx)((0, $581d88978d17bd2f$export$e6b7dda6e06d753e), {})
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3867e15ac7e3b5d9$export$8b251419efc915eb), {
                        primaryProduct: primaryProduct,
                        input: isNav4Enabled ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $1a733a128842bf36$export$2e2bcd8739ae039), {}),
                        filters: /*#__PURE__*/ (0, $l998X.jsx)((0, $96ac82e899780ca0$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($4fce253db54ab402$var$SearchPageBody, {
                        aggAbsoluteUrl: aggAbsoluteUrl,
                        debugPortalRef: debugPortalRef,
                        preloadDataProvider: preloadDataProvider
                    })
                ]
            })
        ]
    });
};










var $brXu2 = parcelRequire("brXu2");





const $9b6053aa72d69c53$export$a54ec244c8863715 = ({ shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, onSearchResultsShown: onSearchResultsShown, headerOffset: headerOffset })=>{
    const { queryParams: queryParams, isNav4Enabled: isNav4Enabled, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = shell;
    const getFrontendExperiment = (0, $42omo.useMemo)(()=>(0, $iA4lt.createFrontendExperimentHandler)(), []);
    const getFrontendGate = (0, $42omo.useMemo)(()=>(0, $iA4lt.createFeatureGateHandler)(undefined), []);
    const [isOnline, _] = (0, $42omo.useState)(navigator.onLine);
    (0, $42omo.useEffect)(()=>{
        (0, $c7e627886411fcb9$export$5e3e5ca9e3ba891b)(isOnline, (0, (/*@__PURE__*/$parcel$interopDefault($6df538e2e254fd26$exports))), (0, $c7e627886411fcb9$export$add61e2630a21f9), (0, (/*@__PURE__*/$parcel$interopDefault($d264f14dd361aa2b$exports))), (0, $c7e627886411fcb9$export$4be43fd067fd9d7f));
    }, [
        isOnline
    ]);
    // hold on to the first function reference passed to the package to
    // avoid excessive re-rendering if the consumer doesn't pass in
    // a stable function
    const mapUserIdToProfileUrlRef = (0, $42omo.useRef)(mapUserIdToProfileUrl);
    // Start capturing extensions for the active search query and CQL query
    (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('search_async_ssr')) (0, $4xBBd.startCapturingExtensions)((0, $b96117069722906e$export$2e2bcd8739ae039).operation.name);
        else (0, $4xBBd.startCapturingExtensions)((0, $7Ngf7.default).operation.name);
        (0, $4xBBd.startCapturingExtensions)((0, $atY36.default).operation.name);
    }, []);
    // Clear extensions on unmount for the active search query and CQL query
    (0, $42omo.useEffect)(()=>()=>{
            if ((0, $dh538.fg)('search_async_ssr')) (0, $4xBBd.stopCapturingExtensions)((0, $b96117069722906e$export$2e2bcd8739ae039).operation.name);
            else (0, $4xBBd.stopCapturingExtensions)((0, $7Ngf7.default).operation.name);
            (0, $4xBBd.stopCapturingExtensions)((0, $atY36.default).operation.name);
        }, []);
    (0, $brXu2.reconcileSsrSearchSessionId)((0, $lRrav.SEARCH_SESSION_ID), shell.cloudId, shell.preloadDataProvider);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: "search-page-relay",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.RelayEnvironmentProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $86ob4.WidthObserverProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2bb9aeea11dbc94b$export$f6a06b563a614935), {
                    ...shell,
                    callbacks: callbacks,
                    searchSessionId: (0, $lRrav.SEARCH_SESSION_ID).value(),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2lmJQ.default), {
                        experience: (0, $9rRKJ.SearchExperience).SEARCH_PAGE,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7WbA8.AppContextProvider), {
                            mapUserIdToProfileUrl: mapUserIdToProfileUrlRef.current,
                            generateSearchUrl: generateSearchUrl,
                            queryParams: queryParams,
                            onNavigate: onNavigate,
                            getFrontendExperiment: getFrontendExperiment,
                            getFeatureGate: getFrontendGate,
                            isNav4Enabled: isNav4Enabled,
                            isAdminHubAIEnabled: isAdminHubAIEnabled,
                            isRovoLLMEnabled: isRovoLLMEnabled,
                            onSearchResultsShown: onSearchResultsShown,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7bZ3i.SmartCardProvider), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3f9016d1e452d4e9$export$119dcb5621de506f), {
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4fce253db54ab402$export$c3f0fa3e50c0d1e9), {
                                            headerOffset: headerOffset,
                                            aggAbsoluteUrl: shell.aggAbsoluteUrl,
                                            preloadDataProvider: shell.preloadDataProvider
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};


function $c77fa5848e4f5168$export$a54ec244c8863715(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9b6053aa72d69c53$export$a54ec244c8863715), {
        ...props
    });
}
function $c77fa5848e4f5168$export$e5dd664a472559bb({ shell: shell, ...props }) {
    const shellWithLite = (0, $42omo.useMemo)(()=>({
            ...shell,
            features: {
                lite: {
                    enabled: true
                }
            }
        }), [
        shell
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9b6053aa72d69c53$export$a54ec244c8863715), {
        ...props,
        shell: shellWithLite
    });
}
function $c77fa5848e4f5168$export$2194eaf953b87e28({ shell: shell, experiments: experiments, ...props }) {
    const shellWithSideBySide = (0, $42omo.useMemo)(()=>({
            ...shell,
            features: {
                sideBySide: {
                    enabled: true,
                    experiments: experiments
                }
            }
        }), [
        shell,
        experiments
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9b6053aa72d69c53$export$a54ec244c8863715), {
        ...props,
        shell: shellWithSideBySide
    });
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 















const $aac8e94998d25d17$export$a5e892786b028f3b = {
    ROVO_COMPARISON_TOOL: 'rovoComparisonTool'
};
const $aac8e94998d25d17$export$76a2e4c433c23bb9 = {
    UI: 'ui',
    TRACK: 'track',
    SCREEN: 'screen',
    OPERATIONAL: 'operational'
};
const $aac8e94998d25d17$export$dce83e8417873763 = {
    SEND_UI_EVENT: 'sendUIEvent',
    SEND_TRACK_EVENT: 'sendTrackEvent',
    SEND_SCREEN_EVENT: 'sendScreenEvent',
    SEND_OPERATIONAL_EVENT: 'sendOperationalEvent'
};
const $aac8e94998d25d17$export$85183a312807388d = 'sideBySide';
const $aac8e94998d25d17$export$32fb395bad9ce8e9 = {
    CLOSED: 'closed',
    CANCELED: 'canceled',
    SUBMITTED: 'submitted'
};








var $a9sR2 = parcelRequire("a9sR2");

var $5DUgU = parcelRequire("5DUgU");


var $kDuN4 = parcelRequire("kDuN4");


const $25d14e15020f60a9$export$3bb03aa5c3d29986 = ({ children: children, tenantId: tenantId, userId: userId, entryPoint: entryPoint })=>{
    const webClient = $25d14e15020f60a9$export$e9ba7ef9458d1a4a({
        hostname: window.location.hostname
    }, {
        product: (0, $aac8e94998d25d17$export$a5e892786b028f3b).ROVO_COMPARISON_TOOL
    });
    if (tenantId) webClient.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, tenantId);
    if (userId) webClient.setUserInfo((0, $5DUgU.userType).ATLASSIAN_ACCOUNT, userId);
    const onEvent = (0, $42omo.useCallback)(({ payload: payload })=>{
        webClient.onEvent((0, $aac8e94998d25d17$export$85183a312807388d), {
            ...payload,
            attributes: {
                ...payload?.attributes,
                entryPoint: entryPoint
            }
        });
    }, [
        webClient,
        entryPoint
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
        channel: "sideBySide",
        onEvent: onEvent,
        children: children
    });
};
const $25d14e15020f60a9$var$getAnalyticsEnv = (hostname)=>{
    let env;
    switch(hostname){
        case 'jira-dev.com':
            env = 'staging';
            break;
        case 'localhost':
            env = 'local';
            break;
        default:
            env = 'prod';
    }
    return env;
};
const $25d14e15020f60a9$export$e9ba7ef9458d1a4a = ({ hostname: hostname }, { product: product })=>{
    const client = new (0, $a9sR2.default)({
        product: product,
        env: $25d14e15020f60a9$var$getAnalyticsEnv(hostname || window.location.hostname),
        origin: (0, $5DUgU.originType).WEB
    });
    return client;
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $bomBS = parcelRequire("bomBS");






const $b64f6fa9c7e14125$var$styles = {
    container: "_1rjcxy5q _1e0c1txw _1wpz1fhb _1o9zidpf",
    clickArea: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb7vkz _bfhk1j28",
    indicator: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1rjc1b66 _18zrv77o _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe _1e0c1txw _4cvr1h6o _1bah1h6o _bfhkvuon _16qs1nax _1pbykb7n _lcxvglyw",
    divider: "_kqswh2mm _1o9zidpf _1wpz1fhb _gx38e4h9 _ngwonqa1 _14vn1l7x"
};
function $b64f6fa9c7e14125$export$78d024e30be11d59({ expandedSide: expandedSide, onExpandSide: onExpandSide }) {
    const [hoveredSide, setHoveredSide] = (0, $42omo.useState)(null);
    const handleLeftClick = (0, $42omo.useCallback)(()=>{
        onExpandSide(expandedSide ? null : 'left');
    }, [
        expandedSide,
        onExpandSide
    ]);
    const handleRightClick = (0, $42omo.useCallback)(()=>{
        onExpandSide(expandedSide ? null : 'right');
    }, [
        expandedSide,
        onExpandSide
    ]);
    const isExpanded = expandedSide !== null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $b64f6fa9c7e14125$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                xcss: $b64f6fa9c7e14125$var$styles.clickArea,
                onClick: handleLeftClick,
                onMouseEnter: ()=>setHoveredSide('left'),
                onMouseLeave: ()=>setHoveredSide((current)=>current === 'left' ? null : current),
                "aria-label": isExpanded ? 'Reset to side-by-side' : 'Expand left panel'
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $b64f6fa9c7e14125$var$styles.divider,
                children: hoveredSide && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $b64f6fa9c7e14125$var$styles.indicator,
                    children: isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bomBS))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        size: "small"
                    }) : hoveredSide === 'left' ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        size: "small"
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        size: "small"
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                xcss: $b64f6fa9c7e14125$var$styles.clickArea,
                onClick: handleRightClick,
                onMouseEnter: ()=>setHoveredSide('right'),
                onMouseLeave: ()=>setHoveredSide((current)=>current === 'right' ? null : current),
                "aria-label": isExpanded ? 'Reset to side-by-side' : 'Expand right panel'
            })
        ]
    });
}


const $10ee11d11e004dd8$var$filterQueryParams = (queryParams, side)=>{
    if (!queryParams) return {};
    const filteredQueryParams = {
        ...queryParams
    }; // Transform leftOverrides or rightOverrides into 'overrides' based on side
    const experimentsKey = side === 'left' ? 'leftOverrides' : 'rightOverrides';
    if (queryParams[experimentsKey]) filteredQueryParams.overrides = queryParams[experimentsKey];
    return filteredQueryParams;
};
const $10ee11d11e004dd8$var$SearchPageWithAbstractedQueryParams = (props)=>{
    const [queryParams, setQueryParams] = (0, $42omo.useState)($10ee11d11e004dd8$var$filterQueryParams(props.shell.queryParams, props.side));
    const previousQueryParams = (0, $42omo.useRef)(queryParams);
    (0, $42omo.useEffect)(()=>{
        const filteredQueryParams = $10ee11d11e004dd8$var$filterQueryParams(props.shell.queryParams, props.side);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hL7bb)))(filteredQueryParams, previousQueryParams.current)) return;
        setQueryParams(filteredQueryParams);
        previousQueryParams.current = filteredQueryParams;
    }, [
        props.shell.queryParams,
        props.side
    ]);
    const shellWithAbstractedQueryParams = (0, $42omo.useMemo)(()=>{
        return {
            ...props.shell,
            queryParams: queryParams
        };
    }, [
        props.shell,
        queryParams
    ]);
    const callbacksWithAbstractedQueryParams = (0, $42omo.useMemo)(()=>{
        return {
            ...props.callbacks,
            updateQueryParameters: (queryParams)=>{
                setQueryParams(queryParams ?? {});
            }
        };
    }, [
        props.callbacks
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c77fa5848e4f5168$export$2194eaf953b87e28), {
        ...props,
        shell: shellWithAbstractedQueryParams,
        callbacks: callbacksWithAbstractedQueryParams
    });
};
const $10ee11d11e004dd8$var$styles = {
    container: "_1e0c1txw _1bah1h6o",
    searchItem: "_16jlkb7n _1o9zkb7n _i0dlf1ug _18zrpxbi _1rjcpxbi",
    searchItemHidden: "_1e0cglyw"
};
function $10ee11d11e004dd8$var$EnterpriseFeedbackComparisonPageInner(props) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            name: 'sideBySideComparisonScreen',
            type: (0, $aac8e94998d25d17$export$dce83e8417873763).SEND_SCREEN_EVENT,
            eventType: (0, $aac8e94998d25d17$export$76a2e4c433c23bb9).SCREEN,
            source: (0, $aac8e94998d25d17$export$85183a312807388d)
        }).fire((0, $aac8e94998d25d17$export$85183a312807388d));
    }, [
        createAnalyticsEvent
    ]);
    const [expandedSide, setExpandedSide] = (0, $42omo.useState)(null);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $10ee11d11e004dd8$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: expandedSide === 'right' ? $10ee11d11e004dd8$var$styles.searchItemHidden : $10ee11d11e004dd8$var$styles.searchItem,
                children: /*#__PURE__*/ (0, $l998X.jsx)($10ee11d11e004dd8$var$SearchPageWithAbstractedQueryParams, {
                    ...props,
                    side: "left"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $b64f6fa9c7e14125$export$78d024e30be11d59), {
                expandedSide: expandedSide,
                onExpandSide: setExpandedSide
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: expandedSide === 'left' ? $10ee11d11e004dd8$var$styles.searchItemHidden : $10ee11d11e004dd8$var$styles.searchItem,
                children: /*#__PURE__*/ (0, $l998X.jsx)($10ee11d11e004dd8$var$SearchPageWithAbstractedQueryParams, {
                    ...props,
                    side: "right"
                })
            })
        ]
    });
}
function $10ee11d11e004dd8$export$d856f3183c4e6577(props) {
    const { shell: shell } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $25d14e15020f60a9$export$3bb03aa5c3d29986), {
        userId: shell.user?.id,
        tenantId: shell.cloudId,
        entryPoint: props.entryPoint,
        children: /*#__PURE__*/ (0, $l998X.jsx)($10ee11d11e004dd8$var$EnterpriseFeedbackComparisonPageInner, {
            ...props
        })
    });
}



var $6mKj3 = parcelRequire("6mKj3");


var $56QzY = parcelRequire("56QzY");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $2Fqwa = parcelRequire("2Fqwa");


var $3LDzU = parcelRequire("3LDzU");


var $9wGTI = parcelRequire("9wGTI");


var $1xpoY = parcelRequire("1xpoY");

parcelRequire("eLV9q");
var $eWzPA = parcelRequire("eWzPA");


var $hU34N = parcelRequire("hU34N");

/**
 * @generated SignedSource<<6e99e23b24e120d224f4d5dc57f82578>>
 * @relayHash 661be1aed012c73ddf57359bb2f0fd03
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 444ca279fa290fc5e4ffd44221107b411b77e5d0204ea16d406462977970c79a
const $a49e7312a1e2cb42$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKeys"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKeys",
                    "variableName": "spaceKeys"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useGetSpaceIdsFromSpaceKeysQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useGetSpaceIdsFromSpaceKeysQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "661be1aed012c73ddf57359bb2f0fd03",
            "id": "444ca279fa290fc5e4ffd44221107b411b77e5d0204ea16d406462977970c79a",
            "metadata": {},
            "name": "useGetSpaceIdsFromSpaceKeysQuery",
            "operationKind": "query",
            "text": "query useGetSpaceIdsFromSpaceKeysQuery($spaceKeys:[String]){spaces(spaceKeys:$spaceKeys){nodes{id}}}"
        }
    };
}();
$a49e7312a1e2cb42$var$node.hash = "9ccf9d7ef02a43c85929f80101c907a1";
var $a49e7312a1e2cb42$export$2e2bcd8739ae039 = $a49e7312a1e2cb42$var$node;






var $c0rhi = parcelRequire("c0rhi");

const $cae6d2e37e31ad91$export$50f68914d42bd134 = ({ setQueryParamsCallback: setQueryParamsCallback, queryParams: queryParams })=>{
    const getSpaceIdsFromSpaceKeys = (0, $42omo.useCallback)(async (spaceKeys)=>{
        if (spaceKeys.length === 0) return [];
        try {
            const query = await (0, $c0rhi.queryInterop)({
                query: (0, $a49e7312a1e2cb42$export$2e2bcd8739ae039),
                variables: {
                    spaceKeys: spaceKeys
                },
                __callerPackage__: "@confluence/advanced-search"
            });
            const spaceIds = (query.data.spaces?.nodes ?? []).map((node)=>node?.id).filter((id)=>!!id);
            return spaceIds;
        } catch  {
            // TODO: log error using what Confluence uses in place of Sentry
            //	likely in follow up ticket
            // drop the spaces query param
            setQueryParamsCallback({
                ...queryParams,
                spaces: undefined
            }, true);
        }
        return [];
    }, [
        queryParams,
        setQueryParamsCallback
    ]);
    return getSpaceIdsFromSpaceKeys;
};



var $cacu1 = parcelRequire("cacu1");

const $4b3e2e9a6de8db0f$export$12ccd9fcc934a6ea = [
    'product',
    'text',
    'originalQuery',
    // This is used by "Did you mean" search correction feature
    'type',
    'lastModified',
    // "lastModified_lt",
    // "lastModified_gt",
    'titleMatch',
    'createdBy',
    'lastUpdatedBy',
    'contributors',
    'owners',
    'spaces',
    'pageStatus',
    'verified',
    'ancestor',
    'labels',
    'jAssignee',
    'jReporter',
    'jProject',
    'jCommentedByMe',
    'jWatchedByMe',
    'focusAreaTypes',
    'focusAreaUnder',
    'referrer',
    'leftOverrides',
    'rightOverrides',
    'from',
    'to',
    'cql',
    'archived',
    'filterDropdownOpen',
    'datasource',
    'status',
    'compassArchived',
    'assetsSchema',
    'assetsType',
    'salesforceStages',
    'campaignStatuses',
    'caseStatuses',
    'closeDate',
    'closeDateVal',
    'positionFocusAreas',
    'positionEmploymentTypes',
    'positionJobFamilies',
    'positionStatuses',
    'positionTeams',
    'isAutoApplied',
    'sort',
    'overrides',
    'opportunityStatus',
    'pullRequestStatus',
    'slackChannels'
];
const $4b3e2e9a6de8db0f$var$enableSideBySideQueryParams = [
    'leftOverrides',
    'rightOverrides'
];
const $4b3e2e9a6de8db0f$var$containerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.025'
});
const $4b3e2e9a6de8db0f$var$searchPageWithButtonWrapperStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    width: '100%'
});
const $4b3e2e9a6de8db0f$var$aiButtonPositionStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    insetBlockEnd: 'space.300',
    insetInlineEnd: 'space.300'
});
const $4b3e2e9a6de8db0f$var$createSearchQueryParamsHook = (queryParamKeys)=>{
    const queryParamHooks = queryParamKeys.map((paramKey)=>[
            paramKey,
            (0, $dPJCf.createSingleQueryParamHook)(paramKey)
        ]);
    return ()=>{
        const queryParamEntries = queryParamHooks.map(([paramKey, hook])=>[
                paramKey,
                hook()
            ]).filter(([_, paramValue])=>!!paramValue);
        return Object.fromEntries(queryParamEntries);
    };
};
const $4b3e2e9a6de8db0f$var$getSearchQueryParams = $4b3e2e9a6de8db0f$var$createSearchQueryParamsHook($4b3e2e9a6de8db0f$export$12ccd9fcc934a6ea);
const $4b3e2e9a6de8db0f$var$InnerSearchPage = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { userEmail: userEmail } = t0;
    const { cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, activationId: activationId, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { push: push, setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    let t1;
    if ($[0] !== setQueryParams) {
        t1 = (params, t2)=>{
            const replace = t2 === undefined ? false : t2;
            const filteredQueryParams = $4b3e2e9a6de8db0f$export$12ccd9fcc934a6ea.map((paramKey)=>[
                    paramKey,
                    params[paramKey]
                ]);
            setQueryParams(Object.fromEntries(filteredQueryParams), replace);
        };
        $[0] = setQueryParams;
        $[1] = t1;
    } else t1 = $[1];
    const setQueryParamsCallback = t1;
    let t2;
    if ($[2] !== displayName || $[3] !== userEmail || $[4] !== userId) {
        t2 = {
            id: userId,
            name: displayName,
            email: userEmail
        };
        $[2] = displayName;
        $[3] = userEmail;
        $[4] = userId;
        $[5] = t2;
    } else t2 = $[5];
    const userDetails = t2;
    let t3;
    if ($[6] !== push) {
        t3 = (url)=>push(url);
        $[6] = push;
        $[7] = t3;
    } else t3 = $[7];
    const onNavigate = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = $4b3e2e9a6de8db0f$var$getSearchQueryParams();
        $[8] = t4;
    } else t4 = $[8];
    const queryParams = t4;
    let t5;
    if ($[9] !== setQueryParamsCallback) {
        t5 = {
            setQueryParamsCallback: setQueryParamsCallback,
            queryParams: queryParams
        };
        $[9] = setQueryParamsCallback;
        $[10] = t5;
    } else t5 = $[10];
    const getSpaceIdsFromSpaceKeys = (0, $cae6d2e37e31ad91$export$50f68914d42bd134)(t5);
    const getNavigateToTeamsApp = (0, $eWzPA.useGetNavigateToTeamsApp)();
    let t6;
    if ($[11] !== getNavigateToTeamsApp) {
        t6 = (id)=>{
            if ((0, $9wGTI.fg)("confluence-adopt-teams-nav-config")) return getNavigateToTeamsApp({
                type: "USER",
                payload: {
                    userId: id
                }
            }).href;
            else return `/wiki/people/${id}`;
        };
        $[11] = getNavigateToTeamsApp;
        $[12] = t6;
    } else t6 = $[12];
    const mapUserIdToProfileUrl = t6;
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $1xpoY.default).getStringList("search_platform_layer_functions", []);
        $[13] = t7;
    } else t7 = $[13];
    const experimentLayers = t7;
    const preloadDataProvider = (0, $3LDzU.usePreloadDataProvider)();
    let t8;
    if ($[14] !== activationId || $[15] !== cloudId || $[16] !== getSpaceIdsFromSpaceKeys || $[17] !== isAdminHubAIEnabled || $[18] !== isRovoLLMEnabled || $[19] !== mapUserIdToProfileUrl || $[20] !== onNavigate || $[21] !== orgId || $[22] !== preloadDataProvider || $[23] !== setQueryParamsCallback || $[24] !== userDetails) {
        t8 = $4b3e2e9a6de8db0f$var$enableSideBySideQueryParams.some((key)=>key in queryParams) && (0, $9wGTI.fg)("enable_rovo_search_overrides") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $4b3e2e9a6de8db0f$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10ee11d11e004dd8$export$d856f3183c4e6577), {
            callbacks: {
                updateQueryParameters: setQueryParamsCallback,
                getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
            },
            shell: {
                cloudId: cloudId,
                orgId: orgId,
                activationId: activationId,
                user: userDetails,
                primaryProduct: "confluence",
                queryParams: queryParams,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                isNav4Enabled: true,
                experimentLayers: experimentLayers,
                isRovoLLMEnabled: isRovoLLMEnabled
            },
            mapUserIdToProfileUrl: mapUserIdToProfileUrl,
            onNavigate: onNavigate,
            testId: "enterprise-feedback-comparison",
            entryPoint: "confluence"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $4b3e2e9a6de8db0f$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $4b3e2e9a6de8db0f$var$searchPageWithButtonWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c77fa5848e4f5168$export$a54ec244c8863715), {
            callbacks: {
                updateQueryParameters: setQueryParamsCallback,
                getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
            },
            shell: {
                cloudId: cloudId,
                orgId: orgId,
                user: userDetails,
                primaryProduct: "confluence",
                analyticsAttributes: {
                    activationId: activationId,
                    navdexPointType: (0, $56QzY.TOUCH)
                },
                queryParams: queryParams,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                isNav4Enabled: true,
                experimentLayers: experimentLayers,
                isRovoLLMEnabled: isRovoLLMEnabled,
                preloadDataProvider: preloadDataProvider
            },
            mapUserIdToProfileUrl: mapUserIdToProfileUrl,
            onNavigate: onNavigate
        }), ((0, $6mKj3.expVal)("failed_search_journey_trigger_rovo_chat", "cohort", "control") !== "control" || (0, $6mKj3.expVal)("failed_search_journey_trigger_rovo_chat", "cohort", "control") !== "not-enrolled") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $4b3e2e9a6de8db0f$var$aiButtonPositionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hU34N.AISmartButtonWrapper), {
            contentId: "",
            contentType: "",
            pageMode: "advanced-search",
            isDisabled: false
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cacu1.PageLoadEndEventUnifiedSearch), null));
        $[14] = activationId;
        $[15] = cloudId;
        $[16] = getSpaceIdsFromSpaceKeys;
        $[17] = isAdminHubAIEnabled;
        $[18] = isRovoLLMEnabled;
        $[19] = mapUserIdToProfileUrl;
        $[20] = onNavigate;
        $[21] = orgId;
        $[22] = preloadDataProvider;
        $[23] = setQueryParamsCallback;
        $[24] = userDetails;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : ({ userEmail: userEmail })=>{
    const { cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, activationId: activationId, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { push: push, setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const setQueryParamsCallback = (0, $42omo.useCallback)((params, replace = false)=>{
        const filteredQueryParams = $4b3e2e9a6de8db0f$export$12ccd9fcc934a6ea.map((paramKey)=>[
                paramKey,
                params[paramKey]
            ]);
        setQueryParams(Object.fromEntries(filteredQueryParams), replace);
    }, [
        setQueryParams
    ]);
    const userDetails = (0, $42omo.useMemo)(()=>{
        return {
            id: userId,
            name: displayName,
            email: userEmail
        };
    }, [
        userId,
        displayName,
        userEmail
    ]);
    const onNavigate = (0, $42omo.useCallback)((url)=>push(url), [
        push
    ]);
    const queryParams = $4b3e2e9a6de8db0f$var$getSearchQueryParams();
    const getSpaceIdsFromSpaceKeys = (0, $cae6d2e37e31ad91$export$50f68914d42bd134)({
        setQueryParamsCallback: setQueryParamsCallback,
        queryParams: queryParams
    });
    const getNavigateToTeamsApp = (0, $eWzPA.useGetNavigateToTeamsApp)();
    const mapUserIdToProfileUrl = (id)=>{
        if ((0, $9wGTI.fg)('confluence-adopt-teams-nav-config')) return getNavigateToTeamsApp({
            type: 'USER',
            payload: {
                userId: id
            }
        }).href;
        else return `/wiki/people/${id}`;
    };
    const experimentLayers = (0, $1xpoY.default).getStringList('search_platform_layer_functions', []);
    const preloadDataProvider = (0, $3LDzU.usePreloadDataProvider)();
    return $4b3e2e9a6de8db0f$var$enableSideBySideQueryParams.some((key)=>key in queryParams) && (0, $9wGTI.fg)('enable_rovo_search_overrides') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $4b3e2e9a6de8db0f$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10ee11d11e004dd8$export$d856f3183c4e6577), {
        callbacks: {
            updateQueryParameters: setQueryParamsCallback,
            getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
        },
        shell: {
            cloudId: cloudId,
            orgId: orgId,
            activationId: activationId,
            user: userDetails,
            primaryProduct: 'confluence',
            queryParams: queryParams,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            isNav4Enabled: true,
            experimentLayers: //nav4 is rolled out, search platform can be cleaned up
            experimentLayers,
            isRovoLLMEnabled: isRovoLLMEnabled
        },
        mapUserIdToProfileUrl: mapUserIdToProfileUrl,
        onNavigate: onNavigate,
        testId: "enterprise-feedback-comparison",
        entryPoint: "confluence"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $4b3e2e9a6de8db0f$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $4b3e2e9a6de8db0f$var$searchPageWithButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c77fa5848e4f5168$export$a54ec244c8863715), {
        callbacks: {
            updateQueryParameters: setQueryParamsCallback,
            getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
        },
        shell: {
            cloudId: cloudId,
            orgId: orgId,
            user: userDetails,
            primaryProduct: 'confluence',
            analyticsAttributes: {
                activationId: activationId,
                navdexPointType: (0, $56QzY.TOUCH)
            },
            queryParams: queryParams,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            isNav4Enabled: true,
            experimentLayers: //nav4 is rolled out, search platform can be cleaned up
            experimentLayers,
            isRovoLLMEnabled: isRovoLLMEnabled,
            preloadDataProvider: preloadDataProvider
        },
        mapUserIdToProfileUrl: mapUserIdToProfileUrl,
        onNavigate: onNavigate
    }), ((0, $6mKj3.expVal)('failed_search_journey_trigger_rovo_chat', 'cohort', 'control') !== 'control' || (0, $6mKj3.expVal)('failed_search_journey_trigger_rovo_chat', 'cohort', 'control') !== 'not-enrolled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $4b3e2e9a6de8db0f$var$aiButtonPositionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hU34N.AISmartButtonWrapper), {
        contentId: "",
        contentType: "",
        pageMode: "advanced-search",
        isDisabled: false
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cacu1.PageLoadEndEventUnifiedSearch), null));
};
const $4b3e2e9a6de8db0f$export$6035a7da2f047ee = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "advanced-search-search-page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fqwa.UserContext), null, $4b3e2e9a6de8db0f$var$_temp));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    // update advanced search page load name (used for UFO)
    (0, $42omo.useMemo)(()=>(0, $054Kg.updatePageloadName)('unified_search'), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "advanced-search-search-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fqwa.UserContext), null, ({ data: data, isLoading: isLoading })=>!isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4b3e2e9a6de8db0f$var$InnerSearchPage, {
            userEmail: data?.email
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "search-page-user-context-loading"
        })));
};
function $4b3e2e9a6de8db0f$var$_temp(t0) {
    const { data: data, isLoading: isLoading } = t0;
    return !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4b3e2e9a6de8db0f$var$InnerSearchPage, {
        userEmail: data?.email
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "search-page-user-context-loading"
    });
}
module.exports["SEARCH_PAGE_QUERY_PARAM_KEYS"] = $4b3e2e9a6de8db0f$export$12ccd9fcc934a6ea;
module.exports["ConfluenceSearchPage"] = $4b3e2e9a6de8db0f$export$6035a7da2f047ee;

});

parcelRegister("dpPtd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
                    return /*#__PURE__*/ (0, $42omo.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$export$a4270ab432ac8a58, {
        children: fn()
    });
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("7bZ3i", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $99uSl = parcelRequire("99uSl");


var $lgmus = parcelRequire("lgmus");


var $9gPkz = parcelRequire("9gPkz");

var $6q0AE = parcelRequire("6q0AE");


var $79vw2 = parcelRequire("79vw2");


var $dE3t3 = parcelRequire("dE3t3");


var $eIleF = parcelRequire("eIleF");


var $dh538 = parcelRequire("dh538");


var $k00oi = parcelRequire("k00oi");

const $4cf4ff4aa0c52ddf$export$97eec7ea3e925862 = 'atlaskit-smart-card:external-auth-completed';
function $4cf4ff4aa0c52ddf$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, rovoOptions: rovoOptions }) {
    const parentContext = (0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    const defaultInitialState = (0, $42omo.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $42omo.useMemo)(()=>{
        return (0, $99uSl.createStore)((0, $dE3t3.cardReducer), initialState);
    }, [
        initialState
    ]);
    const client = (0, $42omo.useMemo)(()=>{
        const c = customClient || new (0, $k00oi.default)();
        if (product && c.setProduct) c.setProduct(product);
        return c;
    }, [
        customClient,
        product
    ]);
    // Listen for external auth completion events and re-resolve any matching unauthorized cards in this store. 
    // Used as guardrail killswitch for synchronized-post-office-and-smartcard-auth-exp in Post Office
    (0, $42omo.useEffect)(()=>{
        if (typeof window === 'undefined' || !(0, $dh538.fg)('navx-smartcard-auth-event-listener-killswitch-fg')) return;
        const handler = (event)=>{
            const detail = event.detail;
            if (!detail?.extensionKeys?.length) return;
            const targetKeys = new Set(detail.extensionKeys);
            const state = store.getState();
            for (const url of Object.keys(state)){
                const cardState = state[url];
                if (!cardState || cardState.status !== 'unauthorized') continue;
                const cardExtensionKey = cardState.details?.meta?.key;
                if (!cardExtensionKey || !targetKeys.has(cardExtensionKey)) continue;
                // Fetch fresh data from ORS and dispatch new payload data
                client.fetchData(url, true).then((response)=>{
                    store.dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RELOADING), {
                        url: url
                    }, response, undefined, undefined, true));
                }, (err)=>{
                    store.dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
                        url: url
                    }, undefined, err, undefined, true));
                });
            }
        };
        window.addEventListener($4cf4ff4aa0c52ddf$export$97eec7ea3e925862, handler);
        return ()=>{
            window.removeEventListener($4cf4ff4aa0c52ddf$export$97eec7ea3e925862, handler);
        };
    }, [
        store,
        client
    ]);
    const providerValue = (0, $42omo.useMemo)(()=>{
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, _platform)=>{
            const cardState = (0, $6q0AE.getUrl)(store, url);
            return cardState.details ? (0, $79vw2.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel,
            rovoOptions: rovoOptions
        };
    }, [
        customAuthFlow,
        client,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        rovoOptions,
        store
    ]);
    const value = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eIleF.SmartCardContext).Provider, {
        value: value,
        children: children
    });
}
var $4cf4ff4aa0c52ddf$export$2e2bcd8739ae039 = $4cf4ff4aa0c52ddf$export$497ecb0280204df4;
module.exports["SMART_CARD_EXTERNAL_AUTH_EVENT"] = $4cf4ff4aa0c52ddf$export$97eec7ea3e925862;
module.exports["SmartCardProvider"] = $4cf4ff4aa0c52ddf$export$497ecb0280204df4;

});

parcelRegister("dE3t3", function(module, exports) {

var $9gPkz = parcelRequire("9gPkz");

var $btw9C = parcelRequire("btw9C");

const $93945b5bac9d9f43$var$isCardAction = (action)=>{
    return [
        (0, $9gPkz.ACTION_PENDING),
        (0, $9gPkz.ACTION_RESOLVING),
        (0, $9gPkz.ACTION_RESOLVED),
        (0, $9gPkz.ACTION_RELOADING),
        (0, $9gPkz.ACTION_ERROR),
        (0, $9gPkz.ACTION_ERROR_FALLBACK),
        (0, $9gPkz.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $93945b5bac9d9f43$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $btw9C.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $93945b5bac9d9f43$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $9gPkz.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $9gPkz.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $9gPkz.ACTION_RESOLVED:
            return $93945b5bac9d9f43$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $9gPkz.ACTION_RELOADING:
            return $93945b5bac9d9f43$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $9gPkz.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $9gPkz.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $9gPkz.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $93945b5bac9d9f43$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$93945b5bac9d9f43$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $93945b5bac9d9f43$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};
module.exports["cardReducer"] = $93945b5bac9d9f43$export$3c7c3113a97b6492;

});

parcelRegister("k00oi", function(module, exports) {

var $1bFdN = parcelRequire("1bFdN");


var $Gi9G7 = parcelRequire("Gi9G7");


var $abpX2 = parcelRequire("abpX2");


var $jHnts = parcelRequire("jHnts");

var $dDhJe = parcelRequire("dDhJe");

var $btw9C = parcelRequire("btw9C");

var $gmi3X = parcelRequire("gmi3X");


var $97i3I = parcelRequire("97i3I");


var $9trs7 = parcelRequire("9trs7");


var $6a9Hv = parcelRequire("6a9Hv");


var $dh538 = parcelRequire("dh538");

const $542f7628c45b2158$var$MAX_BATCH_SIZE = 50;
const $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $542f7628c45b2158$var$URL_RESPONSE_CACHE_SIZE = 100;
const $542f7628c45b2158$export$d6a66073b5d79eb3 = new (0, $9trs7.LRUMap)($542f7628c45b2158$var$URL_RESPONSE_CACHE_SIZE);
class $542f7628c45b2158$export$2e2bcd8739ae039 {
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($abpX2)))({
            limit: 1,
            interval: $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $542f7628c45b2158$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($abpX2)))({
            limit: 1,
            interval: $542f7628c45b2158$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1bFdN)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $542f7628c45b2158$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $jHnts.InvalidUrlError)(error);
        }
    }
    async resolveUrl(url, force = false) {
        const hostname = this.getHostName(url);
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $542f7628c45b2158$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            if ((0, $dh538.fg)('platform_linking_force_no_cache_smart_card_client')) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined
                });
            } else responsePromise = loader.load(url);
            $542f7628c45b2158$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $542f7628c45b2158$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $97i3I.isSuccessfulResponse)(response) || (0, $btw9C.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $542f7628c45b2158$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $97i3I.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($Gi9G7)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $97i3I.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $97i3I.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($Gi9G7)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $97i3I.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $gmi3X.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $gmi3X.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $97i3I.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $gmi3X.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $gmi3X.NetworkError)) return new (0, $jHnts.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $jHnts.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $jHnts.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $jHnts.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $jHnts.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $jHnts.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
    constructor(envKey, baseUrlOverride){
        this.resolverUrl = void 0;
        this.envKey = void 0;
        this.baseUrlOverride = void 0;
        this.urlLoadersByDomain = void 0;
        this.loadersByDomain = void 0;
        this.retryConfig = void 0;
        this.resolvedCache = void 0;
        this.product = void 0;
        this.headers = void 0;
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $97i3I.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $gmi3X.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $97i3I.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>resource.resourceUrl);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dDhJe.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
}
module.exports["default"] = $542f7628c45b2158$export$2e2bcd8739ae039;

});

parcelRegister("Gi9G7", function(module, exports) {
// Packages

var $bfRrZ = parcelRequire("bfRrZ");

function $07f201957e3f51a5$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $bfRrZ.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $07f201957e3f51a5$var$retry;

});

parcelRegister("bfRrZ", function(module, exports) {

module.exports = (parcelRequire("2CRnP"));

});

parcelRegister("2CRnP", function(module, exports) {

var $jWveU = parcelRequire("jWveU");

exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $jWveU(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});

parcelRegister("jWveU", function(module, exports) {
function $e84baaa017e10274$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $e84baaa017e10274$var$RetryOperation;
$e84baaa017e10274$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$e84baaa017e10274$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$e84baaa017e10274$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$e84baaa017e10274$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$e84baaa017e10274$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$e84baaa017e10274$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$e84baaa017e10274$var$RetryOperation.prototype.start = $e84baaa017e10274$var$RetryOperation.prototype.try;
$e84baaa017e10274$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$e84baaa017e10274$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$e84baaa017e10274$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});

parcelRegister("abpX2", function(module, exports) {
'use strict';
class $769f0fd050ef86b5$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $769f0fd050ef86b5$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $769f0fd050ef86b5$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $769f0fd050ef86b5$var$pThrottle;
module.exports.AbortError = $769f0fd050ef86b5$var$AbortError;

});

parcelRegister("dDhJe", function(module, exports) {
const $acfecaf0839e2c0b$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $acfecaf0839e2c0b$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $acfecaf0839e2c0b$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $acfecaf0839e2c0b$export$e2b040f052407032 = {
    dev: $acfecaf0839e2c0b$var$devBaseUrl,
    development: $acfecaf0839e2c0b$var$devBaseUrl,
    stg: $acfecaf0839e2c0b$var$stgBaseUrl,
    staging: $acfecaf0839e2c0b$var$stgBaseUrl,
    prd: $acfecaf0839e2c0b$var$prodBaseUrl,
    prod: $acfecaf0839e2c0b$var$prodBaseUrl,
    production: $acfecaf0839e2c0b$var$prodBaseUrl
};
const $acfecaf0839e2c0b$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? $acfecaf0839e2c0b$var$prodBaseUrl;
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $acfecaf0839e2c0b$export$e2b040f052407032 ? $acfecaf0839e2c0b$export$e2b040f052407032[envKey] : $acfecaf0839e2c0b$var$prodBaseUrl;
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $acfecaf0839e2c0b$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $acfecaf0839e2c0b$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $acfecaf0839e2c0b$export$2e2bcd8739ae039 = $acfecaf0839e2c0b$export$e2b040f052407032;
module.exports["getBaseUrl"] = $acfecaf0839e2c0b$export$f654b28f82155665;
module.exports["getResolverUrl"] = $acfecaf0839e2c0b$export$dc37652c1696f231;

});

parcelRegister("gmi3X", function(module, exports) {
const $ffe0c3b764a3e96a$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $ffe0c3b764a3e96a$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $ffe0c3b764a3e96a$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $ffe0c3b764a3e96a$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $ffe0c3b764a3e96a$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["NetworkError"] = $ffe0c3b764a3e96a$export$bae979e68e4dc802;
module.exports["request"] = $ffe0c3b764a3e96a$export$b5fe3f66a567bec0;

});

parcelRegister("97i3I", function(module, exports) {
const $e30f485c735f2746$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $e30f485c735f2746$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};
module.exports["isSuccessfulResponse"] = $e30f485c735f2746$export$1b59fe731a28a49d;
module.exports["isErrorResponse"] = $e30f485c735f2746$export$bea7bee8a87e7c52;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("5G9KX", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $c4TO3 = parcelRequire("c4TO3");

const $34a6846e1e43ece9$export$5aa524d86254b4f = (key, value)=>{
    if ((0, $dh538.fg)('search_page_use_browser_storage_controls')) (0, $c4TO3.AtlBrowserStorageLocal).setItem(key, value);
    else localStorage.setItem(key, value);
};
const $34a6846e1e43ece9$export$93d719890ad66653 = (key)=>{
    const item = (0, $dh538.fg)('search_page_use_browser_storage_controls') ? (0, $c4TO3.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $34a6846e1e43ece9$export$5df15f289f441790 = (key)=>{
    const item = (0, $dh538.fg)('search_page_use_browser_storage_controls') ? (0, $c4TO3.AtlBrowserStorageLocal).getItem(key) : localStorage.getItem(key);
    return item ? item : null;
};
const $34a6846e1e43ece9$export$baf306891f1b93bd = (key)=>{
    if ((0, $dh538.fg)('search_page_use_browser_storage_controls')) (0, $c4TO3.AtlBrowserStorageLocal).removeItem(key);
    else localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $34a6846e1e43ece9$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $34a6846e1e43ece9$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $34a6846e1e43ece9$export$5df15f289f441790;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("4JDbp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

/**
 * This component will observer the current width,
 * and it will call the `setWidth` callback every time this changes.
 *
 * The only required is the parent HTMLElement should have `position: relative`
 * because this is an absolute element.
 */ const $b400565b9de87bc3$var$WidthObserver = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$var$WidthObserver;
module.exports["default"] = $b400565b9de87bc3$export$2e2bcd8739ae039;

});

parcelRegister("i7RGj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("1662I", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ccb09ee82030ea4$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $e0mB4 = parcelRequire("e0mB4");


var $6b5eb = parcelRequire("6b5eb");


var $b5utg = parcelRequire("b5utg");

var $0ccb09ee82030ea4$var$MILLISECONDS_IN_WEEK = 604800000;
function $0ccb09ee82030ea4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var diff = (0, $e0mB4.default)(date).getTime() - (0, $6b5eb.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $0ccb09ee82030ea4$var$MILLISECONDS_IN_WEEK) + 1;
}

});

parcelRegister("e0mB4", function(module, exports) {
$parcel$export(module.exports, "default", () => $a322980fc7bdc1cb$export$2e2bcd8739ae039);

var $ghphD = parcelRequire("ghphD");


var $b5utg = parcelRequire("b5utg");

function $a322980fc7bdc1cb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $ghphD.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});

parcelRegister("ghphD", function(module, exports) {
$parcel$export(module.exports, "default", () => $bda1d8a3686c6d03$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $jZ39j = parcelRequire("jZ39j");


var $b5utg = parcelRequire("b5utg");


var $2h3f7 = parcelRequire("2h3f7");

function $bda1d8a3686c6d03$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b5utg.default)(1, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var weekStartsOn = (0, $jZ39j.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6b5eb", function(module, exports) {
$parcel$export(module.exports, "default", () => $47f7d34a77e920df$export$2e2bcd8739ae039);

var $3Klnc = parcelRequire("3Klnc");


var $e0mB4 = parcelRequire("e0mB4");


var $b5utg = parcelRequire("b5utg");

function $47f7d34a77e920df$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var year = (0, $3Klnc.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $e0mB4.default)(fourthOfJanuary);
    return date;
}

});

parcelRegister("3Klnc", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ba63f43afaf9481$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $e0mB4 = parcelRequire("e0mB4");


var $b5utg = parcelRequire("b5utg");

function $2ba63f43afaf9481$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $e0mB4.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $e0mB4.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});

parcelRegister("8lMgE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6145b9d2a216bb48$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6145b9d2a216bb48$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $egXhZ.default)(dirtyDate).getFullYear();
}

});

parcelRegister("b4tvS", function(module, exports) {
$parcel$export(module.exports, "ProductsOrder3P", () => (parcelRequire("hdfeV")).ProductsOrder3P);
/**
 * Product key constants, types, and lightweight helpers.
 * No icons, no 3P configs, no React components.
 */ 
var $hdfeV = parcelRequire("hdfeV");


const $6f142b1a5d666130$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    // Can't add these until they're ready as we use this type to enforce that product configs are available for all products
    Talent: 'radar'
};
const $6f142b1a5d666130$export$252aae15ddb3591c = {
    ...$6f142b1a5d666130$var$ProductKeys1P,
    Loom: 'loom'
};
const $6f142b1a5d666130$export$ef2c0ffddaaaf76c = {
    ...$6f142b1a5d666130$var$ProductKeys1P,
    ...(0, $hdfeV.ProductKeys3P)
};
const $6f142b1a5d666130$export$93aa518ca2694c2d = (0, $hdfeV.ProductKeys3P);
const $6f142b1a5d666130$export$73be91b73ebbdb05 = Object.values($6f142b1a5d666130$export$ef2c0ffddaaaf76c);
const $6f142b1a5d666130$export$57043b2770b3924d = Object.values((0, $hdfeV.ProductKeys3P));
const $6f142b1a5d666130$export$225f36a2f261b1e7 = Object.values($6f142b1a5d666130$var$ProductKeys1P);
const $6f142b1a5d666130$export$65f9ab1ba49d5e68 = (key)=>$6f142b1a5d666130$export$225f36a2f261b1e7.includes(key);
const $6f142b1a5d666130$export$ae4856d6227d0649 = (key)=>$6f142b1a5d666130$export$57043b2770b3924d.includes(key);
const $6f142b1a5d666130$export$2a41a819c1db85b1 = (key)=>{
    if (!key) return false;
    // Check hardcoded keys first
    if ($6f142b1a5d666130$export$73be91b73ebbdb05.includes(key)) return true;
    // Treat any "forge-connector-*" string as valid ProductKeys to support
    // dynamically provisioned Forge connectors without updating this constant list.
    // This means isProductKey is *looser* than "is configured in ProductKeys".
    return key.startsWith('forge-connector-');
};
const $6f142b1a5d666130$export$ba4f56e768ae6f1e = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Confluence,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Jira
];
const $6f142b1a5d666130$export$64c23f2d9ef43822 = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Confluence,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Jira,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Atlas,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Trello,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Bitbucket,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Compass,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Focus,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Assets,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Talent,
    ...(0, $hdfeV.ProductsOrder3P)
];
const $6f142b1a5d666130$export$41ecd101a1ccdccc = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Confluence,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Jira,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Atlas,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Trello,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Bitbucket,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Compass,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Focus,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Talent,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Assets,
    ...(0, $hdfeV.NewProductsOrder3P)
];
module.exports["ProductKeys1PForAnalytics"] = $6f142b1a5d666130$export$252aae15ddb3591c;
module.exports["ProductKeys"] = $6f142b1a5d666130$export$ef2c0ffddaaaf76c;
module.exports["ProductKeys3P"] = $6f142b1a5d666130$export$93aa518ca2694c2d;
module.exports["allProductKeys"] = $6f142b1a5d666130$export$73be91b73ebbdb05;
module.exports["all3pProductKeys"] = $6f142b1a5d666130$export$57043b2770b3924d;
module.exports["all1pProductKeys"] = $6f142b1a5d666130$export$225f36a2f261b1e7;
module.exports["is1pProductKey"] = $6f142b1a5d666130$export$65f9ab1ba49d5e68;
module.exports["is3pProductKey"] = $6f142b1a5d666130$export$ae4856d6227d0649;
module.exports["isProductKey"] = $6f142b1a5d666130$export$2a41a819c1db85b1;
module.exports["productsSupportingEmptyQuery"] = $6f142b1a5d666130$export$ba4f56e768ae6f1e;
module.exports["PRODUCTS_ORDER"] = $6f142b1a5d666130$export$64c23f2d9ef43822;
module.exports["PRODUCTS_ORDER_WITH_3P_BY_POPULARITY"] = $6f142b1a5d666130$export$41ecd101a1ccdccc;

});

parcelRegister("hdfeV", function(module, exports) {
/**
 * Pure 3P product key constants extracted for SSR bundle isolation.
 * No icon or config imports - just string mappings.
 *
 * This is the SOURCE OF TRUTH for ProductKeys3P.
 * 3p-product-configs/index.tsx and products.tsx re-export from here.
 */ const $2db55438f96b7ddd$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3',
    Databricks: 'databricks',
    JsmDC: 'jsm-dc',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp'
};
const $2db55438f96b7ddd$export$cc64d659abc3d135 = [
    // Loom is actually a 1P so goes to the top
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    $2db55438f96b7ddd$export$93aa518ca2694c2d.GoogleDrive,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Sharepoint,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.OneDrive,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Dropbox,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Slack,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Teams,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Github,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Figma,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.GoogleCalendar,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Gmail,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.OutlookCalendar,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.OutlookMail,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Airtable,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Smartsheet,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Asana,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Zendesk,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Miro,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Docusign,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Lucid,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Monday,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AzureDevops,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Gitlab,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Canva,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Box,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Zeplin,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ServiceNow,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Freshservice,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.PowerBI,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ClickUp,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Amplitude,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Stripe,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AdobeXD,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Aha,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AdobeSign,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Mural,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Webex,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.PagerDuty,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Pipedrive,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Dovetail,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.LaunchDarkly,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Sentry,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Gitbook,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AWSS3,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeAdamVitareqDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeAdamVitareqProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeK15tScrollSitesDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeK15tScrollSitesProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioAwsDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioAwsProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioClickupDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioClickupProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitbookDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitbookProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGoogleDriveDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGoogleDriveProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGuruDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGuruProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHelpjuiceDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHelpjuiceProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHubspotDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHubspotProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSalesforceDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSalesforceProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSharepointDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSharepointProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioStackOverflowDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioStackOverflowProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUtoolityGitbookDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUtoolityGitbookProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeGdriveEugeneTestDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeGdriveEugeneTestProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoSalesforceDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoSalesforceProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoServicenowDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoServicenowProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoWrikeDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoWrikeProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoAsanaDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoAsanaProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoBasecampDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoBasecampProd,
    // New 3P? Add it here
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Databricks,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Notion,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Todoist,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Hubspot,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.JiraDC,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.JsmDC,
    // Always last
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AtlassianWebCrawler
];
// TODO: QS-8075 replace into PRODUCTS_ORDER when cleaning up the FG
const $2db55438f96b7ddd$export$915acbd1d0c0550d = [
    // Loom is actually a 1P so goes to the top
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    $2db55438f96b7ddd$export$93aa518ca2694c2d.GoogleDrive,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Sharepoint,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Slack,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Teams,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Figma,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Miro,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Github,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Gmail,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Gitlab,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Lucid,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Asana,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AzureDevops,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.GoogleCalendar,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.OneDrive,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Dropbox,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.OutlookCalendar,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.OutlookMail,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Airtable,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Smartsheet,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Zendesk,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Docusign,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Databricks,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Monday,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Canva,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Box,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Zeplin,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ServiceNow,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Freshservice,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.PowerBI,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ClickUp,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Amplitude,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Stripe,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AdobeXD,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Aha,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AdobeSign,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Mural,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Webex,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.PagerDuty,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Pipedrive,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Dovetail,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.LaunchDarkly,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Sentry,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Gitbook,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AWSS3,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Notion,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Todoist,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.Hubspot,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.JiraDC,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.JsmDC,
    // New 3P? Add it here
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeAdamVitareqDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeAdamVitareqProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeK15tScrollSitesDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeK15tScrollSitesProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioAwsDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioAwsProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioClickupDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioClickupProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitbookDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitbookProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGoogleDriveDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGoogleDriveProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGuruDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGuruProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHelpjuiceDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHelpjuiceProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHubspotDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHubspotProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSalesforceDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSalesforceProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSharepointDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSharepointProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioStackOverflowDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioStackOverflowProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUtoolityGitbookDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUtoolityGitbookProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeGdriveEugeneTestDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeGdriveEugeneTestProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoSalesforceDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoSalesforceProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoServicenowDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoServicenowProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoWrikeDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoWrikeProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoAsanaDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoAsanaProd,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoBasecampDev,
    $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoBasecampProd,
    // Always last
    $2db55438f96b7ddd$export$93aa518ca2694c2d.AtlassianWebCrawler
];
const $2db55438f96b7ddd$export$c36c249aaac5cad0 = {
    assignee: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.JiraDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.JsmDC
    ],
    caseStatus: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce
    ],
    closeDate: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce
    ],
    content: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC
    ],
    createdBy: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Hubspot,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce
    ],
    label: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC
    ],
    lastUpdated: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Airtable,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Asana,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.AzureDevops,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Box,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Databricks,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Docusign,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Dropbox,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Figma,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeAdamVitareqDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeAdamVitareqProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeGdriveEugeneTestDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeGdriveEugeneTestProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeK15tScrollSitesDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeK15tScrollSitesProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioAwsDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioAwsProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioClickupDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioClickupProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitbookDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitbookProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGoogleDriveDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGoogleDriveProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGuruDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGuruProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHelpjuiceDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHelpjuiceProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHubspotDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioHubspotProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSalesforceDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSalesforceProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSharepointDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioSharepointProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioStackOverflowDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioStackOverflowProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoAsanaDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoAsanaProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoBasecampDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoBasecampProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoSalesforceDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoSalesforceProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoServicenowDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoServicenowProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoWrikeDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUnitoWrikeProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUtoolityGitbookDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgeUtoolityGitbookProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Github,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Gmail,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.GoogleDrive,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Hubspot,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.JiraDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.JsmDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Loom,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Lucid,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Miro,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Notion,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.OneDrive,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.OutlookMail,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ServiceNow,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Sharepoint,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Slack,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Smartsheet,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Teams,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Zendesk
    ],
    lastUpdatedBy: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Hubspot,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce
    ],
    opportunityStatus: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce
    ],
    onlyTitleMatch: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Airtable,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Asana,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Box,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Databricks,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Docusign,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Dropbox,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Github,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.GoogleDrive,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Hubspot,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Miro,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Notion,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.OneDrive,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.OutlookMail,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ServiceNow,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Sharepoint,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Smartsheet,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Zendesk
    ],
    owner: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Salesforce
    ],
    project: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.JiraDC,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.JsmDC
    ],
    pullRequestStatus: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGithubProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabDev,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ForgePioGitlabProd,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Github,
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Gitlab
    ],
    slackChannel: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.Slack
    ],
    space: [
        $2db55438f96b7ddd$export$93aa518ca2694c2d.ConfluenceDC
    ]
};
module.exports["ProductKeys3P"] = $2db55438f96b7ddd$export$93aa518ca2694c2d;
module.exports["ProductsOrder3P"] = $2db55438f96b7ddd$export$cc64d659abc3d135;
module.exports["NewProductsOrder3P"] = $2db55438f96b7ddd$export$915acbd1d0c0550d;
module.exports["thirdPartyFilterProducts"] = $2db55438f96b7ddd$export$c36c249aaac5cad0;

});

parcelRegister("6Gsan", function(module, exports) {
const $af14923fe5fc3bcc$export$15d12effc8830544 = {
    // Fully supported as GA
    Atlas: 'townsquare',
    Confluence: 'confluence',
    // In development
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension'
};
module.exports["PrimaryProductKeys"] = $af14923fe5fc3bcc$export$15d12effc8830544;

});

parcelRegister("aXjWU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $6d6c82fa2f331bd2$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $6d6c82fa2f331bd2$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $6d6c82fa2f331bd2$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialActiveTriggerState);
const $6d6c82fa2f331bd2$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($6d6c82fa2f331bd2$var$initialTriggerDispatchState);
const $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    // Legacy state — type and update logic are verbatim from the original implementation
    const [legacyState, setLegacyState] = (0, $42omo.useState)({
        activeTriggerId: undefined
    });
    // New record state — each trigger tracks its own boolean independently
    const [recordState, setRecordState] = (0, $42omo.useState)({});
    const setTriggerState = (0, $42omo.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        if ((0, $dh538.fg)('post-office_enable-trigger-record-state')) // New: each trigger tracks its own state independently.
        // Mutual exclusion is enforced at render time by the choreographer.
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
        else // Legacy: verbatim original logic — only one trigger active at a time
        setLegacyState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    // Unified record view exposed to context consumers.
    // In legacy mode, converts the single activeTriggerId to a one-entry record
    // so useTrigger works identically for both paths.
    const activeTriggerState = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('post-office_enable-trigger-record-state')) return recordState;
        const { activeTriggerId: activeTriggerId } = legacyState;
        return activeTriggerId ? {
            [activeTriggerId]: true
        } : {};
    }, [
        recordState,
        legacyState
    ]);
    const triggerContextValue = (0, $42omo.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $42omo.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6d6c82fa2f331bd2$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $6d6c82fa2f331bd2$export$454c1d7c35958f5e = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerContext);
const $6d6c82fa2f331bd2$export$23cbf084e08bdb93 = ()=>(0, $42omo.useContext)($6d6c82fa2f331bd2$var$TriggerDispatchContext);
const $6d6c82fa2f331bd2$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $6d6c82fa2f331bd2$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $6d6c82fa2f331bd2$export$23cbf084e08bdb93();
    const fireTrigger = (0, $42omo.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $6d6c82fa2f331bd2$export$e45375ff75169f = (messageId)=>{
    const enableEpExternalMessageCleanup = (0, $dh538.fg)('post-office_enable-ep-external-message-cleanup');
    const { activeTriggerState: activeTriggerState } = $6d6c82fa2f331bd2$export$454c1d7c35958f5e();
    // In legacy mode (gate off), the record has at most one true entry, so we reconstruct
    // activeTriggerId to preserve the original guard logic verbatim.
    // In record mode (gate on), the guard is unnecessary — setTriggerState is a no-op if
    // the trigger is already active, so we skip the reconstruction.
    const activeTriggerId = (0, $dh538.fg)('post-office_enable-trigger-record-state') ? undefined : Object.keys(activeTriggerState).find((k)=>activeTriggerState[k]);
    const hasMessageAlreadyStarted = enableEpExternalMessageCleanup && activeTriggerId?.endsWith('-started');
    // listeners
    const { isActive: hasMessageStarted } = $6d6c82fa2f331bd2$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $6d6c82fa2f331bd2$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $42omo.useCallback)(()=>{
        if (hasMessageAlreadyStarted) return;
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger,
        hasMessageAlreadyStarted
    ]);
    const dismissMessage = (0, $42omo.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $42omo.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $6d6c82fa2f331bd2$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $6d6c82fa2f331bd2$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $6d6c82fa2f331bd2$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $6d6c82fa2f331bd2$export$e45375ff75169f;

});

parcelRegister("2OtFZ", function(module, exports) {
/* eslint-disable @atlaskit/platform/use-recommended-utils */ 
var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $4OGlb = parcelRequire("4OGlb");


var $iA4lt = parcelRequire("iA4lt");


var $6Gsan = parcelRequire("6Gsan");


var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");

const $d1337898ab272d64$export$de65f9bad07950f2 = ()=>{
    (0, $c6GJD.default).manuallyLogExperimentExposure('enable_google_drive_impersonation_search_in_fps');
};
const $d1337898ab272d64$export$6c232948b0f89805 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('enable_google_drive_impersonation_search_in_fps', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'test';
};
const $d1337898ab272d64$export$9f3b4e44245ab299 = (thirdPartyConfigs, isAllProductSearch)=>{
    const isSlackAuthenticated = !thirdPartyConfigs?.[(0, $b4tvS.ProductKeys3P).Slack]?.userNeedsOAuth;
    const hasFederatedConnectorSource = thirdPartyConfigs?.[(0, $b4tvS.ProductKeys3P).Slack]?.connectorSources?.includes((0, $9d9t8.FEDERATED_CONNECTOR_SOURCE));
    const isUserEligible = isSlackAuthenticated && hasFederatedConnectorSource && isAllProductSearch;
    return isUserEligible;
};
const $d1337898ab272d64$export$b8eda33c6a73a867 = (fireExperimentExposure = false)=>{
    return (0, $c6GJD.default).getExperimentValue('rovosearch_noun_result_counts', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$6cc04d45455a2e52 = (fireExperimentExposure = false)=>{
    return (0, $c6GJD.default).getExperimentValue('web_pages_type_filter_bug', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$1b405ed1dcef1833 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('qf_jira_recents_exclude_confluence', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'test';
};
const $d1337898ab272d64$export$dbfae5c8d94a4c99 = (primaryProduct, { fireLayerExposure: fireLayerExposure = true } = {})=>{
    if (primaryProduct !== (0, $6Gsan.PrimaryProductKeys).Jira) return false;
    const layer = (0, $iA4lt.getMutuallyExclusiveUIExperiment)('rovo_qf_filter_suggestion_exp', 'rovo_search_qf_experience_layer', {
        fireLayerExposure: fireLayerExposure
    });
    return layer?.get('isFilterSuggestionEnabled', false, (value)=>typeof value === 'boolean') ?? false;
};
const $d1337898ab272d64$export$df1791a16917f9c3 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('search_user_right_rail_3p_personalization_v1', 'cohort', 'control', {
        fireExperimentExposure: true
    }) === 'test';
};
const $d1337898ab272d64$export$a254d1715475fc25 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('quick-find-3p-banner', 'bannerType', 'control') !== 'control';
};
const $d1337898ab272d64$export$6308fede6bfa9216 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('quick-find-3p-banner', 'bannerType', 'control', {
        fireExperimentExposure: false
    }) !== 'control';
};
const $d1337898ab272d64$export$a28677150905172f = ()=>{
    return (0, $c6GJD.default).getExperimentValue('confluence_space_icon_update', 'isEnabled', false) === true;
};
const $d1337898ab272d64$export$f980294cad954499 = (thirdPartyConfigs, options = {
    fireExperimentExposure: true
})=>{
    const isEligible3PUser = Object.keys(thirdPartyConfigs).some((productKey)=>thirdPartyConfigs[productKey]?.userNeedsOAuth === false);
    return isEligible3PUser && (0, $c6GJD.default).getExperimentValue('3p_clicks_in_fps_as_qf_recents', 'cohort', 'control', options) === 'test';
};
const $d1337898ab272d64$export$7d99be50af8e6e5c = ()=>(0, $c6GJD.default).getExperimentValue('rovo_search_preload_from_quick_find_using_async', 'isEnabled', false) === true;
const $d1337898ab272d64$export$32815557e5d06f0a = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $c6GJD.default).getExperimentValue('quick_find_3p_boosting_experiment', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$752769d90d201b0a = ()=>{
    return (0, $c6GJD.default).getExperimentValue('afm_customer_contact_search_type_experiment', 'cohort', 'control') === 'test';
};
const $d1337898ab272d64$export$307ab554c0a03fb = ()=>{
    // Check the targeting FG first. This is technically not needed, but makes VR testing much easier
    // since the Gemini framework has full support for FGs, but not Statsig experiments.
    if (!(0, $dh538.fg)('rovo_search_improve_engagement_tracking_gate')) return false;
    return (0, $c6GJD.default).getExperimentValue('rovo_search_improve_engagement_tracking', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'test';
};
const $d1337898ab272d64$export$99df3e6ef07f806c = ()=>{
    // Check the targeting FG first. This is technically not needed, but makes VR testing much easier
    // since the Gemini framework has full support for FGs, but not Statsig experiments.
    if (!(0, $dh538.fg)('rovo_search_improve_engagement_tracking_gate')) return;
    (0, $c6GJD.default).manuallyLogExperimentExposure('rovo_search_improve_engagement_tracking');
};
/**
 * >>> Confluence QuickFind UserShard Search Experiments
 *
 * We have 2 separated experiments: one is for hello tenant, the other is for 24 non-hello tenants.
 *
 * Experiment: `quick-find-user-shard-search-experiment`
 * + hello only
 * + statsig_url = https://go/statsig/experiments/quick-find-user-shard-search-experiment
 *
 * Experiment: `confluence-quickfind-usershard-nonhello-exp`
 * + 24 non-hello tenants
 * + statsig_url = https://go/statsig/experiments/confluence-quickfind-usershard-nonhello-exp
 *
 * These experiments have 3 groups:
 * + cohort = 'control', the current product.
 * + cohort = 'model-only', the model is served without any changes to the UI.
 * + cohort = 'test', both the model and new UI are served.
 *
 */ const $d1337898ab272d64$var$USER_SHARD_EXPERIMENTS = [
    'quick-find-user-shard-search-experiment',
    'confluence-quickfind-usershard-nonhello-exp'
];
const $d1337898ab272d64$var$getValidDebounceTimeout = (value)=>{
    if (typeof value !== 'number' || Number.isNaN(value) || !Number.isFinite(value)) return undefined;
    return value >= 0 ? value : undefined;
};
const $d1337898ab272d64$var$getUserShardExperimentDetails = ()=>{
    for (const experimentName of $d1337898ab272d64$var$USER_SHARD_EXPERIMENTS){
        const experiment = (0, $iA4lt.getMutuallyExclusiveUIExperiment)(experimentName, (0, $4OGlb.STATSIG_QUICK_FIND_LAYER), {
            fireLayerExposure: false
        });
        if (experiment !== undefined) return {
            cohort: experiment.get('cohort', undefined),
            spaceL1Id: experiment.get('spaceL1Id', undefined),
            pageL1Id: experiment.get('pageL1Id', undefined),
            debounceTimeout: $d1337898ab272d64$var$getValidDebounceTimeout(experiment.get('debounceTimeout', undefined))
        };
    }
    return {
        cohort: undefined,
        spaceL1Id: undefined,
        pageL1Id: undefined,
        debounceTimeout: undefined
    };
};
const $d1337898ab272d64$export$995378c845be3fef = ()=>{
    const { cohort: cohort } = $d1337898ab272d64$var$getUserShardExperimentDetails();
    return {
        serveModel: cohort === 'model-only' || cohort === 'test',
        serveUI: cohort === 'test',
        serveControl: cohort === 'control',
        cohort: cohort
    };
};
const $d1337898ab272d64$export$2300db9903c1302f = ()=>{
    return $d1337898ab272d64$export$995378c845be3fef().serveModel;
};
const $d1337898ab272d64$export$d9ee534a20391486 = ()=>{
    return $d1337898ab272d64$export$995378c845be3fef().serveUI;
};
const $d1337898ab272d64$export$1c3bd8b8866d2939 = ()=>{
    return $d1337898ab272d64$export$995378c845be3fef().serveControl;
};
const $d1337898ab272d64$export$3b350d5272fcff38 = ()=>{
    return $d1337898ab272d64$var$getUserShardExperimentDetails().spaceL1Id;
};
const $d1337898ab272d64$export$28bf0ffbee49739c = ()=>{
    return $d1337898ab272d64$var$getUserShardExperimentDetails().pageL1Id;
};
const $d1337898ab272d64$export$d8621fd9027f7208 = ()=>{
    return $d1337898ab272d64$var$getUserShardExperimentDetails().debounceTimeout;
};
const $d1337898ab272d64$export$9e14285db0210414 = (experimentConfig)=>{
    const cohort = experimentConfig.frontendExperiments?.['multi_site_search_in_rovo']?.cohort;
    return cohort === 'test';
};
const $d1337898ab272d64$export$45bf6049ec3ec516 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('unified_search_one_click_3p_connect', 'isEnabled', false) === true;
};
/**
 * Unified Search 3P Connect Improvements Experiment
 */ const $d1337898ab272d64$var$UNIFIED_SEARCH_3P_CONNECT_IMPROVEMENTS_TEST_COHORTS = [
    'icon-and-tooltip',
    'icon-only',
    'tooltip-only'
];
const $d1337898ab272d64$export$1abc158ee6a5b777 = [
    'control',
    ...$d1337898ab272d64$var$UNIFIED_SEARCH_3P_CONNECT_IMPROVEMENTS_TEST_COHORTS
];
const $d1337898ab272d64$export$28f6b85de12145ce = ()=>{
    const cohort = (0, $c6GJD.default).getExperimentValue('unified_search_3p_connect_improvements', 'cohort', 'control');
    if ($d1337898ab272d64$export$1abc158ee6a5b777.includes(cohort)) return cohort;
    return 'control';
};
const $d1337898ab272d64$export$f22ea87ae194d314 = ()=>{
    const cohort = $d1337898ab272d64$export$28f6b85de12145ce();
    return $d1337898ab272d64$var$UNIFIED_SEARCH_3P_CONNECT_IMPROVEMENTS_TEST_COHORTS.includes(cohort);
};
const $d1337898ab272d64$var$IMPROVE_BANNER_TARGETING_COHORTS = [
    'control',
    'usage-threshold',
    'max-dismissals'
];
const $d1337898ab272d64$export$647c2f5a2b1ce3a5 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const cohort = (0, $c6GJD.default).getExperimentValue('rovo_search_improve_banner_targeting', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($d1337898ab272d64$var$IMPROVE_BANNER_TARGETING_COHORTS.includes(cohort)) return cohort;
    return 'control';
};
const $d1337898ab272d64$export$a188fe5ccb37cfe6 = (options = {
    fireExperimentExposure: false
})=>{
    return (0, $c6GJD.default).getExperimentValue('quick_find_zero_query_allocation_experiment', 'cohort', 'control', options) === 'test';
};
const $d1337898ab272d64$var$INLINE_3P_QUERY_SUGGESTIONS_TREATMENTS = [
    'control',
    'static',
    'dynamic'
];
const $d1337898ab272d64$export$1a051b8e8c16594f = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const treatment = (0, $c6GJD.default).getExperimentValue('inline_3p_query_suggestions_phase_1', 'inline_3p_query_suggestions_treatment', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($d1337898ab272d64$var$INLINE_3P_QUERY_SUGGESTIONS_TREATMENTS.includes(treatment)) return treatment;
    return 'control';
};
const $d1337898ab272d64$export$e4fdf56860b85064 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('unified_search_right_rail_enhancements', 'cohort', 'control');
};
const $d1337898ab272d64$export$faafa351c854e058 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>(0, $c6GJD.default).getExperimentValue('rovo_search_settings_modal_enabled', 'isEnabled', false, {
        fireExperimentExposure: fireExperimentExposure
    });
const $d1337898ab272d64$export$8877a40e4e8ce5c6 = ()=>{
    (0, $c6GJD.default).manuallyLogExperimentExposure('rovo_search_settings_modal_enabled');
};
const $d1337898ab272d64$export$5526c331b5a2a0a4 = (options = {
    fireExperimentExposure: false
})=>{
    return (0, $c6GJD.default).getExperimentValue('quick_find_zero_query_3p_recs_experiment', 'isEnabled', false, options) === true;
};
const $d1337898ab272d64$export$6d6007cc7a6767d0 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $c6GJD.default).getExperimentValue('rovo_search_github_in_recents', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$1c4aca11d3a542d8 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $c6GJD.default).getExperimentValue('rovo_search_use_sl_clicked_only_in_recents', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$var$FULLPAGE_SEARCH_SUMMARIZE_BUTTON_REVAMP_TREATMENTS = [
    'control',
    'visibility',
    'border'
];
const $d1337898ab272d64$export$b67def2b3de3898b = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const treatment = (0, $c6GJD.default).getExperimentValue('fullpage_search_summarize_button_revamp', 'fullpage_search_summarize_button_revamp_treatment', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($d1337898ab272d64$var$FULLPAGE_SEARCH_SUMMARIZE_BUTTON_REVAMP_TREATMENTS.includes(treatment)) return treatment;
    return 'control';
};
module.exports["triggerExposureForWeakLinkExp"] = $d1337898ab272d64$export$de65f9bad07950f2;
module.exports["serveWeakLinkExpWithoutExposure"] = $d1337898ab272d64$export$6c232948b0f89805;
module.exports["removeFedSlackFromAllProductSearch"] = $d1337898ab272d64$export$9f3b4e44245ab299;
module.exports["serveNounResultCounts"] = $d1337898ab272d64$export$b8eda33c6a73a867;
module.exports["serveWebPagesInTypeFilter"] = $d1337898ab272d64$export$6cc04d45455a2e52;
module.exports["serveJiraRecentsExcludeConfluenceWithoutExposure"] = $d1337898ab272d64$export$1b405ed1dcef1833;
module.exports["serveQFFilterSuggestionExperiment"] = $d1337898ab272d64$export$dbfae5c8d94a4c99;
module.exports["serveRightRailRecommendationsImprovementsWithExposure"] = $d1337898ab272d64$export$df1791a16917f9c3;
module.exports["serveQF3PBannerExperiment"] = $d1337898ab272d64$export$a254d1715475fc25;
module.exports["serveQF3PBannerExperimentWithoutExposure"] = $d1337898ab272d64$export$6308fede6bfa9216;
module.exports["serveConfluenceSpaceIconUpdate"] = $d1337898ab272d64$export$a28677150905172f;
module.exports["serve3PClickIngestionExperiment"] = $d1337898ab272d64$export$f980294cad954499;
module.exports["isQuickFindAsyncPreloadEnabled"] = $d1337898ab272d64$export$7d99be50af8e6e5c;
module.exports["serveQuickFind3PBoostingExperiment"] = $d1337898ab272d64$export$32815557e5d06f0a;
module.exports["serveEngagementTrackingImprovementsExperiment"] = $d1337898ab272d64$export$307ab554c0a03fb;
module.exports["triggerExposureForEngagementTrackingImprovementsExperiment"] = $d1337898ab272d64$export$99df3e6ef07f806c;
module.exports["getUserShardExperimentFlags"] = $d1337898ab272d64$export$995378c845be3fef;
module.exports["serveUserShardModel"] = $d1337898ab272d64$export$2300db9903c1302f;
module.exports["serveUserShardUI"] = $d1337898ab272d64$export$d9ee534a20391486;
module.exports["serveUserShardControl"] = $d1337898ab272d64$export$1c3bd8b8866d2939;
module.exports["getUserShardSpaceL1Id"] = $d1337898ab272d64$export$3b350d5272fcff38;
module.exports["getUserShardPageL1Id"] = $d1337898ab272d64$export$28bf0ffbee49739c;
module.exports["getUserShardDebounceTimeout"] = $d1337898ab272d64$export$d8621fd9027f7208;
module.exports["getMultiSiteSearchInRovo"] = $d1337898ab272d64$export$9e14285db0210414;
module.exports["serveOneClick3PConnectExperiment"] = $d1337898ab272d64$export$45bf6049ec3ec516;
module.exports["getUnifiedSearch3PConnectImprovementsCohort"] = $d1337898ab272d64$export$28f6b85de12145ce;
module.exports["isInUnifiedSearch3PConnectImprovementsTestCohort"] = $d1337898ab272d64$export$f22ea87ae194d314;
module.exports["serveImproveBannerTargetingExperiment"] = $d1337898ab272d64$export$647c2f5a2b1ce3a5;
module.exports["serveQFZeroQueryAllocationExperiment"] = $d1337898ab272d64$export$a188fe5ccb37cfe6;
module.exports["serveInline3PQuerySuggestionsPhase1"] = $d1337898ab272d64$export$1a051b8e8c16594f;
module.exports["getUnifiedSearchRightRailEnhancementsExpValue"] = $d1337898ab272d64$export$e4fdf56860b85064;
module.exports["serveSearchSettingsModalExperiment"] = $d1337898ab272d64$export$faafa351c854e058;
module.exports["triggerExposureForSearchSettingsModalExperiment"] = $d1337898ab272d64$export$8877a40e4e8ce5c6;
module.exports["serveQFZeroQuery3PRecsExperiment"] = $d1337898ab272d64$export$5526c331b5a2a0a4;
module.exports["serveGithubRecentsExperiment"] = $d1337898ab272d64$export$6d6007cc7a6767d0;
module.exports["serveSlClickedOnlyInRecentsExperiment"] = $d1337898ab272d64$export$1c4aca11d3a542d8;
module.exports["serveFullpageSearchSummarizeButtonRevamp"] = $d1337898ab272d64$export$b67def2b3de3898b;

});

parcelRegister("9d9t8", function(module, exports) {

var $eakyO = parcelRequire("eakyO");

const $320daaf61e2ab33a$export$e88fb694deeca21a = 'smartlinks-connector';
const $320daaf61e2ab33a$export$7ad7a95070d8bb93 = (0, $eakyO.ConnectorSources).Federated;
const $320daaf61e2ab33a$export$e3a0662f044cd99b = (0, $eakyO.ConnectorSources).Lite;
const $320daaf61e2ab33a$export$c14e5e3fa6d8b46 = (0, $eakyO.ConnectorSources).Smartlinks;
const $320daaf61e2ab33a$export$aa06c0b5cc41ad9a = (0, $eakyO.ConnectorSources).Full;
const $320daaf61e2ab33a$export$37e0ed5b7fa94503 = (0, $eakyO.ConnectorSources).Backfill;
const $320daaf61e2ab33a$export$af092ad5a950adea = (value)=>{
    return Object.values((0, $eakyO.ConnectorSources)).includes(value);
};
const $320daaf61e2ab33a$export$9a0cf6dd1d986cc2 = 'forge-connector-';
const $320daaf61e2ab33a$export$e5725489d3388d22 = (type)=>{
    return type.startsWith($320daaf61e2ab33a$export$9a0cf6dd1d986cc2);
};
/**
 * Runtime registry for Forge connector icons.
 * Similar to ThirdPartyConfigs, but populated dynamically from API responses.
 */ const $320daaf61e2ab33a$var$forgeConnectorIconsRegistry = new Map();
const $320daaf61e2ab33a$export$4e96e986802512bd = (productKey, icon)=>{
    $320daaf61e2ab33a$var$forgeConnectorIconsRegistry.set(productKey, icon);
};
const $320daaf61e2ab33a$export$2f2bd8960b497856 = (productKey)=>{
    return $320daaf61e2ab33a$var$forgeConnectorIconsRegistry.get(productKey);
};
const $320daaf61e2ab33a$export$2768da79a2599ca3 = ()=>{
    $320daaf61e2ab33a$var$forgeConnectorIconsRegistry.clear();
};
module.exports["FEDERATED_CONNECTOR_SOURCE"] = $320daaf61e2ab33a$export$7ad7a95070d8bb93;
module.exports["LITE_CONNECTOR_SOURCE"] = $320daaf61e2ab33a$export$e3a0662f044cd99b;
module.exports["SMARTLINKS_CONNECTOR_SOURCE"] = $320daaf61e2ab33a$export$c14e5e3fa6d8b46;
module.exports["FULL_CONNECTOR_SOURCE"] = $320daaf61e2ab33a$export$aa06c0b5cc41ad9a;
module.exports["isConnectorSource"] = $320daaf61e2ab33a$export$af092ad5a950adea;
module.exports["isForgeConnectorProductKey"] = $320daaf61e2ab33a$export$e5725489d3388d22;
module.exports["registerForgeConnectorIcon"] = $320daaf61e2ab33a$export$4e96e986802512bd;
module.exports["getForgeConnectorIcon"] = $320daaf61e2ab33a$export$2f2bd8960b497856;

});

parcelRegister("eakyO", function(module, exports) {
const $b8445082174fc78f$export$499e9a6668a55181 = {
    Federated: 'federated',
    Smartlinks: 'smartlinks',
    Lite: 'lite-connector',
    Full: 'full-connector',
    Backfill: 'backfill'
};
module.exports["ConnectorSources"] = $b8445082174fc78f$export$499e9a6668a55181;

});

parcelRegister("bVltF", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $95b33375becf7c06$var$COMPONENT = 'search-page';
const $95b33375becf7c06$export$a98443e214d7b1fd = new (0, $5aVN7.UFOExperience)('load', {
    type: (0, $9NDUe.ExperienceTypes).Load,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    platform: {
        component: $95b33375becf7c06$var$COMPONENT
    }
});
const $95b33375becf7c06$export$e882a2ec68d19be8 = new (0, $5aVN7.UFOExperience)('search-results-load', {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $95b33375becf7c06$var$COMPONENT
    },
    timings: [
        {
            key: 'request',
            startMark: 'request_start',
            endMark: 'request_end'
        },
        {
            key: 'render',
            startMark: 'render_start',
            endMark: 'render_end'
        }
    ]
});
const $95b33375becf7c06$export$eda1f56a83aaec73 = async ()=>{
    if (!$95b33375becf7c06$export$e882a2ec68d19be8.state.final) await $95b33375becf7c06$export$e882a2ec68d19be8.abort({
        metadata: {
            reason: 'restarted'
        }
    });
    $95b33375becf7c06$export$e882a2ec68d19be8.start();
};
const $95b33375becf7c06$export$b066085d86746240 = ({ queryLength: queryLength, wordCount: wordCount })=>{
    $95b33375becf7c06$export$e882a2ec68d19be8.success({
        metadata: {
            queryLength: queryLength,
            wordCount: wordCount
        }
    });
};
const $95b33375becf7c06$export$7cc1b457adcf3334 = ()=>{
    $95b33375becf7c06$export$e882a2ec68d19be8.failure();
};
module.exports["searchPageLoadUFOExperience"] = $95b33375becf7c06$export$a98443e214d7b1fd;
module.exports["searchResultsLoadUFOExperienceStart"] = $95b33375becf7c06$export$eda1f56a83aaec73;
module.exports["searchResultsLoadUFOExperienceSuccess"] = $95b33375becf7c06$export$b066085d86746240;
module.exports["searchResultsLoadUFOExperienceError"] = $95b33375becf7c06$export$7cc1b457adcf3334;

});

parcelRegister("1R3zJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e6d73fa950add8a3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afa74181baaa67be5e1a2274a7254425>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $fP78j = parcelRequire("fP78j");

function $e6d73fa950add8a3$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("kMqyt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $cb2f9539166b293e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30f3baace5bcd49b8a2c522228cf7a06>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $fP78j = parcelRequire("fP78j");

function $cb2f9539166b293e$export$2e2bcd8739ae039({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("3ro6F", function(module, exports) {
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3gadb = parcelRequire("3gadb");


var $5azuv = parcelRequire("5azuv");


var $9VmkK = parcelRequire("9VmkK");


var $F1g0V = parcelRequire("F1g0V");

const $5c3d9d5d7ce5effd$var$itemWrapperStyles = null;
const $5c3d9d5d7ce5effd$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $5c3d9d5d7ce5effd$var$ICON_WIDTH_ESTIMATE = 24;
const $5c3d9d5d7ce5effd$var$staticItemStyles = null;
const $5c3d9d5d7ce5effd$var$staticItemWithTruncationStyles = null;
const $5c3d9d5d7ce5effd$var$staticItemWithoutTruncationStyles = null;
const $5c3d9d5d7ce5effd$var$BreadcrumbsItem = /*#__PURE__*/ (0, $42omo.memo)(({ analyticsContext: analyticsContext, component: component, href: // `createAnalyticsEvent` should be here, but throws errors on render since
// it ends up being spread on a DOM element at the very end
href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, ref: // This is overridden by the `buttonRef` below
ref, target: target, testId: testId, text: text, truncationWidth: truncationWidth, // I believe there is only `createAnalyticsEvent` left on here, but leaving
// it here to allow this to be a patch and not a major
...rest })=>{
    const stepTextRef = (0, $42omo.useRef)(null); // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (iconBefore) iconWidthAllowance += $5c3d9d5d7ce5effd$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $5c3d9d5d7ce5effd$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $F1g0V.default)(truncationWidth, stepTextRef.current, iconWidthAllowance); // This should be a part of staticItemStyles but it requires the !important flag to prevent the padding from being overridden by the button styles
    // compiled treats `${token(xxx)} !important` differently when concat !important in es2019 and esm built files
    // the padding and font weight were not sourced correctly in the esm build
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    }; // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$5c3d9d5d7ce5effd$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = !component ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5azuv.default), {
        ref: stepTextRef,
        analyticsContext: analyticsContext,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        target: target,
        testId: testId,
        truncationWidth: truncationWidth,
        ...rest,
        children: text
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9VmkK.default), {
        ...rest,
        analyticsContext: analyticsContext,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: stepTextRef,
        target: target,
        testId: testId,
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        className: (0, $gMc0m.default)([
            "_vwz41txs",
            truncationWidth ? "_p12f8zc4" : "_1ul9grf3 _1o9zzg3v"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("li", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _ect4ttxp _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsoftgi _toskidpf _15621n76 _191d1h6o"
        ]),
        children: showTooltip ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5c3d9d5d7ce5effd$export$2e2bcd8739ae039 = $5c3d9d5d7ce5effd$var$BreadcrumbsItem;
module.exports["default"] = $5c3d9d5d7ce5effd$export$2e2bcd8739ae039;

});

parcelRegister("5azuv", function(module, exports) {
/* step.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $1Whri = parcelRequire("1Whri");


var $ee7An = parcelRequire("ee7An");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $fVUfS = parcelRequire("fVUfS");

const $bd15777e6f419ea7$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $bd15777e6f419ea7$var$noop = (0, $ee7An.default);
const $bd15777e6f419ea7$var$styles = {
    root: "_11c8fhey _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcv77o _18zrze3t _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo",
    rootT26Shape: "_2rkolb4i",
    withoutTruncation: "_1ul9idpf _1o9zkb7n",
    text: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
}; /**
    * __Step__
    *
    * A button that represents a single step in a breadcrumbs component.
    */ 
const $bd15777e6f419ea7$var$Step = /*#__PURE__*/ (0, $42omo.forwardRef)(({ analyticsContext: analyticsContext, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $bd15777e6f419ea7$var$noop, target: target, testId: testId, children: children, truncationWidth: truncationWidth, ...rest }, ref)=>{
    const handleClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$bd15777e6f419ea7$var$analyticsAttributes
    });
    const content = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            iconBefore,
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                ref: ref,
                className: (0, $gMc0m.default)([
                    $bd15777e6f419ea7$var$styles.text
                ]),
                children: children
            }),
            iconAfter
        ]
    });
    if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        href: href,
        onClick: handleClick,
        target: target,
        testId: testId,
        xcss: (0, $1Whri.cx)($bd15777e6f419ea7$var$styles.root, !truncationWidth && $bd15777e6f419ea7$var$styles.withoutTruncation, (0, $dh538.fg)('platform-dst-shape-theme-default') && $bd15777e6f419ea7$var$styles.rootT26Shape),
        style: {
            maxWidth: truncationWidth
        },
        ...rest,
        children: content
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: handleClick,
        testId: testId,
        xcss: (0, $1Whri.cx)($bd15777e6f419ea7$var$styles.root, !truncationWidth && $bd15777e6f419ea7$var$styles.withoutTruncation, (0, $dh538.fg)('platform-dst-shape-theme-default') && $bd15777e6f419ea7$var$styles.rootT26Shape),
        style: {
            maxWidth: truncationWidth
        },
        ...rest,
        children: content
    });
});
var $bd15777e6f419ea7$export$2e2bcd8739ae039 = $bd15777e6f419ea7$var$Step;
module.exports["default"] = $bd15777e6f419ea7$export$2e2bcd8739ae039;

});

parcelRegister("9VmkK", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $eEA8O = parcelRequire("eEA8O");


var $ee7An = parcelRequire("ee7An");

const $b9cd9c632c3988d9$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $b9cd9c632c3988d9$var$noop = (0, $ee7An.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $b9cd9c632c3988d9$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $b9cd9c632c3988d9$var$noop, target: target, testId: testId, // Button does not take `createAnalyticsEvent`, but it is spread on anyway
...props }, ref)=>{
    const handleClicked = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$b9cd9c632c3988d9$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $b9cd9c632c3988d9$export$2e2bcd8739ae039 = $b9cd9c632c3988d9$var$StepOld;
module.exports["default"] = $b9cd9c632c3988d9$export$2e2bcd8739ae039;

});

parcelRegister("F1g0V", function(module, exports) {
$parcel$export(module.exports, "default", () => $7675ee682b2302ec$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $7675ee682b2302ec$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $42omo.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $42omo.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $42omo.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});

parcelRegister("kGnTD", function(module, exports) {
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $k7fGo = parcelRequire("k7fGo");


var $3AVDQ = parcelRequire("3AVDQ");

const $bb8be9a617eb3e67$var$defaultMaxItems = 8;
const $bb8be9a617eb3e67$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $bb8be9a617eb3e67$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $bb8be9a617eb3e67$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children;
const $bb8be9a617eb3e67$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $bb8be9a617eb3e67$var$noop = (0, $ee7An.default);
const $bb8be9a617eb3e67$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $bb8be9a617eb3e67$var$breadcrumbStyles = null;
const $bb8be9a617eb3e67$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $bb8be9a617eb3e67$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $bb8be9a617eb3e67$var$noop, analyticsContext: analyticsContext, label: label = $bb8be9a617eb3e67$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $bb8be9a617eb3e67$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $42omo.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $42omo.useState)(false);
    const wrapperRef = (0, $42omo.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $bb8be9a617eb3e67$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealedMemoized = (0, $42omo.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($bb8be9a617eb3e67$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $3AVDQ.useOnRevealed)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$bb8be9a617eb3e67$var$analyticsAttributes
    });
    const childrenArray = $bb8be9a617eb3e67$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray; // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $k7fGo.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $l998X.jsx)("nav", {
        "aria-label": label,
        ref: (0, $3654r.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $l998X.jsx)("ol", {
            "data-testid": testId,
            className: (0, $gMc0m.default)([
                "_1e0c1txw _1n261g80 _syaz1rpy _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
            ]),
            children: breadcrumbsItems
        })
    });
});
const $bb8be9a617eb3e67$var$Breadcrumbs = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)($bb8be9a617eb3e67$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $bb8be9a617eb3e67$export$2e2bcd8739ae039 = $bb8be9a617eb3e67$var$Breadcrumbs;
module.exports["default"] = $bb8be9a617eb3e67$export$2e2bcd8739ae039;

});

parcelRegister("k7fGo", function(module, exports) {
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $ee7An = parcelRequire("ee7An");


var $fVUfS = parcelRequire("fVUfS");

const $7976e3e68603e041$var$noop = (0, $ee7An.default);
const $7976e3e68603e041$var$itemWrapperStyles = null;
const $7976e3e68603e041$var$styles = {
    root: "_11c8fhey _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo"
};
const $7976e3e68603e041$var$EllipsisItem = /*#__PURE__*/ (0, $42omo.memo)(({ label: label, onClick: onClick = $7976e3e68603e041$var$noop, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("li", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            "aria-label": label,
            onClick: onClick,
            xcss: $7976e3e68603e041$var$styles.root,
            testId: testId,
            children: "\u2026"
        })
    })); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $7976e3e68603e041$export$2e2bcd8739ae039 = $7976e3e68603e041$var$EllipsisItem;
module.exports["default"] = $7976e3e68603e041$export$2e2bcd8739ae039;

});

parcelRegister("3AVDQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bzNqF = parcelRequire("bzNqF");

function $bbb20e0fdee82203$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $bzNqF.default)(isExpanded);
    (0, $42omo.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}
module.exports["useOnRevealed"] = $bbb20e0fdee82203$export$e9c4922b2ecf808a;

});

parcelRegister("i6xGB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::151fe33e88b0ee8f745faaf0f04d86d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2e2eae372bc9680$var$_react = $d2e2eae372bc9680$var$_interopRequireDefault((parcelRequire("42omo")));

var $d2e2eae372bc9680$var$_baseNew = $d2e2eae372bc9680$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d2e2eae372bc9680$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2e2eae372bc9680$var$StopwatchIcon = (props)=>/*#__PURE__*/ $d2e2eae372bc9680$var$_react.default.createElement($d2e2eae372bc9680$var$_baseNew.default, Object.assign({
        name: "StopwatchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 0h6v1.5H8.75v1.543a6.47 6.47 0 0 1 3.06 1.19l1.137-1.24 1.106 1.014-1.137 1.24a6.5 6.5 0 1 1-9.832 0l-1.137-1.24 1.106-1.014 1.137 1.24a6.47 6.47 0 0 1 3.06-1.19V1.5H5zm3 4.5a4.98 4.98 0 0 0-3.378 1.314A5 5 0 1 0 8 4.5m2.842 3.01-2.541 2.75-1.102-1.02 2.542-2.75z" clip-rule="evenodd"/>`
    }, props));
$d2e2eae372bc9680$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $d2e2eae372bc9680$var$_default = module.exports.default = $d2e2eae372bc9680$var$StopwatchIcon;

});

parcelRegister("2qzBQ", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $44766eafbe4aebec$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $44766eafbe4aebec$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $44766eafbe4aebec$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $44766eafbe4aebec$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $44766eafbe4aebec$export$5c07a4287a46fa1f;

});

parcelRegister("jnPv4", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $5G9KX = parcelRequire("5G9KX");


var $6jKOp = parcelRequire("6jKOp");


var $3WVPu = parcelRequire("3WVPu");


var $5b4k9 = parcelRequire("5b4k9");


var $YBuvR = parcelRequire("YBuvR");

const $582af5ffd704fa53$export$e89e805418f4d2c = (args)=>{
    const { name: name } = args;
    let cacheInstance = null;
    let resolvedStorage = null;
    // During refresh, the main cache will hold pending promises so we need a way to access the last resolved value
    // This cache can return these values while the refresh is in progress
    const resolvedValueCache = new Map();
    /**
	 * NOTE: Scope control (QS-9209)
	 *
	 * The storage adapter system is introduced specifically so the combined search config cache
	 * can participate in host-provided persistence (e.g., Confluence SSR local storage).
	 *
	 * The combined config experiment (`search_combined_config`, QS-9091) must be enabled for the
	 * adapter system to be used.
	 */ const COMBINED_CONFIG_PERSISTED_CACHE_KEY = (0, $5b4k9.SEARCH_COMBINED_CONFIG_CACHE_KEY);
    const defaultLocalStorageAdapter = {
        getItem: (key)=>(0, $5G9KX.getLocalStorageItemAsString)(key),
        setItem: (key, value)=>(0, $5G9KX.setLocalStorageItem)(key, value)
    };
    function isCombinedConfigEnabled() {
        return (0, $c6GJD.default).getExperimentValue('search_combined_config', 'isEnabled', false) === true;
    }
    function shouldUseAdapterSystemForThisCache() {
        return name === COMBINED_CONFIG_PERSISTED_CACHE_KEY && isCombinedConfigEnabled();
    }
    const getCacheInstance = ()=>{
        /**
		 * We lazily create the cache instance to avoid the issue in SSR
		 * where the localStorage isn't available.
		 */ if (!cacheInstance) {
            cacheInstance = (0, $3WVPu.getInstance)(args);
            // Resolve persisted state lazily (SSR-safe)
            let persistedState = null;
            try {
                if (shouldUseAdapterSystemForThisCache()) {
                    const factory = (0, $YBuvR.getSearchClientStorageAdapterFactory)();
                    if (factory) {
                        resolvedStorage = factory();
                        persistedState = resolvedStorage?.getItem(name) ?? null;
                    }
                    // If the adapter cache is cold (e.g. gate transition from direct localStorage
                    // to StorageManager) or the factory isn't registered yet, fall back to the
                    // raw localStorage key. This ensures stale-but-present data from the
                    // pre-transition era is served immediately rather than blocking on the network
                    // and potentially timing out the DegradablePromise.
                    // SSR-safe: getLocalStorageItemAsString throws in SSR -> caught by outer try/catch.
                    if (!persistedState) persistedState = (0, $5G9KX.getLocalStorageItemAsString)(name);
                } else persistedState = (0, $5G9KX.getLocalStorageItemAsString)(name);
            } catch  {
            // Error retrieving persisted state - continue without it
            }
            if (persistedState) {
                // Populate the resolved value cache with the contents of local storage
                const object = cacheInstance.deserialize(persistedState);
                if (object) Object.entries(object).forEach(([key, entry])=>{
                    if (entry && 'result' in entry) resolvedValueCache.set(key, entry.result);
                });
            }
        }
        return cacheInstance;
    };
    const get = (key, returnExpired)=>{
        const storedValue = getCacheInstance().get(key, returnExpired ?? true); // fetch expired result by default
        const isExpired = getCacheInstance().isExpired(key);
        return {
            storedValue: storedValue,
            isExpired: isExpired
        };
    };
    const set = async (key, result, expiration)=>{
        getCacheInstance().set(key, result, expiration);
        try {
            const resolvedValue = await result;
            resolvedValueCache.set(key, resolvedValue);
            const serialized = await getCacheInstance().serialize();
            if (serialized) {
                if (shouldUseAdapterSystemForThisCache()) {
                    const adapter = resolvedStorage ?? (0, $YBuvR.getSearchClientStorageAdapterFactory)()?.() ?? defaultLocalStorageAdapter;
                    adapter.setItem(name, serialized);
                } else (0, $5G9KX.setLocalStorageItem)(name, serialized);
            }
        } catch  {
        // noop - an exception in the result promise or serialisation should be ignored so we dont throw unhandled exceptions
        }
    };
    const update = async (key, updater, expiration)=>{
        // Read remaining TTL before get(), which removes expired entries from the map
        const remainingTtl = expiration ?? getCacheInstance().getRemainingTtl(key);
        const { storedValue: storedValue } = get(key, true);
        if (!storedValue) return false;
        try {
            const currentValue = await storedValue;
            const updatedValue = updater(currentValue);
            await set(key, Promise.resolve(updatedValue), remainingTtl || undefined);
            return true;
        } catch  {
            return false;
        }
    };
    const clear = (key)=>{
        if (key) resolvedValueCache.delete(key);
        else resolvedValueCache.clear();
        getCacheInstance().clear(key);
    };
    const refreshOnAccessDecorator = ({ key: key, supplier: supplier, returnExpired: returnExpired, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks, serveResolvedDuringRefresh: serveResolvedDuringRefresh, traceInfoExtractor: traceInfoExtractor })=>{
        const { storedValue: storedValue, isExpired: isExpired } = get(key, returnExpired);
        const shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
        // When enabled, returns already-resolved values from an in-memory cache during background
        // refresh instead of returning pending promises. Callers can opt out by passing false.
        const serveResolvedDuringRefreshEnabled = serveResolvedDuringRefresh ?? false;
        if (!storedValue || shouldRefresh) {
            // Wrap the supplier to track network calls
            const trackedSupplier = async ()=>{
                networkCallbacks?.onStart();
                try {
                    const result = await supplier();
                    const traceInfo = traceInfoExtractor ? traceInfoExtractor() : (0, $6jKOp.extractTraceInfoFromResponse)(result);
                    networkCallbacks?.onSuccess(traceInfo);
                    return result;
                } catch (error) {
                    const errorName = error?.name || 'UnknownError';
                    const errorMessage = error?.message || 'An unknown error occurred';
                    networkCallbacks?.onError(errorName, errorMessage, undefined);
                    throw error;
                }
            };
            const apiPromise = trackedSupplier();
            set(key, apiPromise, expiration);
            // If there was already a stored value prior to refreshing, return it
            if (storedValue) {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: true
                });
                // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
                if (serveResolvedDuringRefreshEnabled) {
                    const resolvedValue = resolvedValueCache.get(key);
                    if (resolvedValue !== undefined) return resolvedValue;
                }
                return storedValue;
            } else {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: false
                });
                return apiPromise;
            }
        } else {
            if (analyticsCallback) analyticsCallback({
                refreshTriggered: false,
                hit: true
            });
            // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
            if (serveResolvedDuringRefreshEnabled) {
                const resolvedValue = resolvedValueCache.get(key);
                if (resolvedValue !== undefined) return resolvedValue;
            }
            return storedValue;
        }
    };
    const seed = (key, value, expiration)=>set(key, Promise.resolve(value), expiration);
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator,
        clear: clear,
        update: update,
        seed: seed
    };
};
module.exports["promiseCache"] = $582af5ffd704fa53$export$e89e805418f4d2c;

});

parcelRegister("6jKOp", function(module, exports) {
const $cb37190253d46910$var$NOT_AVAILABLE = 'not_available';
const $cb37190253d46910$export$fca3401e33379daf = (result)=>{
    if (result && typeof result === 'object' && 'extensions' in result) {
        const extensions = result.extensions;
        const gateway = extensions?.gateway;
        if (gateway) return {
            requestId: gateway.request_id ?? undefined,
            traceId: gateway.trace_id ?? undefined
        };
    }
    return undefined;
};
const $cb37190253d46910$export$4acb28c262cd52bd = (traceInfo)=>({
        requestId: traceInfo?.requestId ?? $cb37190253d46910$var$NOT_AVAILABLE,
        traceId: traceInfo?.traceId ?? $cb37190253d46910$var$NOT_AVAILABLE
    });
module.exports["extractTraceInfoFromResponse"] = $cb37190253d46910$export$fca3401e33379daf;
module.exports["normaliseTraceInfo"] = $cb37190253d46910$export$4acb28c262cd52bd;

});

parcelRegister("3WVPu", function(module, exports) {
const $fc16ad90038db0a8$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
class $fc16ad90038db0a8$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result, expiration) {
        const entry = new $fc16ad90038db0a8$var$Entry({
            result: result,
            expirationTime: Date.now() + (expiration || this.expiration),
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $fc16ad90038db0a8$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
            return object;
        } catch  {
        // TODO: Log error via sentry
        }
        return undefined;
    }
    isExpired(key) {
        const entry = this.map[key];
        return entry ? entry.isExpired() : true;
    }
    getRemainingTtl(key) {
        const entry = this.map[key];
        if (!entry) return undefined;
        return Math.max(0, entry.getExpirationTime() - Date.now());
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $fc16ad90038db0a8$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $fc16ad90038db0a8$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $fc16ad90038db0a8$export$8bedcca5bbd73999 = (args)=>{
    return new $fc16ad90038db0a8$var$Cache(args);
};
module.exports["getInstance"] = $fc16ad90038db0a8$export$8bedcca5bbd73999;

});

parcelRegister("3Tbc2", function(module, exports) {

var $fQifp = parcelRequire("fQifp");

const $3c05ea8f13f2fd4c$export$ff01cc10d3c607be = 6000; // default timeout
const $3c05ea8f13f2fd4c$var$DEGRADE_ERROR = new (0, $fQifp.DegradeError)('Promise is degraded');
class $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9 {
    static from(wrapped, degradationCallback = ()=>{}, timeoutMs) {
        return new $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9(wrapped, degradationCallback, timeoutMs ?? $3c05ea8f13f2fd4c$export$ff01cc10d3c607be);
    }
    constructor(wrapped, degradationCallback, timeoutMs = $3c05ea8f13f2fd4c$export$ff01cc10d3c607be){
        this.degradablePromiseInternal = void 0;
        this.degradeTimeout = void 0;
        this.timeoutMs = void 0;
        this.degradeInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.timeout = ()=>{
            this.degradeInternal();
        };
        this.promise = ()=>this.degradablePromiseInternal;
        const degrader = new Promise((_, reject)=>{
            this.degradeInternal = ()=>{
                reject($3c05ea8f13f2fd4c$var$DEGRADE_ERROR);
                degradationCallback('timeout');
            };
        });
        // Call the degradation callback with 'failed' if the wrapped promise fails, easy way to track metrics at fetch level
        wrapped.catch(()=>{
            degradationCallback('failure');
        });
        // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
        const wrappedFinally = wrapped.finally(()=>{
            if (this.degradeTimeout) clearTimeout(this.degradeTimeout);
        });
        const wrapper = Promise.race([
            wrappedFinally,
            degrader
        ]);
        this.degradablePromiseInternal = wrapper;
        this.timeoutMs = timeoutMs ?? $3c05ea8f13f2fd4c$export$ff01cc10d3c607be;
        this.degradeTimeout = setTimeout(this.timeout, this.timeoutMs);
    }
}
module.exports["DegradablePromise"] = $3c05ea8f13f2fd4c$export$ea6d6e4c9647fa9;

});

parcelRegister("fQifp", function(module, exports) {
class $821f2e34e1284477$export$85bf8e4fb143676a extends Error {
    constructor(...args){
        super(...args);
        this.isDegraded = true;
    }
}
module.exports["DegradeError"] = $821f2e34e1284477$export$85bf8e4fb143676a;

});

parcelRegister("hL7bb", function(module, exports) {
var $cedc651d64f014e0$var$pSlice = Array.prototype.slice;

var $gFqzn = parcelRequire("gFqzn");


var $2EuUq = parcelRequire("2EuUq");

var $cedc651d64f014e0$var$deepEqual = module.exports = function(actual, expected, opts) {
    if (!opts) opts = {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
    else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
    else return $cedc651d64f014e0$var$objEquiv(actual, expected, opts);
};
function $cedc651d64f014e0$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $cedc651d64f014e0$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $cedc651d64f014e0$var$objEquiv(a, b, opts) {
    var i, key;
    if ($cedc651d64f014e0$var$isUndefinedOrNull(a) || $cedc651d64f014e0$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if ($2EuUq(a)) {
        if (!$2EuUq(b)) return false;
        a = $cedc651d64f014e0$var$pSlice.call(a);
        b = $cedc651d64f014e0$var$pSlice.call(b);
        return $cedc651d64f014e0$var$deepEqual(a, b, opts);
    }
    if ($cedc651d64f014e0$var$isBuffer(a)) {
        if (!$cedc651d64f014e0$var$isBuffer(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    try {
        var ka = $gFqzn(a), kb = $gFqzn(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$cedc651d64f014e0$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return typeof a === typeof b;
}

});

parcelRegister("gFqzn", function(module, exports) {
exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
exports.shim = shim;
function shim(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
}

});

parcelRegister("2EuUq", function(module, exports) {
var supportsArgumentsClass = function() {
    return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';
exports = module.exports = supportsArgumentsClass ? supported : unsupported;
exports.supported = supported;
function supported(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
}
exports.unsupported = unsupported;
function unsupported(object) {
    return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
}

});

parcelRegister("7DldS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f2cdb4cb36c37cab$export$bc9ec39841ba8fd3 = {
    CHAT: 'chat',
    SEARCH_QF_PILL: 'search-qf-connect-apps-pill',
    SEARCH_SIDEBAR: 'search-app-filter-sidebar'
};
const $f2cdb4cb36c37cab$export$ec3ac09cbc485f99 = (surface)=>surface?.startsWith('search-') === true;
const $f2cdb4cb36c37cab$var$initialState = {
    product: '',
    siteId: '',
    experienceId: 'ai-mate',
    assistanceServiceConfig: undefined,
    surface: undefined
};
const $f2cdb4cb36c37cab$var$rovoSettingsConfig = /*#__PURE__*/ (0, $42omo.createContext)($f2cdb4cb36c37cab$var$initialState);
const $f2cdb4cb36c37cab$export$e6e0575f100c37ab = $f2cdb4cb36c37cab$var$rovoSettingsConfig.Provider;
const $f2cdb4cb36c37cab$export$db68c798d50f727e = ()=>(0, $42omo.useContext)($f2cdb4cb36c37cab$var$rovoSettingsConfig);
module.exports["RovoSettingsModalSurface"] = $f2cdb4cb36c37cab$export$bc9ec39841ba8fd3;
module.exports["isSearchSurface"] = $f2cdb4cb36c37cab$export$ec3ac09cbc485f99;
module.exports["RovoSettingsConfigProvider"] = $f2cdb4cb36c37cab$export$e6e0575f100c37ab;
module.exports["useRovoSettingsConfig"] = $f2cdb4cb36c37cab$export$db68c798d50f727e;

});

parcelRegister("bRblh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $aXWIB = parcelRequire("aXWIB");


var $tvI67 = parcelRequire("tvI67");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");


var $7ZiAi = parcelRequire("7ZiAi");

const $760b34ee18927bc0$var$triggerStyles = {
    button: "_1dqoglyw _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi _bfhk1j28 _80omtlke _1bsb1osq _irr31dpa",
    text: "_11c8wadc _syaz1rpy"
};
const $760b34ee18927bc0$var$DefaultTrigger = ({ open: open })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        xcss: $760b34ee18927bc0$var$triggerStyles.button,
        onClick: ()=>open(),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            alignItems: "center",
            gap: "space.075",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $760b34ee18927bc0$var$triggerStyles.text,
                    children: formatMessage((0, $7ZiAi.messages).defaultTriggerLabel)
                })
            ]
        })
    });
};

const $760b34ee18927bc0$var$LazyRovoSettingsModalProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("faZvA")).then((mod)=>({
            default: mod.RovoSettingsModalLazy
        }))); /**
       * Self-contained entrypoint for the Rovo Settings modal.
       *
       * The trigger renders eagerly. The provider tree and modal
       * are lazy-loaded only when the user first clicks the trigger.
       * Subsequent opens reuse the mounted provider — no re-mount or re-fetch.
       */ 
const $760b34ee18927bc0$export$f2c3f3e62df426ba = ({ children: renderTrigger, ...providerProps })=>{
    const [isActivated, setIsActivated] = (0, $42omo.useState)(false);
    const pendingOpenOptions = (0, $42omo.useRef)(undefined);
    const openModalRef = (0, $42omo.useRef)(null);
    const open = (0, $42omo.useCallback)((options)=>{
        if (openModalRef.current) // Provider already mounted — open directly
        openModalRef.current(options);
        else {
            // First click — store options and mount the provider
            pendingOpenOptions.current = options;
            setIsActivated(true);
        }
    }, []); // Calling the render function directly (rather than mounting it as a
    // component) makes React diff the returned JSX in-place against the previous
    // render, so the trigger element survives parent re-renders even if the
    // render function's identity changes (e.g. inline arrows).
    const triggerNode = renderTrigger ? renderTrigger({
        open: open
    }) : /*#__PURE__*/ (0, $l998X.jsx)($760b34ee18927bc0$var$DefaultTrigger, {
        open: open
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $lAJUP.ErrorBoundary), {
        fallbackRender: ()=>null,
        children: [
            triggerNode,
            isActivated && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)($760b34ee18927bc0$var$LazyRovoSettingsModalProvider, {
                    ...providerProps,
                    pendingOpenOptions: pendingOpenOptions,
                    openModalRef: openModalRef
                })
            })
        ]
    });
};
module.exports["RovoSettingsModal"] = $760b34ee18927bc0$export$f2c3f3e62df426ba;

});

parcelRegister("7ZiAi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $c17fc71688854b9e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    modalTitle: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final",
        defaultMessage: "Sources & apps"
    },
    searchPlaceholder: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final",
        defaultMessage: "Search settings"
    },
    defaultTriggerLabel: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final",
        defaultMessage: "Explore all apps"
    }
});
module.exports["messages"] = $c17fc71688854b9e$export$defe85febe8b728c;

});

parcelRegister("faZvA", function(module, exports) {

let $b0c7807700c74548$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0c7807700c74548$var$load("hdYRX"),
    $b0c7807700c74548$var$load("1YS9Y"),
    $b0c7807700c74548$var$load("etEYy"),
    $b0c7807700c74548$var$load("6wr18"),
    $b0c7807700c74548$var$load("jvHRs"),
    $b0c7807700c74548$var$load("EfMFE"),
    $b0c7807700c74548$var$load("3BqWF"),
    $b0c7807700c74548$var$load("lGnwl"),
    $b0c7807700c74548$var$load("7EorR"),
    $b0c7807700c74548$var$load("5NQgH"),
    $b0c7807700c74548$var$load("ffEVr"),
    $b0c7807700c74548$var$load("Wowvf"),
    $b0c7807700c74548$var$load("6bVVs"),
    $b0c7807700c74548$var$load("7mo6o"),
    $b0c7807700c74548$var$load("cONk3"),
    $b0c7807700c74548$var$load("ltDLY"),
    $b0c7807700c74548$var$load("jnVKv")
]).then(()=>parcelRequire('7Bg2n'));

});

parcelRegister("a9bjQ", function(module, exports) {

let $76338664113c26be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $76338664113c26be$var$load("kGVQM").then(()=>parcelRequire('8xAxJ'));

});

parcelRegister("69PnT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2228fa01b7e8b5ee470ffc60df47923d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47bb7135644f74cd$var$_react = $47bb7135644f74cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $47bb7135644f74cd$var$_baseNew = $47bb7135644f74cd$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $47bb7135644f74cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47bb7135644f74cd$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $47bb7135644f74cd$var$_react.default.createElement($47bb7135644f74cd$var$_baseNew.default, Object.assign({
        name: "ArrowUpRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$47bb7135644f74cd$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $47bb7135644f74cd$var$_default = module.exports.default = $47bb7135644f74cd$var$ArrowUpRightIcon;

});

parcelRegister("PGaF8", function(module, exports) {
// @ts-ignore no types for this package :(

var $8M8UO = parcelRequire("8M8UO");


var $epqyT = parcelRequire("epqyT");

const $637e594f574ec048$var$DEFAULT_TIMING = {
    initialPollInterval: 5,
    pollBackoffRate: 2,
    idleTimeout: 30
};
class $637e594f574ec048$export$2e2bcd8739ae039 {
    /**
   * Callback for sending a 'track' analytics event. This callback should either be the
   * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
   * The data for the dwell event will be passed to this method for sending.
   *
   * @callback trackCallback
   * @param {Object} eventData - the base event data that will be added to the track event.
   */ /**
   * Creates and initialises the DwellTimeHelper.
   *
   * @param {trackCallback} trackCallback - the track callback responsible for actually sending
   * the event.
   * @param {Object} eventData - the base data that will be added to the track event.
   * Additional dwell time attributes will be appended to this data. Note that you don't need to
   * include the 'action' property, as this will be added automatically.
   * @param {?string} searchSessionId - a unique identifier for the related search session.
   * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
   * timing used for measuring dwell time. The following values are possible:
   * - initialPollInterval: how long to wait before the first dwell milestone event
   * is fired (in seconds). Default = 5.
   * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
   * event. Default = 2.
   * - idleTimeout: how long to wait for no user activity before pausing
   * the dwell timer (in seconds). Default = 30s.
   * @param {?DwellTimeHelperOptions} dwellTimeHelperOptions - options provided to customise behaviour
   * of the helper.
   * - iframeDwell = enable detection of activity in iframes.
   */ constructor(trackCallback, _eventData, _searchSessionId, timingOptions, dwellTimeHelperOptions){
        this.timeMeInitialized = false;
        this._eventData = void 0;
        this._searchSessionId = void 0;
        this._timing = void 0;
        this._trackCallback = void 0;
        this._dwellTimeHelperOptions = void 0;
        /**
     * Starts the dwell timer. This method should be called upon the initial page load.
     */ this.start = ()=>{
            if (this.timeMeInitialized) throw new Error('DwellTimeHelper should only be initialised once per page load.');
            this.timeMeInitialized = true;
            this._initDwellTimeCounterAndPolling();
            if (typeof window !== 'undefined') window.addEventListener('beforeunload', ()=>{
                this.stop();
            });
        };
        /**
     * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
     * finalise a dwell measurement without starting a new one. When switching to a new page in a
     * single-page app, use newPage instead.
     */ this.stop = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).isUserCurrentlyOnPage) this._sendDwellEvent(this._eventData, this._searchSessionId, true);
            (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).stopAllTimers();
            (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).resetAllRecordedPageTimes();
            (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).timeElapsedCallbacks = [];
            this.timeMeInitialized = false;
        };
        /**
     * Send the final dwell event and reinitialise the dwell timer for a new page.
     * This method should be called whenever a new page is switched to in a single-page app context.
     *
     * @param {Object} eventData - the base data that will be added to the track event.
     * @param {?string} searchSessionId - the new search session ID.
     */ this.newPage = (eventData, searchSessionId)=>{
            (0, $epqyT.validateDwellBaseEvent)(eventData);
            this.stop();
            this._eventData = eventData;
            this._searchSessionId = searchSessionId;
            this._initDwellTimeCounterAndPolling();
        };
        /**
     * This is a modified version of timeit's original listForIdleEvents function,
     * which also listens to events inside same-origin iframes (such as Confluence whiteboards and databases).
     * https://github.com/jasonzissman/TimeMe.js/blob/master/timeme.js#L338
     */ this._listForIdleEvents = ()=>{
            document.addEventListener('mousemove', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
            });
            document.addEventListener('keyup', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
            });
            document.addEventListener('touchstart', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
            });
            window.addEventListener('scroll', ()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
            });
            /**
       * Find all same origin iframes (same origin allow access to contentWindow.document)
       * and add event listeners to them too.
       */ const iframes = document.getElementsByTagName('iframe');
            for(let i = 0; i < iframes.length; i++){
                const iframe = iframes[i];
                try {
                    iframe?.contentWindow?.document.addEventListener('mousemove', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
                    });
                    iframe?.contentWindow?.document.addEventListener('keyup', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
                    });
                    iframe?.contentWindow?.document.addEventListener('touchstart', ()=>{
                        (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).userActivityDetected();
                    });
                } catch (e) {
                // do nothing: We don't want to listen to cross-origin iframes
                }
            }
            setInterval(()=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).isUserCurrentlyIdle !== true) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).checkIdleState();
                    // This ensures the timer continues when switching between the iframe and the rest of the page
                    (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).startTimer();
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).checkIdleStateRateMs);
        };
        this._initDwellTimeCounterAndPolling = ()=>{
            // If iframeDwell is enabled, override the listener for idle events to also listen to events in iframes.
            if (this._dwellTimeHelperOptions?.iframeDwell) (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).listForIdleEvents = this._listForIdleEvents;
            (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).initialize({
                idleTimeoutInSeconds: this._timing.idleTimeout
            });
            this._pollDwellTime(this._timing.initialPollInterval, this._searchSessionId, this._eventData);
        };
        this._pollDwellTime = (pollTime, searchSessionId, eventData)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).callAfterTimeElapsedInSeconds(pollTime, ()=>{
                this._sendDwellEvent(eventData, searchSessionId, false);
                this._pollDwellTime(pollTime * this._timing.pollBackoffRate, searchSessionId, eventData);
            });
        };
        this._sendDwellEvent = (eventData, searchSessionId, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: (0, (/*@__PURE__*/$parcel$interopDefault($8M8UO))).getTimeOnCurrentPageInMilliseconds(),
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: 'dwelled',
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                containers: eventData.containers,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: {
                    ...dwellAttributes,
                    ...eventData.attributes
                },
                tags: eventData.tags
            });
        };
        if (!trackCallback) throw new Error('trackCallback is required for DwellTimeHelper');
        (0, $epqyT.validateDwellBaseEvent)(_eventData);
        this._trackCallback = trackCallback;
        this._eventData = _eventData;
        this._searchSessionId = _searchSessionId;
        this._timing = {
            ...$637e594f574ec048$var$DEFAULT_TIMING,
            ...timingOptions
        };
        this._dwellTimeHelperOptions = dwellTimeHelperOptions;
    }
}
module.exports["default"] = $637e594f574ec048$export$2e2bcd8739ae039;

});

parcelRegister("8M8UO", function(module, exports) {
/*Copyright (c) 2020 Jason Zissman
Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ (()=>{
    ((root, factory)=>{
        if (module.exports) // CommonJS
        return module.exports = factory();
        else if (typeof define === 'function' && define.amd) // AMD
        define([], ()=>{
            return root.TimeMe = factory();
        });
        else // Global Variables
        return root.TimeMe = factory();
    })(module.exports, ()=>{
        let TimeMe = {
            startStopTimes: {},
            idleTimeoutMs: 30000,
            currentIdleTimeMs: 0,
            checkIdleStateRateMs: 250,
            isUserCurrentlyOnPage: true,
            isUserCurrentlyIdle: false,
            currentPageName: "default-page-name",
            timeElapsedCallbacks: [],
            userLeftCallbacks: [],
            userReturnCallbacks: [],
            trackTimeOnElement: (elementId)=>{
                let element = document.getElementById(elementId);
                if (element) {
                    element.addEventListener("mouseover", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mousemove", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mouseleave", ()=>{
                        TimeMe.stopTimer(elementId);
                    });
                    element.addEventListener("keypress", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("focus", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                }
            },
            getTimeOnElementInSeconds: (elementId)=>{
                let time = TimeMe.getTimeOnPageInSeconds(elementId);
                if (time) return time;
                else return 0;
            },
            // startTime is optional. If provided, must be of type Date(). By providing
            // startTime, you are overriding the internal timing mechanism and manually
            // indicating the start time.
            startTimer: (pageName, startTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                if (TimeMe.startStopTimes[pageName] === undefined) TimeMe.startStopTimes[pageName] = [];
                else {
                    let arrayOfTimes = TimeMe.startStopTimes[pageName];
                    let latestStartStopEntry = arrayOfTimes[arrayOfTimes.length - 1];
                    if (latestStartStopEntry !== undefined && latestStartStopEntry.stopTime === undefined) // Can't start new timer until previous finishes.
                    return;
                }
                TimeMe.startStopTimes[pageName].push({
                    "startTime": startTime || new Date(),
                    "stopTime": undefined
                });
            },
            stopAllTimers: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.stopTimer(pageNames[i]);
            },
            // stopTime is optional. If provided, must be of type Date(). By providing
            // stopTime, you are overriding the internal timing mechanism and manually
            // indicating the stop time.
            stopTimer: (pageName, stopTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined || arrayOfTimes.length === 0) // Can't stop timer before you've started it.
                return;
                if (arrayOfTimes[arrayOfTimes.length - 1].stopTime === undefined) arrayOfTimes[arrayOfTimes.length - 1].stopTime = stopTime || new Date();
            },
            getTimeOnCurrentPageInSeconds: ()=>{
                return TimeMe.getTimeOnPageInSeconds(TimeMe.currentPageName);
            },
            getTimeOnPageInSeconds: (pageName)=>{
                let timeInMs = TimeMe.getTimeOnPageInMilliseconds(pageName);
                if (timeInMs === undefined) return undefined;
                else return timeInMs / 1000;
            },
            getTimeOnCurrentPageInMilliseconds: ()=>{
                return TimeMe.getTimeOnPageInMilliseconds(TimeMe.currentPageName);
            },
            getTimeOnPageInMilliseconds: (pageName)=>{
                let totalTimeOnPage = 0;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined) // Can't get time on page before you've started the timer.
                return;
                let timeSpentOnPageInSeconds = 0;
                for(let i = 0; i < arrayOfTimes.length; i++){
                    let startTime = arrayOfTimes[i].startTime;
                    let stopTime = arrayOfTimes[i].stopTime;
                    if (stopTime === undefined) stopTime = new Date();
                    let difference = stopTime - startTime;
                    timeSpentOnPageInSeconds += difference;
                }
                totalTimeOnPage = Number(timeSpentOnPageInSeconds);
                return totalTimeOnPage;
            },
            getTimeOnAllPagesInSeconds: ()=>{
                let allTimes = [];
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++){
                    let pageName = pageNames[i];
                    let timeOnPage = TimeMe.getTimeOnPageInSeconds(pageName);
                    allTimes.push({
                        "pageName": pageName,
                        "timeOnPage": timeOnPage
                    });
                }
                return allTimes;
            },
            setIdleDurationInSeconds: (duration)=>{
                let durationFloat = parseFloat(duration);
                if (isNaN(durationFloat) === false) TimeMe.idleTimeoutMs = duration * 1000;
                else throw {
                    name: "InvalidDurationException",
                    message: "An invalid duration time (" + duration + ") was provided."
                };
            },
            setCurrentPageName: (pageName)=>{
                TimeMe.currentPageName = pageName;
            },
            resetRecordedPageTime: (pageName)=>{
                delete TimeMe.startStopTimes[pageName];
            },
            resetAllRecordedPageTimes: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.resetRecordedPageTime(pageNames[i]);
            },
            userActivityDetected: ()=>{
                if (TimeMe.isUserCurrentlyIdle) TimeMe.triggerUserHasReturned();
                TimeMe.resetIdleCountdown();
            },
            resetIdleCountdown: ()=>{
                TimeMe.isUserCurrentlyIdle = false;
                TimeMe.currentIdleTimeMs = 0;
            },
            callWhenUserLeaves: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userLeftCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            callWhenUserReturns: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userReturnCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            triggerUserHasReturned: ()=>{
                if (!TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = true;
                    TimeMe.resetIdleCountdown();
                    for(let i = 0; i < TimeMe.userReturnCallbacks.length; i++){
                        let userReturnedCallback = TimeMe.userReturnCallbacks[i];
                        let numberTimes = userReturnedCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userReturnedCallback.numberOfTimesToInvoke -= 1;
                            userReturnedCallback.callback();
                        }
                    }
                }
                TimeMe.startTimer();
            },
            // TODO - we are muddying the waters in between
            // 'user left page' and 'user gone idle'. Really should be
            // two separate concepts entirely. Need to break this into smaller  functions
            // for either scenario.
            triggerUserHasLeftPageOrGoneIdle: ()=>{
                if (TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = false;
                    for(let i = 0; i < TimeMe.userLeftCallbacks.length; i++){
                        let userHasLeftCallback = TimeMe.userLeftCallbacks[i];
                        let numberTimes = userHasLeftCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userHasLeftCallback.numberOfTimesToInvoke -= 1;
                            userHasLeftCallback.callback();
                        }
                    }
                }
                TimeMe.stopAllTimers();
            },
            callAfterTimeElapsedInSeconds: (timeInSeconds, callback)=>{
                TimeMe.timeElapsedCallbacks.push({
                    timeInSeconds: timeInSeconds,
                    callback: callback,
                    pending: true
                });
            },
            checkIdleState: ()=>{
                for(let i = 0; i < TimeMe.timeElapsedCallbacks.length; i++)if (TimeMe.timeElapsedCallbacks[i].pending && TimeMe.getTimeOnCurrentPageInSeconds() > TimeMe.timeElapsedCallbacks[i].timeInSeconds) {
                    TimeMe.timeElapsedCallbacks[i].callback();
                    TimeMe.timeElapsedCallbacks[i].pending = false;
                }
                if (TimeMe.isUserCurrentlyIdle === false && TimeMe.currentIdleTimeMs > TimeMe.idleTimeoutMs) {
                    TimeMe.isUserCurrentlyIdle = true;
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                } else TimeMe.currentIdleTimeMs += TimeMe.checkIdleStateRateMs;
            },
            visibilityChangeEventName: undefined,
            hiddenPropName: undefined,
            listenForVisibilityEvents: (trackWhenUserLeavesPage, trackWhenUserGoesIdle)=>{
                if (trackWhenUserLeavesPage) TimeMe.listenForUserLeavesOrReturnsEvents();
                if (trackWhenUserGoesIdle) TimeMe.listForIdleEvents();
            },
            listenForUserLeavesOrReturnsEvents: ()=>{
                if (typeof document.hidden !== "undefined") {
                    TimeMe.hiddenPropName = "hidden";
                    TimeMe.visibilityChangeEventName = "visibilitychange";
                } else if (typeof document.mozHidden !== "undefined") {
                    TimeMe.hiddenPropName = "mozHidden";
                    TimeMe.visibilityChangeEventName = "mozvisibilitychange";
                } else if (typeof document.msHidden !== "undefined") {
                    TimeMe.hiddenPropName = "msHidden";
                    TimeMe.visibilityChangeEventName = "msvisibilitychange";
                } else if (typeof document.webkitHidden !== "undefined") {
                    TimeMe.hiddenPropName = "webkitHidden";
                    TimeMe.visibilityChangeEventName = "webkitvisibilitychange";
                }
                document.addEventListener(TimeMe.visibilityChangeEventName, ()=>{
                    if (document[TimeMe.hiddenPropName]) TimeMe.triggerUserHasLeftPageOrGoneIdle();
                    else TimeMe.triggerUserHasReturned();
                }, false);
                window.addEventListener('blur', ()=>{
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                });
                window.addEventListener('focus', ()=>{
                    TimeMe.triggerUserHasReturned();
                });
            },
            listForIdleEvents: ()=>{
                document.addEventListener("mousemove", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("keyup", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("touchstart", ()=>{
                    TimeMe.userActivityDetected();
                });
                window.addEventListener("scroll", ()=>{
                    TimeMe.userActivityDetected();
                });
                setInterval(()=>{
                    if (TimeMe.isUserCurrentlyIdle !== true) TimeMe.checkIdleState();
                }, TimeMe.checkIdleStateRateMs);
            },
            websocket: undefined,
            websocketHost: undefined,
            setUpWebsocket: (websocketOptions)=>{
                if (window.WebSocket && websocketOptions) {
                    let websocketHost = websocketOptions.websocketHost; // "ws://hostname:port"
                    try {
                        TimeMe.websocket = new WebSocket(websocketHost);
                        window.onbeforeunload = ()=>{
                            TimeMe.sendCurrentTime(websocketOptions.appId);
                        };
                        TimeMe.websocket.onopen = ()=>{
                            TimeMe.sendInitWsRequest(websocketOptions.appId);
                        };
                        TimeMe.websocket.onerror = (error)=>{
                            if (console) console.log("Error occurred in websocket connection: " + error);
                        };
                        TimeMe.websocket.onmessage = (event)=>{
                            if (console) console.log(event.data);
                        };
                    } catch (error) {
                        if (console) console.error("Failed to connect to websocket host.  Error:" + error);
                    }
                }
            },
            websocketSend: (data)=>{
                TimeMe.websocket.send(JSON.stringify(data));
            },
            sendCurrentTime: (appId)=>{
                let timeSpentOnPage = TimeMe.getTimeOnCurrentPageInMilliseconds();
                let data = {
                    type: "INSERT_TIME",
                    appId: appId,
                    timeOnPageMs: timeSpentOnPage,
                    pageName: TimeMe.currentPageName
                };
                TimeMe.websocketSend(data);
            },
            sendInitWsRequest: (appId)=>{
                let data = {
                    type: "INIT",
                    appId: appId
                };
                TimeMe.websocketSend(data);
            },
            initialize: (options)=>{
                let idleTimeoutInSeconds = TimeMe.idleTimeoutMs || 30;
                let currentPageName = TimeMe.currentPageName || "default-page-name";
                let websocketOptions = undefined;
                let initialStartTime = undefined;
                let trackWhenUserLeavesPage = true;
                let trackWhenUserGoesIdle = true;
                if (options) {
                    idleTimeoutInSeconds = options.idleTimeoutInSeconds || idleTimeoutInSeconds;
                    currentPageName = options.currentPageName || currentPageName;
                    websocketOptions = options.websocketOptions;
                    initialStartTime = options.initialStartTime;
                    if (options.trackWhenUserLeavesPage === false) trackWhenUserLeavesPage = false;
                    if (options.trackWhenUserGoesIdle === false) trackWhenUserGoesIdle = false;
                }
                TimeMe.setIdleDurationInSeconds(idleTimeoutInSeconds);
                TimeMe.setCurrentPageName(currentPageName);
                TimeMe.setUpWebsocket(websocketOptions);
                TimeMe.listenForVisibilityEvents(trackWhenUserLeavesPage, trackWhenUserGoesIdle);
                // TODO - only do this if page currently visible.
                TimeMe.startTimer(undefined, initialStartTime);
            }
        };
        return TimeMe;
    });
}).call(module.exports);

});

parcelRegister("6gi58", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $hw4j5 = parcelRequire("hw4j5");

const $c59e27924968799d$export$42679f7213a051c = ()=>{
    return `
	query SearchPageJiraFieldHydration (
		$issueKeys: [String!]!
		$cloudId: ID!
		$includeStatusCategoryId: Boolean!
	) {
		jira {
			issuesByKey(cloudId: $cloudId, keys: $issueKeys) {
				id
				statusField {
					status {
						name
						statusCategory {
							colorName
							statusCategoryId @include(if: $includeStatusCategoryId)
						}
					}
				}
			}
		}
	}
	`;
};


const $4858f1196c57a1ec$var$cache = (0, $hw4j5.inMemoryCache)();
const $4858f1196c57a1ec$export$801183f161baaa36 = (variables)=>{
    const keyObj = {
        issueKeys: variables.issueKeys
    };
    return (0, $2qzBQ.generateHashFromVariables)(keyObj);
};
// Expire the cache if there are errors or results are empty
const $4858f1196c57a1ec$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.jira.issuesByKey.length === 0;
};
const $4858f1196c57a1ec$export$16b4bc84d4d9549f = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $c59e27924968799d$export$42679f7213a051c)();
    // ensure that includeStatusCategoryId is always initialized with a boolean value to create a valid GQL query
    const { includeStatusCategoryId: includeStatusCategoryId = false } = variables;
    const variablesWithFlags = {
        ...variables,
        includeStatusCategoryId: includeStatusCategoryId
    };
    return $4858f1196c57a1ec$var$cache.inMemoryDecorator($4858f1196c57a1ec$export$801183f161baaa36(variables), ()=>(0, $4qT1X.fetchAgg)({
            variables: variablesWithFlags,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: 'SearchPageJiraFieldHydration',
            headers: headers
        }), $4858f1196c57a1ec$var$expireWhen);
};
module.exports["fetchJiraFieldsQuery"] = $4858f1196c57a1ec$export$16b4bc84d4d9549f;

});

parcelRegister("dS0qJ", function(module, exports) {
const $c4d36ce3018afd80$export$3ea53827ed349b2e = (locale)=>{
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return locale.toLowerCase().startsWith('en');
};
module.exports["isEnglishLocale"] = $c4d36ce3018afd80$export$3ea53827ed349b2e;

});

parcelRegister("226KS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46a94e1addf026bfebe08b8e272a8c2a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17b1021e2b775282$var$_react = $17b1021e2b775282$var$_interopRequireDefault((parcelRequire("42omo")));

var $17b1021e2b775282$var$_baseNew = $17b1021e2b775282$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $17b1021e2b775282$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing schema in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $17b1021e2b775282$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $17b1021e2b775282$var$_react.default.createElement($17b1021e2b775282$var$_baseNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.75 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0-8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3 13.5a2 2 0 0 1-2-2V0h1.5v4H8v1.5H2.5v6a.5.5 0 0 0 .5.5h5v1.5zm9.75-4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m0-8a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5"/>`
    }, props));
$17b1021e2b775282$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $17b1021e2b775282$var$_default = module.exports.default = $17b1021e2b775282$var$AssetsSchemaIcon;

});

parcelRegister("cVtio", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $f7lNm = parcelRequire("f7lNm");

const $ca77e5059fb214ed$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return [
        fireAnalyticsEvent
    ];
};
module.exports["useAnalytics"] = $ca77e5059fb214ed$export$e955abb82869dc84;

});

parcelRegister("i25hX", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c5134eb78e10703c$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload'
]);
const $c5134eb78e10703c$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let subIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callback,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const payload = publishQueue[topic];
                callback(payload);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        /**
     * Log that this Topic received a published event, regardless of whether it has subscribers or not.
     * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
     */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$c5134eb78e10703c$var$ignoredTriggerLatestEvents.has(payload.type)) publishQueue[topic] = payload;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(payload));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $c5134eb78e10703c$var$pubSub = $c5134eb78e10703c$var$createPubSub();
const $c5134eb78e10703c$var$usePubSub = ()=>{
    return $c5134eb78e10703c$var$pubSub;
};
const $c5134eb78e10703c$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest }, callback)=>{
    const { subscribe: subscribe } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic
    ]);
};
const $c5134eb78e10703c$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $c5134eb78e10703c$var$usePubSub();
    const callbackRef = (0, $42omo.useRef)(callback);
    callbackRef.current = callback;
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $c5134eb78e10703c$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $c5134eb78e10703c$var$usePubSub();
    (0, $42omo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $c5134eb78e10703c$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $c5134eb78e10703c$var$usePubSub();
    const publishFn = (0, $42omo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $c5134eb78e10703c$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount })=>{
    $c5134eb78e10703c$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest
    }, onEvent);
    $c5134eb78e10703c$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["useSubscribe"] = $c5134eb78e10703c$export$d3d523392640272;
module.exports["useSubscribeAll"] = $c5134eb78e10703c$export$2570c8aa24b6d327;
module.exports["usePublish"] = $c5134eb78e10703c$export$d55c81786220731c;
module.exports["Subscriber"] = $c5134eb78e10703c$export$60959659b2c22881;

});

parcelRegister("2Rith", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("ifW2H", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $62e0541727c97e34$export$4f059feb37b5835e = (0, $42omo.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $62e0541727c97e34$export$4f059feb37b5835e;

});

parcelRegister("8Y3mE", function(module, exports) {

var $ea2ui = parcelRequire("ea2ui");

const $a544c5804dc19870$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $ea2ui.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $a544c5804dc19870$export$5013b36eeed4ec19;

});

parcelRegister("ea2ui", function(module, exports) {
var $5a6bb3bf0e14987c$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $5a6bb3bf0e14987c$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $5a6bb3bf0e14987c$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $5a6bb3bf0e14987c$export$7052d5b66e36f60f;

});

parcelRegister("j4EkW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kTkuM = parcelRequire("kTkuM");


var $a4NM6 = parcelRequire("a4NM6");


var $ea2ui = parcelRequire("ea2ui");

const $a4ec83494ea42b83$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $42omo.useRef)(undefined);
    const aiSessionStateRef = (0, $42omo.useRef)((0, $ea2ui.AISessionState).unset);
    const setAISessionState = (0, $42omo.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $42omo.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $42omo.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $kTkuM.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $a4NM6.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $42omo.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $a4NM6.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $a4ec83494ea42b83$export$259576f4e7ac6488;

});

parcelRegister("kTkuM", function(module, exports) {

var $dWJ5i = parcelRequire("dWJ5i");


var $cUcZ5 = parcelRequire("cUcZ5");

function $9779584a42635fbf$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $dWJ5i.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
}
module.exports["getNewSingleInstrumentationID"] = $9779584a42635fbf$export$cee2a1482be61648;

});

parcelRegister("dWJ5i", function(module, exports) {
const $a273a9fd41301c8f$var$t = Symbol.for("@ts-pattern/matcher"), $a273a9fd41301c8f$var$e = Symbol.for("@ts-pattern/isVariadic"), $a273a9fd41301c8f$var$n = "@ts-pattern/anonymous-select-key", $a273a9fd41301c8f$var$r = (t)=>Boolean(t && "object" == typeof t), $a273a9fd41301c8f$var$i = (e)=>e && !!e[$a273a9fd41301c8f$var$t], $a273a9fd41301c8f$var$o = (n, s, c)=>{
    if ($a273a9fd41301c8f$var$i(n)) {
        const e = n[$a273a9fd41301c8f$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($a273a9fd41301c8f$var$r(n)) {
        if (!$a273a9fd41301c8f$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $a273a9fd41301c8f$var$i(s) && s[$a273a9fd41301c8f$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$a273a9fd41301c8f$var$o(t, e[n], c)) && r.every((t, e)=>$a273a9fd41301c8f$var$o(t, n[e], c)) && (0 === a.length || $a273a9fd41301c8f$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$a273a9fd41301c8f$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $a273a9fd41301c8f$var$i(a = r) && "optional" === a[$a273a9fd41301c8f$var$t]().matcherType) && $a273a9fd41301c8f$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $a273a9fd41301c8f$var$s = (e)=>{
    var n, o, a;
    return $a273a9fd41301c8f$var$r(e) ? $a273a9fd41301c8f$var$i(e) ? null != (n = null == (o = (a = e[$a273a9fd41301c8f$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s) : $a273a9fd41301c8f$var$c(Object.values(e), $a273a9fd41301c8f$var$s) : [];
}, $a273a9fd41301c8f$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $a273a9fd41301c8f$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$a273a9fd41301c8f$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $a273a9fd41301c8f$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $a273a9fd41301c8f$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$a273a9fd41301c8f$var$l(t),
        and: (e)=>$a273a9fd41301c8f$var$m(t, e),
        or: (e)=>$a273a9fd41301c8f$var$d(t, e),
        select: (e)=>void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t)
    });
}
function $a273a9fd41301c8f$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$a273a9fd41301c8f$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$a273a9fd41301c8f$var$h($a273a9fd41301c8f$var$l(t)),
        select: (e)=>$a273a9fd41301c8f$var$h(void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t))
    });
}
function $a273a9fd41301c8f$var$l(e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($a273a9fd41301c8f$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $a273a9fd41301c8f$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$s(e),
                matcherType: "optional"
            })
    });
}
const $a273a9fd41301c8f$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $a273a9fd41301c8f$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $a273a9fd41301c8f$var$m(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "and"
            })
    });
}
function $a273a9fd41301c8f$var$d(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "or"
            })
    });
}
function $a273a9fd41301c8f$var$p(e) {
    return {
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $a273a9fd41301c8f$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $a273a9fd41301c8f$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $a273a9fd41301c8f$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $a273a9fd41301c8f$var$n
                    ].concat(void 0 === i ? [] : $a273a9fd41301c8f$var$s(i))
            })
    });
}
function $a273a9fd41301c8f$var$v(t) {
    return "number" == typeof t;
}
function $a273a9fd41301c8f$var$b(t) {
    return "string" == typeof t;
}
function $a273a9fd41301c8f$var$w(t) {
    return "bigint" == typeof t;
}
const $a273a9fd41301c8f$var$S = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return !0;
})), $a273a9fd41301c8f$var$O = $a273a9fd41301c8f$var$S, $a273a9fd41301c8f$var$j = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length >= t))(e))),
        length: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && Boolean(t.match(n))))));
        }
    }), $a273a9fd41301c8f$var$K = $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$b)), $a273a9fd41301c8f$var$x = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e >= t))(e))),
        int: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t < 0)))
    }), $a273a9fd41301c8f$var$E = $a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$v)), $a273a9fd41301c8f$var$A = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e >= t))(e))),
        positive: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t < 0)))
    }), $a273a9fd41301c8f$var$P = $a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$w)), $a273a9fd41301c8f$var$T = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "boolean" == typeof t;
})), $a273a9fd41301c8f$var$B = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "symbol" == typeof t;
})), $a273a9fd41301c8f$var$_ = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null == t;
})), $a273a9fd41301c8f$var$k = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null != t;
}));
var $a273a9fd41301c8f$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $a273a9fd41301c8f$var$t,
    optional: $a273a9fd41301c8f$var$l,
    array: function(...e) {
        return $a273a9fd41301c8f$var$h({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $a273a9fd41301c8f$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$a273a9fd41301c8f$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $a273a9fd41301c8f$var$f(t, (t)=>$a273a9fd41301c8f$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $a273a9fd41301c8f$var$g(t, (t, e)=>{
                                const n = $a273a9fd41301c8f$var$o(s, e, r), i = $a273a9fd41301c8f$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$a273a9fd41301c8f$var$s(e[0]),
                            ...$a273a9fd41301c8f$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $a273a9fd41301c8f$var$m,
    union: $a273a9fd41301c8f$var$d,
    not: function(e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$a273a9fd41301c8f$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $a273a9fd41301c8f$var$p,
    select: $a273a9fd41301c8f$var$y,
    any: $a273a9fd41301c8f$var$S,
    _: $a273a9fd41301c8f$var$O,
    string: $a273a9fd41301c8f$var$K,
    number: $a273a9fd41301c8f$var$E,
    bigint: $a273a9fd41301c8f$var$P,
    boolean: $a273a9fd41301c8f$var$T,
    symbol: $a273a9fd41301c8f$var$B,
    nullish: $a273a9fd41301c8f$var$_,
    nonNullable: $a273a9fd41301c8f$var$k,
    instanceOf: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p($a273a9fd41301c8f$export$ce1e7a33533a73d9(t)));
    }
};
class $a273a9fd41301c8f$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $a273a9fd41301c8f$var$$ = {
    matched: !1,
    value: void 0
};
function $a273a9fd41301c8f$export$4659b591c19bdf3d(t) {
    return new $a273a9fd41301c8f$var$I(t, $a273a9fd41301c8f$var$$);
}
class $a273a9fd41301c8f$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$a273a9fd41301c8f$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $a273a9fd41301c8f$var$$ : {
            matched: !0,
            value: e(s ? $a273a9fd41301c8f$var$n in c ? c[$a273a9fd41301c8f$var$n] : c : this.input, this.input)
        };
        return new $a273a9fd41301c8f$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $a273a9fd41301c8f$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $a273a9fd41301c8f$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $a273a9fd41301c8f$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $a273a9fd41301c8f$var$L(t) {
    throw new $a273a9fd41301c8f$export$6c1467edb54d3773(t);
}
module.exports["P"] = $a273a9fd41301c8f$export$56c0d5a1e737357d;
module.exports["match"] = $a273a9fd41301c8f$export$4659b591c19bdf3d;

});

parcelRegister("a4NM6", function(module, exports) {

var $hEbxW = parcelRequire("hEbxW");

var $eGd7K = parcelRequire("eGd7K");

const $2674cc9dba61bfc1$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $2674cc9dba61bfc1$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $2674cc9dba61bfc1$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $eGd7K.setCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $2674cc9dba61bfc1$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $hEbxW.getCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $2674cc9dba61bfc1$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$d6fb1caea334c7c7;

});

parcelRegister("fYQcF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dWJ5i = parcelRequire("dWJ5i");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $1M9Av = parcelRequire("1M9Av");


var $ea2ui = parcelRequire("ea2ui");


var $j4EkW = parcelRequire("j4EkW");

const $a22fd04a8888d493$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $42omo.useContext)((0, $ifW2H.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $42omo.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $j4EkW.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $42omo.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $dWJ5i.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $ea2ui.AISessionState).unset,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).viewed, (0, $ea2ui.AISessionState).error, (0, $ea2ui.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $ea2ui.AISessionState).initiated,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).submitted, (0, $ea2ui.AISessionState).actioned, (0, $ea2ui.AISessionState).adopted, (0, $ea2ui.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $42omo.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $3pfAb.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $42omo.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $dWJ5i.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $1M9Av.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $42omo.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $42omo.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $42omo.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    // Each `useCallback` above depends on `createAndMergeEventPayload`, which in
    // turn closes over per-render config values (e.g. `additionalAttributes`
    // passed via `customConfig`). When callers spread fresh literals on every
    // render, those callbacks get fresh identities every render too. Consumers
    // that feed them into their own `useCallback` / `useEffect` deps then suffer
    // spurious re-runs — and combined with functional state updaters, this can
    // drive infinite render loops (see Jira CRCS-4870 / OOM regression).
    //
    // Stabilise the entire return surface behind a feature gate.
    const stableReturn = $a22fd04a8888d493$var$useStableMethods(baseReturn);
    return (0, $dh538.fg)('platform_ai_analytics_stable_handler_refs') ? stableReturn : baseReturn;
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $a22fd04a8888d493$var$useStableMethods(methods) {
    const ref = (0, $42omo.useRef)(methods);
    ref.current = methods;
    return (0, $42omo.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useAIEventsInstrumentation"] = $a22fd04a8888d493$export$ddf49ad062368ad2;

});

parcelRegister("1M9Av", function(module, exports) {
const $699df07a7cf548d4$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $699df07a7cf548d4$export$e053e424fcbfebe9;

});

parcelRegister("2Pg7f", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $esRft = parcelRequire("esRft");


var $4JWgN = parcelRequire("4JWgN");


var $ee7An = parcelRequire("ee7An");


var $loiTn = parcelRequire("loiTn");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $htJyp = parcelRequire("htJyp");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $fj4Q9 = parcelRequire("fj4Q9");


var $7rhez = parcelRequire("7rhez");


var $dBzHN = parcelRequire("dBzHN");


var $crJ46 = parcelRequire("crJ46");


var $6MWy1 = parcelRequire("6MWy1");


var $2cWqt = parcelRequire("2cWqt");


var $2LGbr = parcelRequire("2LGbr");


var $6Ac15 = parcelRequire("6Ac15");


var $1DG7o = parcelRequire("1DG7o");

const $49cfd043cf935c3d$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $49cfd043cf935c3d$var$AvatarGroup = ({ appearance: appearance = 'stack', moreIndicatorAppearance: moreIndicatorAppearance, avatar: avatar = (0, $esRft.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const onClose = (0, $42omo.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $42omo.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    const { AvatarGroupItem: avatarGroupItemOverrides, Avatar: avatarOverrides, MoreIndicator: moreIndicatorOverrides } = (0, $dBzHN.getOverrides)(overrides);
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow.
    // Skipped when top-layer is enabled — DropdownMenu/top-layer handles
    // ArrowDown-to-open and arrow key navigation internally.
    (0, $42omo.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Top-layer path: ArrowDown-to-open is handled by the menu's
        // own focus management, so skip the parent's ArrowDown handler.
        if ((0, $dh538.fg)('platform-dst-top-layer')) return 0, $ee7An.default;
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $ee7An.default;
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $4JWgN.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $4JWgN.KEY_DOWN)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>moreIndicatorOverrides.render((0, $2LGbr.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props,
                ...(0, $dh538.fg)('jira-ai-agent-stack') && {
                    appearance: moreIndicatorAppearance
                }
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        if ((0, $dh538.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $7rhez.MoreDropdownTopLayer), {
            isOpen: isOpen,
            onClose: onClose,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            data: data,
            max: max,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            overrides: overrides,
            onAvatarClick: onAvatarClick,
            testId: testId,
            labelId: labelId,
            renderMoreButton: renderMoreButton,
            handleTriggerClicked: handleTriggerClicked,
            bindFocus: bindFocus
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        const avatarComponent = avatar && (0, $dh538.fg)('platform-avatar-group-pass-avatar-to-item') ? avatar : undefined;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6MWy1.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2cWqt.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                            titleId: labelId,
                            testId: `${testId}--section`,
                            children: data.slice(max).map((avatarData, index)=>avatarGroupItemOverrides.render((0, $fj4Q9.default), {
                                    avatar: avatarData,
                                    avatarComponent: avatarComponent,
                                    onAvatarClick: onAvatarClick,
                                    avatarOverrides: avatarOverrides,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>(0, $dh538.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $htJyp.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: renderMoreButton({
                        ...triggerProps,
                        ...bindFocus,
                        onClick: handleTriggerClicked
                    })
                }) : renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $49cfd043cf935c3d$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const groupId = (0, $c0qxy.useId)();
    return appearance === 'stack' ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $6Ac15.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = avatarOverrides.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                if ((0, $dh538.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $htJyp.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                        content: avatarData.name,
                        testId: testId && `${testId}--tooltip-${idx}`,
                        position: tooltipPosition,
                        children: finalAvatar
                    }) : finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx));
                else return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $crJ46.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = avatarOverrides.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                if ((0, $dh538.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $htJyp.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                        content: avatarData.name,
                        testId: testId && `${testId}--tooltip-${idx}`,
                        position: tooltipPosition,
                        children: finalAvatar
                    }) : finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx));
                else return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    });
};
var $49cfd043cf935c3d$export$2e2bcd8739ae039 = $49cfd043cf935c3d$var$AvatarGroup;
module.exports["default"] = $49cfd043cf935c3d$export$2e2bcd8739ae039;

});

parcelRegister("loiTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $48d42f44838c1016$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $48d42f44838c1016$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $42omo.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $42omo.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("fj4Q9", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");

var $d77M1 = parcelRequire("d77M1");

var $cGtPE = parcelRequire("cGtPE");


var $dh538 = parcelRequire("dh538");


var $atkCk = parcelRequire("atkCk");

const $b02c3981c986946c$var$AvatarGroupItem = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { avatar: avatar, avatarComponent: avatarComponent, index: index, onAvatarClick: onAvatarClick, testId: testId, avatarOverrides: avatarOverrides, role: role } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: _borderColor, children: children, href: href, isDisabled: isDisabled, key: _key, label: label, name: name, onClick: onClick, presence: presence, size: _size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: _groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $atkCk.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            role: role,
            ...props,
            children: children
        });
    };
    const AvatarComponent = (0, $dh538.fg)('platform-avatar-group-pass-avatar-to-item') ? avatarComponent ?? (0, $esRft.default) : (0, $esRft.default);
    const AvatarIcon = avatarOverrides && (0, $dh538.fg)('platform-avatar-group-pass-avatar-to-item') ? avatarOverrides.render(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: 'transparent',
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: '',
        presence: presence,
        size: 'small',
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    }, 0) : /*#__PURE__*/ (0, $l998X.jsx)(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        role: role,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        role: role,
        children: name
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b02c3981c986946c$export$2e2bcd8739ae039 = $b02c3981c986946c$var$AvatarGroupItem;
module.exports["default"] = $b02c3981c986946c$export$2e2bcd8739ae039;

});

parcelRegister("atkCk", function(module, exports) {
// eslint-disable-next-line sort-imports

var $42omo = parcelRequire("42omo");


var $2gBGR = parcelRequire("2gBGR");

// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $f69e73e233725633$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $2gBGR.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $f69e73e233725633$export$2e2bcd8739ae039 = $f69e73e233725633$var$useRegisterItemWithFocusManager;
module.exports["default"] = $f69e73e233725633$export$2e2bcd8739ae039;

});

parcelRegister("2gBGR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $9cda518d56d21a57$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
module.exports["FocusManagerContext"] = $9cda518d56d21a57$export$f18c1d4fc7326096;

});

parcelRegister("7rhez", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $4JWgN = parcelRequire("4JWgN");


var $loiTn = parcelRequire("loiTn");


var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $hFC20 = parcelRequire("hFC20");


var $bgEkj = parcelRequire("bgEkj");


var $1B1St = parcelRequire("1B1St");


var $JW5lP = parcelRequire("JW5lP");


var $fj4Q9 = parcelRequire("fj4Q9");

const $718509c391f9c05e$var$animation = (0, $hFC20.slideAndFade)();
const $718509c391f9c05e$var$topLayerPlacement = (0, $bgEkj.fromLegacyPlacement)({
    legacy: 'bottom-end'
});
function $718509c391f9c05e$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...props
                }, index),
            ...overrides?.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...props
                }, index),
            ...overrides?.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...props
                }),
            ...overrides?.MoreIndicator
        }
    };
}
function $718509c391f9c05e$export$36ea40361987a72d({ isOpen: isOpen, onClose: onClose, isTriggeredUsingKeyboard: _isTriggeredUsingKeyboard, data: data, max: max, overrides: overrides, onAvatarClick: onAvatarClick, testId: testId, labelId: labelId, renderMoreButton: renderMoreButton, handleTriggerClicked: handleTriggerClicked, bindFocus: _bindFocus }) {
    const handleOnClose = (0, $42omo.useCallback)(({ reason: _reason })=>{
        onClose();
    }, [
        onClose
    ]);
    const menuRef = (0, $42omo.useRef)(null);
    const overflowMenuTestId = testId ? `${testId}--overflow-menu` : undefined;
    // Arrow key navigation inside the open menu
    (0, $JW5lP.useArrowNavigation)({
        containerRef: menuRef,
        onClose: onClose,
        isEnabled: isOpen
    });
    // ArrowDown-to-open: when the trigger is focused and the menu is closed,
    // pressing ArrowDown opens the menu (WAI-ARIA menu button pattern).
    // We track focus on the trigger wrapper to avoid threading onFocus/onBlur
    // through the renderMoreButton/MoreIndicator prop plumbing.
    const triggerWrapperRef = (0, $42omo.useRef)(null);
    const { isFocused: isFocused, bindFocus: triggerFocusBind } = (0, $loiTn.default)();
    (0, $42omo.useEffect)(()=>{
        if (!isFocused || isOpen) return;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnArrowDown(e) {
                if (e.key === (0, $4JWgN.KEY_DOWN)) {
                    // Prevent page scroll when opening the menu via ArrowDown.
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1B1St.Popup), {
        placement: $718509c391f9c05e$var$topLayerPlacement,
        onClose: handleOnClose,
        testId: overflowMenuTestId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1B1St.Popup).TriggerFunction, {
                children: ({ ref: ref, ariaAttributes: ariaAttributes })=>// Workaround: wrapping span to track trigger focus for ArrowDown-to-open.
                    //
                    // The `useFocus` hook needs onFocus/onBlur on the trigger element,
                    // but we cannot thread those through the renderMoreButton → MoreIndicator
                    // prop plumbing without changing those APIs (onFocus/onBlur would need
                    // to go into MoreIndicator's `buttonProps`, but renderMoreButton does not
                    // expose that).
                    //
                    // Using `display: contents` so the span does not affect layout — the
                    // button renders as if the span were not there. Focus events from the
                    // button bubble up to this span, allowing useFocus to track state.
                    //
                    // If MoreIndicator's API is refactored to accept focus handlers via
                    // buttonProps, this wrapper can be removed.
                    /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        ref: triggerWrapperRef,
                        onFocus: triggerFocusBind.onFocus,
                        onBlur: triggerFocusBind.onBlur,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- display: contents is a layout-neutral wrapper; it cannot affect visual output.
                        style: {
                            display: 'contents'
                        },
                        children: renderMoreButton({
                            ref: ref,
                            'aria-controls': isOpen ? ariaAttributes['aria-controls'] : undefined,
                            'aria-expanded': isOpen,
                            'aria-haspopup': true,
                            onClick: handleTriggerClicked
                        })
                    })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1B1St.Popup).Content, {
                role: "menu",
                label: "avatar group",
                isOpen: isOpen,
                animate: $718509c391f9c05e$var$animation,
                testId: overflowMenuTestId ? `${overflowMenuTestId}--content` : undefined,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1B1St.Popup).Surface, {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        ref: menuRef,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
                            minWidth: 250,
                            maxHeight: 300,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                                titleId: labelId,
                                testId: testId ? `${testId}--section` : undefined,
                                children: data.slice(max).map((avatar, index)=>$718509c391f9c05e$var$getOverrides(overrides).AvatarGroupItem.render((0, $fj4Q9.default), {
                                        avatar: avatar,
                                        onAvatarClick: onAvatarClick,
                                        testId: testId ? `${testId}--avatar-group-item-${index + max}` : undefined,
                                        index: index + max,
                                        role: 'menuitem'
                                    }, index + max))
                            })
                        })
                    })
                })
            })
        ]
    });
}
module.exports["MoreDropdownTopLayer"] = $718509c391f9c05e$export$36ea40361987a72d;

});

parcelRegister("JW5lP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $hTKp4 = parcelRequire("hTKp4");


var $4JWgN = parcelRequire("4JWgN");


var $dOnbq = parcelRequire("dOnbq");

const $fe7e868f8d553302$var$menuScope = '[role="menu"]';
function $fe7e868f8d553302$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($fe7e868f8d553302$var$menuScope);
    // Container itself has role="menu" — element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there's no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it's "owned" by this
    // container without passing through another role="menu" first.
    let parent = closestMenu.parentElement;
    while(parent && parent !== container){
        if (parent.getAttribute('role') === 'menu') // There's a parent menu between the closest menu and the
        // container — the element is in a nested sub-menu.
        return false;
        parent = parent.parentElement;
    }
    // The closest menu is directly inside the container (no nesting).
    return parent === container;
}
function $fe7e868f8d553302$export$23dfbae28e0cc453({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        const focused = (0, $hTKp4.getDocument)()?.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($fe7e868f8d553302$var$menuScope) !== container) return;
        }
        if (event.key === (0, $4JWgN.KEY_DOWN)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $dOnbq.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4JWgN.KEY_UP)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $dOnbq.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4JWgN.KEY_HOME)) {
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (0, $dOnbq.getFirstFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4JWgN.KEY_END)) {
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (0, $dOnbq.getLastFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4JWgN.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                // Only close if this container is inside another role="menu"
                // (i.e. it's a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                const isNested = container.parentElement?.closest($fe7e868f8d553302$var$menuScope) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $42omo.useEffect)(()=>{
        const container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $fFa3V.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}
module.exports["isAtCurrentMenuLevel"] = $fe7e868f8d553302$export$f1bba0ef464d60af;
module.exports["useArrowNavigation"] = $fe7e868f8d553302$export$23dfbae28e0cc453;

});

parcelRegister("dBzHN", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1DG7o = parcelRequire("1DG7o");

function $c815a93d07d97aec$export$f525cc57d37ca574(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $42omo.createElement)(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>//@ts-ignore - TS2604/TS2786: Component type union causing issues for help-center local consumption with TS 5.9.2
                /*#__PURE__*/ (0, $42omo.createElement)(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
module.exports["getOverrides"] = $c815a93d07d97aec$export$f525cc57d37ca574;

});

parcelRegister("1DG7o", function(module, exports) {
const $e8b8a534df2444a6$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};
module.exports["composeUniqueKey"] = $e8b8a534df2444a6$export$b067756944994c79;

});

parcelRegister("crJ46", function(module, exports) {
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $g9Srd = parcelRequire("g9Srd");


var $dh538 = parcelRequire("dh538");

const $97f44b6287529f93$var$gutter = "var(--ds-space-negative-050, -4px)";
const $97f44b6287529f93$var$listStyles = null;
const $97f44b6287529f93$var$listStylesFlagged = null;
const $97f44b6287529f93$var$listItemStyles = null;
const $97f44b6287529f93$var$Grid = ({ id: id, children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_6rth1b66 _y4tiv77o _bozgv77o"
        ]),
        children: (0, $dh538.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
            exitThenEnter: true,
            children: (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                    className: (0, $gMc0m.default)([
                        "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                    ]),
                    children: child
                }))
        }) : (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                className: (0, $gMc0m.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $97f44b6287529f93$export$2e2bcd8739ae039 = $97f44b6287529f93$var$Grid;
module.exports["default"] = $97f44b6287529f93$export$2e2bcd8739ae039;

});

parcelRegister("6MWy1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $1ztii = parcelRequire("1ztii");


var $2gBGR = parcelRequire("2gBGR");

// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Focus manager__
 *
 * A focus manager {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $5d9c84f5f87b7a1d$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $42omo.useEffect)(()=>{
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $1ztii.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: (0, $1ztii.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2gBGR.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $5d9c84f5f87b7a1d$export$2e2bcd8739ae039 = $5d9c84f5f87b7a1d$var$FocusManager;
module.exports["default"] = $5d9c84f5f87b7a1d$export$2e2bcd8739ae039;

});

parcelRegister("1ztii", function(module, exports) {
$parcel$export(module.exports, "default", () => $15cbf707a7ad85d1$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");

const $15cbf707a7ad85d1$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
    return;
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
    return;
};
function $15cbf707a7ad85d1$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $15cbf707a7ad85d1$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("2cWqt", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $2gBGR = parcelRequire("2gBGR");

/**
 * It sets focus to the first avatar when popup is open.
 */ const $fd056483eb698f52$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $2gBGR.FocusManagerContext));
    (0, $42omo.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $fd056483eb698f52$export$2e2bcd8739ae039 = $fd056483eb698f52$var$PopupAvatarGroup;
module.exports["default"] = $fd056483eb698f52$export$2e2bcd8739ae039;

});

parcelRegister("2LGbr", function(module, exports) {
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $965bb25f1302cdca$var$boxShadowCssVar = '--avatar-box-shadow';
const $965bb25f1302cdca$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh1ntv _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhki8nm _syazi7uo _16qs1nhn _t9ec1aqe _1ejjglyw _mizu1v1w _ra3xnqa1 _1ah3yh40 _128myh40 _irr3plhp _30l3i7uo _1di61gdz _9h8hi7uo _jlxit94y",
    circle: "_2rko1qll",
    activeScale: "_1q8w1np6",
    active: "_bfhk15s3 _16qsdfwd _syaz6x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    activeStateScale: "_t9ec1np6",
    disabled: "_80om13gf _1peq2wxo _1hfkvuon",
    hexagon: "_mkrz1k6g"
};
const $965bb25f1302cdca$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $965bb25f1302cdca$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rkofajl _14mjfajl",
    large: "_2rkofajl _14mjfajl",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
const $965bb25f1302cdca$var$fontMap = {
    small: "_11c8wadc",
    medium: "_11c8wadc",
    large: "_11c8wadc",
    xlarge: "_11c81d4k",
    xxlarge: "_11c81d4k"
};
const $965bb25f1302cdca$var$MAX_DISPLAY_COUNT = 99;
const $965bb25f1302cdca$var$MoreIndicator = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = "var(--ds-surface, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $965bb25f1302cdca$var$MAX_DISPLAY_COUNT ? $965bb25f1302cdca$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ (0, $l998X.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$965bb25f1302cdca$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $gMc0m.default)([
            $965bb25f1302cdca$var$styles.root,
            !(0, $dh538.fg)('remove_scaling_from_avatar_stack') && $965bb25f1302cdca$var$styles.activeScale,
            $965bb25f1302cdca$var$borderRadiusMap[size],
            appearance === 'circle' && $965bb25f1302cdca$var$styles.circle,
            appearance === 'hexagon' && (0, $dh538.fg)('jira-ai-agent-stack') && $965bb25f1302cdca$var$styles.hexagon,
            $965bb25f1302cdca$var$widthHeightMap[size],
            $965bb25f1302cdca$var$fontMap[size],
            isActive && $965bb25f1302cdca$var$styles.active,
            isActive && !(0, $dh538.fg)('remove_scaling_from_avatar_stack') && $965bb25f1302cdca$var$styles.activeStateScale
        ]),
        children: [
            "+",
            displayCount
        ]
    });
});
$965bb25f1302cdca$var$MoreIndicator.displayName = 'MoreIndicator'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $965bb25f1302cdca$export$2e2bcd8739ae039 = $965bb25f1302cdca$var$MoreIndicator;
module.exports["default"] = $965bb25f1302cdca$export$2e2bcd8739ae039;

});

parcelRegister("6Ac15", function(module, exports) {
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $g9Srd = parcelRequire("g9Srd");


var $dh538 = parcelRequire("dh538");

const $7b5befcdc2ab883e$var$listStyles = null;
const $7b5befcdc2ab883e$var$listSmallStyles = null;
const $7b5befcdc2ab883e$var$listItemStyles = null;
const $7b5befcdc2ab883e$var$listItemSmallStyles = null;
const $7b5befcdc2ab883e$var$Stack = ({ id: id, children: children, testId: testId, 'aria-label': label, size: size })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l21b66"
        ]),
        children: (0, $dh538.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
            exitThenEnter: true,
            children: (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                    className: (0, $gMc0m.default)([
                        "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                        size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
                    ]),
                    children: child
                }))
        }) : (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                className: (0, $gMc0m.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                    size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
                ]),
                children: child
            }))
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $7b5befcdc2ab883e$export$2e2bcd8739ae039 = $7b5befcdc2ab883e$var$Stack;
module.exports["default"] = $7b5befcdc2ab883e$export$2e2bcd8739ae039;

});

parcelRegister("7642E", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $XOZYy = parcelRequire("XOZYy");


const $52ac3a8ba658d4f5$var$_inlined0 = (()=>{
    const module1 = {
        exports: {}
    };
    const exports = module1.exports;
    (function() {
        /**
 * Shim for the removed @atlaskit/icon default export (legacy Icon base component).
 *
 * This provides a lightweight replacement for the legacy Icon component that
 * was removed in DSP-24550. Instead of wrapping the glyph in a span with
 * complex styling, it simply renders the glyph component directly, passing
 * through relevant props.
 *
 * This is NOT a public API — it exists solely to unblock the removal of
 * deprecated icon APIs from @atlaskit/icon.
 */ const React = (parcelRequire("42omo"));
        function Icon(props) {
            const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor, testId: testId, label: label } = props;
            if (Glyph) return React.createElement(Glyph, {
                role: label ? 'img' : 'presentation',
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                fill: primaryColor || 'currentColor'
            });
            if (dangerouslySetGlyph) return React.createElement('span', {
                dangerouslySetInnerHTML: {
                    __html: dangerouslySetGlyph
                },
                role: label ? 'img' : undefined,
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                style: {
                    display: 'inline-block',
                    lineHeight: 1,
                    color: primaryColor || 'currentColor'
                }
            });
            return null;
        }
        Icon.displayName = 'Icon';
        module1.exports = Icon;
    })();
    return module1.exports;
})();
module.exports = Object.assign({}, $XOZYy, {
    default: $52ac3a8ba658d4f5$var$_inlined0
});
if ($XOZYy.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("9M4aB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0eee459540e5ec28215a3b80df0172>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71dbd4ce92c1377b$var$_react = $71dbd4ce92c1377b$var$_interopRequireDefault((parcelRequire("42omo")));

var $71dbd4ce92c1377b$var$_baseNew = $71dbd4ce92c1377b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $71dbd4ce92c1377b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $71dbd4ce92c1377b$var$ShareIcon = (props)=>/*#__PURE__*/ $71dbd4ce92c1377b$var$_react.default.createElement($71dbd4ce92c1377b$var$_baseNew.default, Object.assign({
        name: "ShareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$71dbd4ce92c1377b$var$ShareIcon.displayName = 'ShareIcon';
var $71dbd4ce92c1377b$var$_default = module.exports.default = $71dbd4ce92c1377b$var$ShareIcon;

});

parcelRegister("9NPDv", function(module, exports) {
function $289674a27c9becd8$export$f2f9c8e083d34d6b(permissionLevel // TODO QS-6952 typing here is not great
) {
    if (!permissionLevel) return false;
    return permissionLevel === 'restricted' || permissionLevel === 'private';
}
module.exports["isNonPublic"] = $289674a27c9becd8$export$f2f9c8e083d34d6b;

});

parcelRegister("e6pbP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4452a63831cbd09$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $a4452a63831cbd09$var$t() {
    return $a4452a63831cbd09$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $a4452a63831cbd09$var$t.apply(this, arguments);
}
const $a4452a63831cbd09$var$n = [
    "children",
    "options"
], $a4452a63831cbd09$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $a4452a63831cbd09$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($a4452a63831cbd09$var$i || ($a4452a63831cbd09$var$i = {}));
const $a4452a63831cbd09$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    for: "htmlFor"
}), $a4452a63831cbd09$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $a4452a63831cbd09$var$o = [
    "style",
    "script"
], $a4452a63831cbd09$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $a4452a63831cbd09$var$s = /mailto:/i, $a4452a63831cbd09$var$d = /\n{2,}$/, $a4452a63831cbd09$var$u = /^(\s*>[\s\S]*?)(?=\n{2,})/, $a4452a63831cbd09$var$p = /^ *> ?/gm, $a4452a63831cbd09$var$f = /^ {2,}\n/, $a4452a63831cbd09$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $a4452a63831cbd09$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $a4452a63831cbd09$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $a4452a63831cbd09$var$k = /^(?:\n *)*\n/, $a4452a63831cbd09$var$x = /\r\n?/g, $a4452a63831cbd09$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $a4452a63831cbd09$var$v = /^\[\^([^\]]+)]/, $a4452a63831cbd09$var$S = /\f/g, $a4452a63831cbd09$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $a4452a63831cbd09$var$$ = /^\s*?\[(x|\s)\]/, $a4452a63831cbd09$var$w = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$C = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $a4452a63831cbd09$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $a4452a63831cbd09$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $a4452a63831cbd09$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $a4452a63831cbd09$var$T = /^<!--[\s\S]*?(?:-->)/, $a4452a63831cbd09$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $a4452a63831cbd09$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $a4452a63831cbd09$var$M = /^\{.*\}$/, $a4452a63831cbd09$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $a4452a63831cbd09$var$I = /^<([^ >]+@[^ >]+)>/, $a4452a63831cbd09$var$U = /^<([^ >]+:\/[^ >]+)>/, $a4452a63831cbd09$var$D = /-([a-z])?/gi, $a4452a63831cbd09$var$j = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $a4452a63831cbd09$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $a4452a63831cbd09$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $a4452a63831cbd09$var$P = /(\[|\])/g, $a4452a63831cbd09$var$_ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $a4452a63831cbd09$var$W = /\t/g, $a4452a63831cbd09$var$G = /(^ *\||\| *$)/g, $a4452a63831cbd09$var$Z = /^ *:-+: *$/, $a4452a63831cbd09$var$q = /^ *:-+ *$/, $a4452a63831cbd09$var$Q = /^ *-+: *$/, $a4452a63831cbd09$var$V = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $a4452a63831cbd09$var$X = new RegExp(`^([*_])\\1${$a4452a63831cbd09$var$V}\\1\\1(?!\\1)`), $a4452a63831cbd09$var$J = new RegExp(`^([*_])${$a4452a63831cbd09$var$V}\\1(?!\\1|\\w)`), $a4452a63831cbd09$var$K = new RegExp(`^==${$a4452a63831cbd09$var$V}==`), $a4452a63831cbd09$var$Y = new RegExp(`^~~${$a4452a63831cbd09$var$V}~~`), $a4452a63831cbd09$var$ee = /^\\([^0-9A-Za-z\s])/, $a4452a63831cbd09$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $a4452a63831cbd09$var$ne = /^\n+/, $a4452a63831cbd09$var$re = /^([ \t]*)/, $a4452a63831cbd09$var$ie = /\\([^\\])/g, $a4452a63831cbd09$var$le = / *\n+$/, $a4452a63831cbd09$var$ae = /(?:^|\n)( *)$/, $a4452a63831cbd09$var$oe = "(?:\\d+\\.)", $a4452a63831cbd09$var$ce = "(?:[*+-])";
function $a4452a63831cbd09$var$se(e) {
    return "( *)(" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + ") +";
}
const $a4452a63831cbd09$var$de = $a4452a63831cbd09$var$se(1), $a4452a63831cbd09$var$ue = $a4452a63831cbd09$var$se(2);
function $a4452a63831cbd09$var$pe(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue));
}
const $a4452a63831cbd09$var$fe = $a4452a63831cbd09$var$pe(1), $a4452a63831cbd09$var$he = $a4452a63831cbd09$var$pe(2);
function $a4452a63831cbd09$var$me(e) {
    return new RegExp("^" + (1 === e ? $a4452a63831cbd09$var$de : $a4452a63831cbd09$var$ue) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $a4452a63831cbd09$var$ge = $a4452a63831cbd09$var$me(1), $a4452a63831cbd09$var$ye = $a4452a63831cbd09$var$me(2);
function $a4452a63831cbd09$var$ke(e) {
    const t = 1 === e ? $a4452a63831cbd09$var$oe : $a4452a63831cbd09$var$ce;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $a4452a63831cbd09$var$xe = $a4452a63831cbd09$var$ke(1), $a4452a63831cbd09$var$be = $a4452a63831cbd09$var$ke(2);
function $a4452a63831cbd09$var$ve(e, t) {
    const n = 1 === t, i = n ? $a4452a63831cbd09$var$xe : $a4452a63831cbd09$var$be, l = n ? $a4452a63831cbd09$var$ge : $a4452a63831cbd09$var$ye, a = n ? $a4452a63831cbd09$var$fe : $a4452a63831cbd09$var$he;
    return {
        match (e, t, n) {
            const r = $a4452a63831cbd09$var$ae.exec(n);
            return r && (t.list || !t.inline && !t.simple) ? i.exec(e = r[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($a4452a63831cbd09$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, u = -1 !== s.indexOf("\n\n") || d && c;
                    c = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($a4452a63831cbd09$var$le, "\n\n")) : (r.inline = !0, h = s.replace($a4452a63831cbd09$var$le, ""));
                    const m = t(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $a4452a63831cbd09$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $a4452a63831cbd09$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $a4452a63831cbd09$var$Ee = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $a4452a63831cbd09$var$$e = [
    $a4452a63831cbd09$var$u,
    $a4452a63831cbd09$var$m,
    $a4452a63831cbd09$var$g,
    $a4452a63831cbd09$var$w,
    $a4452a63831cbd09$var$z,
    $a4452a63831cbd09$var$C,
    $a4452a63831cbd09$var$T,
    $a4452a63831cbd09$var$j,
    $a4452a63831cbd09$var$ge,
    $a4452a63831cbd09$var$xe,
    $a4452a63831cbd09$var$ye,
    $a4452a63831cbd09$var$be
], $a4452a63831cbd09$var$we = [
    ...$a4452a63831cbd09$var$$e,
    /^[^\n]+(?:  \n|\n{2,})/,
    $a4452a63831cbd09$var$L,
    $a4452a63831cbd09$var$B
];
function $a4452a63831cbd09$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $a4452a63831cbd09$var$ze(e) {
    return $a4452a63831cbd09$var$Q.test(e) ? "right" : $a4452a63831cbd09$var$Z.test(e) ? "center" : $a4452a63831cbd09$var$q.test(e) ? "left" : null;
}
function $a4452a63831cbd09$var$Le(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $a4452a63831cbd09$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $a4452a63831cbd09$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $a4452a63831cbd09$var$Ae(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($a4452a63831cbd09$var$G, "").split("|").map($a4452a63831cbd09$var$ze) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $a4452a63831cbd09$var$Le(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $a4452a63831cbd09$var$Le(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $a4452a63831cbd09$export$e0aa44767d8750d5.paragraph
    };
}
function $a4452a63831cbd09$var$Te(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $a4452a63831cbd09$var$Oe(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $a4452a63831cbd09$var$Me(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $a4452a63831cbd09$var$Re(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $a4452a63831cbd09$var$Ie(e, t, n) {
    if (t.inline || t.simple) return null;
    if (n && !n.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$a4452a63831cbd09$var$$e.some((t)=>t.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $a4452a63831cbd09$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $a4452a63831cbd09$var$De(e) {
    return e.replace($a4452a63831cbd09$var$ie, "$1");
}
function $a4452a63831cbd09$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$Ne(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $a4452a63831cbd09$var$He(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $a4452a63831cbd09$var$Fe = (e, t, n)=>({
        children: $a4452a63831cbd09$var$je(t, e[1], n)
    });
function $a4452a63831cbd09$var$Pe() {
    return {};
}
function $a4452a63831cbd09$var$_e() {
    return null;
}
function $a4452a63831cbd09$var$We(...e) {
    return e.filter(Boolean).join(" ");
}
function $a4452a63831cbd09$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $a4452a63831cbd09$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $a4452a63831cbd09$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $a4452a63831cbd09$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $a4452a63831cbd09$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $a4452a63831cbd09$var$t({}, n, l, {
            className: $a4452a63831cbd09$var$We(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($a4452a63831cbd09$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $a4452a63831cbd09$var$_.test(t));
        const r = le(ie(n ? t : `${t.trimEnd().replace($a4452a63831cbd09$var$ne, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $42omo.createElement(l, {
            key: "outer"
        }, a);
    }
    function Z(t, n) {
        const r = n.match($a4452a63831cbd09$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($a4452a63831cbd09$var$O) && (e = e.replace($a4452a63831cbd09$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $a4452a63831cbd09$var$l[c] || c, u = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($a4452a63831cbd09$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof u && ($a4452a63831cbd09$var$L.test(u) || $a4452a63831cbd09$var$B.test(u)) && (n[d] = $42omo.cloneElement(G(u.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$a4452a63831cbd09$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $a4452a63831cbd09$export$3e2338ea76b578c9, i.slugify = i.slugify || $a4452a63831cbd09$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $a4452a63831cbd09$var$t({}, $a4452a63831cbd09$var$a, i.namedCodesToUnicode) : $a4452a63831cbd09$var$a, i.createElement = i.createElement || $42omo.createElement;
    const q = [], Q = {}, V = {
        [$a4452a63831cbd09$export$e0aa44767d8750d5.blockQuote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$u),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($a4452a63831cbd09$var$p, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakLine]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$f),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.breakThematic]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$h),
            order: 1,
            parse: $a4452a63831cbd09$var$Pe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $a4452a63831cbd09$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeFenced]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: Z("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.codeInline]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnote]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$b),
            order: 0,
            parse: (e)=>(q.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.footnoteReference]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $a4452a63831cbd09$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.gfmTask]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$$),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.heading]: {
            match: $a4452a63831cbd09$var$Me(i.enforceAtxHeadings ? $a4452a63831cbd09$var$C : $a4452a63831cbd09$var$w),
            order: 1,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[2], n),
                    id: i.slugify(e[2], $a4452a63831cbd09$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.headingSetext]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$je(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.heading
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($a4452a63831cbd09$var$re), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $a4452a63831cbd09$var$we.some((e)=>e.test(c)) ? $a4452a63831cbd09$var$He : $a4452a63831cbd09$var$je);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $a4452a63831cbd09$var$o.indexOf(s), u = (d ? s : e[1]).trim(), p = {
                    attrs: Z(u, e[2]),
                    noInnerParse: d,
                    tag: u
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? p.text = e[3] : p.children = a(t, l, n), n.inAnchor = !1, p;
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({
                    key: r.key
                }, e.attrs), e.text || n(e.children, r))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: Z(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $a4452a63831cbd09$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.htmlComment]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$T),
            order: 1,
            parse: ()=>({}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.image]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Ee),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.link]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$Se),
            order: 3,
            parse: (e, t, n)=>({
                    children: $a4452a63831cbd09$var$Ne(t, e[1], n),
                    target: $a4452a63831cbd09$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor ? null : $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $a4452a63831cbd09$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.link
                };
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.orderedList]: $a4452a63831cbd09$var$ve(d, 1),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.unorderedList]: $a4452a63831cbd09$var$ve(d, 2),
        [$a4452a63831cbd09$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$k),
            order: 3,
            parse: $a4452a63831cbd09$var$Pe,
            render: ()=>"\n"
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.paragraph]: {
            match: $a4452a63831cbd09$var$Ie,
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.ref]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$N),
            order: 0,
            parse: (e)=>(Q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $a4452a63831cbd09$var$_e
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refImage]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(Q[e.ref].target, "img", "src"),
                    title: Q[e.ref].title
                }) : null
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.refLink]: {
            match: $a4452a63831cbd09$var$Oe($a4452a63831cbd09$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: t(e[0].replace($a4452a63831cbd09$var$P, "\\$1"), n),
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(Q[e.ref].target, "a", "href"),
                    title: Q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, t(e.fallbackChildren, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.table]: {
            match: $a4452a63831cbd09$var$Me($a4452a63831cbd09$var$j),
            order: 1,
            parse: $a4452a63831cbd09$var$Ae,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $a4452a63831cbd09$var$Te(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $a4452a63831cbd09$var$Te(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.text]: {
            match: $a4452a63831cbd09$var$Re($a4452a63831cbd09$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($a4452a63831cbd09$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textBolded]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$X),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEmphasized]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$J),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textEscaped]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$ee),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $a4452a63831cbd09$export$e0aa44767d8750d5.text
                })
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textMarked]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$K),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$a4452a63831cbd09$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $a4452a63831cbd09$var$Be($a4452a63831cbd09$var$Y),
            order: 3,
            parse: $a4452a63831cbd09$var$Fe,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlBlock], delete V[$a4452a63831cbd09$export$e0aa44767d8750d5.htmlSelfClosing]);
    const ie = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [], a = "";
            for(; r;){
                let o = 0;
                for(; o < t.length;){
                    const c = t[o], s = e[c], d = s.match(r, i, a);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const t = s.parse(d, n, i);
                        null == t.type && (t.type = c), l.push(t), a = e;
                        break;
                    }
                    o++;
                }
            }
            return l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($a4452a63831cbd09$var$x, "\n").replace($a4452a63831cbd09$var$S, "").replace($a4452a63831cbd09$var$W, "    ");
            }(e), t);
        };
    }(V), le = (ae = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(V, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return ae(t, e, n);
    });
    var ae;
    const oe = G(n);
    return q.length ? d("div", null, oe, d("footer", {
        key: "footer"
    }, q.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $a4452a63831cbd09$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, le(ie(e.footnote, {
            inline: !0
        })));
    }))) : oe;
}
var $a4452a63831cbd09$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $a4452a63831cbd09$var$n);
    return $42omo.cloneElement($a4452a63831cbd09$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("3euKc", function(module, exports) {
const $818cc046e194381e$export$c32a8291d21fb086 = (thumbnailUrl)=>{
    // Parse the URL
    try {
        const urlObj = new URL(thumbnailUrl);
        const params = urlObj.searchParams;
        // Extract the required parameters
        const amzExpires = params.get('X-Amz-Expires');
        const amzDate = params.get('X-Amz-Date');
        // if we lose the format, we should not attempt to render the thumbnail
        if (!amzExpires || !amzDate) return true;
        // Convert X-Amz-Date to a Date object
        const amzDateObj = new Date(parseInt(amzDate.substring(0, 4)), // Year
        parseInt(amzDate.substring(4, 6)) - 1, // Month (0-based index)
        parseInt(amzDate.substring(6, 8)), // Day
        parseInt(amzDate.substring(9, 11)), // Hour
        parseInt(amzDate.substring(11, 13)), // Minute
        parseInt(amzDate.substring(13, 15))) // Second
        ;
        // Calculate the expiration time in milliseconds
        const expirationTime = amzDateObj.getTime() + parseInt(amzExpires) * 1000;
        // Get the current time in milliseconds
        const currentTime = Date.now();
        // Determine if the current time is greater than the expiration time
        return currentTime > expirationTime;
    } catch  {
        // If the URL is invalid, we cannot determine expiration
        // TODO QS-6952 log exception for invalid URLs
        return true;
    }
};
module.exports["isAWSThumbnailUrlExpired"] = $818cc046e194381e$export$c32a8291d21fb086;

});

parcelRegister("eEJlK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28489413fc4445a7626c716baa7dc401>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aab7faa6feacec73$var$_react = $aab7faa6feacec73$var$_interopRequireDefault((parcelRequire("42omo")));

var $aab7faa6feacec73$var$_baseNew = $aab7faa6feacec73$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $aab7faa6feacec73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ReplyLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: replying to a message thread
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aab7faa6feacec73$var$ReplyLeftIcon = (props)=>/*#__PURE__*/ $aab7faa6feacec73$var$_react.default.createElement($aab7faa6feacec73$var$_baseNew.default, Object.assign({
        name: "ReplyLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.78 2.28 2.56 5.498H7.5a8.5 8.5 0 0 1 8.5 8.5h-1.5a7 7 0 0 0-7-7H2.56l3.22 3.22-1.06 1.06-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5z"/>`
    }, props));
$aab7faa6feacec73$var$ReplyLeftIcon.displayName = 'ReplyLeftIcon';
var $aab7faa6feacec73$var$_default = module.exports.default = $aab7faa6feacec73$var$ReplyLeftIcon;

});

parcelRegister("e3TOY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5ae331244e5ce5f0d911605ea315070>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3cca56e09704fd9$var$_react = $a3cca56e09704fd9$var$_interopRequireDefault((parcelRequire("42omo")));

var $a3cca56e09704fd9$var$_baseNew = $a3cca56e09704fd9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a3cca56e09704fd9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Audio".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/core/audio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3cca56e09704fd9$var$AudioIcon = (props)=>/*#__PURE__*/ $a3cca56e09704fd9$var$_react.default.createElement($a3cca56e09704fd9$var$_baseNew.default, Object.assign({
        name: "AudioIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.746 1.188A.75.75 0 0 1 15 1.75V11a3 3 0 1 1-3-3h1.5V5.85L7 6.662V12a3 3 0 1 1-3-3h1.5V2.75a.75.75 0 0 1 .657-.744l8-1a.75.75 0 0 1 .59.182M5.5 10.5H4A1.5 1.5 0 1 0 5.5 12zM7 5.15l6.5-.812V2.6L7 3.412zm6.5 4.35H12a1.5 1.5 0 1 0 1.5 1.5z" clip-rule="evenodd"/>`
    }, props));
$a3cca56e09704fd9$var$AudioIcon.displayName = 'AudioIcon';
var $a3cca56e09704fd9$var$_default = module.exports.default = $a3cca56e09704fd9$var$AudioIcon;

});

parcelRegister("lJWuA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0b019b9a1703ba836e9431143f4089a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd3b2c4d733eb3d1$var$_react = $fd3b2c4d733eb3d1$var$_interopRequireDefault((parcelRequire("42omo")));

var $fd3b2c4d733eb3d1$var$_baseNew = $fd3b2c4d733eb3d1$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fd3b2c4d733eb3d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd3b2c4d733eb3d1$var$RepeatIcon = (props)=>/*#__PURE__*/ $fd3b2c4d733eb3d1$var$_react.default.createElement($fd3b2c4d733eb3d1$var$_baseNew.default, Object.assign({
        name: "RepeatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$fd3b2c4d733eb3d1$var$RepeatIcon.displayName = 'RepeatIcon';
var $fd3b2c4d733eb3d1$var$_default = module.exports.default = $fd3b2c4d733eb3d1$var$RepeatIcon;

});

parcelRegister("2BDjU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9ff1b999d67869c$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lFkSe = parcelRequire("lFkSe");


var $ncxs7 = parcelRequire("ncxs7");


var $9Phth = parcelRequire("9Phth");

const $b9ff1b999d67869c$export$ba912c88d6fa0f00 = ({ status: status, health: health, customColor: customColor, spacing: spacing, testId: testId, label: label })=>{
    const color = status === 'on_track' || status === 'at_risk' || status === 'off_track' ? (0, $ncxs7.getFocusAreaIconColor)({
        customColor: customColor,
        status: (0, $9Phth.FOCUS_AREA_STATUS_KEYS).IN_PROGRESS,
        health: status
    }) : (0, $ncxs7.getFocusAreaIconColor)({
        customColor: customColor,
        status: status,
        health: health
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
        color: color,
        spacing: spacing || 'none',
        label: label || '',
        testId: testId
    });
};
function $b9ff1b999d67869c$export$2e2bcd8739ae039({ status: status, health: health, customColor: customColor, spacing: spacing, testId: testId, label: label }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
        color: (0, $ncxs7.getFocusAreaIconColor)({
            customColor: customColor,
            status: status,
            health: health
        }),
        spacing: spacing || 'none',
        label: label || '',
        testId: testId
    });
}

});

parcelRegister("lFkSe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76102cae83ff84364fe0f8b9a98fb276>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc5d9e69cae7ca27$var$_react = $fc5d9e69cae7ca27$var$_interopRequireDefault((parcelRequire("42omo")));

var $fc5d9e69cae7ca27$var$_baseNew = $fc5d9e69cae7ca27$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fc5d9e69cae7ca27$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FocusArea".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Focus Areas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc5d9e69cae7ca27$var$FocusAreaIcon = (props)=>/*#__PURE__*/ $fc5d9e69cae7ca27$var$_react.default.createElement($fc5d9e69cae7ca27$var$_baseNew.default, Object.assign({
        name: "FocusAreaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13v-3h1.5v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2m12.5 0v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5M9.75 8a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0M1 3a2 2 0 0 1 2-2h3v1.5H3a.5.5 0 0 0-.5.5v3H1zm12.5 0a.5.5 0 0 0-.5-.5h-3V1h3a2 2 0 0 1 2 2v3h-1.5zm-2.25 5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0"/>`
    }, props));
$fc5d9e69cae7ca27$var$FocusAreaIcon.displayName = 'FocusAreaIcon';
var $fc5d9e69cae7ca27$var$_default = module.exports.default = $fc5d9e69cae7ca27$var$FocusAreaIcon;

});

parcelRegister("ncxs7", function(module, exports) {

var $9Phth = parcelRequire("9Phth");

const $dec905367716080f$export$4ee6399ea9bdb374 = ({ customColor: customColor, status: status, health: health })=>customColor || (0, $9Phth.FOCUS_AREA_DERIVED_STATUS_KEY_TO_COLOR_MAP)[$dec905367716080f$export$dc241ab7a519fd3f({
        status: status,
        health: health
    }).derivedStatusKey];
const $dec905367716080f$export$dc241ab7a519fd3f = ({ status: status, health: health })=>{
    const statusKey = $dec905367716080f$var$getValidStatus(status);
    const healthKey = $dec905367716080f$var$getValidHealth(health);
    const derivedStatusKey = statusKey === (0, $9Phth.FOCUS_AREA_STATUS_KEYS).IN_PROGRESS && healthKey ? healthKey : statusKey;
    return {
        derivedStatusKey: derivedStatusKey,
        derivedStatusLabel: (0, $9Phth.FOCUS_AREA_DERIVED_STATUS_KEY_TO_LABEL_MAP)[derivedStatusKey]
    };
};
const $dec905367716080f$var$getValidStatus = (status)=>status && (0, $9Phth.FOCUS_AREA_STATUS_KEYS_LIST).includes(status) ? status : (0, $9Phth.FOCUS_AREA_STATUS_KEYS).PENDING;
const $dec905367716080f$var$getValidHealth = (health)=>health && (0, $9Phth.FOCUS_AREA_HEALTH_KEYS_LIST).includes(health) ? health : undefined;
module.exports["getFocusAreaIconColor"] = $dec905367716080f$export$4ee6399ea9bdb374;

});

parcelRegister("9Phth", function(module, exports) {
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING = 'pending';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS = 'in_progress';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED = 'paused';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED = 'completed';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK = 'on_track';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK = 'at_risk';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK = 'off_track';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PENDING = 'Pending';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_IN_PROGRESS = 'In progress';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PAUSED = 'Paused';
const $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_COMPLETED = 'Completed';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_ON_TRACK = 'On track';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_AT_RISK = 'At risk';
const $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_OFF_TRACK = 'Off track';
const $76dba10ec45af105$export$c567f03f9a52e6e = {
    PENDING: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING,
    IN_PROGRESS: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS,
    PAUSED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED,
    COMPLETED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED
};
const $76dba10ec45af105$export$18c983eb7bb605ee = {
    ON_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK,
    AT_RISK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK,
    OFF_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK
};
const $76dba10ec45af105$export$a75c07cb53bf7489 = {
    PENDING: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PENDING,
    IN_PROGRESS: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_IN_PROGRESS,
    PAUSED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PAUSED,
    COMPLETED: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_COMPLETED
};
const $76dba10ec45af105$export$b00cb7f00f2a82c0 = {
    ON_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_ON_TRACK,
    AT_RISK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_AT_RISK,
    OFF_TRACK: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_OFF_TRACK
};
const $76dba10ec45af105$export$8ed017a96b82c456 = [
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING,
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS,
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED,
    $76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED
];
const $76dba10ec45af105$export$91000048f1c8a9ff = [
    $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK,
    $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK,
    $76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK
];
const $76dba10ec45af105$export$521c96d8ff090910 = {
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PENDING]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PENDING,
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_IN_PROGRESS]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_IN_PROGRESS,
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_PAUSED]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_PAUSED,
    [$76dba10ec45af105$var$FOCUS_AREA_STATUS_KEY_COMPLETED]: $76dba10ec45af105$var$FOCUS_AREA_STATUS_LABEL_COMPLETED
};
const $76dba10ec45af105$export$b4e54ea069601d19 = {
    [$76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_ON_TRACK]: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_ON_TRACK,
    [$76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_AT_RISK]: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_AT_RISK,
    [$76dba10ec45af105$var$FOCUS_AREA_HEALTH_KEY_OFF_TRACK]: $76dba10ec45af105$var$FOCUS_AREA_HEALTH_LABEL_OFF_TRACK
};
const $76dba10ec45af105$export$357f9a743d453edd = {
    ...$76dba10ec45af105$export$521c96d8ff090910,
    ...$76dba10ec45af105$export$b4e54ea069601d19
};
const $76dba10ec45af105$export$8a9f9b723771f4eb = {
    pending: "var(--ds-icon-accent-gray, #7D818A)",
    in_progress: "var(--ds-icon-accent-gray, #7D818A)",
    on_track: "var(--ds-icon-accent-lime, #6A9A23)",
    at_risk: "var(--ds-icon-warning, #E06C00)",
    off_track: "var(--ds-icon-accent-red, #C9372C)",
    paused: "var(--ds-icon-accent-gray, #7D818A)",
    completed: "var(--ds-icon-accent-gray, #7D818A)"
};
module.exports["FOCUS_AREA_STATUS_KEYS"] = $76dba10ec45af105$export$c567f03f9a52e6e;
module.exports["FOCUS_AREA_STATUS_KEYS_LIST"] = $76dba10ec45af105$export$8ed017a96b82c456;
module.exports["FOCUS_AREA_HEALTH_KEYS_LIST"] = $76dba10ec45af105$export$91000048f1c8a9ff;
module.exports["FOCUS_AREA_DERIVED_STATUS_KEY_TO_LABEL_MAP"] = $76dba10ec45af105$export$357f9a743d453edd;
module.exports["FOCUS_AREA_DERIVED_STATUS_KEY_TO_COLOR_MAP"] = $76dba10ec45af105$export$8a9f9b723771f4eb;

});

parcelRegister("x4n5k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c07c4c04f9f99a3868a6c26b78654ed8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0636793d229b2435$var$_react = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("42omo")));

var $0636793d229b2435$var$_baseNew = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0636793d229b2435$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0636793d229b2435$var$BookOpenIcon = (props)=>/*#__PURE__*/ $0636793d229b2435$var$_react.default.createElement($0636793d229b2435$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$0636793d229b2435$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $0636793d229b2435$var$_default = module.exports.default = $0636793d229b2435$var$BookOpenIcon;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");


var $9wgn8 = parcelRequire("9wgn8");


var $cVrnQ = parcelRequire("cVrnQ");


var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $gMc0m.default)([
            $71feb0a29953fded$var$svgStyles.root
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $gMc0m.default)([
                        $71feb0a29953fded$var$svgStyles.rect
                    ])
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $edf27753e59bf881$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $edf27753e59bf881$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $edf27753e59bf881$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $edf27753e59bf881$var$disabledCheckedStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwnby5v _f0grby5v _syaz1gmx _80om13gf _1vj5by5v _q29qby5v _dh4gby5v _cz1uby5v _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("6yoZS", function(module, exports) {

let $4c594eef01830b0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c594eef01830b0b$var$load("hhss7"),
    $4c594eef01830b0b$var$load("cyGuT")
]).then(()=>parcelRequire('biiXa'));

});

parcelRegister("8s0lk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $7gpC4 = parcelRequire("7gpC4");


var $6uGcC = parcelRequire("6uGcC");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $f7lNm = parcelRequire("f7lNm");


var $cVShq = parcelRequire("cVShq");


var $lKYSu = parcelRequire("lKYSu");


var $Ze1Cu = parcelRequire("Ze1Cu");


const $fb8ee5ddf0b7e055$var$AkFeedbackCollector = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $fb8ee5ddf0b7e055$var$AkFeedbackFlag = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6yoZS")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $fb8ee5ddf0b7e055$export$204772be093f4012 = ({ entrypointId: entrypointId, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler, userDetails: userDetails, attributes: attributes, attributesWithConsent: attributesWithConsent = {}, liked: externalLike, customContent: // set like state from the outside
customContent, featureTitle: featureTitle })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const [showFeedbackModal, setFeedbackModal] = (0, $42omo.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $42omo.useState)(false);
    const [hasConsent, setConsent] = (0, $42omo.useState)(false);
    const [liked, setLiked] = (0, $42omo.useState)(externalLike);
    const feedbackObject = {
        ...attributes,
        ...hasConsent ? attributesWithConsent : {}
    };
    const feedbackContext = Object.entries(feedbackObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $42omo.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignBlock: "center",
                space: "space.050",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cVShq.FeedbackButtons), {
                    setDisplayFlag: setDisplayFlag,
                    setFeedbackModal: setFeedbackModal,
                    onLikeButtonClickHandler: onLikeButtonClickHandler,
                    onDislikeButtonClickHandler: onDislikeButtonClickHandler,
                    liked: liked,
                    setLiked: setLiked
                })
            }),
            showFeedbackModal ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                children: /*#__PURE__*/ (0, $l998X.jsx)($fb8ee5ddf0b7e055$var$AkFeedbackCollector, {
                    locale: locale,
                    onClose: ()=>{
                        setFeedbackModal(false);
                    },
                    onSubmit: ()=>{
                        setDisplayFlag(true);
                    },
                    customContent: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.050",
                        children: [
                            Object.keys(attributesWithConsent).length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                label: formatMessage((0, $lKYSu.messages).ai_answer_component_report_consent_checkbox_label),
                                onChange: toggleConsentCheckbox,
                                isChecked: hasConsent
                            }) : undefined,
                            customContent
                        ]
                    }),
                    atlassianAccountId: userDetails.id,
                    name: userDetails.name,
                    entrypointId: entrypointId,
                    additionalFields: [
                        {
                            id: (0, $f7lNm.FEEDBACK_CONTEXT_CF),
                            value: feedbackContext
                        }
                    ],
                    feedbackTitle: formatMessage((0, $lKYSu.messages).ai_answer_component_report_modal_title, {
                        featureTitle: featureTitle ?? 'Atlassian Intelligence'
                    }),
                    feedbackTitleDetails: /*#__PURE__*/ (0, $l998X.jsx)((0, $Ze1Cu.AIAnswerReportDescriptionWrapper), {
                        children: formatMessage((0, $lKYSu.messages).ai_answer_component_report_summary_label)
                    }),
                    feedbackGroupLabels: {
                        empty: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_empty_option_share_label)
                        },
                        question: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_relevance_option_label)
                        },
                        comment: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: ''
                        },
                        bug: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: ''
                        },
                        suggestion: {
                            fieldLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_details_label),
                            selectOptionLabel: formatMessage((0, $lKYSu.messages).ai_answer_component_report_other_option_label)
                        }
                    },
                    summaryPlaceholder: formatMessage((0, $lKYSu.messages).ai_answer_component_summary_placeholder_label)
                })
            }) : null,
            displayFlag && /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                    children: /*#__PURE__*/ (0, $l998X.jsx)($fb8ee5ddf0b7e055$var$AkFeedbackFlag, {
                        locale: locale,
                        description: formatMessage((0, $lKYSu.messages).ai_answer_component_feedback_flag_description)
                    })
                })
            })
        ]
    });
};
module.exports["AIFeedbackV2"] = $fb8ee5ddf0b7e055$export$204772be093f4012;

});

parcelRegister("cVShq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $9zIwY = parcelRequire("9zIwY");


var $9FnLD = parcelRequire("9FnLD");


var $lKYSu = parcelRequire("lKYSu");

const $f7d37ee6f062b97b$var$LikeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
const $f7d37ee6f062b97b$var$ActiveLikeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
const $f7d37ee6f062b97b$var$DislikeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
const $f7d37ee6f062b97b$var$ActiveDislikeIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
const $f7d37ee6f062b97b$export$c633fc044a8b8981 = ({ liked: liked, setLiked: setLiked, setDisplayFlag: setDisplayFlag, setFeedbackModal: setFeedbackModal, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [likesDisabled, setLikesDisabled] = (0, $42omo.useState)(false);
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        setDisplayFlag(true);
        setLiked(true);
        setLikesDisabled(true);
        onLikeButtonClickHandler && onLikeButtonClickHandler(e);
    }, [
        setDisplayFlag,
        setLiked,
        onLikeButtonClickHandler
    ]);
    const dislikeButtonCallback = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        setFeedbackModal(true);
        setLiked(false);
        setLikesDisabled(true);
        onDislikeButtonClickHandler && onDislikeButtonClickHandler(e);
    }, [
        setFeedbackModal,
        setLiked,
        onDislikeButtonClickHandler
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: liked === true ? $f7d37ee6f062b97b$var$ActiveLikeIcon : $f7d37ee6f062b97b$var$LikeIcon,
                onClick: likeButtonCallback,
                label: formatMessage((0, $lKYSu.messages).ai_answer_component_like_button_tooltip),
                appearance: "subtle",
                isTooltipDisabled: false,
                isDisabled: liked && likesDisabled,
                testId: "ai-answer-like-button",
                spacing: "compact"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: liked === false ? $f7d37ee6f062b97b$var$ActiveDislikeIcon : $f7d37ee6f062b97b$var$DislikeIcon,
                onClick: dislikeButtonCallback,
                label: formatMessage((0, $lKYSu.messages).ai_answer_component_dislike_button_tooltip),
                appearance: "subtle",
                isTooltipDisabled: false,
                isDisabled: !liked && likesDisabled,
                testId: "ai-answer-dislike-button",
                spacing: "compact"
            })
        ]
    });
};
module.exports["FeedbackButtons"] = $f7d37ee6f062b97b$export$c633fc044a8b8981;

});

parcelRegister("lKYSu", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $9f9db0398a2d685d$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    ai_answer_component_report_consent_checkbox_label: {
        id: "search_ai.ai_answer_component_report_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    ai_answer_component_report_modal_title: {
        id: "search_ai.ai_answer_component_report_modal_title",
        defaultMessage: "Help us improve {featureTitle}"
    },
    ai_answer_component_report_summary_label: {
        id: "search_ai.ai_answer_component_report_summary_label",
        defaultMessage: "Was there a problem with the response? Let us know what happened."
    },
    ai_answer_component_report_details_label: {
        id: "search_ai.ai_answer_component_report_details_label",
        defaultMessage: "Describe the issue"
    },
    ai_answer_component_report_empty_option_share_label: {
        id: "search_ai.ai_answer_component_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    ai_answer_component_report_relevance_option_label: {
        id: "search_ai.ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    ai_answer_component_report_offensive_option_label: {
        id: "search_ai.ai_answer_component_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    ai_answer_component_report_other_option_label: {
        id: "search_ai.ai_answer_component_report_other_option_label",
        defaultMessage: "Something else"
    },
    ai_answer_component_summary_placeholder_label: {
        id: "search_ai.ai_answer_component_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    ai_answer_component_feedback_flag_description: {
        id: "search_ai.ai_answer_component_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    },
    ai_answer_component_like_button_tooltip: {
        id: "search_ai.ai_answer_component_like_button_tooltip",
        defaultMessage: "Good response"
    },
    ai_answer_component_dislike_button_tooltip: {
        id: "search_ai.ai_answer_component_dislike_button_tooltip",
        defaultMessage: "Bad response"
    }
});
module.exports["messages"] = $9f9db0398a2d685d$export$defe85febe8b728c;

});

parcelRegister("Ze1Cu", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $49ca0736ce81ccf3$export$8b91051e793e6316 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_n3tdpxbi",
            __cmplp.className
        ])
    });
});
module.exports["AIAnswerReportDescriptionWrapper"] = $49ca0736ce81ccf3$export$8b91051e793e6316;

});

parcelRegister("7Zbm6", function(module, exports) {
var $313b937e83fff73c$export$e20550b618a28239 = /*#__PURE__*/ function(NLPSearchResultFormat) {
    NLPSearchResultFormat["PLAINTEXT"] = "PLAIN_TEXT";
    NLPSearchResultFormat["ADF"] = "ADF";
    NLPSearchResultFormat["JSON"] = "JSON";
    NLPSearchResultFormat["MARKDOWN"] = "MARKDOWN";
    return NLPSearchResultFormat;
}({});
var $313b937e83fff73c$export$eae917983a0398aa = /*#__PURE__*/ function(NLPSearchJSONResultFormat) {
    NLPSearchJSONResultFormat["WHO"] = "who";
    NLPSearchJSONResultFormat["WORK"] = "work";
    NLPSearchJSONResultFormat["TEAM"] = "team";
    NLPSearchJSONResultFormat["PERSON"] = "person";
    NLPSearchJSONResultFormat["AGENT"] = "agent";
    return NLPSearchJSONResultFormat;
}({});
var $313b937e83fff73c$export$49d1ac864ca8db3a = /*#__PURE__*/ function(NLPSearchDisclaimerType) {
    NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
    return NLPSearchDisclaimerType;
}({});
var $313b937e83fff73c$export$9405d23bea8d0d8b = /*#__PURE__*/ function(NLPSearchErrorState) {
    NLPSearchErrorState["NoAnswer"] = "NO_ANSWER";
    NLPSearchErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NLPSearchErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NLPSearchErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NLPSearchErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NLPSearchErrorState["NoAnswerOpenAIResponseError"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NLPSearchErrorState["NoAnswerOpenAIRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NLPSearchErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NLPSearchErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
    NLPSearchErrorState["AcceptableUseViolation"] = "ACCEPTABLE_USE_VIOLATIONS";
    NLPSearchErrorState["AIDisabled"] = "AI_DISABLED";
    NLPSearchErrorState["EarlyStop"] = "EARLY_STOP";
    // These values are not returned from the BE and are only used by the FE
    NLPSearchErrorState["Default"] = "DEFAULT";
    // Value at component initialization
    NLPSearchErrorState["NetworkError"] = "NETWORK_ERROR";
    // Value if the network call fails
    NLPSearchErrorState["TimeoutError"] = "TIMEOUT_ERROR";
    // Value if the network call times out
    NLPSearchErrorState["HIPAAError"] = "HIPAA_ERROR";
    return NLPSearchErrorState;
}({});
var $313b937e83fff73c$export$6b1112c70cca65d3 = /*#__PURE__*/ function(NLPSearchErrorCodes) {
    NLPSearchErrorCodes["HIPAA_ENABLED_ERROR"] = "convoai.rest.browsing.product.has.hipaa.enabled";
    return NLPSearchErrorCodes;
}({});
var $313b937e83fff73c$export$7c6c2f9c68de2e45 = /*#__PURE__*/ function(NLPSearchResultContainerDataTypeContainerType) {
    NLPSearchResultContainerDataTypeContainerType["ConfluenceSpace"] = "confluenceSpace";
    NLPSearchResultContainerDataTypeContainerType["JiraProject"] = "jiraProject";
    return NLPSearchResultContainerDataTypeContainerType;
}({});
var $313b937e83fff73c$export$12b805d25b464b8d = /*#__PURE__*/ function(NLPSearchCustomDefinitionType) {
    NLPSearchCustomDefinitionType["CURATED"] = "CURATED";
    NLPSearchCustomDefinitionType["PRECOMPUTED"] = "PRECOMPUTED";
    return NLPSearchCustomDefinitionType;
}({});
var $313b937e83fff73c$export$130eddddf4243f3f = /*#__PURE__*/ function(AIAnswerQueryStreamType) {
    AIAnswerQueryStreamType["AnswerType"] = "ANSWER_TYPE";
    AIAnswerQueryStreamType["GenerationType"] = "ANSWER_GENERATION_TYPE";
    AIAnswerQueryStreamType["AnswerPart"] = "ANSWER_PART";
    AIAnswerQueryStreamType["FinalResponse"] = "FINAL_RESPONSE";
    AIAnswerQueryStreamType["Trace"] = "TRACE";
    AIAnswerQueryStreamType["ErrorStateQuerySuggestions"] = "ERROR_STATE_QUERY_SUGGESTIONS";
    AIAnswerQueryStreamType["DynamicLayoutSubAgentMessage"] = "DL_SUB_AGENT";
    AIAnswerQueryStreamType["EarlyStop"] = "EARLY_STOP";
    return AIAnswerQueryStreamType;
}({});
var $313b937e83fff73c$export$e7b798431c659b80 = /*#__PURE__*/ function(AIAnswerAPIType) {
    AIAnswerAPIType["STREAM"] = "STREAM";
    return AIAnswerAPIType;
}({});
var $313b937e83fff73c$export$c13e418beaf43d1c = /*#__PURE__*/ function(DefinitionAnswerState) {
    DefinitionAnswerState["LOADING"] = "loading";
    DefinitionAnswerState["ANSWERED"] = "answered";
    DefinitionAnswerState["ERRORED"] = "errored";
    return DefinitionAnswerState;
}({});
module.exports["NLPSearchResultFormat"] = $313b937e83fff73c$export$e20550b618a28239;
module.exports["NLPSearchJSONResultFormat"] = $313b937e83fff73c$export$eae917983a0398aa;
module.exports["NLPSearchErrorState"] = $313b937e83fff73c$export$9405d23bea8d0d8b;
module.exports["NLPSearchErrorCodes"] = $313b937e83fff73c$export$6b1112c70cca65d3;
module.exports["NLPSearchResultContainerDataTypeContainerType"] = $313b937e83fff73c$export$7c6c2f9c68de2e45;
module.exports["NLPSearchCustomDefinitionType"] = $313b937e83fff73c$export$12b805d25b464b8d;
module.exports["AIAnswerQueryStreamType"] = $313b937e83fff73c$export$130eddddf4243f3f;
module.exports["AIAnswerAPIType"] = $313b937e83fff73c$export$e7b798431c659b80;

});

parcelRegister("hm6w9", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $6yCpa = parcelRequire("6yCpa");


var $dbl1i = parcelRequire("dbl1i");


var $4OGlb = parcelRequire("4OGlb");


var $2hfy2 = parcelRequire("2hfy2");

const $f62b6f09dac42d3d$export$2f6c9ab85be44d1a = (onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    if (shouldNotGetBackendExperiment) return;
    return $f62b6f09dac42d3d$var$getParallelBackendExperimentsConfig(onErrorFn, getLayerValuesFn ?? $f62b6f09dac42d3d$export$3178593b0bf95121);
};
const $f62b6f09dac42d3d$export$3178593b0bf95121 = (layerName, options)=>{
    const layer = (0, $c6GJD.default).getLayer(layerName, {
        ...options?.fireLayerExposure === false ? {
            fireLayerExposure: false
        } : {}
    });
    const layerNameWithoutSuffix = layerName.replace('_standard', '').replace('_premium', '');
    return {
        name: layerNameWithoutSuffix,
        layerId: layer.get('layerId', 'default'),
        shadowId: layer.get('shadowId', null),
        // The below values might not be sent to the backend but we can still track them in the frontend
        controlId: layer.get('controlId', null),
        abTestId: layer.get('abTestId', 'no_ab_test_id'),
        ...(0, $c6GJD.default).checkGate('search-experiment-overrides-backend') && {
            testId: layer.get('testId', null)
        }
    };
};
const $f62b6f09dac42d3d$export$f0d0c69a221c32ee = (onError, fireLayerExposure = true, getLayerValuesFn)=>{
    try {
        const layer = (0, $c6GJD.default).getLayer((0, $4OGlb.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), fireLayerExposure ? {} : {
            fireLayerExposure: false
        });
        let abTestId;
        let rawLayerFunctions;
        if (getLayerValuesFn) {
            const layerResult = getLayerValuesFn((0, $4OGlb.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), fireLayerExposure ? {} : {
                fireLayerExposure: false
            });
            abTestId = layerResult.abTestId ?? 'no_ab_test_id';
            rawLayerFunctions = layerResult.layerFunctions ?? [];
        } else {
            abTestId = layer.get('abTestId', 'no_ab_test_id');
            rawLayerFunctions = layer.get('layerFunctions', []);
        }
        const layerFunctions = (0, $dbl1i.mutuallyExclusiveBackendSearchLogicParametersSchema).safeParse(rawLayerFunctions).data;
        return {
            layerFunctions: layerFunctions || [],
            abTestId: abTestId,
            // The get 'mutualExclusion' is breaking in Jira when retrieving a boolean value from layer,
            // so for the compatibility, we use the abTestId to determine if it's a mutually exclusive experiment
            mutualExclusion: abTestId !== 'no_ab_test_id'
        };
    } catch (error) {
        onError?.(error);
    }
};
const $f62b6f09dac42d3d$export$ad31a6212fa2b02c = (layerName, onError)=>{
    try {
        const layer = (0, $c6GJD.default).getLayer(layerName);
        const layerValues = {
            l1Id: layer.get('l1Id', 'default'),
            l1Entity: layer.get('l1Entity', '*'),
            l2Id: layer.get('l2Id', 'default'),
            l2Entity: layer.get('l2Entity', '*'),
            l3Id: layer.get('l3Id', 'default'),
            qrId: layer.get('qrId', 'default'),
            abTestId: layer.get('abTestId', 'no_ab_test_id'),
            /**
			 * This is a map of UI features that are enabled for the combined experiment.
			 * for example:
			 * {
			 * 	uiFeature1: true,
			 * 	uiFeature2: false,
			 * }
			 */ uiFeatures: layer.get('uiFeatures', {}),
            controlId: layer.get('controlId', 'default'),
            enabled: layer.get('enabled', false)
        };
        return layerValues;
    } catch (error) {
        onError?.(error);
    }
};
const $f62b6f09dac42d3d$var$getStandardOrPremiumLayerValues = (featureGateName, standardLayerName, premiumLayerName, resolveLayerValues = $f62b6f09dac42d3d$export$3178593b0bf95121)=>{
    const isPremium = (0, $c6GJD.default).checkGate(featureGateName);
    if (isPremium) return resolveLayerValues(premiumLayerName);
    return resolveLayerValues(standardLayerName);
};
const $f62b6f09dac42d3d$var$getParallelBackendExperimentsConfig = (onErrorFn, resolveLayerValues = $f62b6f09dac42d3d$export$3178593b0bf95121)=>{
    try {
        const allLayers = [];
        const layer1 = $f62b6f09dac42d3d$var$getStandardOrPremiumLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM), resolveLayerValues);
        allLayers.push(layer1);
        const layer2 = $f62b6f09dac42d3d$var$getStandardOrPremiumLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD), (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM), resolveLayerValues);
        allLayers.push(layer2);
        const layer2Blending = resolveLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER));
        allLayers.push(layer2Blending);
        const isLayer3Enabled = (0, $c6GJD.default).checkGate((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED));
        if (isLayer3Enabled) {
            const layer3 = resolveLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_L3_LAYER));
            allLayers.push(layer3);
        }
        const isQueryExpansionLayerEnabled = (0, $c6GJD.default).checkGate((0, $4OGlb.STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED));
        if (isQueryExpansionLayerEnabled) {
            const layerQueryExpansion = resolveLayerValues((0, $4OGlb.STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER));
            allLayers.push(layerQueryExpansion);
        }
        const concatenatedExperimentId = allLayers.map((l)=>l?.layerId).join('_');
        const concatenatedShadowExperimentId = allLayers.map((l)=>l?.shadowId).join('_');
        return {
            experimentId: concatenatedExperimentId,
            shadowExperimentId: concatenatedShadowExperimentId,
            experimentLayers: allLayers
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return 0, $4OGlb.DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG;
};
const $f62b6f09dac42d3d$var$isEnrolledInMutuallyExclusiveUIExperiment = (experience)=>{
    const isEnrolledInQuickFindUIExperiment = (0, $c6GJD.default).getLayerValue((0, $4OGlb.STATSIG_QUICK_FIND_LAYER), 'frontendExperimentName', '', {
        fireLayerExposure: false
    }) !== '';
    const isEnrolledInSearchPageUIExperiment = (0, $c6GJD.default).getLayerValue((0, $4OGlb.STATSIG_FULL_PAGE_SEARCH_LAYER), 'frontendExperimentName', '', {
        fireLayerExposure: false
    }) !== '';
    return experience === 'quick-find' && isEnrolledInQuickFindUIExperiment || experience === 'search-page' && isEnrolledInSearchPageUIExperiment;
};
const $f62b6f09dac42d3d$var$applyBackendExperimentOverrides = (backendExperiment, backendExperimentOverrides)=>{
    // Handle undefined backendExperiment by creating a minimal experiment with empty layers
    const experiment = backendExperiment || {
        experimentLayers: []
    };
    const shouldApplyOverrides = (0, $dh538.fg)('enable_rovo_search_overrides') && Boolean(backendExperimentOverrides?.length);
    if (!shouldApplyOverrides) return backendExperiment;
    return {
        ...experiment,
        experimentLayers: (0, $2hfy2.mergeBackendExperimentLayerOverrides)(experiment.experimentLayers ?? [], backendExperimentOverrides ?? [])
    };
};
/**
 * Helper function to apply overrides when normal experiment flow is not applicable.
 * Returns undefined if no overrides are provided, otherwise applies overrides to the backend experiment.
 */ const $f62b6f09dac42d3d$var$applyOverridesOrReturnUndefined = (experimentConfig, backendExperimentOverrides)=>{
    const shouldApplyOverrides = (0, $dh538.fg)('enable_rovo_search_overrides') && Boolean(backendExperimentOverrides?.length);
    if (!shouldApplyOverrides) return undefined;
    return $f62b6f09dac42d3d$var$applyBackendExperimentOverrides(experimentConfig.backendExperiment, backendExperimentOverrides);
};
const $f62b6f09dac42d3d$export$9009723727c24828 = ({ experimentConfig: experimentConfig, entities: entities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters, backendExperimentOverrides: backendExperimentOverrides, getLayerValuesFn: getLayerValuesFn })=>{
    if (experimentConfig.combinedExperiment?.enabled) return $f62b6f09dac42d3d$var$applyBackendExperimentOverrides((0, $2hfy2.mapCombinedLayerExperiment)({
        combinedExperiment: experimentConfig.combinedExperiment
    }), backendExperimentOverrides);
    if (!experimentConfig.dynamicExperiments) return $f62b6f09dac42d3d$var$applyOverridesOrReturnUndefined(experimentConfig, backendExperimentOverrides);
    if ($f62b6f09dac42d3d$var$isEnrolledInMutuallyExclusiveUIExperiment(experience)) return $f62b6f09dac42d3d$var$applyOverridesOrReturnUndefined(experimentConfig, backendExperimentOverrides);
    const requestedEntities = entities.flatMap((entity)=>{
        try {
            const { resourceOwner: resourceOwner, resourceType: resourceType } = (0, $6yCpa.Ati).parse(entity);
            return [
                {
                    entity: resourceOwner,
                    subEntity: resourceType.toUpperCase()
                }
            ];
        } catch  {
            return [];
        }
    });
    // Skip layer exposure when overrides are enabled and there are overrides
    const skipLayerExposure = (0, $dh538.fg)('enable_rovo_search_overrides') && Boolean(backendExperimentOverrides?.length);
    const fireLayerExposure = !skipLayerExposure;
    const experimentParams = $f62b6f09dac42d3d$export$f0d0c69a221c32ee(undefined, fireLayerExposure, getLayerValuesFn);
    if (experimentParams?.mutualExclusion) return $f62b6f09dac42d3d$var$applyBackendExperimentOverrides((0, $2hfy2.mapMutuallyExclusiveExperiment)({
        experimentParams: experimentParams,
        productEdition: productEdition,
        isHello: isHello,
        requestedEntities: requestedEntities,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    }), backendExperimentOverrides);
    return $f62b6f09dac42d3d$var$applyBackendExperimentOverrides((0, $2hfy2.mapDynamicExperiments)({
        dynamicExperiments: experimentConfig.dynamicExperiments,
        productEdition: productEdition,
        isHello: isHello,
        requestedEntities: requestedEntities,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters,
        fireLayerExposure: fireLayerExposure,
        getLayerValuesFn: getLayerValuesFn
    }), backendExperimentOverrides);
};
module.exports["getBackendExperimentConfig"] = $f62b6f09dac42d3d$export$2f6c9ab85be44d1a;
module.exports["getLayerValues"] = $f62b6f09dac42d3d$export$3178593b0bf95121;
module.exports["getCombinedLayerValues"] = $f62b6f09dac42d3d$export$ad31a6212fa2b02c;
module.exports["getBackendExperiment"] = $f62b6f09dac42d3d$export$9009723727c24828;

});

parcelRegister("dbl1i", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $de7a36fee3572948$var$experimentExperienceEnum = (0, $gLLcz.z).enum([
    'search-page',
    'quick-find',
    'search-page-space-filter',
    'quick-search',
    'advanced-search',
    'sain'
]);
const $de7a36fee3572948$var$linkedEntityGranularityEnum = (0, $gLLcz.z).enum([
    'ALL_MATCHING_MESSAGES',
    'DEFAULT',
    'FULL_THREAD',
    'ONLY_LINKED_ENTITIES'
]);
const $de7a36fee3572948$var$layerFunctionBaseSchema = {
    layerType: (0, $gLLcz.z).string().startsWith('search_platform_layer_').optional(),
    entity: (0, $gLLcz.z).string().optional(),
    subEntity: (0, $gLLcz.z).string().optional(),
    hello: (0, $gLLcz.z).boolean().optional(),
    isJiraIssueIndexed: (0, $gLLcz.z).boolean().optional(),
    linkedEntityGranularity: $de7a36fee3572948$var$linkedEntityGranularityEnum.optional(),
    confluenceTier: (0, $gLLcz.z).string().array().optional(),
    productDataRegions: (0, $gLLcz.z).record((0, $gLLcz.z).string(), (0, $gLLcz.z).string().array()).optional(),
    experiences: $de7a36fee3572948$var$experimentExperienceEnum.array().optional(),
    tenantIds: (0, $gLLcz.z).string().array().optional(),
    targetingGateId: (0, $gLLcz.z).string().optional(),
    providerId: (0, $gLLcz.z).string().optional(),
    connectorSources: (0, $gLLcz.z).array((0, $gLLcz.z).string()).optional(),
    integrationAri: (0, $gLLcz.z).string().optional()
};
const $de7a36fee3572948$var$layerFunction = (0, $gLLcz.z).object($de7a36fee3572948$var$layerFunctionBaseSchema);
const $de7a36fee3572948$var$dynamicConfigSchema = (0, $gLLcz.z).string().transform((str, ctx)=>{
    try {
        return JSON.parse(str);
    } catch (e) {
        ctx.addIssue({
            code: 'custom',
            message: 'Invalid JSON'
        });
        return (0, $gLLcz.z).NEVER;
    }
}).pipe((0, $gLLcz.z).object({
    ...$de7a36fee3572948$var$layerFunctionBaseSchema,
    statsigLayerId: (0, $gLLcz.z).string().startsWith('search_platform_')
}));
const $de7a36fee3572948$var$mutuallyExclusiveDynamicConfigSchema = (0, $gLLcz.z).string().transform((str, ctx)=>{
    try {
        return JSON.parse(str);
    } catch (e) {
        ctx.addIssue({
            code: 'custom',
            message: 'Invalid JSON'
        });
        return (0, $gLLcz.z).NEVER;
    }
}).pipe((0, $gLLcz.z).object({
    ...$de7a36fee3572948$var$layerFunctionBaseSchema,
    layerId: (0, $gLLcz.z).string(),
    controlId: (0, $gLLcz.z).string().optional()
}));
const $de7a36fee3572948$export$4b5312b6cfd0d20a = (0, $gLLcz.z).array((0, $gLLcz.z).string()).transform((arrayJSONStrings)=>{
    return arrayJSONStrings.map((jsonStr)=>$de7a36fee3572948$var$dynamicConfigSchema.safeParse(jsonStr).data).flatMap((dynamicConfig)=>dynamicConfig ? dynamicConfig : []);
}).refine((dynamicConfig)=>dynamicConfig.length); // The schema is invalid if all JSON strings are invalid
const $de7a36fee3572948$export$e1f2182538b46e4b = (0, $gLLcz.z).array((0, $gLLcz.z).string()).transform((arrayJSONStrings)=>{
    return arrayJSONStrings.map((jsonStr)=>$de7a36fee3572948$var$mutuallyExclusiveDynamicConfigSchema.safeParse(jsonStr).data).flatMap((dynamicConfig)=>dynamicConfig ? dynamicConfig : []);
}).refine((dynamicConfig)=>dynamicConfig.length); // The schema is invalid if all JSON strings are invalid
module.exports["dynamicExperimentsSchema"] = $de7a36fee3572948$export$4b5312b6cfd0d20a;
module.exports["mutuallyExclusiveBackendSearchLogicParametersSchema"] = $de7a36fee3572948$export$e1f2182538b46e4b;

});

parcelRegister("2hfy2", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $4OGlb = parcelRequire("4OGlb");


var $hm6w9 = parcelRequire("hm6w9");

const $c517901dc1a94583$var$WILDCARD = '*';
const $c517901dc1a94583$var$JIRA_ENTITY = 'jira';
const $c517901dc1a94583$export$8dc0dcff4d3bde7a = ({ combinedExperiment: combinedExperiment })=>{
    if (combinedExperiment) {
        const experimentLayers = [
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_NAME),
                combinedExperiment.l1Id
            ],
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_NAME),
                combinedExperiment.l2Id
            ],
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_L3_LAYER_NAME),
                combinedExperiment.l3Id
            ],
            [
                (0, $4OGlb.STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER_NAME),
                combinedExperiment.qrId
            ]
        ];
        return {
            experimentLayers: experimentLayers.map(([layerType, layerId])=>{
                let entity = $c517901dc1a94583$var$WILDCARD;
                if (layerType === (0, $4OGlb.STATSIG_SEARCH_BACKEND_L1_LAYER_NAME)) entity = combinedExperiment.l1Entity ?? $c517901dc1a94583$var$WILDCARD;
                if (layerType === (0, $4OGlb.STATSIG_SEARCH_BACKEND_L2_LAYER_NAME)) entity = combinedExperiment.l2Entity ?? $c517901dc1a94583$var$WILDCARD;
                return {
                    name: layerType,
                    layerId: null,
                    shadowId: null,
                    definitions: [
                        {
                            layerId: layerId,
                            shadowId: null,
                            entity: entity,
                            subEntity: $c517901dc1a94583$var$WILDCARD,
                            abTestId: combinedExperiment.abTestId ?? null
                        }
                    ],
                    analyticsDefinitions: [
                        {
                            layerId: layerId,
                            shadowId: null,
                            entity: entity,
                            subEntity: $c517901dc1a94583$var$WILDCARD,
                            abTestId: combinedExperiment.abTestId ?? null,
                            controlId: combinedExperiment.controlId ?? null
                        }
                    ]
                };
            })
        };
    }
    return {
        experimentLayers: []
    };
};
const $c517901dc1a94583$var$getLayersRelevantToSearchRequest = ({ dynamicExperiments: dynamicExperiments, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters })=>{
    return dynamicExperiments.filter($c517901dc1a94583$var$containsTenantId(tenantId)).filter($c517901dc1a94583$export$647cb61786ce5ae0(productEdition)).filter($c517901dc1a94583$var$containsExperience(experience)).filter($c517901dc1a94583$var$isHelloTenant(isHello)).filter($c517901dc1a94583$var$containsRequestedEntities(requestedEntities)).filter($c517901dc1a94583$var$containsRequestedSubEntities(requestedEntities)).filter($c517901dc1a94583$export$273a58382ea22085(thirdPartyFilters)).filter($c517901dc1a94583$var$isJiraIssueIndexedConditionSatisfied(isJiraIssueIndexed)).filter($c517901dc1a94583$var$isLinkedEntityGranularityConditionSatisfied(linkedEntityGranularity)).filter($c517901dc1a94583$var$passesTargetingGate()).filter($c517901dc1a94583$var$satisfiesProductDataRegions(productDataRegions)).reduce((layerFunctions, currentLayerFunction)=>{
        // IF there are more than one definitions with the same definition
        // THEN only add the first one defined, (do not add this one)
        const containsCollision = layerFunctions.find((layerFunction)=>{
            if ((0, $dh538.fg)('rovo_3p_exp_targeting')) /**
					 * This isn't perfect either because there can be some edge cases where
					 * an experiment definition is included, but not used. e.g.
					 * - Defitions we have are:
					 * 			[entity: confluence, subEntity: page],
					 * 			[entity: confluence, subEntity: *]
					 * - The request is for entity: confluence, subEntity: page
					 *
					 * Both definitions would be included in the final list, but only the
					 * first would ever be used, but we fire exposures for both.
					 *
					 * To fix this, we would need to do one of the following:
					 * - Replicate all of the fan out logic here (ugly and hard to maintain),
					 *   so we know exactly which experiment definitions will get used
					 * - Fire experiment exposures in the backend
					 */ return layerFunction.layerType === currentLayerFunction.layerType && layerFunction.entity === currentLayerFunction.entity && layerFunction.subEntity === currentLayerFunction.subEntity && layerFunction.integrationAri === currentLayerFunction.integrationAri && layerFunction.providerId === currentLayerFunction.providerId && JSON.stringify(layerFunction.connectorSources?.sort()) === JSON.stringify(currentLayerFunction.connectorSources?.sort());
            else /**
					 * I think there's a bug here, what if:
					 * - layerFunctions contains
					 * 			[entity: graph, subEntity: video]
					 * 			[entity: graph, subEntity: *]
					 * - The request is for entities:
					 * 			ati:cloud:graph:design
					 * 			ati:cloud:graph:video
					 *
					 * Only the first definition would get included, but both would have
					 * been used after the 3P requests are fanned out.
					 */ return layerFunction.layerType === currentLayerFunction.layerType && (layerFunction.entity === currentLayerFunction.entity || currentLayerFunction.entity === $c517901dc1a94583$var$WILDCARD || layerFunction.entity === $c517901dc1a94583$var$WILDCARD) && (layerFunction.subEntity === currentLayerFunction.subEntity || currentLayerFunction.subEntity === $c517901dc1a94583$var$WILDCARD || layerFunction.subEntity === $c517901dc1a94583$var$WILDCARD);
        });
        return containsCollision ? layerFunctions : [
            ...layerFunctions,
            currentLayerFunction
        ];
    }, []);
};
const $c517901dc1a94583$var$mapExperimentsToExperimentDefinitions = (experiments)=>{
    return experiments.reduce((experimentLayers, definitionWithLayerType)=>{
        const existingLayer = experimentLayers.find((layer)=>layer.name === definitionWithLayerType.layerType);
        const { controlId: _controlId, statsigLayerId: _statsigLayerId, ...newDefinition } = definitionWithLayerType.definition;
        const analyticsDefinition = {
            ...definitionWithLayerType.definition
        };
        if (!existingLayer) {
            experimentLayers.push({
                name: definitionWithLayerType.layerType,
                layerId: null,
                shadowId: null,
                definitions: [
                    newDefinition
                ],
                analyticsDefinitions: [
                    analyticsDefinition
                ]
            });
            return experimentLayers;
        }
        existingLayer.definitions?.push(newDefinition);
        existingLayer.analyticsDefinitions?.push(analyticsDefinition);
        return experimentLayers;
    }, []);
};
const $c517901dc1a94583$export$10532bc904a76c69 = ({ experimentParams: experimentParams, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters })=>{
    const dynamicExperiments = experimentParams?.layerFunctions || [];
    const { abTestId: abTestId } = experimentParams || {
        abTestId: null
    };
    const relevantExperiments = $c517901dc1a94583$var$getLayersRelevantToSearchRequest({
        dynamicExperiments: dynamicExperiments,
        requestedEntities: requestedEntities,
        productEdition: productEdition,
        isHello: isHello,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    });
    const experiments = relevantExperiments.map((dynamicExp)=>{
        return {
            definition: {
                layerId: dynamicExp.layerId,
                shadowId: null,
                entity: dynamicExp.entity,
                subEntity: dynamicExp.subEntity,
                abTestId: abTestId,
                controlId: dynamicExp.controlId ?? null,
                statsigLayerId: null,
                ...(0, $dh538.fg)('rovo_3p_exp_targeting') ? {
                    providerId: dynamicExp.providerId,
                    integrationARI: dynamicExp.integrationAri,
                    connectorSources: dynamicExp.connectorSources
                } : {}
            },
            layerType: dynamicExp.layerType
        };
    });
    return {
        experimentLayers: $c517901dc1a94583$var$mapExperimentsToExperimentDefinitions(experiments)
    };
};
const $c517901dc1a94583$export$b9a99705ca4e42b9 = (experimentLayers, overrides)=>{
    const mergedLayers = experimentLayers.map((l)=>({
            ...l,
            // ensure that definitions and analyticsDefinitions have an array
            definitions: l.definitions ? [
                ...l.definitions
            ] : [],
            analyticsDefinitions: l.analyticsDefinitions ? [
                ...l.analyticsDefinitions
            ] : []
        }));
    for (const override of overrides){
        const overrideDefinitions = override.analyticsDefinitions ?? [];
        if (overrideDefinitions.length === 0) continue;
        const layer = mergedLayers.find((l)=>l.name === override.name);
        if (!layer) {
            // Remove controlId from definitions since they're for request payloads
            const requestDefinitions = overrideDefinitions.map(({ controlId: _controlId, ...def })=>def);
            mergedLayers.push({
                name: override.name,
                layerId: null,
                shadowId: null,
                definitions: requestDefinitions,
                analyticsDefinitions: [
                    ...overrideDefinitions
                ]
            });
            continue;
        }
        for (const overrideDef of overrideDefinitions){
            const keyEntity = overrideDef.entity ?? null;
            const keySubEntity = overrideDef.subEntity ?? null;
            const analyticsIndex = layer.analyticsDefinitions.findIndex((d)=>(d.entity ?? null) === keyEntity && (d.subEntity ?? null) === keySubEntity);
            if (analyticsIndex >= 0) layer.analyticsDefinitions[analyticsIndex] = overrideDef;
            else layer.analyticsDefinitions.push(overrideDef);
            const { controlId: _controlId, ...requestDef } = overrideDef;
            const requestIndex = layer.definitions.findIndex((d)=>(d.entity ?? null) === keyEntity && (d.subEntity ?? null) === keySubEntity);
            if (requestIndex >= 0) layer.definitions[requestIndex] = requestDef;
            else layer.definitions.push(requestDef);
        }
    }
    return mergedLayers;
};
const $c517901dc1a94583$export$37bc8313287bf4ea = ({ dynamicExperiments: dynamicExperiments, requestedEntities: requestedEntities, productEdition: productEdition, isHello: isHello, productDataRegions: productDataRegions, experience: experience, tenantId: tenantId, isJiraIssueIndexed: isJiraIssueIndexed, linkedEntityGranularity: linkedEntityGranularity, thirdPartyFilters: thirdPartyFilters, fireLayerExposure: fireLayerExposure = true, getLayerValuesFn: getLayerValuesFn = (0, $hm6w9.getLayerValues) })=>{
    const relevantExperiments = $c517901dc1a94583$var$getLayersRelevantToSearchRequest({
        dynamicExperiments: dynamicExperiments,
        requestedEntities: requestedEntities,
        productEdition: productEdition,
        isHello: isHello,
        productDataRegions: productDataRegions,
        experience: experience,
        tenantId: tenantId,
        isJiraIssueIndexed: isJiraIssueIndexed,
        linkedEntityGranularity: linkedEntityGranularity,
        thirdPartyFilters: thirdPartyFilters
    });
    const experiments = relevantExperiments.map((dynamicExp)=>{
        const { layerId: layerId, shadowId: shadowId, abTestId: abTestId, controlId: controlId } = getLayerValuesFn(dynamicExp.statsigLayerId, fireLayerExposure ? undefined : {
            fireLayerExposure: false
        });
        return {
            definition: {
                layerId: layerId,
                shadowId: shadowId,
                entity: dynamicExp.entity,
                subEntity: dynamicExp.subEntity,
                abTestId: abTestId,
                controlId: controlId,
                statsigLayerId: dynamicExp.statsigLayerId,
                ...(0, $dh538.fg)('rovo_3p_exp_targeting') ? {
                    providerId: dynamicExp.providerId,
                    integrationARI: dynamicExp.integrationAri,
                    connectorSources: dynamicExp.connectorSources
                } : {}
            },
            layerType: dynamicExp.layerType
        };
    });
    return {
        experimentLayers: $c517901dc1a94583$var$mapExperimentsToExperimentDefinitions(experiments)
    };
};
const $c517901dc1a94583$export$647cb61786ce5ae0 = (productEdition)=>(dynamicExp)=>{
        // Opt for specificity. Does not filter out values that do not have the confluenceTier attribute
        if (!dynamicExp.confluenceTier || dynamicExp.confluenceTier.length === 0) return true;
        return !!dynamicExp.confluenceTier?.find((experimentTier)=>productEdition?.['confluence'] === experimentTier);
    };
const $c517901dc1a94583$var$isHelloTenant = (isHello)=>(dynamicExp)=>{
        if (dynamicExp.hello === undefined || dynamicExp.hello === null) return true;
        return dynamicExp.hello === isHello;
    };
const $c517901dc1a94583$var$passesTargetingGate = ()=>(dynamicExp)=>{
        if (dynamicExp.targetingGateId === undefined || dynamicExp.targetingGateId === null) return true;
        // eslint-disable-next-line @atlaskit/platform/static-feature-flags
        return (0, $dh538.fg)(dynamicExp.targetingGateId);
    };
/**
 * This is specifically used for targeting based on indexing status of the tenant.
 * This might NOT be needed once Jira indexed and ROVO in Jira is shipped to 100%
 */ const $c517901dc1a94583$var$isJiraIssueIndexedConditionSatisfied = (isJiraIssueIndexed)=>(dynamicExp)=>{
        if (isJiraIssueIndexed === undefined || dynamicExp.isJiraIssueIndexed === undefined || dynamicExp.isJiraIssueIndexed === null || dynamicExp?.entity !== $c517901dc1a94583$var$JIRA_ENTITY) return true;
        return dynamicExp.isJiraIssueIndexed === isJiraIssueIndexed;
    };
const $c517901dc1a94583$var$isLinkedEntityGranularityConditionSatisfied = (linkedEntityGranularity)=>(dynamicExp)=>{
        if (linkedEntityGranularity === undefined || dynamicExp.linkedEntityGranularity === undefined || dynamicExp.linkedEntityGranularity === null) return true;
        return dynamicExp.linkedEntityGranularity === linkedEntityGranularity;
    };
const $c517901dc1a94583$var$containsRequestedEntities = (entityFilter)=>(dynamicExp)=>{
        if (!dynamicExp.entity || dynamicExp.entity === $c517901dc1a94583$var$WILDCARD) return true;
        const isFilteredEntity = entityFilter.find((filteredEntity)=>dynamicExp.entity === filteredEntity.entity);
        return isFilteredEntity ?? false;
    };
const $c517901dc1a94583$var$containsRequestedSubEntities = (entityFilter)=>(dynamicExp)=>{
        if (!dynamicExp.subEntity || dynamicExp.subEntity === $c517901dc1a94583$var$WILDCARD) return true;
        const isFilteredSubEntity = entityFilter.find((filteredEntity)=>dynamicExp.subEntity === filteredEntity.subEntity);
        return isFilteredSubEntity ?? false;
    };
/**
 * Determines whether the provided data regions (dataRegions) are defined in
 * the dynamic configuration (dynamicExp). Every data region for a given product
 * in the dynamic configuration must be specified  in order for the given
 * experiment layer to be eligible.
 *
 * @param dataRegions Represents where the data comes from comes from for
 * each product.
 * ```
 * { 'confluence': ["us-west-2"], 'compass': ["us-east-1"] }`
 * ```
 *
 * @returns a boolean that indicates whether or not the provided data regions
 * (dataRegions) are specified in the dynamic configuration (dynamicExp).
 */ const $c517901dc1a94583$var$satisfiesProductDataRegions = (dataRegions)=>(dynamicExp)=>{
        if (!dynamicExp.productDataRegions) return true;
        return Object.keys(dynamicExp.productDataRegions).map((product)=>{
            const productDataRegions = dynamicExp.productDataRegions?.[product];
            const isProductEligible = dataRegions?.[product]?.every((dataRegion)=>{
                return productDataRegions?.includes(dataRegion);
            });
            return !!isProductEligible;
        }).reduce((prev, curr)=>prev && curr);
    };
const $c517901dc1a94583$var$containsExperience = (experience)=>(dynamicExp)=>{
        if (!dynamicExp.experiences || dynamicExp.experiences.length === 0) return true;
        return dynamicExp.experiences?.find((dynamicExpExperience)=>experience === dynamicExpExperience);
    };
const $c517901dc1a94583$var$containsTenantId = (tenantId)=>(dynamicExp)=>{
        if (!dynamicExp.tenantIds || dynamicExp.tenantIds.length === 0) return true;
        return dynamicExp.tenantIds?.find((dynamicExpTenantId)=>tenantId === dynamicExpTenantId);
    };
const $c517901dc1a94583$export$273a58382ea22085 = (thirdPartyFilters)=>(dynamicExp)=>{
        if (!dynamicExp.connectorSources?.length && !dynamicExp.providerId && !dynamicExp.integrationAri) return true;
        if (!thirdPartyFilters?.thirdPartyProducts) return false;
        if (!(0, $dh538.fg)('rovo_3p_exp_targeting')) return false;
        const providerIdExp = dynamicExp.providerId ?? $c517901dc1a94583$var$WILDCARD;
        const integrationAriExp = dynamicExp.integrationAri ?? $c517901dc1a94583$var$WILDCARD;
        const connectorSourceExp = dynamicExp.connectorSources;
        const matches3pTarget = thirdPartyFilters.thirdPartyProducts.find((thirdPartyProduct)=>{
            // https://atlassian.slack.com/archives/C08CGNZTMC2/p1756690283247959
            const containsConnectorSource = thirdPartyProduct.connectorSources?.find((connectorSourceFromConfig)=>connectorSourceExp?.find((connectorSourceFromExp)=>connectorSourceFromExp === connectorSourceFromConfig));
            const matchesProviderId = providerIdExp === $c517901dc1a94583$var$WILDCARD || providerIdExp === thirdPartyProduct.providerId;
            const matchesIntegrationAri = integrationAriExp === $c517901dc1a94583$var$WILDCARD || integrationAriExp === thirdPartyProduct.integrationId;
            return matchesProviderId && matchesIntegrationAri && (!connectorSourceExp || Boolean(containsConnectorSource) // !connectorSources = wildcard
            );
        });
        return Boolean(matches3pTarget);
    };
module.exports["mapCombinedLayerExperiment"] = $c517901dc1a94583$export$8dc0dcff4d3bde7a;
module.exports["mapMutuallyExclusiveExperiment"] = $c517901dc1a94583$export$10532bc904a76c69;
module.exports["mergeBackendExperimentLayerOverrides"] = $c517901dc1a94583$export$b9a99705ca4e42b9;
module.exports["mapDynamicExperiments"] = $c517901dc1a94583$export$37bc8313287bf4ea;

});

parcelRegister("2XcmP", function(module, exports) {
//refer to
//https://hello.atlassian.net/wiki/spaces/CASRAQ/pages/2821410030/Spike+Spec+Basic+Question+Detection+Integration+in+the+FE

var $1ycSR = parcelRequire("1ycSR");


var $cNAxK = parcelRequire("cNAxK");


var $ff9it = parcelRequire("ff9it");

const $35f896f2bbb88bbe$export$f72a6b3071a7b2a5 = ({ query: query, locale: locale })=>{
    const language = locale.split('-')[0].toLowerCase();
    const queryWords = query.split(' ');
    const endsWithAQuestionMark = query.endsWith('?');
    const isLanguageWithSpaces = (0, $1ycSR.languagesWithSpaces).includes(language);
    const isLanguageWithoutSpaces = (0, $cNAxK.languagesWithoutSpaces).includes(language);
    const isLanguageSupported = isLanguageWithSpaces || isLanguageWithoutSpaces;
    if (isLanguageSupported && endsWithAQuestionMark && queryWords.length > 1) return true;
    if (isLanguageWithSpaces) {
        const languageQuestionWords = (0, $ff9it.questionWords)[language];
        return queryWords.some((queryWord)=>languageQuestionWords.includes(queryWord.toLocaleLowerCase(locale))) && queryWords.length > 1;
    }
    if (isLanguageWithoutSpaces) {
        const languageQuestionWords = language === 'zh' ? (0, $ff9it.questionWords)[locale.toLowerCase()] : (0, $ff9it.questionWords)[language];
        return languageQuestionWords.some((questionWord)=>query.includes(questionWord)) && query.length > 1;
    }
    return false;
};
module.exports["isQuestion"] = $35f896f2bbb88bbe$export$f72a6b3071a7b2a5;

});

parcelRegister("1ycSR", function(module, exports) {
// combined lists below make the complete list of languages we currently support for detection
const $a6d657773e301106$export$bd2c824c45156b2b = [
    'en',
    'de',
    'ru',
    'fr',
    'pt',
    'cs',
    'el'
];
module.exports["languagesWithSpaces"] = $a6d657773e301106$export$bd2c824c45156b2b;

});

parcelRegister("cNAxK", function(module, exports) {
const $72ac09375fa29c15$export$175fffd27b9ba43e = [
    'zh',
    'ja',
    'ko'
];
module.exports["languagesWithoutSpaces"] = $72ac09375fa29c15$export$175fffd27b9ba43e;

});

parcelRegister("ff9it", function(module, exports) {
// eslint-disable-next-line no-barrel-files/no-barrel-files


const $85a5184734448d8e$export$6f8f84a4a12a6044 = {
    en: [
        'who',
        'what',
        'when',
        'where',
        'why',
        'is',
        'how',
        'which',
        'do',
        'does',
        'are',
        'can',
        'does',
        'would',
        'will',
        'could',
        'should',
        'did',
        'has',
        'have',
        'was'
    ],
    de: [
        'wer',
        'was',
        'wann',
        'wo',
        'warum',
        'wie',
        'welcher',
        'wieviel'
    ],
    ru: [
        "\u0447\u0442\u043E",
        "\u043A\u043E\u0433\u0434\u0430",
        "\u0433\u0434\u0435",
        "\u043F\u043E\u0447\u0435\u043C\u0443",
        "\u043A\u0430\u043A",
        "\u043A\u0430\u043A\u043E\u0432\u0430",
        "\u043A\u0442\u043E",
        "\u043A\u0430\u043A\u043E\u0439",
        "\u0441\u043A\u043E\u043B\u044C\u043A\u043E",
        "\u0437\u0430\u0447\u0435\u043C",
        "\u043E\u0442\u043A\u0443\u0434\u0430",
        "\u043A\u0443\u0434\u0430"
    ],
    fr: [
        'qui',
        'quoi',
        "o\xf9",
        'quand',
        'pourquoi',
        'comment',
        'combien',
        'lequel',
        'quel',
        'quelle',
        'quels',
        'quelles'
    ],
    pt: [
        'que',
        'quem',
        'onde',
        'quando',
        'como',
        'quanto',
        'qual'
    ],
    cs: [
        'kdo',
        'co',
        'kdy',
        'kde',
        "pro\u010D",
        'jak',
        'kolik',
        "kter\xfd"
    ],
    el: [
        "\u03C4\u03B9",
        "\u03C0\u03BF\u03B9\u03BF\u03C2",
        "\u03C0\u03BF\u03B9\u03B1",
        "\u03C0\u03BF\u03B9\u03BF",
        "\u03C0\u03CC\u03C4\u03B5",
        "\u03C0\u03BF\u03CD",
        "\u03C0\u03CE\u03C2",
        "\u03B3\u03B9\u03B1\u03C4\u03AF",
        "\u03C0\u03CC\u03C3\u03BF"
    ],
    'zh-cn': [
        "\u4EC0\u4E48",
        "\u8C01",
        "\u54EA\u91CC",
        "\u4E3A\u4EC0\u4E48",
        "\u4F55\u65F6",
        "\u600E\u4E48",
        "\u54EA",
        "\u591A\u5C11"
    ],
    'zh-sg': [
        "\u4EC0\u4E48",
        "\u8C01",
        "\u54EA\u91CC",
        "\u4E3A\u4EC0\u4E48",
        "\u4F55\u65F6",
        "\u600E\u4E48",
        "\u54EA",
        "\u591A\u5C11"
    ],
    'zh-hk': [
        "\u4EC0\u9EBC",
        "\u70BA\u4EC0\u9EBC",
        "\u5728\u54EA\u88E1",
        "\u4F55\u6642",
        "\u8AB0",
        "\u54EA\u4E00\u500B",
        "\u5982\u4F55",
        "\u591A\u5C11"
    ],
    'zh-mo': [
        "\u4EC0\u9EBC",
        "\u70BA\u4EC0\u9EBC",
        "\u5728\u54EA\u88E1",
        "\u4F55\u6642",
        "\u8AB0",
        "\u54EA\u4E00\u500B",
        "\u5982\u4F55",
        "\u591A\u5C11"
    ],
    'zh-tw': [
        "\u4EC0\u9EBC",
        "\u70BA\u4EC0\u9EBC",
        "\u5728\u54EA\u88E1",
        "\u4F55\u6642",
        "\u8AB0",
        "\u54EA\u4E00\u500B",
        "\u5982\u4F55",
        "\u591A\u5C11"
    ],
    ja: [
        "\u4F55",
        "\u306A\u306B",
        "\u8AB0",
        "\u3060\u308C",
        "\u3069\u3053",
        "\u3069\u3046\u3057\u3066",
        "\u3044\u3064",
        "\u3069\u306E",
        "\u3044\u304F\u3064",
        "\u3069\u308C"
    ],
    ko: [
        "\uBB34\uC5C7",
        "\uBB50",
        "\uC5B4\uB514",
        "\uC5B8\uC81C",
        "\uC65C",
        "\uB204\uAD6C",
        "\uC5B4\uB5BB\uAC8C",
        "\uBA87",
        "\uC5B4\uB290"
    ]
};
module.exports["questionWords"] = $85a5184734448d8e$export$6f8f84a4a12a6044;

});

parcelRegister("c2fn3", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $f7lNm = parcelRequire("f7lNm");


var $ca96q = parcelRequire("ca96q");

// Jira-family product keys that support NL→JQL (jira, jira-product-discovery, jira-servicedesk).
// Used to guard against over-triggering JIRA_NATURAL_LANGUAGE_QUERY on non-Jira surfaces.
const $13e20894b1795bef$var$JIRA_FAMILY_APP_IDS = new Set([
    'jira',
    'jira-product-discovery',
    'jira-servicedesk'
]);
// temporaray solution for detecting query intent for new smart answers
// TODO: remove this once BE/ML solution is ready for use
function $13e20894b1795bef$var$detectQueryIntent(query, _cloudId) {
    const lowercaseQuery = query.toLowerCase();
    if (/^[a-z][a-z0-9_]+-\d+$/.test(lowercaseQuery) && (0, $dh538.fg)('kd_restrict_jira_issue_query_intent')) return (0, $f7lNm.QueryIntent).JIRA_ISSUE;
    if (/\w+-\d+/.test(lowercaseQuery) && !(0, $dh538.fg)('kd_restrict_jira_issue_query_intent')) return (0, $f7lNm.QueryIntent).JIRA_ISSUE;
    if (lowercaseQuery.endsWith(' agent') || lowercaseQuery.endsWith(' agents')) return (0, $f7lNm.QueryIntent).AGENT;
    return null;
}
const $13e20894b1795bef$export$af8ff827a7d12c1e = async ({ query: query, siteId: siteId, locale: locale, metadata: metadata, cloudId: cloudId, orgId: orgId, workspaceId: workspaceId, product: product, selectedProduct: selectedProduct, setQueryIntent: setQueryIntent, setTransformedQuery: setTransformedQuery, onError: onError })=>{
    const handleError = (error)=>{
        setQueryIntent((0, $f7lNm.QueryIntent).NONE);
        setTransformedQuery('');
        onError?.(error);
    };
    try {
        let queryIntent = $13e20894b1795bef$var$detectQueryIntent(query, cloudId);
        if (queryIntent) setQueryIntent(queryIntent);
        const aggResponse = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $ca96q.KnowledgeDiscoveryAnswerRouteQuery),
            variables: {
                query: query,
                siteId: siteId,
                locale: locale,
                orgId: orgId,
                ...metadata ? {
                    metadata: metadata
                } : {}
            },
            operationName: (0, $ca96q.ANSWER_ROUTE_OPERATION_NAME),
            cache: {
                ttl: 300000,
                key: query
            },
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        });
        const response = aggResponse?.data?.knowledgeDiscovery.smartAnswersRoute;
        if (!response || response?.__typename === 'QueryError' || Boolean(response?.message)) {
            // If we have a query intent, we can use the original query
            if (queryIntent) {
                if (queryIntent === (0, $f7lNm.QueryIntent).AGENT) {
                    setTransformedQuery(query.replace(' agent', '').replace(' Agent', ''));
                    return;
                }
                setTransformedQuery(query);
                return;
            }
            const error = new Error(response?.message || 'getSmartAnswerRoute error');
            handleError(error);
            return;
        }
        if (!queryIntent) {
            let beQueryIntent = response.route;
            if (beQueryIntent === (0, $f7lNm.QueryIntent).VISUAL && !(0, $dh538.fg)('hybrid_orchestrator_enable_image_search')) beQueryIntent = (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY;
            if (beQueryIntent === (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY && selectedProduct && !$13e20894b1795bef$var$JIRA_FAMILY_APP_IDS.has(selectedProduct) && (0, $dh538.fg)('kd_fix_sain_jira_nql_query_intent_overtriggering')) beQueryIntent = (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY;
            setQueryIntent(beQueryIntent);
        }
        if (queryIntent === (0, $f7lNm.QueryIntent).AGENT) {
            setTransformedQuery(query.replace(' agent', '').replace(' Agent', ''));
            return;
        }
        setTransformedQuery(response.transformedQuery);
    } catch (error) {
        handleError(error);
    }
};
module.exports["getSmartAnswerRoute"] = $13e20894b1795bef$export$af8ff827a7d12c1e;

});

parcelRegister("ca96q", function(module, exports) {
const $b4ee38bbfadb7dbb$export$9b6dcba7f888840b = 'KnowledgeDiscoveryAnswerRoute';
const $b4ee38bbfadb7dbb$export$87415d93715f6028 = `
  query ${$b4ee38bbfadb7dbb$export$9b6dcba7f888840b}(
    $siteId: String!
    $query: String!
    $locale: String!
    $metadata: KnowledgeDiscoveryMetadata
    $orgId: String
  ) {
    knowledgeDiscovery {
      smartAnswersRoute(
        siteId: $siteId
        query: $query
        locale: $locale
				metadata: $metadata
				orgId: $orgId
      ) {
        __typename
        ... on KnowledgeDiscoverySmartAnswersRoute {
          route
          transformedQuery
        }
        ... on QueryError {
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
    }
  }
`;
module.exports["ANSWER_ROUTE_OPERATION_NAME"] = $b4ee38bbfadb7dbb$export$9b6dcba7f888840b;
module.exports["KnowledgeDiscoveryAnswerRouteQuery"] = $b4ee38bbfadb7dbb$export$87415d93715f6028;

});

parcelRegister("brXu2", function(module, exports) {
const $ac75f08ed77f6c79$export$9973452e04e9a696 = (searchSessionId, cloudId, preloadDataProvider)=>{
    if (!cloudId || !preloadDataProvider) return;
    const preloadedSearchSessionId = preloadDataProvider.getPreloadedSearch({
        cloudId: cloudId
    })?.search?.generated?.searchSessionId;
    const currentSearchSessionId = searchSessionId.value();
    if (preloadedSearchSessionId && preloadedSearchSessionId !== currentSearchSessionId) searchSessionId.update(preloadedSearchSessionId);
};
module.exports["reconcileSsrSearchSessionId"] = $ac75f08ed77f6c79$export$9973452e04e9a696;

});

parcelRegister("bomBS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a2de3deabb017040488a53969ad0b6f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84b37978f45b293c$var$_react = $84b37978f45b293c$var$_interopRequireDefault((parcelRequire("42omo")));

var $84b37978f45b293c$var$_baseNew = $84b37978f45b293c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $84b37978f45b293c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CollapseHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element to its smallest size.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84b37978f45b293c$var$CollapseHorizontalIcon = (props)=>/*#__PURE__*/ $84b37978f45b293c$var$_react.default.createElement($84b37978f45b293c$var$_baseNew.default, Object.assign({
        name: "CollapseHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.25 0v16h1.5V0zm2.72 7.47a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06-1.97-1.97H16v-1.5h-3.69l1.97-1.97-1.06-1.06zM1.72 5.28l1.97 1.97H0v1.5h3.69l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06L2.78 4.22z"/>`
    }, props));
$84b37978f45b293c$var$CollapseHorizontalIcon.displayName = 'CollapseHorizontalIcon';
var $84b37978f45b293c$var$_default = module.exports.default = $84b37978f45b293c$var$CollapseHorizontalIcon;

});

parcelRegister("2Fqwa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bavCP = parcelRequire("bavCP");


var $gHANe = parcelRequire("gHANe");

const $8294bb1f8dce0d1c$export$38ee920e59704589 = ({ children: children })=>/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
        query: (0, $gHANe.UserContextQuery),
        __callerPackage__: "@confluence/navigation-search-dialog"
    }, ({ data: rawData, loading: loading })=>{
        const displayName = (rawData && rawData.user && rawData.user.displayName) ?? undefined;
        const id = (rawData && rawData.user && rawData.user.id) ?? undefined;
        const emails = rawData && rawData.user && rawData.user.emails || [];
        const email = emails.filter((email)=>email?.isPrimary).map((email)=>email?.value).find(Boolean) ?? undefined;
        return children({
            isLoading: loading,
            data: {
                email: email,
                id: id,
                name: displayName
            }
        });
    });
module.exports["UserContext"] = $8294bb1f8dce0d1c$export$38ee920e59704589;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $frIzR.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("gHANe", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $d5213b14145490b2$export$4dfd297558414f12 = (0, $eSUdr.default)`query UserContextQuery{user:confluence_atlassianUser(current:true){id displayName emails{value isPrimary}}}`;
module.exports["UserContextQuery"] = $d5213b14145490b2$export$4dfd297558414f12;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $bYUc2 = parcelRequire("bYUc2");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $ay6Zz.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: (0, $bYUc2.getIsNav4EnabledSafe)(),
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    const getNavigateToTeamsAppCallback = (0, $42omo.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
    return (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? getNavigateToTeamsAppCallback : getNavigateToTeamsApp;
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("cacu1", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lLRfG = parcelRequire("lLRfG");


var $dmHCt = parcelRequire("dmHCt");

const $94cd8136f02eb351$export$7999a9defd2c3cf4 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLRfG.PageLoadEnd), {
            metric: (0, $dmHCt.ADVANCED_SEARCH_PAGE_LOAD)
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLRfG.PageLoadEnd), {
        metric: (0, $dmHCt.ADVANCED_SEARCH_PAGE_LOAD)
    }));
const $94cd8136f02eb351$export$f397be5efb2fdcd6 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLRfG.PageLoadEnd), {
            metric: (0, $dmHCt.UNIFIED_SEARCH_PAGE_LOAD)
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLRfG.PageLoadEnd), {
        metric: (0, $dmHCt.UNIFIED_SEARCH_PAGE_LOAD)
    }));
module.exports["PageLoadEndEvent"] = $94cd8136f02eb351$export$7999a9defd2c3cf4;
module.exports["PageLoadEndEventUnifiedSearch"] = $94cd8136f02eb351$export$f397be5efb2fdcd6;

});

parcelRegister("lLRfG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cbc8g = parcelRequire("cbc8g");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $4291167636037428$var$PageLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasFiredRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $cbc8g.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $4291167636037428$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($4291167636037428$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $4291167636037428$export$570dec5b65c6715b;

});

parcelRegister("aJv6Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = Boolean(window.__SSR_REACT_STREAMING__) ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $4u5NT = parcelRequire("4u5NT");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $4u5NT.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $4u5NT.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("dmHCt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");

const $39eddf90ec2ee1a9$export$a92a425cb9f9c4ac = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.ADVANCED_SEARCH_LOAD_KEY)
});
const $39eddf90ec2ee1a9$export$8c056601d31b4cd5 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY)
});
const $39eddf90ec2ee1a9$export$db955b49fff67969 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY)
});
const $39eddf90ec2ee1a9$export$c9bd41426c856cf1 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY)
});
const $39eddf90ec2ee1a9$export$b390264dd924c8b1 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.UNIFIED_SEARCH_LOAD_KEY)
});
module.exports["ADVANCED_SEARCH_PAGE_LOAD"] = $39eddf90ec2ee1a9$export$a92a425cb9f9c4ac;
module.exports["ADVANCED_SEARCH_COMPONENT_PAGE_SEGMENT_LOAD"] = $39eddf90ec2ee1a9$export$8c056601d31b4cd5;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD"] = $39eddf90ec2ee1a9$export$db955b49fff67969;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_PAGE_SEGMENT_LOAD"] = $39eddf90ec2ee1a9$export$c9bd41426c856cf1;
module.exports["UNIFIED_SEARCH_PAGE_LOAD"] = $39eddf90ec2ee1a9$export$b390264dd924c8b1;

});

parcelRegister("lSOAM", function(module, exports) {
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");

var $kyiqo = parcelRequire("kyiqo");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("kyiqo", function(module, exports) {

var $bCz2F = parcelRequire("bCz2F");


var $bs5rD = parcelRequire("bs5rD");

const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};
module.exports["metrics"] = $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54;

});

parcelRegister("bCz2F", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $bs5rD = parcelRequire("bs5rD");

const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $bbc3e125622b0c90$export$370df09ecc3de059;

});

parcelRegister("bs5rD", function(module, exports) {

var $iuio5 = parcelRequire("iuio5");


var $boXf9 = parcelRequire("boXf9");


var $giQku = parcelRequire("giQku");


var $j4jXg = parcelRequire("j4jXg");

const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $d0aae4122f29b5ae$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $d0aae4122f29b5ae$export$94114666844d5f66;
module.exports["interaction"] = $d0aae4122f29b5ae$export$92473e6020ad89b4;
module.exports["custom"] = $d0aae4122f29b5ae$export$4c00f665f0d4b443;

});

parcelRegister("iuio5", function(module, exports) {

var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $4k3LC = parcelRequire("4k3LC");

class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $6456fd2c244bded5$export$efdd3e096bc27746;

});

parcelRegister("boXf9", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $7RgFv = parcelRequire("7RgFv");


var $lH7GJ = parcelRequire("lH7GJ");


var $11Zqj = parcelRequire("11Zqj");


var $j4jXg = parcelRequire("j4jXg");


var $3znwT = parcelRequire("3znwT");


var $69Zr8 = parcelRequire("69Zr8");


var $e9ZCR = parcelRequire("e9ZCR");

class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $b4ce8d24635e776a$export$3c51073271a9eac3;

});

parcelRegister("e9ZCR", function(module, exports) {

var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");

class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $fd3d2d441d340510$export$dc0d85d4d6503cd7;

});

parcelRegister("giQku", function(module, exports) {

var $h6RR2 = parcelRequire("h6RR2");


var $j4jXg = parcelRequire("j4jXg");


var $4k3LC = parcelRequire("4k3LC");


var $iuio5 = parcelRequire("iuio5");


var $69Zr8 = parcelRequire("69Zr8");

class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $4f83d9bff0211700$export$24c8bfcd77494cc1;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $cbc8g = parcelRequire("cbc8g");


var $kGwvc = parcelRequire("kGwvc");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $cbc8g.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $kGwvc.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $kGwvc.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
$parcel$export(module.exports, "createBM3PageSegmentLoadMetricRaw", () => $864083edfead32eb$export$2a2fe1e11b4e0413);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $kyiqo = parcelRequire("kyiqo");

const { pageSegmentLoad: $864083edfead32eb$export$2a2fe1e11b4e0413 } = (0, $kyiqo.metrics);

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("cs0rL")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $cs0rL = parcelRequire("cs0rL");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("19w2x", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6ttbq = parcelRequire("6ttbq");


var $83H3T = parcelRequire("83H3T");


var $dclyF = parcelRequire("dclyF");


var $hUAWL = parcelRequire("hUAWL");


var $2K5gO = parcelRequire("2K5gO");


var $4QtAs = parcelRequire("4QtAs");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $105205360274b3e9$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $105205360274b3e9$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $105205360274b3e9$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $105205360274b3e9$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $42omo.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    const setTimeout = (0, $2K5gO.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $hUAWL.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $6ttbq.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$105205360274b3e9$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $105205360274b3e9$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $105205360274b3e9$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $105205360274b3e9$export$a300664a1a230956;

});

parcelRegister("83H3T", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $42omo.useRef)(null);
    const setRef = (0, $42omo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $68de0fcb6733268f$export$ff879f35a69d56b7;

});

parcelRegister("hUAWL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $9fe18f2334f78b72$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $9fe18f2334f78b72$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $9fe18f2334f78b72$var$getHookDeps(opts));
    return (0, $42omo.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $9fe18f2334f78b72$export$1775f27e7c8051ca;

});

parcelRegister("4QtAs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dclyF = parcelRequire("dclyF");

const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $42omo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $0136602141ebd577$export$9e95200239cd148b;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("gHaxX", function(module, exports) {

var $973aB = parcelRequire("973aB");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/user/manifest.ts
var $c278d7dccfa97a86$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $973aB.IdentityUserAriResourceOwner),
    resourceType: (0, $973aB.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $c278d7dccfa97a86$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3NXcb.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $c278d7dccfa97a86$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $c278d7dccfa97a86$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $c278d7dccfa97a86$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $c278d7dccfa97a86$export$1e9d09c2be53e55e;

});

parcelRegister("973aB", function(module, exports) {
// src/identity/user/types.ts
var $6a2739fa6e7a2528$export$b4c14c54282a779d = "identity", $6a2739fa6e7a2528$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $6a2739fa6e7a2528$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $6a2739fa6e7a2528$export$e9b50e20f4fbfb71;

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("i0VEL", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $iu6m9 = parcelRequire("iu6m9");

class $1946187bbb294084$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $eTj7Y.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $1946187bbb294084$export$1185db7a00c13eed;

});

parcelRegister("kt8c2", function(module, exports) {

var $9Bict = parcelRequire("9Bict");

const $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $f62061dbe92ec1bb$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $f62061dbe92ec1bb$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $9Bict.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $f62061dbe92ec1bb$export$2e2bcd8739ae039;

});

parcelRegister("9Bict", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $21987ac45ee5412e$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $21987ac45ee5412e$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$21987ac45ee5412e$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $21987ac45ee5412e$export$efebfe7859cae3c7;

});

parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $i0VEL = parcelRequire("i0VEL");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("hR4U4", function(module, exports) {
const $991dc85317754fda$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $991dc85317754fda$export$bc36ebf73899a71d;

});

parcelRegister("hpNab", function(module, exports) {

var $kFwgS = parcelRequire("kFwgS");


var $9tQM5 = parcelRequire("9tQM5");

var $cfa17a27dec34885$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $cfa17a27dec34885$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $cfa17a27dec34885$var$pageAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$blogPostAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.edit,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.view
};
const $cfa17a27dec34885$var$whiteboardAllowedFeatures = {
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $cfa17a27dec34885$export$a3fda3dcee62e1cc.whiteboard
};
const $cfa17a27dec34885$var$contentTypeAllowedFeatures = {
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $cfa17a27dec34885$var$pageAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $cfa17a27dec34885$var$blogPostAllowedFeatures,
    [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $cfa17a27dec34885$var$whiteboardAllowedFeatures
};
const $cfa17a27dec34885$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$cfa17a27dec34885$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $cfa17a27dec34885$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $cfa17a27dec34885$export$3207c60940c4a9b0;

});

parcelRegister("kFwgS", function(module, exports) {
var $b38de1a13d5a6bb8$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $b38de1a13d5a6bb8$export$816ef638e478449a;

});

parcelRegister("9tQM5", function(module, exports) {
var $5b5865fbd831eb6d$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $5b5865fbd831eb6d$export$942a5fac9b8c9dc2;

});

parcelRegister("aWwYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4BDAe = parcelRequire("4BDAe");


var $6mKj3 = parcelRequire("6mKj3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $1P1Tu.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $9zUhf.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $42omo.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $42omo.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $42omo.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $42omo.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $9zUhf.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("4BDAe", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $bbe4d3361c67916e$var$noop = (props)=>{};
const $bbe4d3361c67916e$export$5f5debba1692bf40 = ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    if (!context) return {
        open: $bbe4d3361c67916e$var$noop,
        close: $bbe4d3361c67916e$var$noop,
        setPanelWidth: $bbe4d3361c67916e$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bbe4d3361c67916e$export$5f5debba1692bf40;

});

parcelRegister("fN3iy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $7FN4e = parcelRequire("7FN4e");


var $D92g9 = parcelRequire("D92g9");

const $1ec08acbc7c3653d$var$noop = ()=>{};
const $1ec08acbc7c3653d$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $1ec08acbc7c3653d$var$noop,
    onClose: $1ec08acbc7c3653d$var$noop
};
const $1ec08acbc7c3653d$export$f473d225913e225d = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $1ec08acbc7c3653d$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $1ec08acbc7c3653d$var$noop,
                onClose: $1ec08acbc7c3653d$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $D92g9.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $1ec08acbc7c3653d$var$initialState.onOpen,
                onClose: params.onClose || $1ec08acbc7c3653d$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $1ec08acbc7c3653d$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $7FN4e.usePanelWidth)((0, $dh538.fg)('nin_glance_panel_initial_width_ssr') ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $42omo.useReducer)($1ec08acbc7c3653d$var$previewPanelsReducer, {
        ...$1ec08acbc7c3653d$var$initialState,
        ...initialPanel && (0, $dh538.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $42omo.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $42omo.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $42omo.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $42omo.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1ec08acbc7c3653d$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $1ec08acbc7c3653d$export$609db4be92d0fad8 = ()=>{
    return (0, $42omo.useContext)($1ec08acbc7c3653d$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $1ec08acbc7c3653d$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $1ec08acbc7c3653d$export$609db4be92d0fad8;

});

parcelRegister("7FN4e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $awbqn = parcelRequire("awbqn");

const $426c7353872dcab1$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $42omo.useState)((0, $awbqn.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $42omo.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $42omo.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $42omo.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $42omo.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $42omo.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $42omo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $awbqn.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $426c7353872dcab1$export$82b270f291af5a5;

});

parcelRegister("awbqn", function(module, exports) {
const $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH = 400;
const $9ee4137247832c84$var$PANEL_MAX_WIDTH = 1000;
const $9ee4137247832c84$var$MINIMUM_WIDTH = 1800;
const $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $9ee4137247832c84$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $9ee4137247832c84$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $9ee4137247832c84$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $9ee4137247832c84$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $9ee4137247832c84$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $9ee4137247832c84$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $9ee4137247832c84$export$29ceecbfeef33bfc;

});

parcelRegister("D92g9", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");

const $101bde26e7a6d36a$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $k4HRJ.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $k4HRJ.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $101bde26e7a6d36a$export$eb89e687f2b278d7;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("52EPl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ccHMk = parcelRequire("ccHMk");


var $4JWgN = parcelRequire("4JWgN");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $loiTn = parcelRequire("loiTn");


var $ghftu = parcelRequire("ghftu");


var $kIK5c = parcelRequire("kIK5c");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $g5lKx = parcelRequire("g5lKx");


var $cmqV4 = parcelRequire("cmqV4");


var $4hF42 = parcelRequire("4hF42");


var $rTIrg = parcelRequire("rTIrg");


var $nVQ0B = parcelRequire("nVQ0B");


var $dhBFe = parcelRequire("dhBFe");


var $6XsRH = parcelRequire("6XsRH");

const $58fceacc21a186da$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $58fceacc21a186da$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $58fceacc21a186da$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${crossAxis}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-start`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $58fceacc21a186da$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ function $58fceacc21a186da$var$DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $g5lKx.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const id = (0, $6XsRH.default)();
    const itemRef = (0, $dhBFe.default)();
    const { currentLevel: currentLevel } = (0, $kIK5c.useLayering)();
    const fallbackPlacements = (0, $42omo.useMemo)(()=>$58fceacc21a186da$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $42omo.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        const isTabLeftOrEscapeKey = $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $4JWgN.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $4JWgN.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $4JWgN.KEY_LEFT))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4JWgN.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $nVQ0B.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...bindFocus,
                    ref: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4hF42.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $rTIrg.default), {
                        spacing: spacing,
                        maxHeight: $58fceacc21a186da$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $58fceacc21a186da$var$DropdownMenu = (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $dh538.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cmqV4.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, $l998X.jsx)($58fceacc21a186da$var$DropdownMenuLegacy, {
        ...props
    });
};
var $58fceacc21a186da$export$2e2bcd8739ae039 = $58fceacc21a186da$var$DropdownMenu;
module.exports["default"] = $58fceacc21a186da$export$2e2bcd8739ae039;

});

parcelRegister("6mkwk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b752f7534b8d0112$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $b752f7534b8d0112$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $42omo.useState)(getDefaultPropValue);
    const isControlledRef = (0, $42omo.useRef)(isControlled);
    (0, $42omo.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $42omo.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("cmqV4", function(module, exports) {
/* dropdown-menu-top-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fFa3V = parcelRequire("fFa3V");


var $ccHMk = parcelRequire("ccHMk");


var $4JWgN = parcelRequire("4JWgN");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $loiTn = parcelRequire("loiTn");


var $ghftu = parcelRequire("ghftu");


var $2SlZp = parcelRequire("2SlZp");


var $9hlns = parcelRequire("9hlns");


var $hFC20 = parcelRequire("hFC20");


var $bgEkj = parcelRequire("bgEkj");


var $1B1St = parcelRequire("1B1St");


var $nVQ0B = parcelRequire("nVQ0B");


var $dOnbq = parcelRequire("dOnbq");

var $JW5lP = parcelRequire("JW5lP");

const $1e16cab33633f070$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $1e16cab33633f070$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k",
    menuContent: "_2rkofajl _bfhk1bhr _16qs130s"
};
const $1e16cab33633f070$var$animation = (0, $hFC20.slideAndFade)(); /**
                                   * Event types produced by trigger interactions.
                                   *
                                   * - `React.MouseEvent<Element>` — from the trigger's `onClick` handler
                                   * - `React.KeyboardEvent<Element>` — from the trigger's `onClick` when activated via keyboard
                                   * - `KeyboardEvent` — native event from the ArrowDown `bind(window, ...)` listener
                                   */ 
function $1e16cab33633f070$var$isKeyboardTriggered(event) {
    if (event.type === 'keydown') return true;
    if ('clientX' in event && (event.clientX === 0 || event.clientY === 0)) return true;
    if (event.detail === 0) return true;
    return false;
} /**
   * Loading indicator for the dropdown menu.
   */ 
function $1e16cab33633f070$var$LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "menuitem",
        className: (0, $gMc0m.default)([
            $1e16cab33633f070$var$styles.spinnerContainer
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
} /**
   * Top-layer implementation of DropdownMenu.
   *
   * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
   * with native Popover API via `@atlaskit/top-layer`.
   *
   * What's no longer needed:
   * - Portal: top layer handles stacking natively
   * - FocusLock / react-focus-lock: popover=auto provides light dismiss
   * - z-index: top layer is always above everything
   * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
   * - handle-focus.tsx: replaced by `useArrowNavigation`
   * - Layering context: top layer nesting is handled by the browser
   * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
   */ 
function $1e16cab33633f070$var$DropdownMenuTopLayer({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $42omo.useRef)(null);
    const menuRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const topLayerPlacement = (0, $42omo.useMemo)(()=>(0, $bgEkj.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]); // ── Close handling ──
    // Focus restoration is handled natively by the Popover API:
    //   - Escape → browser restores focus to the trigger automatically
    //   - Click-outside → browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration — effectively overriding it.
    const handleOnClose = (0, $42omo.useCallback)(({ reason: _reason })=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]); // ── Trigger click handling ──
    const handleTriggerClicked = (0, $42omo.useCallback)((event)=>{
        const newValue = !isLocalOpen;
        setTriggeredUsingKeyboard($1e16cab33633f070$var$isKeyboardTriggered(event));
        setLocalIsOpen(newValue); // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: newValue,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)(); // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $42omo.useEffect)(()=>{
        if (!isFocused || isLocalOpen) return 0, $ee7An.default;
         // Don't open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = triggerRef.current?.closest('[role="menu"]') != null;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) setTriggeredUsingKeyboard(true);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]); // ── Arrow navigation ──
    // useArrowNavigation handles ArrowUp/Down, Home/End, and Tab-to-close
    // by querying focusable elements in the menu DOM container.
    const handleArrowClose = (0, $42omo.useCallback)(()=>{
        handleOnClose({
            reason: 'escape'
        });
    }, [
        handleOnClose
    ]);
    const handleNestedOpen = (0, $42omo.useCallback)(({ trigger: trigger })=>{
        trigger.click();
    }, []);
    const handleNestedClose = (0, $42omo.useCallback)(()=>{
        handleOnClose({
            reason: 'escape'
        });
    }, [
        handleOnClose
    ]);
    (0, $JW5lP.useArrowNavigation)({
        containerRef: menuRef,
        onClose: handleArrowClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleNestedClose,
        isEnabled: isLocalOpen,
        filter: (0, $JW5lP.isAtCurrentMenuLevel)
    }); // ── Auto-focus first item on open ──
    (0, $42omo.useEffect)(()=>{
        if (!isLocalOpen || !isTriggeredUsingKeyboard && !autoFocus) return;
        requestAnimationFrame(()=>{
            const menu = menuRef.current;
            if (!menu) return;
            const firstItem = (0, $dOnbq.getFirstFocusable)({
                container: menu
            });
            firstItem?.focus();
        });
    }, [
        isLocalOpen,
        isTriggeredUsingKeyboard,
        autoFocus
    ]); // shouldFitContainer is handled by the width prop on Popup.Content below.
    const popupContentWidth = shouldFitContainer ? 'min-trigger' : 'content'; // ── Close on menu item click ──
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested triggers (items with aria-haspopup).
    const handleMenuClick = (0, $42omo.useCallback)((e)=>{
        const target = e.target;
        const menuItem = target.closest?.('[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio'; // Don't close the menu when clicking a nested trigger (aria-haspopup).
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger = menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $nVQ0B.default), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1B1St.Popup), {
            placement: topLayerPlacement,
            onClose: handleOnClose,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1B1St.Popup).TriggerFunction, {
                    children: ({ ref: ref, toggle: _toggle, ariaAttributes: ariaAttributes })=>{
                        const combinedRef = (0, $3654r.default)([
                            ref,
                            triggerRef
                        ]); // FUDGE(top-layer-api): cast `ariaAttributes` to the narrow shape that adopter
                        // public types expect. `@atlaskit/top-layer` types `aria-haspopup` as the wider
                        // WAI-ARIA union (boolean | 'dialog' | 'menu' | 'listbox' | 'tree' | 'grid'),
                        // but the public `CustomTriggerProps` (extending `@atlaskit/popup` `TriggerProps`)
                        // is intentionally kept narrow (boolean | 'dialog') because the top-layer API
                        // surface is not yet settled. The runtime value is unchanged; only the
                        // TypeScript-visible type is narrowed at this boundary.
                        // REMOVE WHEN: the top-layer public API is committed (see
                        // packages/design-system/top-layer/notes/decisions/migration-roadmap.md "Open API
                        // decisions deferred to a follow-up PR") and a follow-up `minor` PR widens
                        // `TriggerProps['aria-haspopup']` on `@atlaskit/popup` to match.
                        const narrowAriaAttributes = ariaAttributes;
                        if (typeof trigger === 'function') return trigger({
                            ...narrowAriaAttributes,
                            ...bindFocus,
                            triggerRef: combinedRef,
                            isSelected: isLocalOpen,
                            onClick: handleTriggerClicked,
                            testId: testId && `${testId}--trigger`
                        });
                        return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            ...bindFocus,
                            ref: combinedRef,
                            ...narrowAriaAttributes,
                            isSelected: isLocalOpen,
                            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            onClick: handleTriggerClicked,
                            testId: testId && `${testId}--trigger`,
                            "aria-label": label,
                            interactionName: interactionName,
                            children: trigger
                        });
                    }
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1B1St.Popup).Content, {
                    role: "menu",
                    label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
                    isOpen: isLocalOpen,
                    animate: $1e16cab33633f070$var$animation,
                    width: popupContentWidth,
                    testId: testId && `${testId}--content`,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        ref: menuRef,
                        className: (0, $gMc0m.default)([
                            $1e16cab33633f070$var$styles.menuContent
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
                            isLoading: isLoading,
                            maxHeight: $1e16cab33633f070$var$MAX_HEIGHT,
                            maxWidth: shouldFitContainer ? undefined : 800,
                            onClick: handleMenuClick,
                            role: "menu",
                            spacing: spacing,
                            testId: testId && `${testId}--menu-wrapper--menu-group`,
                            menuLabel: menuLabel,
                            children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)($1e16cab33633f070$var$LoadingIndicator, {
                                statusLabel: statusLabel,
                                testId: testId && `${testId}--menu-wrapper--loading-indicator`
                            }) : children
                        })
                    })
                })
            ]
        })
    });
}
var $1e16cab33633f070$export$2e2bcd8739ae039 = $1e16cab33633f070$var$DropdownMenuTopLayer;
module.exports["default"] = $1e16cab33633f070$export$2e2bcd8739ae039;

});

parcelRegister("nVQ0B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5g4rt = parcelRequire("5g4rt");

/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $02b3fc6de2f24ae9$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $42omo.useRef)({});
    const context = (0, $42omo.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5g4rt.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
var $02b3fc6de2f24ae9$export$2e2bcd8739ae039 = $02b3fc6de2f24ae9$var$SelectionStore;
module.exports["default"] = $02b3fc6de2f24ae9$export$2e2bcd8739ae039;

});

parcelRegister("5g4rt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $19b5453b5db39d0b$export$756f795847463ebd = /*#__PURE__*/ (0, $42omo.createContext)({
    setItemState: (0, $ee7An.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $ee7An.default),
    getGroupState: ()=>({})
});
module.exports["SelectionStoreContext"] = $19b5453b5db39d0b$export$756f795847463ebd;

});

parcelRegister("4hF42", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $kIK5c = parcelRequire("kIK5c");


var $ijhQY = parcelRequire("ijhQY");


var $6wMCT = parcelRequire("6wMCT");

/**
 * Focus manager logic.
 */ const $72bf3d2a48c5b2ec$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $42omo.useState)(0);
    const registerMode = (0, $42omo.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $kIK5c.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $42omo.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $42omo.useEffect)(()=>(0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $ijhQY.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6wMCT.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $72bf3d2a48c5b2ec$export$2e2bcd8739ae039 = $72bf3d2a48c5b2ec$var$FocusManager;
module.exports["default"] = $72bf3d2a48c5b2ec$export$2e2bcd8739ae039;

});

parcelRegister("ijhQY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb43cdb6098a100$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");


var $dh538 = parcelRequire("dh538");


var $6XsRH = parcelRequire("6XsRH");

const $8cb43cdb6098a100$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $8cb43cdb6098a100$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $6XsRH.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $4JWgN.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $4JWgN.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $8cb43cdb6098a100$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("6XsRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec4c4b23458ff7f$export$2e2bcd8739ae039);

var $c0qxy = parcelRequire("c0qxy");

const $6ec4c4b23458ff7f$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $6ec4c4b23458ff7f$export$2e2bcd8739ae039() {
    const id = (0, $c0qxy.useId)();
    return `${$6ec4c4b23458ff7f$export$8a682ae47622dbb9}${id}`;
}
module.exports["PREFIX"] = $6ec4c4b23458ff7f$export$8a682ae47622dbb9;

});

parcelRegister("6wMCT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $ad89860a791bab0b$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
module.exports["FocusManagerContext"] = $ad89860a791bab0b$export$f18c1d4fc7326096;

});

parcelRegister("rTIrg", function(module, exports) {
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $51SOF = parcelRequire("51SOF");


var $4AsMp = parcelRequire("4AsMp");


var $6wMCT = parcelRequire("6wMCT");

const $b799d0b248957a2a$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
const $b799d0b248957a2a$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b799d0b248957a2a$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    }); /**
          *
          * MenuWrapper wraps all the menu items.
          * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
          * if a CheckboxItem or RadioItem is clicked.
          * It also sets focus to the first menu item when opened.
          */ 
const $b799d0b248957a2a$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $6wMCT.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $51SOF.default)(menuItem) || (0, $4AsMp.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        }); // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $42omo.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $dh538.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)($b799d0b248957a2a$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $b799d0b248957a2a$export$2e2bcd8739ae039 = $b799d0b248957a2a$var$MenuWrapper;
module.exports["default"] = $b799d0b248957a2a$export$2e2bcd8739ae039;

});

parcelRegister("51SOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e12d4b588eba9c45$export$2e2bcd8739ae039);
function $e12d4b588eba9c45$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("4AsMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1db4379970383b$export$2e2bcd8739ae039);
function $9b1db4379970383b$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("dhBFe", function(module, exports) {
// eslint-disable-next-line sort-imports

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $6wMCT = parcelRequire("6wMCT");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $167560b2a39794c6$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $6wMCT.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (hasPopup && (0, $dh538.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $167560b2a39794c6$export$2e2bcd8739ae039 = $167560b2a39794c6$var$useRegisterItemWithFocusManager;
module.exports["default"] = $167560b2a39794c6$export$2e2bcd8739ae039;

});

parcelRegister("4AkKf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82ab01af3f80a4391aaf33fbaff15a85>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $356a9dc0786a9256$var$_react = $356a9dc0786a9256$var$_interopRequireDefault((parcelRequire("42omo")));

var $356a9dc0786a9256$var$_baseNew = $356a9dc0786a9256$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $356a9dc0786a9256$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $356a9dc0786a9256$var$FilterIcon = (props)=>/*#__PURE__*/ $356a9dc0786a9256$var$_react.default.createElement($356a9dc0786a9256$var$_baseNew.default, Object.assign({
        name: "FilterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-2 5.25H3v-1.5h10zM11 14H5v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$356a9dc0786a9256$var$FilterIcon.displayName = 'FilterIcon';
var $356a9dc0786a9256$var$_default = module.exports.default = $356a9dc0786a9256$var$FilterIcon;

});

parcelRegister("dAYOx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");


var $d77M1 = parcelRequire("d77M1");


var $cGtPE = parcelRequire("cGtPE");


var $dhBFe = parcelRequire("dhBFe");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $cdf608dda9733d23$var$DropdownMenuItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $dhBFe.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $42omo.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
});
var $cdf608dda9733d23$export$2e2bcd8739ae039 = $cdf608dda9733d23$var$DropdownMenuItem;
module.exports["default"] = $cdf608dda9733d23$export$2e2bcd8739ae039;

});

parcelRegister("ahaN7", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $88990be4c91574c4$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $88990be4c91574c4$export$2e2bcd8739ae039 = $88990be4c91574c4$var$DropdownMenuItemGroup;
module.exports["default"] = $88990be4c91574c4$export$2e2bcd8739ae039;

});

parcelRegister("2UQGL", function(module, exports) {
/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $19018ee1ec1e6aca$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $19018ee1ec1e6aca$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $19018ee1ec1e6aca$var$styles.heading,
        children: title
    });
var $19018ee1ec1e6aca$export$2e2bcd8739ae039 = $19018ee1ec1e6aca$var$GroupTitle;
module.exports["default"] = $19018ee1ec1e6aca$export$2e2bcd8739ae039;

});

parcelRegister("3pU8m", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $7p5xt = parcelRequire("7p5xt");


var $56M4r = parcelRequire("56M4r");


var $iTh4n = parcelRequire("iTh4n");


var $jwNgW = parcelRequire("jwNgW");


var $dhBFe = parcelRequire("dhBFe");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $a61a6d10c0a933b0$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $ee7An.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $kyRHQ;
    const [selected, setSelected] = (0, $jwNgW.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $42omo.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $dhBFe.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7p5xt.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, $iTh4n.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest,
            children: children
        })
    });
};
var $a61a6d10c0a933b0$export$2e2bcd8739ae039 = $a61a6d10c0a933b0$var$DropdownItemCheckbox;
module.exports["default"] = $a61a6d10c0a933b0$export$2e2bcd8739ae039;

});

parcelRegister("iTh4n", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $ade312c7505f4d8d$var$svgStyles = null; /**
                         * __Checkbox icon__
                         *
                         * Used to visually represent the selected state in DropdownItemCheckbox
                         *
                         * @internal
                         */ 
const $ade312c7505f4d8d$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $ade312c7505f4d8d$export$2e2bcd8739ae039 = $ade312c7505f4d8d$var$CheckboxIcon;
module.exports["default"] = $ade312c7505f4d8d$export$2e2bcd8739ae039;

});

parcelRegister("jwNgW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1FJYC = parcelRequire("1FJYC");


var $5g4rt = parcelRequire("5g4rt");

/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $05848c92b720c3b2$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $42omo.useContext)((0, $5g4rt.SelectionStoreContext));
    const groupId = (0, $42omo.useContext)((0, $1FJYC.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $42omo.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $42omo.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $05848c92b720c3b2$export$2e2bcd8739ae039 = $05848c92b720c3b2$var$useCheckboxState;
module.exports["default"] = $05848c92b720c3b2$export$2e2bcd8739ae039;

});

parcelRegister("1FJYC", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5d17552b6cb2fab4$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $42omo.createContext)('');
module.exports["CheckboxGroupContext"] = $5d17552b6cb2fab4$export$baf37c4be89255b8;

});

parcelRegister("fKL7x", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");


var $1FJYC = parcelRequire("1FJYC");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $b6be4855f2bf1ca8$var$DropdownItemCheckboxGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1FJYC.CheckboxGroupContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $b6be4855f2bf1ca8$export$2e2bcd8739ae039 = $b6be4855f2bf1ca8$var$DropdownItemCheckboxGroup;
module.exports["default"] = $b6be4855f2bf1ca8$export$2e2bcd8739ae039;

});

parcelRegister("eyfm5", function(module, exports) {
const $6fd46c311db8d44c$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });
module.exports["listItem"] = $6fd46c311db8d44c$export$76c7e83ecc9cdf05;

});

parcelRegister("2FFuS", function(module, exports) {

var $enilC = parcelRequire("enilC");

const $a4fc62108e90d067$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $enilC.createTextNodes)(content)
    });
module.exports["paragraph"] = $a4fc62108e90d067$export$9c206ddddb32a9b;

});

parcelRegister("enilC", function(module, exports) {

var $aoDcQ = parcelRequire("aoDcQ");

function $b397a3d9dc60a40a$export$3a269a5941b62f04(nodes) {
    return nodes.map($b397a3d9dc60a40a$export$72b9432ea0656b50);
}
function $b397a3d9dc60a40a$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $aoDcQ.text)(str) : str;
}
module.exports["createTextNodes"] = $b397a3d9dc60a40a$export$3a269a5941b62f04;

});

parcelRegister("aoDcQ", function(module, exports) {
const $cb8b1b1eb7a280a9$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });
module.exports["text"] = $cb8b1b1eb7a280a9$export$6f093cfa640b7166;

});

parcelRegister("2daQU", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("aqrhZ", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("96msn")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("96msn")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("96msn")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $lhchg = parcelRequire("lhchg");


var $96msn = parcelRequire("96msn");

parcelRequire("1BwGq");
var $jnAB4 = parcelRequire("jnAB4");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("eow39");
var $jyd5r = parcelRequire("jyd5r");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");


var $iYRNV = parcelRequire("iYRNV");


});

parcelRegister("8dgvm", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("dXZzO")).MODE);

var $dXZzO = parcelRequire("dXZzO");

const $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN = undefined;
const $5fac572772fbabda$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $5fac572772fbabda$var$DEFAULT_MODE = (0, $dXZzO.MODE).HYDRATE;
const $5fac572772fbabda$var$DEFAULT_RETRY = 2;
const $5fac572772fbabda$var$config = {
    crossOrigin: $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN,
    manifest: $5fac572772fbabda$var$DEFAULT_MANIFEST,
    mode: $5fac572772fbabda$var$DEFAULT_MODE,
    retry: $5fac572772fbabda$var$DEFAULT_RETRY
};
const $5fac572772fbabda$export$44487a86467333c3 = ()=>$5fac572772fbabda$var$config;
const $5fac572772fbabda$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $5fac572772fbabda$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $5fac572772fbabda$var$DEFAULT_CROSS_ORIGIN;
    $5fac572772fbabda$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $5fac572772fbabda$var$DEFAULT_MANIFEST;
    $5fac572772fbabda$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $5fac572772fbabda$var$DEFAULT_MODE;
    $5fac572772fbabda$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $5fac572772fbabda$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $5fac572772fbabda$export$44487a86467333c3;
module.exports["setConfig"] = $5fac572772fbabda$export$940a7873bb071df8;

});

parcelRegister("dXZzO", function(module, exports) {
const $a2b08cde192cf1ec$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $a2b08cde192cf1ec$export$e48589d9e4824227;

});

parcelRegister("lhchg", function(module, exports) {

var $89YVk = parcelRequire("89YVk");


var $8dgvm = parcelRequire("8dgvm");

parcelRequire("ecrVx");
var $4CMiD = parcelRequire("4CMiD");
var $6y0vU = parcelRequire("6y0vU");


var $27zaj = parcelRequire("27zaj");

const $f7d4b5876658b264$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $8dgvm.setConfig)(config);
        (0, $4CMiD.LISTENERS).length = 0;
        (0, $6y0vU.setCurrent)(0);
        if (!(0, $27zaj.isNodeEnvironment)()) (0, $89YVk.collect)();
    }
};

});

parcelRegister("89YVk", function(module, exports) {

var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");


var $8lfql = parcelRequire("8lfql");


var $3iPPT = parcelRequire("3iPPT");

const $5f0e6c234ea4c71a$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $8dgvm.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $dXZzO.MODE).RENDER ? (0, $8lfql.cloneElements)(markers[i], lazyBegin) : (0, $3iPPT.refElements)(markers[i], lazyBegin);
        if ((0, $euF6Z.COLLECTED).has(lazyBegin)) (0, $euF6Z.COLLECTED).get(lazyBegin).push(value);
        else (0, $euF6Z.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $5f0e6c234ea4c71a$export$bb44f104e3c54dae;

});

parcelRegister("euF6Z", function(module, exports) {
const $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $a8d3c1fdc5de2df2$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $a8d3c1fdc5de2df2$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $a8d3c1fdc5de2df2$export$4831ef3968ea94ef;

});

parcelRegister("8lfql", function(module, exports) {
const $612c3fc5c2a28c4f$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $612c3fc5c2a28c4f$export$c42217d53a7ebafb;

});

parcelRegister("3iPPT", function(module, exports) {
const $267b431587227d50$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $267b431587227d50$export$c69443129766a7fc;

});

parcelRegister("ecrVx", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("6y0vU")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("6y0vU")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("6y0vU")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("4CMiD")).LISTENERS);

var $6y0vU = parcelRequire("6y0vU");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");


});

parcelRegister("6y0vU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $euF6Z = parcelRequire("euF6Z");


var $4CMiD = parcelRequire("4CMiD");


var $ilgZx = parcelRequire("ilgZx");

let $4c46510d73a23c1f$var$CURRENT_PHASE = (0, $euF6Z.PHASE).PAINT;
const $4c46510d73a23c1f$export$5f80f094fd31fffd = (phase)=>{
    $4c46510d73a23c1f$var$CURRENT_PHASE = phase;
    (0, $4CMiD.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $4c46510d73a23c1f$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: (0, $ilgZx.createSubscribe)((0, $4CMiD.LISTENERS)),
    currentValue: ()=>$4c46510d73a23c1f$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$4c46510d73a23c1f$export$5f80f094fd31fffd((0, $euF6Z.PHASE).PAINT)
    }
});
const $4c46510d73a23c1f$export$1dc361b277327f88 = ()=>{
    const v = (0, $42omo.useContext)($4c46510d73a23c1f$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $4c46510d73a23c1f$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $4c46510d73a23c1f$export$5a25eca35e5debcb;
module.exports["useLazyPhase"] = $4c46510d73a23c1f$export$1dc361b277327f88;

});

parcelRegister("4CMiD", function(module, exports) {
const $35e02d56e6163baa$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $35e02d56e6163baa$export$81b9c458a026d68f;

});

parcelRegister("ilgZx", function(module, exports) {
const $d5a75e5021e4308a$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $d5a75e5021e4308a$export$364097d812234b3f;

});

parcelRegister("27zaj", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("7zmsS")).default);

var $7zmsS = parcelRequire("7zmsS");

const $18b7834f7092bd86$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $18b7834f7092bd86$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $18b7834f7092bd86$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $18b7834f7092bd86$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $18b7834f7092bd86$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $18b7834f7092bd86$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $18b7834f7092bd86$export$283635c04a02cc36;
module.exports["attrToProp"] = $18b7834f7092bd86$export$62bf630d0de3d781;

});

parcelRegister("7zmsS", function(module, exports) {
$parcel$export(module.exports, "default", () => $582d3a4d2ad75f69$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $582d3a4d2ad75f69$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("96msn", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");


var $27zaj = parcelRequire("27zaj");
var $7zmsS = parcelRequire("7zmsS");


var $k001K = parcelRequire("k001K");


var $1r9rN = parcelRequire("1r9rN");


var $2niqO = parcelRequire("2niqO");


var $aAlyb = parcelRequire("aAlyb");


var $1C3RC = parcelRequire("1C3RC");


var $1Bcgq = parcelRequire("1Bcgq");


var $fLvpO = parcelRequire("fLvpO");

function $6a061803acf54fcf$var$_extends() {
    $6a061803acf54fcf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a061803acf54fcf$var$_extends.apply(this, arguments);
}
function $6a061803acf54fcf$var$lazyProxy(_loader, { defer: defer = (0, $euF6Z.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $27zaj.isNodeEnvironment)();
    const dataLazyId = (0, $7zmsS.default)(moduleId);
    const LazyInternal = isServer ? (0, $2niqO.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $1r9rN.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $aAlyb.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $8dgvm.getConfig)();
                return (0, $1Bcgq.retry)(_loader, {
                    delay: (0, $k001K.RETRY_DELAY),
                    factor: (0, $k001K.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $27zaj.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $8dgvm.getConfig)();
        return (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $euF6Z.PHASE).PAINT ? (0, $k001K.PRIORITY).HIGH : (0, $k001K.PRIORITY).LOW;
        return (0, $1C3RC.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6a061803acf54fcf$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $euF6Z.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $euF6Z.PHASE).LAZY
    }
};
function $6a061803acf54fcf$export$c952e5f94576010e(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6a061803acf54fcf$export$291dd592399bdafa(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6a061803acf54fcf$export$488013bae63b21da(loader, opts) {
    return $6a061803acf54fcf$var$lazyProxy(loader, $6a061803acf54fcf$var$_extends({}, $6a061803acf54fcf$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6a061803acf54fcf$export$c952e5f94576010e;
module.exports["lazyAfterPaint"] = $6a061803acf54fcf$export$291dd592399bdafa;
module.exports["lazy"] = $6a061803acf54fcf$export$488013bae63b21da;

});

parcelRegister("aQIfl", function(module, exports) {
const $0209d2ec05e7d0da$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $0209d2ec05e7d0da$export$303f43e55cf1ef2f;

});

parcelRegister("k001K", function(module, exports) {
const $e8f3d428f2749473$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $e8f3d428f2749473$export$a339266ad71b2447 = 300;
const $e8f3d428f2749473$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $e8f3d428f2749473$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $e8f3d428f2749473$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $e8f3d428f2749473$export$ba64c908e55507fe;

});

parcelRegister("1r9rN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");
var $dXZzO = parcelRequire("dXZzO");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("1BwGq");
var $9uVEz = parcelRequire("9uVEz");

parcelRequire("ecrVx");
var $6y0vU = parcelRequire("6y0vU");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $k001K = parcelRequire("k001K");


var $fLvpO = parcelRequire("fLvpO");


var $8VyCG = parcelRequire("8VyCG");


var $femay = parcelRequire("femay");


var $1C3RC = parcelRequire("1C3RC");


var $iYRNV = parcelRequire("iYRNV");


var $36I1o = parcelRequire("36I1o");

function $10bfa415480e5081$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $42omo.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $42omo.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $euF6Z.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $42omo.useContext)((0, $iYRNV.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $fLvpO.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $36I1o.useSubscription)({
            context: (0, $9uVEz.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $euF6Z.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $36I1o.useSubscription)({
                context: (0, $6y0vU.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $42omo.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $1C3RC.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $k001K.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        (0, $42omo.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $euF6Z.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $8dgvm.getConfig)().mode === (0, $dXZzO.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8VyCG.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $femay.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $10bfa415480e5081$export$6898b5504b58699a;

});

parcelRegister("1BwGq", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("9uVEz")).WaitContext);

var $9uVEz = parcelRequire("9uVEz");


var $jnAB4 = parcelRequire("jnAB4");


});

parcelRegister("9uVEz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jLShN = parcelRequire("jLShN");

const $6ea3a326e6c1ad89$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $42omo.createContext)({
    subscribe: ()=>(0, $jLShN.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $6ea3a326e6c1ad89$export$9ba3fe09d15de47b;

});

parcelRegister("jLShN", function(module, exports) {
const $e64c8432c5ffa90e$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $e64c8432c5ffa90e$export$276c7dbda7675aec;

});

parcelRegister("jnAB4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9uVEz = parcelRequire("9uVEz");

const $e1bc8db03d394dff$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $42omo.useContext)((0, $9uVEz.WaitContext));
    const value = (0, $42omo.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $42omo.useRef)(new Set());
    const api = (0, $42omo.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $42omo.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9uVEz.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("eow39", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("jyd5r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("h5RZ7")).LazySuspenseContext);

var $jyd5r = parcelRequire("jyd5r");


var $h5RZ7 = parcelRequire("h5RZ7");


});

parcelRegister("jyd5r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");


var $h5RZ7 = parcelRequire("h5RZ7");

class $e3bb580fd9a2f323$export$256c542058532d6f extends (0, $42omo.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h5RZ7.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $27zaj.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $42omo.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $e3bb580fd9a2f323$export$256c542058532d6f;

});

parcelRegister("h5RZ7", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c71cc793aab4db4d$export$c33990e84065970c = /*#__PURE__*/ (0, $42omo.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $c71cc793aab4db4d$export$c33990e84065970c;

});

parcelRegister("fLvpO", function(module, exports) {
const $b7a39d38ff5e8305$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $b7a39d38ff5e8305$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$b7a39d38ff5e8305$export$6aa69c1258005366]: true
    });
    return error;
};
const $b7a39d38ff5e8305$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($b7a39d38ff5e8305$export$6aa69c1258005366);
module.exports["createLoaderError"] = $b7a39d38ff5e8305$export$c73a6a6f0bf7d425;

});

parcelRegister("8VyCG", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $67fe80fcd34326f0$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $67fe80fcd34326f0$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $42omo.useRef)(null);
    const { current: ssrDomNodes } = (0, $42omo.useRef)(content || []);
    (0, $42omo.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($67fe80fcd34326f0$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $67fe80fcd34326f0$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $67fe80fcd34326f0$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $67fe80fcd34326f0$export$d55db778a3e1446b;

});

parcelRegister("femay", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $27zaj = parcelRequire("27zaj");

function $b1695c2d5acdcbdf$var$_extends() {
    $b1695c2d5acdcbdf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b1695c2d5acdcbdf$var$_extends.apply(this, arguments);
}
const $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $27zaj.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $42omo.createElement)((0, $42omo.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $42omo.createElement)(tagName.toLowerCase(), $b1695c2d5acdcbdf$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $b1695c2d5acdcbdf$export$ca5b8fbc835d95e4;

});

parcelRegister("1C3RC", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");


var $27zaj = parcelRequire("27zaj");


var $k001K = parcelRequire("k001K");


var $1J5yR = parcelRequire("1J5yR");


var $iYRNV = parcelRequire("iYRNV");

function $12cc564e7e862135$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $8dgvm.getConfig)();
    const assets = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1J5yR.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $12cc564e7e862135$var$fakePromise = {
    then: ()=>$12cc564e7e862135$var$fakePromise,
    catch: ()=>$12cc564e7e862135$var$fakePromise,
    finally: ()=>$12cc564e7e862135$var$fakePromise
};
function $12cc564e7e862135$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1J5yR.insertLinkTag)(href, rel));
        return $12cc564e7e862135$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $12cc564e7e862135$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $jLShN.noopCleanup;
}
function $12cc564e7e862135$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $27zaj.isNodeEnvironment)()) return 0, $jLShN.noopCleanup;
    (_GlobalReactLooselyLa = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $k001K.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $12cc564e7e862135$export$3af04dbcb01bad4d,
        $12cc564e7e862135$export$1046fd6a49d5e7a,
        $12cc564e7e862135$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $jLShN.noopCleanup;
}
module.exports["preloadAsset"] = $12cc564e7e862135$export$25bad4aa00c45355;

});

parcelRegister("1J5yR", function(module, exports) {

var $iYRNV = parcelRequire("iYRNV");


var $jLShN = parcelRequire("jLShN");


var $8dgvm = parcelRequire("8dgvm");

function $141e4ec3ad408220$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $jLShN.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $8dgvm.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $iYRNV.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $141e4ec3ad408220$export$6610512821c8a4ce;

});

parcelRegister("iYRNV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dd1790f807a46380$export$e2d53c0cbedd2710 = {
    current: null
};
const $dd1790f807a46380$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $42omo.createContext)($dd1790f807a46380$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $dd1790f807a46380$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $dd1790f807a46380$export$8146ab57a3f7a7cb;

});

parcelRegister("36I1o", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $2434146821c65301$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $42omo.useContext)(context);
    (0, $42omo.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $2434146821c65301$export$368b4214baeb914c;

});

parcelRegister("2niqO", function(module, exports) {

var $aQIfl = parcelRequire("aQIfl");


var $42omo = parcelRequire("42omo");


var $8dgvm = parcelRequire("8dgvm");


var $euF6Z = parcelRequire("euF6Z");

parcelRequire("eow39");
var $h5RZ7 = parcelRequire("h5RZ7");


var $27zaj = parcelRequire("27zaj");


var $fLvpO = parcelRequire("fLvpO");

function $1bac06d947c9671a$var$load(moduleId, loader) {
    try {
        return (0, $27zaj.getExport)(loader());
    } catch (err) {
        throw (0, $fLvpO.createLoaderError)(err);
    }
}
function $1bac06d947c9671a$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $1bac06d947c9671a$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $42omo.useContext)((0, $h5RZ7.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $8dgvm.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $euF6Z.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $aQIfl.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("link", {
                key: url,
                rel: defer === (0, $euF6Z.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $1bac06d947c9671a$export$eb2e4b04351cdd9e;

});

parcelRegister("aAlyb", function(module, exports) {
const $7b4dfb9d7bf38586$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $7b4dfb9d7bf38586$export$e673efccd97e4223;

});

parcelRegister("1Bcgq", function(module, exports) {
const $12a2c288067cec34$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $12a2c288067cec34$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $12a2c288067cec34$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $12a2c288067cec34$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $12a2c288067cec34$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $12a2c288067cec34$var$calculateDelay(context, policy);
        if (delay) await $12a2c288067cec34$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $12a2c288067cec34$export$9369b12211e1fce4;

});

parcelRegister("I1nNR", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $chRg6 = parcelRequire("chRg6");

const $7834fba73424be0b$export$a54013f0d02a8f82 = ({ children: children, locale: incomingLocale = (0, $chRg6.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $42omo.useState)();
    const locale = (0, $42omo.useMemo)(()=>(0, $chRg6.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $chRg6.DEFAULT_LOCALE),
        children: children
    });
};
module.exports["I18nProvider"] = $7834fba73424be0b$export$a54013f0d02a8f82;

});

parcelRegister("chRg6", function(module, exports) {
const $22ba11b592de8836$var$DEFAULT_LANGUAGE = 'en';
const $22ba11b592de8836$var$DEFAULT_REGION = 'US';
const $22ba11b592de8836$export$1af4c7e47ad72f44 = `${$22ba11b592de8836$var$DEFAULT_LANGUAGE}-${$22ba11b592de8836$var$DEFAULT_REGION}`;
const $22ba11b592de8836$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $22ba11b592de8836$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $22ba11b592de8836$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $22ba11b592de8836$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $22ba11b592de8836$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $22ba11b592de8836$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $22ba11b592de8836$export$dca0327c9b9c6498;

});

parcelRegister("kudeD", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $khmAd = parcelRequire("khmAd");


var $4icDV = parcelRequire("4icDV");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $0a26766864270169$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $0a26766864270169$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $0a26766864270169$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $42omo.useState)(contentType);
    const isInitialized = (0, $42omo.useRef)(true);
    const iframeLoadMetrics = (0, $42omo.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $42omo.useRef)();
    (0, $42omo.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $khmAd.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $4icDV.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $4icDV.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $0a26766864270169$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $42omo.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $khmAd.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $42omo.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $42omo.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        },
        children: children
    });
};
const $0a26766864270169$export$865423e6f8e2e839 = ()=>{
    return (0, $42omo.useContext)($0a26766864270169$var$PerformanceMetricsContext);
};
const $0a26766864270169$export$c6f19d9afc6c86c8 = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $0a26766864270169$export$865423e6f8e2e839();
    (0, $42omo.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, $l998X.jsx)($0a26766864270169$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["usePerformanceMetrics"] = $0a26766864270169$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $0a26766864270169$export$c6f19d9afc6c86c8;

});

parcelRegister("khmAd", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");


var $j4jXg = parcelRequire("j4jXg");

const $078bd495543d458c$export$4de078c3b9971f9b = ()=>(0, $kyiqo.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $078bd495543d458c$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $078bd495543d458c$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $078bd495543d458c$var$timings
    }
};
const $078bd495543d458c$export$a23245993532c751 = (contentType)=>(0, $kyiqo.metrics).pageSegmentLoad($078bd495543d458c$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $078bd495543d458c$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $078bd495543d458c$export$a23245993532c751;

});

parcelRegister("4icDV", function(module, exports) {
const $2c9093170036a8a1$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $2c9093170036a8a1$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $2c9093170036a8a1$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $2c9093170036a8a1$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $2c9093170036a8a1$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $2c9093170036a8a1$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $2c9093170036a8a1$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $2c9093170036a8a1$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $2c9093170036a8a1$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $2c9093170036a8a1$export$73b982309451f084;

});

parcelRegister("9tntP", function(module, exports) {

var $hf8aJ = parcelRequire("hf8aJ");

class $e12337ddb1a59fdd$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $hf8aJ.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $e12337ddb1a59fdd$export$12b6b072930fd68f;

});

parcelRegister("hf8aJ", function(module, exports) {

var $9PTEZ = parcelRequire("9PTEZ");

function $41a6d457f373bb5d$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $41a6d457f373bb5d$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $9PTEZ.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $41a6d457f373bb5d$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $41a6d457f373bb5d$export$c90b54e658fc4d7c;

});

parcelRegister("9PTEZ", function(module, exports) {
class $98d3e4a5bcf7dec9$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $98d3e4a5bcf7dec9$export$d27a2b6293f7631c;

});

parcelRegister("cGc86", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $diaaX = parcelRequire("diaaX");

const $b9b017651fce2f05$var$UniqueKeyContext = /*#__PURE__*/ (0, $42omo.createContext)({
    uniqueKey: undefined
});
const $b9b017651fce2f05$export$71829d27b87a2006 = ({ children: children })=>{
    const uniqueKey = (0, $42omo.useMemo)(()=>(0, $diaaX.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($b9b017651fce2f05$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        },
        children: children
    });
};
const $b9b017651fce2f05$export$cef64a0cfb90e369 = ()=>{
    return (0, $42omo.useContext)($b9b017651fce2f05$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $b9b017651fce2f05$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $b9b017651fce2f05$export$cef64a0cfb90e369;

});

parcelRegister("3WsBD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j6S25 = parcelRequire("j6S25");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $hpNab = parcelRequire("hpNab");


var $aXWIB = parcelRequire("aXWIB");


var $cezNv = parcelRequire("cezNv");


var $cGc86 = parcelRequire("cGc86");

const $5a8d62fce039da42$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $j6S25.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $5a8d62fce039da42$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $5a8d62fce039da42$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $42omo.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $42omo.useMemo)(()=>allowedFeatures === 'all' ? (0, $hpNab.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature)=>feature !== 'edit' && feature !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature)=>!$5a8d62fce039da42$var$nonAllFeatures.includes(feature)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature)=>(0, $cezNv.isRedirectionEnabled)(feature)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $cezNv.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const queryParams = (0, $42omo.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $5a8d62fce039da42$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        return `?${new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery,
            ...contentConfiguration?.queryParams
        }).toString()}`;
    }, [
        contentConfiguration,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...$5a8d62fce039da42$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $5a8d62fce039da42$var$CONTEXT_PATH = '/wiki/spaces';
const $5a8d62fce039da42$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $5a8d62fce039da42$var$constructUrl(mode = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$5a8d62fce039da42$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$5a8d62fce039da42$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$5a8d62fce039da42$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $5a8d62fce039da42$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $5a8d62fce039da42$export$6e43e60d51b79331;
module.exports["useUrl"] = $5a8d62fce039da42$export$305222dff575c4e3;

});

parcelRegister("cezNv", function(module, exports) {
const $d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = [
    'template-browser',
    'template-browser-panel'
];
const $d21a741e0de1277a$var$hasAllowedFeature = (feature, featureName)=>{
    if (typeof feature === 'string') return feature === featureName;
    if (feature && typeof feature === 'object') return Object.prototype.hasOwnProperty.call(feature, featureName);
    return false;
};
const $d21a741e0de1277a$export$b47e8b0fa2aae156 = (allowedFeatures)=>{
    if (allowedFeatures === 'all') return true;
    return allowedFeatures?.some((feature)=>$d21a741e0de1277a$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName)=>$d21a741e0de1277a$var$hasAllowedFeature(feature, featureName))) ?? false;
};
const $d21a741e0de1277a$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch  {
        return false;
    }
    return false;
};
const $d21a741e0de1277a$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch  {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isInEditorTemplatesPanelEnabled"] = $d21a741e0de1277a$export$b47e8b0fa2aae156;
module.exports["isRedirectionEnabled"] = $d21a741e0de1277a$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $d21a741e0de1277a$export$243fbba563b8aa8e;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

function $e1a1ee666860bb23$export$4d17e2d9c5348842(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $42omo.useRef)(localeState.locale);
    (0, $42omo.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $aXWIB.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $aXWIB.IntlContext));
    if (!context) return (0, $aXWIB.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("6mn0G", function(module, exports) {
function $ef5055edddfff711$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}
module.exports["getTraceId"] = $ef5055edddfff711$export$e88cb5bfb57ce9c4;

});

parcelRegister("euACo", function(module, exports) {
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $035a46a85e451274$var$iconStyles = null;
const $035a46a85e451274$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
}; /**
    * For windows high contrast mode
    */ 
const $035a46a85e451274$var$baseHcmStyles = null;
const $035a46a85e451274$var$primaryEqualsSecondaryHcmStyles = null;
const $035a46a85e451274$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * Replica of deprecated legacy icon/base
                                             *
                                             */ 
const $035a46a85e451274$export$f04a61298a47a40f = /*#__PURE__*/ (0, $42omo.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ (0, $l998X.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $035a46a85e451274$var$sizeStyles[size]
        ])
    });
});
var $035a46a85e451274$export$2e2bcd8739ae039 = $035a46a85e451274$export$f04a61298a47a40f;
module.exports["Icon"] = $035a46a85e451274$export$f04a61298a47a40f;

});

parcelRegister("66dpz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("kiOFr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kSC7A = parcelRequire("kSC7A");


var $f8S0G = parcelRequire("f8S0G");


var $hBNGD = parcelRequire("hBNGD");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $bZKB2 = parcelRequire("bZKB2");


var $6fCTI = parcelRequire("6fCTI");

const $78f887db99bd3113$var$AVAILABLE_SITES_PATH = '/gateway/api/available-sites';
const $78f887db99bd3113$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/available-sites';
const $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_PATH = '/gateway/api/v2/accessible-products';
const $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/v2/accessible-products';
const $78f887db99bd3113$var$defaultProducts = [
    (0, $kSC7A.AvailableSitesProductType).WHITEBOARD,
    (0, $kSC7A.AvailableSitesProductType).BEACON,
    (0, $kSC7A.AvailableSitesProductType).COMPASS,
    (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
    (0, $kSC7A.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $kSC7A.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $kSC7A.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $kSC7A.AvailableSitesProductType).MERCURY,
    (0, $kSC7A.AvailableSitesProductType).OPSGENIE,
    (0, $kSC7A.AvailableSitesProductType).STATUS_PAGE,
    (0, $kSC7A.AvailableSitesProductType).ATLAS,
    (0, $kSC7A.AvailableSitesProductType).LOOM
];
const $78f887db99bd3113$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $78f887db99bd3113$var$getAvailableSites({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    data: sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $f8S0G.default)('operational.getAvailableSitesResolve.failed', (0, $6fCTI.getOperationFailedAttributes)(err))).fire((0, $hBNGD.ANALYTICS_CHANNEL));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
const $78f887db99bd3113$export$bd4055e8b60f8535 = (data)=>{
    const sites = [];
    data.products.forEach((product)=>{
        product.workspaces.forEach((workspace)=>{
            const currentSite = sites.find((site)=>site.cloudId === workspace.cloudId);
            if (currentSite) {
                currentSite.products.push(product.productId);
                return currentSite;
            }
            sites.push({
                avatarUrl: workspace.workspaceAvatarUrl,
                cloudId: workspace.cloudId,
                displayName: workspace.workspaceDisplayName,
                isVertigo: workspace.vortexMode === 'ENABLED',
                products: [
                    product.productId
                ],
                url: workspace.cloudUrl
            });
        });
    });
    return sites;
};
const $78f887db99bd3113$export$3f59b707a86875c4 = ({ gatewayBaseUrl: gatewayBaseUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isMounted = (0, $bZKB2.useIsMounted)();
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const response = await $78f887db99bd3113$var$getAccessibleProducts({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                if (isMounted()) setState({
                    data: $78f887db99bd3113$export$bd4055e8b60f8535(response.data),
                    loading: false,
                    error: undefined
                });
            } catch (error) {
                if (isMounted()) setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        isMounted
    ]);
    return state;
};
async function $78f887db99bd3113$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const availableSitesPath = (0, $dh538.fg)('linking_platform_site_picker_api_unit_compliant') ? $78f887db99bd3113$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH : $78f887db99bd3113$var$AVAILABLE_SITES_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${availableSitesPath}` : availableSitesPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
async function $78f887db99bd3113$var$getAccessibleProducts({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const accessibleProductsPath = (0, $dh538.fg)('linking_platform_site_picker_api_unit_compliant') ? $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH : $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            productIds: products,
            permissionIds: []
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${accessibleProductsPath}` : accessibleProductsPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
module.exports["useAvailableSites"] = $78f887db99bd3113$export$3738ff0cbe469211;
module.exports["mapAccessibleProductsToAvailableSites"] = $78f887db99bd3113$export$bd4055e8b60f8535;
module.exports["useAvailableSitesV2"] = $78f887db99bd3113$export$3f59b707a86875c4;

});

parcelRegister("kSC7A", function(module, exports) {
var $2f440bf1e6112d68$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});
module.exports["AvailableSitesProductType"] = $2f440bf1e6112d68$export$16bdf84263b17cf0;

});

parcelRegister("f8S0G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::bf8c5828b0e062cbddf6092143efece2>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $4a22b51dcbeecd57$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $4a22b51dcbeecd57$export$2e2bcd8739ae039 = $4a22b51dcbeecd57$var$createEventPayload;
module.exports["default"] = $4a22b51dcbeecd57$export$2e2bcd8739ae039;

});

parcelRegister("hBNGD", function(module, exports) {
const $eb5d052cb0327301$export$85183a312807388d = 'media';
const $eb5d052cb0327301$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $eb5d052cb0327301$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $eb5d052cb0327301$export$60efea3f80310017;

});

parcelRegister("bZKB2", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d79b64f48ff0234f$export$80c2a3957bcb42ea() {
    const isMounted = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $42omo.useCallback)(()=>isMounted.current, []);
}
module.exports["useIsMounted"] = $d79b64f48ff0234f$export$80c2a3957bcb42ea;

});

parcelRegister("6fCTI", function(module, exports) {

var $6mn0G = parcelRequire("6mn0G");

const $9cbe6bde573cd7a4$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $9cbe6bde573cd7a4$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $6mn0G.getTraceId)(error),
        status: error.status,
        path: $9cbe6bde573cd7a4$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
const $9cbe6bde573cd7a4$export$e19f9f08a6d79fd2 = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $9cbe6bde573cd7a4$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...$9cbe6bde573cd7a4$export$294520aca64d4e59(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};
module.exports["getOperationFailedAttributes"] = $9cbe6bde573cd7a4$export$b2d107ab31565d0b;

});

parcelRegister("igBZP", function(module, exports) {
'use strict';
/* global setTimeout, clearTimeout */ module.exports = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lastCallAt = void 0;
    var deferred = void 0;
    var timer = void 0;
    var pendingArgs = [];
    return function debounced() {
        var currentWait = $d4c731e2a28427e0$var$getWait(wait);
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (isCold && options.leading) return options.accumulate ? Promise.resolve(fn.call(this, [
            args
        ])).then(function(result) {
            return result[0];
        }) : Promise.resolve(fn.call.apply(fn, [
            this
        ].concat(args)));
        if (deferred) clearTimeout(timer);
        else deferred = $d4c731e2a28427e0$var$defer();
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex = pendingArgs.length - 1;
            return deferred.promise.then(function(results) {
                return results[argsIndex];
            });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
};
function $d4c731e2a28427e0$var$getWait(wait) {
    return typeof wait === 'function' ? wait() : wait;
}
function $d4c731e2a28427e0$var$defer() {
    var deferred = {};
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});

parcelRegister("7p2SJ", function(module, exports) {

var $9tehW = parcelRequire("9tehW");


var $2KLMV = parcelRequire("2KLMV");

const $9de29032692b3583$var$AsyncSelect = (0, $2KLMV.default)((0, $9tehW.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9de29032692b3583$export$2e2bcd8739ae039 = $9de29032692b3583$var$AsyncSelect;
module.exports["default"] = $9de29032692b3583$export$2e2bcd8739ae039;

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function') // dont use finally as it "multiplies" rejected promises
        result.then($568c54c2a75aa99b$export$a775919ebd7dd28a.clear, $568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (inj) {
        var _inj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === inj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(inj, new Error(`Unused "di" injectable: ${((_inj$value = inj.value) == null ? void 0 : _inj$value.displayName) || inj.value}.`, {
            cause: inj.cause
        }));
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
        // reset to avoid potential memory leaks via stack traces
        inj.cause = null;
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("7dyLS", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $lEY55 = parcelRequire("lEY55");


var $iUYhn = parcelRequire("iUYhn");


var $eFiFf = parcelRequire("eFiFf");


var $3YFt4 = parcelRequire("3YFt4");

var $ff4c1fab1412a389$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $ff4c1fab1412a389$export$775b6bb06e53a214 = {
    ...(0, $lEY55.Scope),
    ...(0, $iUYhn.Scope),
    ...(0, $3YFt4.TownsquareScope),
    ...(0, $eFiFf.Scope)
};
module.exports["Scope"] = $ff4c1fab1412a389$export$775b6bb06e53a214;

});

parcelRegister("lEY55", function(module, exports) {
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $31e4730094d25be0$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $31e4730094d25be0$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $31e4730094d25be0$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $31e4730094d25be0$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $31e4730094d25be0$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $31e4730094d25be0$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $31e4730094d25be0$export$80a5be864676016b = 'confluence.space';
const $31e4730094d25be0$export$70542451ad6057d2 = 'urs.user-confluence';
const $31e4730094d25be0$export$6ec00f56b27cdc1d = 'generic-container-result';
const $31e4730094d25be0$export$ca1a50bc869949e = 'person-result';
const $31e4730094d25be0$export$a99961038e9d5471 = 'confluence-object-result';
const $31e4730094d25be0$export$18c69de2b4aa679c = 'recent-confluence';
const $31e4730094d25be0$export$dc31f0db54ab1a30 = 'result-confluence';
const $31e4730094d25be0$export$cb8b6c470492bee8 = 'recent-person';
const $31e4730094d25be0$export$ebb42dafe7a39a20 = 'result-person';
const $31e4730094d25be0$export$602b44a55c824e30 = 'advanced-search-confluence';
const $31e4730094d25be0$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $31e4730094d25be0$export$bbd1709e62826142 = 'confluence-page';
const $31e4730094d25be0$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $31e4730094d25be0$export$b441f0c13fd510b9 = 'confluence-attachment';
const $31e4730094d25be0$export$8ee8726ca4e2f8bd = 'confluence-space';
const $31e4730094d25be0$export$d0e824889e01c751 = 'person';
const $31e4730094d25be0$export$b0c74445b9c9b57 = 'confluence-app';
module.exports["Scope"] = $31e4730094d25be0$export$775b6bb06e53a214;

});

parcelRegister("iUYhn", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $4cce666965dd4176$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $4cce666965dd4176$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $4cce666965dd4176$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $4cce666965dd4176$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $4cce666965dd4176$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $4cce666965dd4176$export$775b6bb06e53a214;

});

parcelRegister("eFiFf", function(module, exports) {
var $e9e0239fba21ef53$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});
module.exports["Scope"] = $e9e0239fba21ef53$export$775b6bb06e53a214;

});

parcelRegister("3YFt4", function(module, exports) {
var $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.
module.exports["TownsquareScope"] = $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa;

});

parcelRegister("3paC4", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $jppmC = parcelRequire("jppmC");

const $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY = 3;
const $6b372c322d10f06f$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY);
};
class $6b372c322d10f06f$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $6b372c322d10f06f$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $jppmC.timed)(this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $6b372c322d10f06f$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $6b372c322d10f06f$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $6b372c322d10f06f$export$5d730b7aed1a3eb0;

});

parcelRegister("jppmC", function(module, exports) {
const $e3bb250125deb745$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $e3bb250125deb745$export$d35186a762cd39c8;

});

parcelRegister("9QfXi", function(module, exports) {
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fFa3V = parcelRequire("fFa3V");


var $2P8Ax = parcelRequire("2P8Ax");


var $dh538 = parcelRequire("dh538");


var $eFvgJ = parcelRequire("eFvgJ");


var $ei7H8 = parcelRequire("ei7H8");


var $e2ssP = parcelRequire("e2ssP");


var $lQ9rc = parcelRequire("lQ9rc");

const $05e49d7ff5fc6a12$var$getCodeBlockStyles = {
    rootT26Shape: "_2rko1mok",
    root: "_11c819w5 _2rko12b0 _1dqoglyw _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhk187e _syazi7uo _1ozdn7od _7xinn7od _t7aun7od _r28du2gc _tajqu2gc _1ohiu2gc _m802u2gc _i6ntu2gc _1w2xu2gc _1hmyegat _vblregat _vbulegat _196q1xv3 _1vbw1xv3 _1v9c1xv3 _1srnt0uh _18r6myb0 _vyvc1n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _ra6gsb9t _13cdh2mm _1pp0126e _zvy9f705 _qcxof705 _qzn01a66 _j0l11wug _1weckb7n _1na21hna _vsnzgrf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909i8nm _scgayz1z _ipl81e17 _40uk1l04 _i81p1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _pyovu2gc _ccm6u2gc _1ascu2gc _1yuau2gc _xr0w1a66 _4io21a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgc124n _bu7z124n _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3wu06 _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eihtd5cb _t9zbd5cb _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t36i7uo _137bh55r _1k7di7uo _97li16jw _12nh9lu1 _1g0517qg _i2igqmo9 _326zi7uo _113p1rpy _1n6t16jw _tgu817qg _1k4716jw _g0lxi7uo _ys4e1rpy _7gp8h55r _1yvqqmo9 _1vwwqmo9 _1rjuqmo9 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o6qmo9 _kxov17qg _1np517qg _m2f517qg _1b9t16jw _1tq616jw _1rd216jw _1pbk16jw _k3li16jw _13zt1rpy _2g12fb2s _k86bqmo9 _b5iy1rpy _gti31rpy _1f0g16jw _9d3e17qg _qdia16jw _72uv16jw",
    showLineNumbers: "_1707efft _1i3h1txw _16noidpf _h4fuidpf _pp6yidpf _1g4tidpf _11wmidpf _1bx8idpf",
    dontShowLineNumbers: "_1i3h1ule _16nou2gc _h4fuu2gc _pp6yu2gc _1g4tu2gc _11wmu2gc _1bx8u2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
}; /**
    * __Code block__
    *
    * A code block highlights an entire block of code and keeps the formatting.
    *
    * - [Examples](https://atlassian.design/components/code/code-block/examples)
    * - [Code](https://atlassian.design/components/code/code-block/code)
    * - [Usage](https://atlassian.design/components/code/code-block/usage)
    */ 
const $05e49d7ff5fc6a12$var$CodeBlock = /*#__PURE__*/ (0, $42omo.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, shouldShowLineNumbers: shouldShowLineNumbers, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $42omo.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $42omo.useState)(false); // Use children if provided, otherwise fall back to deprecated text prop
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $ei7H8.getLineNumWidth)(numLines) : 0; // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled; // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $42omo.useEffect)(()=>{
        const schedule = (0, $2P8Ax.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $eFvgJ.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $42omo.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $42omo.useMemo)(()=>(0, $e2ssP.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]); // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lQ9rc.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: shouldShowLineNumbersValue,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: shouldShowBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $gMc0m.default)([
            $05e49d7ff5fc6a12$var$getCodeBlockStyles.root,
            (0, $dh538.fg)('platform-dst-shape-theme-default') && $05e49d7ff5fc6a12$var$getCodeBlockStyles.rootT26Shape,
            shouldWrapLongLines ? $05e49d7ff5fc6a12$var$getCodeBlockStyles.shouldWrapLongLines : $05e49d7ff5fc6a12$var$getCodeBlockStyles.dontWrapLongLines,
            shouldShowLineNumbersValue ? $05e49d7ff5fc6a12$var$getCodeBlockStyles.showLineNumbers : $05e49d7ff5fc6a12$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $05e49d7ff5fc6a12$export$2e2bcd8739ae039 = $05e49d7ff5fc6a12$var$CodeBlock;
module.exports["default"] = $05e49d7ff5fc6a12$export$2e2bcd8739ae039;

});

parcelRegister("eFvgJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $762b8efdd2f451a9$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $762b8efdd2f451a9$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $762b8efdd2f451a9$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $42omo.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $42omo.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $762b8efdd2f451a9$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};
module.exports["useHighlightLines"] = $762b8efdd2f451a9$export$84415a200bdf33ed;

});

parcelRegister("ei7H8", function(module, exports) {
const $89bf9ce5f21eb7b0$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};
module.exports["getLineNumWidth"] = $89bf9ce5f21eb7b0$export$cb7aec0206b595d2;

});

parcelRegister("e2ssP", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $cTQmR = parcelRequire("cTQmR");

const $93742eb3c537aef5$export$f38728011c178796 = (0, $2XqLN.default)((language)=>{
    if (!language) return '';
    const match = (0, $cTQmR.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});
module.exports["normalizeLanguage"] = $93742eb3c537aef5$export$f38728011c178796;

});

parcelRegister("cTQmR", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $a6db6a3439cd9017$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $a6db6a3439cd9017$export$7c77c3a9bb93870d;

});

parcelRegister("lQ9rc", function(module, exports) {
$parcel$export(module.exports, "default", () => $e33420ccf6f6f193$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $fjCXq = parcelRequire("fjCXq");

var $e33420ccf6f6f193$export$2e2bcd8739ae039 = (0, $fjCXq.default);

});

parcelRegister("fjCXq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5sMDX = parcelRequire("5sMDX");

// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $d73ab72549e3e177$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $l998X.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    AsyncHighlighter.astGenerator = null;
    AsyncHighlighter.highlightInstance = (0, $5sMDX.default);
    AsyncHighlighter.astGeneratorPromise = void 0;
    return AsyncHighlighter;
};

const $d73ab72549e3e177$var$asyncGenerator = $d73ab72549e3e177$var$generator({
    loader: ()=>(parcelRequire("bhcM2")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $d73ab72549e3e177$export$2e2bcd8739ae039 = $d73ab72549e3e177$var$asyncGenerator;
module.exports["default"] = $d73ab72549e3e177$export$2e2bcd8739ae039;

});

parcelRegister("5sMDX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9THMM = parcelRequire("9THMM");


var $39xAV = parcelRequire("39xAV");

/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $65cd19df82755559$var$Highlight = /*#__PURE__*/ (0, $42omo.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $9THMM.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $39xAV.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $65cd19df82755559$export$2e2bcd8739ae039 = $65cd19df82755559$var$Highlight;
module.exports["default"] = $65cd19df82755559$export$2e2bcd8739ae039;

});

parcelRegister("9THMM", function(module, exports) {
$parcel$export(module.exports, "default", () => $91ea43af234a8926$export$2e2bcd8739ae039);

var $5izKv = parcelRequire("5izKv");


var $gOgW3 = parcelRequire("gOgW3");


var $6RvGZ = parcelRequire("6RvGZ");


var $dA1U5 = parcelRequire("dA1U5");

const $91ea43af234a8926$var$newLineRegex = /\n/g;
function $91ea43af234a8926$var$getNewLines(str) {
    return str.match($91ea43af234a8926$var$newLineRegex);
}
function $91ea43af234a8926$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $dA1U5.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $5izKv.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $6RvGZ.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $91ea43af234a8926$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $gOgW3.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $gOgW3.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});

parcelRegister("5izKv", function(module, exports) {

var $gOgW3 = parcelRequire("gOgW3");


var $2hcc9 = parcelRequire("2hcc9");

function $837f3297854d8fe5$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $gOgW3.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $2hcc9.default)(lineNumber));
            return children;
        }
    };
}
var $837f3297854d8fe5$export$2e2bcd8739ae039 = $837f3297854d8fe5$var$createLineGenerator;
module.exports["default"] = $837f3297854d8fe5$export$2e2bcd8739ae039;

});

parcelRegister("gOgW3", function(module, exports) {
$parcel$export(module.exports, "default", () => $09aff78a89d513cf$export$2e2bcd8739ae039);

var $2hcc9 = parcelRequire("2hcc9");

function $09aff78a89d513cf$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, shouldShowLineNumbers: shouldShowLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    // Use new prop if provided, otherwise fall back to deprecated prop
    const shouldShowLineNumbersValue = shouldShowLineNumbers !== undefined ? shouldShowLineNumbers : showLineNumbers;
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && shouldShowLineNumbersValue) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $2hcc9.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $2hcc9.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});

parcelRegister("2hcc9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c2f4afe5a9a95f7$export$2e2bcd8739ae039);
function $3c2f4afe5a9a95f7$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});

parcelRegister("6RvGZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7ca1712ff76e68a$export$2e2bcd8739ae039);

var $gOgW3 = parcelRequire("gOgW3");

function $f7ca1712ff76e68a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $gOgW3.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $f7ca1712ff76e68a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("dA1U5", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a86ea0fafcbd9c5$export$2e2bcd8739ae039);
function $1a86ea0fafcbd9c5$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch  {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});

parcelRegister("39xAV", function(module, exports) {
$parcel$export(module.exports, "default", () => $33a0d4443c5f07c9$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dalCl = parcelRequire("dalCl");

function $33a0d4443c5f07c9$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $dalCl.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});

parcelRegister("dalCl", function(module, exports) {
$parcel$export(module.exports, "default", () => $60fb1400ee6b4dd3$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $g7Pc3 = parcelRequire("g7Pc3");


var $03WRT = parcelRequire("03WRT");


var $8L2tn = parcelRequire("8L2tn");

function $60fb1400ee6b4dd3$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $60fb1400ee6b4dd3$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $03WRT.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $g7Pc3.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    isTooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $8L2tn.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $60fb1400ee6b4dd3$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});

parcelRegister("8L2tn", function(module, exports) {
$parcel$export(module.exports, "default", () => $cef41ad946a85b2e$export$2e2bcd8739ae039);

var $dalCl = parcelRequire("dalCl");

function $cef41ad946a85b2e$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $dalCl.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});

parcelRegister("bhcM2", function(module, exports) {

let $835b30d7ea57673f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $835b30d7ea57673f$var$load("7PMju").then(()=>parcelRequire('kw2OH'));

});

parcelRegister("9EtP6", function(module, exports) {
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $dh538 = parcelRequire("dh538");

const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$baseStylesT26Shape = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $82c18ff824db72a8$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const ourRef = (0, $42omo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $42omo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $42omo.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $l998X.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;
module.exports["default"] = $82c18ff824db72a8$export$2e2bcd8739ae039;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("4k7vU"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("4k7vU", function(module, exports) {

let $325edbbf9f0bbcc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $325edbbf9f0bbcc1$var$load("cONk3"),
    $325edbbf9f0bbcc1$var$load("ltDLY"),
    $325edbbf9f0bbcc1$var$load("6YfM6"),
    $325edbbf9f0bbcc1$var$load("6wr18"),
    $325edbbf9f0bbcc1$var$load("ffEVr"),
    $325edbbf9f0bbcc1$var$load("iivLa"),
    $325edbbf9f0bbcc1$var$load("ajMch"),
    $325edbbf9f0bbcc1$var$load("hxlWB"),
    $325edbbf9f0bbcc1$var$load("kFiBp"),
    $325edbbf9f0bbcc1$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("6iY4P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("7mpOv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");

const $7ae32555811cd45f$export$cc5edac91cdebf9b = (_props = {})=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;
    return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: shouldShowRovo
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("l5jcq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6c7fb5a91851c05d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3405feb70bdc0482b21b411108f82ba5>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2ISy2 = parcelRequire("2ISy2");


var $kXb3C = parcelRequire("kXb3C");

function $6c7fb5a91851c05d$export$2e2bcd8739ae039({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("57Wda", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::599e4be29a2a39bcbf5cf9b372d0e03e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6B0jU = parcelRequire("6B0jU");


var $kXb3C = parcelRequire("kXb3C");

function $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039({ label: label = 'Database', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("kWiYc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4ce94c9023f0019e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $kXb3C = parcelRequire("kXb3C");

function $4ce94c9023f0019e$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("8hhCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $02745cd2b6b0665c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

function $02745cd2b6b0665c$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("9J3bP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $458cec0faf8f188b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6be74be899a91647cea1371235d747>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $kR5QY = parcelRequire("kR5QY");


var $kXb3C = parcelRequire("kXb3C");

function $458cec0faf8f188b$export$2e2bcd8739ae039({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("7G33r", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b1b906ca2447e962$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00a580c76a83b898772f38add89d77e3>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dmbve = parcelRequire("dmbve");


var $kXb3C = parcelRequire("kXb3C");

function $b1b906ca2447e962$export$2e2bcd8739ae039({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("eQfRp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $26650821103220c8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a634b13ea98c89a9c27945d37a8a7571>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ZDq1z = parcelRequire("ZDq1z");


var $kXb3C = parcelRequire("kXb3C");

function $26650821103220c8$export$2e2bcd8739ae039({ label: label = 'Whiteboard', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        color: "var(--ds-icon-accent-teal, #2898BD)"
    });
}

});

parcelRegister("8d3zB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $487ca0b42e22d1f4$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d7811e9ce600b90f94930755b99d471>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $kXb3C = parcelRequire("kXb3C");

function $487ca0b42e22d1f4$export$2e2bcd8739ae039({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("kNUwp", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $dwp40 = parcelRequire("dwp40");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $25BDS = parcelRequire("25BDS");


var $7I6bH = parcelRequire("7I6bH");

const $c1ef33da072a3fc0$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $c1ef33da072a3fc0$var$RELATIVE_URL_V2 = '/gateway/api/xpsearch-aggregator/api/v2/configuration';
const $c1ef33da072a3fc0$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const $c1ef33da072a3fc0$var$RELATIVE_LOOM_AUTH_URL = '/gateway/api/loom-auth/api/internal/identity/user-status';
const $c1ef33da072a3fc0$export$19524a749d98a458 = 'search-config';
const $c1ef33da072a3fc0$export$cf95148f36a28b96 = 'search-3p-config';
const $c1ef33da072a3fc0$export$44d1e7c4ef26c467 = 'loom-user-auth';
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$19524a749d98a458
});
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecorator3pSearch, update: $c1ef33da072a3fc0$var$update3pCache } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$cf95148f36a28b96,
    expiration: 300000
});
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecoratorUserLoomAuth } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$44d1e7c4ef26c467
});
const $c1ef33da072a3fc0$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
/**
 * Creates a traceInfoExtractor that reads from a mutable headers reference.
 * Used by REST config endpoints to extract requestId/traceId from HTTP response headers
 * without storing them in the cache.
 */ const $c1ef33da072a3fc0$var$createTraceInfoExtractor = (headersRef)=>{
    return ()=>{
        const headers = headersRef();
        const requestId = headers['atl-request-id'];
        const traceId = headers['x-trace-id'];
        if (requestId || traceId) return {
            requestId: requestId,
            traceId: traceId
        };
        return undefined;
    };
};
const $c1ef33da072a3fc0$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ef33da072a3fc0$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $2qzBQ.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $c1ef33da072a3fc0$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        serveResolvedDuringRefresh: true
    });
};
const $c1ef33da072a3fc0$export$c6f4290269f11bd5 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ef33da072a3fc0$var$RELATIVE_URL_V2}/${cloudId}`;
    const queryParams = {};
    if ((0, $dh538.fg)('rovo-search-config-endpoints-operation-name')) queryParams['operationName'] = 'searchPageFirstPartyConfig';
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $2qzBQ.generateHash)(`1p|${userId}|${cloudId}|v2`);
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfigPromise = (0, $dwp40.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        }).then((data)=>{
            return {
                resources: data.resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecoratorSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $3Tbc2.DegradablePromise)(searchConfigPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ef33da072a3fc0$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ef33da072a3fc0$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const baseUrl = absoluteUrl || $c1ef33da072a3fc0$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const queryParams = {};
    if ((0, $dh538.fg)('rovo-search-config-endpoints-operation-name')) queryParams['operationName'] = 'searchPageThirdPartyConfig';
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $7I6bH.generate3pHash)(userId || '', cloudId || '');
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfig3PPromise = (0, $dwp40.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecorator3pSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $3Tbc2.DegradablePromise)(searchConfig3PPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ef33da072a3fc0$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecorator3pSearch({
        key: key.toString(),
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ef33da072a3fc0$export$b75556aa5958ec1f = (userId, cloudId, updater)=>{
    const key = (0, $7I6bH.generate3pHash)(userId, cloudId);
    return $c1ef33da072a3fc0$var$update3pCache(key.toString(), updater);
};
const $c1ef33da072a3fc0$export$46e3d34ee7b8c58a = async ({ cloudId: cloudId, userId: userId })=>{
    const url = $c1ef33da072a3fc0$var$RELATIVE_LOOM_AUTH_URL;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $25BDS.generateLoomAuthHash)(userId || '', cloudId || '');
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorUserLoomAuth({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false
    });
};
module.exports["getSearchConfigV2"] = $c1ef33da072a3fc0$export$c6f4290269f11bd5;
module.exports["get3pSearchConfig"] = $c1ef33da072a3fc0$export$6916ea7f169882e0;
module.exports["getUserLoomAuthStatus"] = $c1ef33da072a3fc0$export$46e3d34ee7b8c58a;

});

parcelRegister("25BDS", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");

const $5eb733f1658cb27e$export$42b67d93e908c9dc = (userId, cloudId)=>(0, $2qzBQ.generateHash)(`loom|${userId}|${cloudId}`);
module.exports["generateLoomAuthHash"] = $5eb733f1658cb27e$export$42b67d93e908c9dc;

});

parcelRegister("7I6bH", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");

const $bf230724a07e1336$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $2qzBQ.generateHash)(`3p|${userId}|${cloudId}`);
module.exports["generate3pHash"] = $bf230724a07e1336$export$f80795c7fd0ce9fc;

});

parcelRegister("5tnQQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a932c722f95653b7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c2e42a5240f58c746dfd1694482fb8c>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8DN9t = parcelRequire("8DN9t");


var $kXb3C = parcelRequire("kXb3C");

function $a932c722f95653b7$export$2e2bcd8739ae039({ label: label = 'Calendar', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("6atSO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $73b395c32a9c60f5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f9952b2c673a9067b6b4a0ab78aa7db>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ci7Ox = parcelRequire("ci7Ox");


var $kXb3C = parcelRequire("kXb3C");

function $73b395c32a9c60f5$export$2e2bcd8739ae039({ label: label = 'Question', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("2O3ot", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $abb9e481ac8f38e8$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    dynamicUiType: undefined,
    dynamicUiSubtype: undefined,
    dynamicUiSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined
};
const $abb9e481ac8f38e8$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSubtype, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource
            });
        },
    resetStagingArea: ()=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: undefined,
                dynamicUiType: undefined,
                dynamicUiSubtype: undefined,
                dynamicUiSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        }
};
const $abb9e481ac8f38e8$var$store = (0, $1P1Tu.createStore)({
    initialState: $abb9e481ac8f38e8$var$initialState,
    actions: $abb9e481ac8f38e8$var$actions
});
const $abb9e481ac8f38e8$export$a2795b51ce92008f = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $abb9e481ac8f38e8$export$916334da9df8d04 = (0, $9zUhf.createHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$8f9a13b17bec42d5 = (0, $9zUhf.createActionsHook)($abb9e481ac8f38e8$var$store);
const $abb9e481ac8f38e8$export$5a57f796673aabea = (0, $9zUhf.createStateHook)($abb9e481ac8f38e8$var$store);
module.exports["useMessageIdSelectedForPreview"] = $abb9e481ac8f38e8$export$a2795b51ce92008f;
module.exports["useStagingArea"] = $abb9e481ac8f38e8$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $abb9e481ac8f38e8$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $abb9e481ac8f38e8$export$5a57f796673aabea;

});

parcelRegister("jln20", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gK1lf = parcelRequire("gK1lf");

var $4BDAe = parcelRequire("4BDAe");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("f1MTD"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("epLE5", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $42omo.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("f1MTD", function(module, exports) {

let $af0ce0d2743b8b3d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $af0ce0d2743b8b3d$var$load("5NQgH"),
    $af0ce0d2743b8b3d$var$load("6GYDO"),
    $af0ce0d2743b8b3d$var$load("hhss7"),
    $af0ce0d2743b8b3d$var$load("cyGuT"),
    $af0ce0d2743b8b3d$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("6rSJC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fb3kw = parcelRequire("fb3kw");

/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $aabc54d8ecf8c9ec$var$CheckboxField = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $42omo.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>!Array.isArray(event) && event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>typeof event === 'boolean' ? event : event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
var $aabc54d8ecf8c9ec$export$2e2bcd8739ae039 = $aabc54d8ecf8c9ec$var$CheckboxField;
module.exports["default"] = $aabc54d8ecf8c9ec$export$2e2bcd8739ae039;

});

parcelRegister("d2kvf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1HnpQ = parcelRequire("1HnpQ");


var $i3GYc = parcelRequire("i3GYc");

// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $7cea5ab07179eb6f$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $i3GYc.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1HnpQ.default), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
            children: children
        })
    });
};
var $7cea5ab07179eb6f$export$2e2bcd8739ae039 = $7cea5ab07179eb6f$var$TabPanel;
module.exports["default"] = $7cea5ab07179eb6f$export$2e2bcd8739ae039;

});

parcelRegister("lvsjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa82743632a2ad8f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $fa82743632a2ad8f$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $42omo.useRef)(null);
    var maxWaitArgs = (0, $42omo.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $42omo.useRef)(false);
    var functionTimeoutHandler = (0, $42omo.useRef)(null);
    var isComponentUnmounted = (0, $42omo.useRef)(false);
    var debouncedFunction = (0, $42omo.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $42omo.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $42omo.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $42omo.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $42omo.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("9SMct", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8jHAi = parcelRequire("8jHAi");


var $7CgcZ = parcelRequire("7CgcZ");

const $3c9171fc16956912$var$PageIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), 'blueBold');
$3c9171fc16956912$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $3c9171fc16956912$export$2e2bcd8739ae039 = $3c9171fc16956912$var$PageIconWithColor;
module.exports["default"] = $3c9171fc16956912$export$2e2bcd8739ae039;

});

parcelRegister("7CgcZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7642E = parcelRequire("7642E");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $ivUmx = parcelRequire("ivUmx");

/**
 * Maps IconTile appearance to the icon glyph color token to use when rendering
 * a standalone icon (without a tile background).
 */ const $6846287c8ee6bf50$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $6846287c8ee6bf50$export$3acc3fb10995f020 = (size)=>{
    if ((0, $dh538.fg)('platform_sl_icons_refactor')) switch(size){
        case (0, $5TXU5.SmartLinkSize).Small:
        case (0, $5TXU5.SmartLinkSize).Medium:
            return undefined;
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'small';
        default:
            // SmartLinkSize.Small, SmartLinkSize.Medium, and undefined all
            // previously mapped to size="16" which has been removed. Render
            // the icon directly (no tile) for these sizes.
            return undefined;
    }
};
const $6846287c8ee6bf50$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ((0, $ivUmx.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ObjectIcon, props);
    };
};
const $6846287c8ee6bf50$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = $6846287c8ee6bf50$export$3acc3fb10995f020(size);
        if (tileSize === undefined) {
            // size="16" has been removed — render the icon directly without a tile,
            // using the appearance-derived color so it still matches the intended style.
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                color: $6846287c8ee6bf50$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { shape: _shape, UNSAFE_circleReplacementComponent: _unsafe, ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7642E.IconTile), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["transformSmartLinkSizeToIconTileSize"] = $6846287c8ee6bf50$export$3acc3fb10995f020;
module.exports["renderIconPerSize"] = $6846287c8ee6bf50$export$28dd5ad82647c000;
module.exports["renderIconTile"] = $6846287c8ee6bf50$export$87c3646d0e299cfe;

});

parcelRegister("9JsQ8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $chO1Z = parcelRequire("chO1Z");


var $7CgcZ = parcelRequire("7CgcZ");

const $b894277b0121d160$var$FileIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), 'grayBold');
$b894277b0121d160$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $b894277b0121d160$export$2e2bcd8739ae039 = $b894277b0121d160$var$FileIconWithColor;
module.exports["default"] = $b894277b0121d160$export$2e2bcd8739ae039;

});

parcelRegister("1w5AW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $1zLiv = parcelRequire("1zLiv");


var $7CgcZ = parcelRequire("7CgcZ");

const $236bd638115a684a$var$ChartBarIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))), 'purpleBold');
$236bd638115a684a$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $236bd638115a684a$export$2e2bcd8739ae039 = $236bd638115a684a$var$ChartBarIconWithColor;
module.exports["default"] = $236bd638115a684a$export$2e2bcd8739ae039;

});

parcelRegister("h45kr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $cUQMr = parcelRequire("cUQMr");


var $7CgcZ = parcelRequire("7CgcZ");

const $55cc43e42726cbf8$var$ListBulletedIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), 'greenBold');
$55cc43e42726cbf8$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $55cc43e42726cbf8$export$2e2bcd8739ae039 = $55cc43e42726cbf8$var$ListBulletedIconWithColor;
module.exports["default"] = $55cc43e42726cbf8$export$2e2bcd8739ae039;

});

parcelRegister("j6GAe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fAGae", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("7r4Rz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
// This file is the FG-OFF fallback for platform_sl_icons_refactor.
// Delete this file when platform_sl_icons_refactor is cleaned up.

var $6iY4P = parcelRequire("6iY4P");


var $j6GAe = parcelRequire("j6GAe");


var $7CgcZ = parcelRequire("7CgcZ");

const $a1b21c3b6fc75776$var$BlogIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $6iY4P.default), (0, $j6GAe.default));
$a1b21c3b6fc75776$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $a1b21c3b6fc75776$export$2e2bcd8739ae039 = $a1b21c3b6fc75776$var$BlogIconWithColor;
module.exports["default"] = $a1b21c3b6fc75776$export$2e2bcd8739ae039;

});

parcelRegister("GFtWS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
// This file is the FG-OFF fallback for platform_sl_icons_refactor.
// Delete this file when platform_sl_icons_refactor is cleaned up.

var $66dpz = parcelRequire("66dpz");


var $fAGae = parcelRequire("fAGae");


var $7CgcZ = parcelRequire("7CgcZ");

const $fc75dd15b55d0661$var$LiveDocumentIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $66dpz.default), (0, $fAGae.default));
$fc75dd15b55d0661$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $fc75dd15b55d0661$export$2e2bcd8739ae039 = $fc75dd15b55d0661$var$LiveDocumentIconWithColor;
module.exports["default"] = $fc75dd15b55d0661$export$2e2bcd8739ae039;

});

parcelRegister("8PFSM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $009878891f6679eb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d51578aa68f6f1f67b6c4a1d4bb0368>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iOozU = parcelRequire("iOozU");


var $kXb3C = parcelRequire("kXb3C");

function $009878891f6679eb$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("gPNUg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1babd35f9918b35a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba2400aa1a21e98b14b3159dd611e30a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $iOozU = parcelRequire("iOozU");


var $fP78j = parcelRequire("fP78j");

function $1babd35f9918b35a$export$2e2bcd8739ae039({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iOozU))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("iZCav", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0686486f925c9ddd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5dc8472ed4701f1e18b170a37220fe41>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fZeLS = parcelRequire("fZeLS");


var $kXb3C = parcelRequire("kXb3C");

function $0686486f925c9ddd$export$2e2bcd8739ae039({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZeLS))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("8wyB4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b36b776ec4bd4602$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce7a14286959c742e345710a87afb558>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fZeLS = parcelRequire("fZeLS");


var $fP78j = parcelRequire("fP78j");

function $b36b776ec4bd4602$export$2e2bcd8739ae039({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fZeLS))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
}

});

parcelRegister("5NrIb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $692c05f58e5d3ef7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4a46dfaccc0758bf1b71ccf340efb6a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7OYaz = parcelRequire("7OYaz");


var $kXb3C = parcelRequire("kXb3C");

function $692c05f58e5d3ef7$export$2e2bcd8739ae039({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("iAJNI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5112347e60ca9722$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::934923571ddda86dcc15b2804cd6fdd5>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7OYaz = parcelRequire("7OYaz");


var $fP78j = parcelRequire("fP78j");

function $5112347e60ca9722$export$2e2bcd8739ae039({ label: label = 'Pull Request', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
}

});

parcelRegister("gV3jM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2708dfe0209c3c78$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00550c5037cc26264de6baee26f7399e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eIlE7 = parcelRequire("eIlE7");


var $kXb3C = parcelRequire("kXb3C");

function $2708dfe0209c3c78$export$2e2bcd8739ae039({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("i9OUl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $db9e370fec44d3db$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6d6e475381a024c19a88e7f303e38fe>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eIlE7 = parcelRequire("eIlE7");


var $fP78j = parcelRequire("fP78j");

function $db9e370fec44d3db$export$2e2bcd8739ae039({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
}

});

parcelRegister("2tvDK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ab5e2ffbeed9f2f4$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25c067814582e1346f67a8106048fd7b>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2ISy2 = parcelRequire("2ISy2");


var $fP78j = parcelRequire("fP78j");

function $ab5e2ffbeed9f2f4$export$2e2bcd8739ae039({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
}

});

parcelRegister("1WiZb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c77f4c6a2336f8ae$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0179ace6db90174fb1e33ede0463bdef>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4BqOc = parcelRequire("4BqOc");


var $kXb3C = parcelRequire("kXb3C");

function $c77f4c6a2336f8ae$export$2e2bcd8739ae039({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
}

});

parcelRegister("ey7ks", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c86924eeed42fcc2$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed150536831ff7c67188f4dba2c48b6d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4BqOc = parcelRequire("4BqOc");


var $fP78j = parcelRequire("fP78j");

function $c86924eeed42fcc2$export$2e2bcd8739ae039({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
}

});

parcelRegister("9Q0L0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4cf8a3e1f7af7bd1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4648df99867255b9e8ae22693a4d25a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $fP78j = parcelRequire("fP78j");

function $4cf8a3e1f7af7bd1$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
}

});

parcelRegister("cKqka", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4b99d5ed076c1160$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46cc2c056bbd3058657958f7f09f6575>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5LN4K = parcelRequire("5LN4K");


var $kXb3C = parcelRequire("kXb3C");

function $4b99d5ed076c1160$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("5rEH7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $011790d80979173b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b52a9f186ad8e116ad7e1e0109b235a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $5LN4K = parcelRequire("5LN4K");


var $fP78j = parcelRequire("fP78j");

function $011790d80979173b$export$2e2bcd8739ae039({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
}

});

parcelRegister("7Jxvl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ef63a9b3b9aed96b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c6870d6420a4692ac4cdb5a00753f738>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jz9js = parcelRequire("jz9js");


var $kXb3C = parcelRequire("kXb3C");

function $ef63a9b3b9aed96b$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("alMZU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1b8a825273197b02$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b59d4caf81c32d029adf911a314af4f7>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $jz9js = parcelRequire("jz9js");


var $fP78j = parcelRequire("fP78j");

function $1b8a825273197b02$export$2e2bcd8739ae039({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jz9js))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
}

});

parcelRegister("lWQXA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d00f1f002e9877f9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::64afc1ac758289e96d875e903d67be0d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $kR5QY = parcelRequire("kR5QY");


var $fP78j = parcelRequire("fP78j");

function $d00f1f002e9877f9$export$2e2bcd8739ae039({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
}

});

parcelRegister("4KIbP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $627ab7f82241d2c9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::08e9485c746db90f5ac9b367aa0dd41e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $49GPt = parcelRequire("49GPt");


var $kXb3C = parcelRequire("kXb3C");

function $627ab7f82241d2c9$export$2e2bcd8739ae039({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($49GPt))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("aV3Bk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $18453b22d1a1a3c1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c592506fff69a014ca0cf24d97c237af>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $49GPt = parcelRequire("49GPt");


var $fP78j = parcelRequire("fP78j");

function $18453b22d1a1a3c1$export$2e2bcd8739ae039({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($49GPt))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fX4W8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $042d51f21cf4898d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2862d801ef69d165822b8118797782a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dmbve = parcelRequire("dmbve");


var $fP78j = parcelRequire("fP78j");

function $042d51f21cf4898d$export$2e2bcd8739ae039({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("hcMBV", function(module, exports) {
var $87ac0097385af1df$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["RovoChatAction"] = "RovoChatAction";
    CardAction["ViewAction"] = "ViewAction";
    return CardAction;
}({});
module.exports["CardAction"] = $87ac0097385af1df$export$f40b7e0b762b928b;

});

parcelRegister("4P3K9", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $4fbbebc17c1a2887$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $kzSaQ.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $kzSaQ.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonOwnedBy"] = $4fbbebc17c1a2887$export$19ee667f3f7a6ec3;

});

parcelRegister("4ymXE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df727533991c4aac2a7e523738f16a10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $350c2601c1bf73a9$var$_react = $350c2601c1bf73a9$var$_interopRequireDefault((parcelRequire("42omo")));

var $350c2601c1bf73a9$var$_baseNew = $350c2601c1bf73a9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $350c2601c1bf73a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $350c2601c1bf73a9$var$AiSearchIcon = (props)=>/*#__PURE__*/ $350c2601c1bf73a9$var$_react.default.createElement($350c2601c1bf73a9$var$_baseNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$350c2601c1bf73a9$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $350c2601c1bf73a9$var$_default = module.exports.default = $350c2601c1bf73a9$var$AiSearchIcon;

});

parcelRegister("h982G", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");


var $i25hX = parcelRequire("i25hX");

const $a5e138d08f3fc65b$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $a5e138d08f3fc65b$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $a5e138d08f3fc65b$var$allowedSubdomains = [
    '.jira-dev.com',
    '.jira.atlassian.cloud',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $a5e138d08f3fc65b$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $a5e138d08f3fc65b$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($a5e138d08f3fc65b$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $a5e138d08f3fc65b$var$allowedOrigins.includes(hostname));
};
const $a5e138d08f3fc65b$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $i25hX.usePublish)('ai-mate');
    (0, $42omo.useEffect)(()=>{
        const handlerUnbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$a5e138d08f3fc65b$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $a5e138d08f3fc65b$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $a5e138d08f3fc65b$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload, (0, $dh538.fg)('ai-mate-pub-sub-post-message-origin-fix') ? {
                        targetOrigin: '*'
                    } : undefined);
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $a5e138d08f3fc65b$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $a5e138d08f3fc65b$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $42omo.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const handlerUnbind = (0, $fFa3V.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$a5e138d08f3fc65b$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $a5e138d08f3fc65b$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $42omo.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $a5e138d08f3fc65b$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $a5e138d08f3fc65b$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};
module.exports["ROVO_POST_MESSAGE_EVENT_TYPE"] = $a5e138d08f3fc65b$export$cabfb6cc8c48b099;
module.exports["RovoPostMessagePubsubListener"] = $a5e138d08f3fc65b$export$e5e1a9c59c299631;
module.exports["useRovoPostMessageToPubsub"] = $a5e138d08f3fc65b$export$5340cc94dd0ecbea;

});

parcelRegister("gKlAz", function(module, exports) {

var $eG1Z0 = parcelRequire("eG1Z0");


var $aoDcQ = parcelRequire("aoDcQ");

function $ac303ab343815a94$export$50d34f59d07755a2(mark, maybeNode) {
    const node = typeof maybeNode === 'string' ? (0, $aoDcQ.text)(maybeNode) : maybeNode;
    if ((0, $eG1Z0.isDuplicateMark)(node, mark.type)) {
        // eslint-disable-next-line no-console
        console.error((0, $eG1Z0.duplicateMarkError)(node, mark.type));
        return node;
    }
    node.marks = node.marks || [];
    node.marks.push(mark);
    return node;
}
module.exports["applyMark"] = $ac303ab343815a94$export$50d34f59d07755a2;

});

parcelRegister("eG1Z0", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9abe739d14fcbdba$export$5ec47a80d7cc0dfa(node, type) {
    if (node.marks && node.marks.some((mark)=>mark.type === type)) return true;
    return false;
}
function $9abe739d14fcbdba$export$db1000b9ac08ce57(node, type) {
    return `Mark with the same name '${type}' already exists on a node: ${JSON.stringify(node)}`;
}
module.exports["isDuplicateMark"] = $9abe739d14fcbdba$export$5ec47a80d7cc0dfa;
module.exports["duplicateMarkError"] = $9abe739d14fcbdba$export$db1000b9ac08ce57;

});

parcelRegister("iJQnc", function(module, exports) {

var $gKlAz = parcelRequire("gKlAz");

const $0c4bf63002e7b177$export$6565f9f03506010b = (maybeNode)=>(0, $gKlAz.applyMark)({
        type: 'code'
    }, maybeNode);
module.exports["code"] = $0c4bf63002e7b177$export$6565f9f03506010b;

});

parcelRegister("caRYB", function(module, exports) {
const $d9000e0d99d20134$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });
module.exports["doc"] = $d9000e0d99d20134$export$2a111da947c407d2;

});

parcelRegister("5x0y1", function(module, exports) {
const $548cbc934d83dd4c$export$cbf8224b64e0d942 = (attrs)=>({
        type: 'inlineCard',
        attrs: attrs
    });
module.exports["inlineCard"] = $548cbc934d83dd4c$export$cbf8224b64e0d942;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("gNXND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf9be9856ff4d9$var$_react = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("42omo")));

var $c3bf9be9856ff4d9$var$_baseNew = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c3bf9be9856ff4d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf9be9856ff4d9$var$RovoIcon = (props)=>/*#__PURE__*/ $c3bf9be9856ff4d9$var$_react.default.createElement($c3bf9be9856ff4d9$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$c3bf9be9856ff4d9$var$RovoIcon.displayName = 'RovoIcon';
var $c3bf9be9856ff4d9$var$_default = module.exports.default = $c3bf9be9856ff4d9$var$RovoIcon;

});

parcelRegister("ksiqf", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee44b6768ad41edb$export$2e2bcd8739ae039);

var $922yL = parcelRequire("922yL");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $ee44b6768ad41edb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $922yL.default)(dirtyDate, -amount);
}

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("fakaf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0a76e6973f9e2fd$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $b0a76e6973f9e2fd$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("e1kiJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a350e81639ab5a88$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $922yL = parcelRequire("922yL");


var $b5utg = parcelRequire("b5utg");

function $a350e81639ab5a88$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $922yL.default)(dirtyDate, days);
}

});

parcelRegister("d6omw", function(module, exports) {
$parcel$export(module.exports, "default", () => $989ebbba3827b0fa$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $989ebbba3827b0fa$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInMinute);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("6gF1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $49040fbe3dc0e481$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $e1kiJ = parcelRequire("e1kiJ");


var $b5utg = parcelRequire("b5utg");

function $49040fbe3dc0e481$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $e1kiJ.default)(dirtyDate, -amount);
}

});

parcelRegister("ce4zM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $7p4As = parcelRequire("7p4As");


var $kUQ8q = parcelRequire("kUQ8q");


var $2NzjA = parcelRequire("2NzjA");


var $fkwyI = parcelRequire("fkwyI");

const $7916cd98c58646d3$export$1d9b6b20d392c702 = (props)=>{
    const { href: href, onClick: onClick, ...rest } = props;
    const context = (0, $fkwyI.useTeamsNavigationContext)();
    const input = (0, $2NzjA.buildNavigationInput)({
        ...props,
        href: href ?? '',
        context: context,
        onBeforeNavigate: onClick
    });
    const navigationProps = (0, $kUQ8q.getNavigationProps)(input);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
        ...rest,
        ...navigationProps
    });
};
module.exports["TeamsLinkButton"] = $7916cd98c58646d3$export$1d9b6b20d392c702;

});

parcelRegister("kUQ8q", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $2NzjA = parcelRequire("2NzjA");


var $bO6QG = parcelRequire("bO6QG");

function $198f8477e4ad60c0$export$9f4607ca273c83d(input) {
    const { href: rawHref, intent: intent, context: context, onClick: rawOnClick } = input;
    const previewPanelProps = 'previewPanelProps' in input ? input.previewPanelProps : undefined;
    const resolvedIntent = intent !== 'unknown' ? intent : (0, $bO6QG.classifyNavigationIntent)(rawHref);
    const openLinkInNewTab = resolvedIntent === 'external' || context.forceExternalIntent;
    // Prefix relative hrefs with the context entry point for the current product
    const href = (0, $dh538.fg)('ptc-fix-teams-isolated-links') ? (0, $2NzjA.prefixWithContextEntryPoint)(rawHref, context.contextEntryPoint) : openLinkInNewTab ? rawHref : (0, $2NzjA.prefixWithContextEntryPoint)(rawHref, context.contextEntryPoint ?? '');
    if (openLinkInNewTab) return {
        href: href,
        target: '_blank',
        rel: 'noopener noreferrer',
        onClick: (...args)=>{
            const e = args[0];
            rawOnClick?.(...args);
            if (e.defaultPrevented) return;
            e.preventDefault();
            window.open(href, '_blank', 'noopener noreferrer');
        }
    };
    return {
        href: href,
        target: '_self',
        onClick: (...args)=>{
            const e = args[0];
            rawOnClick?.(...args);
            if (e.defaultPrevented) return;
            // Handle left-click with modifier keys (let browser handle it)
            if (e.button === 0 && (0, $2NzjA.isModified)(e)) return;
            if (previewPanelProps && context.openPreviewPanel) try {
                context.openPreviewPanel({
                    ari: previewPanelProps.ari,
                    name: previewPanelProps.name,
                    url: href
                });
                e.preventDefault();
                return;
            } catch  {
            // Fall through to navigation below if opening the preview panel fails
            }
            // Handle left-clicks without modifier keys
            if (context.navigate && // only use navigate when a handler is provided
            (0, $2NzjA.isTeamsAppRoute)(href) && // only SPA navigate for townsquare routes
            e.button === 0 && // only use navigate for left mouse button clicks
            !(0, $2NzjA.isModified)(e) // let browser handle clicks with modifier
            ) {
                e.preventDefault();
                const routePath = (0, $2NzjA.getRoutePathFromUrl)(href);
                context.navigate(routePath);
                return;
            }
        }
    };
}
module.exports["getNavigationProps"] = $198f8477e4ad60c0$export$9f4607ca273c83d;

});

parcelRegister("2NzjA", function(module, exports) {
// A collection of utility functions for the teams-app-internal-navigation package.

var $dh538 = parcelRequire("dh538");

const $37f03f3dd6637609$export$895d6838d29edd02 = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $37f03f3dd6637609$export$f9ded33a1a6c97c7 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $37f03f3dd6637609$export$ced0c1c5c19926df = (url)=>{
    try {
        const path = $37f03f3dd6637609$export$78cf1468c39d05b1(url);
        const hostname = new URL(url).hostname;
        return (hostname.includes('home.atlassian') || $37f03f3dd6637609$export$634ecc602a6871aa(hostname) || $37f03f3dd6637609$export$9186ccba8effc5de(hostname)) && path.includes('/people');
    } catch  {
        return false;
    }
};
const $37f03f3dd6637609$export$715c8f9057ac0c01 = (path, contextEntryPoint = '')=>{
    if ((0, $dh538.fg)('ptc-fix-teams-isolated-links')) {
        if ($37f03f3dd6637609$export$895d6838d29edd02(path) || // do not prefix for absolute URL
        contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
        path.startsWith('/')) return path;
        return `${contextEntryPoint}/${path}`;
    }
    if ($37f03f3dd6637609$export$895d6838d29edd02(path) || !contextEntryPoint || path.startsWith('/') || path.startsWith(contextEntryPoint)) return path;
    return `${contextEntryPoint}/${path}`;
};
const $37f03f3dd6637609$export$78cf1468c39d05b1 = (url)=>{
    try {
        const parsedUrl = new URL(url, window.location.origin);
        return parsedUrl.pathname;
    } catch  {
        // fallback for malformed URLs
        return url;
    }
};
function $37f03f3dd6637609$export$e0ed33167fbba483({ href: href, context: context, onBeforeNavigate: onBeforeNavigate, ...intentProps }) {
    return intentProps.intent === 'action' ? {
        href: href,
        intent: intentProps.intent,
        previewPanelProps: intentProps.previewPanelProps,
        context: context,
        onClick: onBeforeNavigate
    } : {
        href: href,
        intent: intentProps.intent,
        context: context,
        onClick: onBeforeNavigate
    };
}
// FedRAMP domain patterns used by Atlassian products
const $37f03f3dd6637609$var$FEDRAMP_DOMAIN_PATTERNS = /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/;
// Isolated Cloud domain pattern
const $37f03f3dd6637609$var$ISOLATED_CLOUD_DOMAIN_PATTERN = /atlassian-isolated\.net/;
const $37f03f3dd6637609$export$634ecc602a6871aa = (hostname)=>{
    return $37f03f3dd6637609$var$FEDRAMP_DOMAIN_PATTERNS.test(hostname.toLowerCase());
};
const $37f03f3dd6637609$export$9186ccba8effc5de = (hostname)=>{
    return $37f03f3dd6637609$var$ISOLATED_CLOUD_DOMAIN_PATTERN.test(hostname.toLowerCase());
};
module.exports["isModified"] = $37f03f3dd6637609$export$f9ded33a1a6c97c7;
module.exports["isTeamsAppRoute"] = $37f03f3dd6637609$export$ced0c1c5c19926df;
module.exports["getRoutePathFromUrl"] = $37f03f3dd6637609$export$78cf1468c39d05b1;
module.exports["isFedramp"] = $37f03f3dd6637609$export$634ecc602a6871aa;
module.exports["isIsolatedCloud"] = $37f03f3dd6637609$export$9186ccba8effc5de;
module.exports["prefixWithContextEntryPoint"] = $37f03f3dd6637609$export$715c8f9057ac0c01;
module.exports["buildNavigationInput"] = $37f03f3dd6637609$export$e0ed33167fbba483;

});

parcelRegister("bO6QG", function(module, exports) {

var $2NzjA = parcelRequire("2NzjA");

// List of domains that are considered Atlassian domains - taken from https://support.atlassian.com/organization-administration/docs/ip-addresses-and-domains-for-atlassian-cloud-products/
const $e6ddea2768c8fc71$var$ATLASSIAN_DOMAINS = [
    'localhost',
    '127.0.0.1',
    'atlassian.com',
    'atlassian.net',
    'atl-paas.net',
    'ss-inf.net',
    'jira.com',
    'bitbucket.org',
    'trello.com',
    'loom.com',
    'atlassian-dev.net',
    'atlassian-us-gov-mod.com',
    'atlassian-us-gov-mod.net',
    'atlassian-us-gov.com',
    'atlassian-us-gov.net',
    'atlassian-fex.com',
    'atlassian-fex.net',
    'atlassian-stg-fedm.com',
    'atlassian-stg-fedm.net',
    'atlassian-isolated.net'
];
/** Extra roots for staging links */ const $e6ddea2768c8fc71$var$STAGING_SUFFIXES = [
    'staging.atlassian.io',
    'atl-test.space',
    'jira-dev.com',
    'stg-jira.com',
    'staging.paas-inf.net'
];
function $e6ddea2768c8fc71$var$matchesDomainList(hostname, domains) {
    const lower = hostname.toLowerCase();
    return domains.some((domain)=>lower === domain || lower.endsWith('.' + domain));
}
function $e6ddea2768c8fc71$var$isAtlassianDomain(hostname) {
    const lower = hostname.toLowerCase();
    return $e6ddea2768c8fc71$var$matchesDomainList(hostname, $e6ddea2768c8fc71$var$ATLASSIAN_DOMAINS) || $e6ddea2768c8fc71$var$matchesDomainList(hostname, $e6ddea2768c8fc71$var$STAGING_SUFFIXES) || (0, $2NzjA.isFedramp)(lower) || (0, $2NzjA.isIsolatedCloud)(lower);
}
const $e6ddea2768c8fc71$var$REFERENCE_DOMAINS = [
    'support.atlassian.com',
    'developer.atlassian.com',
    'community.atlassian.com'
];
function $e6ddea2768c8fc71$var$isReferenceDomain(hostname) {
    return $e6ddea2768c8fc71$var$matchesDomainList(hostname, $e6ddea2768c8fc71$var$REFERENCE_DOMAINS);
}
function $e6ddea2768c8fc71$export$f293869d7b7da38b(href) {
    const IS_ABSOLUTE_LINK_REGEX = /^(?:(http|https):\/\/)/;
    const IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
    const isAbsolute = IS_ABSOLUTE_LINK_REGEX.test(href);
    const isNonHttpBased = IS_NON_HTTP_BASED.test(href);
    const isRelative = !isAbsolute && !isNonHttpBased;
    if (isRelative) return 'navigation';
    let parsedUrl;
    try {
        parsedUrl = new URL(href);
    } catch  {
        return 'unknown';
    }
    if (!$e6ddea2768c8fc71$var$isAtlassianDomain(parsedUrl.hostname)) return 'external';
    if ($e6ddea2768c8fc71$var$isReferenceDomain(parsedUrl.hostname)) return 'reference';
    if ($e6ddea2768c8fc71$var$isAtlassianDomain(parsedUrl.hostname)) return 'navigation';
    return 'unknown';
}
module.exports["classifyNavigationIntent"] = $e6ddea2768c8fc71$export$f293869d7b7da38b;

});

parcelRegister("fkwyI", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $2c55f0ec14db1a69$var$NavigationContextReact = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
function $2c55f0ec14db1a69$export$e41452ac1c641b11({ value: value, children: children }) {
    const ancestorEntryPoint = (0, $42omo.useContext)($2c55f0ec14db1a69$var$NavigationContextReact)?.contextEntryPoint;
    const contextValue = (0, $42omo.useMemo)(()=>!value.contextEntryPoint && ancestorEntryPoint ? {
            ...value,
            contextEntryPoint: ancestorEntryPoint
        } : value, [
        ancestorEntryPoint,
        value
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($2c55f0ec14db1a69$var$NavigationContextReact.Provider, {
        value: contextValue,
        children: children
    });
}
function $2c55f0ec14db1a69$export$f3c3decdfa7dda68() {
    const context = (0, $42omo.useContext)($2c55f0ec14db1a69$var$NavigationContextReact);
    return context ?? {};
}
module.exports["TeamsNavigationProvider"] = $2c55f0ec14db1a69$export$e41452ac1c641b11;
module.exports["useTeamsNavigationContext"] = $2c55f0ec14db1a69$export$f3c3decdfa7dda68;

});

parcelRegister("aCzn4", function(module, exports) {
const $26c671ba196278bc$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
module.exports["isBasicClick"] = $26c671ba196278bc$export$eddcd8a5b7e09991;

});

parcelRegister("kPml2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f767605c1291541e11ee398674a3c525>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f299e6000fe75318$var$_react = $f299e6000fe75318$var$_interopRequireDefault((parcelRequire("42omo")));

var $f299e6000fe75318$var$_baseNew = $f299e6000fe75318$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f299e6000fe75318$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f299e6000fe75318$var$LocationIcon = (props)=>/*#__PURE__*/ $f299e6000fe75318$var$_react.default.createElement($f299e6000fe75318$var$_baseNew.default, Object.assign({
        name: "LocationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$f299e6000fe75318$var$LocationIcon.displayName = 'LocationIcon';
var $f299e6000fe75318$var$_default = module.exports.default = $f299e6000fe75318$var$LocationIcon;

});

parcelRegister("9yt4X", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $huXH9 = parcelRequire("huXH9");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $087487947faf3e7f$var$styles = {
    image: "_5ral1dfr _4t3i1osq _1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
    banner: "_1bsb1osq",
    bannerFillSpace: "_1bsb1osq _4t3i1osq _5ral1dfr"
};
const $087487947faf3e7f$var$Observer = ({ onLoad: onLoad })=>{
    (0, $42omo.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    return null;
};

const $087487947faf3e7f$var$AutoDevAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Jp34")));

const $087487947faf3e7f$var$AutoFixAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iXcnT")));

const $087487947faf3e7f$var$AutoReviewAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("aUp1o")));

const $087487947faf3e7f$var$BacklogBuddyAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3KJ0b")));

const $087487947faf3e7f$var$CommsCrafterAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("eKuAc")));

const $087487947faf3e7f$var$CultureAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6kpkG")));

const $087487947faf3e7f$var$CustomerInsightAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Q4wY")));

const $087487947faf3e7f$var$DecisionDirectorAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dRCU8")));

const $087487947faf3e7f$var$FeatureFlagAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kQTXK")));

const $087487947faf3e7f$var$GenericAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kFBSF")));

const $087487947faf3e7f$var$HireWriterAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("44XTS")));

const $087487947faf3e7f$var$MarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2SnMt")));

const $087487947faf3e7f$var$MyUserManualAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cXu7g")));

const $087487947faf3e7f$var$OkrOracleAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3EvKg")));

const $087487947faf3e7f$var$OpsAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("htmh0")));

const $087487947faf3e7f$var$PitchPerfectorAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kTVse")));

const $087487947faf3e7f$var$ProductRequirementAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("emHN5")));

const $087487947faf3e7f$var$ReleaseNotesAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9Oxg9")));

const $087487947faf3e7f$var$ResearchScoutAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("doqXm")));

const $087487947faf3e7f$var$RovoDevAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("k0SSx")));

const $087487947faf3e7f$var$SocialMediaScribeAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kVvzt")));

const $087487947faf3e7f$var$TeamConnectionAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Hx38")));

const $087487947faf3e7f$var$WorkflowBuilderAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3v9w9")));

const $087487947faf3e7f$var$TrialGuideAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("58iCo")));

const $087487947faf3e7f$var$JsmRovoServiceAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("df4F9"))); /**
                                      * OOTB Agents avatars - start
                                      */ 

const $087487947faf3e7f$var$AmplitudeAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("cbUPK")));

const $087487947faf3e7f$var$BoxAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gGDJa")));

const $087487947faf3e7f$var$CanvaAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jmaDr")));

const $087487947faf3e7f$var$FigmaAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ajnZr")));

const $087487947faf3e7f$var$HubSpotAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iLrU0")));

const $087487947faf3e7f$var$IntercomAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("FA5RY")));

const $087487947faf3e7f$var$GammaAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jm9GH")));

const $087487947faf3e7f$var$LovableAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2Hqsv")));

const $087487947faf3e7f$var$ReplitAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fKjEJ")));

const $087487947faf3e7f$var$RovoAgentAvatar = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("bHCOw"))); /**
                          * OOTB Agents avatars - end
                          */ 
const $087487947faf3e7f$export$cf7c9ad03f4a70b2 = {
    primary: '#FCA700',
    secondary: '#FFC716'
};
const $087487947faf3e7f$export$3e344798f7855e62 = {
    primary: '#BF63F3',
    secondary: '#D8A0F7'
};
const $087487947faf3e7f$export$a3d0897f023251ae = {
    primary: '#82B536',
    secondary: '#B3DF72'
};
const $087487947faf3e7f$export$d933daaf7b69e6ee = {
    primary: '#357DE8',
    secondary: '#669DF1'
};
const $087487947faf3e7f$var$colorList = [
    $087487947faf3e7f$export$cf7c9ad03f4a70b2,
    $087487947faf3e7f$export$3e344798f7855e62,
    $087487947faf3e7f$export$a3d0897f023251ae,
    $087487947faf3e7f$export$d933daaf7b69e6ee
]; /**
                                                                               * NOTE: DO NOT ADD OOTB AGENTAVATARS TO THIS LIST
                                                                               */ 
const $087487947faf3e7f$var$avatarList = [
    $087487947faf3e7f$var$CustomerInsightAvatar,
    $087487947faf3e7f$var$BacklogBuddyAvatar,
    $087487947faf3e7f$var$DecisionDirectorAvatar,
    $087487947faf3e7f$var$CommsCrafterAvatar,
    $087487947faf3e7f$var$AutoDevAvatar,
    $087487947faf3e7f$var$OkrOracleAvatar,
    $087487947faf3e7f$var$CultureAvatar,
    $087487947faf3e7f$var$SocialMediaScribeAvatar,
    $087487947faf3e7f$var$TeamConnectionAvatar,
    $087487947faf3e7f$var$HireWriterAvatar,
    $087487947faf3e7f$var$OpsAgentAvatar,
    $087487947faf3e7f$var$ResearchScoutAvatar,
    $087487947faf3e7f$var$ReleaseNotesAvatar,
    $087487947faf3e7f$var$MyUserManualAvatar,
    $087487947faf3e7f$var$PitchPerfectorAvatar,
    $087487947faf3e7f$var$AutoDevAvatar,
    $087487947faf3e7f$var$AutoFixAvatar,
    $087487947faf3e7f$var$AutoReviewAvatar,
    $087487947faf3e7f$var$MarketingMessageMaestroAvatar,
    $087487947faf3e7f$var$FeatureFlagAvatar,
    $087487947faf3e7f$var$ProductRequirementAvatar
];
const $087487947faf3e7f$export$a834793a4d0d739e = $087487947faf3e7f$var$avatarList.length * $087487947faf3e7f$var$colorList.length;
const $087487947faf3e7f$var$outOfTheBoxAgentAvatar = {
    autodev_template_unit_test_creator: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AutoFixAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_migration_config_changer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$OpsAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_vulnerable_dependency_updater_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MarketingMessageMaestroAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_standardizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MyUserManualAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_observer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$ResearchScoutAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_template_code_accessibility_checker_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$HireWriterAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_code_documentation_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$SocialMediaScribeAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    autodev_feature_flag_cleaner_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$FeatureFlagAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$DecisionDirectorAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$MyUserManualAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$ProductRequirementAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    issue_organizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$BacklogBuddyAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$a3d0897f023251ae.primary,
                secondaryColor: $087487947faf3e7f$export$a3d0897f023251ae.secondary
            }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    },
    ops_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$OpsAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    jira_workflow_builder_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$WorkflowBuilderAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
                secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    itops_rca_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AutoReviewAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $087487947faf3e7f$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    jira_trial_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$TrialGuideAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
                secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    jira_admin_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AutoDevAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
                secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    jsm_rovo_service_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$JsmRovoServiceAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$cf7c9ad03f4a70b2
    },
    mcp_amplitude_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$AmplitudeAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_box_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$BoxAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_canva_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$CanvaAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_figma_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$FigmaAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_hubspot_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$HubSpotAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_intercom_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$IntercomAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_gamma_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$GammaAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_lovable_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$LovableAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    mcp_replit_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$ReplitAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    },
    rovo_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$RovoAgentAvatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    }
}; /**
    * agentIdentityAccountId examples:
    * 5b985e7c96cb052b5f65c830
    * 712020:19e57f67-c132-462b-8503-0c19953122cd
    *
    * agentId examples:
    * cd002f25-46e4-4023-80ff-32e4d90849b4
    */ 
const $087487947faf3e7f$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
    // we prioritise agentIdentityAccountId first if it is available
    // this is because agentIdentityAccountId is more widely available (e.g. in ProfilePage)
    const idForAgentAvatar = agentIdentityAccountId || agentId;
    if (idForAgentAvatar) {
        // Take the last 8 characters of the id because JS can't handle 16 digit numbers
        const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
        const parsedId = parseInt(trimmedId, 16);
        if (isNaN(parsedId)) return 0;
        else return parsedId;
    }
    return null;
};
const $087487947faf3e7f$var$ROVO_DEV_AGENT_ID = '027f0676-e8e9-4939-8962-3850987d78bb';
const $087487947faf3e7f$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, size: size })=>{
    if (isRovoDev) return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$RovoDevAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    };
     //@TODO CRCS-3129: Remove Rovo Dev hardcoded icon after TeamEU demos
    // Handle Rovo Dev agent avatar for TeamEU Demo
    if (agentId === $087487947faf3e7f$var$ROVO_DEV_AGENT_ID && (0, $dh538.fg)('jira_ai_force_rovo_dev_avatar')) return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$RovoDevAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $087487947faf3e7f$export$a3d0897f023251ae
    };
    if (typeof agentNamedId === 'string' && $087487947faf3e7f$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $087487947faf3e7f$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    const numberId = $087487947faf3e7f$export$c84eb7708138dd4({
        agentIdentityAccountId: agentIdentityAccountId,
        agentId: agentId
    });
    if (numberId !== null) {
        /**
     * this create all possible combinations of avatars and colors
     * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
     * then choose 1 based on agentId
     */ const totalCombinations = $087487947faf3e7f$var$avatarList.length * $087487947faf3e7f$var$colorList.length;
        const combinationIndex = numberId % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $087487947faf3e7f$var$colorList.length);
        const colorIndex = combinationIndex % $087487947faf3e7f$var$colorList.length;
        const Avatar = $087487947faf3e7f$var$avatarList[avatarIndex];
        const color = $087487947faf3e7f$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, $l998X.jsx)(Avatar, {
                size: (0, $huXH9.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$GenericAvatar, {
            size: (0, $huXH9.AVATAR_SIZES)[size],
            primaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.primary,
            secondaryColor: $087487947faf3e7f$export$d933daaf7b69e6ee.secondary
        }),
        color: $087487947faf3e7f$export$d933daaf7b69e6ee
    };
};
const $087487947faf3e7f$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, height: height, fillSpace: fillSpace })=>{
    const { color: color } = $087487947faf3e7f$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        isRovoDev: isRovoDev,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($087487947faf3e7f$var$styles.banner, fillSpace ? $087487947faf3e7f$var$styles.bannerFillSpace : undefined),
        style: {
            backgroundColor: color.primary,
            height: height ? `${height}px` : undefined
        }
    });
};
const $087487947faf3e7f$export$96bb253b7de22616 = (props)=>{
    const { render: render, color: color } = $087487947faf3e7f$var$getAvatarRender(props);
    const { onLoad: onLoad } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $087487947faf3e7f$var$styles.image,
        style: {
            backgroundColor: color.primary
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Suspense), {
            fallback: null,
            children: [
                onLoad && /*#__PURE__*/ (0, $l998X.jsx)($087487947faf3e7f$var$Observer, {
                    onLoad: onLoad
                }),
                render
            ]
        })
    });
};
module.exports["AgentBanner"] = $087487947faf3e7f$export$6efaefb8ad2fba40;
module.exports["GeneratedAvatar"] = $087487947faf3e7f$export$96bb253b7de22616;

});

parcelRegister("1Jp34", function(module, exports) {

let $142d6c869fc93f1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $142d6c869fc93f1c$var$load("c9Qqc").then(()=>parcelRequire('f0XYo'));

});

parcelRegister("iXcnT", function(module, exports) {

let $dcc757fb35de9e43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dcc757fb35de9e43$var$load("1TK6P").then(()=>parcelRequire('kdo1N'));

});

parcelRegister("aUp1o", function(module, exports) {

let $7f128b1159aaf0b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f128b1159aaf0b3$var$load("grvAy").then(()=>parcelRequire('1xsEe'));

});

parcelRegister("3KJ0b", function(module, exports) {

let $2bb8937090f7886d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2bb8937090f7886d$var$load("23K0q").then(()=>parcelRequire('iOx72'));

});

parcelRegister("eKuAc", function(module, exports) {

let $abcd15b4f7a895b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $abcd15b4f7a895b0$var$load("3kQkj").then(()=>parcelRequire('5yA7f'));

});

parcelRegister("6kpkG", function(module, exports) {

let $49b842e0f53b0840$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $49b842e0f53b0840$var$load("6OXgE").then(()=>parcelRequire('40gXx'));

});

parcelRegister("1Q4wY", function(module, exports) {

let $156e297d03d850f4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $156e297d03d850f4$var$load("cbucA").then(()=>parcelRequire('e6WCz'));

});

parcelRegister("dRCU8", function(module, exports) {

let $a17e67305e32e080$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a17e67305e32e080$var$load("bVhr1").then(()=>parcelRequire('b4yf3'));

});

parcelRegister("kQTXK", function(module, exports) {

let $f2e41300efb7f39f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2e41300efb7f39f$var$load("kE0QC").then(()=>parcelRequire('lRRwN'));

});

parcelRegister("kFBSF", function(module, exports) {

let $f0c5054f72bf4788$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f0c5054f72bf4788$var$load("eVFXf").then(()=>parcelRequire('xXksI'));

});

parcelRegister("44XTS", function(module, exports) {

let $2f86000f50552006$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f86000f50552006$var$load("9FhBz").then(()=>parcelRequire('gHjiO'));

});

parcelRegister("2SnMt", function(module, exports) {

let $21831245fa81e40e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21831245fa81e40e$var$load("6zB8z").then(()=>parcelRequire('9sJzD'));

});

parcelRegister("cXu7g", function(module, exports) {

let $96f25b251372ce30$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $96f25b251372ce30$var$load("eENGY").then(()=>parcelRequire('cxxnV'));

});

parcelRegister("3EvKg", function(module, exports) {

let $2a8dbb6f12744413$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a8dbb6f12744413$var$load("hmlb0").then(()=>parcelRequire('8nSrm'));

});

parcelRegister("htmh0", function(module, exports) {

let $cb866c206a5b0b04$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb866c206a5b0b04$var$load("2NGxc").then(()=>parcelRequire('hGaQU'));

});

parcelRegister("kTVse", function(module, exports) {

let $f37582f3db40c2c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f37582f3db40c2c1$var$load("bPgcq").then(()=>parcelRequire('4zXPl'));

});

parcelRegister("emHN5", function(module, exports) {

let $a75516b19f472f5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a75516b19f472f5d$var$load("31b1q").then(()=>parcelRequire('1xC4V'));

});

parcelRegister("9Oxg9", function(module, exports) {

let $725295393c538ed1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $725295393c538ed1$var$load("8Lh9U").then(()=>parcelRequire('kqZOw'));

});

parcelRegister("doqXm", function(module, exports) {

let $9c026d43c7a38bfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9c026d43c7a38bfd$var$load("6ZzYJ").then(()=>parcelRequire('bZPun'));

});

parcelRegister("k0SSx", function(module, exports) {

let $e91e6080a2f1e543$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e91e6080a2f1e543$var$load("2zIbn").then(()=>parcelRequire('bXyC6'));

});

parcelRegister("kVvzt", function(module, exports) {

let $f3c19ee75daa2848$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f3c19ee75daa2848$var$load("410SS").then(()=>parcelRequire('aY5Ef'));

});

parcelRegister("2Hx38", function(module, exports) {

let $1f793be472254651$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f793be472254651$var$load("z3s9q").then(()=>parcelRequire('9mYoH'));

});

parcelRegister("3v9w9", function(module, exports) {

let $28cba65833e09a5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28cba65833e09a5e$var$load("9gqcE").then(()=>parcelRequire('3hbTz'));

});

parcelRegister("58iCo", function(module, exports) {

let $3bcc244b8daf70af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3bcc244b8daf70af$var$load("eipnW").then(()=>parcelRequire('3AA8L'));

});

parcelRegister("df4F9", function(module, exports) {

let $9a404af99aaca7d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a404af99aaca7d7$var$load("jdAk9").then(()=>parcelRequire('bqzK1'));

});

parcelRegister("cbUPK", function(module, exports) {

let $8e029916cb1e3744$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8e029916cb1e3744$var$load("fbike").then(()=>parcelRequire('GyvF7'));

});

parcelRegister("gGDJa", function(module, exports) {

let $c25f62a14bcce2dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c25f62a14bcce2dc$var$load("4n4TY").then(()=>parcelRequire('UImUr'));

});

parcelRegister("jmaDr", function(module, exports) {

let $e178525485a33ea1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e178525485a33ea1$var$load("2aX2w").then(()=>parcelRequire('6EXWp'));

});

parcelRegister("ajnZr", function(module, exports) {

let $781e49aade0ad5b2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $781e49aade0ad5b2$var$load("dWdGk").then(()=>parcelRequire('bE44a'));

});

parcelRegister("iLrU0", function(module, exports) {

let $da92429d11cff6c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da92429d11cff6c5$var$load("hQhwm").then(()=>parcelRequire('3wBah'));

});

parcelRegister("FA5RY", function(module, exports) {

let $07cfd3e6c0d3435a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $07cfd3e6c0d3435a$var$load("7VfH7").then(()=>parcelRequire('5WMJM'));

});

parcelRegister("jm9GH", function(module, exports) {

let $e1779632453b15d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e1779632453b15d8$var$load("aJ4jy").then(()=>parcelRequire('bPhHP'));

});

parcelRegister("2Hqsv", function(module, exports) {

let $1f741f18d9a21a24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f741f18d9a21a24$var$load("4AOh0").then(()=>parcelRequire('6z9xT'));

});

parcelRegister("fKjEJ", function(module, exports) {

let $b76a6629f8d79b96$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b76a6629f8d79b96$var$load("i87P0").then(()=>parcelRequire('cP8YK'));

});

parcelRegister("bHCOw", function(module, exports) {

let $8851d178ad87e908$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8851d178ad87e908$var$load("aLqH7").then(()=>parcelRequire('iA7sC'));

});

parcelRegister("hezkK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $huXH9 = parcelRequire("huXH9");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $9yt4X = parcelRequire("9yt4X");


var $4Ve7Q = parcelRequire("4Ve7Q");

const $4efd70df50f13ebd$export$2f5dfaa7873e8973 = `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`;
const $4efd70df50f13ebd$var$styles = {
    agentAvatar: "_1e0c1txw _1bah1h6o _4cvr1h6o _mkrz1k6g",
    image: "_5ral1dfr _4t3i1osq _1bsb1osq",
    avatarContentContainer: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $4efd70df50f13ebd$var$stylesCompiled = {
    innerShape: "_4t3i1lk2 _1bsb1lk2 _mkrz1k6g"
};
const $4efd70df50f13ebd$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isRovoDev: isRovoDev, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "aria-label": label,
        xcss: $4efd70df50f13ebd$var$styles.agentAvatar,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $huXH9.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $huXH9.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {},
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(0, $dh538.fg)('rovo_chat_bugfix_agent_avatar_squish') ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minHeight: (0, $huXH9.AVATAR_SIZES)[size],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minWidth: (0, $huXH9.AVATAR_SIZES)[size]
            } : {}
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $4efd70df50f13ebd$var$stylesCompiled.innerShape
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $4efd70df50f13ebd$var$styles.avatarContentContainer,
                children: imgUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "img",
                    xcss: $4efd70df50f13ebd$var$styles.image,
                    src: imgUrl,
                    alt: name || label || formatMessage((0, $4Ve7Q.messages).agentAvatarLabel)
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9yt4X.GeneratedAvatar), {
                    agentId: agentId,
                    agentNamedId: agentNamedId,
                    agentIdentityAccountId: agentIdentityAccountId,
                    isRovoDev: isRovoDev,
                    size: size
                })
            })
        })
    });
};
module.exports["AGENT_AVATAR_CLIP_PATH"] = $4efd70df50f13ebd$export$2f5dfaa7873e8973;
module.exports["AgentAvatar"] = $4efd70df50f13ebd$export$38b71b080e1832c8;

});

parcelRegister("4Ve7Q", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $c1395595ab243cbd$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    agentAvatarLabel: {
        id: "ai-mate.agent-avatar-label",
        defaultMessage: "Agent avatar"
    }
});
module.exports["messages"] = $c1395595ab243cbd$export$defe85febe8b728c;

});

parcelRegister("3gzdJ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2Nwuj = parcelRequire("2Nwuj");


var $kUQ8q = parcelRequire("kUQ8q");


var $2NzjA = parcelRequire("2NzjA");


var $fkwyI = parcelRequire("fkwyI");

const $4ac461805307bdc4$export$72d1cecfc3326890 = (props)=>{
    const { href: href, onClick: onClick, children: children, ...rest } = props;
    const context = (0, $fkwyI.useTeamsNavigationContext)();
    const input = (0, $2NzjA.buildNavigationInput)({
        ...props,
        href: href ?? '',
        context: context,
        onBeforeNavigate: onClick
    });
    const { onClick: composedOnClick, href: resolvedHref, target: target, rel: rel } = (0, $kUQ8q.getNavigationProps)(input);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        ...rest,
        href: resolvedHref,
        target: target,
        rel: rel,
        onClick: composedOnClick,
        children: children
    });
};
module.exports["TeamsLink"] = $4ac461805307bdc4$export$72d1cecfc3326890;

});

parcelRegister("8nlrk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $lAwme = parcelRequire("lAwme");


var $bUp2E = parcelRequire("bUp2E");


var $caPHA = parcelRequire("caPHA");

const $6b7f2dce15d051f7$export$62aa48085237e36f = ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
    (0, $42omo.useEffect)(()=>{
        if (fireAnalytics) fireAnalytics(`ui.${(0, $bUp2E.getActionSubject)(profileType)}.rendered.spinner`, {
            firedAt: Math.round((0, $caPHA.getPageTime)()),
            ...(0, $bUp2E.PACKAGE_META_DATA)
        });
    }, [
        fireAnalytics,
        profileType
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAwme.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
    });
};
module.exports["LoadingState"] = $6b7f2dce15d051f7$export$62aa48085237e36f;

});

parcelRegister("7Y4kW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lDwiy = parcelRequire("lDwiy");

const $eb50cc4a563796fc$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
        ...props,
        label: ""
    });
module.exports["ChatPillIcon"] = $eb50cc4a563796fc$export$38f9b635c1c454e7;

});

parcelRegister("lBFuf", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $hge3g = parcelRequire("hge3g");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $7Y4kW = parcelRequire("7Y4kW");


var $jz7J7 = parcelRequire("jz7J7");

const $204b57ff8caef44c$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $204b57ff8caef44c$var$styles = {
    button: "_2rko12b0 _11c8fhey _189ee4h9 _1dqonqa1 _1h6d1l7x _syazazsu _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhksm61 _irr31dpa _1di6fcek",
    buttonInline: "_18zrv77o",
    queryText: "_1nmz1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm"
};
const $204b57ff8caef44c$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.075",
                alignBlock: "baseline",
                children: [
                    renderIcon ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7Y4kW.ChatPillIcon), {}) : null,
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($204b57ff8caef44c$var$styles.queryText, whiteSpacePreWrap && $204b57ff8caef44c$var$styles.whiteSpacePreWrap),
                        children: children
                    })
                ]
            })
        })
    }));
const $204b57ff8caef44c$export$76b47032dcd9063b = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                xcss: $204b57ff8caef44c$var$styles.buttonInline,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hge3g))), {
                        color: "currentColor",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $204b57ff8caef44c$var$styles.queryText,
                        children: formatMessage((0, $jz7J7.default).browseAgentsPillLabel)
                    })
                ]
            })
        })
    });
});
module.exports["ChatPill"] = $204b57ff8caef44c$export$e33faa86e0996d96;
module.exports["BrowseAgentsPill"] = $204b57ff8caef44c$export$76b47032dcd9063b;

});

parcelRegister("jz7J7", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $5fc6573ead9ef7c8$var$message = (0, $aXWIB.defineMessages)({
    browseAgentsPillLabel: {
        id: "ai-mate.rovo-agent-components.browse-agents-pill.label",
        defaultMessage: "Browse agents"
    }
});
var $5fc6573ead9ef7c8$export$2e2bcd8739ae039 = $5fc6573ead9ef7c8$var$message;
module.exports["default"] = $5fc6573ead9ef7c8$export$2e2bcd8739ae039;

});

parcelRegister("5TGLQ", function(module, exports) {

var $gL6du = parcelRequire("gL6du");


var $aw01o = parcelRequire("aw01o");


var $a6FC8 = parcelRequire("a6FC8");

const $0aa0cd7558ee373c$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $gL6du.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $aw01o.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $a6FC8.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $a6FC8.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};
module.exports["createLocalizationProvider"] = $0aa0cd7558ee373c$export$ea56ca58f08ffa52;

});

parcelRegister("gL6du", function(module, exports) {
const $21e9301be8cff986$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $21e9301be8cff986$export$dca0327c9b9c6498;

});

parcelRegister("aw01o", function(module, exports) {

var $gL6du = parcelRequire("gL6du");


var $3nGJd = parcelRequire("3nGJd");


var $4eigd = parcelRequire("4eigd");


var $2iEso = parcelRequire("2iEso");

const $734802129a3b7f4d$var$INVALID_DATE = new Date(NaN);
const $734802129a3b7f4d$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $734802129a3b7f4d$var$INVARIANT_DATE = (0, $2iEso.toDate)($734802129a3b7f4d$var$INVARIANT);
const $734802129a3b7f4d$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $734802129a3b7f4d$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $734802129a3b7f4d$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $734802129a3b7f4d$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $734802129a3b7f4d$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $gL6du.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($734802129a3b7f4d$var$INVARIANT_DATE);
    const shortDate = $734802129a3b7f4d$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($734802129a3b7f4d$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $734802129a3b7f4d$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $734802129a3b7f4d$var$stripExtras(date).match($734802129a3b7f4d$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $734802129a3b7f4d$var$INVALID_DATE;
        const dateParts = $734802129a3b7f4d$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $4eigd.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3nGJd.isValid)(normalizedDate)) return $734802129a3b7f4d$var$INVALID_DATE;
        return (0, $2iEso.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $734802129a3b7f4d$export$cfa2ef2687faeda2;

});

parcelRegister("3nGJd", function(module, exports) {

var $7sNuF = parcelRequire("7sNuF");

const $7f0fa5875d6e9a42$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $7sNuF.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
module.exports["isValid"] = $7f0fa5875d6e9a42$export$1ea939691cdc45b8;

});

parcelRegister("7sNuF", function(module, exports) {

var $1RvqY = parcelRequire("1RvqY");

const $320ec45740b0ee24$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $1RvqY.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
module.exports["getDaysInMonth"] = $320ec45740b0ee24$export$f645ddd439eb259d;

});

parcelRegister("1RvqY", function(module, exports) {
const $323f2e4da88832b7$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
module.exports["isLeapYear"] = $323f2e4da88832b7$export$553d7fa8e3805fc0;

});

parcelRegister("4eigd", function(module, exports) {

var $aKKC5 = parcelRequire("aKKC5");

const $927e6bf7203913f7$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $aKKC5.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["normalizeDate"] = $927e6bf7203913f7$export$fcc71269590ba0a8;

});

parcelRegister("aKKC5", function(module, exports) {
const $00e4455f9b4cd7ae$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
module.exports["toDateObj"] = $00e4455f9b4cd7ae$export$abe96da78d4f59dd;

});

parcelRegister("2iEso", function(module, exports) {
const $f36e5bfee980e3d5$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
module.exports["toDate"] = $f36e5bfee980e3d5$export$e67a095c620b86fe;

});

parcelRegister("a6FC8", function(module, exports) {
const $5e4f9944cbc7c90e$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $5e4f9944cbc7c90e$export$9b7ca29af37c192;

});

parcelRegister("cewj5", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $8e7fda51b7396b67$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$8e7fda51b7396b67$var$debounce.debounce = $8e7fda51b7396b67$var$debounce;
module.exports = $8e7fda51b7396b67$var$debounce;

});

parcelRegister("9577u", function(module, exports) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $69ca1a8237733efd$var$noop() {
// No operation performed.
}
module.exports = $69ca1a8237733efd$var$noop;

});

parcelRegister("ldFTj", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $f72b4e993b710344$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $f72b4e993b710344$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $f72b4e993b710344$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $f72b4e993b710344$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $f72b4e993b710344$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $f72b4e993b710344$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $f72b4e993b710344$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $f72b4e993b710344$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $f72b4e993b710344$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $f72b4e993b710344$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $f72b4e993b710344$var$root = $f72b4e993b710344$var$freeGlobal || $f72b4e993b710344$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $f72b4e993b710344$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f72b4e993b710344$var$objectToString = $f72b4e993b710344$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f72b4e993b710344$var$nativeMax = Math.max, $f72b4e993b710344$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $f72b4e993b710344$var$now = function() {
    return $f72b4e993b710344$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $f72b4e993b710344$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($f72b4e993b710344$var$FUNC_ERROR_TEXT);
    wait = $f72b4e993b710344$var$toNumber(wait) || 0;
    if ($f72b4e993b710344$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $f72b4e993b710344$var$nativeMax($f72b4e993b710344$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $f72b4e993b710344$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $f72b4e993b710344$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($f72b4e993b710344$var$now());
    }
    function debounced() {
        var time = $f72b4e993b710344$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f72b4e993b710344$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $f72b4e993b710344$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $f72b4e993b710344$var$isSymbol(value) {
    return typeof value == 'symbol' || $f72b4e993b710344$var$isObjectLike(value) && $f72b4e993b710344$var$objectToString.call(value) == $f72b4e993b710344$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $f72b4e993b710344$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($f72b4e993b710344$var$isSymbol(value)) return $f72b4e993b710344$var$NAN;
    if ($f72b4e993b710344$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f72b4e993b710344$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($f72b4e993b710344$var$reTrim, '');
    var isBinary = $f72b4e993b710344$var$reIsBinary.test(value);
    return isBinary || $f72b4e993b710344$var$reIsOctal.test(value) ? $f72b4e993b710344$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $f72b4e993b710344$var$reIsBadHex.test(value) ? $f72b4e993b710344$var$NAN : +value;
}
module.exports = $f72b4e993b710344$var$debounce;

});

parcelRegister("jBvme", function(module, exports) {
'use strict';

var $1GmRG = parcelRequire("1GmRG");


var $abZty = parcelRequire("abZty");

var $e459cbfd8a82954e$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $e459cbfd8a82954e$var$CRHTLF = /[\n\r\t]/g, $e459cbfd8a82954e$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $e459cbfd8a82954e$var$port = /:\d+$/, $e459cbfd8a82954e$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $e459cbfd8a82954e$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $e459cbfd8a82954e$var$trimLeft(str) {
    return (str ? str : '').toString().replace($e459cbfd8a82954e$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $e459cbfd8a82954e$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $e459cbfd8a82954e$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $e459cbfd8a82954e$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $e459cbfd8a82954e$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $e459cbfd8a82954e$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $e459cbfd8a82954e$var$Url(loc, {});
        for(key in $e459cbfd8a82954e$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $e459cbfd8a82954e$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $e459cbfd8a82954e$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $e459cbfd8a82954e$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $e459cbfd8a82954e$var$extractProtocol(address, location) {
    address = $e459cbfd8a82954e$var$trimLeft(address);
    address = address.replace($e459cbfd8a82954e$var$CRHTLF, '');
    location = location || {};
    var match = $e459cbfd8a82954e$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($e459cbfd8a82954e$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $e459cbfd8a82954e$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $e459cbfd8a82954e$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $e459cbfd8a82954e$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $e459cbfd8a82954e$var$Url(address, location, parser) {
    address = $e459cbfd8a82954e$var$trimLeft(address);
    address = address.replace($e459cbfd8a82954e$var$CRHTLF, '');
    if (!(this instanceof $e459cbfd8a82954e$var$Url)) return new $e459cbfd8a82954e$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $e459cbfd8a82954e$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $abZty.parse;
    location = $e459cbfd8a82954e$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $e459cbfd8a82954e$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $e459cbfd8a82954e$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$e459cbfd8a82954e$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $e459cbfd8a82954e$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $e459cbfd8a82954e$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$1GmRG(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $e459cbfd8a82954e$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $e459cbfd8a82954e$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $abZty.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$1GmRG(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($e459cbfd8a82954e$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $e459cbfd8a82954e$var$rules.length; i++){
        var ins = $e459cbfd8a82954e$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $e459cbfd8a82954e$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $e459cbfd8a82954e$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $abZty.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $e459cbfd8a82954e$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $e459cbfd8a82954e$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $e459cbfd8a82954e$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$e459cbfd8a82954e$var$Url.prototype = {
    set: $e459cbfd8a82954e$var$set,
    toString: $e459cbfd8a82954e$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$e459cbfd8a82954e$var$Url.extractProtocol = $e459cbfd8a82954e$var$extractProtocol;
$e459cbfd8a82954e$var$Url.location = $e459cbfd8a82954e$var$lolcation;
$e459cbfd8a82954e$var$Url.trimLeft = $e459cbfd8a82954e$var$trimLeft;
$e459cbfd8a82954e$var$Url.qs = $abZty;
module.exports = $e459cbfd8a82954e$var$Url;

});

parcelRegister("1GmRG", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("abZty", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $76ba9e442b1f2d97$export$fac44ee5b035f737, (v) => $76ba9e442b1f2d97$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $76ba9e442b1f2d97$export$98e6a39c04603d36, (v) => $76ba9e442b1f2d97$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $76ba9e442b1f2d97$export$fac44ee5b035f737;
var $76ba9e442b1f2d97$export$98e6a39c04603d36;
'use strict';
var $76ba9e442b1f2d97$var$has = Object.prototype.hasOwnProperty, $76ba9e442b1f2d97$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $76ba9e442b1f2d97$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $76ba9e442b1f2d97$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $76ba9e442b1f2d97$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $76ba9e442b1f2d97$var$decode(part[1]), value = $76ba9e442b1f2d97$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $76ba9e442b1f2d97$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($76ba9e442b1f2d97$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $76ba9e442b1f2d97$var$undef || isNaN(value))) value = '';
        key = $76ba9e442b1f2d97$var$encode(key);
        value = $76ba9e442b1f2d97$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$76ba9e442b1f2d97$export$fac44ee5b035f737 = $76ba9e442b1f2d97$var$querystringify;
$76ba9e442b1f2d97$export$98e6a39c04603d36 = $76ba9e442b1f2d97$var$querystring;

});

parcelRegister("eLQM6", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $b100a9eece33ac5b$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gfYi7")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": 'datasource-table-view-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b100a9eece33ac5b$var$LazyDatasourceTableView, props));
};
var $b100a9eece33ac5b$export$2e2bcd8739ae039 = $b100a9eece33ac5b$var$DatasourceTableViewWithWrappers;
module.exports["default"] = $b100a9eece33ac5b$export$2e2bcd8739ae039;

});

parcelRegister("gfYi7", function(module, exports) {

let $030de255323e90b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $030de255323e90b6$var$load("3BqWF"),
    $030de255323e90b6$var$load("lGnwl"),
    $030de255323e90b6$var$load("lTK3c"),
    $030de255323e90b6$var$load("1WXdc"),
    $030de255323e90b6$var$load("cONk3"),
    $030de255323e90b6$var$load("ltDLY"),
    $030de255323e90b6$var$load("6wr18"),
    $030de255323e90b6$var$load("5pvpJ"),
    $030de255323e90b6$var$load("eXGjr"),
    $030de255323e90b6$var$load("iNa18"),
    $030de255323e90b6$var$load("8makw"),
    $030de255323e90b6$var$load("ffEVr"),
    $030de255323e90b6$var$load("hhss7"),
    $030de255323e90b6$var$load("kHOMt"),
    $030de255323e90b6$var$load("7EorR"),
    $030de255323e90b6$var$load("Wowvf"),
    $030de255323e90b6$var$load("etEYy"),
    $030de255323e90b6$var$load("7ixUU")
]).then(()=>parcelRequire('jfuml'));

});

parcelRegister("c9mMn", function(module, exports) {
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $621c6a15c091c99d$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e5u6v",
    disabled: "_syaz1gmx"
}; // state of the parent option
const $621c6a15c091c99d$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #17171708)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
}; // the secondary color represents the radio dot or checkmark
const $621c6a15c091c99d$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $621c6a15c091c99d$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
const $621c6a15c091c99d$var$baseIconStyles = null;
const $621c6a15c091c99d$var$baseOptionStyles = null;
const $621c6a15c091c99d$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $42omo.useState)(false);
    const onMouseDown = (0, $42omo.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $42omo.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $42omo.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            $621c6a15c091c99d$var$optionStyles.default,
            isFocused && $621c6a15c091c99d$var$optionStyles.focused,
            isDisabled && $621c6a15c091c99d$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $621c6a15c091c99d$var$iconStyles.inherit : $621c6a15c091c99d$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                    label: "",
                    primaryColor: $621c6a15c091c99d$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $621c6a15c091c99d$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $621c6a15c091c99d$var$svgStyles = null;
const $621c6a15c091c99d$var$CheckboxIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
const $621c6a15c091c99d$var$RadioIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
}; /**
    * __Checkbox option__
    */ 
const $621c6a15c091c99d$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)($621c6a15c091c99d$var$ControlOption, {
        Icon: $621c6a15c091c99d$var$CheckboxIcon,
        ...props
    }); /**
                * __Radio option__
                */ 
const $621c6a15c091c99d$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $l998X.jsx)($621c6a15c091c99d$var$ControlOption, {
        Icon: $621c6a15c091c99d$var$RadioIcon,
        ...props
    });
module.exports["CheckboxOption"] = $621c6a15c091c99d$export$d40cc97ecda916f9;
module.exports["RadioOption"] = $621c6a15c091c99d$export$82ab7168879267a7;

});

parcelRegister("4Ldep", function(module, exports) {
$parcel$export(module.exports, "default", () => $3775d0b53e1446a0$export$2e2bcd8739ae039);

var $dhNqt = parcelRequire("dhNqt");


var $b5utg = parcelRequire("b5utg");

function $3775d0b53e1446a0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeftStartOfDay = (0, $dhNqt.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $dhNqt.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("eUiqt", function(module, exports) {

var $fPVB6 = parcelRequire("fPVB6");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ada496b0a75ae181$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $ada496b0a75ae181$var$reHasRegExpChar = RegExp($ada496b0a75ae181$var$reRegExpChar.source);
/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */ function $ada496b0a75ae181$var$escapeRegExp(string) {
    string = $fPVB6(string);
    return string && $ada496b0a75ae181$var$reHasRegExpChar.test(string) ? string.replace($ada496b0a75ae181$var$reRegExpChar, '\\$&') : string;
}
module.exports = $ada496b0a75ae181$var$escapeRegExp;

});

parcelRegister("cStGJ", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $9K4OG = parcelRequire("9K4OG");


var $g2YHK = parcelRequire("g2YHK");


var $dStU0 = parcelRequire("dStU0");


var $dmgN7 = parcelRequire("dmgN7");


var $42omo = parcelRequire("42omo");


var $c58zA = parcelRequire("c58zA");

var $96018e9e3b3d2b35$var$isDevelopment = false;
var $96018e9e3b3d2b35$var$testOmitPropsOnStringTag = (0, $c58zA.default);
var $96018e9e3b3d2b35$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $96018e9e3b3d2b35$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $96018e9e3b3d2b35$var$testOmitPropsOnStringTag : $96018e9e3b3d2b35$var$testOmitPropsOnComponent;
};
var $96018e9e3b3d2b35$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $96018e9e3b3d2b35$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $dmgN7.registerStyles)(cache, serialized, isStringTag);
    (0, $dStU0.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $dmgN7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $96018e9e3b3d2b35$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $96018e9e3b3d2b35$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $9K4OG.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $42omo.useContext((0, $9K4OG.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $dmgN7.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $g2YHK.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $96018e9e3b3d2b35$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($96018e9e3b3d2b35$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $42omo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $96018e9e3b3d2b35$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $7Q5yr.default)({}, options, nextOptions, {
                shouldForwardProp: $96018e9e3b3d2b35$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $96018e9e3b3d2b35$export$2e2bcd8739ae039;

});

parcelRegister("dStU0", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $a1a7838157a2757d$var$syncFallback = function syncFallback(create) {
    return create();
};
var $a1a7838157a2757d$var$useInsertionEffect = $42omo.useInsertionEffect ? $42omo.useInsertionEffect : false;
var $a1a7838157a2757d$export$db21c7ffa21794e7 = $a1a7838157a2757d$var$useInsertionEffect || $a1a7838157a2757d$var$syncFallback;
var $a1a7838157a2757d$export$811a713a7276cb9d = $a1a7838157a2757d$var$useInsertionEffect || $42omo.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $a1a7838157a2757d$export$db21c7ffa21794e7;

});

parcelRegister("c58zA", function(module, exports) {

var $9bLS2 = parcelRequire("9bLS2");

// eslint-disable-next-line no-undef
var $8cbc9a10962c1be8$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cbc9a10962c1be8$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9bLS2.default)(function(prop) {
    return $8cbc9a10962c1be8$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $8cbc9a10962c1be8$export$2e2bcd8739ae039;

});

parcelRegister("3BZZG", function(module, exports) {
const $b77837f445efd10f$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $b77837f445efd10f$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $b77837f445efd10f$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $b77837f445efd10f$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $b77837f445efd10f$export$d87a47989c00f322;
    if (appearance === 'square') return $b77837f445efd10f$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $b77837f445efd10f$export$aeb48196afcd236a;
    return $b77837f445efd10f$export$d87a47989c00f322;
};
module.exports["defaultImageCardDimensions"] = $b77837f445efd10f$export$d87a47989c00f322;
module.exports["getDefaultCardDimensions"] = $b77837f445efd10f$export$ed7b8a4728e9c63;

});

parcelRegister("e63NX", function(module, exports) {

var $hL7bb = parcelRequire("hL7bb");

const $aeded572d33c89ca$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
const $aeded572d33c89ca$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};
const $aeded572d33c89ca$export$5883721593c4e4b1 = (a, b)=>{
    if ($aeded572d33c89ca$export$7695387cd66cf5b5(a) && $aeded572d33c89ca$export$7695387cd66cf5b5(b)) return a.id !== b.id || a.collectionName !== b.collectionName || a.occurrenceKey !== b.occurrenceKey;
    else return !(0, (/*@__PURE__*/$parcel$interopDefault($hL7bb)))(a, b);
};
module.exports["isFileIdentifier"] = $aeded572d33c89ca$export$7695387cd66cf5b5;
module.exports["isExternalImageIdentifier"] = $aeded572d33c89ca$export$2782f2fbff82f0c9;

});

parcelRegister("7NoXb", function(module, exports) {
$parcel$export(module.exports, "default", () => $a320422a745418e6$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fs5Wi = parcelRequire("fs5Wi");


var $1GQGM = parcelRequire("1GQGM");


const $a320422a745418e6$var$MediaViewer = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1Xnnq")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $a320422a745418e6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $fs5Wi.default), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1GQGM.MediaViewerPortal), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($a320422a745418e6$var$MediaViewer, {
                ...props
            })
        })
    });
}

});

parcelRegister("fs5Wi", function(module, exports) {
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $70BxX = parcelRequire("70BxX");


var $cOrQJ = parcelRequire("cOrQJ");

const $379228055afe24f5$export$442b7be89436c101 = '#101214';
const $379228055afe24f5$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $70BxX.default), {
        blankedColor: $379228055afe24f5$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $379228055afe24f5$export$2e2bcd8739ae039 = $379228055afe24f5$var$ModalSpinner;
module.exports["default"] = $379228055afe24f5$export$2e2bcd8739ae039;

});

parcelRegister("70BxX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9DX83 = parcelRequire("9DX83");

const $9f2ec0906c10b2d9$var$ModalSpinner = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9DX83.default), props);
var $9f2ec0906c10b2d9$export$2e2bcd8739ae039 = $9f2ec0906c10b2d9$var$ModalSpinner;
module.exports["default"] = $9f2ec0906c10b2d9$export$2e2bcd8739ae039;

});

parcelRegister("9DX83", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed42ad447c5e042f$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");

const $ed42ad447c5e042f$var$blanketStyles = null;
const $ed42ad447c5e042f$var$spinnerStyles = null;
const $ed42ad447c5e042f$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $ed42ad447c5e042f$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $42omo.createElement("div", {
        style: {
            backgroundColor: blankedColor || $ed42ad447c5e042f$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $gMc0m.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        size: "large",
        appearance: invertSpinnerColor || $ed42ad447c5e042f$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});

parcelRegister("1GQGM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $caX7N = parcelRequire("caX7N");

const $86b842c4b2e17806$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
        zIndex: 510,
        children: children
    });
module.exports["MediaViewerPortal"] = $86b842c4b2e17806$export$51aee4c01b17acde;

});

parcelRegister("1Xnnq", function(module, exports) {

let $16cd6f4e00178e20$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $16cd6f4e00178e20$var$load("hRqzw"),
    $16cd6f4e00178e20$var$load("cONk3"),
    $16cd6f4e00178e20$var$load("ltDLY"),
    $16cd6f4e00178e20$var$load("f35QR"),
    $16cd6f4e00178e20$var$load("eVYW1"),
    $16cd6f4e00178e20$var$load("ls0Um"),
    $16cd6f4e00178e20$var$load("020xd"),
    $16cd6f4e00178e20$var$load("eTBsW"),
    $16cd6f4e00178e20$var$load("bYxCZ"),
    $16cd6f4e00178e20$var$load("6HBYC"),
    $16cd6f4e00178e20$var$load("eDqo1"),
    $16cd6f4e00178e20$var$load("lxiFd"),
    $16cd6f4e00178e20$var$load("1oiJ6"),
    $16cd6f4e00178e20$var$load("huUvS"),
    $16cd6f4e00178e20$var$load("6wr18"),
    $16cd6f4e00178e20$var$load("llcfA"),
    $16cd6f4e00178e20$var$load("azCDs"),
    $16cd6f4e00178e20$var$load("dT77m"),
    $16cd6f4e00178e20$var$load("8j9XC"),
    $16cd6f4e00178e20$var$load("ffEVr"),
    $16cd6f4e00178e20$var$load("6vhrJ"),
    $16cd6f4e00178e20$var$load("fxC6e"),
    $16cd6f4e00178e20$var$load("kknf5"),
    $16cd6f4e00178e20$var$load("hPalR"),
    $16cd6f4e00178e20$var$load("jDjSj"),
    $16cd6f4e00178e20$var$load("8059b"),
    $16cd6f4e00178e20$var$load("3QZdB"),
    $16cd6f4e00178e20$var$load("3M4Om"),
    $16cd6f4e00178e20$var$load("4jPsO"),
    $16cd6f4e00178e20$var$load("72780"),
    $16cd6f4e00178e20$var$load("hszIA"),
    $16cd6f4e00178e20$var$load("2fk6g"),
    $16cd6f4e00178e20$var$load("ajMch"),
    $16cd6f4e00178e20$var$load("hhss7"),
    $16cd6f4e00178e20$var$load("cKkZK")
]).then(()=>parcelRequire('gamJO'));

});

parcelRegister("31QJ7", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $51c490bf07ac8c08$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    click_to_join: {
        id: "fabric.media.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.media.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    request_access: {
        id: "fabric.media.request_access",
        defaultMessage: "Request access"
    },
    request_access_description: {
        id: "fabric.media.request_access_description",
        defaultMessage: "Request access to {context} view this preview."
    },
    request_access_pending: {
        id: "fabric.media.request_access_pending",
        defaultMessage: "Access pending"
    },
    request_access_pending_description: {
        id: "fabric.media.request_access_pending_description",
        defaultMessage: "Your access request is pending."
    },
    forbidden_description: {
        id: "fabric.media.forbidden_description",
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access."
    },
    request_denied_description: {
        id: "fabric.media.request_denied_description",
        defaultMessage: "Your access request was denied. Contact the site admin if you still need access."
    },
    retry: {
        id: "fabric.media.retry",
        defaultMessage: "Retry"
    },
    failed_to_load: {
        id: "fabric.media.failed_to_load",
        defaultMessage: "Failed to load"
    },
    failed_to_upload: {
        id: "fabric.media.failed_to_upload",
        defaultMessage: "Failed to upload"
    },
    check_internet_connection: {
        id: "fabric.media.check_internet_connection",
        defaultMessage: "Failed to load. Please check your internet connection"
    },
    recent_uploads: {
        id: "fabric.media.recent_uploads",
        defaultMessage: "Recent uploads"
    },
    upload_file: {
        id: "fabric.media.upload_file",
        defaultMessage: "Upload a file"
    },
    drag_and_drop_your_files: {
        id: "fabric.media.drag_and_drop_your_files",
        defaultMessage: "Drag and drop your files anywhere or"
    },
    drag_and_drop_your_files_and_folders: {
        id: "fabric.media.drag_and_drop_your_files_and_folders",
        defaultMessage: "Drag and drop your files and folders anywhere or"
    },
    drop_your_files: {
        id: "fabric.media.drop_your_files",
        defaultMessage: "Drop your files to upload"
    },
    upload: {
        id: "fabric.media.upload",
        defaultMessage: "Upload"
    },
    cancel: {
        id: "fabric.media.cancel",
        defaultMessage: "Cancel"
    },
    delete: {
        id: "fabric.media.delete",
        defaultMessage: "Delete"
    },
    success: {
        id: "fabric.media.success",
        defaultMessage: "Success"
    },
    error: {
        id: "fabric.media.error",
        defaultMessage: "Error"
    },
    search_all_gifs: {
        id: "fabric.media.search_all_gifs",
        defaultMessage: "Search all the GIFs!"
    },
    cant_retrieve_gifs: {
        id: "fabric.media.cant_retrieve_gifs",
        defaultMessage: "Ouch! We could not retrieve any GIFs"
    },
    cant_retrieve_files: {
        id: "fabric.media.cant_retrieve_files",
        defaultMessage: "Ouch! We could not retrieve any files"
    },
    check_your_network: {
        id: "fabric.media.check_your_network",
        defaultMessage: "Check your network connection"
    },
    try_again: {
        id: "fabric.media.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.media.try_another_account",
        defaultMessage: "Try another account"
    },
    no_gifs_found: {
        id: "fabric.media.no_gifs_found",
        defaultMessage: "Hello? Was it me you're looking for?"
    },
    no_gifs_found_suggestion: {
        id: "fabric.media.no_gifs_found_suggestion",
        defaultMessage: "We couldn't find anything for \"{query}\""
    },
    load_more_gifs: {
        id: "fabric.media.load_more_gifs",
        defaultMessage: "Load more GIFs"
    },
    add_account: {
        id: "fabric.media.add_account",
        defaultMessage: "Add account"
    },
    unlink_account: {
        id: "fabric.media.unlink_account",
        defaultMessage: "Unlink Account"
    },
    upload_file_from: {
        id: "fabric.media.upload_file_from",
        defaultMessage: "Upload a file from {name}"
    },
    connect_to: {
        id: "fabric.media.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.media.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.media.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.media.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.media.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.media.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    invalid_permissions: {
        id: "fabric.media.invalid_permissions",
        defaultMessage: "Restricted link"
    },
    invalid_permissions_description: {
        id: "fabric.media.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    select_an_avatar: {
        id: "fabric.media.select_an_avatar",
        defaultMessage: "Select a default avatar"
    },
    upload_an_avatar: {
        id: "fabric.media.upload_an_avatar",
        defaultMessage: "Upload an avatar"
    },
    select_an_avatar_from_all_defaults: {
        id: "fabric.media.select_an_avatar_from_all_defaults",
        defaultMessage: "Select from all default options"
    },
    show_more_avatars_btn_label: {
        id: "fabric.media.show_more_avatars_btn_label",
        defaultMessage: "Show more"
    },
    or_select_default_avatars: {
        id: "fabric.media.or_select_default_avatars",
        defaultMessage: "Upload a photo or select from some default options"
    },
    loading: {
        id: "fabric.media.loading",
        defaultMessage: "Loading..."
    },
    loading_file: {
        id: "fabric.media.loading_file",
        defaultMessage: "Loading file..."
    },
    save: {
        id: "fabric.media.save",
        defaultMessage: "Save"
    },
    or: {
        id: "fabric.media.or",
        defaultMessage: "or"
    },
    upload_photo: {
        id: "fabric.media.upload_photo",
        defaultMessage: "Upload a photo"
    },
    default_avatars: {
        id: "fabric.media.default_avatars",
        defaultMessage: "Default avatars"
    },
    avatar_picker_back_btn_label: {
        id: "fabric.media.avatar_picker_back_btn_label",
        defaultMessage: "Go Back"
    },
    drag_and_drop_images_here: {
        id: "fabric.media.drag_and_drop_images_here",
        defaultMessage: "Drag and drop your images here"
    },
    alt_text: {
        id: "fabric.media.alt_text_label",
        defaultMessage: "Alt text"
    },
    alt_text_description: {
        id: "fabric.media.alt_text_helper_message",
        defaultMessage: "How would you describe the selected image to someone with low vision?"
    },
    image_url_invalid_error: {
        id: "fabric.media.image_url_invalid_error",
        defaultMessage: "Could not load image, the url is invalid."
    },
    image_format_invalid_error: {
        id: "fabric.media.image_format_invalid_error",
        defaultMessage: "Could not load image, the format is invalid."
    },
    image_size_too_large_error: {
        id: "fabric.media.image_size_too_large_error",
        defaultMessage: "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    something_went_wrong: {
        id: "fabric.media.something_went_wrong",
        defaultMessage: "Something went wrong."
    },
    might_be_a_hiccup: {
        id: "fabric.media.might_be_a_hiccup",
        defaultMessage: "It might just be a hiccup."
    },
    couldnt_generate_preview: {
        id: "fabric.media.couldnt_generate_preview",
        defaultMessage: "We couldn't generate a preview for this file."
    },
    couldnt_generate_encrypted_entry_preview: {
        id: "fabric.media.couldnt_generate_encrypted_entry_preview",
        defaultMessage: "We can't preview encrypted or password protected files."
    },
    cant_preview_file_type: {
        id: "fabric.media.cant_preview_file_type",
        defaultMessage: "We can't preview this file type."
    },
    item_not_found_in_list: {
        id: "fabric.media.item_not_found_in_list",
        defaultMessage: "The selected item was not found on the list."
    },
    not_found_title: {
        id: "fabric.media.not_found_title",
        defaultMessage: "Uh oh. We can't find this link!"
    },
    not_found_description: {
        id: "fabric.media.not_found_description",
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again."
    },
    no_pdf_artifacts: {
        id: "fabric.media.no_pdf_artifacts",
        defaultMessage: "No PDF artifacts found for this file."
    },
    password_protected_pdf: {
        id: "fabric.media.password_protected_pdf",
        defaultMessage: "This file is password protected."
    },
    password: {
        id: "fabric.media.password",
        defaultMessage: "Password"
    },
    enter_password: {
        id: "fabric.media.enter_password",
        defaultMessage: "Enter password"
    },
    incorrect_password: {
        id: "fabric.media.incorrect_password",
        defaultMessage: "Incorrect password. Please try again."
    },
    submit: {
        id: "fabric.media.submit",
        defaultMessage: "Submit"
    },
    give_feedback: {
        id: "fabric.media.give_feedback",
        defaultMessage: "Give feedback"
    },
    try_downloading_file: {
        id: "fabric.media.try_downloading_file",
        defaultMessage: "Try downloading the file to view it."
    },
    webgl_warning_description: {
        id: "fabric.media.webgl_warning_description",
        defaultMessage: "Your browser does not support WebGL. Use a WebGL enabled browser to annotate images."
    },
    unable_to_annotate_image: {
        id: "fabric.media.unable_to_annotate_image",
        defaultMessage: "You're unable to annotate this image"
    },
    learn_more: {
        id: "fabric.media.learn_more",
        defaultMessage: "Learn More"
    },
    accounts: {
        id: "fabric.media.accounts",
        defaultMessage: "Accounts"
    },
    actions: {
        id: "fabric.media.actions",
        defaultMessage: "Actions"
    },
    error_hint_retry: {
        id: "fabric.media.error_hint_retry",
        defaultMessage: "Try again and we'll give it another shot."
    },
    error_hint_critical: {
        id: "fabric.media.error_hint_critical",
        defaultMessage: "If the problem keeps happening contact support."
    },
    close: {
        id: "fabric.media.close",
        defaultMessage: "Close"
    },
    could_not_load_editor: {
        id: "fabric.media.could_not_load_editor",
        defaultMessage: "Ouch! We could not load the editor"
    },
    could_not_save_image: {
        id: "fabric.media.could_not_save_image",
        defaultMessage: "Ouch! We could not save the image"
    },
    could_not_load_link: {
        id: "fabric.media.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    annotate: {
        id: "fabric.media.annotate",
        defaultMessage: "Annotate"
    },
    annotate_tool_arrow: {
        id: "fabric.media.annotate.tool.arrow",
        defaultMessage: "Arrow"
    },
    annotate_tool_text: {
        id: "fabric.media.annotate.tool.text",
        defaultMessage: "Text"
    },
    annotate_tool_shape: {
        id: "fabric.media.annotate.tool.shape",
        defaultMessage: "Shape"
    },
    annotate_tool_brush: {
        id: "fabric.media.annotate.tool.brush",
        defaultMessage: "Brush"
    },
    annotate_tool_blur: {
        id: "fabric.media.annotate.tool.blur",
        defaultMessage: "Blur"
    },
    annotate_tool_line_thickness: {
        id: "fabric.media.annotate.tool.line.thickness",
        defaultMessage: "Line thickness"
    },
    annotate_tool_color: {
        id: "fabric.media.annotate.tool.color",
        defaultMessage: "Color"
    },
    annotate_confirmation_close_anyway: {
        id: "fabric.media.annotate.confirmation.close.anyway",
        defaultMessage: "Close anyway"
    },
    annotate_confirmation_heading: {
        id: "fabric.media.annotate.confirmation.heading",
        defaultMessage: "Unsaved changes"
    },
    annotate_confirmation_content: {
        id: "fabric.media.annotate.confirmation.content",
        defaultMessage: "You have some unsaved changes. Are you sure you want to leave?"
    },
    drop_your_files_here: {
        id: "fabric.media.drop_your_files_here",
        defaultMessage: "Drop your files here"
    },
    share_files_instantly: {
        id: "fabric.media.share_files_instantly",
        defaultMessage: "We'll share them instantly"
    },
    insert_files: {
        id: "fabric.media.insert_files",
        defaultMessage: "Insert {0, plural, one {a file} other {{0} files}}"
    },
    zoom_out: {
        id: "fabric.media.zoom_out",
        defaultMessage: "zoom out"
    },
    zoom_in: {
        id: "fabric.media.zoom_in",
        defaultMessage: "zoom in"
    },
    remove_image: {
        id: "fabric.media.remove_image",
        defaultMessage: "Remove image"
    },
    play: {
        id: "fabric.media.play",
        defaultMessage: "Play"
    },
    pause: {
        id: "fabric.media.pause",
        defaultMessage: "Pause"
    },
    disable_fullscreen: {
        id: "fabric.media.disable_fullscreen",
        defaultMessage: "disable fullscreen"
    },
    enable_fullscreen: {
        id: "fabric.media.enable_fullscreen",
        defaultMessage: "enable fullscreen"
    },
    error_loading_file: {
        id: "fabric.media.error_loading_file",
        defaultMessage: "Error loading file"
    },
    error_generating_preview: {
        id: "fabric.media.error_generating_preview",
        defaultMessage: "Error generating preview"
    },
    download: {
        id: "fabric.media.download",
        defaultMessage: "Download"
    },
    download_disabled_security_policy: {
        id: "fabric.media.download_disabled_security_policy",
        defaultMessage: "Download is blocked by your organization's security policy."
    },
    unknown: {
        id: "fabric.media.unknown",
        defaultMessage: "unknown"
    },
    document: {
        id: "fabric.media.document",
        defaultMessage: "document"
    },
    audio: {
        id: "fabric.media.audio",
        defaultMessage: "audio"
    },
    video: {
        id: "fabric.media.video",
        defaultMessage: "video"
    },
    image: {
        id: "fabric.media.image",
        defaultMessage: "image"
    },
    archive: {
        id: "fabric.media.archive",
        defaultMessage: "archive"
    },
    email: {
        id: "fabric.media.email",
        defaultMessage: "email"
    },
    text: {
        id: "fabric.media.text",
        defaultMessage: "text"
    },
    displayThumbnail: {
        id: "fabric.media.display_thumbnail",
        defaultMessage: "Display thumbnail"
    },
    search: {
        id: "fabric.media.search",
        defaultMessage: "search"
    },
    view: {
        id: "fabric.media.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.media.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.media.srclinkunknown",
        defaultMessage: "View Original"
    },
    changeView: {
        id: "fabric.media.change_view",
        defaultMessage: "Change view"
    },
    playbackSpeed: {
        id: "fabric.media.playback_speed",
        defaultMessage: "Playback speed"
    },
    video_captions_enable: {
        id: "fabric.media.video_captions_enable",
        defaultMessage: "Closed Captions"
    },
    video_captions_select_captions: {
        id: "fabric.media.video_captions_select_captions",
        defaultMessage: "Select Captions"
    },
    video_captions_upload_captions_form_header: {
        id: "fabric.media.video_captions_upload_captions_form_header",
        defaultMessage: "Upload Captions"
    },
    video_captions_upload_captions_form_language_picker: {
        id: "fabric.media.video_captions_upload_captions_form_language_picker",
        defaultMessage: "Select the file language"
    },
    video_captions_upload_success_description: {
        id: "fabric.media.video_captions_upload_success_description",
        defaultMessage: "The caption was successfully uploaded for this video."
    },
    video_captions_upload_error_description: {
        id: "fabric.media.video_captions_upload_error_description",
        defaultMessage: "The caption failed to upload."
    },
    video_captions_delete_captions_confirmation_header: {
        id: "fabric.media.video_captions_delete_captions_confirmation_header",
        defaultMessage: "Delete Caption"
    },
    video_captions_delete_captions_confirmation_description: {
        id: "fabric.media.video_captions_delete_captions_confirmation_description",
        defaultMessage: "Please confirm that you want to delete this caption."
    },
    video_captions_delete_success_description: {
        id: "fabric.media.video_captions_delete_success_description",
        defaultMessage: "The caption was successfully removed from this video."
    },
    video_captions_delete_error_description: {
        id: "fabric.media.video_captions_delete_error_description",
        defaultMessage: "The caption failed to delete."
    },
    manage_captions: {
        id: "fabric.media.manage_captions",
        defaultMessage: "Manage Captions"
    },
    add_captions: {
        id: "fabric.media.add_captions",
        defaultMessage: "Add Captions"
    },
    skipBackward: {
        id: "fabric.media.skip_backward",
        defaultMessage: "Back 10 seconds"
    },
    skipForward: {
        id: "fabric.media.skip_forward",
        defaultMessage: "Forward 10 seconds"
    },
    sizeOptions: {
        id: "fabric.media.size_options",
        defaultMessage: "Size options"
    },
    fileDisplayOptions: {
        id: "fabric.media.file.display_options",
        defaultMessage: "Display options"
    },
    volumeLevelControlAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "volume"
    },
    volumeMuteButtonAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "mute"
    },
    playbackDefaultSpeed: {
        id: "fabric.media.playback_default_speed",
        defaultMessage: "Default"
    },
    expand: {
        id: "fabric.media.expand",
        defaultMessage: "Expand"
    },
    preview: {
        id: "fabric.media.preview",
        defaultMessage: "Preview"
    },
    creating_preview: {
        id: "fabric.media.creating_preview",
        defaultMessage: "Creating preview..."
    },
    preview_unavailable: {
        id: "fabric.media.preview_unavailable",
        defaultMessage: "Preview unavailable"
    },
    couldnt_load_file: {
        id: "fabric.media.couldnt_load_file",
        defaultMessage: "We couldn't load the file."
    },
    error_429: {
        id: "fabric.media.error_429",
        defaultMessage: "Error 429"
    },
    close_and_reopen: {
        id: "fabric.media.close_and_reopen",
        defaultMessage: "Try closing this file and reopening."
    },
    viewer_rateLimited: {
        id: "fabric.media.viewer_rateLimited",
        defaultMessage: "We're having difficulties loading your file."
    },
    zip_entry_load_fail: {
        id: "fabric.media.zip_entry_load_failed",
        defaultMessage: "We couldn't load that zip file item to preview"
    },
    file_image_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Image {name} is selected"
    },
    file_video_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Video {name} is selected"
    },
    file_audio_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Audio {name} is selected"
    },
    file_doc_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Document {name} is selected"
    },
    file_archive_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Archive {name} is selected"
    },
    file_unknown_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "File {name} is selected"
    },
    open_file_in_viewer: {
        id: "fabric.media.open_file_in_viewer",
        defaultMessage: "Open {name}"
    },
    video_seeker_assistive_text_time_value: {
        id: "fabric.media.video_seeker_assistive_text_time_value",
        defaultMessage: "{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}"
    },
    video_seeker_label_assistive_text: {
        id: "fabric.media.video_seeker_label_assistive_text",
        defaultMessage: "Seek slider"
    },
    abuse_modal_body: {
        id: "fabric.media.abuse_modal_body",
        defaultMessage: "For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content"
    },
    abuse_modal_title: {
        id: "fabric.media.abuse_modal_title",
        defaultMessage: "Warning"
    },
    abuse_modal_submit: {
        id: "fabric.media.abuse_modal_submit",
        defaultMessage: "Proceed with download"
    },
    image_cropper_arrow_keys_label: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.label",
        defaultMessage: "Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image"
    },
    image_cropper_image_moved: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.action",
        defaultMessage: "You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image"
    },
    image_cropper_zoom_out: {
        id: "media.media-avatar-picker.image-cropper.zoom_out",
        defaultMessage: "Zoom out"
    },
    image_cropper_zoom_in: {
        id: "media.media-avatar-picker.image-cropper.zoom_in",
        defaultMessage: "Zoom in"
    },
    image_cropper_zoom_slider: {
        id: "media.media-avatar-picker.image-cropper.zoom_slider",
        defaultMessage: "set zoom"
    },
    image_placer_img_alt: {
        id: "media.media-avatar-picker.image-placer.image-alt",
        defaultMessage: "Image preview"
    },
    svg_base_alt: {
        id: "media.media-viewer.base-svg.alt",
        defaultMessage: "Svg Image"
    },
    archive_download_label_assistive_text: {
        id: "media.media-viewer.archive-sidebar.wrapper.label_assistive_text",
        defaultMessage: "Download Media"
    }
});
module.exports["messages"] = $51c490bf07ac8c08$export$defe85febe8b728c;

});

parcelRegister("8QL6C", function(module, exports) {

var $6mxnm = parcelRequire("6mxnm");


var $hMBjV = parcelRequire("hMBjV");


var $78fzv = parcelRequire("78fzv");

const $586e61da7604bdbd$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $586e61da7604bdbd$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $hMBjV.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $6mxnm.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $586e61da7604bdbd$export$836625761e76d373 = {
    mediaInline: false
};
function $586e61da7604bdbd$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $78fzv.getGenericFeatureFlag)(flagName, $586e61da7604bdbd$export$836625761e76d373, featureFlags);
}
module.exports["getFeatureFlagKeysAllProducts"] = $586e61da7604bdbd$export$c8bcd5e6111ea1f3;
module.exports["getMediaFeatureFlag"] = $586e61da7604bdbd$export$383e8f51978266d;

});

parcelRegister("6mxnm", function(module, exports) {
// Media feature flags - type and defaults defined here in one source of truth
const $6b97f3fad80b5910$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];
module.exports["supportedProducts"] = $6b97f3fad80b5910$export$2db74afa1ef496f1;

});

parcelRegister("hMBjV", function(module, exports) {
const $d17c6572fbd16cff$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $d17c6572fbd16cff$export$189fe120be7e73fc = ()=>$d17c6572fbd16cff$var$productKeys;
module.exports["getProductKeys"] = $d17c6572fbd16cff$export$189fe120be7e73fc;

});

parcelRegister("78fzv", function(module, exports) {

var $bcpPc = parcelRequire("bcpPc");

function $18475707c4faede4$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $bcpPc.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}
module.exports["getGenericFeatureFlag"] = $18475707c4faede4$export$f2687d0de19e4973;

});

parcelRegister("bcpPc", function(module, exports) {
// window.localStorage is easier to mock in tests if wrapped in this module
const $6c56cea62b261d1c$export$d125817a2695dbc9 = (key)=>{
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};
module.exports["getLocalMediaFeatureFlag"] = $6c56cea62b261d1c$export$d125817a2695dbc9;

});

parcelRegister("d4cCP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $983571389684b329$var$_react = $983571389684b329$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $983571389684b329$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $983571389684b329$var$Audio16Icon = (props)=>/*#__PURE__*/ $983571389684b329$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11 4.195v-.753c0-.271-.23-.468-.514-.44l-6.115.634a.565.565 0 0 0-.514.545v4.616a2 2 0 0 0-.571-.083H5a2 2 0 0 0-2 2V11a2 2 0 0 0 2 2h.286a2 2 0 0 0 2-2V5.76l4.285-.444v2.767A2 2 0 0 0 11 8h-.286a2 2 0 0 0-2 2v.286a2 2 0 0 0 2 2H11a2 2 0 0 0 2-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$983571389684b329$var$Audio16Icon.displayName = 'Audio16Icon';
var $983571389684b329$var$_default = module.exports.default = $983571389684b329$var$Audio16Icon;

});

parcelRegister("46EIy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cewj5 = parcelRequire("cewj5");


var $6ZDLj = parcelRequire("6ZDLj");

const $340ce807e864e408$var$DURATION_MIN = 0.5;
const $340ce807e864e408$var$DURATION_MAX = 1.0;
const $340ce807e864e408$var$EXTRA_PADDING = 4;
const $340ce807e864e408$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $340ce807e864e408$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $340ce807e864e408$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $340ce807e864e408$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $340ce807e864e408$var$DURATION_MAX - $340ce807e864e408$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $340ce807e864e408$var$DURATION_MAX), $340ce807e864e408$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $340ce807e864e408$export$ba458cf715b18bd1);
        }
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $340ce807e864e408$var$EXTRA_PADDING) return newOffset - $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $340ce807e864e408$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $340ce807e864e408$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, $340ce807e864e408$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, _index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (_mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($cewj5)))(this.handleMutation, 30, true));
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$340ce807e864e408$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $340ce807e864e408$var$mapReactChildToReactNode(child, index) {
    const key = $340ce807e864e408$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6ZDLj.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $340ce807e864e408$var$isReactElement(child) {
    return !!child.type;
}
module.exports["MediaFilmStripListItemSelector"] = $340ce807e864e408$export$9f2ec2b609810bce;
module.exports["FilmstripView"] = $340ce807e864e408$export$817db220b90d8024;

});

parcelRegister("6ZDLj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bwcZT = parcelRequire("bwcZT");

const $15c7f4a4aa94e52b$export$924abd21043fc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ArrowLeftWrapper), props);
const $15c7f4a4aa94e52b$export$a5ffe38c17bbc0a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ShadowRight), props);
const $15c7f4a4aa94e52b$export$abf07652016c7e56 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.ArrowRightWrapper), props);
const $15c7f4a4aa94e52b$export$b39b1b86b48b621f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.LeftArrow), props);
const $15c7f4a4aa94e52b$export$6208675820d4cc50 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.RightArrow), props);
const $15c7f4a4aa94e52b$export$d37eb83491863cbb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripViewWrapper), props);
const $15c7f4a4aa94e52b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripList), {
        ...props,
        ref: ref
    }));
const $15c7f4a4aa94e52b$export$54cfc70c184c0713 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwcZT.FilmStripListItem), props);
module.exports["LeftArrow"] = $15c7f4a4aa94e52b$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $15c7f4a4aa94e52b$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $15c7f4a4aa94e52b$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $15c7f4a4aa94e52b$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $15c7f4a4aa94e52b$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $15c7f4a4aa94e52b$export$54cfc70c184c0713;

});

parcelRegister("bwcZT", function(module, exports) {
/* wrappers-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $bPdpL = parcelRequire("bPdpL");


var $5tOl1 = parcelRequire("5tOl1");


var $46EIy = parcelRequire("46EIy");


var $dh538 = parcelRequire("dh538");

const $1156f5d5007639c5$var$filmStripViewStyles = null;
const $1156f5d5007639c5$var$filmStripListWrapperStyles = null;
const $1156f5d5007639c5$var$filmStripListStyles = null;
const $1156f5d5007639c5$var$filmStripListItemStyles = null;
const $1156f5d5007639c5$var$arrowWrapperStyles = null;
const $1156f5d5007639c5$var$arrowLeftWrapperStyles = null;
const $1156f5d5007639c5$var$arrowRightWrapperStyles = null;
const $1156f5d5007639c5$var$shadowStyles = null;
const $1156f5d5007639c5$var$resetButtonStyle = null;
const $1156f5d5007639c5$var$shadowLeftStyles = null;
const $1156f5d5007639c5$var$shadowRightStyles = null;
const $1156f5d5007639c5$var$ShadowLeft = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1ltvidpf"
        ])
    }, children);
const $1156f5d5007639c5$export$924abd21043fc000 = ({ children: children, onClick: onClick })=>{
    return (0, $dh538.fg)('platform_media_a11y_suppression_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_kkk2n7od _1e0c1ule",
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
};
const $1156f5d5007639c5$export$a5ffe38c17bbc0a1 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1xi2idpf"
        ])
    }, children);
const $1156f5d5007639c5$export$abf07652016c7e56 = ({ children: children, onClick: onClick })=>{
    return (0, $dh538.fg)('platform_media_a11y_suppression_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_kkk2n7od _1e0c1ule",
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
};
const $1156f5d5007639c5$export$b39b1b86b48b621f = ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $1156f5d5007639c5$export$6208675820d4cc50 = ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1156f5d5007639c5$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $1156f5d5007639c5$export$d37eb83491863cbb = ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        className: (0, $gMc0m.default)([
            "_2rkofajl _kqswh2mm _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _1yqxkb7n _1ajs4jg8"
        ])
    }, children);
const $1156f5d5007639c5$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
        ])
    }, children));
const $1156f5d5007639c5$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
        ref: ref,
        style: style,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"
        ])
    }, children));
const $1156f5d5007639c5$export$54cfc70c184c0713 = ({ children: children, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $46EIy.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);
module.exports["ArrowLeftWrapper"] = $1156f5d5007639c5$export$924abd21043fc000;
module.exports["ShadowRight"] = $1156f5d5007639c5$export$a5ffe38c17bbc0a1;
module.exports["ArrowRightWrapper"] = $1156f5d5007639c5$export$abf07652016c7e56;
module.exports["LeftArrow"] = $1156f5d5007639c5$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $1156f5d5007639c5$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $1156f5d5007639c5$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $1156f5d5007639c5$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $1156f5d5007639c5$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $1156f5d5007639c5$export$54cfc70c184c0713;

});

parcelRegister("aL0VQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hZ6O7 = parcelRequire("hZ6O7");


var $jRNsq = parcelRequire("jRNsq");


var $i2CQL = parcelRequire("i2CQL");


var $jQCJ9 = parcelRequire("jQCJ9");

const $4cae511015088d55$var$areFilesPotentiallyDuplicated = (file1, file2)=>file1.status === file2.status && file1.name === file2.name && file1.size === file2.size && file1.mimeType === file2.mimeType && file1.id !== file2.id;
function $4cae511015088d55$export$f91c9e51e5ab027d(ids) {
    const nonErrorFiles = (0, $i2CQL.useMediaStore)((state)=>Object.values(state.files).filter((0, $hZ6O7.isNonErrorFinalFileState)));
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const collections = (0, $42omo.useMemo)(()=>Object.fromEntries(ids.map(({ id: id, collectionName: collectionName })=>[
                id,
                collectionName
            ])), [
        ids
    ]);
    const files = (0, $42omo.useMemo)(()=>nonErrorFiles.filter((file)=>ids.some(({ id: id })=>file.id === id)), [
        nonErrorFiles,
        ids
    ]);
    const prevFiles = (0, $jQCJ9.usePrevious)(files);
    (0, $42omo.useEffect)(()=>{
        const prev = prevFiles ?? [];
        // Get the files that have been added or whose status has changed since last time.
        const addedOrChangedFiles = files.filter((file)=>file && prev.every((prevFile)=>prevFile.id !== file.id || prevFile.status !== file.status));
        // Get the files from the list that are duplicates of the added / changed files
        const potentialDuplicates = files.filter((file)=>addedOrChangedFiles.some((addedFile)=>$4cae511015088d55$var$areFilesPotentiallyDuplicated(file, addedFile)));
        if (potentialDuplicates.length) // if any duplicates are found then fetch their hashes along with the added files
        [
            ...addedOrChangedFiles,
            ...potentialDuplicates
        ].forEach((file)=>{
            const collectionName = collections[file.id];
            mediaClient.file.getFileState(file.id, {
                collectionName: collectionName,
                includeHashForDuplicateFiles: true,
                forceRefresh: true
            });
        });
    }, [
        files,
        prevFiles,
        mediaClient,
        collections
    ]);
    const hashMap = (0, $42omo.useMemo)(()=>Object.fromEntries(files.map((file)=>[
                file.id,
                file.hash
            ])), [
        files
    ]);
    return hashMap;
}
module.exports["useFileHashes"] = $4cae511015088d55$export$f91c9e51e5ab027d;

});

parcelRegister("jQCJ9", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $8227eceacc56cecd$export$5cae361ad82dce8b(value) {
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
module.exports["usePrevious"] = $8227eceacc56cecd$export$5cae361ad82dce8b;

});

parcelRegister("9EfFC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dOMrE = parcelRequire("dOMrE");


var $i0btU = parcelRequire("i0btU");


var $4qXXo = parcelRequire("4qXXo");


var $l2474 = parcelRequire("l2474");


var $6mYMS = parcelRequire("6mYMS");


var $3jsXx = parcelRequire("3jsXx");


var $1DWH0 = parcelRequire("1DWH0");


var $28cxD = parcelRequire("28cxD");


var $bwC67 = parcelRequire("bwC67");


var $g6YCz = parcelRequire("g6YCz");

const $893da78086ca16ac$export$7452d7062a4d0634 = 1000;
const $893da78086ca16ac$export$af8124aa496797f2 = '_|unknown|_';
class $893da78086ca16ac$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        (0, $g6YCz.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $g6YCz.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $28cxD.UFOExperienceState)['STARTED'],
            (0, $28cxD.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bwC67.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            }
        }, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, `@${message}`));
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$893da78086ca16ac$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $6mYMS.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dOMrE.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4qXXo.default), {
            mentionType: mentionType,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            spellCheck: false,
            "data-testid": `mention-${id}`,
            "data-mention-type": mentionType,
            "data-mention-tooltip": showTooltip
        }, failedMention ? this.renderUnknownUserError(id) : text || '@...'));
        const ssrPlaceholderProp = props.ssrPlaceholderId ? {
            'data-ssr-placeholder': props.ssrPlaceholderId
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g6YCz.UfoErrorBoundary), {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: localId,
            "data-mention-id": id,
            "data-local-id": localId,
            "data-access-level": accessLevel,
            spellCheck: false,
            ...ssrPlaceholderProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i0btU.default), null, showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: mentionComponent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l2474.default), {
            name: text
        }, mentionComponent)) : mentionComponent)));
    }
    constructor(props){
        super(props);
        this.hoverTimeout = void 0;
        this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        };
        this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $893da78086ca16ac$export$7452d7062a4d0634);
        };
        this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        };
        this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $6mYMS.MentionType).SELF;
            if ((0, $6mYMS.isRestricted)(accessLevel)) return (0, $6mYMS.MentionType).RESTRICTED;
            return (0, $6mYMS.MentionType).DEFAULT;
        };
        (0, $g6YCz.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
}
const $893da78086ca16ac$var$MentionWithAnalytics = (0, $1DWH0.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $3jsXx.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $3jsXx.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($893da78086ca16ac$export$92ab8442e7a15cef);
const $893da78086ca16ac$var$Mention = $893da78086ca16ac$var$MentionWithAnalytics;
var $893da78086ca16ac$export$2e2bcd8739ae039 = $893da78086ca16ac$var$Mention;
module.exports["UNKNOWN_USER_ID"] = $893da78086ca16ac$export$af8124aa496797f2;
module.exports["default"] = $893da78086ca16ac$export$2e2bcd8739ae039;

});

parcelRegister("i0btU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bwC67 = parcelRequire("bwC67");

const $806263e9564ebacc$var$EMPTY = {};
const $806263e9564ebacc$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($806263e9564ebacc$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($806263e9564ebacc$var$EMPTY);
        (0, $bwC67.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $806263e9564ebacc$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $aXWIB.useIntl)();
    const messages = $806263e9564ebacc$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $806263e9564ebacc$export$2e2bcd8739ae039 = $806263e9564ebacc$var$MessagesIntlProvider;
module.exports["default"] = $806263e9564ebacc$export$2e2bcd8739ae039;

});

parcelRegister("bwC67", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gjAAG = parcelRequire("gjAAG");

const $1cb8431546098045$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
const $1cb8431546098045$export$98e06fe7a6174253 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).unknownUserError);
const $1cb8431546098045$export$58bd5a2057b6b855 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessWarning);
const $1cb8431546098045$export$da9f8ce14593162f = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessLabel);
const $1cb8431546098045$export$4a258ffee7316766 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultHeadline);
const $1cb8431546098045$export$702321a50d74536e = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultAdvisedAction);
const $1cb8431546098045$export$ed7f16088a93ae9d = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).loginAgain);
const $1cb8431546098045$export$3ab158df56460d1c = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).differentText);































const $1cb8431546098045$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("6T5MV")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("2MjVl")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("fUTmq")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("5twea")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("fqTiF")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("hOoVI")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("hzBID")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("iMxZ4")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("6A71H")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("45QCs")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("kqeHl")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("dJ6Pi")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("l2oJQ")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("7Z8O5")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("akIwc")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("5QC19")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("jwFdt")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("57HTs")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("ca1Du")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("eD8co")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("b0J0o")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("bloIQ")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("dVKWy")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("1ux4r")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("dct7i")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("gxykE")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("9677e")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("lksJj")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("1mGBp")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("8yPjD")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $1cb8431546098045$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("5twea")).then((mod)=>mod.default);
            }
    }
};
module.exports["UnknownUserError"] = $1cb8431546098045$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $1cb8431546098045$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $1cb8431546098045$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $1cb8431546098045$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $1cb8431546098045$export$702321a50d74536e;
module.exports["LoginAgain"] = $1cb8431546098045$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $1cb8431546098045$export$3ab158df56460d1c;
module.exports["getMessagesForLocale"] = $1cb8431546098045$export$d0a3169680473b6c;

});

parcelRegister("gjAAG", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $898c0db98da1400a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    }
});
module.exports["messages"] = $898c0db98da1400a$export$defe85febe8b728c;

});

parcelRegister("6T5MV", function(module, exports) {

let $503c5e8d0af51132$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $503c5e8d0af51132$var$load("4Mixi"),
    $503c5e8d0af51132$var$load("1jsQH"),
    $503c5e8d0af51132$var$load("i5eMd"),
    $503c5e8d0af51132$var$load("bv8GZ"),
    $503c5e8d0af51132$var$load("i9sd0"),
    $503c5e8d0af51132$var$load("4DYJ5"),
    $503c5e8d0af51132$var$load("gyXEE"),
    $503c5e8d0af51132$var$load("hoPZ9")
]).then(()=>parcelRequire('6Yuab'));

});

parcelRegister("2MjVl", function(module, exports) {

let $205f84f31c80d263$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $205f84f31c80d263$var$load("cjveN"),
    $205f84f31c80d263$var$load("deyvi"),
    $205f84f31c80d263$var$load("4UPfH"),
    $205f84f31c80d263$var$load("cdeuH"),
    $205f84f31c80d263$var$load("aNg21"),
    $205f84f31c80d263$var$load("hfFxJ"),
    $205f84f31c80d263$var$load("1Mp9N"),
    $205f84f31c80d263$var$load("2Fu3d")
]).then(()=>parcelRequire('biDFC'));

});

parcelRegister("fUTmq", function(module, exports) {

let $b967077948092e7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b967077948092e7e$var$load("8XGJb"),
    $b967077948092e7e$var$load("6dERU"),
    $b967077948092e7e$var$load("gd4qs"),
    $b967077948092e7e$var$load("7gF8f"),
    $b967077948092e7e$var$load("YEGhv"),
    $b967077948092e7e$var$load("gofGr"),
    $b967077948092e7e$var$load("dBb6q"),
    $b967077948092e7e$var$load("eJgH8")
]).then(()=>parcelRequire('e7zr1'));

});

parcelRegister("5twea", function(module, exports) {

let $3fc8a8e755b35ba7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fc8a8e755b35ba7$var$load("2YffH").then(()=>parcelRequire('gbdrY'));

});

parcelRegister("fqTiF", function(module, exports) {

let $b3c42e30442687ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b3c42e30442687ea$var$load("hdvZr"),
    $b3c42e30442687ea$var$load("kTurq"),
    $b3c42e30442687ea$var$load("fviv5"),
    $b3c42e30442687ea$var$load("djb49"),
    $b3c42e30442687ea$var$load("d8WL7"),
    $b3c42e30442687ea$var$load("2RQvP"),
    $b3c42e30442687ea$var$load("7Lkvk")
]).then(()=>parcelRequire('4ykQ2'));

});

parcelRegister("hOoVI", function(module, exports) {

let $cf7a71ba4d1a7d13$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cf7a71ba4d1a7d13$var$load("4ViGN"),
    $cf7a71ba4d1a7d13$var$load("j0PWv"),
    $cf7a71ba4d1a7d13$var$load("eBoC7"),
    $cf7a71ba4d1a7d13$var$load("ksTQ6"),
    $cf7a71ba4d1a7d13$var$load("j5F5K"),
    $cf7a71ba4d1a7d13$var$load("7NpX8"),
    $cf7a71ba4d1a7d13$var$load("cukQS"),
    $cf7a71ba4d1a7d13$var$load("5FaEJ")
]).then(()=>parcelRequire('4FRcU'));

});

parcelRegister("hzBID", function(module, exports) {

let $ccb2f6c0baa217fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ccb2f6c0baa217fd$var$load("32vlK"),
    $ccb2f6c0baa217fd$var$load("dlmud"),
    $ccb2f6c0baa217fd$var$load("bNv64"),
    $ccb2f6c0baa217fd$var$load("5CGnz"),
    $ccb2f6c0baa217fd$var$load("dXu4x"),
    $ccb2f6c0baa217fd$var$load("bFU3Y"),
    $ccb2f6c0baa217fd$var$load("3CucM"),
    $ccb2f6c0baa217fd$var$load("9yemY")
]).then(()=>parcelRequire('bG4aH'));

});

parcelRegister("iMxZ4", function(module, exports) {

let $dac712373986424e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dac712373986424e$var$load("7snhF"),
    $dac712373986424e$var$load("bAoKR"),
    $dac712373986424e$var$load("X0Jic"),
    $dac712373986424e$var$load("34YSq"),
    $dac712373986424e$var$load("5IaSN")
]).then(()=>parcelRequire('kVRsY'));

});

parcelRegister("6A71H", function(module, exports) {

let $4cab8e2500c81e40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4cab8e2500c81e40$var$load("bjoGV"),
    $4cab8e2500c81e40$var$load("cbkj0"),
    $4cab8e2500c81e40$var$load("4Afgd"),
    $4cab8e2500c81e40$var$load("9Oxgj"),
    $4cab8e2500c81e40$var$load("18TX5"),
    $4cab8e2500c81e40$var$load("exaJ2"),
    $4cab8e2500c81e40$var$load("lp8Wm"),
    $4cab8e2500c81e40$var$load("l2LZP")
]).then(()=>parcelRequire('FrZOj'));

});

parcelRegister("45QCs", function(module, exports) {

let $2fb07220bd68990e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2fb07220bd68990e$var$load("8oiz7"),
    $2fb07220bd68990e$var$load("17m16"),
    $2fb07220bd68990e$var$load("cMubu"),
    $2fb07220bd68990e$var$load("kAg8V"),
    $2fb07220bd68990e$var$load("9Cdzw"),
    $2fb07220bd68990e$var$load("hcCcg"),
    $2fb07220bd68990e$var$load("cHWSM"),
    $2fb07220bd68990e$var$load("35Ssm")
]).then(()=>parcelRequire('225Fx'));

});

parcelRegister("kqeHl", function(module, exports) {

let $ede1a31387791599$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ede1a31387791599$var$load("hFxmj"),
    $ede1a31387791599$var$load("b4NO6"),
    $ede1a31387791599$var$load("3fLE9"),
    $ede1a31387791599$var$load("fM2oh"),
    $ede1a31387791599$var$load("guNAg"),
    $ede1a31387791599$var$load("j9KTb"),
    $ede1a31387791599$var$load("b37xN"),
    $ede1a31387791599$var$load("ik6u5")
]).then(()=>parcelRequire('alG1N'));

});

parcelRegister("dJ6Pi", function(module, exports) {

let $9fe4c5e3bbeeb3c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9fe4c5e3bbeeb3c3$var$load("fModo").then(()=>parcelRequire('lQyzT'));

});

parcelRegister("l2oJQ", function(module, exports) {

let $f50cf970562150c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f50cf970562150c0$var$load("BXOZB"),
    $f50cf970562150c0$var$load("1K1Fj"),
    $f50cf970562150c0$var$load("8hOn0"),
    $f50cf970562150c0$var$load("xnqy2"),
    $f50cf970562150c0$var$load("cM3gY"),
    $f50cf970562150c0$var$load("3hjAq"),
    $f50cf970562150c0$var$load("7PjNK"),
    $f50cf970562150c0$var$load("Vt6S9")
]).then(()=>parcelRequire('gSUUF'));

});

parcelRegister("7Z8O5", function(module, exports) {

let $5d050fbd5facb726$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5d050fbd5facb726$var$load("9Xiuh"),
    $5d050fbd5facb726$var$load("38sfA"),
    $5d050fbd5facb726$var$load("h4OCL"),
    $5d050fbd5facb726$var$load("awkVi"),
    $5d050fbd5facb726$var$load("6yRq3"),
    $5d050fbd5facb726$var$load("2bCHJ"),
    $5d050fbd5facb726$var$load("ktSfi"),
    $5d050fbd5facb726$var$load("9GZ76")
]).then(()=>parcelRequire('cF55v'));

});

parcelRegister("akIwc", function(module, exports) {

let $785e4e149392f9ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $785e4e149392f9ad$var$load("7Odo3"),
    $785e4e149392f9ad$var$load("bjmre"),
    $785e4e149392f9ad$var$load("bcQs2"),
    $785e4e149392f9ad$var$load("11DLa"),
    $785e4e149392f9ad$var$load("cft22"),
    $785e4e149392f9ad$var$load("fdXnq"),
    $785e4e149392f9ad$var$load("iouLY"),
    $785e4e149392f9ad$var$load("4sOIV")
]).then(()=>parcelRequire('4IbNl'));

});

parcelRegister("5QC19", function(module, exports) {

let $441f4c94ccb114d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $441f4c94ccb114d1$var$load("4VkvT"),
    $441f4c94ccb114d1$var$load("asvK9"),
    $441f4c94ccb114d1$var$load("aBa7j"),
    $441f4c94ccb114d1$var$load("barSq"),
    $441f4c94ccb114d1$var$load("gctEz"),
    $441f4c94ccb114d1$var$load("cItJR"),
    $441f4c94ccb114d1$var$load("hPZE5"),
    $441f4c94ccb114d1$var$load("QTjdE")
]).then(()=>parcelRequire('jKge3'));

});

parcelRegister("jwFdt", function(module, exports) {

let $e370fa3387d5e3b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e370fa3387d5e3b0$var$load("g5qJV"),
    $e370fa3387d5e3b0$var$load("7v6wU"),
    $e370fa3387d5e3b0$var$load("b544F"),
    $e370fa3387d5e3b0$var$load("a8heY"),
    $e370fa3387d5e3b0$var$load("9PPH7"),
    $e370fa3387d5e3b0$var$load("SctKm"),
    $e370fa3387d5e3b0$var$load("dzIm8"),
    $e370fa3387d5e3b0$var$load("hrf1M")
]).then(()=>parcelRequire('lGLcJ'));

});

parcelRegister("57HTs", function(module, exports) {

let $3bafa7864906c813$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3bafa7864906c813$var$load("dPa6p"),
    $3bafa7864906c813$var$load("aEpRh"),
    $3bafa7864906c813$var$load("K6fhx"),
    $3bafa7864906c813$var$load("6hlNE"),
    $3bafa7864906c813$var$load("1y1eN"),
    $3bafa7864906c813$var$load("1fJz1"),
    $3bafa7864906c813$var$load("jqwnR"),
    $3bafa7864906c813$var$load("lsloj")
]).then(()=>parcelRequire('d7PIu'));

});

parcelRegister("ca1Du", function(module, exports) {

let $8da7b01006dab874$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8da7b01006dab874$var$load("iG4uh"),
    $8da7b01006dab874$var$load("3fuR9"),
    $8da7b01006dab874$var$load("gZU54"),
    $8da7b01006dab874$var$load("2bqSD"),
    $8da7b01006dab874$var$load("e8jpx"),
    $8da7b01006dab874$var$load("9yA8o"),
    $8da7b01006dab874$var$load("bGhLc"),
    $8da7b01006dab874$var$load("iRKhU")
]).then(()=>parcelRequire('jwd3r'));

});

parcelRegister("eD8co", function(module, exports) {

let $aa6b115a311b9fd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa6b115a311b9fd0$var$load("aGECO").then(()=>parcelRequire('c2Dmg'));

});

parcelRegister("b0J0o", function(module, exports) {

let $80429af000af95fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $80429af000af95fd$var$load("bSjyK"),
    $80429af000af95fd$var$load("hlJc4"),
    $80429af000af95fd$var$load("j6IGj"),
    $80429af000af95fd$var$load("6tWAg"),
    $80429af000af95fd$var$load("aOdaf")
]).then(()=>parcelRequire('l9Ug4'));

});

parcelRegister("bloIQ", function(module, exports) {

let $8424d53b9bbb3a1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8424d53b9bbb3a1f$var$load("9tVE8"),
    $8424d53b9bbb3a1f$var$load("fMrUo"),
    $8424d53b9bbb3a1f$var$load("4Wdqb"),
    $8424d53b9bbb3a1f$var$load("bJykp"),
    $8424d53b9bbb3a1f$var$load("fjbzp"),
    $8424d53b9bbb3a1f$var$load("448N7"),
    $8424d53b9bbb3a1f$var$load("9v6ER"),
    $8424d53b9bbb3a1f$var$load("aEAsN")
]).then(()=>parcelRequire('fkCIe'));

});

parcelRegister("dVKWy", function(module, exports) {

let $a245033a20d44784$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a245033a20d44784$var$load("5WkxF").then(()=>parcelRequire('hW2zm'));

});

parcelRegister("1ux4r", function(module, exports) {

let $11623ef14a88be02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $11623ef14a88be02$var$load("6UAlo"),
    $11623ef14a88be02$var$load("9eNkX"),
    $11623ef14a88be02$var$load("k10Cs"),
    $11623ef14a88be02$var$load("dh2Er"),
    $11623ef14a88be02$var$load("1pFHs"),
    $11623ef14a88be02$var$load("gBDdh"),
    $11623ef14a88be02$var$load("8Mz40"),
    $11623ef14a88be02$var$load("l6YHr")
]).then(()=>parcelRequire('gR0Ux'));

});

parcelRegister("dct7i", function(module, exports) {

let $99c2fb5138729985$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99c2fb5138729985$var$load("l7PQP").then(()=>parcelRequire('bRxNE'));

});

parcelRegister("gxykE", function(module, exports) {

let $c0aa5c07dc440dda$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c0aa5c07dc440dda$var$load("9Yw4z"),
    $c0aa5c07dc440dda$var$load("h0uBE"),
    $c0aa5c07dc440dda$var$load("1n8w9"),
    $c0aa5c07dc440dda$var$load("eBLgB"),
    $c0aa5c07dc440dda$var$load("d0Fxy"),
    $c0aa5c07dc440dda$var$load("6NHX3"),
    $c0aa5c07dc440dda$var$load("77dzh")
]).then(()=>parcelRequire('4dnaM'));

});

parcelRegister("9677e", function(module, exports) {

let $69fa319b49dca515$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69fa319b49dca515$var$load("fLjHM").then(()=>parcelRequire('2qq54'));

});

parcelRegister("lksJj", function(module, exports) {

let $f871c05e7ad2e071$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f871c05e7ad2e071$var$load("3YGga").then(()=>parcelRequire('7iyzo'));

});

parcelRegister("1mGBp", function(module, exports) {

let $0fe8e47223ece87f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0fe8e47223ece87f$var$load("ia9y3"),
    $0fe8e47223ece87f$var$load("j9OUx"),
    $0fe8e47223ece87f$var$load("l079e"),
    $0fe8e47223ece87f$var$load("bV8sS"),
    $0fe8e47223ece87f$var$load("kKXTS"),
    $0fe8e47223ece87f$var$load("ebljE"),
    $0fe8e47223ece87f$var$load("hF4v3"),
    $0fe8e47223ece87f$var$load("afU9w")
]).then(()=>parcelRequire('lRTsu'));

});

parcelRegister("8yPjD", function(module, exports) {

let $63b94def09bd7557$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63b94def09bd7557$var$load("15ncj"),
    $63b94def09bd7557$var$load("gDiIK"),
    $63b94def09bd7557$var$load("f1B4n"),
    $63b94def09bd7557$var$load("eLlpV"),
    $63b94def09bd7557$var$load("7sItg"),
    $63b94def09bd7557$var$load("j4dSZ"),
    $63b94def09bd7557$var$load("1Tuyb"),
    $63b94def09bd7557$var$load("7iCpI")
]).then(()=>parcelRequire('jKBtA'));

});

parcelRegister("4qXXo", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $6mYMS = parcelRequire("6mYMS");


var $42omo = parcelRequire("42omo");

const $1278ab3a4b348f22$var$mentionStyle = {
    [(0, $6mYMS.MentionType).SELF]: {
        background: "var(--ds-background-brand-bold, #1868DB)",
        borderColor: 'transparent',
        text: "var(--ds-text-inverse, #FFFFFF)",
        hoveredBackground: "var(--ds-background-brand-bold-hovered, #1558BC)",
        pressedBackground: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    [(0, $6mYMS.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: "var(--ds-border-bold, #7D818A)",
        text: "var(--ds-text, #292A2E)",
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $6mYMS.MentionType).DEFAULT]: {
        background: "var(--ds-background-neutral, #0515240F)",
        borderColor: 'transparent',
        text: "var(--ds-text-subtle, #505258)",
        hoveredBackground: "var(--ds-background-neutral-hovered, #0B120E24)",
        pressedBackground: "var(--ds-background-neutral-pressed, #080F214A)"
    }
};
const $1278ab3a4b348f22$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $1278ab3a4b348f22$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $1278ab3a4b348f22$var$PrimitiveMention = /*#__PURE__*/ (0, $42omo.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $9K4OG.css)("display:inline;border:var(--ds-border-width, 1px) solid ", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $1278ab3a4b348f22$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $1278ab3a4b348f22$export$2e2bcd8739ae039 = $1278ab3a4b348f22$var$PrimitiveMention;
module.exports["default"] = $1278ab3a4b348f22$export$2e2bcd8739ae039;

});

parcelRegister("l2474", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $d23df821b2d2d994$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("gURmQ")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $d23df821b2d2d994$export$2e2bcd8739ae039 = $d23df821b2d2d994$var$AsyncNoAccessTooltip;
module.exports["default"] = $d23df821b2d2d994$export$2e2bcd8739ae039;

});

parcelRegister("gURmQ", function(module, exports) {

let $c50b45f90fc6d653$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c50b45f90fc6d653$var$load("2lsX7").then(()=>parcelRequire('5zTqW'));

});

parcelRegister("g6YCz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $af19f55bb4052571$export$1d011e4240507c78 = new (0, $9801n.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
});
class $af19f55bb4052571$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        $af19f55bb4052571$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["mentionRenderedUfoExperience"] = $af19f55bb4052571$export$1d011e4240507c78;
module.exports["UfoErrorBoundary"] = $af19f55bb4052571$export$5ef1c2550074a375;

});

parcelRegister("1NrSh", function(module, exports) {
const $49895188b0a86f3f$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};
module.exports["PRD_CONFIG"] = $49895188b0a86f3f$export$d4fff2dfff3e2bc1;

});

parcelRegister("7uLCZ", function(module, exports) {

var $bDniu = parcelRequire("bDniu");


var $4tRVV = parcelRequire("4tRVV");



var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $2HVlJ = parcelRequire("2HVlJ");



var $lPGZG = parcelRequire("lPGZG");


var $dlky5 = parcelRequire("dlky5");

var $575047a4d1f8def0$export$bb38bb9a1161268 = 'unmounted';
var $575047a4d1f8def0$export$84cbff306f539230 = 'exited';
var $575047a4d1f8def0$export$df38205c966be359 = 'entering';
var $575047a4d1f8def0$export$78e9e6e3e014d60a = 'entered';
var $575047a4d1f8def0$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $575047a4d1f8def0$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
                _this.appearStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else initialStatus = $575047a4d1f8def0$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $575047a4d1f8def0$export$bb38bb9a1161268;
        else initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $575047a4d1f8def0$export$bb38bb9a1161268) return {
            status: $575047a4d1f8def0$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $575047a4d1f8def0$export$df38205c966be359 && status !== $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else if (status === $575047a4d1f8def0$export$df38205c966be359 || status === $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $575047a4d1f8def0$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $dlky5.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $575047a4d1f8def0$export$84cbff306f539230) this.setState({
            status: $575047a4d1f8def0$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $2HVlJ.default).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $575047a4d1f8def0$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $575047a4d1f8def0$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $2HVlJ.default).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $575047a4d1f8def0$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $575047a4d1f8def0$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $575047a4d1f8def0$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $bDniu.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lPGZG.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
$575047a4d1f8def0$var$Transition.contextType = (0, $lPGZG.default);
$575047a4d1f8def0$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $575047a4d1f8def0$var$noop() {}
$575047a4d1f8def0$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $575047a4d1f8def0$var$noop,
    onEntering: $575047a4d1f8def0$var$noop,
    onEntered: $575047a4d1f8def0$var$noop,
    onExit: $575047a4d1f8def0$var$noop,
    onExiting: $575047a4d1f8def0$var$noop,
    onExited: $575047a4d1f8def0$var$noop
};
$575047a4d1f8def0$var$Transition.UNMOUNTED = $575047a4d1f8def0$export$bb38bb9a1161268;
$575047a4d1f8def0$var$Transition.EXITED = $575047a4d1f8def0$export$84cbff306f539230;
$575047a4d1f8def0$var$Transition.ENTERING = $575047a4d1f8def0$export$df38205c966be359;
$575047a4d1f8def0$var$Transition.ENTERED = $575047a4d1f8def0$export$78e9e6e3e014d60a;
$575047a4d1f8def0$var$Transition.EXITING = $575047a4d1f8def0$export$4aacc83d4d59139f;
var $575047a4d1f8def0$export$2e2bcd8739ae039 = $575047a4d1f8def0$var$Transition;
module.exports["default"] = $575047a4d1f8def0$export$2e2bcd8739ae039;

});

parcelRegister("2HVlJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f8c1559a495fd3f$export$2e2bcd8739ae039);
var $1f8c1559a495fd3f$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("lPGZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe4fb61bd619d593$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var $fe4fb61bd619d593$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);

});

parcelRegister("dlky5", function(module, exports) {
var $9b6d2d196fd1178d$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};
module.exports["forceReflow"] = $9b6d2d196fd1178d$export$7d26bbb1236dafd6;

});

parcelRegister("6Htct", function(module, exports) {
var $4c47f75c6ef52bb8$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $4c47f75c6ef52bb8$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'review-api-security',
    'policy-assist'
]);
var $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_CREATE_PULL_REQUEST"] = "bitbucket-create-pull-request";
    PageContextType["BITBUCKET_PULL_REQUEST_WITHOUT_PIPELINES_STARTERS"] = "bitbucket-pull-request-without-pipelines-starters";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["SAC"] = "sac";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $4c47f75c6ef52bb8$export$4f757e7d9540e8f9 = 'prompt-of-day';
module.exports["HandleActionType"] = $4c47f75c6ef52bb8$export$87497e63e164f4b3;
module.exports["LEGACY_DYNAMIC_SKILL_IDS"] = $4c47f75c6ef52bb8$export$c91e07269f22915a;
module.exports["PageContextType"] = $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127;
module.exports["PROMPT_OF_DAY_ACTION_ID"] = $4c47f75c6ef52bb8$export$4f757e7d9540e8f9;

});

parcelRegister("aMqwg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9d4cc27d6faf7a6e$var$rovoEntitlementStore = (0, $1P1Tu.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $9d4cc27d6faf7a6e$var$useStateHook = (0, $9zUhf.createStateHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$66d5dd4be64dea43 = ()=>{
    const result = $9d4cc27d6faf7a6e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $9d4cc27d6faf7a6e$export$8004893135276275 = (0, $9zUhf.createActionsHook)($9d4cc27d6faf7a6e$var$rovoEntitlementStore);
const $9d4cc27d6faf7a6e$export$d03a05ad8547472c = ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $9d4cc27d6faf7a6e$export$8004893135276275();
    (0, $42omo.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $9d4cc27d6faf7a6e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $9d4cc27d6faf7a6e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $9d4cc27d6faf7a6e$export$d03a05ad8547472c;

});

parcelRegister("9eLw5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $9zUhf = parcelRequire("9zUhf");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");

var $4HDYO = parcelRequire("4HDYO");


var $flpNp = parcelRequire("flpNp");

const $2c362c1c58e43242$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            }
    }
});
const $2c362c1c58e43242$var$selector = (0, $cclHy.createSelector)((state)=>state.cache, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
	 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
	 * and it will determine whether to rerender the component
	 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
	 *
	 * e.g. for `enabled` true condition:
	 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
	 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
	 *
	 * To test this, run the unit test, and then force this function to return new stuff on every call
	 * e.g. `return { ...result, random: Math.random() };`
	 * it will result in increase renderCount in the unit test
	 */ (cache, key, initialQueryEnabled)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: initialQueryEnabled
    });
const $2c362c1c58e43242$var$useCacheEntry = (0, $9zUhf.createHook)($2c362c1c58e43242$var$store, {
    selector: $2c362c1c58e43242$var$selector
});
const $2c362c1c58e43242$export$96097db97bddd5cd = ({ queryKey: queryKeyParts, queryFn: queryFn, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const storeApi = (0, $4HDYO.defaultRegistry).getStore($2c362c1c58e43242$var$store);
    const actions = storeApi.actions;
    if (actions.getCacheEntry(queryKey) !== undefined) return;
    onStart?.();
    actions.updateCacheEntry(queryKey, {
        isFetching: true,
        data: null,
        error: null
    });
    queryFn().then((response)=>{
        actions.updateCacheEntry(queryKey, {
            data: response,
            error: null,
            isFetching: false
        });
        onSuccess?.(response);
    }).catch((error)=>{
        // Cache-side errors are intentionally swallowed: a downstream `useQuery`
        // observer (if any) will refetch and surface the error via its normal
        // path. `onError` is purely for the warm callsite's observability.
        actions.updateCacheEntry(queryKey, {
            isFetching: false
        });
        onError?.(error);
    });
};
const $2c362c1c58e43242$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $42omo.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $42omo.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $42omo.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $2c362c1c58e43242$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $flpNp.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $42omo.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $fFa3V.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["prefetchQuery"] = $2c362c1c58e43242$export$96097db97bddd5cd;
module.exports["useQuery"] = $2c362c1c58e43242$export$dd0a697e1782aedd;

});

parcelRegister("8CAML", function(module, exports) {

var $8Igpw = parcelRequire("8Igpw");

const $ece6631c27d5e331$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $ece6631c27d5e331$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $ece6631c27d5e331$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $ece6631c27d5e331$export$ba203f24e0131ba7) throw err;
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') return {
            data: null,
            errors: undefined
        };
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $8Igpw.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $ece6631c27d5e331$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $ece6631c27d5e331$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $ece6631c27d5e331$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $ece6631c27d5e331$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $ece6631c27d5e331$export$f602b5befecb0b84;
module.exports["GqlApiError"] = $ece6631c27d5e331$export$ba203f24e0131ba7;

});

parcelRegister("iswAx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $2Nwuj = parcelRequire("2Nwuj");


var $4Nwes = parcelRequire("4Nwes");


var $9EfFC = parcelRequire("9EfFC");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $9uTsJ = parcelRequire("9uTsJ");


var $bOrYy = parcelRequire("bOrYy");


var $kpYGL = parcelRequire("kpYGL");


var $1yaYZ = parcelRequire("1yaYZ");


var $9eLw5 = parcelRequire("9eLw5");


var $26nu6 = parcelRequire("26nu6");


var $cqFPV = parcelRequire("cqFPV");


var $fQF1W = parcelRequire("fQF1W");


var $eOn3v = parcelRequire("eOn3v");


var $5kyLi = parcelRequire("5kyLi");

const $baa53903be441878$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $baa53903be441878$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $baa53903be441878$export$1565ea9a9fb7ad67 = ({ agent: agent, siteId: siteId, simplified: simplified, onClick: onClick })=>{
    if ((0, $26nu6.isSystemAgent)(agent) || (0, $26nu6.isOOTBAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        testId: "atlassian-icon",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                label: "",
                appearance: "brand",
                size: "small"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: "Atlassian"
            })
        ]
    });
    if ((0, $26nu6.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            alignBlock: "center",
            testId: "atlassian-icon",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                href: authoringTeam.profile_url,
                target: "_blank",
                onClick: onClick,
                children: authoringTeam.display_name
            })
        });
        const aaid = agent.creator ? $baa53903be441878$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)($baa53903be441878$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified,
            onClick: onClick
        });
    }
    if ((0, $dh538.fg)('rovo_agent_support_a2a_avatar') ? (0, $bOrYy.isForgeAgentByCreatorType)(agent.creator_type) : (0, $26nu6.isForgeAgent)(agent)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: agent.creator
    });
    return null;
};
// TODO consolidate this with `AgentCreator` component `platform/packages/ai-mate/conversation-assistant-agent/src/common/ui/creator/index.tsx`
const $baa53903be441878$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false, onClick: onClick })=>{
    (0, $fBMbo.di)($baa53903be441878$export$5d980898591175e);
    const { profile: profile, client: client } = $baa53903be441878$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { atlasURL: atlasURL } = (0, $fQF1W.useAtlasURL)(siteId);
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $5kyLi.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
    if (simplified) {
        const profileUrl = atlasURL(`/people/${userId}`);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
            href: profileUrl,
            target: "_blank",
            onClick: onClick,
            children: fullName
        });
    }
    return profileCard ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9uTsJ.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9EfFC.default), {
            id: userId,
            isHighlighted: profile.data.isCurrentUser,
            text: `@${fullName}`
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9EfFC.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
function $baa53903be441878$export$5d980898591175e(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $eOn3v.useProfileClient)();
    const profile = (0, $9eLw5.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                (0, $1yaYZ.logException)({
                    exception: error,
                    name: 'ConversationAssistantAgentUseProfileResolutionError'
                });
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
}
const $baa53903be441878$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $baa53903be441878$export$a6e36c224ec3c0cb = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled);
    if (!enabledSources?.length) return [];
    const allAris = enabledSources?.reduce((acc, cur)=>{
        const allFilters = [
            ...cur?.filters?.parentFilter ?? [],
            ...cur?.filters?.spaceFilter ?? [],
            ...cur?.filters?.projectFilter ?? []
        ];
        allFilters.forEach((item)=>acc.add(item));
        return acc;
    }, new Set());
    return Array.from(allAris);
};
const $baa53903be441878$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $cqFPV.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $cqFPV.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $cqFPV.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
module.exports["getAAIDFromARI"] = $baa53903be441878$export$3761e66a04602cbd;
module.exports["AgentCreatedBy"] = $baa53903be441878$export$1565ea9a9fb7ad67;
module.exports["useProfileResolution"] = $baa53903be441878$export$5d980898591175e;
module.exports["getEnabledKnowlegeArisFromAgent"] = $baa53903be441878$export$a6e36c224ec3c0cb;
module.exports["getSuggestedOotbAgents"] = $baa53903be441878$export$6d876204c5d593ac;

});

parcelRegister("26nu6", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $04c28723649a2305$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $04c28723649a2305$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $04c28723649a2305$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE' || agent.creator_type === 'REMOTE_A2A' && (0, $dh538.fg)('rovo_agent_support_a2a_avatar');
const $04c28723649a2305$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $04c28723649a2305$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $04c28723649a2305$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates',
    VERIFIED_AGENTS: 'verified-agents',
    /** Jira browse tab: agents available for Jira (UI label localized in product). */ AVAILABLE_FOR_JIRA: 'available-for-jira'
};
module.exports["isSystemAgent"] = $04c28723649a2305$export$7c120b233d4844c6;
module.exports["isCustomerAgent"] = $04c28723649a2305$export$f817e52cf2c5cc8c;
module.exports["isForgeAgent"] = $04c28723649a2305$export$2149adda3d8a5807;
module.exports["isOOTBAgent"] = $04c28723649a2305$export$7091e3bee2adaacb;
module.exports["BrowseCategories"] = $04c28723649a2305$export$916e4870f74f205b;

});

parcelRegister("cqFPV", function(module, exports) {
const $570a782ebb8f75e0$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $570a782ebb8f75e0$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $570a782ebb8f75e0$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $570a782ebb8f75e0$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $570a782ebb8f75e0$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $570a782ebb8f75e0$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $570a782ebb8f75e0$var$AGENT_AUP_ERROR_CODE;
const $570a782ebb8f75e0$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $570a782ebb8f75e0$var$HIPAA_ERROR_CODE;
const $570a782ebb8f75e0$export$429080cfef3412f2 = 'browse-agents-container';
module.exports["DEFAULT_AGENTS_NAMED_ID_LIST"] = $570a782ebb8f75e0$export$2d0163867590928d;
module.exports["DEFAULT_OOTB_AGENTS_NAMED_IDS"] = $570a782ebb8f75e0$export$804d9ee5f4cc40a8;
module.exports["isHipaaError"] = $570a782ebb8f75e0$export$f8b1b75846492611;
module.exports["AGENTS_CONTAINER_ID"] = $570a782ebb8f75e0$export$429080cfef3412f2;

});

parcelRegister("fQF1W", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $827Ne = parcelRequire("827Ne");


var $dYtRL = parcelRequire("dYtRL");

const $2a6bb271c0fd2ecb$export$8a1abb7c176bd202 = (siteId)=>{
    const { data: tenantData } = (0, $dYtRL.useTenantDataController)(siteId);
    const atlasURL = (0, $42omo.useCallback)((path)=>(0, $827Ne.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $2a6bb271c0fd2ecb$export$b61b99f9ac0264be = (siteId)=>{
    const { atlasURL: atlasURL } = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};
module.exports["useAtlasURL"] = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202;

});

parcelRegister("827Ne", function(module, exports) {

var $6FQwA = parcelRequire("6FQwA");


var $bhcGS = parcelRequire("bhcGS");

const $5ae4133df3384b49$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $5ae4133df3384b49$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $5ae4133df3384b49$export$5105758c0e772381 = ()=>{
    return (0, $bhcGS.isStaging)() ? $5ae4133df3384b49$var$ATLAS_STAGING_URL : $5ae4133df3384b49$var$ATLAS_PROD_URL;
};
const $5ae4133df3384b49$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$5ae4133df3384b49$export$5105758c0e772381()}/o/${orgId}` : $5ae4133df3384b49$export$5105758c0e772381();
    return (0, $6FQwA.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};
module.exports["getAtlasHost"] = $5ae4133df3384b49$export$5105758c0e772381;
module.exports["getAtlasURL"] = $5ae4133df3384b49$export$bfee0f88bf621ad3;

});

parcelRegister("6FQwA", function(module, exports) {

var $kGZ7I = parcelRequire("kGZ7I");

const $fba4647064c9da0b$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $fba4647064c9da0b$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $fba4647064c9da0b$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $fba4647064c9da0b$export$9748efee331ec573 = (param)=>`${0, $kGZ7I.ROVO_PARAM_PREFIX}${$fba4647064c9da0b$export$fda91e425d265029(param)}`;
const $fba4647064c9da0b$export$f2888183a34644d4 = (param)=>{
    return $fba4647064c9da0b$export$858653b7ee3cbb17(param.replace((0, $kGZ7I.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $fba4647064c9da0b$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $fba4647064c9da0b$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $kGZ7I.ROVO_PARAM_PREFIX))) return;
        const paramKey = $fba4647064c9da0b$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $fba4647064c9da0b$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $fba4647064c9da0b$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $fba4647064c9da0b$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $fba4647064c9da0b$export$ef04687636c850fe(window.location.pathname, params));
};
const $fba4647064c9da0b$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $fba4647064c9da0b$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $fba4647064c9da0b$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $fba4647064c9da0b$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$fba4647064c9da0b$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$fba4647064c9da0b$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $fba4647064c9da0b$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $fba4647064c9da0b$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $kGZ7I.ROVO_VALID_PARAMS).map((param)=>`${$fba4647064c9da0b$export$9748efee331ec573(param)}${suffix}`);
};
module.exports["getRovoParams"] = $fba4647064c9da0b$export$6405071f390601f7;
module.exports["updatePageRovoParams"] = $fba4647064c9da0b$export$4a302fc7d977f7b3;
module.exports["addRovoParamsToUrl"] = $fba4647064c9da0b$export$ef04687636c850fe;
module.exports["encodeRovoParams"] = $fba4647064c9da0b$export$eddc20a009406015;

});

parcelRegister("kGZ7I", function(module, exports) {
const $0075612de7c1f282$export$5a550907ffbc9119 = 'rovoChat';
const $0075612de7c1f282$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt',
    'promptLibraryOpen',
    'openChatMode'
];
module.exports["ROVO_PARAM_PREFIX"] = $0075612de7c1f282$export$5a550907ffbc9119;
module.exports["ROVO_VALID_PARAMS"] = $0075612de7c1f282$export$3cd6b610e7ede579;

});

parcelRegister("bhcGS", function(module, exports) {
const $f2c917fe02396491$export$23da1d24a38b0bde = ()=>{
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
module.exports["isStaging"] = $f2c917fe02396491$export$23da1d24a38b0bde;

});

parcelRegister("dYtRL", function(module, exports) {

var $fBMbo = parcelRequire("fBMbo");


var $16lEl = parcelRequire("16lEl");


var $hUyPY = parcelRequire("hUyPY");


var $9eLw5 = parcelRequire("9eLw5");


var $hGGLc = parcelRequire("hGGLc");

const $63d59501eb65c4db$export$b863fec6791eae25 = (siteId)=>{
    (0, $fBMbo.di)((0, $9eLw5.useQuery));
    const experience = (0, $hUyPY.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error } = (0, $9eLw5.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $hGGLc.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error
    };
};
module.exports["useTenantDataController"] = $63d59501eb65c4db$export$b863fec6791eae25;

});

parcelRegister("hGGLc", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $8CAML = parcelRequire("8CAML");

const $0fc4c72c92b990ea$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
	orgId
  }
}
`;
const $0fc4c72c92b990ea$var$cache = new Map();
const $0fc4c72c92b990ea$export$d4ace54df9bd6bb1 = async (cloudId)=>{
    // If AIFC is enabled, use the new caching
    if ((0, $dh538.fg)('aifc_create_enabled')) {
        // Check if we already have a pending promise or cached result
        if ($0fc4c72c92b990ea$var$cache.has(cloudId)) return $0fc4c72c92b990ea$var$cache.get(cloudId);
        const response = await (0, $8CAML.performGqlFetch)({
            gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
            variables: {
                cloudIds: [
                    cloudId
                ]
            }
        });
        const result = response.data?.tenantContexts?.[0];
        if (result) // Store the promise in the cache
        $0fc4c72c92b990ea$var$cache.set(cloudId, result);
        return result;
    }
    const response = await (0, $8CAML.performGqlFetch)({
        gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};
module.exports["getCloudUrlFromId"] = $0fc4c72c92b990ea$export$d4ace54df9bd6bb1;

});

parcelRegister("eOn3v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $fHxn4 = parcelRequire("fHxn4");

const $1bde4828e2efe4cf$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $1bde4828e2efe4cf$var$client;
const $1bde4828e2efe4cf$export$d43dc22a8337ee9f = ()=>{
    (0, $fBMbo.di)((0, $fHxn4.default));
    const profileClient = (0, $42omo.useMemo)(()=>{
        if (!$1bde4828e2efe4cf$var$client) // To support di
        $1bde4828e2efe4cf$var$client = new (0, $fHxn4.default)({
            url: $1bde4828e2efe4cf$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $1bde4828e2efe4cf$var$client;
    }, []);
    return profileClient;
};
module.exports["useProfileClient"] = $1bde4828e2efe4cf$export$d43dc22a8337ee9f;

});

parcelRegister("5kyLi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b55ef878efda143d$var$message = (0, $aXWIB.defineMessages)({
    deactivatedCreatorName: {
        id: "rovo-chat.agent-card.deactivated-name",
        defaultMessage: "{name} (deactivated)"
    }
});
var $b55ef878efda143d$export$2e2bcd8739ae039 = $b55ef878efda143d$var$message;
module.exports["default"] = $b55ef878efda143d$export$2e2bcd8739ae039;

});

parcelRegister("5gEqE", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $2CHXX = parcelRequire("2CHXX");

const $815712ef274e8115$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isChatOnboardingMiniModalOpen: false,
    emptyChatLaunchGreeting: undefined,
    emptyChatLaunchProjectContext: undefined,
    emptyChatLaunchConversationActions: undefined,
    emptyChatLaunchReplaceProviderActions: false,
    emptyChatLaunchSkillRegistryTags: undefined,
    emptyChatLaunchId: 0,
    selectedSpace: undefined,
    activeTabId: 'suggestions',
    previousTabId: 'suggestions',
    lastTabConversationId: '',
    lastLifecycleConversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID),
    lastLifecycleLaunchId: undefined
};
const $815712ef274e8115$var$store = (0, $1P1Tu.createStore)({
    name: 'uiStore',
    initialState: $815712ef274e8115$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$815712ef274e8115$var$initialState,
                    conversationHeader: null,
                    selectedSpace: undefined
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setIsChatOnboardingMiniModalOpen: (status)=>({ setState: setState })=>{
                setState({
                    isChatOnboardingMiniModalOpen: status
                });
            },
        setConversationHeader: (header)=>({ setState: setState })=>{
                setState({
                    conversationHeader: header
                });
            },
        getIsMounted: ()=>({ getState: getState })=>{
                return getState().mounted;
            },
        setEmptyChatLaunch: (payload)=>({ setState: setState, getState: getState })=>{
                setState({
                    emptyChatLaunchGreeting: payload.customGreeting,
                    emptyChatLaunchConversationActions: payload.customConversationActions,
                    emptyChatLaunchProjectContext: payload.projectContext,
                    emptyChatLaunchReplaceProviderActions: payload.replaceProviderActions ?? false,
                    emptyChatLaunchSkillRegistryTags: payload.skillRegistryTags,
                    emptyChatLaunchId: getState().emptyChatLaunchId + 1
                });
            },
        clearEmptyChatLaunchGreeting: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        clearEmptyChatLaunchAll: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchProjectContext: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        setSelectedSpace: (space)=>({ setState: setState })=>{
                setState({
                    selectedSpace: space
                });
            },
        clearSelectedSpace: ()=>({ setState: setState })=>{
                setState({
                    selectedSpace: undefined
                });
            },
        setActiveTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    activeTabId: tabId
                });
            },
        setPreviousTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    previousTabId: tabId
                });
            },
        setLastTabConversationId: (id)=>({ setState: setState })=>{
                setState({
                    lastTabConversationId: id
                });
            },
        checkAndUpdateLifecycleGuard: (conversationId, launchId)=>({ getState: getState, setState: setState })=>{
                const { lastLifecycleConversationId: lastLifecycleConversationId, lastLifecycleLaunchId: lastLifecycleLaunchId } = getState();
                if (lastLifecycleConversationId === conversationId && lastLifecycleLaunchId === launchId) return false;
                setState({
                    lastLifecycleConversationId: conversationId,
                    lastLifecycleLaunchId: launchId
                });
                return true;
            }
    }
});
const $815712ef274e8115$var$useStore = (0, $9zUhf.createHook)($815712ef274e8115$var$store);
const $815712ef274e8115$export$13a6c73a57f1d6a6 = (0, $9zUhf.createHook)($815712ef274e8115$var$store, {
    selector: (state)=>({
            customGreeting: state.emptyChatLaunchGreeting,
            projectContext: state.emptyChatLaunchProjectContext,
            customConversationActions: state.emptyChatLaunchConversationActions,
            replaceProviderActions: state.emptyChatLaunchReplaceProviderActions,
            skillRegistryTags: state.emptyChatLaunchSkillRegistryTags,
            launchId: state.emptyChatLaunchId
        })
});
const $815712ef274e8115$export$81a40d215ef1c1de = (0, $9zUhf.createHook)($815712ef274e8115$var$store, {
    selector: (state)=>({
            activeTabId: state.activeTabId,
            previousTabId: state.previousTabId,
            lastTabConversationId: state.lastTabConversationId
        })
});
const $815712ef274e8115$export$5b2ba9b8ea3b0771 = ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId }] = $815712ef274e8115$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        conversationHeader: conversationHeader ?? null,
        selectedSpace: selectedSpace,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
        setConversationHeader: setConversationHeader,
        setSelectedSpace: setSelectedSpace,
        clearSelectedSpace: clearSelectedSpace,
        activeTabId: activeTabId,
        previousTabId: previousTabId,
        lastTabConversationId: lastTabConversationId,
        setActiveTabId: setActiveTabId,
        setPreviousTabId: setPreviousTabId,
        setLastTabConversationId: setLastTabConversationId
    };
};
const $815712ef274e8115$export$cd2fc25ddd3752d4 = (0, $9zUhf.createActionsHook)($815712ef274e8115$var$store);
module.exports["useEmptyChatLaunchSelector"] = $815712ef274e8115$export$13a6c73a57f1d6a6;
module.exports["useActiveTabSelector"] = $815712ef274e8115$export$81a40d215ef1c1de;
module.exports["useUIStore"] = $815712ef274e8115$export$5b2ba9b8ea3b0771;
module.exports["useUIStoreActions"] = $815712ef274e8115$export$cd2fc25ddd3752d4;

});

parcelRegister("jO3S6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i4C2H = parcelRequire("i4C2H");


const $5eff64246cff89b2$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("23ga2"))); /**
             * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
             */ 
const $5eff64246cff89b2$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i4C2H.default), {
        interactionName: "rovo-conversation-assistant-animated-icon",
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($5eff64246cff89b2$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        })
    });
});
module.exports["LazyAnimatedRovoIcon"] = $5eff64246cff89b2$export$7ea4e54699cd5224;

});

parcelRegister("23ga2", function(module, exports) {

let $17e865d2382724b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17e865d2382724b6$var$load("frhR0").then(()=>parcelRequire('5O8EX'));

});

parcelRegister("4iPjq", function(module, exports) {
parcelRequire("aqrhZ");
var $96msn = parcelRequire("96msn");


var $5wEPK = parcelRequire("5wEPK");


const $74848600c16eb369$var$LazyLinkPickerComponent = (0, $96msn.lazyForPaint)(()=>(parcelRequire("8ko3x")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $74848600c16eb369$var$_default_1 = (0, $5wEPK.composeLinkPicker)($74848600c16eb369$var$LazyLinkPickerComponent);
var $74848600c16eb369$export$2e2bcd8739ae039 = $74848600c16eb369$var$_default_1;
module.exports["default"] = $74848600c16eb369$export$2e2bcd8739ae039;

});

parcelRegister("5wEPK", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

parcelRequire("aqrhZ");
var $jyd5r = parcelRequire("jyd5r");


var $bYRk6 = parcelRequire("bYRk6");


var $2lNr8 = parcelRequire("2lNr8");


var $knjgj = parcelRequire("knjgj");


var $918lS = parcelRequire("918lS");


var $jrfDA = parcelRequire("jrfDA");


var $lQSkW = parcelRequire("lQSkW");

const $99bf16152ad1d840$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $99bf16152ad1d840$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $2lNr8.COMPONENT_NAME),
    source: (0, $2lNr8.COMPONENT_NAME)
};
const $99bf16152ad1d840$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot,
        children: children
    });
};
const $99bf16152ad1d840$var$fixedWidthContainerStyles = null;
const $99bf16152ad1d840$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb1ubl"
        ])
    });
};
const $99bf16152ad1d840$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $42omo.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $99bf16152ad1d840$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: $99bf16152ad1d840$export$a2495bb1f182689d,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $knjgj.LinkPickerSessionProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lQSkW.MessagesProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            `${0, $2lNr8.LINK_PICKER_WIDTH_IN_PX}px`,
                            ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)($99bf16152ad1d840$var$FixedWidthContainer, {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $918lS.ErrorBoundary), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jyd5r.LazySuspense), {
                                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $jrfDA.LoaderFallback), {
                                        url: props.url,
                                        hideDisplayText: props.hideDisplayText,
                                        isLoadingPlugins: props.isLoadingPlugins,
                                        plugins: props.plugins
                                    }),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)(RootComponent, {
                                        ...props,
                                        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                            ...props
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        });
    });
};
module.exports["composeLinkPicker"] = $99bf16152ad1d840$export$922eb685ceb4a294;

});

parcelRegister("2lNr8", function(module, exports) {
const $7282d690d6f118fb$export$85183a312807388d = 'media';
const $7282d690d6f118fb$export$fc44104665f4d1e5 = 'linkPicker';
const $7282d690d6f118fb$export$452f1062ecf44be7 = 5;
const $7282d690d6f118fb$export$bf31a09f182d5584 = 342;
const $7282d690d6f118fb$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $7282d690d6f118fb$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $7282d690d6f118fb$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $7282d690d6f118fb$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $7282d690d6f118fb$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $7282d690d6f118fb$export$542fb16962bf430c;

});

parcelRegister("knjgj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $hzd6s = parcelRequire("hzd6s");

const $56c0565d5892d700$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $56c0565d5892d700$export$3285420c698bc605 = /*#__PURE__*/ (0, $42omo.createContext)($56c0565d5892d700$export$c07727f5eddb98f);
const $56c0565d5892d700$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $42omo.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $56c0565d5892d700$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $42omo.useRef)((0, $dQl1W.v4)());
    (0, $42omo.useEffect)(()=>{
        return ()=>(0, $hzd6s.abortUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    $56c0565d5892d700$var$useConstructor(()=>(0, $hzd6s.startUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId));
    return /*#__PURE__*/ (0, $l998X.jsx)($56c0565d5892d700$export$3285420c698bc605.Provider, {
        value: sessionId,
        children: children
    });
};
const $56c0565d5892d700$export$36ecc935abdc3636 = ()=>(0, $42omo.useContext)($56c0565d5892d700$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $56c0565d5892d700$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $56c0565d5892d700$export$36ecc935abdc3636;

});

parcelRegister("hzd6s", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $f665373313765471$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $f665373313765471$var$ufoExperiences = {
    [$f665373313765471$export$f9c7780c574346a2.mounted]: new (0, $9801n.ConcurrentExperience)($f665373313765471$export$f9c7780c574346a2.mounted, {
        type: (0, $iqaft.ExperienceTypes).Load,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $f665373313765471$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $f665373313765471$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $f665373313765471$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $f665373313765471$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $f665373313765471$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $f665373313765471$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $f665373313765471$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $f665373313765471$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $f665373313765471$export$b1021040eb94cdca;

});

parcelRegister("918lS", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hzd6s = parcelRequire("hzd6s");


var $2lNr8 = parcelRequire("2lNr8");


var $abGcM = parcelRequire("abGcM");


var $knjgj = parcelRequire("knjgj");


var $khavy = parcelRequire("khavy");


var $3blls = parcelRequire("3blls");

function $4548d496336bec74$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $knjgj.useLinkPickerSessionId)();
    const handleError = (0, $42omo.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $abGcM.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $2lNr8.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $hzd6s.failUfoExperience)((0, $hzd6s.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $khavy.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $3blls.ErrorBoundaryFallback),
        children: children
    });
}
module.exports["ErrorBoundary"] = $4548d496336bec74$export$e926676385687eaf;

});

parcelRegister("abGcM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::590b9da528f0d0b88cea1feaa1815283>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $1d2d80882026b768$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $1d2d80882026b768$export$2e2bcd8739ae039 = $1d2d80882026b768$var$createEventPayload;
module.exports["default"] = $1d2d80882026b768$export$2e2bcd8739ae039;

});

parcelRegister("khavy", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

class $096b317da4a8d9ff$export$688779ac61ee945f extends (0, $42omo.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, $l998X.jsx)(ErrorComponent, {});
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $096b317da4a8d9ff$export$688779ac61ee945f;

});

parcelRegister("3blls", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $2lNr8 = parcelRequire("2lNr8");


var $c2ARh = parcelRequire("c2ARh");


var $atwsN = parcelRequire("atwsN");


var $lO9iE = parcelRequire("lO9iE");

const $6fbfcea2b9f5c943$var$errorBoundaryFallbackStyles = null;
const $6fbfcea2b9f5c943$var$messages = (0, $aXWIB.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $6fbfcea2b9f5c943$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const header = intl.formatMessage($6fbfcea2b9f5c943$var$messages.heading);
    const description = intl.formatMessage($6fbfcea2b9f5c943$var$messages.description);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lO9iE.MinHeightContainer), {
        minHeight: (0, $2lNr8.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $gMc0m.default)([
            "_11c8i4vh"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $atwsN.EmptyState), {
            header: header,
            renderImage: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $c2ARh.GenericErrorSVG), {}),
            description: description
        })
    });
};
module.exports["ErrorBoundaryFallback"] = $6fbfcea2b9f5c943$export$8a28b7e38e4685dd;

});

parcelRegister("c2ARh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2890d1e9307e8ae4$var$SIZE = 96;
const $2890d1e9307e8ae4$var$genericErrorStyles = null;
const $2890d1e9307e8ae4$export$e54420a1a27457a4 = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#fff",
                d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#B7B9BE",
                d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
                clipRule: "evenodd"
            })
        ]
    });
};
module.exports["GenericErrorSVG"] = $2890d1e9307e8ae4$export$e54420a1a27457a4;

});

parcelRegister("atwsN", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");

const $e8c7333955d8c82e$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $e8c7333955d8c82e$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: $e8c7333955d8c82e$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "small",
                as: "h2",
                children: header
            }),
            description && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                as: "p",
                color: "color.text",
                children: description
            }),
            action && action
        ]
    });
};
module.exports["EmptyState"] = $e8c7333955d8c82e$export$fddf379e22a74b00;

});

parcelRegister("lO9iE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $562443300071d672$var$minHeightComponentStyles = null;
const $562443300071d672$export$42134e2a251518b3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $562443300071d672$export$42134e2a251518b3;

});

parcelRegister("jrfDA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $lO9iE = parcelRequire("lO9iE");

const $c92e1a3420d5d33f$var$styles = null;
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $c92e1a3420d5d33f$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $c92e1a3420d5d33f$export$d96e921133238c41 = (props)=>{
    const minHeight = $c92e1a3420d5d33f$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lO9iE.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $gMc0m.default)([
            "_4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: props.name || 'link-picker-loading',
            size: "medium"
        })
    });
};
module.exports["LoaderFallback"] = $c92e1a3420d5d33f$export$d96e921133238c41;

});

parcelRegister("lQSkW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ab7LA = parcelRequire("ab7LA");

const $6958f3d9e68e6f8d$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ab7LA.LazyMessagesProvider), {
        children: children
    });
};
module.exports["MessagesProvider"] = $6958f3d9e68e6f8d$export$54320b51a950d54a;

});

parcelRegister("ab7LA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $iaMDd = parcelRequire("iaMDd");


var $3lHRF = parcelRequire("3lHRF");

const $42f9fe6b4d8a0292$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $iaMDd.default),
        loaderFn: (0, $3lHRF.fetchMessagesForLocale),
        children: children
    });
};
module.exports["LazyMessagesProvider"] = $42f9fe6b4d8a0292$export$d013d33430f9fb4b;

});

parcelRegister("3lHRF", function(module, exports) {

var $aWYpi = parcelRequire("aWYpi");

const $b1e230aff09883c2$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $b1e230aff09883c2$export$2b153a2030b0feb2;

});

parcelRegister("aWYpi", function(module, exports) {

























const $c4ed7fdc8607c9f9$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("49ni4")),
    da: ()=>(parcelRequire("9i24I")),
    de: ()=>(parcelRequire("3GGRL")),
    en_GB: ()=>(parcelRequire("f9H50")),
    en_ZZ: ()=>(parcelRequire("ecHgQ")),
    en: ()=>Promise.resolve((parcelRequire("iaMDd"))),
    es: ()=>(parcelRequire("b9n7m")),
    fi: ()=>(parcelRequire("9Ymrs")),
    fr: ()=>(parcelRequire("c09we")),
    hu: ()=>(parcelRequire("eWHOv")),
    it: ()=>(parcelRequire("joBHN")),
    ja: ()=>(parcelRequire("EDSZV")),
    ko: ()=>(parcelRequire("f5q2I")),
    nb: ()=>(parcelRequire("rJqkb")),
    nl: ()=>(parcelRequire("58PdT")),
    pl: ()=>(parcelRequire("enArn")),
    pt_BR: ()=>(parcelRequire("5XYTp")),
    ru: ()=>(parcelRequire("k3D4M")),
    sv: ()=>(parcelRequire("819Nj")),
    th: ()=>(parcelRequire("khF3L")),
    tr: ()=>(parcelRequire("3Shvv")),
    uk: ()=>(parcelRequire("7MpfQ")),
    vi: ()=>(parcelRequire("bbM1s")),
    zh_TW: ()=>(parcelRequire("hE3F1")),
    zh: ()=>(parcelRequire("dpRbE"))
};
module.exports["locales"] = $c4ed7fdc8607c9f9$export$df1c34db1371eeed;

});

parcelRegister("49ni4", function(module, exports) {

let $305a11b60fea096a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $305a11b60fea096a$var$load("4Mixi"),
    $305a11b60fea096a$var$load("1jsQH"),
    $305a11b60fea096a$var$load("i5eMd"),
    $305a11b60fea096a$var$load("bv8GZ"),
    $305a11b60fea096a$var$load("i9sd0"),
    $305a11b60fea096a$var$load("4DYJ5"),
    $305a11b60fea096a$var$load("gyXEE"),
    $305a11b60fea096a$var$load("hoPZ9")
]).then(()=>parcelRequire('k82rV'));

});

parcelRegister("9i24I", function(module, exports) {

let $6c376795d61b5f16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c376795d61b5f16$var$load("cjveN"),
    $6c376795d61b5f16$var$load("deyvi"),
    $6c376795d61b5f16$var$load("4UPfH"),
    $6c376795d61b5f16$var$load("cdeuH"),
    $6c376795d61b5f16$var$load("aNg21"),
    $6c376795d61b5f16$var$load("hfFxJ"),
    $6c376795d61b5f16$var$load("1Mp9N"),
    $6c376795d61b5f16$var$load("2Fu3d")
]).then(()=>parcelRequire('5CXR9'));

});

parcelRegister("3GGRL", function(module, exports) {

let $2af68baa2ba0afdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2af68baa2ba0afdb$var$load("8XGJb"),
    $2af68baa2ba0afdb$var$load("6dERU"),
    $2af68baa2ba0afdb$var$load("gd4qs"),
    $2af68baa2ba0afdb$var$load("7gF8f"),
    $2af68baa2ba0afdb$var$load("YEGhv"),
    $2af68baa2ba0afdb$var$load("gofGr"),
    $2af68baa2ba0afdb$var$load("dBb6q"),
    $2af68baa2ba0afdb$var$load("eJgH8")
]).then(()=>parcelRequire('28QMN'));

});

parcelRegister("f9H50", function(module, exports) {

let $b0891d001c3b0f5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0891d001c3b0f5d$var$load("hdvZr"),
    $b0891d001c3b0f5d$var$load("kTurq"),
    $b0891d001c3b0f5d$var$load("fviv5"),
    $b0891d001c3b0f5d$var$load("djb49"),
    $b0891d001c3b0f5d$var$load("d8WL7"),
    $b0891d001c3b0f5d$var$load("2RQvP"),
    $b0891d001c3b0f5d$var$load("7Lkvk")
]).then(()=>parcelRequire('b4NXj'));

});

parcelRegister("ecHgQ", function(module, exports) {

let $a573c0545bc835b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a573c0545bc835b1$var$load("4ViGN"),
    $a573c0545bc835b1$var$load("j0PWv"),
    $a573c0545bc835b1$var$load("eBoC7"),
    $a573c0545bc835b1$var$load("ksTQ6"),
    $a573c0545bc835b1$var$load("j5F5K"),
    $a573c0545bc835b1$var$load("7NpX8"),
    $a573c0545bc835b1$var$load("cukQS"),
    $a573c0545bc835b1$var$load("5FaEJ")
]).then(()=>parcelRequire('5SuH4'));

});

parcelRegister("b9n7m", function(module, exports) {

let $81e277acab2bd080$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81e277acab2bd080$var$load("32vlK"),
    $81e277acab2bd080$var$load("dlmud"),
    $81e277acab2bd080$var$load("bNv64"),
    $81e277acab2bd080$var$load("5CGnz"),
    $81e277acab2bd080$var$load("dXu4x"),
    $81e277acab2bd080$var$load("bFU3Y"),
    $81e277acab2bd080$var$load("3CucM"),
    $81e277acab2bd080$var$load("9yemY")
]).then(()=>parcelRequire('7TuuZ'));

});

parcelRegister("9Ymrs", function(module, exports) {

let $742b201de0044ee5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $742b201de0044ee5$var$load("bjoGV"),
    $742b201de0044ee5$var$load("cbkj0"),
    $742b201de0044ee5$var$load("4Afgd"),
    $742b201de0044ee5$var$load("9Oxgj"),
    $742b201de0044ee5$var$load("18TX5"),
    $742b201de0044ee5$var$load("exaJ2"),
    $742b201de0044ee5$var$load("lp8Wm"),
    $742b201de0044ee5$var$load("l2LZP")
]).then(()=>parcelRequire('ezgWl'));

});

parcelRegister("c09we", function(module, exports) {

let $8bccde637f75ef88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8bccde637f75ef88$var$load("8oiz7"),
    $8bccde637f75ef88$var$load("17m16"),
    $8bccde637f75ef88$var$load("cMubu"),
    $8bccde637f75ef88$var$load("kAg8V"),
    $8bccde637f75ef88$var$load("9Cdzw"),
    $8bccde637f75ef88$var$load("hcCcg"),
    $8bccde637f75ef88$var$load("cHWSM"),
    $8bccde637f75ef88$var$load("35Ssm")
]).then(()=>parcelRequire('gYv97'));

});

parcelRegister("eWHOv", function(module, exports) {

let $ae1877f695269b3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae1877f695269b3f$var$load("hFxmj"),
    $ae1877f695269b3f$var$load("b4NO6"),
    $ae1877f695269b3f$var$load("3fLE9"),
    $ae1877f695269b3f$var$load("fM2oh"),
    $ae1877f695269b3f$var$load("guNAg"),
    $ae1877f695269b3f$var$load("j9KTb"),
    $ae1877f695269b3f$var$load("b37xN"),
    $ae1877f695269b3f$var$load("ik6u5")
]).then(()=>parcelRequire('bVNwo'));

});

parcelRegister("joBHN", function(module, exports) {

let $e1ed81b248c56b08$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e1ed81b248c56b08$var$load("BXOZB"),
    $e1ed81b248c56b08$var$load("1K1Fj"),
    $e1ed81b248c56b08$var$load("8hOn0"),
    $e1ed81b248c56b08$var$load("xnqy2"),
    $e1ed81b248c56b08$var$load("cM3gY"),
    $e1ed81b248c56b08$var$load("3hjAq"),
    $e1ed81b248c56b08$var$load("7PjNK"),
    $e1ed81b248c56b08$var$load("Vt6S9")
]).then(()=>parcelRequire('lxZVf'));

});

parcelRegister("EDSZV", function(module, exports) {

let $07a2ad1527c69f6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $07a2ad1527c69f6b$var$load("9Xiuh"),
    $07a2ad1527c69f6b$var$load("38sfA"),
    $07a2ad1527c69f6b$var$load("h4OCL"),
    $07a2ad1527c69f6b$var$load("awkVi"),
    $07a2ad1527c69f6b$var$load("6yRq3"),
    $07a2ad1527c69f6b$var$load("2bCHJ"),
    $07a2ad1527c69f6b$var$load("ktSfi"),
    $07a2ad1527c69f6b$var$load("9GZ76")
]).then(()=>parcelRequire('hflsJ'));

});

parcelRegister("f5q2I", function(module, exports) {

let $afbb862f455b1607$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $afbb862f455b1607$var$load("7Odo3"),
    $afbb862f455b1607$var$load("bjmre"),
    $afbb862f455b1607$var$load("bcQs2"),
    $afbb862f455b1607$var$load("11DLa"),
    $afbb862f455b1607$var$load("cft22"),
    $afbb862f455b1607$var$load("fdXnq"),
    $afbb862f455b1607$var$load("iouLY"),
    $afbb862f455b1607$var$load("4sOIV")
]).then(()=>parcelRequire('73LWR'));

});

parcelRegister("rJqkb", function(module, exports) {

let $0535c1e8d4cff100$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0535c1e8d4cff100$var$load("4VkvT"),
    $0535c1e8d4cff100$var$load("asvK9"),
    $0535c1e8d4cff100$var$load("aBa7j"),
    $0535c1e8d4cff100$var$load("barSq"),
    $0535c1e8d4cff100$var$load("gctEz"),
    $0535c1e8d4cff100$var$load("cItJR"),
    $0535c1e8d4cff100$var$load("hPZE5"),
    $0535c1e8d4cff100$var$load("QTjdE")
]).then(()=>parcelRequire('h0YR4'));

});

parcelRegister("58PdT", function(module, exports) {

let $3be56eed8368bce0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3be56eed8368bce0$var$load("g5qJV"),
    $3be56eed8368bce0$var$load("7v6wU"),
    $3be56eed8368bce0$var$load("b544F"),
    $3be56eed8368bce0$var$load("a8heY"),
    $3be56eed8368bce0$var$load("9PPH7"),
    $3be56eed8368bce0$var$load("SctKm"),
    $3be56eed8368bce0$var$load("dzIm8"),
    $3be56eed8368bce0$var$load("hrf1M")
]).then(()=>parcelRequire('573SD'));

});

parcelRegister("enArn", function(module, exports) {

let $a77f7b0327a81145$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a77f7b0327a81145$var$load("dPa6p"),
    $a77f7b0327a81145$var$load("aEpRh"),
    $a77f7b0327a81145$var$load("K6fhx"),
    $a77f7b0327a81145$var$load("6hlNE"),
    $a77f7b0327a81145$var$load("1y1eN"),
    $a77f7b0327a81145$var$load("1fJz1"),
    $a77f7b0327a81145$var$load("jqwnR"),
    $a77f7b0327a81145$var$load("lsloj")
]).then(()=>parcelRequire('8sMYh'));

});

parcelRegister("5XYTp", function(module, exports) {

let $4581b27058c75bd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4581b27058c75bd4$var$load("iG4uh"),
    $4581b27058c75bd4$var$load("3fuR9"),
    $4581b27058c75bd4$var$load("gZU54"),
    $4581b27058c75bd4$var$load("2bqSD"),
    $4581b27058c75bd4$var$load("e8jpx"),
    $4581b27058c75bd4$var$load("9yA8o"),
    $4581b27058c75bd4$var$load("bGhLc"),
    $4581b27058c75bd4$var$load("iRKhU")
]).then(()=>parcelRequire('lRfBG'));

});

parcelRegister("k3D4M", function(module, exports) {

let $e9a266292735eae2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e9a266292735eae2$var$load("9tVE8"),
    $e9a266292735eae2$var$load("fMrUo"),
    $e9a266292735eae2$var$load("4Wdqb"),
    $e9a266292735eae2$var$load("bJykp"),
    $e9a266292735eae2$var$load("fjbzp"),
    $e9a266292735eae2$var$load("448N7"),
    $e9a266292735eae2$var$load("9v6ER"),
    $e9a266292735eae2$var$load("aEAsN")
]).then(()=>parcelRequire('hZouV'));

});

parcelRegister("819Nj", function(module, exports) {

let $5d6603af87dbf1fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5d6603af87dbf1fc$var$load("6UAlo"),
    $5d6603af87dbf1fc$var$load("9eNkX"),
    $5d6603af87dbf1fc$var$load("k10Cs"),
    $5d6603af87dbf1fc$var$load("dh2Er"),
    $5d6603af87dbf1fc$var$load("1pFHs"),
    $5d6603af87dbf1fc$var$load("gBDdh"),
    $5d6603af87dbf1fc$var$load("8Mz40"),
    $5d6603af87dbf1fc$var$load("l6YHr")
]).then(()=>parcelRequire('4LH4L'));

});

parcelRegister("khF3L", function(module, exports) {

let $ec453ec2806faba2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec453ec2806faba2$var$load("jYGxH").then(()=>parcelRequire('hlxQj'));

});

parcelRegister("3Shvv", function(module, exports) {

let $2d23fecbe4644720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d23fecbe4644720$var$load("czAFw").then(()=>parcelRequire('gQkbc'));

});

parcelRegister("7MpfQ", function(module, exports) {

let $5aa09b1e53b19903$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5aa09b1e53b19903$var$load("c0Efy").then(()=>parcelRequire('lC9hp'));

});

parcelRegister("bbM1s", function(module, exports) {

let $8255f915989d7a01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8255f915989d7a01$var$load("dKBuH").then(()=>parcelRequire('fzD7h'));

});

parcelRegister("hE3F1", function(module, exports) {

let $cd890306c10c6d8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd890306c10c6d8a$var$load("ia9y3"),
    $cd890306c10c6d8a$var$load("j9OUx"),
    $cd890306c10c6d8a$var$load("l079e"),
    $cd890306c10c6d8a$var$load("bV8sS"),
    $cd890306c10c6d8a$var$load("kKXTS"),
    $cd890306c10c6d8a$var$load("ebljE"),
    $cd890306c10c6d8a$var$load("hF4v3"),
    $cd890306c10c6d8a$var$load("afU9w")
]).then(()=>parcelRequire('6PXdj'));

});

parcelRegister("dpRbE", function(module, exports) {

let $9c46ddff53e4b24d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9c46ddff53e4b24d$var$load("15ncj"),
    $9c46ddff53e4b24d$var$load("gDiIK"),
    $9c46ddff53e4b24d$var$load("f1B4n"),
    $9c46ddff53e4b24d$var$load("eLlpV"),
    $9c46ddff53e4b24d$var$load("7sItg"),
    $9c46ddff53e4b24d$var$load("j4dSZ"),
    $9c46ddff53e4b24d$var$load("1Tuyb"),
    $9c46ddff53e4b24d$var$load("7iCpI")
]).then(()=>parcelRequire('5WXmf'));

});

parcelRegister("8ko3x", function(module, exports) {

let $6102da0515d5d87e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6102da0515d5d87e$var$load("cONk3"),
    $6102da0515d5d87e$var$load("ltDLY"),
    $6102da0515d5d87e$var$load("6wr18"),
    $6102da0515d5d87e$var$load("3BqWF"),
    $6102da0515d5d87e$var$load("lGnwl"),
    $6102da0515d5d87e$var$load("7EorR"),
    $6102da0515d5d87e$var$load("ffEVr"),
    $6102da0515d5d87e$var$load("Wowvf"),
    $6102da0515d5d87e$var$load("hhss7"),
    $6102da0515d5d87e$var$load("c0JsV")
]).then(()=>parcelRequire('cDSVd'));

});

parcelRegister("io1wY", function(module, exports) {
$parcel$export(module.exports, "default", () => $d62ba7e132800466$export$2e2bcd8739ae039);

var $4Ldep = parcelRequire("4Ldep");


var $ksiqf = parcelRequire("ksiqf");


var $b5utg = parcelRequire("b5utg");

function $d62ba7e132800466$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $4Ldep.default)(dirtyDate, (0, $ksiqf.default)(Date.now(), 1));
}

});

parcelRegister("l7fKC", function(module, exports) {
/* Toolbar.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $8hoW2 = parcelRequire("8hoW2");


var $9jB2n = parcelRequire("9jB2n");


var $12Oyv = parcelRequire("12Oyv");


var $j0UQK = parcelRequire("j0UQK");

const $a3c14e992c9fdb13$var$styles = {
    toolbarBase: "_2rko1qi0 _zulp1b66 _1e0c1txw _4cvr1h6o",
    toolbar: "_bfhk1bhr _4t3i14no _u5f31b66 _19bv1b66 _16qs130s",
    toolbarResponsive: "_195gpxbi",
    primaryToolbar: "_bfhkvuon _1tkezwfg",
    toolbarSeparator: "_1mj714no",
    hiddenSelectors: "_fy9oglyw _18shglyw _ze7rglyw",
    hiddenSelectorsPatch: "_z5m7glyw"
};
const $a3c14e992c9fdb13$export$4c260019440d418f = ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const toolbar = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.toolbar, $a3c14e992c9fdb13$var$styles.toolbarResponsive, $a3c14e992c9fdb13$var$styles.hiddenSelectors, $a3c14e992c9fdb13$var$styles.toolbarSeparator, $a3c14e992c9fdb13$var$styles.hiddenSelectorsPatch),
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": "inline",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $j0UQK.ViewEventEmitter), {
                actionSubject: (0, $j0UQK.ACTION_SUBJECT).TOOLBAR,
                actionSubjectId: actionSubjectId
            }),
            children
        ]
    });
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $8hoW2.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, $l998X.jsx)((0, $12Oyv.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel,
            children: toolbar
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveWrapper), {
        children: wrappedToolbar
    });
};
const $a3c14e992c9fdb13$export$7469f9986edfc2 = ({ children: children, label: label, breakpointPreset: breakpointPreset })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9jB2n.ResponsiveContainer), {
        breakpointPreset: breakpointPreset,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($a3c14e992c9fdb13$var$styles.toolbarBase, $a3c14e992c9fdb13$var$styles.primaryToolbar, $a3c14e992c9fdb13$var$styles.hiddenSelectors),
            "aria-label": label,
            "data-toolbar-type": "primary",
            children: children
        })
    });
};
module.exports["Toolbar"] = $a3c14e992c9fdb13$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $a3c14e992c9fdb13$export$7469f9986edfc2;

});

parcelRegister("9jB2n", function(module, exports) {
/* ResponsiveContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-container-queries */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $1oCLl = parcelRequire("1oCLl");

const $bc8e1bf6110fb52a$var$styles = {
    responsiveContainer: "_1bsb1osq _7cca15wb _1f38ptqj _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    responsiveContainerFullPage: "_1bsb1ns9 _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    fullpage: "_luoiglyw _2ojp1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _syrzglyw _fr6v1ule _1je21ule _1btx1ule _biad1ule _1ana1ule",
    reduced: "_kkyiglyw _1dj81ule _1cg81ule _j3qgglyw _xh1i1ule _oj3l1ule _13s9glyw _4nul1ule _wt211ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssue: "_152xglyw _1cn41ule _4cj71ule _afriglyw _ozjb1ule _w81r1ule _1mckglyw _r2nv1ule _1ym01ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssueUpdated: "_152xglyw _1cn41ule _1j4d1ule _1n52glyw _1nd71ule _lf431ule _103bglyw _1p0z1ule _g5yu1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmComment: "_s2iiglyw _o4331ule _1jvu1ule _lankglyw _1xpy1ule _1vu31ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmCommentUpdated: "_s2iiglyw _o4331ule _1u301ule _u7j1glyw _c7al1ule _14ob1ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    confluenceComment: "_15nrglyw _cm5a1ule _7qjy1ule _13ioglyw _8urt1ule _cpaf1ule _18zmglyw _1uj01ule _1oqh1ule _tzm6glyw _ktne1ule _87bn1ule",
    responsiveRulesWrapper: "_1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _33p2glyw _1dre1ule _u47mglyw _rut51ule _fj5dglyw _5wt61ule _hmx4glyw _1rrm1ule _ut18glyw _1nwo1ule _19fzglyw _1r831ule"
};
const $bc8e1bf6110fb52a$var$presetStyleMap = {
    fullpage: $bc8e1bf6110fb52a$var$styles.fullpage,
    reduced: $bc8e1bf6110fb52a$var$styles.reduced,
    'jira-issue': $bc8e1bf6110fb52a$var$styles.jiraIssue,
    'jsm-comment': $bc8e1bf6110fb52a$var$styles.jsmComment,
    'confluence-comment': $bc8e1bf6110fb52a$var$styles.confluenceComment
};
const $bc8e1bf6110fb52a$var$updatedPresetStyleMap = {
    'jira-issue': $bc8e1bf6110fb52a$var$styles.jiraIssueUpdated,
    'jsm-comment': $bc8e1bf6110fb52a$var$styles.jsmCommentUpdated
};
const $bc8e1bf6110fb52a$export$e60a4704009a0009 = ({ children: children, breakpointPreset: breakpointPreset })=>{
    const isUpdatedConfig = (0, $1oCLl.expValEquals)('platform_editor_toolbar_update_jira_config', 'isEnabled', true) && breakpointPreset in $bc8e1bf6110fb52a$var$updatedPresetStyleMap;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(breakpointPreset === 'fullpage' ? $bc8e1bf6110fb52a$var$styles.responsiveContainerFullPage : $bc8e1bf6110fb52a$var$styles.responsiveContainer, isUpdatedConfig ? $bc8e1bf6110fb52a$var$updatedPresetStyleMap[breakpointPreset] : $bc8e1bf6110fb52a$var$presetStyleMap[breakpointPreset]),
        children: children
    });
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $bc8e1bf6110fb52a$export$fa6e408d6a7d6214 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $bc8e1bf6110fb52a$var$styles.responsiveRulesWrapper,
        children: children
    });
};
module.exports["ResponsiveContainer"] = $bc8e1bf6110fb52a$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $bc8e1bf6110fb52a$export$fa6e408d6a7d6214;

});

parcelRegister("12Oyv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");

const $b79e6ddf5e0c34a1$export$881345eb2554ea9e = ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            const currentIndex = focusableElements.findIndex((el)=>el === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $hTKp4.getDocument)();
            let index = doc?.activeElement ? focusableElements.findIndex((el)=>el === doc?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements.forEach((el)=>el.setAttribute('tabindex', '-1'));
            focusableElements[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event)) handleFocus(event);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        children: children
    });
};
module.exports["ToolbarKeyboardNavigationProvider"] = $b79e6ddf5e0c34a1$export$881345eb2554ea9e;

});

parcelRegister("j0UQK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8hoW2 = parcelRequire("8hoW2");

const $e7817ef9ea32a2ec$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $e7817ef9ea32a2ec$export$58d0f383acf77599 = ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $42omo.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $8hoW2.useToolbarUI)();
    (0, $42omo.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $e7817ef9ea32a2ec$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $e7817ef9ea32a2ec$export$58d0f383acf77599;

});

parcelRegister("2gkmX", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $5vVM5 = parcelRequire("5vVM5");


var $7fmpI = parcelRequire("7fmpI");


var $led7c = parcelRequire("led7c");


var $lWghV = parcelRequire("lWghV");


var $gSnMl = parcelRequire("gSnMl");


var $bT1qC = parcelRequire("bT1qC");

class $1697754dbd6854fe$export$2e2bcd8739ae039 {
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init(shouldSkipInitRender = false) {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        if (!shouldSkipInitRender) this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fmpI.ErrorBoundary), {
                component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent
            }, component());
        this.portalProviderAPI.render(componentWithErrorBoundary, // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Only return reference if domRef is defined
        if (this.domRef === undefined) //raise an error
        throw new Error('domRef is not defined or may have been destroyed');
        // Spreading props to pass through dynamic component props
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $1697754dbd6854fe$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
    constructor(_node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        this.domRef = void 0;
        this.contentDOMWrapper = void 0;
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.reactComponent = void 0;
        this.portalProviderAPI = void 0;
        this._viewShouldUpdate = void 0;
        this.eventDispatcher = void 0;
        this.decorations = [];
        this.reactComponentProps = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.key = void 0;
        this.shouldRenderImmediatelyInPortal = void 0;
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = _node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $gSnMl.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
}
module.exports["default"] = $1697754dbd6854fe$export$2e2bcd8739ae039;

});

parcelRegister("gSnMl", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");

const $98e7d56f800fed91$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
};
module.exports["generateUniqueNodeKey"] = $98e7d56f800fed91$export$4a323a0542a1e4d1;

});

parcelRegister("bT1qC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5SAOw = parcelRequire("5SAOw");


var $dh538 = parcelRequire("dh538");


var $d925B = parcelRequire("d925B");


var $eTj7Y = parcelRequire("eTj7Y");


var $7fmpI = parcelRequire("7fmpI");


var $lWghV = parcelRequire("lWghV");

var $led7c = parcelRequire("led7c");


var $d7ZU3 = parcelRequire("d7ZU3");


var $TfRUG = parcelRequire("TfRUG");


var $gSnMl = parcelRequire("gSnMl");


var $iEqmY = parcelRequire("iEqmY");

const $8cc71206023006a6$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $8cc71206023006a6$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $8cc71206023006a6$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $8cc71206023006a6$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $led7c.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $led7c.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $led7c.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $8cc71206023006a6$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $gSnMl.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $8cc71206023006a6$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$8cc71206023006a6$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($8cc71206023006a6$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$8cc71206023006a6$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $5SAOw.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $iEqmY.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $8cc71206023006a6$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $8cc71206023006a6$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $8cc71206023006a6$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7fmpI.ErrorBoundary), {
            component: (0, $d925B.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $d925B.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)), /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $d7ZU3.getBrowserInfo)().android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $TfRUG.ZERO_WIDTH_SPACE)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            className: `${$8cc71206023006a6$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $8cc71206023006a6$var$counterPerEditorViewMap = new WeakMap();
function $8cc71206023006a6$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $8cc71206023006a6$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || (0, $eTj7Y.isSSR)()) return $8cc71206023006a6$var$createNodeView(parameters);
        if ((0, $dh538.fg)('platform_editor_inline_node_virt_threshold_override')) return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $8cc71206023006a6$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $8cc71206023006a6$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $8cc71206023006a6$var$createNodeView(parameters);
        return $8cc71206023006a6$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}
module.exports["getInlineNodeViewProducer"] = $8cc71206023006a6$export$17a8c3162956317d;

});

parcelRegister("iEqmY", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $5d9b4 = parcelRequire("5d9b4");

// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $af3e0b19ba2c5452$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$af3e0b19ba2c5452$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});
module.exports["getOrCreateOnVisibleObserver"] = $af3e0b19ba2c5452$export$d73c873f0a6a03c3;

});

parcelRegister("l8mxb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57e36493b019d12297a87aa4bfc67ec1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f62bd32daa0e4ca4$var$_react = $f62bd32daa0e4ca4$var$_interopRequireDefault((parcelRequire("42omo")));

var $f62bd32daa0e4ca4$var$_baseNew = $f62bd32daa0e4ca4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f62bd32daa0e4ca4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f62bd32daa0e4ca4$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $f62bd32daa0e4ca4$var$_react.default.createElement($f62bd32daa0e4ca4$var$_baseNew.default, Object.assign({
        name: "PersonAddedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 12.75A3.75 3.75 0 0 1 4.75 9H9v1.5H4.75a2.25 2.25 0 0 0-2.25 2.25V15H1zM9.5 4a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M11 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0m4.95 6.99-3.83 4.5a.75.75 0 0 1-1.14 0l-1.92-2.25 1.14-.97 1.35 1.58 3.26-3.83z"/>`
    }, props));
$f62bd32daa0e4ca4$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $f62bd32daa0e4ca4$var$_default = module.exports.default = $f62bd32daa0e4ca4$var$PersonAddedIcon;

});

parcelRegister("i08Mr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $e459ef83dafb04f4$var$initialState = {
    fullScreen: false,
    externalEmbed: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    customFeedbackCategories: undefined,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    disableSettingsModal: false,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true
    }
};
const $e459ef83dafb04f4$export$ab340e857ee89c62 = $e459ef83dafb04f4$var$initialState;
const $e459ef83dafb04f4$var$uiConfig = /*#__PURE__*/ (0, $42omo.createContext)($e459ef83dafb04f4$var$initialState);
const $e459ef83dafb04f4$export$3063519296e335bf = $e459ef83dafb04f4$var$uiConfig.Provider;
const $e459ef83dafb04f4$export$e83755c3ab7a4493 = ()=>(0, $42omo.useContext)($e459ef83dafb04f4$var$uiConfig);
const $e459ef83dafb04f4$export$3e623b13d2da727a = (config)=>{
    // Allow fullscreen override for branch deploy testing purposes
    const processedConfig = localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $dh538.fg)('rovo_chat_show_local_frontend_components') ? {
        ...config,
        fullScreen: true
    } : config;
    return {
        ...{
            ...$e459ef83dafb04f4$var$initialState,
            ...processedConfig,
            enableBrowserContextBanner: processedConfig?.enableBrowserContextBanner ?? $e459ef83dafb04f4$var$initialState.enableBrowserContextBanner,
            disableSettingsModal: processedConfig?.disableSettingsModal ?? $e459ef83dafb04f4$var$initialState.disableSettingsModal,
            browserContextSanitizer: processedConfig?.browserContextSanitizer,
            elements: {
                ...$e459ef83dafb04f4$var$initialState.elements,
                ...processedConfig?.elements
            },
            promptInputDroppableUrls: processedConfig?.promptInputDroppableUrls
        }
    };
};
module.exports["UIConfigProvider"] = $e459ef83dafb04f4$export$3063519296e335bf;
module.exports["useUIConfig"] = $e459ef83dafb04f4$export$e83755c3ab7a4493;
module.exports["createUIConfig"] = $e459ef83dafb04f4$export$3e623b13d2da727a;

});

parcelRegister("g6sXu", function(module, exports) {
$parcel$export(module.exports, "default", () => $6724333aa005e095$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

const $6724333aa005e095$export$6a802fb2263552f1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(()=>{});
function $6724333aa005e095$export$2e2bcd8739ae039(Component) {
    return class WithOutsideClick extends (0, $42omo.PureComponent) {
        componentDidMount() {
            if (this.props.handleClickOutside) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('keydown', this.handleKeydown, false);
        }
        componentWillUnmount() {
            if (this.props.handleClickOutside) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', this.handleKeydown, false);
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6724333aa005e095$export$6a802fb2263552f1.Provider, {
                value: this.setOutsideClickTargetRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, this.props));
        }
        constructor(...args){
            super(...args);
            this.outsideClickTargetRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
            this.handleClick = (evt)=>{
                const domNode = this.outsideClickTargetRef.current?.deref();
                if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) this.props.handleClickOutside?.(evt);
            };
            this.handleKeydown = (evt)=>{
                if (evt.code === 'Escape' && this.props.handleEscapeKeydown) this.props.handleEscapeKeydown(evt);
            };
            this.setOutsideClickTargetRef = (el)=>{
                this.outsideClickTargetRef.current = el && new WeakRef(el);
            };
        }
    };
}
module.exports["PlainOutsideClickTargetRefContext"] = $6724333aa005e095$export$6a802fb2263552f1;

});

parcelRegister("cI0rA", function(module, exports) {
$parcel$export(module.exports, "default", () => $9409f042c788dd08$export$2e2bcd8739ae039);

var $4Ldep = parcelRequire("4Ldep");


var $b5utg = parcelRequire("b5utg");

function $9409f042c788dd08$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $4Ldep.default)(dirtyDate, Date.now());
}

});

parcelRegister("fSNb6", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $kfZYI = parcelRequire("kfZYI");

var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $4IhTl = parcelRequire("4IhTl");


var $7gB19 = parcelRequire("7gB19");


var $7LErD = parcelRequire("7LErD");

// default configs is also config for production env
const $23c58483533ad0ac$var$productionConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.atlassian.com'
};
const $23c58483533ad0ac$var$devAndStagingConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $23c58483533ad0ac$var$localAndTestConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'http',
        server: 'localhost:3000'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $23c58483533ad0ac$var$isolatedCloudConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    // Note that the env type passed to getUrlForDomainInContext (e.g. prod) doesn't matter
    // in Isolated Cloud, so this will work for staging IC too
    atlassianAccountUrl: (0, $kfZYI.getUrlForDomainInContext)('id', 'prod') ?? 'id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: `https://team.${(0, $T9xHm.isolatedCloudDomain)() ?? ''}`
};
const $23c58483533ad0ac$var$fedrampConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian-us-gov-mod.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralDisabled: true
};
const $23c58483533ad0ac$var$EnvOverrideKeys = [
    'adev',
    'stg-east',
    'local',
    'test',
    'fedramp',
    'prod-east'
];
const $23c58483533ad0ac$var$environmentOverrides = {
    'prod-east': $23c58483533ad0ac$var$productionConfig,
    local: {
        ...(0, $7LErD.LOCAL_PRODUCTION_BACKEND) ? $23c58483533ad0ac$var$productionConfig : $23c58483533ad0ac$var$localAndTestConfig,
        analytics: {
            scheme: 'http',
            server: typeof (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))) !== 'undefined' ? `${(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).location.hostname}:3000` : 'localhost:3000'
        }
    },
    test: {
        ...$23c58483533ad0ac$var$localAndTestConfig
    },
    adev: $23c58483533ad0ac$var$devAndStagingConfig,
    'stg-east': $23c58483533ad0ac$var$devAndStagingConfig,
    fedramp: $23c58483533ad0ac$var$fedrampConfig
};
const $23c58483533ad0ac$var$cachedConfig = {};
function $23c58483533ad0ac$export$634ecc602a6871aa() {
    return (0, $lzcvT.isFedRamp)();
}
function $23c58483533ad0ac$export$44487a86467333c3() {
    const env = $23c58483533ad0ac$export$634ecc602a6871aa() ? 'fedramp' : (0, $7gB19.getEnv)();
    const appName = (0, $4IhTl.getAppName)();
    const key = `${env}_${appName}`;
    if (!$23c58483533ad0ac$var$cachedConfig[key]) {
        if ((0, $T9xHm.isIsolatedCloud)()) $23c58483533ad0ac$var$cachedConfig[key] = $23c58483533ad0ac$var$isolatedCloudConfig;
        else if ($23c58483533ad0ac$var$EnvOverrideKeys.includes(env)) $23c58483533ad0ac$var$cachedConfig[key] = {
            ...$23c58483533ad0ac$var$environmentOverrides[env]
        };
        else // fallback to prod as customers can have custom domains.
        $23c58483533ad0ac$var$cachedConfig[key] = {
            ...$23c58483533ad0ac$var$environmentOverrides['prod-east']
        };
    }
    return $23c58483533ad0ac$var$cachedConfig[key];
}
module.exports["isFedramp"] = $23c58483533ad0ac$export$634ecc602a6871aa;
module.exports["getConfig"] = $23c58483533ad0ac$export$44487a86467333c3;

});

parcelRegister("4IhTl", function(module, exports) {
var $e50b5a5f7ee21567$export$b767e803e7ca9563 = /*#__PURE__*/ function(AppNames) {
    AppNames["EMBEDDABLE_DIRECTORY"] = "embeddableDirectory";
    AppNames["STANDALONE_DIRECTORY"] = "standaloneDirectory";
    return AppNames;
}({});
function $e50b5a5f7ee21567$export$dcecb2dbc7fe753c() {
    // @ts-ignore
    return window.__app_name__ || "embeddableDirectory";
}
module.exports["AppNames"] = $e50b5a5f7ee21567$export$b767e803e7ca9563;
module.exports["getAppName"] = $e50b5a5f7ee21567$export$dcecb2dbc7fe753c;

});

parcelRegister("7gB19", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $7LErD = parcelRequire("7LErD");

var $c1805fedb6ad58a9$export$e7dfafc24fab792e = /*#__PURE__*/ function(MicrosEnv) {
    MicrosEnv["ADEV"] = "adev";
    MicrosEnv["STG_EAST"] = "stg-east";
    MicrosEnv["PROD_EAST"] = "prod-east";
    return MicrosEnv;
}({});
const $c1805fedb6ad58a9$export$d76bdf9f4281ae1b = {
    local: 'local',
    test: 'test',
    prod: 'prod',
    stg: 'staging',
    ["adev"]: 'staging',
    ["stg-east"]: 'staging',
    ["prod-east"]: 'production'
};
const $c1805fedb6ad58a9$var$SIMPLE_TO_DAMN_COMPLEX_ENV = {
    prod: 'prod-east',
    stg: 'stg-east'
};
let $c1805fedb6ad58a9$var$presetEnv;
const $c1805fedb6ad58a9$export$84bc02d3c7a6b55f = (env)=>{
    const envOverride = $c1805fedb6ad58a9$var$SIMPLE_TO_DAMN_COMPLEX_ENV[env];
    if (envOverride) $c1805fedb6ad58a9$var$presetEnv = envOverride;
};
function $c1805fedb6ad58a9$export$4bd44a2aa29d3d6e() {
    if ($c1805fedb6ad58a9$var$presetEnv) return $c1805fedb6ad58a9$var$presetEnv;
    if (0, $7LErD.DEV) return 'local';
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).__env__;
}
function $c1805fedb6ad58a9$export$15b8d8b1ba394f55() {
    return $c1805fedb6ad58a9$export$d76bdf9f4281ae1b[$c1805fedb6ad58a9$export$4bd44a2aa29d3d6e()];
}
module.exports["setEnv"] = $c1805fedb6ad58a9$export$84bc02d3c7a6b55f;
module.exports["getEnv"] = $c1805fedb6ad58a9$export$4bd44a2aa29d3d6e;

});

parcelRegister("7LErD", function(module, exports) {
// @ts-ignore
const $015647182f1a27ed$export$404582bc18fe4d9e = typeof __DEV__ !== 'undefined' && __DEV__;
const $015647182f1a27ed$export$771a63345d182ddd = // @ts-ignore
typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' && // @ts-ignore
__LOCAL_PRODUCTION_BACKEND__;
module.exports["DEV"] = $015647182f1a27ed$export$404582bc18fe4d9e;
module.exports["LOCAL_PRODUCTION_BACKEND"] = $015647182f1a27ed$export$771a63345d182ddd;

});

parcelRegister("6aZ5T", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb8521585dee6236$export$2e2bcd8739ae039);
// Do not export TeamProfileCard here as it will break lazy-loading for the team trigger.


var $aZdSX = parcelRequire("aZdSX");

var $bb8521585dee6236$export$2e2bcd8739ae039 = (0, $aZdSX.default);

});

parcelRegister("aZdSX", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $iK7QL = parcelRequire("iK7QL");

var $9EUfN = parcelRequire("9EUfN");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");


var $fDXXi = parcelRequire("fDXXi");


var $g5lKx = parcelRequire("g5lKx");


var $81aSu = parcelRequire("81aSu");


var $2qY37 = parcelRequire("2qY37");


var $bUp2E = parcelRequire("bUp2E");


var $aCzn4 = parcelRequire("aCzn4");


var $fVnHQ = parcelRequire("fVnHQ");


var $caPHA = parcelRequire("caPHA");


var $k5hbH = parcelRequire("k5hbH");


var $lIPgo = parcelRequire("lIPgo");


var $2q1np = parcelRequire("2q1np");

class $5b8c19cec0dfc921$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $81aSu.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                    ...(0, $2qY37.default).giveKudosButton
                }),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $k5hbH.ErrorBoundary), {
            onError: this.onErrorBoundary,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, $g5lKx.layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: this.props.shouldRenderToParent
            })
        });
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args);
        this._isMounted = false;
        this.showTimer = 0;
        this.hideTimer = 0;
        this.openedByHover = false;
        this.openTime = 0;
        this.fireAnalytics = (eventKey, ...attributes)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.fireEvent) this.props.fireEvent(eventKey, ...attributes);
        };
        this.fireAnalyticsWithDuration = (eventKey, generator)=>{
            const duration = (0, $caPHA.getPageTime)() - this.openTime;
            const attributes = generator(duration);
            this.fireAnalytics(eventKey, attributes);
        };
        this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        };
        this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $caPHA.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        };
        this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $aCzn4.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics('ui.teamProfileCard.triggered', {
                    method: 'click',
                    ...(0, $bUp2E.PACKAGE_META_DATA),
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    teamId: this.props.teamId
                });
            }
        };
        this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                this.fireAnalytics('ui.teamProfileCard.triggered', {
                    method: 'hover',
                    ...(0, $bUp2E.PACKAGE_META_DATA),
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    teamId: this.props.teamId
                });
            }
            this.showProfilecard((0, $fVnHQ.DELAY_MS_SHOW));
        };
        this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $fVnHQ.DELAY_MS_HIDE));
        };
        this.onKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isTriggeredByKeyboard: true
                });
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics('ui.teamProfileCard.triggered', {
                    method: 'click',
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    teamId: this.props.teamId,
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
            }
        };
        this.onClose = ()=>{
            this.hideProfilecard();
            this.setState({
                isTriggeredByKeyboard: false
            });
        };
        this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $fVnHQ.DELAY_MS_HIDE));
            this.setState({
                kudosDrawerOpen: true
            });
        };
        this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        };
        this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        };
        this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        };
        this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        };
        this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false,
            isTriggeredByKeyboard: false
        };
        this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, this.fireAnalytics),
                    this.props.resourceClient.shouldShowGiveKudos(),
                    this.props.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        };
        this.onErrorBoundary = ()=>{
            this.fireAnalytics('ui.teamProfileCard.rendered.errorBoundary', {
                ...(0, $bUp2E.PACKAGE_META_DATA),
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                duration: 0
            });
            this.setState({
                renderError: true
            });
        };
        this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: this.fireAnalyticsWithDuration,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ...this.cardListeners,
                children: this.state.visible && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $2q1np.default), {
                        analytics: this.fireAnalyticsWithDuration
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lIPgo.TeamProfileCardLazy), {
                        ...newProps,
                        isLoading: isLoading,
                        hasError: hasError,
                        errorType: error,
                        isTriggeredByKeyboard: this.state.isTriggeredByKeyboard
                    })
                })
            });
        };
        this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iK7QL.GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, $9EUfN.KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                })
            });
        };
        this.renderTrigger = (triggerProps)=>{
            const { children: children, intl: intl, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        role: "button",
                        testId: "team-profilecard-trigger-wrapper",
                        tabIndex: 0,
                        "aria-label": intl.formatMessage((0, $2qY37.default).teamProfileCardAriaLabel),
                        onKeyUp: this.onKeyPress,
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $l998X.jsx)("a", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            color: 'initial',
                            textDecoration: 'none'
                        },
                        href: viewProfileLink,
                        ...triggerProps,
                        ref: triggerProps.ref,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
        };
    }
}
$5b8c19cec0dfc921$export$f811dc569217c959.defaultProps = {
    actions: [],
    trigger: 'hover',
    position: 'bottom-start',
    triggerLinkType: 'link',
    shouldRenderToParent: true
};
const $5b8c19cec0dfc921$var$TeamProfileCardTrigger = (props)=>{
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    if ((0, $dh538.fg)('people-teams-deprecate-profilecard-teams')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: props.children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($5b8c19cec0dfc921$export$f811dc569217c959, {
        ...props,
        fireEvent: fireEvent
    });
};
/**
 * @deprecated This component is deprecated and provides no functionality.
 * It now simply renders its children without any profile card behavior.
 * Please use `@atlassian/team-profilecard` instead for team profile card functionality.
 */ const $5b8c19cec0dfc921$var$_default_1 = (0, $aXWIB.injectIntl)($5b8c19cec0dfc921$var$TeamProfileCardTrigger);
var $5b8c19cec0dfc921$export$2e2bcd8739ae039 = $5b8c19cec0dfc921$var$_default_1;
module.exports["default"] = $5b8c19cec0dfc921$export$2e2bcd8739ae039;

});

parcelRegister("k5hbH", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $2b2ce0b0062a7857$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $2b2ce0b0062a7857$export$2e2bcd8739ae039 = $2b2ce0b0062a7857$export$e926676385687eaf;
module.exports["ErrorBoundary"] = $2b2ce0b0062a7857$export$e926676385687eaf;

});

parcelRegister("lIPgo", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $8c4f830abcac73ad$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jZ73o")));
module.exports["TeamProfileCardLazy"] = $8c4f830abcac73ad$export$82a49d896f41ca78;

});

parcelRegister("jZ73o", function(module, exports) {

let $e8c92f8bbeab3b1c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e8c92f8bbeab3b1c$var$load("lTK3c"),
    $e8c92f8bbeab3b1c$var$load("1WXdc"),
    $e8c92f8bbeab3b1c$var$load("6wr18"),
    $e8c92f8bbeab3b1c$var$load("ffEVr"),
    $e8c92f8bbeab3b1c$var$load("hhss7"),
    $e8c92f8bbeab3b1c$var$load("Wowvf"),
    $e8c92f8bbeab3b1c$var$load("jnkIk")
]).then(()=>parcelRequire('3PwS1'));

});

parcelRegister("2q1np", function(module, exports) {
$parcel$export(module.exports, "default", () => $08e9a613b6d3c33c$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $by9Aj = parcelRequire("by9Aj");


var $bUp2E = parcelRequire("bUp2E");


var $caPHA = parcelRequire("caPHA");

var $08e9a613b6d3c33c$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    (0, $42omo.useEffect)(()=>{
        analytics('ui.teamProfileCard.rendered.spinner', (duration)=>({
                duration: duration,
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $by9Aj.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $by9Aj.CardHeader), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $by9Aj.CardContent), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $by9Aj.LoadingWrapper), {
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
                })
            })
        ]
    });
};

});

parcelRegister("by9Aj", function(module, exports) {
/* TeamTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $jv8de = parcelRequire("jv8de");

const $45954f322eeb538a$var$styles = {
    cardtriggerwrapper: "_1e0c1kw7",
    cardwrapper: "_2rko12b0 _1bsbnklw _kqswh2mm",
    cardheader: "_4t3i1qr7 _1bsb1osq",
    cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
    loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw",
    grayoutImage: "_kdam7g3v"
};
const $45954f322eeb538a$export$a443be8291b92497 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardtriggerwrapper)
    });
const $45954f322eeb538a$export$6aa22a823032b784 = ({ testId: testId, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardwrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: testId,
        children: children
    });
const $45954f322eeb538a$export$5665775b26e26c5d = ({ image: image, isLoading: isLoading, label: label, isDisabled: isDisabled })=>isLoading || !image ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardheader, isDisabled && $45954f322eeb538a$var$styles.grayoutImage),
        backgroundColor: "color.background.neutral"
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $jv8de.CoverImage), {
        alt: label || '',
        src: image,
        isDisabled: isDisabled
    });
const $45954f322eeb538a$export$64ef9b8c11710c47 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.cardcontent),
        ...props
    });
const $45954f322eeb538a$export$43a792a870d28db2 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($45954f322eeb538a$var$styles.loadingwrapper),
        ...props
    });
module.exports["CardWrapper"] = $45954f322eeb538a$export$6aa22a823032b784;
module.exports["CardHeader"] = $45954f322eeb538a$export$5665775b26e26c5d;
module.exports["CardContent"] = $45954f322eeb538a$export$64ef9b8c11710c47;
module.exports["LoadingWrapper"] = $45954f322eeb538a$export$43a792a870d28db2;

});

parcelRegister("jv8de", function(module, exports) {
/* CoverImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

const $51d6e29b89f36ec6$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1qr7 _kqswh2mm _13li12b0 _qrwq12b0 _1e0c1txw _1bah1h6o _4cvr1h6o",
    image: "_1bsbnklw _4t3i1wug",
    imageNext: "_4t3i1osq _5ral1dfr",
    grayoutImage: "_kdam7g3v"
};
const $51d6e29b89f36ec6$export$a65e282337ff0f53 = ({ src: src, alt: alt = '', isDisabled: isDisabled })=>{
    const containerRef = (0, $42omo.useRef)(null);
    const imgRef = (0, $42omo.useRef)(null);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: containerRef,
        xcss: $51d6e29b89f36ec6$var$styles.container,
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            as: "img",
            ref: imgRef,
            src: src,
            alt: alt,
            xcss: (0, $1Whri.cx)((0, $dh538.fg)('cover-header-image-team-profilecard') ? $51d6e29b89f36ec6$var$styles.imageNext : $51d6e29b89f36ec6$var$styles.image, isDisabled && $51d6e29b89f36ec6$var$styles.grayoutImage)
        })
    });
};
module.exports["CoverImage"] = $51d6e29b89f36ec6$export$a65e282337ff0f53;

});

parcelRegister("O1c6O", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ffCOo = parcelRequire("ffCOo");

const $a6f5bf930119200a$export$f7434a73419cbe6f = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $a6f5bf930119200a$export$73b91fac7f27799f({ data: data, children: children }) {
    const analyticsContextData = (0, $42omo.useMemo)(()=>{
        if (typeof data === 'object') return {
            ...$a6f5bf930119200a$export$f7434a73419cbe6f,
            ...data
        };
        return $a6f5bf930119200a$export$f7434a73419cbe6f;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.PeopleTeamsAnalyticsContext), {
        data: analyticsContextData,
        children: children
    });
}
module.exports["TeamsAppAnalyticsContext"] = $a6f5bf930119200a$export$73b91fac7f27799f;

});

parcelRegister("4bnNr", function(module, exports) {

var $hdvI3 = parcelRequire("hdvI3");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/jira/project/manifest.ts
var $30baa5fc53208f94$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hdvI3.JiraProjectAriResourceOwner),
    resourceType: (0, $hdvI3.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $30baa5fc53208f94$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $30baa5fc53208f94$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $30baa5fc53208f94$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $30baa5fc53208f94$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
};
module.exports["JiraProjectAri"] = $30baa5fc53208f94$export$75a0a0a7cb0a58ae;

});

parcelRegister("hdvI3", function(module, exports) {
// src/jira/project/types.ts
var $c88c3f6e5a62c5c4$export$99d538a3b04916b1 = "jira", $c88c3f6e5a62c5c4$export$736763838d3aa22e = "project";
module.exports["JiraProjectAriResourceOwner"] = $c88c3f6e5a62c5c4$export$99d538a3b04916b1;
module.exports["JiraProjectAriResourceType"] = $c88c3f6e5a62c5c4$export$736763838d3aa22e;

});

parcelRegister("9lcFT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8RDU2 = parcelRequire("8RDU2");

const $3430de584d0e6443$var$defaultAnalyticsMethod = ()=>{
    // tslint:disable-next-line no-console
    // eslint-disable-next-line no-console
    console.warn('No analytics client has been provided.');
    (0, $8RDU2.logInfoMessage)('Analytics Context accessed before AnalyticsClient was loaded');
};
const $3430de584d0e6443$export$7fa70eb12a96b7d1 = {
    getAnalyticsWebClient: ()=>{
        $3430de584d0e6443$var$defaultAnalyticsMethod();
        return;
    },
    pushTrackEvent: $3430de584d0e6443$var$defaultAnalyticsMethod,
    pushScreenEvent: $3430de584d0e6443$var$defaultAnalyticsMethod,
    pushUIEvent: $3430de584d0e6443$var$defaultAnalyticsMethod,
    pushOperationalEvent: $3430de584d0e6443$var$defaultAnalyticsMethod,
    startUIViewedEvent: $3430de584d0e6443$var$defaultAnalyticsMethod,
    expTracker: ()=>{
        throw new Error('No analytics client has been provided');
    },
    setTeamId: ()=>{
        throw new Error('No analytics client has been provided');
    },
    setConsumer: ()=>{}
};
const $3430de584d0e6443$var$AnalyticsContextState = {
    analytics: $3430de584d0e6443$export$7fa70eb12a96b7d1
};
const $3430de584d0e6443$export$83cd6c3eba7d8d9e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($3430de584d0e6443$var$AnalyticsContextState);
module.exports["AnalyticsContext"] = $3430de584d0e6443$export$83cd6c3eba7d8d9e;

});

parcelRegister("8RDU2", function(module, exports) {

var $iE25L = parcelRequire("iE25L");

const $81978b4d127270c6$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $81978b4d127270c6$export$f86b2a1a2ce291b3 = (0, $iE25L.logExceptionWithPackageContext)($81978b4d127270c6$var$packageContext);
const $81978b4d127270c6$export$ece28f5cfa04608 = (0, $iE25L.logErrorMessageWithPackageContext)($81978b4d127270c6$var$packageContext);
const $81978b4d127270c6$export$386587bcf05ee8ea = (0, $iE25L.logInfoMessageWithPackageContext)($81978b4d127270c6$var$packageContext);
const $81978b4d127270c6$export$9edc7d6f1c33ddc = (0, $iE25L.createErrorHandlerWithPackageContext)($81978b4d127270c6$var$packageContext);
module.exports["logException"] = $81978b4d127270c6$export$f86b2a1a2ce291b3;
module.exports["logErrorMessage"] = $81978b4d127270c6$export$ece28f5cfa04608;
module.exports["logInfoMessage"] = $81978b4d127270c6$export$386587bcf05ee8ea;

});

parcelRegister("7ynk7", function(module, exports) {
/**
 * @private
 * @deprecated Analytics event names should use camelCase, therefore AnalyticsKeys should no longer be used or expanded.
 */ const $bd7bc2f475048529$export$e8d1ded05852e864 = {
    ACTIVITY_ALL_VIEW: 'activity.all.view',
    ACTIVITY_WATCHING_VIEW: 'activity.watching.view',
    HISTORY_VIEW: 'history.view',
    PEOPLE_VIEW: 'people-search.view',
    PROFILE_PAGE_VIEW: 'profile-page.view',
    AGENT_PROFILE_PAGE_VIEW: 'agent-profile-page.view',
    PROFILE_WORKED_ON_PAGE_VIEW: 'profile-worked-on-page.view',
    PROFILE_SETTINGS_CLOSE_ACCOUNT_VIEW: 'profile-settings.close-account.view',
    PROFILE_SETTINGS_EMAIL_VIEW: 'profile-settings.email.view',
    PROFILE_SETTINGS_GENERAL_VIEW: 'profile-settings.general.view',
    PROFILE_SETTINGS_PROFILE_AND_VISIBILITY_VIEW: 'profile-settings.profile-and-visibility.view',
    PROFILE_SETTINGS_PRIVACY_VIEW: 'profile-settings.privacy.view',
    PROFILE_SETTINGS_PRODUCT_VIEW: 'profile-settings.product.view',
    PROFILE_SETTINGS_SECURITY_VIEW: 'profile-settings.security.view',
    PROFILE_SETTINGS_TWO_STEP_VERIFICATION_VIEW: 'profile-settings.security.two-step-verification.view',
    PROFILE_SETTINGS_API_TOKENS_VIEW: 'profile-settings.security.api-tokens.view',
    PROFILE_SETTINGS_RECENT_DEVICES_VIEW: 'profile-settings.security.recent-devices.view',
    PROFILE_SETTINGS_CONNECTED_APPS_VIEW: 'profile-settings.connected-apps.view',
    TEAM_PROFILE_VIEW: 'team-profile.view',
    KUDOS_PAGE_VIEW: 'kudos-page.view',
    TEAM_PROFILE_BROWSE_ALL: 'team-profile.browse-all',
    ALL_TEAMS_DISABLED: 'profile-search.view.all-teams.disabled',
    // TODO: remove these once we move to a new analytics platform
    LEGACY_ACTIVITY_ALL_VIEW: 'newsfeed.view'
};
const $bd7bc2f475048529$export$6430c2bbc66a6fa = {
    [$bd7bc2f475048529$export$e8d1ded05852e864.PROFILE_PAGE_VIEW]: 'userProfile',
    [$bd7bc2f475048529$export$e8d1ded05852e864.TEAM_PROFILE_BROWSE_ALL]: 'teamsPage'
};
var $bd7bc2f475048529$export$2102531865f3e90e = /*#__PURE__*/ function(AnalyticsEventSource) {
    // `/people/<userId>` page
    AnalyticsEventSource["USER_PROFILE_SCREEN"] = "userProfileScreen";
    AnalyticsEventSource["USER_PROFILE_ABOUT"] = "userProfileAbout";
    // `/people/<userId>/work` page
    AnalyticsEventSource["USER_WORK_SCREEN"] = "userWorkScreen";
    // `/people/agent/<agentId>` page
    AnalyticsEventSource["AGENT_PROFILE_SCREEN"] = "agentProfileScreen";
    AnalyticsEventSource["AGENT_DELETE_SUCCESS_FLAG"] = "agentDeletedSuccessflag";
    AnalyticsEventSource["AGENT_DELETE_ERROR_FLAG"] = "agentDeletedErrorflag";
    // `/people/team/<teamId>` page
    AnalyticsEventSource["TEAM_PROFILE_SCREEN"] = "teamProfileScreen";
    AnalyticsEventSource["TEAM_PROFILE_ABOUT"] = "teamProfileAbout";
    AnalyticsEventSource["TEAM_RESTORE_SCREEN"] = "teamRestoreScreen";
    AnalyticsEventSource["TEAM_RESTORE_SUCCESS_FLAG"] = "teamReactivatedSuccessflag";
    AnalyticsEventSource["TEAM_RESTORE_ERROR_FLAG"] = "teamReactivatedErrorflag";
    AnalyticsEventSource["CREATE_TEAM_MODAL"] = "createTeamModal";
    AnalyticsEventSource["TEAM_LINKS_REACH_LIMIT_FLAG"] = "teamLinksReachLimitFlag";
    // `/people/search` page
    AnalyticsEventSource["DIRECTORY_SCREEN"] = "directoryScreen";
    // new `/people/search` page
    AnalyticsEventSource["PEOPLE_HOME"] = "peopleHome";
    AnalyticsEventSource["PEOPLE_DRAWER"] = "peopleDrawer";
    // inside avatar menu
    AnalyticsEventSource["USER_MENU"] = "userMenu";
    // experimentLeaf */
    AnalyticsEventSource["ADD_PEOPLE_MODAL"] = "addPeopleModal";
    // generic metrics
    AnalyticsEventSource["CLIENT_METRICS"] = "clientMetrics";
    // generic metrics
    AnalyticsEventSource["DIRECTORY_APP"] = "directoryApp";
    AnalyticsEventSource["INITIALS_DIALOG"] = "avatarInitialsPicker";
    // /people/kudos/:uuid
    AnalyticsEventSource["KUDOS_SCREEN"] = "kudos";
    AnalyticsEventSource["PROFILE_CARD"] = "profilecard";
    // new `/people/search/teams` page
    AnalyticsEventSource["TEAMS_PAGE"] = "teamsPage";
    return AnalyticsEventSource;
}({});
var $bd7bc2f475048529$export$74eee170ad238aae = /*#__PURE__*/ function(AnalyticsEventActions) {
    AnalyticsEventActions["ACCEPTED"] = "accepted";
    AnalyticsEventActions["CLICKED"] = "clicked";
    AnalyticsEventActions["CLOSED"] = "closed";
    AnalyticsEventActions["COLLAPSED"] = "collapsed";
    AnalyticsEventActions["CREATED"] = "created";
    AnalyticsEventActions["DECLINED"] = "declined";
    AnalyticsEventActions["DELETED"] = "deleted";
    AnalyticsEventActions["EDITED"] = "edited";
    AnalyticsEventActions["EXPANDED"] = "expanded";
    AnalyticsEventActions["EXPOSED"] = "exposed";
    AnalyticsEventActions["FAILED"] = "failed";
    AnalyticsEventActions["JOINED"] = "joined";
    AnalyticsEventActions["REDIRECTED"] = "redirected";
    AnalyticsEventActions["REMOVED"] = "removed";
    AnalyticsEventActions["SENT"] = "sent";
    AnalyticsEventActions["SORTED"] = "sorted";
    AnalyticsEventActions["STARTED"] = "started";
    AnalyticsEventActions["OPENED"] = "opened";
    AnalyticsEventActions["SHOWN"] = "shown";
    AnalyticsEventActions["SUBMITTED"] = "submitted";
    AnalyticsEventActions["SUCCEEDED"] = "succeeded";
    AnalyticsEventActions["TRIGGERED"] = "triggered";
    AnalyticsEventActions["TYPED"] = "typed";
    AnalyticsEventActions["VIEWED"] = "viewed";
    AnalyticsEventActions["MOUNTED"] = "mounted";
    AnalyticsEventActions["MOVED"] = "moved";
    AnalyticsEventActions["DRAGGED"] = "dragged";
    AnalyticsEventActions["SELECTED"] = "selected";
    AnalyticsEventActions["LINKED"] = "linked";
    return AnalyticsEventActions;
}({});
var $bd7bc2f475048529$export$670f80b77450980d = /*#__PURE__*/ function(AnalyticsEventSubjects) {
    AnalyticsEventSubjects["TEAM_LINK"] = "teamLink";
    AnalyticsEventSubjects["BUTTON"] = "button";
    AnalyticsEventSubjects["MODAL_DIALOG"] = "modalDialog";
    AnalyticsEventSubjects["FORM"] = "form";
    AnalyticsEventSubjects["ERROR"] = "error";
    return AnalyticsEventSubjects;
}({});
module.exports["AnalyticsKeys"] = $bd7bc2f475048529$export$e8d1ded05852e864;
module.exports["analyticsKeyToEventMap"] = $bd7bc2f475048529$export$6430c2bbc66a6fa;
module.exports["AnalyticsEventSource"] = $bd7bc2f475048529$export$2102531865f3e90e;
module.exports["AnalyticsEventActions"] = $bd7bc2f475048529$export$74eee170ad238aae;
module.exports["AnalyticsEventSubjects"] = $bd7bc2f475048529$export$670f80b77450980d;

});

parcelRegister("64q5H", function(module, exports) {
var $9dac2ebdabc50575$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $9dac2ebdabc50575$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $9dac2ebdabc50575$export$cde1786a482f9a1c(error) {
    return $9dac2ebdabc50575$export$9677d7c364ada66c(401, error) || $9dac2ebdabc50575$export$9677d7c364ada66c(403, error);
}
const $9dac2ebdabc50575$export$c27af9588f06f6fc = [
    'SentryIgnoreError'
];
const $9dac2ebdabc50575$export$f4c3d57f2f41ffe2 = {
    'Could not verify accountId from header': 'AccountIdMismatch'
};
function $9dac2ebdabc50575$export$ece443678e6cc3f5(error) {
    const constructor = error?.constructor.name;
    if (constructor && $9dac2ebdabc50575$export$c27af9588f06f6fc.includes(constructor)) return constructor;
    const message = error?.message || '';
    const containedReason = message && Object.keys($9dac2ebdabc50575$export$f4c3d57f2f41ffe2).find((ignoredMessage)=>message.includes(ignoredMessage));
    if (containedReason) return $9dac2ebdabc50575$export$f4c3d57f2f41ffe2[containedReason];
}
function $9dac2ebdabc50575$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $9dac2ebdabc50575$export$94c4b26e937da69(error) {
    if (!error) return false;
    const statusCode = error['status'] || error['statusCode'];
    // We want to log 429 errors to understand rate limiting
    if (parseInt(statusCode, 10) >= 400 && parseInt(statusCode, 10) < 500 && parseInt(statusCode, 10) !== 429) return true;
    const reg = new RegExp(/status (code)?.*(4\d\d)/g);
    return !!error.message?.match(reg);
}
function $9dac2ebdabc50575$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $9dac2ebdabc50575$export$b19e812222b57630 = /*#__PURE__*/ function(DirectoryErrorCode) {
    DirectoryErrorCode["MISSING_ERROR_MESSAGE"] = "MissingErrorMessage";
    return DirectoryErrorCode;
}({});
var $9dac2ebdabc50575$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
function $9dac2ebdabc50575$export$76843b239f07f80a(error, field) {
    return error instanceof Error && field in error;
}
function $9dac2ebdabc50575$export$c5975066c735ef7e(err) {
    return typeof err === 'object' && err !== null && 'graphQLErrors' in err;
}
module.exports["ErrorCategory"] = $9dac2ebdabc50575$export$fe4bb20808298551;
module.exports["StatusCode"] = $9dac2ebdabc50575$export$f66f92b8741acd5b;
module.exports["isAuthError"] = $9dac2ebdabc50575$export$cde1786a482f9a1c;
module.exports["isErrorStatusCode"] = $9dac2ebdabc50575$export$9677d7c364ada66c;
module.exports["ignoredErrorReason"] = $9dac2ebdabc50575$export$ece443678e6cc3f5;
module.exports["is4xxError"] = $9dac2ebdabc50575$export$94c4b26e937da69;
module.exports["doesErrorContainStatus"] = $9dac2ebdabc50575$export$7c7624f23566b6ff;
module.exports["DirectoryErrorCode"] = $9dac2ebdabc50575$export$b19e812222b57630;
module.exports["isUseQueryLightError"] = $9dac2ebdabc50575$export$c5975066c735ef7e;

});

parcelRegister("jg9Go", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $dedJV = parcelRequire("dedJV");

var $kfZYI = parcelRequire("kfZYI");

var $T9xHm = parcelRequire("T9xHm");


var $fSNb6 = parcelRequire("fSNb6");


var $d7os3 = parcelRequire("d7os3");

const $37fb079860541880$var$initialState = {
    isTeamCentral: false,
    hasWorkspace: false,
    orgHasWorkspace: false,
    teamCentralHandlers: {},
    teamCentralUrl: undefined
};
const $37fb079860541880$var$actions = {
    initTeamCentral: (appName, cloudId, teamCentralHandlers = {})=>({ setState: setState })=>{
            const isTeamCentral = appName === 'teamcentral-directory';
            let teamCentralUrlPromise;
            if ((0, $fSNb6.getConfig)().teamCentralDisabled === true) teamCentralUrlPromise = Promise.resolve(undefined);
            else teamCentralUrlPromise = (0, $d7os3.default).isGlobalExperienceWorkspaceForCloudId(cloudId).then((isGlobalExperience)=>{
                // Isolated cloud only functionality uses prod only environment to get an IC domain
                if ((0, $T9xHm.isIsolatedCloud)()) return isGlobalExperience ? (0, $kfZYI.getUrlForDomainInContext)('home', 'prod') : `https://team.${(0, $T9xHm.isolatedCloudDomain)() ?? ''}`;
                return isGlobalExperience ? (0, $dedJV.getATLContextUrl)('home') : (0, $dedJV.getATLContextUrl)('team');
            });
            if (isTeamCentral) // Assume site already has a TC workspace if directory is running in TC mode
            teamCentralUrlPromise.then((teamCentralUrl)=>{
                setState({
                    isTeamCentral: isTeamCentral,
                    hasWorkspace: true,
                    orgHasWorkspace: true,
                    teamCentralHandlers: teamCentralHandlers,
                    teamCentralUrl: teamCentralUrl
                });
            });
            else {
                // Otherwise, fetch for workspace information
                const requests = [
                    (0, $d7os3.default).hasWorkspaceForCloudId(cloudId),
                    (0, $d7os3.default).doesOrgContainAnyWorkspace(cloudId),
                    teamCentralUrlPromise
                ];
                Promise.all(requests).then(([hasWorkspace, orgHasWorkspace, teamCentralUrl])=>{
                    setState({
                        isTeamCentral: false,
                        hasWorkspace: hasWorkspace,
                        orgHasWorkspace: orgHasWorkspace,
                        teamCentralHandlers: teamCentralHandlers,
                        teamCentralUrl: teamCentralUrl
                    });
                });
            }
        },
    initTeamCentralWithValues: ({ appName: appName, hasWorkspace: hasWorkspace, orgHasWorkspace: orgHasWorkspace, teamCentralHandlers: teamCentralHandlers = {}, teamCentralUrl: teamCentralUrl })=>({ setState: setState })=>{
            setState({
                isTeamCentral: appName === 'teamcentral-directory',
                hasWorkspace: hasWorkspace,
                orgHasWorkspace: orgHasWorkspace,
                teamCentralHandlers: teamCentralHandlers,
                teamCentralUrl: teamCentralUrl
            });
        }
};
/**
 * Manage states of searching People and Teams in search home page.
 */ const $37fb079860541880$var$Store = (0, $1P1Tu.createStore)({
    initialState: $37fb079860541880$var$initialState,
    actions: $37fb079860541880$var$actions,
    name: 'SearchHomePage'
});
const $37fb079860541880$export$39314e672c06693f = (0, $9zUhf.createHook)($37fb079860541880$var$Store);
const $37fb079860541880$export$7c58a39ba496932b = (0, $9zUhf.createHook)($37fb079860541880$var$Store, {
    selector: null
});
const $37fb079860541880$export$9da989c55553d02d = (0, $9zUhf.createHook)($37fb079860541880$var$Store, {
    selector: (s)=>s.isTeamCentral
});
const $37fb079860541880$export$20f07b26e9a56b9 = (0, $9zUhf.createHook)($37fb079860541880$var$Store, {
    selector: (s)=>s.isTeamCentral || s.hasWorkspace || s.orgHasWorkspace
});
module.exports["useTeamCentralStore"] = $37fb079860541880$export$39314e672c06693f;
module.exports["useTeamCentralStoreApi"] = $37fb079860541880$export$7c58a39ba496932b;
module.exports["useIsTeamCentral"] = $37fb079860541880$export$9da989c55553d02d;
module.exports["useTeamCentralPresent"] = $37fb079860541880$export$20f07b26e9a56b9;

});

parcelRegister("d7os3", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $fSNb6 = parcelRequire("fSNb6");


var $26CPK = parcelRequire("26CPK");

const $0c78eb453da04663$var$UNSHARDED_PREFIX = '/watermelon';
class $0c78eb453da04663$export$424050aeba67e883 extends (0, $26CPK.default) {
    async hasWorkspaceForCloudId(cloudId) {
        try {
            await this.getResource(`${this.buildShardedPrefix(cloudId)}/workspace/exists?cloudId=${cloudId}`);
            return true;
        } catch (err) {
            return false;
        }
    }
    async doesOrgContainAnyWorkspace(cloudId) {
        try {
            await this.getResource(((0, $dh538.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $0c78eb453da04663$var$UNSHARDED_PREFIX : this.buildShardedPrefix(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`);
            return true;
        } catch (err) {
            return false;
        }
    }
    async isGlobalExperienceWorkspaceForCloudId(cloudId) {
        try {
            const res = await this.makeRequest(`${this.buildShardedPrefix(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                headers: {
                    Accept: 'text/plain'
                }
            });
            return Promise.resolve(res === 'GLOBAL_EXPERIENCE');
        } catch (err) {
            return Promise.resolve(false);
        }
    }
    buildShardedPrefix(cloudId) {
        return `/townsquare/s/${cloudId}`;
    }
    constructor(){
        super({
            serviceUrl: (0, $fSNb6.getConfig)().stargateRoot
        });
    }
}
/**
 * REST Client to make calls to resources on the team central service.
 *
 * Note: You probably don't want to use this directly. Use the centralised store instead where these values
 * have already been fetched. See useTeamCentralStore().
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
const $0c78eb453da04663$var$_default_1 = new $0c78eb453da04663$export$424050aeba67e883();
var $0c78eb453da04663$export$2e2bcd8739ae039 = $0c78eb453da04663$var$_default_1;
module.exports["default"] = $0c78eb453da04663$export$2e2bcd8739ae039;

});

parcelRegister("26CPK", function(module, exports) {

var $lgmus = parcelRequire("lgmus");


var $20sPA = parcelRequire("20sPA");


var $62D5H = parcelRequire("62D5H");


var $04lnm = parcelRequire("04lnm");


var $64q5H = parcelRequire("64q5H");


var $6qypy = parcelRequire("6qypy");


var $eeb3x = parcelRequire("eeb3x");

const $10e3c4cbc175c988$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
const $10e3c4cbc175c988$var$fetchWithExponentialBackoff = (0, $6qypy.withDefaultExponentialBackoff)(fetch);
// tslint:disable-next-line no-any
function $10e3c4cbc175c988$var$parseResponse(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}
async function $10e3c4cbc175c988$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || (0, $64q5H.DirectoryErrorCode).MISSING_ERROR_MESSAGE);
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}
let $10e3c4cbc175c988$var$incrementRedirectCount;
let $10e3c4cbc175c988$var$clearRedirectCount;
$10e3c4cbc175c988$export$7a0fc52d8c359feb();
function $10e3c4cbc175c988$export$7a0fc52d8c359feb() {
    $10e3c4cbc175c988$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($20sPA)))(()=>(0, $04lnm.setCookie)((0, $04lnm.REDIRECT_COUNT), (0, $04lnm.getCookieAsInteger)((0, $04lnm.REDIRECT_COUNT)) + 1));
    $10e3c4cbc175c988$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($20sPA)))(()=>(0, $04lnm.clearCookie)((0, $04lnm.REDIRECT_COUNT)));
}
class $10e3c4cbc175c988$var$RestClient {
    async getResource(path) {
        return this.makeRequest(path);
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
       * PATCH must be uppercase as per fetch spec only
       * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
       * are normalised to uppercase.
       *
       * https://github.com/github/fetch/issues/37
       * https://fetch.spec.whatwg.org/#methods
       */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {}) {
        const url = this.serviceUrl + path;
        const options = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))({}, $10e3c4cbc175c988$var$defaultFetchOptions, additionalFetchOptions);
        const response = await $10e3c4cbc175c988$var$fetchWithExponentialBackoff(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $eeb3x.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $62D5H.SentryIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await $10e3c4cbc175c988$export$91c32f1b22d29b2d(response);
                throw new (0, $62D5H.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined
                });
            }
        }
        // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
        return additionalFetchOptions.ignoreResponse ? null : $10e3c4cbc175c988$var$parseResponse(response);
    }
    constructor({ serviceUrl: serviceUrl = '' } = {}){
        this.serviceUrl = void 0;
        /**
     * This function is necessary for if `statusCodeHandler` prescribes a login
     * redirect upon a 401 response.
     * While the default redirect behaviour may be overriden, this function has
     * been kept separate to ensure it cannot be overriden, lest a host
     * application supply embeddable-directory with a custom handler that suffers
     * the infinite redirect bug.
     */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $10e3c4cbc175c988$var$incrementRedirectCount();
            } else $10e3c4cbc175c988$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
}
var $10e3c4cbc175c988$export$2e2bcd8739ae039 = $10e3c4cbc175c988$var$RestClient;
module.exports["default"] = $10e3c4cbc175c988$export$2e2bcd8739ae039;

});

parcelRegister("62D5H", function(module, exports) {
var $b33c0d587a5a5a93$var$_GraphQLError;
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $b33c0d587a5a5a93$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.message = void 0;
        this.name = void 0;
        this.stack = void 0;
        this.name = this.constructor.name;
        this.message = message;
        this.stack = new Error(message).stack || '';
    }
}
class $b33c0d587a5a5a93$export$c73ca302efeda3b4 extends $b33c0d587a5a5a93$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $b33c0d587a5a5a93$export$c73ca302efeda3b4.prototype);
    }
}
class $b33c0d587a5a5a93$export$20de9a0e470e95aa extends $b33c0d587a5a5a93$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $b33c0d587a5a5a93$export$20de9a0e470e95aa.prototype);
    }
}
class $b33c0d587a5a5a93$export$65bd6083489bd8bb extends $b33c0d587a5a5a93$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId }){
        super(message);
        this.status = void 0;
        this.traceId = void 0;
        Object.setPrototypeOf(this, $b33c0d587a5a5a93$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
    }
}
class $b33c0d587a5a5a93$export$92d6ed0888e7cb7f extends $b33c0d587a5a5a93$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        this.fields = void 0;
        // tslint:disable-line no-any
        this.category = void 0;
        Object.setPrototypeOf(this, $b33c0d587a5a5a93$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
}
$b33c0d587a5a5a93$var$_GraphQLError = $b33c0d587a5a5a93$export$92d6ed0888e7cb7f;
$b33c0d587a5a5a93$export$92d6ed0888e7cb7f.from = (rawErrors)=>{
    const firstError = rawErrors[0];
    const errorData = {
        category: firstError.category,
        message: firstError.message
    };
    if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
        obj[item.field] = item.message;
        return obj;
    }, {});
    return new $b33c0d587a5a5a93$var$_GraphQLError(errorData);
};
module.exports["SentryIgnoreError"] = $b33c0d587a5a5a93$export$20de9a0e470e95aa;
module.exports["HttpError"] = $b33c0d587a5a5a93$export$65bd6083489bd8bb;

});

parcelRegister("04lnm", function(module, exports) {
const $a59d373241532556$export$f6101897f0230549 = 'redirectCount';
const $a59d373241532556$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $a59d373241532556$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $a59d373241532556$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $a59d373241532556$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}
module.exports["REDIRECT_COUNT"] = $a59d373241532556$export$f6101897f0230549;
module.exports["setCookie"] = $a59d373241532556$export$110700823644f4a6;
module.exports["getCookieAsInteger"] = $a59d373241532556$export$6a289e5003f59269;
module.exports["clearCookie"] = $a59d373241532556$export$ad3506281d5a5e5d;

});

parcelRegister("6qypy", function(module, exports) {
const $0713028e3709bd77$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $0713028e3709bd77$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
// tslint:disable-next-line no-any
const $0713028e3709bd77$var$defaultRetryIfCallback = (a)=>!a;
const $0713028e3709bd77$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $0713028e3709bd77$var$defaultRetryIfCallback
};
function $0713028e3709bd77$export$20eaa22f2295996f(toTry, hofOptions = $0713028e3709bd77$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
function $0713028e3709bd77$export$455df4c93665fa4a(fetchOp) {
    return $0713028e3709bd77$export$20eaa22f2295996f(fetchOp, {
        initial: $0713028e3709bd77$export$8f4286bf21155381.INITIAL_DELAY,
        jitter: $0713028e3709bd77$export$8f4286bf21155381.JITTER,
        max: $0713028e3709bd77$export$8f4286bf21155381.MAX_RETRIES,
        retryIf: (response)=>$0713028e3709bd77$export$55b2fbd5d4a32495(response.status)
    });
}
module.exports["withDefaultExponentialBackoff"] = $0713028e3709bd77$export$455df4c93665fa4a;

});

parcelRegister("eeb3x", function(module, exports) {
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $bd5be70468c361cc$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $bd5be70468c361cc$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $bd5be70468c361cc$export$8c005e458e12d501.handlers = handlers;
    }
};
function $bd5be70468c361cc$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $bd5be70468c361cc$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}
module.exports["statusCodeHandlersProvider"] = $bd5be70468c361cc$export$8c005e458e12d501;
module.exports["handleResponse"] = $bd5be70468c361cc$export$c113a67a6762ad2e;

});

parcelRegister("Knzlm", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $dh538 = parcelRequire("dh538");


var $asH6r = parcelRequire("asH6r");

var $ecUKi = parcelRequire("ecUKi");

// Private actions:
// It is called by `getPrincipalUserInfo` action
const $3022123db001046f$var$getIsSiteAdmin = (cloudId)=>async ({ setState: setState })=>{
        if (!cloudId) {
            if (!(0, $dh538.fg)('people_and_teams_fix_is_site_admin_race_condition')) setState({
                isSiteAdmin: false
            });
            return;
        }
        let isSiteAdmin = false;
        try {
            isSiteAdmin = await (0, $asH6r.teamsClient).getIsSiteAdmin(cloudId);
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        } finally{
            setState({
                isSiteAdmin: isSiteAdmin
            });
        }
    };
// it is called by `getPrincipalUserInfo` action
const $3022123db001046f$var$getMutability = (userId)=>async ({ setState: setState })=>{
        try {
            const data = await (0, $asH6r.teamsClient).getProfileWithMutability(userId);
            setState({
                mutabilityConstraints: data
            });
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        }
    };
const $3022123db001046f$var$getAvatarUploadedStatus = (userId)=>async ({ setState: setState })=>{
        try {
            setState({
                avatarUploaded: {
                    isLoading: true,
                    error: undefined,
                    uploaded: undefined
                }
            });
            const data = await (0, $asH6r.teamsClient).getMyAvatarUploadedStatus(userId);
            setState({
                avatarUploaded: {
                    isLoading: false,
                    uploaded: data.uploaded
                }
            });
        } catch (e) {
            setState({
                avatarUploaded: {
                    isLoading: false,
                    error: e instanceof Error ? e : new Error('Unknown error'),
                    uploaded: undefined
                }
            });
        }
    };
const $3022123db001046f$var$actions = {
    /**
	 * Get user information of current logged-in user.
	 * @param cloudId: If Cloud Id is passed, that means People Directory is rendered in a site and we use Cloud Id to check 'isSiteAdmin' info.
	 * If Cloud Id is not passed, `isSiteAdmin` is false by default.
	 */ getPrincipalUserInfo: (cloudId)=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            // stop fetching when it is already fetched
            if (getState().isFetching || getState().hasLoaded) return;
            setState({
                isFetching: true,
                hasLoaded: false
            });
            try {
                const userBasicData = await (0, $ecUKi.userInfoProvider).get();
                setState({
                    principalUserId: userBasicData.userId,
                    ...userBasicData
                });
                dispatch($3022123db001046f$var$getIsSiteAdmin(cloudId));
                dispatch($3022123db001046f$var$getMutability(userBasicData.userId));
                setState({
                    hasLoaded: true
                });
            } catch (e) {
                setState({
                    hasError: true,
                    hasLoaded: false
                });
            } finally{
                setState({
                    isFetching: false
                });
            }
        },
    getAvatarUploadedStatus: $3022123db001046f$var$getAvatarUploadedStatus,
    setAvatarUploadedStatus: (uploaded)=>({ setState: setState })=>{
            setState({
                avatarUploaded: {
                    uploaded: uploaded,
                    isLoading: false,
                    isDeleting: false
                }
            });
        },
    deleteUserAvatar: ()=>async ({ getState: getState, dispatch: dispatch, setState: setState })=>{
            try {
                setState({
                    avatarUrl: undefined,
                    avatarUploaded: {
                        isDeleting: true,
                        isLoading: true,
                        error: undefined
                    }
                });
                await (0, $asH6r.teamsClient).deleteAvatar(getState().principalUserId);
                dispatch($3022123db001046f$var$actions.fetchAvatarInfo());
            } catch (e) {
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        isDeleting: false,
                        error: e instanceof Error ? e : new Error('Unknown error')
                    }
                });
            } finally{
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        isDeleting: false
                    }
                });
            }
        },
    fetchAvatarInfo: ()=>async ({ getState: getState, setState: setState })=>{
            const avatarInfo = await (0, $asH6r.teamsClient).fetchUserAvatarInfo(getState().principalUserId);
            setState({
                avatarUrl: avatarInfo.url,
                avatarUploaded: {
                    uploaded: avatarInfo.uploaded,
                    isLoading: false
                }
            });
        },
    updateUserAvatar: (userId, fileURI)=>async ({ setState: setState })=>{
            setState({
                avatarUrl: undefined,
                avatarUploaded: {
                    isDeleting: false,
                    isLoading: true,
                    isUploading: true,
                    hasUploadedAvatar: false,
                    error: undefined
                }
            });
            try {
                const avatarUrl = await (0, $asH6r.teamsClient).updateUserAvatar({
                    id: userId,
                    fileURI: fileURI
                });
                setState({
                    avatarUrl: avatarUrl,
                    avatarUploaded: {
                        uploaded: true,
                        isLoading: false,
                        isUploading: false,
                        hasUploadedAvatar: true
                    }
                });
            } catch (error) {
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        isUploading: false,
                        error: error instanceof Error ? error : new Error('Unknown error'),
                        hasUploadedAvatar: undefined
                    }
                });
            }
        },
    setPrincipalUserInfo: (data)=>({ setState: setState })=>{
            setState(data);
        },
    getIsSiteAdmin: $3022123db001046f$var$getIsSiteAdmin,
    setPrincipalUserId: (principalUserId)=>({ setState: setState })=>{
            setState({
                principalUserId: principalUserId
            });
        }
};
const $3022123db001046f$var$initialState = {
    principalUserId: '',
    avatarUrl: '',
    email: '',
    fullName: '',
    title: '',
    isSiteAdmin: false,
    isFetching: false,
    hasError: false,
    hasLoaded: false,
    avatarUploaded: {
        isLoading: false
    }
};
/**
 * Manage states of a site
 */ const $3022123db001046f$var$Store = (0, $1P1Tu.createStore)({
    initialState: $3022123db001046f$var$initialState,
    actions: $3022123db001046f$var$actions,
    name: 'PrincipalUser'
});
const $3022123db001046f$export$33e3bf16c7530dd4 = (0, $9zUhf.createHook)($3022123db001046f$var$Store);
const $3022123db001046f$export$b26d2c7f264f51a8 = (0, $9zUhf.createHook)($3022123db001046f$var$Store, {
    selector: (state)=>state.avatarUploaded
});
module.exports["usePrincipalUser"] = $3022123db001046f$export$33e3bf16c7530dd4;
module.exports["useAvatarUploadedStatus"] = $3022123db001046f$export$b26d2c7f264f51a8;

});

parcelRegister("ecUKi", function(module, exports) {

var $9qOkK = parcelRequire("9qOkK");

// Needs to be declared here to avoid blowing up this earlyInit bundle
class $0c5ce416cf97cf51$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.name = void 0;
        this.response = void 0;
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $0c5ce416cf97cf51$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) throw new $0c5ce416cf97cf51$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $9qOkK.DEFAULT_CONFIG).stargateRoot}/me`).then((me)=>{
            return {
                userId: me.account_id,
                locale: me.locale,
                fullName: me.name,
                avatarUrl: me.picture,
                email: me.email,
                title: me.extended_profile?.job_title
            };
        });
        return this.promise;
    }
    constructor(){
        this.promise = void 0;
    }
}
const $0c5ce416cf97cf51$export$30a852ca4cb27370 = new $0c5ce416cf97cf51$export$dc10e400a1189789();
module.exports["userInfoProvider"] = $0c5ce416cf97cf51$export$30a852ca4cb27370;

});

parcelRegister("4OURt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9lcFT = parcelRequire("9lcFT");

/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */ const $7e7274fe2dbfbc96$var$useAnalytics = ()=>(0, $42omo.useContext)((0, $9lcFT.AnalyticsContext)).analytics;
var $7e7274fe2dbfbc96$export$2e2bcd8739ae039 = $7e7274fe2dbfbc96$var$useAnalytics;
module.exports["default"] = $7e7274fe2dbfbc96$export$2e2bcd8739ae039;

});

parcelRegister("jYxBx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $g58eM = parcelRequire("g58eM");

const $e8adb0147cc02fce$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getArtifact: null
});
function $e8adb0147cc02fce$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return new (0, $g58eM.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            },
            expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e8adb0147cc02fce$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $e8adb0147cc02fce$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($e8adb0147cc02fce$export$ca1b33377afa620);
function $e8adb0147cc02fce$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const { getArtifact: getArtifact } = $e8adb0147cc02fce$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}
module.exports["FlightDeckProvider"] = $e8adb0147cc02fce$export$56da85ac9d40dbcd;
module.exports["useFlightDeckContext"] = $e8adb0147cc02fce$export$73c96350a5e69ec;
module.exports["useFlightDeckArtifact"] = $e8adb0147cc02fce$export$3b241cde208d2c5e;

});

parcelRegister("e31DP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jYxBx = parcelRequire("jYxBx");


var $h4NLj = parcelRequire("h4NLj");


var $6hu6G = parcelRequire("6hu6G");

const $5e20bb9e4d5269b7$export$6620595b7f837f8f = (version, product, logger, baseUrl)=>{
    const { getArtifact: getArtifact } = (0, $jYxBx.useFlightDeckContext)();
    return (0, $42omo.useMemo)(()=>(0, $6hu6G.createActivityClient)(version, product, logger, baseUrl, // If the rw-client is wrapped in a FD provider, use the provided fetch function
        getArtifact ? ()=>getArtifact((0, $h4NLj.FD_CLIENT_FETCH_PROPS).name, (0, $h4NLj.FD_CLIENT_FETCH_PROPS).dimensions) : undefined), [
        version,
        product,
        logger,
        baseUrl,
        getArtifact
    ]);
};
module.exports["useActivityClient"] = $5e20bb9e4d5269b7$export$6620595b7f837f8f;

});

parcelRegister("jSpMW", function(module, exports) {


(function(global, factory) {
    factory(module.exports, (parcelRequire("4zBBx")), (parcelRequire("42omo")));
})(module.exports, function(exports1, lottie, React) {
    'use strict';
    function _interopDefaultLegacy(e) {
        return e && typeof e === 'object' && 'default' in e ? e : {
            'default': e
        };
    }
    var lottie__default = /*#__PURE__*/ _interopDefaultLegacy(lottie);
    var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[r] = t, e;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _objectWithoutProperties(e, t) {
        if (null == e) return {};
        var o, r, i = _objectWithoutPropertiesLoose(e, t);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
        }
        return i;
    }
    function _objectWithoutPropertiesLoose(r, e) {
        if (null == r) return {};
        var t = {};
        for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
            if (e.includes(n)) continue;
            t[n] = r[n];
        }
        return t;
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    var _excluded$1 = [
        "animationData",
        "loop",
        "autoplay",
        "initialSegment",
        "onComplete",
        "onLoopComplete",
        "onEnterFrame",
        "onSegmentStart",
        "onConfigReady",
        "onDataReady",
        "onDataFailed",
        "onLoadedImages",
        "onDOMLoaded",
        "onDestroy",
        "lottieRef",
        "renderer",
        "name",
        "assetsPath",
        "rendererSettings"
    ];
    var useLottie = function useLottie(props, style) {
        var animationData = props.animationData, loop = props.loop, autoplay = props.autoplay, initialSegment = props.initialSegment, onComplete = props.onComplete, onLoopComplete = props.onLoopComplete, onEnterFrame = props.onEnterFrame, onSegmentStart = props.onSegmentStart, onConfigReady = props.onConfigReady, onDataReady = props.onDataReady, onDataFailed = props.onDataFailed, onLoadedImages = props.onLoadedImages, onDOMLoaded = props.onDOMLoaded, onDestroy = props.onDestroy;
        props.lottieRef;
        props.renderer;
        props.name;
        props.assetsPath;
        props.rendererSettings;
        var rest = _objectWithoutProperties(props, _excluded$1);
        var _useState = React.useState(false), _useState2 = _slicedToArray(_useState, 2), animationLoaded = _useState2[0], setAnimationLoaded = _useState2[1];
        var animationInstanceRef = React.useRef();
        var animationContainer = React.useRef(null);
        /*
          ======================================
              INTERACTION METHODS
          ======================================
       */ /**
     * Play
     */ var play = function play() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.play();
        };
        /**
     * Stop
     */ var stop = function stop() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.stop();
        };
        /**
     * Pause
     */ var pause = function pause() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.pause();
        };
        /**
     * Set animation speed
     * @param speed
     */ var setSpeed = function setSpeed(speed) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSpeed(speed);
        };
        /**
     * Got to frame and play
     * @param value
     * @param isFrame
     */ var goToAndPlay = function goToAndPlay(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndPlay(value, isFrame);
        };
        /**
     * Got to frame and stop
     * @param value
     * @param isFrame
     */ var goToAndStop = function goToAndStop(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndStop(value, isFrame);
        };
        /**
     * Set animation direction
     * @param direction
     */ var setDirection = function setDirection(direction) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setDirection(direction);
        };
        /**
     * Play animation segments
     * @param segments
     * @param forceFlag
     */ var playSegments = function playSegments(segments, forceFlag) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.playSegments(segments, forceFlag);
        };
        /**
     * Set sub frames
     * @param useSubFrames
     */ var setSubframe = function setSubframe(useSubFrames) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSubframe(useSubFrames);
        };
        /**
     * Get animation duration
     * @param inFrames
     */ var getDuration = function getDuration(inFrames) {
            var _a;
            return (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getDuration(inFrames);
        };
        /**
     * Destroy animation
     */ var destroy = function destroy() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Removing the reference to the animation so separate cleanups are skipped.
            // Without it the internal `lottie-react` instance throws exceptions as it already cleared itself on destroy.
            animationInstanceRef.current = undefined;
        };
        /*
          ======================================
              LOTTIE
          ======================================
       */ /**
     * Load a new animation, and if it's the case, destroy the previous one
     * @param {Object} forcedConfigs
     */ var loadAnimation = function loadAnimation() {
            var forcedConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _a;
            // Return if the container ref is null
            if (!animationContainer.current) return;
            // Destroy any previous instance
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Build the animation configuration
            var config = _objectSpread2(_objectSpread2(_objectSpread2({}, props), forcedConfigs), {}, {
                container: animationContainer.current
            });
            // Save the animation instance
            animationInstanceRef.current = lottie__default["default"].loadAnimation(config);
            setAnimationLoaded(!!animationInstanceRef.current);
            // Return a function that will clean up
            return function() {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
                animationInstanceRef.current = undefined;
            };
        };
        /**
     * (Re)Initialize when animation data changed
     */ React.useEffect(function() {
            var onUnmount = loadAnimation();
            // Clean up on unmount
            return function() {
                return onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            animationData,
            loop
        ]);
        // Update the autoplay state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            animationInstanceRef.current.autoplay = !!autoplay;
        }, [
            autoplay
        ]);
        // Update the initial segment state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            // When null should reset to default animation length
            if (!initialSegment) {
                animationInstanceRef.current.resetSegments(true);
                return;
            }
            // If it's not a valid segment, do nothing
            if (!Array.isArray(initialSegment) || !initialSegment.length) return;
            // If the current position it's not in the new segment
            // set the current position to start
            if (animationInstanceRef.current.currentRawFrame < initialSegment[0] || animationInstanceRef.current.currentRawFrame > initialSegment[1]) animationInstanceRef.current.currentRawFrame = initialSegment[0];
            // Update the segment
            animationInstanceRef.current.setSegment(initialSegment[0], initialSegment[1]);
        }, [
            initialSegment
        ]);
        /*
          ======================================
              EVENTS
          ======================================
       */ /**
     * Reinitialize listener on change
     */ React.useEffect(function() {
            var partialListeners = [
                {
                    name: "complete",
                    handler: onComplete
                },
                {
                    name: "loopComplete",
                    handler: onLoopComplete
                },
                {
                    name: "enterFrame",
                    handler: onEnterFrame
                },
                {
                    name: "segmentStart",
                    handler: onSegmentStart
                },
                {
                    name: "config_ready",
                    handler: onConfigReady
                },
                {
                    name: "data_ready",
                    handler: onDataReady
                },
                {
                    name: "data_failed",
                    handler: onDataFailed
                },
                {
                    name: "loaded_images",
                    handler: onLoadedImages
                },
                {
                    name: "DOMLoaded",
                    handler: onDOMLoaded
                },
                {
                    name: "destroy",
                    handler: onDestroy
                }
            ];
            var listeners = partialListeners.filter(function(listener) {
                return listener.handler != null;
            });
            if (!listeners.length) return;
            var deregisterList = listeners.map(/**
       * Handle the process of adding an event listener
       * @param {Listener} listener
       * @return {Function} Function that deregister the listener
       */ function(listener) {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.addEventListener(listener.name, listener.handler);
                // Return a function to deregister this listener
                return function() {
                    var _a;
                    (_a = animationInstanceRef.current) === null || _a === void 0 || _a.removeEventListener(listener.name, listener.handler);
                };
            });
            // Deregister listeners on unmount
            return function() {
                deregisterList.forEach(function(deregister) {
                    return deregister();
                });
            };
        }, [
            onComplete,
            onLoopComplete,
            onEnterFrame,
            onSegmentStart,
            onConfigReady,
            onDataReady,
            onDataFailed,
            onLoadedImages,
            onDOMLoaded,
            onDestroy
        ]);
        /**
     * Build the animation view
     */ var View = /*#__PURE__*/ React__default["default"].createElement("div", _objectSpread2({
            style: style,
            ref: animationContainer
        }, rest));
        return {
            View: View,
            play: play,
            stop: stop,
            pause: pause,
            setSpeed: setSpeed,
            goToAndStop: goToAndStop,
            goToAndPlay: goToAndPlay,
            setDirection: setDirection,
            playSegments: playSegments,
            setSubframe: setSubframe,
            getDuration: getDuration,
            destroy: destroy,
            animationContainerRef: animationContainer,
            animationLoaded: animationLoaded,
            animationItem: animationInstanceRef.current
        };
    };
    // helpers
    function getContainerVisibility(container) {
        var _container$getBoundin = container.getBoundingClientRect(), top = _container$getBoundin.top, height = _container$getBoundin.height;
        var current = window.innerHeight - top;
        var max = window.innerHeight + height;
        return current / max;
    }
    function getContainerCursorPosition(container, cursorX, cursorY) {
        var _container$getBoundin2 = container.getBoundingClientRect(), top = _container$getBoundin2.top, left = _container$getBoundin2.left, width = _container$getBoundin2.width, height = _container$getBoundin2.height;
        var x = (cursorX - left) / width;
        var y = (cursorY - top) / height;
        return {
            x: x,
            y: y
        };
    }
    var useInitInteractivity = function useInitInteractivity(_ref) {
        var wrapperRef = _ref.wrapperRef, animationItem = _ref.animationItem, mode = _ref.mode, actions = _ref.actions;
        React.useEffect(function() {
            var wrapper = wrapperRef.current;
            if (!wrapper || !animationItem || !actions.length) return;
            animationItem.stop();
            var scrollModeHandler = function scrollModeHandler() {
                var assignedSegment = null;
                var scrollHandler = function scrollHandler() {
                    var currentPercent = getContainerVisibility(wrapper);
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref2) {
                        var visibility = _ref2.visibility;
                        return visibility && currentPercent >= visibility[0] && currentPercent <= visibility[1];
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    if (action.type === "seek" && action.visibility && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var frameToGo = action.frames[0] + Math.ceil((currentPercent - action.visibility[0]) / (action.visibility[1] - action.visibility[0]) * action.frames[1]);
                        //! goToAndStop must be relative to the start of the current segment
                        animationItem.goToAndStop(frameToGo - animationItem.firstFrame - 1, true);
                    }
                    if (action.type === "loop") {
                        // Loop: Loop a given frames
                        if (assignedSegment === null) {
                            // if not playing any segments currently. play those segments and save to state
                            animationItem.playSegments(action.frames, true);
                            assignedSegment = action.frames;
                        } else {
                            // if playing any segments currently.
                            //check if segments in state are equal to the frames selected by action
                            if (assignedSegment !== action.frames) {
                                // if they are not equal. new segments are to be loaded
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            } else if (animationItem.isPaused) {
                                // if they are equal the play method must be called only if lottie is paused
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            }
                        }
                    }
                    if (action.type === "play" && animationItem.isPaused) {
                        // Play: Reset segments and continue playing full animation from current position
                        animationItem.resetSegments(true);
                        animationItem.play();
                    }
                    if (action.type === "stop") // Stop: Stop playback
                    animationItem.goToAndStop(action.frames[0] - animationItem.firstFrame - 1, true);
                };
                document.addEventListener("scroll", scrollHandler);
                return function() {
                    document.removeEventListener("scroll", scrollHandler);
                };
            };
            var cursorModeHandler = function cursorModeHandler() {
                var handleCursor = function handleCursor(_x, _y) {
                    var x = _x;
                    var y = _y;
                    // Resolve cursor position if cursor is inside container
                    if (x !== -1 && y !== -1) {
                        // Get container cursor position
                        var pos = getContainerCursorPosition(wrapper, x, y);
                        // Use the resolved position
                        x = pos.x;
                        y = pos.y;
                    }
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref3) {
                        var position = _ref3.position;
                        if (position && Array.isArray(position.x) && Array.isArray(position.y)) return x >= position.x[0] && x <= position.x[1] && y >= position.y[0] && y <= position.y[1];
                        if (position && !Number.isNaN(position.x) && !Number.isNaN(position.y)) return x === position.x && y === position.y;
                        return false;
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    // Process action types:
                    if (action.type === "seek" && action.position && Array.isArray(action.position.x) && Array.isArray(action.position.y) && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var xPercent = (x - action.position.x[0]) / (action.position.x[1] - action.position.x[0]);
                        var yPercent = (y - action.position.y[0]) / (action.position.y[1] - action.position.y[0]);
                        animationItem.playSegments(action.frames, true);
                        animationItem.goToAndStop(Math.ceil((xPercent + yPercent) / 2 * (action.frames[1] - action.frames[0])), true);
                    }
                    if (action.type === "loop") animationItem.playSegments(action.frames, true);
                    if (action.type === "play") {
                        // Play: Reset segments and continue playing full animation from current position
                        if (animationItem.isPaused) animationItem.resetSegments(false);
                        animationItem.playSegments(action.frames);
                    }
                    if (action.type === "stop") animationItem.goToAndStop(action.frames[0], true);
                };
                var mouseMoveHandler = function mouseMoveHandler(ev) {
                    handleCursor(ev.clientX, ev.clientY);
                };
                var mouseOutHandler = function mouseOutHandler() {
                    handleCursor(-1, -1);
                };
                wrapper.addEventListener("mousemove", mouseMoveHandler);
                wrapper.addEventListener("mouseout", mouseOutHandler);
                return function() {
                    wrapper.removeEventListener("mousemove", mouseMoveHandler);
                    wrapper.removeEventListener("mouseout", mouseOutHandler);
                };
            };
            switch(mode){
                case "scroll":
                    return scrollModeHandler();
                case "cursor":
                    return cursorModeHandler();
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            mode,
            animationItem
        ]);
    };
    var useLottieInteractivity = function useLottieInteractivity(_ref4) {
        var actions = _ref4.actions, mode = _ref4.mode, lottieObj = _ref4.lottieObj;
        var animationItem = lottieObj.animationItem, View = lottieObj.View, animationContainerRef = lottieObj.animationContainerRef;
        useInitInteractivity({
            actions: actions,
            animationItem: animationItem,
            mode: mode,
            wrapperRef: animationContainerRef
        });
        return View;
    };
    var _excluded = [
        "style",
        "interactivity"
    ];
    var Lottie = function Lottie(props) {
        var _a, _b, _c;
        var style = props.style, interactivity = props.interactivity, lottieProps = _objectWithoutProperties(props, _excluded);
        /**
     * Initialize the 'useLottie' hook
     */ var _useLottie = useLottie(lottieProps, style), View = _useLottie.View, play = _useLottie.play, stop = _useLottie.stop, pause = _useLottie.pause, setSpeed = _useLottie.setSpeed, goToAndStop = _useLottie.goToAndStop, goToAndPlay = _useLottie.goToAndPlay, setDirection = _useLottie.setDirection, playSegments = _useLottie.playSegments, setSubframe = _useLottie.setSubframe, getDuration = _useLottie.getDuration, destroy = _useLottie.destroy, animationContainerRef = _useLottie.animationContainerRef, animationLoaded = _useLottie.animationLoaded, animationItem = _useLottie.animationItem;
        /**
     * Make the hook variables/methods available through the provided 'lottieRef'
     */ React.useEffect(function() {
            if (props.lottieRef) props.lottieRef.current = {
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndPlay: goToAndPlay,
                goToAndStop: goToAndStop,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            (_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current
        ]);
        return useLottieInteractivity({
            lottieObj: {
                View: View,
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndStop: goToAndStop,
                goToAndPlay: goToAndPlay,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            },
            actions: (_b = interactivity === null || interactivity === void 0 ? void 0 : interactivity.actions) !== null && _b !== void 0 ? _b : [],
            mode: (_c = interactivity === null || interactivity === void 0 ? void 0 : interactivity.mode) !== null && _c !== void 0 ? _c : "scroll"
        });
    };
    Object.defineProperty(exports1, 'LottiePlayer', {
        enumerable: true,
        get: function() {
            return lottie__default["default"];
        }
    });
    exports1["default"] = Lottie;
    exports1.useLottie = useLottie;
    exports1.useLottieInteractivity = useLottieInteractivity;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("4acD6", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $48675c89bdefef9d$export$d4c72bab9d6cc13a = {
    nudges: [],
    dailyBriefUnread: null
};
const $48675c89bdefef9d$export$e324594224ef24da = {
    setNudges: (nudges)=>({ setState: setState })=>{
            setState({
                nudges: nudges
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        },
    setDailyBriefUnread: (dailyBriefUnread)=>({ setState: setState })=>{
            setState({
                dailyBriefUnread: dailyBriefUnread
            });
        }
};
const $48675c89bdefef9d$export$72552b26ebb37b2 = (0, $1P1Tu.createStore)({
    initialState: $48675c89bdefef9d$export$d4c72bab9d6cc13a,
    actions: $48675c89bdefef9d$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $48675c89bdefef9d$export$af36d029992e7a8c = (0, $9zUhf.createActionsHook)($48675c89bdefef9d$export$72552b26ebb37b2);
module.exports["AISmartButtonStore"] = $48675c89bdefef9d$export$72552b26ebb37b2;
module.exports["useAISmartButtonActions"] = $48675c89bdefef9d$export$af36d029992e7a8c;

});

parcelRegister("1cfhF", function(module, exports) {
const $bd349f0afc0f2270$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $bd349f0afc0f2270$export$6c053e1694ef181c = {
    prod: $bd349f0afc0f2270$export$31048cb2a0753b12,
    staging: $bd349f0afc0f2270$export$9d8f18312db80469
};
const $bd349f0afc0f2270$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $bd349f0afc0f2270$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $bd349f0afc0f2270$export$54e3fc09a2a3347a;

});

parcelRegister("lfQiY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1cfhF = parcelRequire("1cfhF");


var $kfKKN = parcelRequire("kfKKN");

function $d96a3db7fec61911$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $42omo.useRef)();
    const firedViewedUIEventId = (0, $42omo.useRef)();
    const mapToCcpProductKeys = (0, $42omo.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $1cfhF.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $42omo.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $42omo.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $kfKKN.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $kfKKN.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $d96a3db7fec61911$export$c2095165ae2bdcda;

});

parcelRegister("kfKKN", function(module, exports) {
const $f3fd7ff29ab4c819$export$c536a7e29a0739b8 = 'crossFlow';
var $f3fd7ff29ab4c819$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $f3fd7ff29ab4c819$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $f3fd7ff29ab4c819$export$285f3d0989f9023f;

});

parcelRegister("7DCm4", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $399439794f928dc1$var$DEFINITIONS_COMPONENT = 'search-ai-definitions';
const $399439794f928dc1$export$5b2a28beea8d66c3 = new (0, $5aVN7.UFOExperience)(`${$399439794f928dc1$var$DEFINITIONS_COMPONENT}-load`, {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $399439794f928dc1$var$DEFINITIONS_COMPONENT
    }
});
module.exports["aiDefinitionsLoadUFOExperience"] = $399439794f928dc1$export$5b2a28beea8d66c3;

});

parcelRegister("7DA0P", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $bhuAa = parcelRequire("bhuAa");

const $6a1b9fb9a12a7345$export$2aadebb53f6015f6 = ({ children: children, style: style, shouldFillContainer: shouldFillContainer, isExpanded: isExpanded })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $bhuAa.SearchDialogWrapper), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        "data-test-id": "search-dialog-dialog-wrapper",
        tabIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: children
    });
module.exports["SearchDialog"] = $6a1b9fb9a12a7345$export$2aadebb53f6015f6;

});

parcelRegister("bhuAa", function(module, exports) {
parcelRequire("42omo");


var $2azjJ = parcelRequire("2azjJ");


var $cStGJ = parcelRequire("cStGJ");

const $c28fa387cd30d0f7$export$dcefba65c42da69c = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e101cjwc0"
})("position:relative;", (props)=>props.shouldFillContainer ? `width: 100%;` : `width: ${0, $2azjJ.dialogWidth};`, " ", (props)=>props.isExpanded && props.shouldFillContainer ? `min-width: ${0, $2azjJ.dialogWidth};` : '', " box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);border-radius:var(--ds-radius-large, 8px);background-color:var(--ds-surface-overlay, #FFFFFF);overflow:hidden;margin-top:", (0, $2azjJ.grid).px, ";:focus{outline:none;}display:flex;flex-direction:column;height:100%;@media screen and (max-width: ", (0, $2azjJ.dialogPageTakeoverWidth), "px){min-width:100%;max-width:100%;border-radius:0;margin-top:0;flex:1;overflow:auto;}");
module.exports["SearchDialogWrapper"] = $c28fa387cd30d0f7$export$dcefba65c42da69c;

});

parcelRegister("2azjJ", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line no-barrel-files/no-barrel-files






const $5648f131343e99e5$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$5648f131343e99e5$var$AkGrid(multiplier * num),
        half: ()=>$5648f131343e99e5$var$AkGrid(0.5 * num),
        twice: ()=>$5648f131343e99e5$var$AkGrid(2 * num)
    });
const $5648f131343e99e5$export$85fc379452d91af0 = $5648f131343e99e5$var$AkGrid(1);
const $5648f131343e99e5$export$b9930dabfa4a3a3 = '56px';
const $5648f131343e99e5$export$f6af7620e8789c39 = '200px';
const $5648f131343e99e5$export$64d8573e83b64ff8 = '150px';
const $5648f131343e99e5$export$a3da89b899389ed8 = '780px';
const $5648f131343e99e5$export$ce4512df260a325a = 780;
const $5648f131343e99e5$export$a406031ed42c8e02 = '1130px';
const $5648f131343e99e5$export$e00021bea368c518 = $5648f131343e99e5$export$85fc379452d91af0.multiple(4);
const $5648f131343e99e5$export$30310ee354b45eb0 = $5648f131343e99e5$export$85fc379452d91af0.multiple(6);
module.exports["grid"] = $5648f131343e99e5$export$85fc379452d91af0;
module.exports["atlassianNavigationHeight"] = $5648f131343e99e5$export$b9930dabfa4a3a3;
module.exports["collapsedSearchInputWidth"] = $5648f131343e99e5$export$f6af7620e8789c39;
module.exports["dialogWidth"] = $5648f131343e99e5$export$a3da89b899389ed8;
module.exports["dialogPageTakeoverWidth"] = $5648f131343e99e5$export$ce4512df260a325a;
module.exports["dialogPageCentreWidth"] = $5648f131343e99e5$export$a406031ed42c8e02;
module.exports["inputFieldHeight"] = $5648f131343e99e5$export$e00021bea368c518;
module.exports["enlargedInputFieldHeight"] = $5648f131343e99e5$export$30310ee354b45eb0;

});

parcelRegister("5k6WH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $uRQKa = parcelRequire("uRQKa");


var $6ttbq = parcelRequire("6ttbq");

const $479e1e8ac650b5b6$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $42omo.useState)((0, $6ttbq.isReducedMotion));
    (0, $42omo.useEffect)(()=>{
        if (!(0, $uRQKa.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $fFa3V.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $479e1e8ac650b5b6$export$c537e63161742ce3;

});

parcelRegister("h8GF6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb4c0b04d74b34ec32eb001d1db58986>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7a446cadbb9b140$var$_react = $c7a446cadbb9b140$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7a446cadbb9b140$var$_baseNew = $c7a446cadbb9b140$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7a446cadbb9b140$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CollapseVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the height of an element to its smallest size.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7a446cadbb9b140$var$CollapseVerticalIcon = (props)=>/*#__PURE__*/ $c7a446cadbb9b140$var$_react.default.createElement($c7a446cadbb9b140$var$_baseNew.default, Object.assign({
        name: "CollapseVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M0 7.25h16v1.5H0zm7.47 2.72a.75.75 0 0 1 1.06 0l3.25 3.25-1.06 1.06-1.97-1.97V16h-1.5v-3.69l-1.97 1.97-1.06-1.06zM5.28 1.72l1.97 1.97V0h1.5v3.69l1.97-1.97 1.06 1.06-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 2.78z"/>`
    }, props));
$c7a446cadbb9b140$var$CollapseVerticalIcon.displayName = 'CollapseVerticalIcon';
var $c7a446cadbb9b140$var$_default = module.exports.default = $c7a446cadbb9b140$var$CollapseVerticalIcon;

});

parcelRegister("7lL49", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $827bbb02634e926d$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    /**
   * Messages for the AI Answer Component
   */ ai_answer_component_initial_title_text: {
        id: "search_ai.ai_answer_component.initial_title_text",
        defaultMessage: "Ask questions in search and get answers based on the content you have access to"
    },
    ai_answer_component_beta_status_label: {
        id: "search_ai.ai_answer_component.beta_status_label",
        defaultMessage: "Beta"
    },
    ai_answer_component_title_text: {
        id: "search_ai.ai_answer_component.title_text",
        defaultMessage: "Atlassian Intelligence"
    },
    ai_answer_component_title_text_loading: {
        id: "search_ai.ai_answer_component.title_text_loading",
        defaultMessage: "is working..."
    },
    ai_answer_component_title_text_loading_reading_aids: {
        id: "search_ai.ai_answer_component.title_text_loading_reading_aids",
        defaultMessage: "Generating"
    },
    ai_answer_component_title_text_loaded: {
        id: "search_ai.ai_answer_component.title_text_loaded",
        defaultMessage: "Answered by"
    },
    ai_answer_component_button_text: {
        id: "ai_answer_component_button_text",
        defaultMessage: "Ask AI"
    },
    ai_answer_component_result_error_text: {
        id: "search_ai.ai_answer_component.result_error_text",
        defaultMessage: "{brandName} couldn't generate an answer for you. Try rephrasing or explore using filters in {advancedSearchLink}."
    },
    ai_answer_component_result_error_advanced_search_link: {
        id: "search_ai.ai_answer_component.result_error_advanced_search_link",
        defaultMessage: "advanced search"
    },
    ai_answer_component_source_label: {
        id: "search_ai.ai_answer_component.source_label",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    },
    ai_answer_component_reference_label: {
        id: "search_ai.ai_answer_component.reference_label",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    },
    ai_answer_component_source_page_icon_label: {
        id: "search_ai.ai_answer_component.source_page_icon_label",
        defaultMessage: "Source Page Icon"
    },
    ai_answer_expand_button_label: {
        id: "search_ai.ai_answer_component.expand_button_label",
        defaultMessage: "Show more"
    },
    ai_answer_collapse_button_label: {
        id: "search_ai.ai_answer_component.collapse_button_label",
        defaultMessage: "Show less"
    },
    ai_answer_component_information_icon_tooltip_text: {
        id: "search_ai.ai_answer_component_information_icon_tooltip_text",
        defaultMessage: "Information quality may vary. {informationLink}"
    },
    ai_answer_component_information_icon_tooltip_link: {
        id: "search_ai.ai_answer_component_information_icon_tooltip_link",
        defaultMessage: "Learn why"
    },
    ai_answer_component_feedback_label: {
        id: "search_ai.ai_answer_component_feedback_label",
        defaultMessage: "Was this helpful?"
    },
    ai_answer_component_like_button_tooltip: {
        id: "search_ai.ai_answer_component_like_button_tooltip",
        defaultMessage: "Good response"
    },
    ai_answer_component_dislike_button_tooltip: {
        id: "search_ai.ai_answer_component_dislike_button_tooltip",
        defaultMessage: "Bad response"
    },
    ai_answer_component_report_button: {
        id: "search_ai.ai_answer_component_report_button",
        defaultMessage: "Report this"
    },
    ai_answer_component_report_success_text: {
        id: "search_ai.ai_answer_component_report_success_text",
        defaultMessage: "Report submitted"
    },
    ai_answer_component_report_modal_title: {
        id: "search_ai.ai_answer_component_report_modal_title",
        defaultMessage: "Help us improve {brandName}"
    },
    ai_answer_component_report_summary_label: {
        id: "search_ai.ai_answer_component_report_summary_label",
        defaultMessage: "Was there a problem with the AI response? Let us know what happened."
    },
    ai_answer_component_report_empty_option_label: {
        id: "search_ai.ai_answer_component_report_empty_option_label",
        defaultMessage: "I want to report..."
    },
    ai_answer_component_report_empty_option_share_label: {
        id: "search_ai.ai_answer_component_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    ai_answer_component_report_consent_checkbox_label: {
        id: "search_ai.ai_answer_component_report_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    ai_answer_component_topics_not_relevant_checkbox_label: {
        id: "search_ai.ai_answer_component_topics_not_relevant_checkbox_label",
        defaultMessage: "The topics are not relevant to this person."
    },
    ai_answer_component_report_relevance_option_label: {
        id: "search_ai.ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    sac_ai_answer_component_report_relevance_option_label: {
        id: "search_ai.sac_ai_answer_component_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t accurate"
    },
    ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    ai_answer_component_report_offensive_option_label: {
        id: "search_ai.ai_answer_component_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    sac_ai_answer_component_report_unhelpful_links_option_label: {
        id: "search_ai.sac_ai_answer_component_report_unhelpful_links_option_label",
        defaultMessage: "Unhelpful links"
    },
    sac_ai_answer_component_report_inaccurate_option_label: {
        id: "search_ai.sac_ai_answer_component_report_inaccurate_option_label",
        defaultMessage: "Too slow"
    },
    ai_answer_component_report_other_option_label: {
        id: "search_ai.ai_answer_component_report_other_option_label",
        defaultMessage: "Something else"
    },
    sac_ai_answer_component_report_other_option_label: {
        id: "search_ai.sac_ai_answer_component_report_other_option_label",
        defaultMessage: "Other"
    },
    ai_answer_component_report_details_label: {
        id: "search_ai.ai_answer_component_report_details_label",
        defaultMessage: "Describe the issue"
    },
    ai_answer_component_feedback_flag_description: {
        id: "search_ai.ai_answer_component_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    },
    ai_answer_component_summary_placeholder_label: {
        id: "search_ai.ai_answer_component_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    ai_answer_component_followups_label: {
        id: "search_ai.ai_answer_component_followups_label",
        defaultMessage: "Ask a follow up question"
    },
    ai_answer_component_error_state_subjective_query: {
        id: "search_ai.ai_answer_component_error_state_subjective_query",
        defaultMessage: "That seems like a subjective question, so {brandName} can\u2019t answer it for you right now."
    },
    ai_answer_component_error_state_keyword: {
        id: "search_ai.ai_answer_component_error_state_keyword",
        defaultMessage: "{brandName} couldn\u2019t understand your question, possibly because it didn\u2019t include enough details. Try rephrasing your question, or including some more specific details. {learnMoreLink}"
    },
    ai_answer_component_error_state_acceptable_use: {
        id: "search_ai.ai_answer_component_error_state_acceptable_use",
        defaultMessage: "{brandName} can\u2019t provide you with a response, as it might go against {acceptableUseLink}. Please try asking another question."
    },
    ai_answer_component_error_state_acceptable_use_link: {
        id: "search_ai.ai_answer_component_error_state_acceptable_use_link",
        defaultMessage: "Atlassian's acceptable use policy"
    },
    ai_answer_component_error_state_network: {
        id: "search_ai.ai_answer_component_error_state_network",
        defaultMessage: "{brandName} can't provide a response right now. Read more in our {supportLink}."
    },
    ai_answer_component_error_state_hipaa: {
        id: "search_ai.ai_answer_component_error_state_hipaa",
        defaultMessage: "Due to HIPAA compliance, we can\u2019t provide an answer. {supportLink}."
    },
    ai_answer_component_error_state_no_answer: {
        id: "search_ai.ai_answer_component_error_state_no_answer",
        defaultMessage: "{brandName} doesn\u2019t have enough data to provide a response right now. It\u2019s possible that we couldn\u2019t find the relevant information in your company\u2019s knowledge base. Try rephrasing your question, or including some more specific details. {learnMoreLink}"
    },
    ai_answer_component_open_ai_rate_limit_error: {
        id: "search_ai.ai_answer_component_open_ai_rate_limit_error",
        defaultMessage: "Excessive use has been detected with {brandName}. Try again later. Read more in our {supportLink}."
    },
    ai_answer_component_support_link: {
        id: "search_ai.ai_answer_component_support_link",
        defaultMessage: "support documentation"
    },
    ai_answer_component_hipaa_compliance_link: {
        id: "search_ai.ai_answer_component_hipaa_compliance_link",
        defaultMessage: "Find out more about HIPAA"
    },
    ai_answer_component_error_state_no_who_is_answer: {
        id: "search_ai.ai_answer_component_error_state_no_who_is_answer",
        defaultMessage: "{brandName} couldn\u2019t find a match for this person in your organisation. It\u2019s possible that there was a misspelling in your search, this person goes by another name, or that this person doesn\u2019t work here."
    },
    ai_answer_component_disclaimer_who_question: {
        id: "search_ai.ai_answer_component_disclaimer_who_question",
        defaultMessage: "This information is solely based on what\u2019s in your knowledge base and may not always be accurate."
    },
    ai_answer_permission_label: {
        id: "search_ai.ai_answer_permission_label",
        defaultMessage: "Answers may include information from pages that are restricted to others but visible to you."
    },
    ai_answer_dialog_cancel_label: {
        id: "search_ai.ai_answer_dialog_cancel_label",
        defaultMessage: "Dive deeper into the {searchResultsLink}"
    },
    ai_answer_dialog_search_results_label: {
        id: "search_ai.ai_answer_dialog_search_results_label",
        defaultMessage: "search results"
    },
    ai_answer_dialog_teams_not_found_message: {
        id: "search_ai.ai_answer_dialog_teams_not_found_message",
        defaultMessage: "Some teams may not be found on this site due to"
    },
    ai_answer_dialog_teams_not_found_message_link: {
        id: "search_ai.ai_answer_dialog_teams_not_found_message_link",
        defaultMessage: "changes in team visibility."
    },
    ai_answer_onboarding_banner_title: {
        id: "search_ai.ai_answer_onboarding_banner_title",
        defaultMessage: "Try Atlassian Intelligence in search"
    },
    ai_answer_onboarding_banner_v1_info: {
        id: "search_ai.ai_answer_onboarding_banner_v1_info",
        defaultMessage: "<b>Example:</b>How do I submit expenses for reimbursement?"
    },
    ai_answer_onboarding_banner_info: {
        id: "search_ai.ai_answer_onboarding_banner_info",
        defaultMessage: "Ask about a project or topic within your company\u2019s knowledge base. {informationLink}"
    },
    ai_answer_onboarding_banner_tooltip_link: {
        id: "search_ai.ai_answer_onboarding_banner_tooltip_link",
        defaultMessage: "Learn more"
    },
    ai_answer_onboarding_close_button_text: {
        id: "search_ai.ai_answer_onboarding_close_button_text",
        defaultMessage: "Close"
    },
    ai_answer_onboarding_banner_example_query_vacation_policy: {
        id: "search_ai.ai_answer_onboarding_banner_example_query_vacation_policy",
        defaultMessage: "What is the vacation policy?"
    },
    ai_answer_onboarding_banner_example_query_expenses: {
        id: "search_ai.ai_answer_onboarding_banner_example_query_expenses",
        defaultMessage: "How to submit expenses for reimbursement?"
    },
    ai_answer_dialog_loaded_footer_sac: {
        id: "search_ai.ai_answer_dialog_loaded_footer_sac",
        defaultMessage: "Powered by AI"
    },
    ai_answer_dialog_loaded_footer: {
        id: "search_ai.ai_answer_dialog_loaded_footer",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    ai_answer_dialog_footer_more_options_tooltip: {
        id: "search_ai.ai_answer_dialog_footer_more_options_tooltip",
        defaultMessage: "More options"
    },
    ai_answer_dialog_updated: {
        id: "search_ai.ai_answer_dialog_updated",
        defaultMessage: "Updated"
    },
    ai_answer_who_questions_frequent_locations_header: {
        id: "search_ai.ai_answer_who_questions_frequent_locations_header",
        defaultMessage: "Frequent locations"
    },
    ai_answer_who_questions_frequent_collaborators_header: {
        id: "search_ai.ai_answer_who_questions_frequent_collaborators_header",
        defaultMessage: "Frequent collaborators"
    },
    ai_answer_who_question_team_section_member_count: {
        id: "search_ai.ai_answer_who_question_team_section_member_count",
        defaultMessage: "{count, plural, =0 {No members} one {# member} other {# members}}"
    },
    ai_answer_who_questions_teams_header: {
        id: "search_ai.ai_answer_who_questions_teams_header",
        defaultMessage: "Teams"
    },
    ai_answer_who_questions_view_profile: {
        id: "search_ai.ai_answer_who_questions_view_profile",
        defaultMessage: "View profile"
    },
    ai_answer_who_questions_hover_role_icon: {
        id: "search_ai.ai_answer_who_questions_hover_role_icon",
        defaultMessage: "Role"
    },
    ai_answer_who_questions_hover_department_icon: {
        id: "search_ai.ai_answer_who_questions_hover_department_icon",
        defaultMessage: "Department"
    },
    ai_answer_who_questions_hover_location_icon: {
        id: "search_ai.ai_answer_who_questions_hover_location_icon",
        defaultMessage: "Location"
    },
    ai_answer_who_questions_hover_local_time_icon: {
        id: "search_ai.ai_answer_who_questions_hover_local_time_icon",
        defaultMessage: "Local time"
    },
    ai_answer_who_questions_hover_email_icon: {
        id: "search_ai.ai_answer_who_questions_hover_email_icon",
        defaultMessage: "Email"
    },
    ai_answer_who_questions_footer_header: {
        id: "search_ai.ai_answer_who_questions_footer_header",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numMatches} additional {numMatches, plural, =1 {match} other {matches}}"
    },
    ai_answer_dialog_footer_content_quality_short: {
        id: "search_ai.ai_answer_dialog_footer_content_quality_short",
        defaultMessage: "Uses AI. Verify results."
    },
    ai_answer_dialog_footer_beta_tag: {
        id: "search_ai.ai_answer_dialog_footer_beta_tag",
        defaultMessage: "BETA"
    },
    ai_answer_dialog_footer_content_quality_long: {
        id: "search_ai.ai_answer_dialog_footer_content_quality_long",
        defaultMessage: "Uses AI. Verify results."
    },
    reading_aids_dialog_information_icon_tooltip_link: {
        id: "search_ai.reading_aids_dialog_information_icon_tooltip_link",
        defaultMessage: "Learn more"
    },
    reading_aids_dialog_loaded_footer: {
        id: "search_ai.reading_aids_dialog_loaded_footer",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    reading_aids_dialog_disclaimer: {
        id: "search_ai.reading_aids_dialog_disclaimer",
        defaultMessage: "Information may vary."
    },
    reading_aids_dialog_disclaimer_link: {
        id: "search_ai.reading_aids_dialog_disclaimer_link",
        defaultMessage: "Learn why"
    },
    reading_aids_defined_by: {
        id: "search_ai.reading_aids_dialog_defined_by",
        defaultMessage: "Defined by"
    },
    reading_aids_see_edit_history: {
        id: "search_ai.reading_aids_dialog_see_edit_history",
        defaultMessage: "See all edit history"
    },
    ai_answer_admin_message: {
        id: "search_ai.ai_answer_admin_message",
        defaultMessage: "Unleash the knowledge in your Confluence by asking questions in search and getting answers from Atlassian Intelligence."
    },
    ai_answer_admin_turn_on_atlassian_intelligence: {
        id: "search_ai.ai_admin_turn_on_atlassian_intelligence",
        defaultMessage: "Turn on Atlassian Intelligence"
    },
    ai_answer_admin_info_popup_header: {
        id: "search_ai.ai_answer_admin_info_popup_header",
        defaultMessage: "Get answers from Atlassian Intelligence in search"
    },
    ai_answer_admin_info_popup_banner_alt_text: {
        id: "search_ai.ai_answer_admin_info_popup_banner_alt_text",
        defaultMessage: "Search input with example query \"What is the vacation policy?\""
    },
    ai_answer_admin_info_popup_link: {
        id: "search_ai.ai_answer_admin_info_popup_link",
        defaultMessage: "Learn more about Atlassian Intelligence"
    },
    ai_answer_admin_info_popup_dismiss: {
        id: "search_ai.ai_answer_admin_info_popup_dismiss",
        defaultMessage: "Dismiss"
    },
    ai_answer_generating_text: {
        id: "search_ai.ai_answer_generating_text",
        defaultMessage: "Generating"
    },
    ai_answer_generating_rovo: {
        id: "ai_answer_generating_rovo",
        defaultMessage: "Generating"
    },
    ai_answer_generating_icon_alt_text: {
        id: "search_ai.ai_answer_generating_icon_alt_text",
        defaultMessage: "Generating icon"
    },
    ai_answer_button_tooltip_message: {
        id: "search_ai_answer_prompt.ask_ai_button.tooltip",
        defaultMessage: "Ask a question in search to get an answer from Atlassian Intelligence"
    },
    ai_answer_reading_aids_banner_header: {
        id: "search_ai.reading_aids.banner_header",
        defaultMessage: "Define any term with AI, not just acronyms"
    },
    ai_answer_reading_aids_banner_description: {
        id: "search_ai.reading_aids.banner_description",
        defaultMessage: "Get definitions for project terms, team names and more. Just highlight the word or phrase, then select <b>Define</b>."
    },
    reading_aids_edited_definition_report_modal_title: {
        id: "search_ai.reading_aids_edited_definition_report_modal_title",
        defaultMessage: "Help us improve Definitions"
    },
    reading_aids_edited_definition_report_label: {
        id: "search_ai.reading_aids_edited_definition_report_label",
        defaultMessage: "Was there a problem with this definition? Let us know what happened."
    },
    knowledge_cards_view_team: {
        id: "search_ai.knowledge_cards.view_team",
        defaultMessage: "View team"
    },
    knowledge_cards_team_subheader: {
        id: "search_ai.knowledge_cards.team_subheader",
        defaultMessage: "Team"
    },
    knowledge_cards_copy_email_address: {
        id: "search_ai.knowledge_cards.copy_email_address",
        defaultMessage: "Copy email address"
    },
    knowledge_cards_recent_work_subheader: {
        id: "search_ai.knowledge_cards.recent_work_subheader",
        defaultMessage: "Recent work"
    },
    knowledge_cards_worked_on_subheader: {
        id: "search_ai.knowledge_cards.worked_on_subheader",
        defaultMessage: "Worked on"
    },
    knowledge_cards_collaborators_subheader: {
        id: "search_ai.knowledge_cards.collaborators_subheader",
        defaultMessage: "Collaborators"
    },
    knowledge_cards_recent_work_empty: {
        id: "search_ai.knowledge_cards.recent_work_empty",
        defaultMessage: "No recent work"
    },
    knowledge_cards_collaborators_empty: {
        id: "search_ai.knowledge_cards.collaborators_empty",
        defaultMessage: "No recent collaborators"
    },
    knowledge_cards_teammembers_empty: {
        id: "search_ai.knowledge_cards.teammembers_empty",
        defaultMessage: "No team members"
    },
    knowledge_cards_view_all_link: {
        id: "search_ai.knowledge_cards.view_all_link",
        defaultMessage: "View all"
    },
    knowledge_cards_team_members_subheader: {
        id: "search_ai.knowledge_cards.team_members_subheader",
        defaultMessage: "Team members"
    },
    knowledge_cards_view_agent: {
        id: "search_ai.knowledge_cards.view_agent",
        defaultMessage: "View agent"
    },
    knowledge_cards_agent_subheader: {
        id: "search_ai.knowledge_cards.agent_subheader",
        defaultMessage: "AI Agent"
    },
    knowledge_cards_rovo_agent_by: {
        id: "search_ai.knowledge_cards.rovo_agent_by",
        defaultMessage: "by"
    },
    knowledge_cards_teams_subheader: {
        id: "search_ai.knowledge_cards.teams_subheader",
        defaultMessage: "Teams"
    },
    knowledge_cards_team_member_count: {
        id: "search_ai.knowledge_cards.team_member_count",
        defaultMessage: "{count} members"
    },
    knowledge_cards_person_hover_profile_link: {
        id: "search_ai.knowledge_cards.person_hover_profile_link",
        defaultMessage: "View profile"
    },
    ai_answer_onboarding_banner_info_galaxia: {
        id: "search_ai.ai_answer_onboarding_banner_info-galaxia",
        defaultMessage: "Ask about a space or topic within your company\u2019s knowledge base. {informationLink}"
    },
    ai_answer_reading_aids_banner_description_galaxia: {
        id: "search_ai.reading_aids.banner_description-galaxia",
        defaultMessage: "Get definitions for space terms, team names and more. Just highlight the word or phrase, then select <b>Define</b>."
    },
    knowledge_cards_person_org_chart_label: {
        id: "search_ai.knowledge_cards_person_org_chart_label",
        defaultMessage: "Reporting line"
    },
    knowledge_cards_person_org_chart_modal_header: {
        id: "search_ai.knowledge_cards_person_org_chart_modal_header",
        defaultMessage: "Reporting Line"
    },
    ai_answer_sac_feedback_option_not_relevant: {
        id: "search_ai.sac_feedback_option_not_relevant",
        defaultMessage: "Wasn't relevant"
    },
    ai_answer_sac_feedback_option_not_accurate: {
        id: "search_ai.sac_feedback_option_not_accurate",
        defaultMessage: "Wasn't accurate"
    },
    ai_answer_sac_feedback_option_too_slow: {
        id: "search_ai.sac_feedback_option_too_slow",
        defaultMessage: "Too slow"
    },
    ai_answer_sac_feedback_option_unhelpful: {
        id: "search_ai.sac_feedback_option_unhelpful",
        defaultMessage: "Unhelpful links"
    },
    ai_answer_sac_feedback_option_other: {
        id: "search_ai.sac_feedback_option_other",
        defaultMessage: "Other"
    }
});
module.exports["messages"] = $827bbb02634e926d$export$defe85febe8b728c;

});

parcelRegister("ab1fW", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lBFuf = parcelRequire("lBFuf");


var $kIvLT = parcelRequire("kIvLT");


var $jA9SA = parcelRequire("jA9SA");

const $de70ae3c39f94954$export$668058776bea98f5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ onClick: onButtonClick, experienceId: experienceId, followUpIndex: followUpIndex, followUpType: followUpType, followUpText: followUpText, ...props }, ref)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const analyticsPropertiesRef = (0, $42omo.useRef)();
    analyticsPropertiesRef.current = {
        followUpIndex: followUpIndex,
        followUpType: followUpType,
        followUpLength: followUpText.length,
        ...experienceId ? {
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).experienceId]: experienceId
        } : {}
    };
    (0, $42omo.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'screen',
            name: 'followUpQueryButton',
            attributes: analyticsPropertiesRef.current
        });
    }, [
        sendAnalyticsEvent
    ]);
    const onClick = (0, $42omo.useCallback)((_, analyticsEvent)=>{
        sendAnalyticsEvent(analyticsEvent.update({
            actionSubjectId: 'followUpQueryButton',
            attributes: {
                ...analyticsEvent.payload.attributes,
                ...analyticsPropertiesRef.current
            }
        }));
        onButtonClick();
    }, [
        onButtonClick,
        sendAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lBFuf.ChatPill), {
        onClick: onClick,
        ...props,
        ref: ref,
        children: followUpText
    });
});
module.exports["FollowUpButton"] = $de70ae3c39f94954$export$668058776bea98f5;

});

parcelRegister("2YIh2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $4JDbp = parcelRequire("4JDbp");


var $g91Ox = parcelRequire("g91Ox");

const $2fb19ef32ab04e83$var$AVATAR_BREAKPOINT = 180;
const $2fb19ef32ab04e83$var$unbouncedStyles = {
    name: "_11c81qyo _1reo15vq _18m915vq _k48p1wq8 _y3gn1h6o _1bto1l2s _1e0ccj1k _sudp1e54 _1yyjcs5v"
};
const $2fb19ef32ab04e83$var$styles = {
    emptyLine: "_4t3igktf"
};
function $2fb19ef32ab04e83$export$4c094c8f61edecb4({ data: { avatarUrl: avatarUrl, id: id, name: name, jobTitle: jobTitle, location: location, localTime: localTime } }) {
    const shouldShowEmptyLine = !jobTitle && !location && !localTime;
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(0);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $g91Ox.PersonCardWrapper), {
        id: id,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.default), {
                setWidth: setWidth
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.150",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                        src: avatarUrl,
                        name: name,
                        size: width < $2fb19ef32ab04e83$var$AVATAR_BREAKPOINT ? 'xlarge' : 'xxlarge'
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.050",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                as: "h2",
                                xcss: $2fb19ef32ab04e83$var$unbouncedStyles.name,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                maxLines: 2,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: jobTitle
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                maxLines: 1,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: [
                                    location,
                                    localTime
                                ].filter(Boolean).join(' ')
                            }),
                            shouldShowEmptyLine && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $2fb19ef32ab04e83$var$styles.emptyLine
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
module.exports["PersonCard"] = $2fb19ef32ab04e83$export$4c094c8f61edecb4;

});

parcelRegister("g91Ox", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $ead1b65abe4e11c5$var$wrapperStyles = {
    root: "_2rko1mok _v564nm7n _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq _4t3i1osq _1ul91lit _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _kqswh2mm _9oik1r31 _1bnxglyw _jf4cnqa1 _d0altlke _1s5z1k61 _le1b1cqc _73vx1ytf _1gav5cps"
};
const $ead1b65abe4e11c5$export$a3474cd1dd8e70a = ({ id: id, children: children, testId: testId })=>{
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ead1b65abe4e11c5$var$wrapperStyles.root),
        backgroundColor: isHovered ? 'elevation.surface.hovered' : 'elevation.surface',
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: testId || `person-card-${id}`,
        children: children
    });
};
module.exports["PersonCardWrapper"] = $ead1b65abe4e11c5$export$a3474cd1dd8e70a;

});

parcelRegister("bvjDB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63af381965cffd1b2653ae2b97232288>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8601d29e65a3bd86$var$_react = $8601d29e65a3bd86$var$_interopRequireDefault((parcelRequire("42omo")));

var $8601d29e65a3bd86$var$_baseNew = $8601d29e65a3bd86$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8601d29e65a3bd86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minimize".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for minimizing or docking modals to the bottom of the viewport.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8601d29e65a3bd86$var$MinimizeIcon = (props)=>/*#__PURE__*/ $8601d29e65a3bd86$var$_react.default.createElement($8601d29e65a3bd86$var$_baseNew.default, Object.assign({
        name: "MinimizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 14H2v-1.5h12z" clip-rule="evenodd"/>`
    }, props));
$8601d29e65a3bd86$var$MinimizeIcon.displayName = 'MinimizeIcon';
var $8601d29e65a3bd86$var$_default = module.exports.default = $8601d29e65a3bd86$var$MinimizeIcon;

});

parcelRegister("39EIK", function(module, exports) {
/* knowledge-cards-topics.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $aK1zu = parcelRequire("aK1zu");

const $7dad6b71e18043a2$var$styles = {
    root: ""
};
const $7dad6b71e18043a2$export$71025593c3acaa9c = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $7dad6b71e18043a2$var$styles.root,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aK1zu.AITopicsByPerson), {
            ...props
        })
    });
};
module.exports["KnowledgeCardsTopics"] = $7dad6b71e18043a2$export$71025593c3acaa9c;

});

parcelRegister("9D6Kx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::240d2a2d2ecd17e4d685f807cd1b54f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $702cfde9ca1d470b$var$_react = $702cfde9ca1d470b$var$_interopRequireDefault((parcelRequire("42omo")));

var $702cfde9ca1d470b$var$_baseNew = $702cfde9ca1d470b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $702cfde9ca1d470b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $702cfde9ca1d470b$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $702cfde9ca1d470b$var$_react.default.createElement($702cfde9ca1d470b$var$_baseNew.default, Object.assign({
        name: "BookWithBookmarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$702cfde9ca1d470b$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $702cfde9ca1d470b$var$_default = module.exports.default = $702cfde9ca1d470b$var$BookWithBookmarkIcon;

});

parcelRegister("aUwPP", function(module, exports) {

var $9LRzA = parcelRequire("9LRzA");


var $5abq6 = parcelRequire("5abq6");


var $b9lC3 = parcelRequire("b9lC3");


var $87fJd = parcelRequire("87fJd");

const $8f944f557ac62b40$export$171e576bb7c729fa = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $9LRzA.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $b9lC3.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $b9lC3.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $b9lC3.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: (indentationMark?.attrs.level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $87fJd.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
module.exports["indentationPlugin"] = $8f944f557ac62b40$export$171e576bb7c729fa;

});

parcelRegister("b9lC3", function(module, exports) {

var $aU3dp = parcelRequire("aU3dp");

var $d925B = parcelRequire("d925B");


var $dhoHU = parcelRequire("dhoHU");


var $5abq6 = parcelRequire("5abq6");


var $kecXX = parcelRequire("kecXX");


var $by9bj = parcelRequire("by9bj");

const $a4290f7701cf1730$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $a4290f7701cf1730$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $dhoHU.toggleBlockMark)(indentation, getNewIndentationAttrs, $a4290f7701cf1730$export$54db194d337db321)(state, dispatch);
    };
}
function $a4290f7701cf1730$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $kecXX.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $a4290f7701cf1730$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $by9bj.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $5abq6.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $a4290f7701cf1730$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getIndentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $a4290f7701cf1730$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $a4290f7701cf1730$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>$a4290f7701cf1730$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $a4290f7701cf1730$var$getOutdentAttrs,
            direction: (0, $aU3dp.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $a4290f7701cf1730$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $dhoHU.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);
module.exports["isIndentationAllowed"] = $a4290f7701cf1730$export$54db194d337db321;
module.exports["getIndentCommand"] = $a4290f7701cf1730$export$b294289254b8cdac;
module.exports["getOutdentCommand"] = $a4290f7701cf1730$export$620b2a1f10eb3a5f;

});

parcelRegister("kecXX", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d4de3432317ffe3$export$2e2bcd8739ae039);
function $2d4de3432317ffe3$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("by9bj", function(module, exports) {

var $d925B = parcelRequire("d925B");

var $aU3dp = parcelRequire("aU3dp");

const $a44445544afb543f$var$indentTypes = {
    paragraph: (0, $aU3dp.INDENT_TYPE).PARAGRAPH,
    heading: (0, $aU3dp.INDENT_TYPE).HEADING
};
function $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $a44445544afb543f$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $a44445544afb543f$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $a44445544afb543f$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $a44445544afb543f$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $a44445544afb543f$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $a44445544afb543f$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}
module.exports["createAnalyticsDispatch"] = $a44445544afb543f$export$4f15b45384b61427;

});

parcelRegister("87fJd", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $kTbzR = parcelRequire("kTbzR");


var $dus6D = parcelRequire("dus6D");


var $8m4tT = parcelRequire("8m4tT");


var $b9lC3 = parcelRequire("b9lC3");

function $e60d68c782a1a955$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && parent?.type === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $b9lC3.getIndentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.outdent)), (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $kTbzR.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $8m4tT.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $b9lC3.getOutdentCommand)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}
var $e60d68c782a1a955$export$2e2bcd8739ae039 = $e60d68c782a1a955$export$e832373cff8dec22;
module.exports["keymapPlugin"] = $e60d68c782a1a955$export$e832373cff8dec22;

});

parcelRegister("bTdbD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48827792ad56aec1327e3c5557d624a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a7f0f5cf9a8ca34$var$_react = $8a7f0f5cf9a8ca34$var$_interopRequireDefault((parcelRequire("42omo")));

var $8a7f0f5cf9a8ca34$var$_baseNew = $8a7f0f5cf9a8ca34$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $8a7f0f5cf9a8ca34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a7f0f5cf9a8ca34$var$PagesIcon = (props)=>/*#__PURE__*/ $8a7f0f5cf9a8ca34$var$_react.default.createElement($8a7f0f5cf9a8ca34$var$_baseNew.default, Object.assign({
        name: "PagesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$8a7f0f5cf9a8ca34$var$PagesIcon.displayName = 'PagesIcon';
var $8a7f0f5cf9a8ca34$var$_default = module.exports.default = $8a7f0f5cf9a8ca34$var$PagesIcon;

});

parcelRegister("lM0k7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f9c25083e911723e75d25e884618325>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd9e54e9a7d9c520$var$_react = $fd9e54e9a7d9c520$var$_interopRequireDefault((parcelRequire("42omo")));

var $fd9e54e9a7d9c520$var$_baseNew = $fd9e54e9a7d9c520$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fd9e54e9a7d9c520$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: 'Design task' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd9e54e9a7d9c520$var$PenIcon = (props)=>/*#__PURE__*/ $fd9e54e9a7d9c520$var$_react.default.createElement($fd9e54e9a7d9c520$var$_baseNew.default, Object.assign({
        name: "PenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.72.72a.75.75 0 0 1 .73-.194l9.167 2.522a2 2 0 0 1 1.461 1.739l.294 3.083a2 2 0 0 1 2.042.483L15.78 9.72a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0l-1.366-1.366a2 2 0 0 1-.484-2.042l-3.083-.294a2 2 0 0 1-1.74-1.46L.528 1.448A.75.75 0 0 1 .72.72m12.634 8.694a.5.5 0 0 0-.707 0l-3.233 3.232a.5.5 0 0 0 0 .707l.836.836 3.94-3.94zM6.636 5.575a1.624 1.624 0 0 1 2.114 1.55 1.625 1.625 0 1 1-3.175-.49l-2.85-2.85 1.77 6.435a.5.5 0 0 0 .435.365l4.04.384 1.999-2-.384-4.04a.5.5 0 0 0-.365-.435l-6.435-1.77z" clip-rule="evenodd"/>`
    }, props));
$fd9e54e9a7d9c520$var$PenIcon.displayName = 'PenIcon';
var $fd9e54e9a7d9c520$var$_default = module.exports.default = $fd9e54e9a7d9c520$var$PenIcon;

});

parcelRegister("eLJ6t", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // want color of icon to be the same for regular/light/dark modes

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $4af0d4a8e674c639$export$eaf821108be3620b = ({ size: size = 'small', greyed: greyed = false })=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.5 15.3L17.5 18.3",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.5 15.3L6.5 18.3",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.5 10.3L6.5 7.30002",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.5 10.3L17.5 7.30002",
                stroke: "#626F86",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.0001 16.8V19.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M8.00012 12.8L5.00012 12.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.0001 8.80003L12.0001 5.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.0002 12.8L19.0002 12.8",
                stroke: "#626F86",
                strokeWidth: "1.5"
            })
        ]
    });
var $4af0d4a8e674c639$export$2e2bcd8739ae039 = $4af0d4a8e674c639$export$eaf821108be3620b;
module.exports["default"] = $4af0d4a8e674c639$export$2e2bcd8739ae039;

});

parcelRegister("6bRC8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Doctype = module.exports.CDATA = module.exports.Tag = module.exports.Style = module.exports.Script = module.exports.Comment = module.exports.Directive = module.exports.Text = module.exports.Root = module.exports.isTag = module.exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */ var $481d5bd0dde00292$var$ElementType;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($481d5bd0dde00292$var$ElementType = module.exports.ElementType || (module.exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */ function $481d5bd0dde00292$var$isTag(elem) {
    return elem.type === $481d5bd0dde00292$var$ElementType.Tag || elem.type === $481d5bd0dde00292$var$ElementType.Script || elem.type === $481d5bd0dde00292$var$ElementType.Style;
}
module.exports.isTag = $481d5bd0dde00292$var$isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */ module.exports.Root = $481d5bd0dde00292$var$ElementType.Root;
/** Type for Text */ module.exports.Text = $481d5bd0dde00292$var$ElementType.Text;
/** Type for <? ... ?> */ module.exports.Directive = $481d5bd0dde00292$var$ElementType.Directive;
/** Type for <!-- ... --> */ module.exports.Comment = $481d5bd0dde00292$var$ElementType.Comment;
/** Type for <script> tags */ module.exports.Script = $481d5bd0dde00292$var$ElementType.Script;
/** Type for <style> tags */ module.exports.Style = $481d5bd0dde00292$var$ElementType.Style;
/** Type for Any tag */ module.exports.Tag = $481d5bd0dde00292$var$ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */ module.exports.CDATA = $481d5bd0dde00292$var$ElementType.CDATA;
/** Type for <!doctype ...> */ module.exports.Doctype = $481d5bd0dde00292$var$ElementType.Doctype;

});

parcelRegister("7Rnqo", function(module, exports) {
module.exports = {
    trueFunc: function trueFunc() {
        return true;
    },
    falseFunc: function falseFunc() {
        return false;
    }
};

});

parcelRegister("fftKo", function(module, exports) {

var $bGFyo = parcelRequire("bGFyo");

const $b19f54e58e62e654$var$reName = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/;
const $b19f54e58e62e654$var$reEscape = /\\([\da-f]{1,6}\s?|(\s)|.)/gi;
const $b19f54e58e62e654$var$actionTypes = new Map([
    [
        126 /* Tilde */ ,
        (0, $bGFyo.AttributeAction).Element
    ],
    [
        94 /* Circumflex */ ,
        (0, $bGFyo.AttributeAction).Start
    ],
    [
        36 /* Dollar */ ,
        (0, $bGFyo.AttributeAction).End
    ],
    [
        42 /* Asterisk */ ,
        (0, $bGFyo.AttributeAction).Any
    ],
    [
        33 /* ExclamationMark */ ,
        (0, $bGFyo.AttributeAction).Not
    ],
    [
        124 /* Pipe */ ,
        (0, $bGFyo.AttributeAction).Hyphen
    ]
]);
// Pseudos, whose data property is parsed as well.
const $b19f54e58e62e654$var$unpackPseudos = new Set([
    "has",
    "not",
    "matches",
    "is",
    "where",
    "host",
    "host-context"
]);
function $b19f54e58e62e654$export$41d1fe2780697dca(selector) {
    switch(selector.type){
        case (0, $bGFyo.SelectorType).Adjacent:
        case (0, $bGFyo.SelectorType).Child:
        case (0, $bGFyo.SelectorType).Descendant:
        case (0, $bGFyo.SelectorType).Parent:
        case (0, $bGFyo.SelectorType).Sibling:
        case (0, $bGFyo.SelectorType).ColumnCombinator:
            return true;
        default:
            return false;
    }
}
const $b19f54e58e62e654$var$stripQuotesFromPseudos = new Set([
    "contains",
    "icontains"
]);
// Unescape function taken from https://github.com/jquery/sizzle/blob/master/src/sizzle.js#L152
function $b19f54e58e62e654$var$funescape(_, escaped, escapedWhitespace) {
    const high = parseInt(escaped, 16) - 0x10000;
    // NaN means non-codepoint
    return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xd800, high & 0x3ff | 0xdc00);
}
function $b19f54e58e62e654$var$unescapeCSS(str) {
    return str.replace($b19f54e58e62e654$var$reEscape, $b19f54e58e62e654$var$funescape);
}
function $b19f54e58e62e654$var$isQuote(c) {
    return c === 39 /* SingleQuote */  || c === 34 /* DoubleQuote */ ;
}
function $b19f54e58e62e654$var$isWhitespace(c) {
    return c === 32 /* Space */  || c === 9 /* Tab */  || c === 10 /* NewLine */  || c === 12 /* FormFeed */  || c === 13 /* CarriageReturn */ ;
}
function $b19f54e58e62e654$export$98e6a39c04603d36(selector) {
    const subselects = [];
    const endIndex = $b19f54e58e62e654$var$parseSelector(subselects, `${selector}`, 0);
    if (endIndex < selector.length) throw new Error(`Unmatched selector: ${selector.slice(endIndex)}`);
    return subselects;
}
function $b19f54e58e62e654$var$parseSelector(subselects, selector, selectorIndex) {
    let tokens = [];
    function getName(offset) {
        const match = selector.slice(selectorIndex + offset).match($b19f54e58e62e654$var$reName);
        if (!match) throw new Error(`Expected name, found ${selector.slice(selectorIndex)}`);
        const [name] = match;
        selectorIndex += offset + name.length;
        return $b19f54e58e62e654$var$unescapeCSS(name);
    }
    function stripWhitespace(offset) {
        selectorIndex += offset;
        while(selectorIndex < selector.length && $b19f54e58e62e654$var$isWhitespace(selector.charCodeAt(selectorIndex)))selectorIndex++;
    }
    function readValueWithParenthesis() {
        selectorIndex += 1;
        const start = selectorIndex;
        let counter = 1;
        for(; counter > 0 && selectorIndex < selector.length; selectorIndex++){
            if (selector.charCodeAt(selectorIndex) === 40 /* LeftParenthesis */  && !isEscaped(selectorIndex)) counter++;
            else if (selector.charCodeAt(selectorIndex) === 41 /* RightParenthesis */  && !isEscaped(selectorIndex)) counter--;
        }
        if (counter) throw new Error("Parenthesis not matched");
        return $b19f54e58e62e654$var$unescapeCSS(selector.slice(start, selectorIndex - 1));
    }
    function isEscaped(pos) {
        let slashCount = 0;
        while(selector.charCodeAt(--pos) === 92 /* BackSlash */ )slashCount++;
        return (slashCount & 1) === 1;
    }
    function ensureNotTraversal() {
        if (tokens.length > 0 && $b19f54e58e62e654$export$41d1fe2780697dca(tokens[tokens.length - 1])) throw new Error("Did not expect successive traversals.");
    }
    function addTraversal(type) {
        if (tokens.length > 0 && tokens[tokens.length - 1].type === (0, $bGFyo.SelectorType).Descendant) {
            tokens[tokens.length - 1].type = type;
            return;
        }
        ensureNotTraversal();
        tokens.push({
            type: type
        });
    }
    function addSpecialAttribute(name, action) {
        tokens.push({
            type: (0, $bGFyo.SelectorType).Attribute,
            name: name,
            action: action,
            value: getName(1),
            namespace: null,
            ignoreCase: "quirks"
        });
    }
    /**
     * We have finished parsing the current part of the selector.
     *
     * Remove descendant tokens at the end if they exist,
     * and return the last index, so that parsing can be
     * picked up from here.
     */ function finalizeSubselector() {
        if (tokens.length && tokens[tokens.length - 1].type === (0, $bGFyo.SelectorType).Descendant) tokens.pop();
        if (tokens.length === 0) throw new Error("Empty sub-selector");
        subselects.push(tokens);
    }
    stripWhitespace(0);
    if (selector.length === selectorIndex) return selectorIndex;
    loop: while(selectorIndex < selector.length){
        const firstChar = selector.charCodeAt(selectorIndex);
        switch(firstChar){
            // Whitespace
            case 32 /* Space */ :
            case 9 /* Tab */ :
            case 10 /* NewLine */ :
            case 12 /* FormFeed */ :
            case 13 /* CarriageReturn */ :
                if (tokens.length === 0 || tokens[0].type !== (0, $bGFyo.SelectorType).Descendant) {
                    ensureNotTraversal();
                    tokens.push({
                        type: (0, $bGFyo.SelectorType).Descendant
                    });
                }
                stripWhitespace(1);
                break;
            // Traversals
            case 62 /* GreaterThan */ :
                addTraversal((0, $bGFyo.SelectorType).Child);
                stripWhitespace(1);
                break;
            case 60 /* LessThan */ :
                addTraversal((0, $bGFyo.SelectorType).Parent);
                stripWhitespace(1);
                break;
            case 126 /* Tilde */ :
                addTraversal((0, $bGFyo.SelectorType).Sibling);
                stripWhitespace(1);
                break;
            case 43 /* Plus */ :
                addTraversal((0, $bGFyo.SelectorType).Adjacent);
                stripWhitespace(1);
                break;
            // Special attribute selectors: .class, #id
            case 46 /* Period */ :
                addSpecialAttribute("class", (0, $bGFyo.AttributeAction).Element);
                break;
            case 35 /* Hash */ :
                addSpecialAttribute("id", (0, $bGFyo.AttributeAction).Equals);
                break;
            case 91 /* LeftSquareBracket */ :
                {
                    stripWhitespace(1);
                    // Determine attribute name and namespace
                    let name;
                    let namespace = null;
                    if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */ ) // Equivalent to no namespace
                    name = getName(1);
                    else if (selector.startsWith("*|", selectorIndex)) {
                        namespace = "*";
                        name = getName(2);
                    } else {
                        name = getName(0);
                        if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */  && selector.charCodeAt(selectorIndex + 1) !== 61 /* Equal */ ) {
                            namespace = name;
                            name = getName(1);
                        }
                    }
                    stripWhitespace(0);
                    // Determine comparison operation
                    let action = (0, $bGFyo.AttributeAction).Exists;
                    const possibleAction = $b19f54e58e62e654$var$actionTypes.get(selector.charCodeAt(selectorIndex));
                    if (possibleAction) {
                        action = possibleAction;
                        if (selector.charCodeAt(selectorIndex + 1) !== 61 /* Equal */ ) throw new Error("Expected `=`");
                        stripWhitespace(2);
                    } else if (selector.charCodeAt(selectorIndex) === 61 /* Equal */ ) {
                        action = (0, $bGFyo.AttributeAction).Equals;
                        stripWhitespace(1);
                    }
                    // Determine value
                    let value = "";
                    let ignoreCase = null;
                    if (action !== "exists") {
                        if ($b19f54e58e62e654$var$isQuote(selector.charCodeAt(selectorIndex))) {
                            const quote = selector.charCodeAt(selectorIndex);
                            let sectionEnd = selectorIndex + 1;
                            while(sectionEnd < selector.length && (selector.charCodeAt(sectionEnd) !== quote || isEscaped(sectionEnd)))sectionEnd += 1;
                            if (selector.charCodeAt(sectionEnd) !== quote) throw new Error("Attribute value didn't end");
                            value = $b19f54e58e62e654$var$unescapeCSS(selector.slice(selectorIndex + 1, sectionEnd));
                            selectorIndex = sectionEnd + 1;
                        } else {
                            const valueStart = selectorIndex;
                            while(selectorIndex < selector.length && (!$b19f54e58e62e654$var$isWhitespace(selector.charCodeAt(selectorIndex)) && selector.charCodeAt(selectorIndex) !== 93 /* RightSquareBracket */  || isEscaped(selectorIndex)))selectorIndex += 1;
                            value = $b19f54e58e62e654$var$unescapeCSS(selector.slice(valueStart, selectorIndex));
                        }
                        stripWhitespace(0);
                        // See if we have a force ignore flag
                        const forceIgnore = selector.charCodeAt(selectorIndex) | 0x20;
                        // If the forceIgnore flag is set (either `i` or `s`), use that value
                        if (forceIgnore === 115 /* LowerS */ ) {
                            ignoreCase = false;
                            stripWhitespace(1);
                        } else if (forceIgnore === 105 /* LowerI */ ) {
                            ignoreCase = true;
                            stripWhitespace(1);
                        }
                    }
                    if (selector.charCodeAt(selectorIndex) !== 93 /* RightSquareBracket */ ) throw new Error("Attribute selector didn't terminate");
                    selectorIndex += 1;
                    const attributeSelector = {
                        type: (0, $bGFyo.SelectorType).Attribute,
                        name: name,
                        action: action,
                        value: value,
                        namespace: namespace,
                        ignoreCase: ignoreCase
                    };
                    tokens.push(attributeSelector);
                    break;
                }
            case 58 /* Colon */ :
                {
                    if (selector.charCodeAt(selectorIndex + 1) === 58 /* Colon */ ) {
                        tokens.push({
                            type: (0, $bGFyo.SelectorType).PseudoElement,
                            name: getName(2).toLowerCase(),
                            data: selector.charCodeAt(selectorIndex) === 40 /* LeftParenthesis */  ? readValueWithParenthesis() : null
                        });
                        continue;
                    }
                    const name = getName(1).toLowerCase();
                    let data = null;
                    if (selector.charCodeAt(selectorIndex) === 40 /* LeftParenthesis */ ) {
                        if ($b19f54e58e62e654$var$unpackPseudos.has(name)) {
                            if ($b19f54e58e62e654$var$isQuote(selector.charCodeAt(selectorIndex + 1))) throw new Error(`Pseudo-selector ${name} cannot be quoted`);
                            data = [];
                            selectorIndex = $b19f54e58e62e654$var$parseSelector(data, selector, selectorIndex + 1);
                            if (selector.charCodeAt(selectorIndex) !== 41 /* RightParenthesis */ ) throw new Error(`Missing closing parenthesis in :${name} (${selector})`);
                            selectorIndex += 1;
                        } else {
                            data = readValueWithParenthesis();
                            if ($b19f54e58e62e654$var$stripQuotesFromPseudos.has(name)) {
                                const quot = data.charCodeAt(0);
                                if (quot === data.charCodeAt(data.length - 1) && $b19f54e58e62e654$var$isQuote(quot)) data = data.slice(1, -1);
                            }
                            data = $b19f54e58e62e654$var$unescapeCSS(data);
                        }
                    }
                    tokens.push({
                        type: (0, $bGFyo.SelectorType).Pseudo,
                        name: name,
                        data: data
                    });
                    break;
                }
            case 44 /* Comma */ :
                finalizeSubselector();
                tokens = [];
                stripWhitespace(1);
                break;
            default:
                {
                    if (selector.startsWith("/*", selectorIndex)) {
                        const endIndex = selector.indexOf("*/", selectorIndex + 2);
                        if (endIndex < 0) throw new Error("Comment was not terminated");
                        selectorIndex = endIndex + 2;
                        // Remove leading whitespace
                        if (tokens.length === 0) stripWhitespace(0);
                        break;
                    }
                    let namespace = null;
                    let name;
                    if (firstChar === 42 /* Asterisk */ ) {
                        selectorIndex += 1;
                        name = "*";
                    } else if (firstChar === 124 /* Pipe */ ) {
                        name = "";
                        if (selector.charCodeAt(selectorIndex + 1) === 124 /* Pipe */ ) {
                            addTraversal((0, $bGFyo.SelectorType).ColumnCombinator);
                            stripWhitespace(2);
                            break;
                        }
                    } else if ($b19f54e58e62e654$var$reName.test(selector.slice(selectorIndex))) name = getName(0);
                    else break loop;
                    if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */  && selector.charCodeAt(selectorIndex + 1) !== 124 /* Pipe */ ) {
                        namespace = name;
                        if (selector.charCodeAt(selectorIndex + 1) === 42 /* Asterisk */ ) {
                            name = "*";
                            selectorIndex += 2;
                        } else name = getName(1);
                    }
                    tokens.push(name === "*" ? {
                        type: (0, $bGFyo.SelectorType).Universal,
                        namespace: namespace
                    } : {
                        type: (0, $bGFyo.SelectorType).Tag,
                        name: name,
                        namespace: namespace
                    });
                }
        }
    }
    finalizeSubselector();
    return selectorIndex;
}
module.exports["isTraversal"] = $b19f54e58e62e654$export$41d1fe2780697dca;
module.exports["parse"] = $b19f54e58e62e654$export$98e6a39c04603d36;

});

parcelRegister("bGFyo", function(module, exports) {
$parcel$export(module.exports, "SelectorType", () => $8823d9a2a18ac4eb$export$4e8b093ec8dcab0d);
$parcel$export(module.exports, "AttributeAction", () => $8823d9a2a18ac4eb$export$dbc3de62b8fcdc89);
var $8823d9a2a18ac4eb$export$4e8b093ec8dcab0d;
(function(SelectorType) {
    SelectorType["Attribute"] = "attribute";
    SelectorType["Pseudo"] = "pseudo";
    SelectorType["PseudoElement"] = "pseudo-element";
    SelectorType["Tag"] = "tag";
    SelectorType["Universal"] = "universal";
    // Traversals
    SelectorType["Adjacent"] = "adjacent";
    SelectorType["Child"] = "child";
    SelectorType["Descendant"] = "descendant";
    SelectorType["Parent"] = "parent";
    SelectorType["Sibling"] = "sibling";
    SelectorType["ColumnCombinator"] = "column-combinator";
})($8823d9a2a18ac4eb$export$4e8b093ec8dcab0d || ($8823d9a2a18ac4eb$export$4e8b093ec8dcab0d = {}));
const $8823d9a2a18ac4eb$export$b378b9ead145a8a4 = {
    Unknown: null,
    QuirksMode: "quirks",
    IgnoreCase: true,
    CaseSensitive: false
};
var $8823d9a2a18ac4eb$export$dbc3de62b8fcdc89;
(function(AttributeAction) {
    AttributeAction["Any"] = "any";
    AttributeAction["Element"] = "element";
    AttributeAction["End"] = "end";
    AttributeAction["Equals"] = "equals";
    AttributeAction["Exists"] = "exists";
    AttributeAction["Hyphen"] = "hyphen";
    AttributeAction["Not"] = "not";
    AttributeAction["Start"] = "start";
})($8823d9a2a18ac4eb$export$dbc3de62b8fcdc89 || ($8823d9a2a18ac4eb$export$dbc3de62b8fcdc89 = {}));

});

parcelRegister("2aBVB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sequence = module.exports.generate = module.exports.compile = module.exports.parse = void 0;

var $cYV4C = parcelRequire("cYV4C");

Object.defineProperty(module.exports, "parse", {
    enumerable: true,
    get: function() {
        return $cYV4C.parse;
    }
});

var $iqfbE = parcelRequire("iqfbE");

Object.defineProperty(module.exports, "compile", {
    enumerable: true,
    get: function() {
        return $iqfbE.compile;
    }
});
Object.defineProperty(module.exports, "generate", {
    enumerable: true,
    get: function() {
        return $iqfbE.generate;
    }
});
/**
 * Parses and compiles a formula to a highly optimized function.
 * Combination of {@link parse} and {@link compile}.
 *
 * If the formula doesn't match any elements,
 * it returns [`boolbase`](https://github.com/fb55/boolbase)'s `falseFunc`.
 * Otherwise, a function accepting an _index_ is returned, which returns
 * whether or not the passed _index_ matches the formula.
 *
 * Note: The nth-rule starts counting at `1`, the returned function at `0`.
 *
 * @param formula The formula to compile.
 * @example
 * const check = nthCheck("2n+3");
 *
 * check(0); // `false`
 * check(1); // `false`
 * check(2); // `true`
 * check(3); // `false`
 * check(4); // `true`
 * check(5); // `false`
 * check(6); // `true`
 */ function $1949efacd65a495e$var$nthCheck(formula) {
    return (0, $iqfbE.compile)((0, $cYV4C.parse)(formula));
}
module.exports.default = $1949efacd65a495e$var$nthCheck;
/**
 * Parses and compiles a formula to a generator that produces a sequence of indices.
 * Combination of {@link parse} and {@link generate}.
 *
 * @param formula The formula to compile.
 * @returns A function that produces a sequence of indices.
 * @example <caption>Always increasing</caption>
 *
 * ```js
 * const gen = nthCheck.sequence('2n+3')
 *
 * gen() // `1`
 * gen() // `3`
 * gen() // `5`
 * gen() // `8`
 * gen() // `11`
 * ```
 *
 * @example <caption>With end value</caption>
 *
 * ```js
 *
 * const gen = nthCheck.sequence('-2n+5');
 *
 * gen() // 0
 * gen() // 2
 * gen() // 4
 * gen() // null
 * ```
 */ function $1949efacd65a495e$var$sequence(formula) {
    return (0, $iqfbE.generate)((0, $cYV4C.parse)(formula));
}
module.exports.sequence = $1949efacd65a495e$var$sequence;

});

parcelRegister("cYV4C", function(module, exports) {
"use strict";
// Following http://www.w3.org/TR/css3-selectors/#nth-child-pseudo
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = void 0;
// Whitespace as per https://www.w3.org/TR/selectors-3/#lex is " \t\r\n\f"
var $97375c385ba9f00e$var$whitespace = new Set([
    9,
    10,
    12,
    13,
    32
]);
var $97375c385ba9f00e$var$ZERO = "0".charCodeAt(0);
var $97375c385ba9f00e$var$NINE = "9".charCodeAt(0);
/**
 * Parses an expression.
 *
 * @throws An `Error` if parsing fails.
 * @returns An array containing the integer step size and the integer offset of the nth rule.
 * @example nthCheck.parse("2n+3"); // returns [2, 3]
 */ function $97375c385ba9f00e$var$parse(formula) {
    formula = formula.trim().toLowerCase();
    if (formula === "even") return [
        2,
        0
    ];
    else if (formula === "odd") return [
        2,
        1
    ];
    // Parse [ ['-'|'+']? INTEGER? {N} [ S* ['-'|'+'] S* INTEGER ]?
    var idx = 0;
    var a = 0;
    var sign = readSign();
    var number = readNumber();
    if (idx < formula.length && formula.charAt(idx) === "n") {
        idx++;
        a = sign * (number !== null && number !== void 0 ? number : 1);
        skipWhitespace();
        if (idx < formula.length) {
            sign = readSign();
            skipWhitespace();
            number = readNumber();
        } else sign = number = 0;
    }
    // Throw if there is anything else
    if (number === null || idx < formula.length) throw new Error("n-th rule couldn't be parsed ('".concat(formula, "')"));
    return [
        a,
        sign * number
    ];
    function readSign() {
        if (formula.charAt(idx) === "-") {
            idx++;
            return -1;
        }
        if (formula.charAt(idx) === "+") idx++;
        return 1;
    }
    function readNumber() {
        var start = idx;
        var value = 0;
        while(idx < formula.length && formula.charCodeAt(idx) >= $97375c385ba9f00e$var$ZERO && formula.charCodeAt(idx) <= $97375c385ba9f00e$var$NINE){
            value = value * 10 + (formula.charCodeAt(idx) - $97375c385ba9f00e$var$ZERO);
            idx++;
        }
        // Return `null` if we didn't read anything.
        return idx === start ? null : value;
    }
    function skipWhitespace() {
        while(idx < formula.length && $97375c385ba9f00e$var$whitespace.has(formula.charCodeAt(idx)))idx++;
    }
}
module.exports.parse = $97375c385ba9f00e$var$parse;

});

parcelRegister("iqfbE", function(module, exports) {
"use strict";
var $d6966f8086ce294a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generate = module.exports.compile = void 0;

var $d6966f8086ce294a$var$boolbase_1 = $d6966f8086ce294a$var$__importDefault((parcelRequire("7Rnqo")));
/**
 * Returns a function that checks if an elements index matches the given rule
 * highly optimized to return the fastest solution.
 *
 * @param parsed A tuple [a, b], as returned by `parse`.
 * @returns A highly optimized function that returns whether an index matches the nth-check.
 * @example
 *
 * ```js
 * const check = nthCheck.compile([2, 3]);
 *
 * check(0); // `false`
 * check(1); // `false`
 * check(2); // `true`
 * check(3); // `false`
 * check(4); // `true`
 * check(5); // `false`
 * check(6); // `true`
 * ```
 */ function $d6966f8086ce294a$var$compile(parsed) {
    var a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    var b = parsed[1] - 1;
    /*
     * When `b <= 0`, `a * n` won't be lead to any matches for `a < 0`.
     * Besides, the specification states that no elements are
     * matched when `a` and `b` are 0.
     *
     * `b < 0` here as we subtracted 1 from `b` above.
     */ if (b < 0 && a <= 0) return $d6966f8086ce294a$var$boolbase_1.default.falseFunc;
    // When `a` is in the range -1..1, it matches any element (so only `b` is checked).
    if (a === -1) return function(index) {
        return index <= b;
    };
    if (a === 0) return function(index) {
        return index === b;
    };
    // When `b <= 0` and `a === 1`, they match any element.
    if (a === 1) return b < 0 ? $d6966f8086ce294a$var$boolbase_1.default.trueFunc : function(index) {
        return index >= b;
    };
    /*
     * Otherwise, modulo can be used to check if there is a match.
     *
     * Modulo doesn't care about the sign, so let's use `a`s absolute value.
     */ var absA = Math.abs(a);
    // Get `b mod a`, + a if this is negative.
    var bMod = (b % absA + absA) % absA;
    return a > 1 ? function(index) {
        return index >= b && index % absA === bMod;
    } : function(index) {
        return index <= b && index % absA === bMod;
    };
}
module.exports.compile = $d6966f8086ce294a$var$compile;
/**
 * Returns a function that produces a monotonously increasing sequence of indices.
 *
 * If the sequence has an end, the returned function will return `null` after
 * the last index in the sequence.
 *
 * @param parsed A tuple [a, b], as returned by `parse`.
 * @returns A function that produces a sequence of indices.
 * @example <caption>Always increasing (2n+3)</caption>
 *
 * ```js
 * const gen = nthCheck.generate([2, 3])
 *
 * gen() // `1`
 * gen() // `3`
 * gen() // `5`
 * gen() // `8`
 * gen() // `11`
 * ```
 *
 * @example <caption>With end value (-2n+10)</caption>
 *
 * ```js
 *
 * const gen = nthCheck.generate([-2, 5]);
 *
 * gen() // 0
 * gen() // 2
 * gen() // 4
 * gen() // null
 * ```
 */ function $d6966f8086ce294a$var$generate(parsed) {
    var a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    var b = parsed[1] - 1;
    var n = 0;
    // Make sure to always return an increasing sequence
    if (a < 0) {
        var aPos_1 = -a;
        // Get `b mod a`
        var minValue_1 = (b % aPos_1 + aPos_1) % aPos_1;
        return function() {
            var val = minValue_1 + aPos_1 * n++;
            return val > b ? null : val;
        };
    }
    if (a === 0) return b < 0 ? function() {
        return null;
    } : function() {
        return n++ === 0 ? b : null;
    };
    if (b < 0) b += a * Math.ceil(-b / a);
    return function() {
        return a * n++ + b;
    };
}
module.exports.generate = $d6966f8086ce294a$var$generate;

});

parcelRegister("iPfZG", function(module, exports) {
$parcel$export(module.exports, "EngagementSpotlight", () => $d1e26a6c07491d4a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $2Fndw = parcelRequire("2Fndw");


var $iiBJH = parcelRequire("iiBJH");


var $3Npfo = parcelRequire("3Npfo");


var $k5HOq = parcelRequire("k5HOq");


var $8cBM8 = parcelRequire("8cBM8");

const $d1e26a6c07491d4a$var$SpotlightWithVariables = (0, $iiBJH.default)((0, $8cBM8.default));
const $d1e26a6c07491d4a$export$f57123e11f24bec9 = (0, $3Npfo.default)($d1e26a6c07491d4a$var$SpotlightWithVariables);
const $d1e26a6c07491d4a$var$SpotlightWithMessage = (0, $k5HOq.default)($d1e26a6c07491d4a$export$f57123e11f24bec9, 'spotlight');
function $d1e26a6c07491d4a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d1e26a6c07491d4a$var$SpotlightWithMessage, props));
}

});

parcelRegister("iiBJH", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cfa45347111319c$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $3Sftg = parcelRequire("3Sftg");

function $3cfa45347111319c$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $42omo.Component) {
        render() {
            const props = $3cfa45347111319c$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TargetComponent, props);
        }
    }
    WithVariables.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $3cfa45347111319c$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $3Sftg.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $3Sftg.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $3Sftg.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});

parcelRegister("3Sftg", function(module, exports) {

var $g47C5 = parcelRequire("g47C5");

var $4xewT = parcelRequire("4xewT");

function $e4ebe363c373022b$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $e4ebe363c373022b$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $4xewT.runTemplateForUrl)(input, variables) : (0, $4xewT.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $g47C5.REPLACEMENT_ERROR)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}
module.exports["rebuildButtonAction"] = $e4ebe363c373022b$export$5d0ec4f796aceeb1;
module.exports["runTemplateOnInputs"] = $e4ebe363c373022b$export$d808999430a3f186;

});

parcelRegister("g47C5", function(module, exports) {
const $e428a4697dceb24e$export$e26f00bd90899835 = 'success';
const $e428a4697dceb24e$export$edb46161045fece7 = 'error';
module.exports["REPLACEMENT_ERROR"] = $e428a4697dceb24e$export$edb46161045fece7;

});

parcelRegister("4xewT", function(module, exports) {

var $i0lyP = parcelRequire("i0lyP");


var $cpDxi = parcelRequire("cpDxi");


var $g47C5 = parcelRequire("g47C5");


var $cuEWu = parcelRequire("cuEWu");

function $ace38877ac0d85ab$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $i0lyP.default)(template);
    return (0, $cuEWu.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $ace38877ac0d85ab$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $i0lyP.default)(template);
    return (0, $cpDxi.replaceForUrl)(epTemplate, variables);
}
function $ace38877ac0d85ab$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $i0lyP.default)(template);
    return (0, $cpDxi.replaceForHtml)(epTemplate, variables);
}
module.exports["runTemplateForUrl"] = $ace38877ac0d85ab$export$416b2ef51d91ea20;
module.exports["runTemplateForHtml"] = $ace38877ac0d85ab$export$5681b97796b74884;

});

parcelRegister("i0lyP", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2be59bfe0ce0113$export$2e2bcd8739ae039);

var $bz2UO = parcelRequire("bz2UO");

/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $e2be59bfe0ce0113$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $e2be59bfe0ce0113$var$UNESCAPED_MATCH = 1;
const $e2be59bfe0ce0113$var$UNESCAPED_GROUP_CONTENTS = 2;
const $e2be59bfe0ce0113$var$ESCAPED_GROUP_CONTENTS = 5;
function $e2be59bfe0ce0113$export$2e2bcd8739ae039(template) {
    const parts = (0, $bz2UO.regexpParts)(template, $e2be59bfe0ce0113$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$e2be59bfe0ce0113$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$e2be59bfe0ce0113$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$e2be59bfe0ce0113$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});

parcelRegister("bz2UO", function(module, exports) {
function $78901a26ed98192e$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $78901a26ed98192e$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $78901a26ed98192e$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $78901a26ed98192e$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $78901a26ed98192e$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}
module.exports["regexpParts"] = $78901a26ed98192e$export$b16d411b3b6d6dff;

});

parcelRegister("cpDxi", function(module, exports) {

var $cuEWu = parcelRequire("cuEWu");


var $48gB0 = parcelRequire("48gB0");

/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $9d422126fe4600e0$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $cuEWu.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $9d422126fe4600e0$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $9d422126fe4600e0$var$rawReplaceVariablesForUrl(template, variables) {
    return $9d422126fe4600e0$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $9d422126fe4600e0$var$rawReplaceVariablesForHtml(template, variables) {
    return $9d422126fe4600e0$var$rawReplaceVariables(template, variables, (0, $48gB0.default));
}
function $9d422126fe4600e0$export$d10ae881b12b8ef2(template, variables) {
    return $9d422126fe4600e0$var$withVariableValidation(template, variables, $9d422126fe4600e0$var$rawReplaceVariablesForUrl);
}
function $9d422126fe4600e0$export$ca536300dbd6350(template, variables) {
    return $9d422126fe4600e0$var$withVariableValidation(template, variables, $9d422126fe4600e0$var$rawReplaceVariablesForHtml);
}
module.exports["replaceForUrl"] = $9d422126fe4600e0$export$d10ae881b12b8ef2;
module.exports["replaceForHtml"] = $9d422126fe4600e0$export$ca536300dbd6350;

});

parcelRegister("cuEWu", function(module, exports) {

var $1rjmQ = parcelRequire("1rjmQ");

function $5e0333abe2221126$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $5e0333abe2221126$export$4a33186abb06007b(template) {
    const variableParts = $5e0333abe2221126$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $1rjmQ.uniqStrings)(variableNames);
}
module.exports["getRequiredVariablesFromTemplate"] = $5e0333abe2221126$export$4a33186abb06007b;

});

parcelRegister("1rjmQ", function(module, exports) {
/**
 * Removes duplicate strings from an array.
 */ function $56c35590cbe5b17a$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}
module.exports["uniqStrings"] = $56c35590cbe5b17a$export$c150c7c1a29f33d8;

});

parcelRegister("48gB0", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d527f6527719db2$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $8d527f6527719db2$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});

parcelRegister("3Npfo", function(module, exports) {
$parcel$export(module.exports, "default", () => $924fbb9a636b21af$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $1DWH0 = parcelRequire("1DWH0");

var $924fbb9a636b21af$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $42omo.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args);
            this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $1DWH0.default)()(EngagementEventsWrapper);
};

});

parcelRegister("k5HOq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e47b6edde9367a4f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");

var $e47b6edde9367a4f$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
        constructor(...args){
            super(...args);
            this.context = void 0;
        }
    }
    StoreWrapper.contextTypes = {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    };
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $42omo.useState)(null);
        const unsubscribeRef = (0, $42omo.useRef)(null);
        const removeConfigRef = (0, $42omo.useRef)(null);
        const canSubscribe = (0, $42omo.useCallback)(()=>{
            return context && !!context?.subscribeEngagementState;
        }, [
            context
        ]);
        const canSetConfig = (0, $42omo.useCallback)(()=>{
            return context && !!context?.setComponentConfig;
        }, [
            context
        ]);
        const onStoreChange = (0, $42omo.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $42omo.useCallback)(()=>{
            return context?.subscribeEngagementState?.(onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $42omo.useCallback)((propsToUse = props)=>{
            return context?.setComponentConfig?.(getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $42omo.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $42omo.useRef)(engagementId);
        const previousMessageType = (0, $42omo.useRef)(messageType);
        const previousOnMessageDisposition = (0, $42omo.useRef)(onMessageDisposition);
        (0, $42omo.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
            key: messageKey,
            ...props,
            ...message
        });
    };
    return StoreWrapper;
};

});

parcelRegister("8cBM8", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $hQNhB = parcelRequire("hQNhB");


var $gj7hi = parcelRequire("gj7hi");


var $5RBJ9 = parcelRequire("5RBJ9");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");


var $bqAtB = parcelRequire("bqAtB");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $hzth4 = parcelRequire("hzth4");

var $19Jj3 = parcelRequire("19Jj3");

var $eSpLK = parcelRequire("eSpLK");


var $7cTWR = parcelRequire("7cTWR");


var $8953F = parcelRequire("8953F");


var $9A5yV = parcelRequire("9A5yV");

function $86110ead6fe3e8af$var$_defineProperty(e, r, t) {
    return (r = $86110ead6fe3e8af$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $86110ead6fe3e8af$var$_toPropertyKey(t) {
    var i = $86110ead6fe3e8af$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $86110ead6fe3e8af$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $86110ead6fe3e8af$var$styles = {
    image: "_1bsb1osq"
};
const $86110ead6fe3e8af$export$f14689466e4eca7a = ({ isMigrated: isMigrated = false, ...rest })=>{
    if (isMigrated && (0, $dh538.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($86110ead6fe3e8af$var$MigratedAkSpotlight, rest);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($86110ead6fe3e8af$var$DeprecatedAkSpotlight, rest);
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $86110ead6fe3e8af$var$DeprecatedAkSpotlight extends (0, $42omo.Component) {
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $7cTWR.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A5yV.default), {
            html: body
        }));
    }
}
$86110ead6fe3e8af$var$_defineProperty($86110ead6fe3e8af$var$DeprecatedAkSpotlight, "defaultProps", {
    fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB)))
});
const $86110ead6fe3e8af$var$MigratedAkSpotlight = (props)=>{
    const placement = (0, $8953F.translations).dialogPlacement(props.dialogPlacement);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const dismiss = (0, $42omo.useCallback)(()=>{
        setIsVisible(false);
    }, [
        setIsVisible
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        offset: props.offset,
        dismiss: dismiss,
        placement: placement,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), props.image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: props.image,
        alt: "",
        className: (0, $gMc0m.default)([
            $86110ead6fe3e8af$var$styles.image
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, props.body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, props.secondaryAction && (props.secondaryAction?.type === 'link' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSpLK.SpotlightSecondaryLink), {
        onClick: dismiss,
        ...props.secondaryAction.data,
        href: props.secondaryAction.data?.url || '',
        target: props.secondaryAction.data?.target
    }, props.secondaryText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), {
        onClick: dismiss,
        ...props.secondaryAction.data
    }, props.secondaryText)), props.primaryAction && (props.primaryAction?.type === 'link' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hzth4.SpotlightPrimaryLink), {
        onClick: dismiss,
        ...props.primaryAction.data,
        href: props.primaryAction.data?.url || '',
        target: props.primaryAction.data?.target
    }, props.primaryText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: dismiss,
        ...props.primaryAction.data
    }, props.primaryText))))));
};
var $86110ead6fe3e8af$export$2e2bcd8739ae039 = $86110ead6fe3e8af$export$f14689466e4eca7a;
module.exports["default"] = $86110ead6fe3e8af$export$2e2bcd8739ae039;

});

parcelRegister("hzth4", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $auNCB = parcelRequire("auNCB");

var $iXCQx = parcelRequire("iXCQx");

const $ccaffbcaf2b62b3e$var$styles = {
    root: "_2rko12b0 _vchhusvi _1e0c1txw _4cvr1h6o _syaz15cr",
    outline: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1dqonqa1 _189ee4h9 _1h6d8yml _18zr12x7 _bfhk1aqn _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31ibz _1nrm1r31 _c2waglyw _1iohnqa1 _1di6of27",
    primary: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1dqonqa1 _189ee4h9 _1h6da755 _18zr12x7 _bfhk1856 _9oik1r31 _1bnxglyw _jf4cnqa1 _irr3hf2y _1nrm1r31 _c2waglyw _1iohnqa1 _1di6g6ey"
};
const $ccaffbcaf2b62b3e$export$82ba9bc832fb64 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, appearance: appearance = 'outline', href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: (0, $1Whri.cx)($ccaffbcaf2b62b3e$var$styles.root, $ccaffbcaf2b62b3e$var$styles[appearance]),
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightPrimaryLink",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    }));
module.exports["SpotlightPrimaryLink"] = $ccaffbcaf2b62b3e$export$82ba9bc832fb64;

});

parcelRegister("eSpLK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $auNCB = parcelRequire("auNCB");

var $iXCQx = parcelRequire("iXCQx");

const $8b5e95512cfdb346$var$styles = {
    root: "_2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _18zr12x7 _1rjcv77o _vchhusvi _1e0c1txw _4cvr1h6o _syaz15cr _bfhk1aqn _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31ibz _1nrm1r31 _c2waglyw _1iohnqa1 _1di6of27"
};
const $8b5e95512cfdb346$export$797d360648cfd970 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $8b5e95512cfdb346$var$styles.root,
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightSecondaryLink",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    }));
module.exports["SpotlightSecondaryLink"] = $8b5e95512cfdb346$export$797d360648cfd970;

});

parcelRegister("7cTWR", function(module, exports) {
const $31e3ef3c9b5f37b6$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};
module.exports["buttonActionTypes"] = $31e3ef3c9b5f37b6$export$e7d79186651244da;

});

parcelRegister("8953F", function(module, exports) {
const $59e8e8c8e0635f86$export$44271b4f0c6a3563 = (value)=>{
    if (!value || value.length === 0) return '';
    /**
   * All of the following are actually invalid in CSS selectors.
   * It's unlikely that a lot of these are actually used as `Spotlight` `name` prop values.
   * If it turns out other characters are used, add them as needed.
   *
   * (space) — descendant combinator
   * > — child combinator
   * + — adjacent sibling combinator
   * ~ — general sibling combinator
   * . — class selector
   * # — ID selector
   * : — pseudo-class/element
   * [ ] — attribute selectors
   * ( ) — functional notation
   * , — selector list separator
   * * — universal selector
   * | — namespace separator
   * " ' — string delimiters
   * \ — escape character
   * Characters not allowed in unescaped identifiers:
   * Digits 0-9 cannot be the first character
   * !, @, $, %, ^, &, =, {, }, ;, /, and most other punctuation
   */ return value.replaceAll(' ', '-').replaceAll('/', '-');
};
const $59e8e8c8e0635f86$var$placementMap = {
    'top right': 'top-start',
    'top center': 'top-center',
    'top left': 'top-end',
    'right bottom': 'right-start',
    'right middle': 'right-start',
    'right top': 'right-end',
    'bottom left': 'bottom-end',
    'bottom center': 'bottom-center',
    'bottom right': 'bottom-start',
    'left top': 'left-end',
    'left middle': 'left-start',
    'left bottom': 'left-start'
};
const $59e8e8c8e0635f86$export$608d2c28a2f3926e = (value)=>{
    // `bottom left` is the default placement when `undefined` is passed.
    return $59e8e8c8e0635f86$var$placementMap[value || 'bottom left'];
};
const $59e8e8c8e0635f86$export$150b732325d14d04 = {
    target: $59e8e8c8e0635f86$export$44271b4f0c6a3563,
    dialogPlacement: $59e8e8c8e0635f86$export$608d2c28a2f3926e
};
module.exports["translations"] = $59e8e8c8e0635f86$export$150b732325d14d04;

});

parcelRegister("9A5yV", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $8cb2cd879eafccd1$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}
module.exports["default"] = $8cb2cd879eafccd1$export$2e2bcd8739ae039;

});

parcelRegister("lgqtG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $k7Tf7 = parcelRequire("k7Tf7");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $759182b58ca4f194$export$e040768d915476be = ({ children: children })=>{
    if ((0, $dh538.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
$759182b58ca4f194$export$e040768d915476be.displayName = 'SpotlightManager';
module.exports["SpotlightManager"] = $759182b58ca4f194$export$e040768d915476be;

});

parcelRegister("2Ehdd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5izcQ = parcelRequire("5izcQ");


var $dh538 = parcelRequire("dh538");


var $a90ar = parcelRequire("a90ar");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */ const $46b4de62a9eb0177$export$e29577842f211e22 = ({ children: children, name: name })=>{
    if ((0, $dh538.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children);
};
$46b4de62a9eb0177$export$e29577842f211e22.displayName = 'SpotlightTarget';
module.exports["SpotlightTarget"] = $46b4de62a9eb0177$export$e29577842f211e22;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("4ayWZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0eaf91608b1fc1f9ea14632557d8241d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30933503c57ef329$var$_react = $30933503c57ef329$var$_interopRequireDefault((parcelRequire("42omo")));

var $30933503c57ef329$var$_baseNew = $30933503c57ef329$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $30933503c57ef329$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30933503c57ef329$var$DashboardIcon = (props)=>/*#__PURE__*/ $30933503c57ef329$var$_react.default.createElement($30933503c57ef329$var$_baseNew.default, Object.assign({
        name: "DashboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$30933503c57ef329$var$DashboardIcon.displayName = 'DashboardIcon';
var $30933503c57ef329$var$_default = module.exports.default = $30933503c57ef329$var$DashboardIcon;

});

parcelRegister("fNJG8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c02a973e1b80a41efb48b80326ffc315>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b80edd69ce46ac6c$var$_react = $b80edd69ce46ac6c$var$_interopRequireDefault((parcelRequire("42omo")));

var $b80edd69ce46ac6c$var$_baseNew = $b80edd69ce46ac6c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $b80edd69ce46ac6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b80edd69ce46ac6c$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $b80edd69ce46ac6c$var$_react.default.createElement($b80edd69ce46ac6c$var$_baseNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$b80edd69ce46ac6c$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $b80edd69ce46ac6c$var$_default = module.exports.default = $b80edd69ce46ac6c$var$CloudArrowUpIcon;

});

parcelRegister("f6IRL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e4ce3568a939e12f8a5f474d8d813cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $affa380c4e32b374$var$_react = $affa380c4e32b374$var$_interopRequireDefault((parcelRequire("42omo")));

var $affa380c4e32b374$var$_baseNew = $affa380c4e32b374$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $affa380c4e32b374$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $affa380c4e32b374$var$RoadmapIcon = (props)=>/*#__PURE__*/ $affa380c4e32b374$var$_react.default.createElement($affa380c4e32b374$var$_baseNew.default, Object.assign({
        name: "RoadmapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$affa380c4e32b374$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $affa380c4e32b374$var$_default = module.exports.default = $affa380c4e32b374$var$RoadmapIcon;

});

parcelRegister("2MNkP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77c848e3098666bf0b9d860f7c0fa130>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2076555da7727269$var$_react = $2076555da7727269$var$_interopRequireDefault((parcelRequire("42omo")));

var $2076555da7727269$var$_baseNew = $2076555da7727269$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2076555da7727269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EditBulk".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing multiple objects in bulk.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2076555da7727269$var$EditBulkIcon = (props)=>/*#__PURE__*/ $2076555da7727269$var$_react.default.createElement($2076555da7727269$var$_baseNew.default, Object.assign({
        name: "EditBulkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h2.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-2.5A.75.75 0 0 1 1 4.25zm1.5.75v1h1v-1zm9.836.104a2 2 0 0 1 2.828 0l.232.232a2 2 0 0 1 0 2.828l-4.848 4.849a2 2 0 0 1-1.022.547l-2.129.425a.75.75 0 0 1-.882-.882l.425-2.129a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.708 0L13.061 4l.939.94.336-.336a.5.5 0 0 0 0-.708zM12.939 6 12 5.06 8.548 8.514a.5.5 0 0 0-.137.255l-.205 1.026 1.026-.205a.5.5 0 0 0 .255-.137zM1 6.75A.75.75 0 0 1 1.75 6h2.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-2.5A.75.75 0 0 1 1 9.25zm1.5.75v1h1v-1zM1 11.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1-.75-.75zm1.5.75v1h1v-1z" clip-rule="evenodd"/>`
    }, props));
$2076555da7727269$var$EditBulkIcon.displayName = 'EditBulkIcon';
var $2076555da7727269$var$_default = module.exports.default = $2076555da7727269$var$EditBulkIcon;

});

parcelRegister("la4Nn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19a68b338d526637a8b5aa12ee323900>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f67e406d7c5cafb0$var$_react = $f67e406d7c5cafb0$var$_interopRequireDefault((parcelRequire("42omo")));

var $f67e406d7c5cafb0$var$_baseNew = $f67e406d7c5cafb0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f67e406d7c5cafb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Hashtag".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: topics in Atlas, tags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f67e406d7c5cafb0$var$HashtagIcon = (props)=>/*#__PURE__*/ $f67e406d7c5cafb0$var$_react.default.createElement($f67e406d7c5cafb0$var$_baseNew.default, Object.assign({
        name: "HashtagIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.274 5 6.012.868l1.476.264L6.798 5h3.476l.738-4.132 1.476.264L11.798 5H15v1.5h-3.47l-.536 3H14V11h-3.274l-.738 4.132-1.476-.264.69-3.868H5.726l-.738 4.132-1.476-.264.69-3.868H1V9.5h3.47l.536-3H2V5zM6.53 6.5l-.536 3H9.47l.536-3z" clip-rule="evenodd"/>`
    }, props));
$f67e406d7c5cafb0$var$HashtagIcon.displayName = 'HashtagIcon';
var $f67e406d7c5cafb0$var$_default = module.exports.default = $f67e406d7c5cafb0$var$HashtagIcon;

});

parcelRegister("g5QRf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb761d6fd7d44f19$var$_react = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("42omo")));

var $bb761d6fd7d44f19$var$_baseNew = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bb761d6fd7d44f19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $bb761d6fd7d44f19$var$_react.default.createElement($bb761d6fd7d44f19$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$bb761d6fd7d44f19$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $bb761d6fd7d44f19$var$_default = module.exports.default = $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon;

});

parcelRegister("cBi7Q", function(module, exports) {
const $a428bcb8f1a15d17$export$4b225aae27e9366b = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
const $a428bcb8f1a15d17$export$c87b1e2e3344192f = 1000;
const $a428bcb8f1a15d17$export$c4e7b6208a0b853e = 60;
const $a428bcb8f1a15d17$export$cd6b7e688e614eeb = $a428bcb8f1a15d17$export$c4e7b6208a0b853e * 60;
const $a428bcb8f1a15d17$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $a428bcb8f1a15d17$export$a0d33d6e93abfb90 = 'aiMateChatLoadPreference';
const $a428bcb8f1a15d17$export$e5a3af287978673c = (siteId)=>siteId ? `${$a428bcb8f1a15d17$export$a0d33d6e93abfb90}_${siteId}` : $a428bcb8f1a15d17$export$a0d33d6e93abfb90;
const $a428bcb8f1a15d17$export$e8114853eca81277 = 'ai-mate';
const $a428bcb8f1a15d17$export$45d167a0ef5aef8d = '/gateway/api/directory/graphql';
const $a428bcb8f1a15d17$export$1ea9613e3e37d315 = 30 * $a428bcb8f1a15d17$export$c4e7b6208a0b853e * $a428bcb8f1a15d17$export$c87b1e2e3344192f;
const $a428bcb8f1a15d17$export$501af059da333e01 = 5 * $a428bcb8f1a15d17$export$c4e7b6208a0b853e * $a428bcb8f1a15d17$export$c87b1e2e3344192f;
const $a428bcb8f1a15d17$export$f8d883b8f9181b19 = 'rovoChatLastMessageSentAt';
const $a428bcb8f1a15d17$export$85d90d98449e85fd = 140;
const $a428bcb8f1a15d17$export$cad0f6e78cd99203 = '600px';
const $a428bcb8f1a15d17$export$900371d5fadf47e7 = {
    NEW_CHAT_BUTTON: 'rovo-chat-new-chat-button',
    THUMBS_UP_BUTTON: 'rovo-chat-thumbs-up-button'
};
module.exports["FEEDBACK_COLLECTOR_ENTRYPOINT_ID"] = $a428bcb8f1a15d17$export$4b225aae27e9366b;
module.exports["MS_IN_SECOND"] = $a428bcb8f1a15d17$export$c87b1e2e3344192f;
module.exports["SECONDS_IN_HR"] = $a428bcb8f1a15d17$export$cd6b7e688e614eeb;
module.exports["getChatLoadPreferenceKey"] = $a428bcb8f1a15d17$export$e5a3af287978673c;
module.exports["AI_MATE_EXPERIENCE_ID"] = $a428bcb8f1a15d17$export$e8114853eca81277;
module.exports["SHORTER_TIMEOUT_BEFORE_NEW_CHAT"] = $a428bcb8f1a15d17$export$501af059da333e01;
module.exports["LS_LAST_MESSAGE_SENT_AT"] = $a428bcb8f1a15d17$export$f8d883b8f9181b19;
module.exports["MINI_MODAL_GREETING_HEIGHT"] = $a428bcb8f1a15d17$export$85d90d98449e85fd;
module.exports["MINI_MODAL_EXPANDED_HEIGHT"] = $a428bcb8f1a15d17$export$cad0f6e78cd99203;
module.exports["POLLINATOR_TEST_IDS"] = $a428bcb8f1a15d17$export$900371d5fadf47e7;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("18R9N", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $42omo.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("7boqA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $42omo.useCallback)(()=>{
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("hbYDZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa391a3d57e28f300b24cee0bba3c43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c842815f2fb3ef87$var$_react = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("42omo")));

var $c842815f2fb3ef87$var$_baseNew = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c842815f2fb3ef87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for use for Jira Projects for now. This will replace the Jira rocket. 

More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c842815f2fb3ef87$var$SpacesIcon = (props)=>/*#__PURE__*/ $c842815f2fb3ef87$var$_react.default.createElement($c842815f2fb3ef87$var$_baseNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.496a5.98 5.98 0 0 1-2.809 3.7 5.98 5.98 0 0 1-4.608.583 29.4 29.4 0 0 0 3.858-1.881 29.4 29.4 0 0 0 3.559-2.402"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.425 2.308-.447.377-.013.751.017 1.083.126.338.11.678.32.888.684.354.613.152 1.297-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.397a20 20 0 0 1-1.517 1.263 29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.58c-.65.275-1.272.506-1.85.683h-.003q-.28.087-.548.159c-.783.206-1.511.317-2.116.288-.505-.025-1.114-.162-1.49-.63l-.052-.069-.07-.109-.07-.139a1.6 1.6 0 0 1-.078-.972c.071-.342.231-.681.431-1.001.35-.559.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.499c-.302.324-.536.62-.698.879-.147.235-.213.407-.236.515l-.004.046c.048.022.155.056.37.067.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34c.089.504.265 1.004.538 1.475.198.344.435.652.702.921 1.181-.43 2.542-1.062 3.945-1.872s2.63-1.672 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36a6 6 0 0 0-1.111.166q.233.306.432.647.196.341.342.695c.394-.423.665-.788.816-1.08.098-.192.121-.303.127-.355q-.016-.009-.041-.019a1.7 1.7 0 0 0-.565-.053" clip-rule="evenodd"/>`
    }, props));
$c842815f2fb3ef87$var$SpacesIcon.displayName = 'SpacesIcon';
var $c842815f2fb3ef87$var$_default = module.exports.default = $c842815f2fb3ef87$var$SpacesIcon;

});

parcelRegister("5qqdA", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $76e32f06e038930c$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $76e32f06e038930c$export$64aee74ba59709e5 = 439; // px
const $76e32f06e038930c$export$1c07393c5bb1bc27 = 439; // px
const $76e32f06e038930c$export$aa3478deee7adbeb = 350; // px
const $76e32f06e038930c$export$21e515a86cd1733b = 'Chat';
const $76e32f06e038930c$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $76e32f06e038930c$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $76e32f06e038930c$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $76e32f06e038930c$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $76e32f06e038930c$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $76e32f06e038930c$export$e942bf04e23ff966;

});

parcelRegister("8unJx", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $kPbXZ = parcelRequire("kPbXZ");

const $d1d2403974de0af3$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    initialPrompt: undefined
};
const $d1d2403974de0af3$var$store = (0, $1P1Tu.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $d1d2403974de0af3$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($d1d2403974de0af3$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
							which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                }
            },
        openConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // Already in the desired mode — ensure the sidebar is actually
                // visible (it may have been displaced by another panel) but
                // otherwise treat this as a no-op.
                if (currentMode === targetMode) {
                    if (targetMode === (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR && !sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                    return;
                }
                // Switch to the target mode
                switch(targetMode){
                    case (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).SIDEBAR
                        });
                        return;
                    case (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $kPbXZ.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            }
    }
});
const $d1d2403974de0af3$var$useStore = (0, $9zUhf.createHook)($d1d2403974de0af3$var$store);
const $d1d2403974de0af3$export$37440b51449f7ac6 = ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, initialPrompt: initialPrompt }, { reset: reset, clearInitialPrompt: clearInitialPrompt, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable }] = $d1d2403974de0af3$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        openConversationAssistantUIMode: openConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable
    };
};
const $d1d2403974de0af3$export$66cf76b7e04da11f = (0, $9zUhf.createActionsHook)($d1d2403974de0af3$var$store);
module.exports["useRovoExperienceAPIStore"] = $d1d2403974de0af3$export$37440b51449f7ac6;

});

parcelRegister("kPbXZ", function(module, exports) {
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $053d47555d884138$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $053d47555d884138$export$bc36ebf73899a71d;

});

parcelRegister("2bR8c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5qqdA = parcelRequire("5qqdA");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $42omo.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("2YmgJ", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $a63d9f06b3e123f3$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        jiraIssueViewActions: undefined,
        input: '',
        activeAction: undefined,
        buttonClickedTimestamp: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        /*
     * Jira Issue View does not use the provider pattern yet, so we need to skip the provider action fetching.
     * When Jira Issue View is migrated to set actions using provider pattern, we can remove this setter.
     */ setJiraIssueViewActions: (actions)=>({ setState: setState })=>{
                setState({
                    jiraIssueViewActions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
     * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
     */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
                setState({
                    buttonClickedTimestamp: buttonClickedTimestamp
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            },
        getButtonClickedTimestamp: ()=>({ getState: getState })=>{
                return getState().buttonClickedTimestamp;
            },
        setConvoStarterActionPrompt: (convoStarterActionPrompt)=>({ setState: setState })=>{
                setState({
                    convoStarterActionPrompt: convoStarterActionPrompt
                });
            }
    }
});
const $a63d9f06b3e123f3$export$83a8985e8d377ba1 = (0, $9zUhf.createHook)($a63d9f06b3e123f3$var$store);
const $a63d9f06b3e123f3$export$74d7aed167e24a67 = (0, $9zUhf.createActionsHook)($a63d9f06b3e123f3$var$store);
const $a63d9f06b3e123f3$export$d6ed3fb83640b335 = (0, $9zUhf.createStateHook)($a63d9f06b3e123f3$var$store);
const $a63d9f06b3e123f3$export$4be353558b8b8a37 = (0, $9zUhf.createStateHook)($a63d9f06b3e123f3$var$store, {
    selector: (state)=>state.convoStarterActionPrompt
});
module.exports["useConversationActionsStore"] = $a63d9f06b3e123f3$export$83a8985e8d377ba1;
module.exports["useConversationActionsStoreActions"] = $a63d9f06b3e123f3$export$74d7aed167e24a67;
module.exports["useConversationActionsStoreState"] = $a63d9f06b3e123f3$export$d6ed3fb83640b335;

});

parcelRegister("6TWiP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f828166ff0e4b26e4ba3197fe41c41b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50651ad665c1db79$var$_react = $50651ad665c1db79$var$_interopRequireDefault((parcelRequire("42omo")));

var $50651ad665c1db79$var$_baseNew = $50651ad665c1db79$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $50651ad665c1db79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Atom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50651ad665c1db79$var$AtomIcon = (props)=>/*#__PURE__*/ $50651ad665c1db79$var$_react.default.createElement($50651ad665c1db79$var$_baseNew.default, Object.assign({
        name: "AtomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.87 1.42c1.566-.567 3.258-.667 4.318.393 1.059 1.059.959 2.75.392 4.317A11 11 0 0 1 13.683 8c.376.635.678 1.265.897 1.87.567 1.566.667 3.258-.393 4.318-1.059 1.059-2.75.959-4.317.392A11 11 0 0 1 8 13.683a11 11 0 0 1-1.87.897c-1.566.567-3.258.667-4.317-.393-1.06-1.059-.96-2.75-.393-4.317.219-.605.52-1.235.896-1.87a11 11 0 0 1-.896-1.87c-.567-1.566-.667-3.258.393-4.317C2.872.753 4.563.853 6.13 1.42c.605.219 1.235.52 1.87.896a11 11 0 0 1 1.87-.896M3.26 9.397a9 9 0 0 0-.43.983c-.521 1.44-.362 2.342.043 2.747s1.306.564 2.747.043a9 9 0 0 0 .983-.43 17 17 0 0 1-1.785-1.558A17 17 0 0 1 3.26 9.397m9.48 0a17.4 17.4 0 0 1-3.343 3.342q.507.258.983.431c1.44.521 2.342.362 2.747-.043s.564-1.306.043-2.747a9 9 0 0 0-.43-.983M8 4.099a15.5 15.5 0 0 0-2.121 1.78A15.5 15.5 0 0 0 4.099 8a15.4 15.4 0 0 0 1.78 2.121A15.5 15.5 0 0 0 8 11.901a15.5 15.5 0 0 0 2.121-1.78A15.5 15.5 0 0 0 11.901 8a15.5 15.5 0 0 0-1.78-2.121A15.5 15.5 0 0 0 8 4.099M5.62 2.83c-1.44-.521-2.342-.362-2.747.043S2.31 4.18 2.83 5.62q.173.475.43.983c.46-.607.981-1.207 1.558-1.785A17 17 0 0 1 6.603 3.26a9 9 0 0 0-.983-.43m7.507.043c-.405-.405-1.306-.564-2.747-.043a9 9 0 0 0-.983.43c.607.46 1.207.981 1.785 1.558a17 17 0 0 1 1.557 1.785 9 9 0 0 0 .431-.983c.521-1.44.362-2.342-.043-2.747"/><path fill="currentcolor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$50651ad665c1db79$var$AtomIcon.displayName = 'AtomIcon';
var $50651ad665c1db79$var$_default = module.exports.default = $50651ad665c1db79$var$AtomIcon;

});

parcelRegister("zCcSI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $ibzAc = parcelRequire("ibzAc");


var $32x2E = parcelRequire("32x2E");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $8aF6s = parcelRequire("8aF6s");


var $c96tF = parcelRequire("c96tF");


var $9cZ1w = parcelRequire("9cZ1w");

const $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY = 500;
const $e34c3f63766da5b3$export$a9c99c9d804e8c41 = ({ assistanceServiceConfigHeaders: assistanceServiceConfigHeaders = {}, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose = false, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose = false })=>{
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const emojiProvider = (0, $42omo.useMemo)(()=>{
        return (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
            cloudId: cloudId,
            userId: userId
        });
    }, [
        userId,
        cloudId
    ]);
    return {
        displaySubmitFlag: true,
        siteId: cloudId,
        product: 'confluence',
        orgId: orgId,
        assistanceServiceConfig: {
            headers: assistanceServiceConfigHeaders,
            baseUrl: '/gateway/api/assist'
        },
        emojiProvider: emojiProvider,
        userId: userId ?? undefined,
        preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
    };
};
const $e34c3f63766da5b3$export$577864d1e6735f1b = ({ flags: flags, customGreeting: customGreeting, shouldShowGreeting: shouldShowGreeting, shouldHideFeedback: shouldHideFeedback })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const intl = (0, $aXWIB.useIntl)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const navigateToObject = (0, $42omo.useCallback)(async ({ baseUrl: baseUrlNav, path: path })=>{
        (0, $c96tF.createNavigateToObject)(push)({
            baseUrl: baseUrlNav,
            path: path
        });
        // artifical delay before closing the modal gives the app a moment to transition to the created object while the modal is still open, this creates a smoother transition from modal to new object.
        // For non-SPA transitions, a full page reload will happen so this delay will be ignored
        await new Promise((r)=>setTimeout(r, $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY));
    }, [
        push
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    const handleCloseSmartCreate = (0, $42omo.useCallback)(({ feedbackVariant: feedbackVariant, currentConversationId: currentConversationId, remixMetadata: remixMetadata, contentType: contentType, contentMode: contentMode })=>{
        if (shouldHideFeedback) return;
        if (feedbackVariant === undefined) return;
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: feedbackVariant,
            contentType: contentType,
            contentMode: contentMode,
            cloudId: cloudId,
            currentConversationId: currentConversationId ?? undefined,
            remixMetadata: remixMetadata
        });
    }, [
        showCreateWithRovoModalCloseFeedbackFlag,
        shouldHideFeedback,
        cloudId
    ]);
    return {
        customHandlers: {
            handleSubmitSmartCreate: navigateToObject,
            handleCloseSmartCreate: handleCloseSmartCreate
        },
        elements: {
            shouldShowGreeting: shouldShowGreeting ?? undefined
        },
        customGreeting: customGreeting ?? undefined
    };
};
module.exports["useConversationAssistantConfig"] = $e34c3f63766da5b3$export$a9c99c9d804e8c41;
module.exports["useConversationAssistantUiConfig"] = $e34c3f63766da5b3$export$577864d1e6735f1b;

});

parcelRegister("c96tF", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $8f856ee350559225$export$b2e60ce4b3907e57 = (baseUrl)=>{
    const host = window.location.host;
    return baseUrl.includes(host) && baseUrl.includes((0, $jlIaF.CONTEXT_PATH));
};
// database need flow query param for special case handling
const $8f856ee350559225$var$addFlowParam = (baseUrl, path)=>{
    const url = new URL(path, baseUrl);
    url.searchParams.set('flow', 'aiCreate');
    return url.pathname + url.search;
};
const $8f856ee350559225$export$38454a8d1321e65a = (push)=>({ baseUrl: baseUrl, path: path })=>{
        const isDatabase = Boolean((0, $1NBp8.DATABASE_VIEW).match(`${baseUrl}${path}`));
        let finalPath = path;
        if (isDatabase) finalPath = $8f856ee350559225$var$addFlowParam(baseUrl, path);
        if ($8f856ee350559225$export$b2e60ce4b3907e57(baseUrl)) push((0, $jlIaF.CONTEXT_PATH) + finalPath);
        else window.location.href = `${baseUrl}${finalPath}`;
    };
module.exports["createNavigateToObject"] = $8f856ee350559225$export$38454a8d1321e65a;

});

parcelRegister("5ruin", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $2b71e6bc29f732db$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $2b71e6bc29f732db$var$initialState = {
    configuration: $2b71e6bc29f732db$var$noopConfiguration
};
const $2b71e6bc29f732db$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $2b71e6bc29f732db$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $2b71e6bc29f732db$export$e0afd2e658e4f7ce = (0, $1P1Tu.createStore)({
    initialState: $2b71e6bc29f732db$var$initialState,
    actions: $2b71e6bc29f732db$var$actions,
    name: 'RovoCurrentConfigStore'
});
const $2b71e6bc29f732db$export$2cefdfe72db08be4 = (0, $9zUhf.createActionsHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce);
const $2b71e6bc29f732db$export$d7809b5c7bef1f6d = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration
});
const $2b71e6bc29f732db$export$897f16b7b08b0ac = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.getActions
});
const $2b71e6bc29f732db$export$1e0546f83460b30d = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.tags
});
const $2b71e6bc29f732db$export$2a73ca2333c94154 = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.customGreeting
});
const $2b71e6bc29f732db$export$9d0f592eafe765c0 = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.shouldShowGreeting
});
const $2b71e6bc29f732db$export$6745aa6ec6db525a = (0, $9zUhf.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.prioritizeCustomActionResults
});
module.exports["useRovoCurrentConfigStoreActions"] = $2b71e6bc29f732db$export$2cefdfe72db08be4;
module.exports["useRovoConfigGetActions"] = $2b71e6bc29f732db$export$897f16b7b08b0ac;
module.exports["useRovoConfigTags"] = $2b71e6bc29f732db$export$1e0546f83460b30d;
module.exports["useRovoConfigCustomGreeting"] = $2b71e6bc29f732db$export$2a73ca2333c94154;
module.exports["useRovoConfigShouldShowGreeting"] = $2b71e6bc29f732db$export$9d0f592eafe765c0;
module.exports["useRovoConfigPrioritizeCustomActionResults"] = $2b71e6bc29f732db$export$6745aa6ec6db525a;

});

parcelRegister("7fKGk", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.1
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("bHjhd", function(module, exports) {

var $kiOFr = parcelRequire("kiOFr");

const $89598f5ca555d4d3$export$7fa7ed95afa3407a = (cloudId, gatewayBaseUrl)=>{
    const { data: data, loading: loading, error: error } = (0, $kiOFr.useAvailableSites)({
        gatewayBaseUrl: gatewayBaseUrl
    });
    const filterData = data.filter((site)=>site.cloudId === cloudId);
    if (filterData.length > 0) return {
        data: filterData[0].url,
        loading: loading,
        error: error
    };
    return {
        data: undefined,
        loading: loading,
        error: error
    };
};
module.exports["useCloudIdToUrl"] = $89598f5ca555d4d3$export$7fa7ed95afa3407a;

});

parcelRegister("228oz", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $4EMbH = parcelRequire("4EMbH");


var $4rdL9 = parcelRequire("4rdL9");


// Module-level constant: noun values should never be treated as nested products
const $66fdf3be8fc8b85e$var$NOUN_KEYS_SET = new Set(Object.values((0, $4EMbH.NounKeys)));
// Single-select filter option: ~32px (space.400) + ~8px padding
const $66fdf3be8fc8b85e$var$DEFAULT_APP_FILTER_ITEM_HEIGHT_PX = 40;
const $66fdf3be8fc8b85e$var$DEFAULT_APP_FILTER_GAP_PX = 4;
// Reserved for: "All" option, section headers, padding, Show More, description,
// plus "Improve search Give feedback" footer (marginTop + paddingBlock + content ~48px)
const $66fdf3be8fc8b85e$var$DEFAULT_RESERVED_HEIGHT_PX = 260;
// Accordions and fanout expand 1 option to multiple rows; reduce slots to prevent overflow
const $66fdf3be8fc8b85e$var$SLOT_SAFETY_FACTOR = 0.75;
const $66fdf3be8fc8b85e$export$d331923b1a860030 = (availableHeight, options)=>{
    const { connectedCount: connectedCount, unconnectedCount: unconnectedCount, ratio: ratio = [
        2,
        1
    ], itemHeight: itemHeight = $66fdf3be8fc8b85e$var$DEFAULT_APP_FILTER_ITEM_HEIGHT_PX, gap: gap = $66fdf3be8fc8b85e$var$DEFAULT_APP_FILTER_GAP_PX, reservedHeight: reservedHeight = $66fdf3be8fc8b85e$var$DEFAULT_RESERVED_HEIGHT_PX, slotSafetyFactor: slotSafetyFactor = $66fdf3be8fc8b85e$var$SLOT_SAFETY_FACTOR } = options;
    const [ratioConnected, ratioUnconnected] = ratio;
    const ratioTotal = ratioConnected + ratioUnconnected;
    // Fallback for invalid or very small viewport
    if (availableHeight <= 0 || reservedHeight >= availableHeight) return {
        connectedMax: Math.min(2, connectedCount),
        unconnectedMax: Math.min(1, unconnectedCount)
    };
    const usableHeight = Math.max(0, availableHeight - reservedHeight);
    // Same formula as get-max-results-to-show: slots = (height + gap) / (itemHeight + gap)
    // Apply safety factor: accordions and fanout expand 1 option to multiple rows
    const totalSlots = Math.max(1, Math.floor((usableHeight + gap) / (itemHeight + gap) * slotSafetyFactor));
    if (totalSlots <= 0) return {
        connectedMax: Math.min(1, connectedCount),
        unconnectedMax: Math.min(1, unconnectedCount)
    };
    // Allocate by ratio: connected gets 2/3, unconnected gets 1/3
    let connectedSlots = Math.ceil(totalSlots * ratioConnected / ratioTotal);
    let unconnectedSlots = totalSlots - connectedSlots;
    // Cap by actual counts and redistribute surplus
    let connectedMax = Math.min(connectedSlots, connectedCount);
    let unconnectedMax = Math.min(unconnectedSlots, unconnectedCount);
    const usedSlots = connectedMax + unconnectedMax;
    const surplusSlots = totalSlots - usedSlots;
    if (surplusSlots > 0) {
        // Give surplus to the section that can take more
        const connectedRemaining = connectedCount - connectedMax;
        const unconnectedRemaining = unconnectedCount - unconnectedMax;
        if (connectedRemaining > 0 && unconnectedRemaining > 0) {
            // Both can take more: favour connected (2:1)
            const toConnected = Math.min(surplusSlots, connectedRemaining, Math.ceil(surplusSlots * ratioConnected / ratioTotal));
            const toUnconnected = Math.min(surplusSlots - toConnected, unconnectedRemaining);
            connectedMax += toConnected;
            unconnectedMax += toUnconnected;
        } else if (connectedRemaining > 0) connectedMax += Math.min(surplusSlots, connectedRemaining);
        else if (unconnectedRemaining > 0) unconnectedMax += Math.min(surplusSlots, unconnectedRemaining);
    }
    return {
        connectedMax: connectedMax,
        unconnectedMax: unconnectedMax
    };
};
const $66fdf3be8fc8b85e$export$f23b402bf6327aa3 = ({ visibleAppsFull: visibleAppsFull, connectedApps: connectedApps, unconnectedApps: unconnectedApps, connectedMax: connectedMax, unconnectedMax: unconnectedMax, hiddenAppsOther: hiddenAppsOther, thirdPartyConfigs: thirdPartyConfigs, sidebarStoredState: sidebarStoredState, selectedProduct: selectedProduct, primaryProduct: primaryProduct })=>{
    const nestedProducts = (0, $4rdL9.getNestedProducts)();
    // Check if an app is explicitly hidden by the user (not just in hiddenAppsOther due to overflow)
    const isUserHidden = (app)=>app.value && sidebarStoredState?.filters?.[app.value]?.hidden === true;
    // Pool of unconnected apps we can "refill" from: overflow from main list +
    // unconnected apps that were originally hidden (e.g. Figma, Salesforce)
    // Filter out user-hidden apps from the pool so they don't get pulled back into visible
    const { unconnectedHiddenApps: unconnectedFromHidden } = $66fdf3be8fc8b85e$export$4e4e635ffed5c2db({
        visibleApps: [],
        thirdPartyConfigs: thirdPartyConfigs,
        hiddenApps: hiddenAppsOther
    });
    const unconnectedPool = [
        ...unconnectedApps.slice(unconnectedMax),
        ...unconnectedFromHidden
    ].filter((app)=>!isUserHidden(app));
    const isNested = (app)=>app.value ? nestedProducts.has(app.value) && !$66fdf3be8fc8b85e$var$NOUN_KEYS_SET.has(app.value) : false;
    // First pass: take non-nested unconnected apps (nested ones appear inside parent accordions)
    // Skip apps that are user-hidden
    const unconnectedVisible = [];
    for (const app of unconnectedApps){
        if (unconnectedVisible.length >= unconnectedMax) break;
        if (isNested(app) || isUserHidden(app)) continue;
        unconnectedVisible.push(app);
    }
    // Second pass: refill from pool if we have room (e.g. when many unconnected are nested)
    const promoted = new Set();
    for (const app of unconnectedPool){
        if (unconnectedVisible.length >= unconnectedMax) break;
        if (isNested(app) || promoted.has(app)) continue;
        unconnectedVisible.push(app);
        promoted.add(app);
    }
    // Track promoted keys so we don't list them in hiddenApps
    const promotedKeys = new Set(Array.from(promoted).map((a)=>a.compositeKey ?? a.value));
    // Keep nested products only within the slice limits to respect viewport constraints
    // When nested products are outside the slice, accordions should collapse (but remain visible)
    // Nouns are excluded: they are standalone inline options, not accordion children
    const unconnectedNestedInSlice = unconnectedApps.slice(0, unconnectedMax).filter((app)=>app.value && isNested(app) && !isUserHidden(app));
    const connectedNestedInSlice = connectedApps.slice(0, connectedMax).filter((app)=>app.value && isNested(app) && !isUserHidden(app));
    // Assemble visible: All filter, connected slice, unconnected slice, nested connected, nested unconnected
    // Filter out user-hidden apps from connected apps
    const allOption = visibleAppsFull.find((app)=>app.value === undefined);
    // Ensure the selected product is always included in visible apps, even if it would be cut off by viewport limits.
    // Also handles nouns: a noun's value (e.g. 'goal') won't match selectedProduct ('atlas'),
    // so we also check app.isSelected to catch selected nouns that are outside the viewport slice.
    const connectedSlice = connectedApps.slice(0, connectedMax);
    const selectedConnectedApp = selectedProduct ? connectedApps.find((app)=>(app.value === selectedProduct || app.isSelected) && !connectedSlice.includes(app)) : undefined;
    const selectedUnconnectedApp = selectedProduct && !selectedConnectedApp ? unconnectedApps.find((app)=>(app.value === selectedProduct || app.isSelected) && !unconnectedVisible.includes(app)) : undefined;
    // primaryProduct should always be visible so its accordion shows on initial load.
    // When primaryProduct === selectedProduct, selectedProduct logic already handles it.
    // primaryProduct is always a 1p connected app, never in unconnected
    const primaryProductConnectedApp = primaryProduct && primaryProduct !== selectedProduct ? connectedApps.find((app)=>app.value === primaryProduct && !connectedApps.slice(0, connectedMax).includes(app)) : undefined;
    const visibleApps = [
        ...allOption ? [
            allOption
        ] : [],
        ...connectedApps.slice(0, connectedMax).filter((app)=>!isUserHidden(app) || app.value === selectedProduct || app.value === primaryProduct),
        ...selectedConnectedApp ? [
            selectedConnectedApp
        ] : [],
        ...primaryProductConnectedApp ? [
            primaryProductConnectedApp
        ] : [],
        ...unconnectedVisible,
        ...selectedUnconnectedApp ? [
            selectedUnconnectedApp
        ] : [],
        ...connectedNestedInSlice,
        ...unconnectedNestedInSlice
    ];
    // Mark parent products with metadata indicating if their nested children are in the visible slice
    // This is used by AccordionFilterItem to determine if accordion should auto-collapse on viewport shrink
    const visibleNestedSet = new Set([
        ...connectedNestedInSlice.map((app)=>app.value),
        ...unconnectedNestedInSlice.map((app)=>app.value)
    ].filter(Boolean));
    visibleApps.forEach((app)=>{
        if (app.value && app.productCategory) {
            const hasVisibleNestedChildren = app.productCategory.products?.some((nestedProd)=>visibleNestedSet.has(nestedProd)) ?? false;
            app.__hasVisibleChildren = hasVisibleNestedChildren;
        }
    });
    // Hidden = overflow from both sections + originally hidden, minus promoted (already visible) and selected product
    const hiddenAppsRaw = [
        ...connectedApps.slice(connectedMax),
        ...unconnectedApps.slice(unconnectedMax),
        ...hiddenAppsOther
    ];
    const hiddenApps = hiddenAppsRaw.filter((app)=>{
        // Exclude promoted apps (already in visible)
        if (promotedKeys.has(app.compositeKey ?? app.value)) return false;
        // Exclude selected product and primary product (always visible)
        if (selectedProduct && (app.value === selectedProduct || app.compositeKey?.startsWith(`${selectedProduct}-`)) || primaryProduct && (app.value === primaryProduct || app.compositeKey?.startsWith(`${primaryProduct}-`))) return false;
        // Exclude selected nouns (e.g. a noun with isSelected=true that was pulled into visible)
        if (app.isSelected) return false;
        return true;
    });
    return {
        visibleApps: visibleApps,
        hiddenApps: hiddenApps
    };
};
const $66fdf3be8fc8b85e$export$63d5998c4291558c = (selectedProduct, selectedDatasource, productFilters, thirdPartyConfigs, onSelectProduct)=>{
    const fanoutProduct = productFilters.find((option)=>option.value === selectedProduct && option.value && option.value in thirdPartyConfigs && thirdPartyConfigs[option.value]?.fanOutConnectorSources);
    if (!fanoutProduct || !selectedDatasource) return null;
    return {
        ...fanoutProduct,
        label: selectedDatasource.workspaceName || fanoutProduct.label,
        compositeKey: `${fanoutProduct.value}-${selectedDatasource.datasourceId}`,
        onSelect: ()=>onSelectProduct(fanoutProduct.value, selectedDatasource),
        isSelected: true,
        datasourceId: selectedDatasource.datasourceId
    };
};
/**
 * Checks if an option supports fanout (multiple datasources)
 */ const $66fdf3be8fc8b85e$var$isFanoutEnabled = (option, thirdPartyConfigs)=>{
    return !!(option.value && option.value in thirdPartyConfigs && thirdPartyConfigs[option.value]?.fanOutConnectorSources);
};
const $66fdf3be8fc8b85e$export$a655af3e5904d3b1 = (hiddenApps, thirdPartyConfigs, selectedProduct, selectedDatasource, onSelectProduct)=>{
    // Create a Set for O(1) lookup of the selected datasource
    const selectedDatasourceId = selectedDatasource?.datasourceId;
    const selectedDatasourceSet = selectedDatasourceId ? new Set([
        selectedDatasourceId
    ]) : new Set();
    return hiddenApps.flatMap((option)=>{
        if ($66fdf3be8fc8b85e$var$isFanoutEnabled(option, thirdPartyConfigs)) {
            const datasources = thirdPartyConfigs[option.value].datasources || [];
            // Use a for loop for better performance when filtering
            const filteredDatasources = [];
            for(let i = 0; i < datasources.length; i++){
                const datasource = datasources[i];
                // If this product is selected with a specific datasource, exclude that datasource from hidden apps
                // (it's already in visible apps)
                if (option.value === selectedProduct && selectedDatasourceSet.has(datasource.datasourceId)) continue;
                filteredDatasources.push(datasource);
            }
            return filteredDatasources.map((datasource)=>{
                const compositeKey = `${option.value}-${datasource.datasourceId}`;
                return {
                    ...option,
                    label: datasource.workspaceName || option.label,
                    // Show count for fanout products if feature flag is enabled, otherwise undefined
                    count: (0, $dh538.fg)('result-count-for-fanned-out-connectors-enabled') ? option.count : undefined,
                    compositeKey: compositeKey,
                    onSelect: onSelectProduct ? ()=>onSelectProduct(option.value, datasource) : option.onSelect,
                    isSelected: option.value === selectedProduct && datasource.datasourceId === selectedDatasourceId,
                    datasourceId: datasource.datasourceId
                };
            });
        }
        return [
            option
        ];
    });
};
const $66fdf3be8fc8b85e$export$5f7dec9d1a00b559 = (option, thirdPartyConfigs, selectedProduct, selectedDatasource, onSelectProduct)=>{
    if (option.value && option.value in thirdPartyConfigs && thirdPartyConfigs[option.value]?.fanOutConnectorSources) {
        // Fanout: create options for each datasource
        const datasources = thirdPartyConfigs[option.value].datasources || [];
        // Show all datasources for this product, not just the selected one
        const filteredDatasources = datasources;
        return filteredDatasources.map((datasource)=>({
                ...option,
                label: datasource.workspaceName || option.label,
                // Show count for fanout products if feature flag is enabled, otherwise undefined
                // (it would show the aggregate count for all datasources, not the specific datasource count)
                count: (0, $dh538.fg)('result-count-for-fanned-out-connectors-enabled') ? option.count : undefined,
                compositeKey: `${option.value}-${datasource.datasourceId}`,
                onSelect: onSelectProduct ? ()=>onSelectProduct(option.value, datasource) : option.onSelect,
                isSelected: option.value === selectedProduct && datasource.datasourceId === selectedDatasource?.datasourceId,
                datasourceId: datasource.datasourceId
            }));
    }
    // Base case: use the original option
    return [
        option
    ];
};
const $66fdf3be8fc8b85e$export$4e4e635ffed5c2db = ({ visibleApps: visibleApps, thirdPartyConfigs: thirdPartyConfigs, hiddenApps: hiddenApps })=>{
    // First, set product statuses for all apps (visible + hidden)
    const productStatuses = new Map();
    const allApps = [
        ...visibleApps,
        ...hiddenApps || []
    ];
    allApps.forEach((app)=>{
        if (!app || app.value === undefined) return;
        const userNeedsOAuth = thirdPartyConfigs[app.value]?.userNeedsOAuth;
        const connectStatus = !userNeedsOAuth;
        productStatuses.set(app.value, connectStatus);
    });
    // Then, categorize visible apps based on productStatuses
    const connectedApps = [];
    const unconnectedApps = [];
    visibleApps.forEach((app)=>{
        if (!app || app.value === undefined) return;
        const isConnected = productStatuses.get(app.value);
        if (isConnected) connectedApps.push(app);
        else unconnectedApps.push(app);
    });
    // Categorize hidden apps for separate "Show More" dropdowns in each section
    // This is needed for the `unified_search_right_rail_enhancements` experiment to show the correct apps in the "Show More" dropdowns
    const connectedHiddenApps = [];
    const unconnectedHiddenApps = [];
    if (hiddenApps) {
        const nestedProducts = (0, $4rdL9.getNestedProducts)();
        hiddenApps.forEach((app)=>{
            if (!app || app.value === undefined) return;
            // Skip nested products (e.g. Confluence DC, Extranet) — they should only appear
            // inside their parent's accordion, never as standalone items in Show More popups.
            // They remain in hiddenApps so allAppsForNesting can still find them for accordion rendering.
            if (nestedProducts.has(app.value) && !$66fdf3be8fc8b85e$var$NOUN_KEYS_SET.has(app.value)) return;
            const isConnected = productStatuses.get(app.value);
            if (isConnected) connectedHiddenApps.push(app);
            else unconnectedHiddenApps.push(app);
        });
    }
    return {
        productStatuses: productStatuses,
        connectedApps: connectedApps,
        unconnectedApps: unconnectedApps,
        connectedHiddenApps: connectedHiddenApps,
        unconnectedHiddenApps: unconnectedHiddenApps
    };
};
module.exports["getSectionVisibilityLimits"] = $66fdf3be8fc8b85e$export$d331923b1a860030;
module.exports["buildSingleSelectVisibleAndHidden"] = $66fdf3be8fc8b85e$export$f23b402bf6327aa3;
module.exports["categorizeAppsByAuthStatus"] = $66fdf3be8fc8b85e$export$4e4e635ffed5c2db;
module.exports["applyFanoutToHiddenApps"] = $66fdf3be8fc8b85e$export$a655af3e5904d3b1;
module.exports["createFanoutOptions"] = $66fdf3be8fc8b85e$export$5f7dec9d1a00b559;

});

parcelRegister("hjK5g", function(module, exports) {
const $c22501eb74d4b25e$export$4699366f3c37153b = (userId)=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`;
module.exports["getPersonalizationSiteUserTraitsUrl"] = $c22501eb74d4b25e$export$4699366f3c37153b;

});

parcelRegister("9yHRR", function(module, exports) {
function $a76d65470eed38dc$export$d8fb4f78442c9917({ cloudId: cloudId, preloadDataProvider: preloadDataProvider }) {
    if (!cloudId || !preloadDataProvider) return null;
    const preloadedSearch = preloadDataProvider.getPreloadedSearch({
        cloudId: cloudId
    });
    const source = preloadedSearch?.source;
    const searchResultsQueryVariables = preloadedSearch?.search?.queryVariables ?? null;
    const rightPanelQueryVariables = preloadedSearch?.rightPanel?.queryVariables ?? null;
    if (!searchResultsQueryVariables && !rightPanelQueryVariables) return null;
    return {
        source: source,
        searchResultsQueryVariables: searchResultsQueryVariables,
        rightPanelQueryVariables: rightPanelQueryVariables
    };
}
module.exports["getPreloadedQueryVars"] = $a76d65470eed38dc$export$d8fb4f78442c9917;

});

parcelRegister("5KDjW", function(module, exports) {
const $689155f366943b1a$export$8debfec283cb37b9 = {
    Confluence: 'confluence',
    Atlas: 'atlas',
    Jira: 'jira',
    JiraServiceManagement: 'jira-servicedesk'
};
module.exports["ProductCategoryKey"] = $689155f366943b1a$export$8debfec283cb37b9;

});

parcelRegister("4rdL9", function(module, exports) {

var $kjNhq = parcelRequire("kjNhq");

const $b74516579de1cecd$export$beb7df217e8a6731 = ()=>{
    const nestedProducts = new Set();
    Object.values((0, $kjNhq.productCategories)).forEach((categoryConfig)=>{
        categoryConfig.products.forEach((productKey)=>{
            // Skip the primary product of the category, only hide the nested ones
            if (productKey !== categoryConfig.productCategory) nestedProducts.add(productKey);
        });
    });
    return nestedProducts;
};
module.exports["getNestedProducts"] = $b74516579de1cecd$export$beb7df217e8a6731;

});

parcelRegister("gX70r", function(module, exports) {
/**
 * Fetch function for Jira issue → PR hydration.
 *
 * Mirrors the pattern of fetchJiraFieldsQuery in ./index.tsx:
 * - Uses fetchAgg to call AGG
 * - Wraps with inMemoryCache for deduplication
 * - Parses response into IssueLinkedPRs mapping
 */ 
var $bZUnP = parcelRequire("bZUnP");

const $13eac6b699d0fe4d$export$dd62bd2a3f89a28e = (response, issueAris)=>{
    const result = {};
    const graphStore = response.data?.graphStore;
    if (!graphStore) return result;
    issueAris.forEach((ari, index)=>{
        const aliasKey = `issue${index}`;
        const connection = graphStore[aliasKey];
        const prs = [];
        let totalEdgeCount = 0;
        if (connection?.edges) {
            totalEdgeCount = connection.edges.length;
            for (const edge of connection.edges)if (edge?.node) prs.push({
                id: edge.node.id,
                title: edge.node.title,
                url: edge.node.url,
                pullRequestInternalId: edge.node.pullRequestInternalId,
                status: edge.node.status,
                lastUpdated: edge.node.lastUpdated,
                reviewers: (edge.node.reviewers ?? []).filter((r)=>r?.approvalStatus != null)
            });
        }
        // If the API returned its maximum (PR_LIMIT_PER_ISSUE), there may be
        // more PRs we haven't seen, so we can't show an exact count.
        const hitApiLimit = totalEdgeCount >= (0, $bZUnP.PR_LIMIT_PER_ISSUE);
        result[ari] = {
            status: 'loaded',
            prs: prs,
            hasMore: hitApiLimit
        };
    });
    return result;
};
module.exports["parseJiraPRResponse"] = $13eac6b699d0fe4d$export$dd62bd2a3f89a28e;

});

parcelRegister("bjsau", function(module, exports) {
const $f621893ab966c547$export$3ea53827ed349b2e = (locale)=>{
    const lowerCaseLocale = locale.toLowerCase();
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return lowerCaseLocale === 'en' || lowerCaseLocale.startsWith('en-');
};
module.exports["isEnglishLocale"] = $f621893ab966c547$export$3ea53827ed349b2e;

});

parcelRegister("1u6ec", function(module, exports) {
const $b5906586dba07596$export$7ac4ac6a6e59d0eb = {
    ACCEPTED: {
        display: 'Accepted',
        appearance: 'success'
    },
    CANCELED: {
        display: 'Canceled',
        appearance: 'neutral'
    },
    DEFERRED: {
        display: 'Deferred',
        appearance: 'danger'
    },
    DRAFT: {
        display: 'Draft',
        appearance: 'neutral'
    },
    IN_REVIEW: {
        display: 'In Review',
        appearance: 'information'
    },
    REVISING: {
        display: 'Revising',
        appearance: 'information'
    },
    SUBMITTED: {
        display: 'Submitted',
        appearance: 'information'
    }
};
module.exports["SPF_ASK_STATUS_CONFIG"] = $b5906586dba07596$export$7ac4ac6a6e59d0eb;

});

parcelRegister("3IoAL", function(module, exports) {
/**
 * Sorts filter options by result count in descending order.
 * Used to ensure apps are ranked properly by their result counts.
 */ const $269bdb2a853d2488$export$ed61fa4d22723bde = (apps)=>{
    return apps.sort((a, b)=>{
        const countA = a.count ?? 0;
        const countB = b.count ?? 0;
        return countB - countA;
    });
};
module.exports["sortByResultCount"] = $269bdb2a853d2488$export$ed61fa4d22723bde;

});

parcelRegister("kjNhq", function(module, exports) {

var $4Nwes = parcelRequire("4Nwes");

var $lAFHW = parcelRequire("lAFHW");


var $9yyKc = parcelRequire("9yyKc");


var $5KDjW = parcelRequire("5KDjW");


var $1yEFx = parcelRequire("1yEFx");

const $767c61a72117c665$export$a4919093f6d1d650 = {
    [(0, $5KDjW.ProductCategoryKey).Confluence]: {
        productCategory: (0, $5KDjW.ProductCategoryKey).Confluence,
        displayName: 'Confluence',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.ConfluenceIcon), 'Confluence'),
        products: [
            (0, $1yEFx.ProductKeys).Confluence,
            (0, $1yEFx.ProductKeys).ConfluenceDC
        ]
    },
    [(0, $5KDjW.ProductCategoryKey).Atlas]: {
        productCategory: (0, $5KDjW.ProductCategoryKey).Atlas,
        displayName: 'Atlas',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $4Nwes.AtlassianIcon), 'Atlas'),
        products: [
            (0, $1yEFx.ProductKeys).Atlas,
            (0, $1yEFx.ProductKeys).AtlassianWebCrawler
        ]
    },
    [(0, $5KDjW.ProductCategoryKey).Jira]: {
        productCategory: (0, $5KDjW.ProductCategoryKey).Jira,
        displayName: 'Jira',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.JiraIcon), 'Jira'),
        products: [
            (0, $1yEFx.ProductKeys).Jira,
            (0, $1yEFx.ProductKeys).JiraDC
        ]
    },
    [(0, $5KDjW.ProductCategoryKey).JiraServiceManagement]: {
        productCategory: (0, $5KDjW.ProductCategoryKey).JiraServiceManagement,
        displayName: 'Jira Service Management',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.JiraServiceManagementIcon), 'Jira Service Management'),
        products: [
            (0, $1yEFx.ProductKeys).JiraServiceManagement,
            (0, $1yEFx.ProductKeys).JsmDC
        ]
    }
};
const $767c61a72117c665$export$a7242197dd5e4d4a = (productKey)=>{
    return Object.values($767c61a72117c665$export$a4919093f6d1d650).find((categoryConfig)=>categoryConfig.productCategory === productKey);
};
module.exports["productCategories"] = $767c61a72117c665$export$a4919093f6d1d650;
module.exports["getCategoryForProduct"] = $767c61a72117c665$export$a7242197dd5e4d4a;

});

parcelRegister("bZUnP", function(module, exports) {
/**
 * Dynamic GraphQL query generator for Jira issue → PR hydration.
 *
 * Uses GraphQL aliases to batch multiple issue ARI lookups into a single
 * AGG request to devOps.ariGraph.issueAssociatedPr.
 *
 * The GraphStore schema only supports single-ID lookups (id: ID!), so we use
 * GraphQL aliases to batch multiple lookups. The number of issues per query
 * is capped at MAX_ISSUES_PER_QUERY to prevent unbounded query sizes.
 *
 * Example generated query:
 * ```graphql
 * query SearchPageJiraPRHydration($issueAri0: ID!, $issueAri1: ID!) {
 *   graphStore @optIn(to: "GraphStore") {
 *     issue0: issueAssociatedPr(id: $issueAri0, first: 10)
 *       @optIn(to: "GraphStoreIssueAssociatedPr") {
 *       edges { id node { ... on DevOpsPullRequestDetails { ... } } }
 *     }
 *     issue1: issueAssociatedPr(id: $issueAri1, first: 10)
 *       @optIn(to: "GraphStoreIssueAssociatedPr") { ... }
 *   }
 * }
 * ```
 */ /** Maximum number of PRs to fetch per issue */ const $031ed959813eb979$export$69dc5feb6b8b3875 = 10;
const $031ed959813eb979$export$a4483ba8b81f9df3 = 100;
const $031ed959813eb979$var$prFragment = `
	edges {
		id
		node {
			... on DevOpsPullRequestDetails {
				id
				title
				url
				pullRequestInternalId
				status
				lastUpdated
				reviewers {
					approvalStatus
				}
			}
		}
	}
`;
const $031ed959813eb979$export$a63f485bef82bd22 = (issueAris)=>{
    if (issueAris.length === 0) throw new Error('jiraPRQueryGenerator requires at least one issue ARI');
    if (issueAris.length > $031ed959813eb979$export$a4483ba8b81f9df3) throw new Error(`jiraPRQueryGenerator received ${issueAris.length} issue ARIs, but the maximum is ${$031ed959813eb979$export$a4483ba8b81f9df3}. Use the fetch layer to chunk large batches.`);
    const variableDeclarations = issueAris.map((_, index)=>`$issueAri${index}: ID!`).join(', ');
    const aliasedFields = issueAris.map((_, index)=>`
			issue${index}: issueAssociatedPr(id: $issueAri${index}, first: ${$031ed959813eb979$export$69dc5feb6b8b3875})
				@optIn(to: "GraphStoreIssueAssociatedPr") {
				${$031ed959813eb979$var$prFragment}
			}`).join('\n');
    return `
	query SearchPageJiraPRHydration(${variableDeclarations}) {
		graphStore @optIn(to: "GraphStore") {
			${aliasedFields}
		}
	}
	`;
};
const $031ed959813eb979$export$14ca0ef39292cb33 = (issueAris)=>{
    const variables = {};
    issueAris.forEach((ari, index)=>{
        variables[`issueAri${index}`] = ari;
    });
    return variables;
};
module.exports["PR_LIMIT_PER_ISSUE"] = $031ed959813eb979$export$69dc5feb6b8b3875;
module.exports["MAX_ISSUES_PER_QUERY"] = $031ed959813eb979$export$a4483ba8b81f9df3;
module.exports["jiraPRQueryGenerator"] = $031ed959813eb979$export$a63f485bef82bd22;
module.exports["buildPRQueryVariables"] = $031ed959813eb979$export$14ca0ef39292cb33;

});


//# sourceMappingURL=SearchPage.da3f035a.js.map
